var JN = Object.defineProperty;
var eA = (s, i, o) => i in s ? JN(s, i, { enumerable: !0, configurable: !0, writable: !0, value: o }) : s[i] = o;
var Kc = (s, i, o) => (eA(s, typeof i != "symbol" ? i + "" : i, o), o);
import * as yh from "vue";
import { ref as pt, watch as an, defineComponent as Nr, computed as Vt, useAttrs as ts, resolveComponent as pr, openBlock as he, createElementBlock as De, normalizeClass as jt, normalizeStyle as nn, withKeys as vi, unref as kt, createElementVNode as U, createVNode as Ze, createCommentVNode as Ut, createBlock as gn, Teleport as ul, withDirectives as fn, toDisplayString as wt, Fragment as nr, renderList as Fr, vShow as ea, renderSlot as jr, createTextVNode as Ft, mergeProps as rs, vModelCheckbox as f1, onMounted as Na, onUnmounted as _l, resolveDirective as tA, Transition as rA, withCtx as rn, reactive as dm, watchEffect as g1, vModelRadio as nA, nextTick as Yp, vModelText as aA, mergeModels as Ih, useModel as iA, markRaw as oA, onBeforeUnmount as E1, resolveDynamicComponent as sA, shallowReadonly as Qc, toValue as $o, version as lA, useCssVars as cA, onBeforeMount as h1, inject as S1, h as b1, getCurrentInstance as Wo, effectScope as dA, shallowRef as T1, isRef as uA, Text as _A, createStaticVNode as Yn } from "vue";
var v1 = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function C1(s) {
  return s && s.__esModule && Object.prototype.hasOwnProperty.call(s, "default") ? s.default : s;
}
function pA(s) {
  if (s.__esModule)
    return s;
  var i = s.default;
  if (typeof i == "function") {
    var o = function c() {
      return this instanceof c ? Reflect.construct(i, arguments, this.constructor) : i.apply(this, arguments);
    };
    o.prototype = i.prototype;
  } else
    o = {};
  return Object.defineProperty(o, "__esModule", { value: !0 }), Object.keys(s).forEach(function(c) {
    var r = Object.getOwnPropertyDescriptor(s, c);
    Object.defineProperty(o, c, r.get ? r : {
      enumerable: !0,
      get: function() {
        return s[c];
      }
    });
  }), o;
}
var R1 = { exports: {} };
(function(s, i) {
  (function(o, c) {
    s.exports = c();
  })(v1, function() {
    var o = 1e3, c = 6e4, r = 36e5, e = "millisecond", g = "second", h = "minute", S = "hour", C = "day", O = "week", N = "month", D = "quarter", x = "year", L = "date", G = "Invalid Date", Y = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, k = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, W = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function(ge) {
      var w = ["th", "st", "nd", "rd"], fe = ge % 100;
      return "[" + ge + (w[(fe - 20) % 10] || w[fe] || w[0]) + "]";
    } }, Z = function(ge, w, fe) {
      var j = String(ge);
      return !j || j.length >= w ? ge : "" + Array(w + 1 - j.length).join(fe) + ge;
    }, H = { s: Z, z: function(ge) {
      var w = -ge.utcOffset(), fe = Math.abs(w), j = Math.floor(fe / 60), J = fe % 60;
      return (w <= 0 ? "+" : "-") + Z(j, 2, "0") + ":" + Z(J, 2, "0");
    }, m: function ge(w, fe) {
      if (w.date() < fe.date())
        return -ge(fe, w);
      var j = 12 * (fe.year() - w.year()) + (fe.month() - w.month()), J = w.clone().add(j, N), de = fe - J < 0, ie = w.clone().add(j + (de ? -1 : 1), N);
      return +(-(j + (fe - J) / (de ? J - ie : ie - J)) || 0);
    }, a: function(ge) {
      return ge < 0 ? Math.ceil(ge) || 0 : Math.floor(ge);
    }, p: function(ge) {
      return { M: N, y: x, w: O, d: C, D: L, h: S, m: h, s: g, ms: e, Q: D }[ge] || String(ge || "").toLowerCase().replace(/s$/, "");
    }, u: function(ge) {
      return ge === void 0;
    } }, K = "en", Q = {};
    Q[K] = W;
    var _e = "$isDayjsObject", se = function(ge) {
      return ge instanceof Je || !(!ge || !ge[_e]);
    }, Pe = function ge(w, fe, j) {
      var J;
      if (!w)
        return K;
      if (typeof w == "string") {
        var de = w.toLowerCase();
        Q[de] && (J = de), fe && (Q[de] = fe, J = de);
        var ie = w.split("-");
        if (!J && ie.length > 1)
          return ge(ie[0]);
      } else {
        var X = w.name;
        Q[X] = w, J = X;
      }
      return !j && J && (K = J), J || !j && K;
    }, Ke = function(ge, w) {
      if (se(ge))
        return ge.clone();
      var fe = typeof w == "object" ? w : {};
      return fe.date = ge, fe.args = arguments, new Je(fe);
    }, ye = H;
    ye.l = Pe, ye.i = se, ye.w = function(ge, w) {
      return Ke(ge, { locale: w.$L, utc: w.$u, x: w.$x, $offset: w.$offset });
    };
    var Je = function() {
      function ge(fe) {
        this.$L = Pe(fe.locale, null, !0), this.parse(fe), this.$x = this.$x || fe.x || {}, this[_e] = !0;
      }
      var w = ge.prototype;
      return w.parse = function(fe) {
        this.$d = function(j) {
          var J = j.date, de = j.utc;
          if (J === null)
            return /* @__PURE__ */ new Date(NaN);
          if (ye.u(J))
            return /* @__PURE__ */ new Date();
          if (J instanceof Date)
            return new Date(J);
          if (typeof J == "string" && !/Z$/i.test(J)) {
            var ie = J.match(Y);
            if (ie) {
              var X = ie[2] - 1 || 0, ue = (ie[7] || "0").substring(0, 3);
              return de ? new Date(Date.UTC(ie[1], X, ie[3] || 1, ie[4] || 0, ie[5] || 0, ie[6] || 0, ue)) : new Date(ie[1], X, ie[3] || 1, ie[4] || 0, ie[5] || 0, ie[6] || 0, ue);
            }
          }
          return new Date(J);
        }(fe), this.init();
      }, w.init = function() {
        var fe = this.$d;
        this.$y = fe.getFullYear(), this.$M = fe.getMonth(), this.$D = fe.getDate(), this.$W = fe.getDay(), this.$H = fe.getHours(), this.$m = fe.getMinutes(), this.$s = fe.getSeconds(), this.$ms = fe.getMilliseconds();
      }, w.$utils = function() {
        return ye;
      }, w.isValid = function() {
        return this.$d.toString() !== G;
      }, w.isSame = function(fe, j) {
        var J = Ke(fe);
        return this.startOf(j) <= J && J <= this.endOf(j);
      }, w.isAfter = function(fe, j) {
        return Ke(fe) < this.startOf(j);
      }, w.isBefore = function(fe, j) {
        return this.endOf(j) < Ke(fe);
      }, w.$g = function(fe, j, J) {
        return ye.u(fe) ? this[j] : this.set(J, fe);
      }, w.unix = function() {
        return Math.floor(this.valueOf() / 1e3);
      }, w.valueOf = function() {
        return this.$d.getTime();
      }, w.startOf = function(fe, j) {
        var J = this, de = !!ye.u(j) || j, ie = ye.p(fe), X = function(we, st) {
          var Rt = ye.w(J.$u ? Date.UTC(J.$y, st, we) : new Date(J.$y, st, we), J);
          return de ? Rt : Rt.endOf(C);
        }, ue = function(we, st) {
          return ye.w(J.toDate()[we].apply(J.toDate("s"), (de ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(st)), J);
        }, Oe = this.$W, Re = this.$M, ae = this.$D, Ee = "set" + (this.$u ? "UTC" : "");
        switch (ie) {
          case x:
            return de ? X(1, 0) : X(31, 11);
          case N:
            return de ? X(1, Re) : X(0, Re + 1);
          case O:
            var ne = this.$locale().weekStart || 0, Ge = (Oe < ne ? Oe + 7 : Oe) - ne;
            return X(de ? ae - Ge : ae + (6 - Ge), Re);
          case C:
          case L:
            return ue(Ee + "Hours", 0);
          case S:
            return ue(Ee + "Minutes", 1);
          case h:
            return ue(Ee + "Seconds", 2);
          case g:
            return ue(Ee + "Milliseconds", 3);
          default:
            return this.clone();
        }
      }, w.endOf = function(fe) {
        return this.startOf(fe, !1);
      }, w.$set = function(fe, j) {
        var J, de = ye.p(fe), ie = "set" + (this.$u ? "UTC" : ""), X = (J = {}, J[C] = ie + "Date", J[L] = ie + "Date", J[N] = ie + "Month", J[x] = ie + "FullYear", J[S] = ie + "Hours", J[h] = ie + "Minutes", J[g] = ie + "Seconds", J[e] = ie + "Milliseconds", J)[de], ue = de === C ? this.$D + (j - this.$W) : j;
        if (de === N || de === x) {
          var Oe = this.clone().set(L, 1);
          Oe.$d[X](ue), Oe.init(), this.$d = Oe.set(L, Math.min(this.$D, Oe.daysInMonth())).$d;
        } else
          X && this.$d[X](ue);
        return this.init(), this;
      }, w.set = function(fe, j) {
        return this.clone().$set(fe, j);
      }, w.get = function(fe) {
        return this[ye.p(fe)]();
      }, w.add = function(fe, j) {
        var J, de = this;
        fe = Number(fe);
        var ie = ye.p(j), X = function(Re) {
          var ae = Ke(de);
          return ye.w(ae.date(ae.date() + Math.round(Re * fe)), de);
        };
        if (ie === N)
          return this.set(N, this.$M + fe);
        if (ie === x)
          return this.set(x, this.$y + fe);
        if (ie === C)
          return X(1);
        if (ie === O)
          return X(7);
        var ue = (J = {}, J[h] = c, J[S] = r, J[g] = o, J)[ie] || 1, Oe = this.$d.getTime() + fe * ue;
        return ye.w(Oe, this);
      }, w.subtract = function(fe, j) {
        return this.add(-1 * fe, j);
      }, w.format = function(fe) {
        var j = this, J = this.$locale();
        if (!this.isValid())
          return J.invalidDate || G;
        var de = fe || "YYYY-MM-DDTHH:mm:ssZ", ie = ye.z(this), X = this.$H, ue = this.$m, Oe = this.$M, Re = J.weekdays, ae = J.months, Ee = J.meridiem, ne = function(st, Rt, rt, z) {
          return st && (st[Rt] || st(j, de)) || rt[Rt].slice(0, z);
        }, Ge = function(st) {
          return ye.s(X % 12 || 12, st, "0");
        }, we = Ee || function(st, Rt, rt) {
          var z = st < 12 ? "AM" : "PM";
          return rt ? z.toLowerCase() : z;
        };
        return de.replace(k, function(st, Rt) {
          return Rt || function(rt) {
            switch (rt) {
              case "YY":
                return String(j.$y).slice(-2);
              case "YYYY":
                return ye.s(j.$y, 4, "0");
              case "M":
                return Oe + 1;
              case "MM":
                return ye.s(Oe + 1, 2, "0");
              case "MMM":
                return ne(J.monthsShort, Oe, ae, 3);
              case "MMMM":
                return ne(ae, Oe);
              case "D":
                return j.$D;
              case "DD":
                return ye.s(j.$D, 2, "0");
              case "d":
                return String(j.$W);
              case "dd":
                return ne(J.weekdaysMin, j.$W, Re, 2);
              case "ddd":
                return ne(J.weekdaysShort, j.$W, Re, 3);
              case "dddd":
                return Re[j.$W];
              case "H":
                return String(X);
              case "HH":
                return ye.s(X, 2, "0");
              case "h":
                return Ge(1);
              case "hh":
                return Ge(2);
              case "a":
                return we(X, ue, !0);
              case "A":
                return we(X, ue, !1);
              case "m":
                return String(ue);
              case "mm":
                return ye.s(ue, 2, "0");
              case "s":
                return String(j.$s);
              case "ss":
                return ye.s(j.$s, 2, "0");
              case "SSS":
                return ye.s(j.$ms, 3, "0");
              case "Z":
                return ie;
            }
            return null;
          }(st) || ie.replace(":", "");
        });
      }, w.utcOffset = function() {
        return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
      }, w.diff = function(fe, j, J) {
        var de, ie = this, X = ye.p(j), ue = Ke(fe), Oe = (ue.utcOffset() - this.utcOffset()) * c, Re = this - ue, ae = function() {
          return ye.m(ie, ue);
        };
        switch (X) {
          case x:
            de = ae() / 12;
            break;
          case N:
            de = ae();
            break;
          case D:
            de = ae() / 3;
            break;
          case O:
            de = (Re - Oe) / 6048e5;
            break;
          case C:
            de = (Re - Oe) / 864e5;
            break;
          case S:
            de = Re / r;
            break;
          case h:
            de = Re / c;
            break;
          case g:
            de = Re / o;
            break;
          default:
            de = Re;
        }
        return J ? de : ye.a(de);
      }, w.daysInMonth = function() {
        return this.endOf(N).$D;
      }, w.$locale = function() {
        return Q[this.$L];
      }, w.locale = function(fe, j) {
        if (!fe)
          return this.$L;
        var J = this.clone(), de = Pe(fe, j, !0);
        return de && (J.$L = de), J;
      }, w.clone = function() {
        return ye.w(this.$d, this);
      }, w.toDate = function() {
        return new Date(this.valueOf());
      }, w.toJSON = function() {
        return this.isValid() ? this.toISOString() : null;
      }, w.toISOString = function() {
        return this.$d.toISOString();
      }, w.toString = function() {
        return this.$d.toUTCString();
      }, ge;
    }(), mt = Je.prototype;
    return Ke.prototype = mt, [["$ms", e], ["$s", g], ["$m", h], ["$H", S], ["$W", C], ["$M", N], ["$y", x], ["$D", L]].forEach(function(ge) {
      mt[ge[1]] = function(w) {
        return this.$g(w, ge[0], ge[1]);
      };
    }), Ke.extend = function(ge, w) {
      return ge.$i || (ge(w, Je, Ke), ge.$i = !0), Ke;
    }, Ke.locale = Pe, Ke.isDayjs = se, Ke.unix = function(ge) {
      return Ke(1e3 * ge);
    }, Ke.en = Q[K], Ke.Ls = Q, Ke.p = {}, Ke;
  });
})(R1);
var mA = R1.exports;
const rr = /* @__PURE__ */ C1(mA), fA = (s) => {
  const i = rr(s), o = i.get("year"), c = i.get("month"), r = new Date(o, c, 0), e = rr(r).format("MM"), g = r.getDate();
  let h = r.getDay() - 1;
  h = h < 0 ? 6 : h;
  let S = [];
  for (let C = g - h; C <= g; C++)
    S.push(C);
  return S.length === 7 ? [] : S.map((C) => ({
    year: o,
    month: c,
    day: C,
    disabled: !0,
    format: rr(`${o}-${e}-${C}`).format("YYYY-MM-DD"),
    date: rr(`${o}-${e}-${C}`).toDate(),
    unable: !1
  }));
}, gA = (s) => {
  const i = rr(s), o = i.get("year"), c = i.get("month") + 1;
  return new Array(i.daysInMonth()).fill(1).map((r, e) => ({
    year: o,
    month: c,
    day: e + 1,
    disabled: !1,
    format: rr(`${o}-${c}-${e + 1}`).format("YYYY-MM-DD"),
    date: rr(`${o}-${c}-${r}`).toDate(),
    unable: !1
  }));
}, EA = (s) => {
  const i = rr(s), o = i.add(1, "month"), c = i.endOf("month").day();
  return new Array(7 - c).fill(1).map((r, e) => ({
    year: o.get("year"),
    month: o.get("month") + 1,
    day: e + 1,
    disabled: !0,
    format: rr(`${o.get("year")}-${o.get("month") + 1}-${e + 1}`).format("YYYY-MM-DD"),
    date: rr(`${o.get("year")}-${o.get("month") + 1}-${e + 1}`).toDate(),
    unable: !1
  }));
}, hA = (s) => {
  const o = rr(s).get("year"), c = [];
  for (let r = 1; r <= 12; r++)
    c.push({
      year: o,
      month: r,
      day: 0,
      disabled: !1,
      format: rr(`${o}-${r}`).format("YYYY-MM"),
      date: rr(`${o}-${r}`).toDate(),
      unable: !1
    });
  return c;
}, SA = (s) => {
  const o = +(rr(s).format("YYYY").slice(0, 3) + "0"), c = [];
  for (let r = o; r <= o + 9; r++)
    c.push({
      year: r,
      month: 0,
      day: 0,
      disabled: !1,
      format: r.toString(),
      date: rr(`${r}`).toDate(),
      unable: !1
    });
  return c;
};
function el(s) {
  throw new Error('Could not dynamically require "' + s + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var Dh = { exports: {} }, Xc = { exports: {} };
/*! cpexcel.js (C) 2013-present SheetJS -- http://sheetjs.com */
var wh;
function bA() {
  return wh || (wh = 1, function(s) {
    var i = { version: "1.15.0" };
    i[437] = function() {
      for (var o = `\0\x07\b	
\v\f\r\x1B !"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_\`abcdefghijklmnopqrstuvwxyz{|}~ÇüéâäàåçêëèïîìÄÅÉæÆôöòûùÿÖÜ¢£¥₧ƒáíóúñÑªº¿⌐¬½¼¡«»░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀αßΓπΣσµτΦΘΩδ∞φε∩≡±≥≤⌠⌡÷≈°∙·√ⁿ²■ `, c = [], r = {}, e = 0; e != o.length; ++e)
        o.charCodeAt(e) !== 65533 && (r[o.charAt(e)] = e), c[e] = o.charAt(e);
      return { enc: r, dec: c };
    }(), i[620] = function() {
      for (var o = `\0\x07\b	
\v\f\r\x1B !"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_\`abcdefghijklmnopqrstuvwxyz{|}~ÇüéâäàąçêëèïîćÄĄĘęłôöĆûùŚÖÜ¢Ł¥śƒŹŻóÓńŃźż¿⌐¬½¼¡«»░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀αßΓπΣσµτΦΘΩδ∞φε∩≡±≥≤⌠⌡÷≈°∙·√ⁿ²■ `, c = [], r = {}, e = 0; e != o.length; ++e)
        o.charCodeAt(e) !== 65533 && (r[o.charAt(e)] = e), c[e] = o.charAt(e);
      return { enc: r, dec: c };
    }(), i[737] = function() {
      for (var o = `\0\x07\b	
\v\f\r\x1B !"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_\`abcdefghijklmnopqrstuvwxyz{|}~ΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡΣΤΥΦΧΨΩαβγδεζηθικλμνξοπρσςτυφχψ░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀ωάέήϊίόύϋώΆΈΉΊΌΎΏ±≥≤ΪΫ÷≈°∙·√ⁿ²■ `, c = [], r = {}, e = 0; e != o.length; ++e)
        o.charCodeAt(e) !== 65533 && (r[o.charAt(e)] = e), c[e] = o.charAt(e);
      return { enc: r, dec: c };
    }(), i[850] = function() {
      for (var o = `\0\x07\b	
\v\f\r\x1B !"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_\`abcdefghijklmnopqrstuvwxyz{|}~ÇüéâäàåçêëèïîìÄÅÉæÆôöòûùÿÖÜø£Ø×ƒáíóúñÑªº¿®¬½¼¡«»░▒▓│┤ÁÂÀ©╣║╗╝¢¥┐└┴┬├─┼ãÃ╚╔╩╦╠═╬¤ðÐÊËÈıÍÎÏ┘┌█▄¦Ì▀ÓßÔÒõÕµþÞÚÛÙýÝ¯´­±‗¾¶§÷¸°¨·¹³²■ `, c = [], r = {}, e = 0; e != o.length; ++e)
        o.charCodeAt(e) !== 65533 && (r[o.charAt(e)] = e), c[e] = o.charAt(e);
      return { enc: r, dec: c };
    }(), i[852] = function() {
      for (var o = `\0\x07\b	
\v\f\r\x1B !"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_\`abcdefghijklmnopqrstuvwxyz{|}~ÇüéâäůćçłëŐőîŹÄĆÉĹĺôöĽľŚśÖÜŤťŁ×čáíóúĄąŽžĘę¬źČş«»░▒▓│┤ÁÂĚŞ╣║╗╝Żż┐└┴┬├─┼Ăă╚╔╩╦╠═╬¤đĐĎËďŇÍÎě┘┌█▄ŢŮ▀ÓßÔŃńňŠšŔÚŕŰýÝţ´­˝˛ˇ˘§÷¸°¨˙űŘř■ `, c = [], r = {}, e = 0; e != o.length; ++e)
        o.charCodeAt(e) !== 65533 && (r[o.charAt(e)] = e), c[e] = o.charAt(e);
      return { enc: r, dec: c };
    }(), i[857] = function() {
      for (var o = `\0\x07\b	
\v\f\r\x1B !"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_\`abcdefghijklmnopqrstuvwxyz{|}~ÇüéâäàåçêëèïîıÄÅÉæÆôöòûùİÖÜø£ØŞşáíóúñÑĞğ¿®¬½¼¡«»░▒▓│┤ÁÂÀ©╣║╗╝¢¥┐└┴┬├─┼ãÃ╚╔╩╦╠═╬¤ºªÊËÈ�ÍÎÏ┘┌█▄¦Ì▀ÓßÔÒõÕµ�×ÚÛÙìÿ¯´­±�¾¶§÷¸°¨·¹³²■ `, c = [], r = {}, e = 0; e != o.length; ++e)
        o.charCodeAt(e) !== 65533 && (r[o.charAt(e)] = e), c[e] = o.charAt(e);
      return { enc: r, dec: c };
    }(), i[861] = function() {
      for (var o = `\0\x07\b	
\v\f\r\x1B !"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_\`abcdefghijklmnopqrstuvwxyz{|}~ÇüéâäàåçêëèÐðÞÄÅÉæÆôöþûÝýÖÜø£Ø₧ƒáíóúÁÍÓÚ¿⌐¬½¼¡«»░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀αßΓπΣσµτΦΘΩδ∞φε∩≡±≥≤⌠⌡÷≈°∙·√ⁿ²■ `, c = [], r = {}, e = 0; e != o.length; ++e)
        o.charCodeAt(e) !== 65533 && (r[o.charAt(e)] = e), c[e] = o.charAt(e);
      return { enc: r, dec: c };
    }(), i[865] = function() {
      for (var o = `\0\x07\b	
\v\f\r\x1B !"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_\`abcdefghijklmnopqrstuvwxyz{|}~ÇüéâäàåçêëèïîìÄÅÉæÆôöòûùÿÖÜø£Ø₧ƒáíóúñÑªº¿⌐¬½¼¡«¤░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀αßΓπΣσµτΦΘΩδ∞φε∩≡±≥≤⌠⌡÷≈°∙·√ⁿ²■ `, c = [], r = {}, e = 0; e != o.length; ++e)
        o.charCodeAt(e) !== 65533 && (r[o.charAt(e)] = e), c[e] = o.charAt(e);
      return { enc: r, dec: c };
    }(), i[866] = function() {
      for (var o = `\0\x07\b	
\v\f\r\x1B !"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_\`abcdefghijklmnopqrstuvwxyz{|}~АБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯабвгдежзийклмноп░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀рстуфхцчшщъыьэюяЁёЄєЇїЎў°∙·√№¤■ `, c = [], r = {}, e = 0; e != o.length; ++e)
        o.charCodeAt(e) !== 65533 && (r[o.charAt(e)] = e), c[e] = o.charAt(e);
      return { enc: r, dec: c };
    }(), i[874] = function() {
      for (var o = `\0\x07\b	
\v\f\r\x1B !"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_\`abcdefghijklmnopqrstuvwxyz{|}~€����…�����������‘’“”•–—�������� กขฃคฅฆงจฉชซฌญฎฏฐฑฒณดตถทธนบปผฝพฟภมยรฤลฦวศษสหฬอฮฯะัาำิีึืฺุู����฿เแโใไๅๆ็่้๊๋์ํ๎๏๐๑๒๓๔๕๖๗๘๙๚๛����`, c = [], r = {}, e = 0; e != o.length; ++e)
        o.charCodeAt(e) !== 65533 && (r[o.charAt(e)] = e), c[e] = o.charAt(e);
      return { enc: r, dec: c };
    }(), i[895] = function() {
      for (var o = `\0\x07\b	
\v\f\r\x1B !"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_\`abcdefghijklmnopqrstuvwxyz{|}~ČüéďäĎŤčěĚĹÍľǪÄÁÉžŽôöÓůÚýÖÜŠĽÝŘťáíóúňŇŮÔšřŕŔ¼§«»░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀αßΓπΣσµτΦΘΩδ∞φε∩≡±≥≤⌠⌡÷≈°∙·√ⁿ²■ `, c = [], r = {}, e = 0; e != o.length; ++e)
        o.charCodeAt(e) !== 65533 && (r[o.charAt(e)] = e), c[e] = o.charAt(e);
      return { enc: r, dec: c };
    }(), i[932] = function() {
      var o = [], c = {}, r = [], e;
      for (r[0] = `\0\x07\b	
\v\f\r\x1B !"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_\`abcdefghijklmnopqrstuvwxyz{|}~���������������������������������｡｢｣､･ｦｧｨｩｪｫｬｭｮｯｰｱｲｳｴｵｶｷｸｹｺｻｼｽｾｿﾀﾁﾂﾃﾄﾅﾆﾇﾈﾉﾊﾋﾌﾍﾎﾏﾐﾑﾒﾓﾔﾕﾖﾗﾘﾙﾚﾛﾜﾝﾞﾟ��������������������������������`.split(""), e = 0; e != r[0].length; ++e)
        r[0][e].charCodeAt(0) !== 65533 && (c[r[0][e]] = 0 + e, o[0 + e] = r[0][e]);
      for (r[129] = "����������������������������������������������������������������　、。，．・：；？！゛゜´｀¨＾￣＿ヽヾゝゞ〃仝々〆〇ー―‐／＼～∥｜…‥‘’“”（）〔〕［］｛｝〈〉《》「」『』【】＋－±×�÷＝≠＜＞≦≧∞∴♂♀°′″℃￥＄￠￡％＃＆＊＠§☆★○●◎◇◆□■△▲▽▼※〒→←↑↓〓�����������∈∋⊆⊇⊂⊃∪∩��������∧∨￢⇒⇔∀∃�����������∠⊥⌒∂∇≡≒≪≫√∽∝∵∫∬�������Å‰♯♭♪†‡¶����◯���".split(""), e = 0; e != r[129].length; ++e)
        r[129][e].charCodeAt(0) !== 65533 && (c[r[129][e]] = 33024 + e, o[33024 + e] = r[129][e]);
      for (r[130] = "�������������������������������������������������������������������������������０１２３４５６７８９�������ＡＢＣＤＥＦＧＨＩＪＫＬＭＮＯＰＱＲＳＴＵＶＷＸＹＺ�������ａｂｃｄｅｆｇｈｉｊｋｌｍｎｏｐｑｒｓｔｕｖｗｘｙｚ����ぁあぃいぅうぇえぉおかがきぎくぐけげこごさざしじすずせぜそぞただちぢっつづてでとどなにぬねのはばぱひびぴふぶぷへべぺほぼぽまみむめもゃやゅゆょよらりるれろゎわゐゑをん��������������".split(""), e = 0; e != r[130].length; ++e)
        r[130][e].charCodeAt(0) !== 65533 && (c[r[130][e]] = 33280 + e, o[33280 + e] = r[130][e]);
      for (r[131] = "����������������������������������������������������������������ァアィイゥウェエォオカガキギクグケゲコゴサザシジスズセゼソゾタダチヂッツヅテデトドナニヌネノハバパヒビピフブプヘベペホボポマミ�ムメモャヤュユョヨラリルレロヮワヰヱヲンヴヵヶ��������ΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡΣΤΥΦΧΨΩ��������αβγδεζηθικλμνξοπρστυφχψω�����������������������������������������".split(""), e = 0; e != r[131].length; ++e)
        r[131][e].charCodeAt(0) !== 65533 && (c[r[131][e]] = 33536 + e, o[33536 + e] = r[131][e]);
      for (r[132] = "����������������������������������������������������������������АБВГДЕЁЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯ���������������абвгдеёжзийклмн�опрстуфхцчшщъыьэюя�������������─│┌┐┘└├┬┤┴┼━┃┏┓┛┗┣┳┫┻╋┠┯┨┷┿┝┰┥┸╂�����������������������������������������������������������������".split(""), e = 0; e != r[132].length; ++e)
        r[132][e].charCodeAt(0) !== 65533 && (c[r[132][e]] = 33792 + e, o[33792 + e] = r[132][e]);
      for (r[135] = "����������������������������������������������������������������①②③④⑤⑥⑦⑧⑨⑩⑪⑫⑬⑭⑮⑯⑰⑱⑲⑳ⅠⅡⅢⅣⅤⅥⅦⅧⅨⅩ�㍉㌔㌢㍍㌘㌧㌃㌶㍑㍗㌍㌦㌣㌫㍊㌻㎜㎝㎞㎎㎏㏄㎡��������㍻�〝〟№㏍℡㊤㊥㊦㊧㊨㈱㈲㈹㍾㍽㍼≒≡∫∮∑√⊥∠∟⊿∵∩∪���������������������������������������������������������������������������������������������������".split(""), e = 0; e != r[135].length; ++e)
        r[135][e].charCodeAt(0) !== 65533 && (c[r[135][e]] = 34560 + e, o[34560 + e] = r[135][e]);
      for (r[136] = "���������������������������������������������������������������������������������������������������������������������������������������������������������������亜唖娃阿哀愛挨姶逢葵茜穐悪握渥旭葦芦鯵梓圧斡扱宛姐虻飴絢綾鮎或粟袷安庵按暗案闇鞍杏以伊位依偉囲夷委威尉惟意慰易椅為畏異移維緯胃萎衣謂違遺医井亥域育郁磯一壱溢逸稲茨芋鰯允印咽員因姻引飲淫胤蔭���".split(""), e = 0; e != r[136].length; ++e)
        r[136][e].charCodeAt(0) !== 65533 && (c[r[136][e]] = 34816 + e, o[34816 + e] = r[136][e]);
      for (r[137] = "����������������������������������������������������������������院陰隠韻吋右宇烏羽迂雨卯鵜窺丑碓臼渦嘘唄欝蔚鰻姥厩浦瓜閏噂云運雲荏餌叡営嬰影映曳栄永泳洩瑛盈穎頴英衛詠鋭液疫益駅悦謁越閲榎厭円�園堰奄宴延怨掩援沿演炎焔煙燕猿縁艶苑薗遠鉛鴛塩於汚甥凹央奥往応押旺横欧殴王翁襖鴬鴎黄岡沖荻億屋憶臆桶牡乙俺卸恩温穏音下化仮何伽価佳加可嘉夏嫁家寡科暇果架歌河火珂禍禾稼箇花苛茄荷華菓蝦課嘩貨迦過霞蚊俄峨我牙画臥芽蛾賀雅餓駕介会解回塊壊廻快怪悔恢懐戒拐改���".split(""), e = 0; e != r[137].length; ++e)
        r[137][e].charCodeAt(0) !== 65533 && (c[r[137][e]] = 35072 + e, o[35072 + e] = r[137][e]);
      for (r[138] = "����������������������������������������������������������������魁晦械海灰界皆絵芥蟹開階貝凱劾外咳害崖慨概涯碍蓋街該鎧骸浬馨蛙垣柿蛎鈎劃嚇各廓拡撹格核殻獲確穫覚角赫較郭閣隔革学岳楽額顎掛笠樫�橿梶鰍潟割喝恰括活渇滑葛褐轄且鰹叶椛樺鞄株兜竃蒲釜鎌噛鴨栢茅萱粥刈苅瓦乾侃冠寒刊勘勧巻喚堪姦完官寛干幹患感慣憾換敢柑桓棺款歓汗漢澗潅環甘監看竿管簡緩缶翰肝艦莞観諌貫還鑑間閑関陥韓館舘丸含岸巌玩癌眼岩翫贋雁頑顔願企伎危喜器基奇嬉寄岐希幾忌揮机旗既期棋棄���".split(""), e = 0; e != r[138].length; ++e)
        r[138][e].charCodeAt(0) !== 65533 && (c[r[138][e]] = 35328 + e, o[35328 + e] = r[138][e]);
      for (r[139] = "����������������������������������������������������������������機帰毅気汽畿祈季稀紀徽規記貴起軌輝飢騎鬼亀偽儀妓宜戯技擬欺犠疑祇義蟻誼議掬菊鞠吉吃喫桔橘詰砧杵黍却客脚虐逆丘久仇休及吸宮弓急救�朽求汲泣灸球究窮笈級糾給旧牛去居巨拒拠挙渠虚許距鋸漁禦魚亨享京供侠僑兇競共凶協匡卿叫喬境峡強彊怯恐恭挟教橋況狂狭矯胸脅興蕎郷鏡響饗驚仰凝尭暁業局曲極玉桐粁僅勤均巾錦斤欣欽琴禁禽筋緊芹菌衿襟謹近金吟銀九倶句区狗玖矩苦躯駆駈駒具愚虞喰空偶寓遇隅串櫛釧屑屈���".split(""), e = 0; e != r[139].length; ++e)
        r[139][e].charCodeAt(0) !== 65533 && (c[r[139][e]] = 35584 + e, o[35584 + e] = r[139][e]);
      for (r[140] = "����������������������������������������������������������������掘窟沓靴轡窪熊隈粂栗繰桑鍬勲君薫訓群軍郡卦袈祁係傾刑兄啓圭珪型契形径恵慶慧憩掲携敬景桂渓畦稽系経継繋罫茎荊蛍計詣警軽頚鶏芸迎鯨�劇戟撃激隙桁傑欠決潔穴結血訣月件倹倦健兼券剣喧圏堅嫌建憲懸拳捲検権牽犬献研硯絹県肩見謙賢軒遣鍵険顕験鹸元原厳幻弦減源玄現絃舷言諺限乎個古呼固姑孤己庫弧戸故枯湖狐糊袴股胡菰虎誇跨鈷雇顧鼓五互伍午呉吾娯後御悟梧檎瑚碁語誤護醐乞鯉交佼侯候倖光公功効勾厚口向���".split(""), e = 0; e != r[140].length; ++e)
        r[140][e].charCodeAt(0) !== 65533 && (c[r[140][e]] = 35840 + e, o[35840 + e] = r[140][e]);
      for (r[141] = "����������������������������������������������������������������后喉坑垢好孔孝宏工巧巷幸広庚康弘恒慌抗拘控攻昂晃更杭校梗構江洪浩港溝甲皇硬稿糠紅紘絞綱耕考肯肱腔膏航荒行衡講貢購郊酵鉱砿鋼閤降�項香高鴻剛劫号合壕拷濠豪轟麹克刻告国穀酷鵠黒獄漉腰甑忽惚骨狛込此頃今困坤墾婚恨懇昏昆根梱混痕紺艮魂些佐叉唆嵯左差査沙瑳砂詐鎖裟坐座挫債催再最哉塞妻宰彩才採栽歳済災采犀砕砦祭斎細菜裁載際剤在材罪財冴坂阪堺榊肴咲崎埼碕鷺作削咋搾昨朔柵窄策索錯桜鮭笹匙冊刷���".split(""), e = 0; e != r[141].length; ++e)
        r[141][e].charCodeAt(0) !== 65533 && (c[r[141][e]] = 36096 + e, o[36096 + e] = r[141][e]);
      for (r[142] = "����������������������������������������������������������������察拶撮擦札殺薩雑皐鯖捌錆鮫皿晒三傘参山惨撒散桟燦珊産算纂蚕讃賛酸餐斬暫残仕仔伺使刺司史嗣四士始姉姿子屍市師志思指支孜斯施旨枝止�死氏獅祉私糸紙紫肢脂至視詞詩試誌諮資賜雌飼歯事似侍児字寺慈持時次滋治爾璽痔磁示而耳自蒔辞汐鹿式識鴫竺軸宍雫七叱執失嫉室悉湿漆疾質実蔀篠偲柴芝屡蕊縞舎写射捨赦斜煮社紗者謝車遮蛇邪借勺尺杓灼爵酌釈錫若寂弱惹主取守手朱殊狩珠種腫趣酒首儒受呪寿授樹綬需囚収周���".split(""), e = 0; e != r[142].length; ++e)
        r[142][e].charCodeAt(0) !== 65533 && (c[r[142][e]] = 36352 + e, o[36352 + e] = r[142][e]);
      for (r[143] = "����������������������������������������������������������������宗就州修愁拾洲秀秋終繍習臭舟蒐衆襲讐蹴輯週酋酬集醜什住充十従戎柔汁渋獣縦重銃叔夙宿淑祝縮粛塾熟出術述俊峻春瞬竣舜駿准循旬楯殉淳�準潤盾純巡遵醇順処初所暑曙渚庶緒署書薯藷諸助叙女序徐恕鋤除傷償勝匠升召哨商唱嘗奨妾娼宵将小少尚庄床廠彰承抄招掌捷昇昌昭晶松梢樟樵沼消渉湘焼焦照症省硝礁祥称章笑粧紹肖菖蒋蕉衝裳訟証詔詳象賞醤鉦鍾鐘障鞘上丈丞乗冗剰城場壌嬢常情擾条杖浄状畳穣蒸譲醸錠嘱埴飾���".split(""), e = 0; e != r[143].length; ++e)
        r[143][e].charCodeAt(0) !== 65533 && (c[r[143][e]] = 36608 + e, o[36608 + e] = r[143][e]);
      for (r[144] = "����������������������������������������������������������������拭植殖燭織職色触食蝕辱尻伸信侵唇娠寝審心慎振新晋森榛浸深申疹真神秦紳臣芯薪親診身辛進針震人仁刃塵壬尋甚尽腎訊迅陣靭笥諏須酢図厨�逗吹垂帥推水炊睡粋翠衰遂酔錐錘随瑞髄崇嵩数枢趨雛据杉椙菅頗雀裾澄摺寸世瀬畝是凄制勢姓征性成政整星晴棲栖正清牲生盛精聖声製西誠誓請逝醒青静斉税脆隻席惜戚斥昔析石積籍績脊責赤跡蹟碩切拙接摂折設窃節説雪絶舌蝉仙先千占宣専尖川戦扇撰栓栴泉浅洗染潜煎煽旋穿箭線���".split(""), e = 0; e != r[144].length; ++e)
        r[144][e].charCodeAt(0) !== 65533 && (c[r[144][e]] = 36864 + e, o[36864 + e] = r[144][e]);
      for (r[145] = "����������������������������������������������������������������繊羨腺舛船薦詮賎践選遷銭銑閃鮮前善漸然全禅繕膳糎噌塑岨措曾曽楚狙疏疎礎祖租粗素組蘇訴阻遡鼠僧創双叢倉喪壮奏爽宋層匝惣想捜掃挿掻�操早曹巣槍槽漕燥争痩相窓糟総綜聡草荘葬蒼藻装走送遭鎗霜騒像増憎臓蔵贈造促側則即息捉束測足速俗属賊族続卒袖其揃存孫尊損村遜他多太汰詑唾堕妥惰打柁舵楕陀駄騨体堆対耐岱帯待怠態戴替泰滞胎腿苔袋貸退逮隊黛鯛代台大第醍題鷹滝瀧卓啄宅托択拓沢濯琢託鐸濁諾茸凧蛸只���".split(""), e = 0; e != r[145].length; ++e)
        r[145][e].charCodeAt(0) !== 65533 && (c[r[145][e]] = 37120 + e, o[37120 + e] = r[145][e]);
      for (r[146] = "����������������������������������������������������������������叩但達辰奪脱巽竪辿棚谷狸鱈樽誰丹単嘆坦担探旦歎淡湛炭短端箪綻耽胆蛋誕鍛団壇弾断暖檀段男談値知地弛恥智池痴稚置致蜘遅馳築畜竹筑蓄�逐秩窒茶嫡着中仲宙忠抽昼柱注虫衷註酎鋳駐樗瀦猪苧著貯丁兆凋喋寵帖帳庁弔張彫徴懲挑暢朝潮牒町眺聴脹腸蝶調諜超跳銚長頂鳥勅捗直朕沈珍賃鎮陳津墜椎槌追鎚痛通塚栂掴槻佃漬柘辻蔦綴鍔椿潰坪壷嬬紬爪吊釣鶴亭低停偵剃貞呈堤定帝底庭廷弟悌抵挺提梯汀碇禎程締艇訂諦蹄逓���".split(""), e = 0; e != r[146].length; ++e)
        r[146][e].charCodeAt(0) !== 65533 && (c[r[146][e]] = 37376 + e, o[37376 + e] = r[146][e]);
      for (r[147] = "����������������������������������������������������������������邸鄭釘鼎泥摘擢敵滴的笛適鏑溺哲徹撤轍迭鉄典填天展店添纏甜貼転顛点伝殿澱田電兎吐堵塗妬屠徒斗杜渡登菟賭途都鍍砥砺努度土奴怒倒党冬�凍刀唐塔塘套宕島嶋悼投搭東桃梼棟盗淘湯涛灯燈当痘祷等答筒糖統到董蕩藤討謄豆踏逃透鐙陶頭騰闘働動同堂導憧撞洞瞳童胴萄道銅峠鴇匿得徳涜特督禿篤毒独読栃橡凸突椴届鳶苫寅酉瀞噸屯惇敦沌豚遁頓呑曇鈍奈那内乍凪薙謎灘捺鍋楢馴縄畷南楠軟難汝二尼弐迩匂賑肉虹廿日乳入���".split(""), e = 0; e != r[147].length; ++e)
        r[147][e].charCodeAt(0) !== 65533 && (c[r[147][e]] = 37632 + e, o[37632 + e] = r[147][e]);
      for (r[148] = "����������������������������������������������������������������如尿韮任妊忍認濡禰祢寧葱猫熱年念捻撚燃粘乃廼之埜嚢悩濃納能脳膿農覗蚤巴把播覇杷波派琶破婆罵芭馬俳廃拝排敗杯盃牌背肺輩配倍培媒梅�楳煤狽買売賠陪這蝿秤矧萩伯剥博拍柏泊白箔粕舶薄迫曝漠爆縛莫駁麦函箱硲箸肇筈櫨幡肌畑畠八鉢溌発醗髪伐罰抜筏閥鳩噺塙蛤隼伴判半反叛帆搬斑板氾汎版犯班畔繁般藩販範釆煩頒飯挽晩番盤磐蕃蛮匪卑否妃庇彼悲扉批披斐比泌疲皮碑秘緋罷肥被誹費避非飛樋簸備尾微枇毘琵眉美���".split(""), e = 0; e != r[148].length; ++e)
        r[148][e].charCodeAt(0) !== 65533 && (c[r[148][e]] = 37888 + e, o[37888 + e] = r[148][e]);
      for (r[149] = "����������������������������������������������������������������鼻柊稗匹疋髭彦膝菱肘弼必畢筆逼桧姫媛紐百謬俵彪標氷漂瓢票表評豹廟描病秒苗錨鋲蒜蛭鰭品彬斌浜瀕貧賓頻敏瓶不付埠夫婦富冨布府怖扶敷�斧普浮父符腐膚芙譜負賦赴阜附侮撫武舞葡蕪部封楓風葺蕗伏副復幅服福腹複覆淵弗払沸仏物鮒分吻噴墳憤扮焚奮粉糞紛雰文聞丙併兵塀幣平弊柄並蔽閉陛米頁僻壁癖碧別瞥蔑箆偏変片篇編辺返遍便勉娩弁鞭保舗鋪圃捕歩甫補輔穂募墓慕戊暮母簿菩倣俸包呆報奉宝峰峯崩庖抱捧放方朋���".split(""), e = 0; e != r[149].length; ++e)
        r[149][e].charCodeAt(0) !== 65533 && (c[r[149][e]] = 38144 + e, o[38144 + e] = r[149][e]);
      for (r[150] = "����������������������������������������������������������������法泡烹砲縫胞芳萌蓬蜂褒訪豊邦鋒飽鳳鵬乏亡傍剖坊妨帽忘忙房暴望某棒冒紡肪膨謀貌貿鉾防吠頬北僕卜墨撲朴牧睦穆釦勃没殆堀幌奔本翻凡盆�摩磨魔麻埋妹昧枚毎哩槙幕膜枕鮪柾鱒桝亦俣又抹末沫迄侭繭麿万慢満漫蔓味未魅巳箕岬密蜜湊蓑稔脈妙粍民眠務夢無牟矛霧鵡椋婿娘冥名命明盟迷銘鳴姪牝滅免棉綿緬面麺摸模茂妄孟毛猛盲網耗蒙儲木黙目杢勿餅尤戻籾貰問悶紋門匁也冶夜爺耶野弥矢厄役約薬訳躍靖柳薮鑓愉愈油癒���".split(""), e = 0; e != r[150].length; ++e)
        r[150][e].charCodeAt(0) !== 65533 && (c[r[150][e]] = 38400 + e, o[38400 + e] = r[150][e]);
      for (r[151] = "����������������������������������������������������������������諭輸唯佑優勇友宥幽悠憂揖有柚湧涌猶猷由祐裕誘遊邑郵雄融夕予余与誉輿預傭幼妖容庸揚揺擁曜楊様洋溶熔用窯羊耀葉蓉要謡踊遥陽養慾抑欲�沃浴翌翼淀羅螺裸来莱頼雷洛絡落酪乱卵嵐欄濫藍蘭覧利吏履李梨理璃痢裏裡里離陸律率立葎掠略劉流溜琉留硫粒隆竜龍侶慮旅虜了亮僚両凌寮料梁涼猟療瞭稜糧良諒遼量陵領力緑倫厘林淋燐琳臨輪隣鱗麟瑠塁涙累類令伶例冷励嶺怜玲礼苓鈴隷零霊麗齢暦歴列劣烈裂廉恋憐漣煉簾練聯���".split(""), e = 0; e != r[151].length; ++e)
        r[151][e].charCodeAt(0) !== 65533 && (c[r[151][e]] = 38656 + e, o[38656 + e] = r[151][e]);
      for (r[152] = "����������������������������������������������������������������蓮連錬呂魯櫓炉賂路露労婁廊弄朗楼榔浪漏牢狼篭老聾蝋郎六麓禄肋録論倭和話歪賄脇惑枠鷲亙亘鰐詫藁蕨椀湾碗腕��������������������������������������������弌丐丕个丱丶丼丿乂乖乘亂亅豫亊舒弍于亞亟亠亢亰亳亶从仍仄仆仂仗仞仭仟价伉佚估佛佝佗佇佶侈侏侘佻佩佰侑佯來侖儘俔俟俎俘俛俑俚俐俤俥倚倨倔倪倥倅伜俶倡倩倬俾俯們倆偃假會偕偐偈做偖偬偸傀傚傅傴傲���".split(""), e = 0; e != r[152].length; ++e)
        r[152][e].charCodeAt(0) !== 65533 && (c[r[152][e]] = 38912 + e, o[38912 + e] = r[152][e]);
      for (r[153] = "����������������������������������������������������������������僉僊傳僂僖僞僥僭僣僮價僵儉儁儂儖儕儔儚儡儺儷儼儻儿兀兒兌兔兢竸兩兪兮冀冂囘册冉冏冑冓冕冖冤冦冢冩冪冫决冱冲冰况冽凅凉凛几處凩凭�凰凵凾刄刋刔刎刧刪刮刳刹剏剄剋剌剞剔剪剴剩剳剿剽劍劔劒剱劈劑辨辧劬劭劼劵勁勍勗勞勣勦飭勠勳勵勸勹匆匈甸匍匐匏匕匚匣匯匱匳匸區卆卅丗卉卍凖卞卩卮夘卻卷厂厖厠厦厥厮厰厶參簒雙叟曼燮叮叨叭叺吁吽呀听吭吼吮吶吩吝呎咏呵咎呟呱呷呰咒呻咀呶咄咐咆哇咢咸咥咬哄哈咨���".split(""), e = 0; e != r[153].length; ++e)
        r[153][e].charCodeAt(0) !== 65533 && (c[r[153][e]] = 39168 + e, o[39168 + e] = r[153][e]);
      for (r[154] = "����������������������������������������������������������������咫哂咤咾咼哘哥哦唏唔哽哮哭哺哢唹啀啣啌售啜啅啖啗唸唳啝喙喀咯喊喟啻啾喘喞單啼喃喩喇喨嗚嗅嗟嗄嗜嗤嗔嘔嗷嘖嗾嗽嘛嗹噎噐營嘴嘶嘲嘸�噫噤嘯噬噪嚆嚀嚊嚠嚔嚏嚥嚮嚶嚴囂嚼囁囃囀囈囎囑囓囗囮囹圀囿圄圉圈國圍圓團圖嗇圜圦圷圸坎圻址坏坩埀垈坡坿垉垓垠垳垤垪垰埃埆埔埒埓堊埖埣堋堙堝塲堡塢塋塰毀塒堽塹墅墹墟墫墺壞墻墸墮壅壓壑壗壙壘壥壜壤壟壯壺壹壻壼壽夂夊夐夛梦夥夬夭夲夸夾竒奕奐奎奚奘奢奠奧奬奩���".split(""), e = 0; e != r[154].length; ++e)
        r[154][e].charCodeAt(0) !== 65533 && (c[r[154][e]] = 39424 + e, o[39424 + e] = r[154][e]);
      for (r[155] = "����������������������������������������������������������������奸妁妝佞侫妣妲姆姨姜妍姙姚娥娟娑娜娉娚婀婬婉娵娶婢婪媚媼媾嫋嫂媽嫣嫗嫦嫩嫖嫺嫻嬌嬋嬖嬲嫐嬪嬶嬾孃孅孀孑孕孚孛孥孩孰孳孵學斈孺宀�它宦宸寃寇寉寔寐寤實寢寞寥寫寰寶寳尅將專對尓尠尢尨尸尹屁屆屎屓屐屏孱屬屮乢屶屹岌岑岔妛岫岻岶岼岷峅岾峇峙峩峽峺峭嶌峪崋崕崗嵜崟崛崑崔崢崚崙崘嵌嵒嵎嵋嵬嵳嵶嶇嶄嶂嶢嶝嶬嶮嶽嶐嶷嶼巉巍巓巒巖巛巫已巵帋帚帙帑帛帶帷幄幃幀幎幗幔幟幢幤幇幵并幺麼广庠廁廂廈廐廏���".split(""), e = 0; e != r[155].length; ++e)
        r[155][e].charCodeAt(0) !== 65533 && (c[r[155][e]] = 39680 + e, o[39680 + e] = r[155][e]);
      for (r[156] = "����������������������������������������������������������������廖廣廝廚廛廢廡廨廩廬廱廳廰廴廸廾弃弉彝彜弋弑弖弩弭弸彁彈彌彎弯彑彖彗彙彡彭彳彷徃徂彿徊很徑徇從徙徘徠徨徭徼忖忻忤忸忱忝悳忿怡恠�怙怐怩怎怱怛怕怫怦怏怺恚恁恪恷恟恊恆恍恣恃恤恂恬恫恙悁悍惧悃悚悄悛悖悗悒悧悋惡悸惠惓悴忰悽惆悵惘慍愕愆惶惷愀惴惺愃愡惻惱愍愎慇愾愨愧慊愿愼愬愴愽慂慄慳慷慘慙慚慫慴慯慥慱慟慝慓慵憙憖憇憬憔憚憊憑憫憮懌懊應懷懈懃懆憺懋罹懍懦懣懶懺懴懿懽懼懾戀戈戉戍戌戔戛���".split(""), e = 0; e != r[156].length; ++e)
        r[156][e].charCodeAt(0) !== 65533 && (c[r[156][e]] = 39936 + e, o[39936 + e] = r[156][e]);
      for (r[157] = "����������������������������������������������������������������戞戡截戮戰戲戳扁扎扞扣扛扠扨扼抂抉找抒抓抖拔抃抔拗拑抻拏拿拆擔拈拜拌拊拂拇抛拉挌拮拱挧挂挈拯拵捐挾捍搜捏掖掎掀掫捶掣掏掉掟掵捫�捩掾揩揀揆揣揉插揶揄搖搴搆搓搦搶攝搗搨搏摧摯摶摎攪撕撓撥撩撈撼據擒擅擇撻擘擂擱擧舉擠擡抬擣擯攬擶擴擲擺攀擽攘攜攅攤攣攫攴攵攷收攸畋效敖敕敍敘敞敝敲數斂斃變斛斟斫斷旃旆旁旄旌旒旛旙无旡旱杲昊昃旻杳昵昶昴昜晏晄晉晁晞晝晤晧晨晟晢晰暃暈暎暉暄暘暝曁暹曉暾暼���".split(""), e = 0; e != r[157].length; ++e)
        r[157][e].charCodeAt(0) !== 65533 && (c[r[157][e]] = 40192 + e, o[40192 + e] = r[157][e]);
      for (r[158] = "����������������������������������������������������������������曄暸曖曚曠昿曦曩曰曵曷朏朖朞朦朧霸朮朿朶杁朸朷杆杞杠杙杣杤枉杰枩杼杪枌枋枦枡枅枷柯枴柬枳柩枸柤柞柝柢柮枹柎柆柧檜栞框栩桀桍栲桎�梳栫桙档桷桿梟梏梭梔條梛梃檮梹桴梵梠梺椏梍桾椁棊椈棘椢椦棡椌棍棔棧棕椶椒椄棗棣椥棹棠棯椨椪椚椣椡棆楹楷楜楸楫楔楾楮椹楴椽楙椰楡楞楝榁楪榲榮槐榿槁槓榾槎寨槊槝榻槃榧樮榑榠榜榕榴槞槨樂樛槿權槹槲槧樅榱樞槭樔槫樊樒櫁樣樓橄樌橲樶橸橇橢橙橦橈樸樢檐檍檠檄檢檣���".split(""), e = 0; e != r[158].length; ++e)
        r[158][e].charCodeAt(0) !== 65533 && (c[r[158][e]] = 40448 + e, o[40448 + e] = r[158][e]);
      for (r[159] = "����������������������������������������������������������������檗蘗檻櫃櫂檸檳檬櫞櫑櫟檪櫚櫪櫻欅蘖櫺欒欖鬱欟欸欷盜欹飮歇歃歉歐歙歔歛歟歡歸歹歿殀殄殃殍殘殕殞殤殪殫殯殲殱殳殷殼毆毋毓毟毬毫毳毯�麾氈氓气氛氤氣汞汕汢汪沂沍沚沁沛汾汨汳沒沐泄泱泓沽泗泅泝沮沱沾沺泛泯泙泪洟衍洶洫洽洸洙洵洳洒洌浣涓浤浚浹浙涎涕濤涅淹渕渊涵淇淦涸淆淬淞淌淨淒淅淺淙淤淕淪淮渭湮渮渙湲湟渾渣湫渫湶湍渟湃渺湎渤滿渝游溂溪溘滉溷滓溽溯滄溲滔滕溏溥滂溟潁漑灌滬滸滾漿滲漱滯漲滌���".split(""), e = 0; e != r[159].length; ++e)
        r[159][e].charCodeAt(0) !== 65533 && (c[r[159][e]] = 40704 + e, o[40704 + e] = r[159][e]);
      for (r[224] = "����������������������������������������������������������������漾漓滷澆潺潸澁澀潯潛濳潭澂潼潘澎澑濂潦澳澣澡澤澹濆澪濟濕濬濔濘濱濮濛瀉瀋濺瀑瀁瀏濾瀛瀚潴瀝瀘瀟瀰瀾瀲灑灣炙炒炯烱炬炸炳炮烟烋烝�烙焉烽焜焙煥煕熈煦煢煌煖煬熏燻熄熕熨熬燗熹熾燒燉燔燎燠燬燧燵燼燹燿爍爐爛爨爭爬爰爲爻爼爿牀牆牋牘牴牾犂犁犇犒犖犢犧犹犲狃狆狄狎狒狢狠狡狹狷倏猗猊猜猖猝猴猯猩猥猾獎獏默獗獪獨獰獸獵獻獺珈玳珎玻珀珥珮珞璢琅瑯琥珸琲琺瑕琿瑟瑙瑁瑜瑩瑰瑣瑪瑶瑾璋璞璧瓊瓏瓔珱���".split(""), e = 0; e != r[224].length; ++e)
        r[224][e].charCodeAt(0) !== 65533 && (c[r[224][e]] = 57344 + e, o[57344 + e] = r[224][e]);
      for (r[225] = "����������������������������������������������������������������瓠瓣瓧瓩瓮瓲瓰瓱瓸瓷甄甃甅甌甎甍甕甓甞甦甬甼畄畍畊畉畛畆畚畩畤畧畫畭畸當疆疇畴疊疉疂疔疚疝疥疣痂疳痃疵疽疸疼疱痍痊痒痙痣痞痾痿�痼瘁痰痺痲痳瘋瘍瘉瘟瘧瘠瘡瘢瘤瘴瘰瘻癇癈癆癜癘癡癢癨癩癪癧癬癰癲癶癸發皀皃皈皋皎皖皓皙皚皰皴皸皹皺盂盍盖盒盞盡盥盧盪蘯盻眈眇眄眩眤眞眥眦眛眷眸睇睚睨睫睛睥睿睾睹瞎瞋瞑瞠瞞瞰瞶瞹瞿瞼瞽瞻矇矍矗矚矜矣矮矼砌砒礦砠礪硅碎硴碆硼碚碌碣碵碪碯磑磆磋磔碾碼磅磊磬���".split(""), e = 0; e != r[225].length; ++e)
        r[225][e].charCodeAt(0) !== 65533 && (c[r[225][e]] = 57600 + e, o[57600 + e] = r[225][e]);
      for (r[226] = "����������������������������������������������������������������磧磚磽磴礇礒礑礙礬礫祀祠祗祟祚祕祓祺祿禊禝禧齋禪禮禳禹禺秉秕秧秬秡秣稈稍稘稙稠稟禀稱稻稾稷穃穗穉穡穢穩龝穰穹穽窈窗窕窘窖窩竈窰�窶竅竄窿邃竇竊竍竏竕竓站竚竝竡竢竦竭竰笂笏笊笆笳笘笙笞笵笨笶筐筺笄筍笋筌筅筵筥筴筧筰筱筬筮箝箘箟箍箜箚箋箒箏筝箙篋篁篌篏箴篆篝篩簑簔篦篥籠簀簇簓篳篷簗簍篶簣簧簪簟簷簫簽籌籃籔籏籀籐籘籟籤籖籥籬籵粃粐粤粭粢粫粡粨粳粲粱粮粹粽糀糅糂糘糒糜糢鬻糯糲糴糶糺紆���".split(""), e = 0; e != r[226].length; ++e)
        r[226][e].charCodeAt(0) !== 65533 && (c[r[226][e]] = 57856 + e, o[57856 + e] = r[226][e]);
      for (r[227] = "����������������������������������������������������������������紂紜紕紊絅絋紮紲紿紵絆絳絖絎絲絨絮絏絣經綉絛綏絽綛綺綮綣綵緇綽綫總綢綯緜綸綟綰緘緝緤緞緻緲緡縅縊縣縡縒縱縟縉縋縢繆繦縻縵縹繃縷�縲縺繧繝繖繞繙繚繹繪繩繼繻纃緕繽辮繿纈纉續纒纐纓纔纖纎纛纜缸缺罅罌罍罎罐网罕罔罘罟罠罨罩罧罸羂羆羃羈羇羌羔羞羝羚羣羯羲羹羮羶羸譱翅翆翊翕翔翡翦翩翳翹飜耆耄耋耒耘耙耜耡耨耿耻聊聆聒聘聚聟聢聨聳聲聰聶聹聽聿肄肆肅肛肓肚肭冐肬胛胥胙胝胄胚胖脉胯胱脛脩脣脯腋���".split(""), e = 0; e != r[227].length; ++e)
        r[227][e].charCodeAt(0) !== 65533 && (c[r[227][e]] = 58112 + e, o[58112 + e] = r[227][e]);
      for (r[228] = "����������������������������������������������������������������隋腆脾腓腑胼腱腮腥腦腴膃膈膊膀膂膠膕膤膣腟膓膩膰膵膾膸膽臀臂膺臉臍臑臙臘臈臚臟臠臧臺臻臾舁舂舅與舊舍舐舖舩舫舸舳艀艙艘艝艚艟艤�艢艨艪艫舮艱艷艸艾芍芒芫芟芻芬苡苣苟苒苴苳苺莓范苻苹苞茆苜茉苙茵茴茖茲茱荀茹荐荅茯茫茗茘莅莚莪莟莢莖茣莎莇莊荼莵荳荵莠莉莨菴萓菫菎菽萃菘萋菁菷萇菠菲萍萢萠莽萸蔆菻葭萪萼蕚蒄葷葫蒭葮蒂葩葆萬葯葹萵蓊葢蒹蒿蒟蓙蓍蒻蓚蓐蓁蓆蓖蒡蔡蓿蓴蔗蔘蔬蔟蔕蔔蓼蕀蕣蕘蕈���".split(""), e = 0; e != r[228].length; ++e)
        r[228][e].charCodeAt(0) !== 65533 && (c[r[228][e]] = 58368 + e, o[58368 + e] = r[228][e]);
      for (r[229] = "����������������������������������������������������������������蕁蘂蕋蕕薀薤薈薑薊薨蕭薔薛藪薇薜蕷蕾薐藉薺藏薹藐藕藝藥藜藹蘊蘓蘋藾藺蘆蘢蘚蘰蘿虍乕虔號虧虱蚓蚣蚩蚪蚋蚌蚶蚯蛄蛆蚰蛉蠣蚫蛔蛞蛩蛬�蛟蛛蛯蜒蜆蜈蜀蜃蛻蜑蜉蜍蛹蜊蜴蜿蜷蜻蜥蜩蜚蝠蝟蝸蝌蝎蝴蝗蝨蝮蝙蝓蝣蝪蠅螢螟螂螯蟋螽蟀蟐雖螫蟄螳蟇蟆螻蟯蟲蟠蠏蠍蟾蟶蟷蠎蟒蠑蠖蠕蠢蠡蠱蠶蠹蠧蠻衄衂衒衙衞衢衫袁衾袞衵衽袵衲袂袗袒袮袙袢袍袤袰袿袱裃裄裔裘裙裝裹褂裼裴裨裲褄褌褊褓襃褞褥褪褫襁襄褻褶褸襌褝襠襞���".split(""), e = 0; e != r[229].length; ++e)
        r[229][e].charCodeAt(0) !== 65533 && (c[r[229][e]] = 58624 + e, o[58624 + e] = r[229][e]);
      for (r[230] = "����������������������������������������������������������������襦襤襭襪襯襴襷襾覃覈覊覓覘覡覩覦覬覯覲覺覽覿觀觚觜觝觧觴觸訃訖訐訌訛訝訥訶詁詛詒詆詈詼詭詬詢誅誂誄誨誡誑誥誦誚誣諄諍諂諚諫諳諧�諤諱謔諠諢諷諞諛謌謇謚諡謖謐謗謠謳鞫謦謫謾謨譁譌譏譎證譖譛譚譫譟譬譯譴譽讀讌讎讒讓讖讙讚谺豁谿豈豌豎豐豕豢豬豸豺貂貉貅貊貍貎貔豼貘戝貭貪貽貲貳貮貶賈賁賤賣賚賽賺賻贄贅贊贇贏贍贐齎贓賍贔贖赧赭赱赳趁趙跂趾趺跏跚跖跌跛跋跪跫跟跣跼踈踉跿踝踞踐踟蹂踵踰踴蹊���".split(""), e = 0; e != r[230].length; ++e)
        r[230][e].charCodeAt(0) !== 65533 && (c[r[230][e]] = 58880 + e, o[58880 + e] = r[230][e]);
      for (r[231] = "����������������������������������������������������������������蹇蹉蹌蹐蹈蹙蹤蹠踪蹣蹕蹶蹲蹼躁躇躅躄躋躊躓躑躔躙躪躡躬躰軆躱躾軅軈軋軛軣軼軻軫軾輊輅輕輒輙輓輜輟輛輌輦輳輻輹轅轂輾轌轉轆轎轗轜�轢轣轤辜辟辣辭辯辷迚迥迢迪迯邇迴逅迹迺逑逕逡逍逞逖逋逧逶逵逹迸遏遐遑遒逎遉逾遖遘遞遨遯遶隨遲邂遽邁邀邊邉邏邨邯邱邵郢郤扈郛鄂鄒鄙鄲鄰酊酖酘酣酥酩酳酲醋醉醂醢醫醯醪醵醴醺釀釁釉釋釐釖釟釡釛釼釵釶鈞釿鈔鈬鈕鈑鉞鉗鉅鉉鉤鉈銕鈿鉋鉐銜銖銓銛鉚鋏銹銷鋩錏鋺鍄錮���".split(""), e = 0; e != r[231].length; ++e)
        r[231][e].charCodeAt(0) !== 65533 && (c[r[231][e]] = 59136 + e, o[59136 + e] = r[231][e]);
      for (r[232] = "����������������������������������������������������������������錙錢錚錣錺錵錻鍜鍠鍼鍮鍖鎰鎬鎭鎔鎹鏖鏗鏨鏥鏘鏃鏝鏐鏈鏤鐚鐔鐓鐃鐇鐐鐶鐫鐵鐡鐺鑁鑒鑄鑛鑠鑢鑞鑪鈩鑰鑵鑷鑽鑚鑼鑾钁鑿閂閇閊閔閖閘閙�閠閨閧閭閼閻閹閾闊濶闃闍闌闕闔闖關闡闥闢阡阨阮阯陂陌陏陋陷陜陞陝陟陦陲陬隍隘隕隗險隧隱隲隰隴隶隸隹雎雋雉雍襍雜霍雕雹霄霆霈霓霎霑霏霖霙霤霪霰霹霽霾靄靆靈靂靉靜靠靤靦靨勒靫靱靹鞅靼鞁靺鞆鞋鞏鞐鞜鞨鞦鞣鞳鞴韃韆韈韋韜韭齏韲竟韶韵頏頌頸頤頡頷頽顆顏顋顫顯顰���".split(""), e = 0; e != r[232].length; ++e)
        r[232][e].charCodeAt(0) !== 65533 && (c[r[232][e]] = 59392 + e, o[59392 + e] = r[232][e]);
      for (r[233] = "����������������������������������������������������������������顱顴顳颪颯颱颶飄飃飆飩飫餃餉餒餔餘餡餝餞餤餠餬餮餽餾饂饉饅饐饋饑饒饌饕馗馘馥馭馮馼駟駛駝駘駑駭駮駱駲駻駸騁騏騅駢騙騫騷驅驂驀驃�騾驕驍驛驗驟驢驥驤驩驫驪骭骰骼髀髏髑髓體髞髟髢髣髦髯髫髮髴髱髷髻鬆鬘鬚鬟鬢鬣鬥鬧鬨鬩鬪鬮鬯鬲魄魃魏魍魎魑魘魴鮓鮃鮑鮖鮗鮟鮠鮨鮴鯀鯊鮹鯆鯏鯑鯒鯣鯢鯤鯔鯡鰺鯲鯱鯰鰕鰔鰉鰓鰌鰆鰈鰒鰊鰄鰮鰛鰥鰤鰡鰰鱇鰲鱆鰾鱚鱠鱧鱶鱸鳧鳬鳰鴉鴈鳫鴃鴆鴪鴦鶯鴣鴟鵄鴕鴒鵁鴿鴾鵆鵈���".split(""), e = 0; e != r[233].length; ++e)
        r[233][e].charCodeAt(0) !== 65533 && (c[r[233][e]] = 59648 + e, o[59648 + e] = r[233][e]);
      for (r[234] = "����������������������������������������������������������������鵝鵞鵤鵑鵐鵙鵲鶉鶇鶫鵯鵺鶚鶤鶩鶲鷄鷁鶻鶸鶺鷆鷏鷂鷙鷓鷸鷦鷭鷯鷽鸚鸛鸞鹵鹹鹽麁麈麋麌麒麕麑麝麥麩麸麪麭靡黌黎黏黐黔黜點黝黠黥黨黯�黴黶黷黹黻黼黽鼇鼈皷鼕鼡鼬鼾齊齒齔齣齟齠齡齦齧齬齪齷齲齶龕龜龠堯槇遙瑤凜熙�������������������������������������������������������������������������������������������".split(""), e = 0; e != r[234].length; ++e)
        r[234][e].charCodeAt(0) !== 65533 && (c[r[234][e]] = 59904 + e, o[59904 + e] = r[234][e]);
      for (r[237] = "����������������������������������������������������������������纊褜鍈銈蓜俉炻昱棈鋹曻彅丨仡仼伀伃伹佖侒侊侚侔俍偀倢俿倞偆偰偂傔僴僘兊兤冝冾凬刕劜劦勀勛匀匇匤卲厓厲叝﨎咜咊咩哿喆坙坥垬埈埇﨏�塚增墲夋奓奛奝奣妤妺孖寀甯寘寬尞岦岺峵崧嵓﨑嵂嵭嶸嶹巐弡弴彧德忞恝悅悊惞惕愠惲愑愷愰憘戓抦揵摠撝擎敎昀昕昻昉昮昞昤晥晗晙晴晳暙暠暲暿曺朎朗杦枻桒柀栁桄棏﨓楨﨔榘槢樰橫橆橳橾櫢櫤毖氿汜沆汯泚洄涇浯涖涬淏淸淲淼渹湜渧渼溿澈澵濵瀅瀇瀨炅炫焏焄煜煆煇凞燁燾犱���".split(""), e = 0; e != r[237].length; ++e)
        r[237][e].charCodeAt(0) !== 65533 && (c[r[237][e]] = 60672 + e, o[60672 + e] = r[237][e]);
      for (r[238] = "����������������������������������������������������������������犾猤猪獷玽珉珖珣珒琇珵琦琪琩琮瑢璉璟甁畯皂皜皞皛皦益睆劯砡硎硤硺礰礼神祥禔福禛竑竧靖竫箞精絈絜綷綠緖繒罇羡羽茁荢荿菇菶葈蒴蕓蕙�蕫﨟薰蘒﨡蠇裵訒訷詹誧誾諟諸諶譓譿賰賴贒赶﨣軏﨤逸遧郞都鄕鄧釚釗釞釭釮釤釥鈆鈐鈊鈺鉀鈼鉎鉙鉑鈹鉧銧鉷鉸鋧鋗鋙鋐﨧鋕鋠鋓錥錡鋻﨨錞鋿錝錂鍰鍗鎤鏆鏞鏸鐱鑅鑈閒隆﨩隝隯霳霻靃靍靏靑靕顗顥飯飼餧館馞驎髙髜魵魲鮏鮱鮻鰀鵰鵫鶴鸙黑��ⅰⅱⅲⅳⅴⅵⅶⅷⅸⅹ￢￤＇＂���".split(""), e = 0; e != r[238].length; ++e)
        r[238][e].charCodeAt(0) !== 65533 && (c[r[238][e]] = 60928 + e, o[60928 + e] = r[238][e]);
      for (r[250] = "����������������������������������������������������������������ⅰⅱⅲⅳⅴⅵⅶⅷⅸⅹⅠⅡⅢⅣⅤⅥⅦⅧⅨⅩ￢￤＇＂㈱№℡∵纊褜鍈銈蓜俉炻昱棈鋹曻彅丨仡仼伀伃伹佖侒侊侚侔俍偀倢俿倞偆偰偂傔僴僘兊�兤冝冾凬刕劜劦勀勛匀匇匤卲厓厲叝﨎咜咊咩哿喆坙坥垬埈埇﨏塚增墲夋奓奛奝奣妤妺孖寀甯寘寬尞岦岺峵崧嵓﨑嵂嵭嶸嶹巐弡弴彧德忞恝悅悊惞惕愠惲愑愷愰憘戓抦揵摠撝擎敎昀昕昻昉昮昞昤晥晗晙晴晳暙暠暲暿曺朎朗杦枻桒柀栁桄棏﨓楨﨔榘槢樰橫橆橳橾櫢櫤毖氿汜沆汯泚洄涇浯���".split(""), e = 0; e != r[250].length; ++e)
        r[250][e].charCodeAt(0) !== 65533 && (c[r[250][e]] = 64e3 + e, o[64e3 + e] = r[250][e]);
      for (r[251] = "����������������������������������������������������������������涖涬淏淸淲淼渹湜渧渼溿澈澵濵瀅瀇瀨炅炫焏焄煜煆煇凞燁燾犱犾猤猪獷玽珉珖珣珒琇珵琦琪琩琮瑢璉璟甁畯皂皜皞皛皦益睆劯砡硎硤硺礰礼神�祥禔福禛竑竧靖竫箞精絈絜綷綠緖繒罇羡羽茁荢荿菇菶葈蒴蕓蕙蕫﨟薰蘒﨡蠇裵訒訷詹誧誾諟諸諶譓譿賰賴贒赶﨣軏﨤逸遧郞都鄕鄧釚釗釞釭釮釤釥鈆鈐鈊鈺鉀鈼鉎鉙鉑鈹鉧銧鉷鉸鋧鋗鋙鋐﨧鋕鋠鋓錥錡鋻﨨錞鋿錝錂鍰鍗鎤鏆鏞鏸鐱鑅鑈閒隆﨩隝隯霳霻靃靍靏靑靕顗顥飯飼餧館馞驎髙���".split(""), e = 0; e != r[251].length; ++e)
        r[251][e].charCodeAt(0) !== 65533 && (c[r[251][e]] = 64256 + e, o[64256 + e] = r[251][e]);
      for (r[252] = "����������������������������������������������������������������髜魵魲鮏鮱鮻鰀鵰鵫鶴鸙黑������������������������������������������������������������������������������������������������������������������������������������������������������������������������������������".split(""), e = 0; e != r[252].length; ++e)
        r[252][e].charCodeAt(0) !== 65533 && (c[r[252][e]] = 64512 + e, o[64512 + e] = r[252][e]);
      return { enc: c, dec: o };
    }(), i[936] = function() {
      var o = [], c = {}, r = [], e;
      for (r[0] = `\0\x07\b	
\v\f\r\x1B !"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_\`abcdefghijklmnopqrstuvwxyz{|}~€�������������������������������������������������������������������������������������������������������������������������������`.split(""), e = 0; e != r[0].length; ++e)
        r[0][e].charCodeAt(0) !== 65533 && (c[r[0][e]] = 0 + e, o[0 + e] = r[0][e]);
      for (r[129] = "����������������������������������������������������������������丂丄丅丆丏丒丗丟丠両丣並丩丮丯丱丳丵丷丼乀乁乂乄乆乊乑乕乗乚乛乢乣乤乥乧乨乪乫乬乭乮乯乲乴乵乶乷乸乹乺乻乼乽乿亀亁亂亃亄亅亇亊�亐亖亗亙亜亝亞亣亪亯亰亱亴亶亷亸亹亼亽亾仈仌仏仐仒仚仛仜仠仢仦仧仩仭仮仯仱仴仸仹仺仼仾伀伂伃伄伅伆伇伈伋伌伒伓伔伕伖伜伝伡伣伨伩伬伭伮伱伳伵伷伹伻伾伿佀佁佂佄佅佇佈佉佊佋佌佒佔佖佡佢佦佨佪佫佭佮佱佲併佷佸佹佺佽侀侁侂侅來侇侊侌侎侐侒侓侕侖侘侙侚侜侞侟価侢�".split(""), e = 0; e != r[129].length; ++e)
        r[129][e].charCodeAt(0) !== 65533 && (c[r[129][e]] = 33024 + e, o[33024 + e] = r[129][e]);
      for (r[130] = "����������������������������������������������������������������侤侫侭侰侱侲侳侴侶侷侸侹侺侻侼侽侾俀俁係俆俇俈俉俋俌俍俒俓俔俕俖俙俛俠俢俤俥俧俫俬俰俲俴俵俶俷俹俻俼俽俿倀倁倂倃倄倅倆倇倈倉倊�個倎倐們倓倕倖倗倛倝倞倠倢倣値倧倫倯倰倱倲倳倴倵倶倷倸倹倻倽倿偀偁偂偄偅偆偉偊偋偍偐偑偒偓偔偖偗偘偙偛偝偞偟偠偡偢偣偤偦偧偨偩偪偫偭偮偯偰偱偲偳側偵偸偹偺偼偽傁傂傃傄傆傇傉傊傋傌傎傏傐傑傒傓傔傕傖傗傘備傚傛傜傝傞傟傠傡傢傤傦傪傫傭傮傯傰傱傳傴債傶傷傸傹傼�".split(""), e = 0; e != r[130].length; ++e)
        r[130][e].charCodeAt(0) !== 65533 && (c[r[130][e]] = 33280 + e, o[33280 + e] = r[130][e]);
      for (r[131] = "����������������������������������������������������������������傽傾傿僀僁僂僃僄僅僆僇僈僉僊僋僌働僎僐僑僒僓僔僕僗僘僙僛僜僝僞僟僠僡僢僣僤僥僨僩僪僫僯僰僱僲僴僶僷僸價僺僼僽僾僿儀儁儂儃億儅儈�儉儊儌儍儎儏儐儑儓儔儕儖儗儘儙儚儛儜儝儞償儠儢儣儤儥儦儧儨儩優儫儬儭儮儯儰儱儲儳儴儵儶儷儸儹儺儻儼儽儾兂兇兊兌兎兏児兒兓兗兘兙兛兝兞兟兠兡兣兤兦內兩兪兯兲兺兾兿冃冄円冇冊冋冎冏冐冑冓冔冘冚冝冞冟冡冣冦冧冨冩冪冭冮冴冸冹冺冾冿凁凂凃凅凈凊凍凎凐凒凓凔凕凖凗�".split(""), e = 0; e != r[131].length; ++e)
        r[131][e].charCodeAt(0) !== 65533 && (c[r[131][e]] = 33536 + e, o[33536 + e] = r[131][e]);
      for (r[132] = "����������������������������������������������������������������凘凙凚凜凞凟凢凣凥処凧凨凩凪凬凮凱凲凴凷凾刄刅刉刋刌刏刐刓刔刕刜刞刟刡刢刣別刦刧刪刬刯刱刲刴刵刼刾剄剅剆則剈剉剋剎剏剒剓剕剗剘�剙剚剛剝剟剠剢剣剤剦剨剫剬剭剮剰剱剳剴創剶剷剸剹剺剻剼剾劀劃劄劅劆劇劉劊劋劌劍劎劏劑劒劔劕劖劗劘劙劚劜劤劥劦劧劮劯劰労劵劶劷劸効劺劻劼劽勀勁勂勄勅勆勈勊勌勍勎勏勑勓勔動勗務勚勛勜勝勞勠勡勢勣勥勦勧勨勩勪勫勬勭勮勯勱勲勳勴勵勶勷勸勻勼勽匁匂匃匄匇匉匊匋匌匎�".split(""), e = 0; e != r[132].length; ++e)
        r[132][e].charCodeAt(0) !== 65533 && (c[r[132][e]] = 33792 + e, o[33792 + e] = r[132][e]);
      for (r[133] = "����������������������������������������������������������������匑匒匓匔匘匛匜匞匟匢匤匥匧匨匩匫匬匭匯匰匱匲匳匴匵匶匷匸匼匽區卂卄卆卋卌卍卐協単卙卛卝卥卨卪卬卭卲卶卹卻卼卽卾厀厁厃厇厈厊厎厏�厐厑厒厓厔厖厗厙厛厜厞厠厡厤厧厪厫厬厭厯厰厱厲厳厴厵厷厸厹厺厼厽厾叀參叄叅叆叇収叏叐叒叓叕叚叜叝叞叡叢叧叴叺叾叿吀吂吅吇吋吔吘吙吚吜吢吤吥吪吰吳吶吷吺吽吿呁呂呄呅呇呉呌呍呎呏呑呚呝呞呟呠呡呣呥呧呩呪呫呬呭呮呯呰呴呹呺呾呿咁咃咅咇咈咉咊咍咑咓咗咘咜咞咟咠咡�".split(""), e = 0; e != r[133].length; ++e)
        r[133][e].charCodeAt(0) !== 65533 && (c[r[133][e]] = 34048 + e, o[34048 + e] = r[133][e]);
      for (r[134] = "����������������������������������������������������������������咢咥咮咰咲咵咶咷咹咺咼咾哃哅哊哋哖哘哛哠員哢哣哤哫哬哯哰哱哴哵哶哷哸哹哻哾唀唂唃唄唅唈唊唋唌唍唎唒唓唕唖唗唘唙唚唜唝唞唟唡唥唦�唨唩唫唭唲唴唵唶唸唹唺唻唽啀啂啅啇啈啋啌啍啎問啑啒啓啔啗啘啙啚啛啝啞啟啠啢啣啨啩啫啯啰啱啲啳啴啹啺啽啿喅喆喌喍喎喐喒喓喕喖喗喚喛喞喠喡喢喣喤喥喦喨喩喪喫喬喭單喯喰喲喴営喸喺喼喿嗀嗁嗂嗃嗆嗇嗈嗊嗋嗎嗏嗐嗕嗗嗘嗙嗚嗛嗞嗠嗢嗧嗩嗭嗮嗰嗱嗴嗶嗸嗹嗺嗻嗼嗿嘂嘃嘄嘅�".split(""), e = 0; e != r[134].length; ++e)
        r[134][e].charCodeAt(0) !== 65533 && (c[r[134][e]] = 34304 + e, o[34304 + e] = r[134][e]);
      for (r[135] = "����������������������������������������������������������������嘆嘇嘊嘋嘍嘐嘑嘒嘓嘔嘕嘖嘗嘙嘚嘜嘝嘠嘡嘢嘥嘦嘨嘩嘪嘫嘮嘯嘰嘳嘵嘷嘸嘺嘼嘽嘾噀噁噂噃噄噅噆噇噈噉噊噋噏噐噑噒噓噕噖噚噛噝噞噟噠噡�噣噥噦噧噭噮噯噰噲噳噴噵噷噸噹噺噽噾噿嚀嚁嚂嚃嚄嚇嚈嚉嚊嚋嚌嚍嚐嚑嚒嚔嚕嚖嚗嚘嚙嚚嚛嚜嚝嚞嚟嚠嚡嚢嚤嚥嚦嚧嚨嚩嚪嚫嚬嚭嚮嚰嚱嚲嚳嚴嚵嚶嚸嚹嚺嚻嚽嚾嚿囀囁囂囃囄囅囆囇囈囉囋囌囍囎囏囐囑囒囓囕囖囘囙囜団囥囦囧囨囩囪囬囮囯囲図囶囷囸囻囼圀圁圂圅圇國圌圍圎圏圐圑�".split(""), e = 0; e != r[135].length; ++e)
        r[135][e].charCodeAt(0) !== 65533 && (c[r[135][e]] = 34560 + e, o[34560 + e] = r[135][e]);
      for (r[136] = "����������������������������������������������������������������園圓圔圕圖圗團圙圚圛圝圞圠圡圢圤圥圦圧圫圱圲圴圵圶圷圸圼圽圿坁坃坄坅坆坈坉坋坒坓坔坕坖坘坙坢坣坥坧坬坮坰坱坲坴坵坸坹坺坽坾坿垀�垁垇垈垉垊垍垎垏垐垑垔垕垖垗垘垙垚垜垝垞垟垥垨垪垬垯垰垱垳垵垶垷垹垺垻垼垽垾垿埀埁埄埅埆埇埈埉埊埌埍埐埑埓埖埗埛埜埞埡埢埣埥埦埧埨埩埪埫埬埮埰埱埲埳埵埶執埻埼埾埿堁堃堄堅堈堉堊堌堎堏堐堒堓堔堖堗堘堚堛堜堝堟堢堣堥堦堧堨堩堫堬堭堮堯報堲堳場堶堷堸堹堺堻堼堽�".split(""), e = 0; e != r[136].length; ++e)
        r[136][e].charCodeAt(0) !== 65533 && (c[r[136][e]] = 34816 + e, o[34816 + e] = r[136][e]);
      for (r[137] = "����������������������������������������������������������������堾堿塀塁塂塃塅塆塇塈塉塊塋塎塏塐塒塓塕塖塗塙塚塛塜塝塟塠塡塢塣塤塦塧塨塩塪塭塮塯塰塱塲塳塴塵塶塷塸塹塺塻塼塽塿墂墄墆墇墈墊墋墌�墍墎墏墐墑墔墕墖増墘墛墜墝墠墡墢墣墤墥墦墧墪墫墬墭墮墯墰墱墲墳墴墵墶墷墸墹墺墻墽墾墿壀壂壃壄壆壇壈壉壊壋壌壍壎壏壐壒壓壔壖壗壘壙壚壛壜壝壞壟壠壡壢壣壥壦壧壨壩壪壭壯壱売壴壵壷壸壺壻壼壽壾壿夀夁夃夅夆夈変夊夋夌夎夐夑夒夓夗夘夛夝夞夠夡夢夣夦夨夬夰夲夳夵夶夻�".split(""), e = 0; e != r[137].length; ++e)
        r[137][e].charCodeAt(0) !== 65533 && (c[r[137][e]] = 35072 + e, o[35072 + e] = r[137][e]);
      for (r[138] = "����������������������������������������������������������������夽夾夿奀奃奅奆奊奌奍奐奒奓奙奛奜奝奞奟奡奣奤奦奧奨奩奪奫奬奭奮奯奰奱奲奵奷奺奻奼奾奿妀妅妉妋妌妎妏妐妑妔妕妘妚妛妜妝妟妠妡妢妦�妧妬妭妰妱妳妴妵妶妷妸妺妼妽妿姀姁姂姃姄姅姇姈姉姌姍姎姏姕姖姙姛姞姟姠姡姢姤姦姧姩姪姫姭姮姯姰姱姲姳姴姵姶姷姸姺姼姽姾娀娂娊娋娍娎娏娐娒娔娕娖娗娙娚娛娝娞娡娢娤娦娧娨娪娫娬娭娮娯娰娳娵娷娸娹娺娻娽娾娿婁婂婃婄婅婇婈婋婌婍婎婏婐婑婒婓婔婖婗婘婙婛婜婝婞婟婠�".split(""), e = 0; e != r[138].length; ++e)
        r[138][e].charCodeAt(0) !== 65533 && (c[r[138][e]] = 35328 + e, o[35328 + e] = r[138][e]);
      for (r[139] = "����������������������������������������������������������������婡婣婤婥婦婨婩婫婬婭婮婯婰婱婲婳婸婹婻婼婽婾媀媁媂媃媄媅媆媇媈媉媊媋媌媍媎媏媐媑媓媔媕媖媗媘媙媜媝媞媟媠媡媢媣媤媥媦媧媨媩媫媬�媭媮媯媰媱媴媶媷媹媺媻媼媽媿嫀嫃嫄嫅嫆嫇嫈嫊嫋嫍嫎嫏嫐嫑嫓嫕嫗嫙嫚嫛嫝嫞嫟嫢嫤嫥嫧嫨嫪嫬嫭嫮嫯嫰嫲嫳嫴嫵嫶嫷嫸嫹嫺嫻嫼嫽嫾嫿嬀嬁嬂嬃嬄嬅嬆嬇嬈嬊嬋嬌嬍嬎嬏嬐嬑嬒嬓嬔嬕嬘嬙嬚嬛嬜嬝嬞嬟嬠嬡嬢嬣嬤嬥嬦嬧嬨嬩嬪嬫嬬嬭嬮嬯嬰嬱嬳嬵嬶嬸嬹嬺嬻嬼嬽嬾嬿孁孂孃孄孅孆孇�".split(""), e = 0; e != r[139].length; ++e)
        r[139][e].charCodeAt(0) !== 65533 && (c[r[139][e]] = 35584 + e, o[35584 + e] = r[139][e]);
      for (r[140] = "����������������������������������������������������������������孈孉孊孋孌孍孎孏孒孖孞孠孡孧孨孫孭孮孯孲孴孶孷學孹孻孼孾孿宂宆宊宍宎宐宑宒宔宖実宧宨宩宬宭宮宯宱宲宷宺宻宼寀寁寃寈寉寊寋寍寎寏�寑寔寕寖寗寘寙寚寛寜寠寢寣實寧審寪寫寬寭寯寱寲寳寴寵寶寷寽対尀専尃尅將專尋尌對導尐尒尓尗尙尛尞尟尠尡尣尦尨尩尪尫尭尮尯尰尲尳尵尶尷屃屄屆屇屌屍屒屓屔屖屗屘屚屛屜屝屟屢層屧屨屩屪屫屬屭屰屲屳屴屵屶屷屸屻屼屽屾岀岃岄岅岆岇岉岊岋岎岏岒岓岕岝岞岟岠岡岤岥岦岧岨�".split(""), e = 0; e != r[140].length; ++e)
        r[140][e].charCodeAt(0) !== 65533 && (c[r[140][e]] = 35840 + e, o[35840 + e] = r[140][e]);
      for (r[141] = "����������������������������������������������������������������岪岮岯岰岲岴岶岹岺岻岼岾峀峂峃峅峆峇峈峉峊峌峍峎峏峐峑峓峔峕峖峗峘峚峛峜峝峞峟峠峢峣峧峩峫峬峮峯峱峲峳峴峵島峷峸峹峺峼峽峾峿崀�崁崄崅崈崉崊崋崌崍崏崐崑崒崓崕崗崘崙崚崜崝崟崠崡崢崣崥崨崪崫崬崯崰崱崲崳崵崶崷崸崹崺崻崼崿嵀嵁嵂嵃嵄嵅嵆嵈嵉嵍嵎嵏嵐嵑嵒嵓嵔嵕嵖嵗嵙嵚嵜嵞嵟嵠嵡嵢嵣嵤嵥嵦嵧嵨嵪嵭嵮嵰嵱嵲嵳嵵嵶嵷嵸嵹嵺嵻嵼嵽嵾嵿嶀嶁嶃嶄嶅嶆嶇嶈嶉嶊嶋嶌嶍嶎嶏嶐嶑嶒嶓嶔嶕嶖嶗嶘嶚嶛嶜嶞嶟嶠�".split(""), e = 0; e != r[141].length; ++e)
        r[141][e].charCodeAt(0) !== 65533 && (c[r[141][e]] = 36096 + e, o[36096 + e] = r[141][e]);
      for (r[142] = "����������������������������������������������������������������嶡嶢嶣嶤嶥嶦嶧嶨嶩嶪嶫嶬嶭嶮嶯嶰嶱嶲嶳嶴嶵嶶嶸嶹嶺嶻嶼嶽嶾嶿巀巁巂巃巄巆巇巈巉巊巋巌巎巏巐巑巒巓巔巕巖巗巘巙巚巜巟巠巣巤巪巬巭�巰巵巶巸巹巺巻巼巿帀帄帇帉帊帋帍帎帒帓帗帞帟帠帡帢帣帤帥帨帩帪師帬帯帰帲帳帴帵帶帹帺帾帿幀幁幃幆幇幈幉幊幋幍幎幏幐幑幒幓幖幗幘幙幚幜幝幟幠幣幤幥幦幧幨幩幪幫幬幭幮幯幰幱幵幷幹幾庁庂広庅庈庉庌庍庎庒庘庛庝庡庢庣庤庨庩庪庫庬庮庯庰庱庲庴庺庻庼庽庿廀廁廂廃廄廅�".split(""), e = 0; e != r[142].length; ++e)
        r[142][e].charCodeAt(0) !== 65533 && (c[r[142][e]] = 36352 + e, o[36352 + e] = r[142][e]);
      for (r[143] = "����������������������������������������������������������������廆廇廈廋廌廍廎廏廐廔廕廗廘廙廚廜廝廞廟廠廡廢廣廤廥廦廧廩廫廬廭廮廯廰廱廲廳廵廸廹廻廼廽弅弆弇弉弌弍弎弐弒弔弖弙弚弜弝弞弡弢弣弤�弨弫弬弮弰弲弳弴張弶強弸弻弽弾弿彁彂彃彄彅彆彇彈彉彊彋彌彍彎彏彑彔彙彚彛彜彞彟彠彣彥彧彨彫彮彯彲彴彵彶彸彺彽彾彿徃徆徍徎徏徑従徔徖徚徛徝從徟徠徢徣徤徥徦徧復徫徬徯徰徱徲徳徴徶徸徹徺徻徾徿忀忁忂忇忈忊忋忎忓忔忕忚忛応忞忟忢忣忥忦忨忩忬忯忰忲忳忴忶忷忹忺忼怇�".split(""), e = 0; e != r[143].length; ++e)
        r[143][e].charCodeAt(0) !== 65533 && (c[r[143][e]] = 36608 + e, o[36608 + e] = r[143][e]);
      for (r[144] = "����������������������������������������������������������������怈怉怋怌怐怑怓怗怘怚怞怟怢怣怤怬怭怮怰怱怲怳怴怶怷怸怹怺怽怾恀恄恅恆恇恈恉恊恌恎恏恑恓恔恖恗恘恛恜恞恟恠恡恥恦恮恱恲恴恵恷恾悀�悁悂悅悆悇悈悊悋悎悏悐悑悓悕悗悘悙悜悞悡悢悤悥悧悩悪悮悰悳悵悶悷悹悺悽悾悿惀惁惂惃惄惇惈惉惌惍惎惏惐惒惓惔惖惗惙惛惞惡惢惣惤惥惪惱惲惵惷惸惻惼惽惾惿愂愃愄愅愇愊愋愌愐愑愒愓愔愖愗愘愙愛愜愝愞愡愢愥愨愩愪愬愭愮愯愰愱愲愳愴愵愶愷愸愹愺愻愼愽愾慀慁慂慃慄慅慆�".split(""), e = 0; e != r[144].length; ++e)
        r[144][e].charCodeAt(0) !== 65533 && (c[r[144][e]] = 36864 + e, o[36864 + e] = r[144][e]);
      for (r[145] = "����������������������������������������������������������������慇慉態慍慏慐慒慓慔慖慗慘慙慚慛慜慞慟慠慡慣慤慥慦慩慪慫慬慭慮慯慱慲慳慴慶慸慹慺慻慼慽慾慿憀憁憂憃憄憅憆憇憈憉憊憌憍憏憐憑憒憓憕�憖憗憘憙憚憛憜憞憟憠憡憢憣憤憥憦憪憫憭憮憯憰憱憲憳憴憵憶憸憹憺憻憼憽憿懀懁懃懄懅懆懇應懌懍懎懏懐懓懕懖懗懘懙懚懛懜懝懞懟懠懡懢懣懤懥懧懨懩懪懫懬懭懮懯懰懱懲懳懴懶懷懸懹懺懻懼懽懾戀戁戂戃戄戅戇戉戓戔戙戜戝戞戠戣戦戧戨戩戫戭戯戰戱戲戵戶戸戹戺戻戼扂扄扅扆扊�".split(""), e = 0; e != r[145].length; ++e)
        r[145][e].charCodeAt(0) !== 65533 && (c[r[145][e]] = 37120 + e, o[37120 + e] = r[145][e]);
      for (r[146] = "����������������������������������������������������������������扏扐払扖扗扙扚扜扝扞扟扠扡扢扤扥扨扱扲扴扵扷扸扺扻扽抁抂抃抅抆抇抈抋抌抍抎抏抐抔抙抜抝択抣抦抧抩抪抭抮抯抰抲抳抴抶抷抸抺抾拀拁�拃拋拏拑拕拝拞拠拡拤拪拫拰拲拵拸拹拺拻挀挃挄挅挆挊挋挌挍挏挐挒挓挔挕挗挘挙挜挦挧挩挬挭挮挰挱挳挴挵挶挷挸挻挼挾挿捀捁捄捇捈捊捑捒捓捔捖捗捘捙捚捛捜捝捠捤捥捦捨捪捫捬捯捰捲捳捴捵捸捹捼捽捾捿掁掃掄掅掆掋掍掑掓掔掕掗掙掚掛掜掝掞掟採掤掦掫掯掱掲掵掶掹掻掽掿揀�".split(""), e = 0; e != r[146].length; ++e)
        r[146][e].charCodeAt(0) !== 65533 && (c[r[146][e]] = 37376 + e, o[37376 + e] = r[146][e]);
      for (r[147] = "����������������������������������������������������������������揁揂揃揅揇揈揊揋揌揑揓揔揕揗揘揙揚換揜揝揟揢揤揥揦揧揨揫揬揮揯揰揱揳揵揷揹揺揻揼揾搃搄搆搇搈搉搊損搎搑搒搕搖搗搘搙搚搝搟搢搣搤�搥搧搨搩搫搮搯搰搱搲搳搵搶搷搸搹搻搼搾摀摂摃摉摋摌摍摎摏摐摑摓摕摖摗摙摚摛摜摝摟摠摡摢摣摤摥摦摨摪摫摬摮摯摰摱摲摳摴摵摶摷摻摼摽摾摿撀撁撃撆撈撉撊撋撌撍撎撏撐撓撔撗撘撚撛撜撝撟撠撡撢撣撥撦撧撨撪撫撯撱撲撳撴撶撹撻撽撾撿擁擃擄擆擇擈擉擊擋擌擏擑擓擔擕擖擙據�".split(""), e = 0; e != r[147].length; ++e)
        r[147][e].charCodeAt(0) !== 65533 && (c[r[147][e]] = 37632 + e, o[37632 + e] = r[147][e]);
      for (r[148] = "����������������������������������������������������������������擛擜擝擟擠擡擣擥擧擨擩擪擫擬擭擮擯擰擱擲擳擴擵擶擷擸擹擺擻擼擽擾擿攁攂攃攄攅攆攇攈攊攋攌攍攎攏攐攑攓攔攕攖攗攙攚攛攜攝攞攟攠攡�攢攣攤攦攧攨攩攪攬攭攰攱攲攳攷攺攼攽敀敁敂敃敄敆敇敊敋敍敎敐敒敓敔敗敘敚敜敟敠敡敤敥敧敨敩敪敭敮敯敱敳敵敶數敹敺敻敼敽敾敿斀斁斂斃斄斅斆斈斉斊斍斎斏斒斔斕斖斘斚斝斞斠斢斣斦斨斪斬斮斱斲斳斴斵斶斷斸斺斻斾斿旀旂旇旈旉旊旍旐旑旓旔旕旘旙旚旛旜旝旞旟旡旣旤旪旫�".split(""), e = 0; e != r[148].length; ++e)
        r[148][e].charCodeAt(0) !== 65533 && (c[r[148][e]] = 37888 + e, o[37888 + e] = r[148][e]);
      for (r[149] = "����������������������������������������������������������������旲旳旴旵旸旹旻旼旽旾旿昁昄昅昇昈昉昋昍昐昑昒昖昗昘昚昛昜昞昡昢昣昤昦昩昪昫昬昮昰昲昳昷昸昹昺昻昽昿晀時晄晅晆晇晈晉晊晍晎晐晑晘�晙晛晜晝晞晠晢晣晥晧晩晪晫晬晭晱晲晳晵晸晹晻晼晽晿暀暁暃暅暆暈暉暊暋暍暎暏暐暒暓暔暕暘暙暚暛暜暞暟暠暡暢暣暤暥暦暩暪暫暬暭暯暰暱暲暳暵暶暷暸暺暻暼暽暿曀曁曂曃曄曅曆曇曈曉曊曋曌曍曎曏曐曑曒曓曔曕曖曗曘曚曞曟曠曡曢曣曤曥曧曨曪曫曬曭曮曯曱曵曶書曺曻曽朁朂會�".split(""), e = 0; e != r[149].length; ++e)
        r[149][e].charCodeAt(0) !== 65533 && (c[r[149][e]] = 38144 + e, o[38144 + e] = r[149][e]);
      for (r[150] = "����������������������������������������������������������������朄朅朆朇朌朎朏朑朒朓朖朘朙朚朜朞朠朡朢朣朤朥朧朩朮朰朲朳朶朷朸朹朻朼朾朿杁杄杅杇杊杋杍杒杔杕杗杘杙杚杛杝杢杣杤杦杧杫杬杮東杴杶�杸杹杺杻杽枀枂枃枅枆枈枊枌枍枎枏枑枒枓枔枖枙枛枟枠枡枤枦枩枬枮枱枲枴枹枺枻枼枽枾枿柀柂柅柆柇柈柉柊柋柌柍柎柕柖柗柛柟柡柣柤柦柧柨柪柫柭柮柲柵柶柷柸柹柺査柼柾栁栂栃栄栆栍栐栒栔栕栘栙栚栛栜栞栟栠栢栣栤栥栦栧栨栫栬栭栮栯栰栱栴栵栶栺栻栿桇桋桍桏桒桖桗桘桙桚桛�".split(""), e = 0; e != r[150].length; ++e)
        r[150][e].charCodeAt(0) !== 65533 && (c[r[150][e]] = 38400 + e, o[38400 + e] = r[150][e]);
      for (r[151] = "����������������������������������������������������������������桜桝桞桟桪桬桭桮桯桰桱桲桳桵桸桹桺桻桼桽桾桿梀梂梄梇梈梉梊梋梌梍梎梐梑梒梔梕梖梘梙梚梛梜條梞梟梠梡梣梤梥梩梪梫梬梮梱梲梴梶梷梸�梹梺梻梼梽梾梿棁棃棄棅棆棇棈棊棌棎棏棐棑棓棔棖棗棙棛棜棝棞棟棡棢棤棥棦棧棨棩棪棫棬棭棯棲棳棴棶棷棸棻棽棾棿椀椂椃椄椆椇椈椉椊椌椏椑椓椔椕椖椗椘椙椚椛検椝椞椡椢椣椥椦椧椨椩椪椫椬椮椯椱椲椳椵椶椷椸椺椻椼椾楀楁楃楄楅楆楇楈楉楊楋楌楍楎楏楐楑楒楓楕楖楘楙楛楜楟�".split(""), e = 0; e != r[151].length; ++e)
        r[151][e].charCodeAt(0) !== 65533 && (c[r[151][e]] = 38656 + e, o[38656 + e] = r[151][e]);
      for (r[152] = "����������������������������������������������������������������楡楢楤楥楧楨楩楪楬業楯楰楲楳楴極楶楺楻楽楾楿榁榃榅榊榋榌榎榏榐榑榒榓榖榗榙榚榝榞榟榠榡榢榣榤榥榦榩榪榬榮榯榰榲榳榵榶榸榹榺榼榽�榾榿槀槂槃槄槅槆槇槈槉構槍槏槑槒槓槕槖槗様槙槚槜槝槞槡槢槣槤槥槦槧槨槩槪槫槬槮槯槰槱槳槴槵槶槷槸槹槺槻槼槾樀樁樂樃樄樅樆樇樈樉樋樌樍樎樏樐樑樒樓樔樕樖標樚樛樜樝樞樠樢樣樤樥樦樧権樫樬樭樮樰樲樳樴樶樷樸樹樺樻樼樿橀橁橂橃橅橆橈橉橊橋橌橍橎橏橑橒橓橔橕橖橗橚�".split(""), e = 0; e != r[152].length; ++e)
        r[152][e].charCodeAt(0) !== 65533 && (c[r[152][e]] = 38912 + e, o[38912 + e] = r[152][e]);
      for (r[153] = "����������������������������������������������������������������橜橝橞機橠橢橣橤橦橧橨橩橪橫橬橭橮橯橰橲橳橴橵橶橷橸橺橻橽橾橿檁檂檃檅檆檇檈檉檊檋檌檍檏檒檓檔檕檖檘檙檚檛檜檝檞檟檡檢檣檤檥檦�檧檨檪檭檮檯檰檱檲檳檴檵檶檷檸檹檺檻檼檽檾檿櫀櫁櫂櫃櫄櫅櫆櫇櫈櫉櫊櫋櫌櫍櫎櫏櫐櫑櫒櫓櫔櫕櫖櫗櫘櫙櫚櫛櫜櫝櫞櫟櫠櫡櫢櫣櫤櫥櫦櫧櫨櫩櫪櫫櫬櫭櫮櫯櫰櫱櫲櫳櫴櫵櫶櫷櫸櫹櫺櫻櫼櫽櫾櫿欀欁欂欃欄欅欆欇欈欉權欋欌欍欎欏欐欑欒欓欔欕欖欗欘欙欚欛欜欝欞欟欥欦欨欩欪欫欬欭欮�".split(""), e = 0; e != r[153].length; ++e)
        r[153][e].charCodeAt(0) !== 65533 && (c[r[153][e]] = 39168 + e, o[39168 + e] = r[153][e]);
      for (r[154] = "����������������������������������������������������������������欯欰欱欳欴欵欶欸欻欼欽欿歀歁歂歄歅歈歊歋歍歎歏歐歑歒歓歔歕歖歗歘歚歛歜歝歞歟歠歡歨歩歫歬歭歮歯歰歱歲歳歴歵歶歷歸歺歽歾歿殀殅殈�殌殎殏殐殑殔殕殗殘殙殜殝殞殟殠殢殣殤殥殦殧殨殩殫殬殭殮殯殰殱殲殶殸殹殺殻殼殽殾毀毃毄毆毇毈毉毊毌毎毐毑毘毚毜毝毞毟毠毢毣毤毥毦毧毨毩毬毭毮毰毱毲毴毶毷毸毺毻毼毾毿氀氁氂氃氄氈氉氊氋氌氎氒気氜氝氞氠氣氥氫氬氭氱氳氶氷氹氺氻氼氾氿汃汄汅汈汋汌汍汎汏汑汒汓汖汘�".split(""), e = 0; e != r[154].length; ++e)
        r[154][e].charCodeAt(0) !== 65533 && (c[r[154][e]] = 39424 + e, o[39424 + e] = r[154][e]);
      for (r[155] = "����������������������������������������������������������������汙汚汢汣汥汦汧汫汬汭汮汯汱汳汵汷汸決汻汼汿沀沄沇沊沋沍沎沑沒沕沖沗沘沚沜沝沞沠沢沨沬沯沰沴沵沶沷沺泀況泂泃泆泇泈泋泍泎泏泑泒泘�泙泚泜泝泟泤泦泧泩泬泭泲泴泹泿洀洂洃洅洆洈洉洊洍洏洐洑洓洔洕洖洘洜洝洟洠洡洢洣洤洦洨洩洬洭洯洰洴洶洷洸洺洿浀浂浄浉浌浐浕浖浗浘浛浝浟浡浢浤浥浧浨浫浬浭浰浱浲浳浵浶浹浺浻浽浾浿涀涁涃涄涆涇涊涋涍涏涐涒涖涗涘涙涚涜涢涥涬涭涰涱涳涴涶涷涹涺涻涼涽涾淁淂淃淈淉淊�".split(""), e = 0; e != r[155].length; ++e)
        r[155][e].charCodeAt(0) !== 65533 && (c[r[155][e]] = 39680 + e, o[39680 + e] = r[155][e]);
      for (r[156] = "����������������������������������������������������������������淍淎淏淐淒淓淔淕淗淚淛淜淟淢淣淥淧淨淩淪淭淯淰淲淴淵淶淸淺淽淾淿渀渁渂渃渄渆渇済渉渋渏渒渓渕渘渙減渜渞渟渢渦渧渨渪測渮渰渱渳渵�渶渷渹渻渼渽渾渿湀湁湂湅湆湇湈湉湊湋湌湏湐湑湒湕湗湙湚湜湝湞湠湡湢湣湤湥湦湧湨湩湪湬湭湯湰湱湲湳湴湵湶湷湸湹湺湻湼湽満溁溂溄溇溈溊溋溌溍溎溑溒溓溔溕準溗溙溚溛溝溞溠溡溣溤溦溨溩溫溬溭溮溰溳溵溸溹溼溾溿滀滃滄滅滆滈滉滊滌滍滎滐滒滖滘滙滛滜滝滣滧滪滫滬滭滮滯�".split(""), e = 0; e != r[156].length; ++e)
        r[156][e].charCodeAt(0) !== 65533 && (c[r[156][e]] = 39936 + e, o[39936 + e] = r[156][e]);
      for (r[157] = "����������������������������������������������������������������滰滱滲滳滵滶滷滸滺滻滼滽滾滿漀漁漃漄漅漇漈漊漋漌漍漎漐漑漒漖漗漘漙漚漛漜漝漞漟漡漢漣漥漦漧漨漬漮漰漲漴漵漷漸漹漺漻漼漽漿潀潁潂�潃潄潅潈潉潊潌潎潏潐潑潒潓潔潕潖潗潙潚潛潝潟潠潡潣潤潥潧潨潩潪潫潬潯潰潱潳潵潶潷潹潻潽潾潿澀澁澂澃澅澆澇澊澋澏澐澑澒澓澔澕澖澗澘澙澚澛澝澞澟澠澢澣澤澥澦澨澩澪澫澬澭澮澯澰澱澲澴澵澷澸澺澻澼澽澾澿濁濃濄濅濆濇濈濊濋濌濍濎濏濐濓濔濕濖濗濘濙濚濛濜濝濟濢濣濤濥�".split(""), e = 0; e != r[157].length; ++e)
        r[157][e].charCodeAt(0) !== 65533 && (c[r[157][e]] = 40192 + e, o[40192 + e] = r[157][e]);
      for (r[158] = "����������������������������������������������������������������濦濧濨濩濪濫濬濭濰濱濲濳濴濵濶濷濸濹濺濻濼濽濾濿瀀瀁瀂瀃瀄瀅瀆瀇瀈瀉瀊瀋瀌瀍瀎瀏瀐瀒瀓瀔瀕瀖瀗瀘瀙瀜瀝瀞瀟瀠瀡瀢瀤瀥瀦瀧瀨瀩瀪�瀫瀬瀭瀮瀯瀰瀱瀲瀳瀴瀶瀷瀸瀺瀻瀼瀽瀾瀿灀灁灂灃灄灅灆灇灈灉灊灋灍灎灐灑灒灓灔灕灖灗灘灙灚灛灜灝灟灠灡灢灣灤灥灦灧灨灩灪灮灱灲灳灴灷灹灺灻災炁炂炃炄炆炇炈炋炌炍炏炐炑炓炗炘炚炛炞炟炠炡炢炣炤炥炦炧炨炩炪炰炲炴炵炶為炾炿烄烅烆烇烉烋烌烍烎烏烐烑烒烓烔烕烖烗烚�".split(""), e = 0; e != r[158].length; ++e)
        r[158][e].charCodeAt(0) !== 65533 && (c[r[158][e]] = 40448 + e, o[40448 + e] = r[158][e]);
      for (r[159] = "����������������������������������������������������������������烜烝烞烠烡烢烣烥烪烮烰烱烲烳烴烵烶烸烺烻烼烾烿焀焁焂焃焄焅焆焇焈焋焌焍焎焏焑焒焔焗焛焜焝焞焟焠無焢焣焤焥焧焨焩焪焫焬焭焮焲焳焴�焵焷焸焹焺焻焼焽焾焿煀煁煂煃煄煆煇煈煉煋煍煏煐煑煒煓煔煕煖煗煘煙煚煛煝煟煠煡煢煣煥煩煪煫煬煭煯煰煱煴煵煶煷煹煻煼煾煿熀熁熂熃熅熆熇熈熉熋熌熍熎熐熑熒熓熕熖熗熚熛熜熝熞熡熢熣熤熥熦熧熩熪熫熭熮熯熰熱熲熴熶熷熸熺熻熼熽熾熿燀燁燂燄燅燆燇燈燉燊燋燌燍燏燐燑燒燓�".split(""), e = 0; e != r[159].length; ++e)
        r[159][e].charCodeAt(0) !== 65533 && (c[r[159][e]] = 40704 + e, o[40704 + e] = r[159][e]);
      for (r[160] = "����������������������������������������������������������������燖燗燘燙燚燛燜燝燞營燡燢燣燤燦燨燩燪燫燬燭燯燰燱燲燳燴燵燶燷燸燺燻燼燽燾燿爀爁爂爃爄爅爇爈爉爊爋爌爍爎爏爐爑爒爓爔爕爖爗爘爙爚�爛爜爞爟爠爡爢爣爤爥爦爧爩爫爭爮爯爲爳爴爺爼爾牀牁牂牃牄牅牆牉牊牋牎牏牐牑牓牔牕牗牘牚牜牞牠牣牤牥牨牪牫牬牭牰牱牳牴牶牷牸牻牼牽犂犃犅犆犇犈犉犌犎犐犑犓犔犕犖犗犘犙犚犛犜犝犞犠犡犢犣犤犥犦犧犨犩犪犫犮犱犲犳犵犺犻犼犽犾犿狀狅狆狇狉狊狋狌狏狑狓狔狕狖狘狚狛�".split(""), e = 0; e != r[160].length; ++e)
        r[160][e].charCodeAt(0) !== 65533 && (c[r[160][e]] = 40960 + e, o[40960 + e] = r[160][e]);
      for (r[161] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������　、。·ˉˇ¨〃々—～‖…‘’“”〔〕〈〉《》「」『』〖〗【】±×÷∶∧∨∑∏∪∩∈∷√⊥∥∠⌒⊙∫∮≡≌≈∽∝≠≮≯≤≥∞∵∴♂♀°′″℃＄¤￠￡‰§№☆★○●◎◇◆□■△▲※→←↑↓〓�".split(""), e = 0; e != r[161].length; ++e)
        r[161][e].charCodeAt(0) !== 65533 && (c[r[161][e]] = 41216 + e, o[41216 + e] = r[161][e]);
      for (r[162] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������ⅰⅱⅲⅳⅴⅵⅶⅷⅸⅹ������⒈⒉⒊⒋⒌⒍⒎⒏⒐⒑⒒⒓⒔⒕⒖⒗⒘⒙⒚⒛⑴⑵⑶⑷⑸⑹⑺⑻⑼⑽⑾⑿⒀⒁⒂⒃⒄⒅⒆⒇①②③④⑤⑥⑦⑧⑨⑩��㈠㈡㈢㈣㈤㈥㈦㈧㈨㈩��ⅠⅡⅢⅣⅤⅥⅦⅧⅨⅩⅪⅫ���".split(""), e = 0; e != r[162].length; ++e)
        r[162][e].charCodeAt(0) !== 65533 && (c[r[162][e]] = 41472 + e, o[41472 + e] = r[162][e]);
      for (r[163] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������！＂＃￥％＆＇（）＊＋，－．／０１２３４５６７８９：；＜＝＞？＠ＡＢＣＤＥＦＧＨＩＪＫＬＭＮＯＰＱＲＳＴＵＶＷＸＹＺ［＼］＾＿｀ａｂｃｄｅｆｇｈｉｊｋｌｍｎｏｐｑｒｓｔｕｖｗｘｙｚ｛｜｝￣�".split(""), e = 0; e != r[163].length; ++e)
        r[163][e].charCodeAt(0) !== 65533 && (c[r[163][e]] = 41728 + e, o[41728 + e] = r[163][e]);
      for (r[164] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������ぁあぃいぅうぇえぉおかがきぎくぐけげこごさざしじすずせぜそぞただちぢっつづてでとどなにぬねのはばぱひびぴふぶぷへべぺほぼぽまみむめもゃやゅゆょよらりるれろゎわゐゑをん������������".split(""), e = 0; e != r[164].length; ++e)
        r[164][e].charCodeAt(0) !== 65533 && (c[r[164][e]] = 41984 + e, o[41984 + e] = r[164][e]);
      for (r[165] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������ァアィイゥウェエォオカガキギクグケゲコゴサザシジスズセゼソゾタダチヂッツヅテデトドナニヌネノハバパヒビピフブプヘベペホボポマミムメモャヤュユョヨラリルレロヮワヰヱヲンヴヵヶ���������".split(""), e = 0; e != r[165].length; ++e)
        r[165][e].charCodeAt(0) !== 65533 && (c[r[165][e]] = 42240 + e, o[42240 + e] = r[165][e]);
      for (r[166] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������ΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡΣΤΥΦΧΨΩ��������αβγδεζηθικλμνξοπρστυφχψω�������︵︶︹︺︿﹀︽︾﹁﹂﹃﹄��︻︼︷︸︱�︳︴����������".split(""), e = 0; e != r[166].length; ++e)
        r[166][e].charCodeAt(0) !== 65533 && (c[r[166][e]] = 42496 + e, o[42496 + e] = r[166][e]);
      for (r[167] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������АБВГДЕЁЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯ���������������абвгдеёжзийклмнопрстуфхцчшщъыьэюя��������������".split(""), e = 0; e != r[167].length; ++e)
        r[167][e].charCodeAt(0) !== 65533 && (c[r[167][e]] = 42752 + e, o[42752 + e] = r[167][e]);
      for (r[168] = "����������������������������������������������������������������ˊˋ˙–―‥‵℅℉↖↗↘↙∕∟∣≒≦≧⊿═║╒╓╔╕╖╗╘╙╚╛╜╝╞╟╠╡╢╣╤╥╦╧╨╩╪╫╬╭╮╯╰╱╲╳▁▂▃▄▅▆▇�█▉▊▋▌▍▎▏▓▔▕▼▽◢◣◤◥☉⊕〒〝〞�����������āáǎàēéěèīíǐìōóǒòūúǔùǖǘǚǜüêɑ�ńň�ɡ����ㄅㄆㄇㄈㄉㄊㄋㄌㄍㄎㄏㄐㄑㄒㄓㄔㄕㄖㄗㄘㄙㄚㄛㄜㄝㄞㄟㄠㄡㄢㄣㄤㄥㄦㄧㄨㄩ����������������������".split(""), e = 0; e != r[168].length; ++e)
        r[168][e].charCodeAt(0) !== 65533 && (c[r[168][e]] = 43008 + e, o[43008 + e] = r[168][e]);
      for (r[169] = "����������������������������������������������������������������〡〢〣〤〥〦〧〨〩㊣㎎㎏㎜㎝㎞㎡㏄㏎㏑㏒㏕︰￢￤�℡㈱�‐���ー゛゜ヽヾ〆ゝゞ﹉﹊﹋﹌﹍﹎﹏﹐﹑﹒﹔﹕﹖﹗﹙﹚﹛﹜﹝﹞﹟﹠﹡�﹢﹣﹤﹥﹦﹨﹩﹪﹫�������������〇�������������─━│┃┄┅┆┇┈┉┊┋┌┍┎┏┐┑┒┓└┕┖┗┘┙┚┛├┝┞┟┠┡┢┣┤┥┦┧┨┩┪┫┬┭┮┯┰┱┲┳┴┵┶┷┸┹┺┻┼┽┾┿╀╁╂╃╄╅╆╇╈╉╊╋����������������".split(""), e = 0; e != r[169].length; ++e)
        r[169][e].charCodeAt(0) !== 65533 && (c[r[169][e]] = 43264 + e, o[43264 + e] = r[169][e]);
      for (r[170] = "����������������������������������������������������������������狜狝狟狢狣狤狥狦狧狪狫狵狶狹狽狾狿猀猂猄猅猆猇猈猉猋猌猍猏猐猑猒猔猘猙猚猟猠猣猤猦猧猨猭猯猰猲猳猵猶猺猻猼猽獀獁獂獃獄獅獆獇獈�獉獊獋獌獎獏獑獓獔獕獖獘獙獚獛獜獝獞獟獡獢獣獤獥獦獧獨獩獪獫獮獰獱�����������������������������������������������������������������������������������������������".split(""), e = 0; e != r[170].length; ++e)
        r[170][e].charCodeAt(0) !== 65533 && (c[r[170][e]] = 43520 + e, o[43520 + e] = r[170][e]);
      for (r[171] = "����������������������������������������������������������������獲獳獴獵獶獷獸獹獺獻獼獽獿玀玁玂玃玅玆玈玊玌玍玏玐玒玓玔玕玗玘玙玚玜玝玞玠玡玣玤玥玦玧玨玪玬玭玱玴玵玶玸玹玼玽玾玿珁珃珄珅珆珇�珋珌珎珒珓珔珕珖珗珘珚珛珜珝珟珡珢珣珤珦珨珪珫珬珮珯珰珱珳珴珵珶珷�����������������������������������������������������������������������������������������������".split(""), e = 0; e != r[171].length; ++e)
        r[171][e].charCodeAt(0) !== 65533 && (c[r[171][e]] = 43776 + e, o[43776 + e] = r[171][e]);
      for (r[172] = "����������������������������������������������������������������珸珹珺珻珼珽現珿琀琁琂琄琇琈琋琌琍琎琑琒琓琔琕琖琗琘琙琜琝琞琟琠琡琣琤琧琩琫琭琯琱琲琷琸琹琺琻琽琾琿瑀瑂瑃瑄瑅瑆瑇瑈瑉瑊瑋瑌瑍�瑎瑏瑐瑑瑒瑓瑔瑖瑘瑝瑠瑡瑢瑣瑤瑥瑦瑧瑨瑩瑪瑫瑬瑮瑯瑱瑲瑳瑴瑵瑸瑹瑺�����������������������������������������������������������������������������������������������".split(""), e = 0; e != r[172].length; ++e)
        r[172][e].charCodeAt(0) !== 65533 && (c[r[172][e]] = 44032 + e, o[44032 + e] = r[172][e]);
      for (r[173] = "����������������������������������������������������������������瑻瑼瑽瑿璂璄璅璆璈璉璊璌璍璏璑璒璓璔璕璖璗璘璙璚璛璝璟璠璡璢璣璤璥璦璪璫璬璭璮璯環璱璲璳璴璵璶璷璸璹璻璼璽璾璿瓀瓁瓂瓃瓄瓅瓆瓇�瓈瓉瓊瓋瓌瓍瓎瓏瓐瓑瓓瓔瓕瓖瓗瓘瓙瓚瓛瓝瓟瓡瓥瓧瓨瓩瓪瓫瓬瓭瓰瓱瓲�����������������������������������������������������������������������������������������������".split(""), e = 0; e != r[173].length; ++e)
        r[173][e].charCodeAt(0) !== 65533 && (c[r[173][e]] = 44288 + e, o[44288 + e] = r[173][e]);
      for (r[174] = "����������������������������������������������������������������瓳瓵瓸瓹瓺瓻瓼瓽瓾甀甁甂甃甅甆甇甈甉甊甋甌甎甐甒甔甕甖甗甛甝甞甠甡產産甤甦甧甪甮甴甶甹甼甽甿畁畂畃畄畆畇畉畊畍畐畑畒畓畕畖畗畘�畝畞畟畠畡畢畣畤畧畨畩畫畬畭畮畯異畱畳畵當畷畺畻畼畽畾疀疁疂疄疅疇�����������������������������������������������������������������������������������������������".split(""), e = 0; e != r[174].length; ++e)
        r[174][e].charCodeAt(0) !== 65533 && (c[r[174][e]] = 44544 + e, o[44544 + e] = r[174][e]);
      for (r[175] = "����������������������������������������������������������������疈疉疊疌疍疎疐疓疕疘疛疜疞疢疦疧疨疩疪疭疶疷疺疻疿痀痁痆痋痌痎痏痐痑痓痗痙痚痜痝痟痠痡痥痩痬痭痮痯痲痳痵痶痷痸痺痻痽痾瘂瘄瘆瘇�瘈瘉瘋瘍瘎瘏瘑瘒瘓瘔瘖瘚瘜瘝瘞瘡瘣瘧瘨瘬瘮瘯瘱瘲瘶瘷瘹瘺瘻瘽癁療癄�����������������������������������������������������������������������������������������������".split(""), e = 0; e != r[175].length; ++e)
        r[175][e].charCodeAt(0) !== 65533 && (c[r[175][e]] = 44800 + e, o[44800 + e] = r[175][e]);
      for (r[176] = "����������������������������������������������������������������癅癆癇癈癉癊癋癎癏癐癑癒癓癕癗癘癙癚癛癝癟癠癡癢癤癥癦癧癨癩癪癬癭癮癰癱癲癳癴癵癶癷癹発發癿皀皁皃皅皉皊皌皍皏皐皒皔皕皗皘皚皛�皜皝皞皟皠皡皢皣皥皦皧皨皩皪皫皬皭皯皰皳皵皶皷皸皹皺皻皼皽皾盀盁盃啊阿埃挨哎唉哀皑癌蔼矮艾碍爱隘鞍氨安俺按暗岸胺案肮昂盎凹敖熬翱袄傲奥懊澳芭捌扒叭吧笆八疤巴拔跋靶把耙坝霸罢爸白柏百摆佰败拜稗斑班搬扳般颁板版扮拌伴瓣半办绊邦帮梆榜膀绑棒磅蚌镑傍谤苞胞包褒剥�".split(""), e = 0; e != r[176].length; ++e)
        r[176][e].charCodeAt(0) !== 65533 && (c[r[176][e]] = 45056 + e, o[45056 + e] = r[176][e]);
      for (r[177] = "����������������������������������������������������������������盄盇盉盋盌盓盕盙盚盜盝盞盠盡盢監盤盦盧盨盩盪盫盬盭盰盳盵盶盷盺盻盽盿眀眂眃眅眆眊県眎眏眐眑眒眓眔眕眖眗眘眛眜眝眞眡眣眤眥眧眪眫�眬眮眰眱眲眳眴眹眻眽眾眿睂睄睅睆睈睉睊睋睌睍睎睏睒睓睔睕睖睗睘睙睜薄雹保堡饱宝抱报暴豹鲍爆杯碑悲卑北辈背贝钡倍狈备惫焙被奔苯本笨崩绷甭泵蹦迸逼鼻比鄙笔彼碧蓖蔽毕毙毖币庇痹闭敝弊必辟壁臂避陛鞭边编贬扁便变卞辨辩辫遍标彪膘表鳖憋别瘪彬斌濒滨宾摈兵冰柄丙秉饼炳�".split(""), e = 0; e != r[177].length; ++e)
        r[177][e].charCodeAt(0) !== 65533 && (c[r[177][e]] = 45312 + e, o[45312 + e] = r[177][e]);
      for (r[178] = "����������������������������������������������������������������睝睞睟睠睤睧睩睪睭睮睯睰睱睲睳睴睵睶睷睸睺睻睼瞁瞂瞃瞆瞇瞈瞉瞊瞋瞏瞐瞓瞔瞕瞖瞗瞘瞙瞚瞛瞜瞝瞞瞡瞣瞤瞦瞨瞫瞭瞮瞯瞱瞲瞴瞶瞷瞸瞹瞺�瞼瞾矀矁矂矃矄矅矆矇矈矉矊矋矌矎矏矐矑矒矓矔矕矖矘矙矚矝矞矟矠矡矤病并玻菠播拨钵波博勃搏铂箔伯帛舶脖膊渤泊驳捕卜哺补埠不布步簿部怖擦猜裁材才财睬踩采彩菜蔡餐参蚕残惭惨灿苍舱仓沧藏操糙槽曹草厕策侧册测层蹭插叉茬茶查碴搽察岔差诧拆柴豺搀掺蝉馋谗缠铲产阐颤昌猖�".split(""), e = 0; e != r[178].length; ++e)
        r[178][e].charCodeAt(0) !== 65533 && (c[r[178][e]] = 45568 + e, o[45568 + e] = r[178][e]);
      for (r[179] = "����������������������������������������������������������������矦矨矪矯矰矱矲矴矵矷矹矺矻矼砃砄砅砆砇砈砊砋砎砏砐砓砕砙砛砞砠砡砢砤砨砪砫砮砯砱砲砳砵砶砽砿硁硂硃硄硆硈硉硊硋硍硏硑硓硔硘硙硚�硛硜硞硟硠硡硢硣硤硥硦硧硨硩硯硰硱硲硳硴硵硶硸硹硺硻硽硾硿碀碁碂碃场尝常长偿肠厂敞畅唱倡超抄钞朝嘲潮巢吵炒车扯撤掣彻澈郴臣辰尘晨忱沉陈趁衬撑称城橙成呈乘程惩澄诚承逞骋秤吃痴持匙池迟弛驰耻齿侈尺赤翅斥炽充冲虫崇宠抽酬畴踌稠愁筹仇绸瞅丑臭初出橱厨躇锄雏滁除楚�".split(""), e = 0; e != r[179].length; ++e)
        r[179][e].charCodeAt(0) !== 65533 && (c[r[179][e]] = 45824 + e, o[45824 + e] = r[179][e]);
      for (r[180] = "����������������������������������������������������������������碄碅碆碈碊碋碏碐碒碔碕碖碙碝碞碠碢碤碦碨碩碪碫碬碭碮碯碵碶碷碸確碻碼碽碿磀磂磃磄磆磇磈磌磍磎磏磑磒磓磖磗磘磚磛磜磝磞磟磠磡磢磣�磤磥磦磧磩磪磫磭磮磯磰磱磳磵磶磸磹磻磼磽磾磿礀礂礃礄礆礇礈礉礊礋礌础储矗搐触处揣川穿椽传船喘串疮窗幢床闯创吹炊捶锤垂春椿醇唇淳纯蠢戳绰疵茨磁雌辞慈瓷词此刺赐次聪葱囱匆从丛凑粗醋簇促蹿篡窜摧崔催脆瘁粹淬翠村存寸磋撮搓措挫错搭达答瘩打大呆歹傣戴带殆代贷袋待逮�".split(""), e = 0; e != r[180].length; ++e)
        r[180][e].charCodeAt(0) !== 65533 && (c[r[180][e]] = 46080 + e, o[46080 + e] = r[180][e]);
      for (r[181] = "����������������������������������������������������������������礍礎礏礐礑礒礔礕礖礗礘礙礚礛礜礝礟礠礡礢礣礥礦礧礨礩礪礫礬礭礮礯礰礱礲礳礵礶礷礸礹礽礿祂祃祄祅祇祊祋祌祍祎祏祐祑祒祔祕祘祙祡祣�祤祦祩祪祫祬祮祰祱祲祳祴祵祶祹祻祼祽祾祿禂禃禆禇禈禉禋禌禍禎禐禑禒怠耽担丹单郸掸胆旦氮但惮淡诞弹蛋当挡党荡档刀捣蹈倒岛祷导到稻悼道盗德得的蹬灯登等瞪凳邓堤低滴迪敌笛狄涤翟嫡抵底地蒂第帝弟递缔颠掂滇碘点典靛垫电佃甸店惦奠淀殿碉叼雕凋刁掉吊钓调跌爹碟蝶迭谍叠�".split(""), e = 0; e != r[181].length; ++e)
        r[181][e].charCodeAt(0) !== 65533 && (c[r[181][e]] = 46336 + e, o[46336 + e] = r[181][e]);
      for (r[182] = "����������������������������������������������������������������禓禔禕禖禗禘禙禛禜禝禞禟禠禡禢禣禤禥禦禨禩禪禫禬禭禮禯禰禱禲禴禵禶禷禸禼禿秂秄秅秇秈秊秌秎秏秐秓秔秖秗秙秚秛秜秝秞秠秡秢秥秨秪�秬秮秱秲秳秴秵秶秷秹秺秼秾秿稁稄稅稇稈稉稊稌稏稐稑稒稓稕稖稘稙稛稜丁盯叮钉顶鼎锭定订丢东冬董懂动栋侗恫冻洞兜抖斗陡豆逗痘都督毒犊独读堵睹赌杜镀肚度渡妒端短锻段断缎堆兑队对墩吨蹲敦顿囤钝盾遁掇哆多夺垛躲朵跺舵剁惰堕蛾峨鹅俄额讹娥恶厄扼遏鄂饿恩而儿耳尔饵洱二�".split(""), e = 0; e != r[182].length; ++e)
        r[182][e].charCodeAt(0) !== 65533 && (c[r[182][e]] = 46592 + e, o[46592 + e] = r[182][e]);
      for (r[183] = "����������������������������������������������������������������稝稟稡稢稤稥稦稧稨稩稪稫稬稭種稯稰稱稲稴稵稶稸稺稾穀穁穂穃穄穅穇穈穉穊穋穌積穎穏穐穒穓穔穕穖穘穙穚穛穜穝穞穟穠穡穢穣穤穥穦穧穨�穩穪穫穬穭穮穯穱穲穳穵穻穼穽穾窂窅窇窉窊窋窌窎窏窐窓窔窙窚窛窞窡窢贰发罚筏伐乏阀法珐藩帆番翻樊矾钒繁凡烦反返范贩犯饭泛坊芳方肪房防妨仿访纺放菲非啡飞肥匪诽吠肺废沸费芬酚吩氛分纷坟焚汾粉奋份忿愤粪丰封枫蜂峰锋风疯烽逢冯缝讽奉凤佛否夫敷肤孵扶拂辐幅氟符伏俘服�".split(""), e = 0; e != r[183].length; ++e)
        r[183][e].charCodeAt(0) !== 65533 && (c[r[183][e]] = 46848 + e, o[46848 + e] = r[183][e]);
      for (r[184] = "����������������������������������������������������������������窣窤窧窩窪窫窮窯窰窱窲窴窵窶窷窸窹窺窻窼窽窾竀竁竂竃竄竅竆竇竈竉竊竌竍竎竏竐竑竒竓竔竕竗竘竚竛竜竝竡竢竤竧竨竩竪竫竬竮竰竱竲竳�竴竵競竷竸竻竼竾笀笁笂笅笇笉笌笍笎笐笒笓笖笗笘笚笜笝笟笡笢笣笧笩笭浮涪福袱弗甫抚辅俯釜斧脯腑府腐赴副覆赋复傅付阜父腹负富讣附妇缚咐噶嘎该改概钙盖溉干甘杆柑竿肝赶感秆敢赣冈刚钢缸肛纲岗港杠篙皋高膏羔糕搞镐稿告哥歌搁戈鸽胳疙割革葛格蛤阁隔铬个各给根跟耕更庚羹�".split(""), e = 0; e != r[184].length; ++e)
        r[184][e].charCodeAt(0) !== 65533 && (c[r[184][e]] = 47104 + e, o[47104 + e] = r[184][e]);
      for (r[185] = "����������������������������������������������������������������笯笰笲笴笵笶笷笹笻笽笿筀筁筂筃筄筆筈筊筍筎筓筕筗筙筜筞筟筡筣筤筥筦筧筨筩筪筫筬筭筯筰筳筴筶筸筺筼筽筿箁箂箃箄箆箇箈箉箊箋箌箎箏�箑箒箓箖箘箙箚箛箞箟箠箣箤箥箮箯箰箲箳箵箶箷箹箺箻箼箽箾箿節篂篃範埂耿梗工攻功恭龚供躬公宫弓巩汞拱贡共钩勾沟苟狗垢构购够辜菇咕箍估沽孤姑鼓古蛊骨谷股故顾固雇刮瓜剐寡挂褂乖拐怪棺关官冠观管馆罐惯灌贯光广逛瑰规圭硅归龟闺轨鬼诡癸桂柜跪贵刽辊滚棍锅郭国果裹过哈�".split(""), e = 0; e != r[185].length; ++e)
        r[185][e].charCodeAt(0) !== 65533 && (c[r[185][e]] = 47360 + e, o[47360 + e] = r[185][e]);
      for (r[186] = "����������������������������������������������������������������篅篈築篊篋篍篎篏篐篒篔篕篖篗篘篛篜篞篟篠篢篣篤篧篨篩篫篬篭篯篰篲篳篴篵篶篸篹篺篻篽篿簀簁簂簃簄簅簆簈簉簊簍簎簐簑簒簓簔簕簗簘簙�簚簛簜簝簞簠簡簢簣簤簥簨簩簫簬簭簮簯簰簱簲簳簴簵簶簷簹簺簻簼簽簾籂骸孩海氦亥害骇酣憨邯韩含涵寒函喊罕翰撼捍旱憾悍焊汗汉夯杭航壕嚎豪毫郝好耗号浩呵喝荷菏核禾和何合盒貉阂河涸赫褐鹤贺嘿黑痕很狠恨哼亨横衡恒轰哄烘虹鸿洪宏弘红喉侯猴吼厚候后呼乎忽瑚壶葫胡蝴狐糊湖�".split(""), e = 0; e != r[186].length; ++e)
        r[186][e].charCodeAt(0) !== 65533 && (c[r[186][e]] = 47616 + e, o[47616 + e] = r[186][e]);
      for (r[187] = "����������������������������������������������������������������籃籄籅籆籇籈籉籊籋籌籎籏籐籑籒籓籔籕籖籗籘籙籚籛籜籝籞籟籠籡籢籣籤籥籦籧籨籩籪籫籬籭籮籯籰籱籲籵籶籷籸籹籺籾籿粀粁粂粃粄粅粆粇�粈粊粋粌粍粎粏粐粓粔粖粙粚粛粠粡粣粦粧粨粩粫粬粭粯粰粴粵粶粷粸粺粻弧虎唬护互沪户花哗华猾滑画划化话槐徊怀淮坏欢环桓还缓换患唤痪豢焕涣宦幻荒慌黄磺蝗簧皇凰惶煌晃幌恍谎灰挥辉徽恢蛔回毁悔慧卉惠晦贿秽会烩汇讳诲绘荤昏婚魂浑混豁活伙火获或惑霍货祸击圾基机畸稽积箕�".split(""), e = 0; e != r[187].length; ++e)
        r[187][e].charCodeAt(0) !== 65533 && (c[r[187][e]] = 47872 + e, o[47872 + e] = r[187][e]);
      for (r[188] = "����������������������������������������������������������������粿糀糂糃糄糆糉糋糎糏糐糑糒糓糔糘糚糛糝糞糡糢糣糤糥糦糧糩糪糫糬糭糮糰糱糲糳糴糵糶糷糹糺糼糽糾糿紀紁紂紃約紅紆紇紈紉紋紌納紎紏紐�紑紒紓純紕紖紗紘紙級紛紜紝紞紟紡紣紤紥紦紨紩紪紬紭紮細紱紲紳紴紵紶肌饥迹激讥鸡姬绩缉吉极棘辑籍集及急疾汲即嫉级挤几脊己蓟技冀季伎祭剂悸济寄寂计记既忌际妓继纪嘉枷夹佳家加荚颊贾甲钾假稼价架驾嫁歼监坚尖笺间煎兼肩艰奸缄茧检柬碱硷拣捡简俭剪减荐槛鉴践贱见键箭件�".split(""), e = 0; e != r[188].length; ++e)
        r[188][e].charCodeAt(0) !== 65533 && (c[r[188][e]] = 48128 + e, o[48128 + e] = r[188][e]);
      for (r[189] = "����������������������������������������������������������������紷紸紹紺紻紼紽紾紿絀絁終絃組絅絆絇絈絉絊絋経絍絎絏結絑絒絓絔絕絖絗絘絙絚絛絜絝絞絟絠絡絢絣絤絥給絧絨絩絪絫絬絭絯絰統絲絳絴絵絶�絸絹絺絻絼絽絾絿綀綁綂綃綄綅綆綇綈綉綊綋綌綍綎綏綐綑綒經綔綕綖綗綘健舰剑饯渐溅涧建僵姜将浆江疆蒋桨奖讲匠酱降蕉椒礁焦胶交郊浇骄娇嚼搅铰矫侥脚狡角饺缴绞剿教酵轿较叫窖揭接皆秸街阶截劫节桔杰捷睫竭洁结解姐戒藉芥界借介疥诫届巾筋斤金今津襟紧锦仅谨进靳晋禁近烬浸�".split(""), e = 0; e != r[189].length; ++e)
        r[189][e].charCodeAt(0) !== 65533 && (c[r[189][e]] = 48384 + e, o[48384 + e] = r[189][e]);
      for (r[190] = "����������������������������������������������������������������継続綛綜綝綞綟綠綡綢綣綤綥綧綨綩綪綫綬維綯綰綱網綳綴綵綶綷綸綹綺綻綼綽綾綿緀緁緂緃緄緅緆緇緈緉緊緋緌緍緎総緐緑緒緓緔緕緖緗緘緙�線緛緜緝緞緟締緡緢緣緤緥緦緧編緩緪緫緬緭緮緯緰緱緲緳練緵緶緷緸緹緺尽劲荆兢茎睛晶鲸京惊精粳经井警景颈静境敬镜径痉靖竟竞净炯窘揪究纠玖韭久灸九酒厩救旧臼舅咎就疚鞠拘狙疽居驹菊局咀矩举沮聚拒据巨具距踞锯俱句惧炬剧捐鹃娟倦眷卷绢撅攫抉掘倔爵觉决诀绝均菌钧军君峻�".split(""), e = 0; e != r[190].length; ++e)
        r[190][e].charCodeAt(0) !== 65533 && (c[r[190][e]] = 48640 + e, o[48640 + e] = r[190][e]);
      for (r[191] = "����������������������������������������������������������������緻緼緽緾緿縀縁縂縃縄縅縆縇縈縉縊縋縌縍縎縏縐縑縒縓縔縕縖縗縘縙縚縛縜縝縞縟縠縡縢縣縤縥縦縧縨縩縪縫縬縭縮縯縰縱縲縳縴縵縶縷縸縹�縺縼總績縿繀繂繃繄繅繆繈繉繊繋繌繍繎繏繐繑繒繓織繕繖繗繘繙繚繛繜繝俊竣浚郡骏喀咖卡咯开揩楷凯慨刊堪勘坎砍看康慷糠扛抗亢炕考拷烤靠坷苛柯棵磕颗科壳咳可渴克刻客课肯啃垦恳坑吭空恐孔控抠口扣寇枯哭窟苦酷库裤夸垮挎跨胯块筷侩快宽款匡筐狂框矿眶旷况亏盔岿窥葵奎魁傀�".split(""), e = 0; e != r[191].length; ++e)
        r[191][e].charCodeAt(0) !== 65533 && (c[r[191][e]] = 48896 + e, o[48896 + e] = r[191][e]);
      for (r[192] = "����������������������������������������������������������������繞繟繠繡繢繣繤繥繦繧繨繩繪繫繬繭繮繯繰繱繲繳繴繵繶繷繸繹繺繻繼繽繾繿纀纁纃纄纅纆纇纈纉纊纋續纍纎纏纐纑纒纓纔纕纖纗纘纙纚纜纝纞�纮纴纻纼绖绤绬绹缊缐缞缷缹缻缼缽缾缿罀罁罃罆罇罈罉罊罋罌罍罎罏罒罓馈愧溃坤昆捆困括扩廓阔垃拉喇蜡腊辣啦莱来赖蓝婪栏拦篮阑兰澜谰揽览懒缆烂滥琅榔狼廊郎朗浪捞劳牢老佬姥酪烙涝勒乐雷镭蕾磊累儡垒擂肋类泪棱楞冷厘梨犁黎篱狸离漓理李里鲤礼莉荔吏栗丽厉励砾历利傈例俐�".split(""), e = 0; e != r[192].length; ++e)
        r[192][e].charCodeAt(0) !== 65533 && (c[r[192][e]] = 49152 + e, o[49152 + e] = r[192][e]);
      for (r[193] = "����������������������������������������������������������������罖罙罛罜罝罞罠罣罤罥罦罧罫罬罭罯罰罳罵罶罷罸罺罻罼罽罿羀羂羃羄羅羆羇羈羉羋羍羏羐羑羒羓羕羖羗羘羙羛羜羠羢羣羥羦羨義羪羫羬羭羮羱�羳羴羵羶羷羺羻羾翀翂翃翄翆翇翈翉翋翍翏翐翑習翓翖翗翙翚翛翜翝翞翢翣痢立粒沥隶力璃哩俩联莲连镰廉怜涟帘敛脸链恋炼练粮凉梁粱良两辆量晾亮谅撩聊僚疗燎寥辽潦了撂镣廖料列裂烈劣猎琳林磷霖临邻鳞淋凛赁吝拎玲菱零龄铃伶羚凌灵陵岭领另令溜琉榴硫馏留刘瘤流柳六龙聋咙笼窿�".split(""), e = 0; e != r[193].length; ++e)
        r[193][e].charCodeAt(0) !== 65533 && (c[r[193][e]] = 49408 + e, o[49408 + e] = r[193][e]);
      for (r[194] = "����������������������������������������������������������������翤翧翨翪翫翬翭翯翲翴翵翶翷翸翹翺翽翾翿耂耇耈耉耊耎耏耑耓耚耛耝耞耟耡耣耤耫耬耭耮耯耰耲耴耹耺耼耾聀聁聄聅聇聈聉聎聏聐聑聓聕聖聗�聙聛聜聝聞聟聠聡聢聣聤聥聦聧聨聫聬聭聮聯聰聲聳聴聵聶職聸聹聺聻聼聽隆垄拢陇楼娄搂篓漏陋芦卢颅庐炉掳卤虏鲁麓碌露路赂鹿潞禄录陆戮驴吕铝侣旅履屡缕虑氯律率滤绿峦挛孪滦卵乱掠略抡轮伦仑沦纶论萝螺罗逻锣箩骡裸落洛骆络妈麻玛码蚂马骂嘛吗埋买麦卖迈脉瞒馒蛮满蔓曼慢漫�".split(""), e = 0; e != r[194].length; ++e)
        r[194][e].charCodeAt(0) !== 65533 && (c[r[194][e]] = 49664 + e, o[49664 + e] = r[194][e]);
      for (r[195] = "����������������������������������������������������������������聾肁肂肅肈肊肍肎肏肐肑肒肔肕肗肙肞肣肦肧肨肬肰肳肵肶肸肹肻胅胇胈胉胊胋胏胐胑胒胓胔胕胘胟胠胢胣胦胮胵胷胹胻胾胿脀脁脃脄脅脇脈脋�脌脕脗脙脛脜脝脟脠脡脢脣脤脥脦脧脨脩脪脫脭脮脰脳脴脵脷脹脺脻脼脽脿谩芒茫盲氓忙莽猫茅锚毛矛铆卯茂冒帽貌贸么玫枚梅酶霉煤没眉媒镁每美昧寐妹媚门闷们萌蒙檬盟锰猛梦孟眯醚靡糜迷谜弥米秘觅泌蜜密幂棉眠绵冕免勉娩缅面苗描瞄藐秒渺庙妙蔑灭民抿皿敏悯闽明螟鸣铭名命谬摸�".split(""), e = 0; e != r[195].length; ++e)
        r[195][e].charCodeAt(0) !== 65533 && (c[r[195][e]] = 49920 + e, o[49920 + e] = r[195][e]);
      for (r[196] = "����������������������������������������������������������������腀腁腂腃腄腅腇腉腍腎腏腒腖腗腘腛腜腝腞腟腡腢腣腤腦腨腪腫腬腯腲腳腵腶腷腸膁膃膄膅膆膇膉膋膌膍膎膐膒膓膔膕膖膗膙膚膞膟膠膡膢膤膥�膧膩膫膬膭膮膯膰膱膲膴膵膶膷膸膹膼膽膾膿臄臅臇臈臉臋臍臎臏臐臑臒臓摹蘑模膜磨摩魔抹末莫墨默沫漠寞陌谋牟某拇牡亩姆母墓暮幕募慕木目睦牧穆拿哪呐钠那娜纳氖乃奶耐奈南男难囊挠脑恼闹淖呢馁内嫩能妮霓倪泥尼拟你匿腻逆溺蔫拈年碾撵捻念娘酿鸟尿捏聂孽啮镊镍涅您柠狞凝宁�".split(""), e = 0; e != r[196].length; ++e)
        r[196][e].charCodeAt(0) !== 65533 && (c[r[196][e]] = 50176 + e, o[50176 + e] = r[196][e]);
      for (r[197] = "����������������������������������������������������������������臔臕臖臗臘臙臚臛臜臝臞臟臠臡臢臤臥臦臨臩臫臮臯臰臱臲臵臶臷臸臹臺臽臿舃與興舉舊舋舎舏舑舓舕舖舗舘舙舚舝舠舤舥舦舧舩舮舲舺舼舽舿�艀艁艂艃艅艆艈艊艌艍艎艐艑艒艓艔艕艖艗艙艛艜艝艞艠艡艢艣艤艥艦艧艩拧泞牛扭钮纽脓浓农弄奴努怒女暖虐疟挪懦糯诺哦欧鸥殴藕呕偶沤啪趴爬帕怕琶拍排牌徘湃派攀潘盘磐盼畔判叛乓庞旁耪胖抛咆刨炮袍跑泡呸胚培裴赔陪配佩沛喷盆砰抨烹澎彭蓬棚硼篷膨朋鹏捧碰坯砒霹批披劈琵毗�".split(""), e = 0; e != r[197].length; ++e)
        r[197][e].charCodeAt(0) !== 65533 && (c[r[197][e]] = 50432 + e, o[50432 + e] = r[197][e]);
      for (r[198] = "����������������������������������������������������������������艪艫艬艭艱艵艶艷艸艻艼芀芁芃芅芆芇芉芌芐芓芔芕芖芚芛芞芠芢芣芧芲芵芶芺芻芼芿苀苂苃苅苆苉苐苖苙苚苝苢苧苨苩苪苬苭苮苰苲苳苵苶苸�苺苼苽苾苿茀茊茋茍茐茒茓茖茘茙茝茞茟茠茡茢茣茤茥茦茩茪茮茰茲茷茻茽啤脾疲皮匹痞僻屁譬篇偏片骗飘漂瓢票撇瞥拼频贫品聘乒坪苹萍平凭瓶评屏坡泼颇婆破魄迫粕剖扑铺仆莆葡菩蒲埔朴圃普浦谱曝瀑期欺栖戚妻七凄漆柒沏其棋奇歧畦崎脐齐旗祈祁骑起岂乞企启契砌器气迄弃汽泣讫掐�".split(""), e = 0; e != r[198].length; ++e)
        r[198][e].charCodeAt(0) !== 65533 && (c[r[198][e]] = 50688 + e, o[50688 + e] = r[198][e]);
      for (r[199] = "����������������������������������������������������������������茾茿荁荂荄荅荈荊荋荌荍荎荓荕荖荗荘荙荝荢荰荱荲荳荴荵荶荹荺荾荿莀莁莂莃莄莇莈莊莋莌莍莏莐莑莔莕莖莗莙莚莝莟莡莢莣莤莥莦莧莬莭莮�莯莵莻莾莿菂菃菄菆菈菉菋菍菎菐菑菒菓菕菗菙菚菛菞菢菣菤菦菧菨菫菬菭恰洽牵扦钎铅千迁签仟谦乾黔钱钳前潜遣浅谴堑嵌欠歉枪呛腔羌墙蔷强抢橇锹敲悄桥瞧乔侨巧鞘撬翘峭俏窍切茄且怯窃钦侵亲秦琴勤芹擒禽寝沁青轻氢倾卿清擎晴氰情顷请庆琼穷秋丘邱球求囚酋泅趋区蛆曲躯屈驱渠�".split(""), e = 0; e != r[199].length; ++e)
        r[199][e].charCodeAt(0) !== 65533 && (c[r[199][e]] = 50944 + e, o[50944 + e] = r[199][e]);
      for (r[200] = "����������������������������������������������������������������菮華菳菴菵菶菷菺菻菼菾菿萀萂萅萇萈萉萊萐萒萓萔萕萖萗萙萚萛萞萟萠萡萢萣萩萪萫萬萭萮萯萰萲萳萴萵萶萷萹萺萻萾萿葀葁葂葃葄葅葇葈葉�葊葋葌葍葎葏葐葒葓葔葕葖葘葝葞葟葠葢葤葥葦葧葨葪葮葯葰葲葴葷葹葻葼取娶龋趣去圈颧权醛泉全痊拳犬券劝缺炔瘸却鹊榷确雀裙群然燃冉染瓤壤攘嚷让饶扰绕惹热壬仁人忍韧任认刃妊纫扔仍日戎茸蓉荣融熔溶容绒冗揉柔肉茹蠕儒孺如辱乳汝入褥软阮蕊瑞锐闰润若弱撒洒萨腮鳃塞赛三叁�".split(""), e = 0; e != r[200].length; ++e)
        r[200][e].charCodeAt(0) !== 65533 && (c[r[200][e]] = 51200 + e, o[51200 + e] = r[200][e]);
      for (r[201] = "����������������������������������������������������������������葽葾葿蒀蒁蒃蒄蒅蒆蒊蒍蒏蒐蒑蒒蒓蒔蒕蒖蒘蒚蒛蒝蒞蒟蒠蒢蒣蒤蒥蒦蒧蒨蒩蒪蒫蒬蒭蒮蒰蒱蒳蒵蒶蒷蒻蒼蒾蓀蓂蓃蓅蓆蓇蓈蓋蓌蓎蓏蓒蓔蓕蓗�蓘蓙蓚蓛蓜蓞蓡蓢蓤蓧蓨蓩蓪蓫蓭蓮蓯蓱蓲蓳蓴蓵蓶蓷蓸蓹蓺蓻蓽蓾蔀蔁蔂伞散桑嗓丧搔骚扫嫂瑟色涩森僧莎砂杀刹沙纱傻啥煞筛晒珊苫杉山删煽衫闪陕擅赡膳善汕扇缮墒伤商赏晌上尚裳梢捎稍烧芍勺韶少哨邵绍奢赊蛇舌舍赦摄射慑涉社设砷申呻伸身深娠绅神沈审婶甚肾慎渗声生甥牲升绳�".split(""), e = 0; e != r[201].length; ++e)
        r[201][e].charCodeAt(0) !== 65533 && (c[r[201][e]] = 51456 + e, o[51456 + e] = r[201][e]);
      for (r[202] = "����������������������������������������������������������������蔃蔄蔅蔆蔇蔈蔉蔊蔋蔍蔎蔏蔐蔒蔔蔕蔖蔘蔙蔛蔜蔝蔞蔠蔢蔣蔤蔥蔦蔧蔨蔩蔪蔭蔮蔯蔰蔱蔲蔳蔴蔵蔶蔾蔿蕀蕁蕂蕄蕅蕆蕇蕋蕌蕍蕎蕏蕐蕑蕒蕓蕔蕕�蕗蕘蕚蕛蕜蕝蕟蕠蕡蕢蕣蕥蕦蕧蕩蕪蕫蕬蕭蕮蕯蕰蕱蕳蕵蕶蕷蕸蕼蕽蕿薀薁省盛剩胜圣师失狮施湿诗尸虱十石拾时什食蚀实识史矢使屎驶始式示士世柿事拭誓逝势是嗜噬适仕侍释饰氏市恃室视试收手首守寿授售受瘦兽蔬枢梳殊抒输叔舒淑疏书赎孰熟薯暑曙署蜀黍鼠属术述树束戍竖墅庶数漱�".split(""), e = 0; e != r[202].length; ++e)
        r[202][e].charCodeAt(0) !== 65533 && (c[r[202][e]] = 51712 + e, o[51712 + e] = r[202][e]);
      for (r[203] = "����������������������������������������������������������������薂薃薆薈薉薊薋薌薍薎薐薑薒薓薔薕薖薗薘薙薚薝薞薟薠薡薢薣薥薦薧薩薫薬薭薱薲薳薴薵薶薸薺薻薼薽薾薿藀藂藃藄藅藆藇藈藊藋藌藍藎藑藒�藔藖藗藘藙藚藛藝藞藟藠藡藢藣藥藦藧藨藪藫藬藭藮藯藰藱藲藳藴藵藶藷藸恕刷耍摔衰甩帅栓拴霜双爽谁水睡税吮瞬顺舜说硕朔烁斯撕嘶思私司丝死肆寺嗣四伺似饲巳松耸怂颂送宋讼诵搜艘擞嗽苏酥俗素速粟僳塑溯宿诉肃酸蒜算虽隋随绥髓碎岁穗遂隧祟孙损笋蓑梭唆缩琐索锁所塌他它她塔�".split(""), e = 0; e != r[203].length; ++e)
        r[203][e].charCodeAt(0) !== 65533 && (c[r[203][e]] = 51968 + e, o[51968 + e] = r[203][e]);
      for (r[204] = "����������������������������������������������������������������藹藺藼藽藾蘀蘁蘂蘃蘄蘆蘇蘈蘉蘊蘋蘌蘍蘎蘏蘐蘒蘓蘔蘕蘗蘘蘙蘚蘛蘜蘝蘞蘟蘠蘡蘢蘣蘤蘥蘦蘨蘪蘫蘬蘭蘮蘯蘰蘱蘲蘳蘴蘵蘶蘷蘹蘺蘻蘽蘾蘿虀�虁虂虃虄虅虆虇虈虉虊虋虌虒虓處虖虗虘虙虛虜虝號虠虡虣虤虥虦虧虨虩虪獭挞蹋踏胎苔抬台泰酞太态汰坍摊贪瘫滩坛檀痰潭谭谈坦毯袒碳探叹炭汤塘搪堂棠膛唐糖倘躺淌趟烫掏涛滔绦萄桃逃淘陶讨套特藤腾疼誊梯剔踢锑提题蹄啼体替嚏惕涕剃屉天添填田甜恬舔腆挑条迢眺跳贴铁帖厅听烃�".split(""), e = 0; e != r[204].length; ++e)
        r[204][e].charCodeAt(0) !== 65533 && (c[r[204][e]] = 52224 + e, o[52224 + e] = r[204][e]);
      for (r[205] = "����������������������������������������������������������������虭虯虰虲虳虴虵虶虷虸蚃蚄蚅蚆蚇蚈蚉蚎蚏蚐蚑蚒蚔蚖蚗蚘蚙蚚蚛蚞蚟蚠蚡蚢蚥蚦蚫蚭蚮蚲蚳蚷蚸蚹蚻蚼蚽蚾蚿蛁蛂蛃蛅蛈蛌蛍蛒蛓蛕蛖蛗蛚蛜�蛝蛠蛡蛢蛣蛥蛦蛧蛨蛪蛫蛬蛯蛵蛶蛷蛺蛻蛼蛽蛿蜁蜄蜅蜆蜋蜌蜎蜏蜐蜑蜔蜖汀廷停亭庭挺艇通桐酮瞳同铜彤童桶捅筒统痛偷投头透凸秃突图徒途涂屠土吐兔湍团推颓腿蜕褪退吞屯臀拖托脱鸵陀驮驼椭妥拓唾挖哇蛙洼娃瓦袜歪外豌弯湾玩顽丸烷完碗挽晚皖惋宛婉万腕汪王亡枉网往旺望忘妄威�".split(""), e = 0; e != r[205].length; ++e)
        r[205][e].charCodeAt(0) !== 65533 && (c[r[205][e]] = 52480 + e, o[52480 + e] = r[205][e]);
      for (r[206] = "����������������������������������������������������������������蜙蜛蜝蜟蜠蜤蜦蜧蜨蜪蜫蜬蜭蜯蜰蜲蜳蜵蜶蜸蜹蜺蜼蜽蝀蝁蝂蝃蝄蝅蝆蝊蝋蝍蝏蝐蝑蝒蝔蝕蝖蝘蝚蝛蝜蝝蝞蝟蝡蝢蝦蝧蝨蝩蝪蝫蝬蝭蝯蝱蝲蝳蝵�蝷蝸蝹蝺蝿螀螁螄螆螇螉螊螌螎螏螐螑螒螔螕螖螘螙螚螛螜螝螞螠螡螢螣螤巍微危韦违桅围唯惟为潍维苇萎委伟伪尾纬未蔚味畏胃喂魏位渭谓尉慰卫瘟温蚊文闻纹吻稳紊问嗡翁瓮挝蜗涡窝我斡卧握沃巫呜钨乌污诬屋无芜梧吾吴毋武五捂午舞伍侮坞戊雾晤物勿务悟误昔熙析西硒矽晰嘻吸锡牺�".split(""), e = 0; e != r[206].length; ++e)
        r[206][e].charCodeAt(0) !== 65533 && (c[r[206][e]] = 52736 + e, o[52736 + e] = r[206][e]);
      for (r[207] = "����������������������������������������������������������������螥螦螧螩螪螮螰螱螲螴螶螷螸螹螻螼螾螿蟁蟂蟃蟄蟅蟇蟈蟉蟌蟍蟎蟏蟐蟔蟕蟖蟗蟘蟙蟚蟜蟝蟞蟟蟡蟢蟣蟤蟦蟧蟨蟩蟫蟬蟭蟯蟰蟱蟲蟳蟴蟵蟶蟷蟸�蟺蟻蟼蟽蟿蠀蠁蠂蠄蠅蠆蠇蠈蠉蠋蠌蠍蠎蠏蠐蠑蠒蠔蠗蠘蠙蠚蠜蠝蠞蠟蠠蠣稀息希悉膝夕惜熄烯溪汐犀檄袭席习媳喜铣洗系隙戏细瞎虾匣霞辖暇峡侠狭下厦夏吓掀锨先仙鲜纤咸贤衔舷闲涎弦嫌显险现献县腺馅羡宪陷限线相厢镶香箱襄湘乡翔祥详想响享项巷橡像向象萧硝霄削哮嚣销消宵淆晓�".split(""), e = 0; e != r[207].length; ++e)
        r[207][e].charCodeAt(0) !== 65533 && (c[r[207][e]] = 52992 + e, o[52992 + e] = r[207][e]);
      for (r[208] = "����������������������������������������������������������������蠤蠥蠦蠧蠨蠩蠪蠫蠬蠭蠮蠯蠰蠱蠳蠴蠵蠶蠷蠸蠺蠻蠽蠾蠿衁衂衃衆衇衈衉衊衋衎衏衐衑衒術衕衖衘衚衛衜衝衞衟衠衦衧衪衭衯衱衳衴衵衶衸衹衺�衻衼袀袃袆袇袉袊袌袎袏袐袑袓袔袕袗袘袙袚袛袝袞袟袠袡袣袥袦袧袨袩袪小孝校肖啸笑效楔些歇蝎鞋协挟携邪斜胁谐写械卸蟹懈泄泻谢屑薪芯锌欣辛新忻心信衅星腥猩惺兴刑型形邢行醒幸杏性姓兄凶胸匈汹雄熊休修羞朽嗅锈秀袖绣墟戌需虚嘘须徐许蓄酗叙旭序畜恤絮婿绪续轩喧宣悬旋玄�".split(""), e = 0; e != r[208].length; ++e)
        r[208][e].charCodeAt(0) !== 65533 && (c[r[208][e]] = 53248 + e, o[53248 + e] = r[208][e]);
      for (r[209] = "����������������������������������������������������������������袬袮袯袰袲袳袴袵袶袸袹袺袻袽袾袿裀裃裄裇裈裊裋裌裍裏裐裑裓裖裗裚裛補裝裞裠裡裦裧裩裪裫裬裭裮裯裲裵裶裷裺裻製裿褀褁褃褄褅褆複褈�褉褋褌褍褎褏褑褔褕褖褗褘褜褝褞褟褠褢褣褤褦褧褨褩褬褭褮褯褱褲褳褵褷选癣眩绚靴薛学穴雪血勋熏循旬询寻驯巡殉汛训讯逊迅压押鸦鸭呀丫芽牙蚜崖衙涯雅哑亚讶焉咽阉烟淹盐严研蜒岩延言颜阎炎沿奄掩眼衍演艳堰燕厌砚雁唁彦焰宴谚验殃央鸯秧杨扬佯疡羊洋阳氧仰痒养样漾邀腰妖瑶�".split(""), e = 0; e != r[209].length; ++e)
        r[209][e].charCodeAt(0) !== 65533 && (c[r[209][e]] = 53504 + e, o[53504 + e] = r[209][e]);
      for (r[210] = "����������������������������������������������������������������褸褹褺褻褼褽褾褿襀襂襃襅襆襇襈襉襊襋襌襍襎襏襐襑襒襓襔襕襖襗襘襙襚襛襜襝襠襡襢襣襤襥襧襨襩襪襫襬襭襮襯襰襱襲襳襴襵襶襷襸襹襺襼�襽襾覀覂覄覅覇覈覉覊見覌覍覎規覐覑覒覓覔覕視覗覘覙覚覛覜覝覞覟覠覡摇尧遥窑谣姚咬舀药要耀椰噎耶爷野冶也页掖业叶曳腋夜液一壹医揖铱依伊衣颐夷遗移仪胰疑沂宜姨彝椅蚁倚已乙矣以艺抑易邑屹亿役臆逸肄疫亦裔意毅忆义益溢诣议谊译异翼翌绎茵荫因殷音阴姻吟银淫寅饮尹引隐�".split(""), e = 0; e != r[210].length; ++e)
        r[210][e].charCodeAt(0) !== 65533 && (c[r[210][e]] = 53760 + e, o[53760 + e] = r[210][e]);
      for (r[211] = "����������������������������������������������������������������覢覣覤覥覦覧覨覩親覫覬覭覮覯覰覱覲観覴覵覶覷覸覹覺覻覼覽覾覿觀觃觍觓觔觕觗觘觙觛觝觟觠觡觢觤觧觨觩觪觬觭觮觰觱觲觴觵觶觷觸觹觺�觻觼觽觾觿訁訂訃訄訅訆計訉訊訋訌訍討訏訐訑訒訓訔訕訖託記訙訚訛訜訝印英樱婴鹰应缨莹萤营荧蝇迎赢盈影颖硬映哟拥佣臃痈庸雍踊蛹咏泳涌永恿勇用幽优悠忧尤由邮铀犹油游酉有友右佑釉诱又幼迂淤于盂榆虞愚舆余俞逾鱼愉渝渔隅予娱雨与屿禹宇语羽玉域芋郁吁遇喻峪御愈欲狱育誉�".split(""), e = 0; e != r[211].length; ++e)
        r[211][e].charCodeAt(0) !== 65533 && (c[r[211][e]] = 54016 + e, o[54016 + e] = r[211][e]);
      for (r[212] = "����������������������������������������������������������������訞訟訠訡訢訣訤訥訦訧訨訩訪訫訬設訮訯訰許訲訳訴訵訶訷訸訹診註証訽訿詀詁詂詃詄詅詆詇詉詊詋詌詍詎詏詐詑詒詓詔評詖詗詘詙詚詛詜詝詞�詟詠詡詢詣詤詥試詧詨詩詪詫詬詭詮詯詰話該詳詴詵詶詷詸詺詻詼詽詾詿誀浴寓裕预豫驭鸳渊冤元垣袁原援辕园员圆猿源缘远苑愿怨院曰约越跃钥岳粤月悦阅耘云郧匀陨允运蕴酝晕韵孕匝砸杂栽哉灾宰载再在咱攒暂赞赃脏葬遭糟凿藻枣早澡蚤躁噪造皂灶燥责择则泽贼怎增憎曾赠扎喳渣札轧�".split(""), e = 0; e != r[212].length; ++e)
        r[212][e].charCodeAt(0) !== 65533 && (c[r[212][e]] = 54272 + e, o[54272 + e] = r[212][e]);
      for (r[213] = "����������������������������������������������������������������誁誂誃誄誅誆誇誈誋誌認誎誏誐誑誒誔誕誖誗誘誙誚誛誜誝語誟誠誡誢誣誤誥誦誧誨誩說誫説読誮誯誰誱課誳誴誵誶誷誸誹誺誻誼誽誾調諀諁諂�諃諄諅諆談諈諉諊請諌諍諎諏諐諑諒諓諔諕論諗諘諙諚諛諜諝諞諟諠諡諢諣铡闸眨栅榨咋乍炸诈摘斋宅窄债寨瞻毡詹粘沾盏斩辗崭展蘸栈占战站湛绽樟章彰漳张掌涨杖丈帐账仗胀瘴障招昭找沼赵照罩兆肇召遮折哲蛰辙者锗蔗这浙珍斟真甄砧臻贞针侦枕疹诊震振镇阵蒸挣睁征狰争怔整拯正政�".split(""), e = 0; e != r[213].length; ++e)
        r[213][e].charCodeAt(0) !== 65533 && (c[r[213][e]] = 54528 + e, o[54528 + e] = r[213][e]);
      for (r[214] = "����������������������������������������������������������������諤諥諦諧諨諩諪諫諬諭諮諯諰諱諲諳諴諵諶諷諸諹諺諻諼諽諾諿謀謁謂謃謄謅謆謈謉謊謋謌謍謎謏謐謑謒謓謔謕謖謗謘謙謚講謜謝謞謟謠謡謢謣�謤謥謧謨謩謪謫謬謭謮謯謰謱謲謳謴謵謶謷謸謹謺謻謼謽謾謿譀譁譂譃譄譅帧症郑证芝枝支吱蜘知肢脂汁之织职直植殖执值侄址指止趾只旨纸志挚掷至致置帜峙制智秩稚质炙痔滞治窒中盅忠钟衷终种肿重仲众舟周州洲诌粥轴肘帚咒皱宙昼骤珠株蛛朱猪诸诛逐竹烛煮拄瞩嘱主著柱助蛀贮铸筑�".split(""), e = 0; e != r[214].length; ++e)
        r[214][e].charCodeAt(0) !== 65533 && (c[r[214][e]] = 54784 + e, o[54784 + e] = r[214][e]);
      for (r[215] = "����������������������������������������������������������������譆譇譈證譊譋譌譍譎譏譐譑譒譓譔譕譖譗識譙譚譛譜譝譞譟譠譡譢譣譤譥譧譨譩譪譫譭譮譯議譱譲譳譴譵譶護譸譹譺譻譼譽譾譿讀讁讂讃讄讅讆�讇讈讉變讋讌讍讎讏讐讑讒讓讔讕讖讗讘讙讚讛讜讝讞讟讬讱讻诇诐诪谉谞住注祝驻抓爪拽专砖转撰赚篆桩庄装妆撞壮状椎锥追赘坠缀谆准捉拙卓桌琢茁酌啄着灼浊兹咨资姿滋淄孜紫仔籽滓子自渍字鬃棕踪宗综总纵邹走奏揍租足卒族祖诅阻组钻纂嘴醉最罪尊遵昨左佐柞做作坐座������".split(""), e = 0; e != r[215].length; ++e)
        r[215][e].charCodeAt(0) !== 65533 && (c[r[215][e]] = 55040 + e, o[55040 + e] = r[215][e]);
      for (r[216] = "����������������������������������������������������������������谸谹谺谻谼谽谾谿豀豂豃豄豅豈豊豋豍豎豏豐豑豒豓豔豖豗豘豙豛豜豝豞豟豠豣豤豥豦豧豨豩豬豭豮豯豰豱豲豴豵豶豷豻豼豽豾豿貀貁貃貄貆貇�貈貋貍貎貏貐貑貒貓貕貖貗貙貚貛貜貝貞貟負財貢貣貤貥貦貧貨販貪貫責貭亍丌兀丐廿卅丕亘丞鬲孬噩丨禺丿匕乇夭爻卮氐囟胤馗毓睾鼗丶亟鼐乜乩亓芈孛啬嘏仄厍厝厣厥厮靥赝匚叵匦匮匾赜卦卣刂刈刎刭刳刿剀剌剞剡剜蒯剽劂劁劐劓冂罔亻仃仉仂仨仡仫仞伛仳伢佤仵伥伧伉伫佞佧攸佚佝�".split(""), e = 0; e != r[216].length; ++e)
        r[216][e].charCodeAt(0) !== 65533 && (c[r[216][e]] = 55296 + e, o[55296 + e] = r[216][e]);
      for (r[217] = "����������������������������������������������������������������貮貯貰貱貲貳貴貵貶買貸貹貺費貼貽貾貿賀賁賂賃賄賅賆資賈賉賊賋賌賍賎賏賐賑賒賓賔賕賖賗賘賙賚賛賜賝賞賟賠賡賢賣賤賥賦賧賨賩質賫賬�賭賮賯賰賱賲賳賴賵賶賷賸賹賺賻購賽賾賿贀贁贂贃贄贅贆贇贈贉贊贋贌贍佟佗伲伽佶佴侑侉侃侏佾佻侪佼侬侔俦俨俪俅俚俣俜俑俟俸倩偌俳倬倏倮倭俾倜倌倥倨偾偃偕偈偎偬偻傥傧傩傺僖儆僭僬僦僮儇儋仝氽佘佥俎龠汆籴兮巽黉馘冁夔勹匍訇匐凫夙兕亠兖亳衮袤亵脔裒禀嬴蠃羸冫冱冽冼�".split(""), e = 0; e != r[217].length; ++e)
        r[217][e].charCodeAt(0) !== 65533 && (c[r[217][e]] = 55552 + e, o[55552 + e] = r[217][e]);
      for (r[218] = "����������������������������������������������������������������贎贏贐贑贒贓贔贕贖贗贘贙贚贛贜贠赑赒赗赟赥赨赩赪赬赮赯赱赲赸赹赺赻赼赽赾赿趀趂趃趆趇趈趉趌趍趎趏趐趒趓趕趖趗趘趙趚趛趜趝趞趠趡�趢趤趥趦趧趨趩趪趫趬趭趮趯趰趲趶趷趹趻趽跀跁跂跅跇跈跉跊跍跐跒跓跔凇冖冢冥讠讦讧讪讴讵讷诂诃诋诏诎诒诓诔诖诘诙诜诟诠诤诨诩诮诰诳诶诹诼诿谀谂谄谇谌谏谑谒谔谕谖谙谛谘谝谟谠谡谥谧谪谫谮谯谲谳谵谶卩卺阝阢阡阱阪阽阼陂陉陔陟陧陬陲陴隈隍隗隰邗邛邝邙邬邡邴邳邶邺�".split(""), e = 0; e != r[218].length; ++e)
        r[218][e].charCodeAt(0) !== 65533 && (c[r[218][e]] = 55808 + e, o[55808 + e] = r[218][e]);
      for (r[219] = "����������������������������������������������������������������跕跘跙跜跠跡跢跥跦跧跩跭跮跰跱跲跴跶跼跾跿踀踁踂踃踄踆踇踈踋踍踎踐踑踒踓踕踖踗踘踙踚踛踜踠踡踤踥踦踧踨踫踭踰踲踳踴踶踷踸踻踼踾�踿蹃蹅蹆蹌蹍蹎蹏蹐蹓蹔蹕蹖蹗蹘蹚蹛蹜蹝蹞蹟蹠蹡蹢蹣蹤蹥蹧蹨蹪蹫蹮蹱邸邰郏郅邾郐郄郇郓郦郢郜郗郛郫郯郾鄄鄢鄞鄣鄱鄯鄹酃酆刍奂劢劬劭劾哿勐勖勰叟燮矍廴凵凼鬯厶弁畚巯坌垩垡塾墼壅壑圩圬圪圳圹圮圯坜圻坂坩垅坫垆坼坻坨坭坶坳垭垤垌垲埏垧垴垓垠埕埘埚埙埒垸埴埯埸埤埝�".split(""), e = 0; e != r[219].length; ++e)
        r[219][e].charCodeAt(0) !== 65533 && (c[r[219][e]] = 56064 + e, o[56064 + e] = r[219][e]);
      for (r[220] = "����������������������������������������������������������������蹳蹵蹷蹸蹹蹺蹻蹽蹾躀躂躃躄躆躈躉躊躋躌躍躎躑躒躓躕躖躗躘躙躚躛躝躟躠躡躢躣躤躥躦躧躨躩躪躭躮躰躱躳躴躵躶躷躸躹躻躼躽躾躿軀軁軂�軃軄軅軆軇軈軉車軋軌軍軏軐軑軒軓軔軕軖軗軘軙軚軛軜軝軞軟軠軡転軣軤堋堍埽埭堀堞堙塄堠塥塬墁墉墚墀馨鼙懿艹艽艿芏芊芨芄芎芑芗芙芫芸芾芰苈苊苣芘芷芮苋苌苁芩芴芡芪芟苄苎芤苡茉苷苤茏茇苜苴苒苘茌苻苓茑茚茆茔茕苠苕茜荑荛荜茈莒茼茴茱莛荞茯荏荇荃荟荀茗荠茭茺茳荦荥�".split(""), e = 0; e != r[220].length; ++e)
        r[220][e].charCodeAt(0) !== 65533 && (c[r[220][e]] = 56320 + e, o[56320 + e] = r[220][e]);
      for (r[221] = "����������������������������������������������������������������軥軦軧軨軩軪軫軬軭軮軯軰軱軲軳軴軵軶軷軸軹軺軻軼軽軾軿輀輁輂較輄輅輆輇輈載輊輋輌輍輎輏輐輑輒輓輔輕輖輗輘輙輚輛輜輝輞輟輠輡輢輣�輤輥輦輧輨輩輪輫輬輭輮輯輰輱輲輳輴輵輶輷輸輹輺輻輼輽輾輿轀轁轂轃轄荨茛荩荬荪荭荮莰荸莳莴莠莪莓莜莅荼莶莩荽莸荻莘莞莨莺莼菁萁菥菘堇萘萋菝菽菖萜萸萑萆菔菟萏萃菸菹菪菅菀萦菰菡葜葑葚葙葳蒇蒈葺蒉葸萼葆葩葶蒌蒎萱葭蓁蓍蓐蓦蒽蓓蓊蒿蒺蓠蒡蒹蒴蒗蓥蓣蔌甍蔸蓰蔹蔟蔺�".split(""), e = 0; e != r[221].length; ++e)
        r[221][e].charCodeAt(0) !== 65533 && (c[r[221][e]] = 56576 + e, o[56576 + e] = r[221][e]);
      for (r[222] = "����������������������������������������������������������������轅轆轇轈轉轊轋轌轍轎轏轐轑轒轓轔轕轖轗轘轙轚轛轜轝轞轟轠轡轢轣轤轥轪辀辌辒辝辠辡辢辤辥辦辧辪辬辭辮辯農辳辴辵辷辸辺辻込辿迀迃迆�迉迊迋迌迍迏迒迖迗迚迠迡迣迧迬迯迱迲迴迵迶迺迻迼迾迿逇逈逌逎逓逕逘蕖蔻蓿蓼蕙蕈蕨蕤蕞蕺瞢蕃蕲蕻薤薨薇薏蕹薮薜薅薹薷薰藓藁藜藿蘧蘅蘩蘖蘼廾弈夼奁耷奕奚奘匏尢尥尬尴扌扪抟抻拊拚拗拮挢拶挹捋捃掭揶捱捺掎掴捭掬掊捩掮掼揲揸揠揿揄揞揎摒揆掾摅摁搋搛搠搌搦搡摞撄摭撖�".split(""), e = 0; e != r[222].length; ++e)
        r[222][e].charCodeAt(0) !== 65533 && (c[r[222][e]] = 56832 + e, o[56832 + e] = r[222][e]);
      for (r[223] = "����������������������������������������������������������������這逜連逤逥逧逨逩逪逫逬逰週進逳逴逷逹逺逽逿遀遃遅遆遈遉遊運遌過達違遖遙遚遜遝遞遟遠遡遤遦遧適遪遫遬遯遰遱遲遳遶遷選遹遺遻遼遾邁�還邅邆邇邉邊邌邍邎邏邐邒邔邖邘邚邜邞邟邠邤邥邧邨邩邫邭邲邷邼邽邿郀摺撷撸撙撺擀擐擗擤擢攉攥攮弋忒甙弑卟叱叽叩叨叻吒吖吆呋呒呓呔呖呃吡呗呙吣吲咂咔呷呱呤咚咛咄呶呦咝哐咭哂咴哒咧咦哓哔呲咣哕咻咿哌哙哚哜咩咪咤哝哏哞唛哧唠哽唔哳唢唣唏唑唧唪啧喏喵啉啭啁啕唿啐唼�".split(""), e = 0; e != r[223].length; ++e)
        r[223][e].charCodeAt(0) !== 65533 && (c[r[223][e]] = 57088 + e, o[57088 + e] = r[223][e]);
      for (r[224] = "����������������������������������������������������������������郂郃郆郈郉郋郌郍郒郔郕郖郘郙郚郞郟郠郣郤郥郩郪郬郮郰郱郲郳郵郶郷郹郺郻郼郿鄀鄁鄃鄅鄆鄇鄈鄉鄊鄋鄌鄍鄎鄏鄐鄑鄒鄓鄔鄕鄖鄗鄘鄚鄛鄜�鄝鄟鄠鄡鄤鄥鄦鄧鄨鄩鄪鄫鄬鄭鄮鄰鄲鄳鄴鄵鄶鄷鄸鄺鄻鄼鄽鄾鄿酀酁酂酄唷啖啵啶啷唳唰啜喋嗒喃喱喹喈喁喟啾嗖喑啻嗟喽喾喔喙嗪嗷嗉嘟嗑嗫嗬嗔嗦嗝嗄嗯嗥嗲嗳嗌嗍嗨嗵嗤辔嘞嘈嘌嘁嘤嘣嗾嘀嘧嘭噘嘹噗嘬噍噢噙噜噌噔嚆噤噱噫噻噼嚅嚓嚯囔囗囝囡囵囫囹囿圄圊圉圜帏帙帔帑帱帻帼�".split(""), e = 0; e != r[224].length; ++e)
        r[224][e].charCodeAt(0) !== 65533 && (c[r[224][e]] = 57344 + e, o[57344 + e] = r[224][e]);
      for (r[225] = "����������������������������������������������������������������酅酇酈酑酓酔酕酖酘酙酛酜酟酠酦酧酨酫酭酳酺酻酼醀醁醂醃醄醆醈醊醎醏醓醔醕醖醗醘醙醜醝醞醟醠醡醤醥醦醧醨醩醫醬醰醱醲醳醶醷醸醹醻�醼醽醾醿釀釁釂釃釄釅釆釈釋釐釒釓釔釕釖釗釘釙釚釛針釞釟釠釡釢釣釤釥帷幄幔幛幞幡岌屺岍岐岖岈岘岙岑岚岜岵岢岽岬岫岱岣峁岷峄峒峤峋峥崂崃崧崦崮崤崞崆崛嵘崾崴崽嵬嵛嵯嵝嵫嵋嵊嵩嵴嶂嶙嶝豳嶷巅彳彷徂徇徉後徕徙徜徨徭徵徼衢彡犭犰犴犷犸狃狁狎狍狒狨狯狩狲狴狷猁狳猃狺�".split(""), e = 0; e != r[225].length; ++e)
        r[225][e].charCodeAt(0) !== 65533 && (c[r[225][e]] = 57600 + e, o[57600 + e] = r[225][e]);
      for (r[226] = "����������������������������������������������������������������釦釧釨釩釪釫釬釭釮釯釰釱釲釳釴釵釶釷釸釹釺釻釼釽釾釿鈀鈁鈂鈃鈄鈅鈆鈇鈈鈉鈊鈋鈌鈍鈎鈏鈐鈑鈒鈓鈔鈕鈖鈗鈘鈙鈚鈛鈜鈝鈞鈟鈠鈡鈢鈣鈤�鈥鈦鈧鈨鈩鈪鈫鈬鈭鈮鈯鈰鈱鈲鈳鈴鈵鈶鈷鈸鈹鈺鈻鈼鈽鈾鈿鉀鉁鉂鉃鉄鉅狻猗猓猡猊猞猝猕猢猹猥猬猸猱獐獍獗獠獬獯獾舛夥飧夤夂饣饧饨饩饪饫饬饴饷饽馀馄馇馊馍馐馑馓馔馕庀庑庋庖庥庠庹庵庾庳赓廒廑廛廨廪膺忄忉忖忏怃忮怄忡忤忾怅怆忪忭忸怙怵怦怛怏怍怩怫怊怿怡恸恹恻恺恂�".split(""), e = 0; e != r[226].length; ++e)
        r[226][e].charCodeAt(0) !== 65533 && (c[r[226][e]] = 57856 + e, o[57856 + e] = r[226][e]);
      for (r[227] = "����������������������������������������������������������������鉆鉇鉈鉉鉊鉋鉌鉍鉎鉏鉐鉑鉒鉓鉔鉕鉖鉗鉘鉙鉚鉛鉜鉝鉞鉟鉠鉡鉢鉣鉤鉥鉦鉧鉨鉩鉪鉫鉬鉭鉮鉯鉰鉱鉲鉳鉵鉶鉷鉸鉹鉺鉻鉼鉽鉾鉿銀銁銂銃銄銅�銆銇銈銉銊銋銌銍銏銐銑銒銓銔銕銖銗銘銙銚銛銜銝銞銟銠銡銢銣銤銥銦銧恪恽悖悚悭悝悃悒悌悛惬悻悱惝惘惆惚悴愠愦愕愣惴愀愎愫慊慵憬憔憧憷懔懵忝隳闩闫闱闳闵闶闼闾阃阄阆阈阊阋阌阍阏阒阕阖阗阙阚丬爿戕氵汔汜汊沣沅沐沔沌汨汩汴汶沆沩泐泔沭泷泸泱泗沲泠泖泺泫泮沱泓泯泾�".split(""), e = 0; e != r[227].length; ++e)
        r[227][e].charCodeAt(0) !== 65533 && (c[r[227][e]] = 58112 + e, o[58112 + e] = r[227][e]);
      for (r[228] = "����������������������������������������������������������������銨銩銪銫銬銭銯銰銱銲銳銴銵銶銷銸銹銺銻銼銽銾銿鋀鋁鋂鋃鋄鋅鋆鋇鋉鋊鋋鋌鋍鋎鋏鋐鋑鋒鋓鋔鋕鋖鋗鋘鋙鋚鋛鋜鋝鋞鋟鋠鋡鋢鋣鋤鋥鋦鋧鋨�鋩鋪鋫鋬鋭鋮鋯鋰鋱鋲鋳鋴鋵鋶鋷鋸鋹鋺鋻鋼鋽鋾鋿錀錁錂錃錄錅錆錇錈錉洹洧洌浃浈洇洄洙洎洫浍洮洵洚浏浒浔洳涑浯涞涠浞涓涔浜浠浼浣渚淇淅淞渎涿淠渑淦淝淙渖涫渌涮渫湮湎湫溲湟溆湓湔渲渥湄滟溱溘滠漭滢溥溧溽溻溷滗溴滏溏滂溟潢潆潇漤漕滹漯漶潋潴漪漉漩澉澍澌潸潲潼潺濑�".split(""), e = 0; e != r[228].length; ++e)
        r[228][e].charCodeAt(0) !== 65533 && (c[r[228][e]] = 58368 + e, o[58368 + e] = r[228][e]);
      for (r[229] = "����������������������������������������������������������������錊錋錌錍錎錏錐錑錒錓錔錕錖錗錘錙錚錛錜錝錞錟錠錡錢錣錤錥錦錧錨錩錪錫錬錭錮錯錰錱録錳錴錵錶錷錸錹錺錻錼錽錿鍀鍁鍂鍃鍄鍅鍆鍇鍈鍉�鍊鍋鍌鍍鍎鍏鍐鍑鍒鍓鍔鍕鍖鍗鍘鍙鍚鍛鍜鍝鍞鍟鍠鍡鍢鍣鍤鍥鍦鍧鍨鍩鍫濉澧澹澶濂濡濮濞濠濯瀚瀣瀛瀹瀵灏灞宀宄宕宓宥宸甯骞搴寤寮褰寰蹇謇辶迓迕迥迮迤迩迦迳迨逅逄逋逦逑逍逖逡逵逶逭逯遄遑遒遐遨遘遢遛暹遴遽邂邈邃邋彐彗彖彘尻咫屐屙孱屣屦羼弪弩弭艴弼鬻屮妁妃妍妩妪妣�".split(""), e = 0; e != r[229].length; ++e)
        r[229][e].charCodeAt(0) !== 65533 && (c[r[229][e]] = 58624 + e, o[58624 + e] = r[229][e]);
      for (r[230] = "����������������������������������������������������������������鍬鍭鍮鍯鍰鍱鍲鍳鍴鍵鍶鍷鍸鍹鍺鍻鍼鍽鍾鍿鎀鎁鎂鎃鎄鎅鎆鎇鎈鎉鎊鎋鎌鎍鎎鎐鎑鎒鎓鎔鎕鎖鎗鎘鎙鎚鎛鎜鎝鎞鎟鎠鎡鎢鎣鎤鎥鎦鎧鎨鎩鎪鎫�鎬鎭鎮鎯鎰鎱鎲鎳鎴鎵鎶鎷鎸鎹鎺鎻鎼鎽鎾鎿鏀鏁鏂鏃鏄鏅鏆鏇鏈鏉鏋鏌鏍妗姊妫妞妤姒妲妯姗妾娅娆姝娈姣姘姹娌娉娲娴娑娣娓婀婧婊婕娼婢婵胬媪媛婷婺媾嫫媲嫒嫔媸嫠嫣嫱嫖嫦嫘嫜嬉嬗嬖嬲嬷孀尕尜孚孥孳孑孓孢驵驷驸驺驿驽骀骁骅骈骊骐骒骓骖骘骛骜骝骟骠骢骣骥骧纟纡纣纥纨纩�".split(""), e = 0; e != r[230].length; ++e)
        r[230][e].charCodeAt(0) !== 65533 && (c[r[230][e]] = 58880 + e, o[58880 + e] = r[230][e]);
      for (r[231] = "����������������������������������������������������������������鏎鏏鏐鏑鏒鏓鏔鏕鏗鏘鏙鏚鏛鏜鏝鏞鏟鏠鏡鏢鏣鏤鏥鏦鏧鏨鏩鏪鏫鏬鏭鏮鏯鏰鏱鏲鏳鏴鏵鏶鏷鏸鏹鏺鏻鏼鏽鏾鏿鐀鐁鐂鐃鐄鐅鐆鐇鐈鐉鐊鐋鐌鐍�鐎鐏鐐鐑鐒鐓鐔鐕鐖鐗鐘鐙鐚鐛鐜鐝鐞鐟鐠鐡鐢鐣鐤鐥鐦鐧鐨鐩鐪鐫鐬鐭鐮纭纰纾绀绁绂绉绋绌绐绔绗绛绠绡绨绫绮绯绱绲缍绶绺绻绾缁缂缃缇缈缋缌缏缑缒缗缙缜缛缟缡缢缣缤缥缦缧缪缫缬缭缯缰缱缲缳缵幺畿巛甾邕玎玑玮玢玟珏珂珑玷玳珀珉珈珥珙顼琊珩珧珞玺珲琏琪瑛琦琥琨琰琮琬�".split(""), e = 0; e != r[231].length; ++e)
        r[231][e].charCodeAt(0) !== 65533 && (c[r[231][e]] = 59136 + e, o[59136 + e] = r[231][e]);
      for (r[232] = "����������������������������������������������������������������鐯鐰鐱鐲鐳鐴鐵鐶鐷鐸鐹鐺鐻鐼鐽鐿鑀鑁鑂鑃鑄鑅鑆鑇鑈鑉鑊鑋鑌鑍鑎鑏鑐鑑鑒鑓鑔鑕鑖鑗鑘鑙鑚鑛鑜鑝鑞鑟鑠鑡鑢鑣鑤鑥鑦鑧鑨鑩鑪鑬鑭鑮鑯�鑰鑱鑲鑳鑴鑵鑶鑷鑸鑹鑺鑻鑼鑽鑾鑿钀钁钂钃钄钑钖钘铇铏铓铔铚铦铻锜锠琛琚瑁瑜瑗瑕瑙瑷瑭瑾璜璎璀璁璇璋璞璨璩璐璧瓒璺韪韫韬杌杓杞杈杩枥枇杪杳枘枧杵枨枞枭枋杷杼柰栉柘栊柩枰栌柙枵柚枳柝栀柃枸柢栎柁柽栲栳桠桡桎桢桄桤梃栝桕桦桁桧桀栾桊桉栩梵梏桴桷梓桫棂楮棼椟椠棹�".split(""), e = 0; e != r[232].length; ++e)
        r[232][e].charCodeAt(0) !== 65533 && (c[r[232][e]] = 59392 + e, o[59392 + e] = r[232][e]);
      for (r[233] = "����������������������������������������������������������������锧锳锽镃镈镋镕镚镠镮镴镵長镸镹镺镻镼镽镾門閁閂閃閄閅閆閇閈閉閊開閌閍閎閏閐閑閒間閔閕閖閗閘閙閚閛閜閝閞閟閠閡関閣閤閥閦閧閨閩閪�閫閬閭閮閯閰閱閲閳閴閵閶閷閸閹閺閻閼閽閾閿闀闁闂闃闄闅闆闇闈闉闊闋椤棰椋椁楗棣椐楱椹楠楂楝榄楫榀榘楸椴槌榇榈槎榉楦楣楹榛榧榻榫榭槔榱槁槊槟榕槠榍槿樯槭樗樘橥槲橄樾檠橐橛樵檎橹樽樨橘橼檑檐檩檗檫猷獒殁殂殇殄殒殓殍殚殛殡殪轫轭轱轲轳轵轶轸轷轹轺轼轾辁辂辄辇辋�".split(""), e = 0; e != r[233].length; ++e)
        r[233][e].charCodeAt(0) !== 65533 && (c[r[233][e]] = 59648 + e, o[59648 + e] = r[233][e]);
      for (r[234] = "����������������������������������������������������������������闌闍闎闏闐闑闒闓闔闕闖闗闘闙闚闛關闝闞闟闠闡闢闣闤闥闦闧闬闿阇阓阘阛阞阠阣阤阥阦阧阨阩阫阬阭阯阰阷阸阹阺阾陁陃陊陎陏陑陒陓陖陗�陘陙陚陜陝陞陠陣陥陦陫陭陮陯陰陱陳陸陹険陻陼陽陾陿隀隁隂隃隄隇隉隊辍辎辏辘辚軎戋戗戛戟戢戡戥戤戬臧瓯瓴瓿甏甑甓攴旮旯旰昊昙杲昃昕昀炅曷昝昴昱昶昵耆晟晔晁晏晖晡晗晷暄暌暧暝暾曛曜曦曩贲贳贶贻贽赀赅赆赈赉赇赍赕赙觇觊觋觌觎觏觐觑牮犟牝牦牯牾牿犄犋犍犏犒挈挲掰�".split(""), e = 0; e != r[234].length; ++e)
        r[234][e].charCodeAt(0) !== 65533 && (c[r[234][e]] = 59904 + e, o[59904 + e] = r[234][e]);
      for (r[235] = "����������������������������������������������������������������隌階隑隒隓隕隖隚際隝隞隟隠隡隢隣隤隥隦隨隩險隫隬隭隮隯隱隲隴隵隷隸隺隻隿雂雃雈雊雋雐雑雓雔雖雗雘雙雚雛雜雝雞雟雡離難雤雥雦雧雫�雬雭雮雰雱雲雴雵雸雺電雼雽雿霂霃霅霊霋霌霐霑霒霔霕霗霘霙霚霛霝霟霠搿擘耄毪毳毽毵毹氅氇氆氍氕氘氙氚氡氩氤氪氲攵敕敫牍牒牖爰虢刖肟肜肓肼朊肽肱肫肭肴肷胧胨胩胪胛胂胄胙胍胗朐胝胫胱胴胭脍脎胲胼朕脒豚脶脞脬脘脲腈腌腓腴腙腚腱腠腩腼腽腭腧塍媵膈膂膑滕膣膪臌朦臊膻�".split(""), e = 0; e != r[235].length; ++e)
        r[235][e].charCodeAt(0) !== 65533 && (c[r[235][e]] = 60160 + e, o[60160 + e] = r[235][e]);
      for (r[236] = "����������������������������������������������������������������霡霢霣霤霥霦霧霨霩霫霬霮霯霱霳霴霵霶霷霺霻霼霽霿靀靁靂靃靄靅靆靇靈靉靊靋靌靍靎靏靐靑靔靕靗靘靚靜靝靟靣靤靦靧靨靪靫靬靭靮靯靰靱�靲靵靷靸靹靺靻靽靾靿鞀鞁鞂鞃鞄鞆鞇鞈鞉鞊鞌鞎鞏鞐鞓鞕鞖鞗鞙鞚鞛鞜鞝臁膦欤欷欹歃歆歙飑飒飓飕飙飚殳彀毂觳斐齑斓於旆旄旃旌旎旒旖炀炜炖炝炻烀炷炫炱烨烊焐焓焖焯焱煳煜煨煅煲煊煸煺熘熳熵熨熠燠燔燧燹爝爨灬焘煦熹戾戽扃扈扉礻祀祆祉祛祜祓祚祢祗祠祯祧祺禅禊禚禧禳忑忐�".split(""), e = 0; e != r[236].length; ++e)
        r[236][e].charCodeAt(0) !== 65533 && (c[r[236][e]] = 60416 + e, o[60416 + e] = r[236][e]);
      for (r[237] = "����������������������������������������������������������������鞞鞟鞡鞢鞤鞥鞦鞧鞨鞩鞪鞬鞮鞰鞱鞳鞵鞶鞷鞸鞹鞺鞻鞼鞽鞾鞿韀韁韂韃韄韅韆韇韈韉韊韋韌韍韎韏韐韑韒韓韔韕韖韗韘韙韚韛韜韝韞韟韠韡韢韣�韤韥韨韮韯韰韱韲韴韷韸韹韺韻韼韽韾響頀頁頂頃頄項順頇須頉頊頋頌頍頎怼恝恚恧恁恙恣悫愆愍慝憩憝懋懑戆肀聿沓泶淼矶矸砀砉砗砘砑斫砭砜砝砹砺砻砟砼砥砬砣砩硎硭硖硗砦硐硇硌硪碛碓碚碇碜碡碣碲碹碥磔磙磉磬磲礅磴礓礤礞礴龛黹黻黼盱眄眍盹眇眈眚眢眙眭眦眵眸睐睑睇睃睚睨�".split(""), e = 0; e != r[237].length; ++e)
        r[237][e].charCodeAt(0) !== 65533 && (c[r[237][e]] = 60672 + e, o[60672 + e] = r[237][e]);
      for (r[238] = "����������������������������������������������������������������頏預頑頒頓頔頕頖頗領頙頚頛頜頝頞頟頠頡頢頣頤頥頦頧頨頩頪頫頬頭頮頯頰頱頲頳頴頵頶頷頸頹頺頻頼頽頾頿顀顁顂顃顄顅顆顇顈顉顊顋題額�顎顏顐顑顒顓顔顕顖顗願顙顚顛顜顝類顟顠顡顢顣顤顥顦顧顨顩顪顫顬顭顮睢睥睿瞍睽瞀瞌瞑瞟瞠瞰瞵瞽町畀畎畋畈畛畲畹疃罘罡罟詈罨罴罱罹羁罾盍盥蠲钅钆钇钋钊钌钍钏钐钔钗钕钚钛钜钣钤钫钪钭钬钯钰钲钴钶钷钸钹钺钼钽钿铄铈铉铊铋铌铍铎铐铑铒铕铖铗铙铘铛铞铟铠铢铤铥铧铨铪�".split(""), e = 0; e != r[238].length; ++e)
        r[238][e].charCodeAt(0) !== 65533 && (c[r[238][e]] = 60928 + e, o[60928 + e] = r[238][e]);
      for (r[239] = "����������������������������������������������������������������顯顰顱顲顳顴颋颎颒颕颙颣風颩颪颫颬颭颮颯颰颱颲颳颴颵颶颷颸颹颺颻颼颽颾颿飀飁飂飃飄飅飆飇飈飉飊飋飌飍飏飐飔飖飗飛飜飝飠飡飢飣飤�飥飦飩飪飫飬飭飮飯飰飱飲飳飴飵飶飷飸飹飺飻飼飽飾飿餀餁餂餃餄餅餆餇铩铫铮铯铳铴铵铷铹铼铽铿锃锂锆锇锉锊锍锎锏锒锓锔锕锖锘锛锝锞锟锢锪锫锩锬锱锲锴锶锷锸锼锾锿镂锵镄镅镆镉镌镎镏镒镓镔镖镗镘镙镛镞镟镝镡镢镤镥镦镧镨镩镪镫镬镯镱镲镳锺矧矬雉秕秭秣秫稆嵇稃稂稞稔�".split(""), e = 0; e != r[239].length; ++e)
        r[239][e].charCodeAt(0) !== 65533 && (c[r[239][e]] = 61184 + e, o[61184 + e] = r[239][e]);
      for (r[240] = "����������������������������������������������������������������餈餉養餋餌餎餏餑餒餓餔餕餖餗餘餙餚餛餜餝餞餟餠餡餢餣餤餥餦餧館餩餪餫餬餭餯餰餱餲餳餴餵餶餷餸餹餺餻餼餽餾餿饀饁饂饃饄饅饆饇饈饉�饊饋饌饍饎饏饐饑饒饓饖饗饘饙饚饛饜饝饞饟饠饡饢饤饦饳饸饹饻饾馂馃馉稹稷穑黏馥穰皈皎皓皙皤瓞瓠甬鸠鸢鸨鸩鸪鸫鸬鸲鸱鸶鸸鸷鸹鸺鸾鹁鹂鹄鹆鹇鹈鹉鹋鹌鹎鹑鹕鹗鹚鹛鹜鹞鹣鹦鹧鹨鹩鹪鹫鹬鹱鹭鹳疒疔疖疠疝疬疣疳疴疸痄疱疰痃痂痖痍痣痨痦痤痫痧瘃痱痼痿瘐瘀瘅瘌瘗瘊瘥瘘瘕瘙�".split(""), e = 0; e != r[240].length; ++e)
        r[240][e].charCodeAt(0) !== 65533 && (c[r[240][e]] = 61440 + e, o[61440 + e] = r[240][e]);
      for (r[241] = "����������������������������������������������������������������馌馎馚馛馜馝馞馟馠馡馢馣馤馦馧馩馪馫馬馭馮馯馰馱馲馳馴馵馶馷馸馹馺馻馼馽馾馿駀駁駂駃駄駅駆駇駈駉駊駋駌駍駎駏駐駑駒駓駔駕駖駗駘�駙駚駛駜駝駞駟駠駡駢駣駤駥駦駧駨駩駪駫駬駭駮駯駰駱駲駳駴駵駶駷駸駹瘛瘼瘢瘠癀瘭瘰瘿瘵癃瘾瘳癍癞癔癜癖癫癯翊竦穸穹窀窆窈窕窦窠窬窨窭窳衤衩衲衽衿袂袢裆袷袼裉裢裎裣裥裱褚裼裨裾裰褡褙褓褛褊褴褫褶襁襦襻疋胥皲皴矜耒耔耖耜耠耢耥耦耧耩耨耱耋耵聃聆聍聒聩聱覃顸颀颃�".split(""), e = 0; e != r[241].length; ++e)
        r[241][e].charCodeAt(0) !== 65533 && (c[r[241][e]] = 61696 + e, o[61696 + e] = r[241][e]);
      for (r[242] = "����������������������������������������������������������������駺駻駼駽駾駿騀騁騂騃騄騅騆騇騈騉騊騋騌騍騎騏騐騑騒験騔騕騖騗騘騙騚騛騜騝騞騟騠騡騢騣騤騥騦騧騨騩騪騫騬騭騮騯騰騱騲騳騴騵騶騷騸�騹騺騻騼騽騾騿驀驁驂驃驄驅驆驇驈驉驊驋驌驍驎驏驐驑驒驓驔驕驖驗驘驙颉颌颍颏颔颚颛颞颟颡颢颥颦虍虔虬虮虿虺虼虻蚨蚍蚋蚬蚝蚧蚣蚪蚓蚩蚶蛄蚵蛎蚰蚺蚱蚯蛉蛏蚴蛩蛱蛲蛭蛳蛐蜓蛞蛴蛟蛘蛑蜃蜇蛸蜈蜊蜍蜉蜣蜻蜞蜥蜮蜚蜾蝈蜴蜱蜩蜷蜿螂蜢蝽蝾蝻蝠蝰蝌蝮螋蝓蝣蝼蝤蝙蝥螓螯螨蟒�".split(""), e = 0; e != r[242].length; ++e)
        r[242][e].charCodeAt(0) !== 65533 && (c[r[242][e]] = 61952 + e, o[61952 + e] = r[242][e]);
      for (r[243] = "����������������������������������������������������������������驚驛驜驝驞驟驠驡驢驣驤驥驦驧驨驩驪驫驲骃骉骍骎骔骕骙骦骩骪骫骬骭骮骯骲骳骴骵骹骻骽骾骿髃髄髆髇髈髉髊髍髎髏髐髒體髕髖髗髙髚髛髜�髝髞髠髢髣髤髥髧髨髩髪髬髮髰髱髲髳髴髵髶髷髸髺髼髽髾髿鬀鬁鬂鬄鬅鬆蟆螈螅螭螗螃螫蟥螬螵螳蟋蟓螽蟑蟀蟊蟛蟪蟠蟮蠖蠓蟾蠊蠛蠡蠹蠼缶罂罄罅舐竺竽笈笃笄笕笊笫笏筇笸笪笙笮笱笠笥笤笳笾笞筘筚筅筵筌筝筠筮筻筢筲筱箐箦箧箸箬箝箨箅箪箜箢箫箴篑篁篌篝篚篥篦篪簌篾篼簏簖簋�".split(""), e = 0; e != r[243].length; ++e)
        r[243][e].charCodeAt(0) !== 65533 && (c[r[243][e]] = 62208 + e, o[62208 + e] = r[243][e]);
      for (r[244] = "����������������������������������������������������������������鬇鬉鬊鬋鬌鬍鬎鬐鬑鬒鬔鬕鬖鬗鬘鬙鬚鬛鬜鬝鬞鬠鬡鬢鬤鬥鬦鬧鬨鬩鬪鬫鬬鬭鬮鬰鬱鬳鬴鬵鬶鬷鬸鬹鬺鬽鬾鬿魀魆魊魋魌魎魐魒魓魕魖魗魘魙魚�魛魜魝魞魟魠魡魢魣魤魥魦魧魨魩魪魫魬魭魮魯魰魱魲魳魴魵魶魷魸魹魺魻簟簪簦簸籁籀臾舁舂舄臬衄舡舢舣舭舯舨舫舸舻舳舴舾艄艉艋艏艚艟艨衾袅袈裘裟襞羝羟羧羯羰羲籼敉粑粝粜粞粢粲粼粽糁糇糌糍糈糅糗糨艮暨羿翎翕翥翡翦翩翮翳糸絷綦綮繇纛麸麴赳趄趔趑趱赧赭豇豉酊酐酎酏酤�".split(""), e = 0; e != r[244].length; ++e)
        r[244][e].charCodeAt(0) !== 65533 && (c[r[244][e]] = 62464 + e, o[62464 + e] = r[244][e]);
      for (r[245] = "����������������������������������������������������������������魼魽魾魿鮀鮁鮂鮃鮄鮅鮆鮇鮈鮉鮊鮋鮌鮍鮎鮏鮐鮑鮒鮓鮔鮕鮖鮗鮘鮙鮚鮛鮜鮝鮞鮟鮠鮡鮢鮣鮤鮥鮦鮧鮨鮩鮪鮫鮬鮭鮮鮯鮰鮱鮲鮳鮴鮵鮶鮷鮸鮹鮺�鮻鮼鮽鮾鮿鯀鯁鯂鯃鯄鯅鯆鯇鯈鯉鯊鯋鯌鯍鯎鯏鯐鯑鯒鯓鯔鯕鯖鯗鯘鯙鯚鯛酢酡酰酩酯酽酾酲酴酹醌醅醐醍醑醢醣醪醭醮醯醵醴醺豕鹾趸跫踅蹙蹩趵趿趼趺跄跖跗跚跞跎跏跛跆跬跷跸跣跹跻跤踉跽踔踝踟踬踮踣踯踺蹀踹踵踽踱蹉蹁蹂蹑蹒蹊蹰蹶蹼蹯蹴躅躏躔躐躜躞豸貂貊貅貘貔斛觖觞觚觜�".split(""), e = 0; e != r[245].length; ++e)
        r[245][e].charCodeAt(0) !== 65533 && (c[r[245][e]] = 62720 + e, o[62720 + e] = r[245][e]);
      for (r[246] = "����������������������������������������������������������������鯜鯝鯞鯟鯠鯡鯢鯣鯤鯥鯦鯧鯨鯩鯪鯫鯬鯭鯮鯯鯰鯱鯲鯳鯴鯵鯶鯷鯸鯹鯺鯻鯼鯽鯾鯿鰀鰁鰂鰃鰄鰅鰆鰇鰈鰉鰊鰋鰌鰍鰎鰏鰐鰑鰒鰓鰔鰕鰖鰗鰘鰙鰚�鰛鰜鰝鰞鰟鰠鰡鰢鰣鰤鰥鰦鰧鰨鰩鰪鰫鰬鰭鰮鰯鰰鰱鰲鰳鰴鰵鰶鰷鰸鰹鰺鰻觥觫觯訾謦靓雩雳雯霆霁霈霏霎霪霭霰霾龀龃龅龆龇龈龉龊龌黾鼋鼍隹隼隽雎雒瞿雠銎銮鋈錾鍪鏊鎏鐾鑫鱿鲂鲅鲆鲇鲈稣鲋鲎鲐鲑鲒鲔鲕鲚鲛鲞鲟鲠鲡鲢鲣鲥鲦鲧鲨鲩鲫鲭鲮鲰鲱鲲鲳鲴鲵鲶鲷鲺鲻鲼鲽鳄鳅鳆鳇鳊鳋�".split(""), e = 0; e != r[246].length; ++e)
        r[246][e].charCodeAt(0) !== 65533 && (c[r[246][e]] = 62976 + e, o[62976 + e] = r[246][e]);
      for (r[247] = "����������������������������������������������������������������鰼鰽鰾鰿鱀鱁鱂鱃鱄鱅鱆鱇鱈鱉鱊鱋鱌鱍鱎鱏鱐鱑鱒鱓鱔鱕鱖鱗鱘鱙鱚鱛鱜鱝鱞鱟鱠鱡鱢鱣鱤鱥鱦鱧鱨鱩鱪鱫鱬鱭鱮鱯鱰鱱鱲鱳鱴鱵鱶鱷鱸鱹鱺�鱻鱽鱾鲀鲃鲄鲉鲊鲌鲏鲓鲖鲗鲘鲙鲝鲪鲬鲯鲹鲾鲿鳀鳁鳂鳈鳉鳑鳒鳚鳛鳠鳡鳌鳍鳎鳏鳐鳓鳔鳕鳗鳘鳙鳜鳝鳟鳢靼鞅鞑鞒鞔鞯鞫鞣鞲鞴骱骰骷鹘骶骺骼髁髀髅髂髋髌髑魅魃魇魉魈魍魑飨餍餮饕饔髟髡髦髯髫髻髭髹鬈鬏鬓鬟鬣麽麾縻麂麇麈麋麒鏖麝麟黛黜黝黠黟黢黩黧黥黪黯鼢鼬鼯鼹鼷鼽鼾齄�".split(""), e = 0; e != r[247].length; ++e)
        r[247][e].charCodeAt(0) !== 65533 && (c[r[247][e]] = 63232 + e, o[63232 + e] = r[247][e]);
      for (r[248] = "����������������������������������������������������������������鳣鳤鳥鳦鳧鳨鳩鳪鳫鳬鳭鳮鳯鳰鳱鳲鳳鳴鳵鳶鳷鳸鳹鳺鳻鳼鳽鳾鳿鴀鴁鴂鴃鴄鴅鴆鴇鴈鴉鴊鴋鴌鴍鴎鴏鴐鴑鴒鴓鴔鴕鴖鴗鴘鴙鴚鴛鴜鴝鴞鴟鴠鴡�鴢鴣鴤鴥鴦鴧鴨鴩鴪鴫鴬鴭鴮鴯鴰鴱鴲鴳鴴鴵鴶鴷鴸鴹鴺鴻鴼鴽鴾鴿鵀鵁鵂�����������������������������������������������������������������������������������������������".split(""), e = 0; e != r[248].length; ++e)
        r[248][e].charCodeAt(0) !== 65533 && (c[r[248][e]] = 63488 + e, o[63488 + e] = r[248][e]);
      for (r[249] = "����������������������������������������������������������������鵃鵄鵅鵆鵇鵈鵉鵊鵋鵌鵍鵎鵏鵐鵑鵒鵓鵔鵕鵖鵗鵘鵙鵚鵛鵜鵝鵞鵟鵠鵡鵢鵣鵤鵥鵦鵧鵨鵩鵪鵫鵬鵭鵮鵯鵰鵱鵲鵳鵴鵵鵶鵷鵸鵹鵺鵻鵼鵽鵾鵿鶀鶁�鶂鶃鶄鶅鶆鶇鶈鶉鶊鶋鶌鶍鶎鶏鶐鶑鶒鶓鶔鶕鶖鶗鶘鶙鶚鶛鶜鶝鶞鶟鶠鶡鶢�����������������������������������������������������������������������������������������������".split(""), e = 0; e != r[249].length; ++e)
        r[249][e].charCodeAt(0) !== 65533 && (c[r[249][e]] = 63744 + e, o[63744 + e] = r[249][e]);
      for (r[250] = "����������������������������������������������������������������鶣鶤鶥鶦鶧鶨鶩鶪鶫鶬鶭鶮鶯鶰鶱鶲鶳鶴鶵鶶鶷鶸鶹鶺鶻鶼鶽鶾鶿鷀鷁鷂鷃鷄鷅鷆鷇鷈鷉鷊鷋鷌鷍鷎鷏鷐鷑鷒鷓鷔鷕鷖鷗鷘鷙鷚鷛鷜鷝鷞鷟鷠鷡�鷢鷣鷤鷥鷦鷧鷨鷩鷪鷫鷬鷭鷮鷯鷰鷱鷲鷳鷴鷵鷶鷷鷸鷹鷺鷻鷼鷽鷾鷿鸀鸁鸂�����������������������������������������������������������������������������������������������".split(""), e = 0; e != r[250].length; ++e)
        r[250][e].charCodeAt(0) !== 65533 && (c[r[250][e]] = 64e3 + e, o[64e3 + e] = r[250][e]);
      for (r[251] = "����������������������������������������������������������������鸃鸄鸅鸆鸇鸈鸉鸊鸋鸌鸍鸎鸏鸐鸑鸒鸓鸔鸕鸖鸗鸘鸙鸚鸛鸜鸝鸞鸤鸧鸮鸰鸴鸻鸼鹀鹍鹐鹒鹓鹔鹖鹙鹝鹟鹠鹡鹢鹥鹮鹯鹲鹴鹵鹶鹷鹸鹹鹺鹻鹼鹽麀�麁麃麄麅麆麉麊麌麍麎麏麐麑麔麕麖麗麘麙麚麛麜麞麠麡麢麣麤麥麧麨麩麪�����������������������������������������������������������������������������������������������".split(""), e = 0; e != r[251].length; ++e)
        r[251][e].charCodeAt(0) !== 65533 && (c[r[251][e]] = 64256 + e, o[64256 + e] = r[251][e]);
      for (r[252] = "����������������������������������������������������������������麫麬麭麮麯麰麱麲麳麵麶麷麹麺麼麿黀黁黂黃黅黆黇黈黊黋黌黐黒黓黕黖黗黙黚點黡黣黤黦黨黫黬黭黮黰黱黲黳黴黵黶黷黸黺黽黿鼀鼁鼂鼃鼄鼅�鼆鼇鼈鼉鼊鼌鼏鼑鼒鼔鼕鼖鼘鼚鼛鼜鼝鼞鼟鼡鼣鼤鼥鼦鼧鼨鼩鼪鼫鼭鼮鼰鼱�����������������������������������������������������������������������������������������������".split(""), e = 0; e != r[252].length; ++e)
        r[252][e].charCodeAt(0) !== 65533 && (c[r[252][e]] = 64512 + e, o[64512 + e] = r[252][e]);
      for (r[253] = "����������������������������������������������������������������鼲鼳鼴鼵鼶鼸鼺鼼鼿齀齁齂齃齅齆齇齈齉齊齋齌齍齎齏齒齓齔齕齖齗齘齙齚齛齜齝齞齟齠齡齢齣齤齥齦齧齨齩齪齫齬齭齮齯齰齱齲齳齴齵齶齷齸�齹齺齻齼齽齾龁龂龍龎龏龐龑龒龓龔龕龖龗龘龜龝龞龡龢龣龤龥郎凉秊裏隣�����������������������������������������������������������������������������������������������".split(""), e = 0; e != r[253].length; ++e)
        r[253][e].charCodeAt(0) !== 65533 && (c[r[253][e]] = 64768 + e, o[64768 + e] = r[253][e]);
      for (r[254] = "����������������������������������������������������������������兀嗀﨎﨏﨑﨓﨔礼﨟蘒﨡﨣﨤﨧﨨﨩��������������������������������������������������������������������������������������������������������������������������������������������������������������������������������".split(""), e = 0; e != r[254].length; ++e)
        r[254][e].charCodeAt(0) !== 65533 && (c[r[254][e]] = 65024 + e, o[65024 + e] = r[254][e]);
      return { enc: c, dec: o };
    }(), i[949] = function() {
      var o = [], c = {}, r = [], e;
      for (r[0] = `\0\x07\b	
\v\f\r\x1B !"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_\`abcdefghijklmnopqrstuvwxyz{|}~��������������������������������������������������������������������������������������������������������������������������������`.split(""), e = 0; e != r[0].length; ++e)
        r[0][e].charCodeAt(0) !== 65533 && (c[r[0][e]] = 0 + e, o[0 + e] = r[0][e]);
      for (r[129] = "�����������������������������������������������������������������갂갃갅갆갋갌갍갎갏갘갞갟갡갢갣갥갦갧갨갩갪갫갮갲갳갴������갵갶갷갺갻갽갾갿걁걂걃걄걅걆걇걈걉걊걌걎걏걐걑걒걓걕������걖걗걙걚걛걝걞걟걠걡걢걣걤걥걦걧걨걩걪걫걬걭걮걯걲걳걵걶걹걻걼걽걾걿겂겇겈겍겎겏겑겒겓겕겖겗겘겙겚겛겞겢겣겤겥겦겧겫겭겮겱겲겳겴겵겶겷겺겾겿곀곂곃곅곆곇곉곊곋곍곎곏곐곑곒곓곔곖곘곙곚곛곜곝곞곟곢곣곥곦곩곫곭곮곲곴곷곸곹곺곻곾곿괁괂괃괅괇괈괉괊괋괎괐괒괓�".split(""), e = 0; e != r[129].length; ++e)
        r[129][e].charCodeAt(0) !== 65533 && (c[r[129][e]] = 33024 + e, o[33024 + e] = r[129][e]);
      for (r[130] = "�����������������������������������������������������������������괔괕괖괗괙괚괛괝괞괟괡괢괣괤괥괦괧괨괪괫괮괯괰괱괲괳������괶괷괹괺괻괽괾괿굀굁굂굃굆굈굊굋굌굍굎굏굑굒굓굕굖굗������굙굚굛굜굝굞굟굠굢굤굥굦굧굨굩굪굫굮굯굱굲굷굸굹굺굾궀궃궄궅궆궇궊궋궍궎궏궑궒궓궔궕궖궗궘궙궚궛궞궟궠궡궢궣궥궦궧궨궩궪궫궬궭궮궯궰궱궲궳궴궵궶궸궹궺궻궼궽궾궿귂귃귅귆귇귉귊귋귌귍귎귏귒귔귕귖귗귘귙귚귛귝귞귟귡귢귣귥귦귧귨귩귪귫귬귭귮귯귰귱귲귳귴귵귶귷�".split(""), e = 0; e != r[130].length; ++e)
        r[130][e].charCodeAt(0) !== 65533 && (c[r[130][e]] = 33280 + e, o[33280 + e] = r[130][e]);
      for (r[131] = "�����������������������������������������������������������������귺귻귽귾긂긃긄긅긆긇긊긌긎긏긐긑긒긓긕긖긗긘긙긚긛긜������긝긞긟긠긡긢긣긤긥긦긧긨긩긪긫긬긭긮긯긲긳긵긶긹긻긼������긽긾긿깂깄깇깈깉깋깏깑깒깓깕깗깘깙깚깛깞깢깣깤깦깧깪깫깭깮깯깱깲깳깴깵깶깷깺깾깿꺀꺁꺂꺃꺆꺇꺈꺉꺊꺋꺍꺎꺏꺐꺑꺒꺓꺔꺕꺖꺗꺘꺙꺚꺛꺜꺝꺞꺟꺠꺡꺢꺣꺤꺥꺦꺧꺨꺩꺪꺫꺬꺭꺮꺯꺰꺱꺲꺳꺴꺵꺶꺷꺸꺹꺺꺻꺿껁껂껃껅껆껇껈껉껊껋껎껒껓껔껕껖껗껚껛껝껞껟껠껡껢껣껤껥�".split(""), e = 0; e != r[131].length; ++e)
        r[131][e].charCodeAt(0) !== 65533 && (c[r[131][e]] = 33536 + e, o[33536 + e] = r[131][e]);
      for (r[132] = "�����������������������������������������������������������������껦껧껩껪껬껮껯껰껱껲껳껵껶껷껹껺껻껽껾껿꼀꼁꼂꼃꼄꼅������꼆꼉꼊꼋꼌꼎꼏꼑꼒꼓꼔꼕꼖꼗꼘꼙꼚꼛꼜꼝꼞꼟꼠꼡꼢꼣������꼤꼥꼦꼧꼨꼩꼪꼫꼮꼯꼱꼳꼵꼶꼷꼸꼹꼺꼻꼾꽀꽄꽅꽆꽇꽊꽋꽌꽍꽎꽏꽑꽒꽓꽔꽕꽖꽗꽘꽙꽚꽛꽞꽟꽠꽡꽢꽣꽦꽧꽨꽩꽪꽫꽬꽭꽮꽯꽰꽱꽲꽳꽴꽵꽶꽷꽸꽺꽻꽼꽽꽾꽿꾁꾂꾃꾅꾆꾇꾉꾊꾋꾌꾍꾎꾏꾒꾓꾔꾖꾗꾘꾙꾚꾛꾝꾞꾟꾠꾡꾢꾣꾤꾥꾦꾧꾨꾩꾪꾫꾬꾭꾮꾯꾰꾱꾲꾳꾴꾵꾶꾷꾺꾻꾽꾾�".split(""), e = 0; e != r[132].length; ++e)
        r[132][e].charCodeAt(0) !== 65533 && (c[r[132][e]] = 33792 + e, o[33792 + e] = r[132][e]);
      for (r[133] = "�����������������������������������������������������������������꾿꿁꿂꿃꿄꿅꿆꿊꿌꿏꿐꿑꿒꿓꿕꿖꿗꿘꿙꿚꿛꿝꿞꿟꿠꿡������꿢꿣꿤꿥꿦꿧꿪꿫꿬꿭꿮꿯꿲꿳꿵꿶꿷꿹꿺꿻꿼꿽꿾꿿뀂뀃������뀅뀆뀇뀈뀉뀊뀋뀍뀎뀏뀑뀒뀓뀕뀖뀗뀘뀙뀚뀛뀞뀟뀠뀡뀢뀣뀤뀥뀦뀧뀩뀪뀫뀬뀭뀮뀯뀰뀱뀲뀳뀴뀵뀶뀷뀸뀹뀺뀻뀼뀽뀾뀿끀끁끂끃끆끇끉끋끍끏끐끑끒끖끘끚끛끜끞끟끠끡끢끣끤끥끦끧끨끩끪끫끬끭끮끯끰끱끲끳끴끵끶끷끸끹끺끻끾끿낁낂낃낅낆낇낈낉낊낋낎낐낒낓낔낕낖낗낛낝낞낣낤�".split(""), e = 0; e != r[133].length; ++e)
        r[133][e].charCodeAt(0) !== 65533 && (c[r[133][e]] = 34048 + e, o[34048 + e] = r[133][e]);
      for (r[134] = "�����������������������������������������������������������������낥낦낧낪낰낲낶낷낹낺낻낽낾낿냀냁냂냃냆냊냋냌냍냎냏냒������냓냕냖냗냙냚냛냜냝냞냟냡냢냣냤냦냧냨냩냪냫냬냭냮냯냰������냱냲냳냴냵냶냷냸냹냺냻냼냽냾냿넀넁넂넃넄넅넆넇넊넍넎넏넑넔넕넖넗넚넞넟넠넡넢넦넧넩넪넫넭넮넯넰넱넲넳넶넺넻넼넽넾넿녂녃녅녆녇녉녊녋녌녍녎녏녒녓녖녗녙녚녛녝녞녟녡녢녣녤녥녦녧녨녩녪녫녬녭녮녯녰녱녲녳녴녵녶녷녺녻녽녾녿놁놃놄놅놆놇놊놌놎놏놐놑놕놖놗놙놚놛놝�".split(""), e = 0; e != r[134].length; ++e)
        r[134][e].charCodeAt(0) !== 65533 && (c[r[134][e]] = 34304 + e, o[34304 + e] = r[134][e]);
      for (r[135] = "�����������������������������������������������������������������놞놟놠놡놢놣놤놥놦놧놩놪놫놬놭놮놯놰놱놲놳놴놵놶놷놸������놹놺놻놼놽놾놿뇀뇁뇂뇃뇄뇅뇆뇇뇈뇉뇊뇋뇍뇎뇏뇑뇒뇓뇕������뇖뇗뇘뇙뇚뇛뇞뇠뇡뇢뇣뇤뇥뇦뇧뇪뇫뇭뇮뇯뇱뇲뇳뇴뇵뇶뇷뇸뇺뇼뇾뇿눀눁눂눃눆눇눉눊눍눎눏눐눑눒눓눖눘눚눛눜눝눞눟눡눢눣눤눥눦눧눨눩눪눫눬눭눮눯눰눱눲눳눵눶눷눸눹눺눻눽눾눿뉀뉁뉂뉃뉄뉅뉆뉇뉈뉉뉊뉋뉌뉍뉎뉏뉐뉑뉒뉓뉔뉕뉖뉗뉙뉚뉛뉝뉞뉟뉡뉢뉣뉤뉥뉦뉧뉪뉫뉬뉭뉮�".split(""), e = 0; e != r[135].length; ++e)
        r[135][e].charCodeAt(0) !== 65533 && (c[r[135][e]] = 34560 + e, o[34560 + e] = r[135][e]);
      for (r[136] = "�����������������������������������������������������������������뉯뉰뉱뉲뉳뉶뉷뉸뉹뉺뉻뉽뉾뉿늀늁늂늃늆늇늈늊늋늌늍늎������늏늒늓늕늖늗늛늜늝늞늟늢늤늧늨늩늫늭늮늯늱늲늳늵늶늷������늸늹늺늻늼늽늾늿닀닁닂닃닄닅닆닇닊닋닍닎닏닑닓닔닕닖닗닚닜닞닟닠닡닣닧닩닪닰닱닲닶닼닽닾댂댃댅댆댇댉댊댋댌댍댎댏댒댖댗댘댙댚댛댝댞댟댠댡댢댣댤댥댦댧댨댩댪댫댬댭댮댯댰댱댲댳댴댵댶댷댸댹댺댻댼댽댾댿덀덁덂덃덄덅덆덇덈덉덊덋덌덍덎덏덐덑덒덓덗덙덚덝덠덡덢덣�".split(""), e = 0; e != r[136].length; ++e)
        r[136][e].charCodeAt(0) !== 65533 && (c[r[136][e]] = 34816 + e, o[34816 + e] = r[136][e]);
      for (r[137] = "�����������������������������������������������������������������덦덨덪덬덭덯덲덳덵덶덷덹덺덻덼덽덾덿뎂뎆뎇뎈뎉뎊뎋뎍������뎎뎏뎑뎒뎓뎕뎖뎗뎘뎙뎚뎛뎜뎝뎞뎟뎢뎣뎤뎥뎦뎧뎩뎪뎫뎭������뎮뎯뎰뎱뎲뎳뎴뎵뎶뎷뎸뎹뎺뎻뎼뎽뎾뎿돀돁돂돃돆돇돉돊돍돏돑돒돓돖돘돚돜돞돟돡돢돣돥돦돧돩돪돫돬돭돮돯돰돱돲돳돴돵돶돷돸돹돺돻돽돾돿됀됁됂됃됄됅됆됇됈됉됊됋됌됍됎됏됑됒됓됔됕됖됗됙됚됛됝됞됟됡됢됣됤됥됦됧됪됬됭됮됯됰됱됲됳됵됶됷됸됹됺됻됼됽됾됿둀둁둂둃둄�".split(""), e = 0; e != r[137].length; ++e)
        r[137][e].charCodeAt(0) !== 65533 && (c[r[137][e]] = 35072 + e, o[35072 + e] = r[137][e]);
      for (r[138] = "�����������������������������������������������������������������둅둆둇둈둉둊둋둌둍둎둏둒둓둕둖둗둙둚둛둜둝둞둟둢둤둦������둧둨둩둪둫둭둮둯둰둱둲둳둴둵둶둷둸둹둺둻둼둽둾둿뒁뒂������뒃뒄뒅뒆뒇뒉뒊뒋뒌뒍뒎뒏뒐뒑뒒뒓뒔뒕뒖뒗뒘뒙뒚뒛뒜뒞뒟뒠뒡뒢뒣뒥뒦뒧뒩뒪뒫뒭뒮뒯뒰뒱뒲뒳뒴뒶뒸뒺뒻뒼뒽뒾뒿듁듂듃듅듆듇듉듊듋듌듍듎듏듑듒듓듔듖듗듘듙듚듛듞듟듡듢듥듧듨듩듪듫듮듰듲듳듴듵듶듷듹듺듻듼듽듾듿딀딁딂딃딄딅딆딇딈딉딊딋딌딍딎딏딐딑딒딓딖딗딙딚딝�".split(""), e = 0; e != r[138].length; ++e)
        r[138][e].charCodeAt(0) !== 65533 && (c[r[138][e]] = 35328 + e, o[35328 + e] = r[138][e]);
      for (r[139] = "�����������������������������������������������������������������딞딟딠딡딢딣딦딫딬딭딮딯딲딳딵딶딷딹딺딻딼딽딾딿땂땆������땇땈땉땊땎땏땑땒땓땕땖땗땘땙땚땛땞땢땣땤땥땦땧땨땩땪������땫땬땭땮땯땰땱땲땳땴땵땶땷땸땹땺땻땼땽땾땿떀떁떂떃떄떅떆떇떈떉떊떋떌떍떎떏떐떑떒떓떔떕떖떗떘떙떚떛떜떝떞떟떢떣떥떦떧떩떬떭떮떯떲떶떷떸떹떺떾떿뗁뗂뗃뗅뗆뗇뗈뗉뗊뗋뗎뗒뗓뗔뗕뗖뗗뗙뗚뗛뗜뗝뗞뗟뗠뗡뗢뗣뗤뗥뗦뗧뗨뗩뗪뗫뗭뗮뗯뗰뗱뗲뗳뗴뗵뗶뗷뗸뗹뗺뗻뗼뗽뗾뗿�".split(""), e = 0; e != r[139].length; ++e)
        r[139][e].charCodeAt(0) !== 65533 && (c[r[139][e]] = 35584 + e, o[35584 + e] = r[139][e]);
      for (r[140] = "�����������������������������������������������������������������똀똁똂똃똄똅똆똇똈똉똊똋똌똍똎똏똒똓똕똖똗똙똚똛똜똝������똞똟똠똡똢똣똤똦똧똨똩똪똫똭똮똯똰똱똲똳똵똶똷똸똹똺������똻똼똽똾똿뙀뙁뙂뙃뙄뙅뙆뙇뙉뙊뙋뙌뙍뙎뙏뙐뙑뙒뙓뙔뙕뙖뙗뙘뙙뙚뙛뙜뙝뙞뙟뙠뙡뙢뙣뙥뙦뙧뙩뙪뙫뙬뙭뙮뙯뙰뙱뙲뙳뙴뙵뙶뙷뙸뙹뙺뙻뙼뙽뙾뙿뚀뚁뚂뚃뚄뚅뚆뚇뚈뚉뚊뚋뚌뚍뚎뚏뚐뚑뚒뚓뚔뚕뚖뚗뚘뚙뚚뚛뚞뚟뚡뚢뚣뚥뚦뚧뚨뚩뚪뚭뚮뚯뚰뚲뚳뚴뚵뚶뚷뚸뚹뚺뚻뚼뚽뚾뚿뛀뛁뛂�".split(""), e = 0; e != r[140].length; ++e)
        r[140][e].charCodeAt(0) !== 65533 && (c[r[140][e]] = 35840 + e, o[35840 + e] = r[140][e]);
      for (r[141] = "�����������������������������������������������������������������뛃뛄뛅뛆뛇뛈뛉뛊뛋뛌뛍뛎뛏뛐뛑뛒뛓뛕뛖뛗뛘뛙뛚뛛뛜뛝������뛞뛟뛠뛡뛢뛣뛤뛥뛦뛧뛨뛩뛪뛫뛬뛭뛮뛯뛱뛲뛳뛵뛶뛷뛹뛺������뛻뛼뛽뛾뛿뜂뜃뜄뜆뜇뜈뜉뜊뜋뜌뜍뜎뜏뜐뜑뜒뜓뜔뜕뜖뜗뜘뜙뜚뜛뜜뜝뜞뜟뜠뜡뜢뜣뜤뜥뜦뜧뜪뜫뜭뜮뜱뜲뜳뜴뜵뜶뜷뜺뜼뜽뜾뜿띀띁띂띃띅띆띇띉띊띋띍띎띏띐띑띒띓띖띗띘띙띚띛띜띝띞띟띡띢띣띥띦띧띩띪띫띬띭띮띯띲띴띶띷띸띹띺띻띾띿랁랂랃랅랆랇랈랉랊랋랎랓랔랕랚랛랝랞�".split(""), e = 0; e != r[141].length; ++e)
        r[141][e].charCodeAt(0) !== 65533 && (c[r[141][e]] = 36096 + e, o[36096 + e] = r[141][e]);
      for (r[142] = "�����������������������������������������������������������������랟랡랢랣랤랥랦랧랪랮랯랰랱랲랳랶랷랹랺랻랼랽랾랿럀럁������럂럃럄럅럆럈럊럋럌럍럎럏럐럑럒럓럔럕럖럗럘럙럚럛럜럝������럞럟럠럡럢럣럤럥럦럧럨럩럪럫럮럯럱럲럳럵럶럷럸럹럺럻럾렂렃렄렅렆렊렋렍렎렏렑렒렓렔렕렖렗렚렜렞렟렠렡렢렣렦렧렩렪렫렭렮렯렰렱렲렳렶렺렻렼렽렾렿롁롂롃롅롆롇롈롉롊롋롌롍롎롏롐롒롔롕롖롗롘롙롚롛롞롟롡롢롣롥롦롧롨롩롪롫롮롰롲롳롴롵롶롷롹롺롻롽롾롿뢀뢁뢂뢃뢄�".split(""), e = 0; e != r[142].length; ++e)
        r[142][e].charCodeAt(0) !== 65533 && (c[r[142][e]] = 36352 + e, o[36352 + e] = r[142][e]);
      for (r[143] = "�����������������������������������������������������������������뢅뢆뢇뢈뢉뢊뢋뢌뢎뢏뢐뢑뢒뢓뢔뢕뢖뢗뢘뢙뢚뢛뢜뢝뢞뢟������뢠뢡뢢뢣뢤뢥뢦뢧뢩뢪뢫뢬뢭뢮뢯뢱뢲뢳뢵뢶뢷뢹뢺뢻뢼뢽������뢾뢿룂룄룆룇룈룉룊룋룍룎룏룑룒룓룕룖룗룘룙룚룛룜룞룠룢룣룤룥룦룧룪룫룭룮룯룱룲룳룴룵룶룷룺룼룾룿뤀뤁뤂뤃뤅뤆뤇뤈뤉뤊뤋뤌뤍뤎뤏뤐뤑뤒뤓뤔뤕뤖뤗뤙뤚뤛뤜뤝뤞뤟뤡뤢뤣뤤뤥뤦뤧뤨뤩뤪뤫뤬뤭뤮뤯뤰뤱뤲뤳뤴뤵뤶뤷뤸뤹뤺뤻뤾뤿륁륂륃륅륆륇륈륉륊륋륍륎륐륒륓륔륕륖륗�".split(""), e = 0; e != r[143].length; ++e)
        r[143][e].charCodeAt(0) !== 65533 && (c[r[143][e]] = 36608 + e, o[36608 + e] = r[143][e]);
      for (r[144] = "�����������������������������������������������������������������륚륛륝륞륟륡륢륣륤륥륦륧륪륬륮륯륰륱륲륳륶륷륹륺륻륽������륾륿릀릁릂릃릆릈릋릌릏릐릑릒릓릔릕릖릗릘릙릚릛릜릝릞������릟릠릡릢릣릤릥릦릧릨릩릪릫릮릯릱릲릳릵릶릷릸릹릺릻릾맀맂맃맄맅맆맇맊맋맍맓맔맕맖맗맚맜맟맠맢맦맧맩맪맫맭맮맯맰맱맲맳맶맻맼맽맾맿먂먃먄먅먆먇먉먊먋먌먍먎먏먐먑먒먓먔먖먗먘먙먚먛먜먝먞먟먠먡먢먣먤먥먦먧먨먩먪먫먬먭먮먯먰먱먲먳먴먵먶먷먺먻먽먾먿멁멃멄멅멆�".split(""), e = 0; e != r[144].length; ++e)
        r[144][e].charCodeAt(0) !== 65533 && (c[r[144][e]] = 36864 + e, o[36864 + e] = r[144][e]);
      for (r[145] = "�����������������������������������������������������������������멇멊멌멏멐멑멒멖멗멙멚멛멝멞멟멠멡멢멣멦멪멫멬멭멮멯������멲멳멵멶멷멹멺멻멼멽멾멿몀몁몂몆몈몉몊몋몍몎몏몐몑몒������몓몔몕몖몗몘몙몚몛몜몝몞몟몠몡몢몣몤몥몦몧몪몭몮몯몱몳몴몵몶몷몺몼몾몿뫀뫁뫂뫃뫅뫆뫇뫉뫊뫋뫌뫍뫎뫏뫐뫑뫒뫓뫔뫕뫖뫗뫚뫛뫜뫝뫞뫟뫠뫡뫢뫣뫤뫥뫦뫧뫨뫩뫪뫫뫬뫭뫮뫯뫰뫱뫲뫳뫴뫵뫶뫷뫸뫹뫺뫻뫽뫾뫿묁묂묃묅묆묇묈묉묊묋묌묎묐묒묓묔묕묖묗묙묚묛묝묞묟묡묢묣묤묥묦묧�".split(""), e = 0; e != r[145].length; ++e)
        r[145][e].charCodeAt(0) !== 65533 && (c[r[145][e]] = 37120 + e, o[37120 + e] = r[145][e]);
      for (r[146] = "�����������������������������������������������������������������묨묪묬묭묮묯묰묱묲묳묷묹묺묿뭀뭁뭂뭃뭆뭈뭊뭋뭌뭎뭑뭒������뭓뭕뭖뭗뭙뭚뭛뭜뭝뭞뭟뭠뭢뭤뭥뭦뭧뭨뭩뭪뭫뭭뭮뭯뭰뭱������뭲뭳뭴뭵뭶뭷뭸뭹뭺뭻뭼뭽뭾뭿뮀뮁뮂뮃뮄뮅뮆뮇뮉뮊뮋뮍뮎뮏뮑뮒뮓뮔뮕뮖뮗뮘뮙뮚뮛뮜뮝뮞뮟뮠뮡뮢뮣뮥뮦뮧뮩뮪뮫뮭뮮뮯뮰뮱뮲뮳뮵뮶뮸뮹뮺뮻뮼뮽뮾뮿믁믂믃믅믆믇믉믊믋믌믍믎믏믑믒믔믕믖믗믘믙믚믛믜믝믞믟믠믡믢믣믤믥믦믧믨믩믪믫믬믭믮믯믰믱믲믳믴믵믶믷믺믻믽믾밁�".split(""), e = 0; e != r[146].length; ++e)
        r[146][e].charCodeAt(0) !== 65533 && (c[r[146][e]] = 37376 + e, o[37376 + e] = r[146][e]);
      for (r[147] = "�����������������������������������������������������������������밃밄밅밆밇밊밎밐밒밓밙밚밠밡밢밣밦밨밪밫밬밮밯밲밳밵������밶밷밹밺밻밼밽밾밿뱂뱆뱇뱈뱊뱋뱎뱏뱑뱒뱓뱔뱕뱖뱗뱘뱙������뱚뱛뱜뱞뱟뱠뱡뱢뱣뱤뱥뱦뱧뱨뱩뱪뱫뱬뱭뱮뱯뱰뱱뱲뱳뱴뱵뱶뱷뱸뱹뱺뱻뱼뱽뱾뱿벀벁벂벃벆벇벉벊벍벏벐벑벒벓벖벘벛벜벝벞벟벢벣벥벦벩벪벫벬벭벮벯벲벶벷벸벹벺벻벾벿볁볂볃볅볆볇볈볉볊볋볌볎볒볓볔볖볗볙볚볛볝볞볟볠볡볢볣볤볥볦볧볨볩볪볫볬볭볮볯볰볱볲볳볷볹볺볻볽�".split(""), e = 0; e != r[147].length; ++e)
        r[147][e].charCodeAt(0) !== 65533 && (c[r[147][e]] = 37632 + e, o[37632 + e] = r[147][e]);
      for (r[148] = "�����������������������������������������������������������������볾볿봀봁봂봃봆봈봊봋봌봍봎봏봑봒봓봕봖봗봘봙봚봛봜봝������봞봟봠봡봢봣봥봦봧봨봩봪봫봭봮봯봰봱봲봳봴봵봶봷봸봹������봺봻봼봽봾봿뵁뵂뵃뵄뵅뵆뵇뵊뵋뵍뵎뵏뵑뵒뵓뵔뵕뵖뵗뵚뵛뵜뵝뵞뵟뵠뵡뵢뵣뵥뵦뵧뵩뵪뵫뵬뵭뵮뵯뵰뵱뵲뵳뵴뵵뵶뵷뵸뵹뵺뵻뵼뵽뵾뵿붂붃붅붆붋붌붍붎붏붒붔붖붗붘붛붝붞붟붠붡붢붣붥붦붧붨붩붪붫붬붭붮붯붱붲붳붴붵붶붷붹붺붻붼붽붾붿뷀뷁뷂뷃뷄뷅뷆뷇뷈뷉뷊뷋뷌뷍뷎뷏뷐뷑�".split(""), e = 0; e != r[148].length; ++e)
        r[148][e].charCodeAt(0) !== 65533 && (c[r[148][e]] = 37888 + e, o[37888 + e] = r[148][e]);
      for (r[149] = "�����������������������������������������������������������������뷒뷓뷖뷗뷙뷚뷛뷝뷞뷟뷠뷡뷢뷣뷤뷥뷦뷧뷨뷪뷫뷬뷭뷮뷯뷱������뷲뷳뷵뷶뷷뷹뷺뷻뷼뷽뷾뷿븁븂븄븆븇븈븉븊븋븎븏븑븒븓������븕븖븗븘븙븚븛븞븠븡븢븣븤븥븦븧븨븩븪븫븬븭븮븯븰븱븲븳븴븵븶븷븸븹븺븻븼븽븾븿빀빁빂빃빆빇빉빊빋빍빏빐빑빒빓빖빘빜빝빞빟빢빣빥빦빧빩빫빬빭빮빯빲빶빷빸빹빺빾빿뺁뺂뺃뺅뺆뺇뺈뺉뺊뺋뺎뺒뺓뺔뺕뺖뺗뺚뺛뺜뺝뺞뺟뺠뺡뺢뺣뺤뺥뺦뺧뺩뺪뺫뺬뺭뺮뺯뺰뺱뺲뺳뺴뺵뺶뺷�".split(""), e = 0; e != r[149].length; ++e)
        r[149][e].charCodeAt(0) !== 65533 && (c[r[149][e]] = 38144 + e, o[38144 + e] = r[149][e]);
      for (r[150] = "�����������������������������������������������������������������뺸뺹뺺뺻뺼뺽뺾뺿뻀뻁뻂뻃뻄뻅뻆뻇뻈뻉뻊뻋뻌뻍뻎뻏뻒뻓������뻕뻖뻙뻚뻛뻜뻝뻞뻟뻡뻢뻦뻧뻨뻩뻪뻫뻭뻮뻯뻰뻱뻲뻳뻴뻵������뻶뻷뻸뻹뻺뻻뻼뻽뻾뻿뼀뼂뼃뼄뼅뼆뼇뼊뼋뼌뼍뼎뼏뼐뼑뼒뼓뼔뼕뼖뼗뼚뼞뼟뼠뼡뼢뼣뼤뼥뼦뼧뼨뼩뼪뼫뼬뼭뼮뼯뼰뼱뼲뼳뼴뼵뼶뼷뼸뼹뼺뼻뼼뼽뼾뼿뽂뽃뽅뽆뽇뽉뽊뽋뽌뽍뽎뽏뽒뽓뽔뽖뽗뽘뽙뽚뽛뽜뽝뽞뽟뽠뽡뽢뽣뽤뽥뽦뽧뽨뽩뽪뽫뽬뽭뽮뽯뽰뽱뽲뽳뽴뽵뽶뽷뽸뽹뽺뽻뽼뽽뽾뽿뾀뾁뾂�".split(""), e = 0; e != r[150].length; ++e)
        r[150][e].charCodeAt(0) !== 65533 && (c[r[150][e]] = 38400 + e, o[38400 + e] = r[150][e]);
      for (r[151] = "�����������������������������������������������������������������뾃뾄뾅뾆뾇뾈뾉뾊뾋뾌뾍뾎뾏뾐뾑뾒뾓뾕뾖뾗뾘뾙뾚뾛뾜뾝������뾞뾟뾠뾡뾢뾣뾤뾥뾦뾧뾨뾩뾪뾫뾬뾭뾮뾯뾱뾲뾳뾴뾵뾶뾷뾸������뾹뾺뾻뾼뾽뾾뾿뿀뿁뿂뿃뿄뿆뿇뿈뿉뿊뿋뿎뿏뿑뿒뿓뿕뿖뿗뿘뿙뿚뿛뿝뿞뿠뿢뿣뿤뿥뿦뿧뿨뿩뿪뿫뿬뿭뿮뿯뿰뿱뿲뿳뿴뿵뿶뿷뿸뿹뿺뿻뿼뿽뿾뿿쀀쀁쀂쀃쀄쀅쀆쀇쀈쀉쀊쀋쀌쀍쀎쀏쀐쀑쀒쀓쀔쀕쀖쀗쀘쀙쀚쀛쀜쀝쀞쀟쀠쀡쀢쀣쀤쀥쀦쀧쀨쀩쀪쀫쀬쀭쀮쀯쀰쀱쀲쀳쀴쀵쀶쀷쀸쀹쀺쀻쀽쀾쀿�".split(""), e = 0; e != r[151].length; ++e)
        r[151][e].charCodeAt(0) !== 65533 && (c[r[151][e]] = 38656 + e, o[38656 + e] = r[151][e]);
      for (r[152] = "�����������������������������������������������������������������쁀쁁쁂쁃쁄쁅쁆쁇쁈쁉쁊쁋쁌쁍쁎쁏쁐쁒쁓쁔쁕쁖쁗쁙쁚쁛������쁝쁞쁟쁡쁢쁣쁤쁥쁦쁧쁪쁫쁬쁭쁮쁯쁰쁱쁲쁳쁴쁵쁶쁷쁸쁹������쁺쁻쁼쁽쁾쁿삀삁삂삃삄삅삆삇삈삉삊삋삌삍삎삏삒삓삕삖삗삙삚삛삜삝삞삟삢삤삦삧삨삩삪삫삮삱삲삷삸삹삺삻삾샂샃샄샆샇샊샋샍샎샏샑샒샓샔샕샖샗샚샞샟샠샡샢샣샦샧샩샪샫샭샮샯샰샱샲샳샶샸샺샻샼샽샾샿섁섂섃섅섆섇섉섊섋섌섍섎섏섑섒섓섔섖섗섘섙섚섛섡섢섥섨섩섪섫섮�".split(""), e = 0; e != r[152].length; ++e)
        r[152][e].charCodeAt(0) !== 65533 && (c[r[152][e]] = 38912 + e, o[38912 + e] = r[152][e]);
      for (r[153] = "�����������������������������������������������������������������섲섳섴섵섷섺섻섽섾섿셁셂셃셄셅셆셇셊셎셏셐셑셒셓셖셗������셙셚셛셝셞셟셠셡셢셣셦셪셫셬셭셮셯셱셲셳셵셶셷셹셺셻������셼셽셾셿솀솁솂솃솄솆솇솈솉솊솋솏솑솒솓솕솗솘솙솚솛솞솠솢솣솤솦솧솪솫솭솮솯솱솲솳솴솵솶솷솸솹솺솻솼솾솿쇀쇁쇂쇃쇅쇆쇇쇉쇊쇋쇍쇎쇏쇐쇑쇒쇓쇕쇖쇙쇚쇛쇜쇝쇞쇟쇡쇢쇣쇥쇦쇧쇩쇪쇫쇬쇭쇮쇯쇲쇴쇵쇶쇷쇸쇹쇺쇻쇾쇿숁숂숃숅숆숇숈숉숊숋숎숐숒숓숔숕숖숗숚숛숝숞숡숢숣�".split(""), e = 0; e != r[153].length; ++e)
        r[153][e].charCodeAt(0) !== 65533 && (c[r[153][e]] = 39168 + e, o[39168 + e] = r[153][e]);
      for (r[154] = "�����������������������������������������������������������������숤숥숦숧숪숬숮숰숳숵숶숷숸숹숺숻숼숽숾숿쉀쉁쉂쉃쉄쉅������쉆쉇쉉쉊쉋쉌쉍쉎쉏쉒쉓쉕쉖쉗쉙쉚쉛쉜쉝쉞쉟쉡쉢쉣쉤쉦������쉧쉨쉩쉪쉫쉮쉯쉱쉲쉳쉵쉶쉷쉸쉹쉺쉻쉾슀슂슃슄슅슆슇슊슋슌슍슎슏슑슒슓슔슕슖슗슙슚슜슞슟슠슡슢슣슦슧슩슪슫슮슯슰슱슲슳슶슸슺슻슼슽슾슿싀싁싂싃싄싅싆싇싈싉싊싋싌싍싎싏싐싑싒싓싔싕싖싗싘싙싚싛싞싟싡싢싥싦싧싨싩싪싮싰싲싳싴싵싷싺싽싾싿쌁쌂쌃쌄쌅쌆쌇쌊쌋쌎쌏�".split(""), e = 0; e != r[154].length; ++e)
        r[154][e].charCodeAt(0) !== 65533 && (c[r[154][e]] = 39424 + e, o[39424 + e] = r[154][e]);
      for (r[155] = "�����������������������������������������������������������������쌐쌑쌒쌖쌗쌙쌚쌛쌝쌞쌟쌠쌡쌢쌣쌦쌧쌪쌫쌬쌭쌮쌯쌰쌱쌲������쌳쌴쌵쌶쌷쌸쌹쌺쌻쌼쌽쌾쌿썀썁썂썃썄썆썇썈썉썊썋썌썍������썎썏썐썑썒썓썔썕썖썗썘썙썚썛썜썝썞썟썠썡썢썣썤썥썦썧썪썫썭썮썯썱썳썴썵썶썷썺썻썾썿쎀쎁쎂쎃쎅쎆쎇쎉쎊쎋쎍쎎쎏쎐쎑쎒쎓쎔쎕쎖쎗쎘쎙쎚쎛쎜쎝쎞쎟쎠쎡쎢쎣쎤쎥쎦쎧쎨쎩쎪쎫쎬쎭쎮쎯쎰쎱쎲쎳쎴쎵쎶쎷쎸쎹쎺쎻쎼쎽쎾쎿쏁쏂쏃쏄쏅쏆쏇쏈쏉쏊쏋쏌쏍쏎쏏쏐쏑쏒쏓쏔쏕쏖쏗쏚�".split(""), e = 0; e != r[155].length; ++e)
        r[155][e].charCodeAt(0) !== 65533 && (c[r[155][e]] = 39680 + e, o[39680 + e] = r[155][e]);
      for (r[156] = "�����������������������������������������������������������������쏛쏝쏞쏡쏣쏤쏥쏦쏧쏪쏫쏬쏮쏯쏰쏱쏲쏳쏶쏷쏹쏺쏻쏼쏽쏾������쏿쐀쐁쐂쐃쐄쐅쐆쐇쐉쐊쐋쐌쐍쐎쐏쐑쐒쐓쐔쐕쐖쐗쐘쐙쐚������쐛쐜쐝쐞쐟쐠쐡쐢쐣쐥쐦쐧쐨쐩쐪쐫쐭쐮쐯쐱쐲쐳쐵쐶쐷쐸쐹쐺쐻쐾쐿쑀쑁쑂쑃쑄쑅쑆쑇쑉쑊쑋쑌쑍쑎쑏쑐쑑쑒쑓쑔쑕쑖쑗쑘쑙쑚쑛쑜쑝쑞쑟쑠쑡쑢쑣쑦쑧쑩쑪쑫쑭쑮쑯쑰쑱쑲쑳쑶쑷쑸쑺쑻쑼쑽쑾쑿쒁쒂쒃쒄쒅쒆쒇쒈쒉쒊쒋쒌쒍쒎쒏쒐쒑쒒쒓쒕쒖쒗쒘쒙쒚쒛쒝쒞쒟쒠쒡쒢쒣쒤쒥쒦쒧쒨쒩�".split(""), e = 0; e != r[156].length; ++e)
        r[156][e].charCodeAt(0) !== 65533 && (c[r[156][e]] = 39936 + e, o[39936 + e] = r[156][e]);
      for (r[157] = "�����������������������������������������������������������������쒪쒫쒬쒭쒮쒯쒰쒱쒲쒳쒴쒵쒶쒷쒹쒺쒻쒽쒾쒿쓀쓁쓂쓃쓄쓅������쓆쓇쓈쓉쓊쓋쓌쓍쓎쓏쓐쓑쓒쓓쓔쓕쓖쓗쓘쓙쓚쓛쓜쓝쓞쓟������쓠쓡쓢쓣쓤쓥쓦쓧쓨쓪쓫쓬쓭쓮쓯쓲쓳쓵쓶쓷쓹쓻쓼쓽쓾씂씃씄씅씆씇씈씉씊씋씍씎씏씑씒씓씕씖씗씘씙씚씛씝씞씟씠씡씢씣씤씥씦씧씪씫씭씮씯씱씲씳씴씵씶씷씺씼씾씿앀앁앂앃앆앇앋앏앐앑앒앖앚앛앜앟앢앣앥앦앧앩앪앫앬앭앮앯앲앶앷앸앹앺앻앾앿얁얂얃얅얆얈얉얊얋얎얐얒얓얔�".split(""), e = 0; e != r[157].length; ++e)
        r[157][e].charCodeAt(0) !== 65533 && (c[r[157][e]] = 40192 + e, o[40192 + e] = r[157][e]);
      for (r[158] = "�����������������������������������������������������������������얖얙얚얛얝얞얟얡얢얣얤얥얦얧얨얪얫얬얭얮얯얰얱얲얳얶������얷얺얿엀엁엂엃엋엍엏엒엓엕엖엗엙엚엛엜엝엞엟엢엤엦엧������엨엩엪엫엯엱엲엳엵엸엹엺엻옂옃옄옉옊옋옍옎옏옑옒옓옔옕옖옗옚옝옞옟옠옡옢옣옦옧옩옪옫옯옱옲옶옸옺옼옽옾옿왂왃왅왆왇왉왊왋왌왍왎왏왒왖왗왘왙왚왛왞왟왡왢왣왤왥왦왧왨왩왪왫왭왮왰왲왳왴왵왶왷왺왻왽왾왿욁욂욃욄욅욆욇욊욌욎욏욐욑욒욓욖욗욙욚욛욝욞욟욠욡욢욣욦�".split(""), e = 0; e != r[158].length; ++e)
        r[158][e].charCodeAt(0) !== 65533 && (c[r[158][e]] = 40448 + e, o[40448 + e] = r[158][e]);
      for (r[159] = "�����������������������������������������������������������������욨욪욫욬욭욮욯욲욳욵욶욷욻욼욽욾욿웂웄웆웇웈웉웊웋웎������웏웑웒웓웕웖웗웘웙웚웛웞웟웢웣웤웥웦웧웪웫웭웮웯웱웲������웳웴웵웶웷웺웻웼웾웿윀윁윂윃윆윇윉윊윋윍윎윏윐윑윒윓윖윘윚윛윜윝윞윟윢윣윥윦윧윩윪윫윬윭윮윯윲윴윶윸윹윺윻윾윿읁읂읃읅읆읇읈읉읋읎읐읙읚읛읝읞읟읡읢읣읤읥읦읧읩읪읬읭읮읯읰읱읲읳읶읷읹읺읻읿잀잁잂잆잋잌잍잏잒잓잕잙잛잜잝잞잟잢잧잨잩잪잫잮잯잱잲잳잵잶잷�".split(""), e = 0; e != r[159].length; ++e)
        r[159][e].charCodeAt(0) !== 65533 && (c[r[159][e]] = 40704 + e, o[40704 + e] = r[159][e]);
      for (r[160] = "�����������������������������������������������������������������잸잹잺잻잾쟂쟃쟄쟅쟆쟇쟊쟋쟍쟏쟑쟒쟓쟔쟕쟖쟗쟙쟚쟛쟜������쟞쟟쟠쟡쟢쟣쟥쟦쟧쟩쟪쟫쟭쟮쟯쟰쟱쟲쟳쟴쟵쟶쟷쟸쟹쟺������쟻쟼쟽쟾쟿젂젃젅젆젇젉젋젌젍젎젏젒젔젗젘젙젚젛젞젟젡젢젣젥젦젧젨젩젪젫젮젰젲젳젴젵젶젷젹젺젻젽젾젿졁졂졃졄졅졆졇졊졋졎졏졐졑졒졓졕졖졗졘졙졚졛졜졝졞졟졠졡졢졣졤졥졦졧졨졩졪졫졬졭졮졯졲졳졵졶졷졹졻졼졽졾졿좂좄좈좉좊좎좏좐좑좒좓좕좖좗좘좙좚좛좜좞좠좢좣좤�".split(""), e = 0; e != r[160].length; ++e)
        r[160][e].charCodeAt(0) !== 65533 && (c[r[160][e]] = 40960 + e, o[40960 + e] = r[160][e]);
      for (r[161] = "�����������������������������������������������������������������좥좦좧좩좪좫좬좭좮좯좰좱좲좳좴좵좶좷좸좹좺좻좾좿죀죁������죂죃죅죆죇죉죊죋죍죎죏죐죑죒죓죖죘죚죛죜죝죞죟죢죣죥������죦죧죨죩죪죫죬죭죮죯죰죱죲죳죴죶죷죸죹죺죻죾죿줁줂줃줇줈줉줊줋줎　、。·‥…¨〃­―∥＼∼‘’“”〔〕〈〉《》「」『』【】±×÷≠≤≥∞∴°′″℃Å￠￡￥♂♀∠⊥⌒∂∇≡≒§※☆★○●◎◇◆□■△▲▽▼→←↑↓↔〓≪≫√∽∝∵∫∬∈∋⊆⊇⊂⊃∪∩∧∨￢�".split(""), e = 0; e != r[161].length; ++e)
        r[161][e].charCodeAt(0) !== 65533 && (c[r[161][e]] = 41216 + e, o[41216 + e] = r[161][e]);
      for (r[162] = "�����������������������������������������������������������������줐줒줓줔줕줖줗줙줚줛줜줝줞줟줠줡줢줣줤줥줦줧줨줩줪줫������줭줮줯줰줱줲줳줵줶줷줸줹줺줻줼줽줾줿쥀쥁쥂쥃쥄쥅쥆쥇������쥈쥉쥊쥋쥌쥍쥎쥏쥒쥓쥕쥖쥗쥙쥚쥛쥜쥝쥞쥟쥢쥤쥥쥦쥧쥨쥩쥪쥫쥭쥮쥯⇒⇔∀∃´～ˇ˘˝˚˙¸˛¡¿ː∮∑∏¤℉‰◁◀▷▶♤♠♡♥♧♣⊙◈▣◐◑▒▤▥▨▧▦▩♨☏☎☜☞¶†‡↕↗↙↖↘♭♩♪♬㉿㈜№㏇™㏂㏘℡€®������������������������".split(""), e = 0; e != r[162].length; ++e)
        r[162][e].charCodeAt(0) !== 65533 && (c[r[162][e]] = 41472 + e, o[41472 + e] = r[162][e]);
      for (r[163] = "�����������������������������������������������������������������쥱쥲쥳쥵쥶쥷쥸쥹쥺쥻쥽쥾쥿즀즁즂즃즄즅즆즇즊즋즍즎즏������즑즒즓즔즕즖즗즚즜즞즟즠즡즢즣즤즥즦즧즨즩즪즫즬즭즮������즯즰즱즲즳즴즵즶즷즸즹즺즻즼즽즾즿짂짃짅짆짉짋짌짍짎짏짒짔짗짘짛！＂＃＄％＆＇（）＊＋，－．／０１２３４５６７８９：；＜＝＞？＠ＡＢＣＤＥＦＧＨＩＪＫＬＭＮＯＰＱＲＳＴＵＶＷＸＹＺ［￦］＾＿｀ａｂｃｄｅｆｇｈｉｊｋｌｍｎｏｐｑｒｓｔｕｖｗｘｙｚ｛｜｝￣�".split(""), e = 0; e != r[163].length; ++e)
        r[163][e].charCodeAt(0) !== 65533 && (c[r[163][e]] = 41728 + e, o[41728 + e] = r[163][e]);
      for (r[164] = "�����������������������������������������������������������������짞짟짡짣짥짦짨짩짪짫짮짲짳짴짵짶짷짺짻짽짾짿쨁쨂쨃쨄������쨅쨆쨇쨊쨎쨏쨐쨑쨒쨓쨕쨖쨗쨙쨚쨛쨜쨝쨞쨟쨠쨡쨢쨣쨤쨥������쨦쨧쨨쨪쨫쨬쨭쨮쨯쨰쨱쨲쨳쨴쨵쨶쨷쨸쨹쨺쨻쨼쨽쨾쨿쩀쩁쩂쩃쩄쩅쩆ㄱㄲㄳㄴㄵㄶㄷㄸㄹㄺㄻㄼㄽㄾㄿㅀㅁㅂㅃㅄㅅㅆㅇㅈㅉㅊㅋㅌㅍㅎㅏㅐㅑㅒㅓㅔㅕㅖㅗㅘㅙㅚㅛㅜㅝㅞㅟㅠㅡㅢㅣㅤㅥㅦㅧㅨㅩㅪㅫㅬㅭㅮㅯㅰㅱㅲㅳㅴㅵㅶㅷㅸㅹㅺㅻㅼㅽㅾㅿㆀㆁㆂㆃㆄㆅㆆㆇㆈㆉㆊㆋㆌㆍㆎ�".split(""), e = 0; e != r[164].length; ++e)
        r[164][e].charCodeAt(0) !== 65533 && (c[r[164][e]] = 41984 + e, o[41984 + e] = r[164][e]);
      for (r[165] = "�����������������������������������������������������������������쩇쩈쩉쩊쩋쩎쩏쩑쩒쩓쩕쩖쩗쩘쩙쩚쩛쩞쩢쩣쩤쩥쩦쩧쩩쩪������쩫쩬쩭쩮쩯쩰쩱쩲쩳쩴쩵쩶쩷쩸쩹쩺쩻쩼쩾쩿쪀쪁쪂쪃쪅쪆������쪇쪈쪉쪊쪋쪌쪍쪎쪏쪐쪑쪒쪓쪔쪕쪖쪗쪙쪚쪛쪜쪝쪞쪟쪠쪡쪢쪣쪤쪥쪦쪧ⅰⅱⅲⅳⅴⅵⅶⅷⅸⅹ�����ⅠⅡⅢⅣⅤⅥⅦⅧⅨⅩ�������ΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡΣΤΥΦΧΨΩ��������αβγδεζηθικλμνξοπρστυφχψω�������".split(""), e = 0; e != r[165].length; ++e)
        r[165][e].charCodeAt(0) !== 65533 && (c[r[165][e]] = 42240 + e, o[42240 + e] = r[165][e]);
      for (r[166] = "�����������������������������������������������������������������쪨쪩쪪쪫쪬쪭쪮쪯쪰쪱쪲쪳쪴쪵쪶쪷쪸쪹쪺쪻쪾쪿쫁쫂쫃쫅������쫆쫇쫈쫉쫊쫋쫎쫐쫒쫔쫕쫖쫗쫚쫛쫜쫝쫞쫟쫡쫢쫣쫤쫥쫦쫧������쫨쫩쫪쫫쫭쫮쫯쫰쫱쫲쫳쫵쫶쫷쫸쫹쫺쫻쫼쫽쫾쫿쬀쬁쬂쬃쬄쬅쬆쬇쬉쬊─│┌┐┘└├┬┤┴┼━┃┏┓┛┗┣┳┫┻╋┠┯┨┷┿┝┰┥┸╂┒┑┚┙┖┕┎┍┞┟┡┢┦┧┩┪┭┮┱┲┵┶┹┺┽┾╀╁╃╄╅╆╇╈╉╊���������������������������".split(""), e = 0; e != r[166].length; ++e)
        r[166][e].charCodeAt(0) !== 65533 && (c[r[166][e]] = 42496 + e, o[42496 + e] = r[166][e]);
      for (r[167] = "�����������������������������������������������������������������쬋쬌쬍쬎쬏쬑쬒쬓쬕쬖쬗쬙쬚쬛쬜쬝쬞쬟쬢쬣쬤쬥쬦쬧쬨쬩������쬪쬫쬬쬭쬮쬯쬰쬱쬲쬳쬴쬵쬶쬷쬸쬹쬺쬻쬼쬽쬾쬿쭀쭂쭃쭄������쭅쭆쭇쭊쭋쭍쭎쭏쭑쭒쭓쭔쭕쭖쭗쭚쭛쭜쭞쭟쭠쭡쭢쭣쭥쭦쭧쭨쭩쭪쭫쭬㎕㎖㎗ℓ㎘㏄㎣㎤㎥㎦㎙㎚㎛㎜㎝㎞㎟㎠㎡㎢㏊㎍㎎㎏㏏㎈㎉㏈㎧㎨㎰㎱㎲㎳㎴㎵㎶㎷㎸㎹㎀㎁㎂㎃㎄㎺㎻㎼㎽㎾㎿㎐㎑㎒㎓㎔Ω㏀㏁㎊㎋㎌㏖㏅㎭㎮㎯㏛㎩㎪㎫㎬㏝㏐㏓㏃㏉㏜㏆����������������".split(""), e = 0; e != r[167].length; ++e)
        r[167][e].charCodeAt(0) !== 65533 && (c[r[167][e]] = 42752 + e, o[42752 + e] = r[167][e]);
      for (r[168] = "�����������������������������������������������������������������쭭쭮쭯쭰쭱쭲쭳쭴쭵쭶쭷쭺쭻쭼쭽쭾쭿쮀쮁쮂쮃쮄쮅쮆쮇쮈������쮉쮊쮋쮌쮍쮎쮏쮐쮑쮒쮓쮔쮕쮖쮗쮘쮙쮚쮛쮝쮞쮟쮠쮡쮢쮣������쮤쮥쮦쮧쮨쮩쮪쮫쮬쮭쮮쮯쮰쮱쮲쮳쮴쮵쮶쮷쮹쮺쮻쮼쮽쮾쮿쯀쯁쯂쯃쯄ÆÐªĦ�Ĳ�ĿŁØŒºÞŦŊ�㉠㉡㉢㉣㉤㉥㉦㉧㉨㉩㉪㉫㉬㉭㉮㉯㉰㉱㉲㉳㉴㉵㉶㉷㉸㉹㉺㉻ⓐⓑⓒⓓⓔⓕⓖⓗⓘⓙⓚⓛⓜⓝⓞⓟⓠⓡⓢⓣⓤⓥⓦⓧⓨⓩ①②③④⑤⑥⑦⑧⑨⑩⑪⑫⑬⑭⑮½⅓⅔¼¾⅛⅜⅝⅞�".split(""), e = 0; e != r[168].length; ++e)
        r[168][e].charCodeAt(0) !== 65533 && (c[r[168][e]] = 43008 + e, o[43008 + e] = r[168][e]);
      for (r[169] = "�����������������������������������������������������������������쯅쯆쯇쯈쯉쯊쯋쯌쯍쯎쯏쯐쯑쯒쯓쯕쯖쯗쯘쯙쯚쯛쯜쯝쯞쯟������쯠쯡쯢쯣쯥쯦쯨쯪쯫쯬쯭쯮쯯쯰쯱쯲쯳쯴쯵쯶쯷쯸쯹쯺쯻쯼������쯽쯾쯿찀찁찂찃찄찅찆찇찈찉찊찋찎찏찑찒찓찕찖찗찘찙찚찛찞찟찠찣찤æđðħıĳĸŀłøœßþŧŋŉ㈀㈁㈂㈃㈄㈅㈆㈇㈈㈉㈊㈋㈌㈍㈎㈏㈐㈑㈒㈓㈔㈕㈖㈗㈘㈙㈚㈛⒜⒝⒞⒟⒠⒡⒢⒣⒤⒥⒦⒧⒨⒩⒪⒫⒬⒭⒮⒯⒰⒱⒲⒳⒴⒵⑴⑵⑶⑷⑸⑹⑺⑻⑼⑽⑾⑿⒀⒁⒂¹²³⁴ⁿ₁₂₃₄�".split(""), e = 0; e != r[169].length; ++e)
        r[169][e].charCodeAt(0) !== 65533 && (c[r[169][e]] = 43264 + e, o[43264 + e] = r[169][e]);
      for (r[170] = "�����������������������������������������������������������������찥찦찪찫찭찯찱찲찳찴찵찶찷찺찿챀챁챂챃챆챇챉챊챋챍챎������챏챐챑챒챓챖챚챛챜챝챞챟챡챢챣챥챧챩챪챫챬챭챮챯챱챲������챳챴챶챷챸챹챺챻챼챽챾챿첀첁첂첃첄첅첆첇첈첉첊첋첌첍첎첏첐첑첒첓ぁあぃいぅうぇえぉおかがきぎくぐけげこごさざしじすずせぜそぞただちぢっつづてでとどなにぬねのはばぱひびぴふぶぷへべぺほぼぽまみむめもゃやゅゆょよらりるれろゎわゐゑをん������������".split(""), e = 0; e != r[170].length; ++e)
        r[170][e].charCodeAt(0) !== 65533 && (c[r[170][e]] = 43520 + e, o[43520 + e] = r[170][e]);
      for (r[171] = "�����������������������������������������������������������������첔첕첖첗첚첛첝첞첟첡첢첣첤첥첦첧첪첮첯첰첱첲첳첶첷첹������첺첻첽첾첿쳀쳁쳂쳃쳆쳈쳊쳋쳌쳍쳎쳏쳑쳒쳓쳕쳖쳗쳘쳙쳚������쳛쳜쳝쳞쳟쳠쳡쳢쳣쳥쳦쳧쳨쳩쳪쳫쳭쳮쳯쳱쳲쳳쳴쳵쳶쳷쳸쳹쳺쳻쳼쳽ァアィイゥウェエォオカガキギクグケゲコゴサザシジスズセゼソゾタダチヂッツヅテデトドナニヌネノハバパヒビピフブプヘベペホボポマミムメモャヤュユョヨラリルレロヮワヰヱヲンヴヵヶ���������".split(""), e = 0; e != r[171].length; ++e)
        r[171][e].charCodeAt(0) !== 65533 && (c[r[171][e]] = 43776 + e, o[43776 + e] = r[171][e]);
      for (r[172] = "�����������������������������������������������������������������쳾쳿촀촂촃촄촅촆촇촊촋촍촎촏촑촒촓촔촕촖촗촚촜촞촟촠������촡촢촣촥촦촧촩촪촫촭촮촯촰촱촲촳촴촵촶촷촸촺촻촼촽촾������촿쵀쵁쵂쵃쵄쵅쵆쵇쵈쵉쵊쵋쵌쵍쵎쵏쵐쵑쵒쵓쵔쵕쵖쵗쵘쵙쵚쵛쵝쵞쵟АБВГДЕЁЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯ���������������абвгдеёжзийклмнопрстуфхцчшщъыьэюя��������������".split(""), e = 0; e != r[172].length; ++e)
        r[172][e].charCodeAt(0) !== 65533 && (c[r[172][e]] = 44032 + e, o[44032 + e] = r[172][e]);
      for (r[173] = "�����������������������������������������������������������������쵡쵢쵣쵥쵦쵧쵨쵩쵪쵫쵮쵰쵲쵳쵴쵵쵶쵷쵹쵺쵻쵼쵽쵾쵿춀������춁춂춃춄춅춆춇춉춊춋춌춍춎춏춐춑춒춓춖춗춙춚춛춝춞춟������춠춡춢춣춦춨춪춫춬춭춮춯춱춲춳춴춵춶춷춸춹춺춻춼춽춾춿췀췁췂췃췅�����������������������������������������������������������������������������������������������".split(""), e = 0; e != r[173].length; ++e)
        r[173][e].charCodeAt(0) !== 65533 && (c[r[173][e]] = 44288 + e, o[44288 + e] = r[173][e]);
      for (r[174] = "�����������������������������������������������������������������췆췇췈췉췊췋췍췎췏췑췒췓췔췕췖췗췘췙췚췛췜췝췞췟췠췡������췢췣췤췥췦췧췩췪췫췭췮췯췱췲췳췴췵췶췷췺췼췾췿츀츁츂������츃츅츆츇츉츊츋츍츎츏츐츑츒츓츕츖츗츘츚츛츜츝츞츟츢츣츥츦츧츩츪츫�����������������������������������������������������������������������������������������������".split(""), e = 0; e != r[174].length; ++e)
        r[174][e].charCodeAt(0) !== 65533 && (c[r[174][e]] = 44544 + e, o[44544 + e] = r[174][e]);
      for (r[175] = "�����������������������������������������������������������������츬츭츮츯츲츴츶츷츸츹츺츻츼츽츾츿칀칁칂칃칄칅칆칇칈칉������칊칋칌칍칎칏칐칑칒칓칔칕칖칗칚칛칝칞칢칣칤칥칦칧칪칬������칮칯칰칱칲칳칶칷칹칺칻칽칾칿캀캁캂캃캆캈캊캋캌캍캎캏캒캓캕캖캗캙�����������������������������������������������������������������������������������������������".split(""), e = 0; e != r[175].length; ++e)
        r[175][e].charCodeAt(0) !== 65533 && (c[r[175][e]] = 44800 + e, o[44800 + e] = r[175][e]);
      for (r[176] = "�����������������������������������������������������������������캚캛캜캝캞캟캢캦캧캨캩캪캫캮캯캰캱캲캳캴캵캶캷캸캹캺������캻캼캽캾캿컀컂컃컄컅컆컇컈컉컊컋컌컍컎컏컐컑컒컓컔컕������컖컗컘컙컚컛컜컝컞컟컠컡컢컣컦컧컩컪컭컮컯컰컱컲컳컶컺컻컼컽컾컿가각간갇갈갉갊감갑값갓갔강갖갗같갚갛개객갠갤갬갭갯갰갱갸갹갼걀걋걍걔걘걜거걱건걷걸걺검겁것겄겅겆겉겊겋게겐겔겜겝겟겠겡겨격겪견겯결겸겹겻겼경곁계곈곌곕곗고곡곤곧골곪곬곯곰곱곳공곶과곽관괄괆�".split(""), e = 0; e != r[176].length; ++e)
        r[176][e].charCodeAt(0) !== 65533 && (c[r[176][e]] = 45056 + e, o[45056 + e] = r[176][e]);
      for (r[177] = "�����������������������������������������������������������������켂켃켅켆켇켉켊켋켌켍켎켏켒켔켖켗켘켙켚켛켝켞켟켡켢켣������켥켦켧켨켩켪켫켮켲켳켴켵켶켷켹켺켻켼켽켾켿콀콁콂콃콄������콅콆콇콈콉콊콋콌콍콎콏콐콑콒콓콖콗콙콚콛콝콞콟콠콡콢콣콦콨콪콫콬괌괍괏광괘괜괠괩괬괭괴괵괸괼굄굅굇굉교굔굘굡굣구국군굳굴굵굶굻굼굽굿궁궂궈궉권궐궜궝궤궷귀귁귄귈귐귑귓규균귤그극근귿글긁금급긋긍긔기긱긴긷길긺김깁깃깅깆깊까깍깎깐깔깖깜깝깟깠깡깥깨깩깬깰깸�".split(""), e = 0; e != r[177].length; ++e)
        r[177][e].charCodeAt(0) !== 65533 && (c[r[177][e]] = 45312 + e, o[45312 + e] = r[177][e]);
      for (r[178] = "�����������������������������������������������������������������콭콮콯콲콳콵콶콷콹콺콻콼콽콾콿쾁쾂쾃쾄쾆쾇쾈쾉쾊쾋쾍������쾎쾏쾐쾑쾒쾓쾔쾕쾖쾗쾘쾙쾚쾛쾜쾝쾞쾟쾠쾢쾣쾤쾥쾦쾧쾩������쾪쾫쾬쾭쾮쾯쾱쾲쾳쾴쾵쾶쾷쾸쾹쾺쾻쾼쾽쾾쾿쿀쿁쿂쿃쿅쿆쿇쿈쿉쿊쿋깹깻깼깽꺄꺅꺌꺼꺽꺾껀껄껌껍껏껐껑께껙껜껨껫껭껴껸껼꼇꼈꼍꼐꼬꼭꼰꼲꼴꼼꼽꼿꽁꽂꽃꽈꽉꽐꽜꽝꽤꽥꽹꾀꾄꾈꾐꾑꾕꾜꾸꾹꾼꿀꿇꿈꿉꿋꿍꿎꿔꿜꿨꿩꿰꿱꿴꿸뀀뀁뀄뀌뀐뀔뀜뀝뀨끄끅끈끊끌끎끓끔끕끗끙�".split(""), e = 0; e != r[178].length; ++e)
        r[178][e].charCodeAt(0) !== 65533 && (c[r[178][e]] = 45568 + e, o[45568 + e] = r[178][e]);
      for (r[179] = "�����������������������������������������������������������������쿌쿍쿎쿏쿐쿑쿒쿓쿔쿕쿖쿗쿘쿙쿚쿛쿜쿝쿞쿟쿢쿣쿥쿦쿧쿩������쿪쿫쿬쿭쿮쿯쿲쿴쿶쿷쿸쿹쿺쿻쿽쿾쿿퀁퀂퀃퀅퀆퀇퀈퀉퀊������퀋퀌퀍퀎퀏퀐퀒퀓퀔퀕퀖퀗퀙퀚퀛퀜퀝퀞퀟퀠퀡퀢퀣퀤퀥퀦퀧퀨퀩퀪퀫퀬끝끼끽낀낄낌낍낏낑나낙낚난낟날낡낢남납낫났낭낮낯낱낳내낵낸낼냄냅냇냈냉냐냑냔냘냠냥너넉넋넌널넒넓넘넙넛넜넝넣네넥넨넬넴넵넷넸넹녀녁년녈념녑녔녕녘녜녠노녹논놀놂놈놉놋농높놓놔놘놜놨뇌뇐뇔뇜뇝�".split(""), e = 0; e != r[179].length; ++e)
        r[179][e].charCodeAt(0) !== 65533 && (c[r[179][e]] = 45824 + e, o[45824 + e] = r[179][e]);
      for (r[180] = "�����������������������������������������������������������������퀮퀯퀰퀱퀲퀳퀶퀷퀹퀺퀻퀽퀾퀿큀큁큂큃큆큈큊큋큌큍큎큏������큑큒큓큕큖큗큙큚큛큜큝큞큟큡큢큣큤큥큦큧큨큩큪큫큮큯������큱큲큳큵큶큷큸큹큺큻큾큿킀킂킃킄킅킆킇킈킉킊킋킌킍킎킏킐킑킒킓킔뇟뇨뇩뇬뇰뇹뇻뇽누눅눈눋눌눔눕눗눙눠눴눼뉘뉜뉠뉨뉩뉴뉵뉼늄늅늉느늑는늘늙늚늠늡늣능늦늪늬늰늴니닉닌닐닒님닙닛닝닢다닥닦단닫달닭닮닯닳담답닷닸당닺닻닿대댁댄댈댐댑댓댔댕댜더덕덖던덛덜덞덟덤덥�".split(""), e = 0; e != r[180].length; ++e)
        r[180][e].charCodeAt(0) !== 65533 && (c[r[180][e]] = 46080 + e, o[46080 + e] = r[180][e]);
      for (r[181] = "�����������������������������������������������������������������킕킖킗킘킙킚킛킜킝킞킟킠킡킢킣킦킧킩킪킫킭킮킯킰킱킲������킳킶킸킺킻킼킽킾킿탂탃탅탆탇탊탋탌탍탎탏탒탖탗탘탙탚������탛탞탟탡탢탣탥탦탧탨탩탪탫탮탲탳탴탵탶탷탹탺탻탼탽탾탿턀턁턂턃턄덧덩덫덮데덱덴델뎀뎁뎃뎄뎅뎌뎐뎔뎠뎡뎨뎬도독돈돋돌돎돐돔돕돗동돛돝돠돤돨돼됐되된될됨됩됫됴두둑둔둘둠둡둣둥둬뒀뒈뒝뒤뒨뒬뒵뒷뒹듀듄듈듐듕드득든듣들듦듬듭듯등듸디딕딘딛딜딤딥딧딨딩딪따딱딴딸�".split(""), e = 0; e != r[181].length; ++e)
        r[181][e].charCodeAt(0) !== 65533 && (c[r[181][e]] = 46336 + e, o[46336 + e] = r[181][e]);
      for (r[182] = "�����������������������������������������������������������������턅턆턇턈턉턊턋턌턎턏턐턑턒턓턔턕턖턗턘턙턚턛턜턝턞턟������턠턡턢턣턤턥턦턧턨턩턪턫턬턭턮턯턲턳턵턶턷턹턻턼턽턾������턿텂텆텇텈텉텊텋텎텏텑텒텓텕텖텗텘텙텚텛텞텠텢텣텤텥텦텧텩텪텫텭땀땁땃땄땅땋때땍땐땔땜땝땟땠땡떠떡떤떨떪떫떰떱떳떴떵떻떼떽뗀뗄뗌뗍뗏뗐뗑뗘뗬또똑똔똘똥똬똴뙈뙤뙨뚜뚝뚠뚤뚫뚬뚱뛔뛰뛴뛸뜀뜁뜅뜨뜩뜬뜯뜰뜸뜹뜻띄띈띌띔띕띠띤띨띰띱띳띵라락란랄람랍랏랐랑랒랖랗�".split(""), e = 0; e != r[182].length; ++e)
        r[182][e].charCodeAt(0) !== 65533 && (c[r[182][e]] = 46592 + e, o[46592 + e] = r[182][e]);
      for (r[183] = "�����������������������������������������������������������������텮텯텰텱텲텳텴텵텶텷텸텹텺텻텽텾텿톀톁톂톃톅톆톇톉톊������톋톌톍톎톏톐톑톒톓톔톕톖톗톘톙톚톛톜톝톞톟톢톣톥톦톧������톩톪톫톬톭톮톯톲톴톶톷톸톹톻톽톾톿퇁퇂퇃퇄퇅퇆퇇퇈퇉퇊퇋퇌퇍퇎퇏래랙랜랠램랩랫랬랭랴략랸럇량러럭런럴럼럽럿렀렁렇레렉렌렐렘렙렛렝려력련렬렴렵렷렸령례롄롑롓로록론롤롬롭롯롱롸롼뢍뢨뢰뢴뢸룀룁룃룅료룐룔룝룟룡루룩룬룰룸룹룻룽뤄뤘뤠뤼뤽륀륄륌륏륑류륙륜률륨륩�".split(""), e = 0; e != r[183].length; ++e)
        r[183][e].charCodeAt(0) !== 65533 && (c[r[183][e]] = 46848 + e, o[46848 + e] = r[183][e]);
      for (r[184] = "�����������������������������������������������������������������퇐퇑퇒퇓퇔퇕퇖퇗퇙퇚퇛퇜퇝퇞퇟퇠퇡퇢퇣퇤퇥퇦퇧퇨퇩퇪������퇫퇬퇭퇮퇯퇰퇱퇲퇳퇵퇶퇷퇹퇺퇻퇼퇽퇾퇿툀툁툂툃툄툅툆������툈툊툋툌툍툎툏툑툒툓툔툕툖툗툘툙툚툛툜툝툞툟툠툡툢툣툤툥툦툧툨툩륫륭르륵른를름릅릇릉릊릍릎리릭린릴림립릿링마막만많맏말맑맒맘맙맛망맞맡맣매맥맨맬맴맵맷맸맹맺먀먁먈먕머먹먼멀멂멈멉멋멍멎멓메멕멘멜멤멥멧멨멩며멱면멸몃몄명몇몌모목몫몬몰몲몸몹못몽뫄뫈뫘뫙뫼�".split(""), e = 0; e != r[184].length; ++e)
        r[184][e].charCodeAt(0) !== 65533 && (c[r[184][e]] = 47104 + e, o[47104 + e] = r[184][e]);
      for (r[185] = "�����������������������������������������������������������������툪툫툮툯툱툲툳툵툶툷툸툹툺툻툾퉀퉂퉃퉄퉅퉆퉇퉉퉊퉋퉌������퉍퉎퉏퉐퉑퉒퉓퉔퉕퉖퉗퉘퉙퉚퉛퉝퉞퉟퉠퉡퉢퉣퉥퉦퉧퉨������퉩퉪퉫퉬퉭퉮퉯퉰퉱퉲퉳퉴퉵퉶퉷퉸퉹퉺퉻퉼퉽퉾퉿튂튃튅튆튇튉튊튋튌묀묄묍묏묑묘묜묠묩묫무묵묶문묻물묽묾뭄뭅뭇뭉뭍뭏뭐뭔뭘뭡뭣뭬뮈뮌뮐뮤뮨뮬뮴뮷므믄믈믐믓미믹민믿밀밂밈밉밋밌밍및밑바박밖밗반받발밝밞밟밤밥밧방밭배백밴밸뱀뱁뱃뱄뱅뱉뱌뱍뱐뱝버벅번벋벌벎범법벗�".split(""), e = 0; e != r[185].length; ++e)
        r[185][e].charCodeAt(0) !== 65533 && (c[r[185][e]] = 47360 + e, o[47360 + e] = r[185][e]);
      for (r[186] = "�����������������������������������������������������������������튍튎튏튒튓튔튖튗튘튙튚튛튝튞튟튡튢튣튥튦튧튨튩튪튫튭������튮튯튰튲튳튴튵튶튷튺튻튽튾틁틃틄틅틆틇틊틌틍틎틏틐틑������틒틓틕틖틗틙틚틛틝틞틟틠틡틢틣틦틧틨틩틪틫틬틭틮틯틲틳틵틶틷틹틺벙벚베벡벤벧벨벰벱벳벴벵벼벽변별볍볏볐병볕볘볜보복볶본볼봄봅봇봉봐봔봤봬뵀뵈뵉뵌뵐뵘뵙뵤뵨부북분붇불붉붊붐붑붓붕붙붚붜붤붰붸뷔뷕뷘뷜뷩뷰뷴뷸븀븃븅브븍븐블븜븝븟비빅빈빌빎빔빕빗빙빚빛빠빡빤�".split(""), e = 0; e != r[186].length; ++e)
        r[186][e].charCodeAt(0) !== 65533 && (c[r[186][e]] = 47616 + e, o[47616 + e] = r[186][e]);
      for (r[187] = "�����������������������������������������������������������������틻틼틽틾틿팂팄팆팇팈팉팊팋팏팑팒팓팕팗팘팙팚팛팞팢팣������팤팦팧팪팫팭팮팯팱팲팳팴팵팶팷팺팾팿퍀퍁퍂퍃퍆퍇퍈퍉������퍊퍋퍌퍍퍎퍏퍐퍑퍒퍓퍔퍕퍖퍗퍘퍙퍚퍛퍜퍝퍞퍟퍠퍡퍢퍣퍤퍥퍦퍧퍨퍩빨빪빰빱빳빴빵빻빼빽뺀뺄뺌뺍뺏뺐뺑뺘뺙뺨뻐뻑뻔뻗뻘뻠뻣뻤뻥뻬뼁뼈뼉뼘뼙뼛뼜뼝뽀뽁뽄뽈뽐뽑뽕뾔뾰뿅뿌뿍뿐뿔뿜뿟뿡쀼쁑쁘쁜쁠쁨쁩삐삑삔삘삠삡삣삥사삭삯산삳살삵삶삼삽삿샀상샅새색샌샐샘샙샛샜생샤�".split(""), e = 0; e != r[187].length; ++e)
        r[187][e].charCodeAt(0) !== 65533 && (c[r[187][e]] = 47872 + e, o[47872 + e] = r[187][e]);
      for (r[188] = "�����������������������������������������������������������������퍪퍫퍬퍭퍮퍯퍰퍱퍲퍳퍴퍵퍶퍷퍸퍹퍺퍻퍾퍿펁펂펃펅펆펇������펈펉펊펋펎펒펓펔펕펖펗펚펛펝펞펟펡펢펣펤펥펦펧펪펬펮������펯펰펱펲펳펵펶펷펹펺펻펽펾펿폀폁폂폃폆폇폊폋폌폍폎폏폑폒폓폔폕폖샥샨샬샴샵샷샹섀섄섈섐섕서석섞섟선섣설섦섧섬섭섯섰성섶세섹센셀셈셉셋셌셍셔셕션셜셤셥셧셨셩셰셴셸솅소속솎손솔솖솜솝솟송솥솨솩솬솰솽쇄쇈쇌쇔쇗쇘쇠쇤쇨쇰쇱쇳쇼쇽숀숄숌숍숏숑수숙순숟술숨숩숫숭�".split(""), e = 0; e != r[188].length; ++e)
        r[188][e].charCodeAt(0) !== 65533 && (c[r[188][e]] = 48128 + e, o[48128 + e] = r[188][e]);
      for (r[189] = "�����������������������������������������������������������������폗폙폚폛폜폝폞폟폠폢폤폥폦폧폨폩폪폫폮폯폱폲폳폵폶폷������폸폹폺폻폾퐀퐂퐃퐄퐅퐆퐇퐉퐊퐋퐌퐍퐎퐏퐐퐑퐒퐓퐔퐕퐖������퐗퐘퐙퐚퐛퐜퐞퐟퐠퐡퐢퐣퐤퐥퐦퐧퐨퐩퐪퐫퐬퐭퐮퐯퐰퐱퐲퐳퐴퐵퐶퐷숯숱숲숴쉈쉐쉑쉔쉘쉠쉥쉬쉭쉰쉴쉼쉽쉿슁슈슉슐슘슛슝스슥슨슬슭슴습슷승시식신싣실싫심십싯싱싶싸싹싻싼쌀쌈쌉쌌쌍쌓쌔쌕쌘쌜쌤쌥쌨쌩썅써썩썬썰썲썸썹썼썽쎄쎈쎌쏀쏘쏙쏜쏟쏠쏢쏨쏩쏭쏴쏵쏸쐈쐐쐤쐬쐰�".split(""), e = 0; e != r[189].length; ++e)
        r[189][e].charCodeAt(0) !== 65533 && (c[r[189][e]] = 48384 + e, o[48384 + e] = r[189][e]);
      for (r[190] = "�����������������������������������������������������������������퐸퐹퐺퐻퐼퐽퐾퐿푁푂푃푅푆푇푈푉푊푋푌푍푎푏푐푑푒푓������푔푕푖푗푘푙푚푛푝푞푟푡푢푣푥푦푧푨푩푪푫푬푮푰푱푲������푳푴푵푶푷푺푻푽푾풁풃풄풅풆풇풊풌풎풏풐풑풒풓풕풖풗풘풙풚풛풜풝쐴쐼쐽쑈쑤쑥쑨쑬쑴쑵쑹쒀쒔쒜쒸쒼쓩쓰쓱쓴쓸쓺쓿씀씁씌씐씔씜씨씩씬씰씸씹씻씽아악안앉않알앍앎앓암압앗았앙앝앞애액앤앨앰앱앳앴앵야약얀얄얇얌얍얏양얕얗얘얜얠얩어억언얹얻얼얽얾엄업없엇었엉엊엌엎�".split(""), e = 0; e != r[190].length; ++e)
        r[190][e].charCodeAt(0) !== 65533 && (c[r[190][e]] = 48640 + e, o[48640 + e] = r[190][e]);
      for (r[191] = "�����������������������������������������������������������������풞풟풠풡풢풣풤풥풦풧풨풪풫풬풭풮풯풰풱풲풳풴풵풶풷풸������풹풺풻풼풽풾풿퓀퓁퓂퓃퓄퓅퓆퓇퓈퓉퓊퓋퓍퓎퓏퓑퓒퓓퓕������퓖퓗퓘퓙퓚퓛퓝퓞퓠퓡퓢퓣퓤퓥퓦퓧퓩퓪퓫퓭퓮퓯퓱퓲퓳퓴퓵퓶퓷퓹퓺퓼에엑엔엘엠엡엣엥여역엮연열엶엷염엽엾엿였영옅옆옇예옌옐옘옙옛옜오옥온올옭옮옰옳옴옵옷옹옻와왁완왈왐왑왓왔왕왜왝왠왬왯왱외왹왼욀욈욉욋욍요욕욘욜욤욥욧용우욱운울욹욺움웁웃웅워웍원월웜웝웠웡웨�".split(""), e = 0; e != r[191].length; ++e)
        r[191][e].charCodeAt(0) !== 65533 && (c[r[191][e]] = 48896 + e, o[48896 + e] = r[191][e]);
      for (r[192] = "�����������������������������������������������������������������퓾퓿픀픁픂픃픅픆픇픉픊픋픍픎픏픐픑픒픓픖픘픙픚픛픜픝������픞픟픠픡픢픣픤픥픦픧픨픩픪픫픬픭픮픯픰픱픲픳픴픵픶픷������픸픹픺픻픾픿핁핂핃핅핆핇핈핉핊핋핎핐핒핓핔핕핖핗핚핛핝핞핟핡핢핣웩웬웰웸웹웽위윅윈윌윔윕윗윙유육윤율윰윱윳융윷으윽은을읊음읍읏응읒읓읔읕읖읗의읜읠읨읫이익인일읽읾잃임입잇있잉잊잎자작잔잖잗잘잚잠잡잣잤장잦재잭잰잴잼잽잿쟀쟁쟈쟉쟌쟎쟐쟘쟝쟤쟨쟬저적전절젊�".split(""), e = 0; e != r[192].length; ++e)
        r[192][e].charCodeAt(0) !== 65533 && (c[r[192][e]] = 49152 + e, o[49152 + e] = r[192][e]);
      for (r[193] = "�����������������������������������������������������������������핤핦핧핪핬핮핯핰핱핲핳핶핷핹핺핻핽핾핿햀햁햂햃햆햊햋������햌햍햎햏햑햒햓햔햕햖햗햘햙햚햛햜햝햞햟햠햡햢햣햤햦햧������햨햩햪햫햬햭햮햯햰햱햲햳햴햵햶햷햸햹햺햻햼햽햾햿헀헁헂헃헄헅헆헇점접젓정젖제젝젠젤젬젭젯젱져젼졀졈졉졌졍졔조족존졸졺좀좁좃종좆좇좋좌좍좔좝좟좡좨좼좽죄죈죌죔죕죗죙죠죡죤죵주죽준줄줅줆줌줍줏중줘줬줴쥐쥑쥔쥘쥠쥡쥣쥬쥰쥴쥼즈즉즌즐즘즙즛증지직진짇질짊짐집짓�".split(""), e = 0; e != r[193].length; ++e)
        r[193][e].charCodeAt(0) !== 65533 && (c[r[193][e]] = 49408 + e, o[49408 + e] = r[193][e]);
      for (r[194] = "�����������������������������������������������������������������헊헋헍헎헏헑헓헔헕헖헗헚헜헞헟헠헡헢헣헦헧헩헪헫헭헮������헯헰헱헲헳헶헸헺헻헼헽헾헿혂혃혅혆혇혉혊혋혌혍혎혏혒������혖혗혘혙혚혛혝혞혟혡혢혣혥혦혧혨혩혪혫혬혮혯혰혱혲혳혴혵혶혷혺혻징짖짙짚짜짝짠짢짤짧짬짭짯짰짱째짹짼쨀쨈쨉쨋쨌쨍쨔쨘쨩쩌쩍쩐쩔쩜쩝쩟쩠쩡쩨쩽쪄쪘쪼쪽쫀쫄쫌쫍쫏쫑쫓쫘쫙쫠쫬쫴쬈쬐쬔쬘쬠쬡쭁쭈쭉쭌쭐쭘쭙쭝쭤쭸쭹쮜쮸쯔쯤쯧쯩찌찍찐찔찜찝찡찢찧차착찬찮찰참찹찻�".split(""), e = 0; e != r[194].length; ++e)
        r[194][e].charCodeAt(0) !== 65533 && (c[r[194][e]] = 49664 + e, o[49664 + e] = r[194][e]);
      for (r[195] = "�����������������������������������������������������������������혽혾혿홁홂홃홄홆홇홊홌홎홏홐홒홓홖홗홙홚홛홝홞홟홠홡������홢홣홤홥홦홨홪홫홬홭홮홯홲홳홵홶홷홸홹홺홻홼홽홾홿횀������횁횂횄횆횇횈횉횊횋횎횏횑횒횓횕횖횗횘횙횚횛횜횞횠횢횣횤횥횦횧횩횪찼창찾채책챈챌챔챕챗챘챙챠챤챦챨챰챵처척천철첨첩첫첬청체첵첸첼쳄쳅쳇쳉쳐쳔쳤쳬쳰촁초촉촌촐촘촙촛총촤촨촬촹최쵠쵤쵬쵭쵯쵱쵸춈추축춘출춤춥춧충춰췄췌췐취췬췰췸췹췻췽츄츈츌츔츙츠측츤츨츰츱츳층�".split(""), e = 0; e != r[195].length; ++e)
        r[195][e].charCodeAt(0) !== 65533 && (c[r[195][e]] = 49920 + e, o[49920 + e] = r[195][e]);
      for (r[196] = "�����������������������������������������������������������������횫횭횮횯횱횲횳횴횵횶횷횸횺횼횽횾횿훀훁훂훃훆훇훉훊훋������훍훎훏훐훒훓훕훖훘훚훛훜훝훞훟훡훢훣훥훦훧훩훪훫훬훭������훮훯훱훲훳훴훶훷훸훹훺훻훾훿휁휂휃휅휆휇휈휉휊휋휌휍휎휏휐휒휓휔치칙친칟칠칡침칩칫칭카칵칸칼캄캅캇캉캐캑캔캘캠캡캣캤캥캬캭컁커컥컨컫컬컴컵컷컸컹케켁켄켈켐켑켓켕켜켠켤켬켭켯켰켱켸코콕콘콜콤콥콧콩콰콱콴콸쾀쾅쾌쾡쾨쾰쿄쿠쿡쿤쿨쿰쿱쿳쿵쿼퀀퀄퀑퀘퀭퀴퀵퀸퀼�".split(""), e = 0; e != r[196].length; ++e)
        r[196][e].charCodeAt(0) !== 65533 && (c[r[196][e]] = 50176 + e, o[50176 + e] = r[196][e]);
      for (r[197] = "�����������������������������������������������������������������휕휖휗휚휛휝휞휟휡휢휣휤휥휦휧휪휬휮휯휰휱휲휳휶휷휹������휺휻휽휾휿흀흁흂흃흅흆흈흊흋흌흍흎흏흒흓흕흚흛흜흝흞������흟흢흤흦흧흨흪흫흭흮흯흱흲흳흵흶흷흸흹흺흻흾흿힀힂힃힄힅힆힇힊힋큄큅큇큉큐큔큘큠크큭큰클큼큽킁키킥킨킬킴킵킷킹타탁탄탈탉탐탑탓탔탕태택탠탤탬탭탯탰탱탸턍터턱턴털턺텀텁텃텄텅테텍텐텔템텝텟텡텨텬텼톄톈토톡톤톨톰톱톳통톺톼퇀퇘퇴퇸툇툉툐투툭툰툴툼툽툿퉁퉈퉜�".split(""), e = 0; e != r[197].length; ++e)
        r[197][e].charCodeAt(0) !== 65533 && (c[r[197][e]] = 50432 + e, o[50432 + e] = r[197][e]);
      for (r[198] = "�����������������������������������������������������������������힍힎힏힑힒힓힔힕힖힗힚힜힞힟힠힡힢힣������������������������������������������������������������������������������퉤튀튁튄튈튐튑튕튜튠튤튬튱트특튼튿틀틂틈틉틋틔틘틜틤틥티틱틴틸팀팁팃팅파팍팎판팔팖팜팝팟팠팡팥패팩팬팰팸팹팻팼팽퍄퍅퍼퍽펀펄펌펍펏펐펑페펙펜펠펨펩펫펭펴편펼폄폅폈평폐폘폡폣포폭폰폴폼폽폿퐁�".split(""), e = 0; e != r[198].length; ++e)
        r[198][e].charCodeAt(0) !== 65533 && (c[r[198][e]] = 50688 + e, o[50688 + e] = r[198][e]);
      for (r[199] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������퐈퐝푀푄표푠푤푭푯푸푹푼푿풀풂품풉풋풍풔풩퓌퓐퓔퓜퓟퓨퓬퓰퓸퓻퓽프픈플픔픕픗피픽핀필핌핍핏핑하학한할핥함합핫항해핵핸핼햄햅햇했행햐향허헉헌헐헒험헙헛헝헤헥헨헬헴헵헷헹혀혁현혈혐협혓혔형혜혠�".split(""), e = 0; e != r[199].length; ++e)
        r[199][e].charCodeAt(0) !== 65533 && (c[r[199][e]] = 50944 + e, o[50944 + e] = r[199][e]);
      for (r[200] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������혤혭호혹혼홀홅홈홉홋홍홑화확환활홧황홰홱홴횃횅회획횐횔횝횟횡효횬횰횹횻후훅훈훌훑훔훗훙훠훤훨훰훵훼훽휀휄휑휘휙휜휠휨휩휫휭휴휵휸휼흄흇흉흐흑흔흖흗흘흙흠흡흣흥흩희흰흴흼흽힁히힉힌힐힘힙힛힝�".split(""), e = 0; e != r[200].length; ++e)
        r[200][e].charCodeAt(0) !== 65533 && (c[r[200][e]] = 51200 + e, o[51200 + e] = r[200][e]);
      for (r[202] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������伽佳假價加可呵哥嘉嫁家暇架枷柯歌珂痂稼苛茄街袈訶賈跏軻迦駕刻却各恪慤殼珏脚覺角閣侃刊墾奸姦干幹懇揀杆柬桿澗癎看磵稈竿簡肝艮艱諫間乫喝曷渴碣竭葛褐蝎鞨勘坎堪嵌感憾戡敢柑橄減甘疳監瞰紺邯鑑鑒龕�".split(""), e = 0; e != r[202].length; ++e)
        r[202][e].charCodeAt(0) !== 65533 && (c[r[202][e]] = 51712 + e, o[51712 + e] = r[202][e]);
      for (r[203] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������匣岬甲胛鉀閘剛堈姜岡崗康强彊慷江畺疆糠絳綱羌腔舡薑襁講鋼降鱇介价個凱塏愷愾慨改槪漑疥皆盖箇芥蓋豈鎧開喀客坑更粳羹醵倨去居巨拒据據擧渠炬祛距踞車遽鉅鋸乾件健巾建愆楗腱虔蹇鍵騫乞傑杰桀儉劍劒檢�".split(""), e = 0; e != r[203].length; ++e)
        r[203][e].charCodeAt(0) !== 65533 && (c[r[203][e]] = 51968 + e, o[51968 + e] = r[203][e]);
      for (r[204] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������瞼鈐黔劫怯迲偈憩揭擊格檄激膈覡隔堅牽犬甄絹繭肩見譴遣鵑抉決潔結缺訣兼慊箝謙鉗鎌京俓倞傾儆勁勍卿坰境庚徑慶憬擎敬景暻更梗涇炅烱璟璥瓊痙硬磬竟競絅經耕耿脛莖警輕逕鏡頃頸驚鯨係啓堺契季屆悸戒桂械�".split(""), e = 0; e != r[204].length; ++e)
        r[204][e].charCodeAt(0) !== 65533 && (c[r[204][e]] = 52224 + e, o[52224 + e] = r[204][e]);
      for (r[205] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������棨溪界癸磎稽系繫繼計誡谿階鷄古叩告呱固姑孤尻庫拷攷故敲暠枯槁沽痼皐睾稿羔考股膏苦苽菰藁蠱袴誥賈辜錮雇顧高鼓哭斛曲梏穀谷鵠困坤崑昆梱棍滾琨袞鯤汨滑骨供公共功孔工恐恭拱控攻珙空蚣貢鞏串寡戈果瓜�".split(""), e = 0; e != r[205].length; ++e)
        r[205][e].charCodeAt(0) !== 65533 && (c[r[205][e]] = 52480 + e, o[52480 + e] = r[205][e]);
      for (r[206] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������科菓誇課跨過鍋顆廓槨藿郭串冠官寬慣棺款灌琯瓘管罐菅觀貫關館刮恝括适侊光匡壙廣曠洸炚狂珖筐胱鑛卦掛罫乖傀塊壞怪愧拐槐魁宏紘肱轟交僑咬喬嬌嶠巧攪敎校橋狡皎矯絞翹膠蕎蛟較轎郊餃驕鮫丘久九仇俱具勾�".split(""), e = 0; e != r[206].length; ++e)
        r[206][e].charCodeAt(0) !== 65533 && (c[r[206][e]] = 52736 + e, o[52736 + e] = r[206][e]);
      for (r[207] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������區口句咎嘔坵垢寇嶇廐懼拘救枸柩構歐毆毬求溝灸狗玖球瞿矩究絿耉臼舅舊苟衢謳購軀逑邱鉤銶駒驅鳩鷗龜國局菊鞠鞫麴君窘群裙軍郡堀屈掘窟宮弓穹窮芎躬倦券勸卷圈拳捲權淃眷厥獗蕨蹶闕机櫃潰詭軌饋句晷歸貴�".split(""), e = 0; e != r[207].length; ++e)
        r[207][e].charCodeAt(0) !== 65533 && (c[r[207][e]] = 52992 + e, o[52992 + e] = r[207][e]);
      for (r[208] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������鬼龜叫圭奎揆槻珪硅窺竅糾葵規赳逵閨勻均畇筠菌鈞龜橘克剋劇戟棘極隙僅劤勤懃斤根槿瑾筋芹菫覲謹近饉契今妗擒昑檎琴禁禽芩衾衿襟金錦伋及急扱汲級給亘兢矜肯企伎其冀嗜器圻基埼夔奇妓寄岐崎己幾忌技旗旣�".split(""), e = 0; e != r[208].length; ++e)
        r[208][e].charCodeAt(0) !== 65533 && (c[r[208][e]] = 53248 + e, o[53248 + e] = r[208][e]);
      for (r[209] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������朞期杞棋棄機欺氣汽沂淇玘琦琪璂璣畸畿碁磯祁祇祈祺箕紀綺羈耆耭肌記譏豈起錡錤飢饑騎騏驥麒緊佶吉拮桔金喫儺喇奈娜懦懶拏拿癩羅蘿螺裸邏那樂洛烙珞落諾酪駱亂卵暖欄煖爛蘭難鸞捏捺南嵐枏楠湳濫男藍襤拉�".split(""), e = 0; e != r[209].length; ++e)
        r[209][e].charCodeAt(0) !== 65533 && (c[r[209][e]] = 53504 + e, o[53504 + e] = r[209][e]);
      for (r[210] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������納臘蠟衲囊娘廊朗浪狼郎乃來內奈柰耐冷女年撚秊念恬拈捻寧寗努勞奴弩怒擄櫓爐瑙盧老蘆虜路露駑魯鷺碌祿綠菉錄鹿論壟弄濃籠聾膿農惱牢磊腦賂雷尿壘屢樓淚漏累縷陋嫩訥杻紐勒肋凜凌稜綾能菱陵尼泥匿溺多茶�".split(""), e = 0; e != r[210].length; ++e)
        r[210][e].charCodeAt(0) !== 65533 && (c[r[210][e]] = 53760 + e, o[53760 + e] = r[210][e]);
      for (r[211] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������丹亶但單團壇彖斷旦檀段湍短端簞緞蛋袒鄲鍛撻澾獺疸達啖坍憺擔曇淡湛潭澹痰聃膽蕁覃談譚錟沓畓答踏遝唐堂塘幢戇撞棠當糖螳黨代垈坮大對岱帶待戴擡玳臺袋貸隊黛宅德悳倒刀到圖堵塗導屠島嶋度徒悼挑掉搗桃�".split(""), e = 0; e != r[211].length; ++e)
        r[211][e].charCodeAt(0) !== 65533 && (c[r[211][e]] = 54016 + e, o[54016 + e] = r[211][e]);
      for (r[212] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������棹櫂淘渡滔濤燾盜睹禱稻萄覩賭跳蹈逃途道都鍍陶韜毒瀆牘犢獨督禿篤纛讀墩惇敦旽暾沌焞燉豚頓乭突仝冬凍動同憧東桐棟洞潼疼瞳童胴董銅兜斗杜枓痘竇荳讀豆逗頭屯臀芚遁遯鈍得嶝橙燈登等藤謄鄧騰喇懶拏癩羅�".split(""), e = 0; e != r[212].length; ++e)
        r[212][e].charCodeAt(0) !== 65533 && (c[r[212][e]] = 54272 + e, o[54272 + e] = r[212][e]);
      for (r[213] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������蘿螺裸邏樂洛烙珞絡落諾酪駱丹亂卵欄欒瀾爛蘭鸞剌辣嵐擥攬欖濫籃纜藍襤覽拉臘蠟廊朗浪狼琅瑯螂郞來崍徠萊冷掠略亮倆兩凉梁樑粮粱糧良諒輛量侶儷勵呂廬慮戾旅櫚濾礪藜蠣閭驢驪麗黎力曆歷瀝礫轢靂憐戀攣漣�".split(""), e = 0; e != r[213].length; ++e)
        r[213][e].charCodeAt(0) !== 65533 && (c[r[213][e]] = 54528 + e, o[54528 + e] = r[213][e]);
      for (r[214] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������煉璉練聯蓮輦連鍊冽列劣洌烈裂廉斂殮濂簾獵令伶囹寧岺嶺怜玲笭羚翎聆逞鈴零靈領齡例澧禮醴隷勞怒撈擄櫓潞瀘爐盧老蘆虜路輅露魯鷺鹵碌祿綠菉錄鹿麓論壟弄朧瀧瓏籠聾儡瀨牢磊賂賚賴雷了僚寮廖料燎療瞭聊蓼�".split(""), e = 0; e != r[214].length; ++e)
        r[214][e].charCodeAt(0) !== 65533 && (c[r[214][e]] = 54784 + e, o[54784 + e] = r[214][e]);
      for (r[215] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������遼鬧龍壘婁屢樓淚漏瘻累縷蔞褸鏤陋劉旒柳榴流溜瀏琉瑠留瘤硫謬類六戮陸侖倫崙淪綸輪律慄栗率隆勒肋凜凌楞稜綾菱陵俚利厘吏唎履悧李梨浬犁狸理璃異痢籬罹羸莉裏裡里釐離鯉吝潾燐璘藺躪隣鱗麟林淋琳臨霖砬�".split(""), e = 0; e != r[215].length; ++e)
        r[215][e].charCodeAt(0) !== 65533 && (c[r[215][e]] = 55040 + e, o[55040 + e] = r[215][e]);
      for (r[216] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������立笠粒摩瑪痲碼磨馬魔麻寞幕漠膜莫邈万卍娩巒彎慢挽晩曼滿漫灣瞞萬蔓蠻輓饅鰻唜抹末沫茉襪靺亡妄忘忙望網罔芒茫莽輞邙埋妹媒寐昧枚梅每煤罵買賣邁魅脈貊陌驀麥孟氓猛盲盟萌冪覓免冕勉棉沔眄眠綿緬面麵滅�".split(""), e = 0; e != r[216].length; ++e)
        r[216][e].charCodeAt(0) !== 65533 && (c[r[216][e]] = 55296 + e, o[55296 + e] = r[216][e]);
      for (r[217] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������蔑冥名命明暝椧溟皿瞑茗蓂螟酩銘鳴袂侮冒募姆帽慕摸摹暮某模母毛牟牡瑁眸矛耗芼茅謀謨貌木沐牧目睦穆鶩歿沒夢朦蒙卯墓妙廟描昴杳渺猫竗苗錨務巫憮懋戊拇撫无楙武毋無珷畝繆舞茂蕪誣貿霧鵡墨默們刎吻問文�".split(""), e = 0; e != r[217].length; ++e)
        r[217][e].charCodeAt(0) !== 65533 && (c[r[217][e]] = 55552 + e, o[55552 + e] = r[217][e]);
      for (r[218] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������汶紊紋聞蚊門雯勿沕物味媚尾嵋彌微未梶楣渼湄眉米美薇謎迷靡黴岷悶愍憫敏旻旼民泯玟珉緡閔密蜜謐剝博拍搏撲朴樸泊珀璞箔粕縛膊舶薄迫雹駁伴半反叛拌搬攀斑槃泮潘班畔瘢盤盼磐磻礬絆般蟠返頒飯勃拔撥渤潑�".split(""), e = 0; e != r[218].length; ++e)
        r[218][e].charCodeAt(0) !== 65533 && (c[r[218][e]] = 55808 + e, o[55808 + e] = r[218][e]);
      for (r[219] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������發跋醱鉢髮魃倣傍坊妨尨幇彷房放方旁昉枋榜滂磅紡肪膀舫芳蒡蚌訪謗邦防龐倍俳北培徘拜排杯湃焙盃背胚裴裵褙賠輩配陪伯佰帛柏栢白百魄幡樊煩燔番磻繁蕃藩飜伐筏罰閥凡帆梵氾汎泛犯範范法琺僻劈壁擘檗璧癖�".split(""), e = 0; e != r[219].length; ++e)
        r[219][e].charCodeAt(0) !== 65533 && (c[r[219][e]] = 56064 + e, o[56064 + e] = r[219][e]);
      for (r[220] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������碧蘗闢霹便卞弁變辨辯邊別瞥鱉鼈丙倂兵屛幷昞昺柄棅炳甁病秉竝輧餠騈保堡報寶普步洑湺潽珤甫菩補褓譜輔伏僕匐卜宓復服福腹茯蔔複覆輹輻馥鰒本乶俸奉封峯峰捧棒烽熢琫縫蓬蜂逢鋒鳳不付俯傅剖副否咐埠夫婦�".split(""), e = 0; e != r[220].length; ++e)
        r[220][e].charCodeAt(0) !== 65533 && (c[r[220][e]] = 56320 + e, o[56320 + e] = r[220][e]);
      for (r[221] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������孚孵富府復扶敷斧浮溥父符簿缶腐腑膚艀芙莩訃負賦賻赴趺部釜阜附駙鳧北分吩噴墳奔奮忿憤扮昐汾焚盆粉糞紛芬賁雰不佛弗彿拂崩朋棚硼繃鵬丕備匕匪卑妃婢庇悲憊扉批斐枇榧比毖毗毘沸泌琵痺砒碑秕秘粃緋翡肥�".split(""), e = 0; e != r[221].length; ++e)
        r[221][e].charCodeAt(0) !== 65533 && (c[r[221][e]] = 56576 + e, o[56576 + e] = r[221][e]);
      for (r[222] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������脾臂菲蜚裨誹譬費鄙非飛鼻嚬嬪彬斌檳殯浜濱瀕牝玭貧賓頻憑氷聘騁乍事些仕伺似使俟僿史司唆嗣四士奢娑寫寺射巳師徙思捨斜斯柶査梭死沙泗渣瀉獅砂社祀祠私篩紗絲肆舍莎蓑蛇裟詐詞謝賜赦辭邪飼駟麝削數朔索�".split(""), e = 0; e != r[222].length; ++e)
        r[222][e].charCodeAt(0) !== 65533 && (c[r[222][e]] = 56832 + e, o[56832 + e] = r[222][e]);
      for (r[223] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������傘刪山散汕珊産疝算蒜酸霰乷撒殺煞薩三參杉森渗芟蔘衫揷澁鈒颯上傷像償商喪嘗孀尙峠常床庠廂想桑橡湘爽牀狀相祥箱翔裳觴詳象賞霜塞璽賽嗇塞穡索色牲生甥省笙墅壻嶼序庶徐恕抒捿敍暑曙書栖棲犀瑞筮絮緖署�".split(""), e = 0; e != r[223].length; ++e)
        r[223][e].charCodeAt(0) !== 65533 && (c[r[223][e]] = 57088 + e, o[57088 + e] = r[223][e]);
      for (r[224] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������胥舒薯西誓逝鋤黍鼠夕奭席惜昔晳析汐淅潟石碩蓆釋錫仙僊先善嬋宣扇敾旋渲煽琁瑄璇璿癬禪線繕羨腺膳船蘚蟬詵跣選銑鐥饍鮮卨屑楔泄洩渫舌薛褻設說雪齧剡暹殲纖蟾贍閃陝攝涉燮葉城姓宬性惺成星晟猩珹盛省筬�".split(""), e = 0; e != r[224].length; ++e)
        r[224][e].charCodeAt(0) !== 65533 && (c[r[224][e]] = 57344 + e, o[57344 + e] = r[224][e]);
      for (r[225] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������聖聲腥誠醒世勢歲洗稅笹細說貰召嘯塑宵小少巢所掃搔昭梳沼消溯瀟炤燒甦疏疎瘙笑篠簫素紹蔬蕭蘇訴逍遡邵銷韶騷俗屬束涑粟續謖贖速孫巽損蓀遜飡率宋悚松淞訟誦送頌刷殺灑碎鎖衰釗修受嗽囚垂壽嫂守岫峀帥愁�".split(""), e = 0; e != r[225].length; ++e)
        r[225][e].charCodeAt(0) !== 65533 && (c[r[225][e]] = 57600 + e, o[57600 + e] = r[225][e]);
      for (r[226] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������戍手授搜收數樹殊水洙漱燧狩獸琇璲瘦睡秀穗竪粹綏綬繡羞脩茱蒐蓚藪袖誰讐輸遂邃酬銖銹隋隧隨雖需須首髓鬚叔塾夙孰宿淑潚熟琡璹肅菽巡徇循恂旬栒楯橓殉洵淳珣盾瞬筍純脣舜荀蓴蕣詢諄醇錞順馴戌術述鉥崇崧�".split(""), e = 0; e != r[226].length; ++e)
        r[226][e].charCodeAt(0) !== 65533 && (c[r[226][e]] = 57856 + e, o[57856 + e] = r[226][e]);
      for (r[227] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������嵩瑟膝蝨濕拾習褶襲丞乘僧勝升承昇繩蠅陞侍匙嘶始媤尸屎屍市弑恃施是時枾柴猜矢示翅蒔蓍視試詩諡豕豺埴寔式息拭植殖湜熄篒蝕識軾食飾伸侁信呻娠宸愼新晨燼申神紳腎臣莘薪藎蜃訊身辛辰迅失室實悉審尋心沁�".split(""), e = 0; e != r[227].length; ++e)
        r[227][e].charCodeAt(0) !== 65533 && (c[r[227][e]] = 58112 + e, o[58112 + e] = r[227][e]);
      for (r[228] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������沈深瀋甚芯諶什十拾雙氏亞俄兒啞娥峨我牙芽莪蛾衙訝阿雅餓鴉鵝堊岳嶽幄惡愕握樂渥鄂鍔顎鰐齷安岸按晏案眼雁鞍顔鮟斡謁軋閼唵岩巖庵暗癌菴闇壓押狎鴨仰央怏昻殃秧鴦厓哀埃崖愛曖涯碍艾隘靄厄扼掖液縊腋額�".split(""), e = 0; e != r[228].length; ++e)
        r[228][e].charCodeAt(0) !== 65533 && (c[r[228][e]] = 58368 + e, o[58368 + e] = r[228][e]);
      for (r[229] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������櫻罌鶯鸚也倻冶夜惹揶椰爺耶若野弱掠略約若葯蒻藥躍亮佯兩凉壤孃恙揚攘敭暘梁楊樣洋瀁煬痒瘍禳穰糧羊良襄諒讓釀陽量養圄御於漁瘀禦語馭魚齬億憶抑檍臆偃堰彦焉言諺孼蘖俺儼嚴奄掩淹嶪業円予余勵呂女如廬�".split(""), e = 0; e != r[229].length; ++e)
        r[229][e].charCodeAt(0) !== 65533 && (c[r[229][e]] = 58624 + e, o[58624 + e] = r[229][e]);
      for (r[230] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������旅歟汝濾璵礖礪與艅茹輿轝閭餘驪麗黎亦力域役易曆歷疫繹譯轢逆驛嚥堧姸娟宴年延憐戀捐挻撚椽沇沿涎涓淵演漣烟然煙煉燃燕璉硏硯秊筵緣練縯聯衍軟輦蓮連鉛鍊鳶列劣咽悅涅烈熱裂說閱厭廉念捻染殮炎焰琰艶苒�".split(""), e = 0; e != r[230].length; ++e)
        r[230][e].charCodeAt(0) !== 65533 && (c[r[230][e]] = 58880 + e, o[58880 + e] = r[230][e]);
      for (r[231] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������簾閻髥鹽曄獵燁葉令囹塋寧嶺嶸影怜映暎楹榮永泳渶潁濚瀛瀯煐營獰玲瑛瑩瓔盈穎纓羚聆英詠迎鈴鍈零霙靈領乂倪例刈叡曳汭濊猊睿穢芮藝蘂禮裔詣譽豫醴銳隸霓預五伍俉傲午吾吳嗚塢墺奧娛寤悟惡懊敖旿晤梧汚澳�".split(""), e = 0; e != r[231].length; ++e)
        r[231][e].charCodeAt(0) !== 65533 && (c[r[231][e]] = 59136 + e, o[59136 + e] = r[231][e]);
      for (r[232] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������烏熬獒筽蜈誤鰲鼇屋沃獄玉鈺溫瑥瘟穩縕蘊兀壅擁瓮甕癰翁邕雍饔渦瓦窩窪臥蛙蝸訛婉完宛梡椀浣玩琓琬碗緩翫脘腕莞豌阮頑曰往旺枉汪王倭娃歪矮外嵬巍猥畏了僚僥凹堯夭妖姚寥寮尿嶢拗搖撓擾料曜樂橈燎燿瑤療�".split(""), e = 0; e != r[232].length; ++e)
        r[232][e].charCodeAt(0) !== 65533 && (c[r[232][e]] = 59392 + e, o[59392 + e] = r[232][e]);
      for (r[233] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������窈窯繇繞耀腰蓼蟯要謠遙遼邀饒慾欲浴縟褥辱俑傭冗勇埇墉容庸慂榕涌湧溶熔瑢用甬聳茸蓉踊鎔鏞龍于佑偶優又友右宇寓尤愚憂旴牛玗瑀盂祐禑禹紆羽芋藕虞迂遇郵釪隅雨雩勖彧旭昱栯煜稶郁頊云暈橒殞澐熉耘芸蕓�".split(""), e = 0; e != r[233].length; ++e)
        r[233][e].charCodeAt(0) !== 65533 && (c[r[233][e]] = 59648 + e, o[59648 + e] = r[233][e]);
      for (r[234] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������運隕雲韻蔚鬱亐熊雄元原員圓園垣媛嫄寃怨愿援沅洹湲源爰猿瑗苑袁轅遠阮院願鴛月越鉞位偉僞危圍委威尉慰暐渭爲瑋緯胃萎葦蔿蝟衛褘謂違韋魏乳侑儒兪劉唯喩孺宥幼幽庾悠惟愈愉揄攸有杻柔柚柳楡楢油洧流游溜�".split(""), e = 0; e != r[234].length; ++e)
        r[234][e].charCodeAt(0) !== 65533 && (c[r[234][e]] = 59904 + e, o[59904 + e] = r[234][e]);
      for (r[235] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������濡猶猷琉瑜由留癒硫紐維臾萸裕誘諛諭踰蹂遊逾遺酉釉鍮類六堉戮毓肉育陸倫允奫尹崙淪潤玧胤贇輪鈗閏律慄栗率聿戎瀜絨融隆垠恩慇殷誾銀隱乙吟淫蔭陰音飮揖泣邑凝應膺鷹依倚儀宜意懿擬椅毅疑矣義艤薏蟻衣誼�".split(""), e = 0; e != r[235].length; ++e)
        r[235][e].charCodeAt(0) !== 65533 && (c[r[235][e]] = 60160 + e, o[60160 + e] = r[235][e]);
      for (r[236] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������議醫二以伊利吏夷姨履已弛彛怡易李梨泥爾珥理異痍痢移罹而耳肄苡荑裏裡貽貳邇里離飴餌匿溺瀷益翊翌翼謚人仁刃印吝咽因姻寅引忍湮燐璘絪茵藺蚓認隣靭靷鱗麟一佚佾壹日溢逸鎰馹任壬妊姙恁林淋稔臨荏賃入卄�".split(""), e = 0; e != r[236].length; ++e)
        r[236][e].charCodeAt(0) !== 65533 && (c[r[236][e]] = 60416 + e, o[60416 + e] = r[236][e]);
      for (r[237] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������立笠粒仍剩孕芿仔刺咨姉姿子字孜恣慈滋炙煮玆瓷疵磁紫者自茨蔗藉諮資雌作勺嚼斫昨灼炸爵綽芍酌雀鵲孱棧殘潺盞岑暫潛箴簪蠶雜丈仗匠場墻壯奬將帳庄張掌暲杖樟檣欌漿牆狀獐璋章粧腸臟臧莊葬蔣薔藏裝贓醬長�".split(""), e = 0; e != r[237].length; ++e)
        r[237][e].charCodeAt(0) !== 65533 && (c[r[237][e]] = 60672 + e, o[60672 + e] = r[237][e]);
      for (r[238] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������障再哉在宰才材栽梓渽滓災縡裁財載齋齎爭箏諍錚佇低儲咀姐底抵杵楮樗沮渚狙猪疽箸紵苧菹著藷詛貯躇這邸雎齟勣吊嫡寂摘敵滴狄炙的積笛籍績翟荻謫賊赤跡蹟迪迹適鏑佃佺傳全典前剪塡塼奠專展廛悛戰栓殿氈澱�".split(""), e = 0; e != r[238].length; ++e)
        r[238][e].charCodeAt(0) !== 65533 && (c[r[238][e]] = 60928 + e, o[60928 + e] = r[238][e]);
      for (r[239] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������煎琠田甸畑癲筌箋箭篆纏詮輾轉鈿銓錢鐫電顚顫餞切截折浙癤竊節絶占岾店漸点粘霑鮎點接摺蝶丁井亭停偵呈姃定幀庭廷征情挺政整旌晶晸柾楨檉正汀淀淨渟湞瀞炡玎珽町睛碇禎程穽精綎艇訂諪貞鄭酊釘鉦鋌錠霆靖�".split(""), e = 0; e != r[239].length; ++e)
        r[239][e].charCodeAt(0) !== 65533 && (c[r[239][e]] = 61184 + e, o[61184 + e] = r[239][e]);
      for (r[240] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������靜頂鼎制劑啼堤帝弟悌提梯濟祭第臍薺製諸蹄醍除際霽題齊俎兆凋助嘲弔彫措操早晁曺曹朝條棗槽漕潮照燥爪璪眺祖祚租稠窕粗糟組繰肇藻蚤詔調趙躁造遭釣阻雕鳥族簇足鏃存尊卒拙猝倧宗從悰慫棕淙琮種終綜縱腫�".split(""), e = 0; e != r[240].length; ++e)
        r[240][e].charCodeAt(0) !== 65533 && (c[r[240][e]] = 61440 + e, o[61440 + e] = r[240][e]);
      for (r[241] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������踪踵鍾鐘佐坐左座挫罪主住侏做姝胄呪周嗾奏宙州廚晝朱柱株注洲湊澍炷珠疇籌紂紬綢舟蛛註誅走躊輳週酎酒鑄駐竹粥俊儁准埈寯峻晙樽浚準濬焌畯竣蠢逡遵雋駿茁中仲衆重卽櫛楫汁葺增憎曾拯烝甑症繒蒸證贈之只�".split(""), e = 0; e != r[241].length; ++e)
        r[241][e].charCodeAt(0) !== 65533 && (c[r[241][e]] = 61696 + e, o[61696 + e] = r[241][e]);
      for (r[242] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������咫地址志持指摯支旨智枝枳止池沚漬知砥祉祗紙肢脂至芝芷蜘誌識贄趾遲直稙稷織職唇嗔塵振搢晉晋桭榛殄津溱珍瑨璡畛疹盡眞瞋秦縉縝臻蔯袗診賑軫辰進鎭陣陳震侄叱姪嫉帙桎瓆疾秩窒膣蛭質跌迭斟朕什執潗緝輯�".split(""), e = 0; e != r[242].length; ++e)
        r[242][e].charCodeAt(0) !== 65533 && (c[r[242][e]] = 61952 + e, o[61952 + e] = r[242][e]);
      for (r[243] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������鏶集徵懲澄且侘借叉嗟嵯差次此磋箚茶蹉車遮捉搾着窄錯鑿齪撰澯燦璨瓚竄簒纂粲纘讚贊鑽餐饌刹察擦札紮僭參塹慘慙懺斬站讒讖倉倡創唱娼廠彰愴敞昌昶暢槍滄漲猖瘡窓脹艙菖蒼債埰寀寨彩採砦綵菜蔡采釵冊柵策�".split(""), e = 0; e != r[243].length; ++e)
        r[243][e].charCodeAt(0) !== 65533 && (c[r[243][e]] = 62208 + e, o[62208 + e] = r[243][e]);
      for (r[244] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������責凄妻悽處倜刺剔尺慽戚拓擲斥滌瘠脊蹠陟隻仟千喘天川擅泉淺玔穿舛薦賤踐遷釧闡阡韆凸哲喆徹撤澈綴輟轍鐵僉尖沾添甛瞻簽籤詹諂堞妾帖捷牒疊睫諜貼輒廳晴淸聽菁請靑鯖切剃替涕滯締諦逮遞體初剿哨憔抄招梢�".split(""), e = 0; e != r[244].length; ++e)
        r[244][e].charCodeAt(0) !== 65533 && (c[r[244][e]] = 62464 + e, o[62464 + e] = r[244][e]);
      for (r[245] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������椒楚樵炒焦硝礁礎秒稍肖艸苕草蕉貂超酢醋醮促囑燭矗蜀觸寸忖村邨叢塚寵悤憁摠總聰蔥銃撮催崔最墜抽推椎楸樞湫皺秋芻萩諏趨追鄒酋醜錐錘鎚雛騶鰍丑畜祝竺筑築縮蓄蹙蹴軸逐春椿瑃出朮黜充忠沖蟲衝衷悴膵萃�".split(""), e = 0; e != r[245].length; ++e)
        r[245][e].charCodeAt(0) !== 65533 && (c[r[245][e]] = 62720 + e, o[62720 + e] = r[245][e]);
      for (r[246] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������贅取吹嘴娶就炊翠聚脆臭趣醉驟鷲側仄厠惻測層侈値嗤峙幟恥梔治淄熾痔痴癡稚穉緇緻置致蚩輜雉馳齒則勅飭親七柒漆侵寢枕沈浸琛砧針鍼蟄秤稱快他咤唾墮妥惰打拖朶楕舵陀馱駝倬卓啄坼度托拓擢晫柝濁濯琢琸託�".split(""), e = 0; e != r[246].length; ++e)
        r[246][e].charCodeAt(0) !== 65533 && (c[r[246][e]] = 62976 + e, o[62976 + e] = r[246][e]);
      for (r[247] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������鐸呑嘆坦彈憚歎灘炭綻誕奪脫探眈耽貪塔搭榻宕帑湯糖蕩兌台太怠態殆汰泰笞胎苔跆邰颱宅擇澤撑攄兎吐土討慟桶洞痛筒統通堆槌腿褪退頹偸套妬投透鬪慝特闖坡婆巴把播擺杷波派爬琶破罷芭跛頗判坂板版瓣販辦鈑�".split(""), e = 0; e != r[247].length; ++e)
        r[247][e].charCodeAt(0) !== 65533 && (c[r[247][e]] = 63232 + e, o[63232 + e] = r[247][e]);
      for (r[248] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������阪八叭捌佩唄悖敗沛浿牌狽稗覇貝彭澎烹膨愎便偏扁片篇編翩遍鞭騙貶坪平枰萍評吠嬖幣廢弊斃肺蔽閉陛佈包匍匏咆哺圃布怖抛抱捕暴泡浦疱砲胞脯苞葡蒲袍褒逋鋪飽鮑幅暴曝瀑爆輻俵剽彪慓杓標漂瓢票表豹飇飄驃�".split(""), e = 0; e != r[248].length; ++e)
        r[248][e].charCodeAt(0) !== 65533 && (c[r[248][e]] = 63488 + e, o[63488 + e] = r[248][e]);
      for (r[249] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������品稟楓諷豊風馮彼披疲皮被避陂匹弼必泌珌畢疋筆苾馝乏逼下何厦夏廈昰河瑕荷蝦賀遐霞鰕壑學虐謔鶴寒恨悍旱汗漢澣瀚罕翰閑閒限韓割轄函含咸啣喊檻涵緘艦銜陷鹹合哈盒蛤閤闔陜亢伉姮嫦巷恒抗杭桁沆港缸肛航�".split(""), e = 0; e != r[249].length; ++e)
        r[249][e].charCodeAt(0) !== 65533 && (c[r[249][e]] = 63744 + e, o[63744 + e] = r[249][e]);
      for (r[250] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������行降項亥偕咳垓奚孩害懈楷海瀣蟹解該諧邂駭骸劾核倖幸杏荇行享向嚮珦鄕響餉饗香噓墟虛許憲櫶獻軒歇險驗奕爀赫革俔峴弦懸晛泫炫玄玹現眩睍絃絢縣舷衒見賢鉉顯孑穴血頁嫌俠協夾峽挾浹狹脅脇莢鋏頰亨兄刑型�".split(""), e = 0; e != r[250].length; ++e)
        r[250][e].charCodeAt(0) !== 65533 && (c[r[250][e]] = 64e3 + e, o[64e3 + e] = r[250][e]);
      for (r[251] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������形泂滎瀅灐炯熒珩瑩荊螢衡逈邢鎣馨兮彗惠慧暳蕙蹊醯鞋乎互呼壕壺好岵弧戶扈昊晧毫浩淏湖滸澔濠濩灝狐琥瑚瓠皓祜糊縞胡芦葫蒿虎號蝴護豪鎬頀顥惑或酷婚昏混渾琿魂忽惚笏哄弘汞泓洪烘紅虹訌鴻化和嬅樺火畵�".split(""), e = 0; e != r[251].length; ++e)
        r[251][e].charCodeAt(0) !== 65533 && (c[r[251][e]] = 64256 + e, o[64256 + e] = r[251][e]);
      for (r[252] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������禍禾花華話譁貨靴廓擴攫確碻穫丸喚奐宦幻患換歡晥桓渙煥環紈還驩鰥活滑猾豁闊凰幌徨恍惶愰慌晃晄榥況湟滉潢煌璜皇篁簧荒蝗遑隍黃匯回廻徊恢悔懷晦會檜淮澮灰獪繪膾茴蛔誨賄劃獲宖橫鐄哮嚆孝效斅曉梟涍淆�".split(""), e = 0; e != r[252].length; ++e)
        r[252][e].charCodeAt(0) !== 65533 && (c[r[252][e]] = 64512 + e, o[64512 + e] = r[252][e]);
      for (r[253] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������爻肴酵驍侯候厚后吼喉嗅帿後朽煦珝逅勛勳塤壎焄熏燻薰訓暈薨喧暄煊萱卉喙毁彙徽揮暉煇諱輝麾休携烋畦虧恤譎鷸兇凶匈洶胸黑昕欣炘痕吃屹紇訖欠欽歆吸恰洽翕興僖凞喜噫囍姬嬉希憙憘戱晞曦熙熹熺犧禧稀羲詰�".split(""), e = 0; e != r[253].length; ++e)
        r[253][e].charCodeAt(0) !== 65533 && (c[r[253][e]] = 64768 + e, o[64768 + e] = r[253][e]);
      return { enc: c, dec: o };
    }(), i[950] = function() {
      var o = [], c = {}, r = [], e;
      for (r[0] = `\0\x07\b	
\v\f\r\x1B !"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_\`abcdefghijklmnopqrstuvwxyz{|}~��������������������������������������������������������������������������������������������������������������������������������`.split(""), e = 0; e != r[0].length; ++e)
        r[0][e].charCodeAt(0) !== 65533 && (c[r[0][e]] = 0 + e, o[0 + e] = r[0][e]);
      for (r[161] = "����������������������������������������������������������������　，、。．‧；：？！︰…‥﹐﹑﹒·﹔﹕﹖﹗｜–︱—︳╴︴﹏（）︵︶｛｝︷︸〔〕︹︺【】︻︼《》︽︾〈〉︿﹀「」﹁﹂『』﹃﹄﹙﹚����������������������������������﹛﹜﹝﹞‘’“”〝〞‵′＃＆＊※§〃○●△▲◎☆★◇◆□■▽▼㊣℅¯￣＿ˍ﹉﹊﹍﹎﹋﹌﹟﹠﹡＋－×÷±√＜＞＝≦≧≠∞≒≡﹢﹣﹤﹥﹦～∩∪⊥∠∟⊿㏒㏑∫∮∵∴♀♂⊕⊙↑↓←→↖↗↙↘∥∣／�".split(""), e = 0; e != r[161].length; ++e)
        r[161][e].charCodeAt(0) !== 65533 && (c[r[161][e]] = 41216 + e, o[41216 + e] = r[161][e]);
      for (r[162] = "����������������������������������������������������������������＼∕﹨＄￥〒￠￡％＠℃℉﹩﹪﹫㏕㎜㎝㎞㏎㎡㎎㎏㏄°兙兛兞兝兡兣嗧瓩糎▁▂▃▄▅▆▇█▏▎▍▌▋▊▉┼┴┬┤├▔─│▕┌┐└┘╭����������������������������������╮╰╯═╞╪╡◢◣◥◤╱╲╳０１２３４５６７８９ⅠⅡⅢⅣⅤⅥⅦⅧⅨⅩ〡〢〣〤〥〦〧〨〩十卄卅ＡＢＣＤＥＦＧＨＩＪＫＬＭＮＯＰＱＲＳＴＵＶＷＸＹＺａｂｃｄｅｆｇｈｉｊｋｌｍｎｏｐｑｒｓｔｕｖ�".split(""), e = 0; e != r[162].length; ++e)
        r[162][e].charCodeAt(0) !== 65533 && (c[r[162][e]] = 41472 + e, o[41472 + e] = r[162][e]);
      for (r[163] = "����������������������������������������������������������������ｗｘｙｚΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡΣΤΥΦΧΨΩαβγδεζηθικλμνξοπρστυφχψωㄅㄆㄇㄈㄉㄊㄋㄌㄍㄎㄏ����������������������������������ㄐㄑㄒㄓㄔㄕㄖㄗㄘㄙㄚㄛㄜㄝㄞㄟㄠㄡㄢㄣㄤㄥㄦㄧㄨㄩ˙ˉˊˇˋ���������������������������������€������������������������������".split(""), e = 0; e != r[163].length; ++e)
        r[163][e].charCodeAt(0) !== 65533 && (c[r[163][e]] = 41728 + e, o[41728 + e] = r[163][e]);
      for (r[164] = "����������������������������������������������������������������一乙丁七乃九了二人儿入八几刀刁力匕十卜又三下丈上丫丸凡久么也乞于亡兀刃勺千叉口土士夕大女子孑孓寸小尢尸山川工己已巳巾干廾弋弓才����������������������������������丑丐不中丰丹之尹予云井互五亢仁什仃仆仇仍今介仄元允內六兮公冗凶分切刈勻勾勿化匹午升卅卞厄友及反壬天夫太夭孔少尤尺屯巴幻廿弔引心戈戶手扎支文斗斤方日曰月木欠止歹毋比毛氏水火爪父爻片牙牛犬王丙�".split(""), e = 0; e != r[164].length; ++e)
        r[164][e].charCodeAt(0) !== 65533 && (c[r[164][e]] = 41984 + e, o[41984 + e] = r[164][e]);
      for (r[165] = "����������������������������������������������������������������世丕且丘主乍乏乎以付仔仕他仗代令仙仞充兄冉冊冬凹出凸刊加功包匆北匝仟半卉卡占卯卮去可古右召叮叩叨叼司叵叫另只史叱台句叭叻四囚外����������������������������������央失奴奶孕它尼巨巧左市布平幼弁弘弗必戊打扔扒扑斥旦朮本未末札正母民氐永汁汀氾犯玄玉瓜瓦甘生用甩田由甲申疋白皮皿目矛矢石示禾穴立丞丟乒乓乩亙交亦亥仿伉伙伊伕伍伐休伏仲件任仰仳份企伋光兇兆先全�".split(""), e = 0; e != r[165].length; ++e)
        r[165][e].charCodeAt(0) !== 65533 && (c[r[165][e]] = 42240 + e, o[42240 + e] = r[165][e]);
      for (r[166] = "����������������������������������������������������������������共再冰列刑划刎刖劣匈匡匠印危吉吏同吊吐吁吋各向名合吃后吆吒因回囝圳地在圭圬圯圩夙多夷夸妄奸妃好她如妁字存宇守宅安寺尖屹州帆并年����������������������������������式弛忙忖戎戌戍成扣扛托收早旨旬旭曲曳有朽朴朱朵次此死氖汝汗汙江池汐汕污汛汍汎灰牟牝百竹米糸缶羊羽老考而耒耳聿肉肋肌臣自至臼舌舛舟艮色艾虫血行衣西阡串亨位住佇佗佞伴佛何估佐佑伽伺伸佃佔似但佣�".split(""), e = 0; e != r[166].length; ++e)
        r[166][e].charCodeAt(0) !== 65533 && (c[r[166][e]] = 42496 + e, o[42496 + e] = r[166][e]);
      for (r[167] = "����������������������������������������������������������������作你伯低伶余佝佈佚兌克免兵冶冷別判利刪刨劫助努劬匣即卵吝吭吞吾否呎吧呆呃吳呈呂君吩告吹吻吸吮吵吶吠吼呀吱含吟听囪困囤囫坊坑址坍����������������������������������均坎圾坐坏圻壯夾妝妒妨妞妣妙妖妍妤妓妊妥孝孜孚孛完宋宏尬局屁尿尾岐岑岔岌巫希序庇床廷弄弟彤形彷役忘忌志忍忱快忸忪戒我抄抗抖技扶抉扭把扼找批扳抒扯折扮投抓抑抆改攻攸旱更束李杏材村杜杖杞杉杆杠�".split(""), e = 0; e != r[167].length; ++e)
        r[167][e].charCodeAt(0) !== 65533 && (c[r[167][e]] = 42752 + e, o[42752 + e] = r[167][e]);
      for (r[168] = "����������������������������������������������������������������杓杗步每求汞沙沁沈沉沅沛汪決沐汰沌汨沖沒汽沃汲汾汴沆汶沍沔沘沂灶灼災灸牢牡牠狄狂玖甬甫男甸皂盯矣私秀禿究系罕肖肓肝肘肛肚育良芒����������������������������������芋芍見角言谷豆豕貝赤走足身車辛辰迂迆迅迄巡邑邢邪邦那酉釆里防阮阱阪阬並乖乳事些亞享京佯依侍佳使佬供例來侃佰併侈佩佻侖佾侏侑佺兔兒兕兩具其典冽函刻券刷刺到刮制剁劾劻卒協卓卑卦卷卸卹取叔受味呵�".split(""), e = 0; e != r[168].length; ++e)
        r[168][e].charCodeAt(0) !== 65533 && (c[r[168][e]] = 43008 + e, o[43008 + e] = r[168][e]);
      for (r[169] = "����������������������������������������������������������������咖呸咕咀呻呷咄咒咆呼咐呱呶和咚呢周咋命咎固垃坷坪坩坡坦坤坼夜奉奇奈奄奔妾妻委妹妮姑姆姐姍始姓姊妯妳姒姅孟孤季宗定官宜宙宛尚屈居����������������������������������屆岷岡岸岩岫岱岳帘帚帖帕帛帑幸庚店府底庖延弦弧弩往征彿彼忝忠忽念忿怏怔怯怵怖怪怕怡性怩怫怛或戕房戾所承拉拌拄抿拂抹拒招披拓拔拋拈抨抽押拐拙拇拍抵拚抱拘拖拗拆抬拎放斧於旺昔易昌昆昂明昀昏昕昊�".split(""), e = 0; e != r[169].length; ++e)
        r[169][e].charCodeAt(0) !== 65533 && (c[r[169][e]] = 43264 + e, o[43264 + e] = r[169][e]);
      for (r[170] = "����������������������������������������������������������������昇服朋杭枋枕東果杳杷枇枝林杯杰板枉松析杵枚枓杼杪杲欣武歧歿氓氛泣注泳沱泌泥河沽沾沼波沫法泓沸泄油況沮泗泅泱沿治泡泛泊沬泯泜泖泠����������������������������������炕炎炒炊炙爬爭爸版牧物狀狎狙狗狐玩玨玟玫玥甽疝疙疚的盂盲直知矽社祀祁秉秈空穹竺糾罔羌羋者肺肥肢肱股肫肩肴肪肯臥臾舍芳芝芙芭芽芟芹花芬芥芯芸芣芰芾芷虎虱初表軋迎返近邵邸邱邶采金長門阜陀阿阻附�".split(""), e = 0; e != r[170].length; ++e)
        r[170][e].charCodeAt(0) !== 65533 && (c[r[170][e]] = 43520 + e, o[43520 + e] = r[170][e]);
      for (r[171] = "����������������������������������������������������������������陂隹雨青非亟亭亮信侵侯便俠俑俏保促侶俘俟俊俗侮俐俄係俚俎俞侷兗冒冑冠剎剃削前剌剋則勇勉勃勁匍南卻厚叛咬哀咨哎哉咸咦咳哇哂咽咪品����������������������������������哄哈咯咫咱咻咩咧咿囿垂型垠垣垢城垮垓奕契奏奎奐姜姘姿姣姨娃姥姪姚姦威姻孩宣宦室客宥封屎屏屍屋峙峒巷帝帥帟幽庠度建弈弭彥很待徊律徇後徉怒思怠急怎怨恍恰恨恢恆恃恬恫恪恤扁拜挖按拼拭持拮拽指拱拷�".split(""), e = 0; e != r[171].length; ++e)
        r[171][e].charCodeAt(0) !== 65533 && (c[r[171][e]] = 43776 + e, o[43776 + e] = r[171][e]);
      for (r[172] = "����������������������������������������������������������������拯括拾拴挑挂政故斫施既春昭映昧是星昨昱昤曷柿染柱柔某柬架枯柵柩柯柄柑枴柚查枸柏柞柳枰柙柢柝柒歪殃殆段毒毗氟泉洋洲洪流津洌洱洞洗����������������������������������活洽派洶洛泵洹洧洸洩洮洵洎洫炫為炳炬炯炭炸炮炤爰牲牯牴狩狠狡玷珊玻玲珍珀玳甚甭畏界畎畋疫疤疥疢疣癸皆皇皈盈盆盃盅省盹相眉看盾盼眇矜砂研砌砍祆祉祈祇禹禺科秒秋穿突竿竽籽紂紅紀紉紇約紆缸美羿耄�".split(""), e = 0; e != r[172].length; ++e)
        r[172][e].charCodeAt(0) !== 65533 && (c[r[172][e]] = 44032 + e, o[44032 + e] = r[172][e]);
      for (r[173] = "����������������������������������������������������������������耐耍耑耶胖胥胚胃胄背胡胛胎胞胤胝致舢苧范茅苣苛苦茄若茂茉苒苗英茁苜苔苑苞苓苟苯茆虐虹虻虺衍衫要觔計訂訃貞負赴赳趴軍軌述迦迢迪迥����������������������������������迭迫迤迨郊郎郁郃酋酊重閂限陋陌降面革韋韭音頁風飛食首香乘亳倌倍倣俯倦倥俸倩倖倆值借倚倒們俺倀倔倨俱倡個候倘俳修倭倪俾倫倉兼冤冥冢凍凌准凋剖剜剔剛剝匪卿原厝叟哨唐唁唷哼哥哲唆哺唔哩哭員唉哮哪�".split(""), e = 0; e != r[173].length; ++e)
        r[173][e].charCodeAt(0) !== 65533 && (c[r[173][e]] = 44288 + e, o[44288 + e] = r[173][e]);
      for (r[174] = "����������������������������������������������������������������哦唧唇哽唏圃圄埂埔埋埃堉夏套奘奚娑娘娜娟娛娓姬娠娣娩娥娌娉孫屘宰害家宴宮宵容宸射屑展屐峭峽峻峪峨峰島崁峴差席師庫庭座弱徒徑徐恙����������������������������������恣恥恐恕恭恩息悄悟悚悍悔悌悅悖扇拳挈拿捎挾振捕捂捆捏捉挺捐挽挪挫挨捍捌效敉料旁旅時晉晏晃晒晌晅晁書朔朕朗校核案框桓根桂桔栩梳栗桌桑栽柴桐桀格桃株桅栓栘桁殊殉殷氣氧氨氦氤泰浪涕消涇浦浸海浙涓�".split(""), e = 0; e != r[174].length; ++e)
        r[174][e].charCodeAt(0) !== 65533 && (c[r[174][e]] = 44544 + e, o[44544 + e] = r[174][e]);
      for (r[175] = "����������������������������������������������������������������浬涉浮浚浴浩涌涊浹涅浥涔烊烘烤烙烈烏爹特狼狹狽狸狷玆班琉珮珠珪珞畔畝畜畚留疾病症疲疳疽疼疹痂疸皋皰益盍盎眩真眠眨矩砰砧砸砝破砷����������������������������������砥砭砠砟砲祕祐祠祟祖神祝祗祚秤秣秧租秦秩秘窄窈站笆笑粉紡紗紋紊素索純紐紕級紜納紙紛缺罟羔翅翁耆耘耕耙耗耽耿胱脂胰脅胭胴脆胸胳脈能脊胼胯臭臬舀舐航舫舨般芻茫荒荔荊茸荐草茵茴荏茲茹茶茗荀茱茨荃�".split(""), e = 0; e != r[175].length; ++e)
        r[175][e].charCodeAt(0) !== 65533 && (c[r[175][e]] = 44800 + e, o[44800 + e] = r[175][e]);
      for (r[176] = "����������������������������������������������������������������虔蚊蚪蚓蚤蚩蚌蚣蚜衰衷袁袂衽衹記訐討訌訕訊託訓訖訏訑豈豺豹財貢起躬軒軔軏辱送逆迷退迺迴逃追逅迸邕郡郝郢酒配酌釘針釗釜釙閃院陣陡����������������������������������陛陝除陘陞隻飢馬骨高鬥鬲鬼乾偺偽停假偃偌做偉健偶偎偕偵側偷偏倏偯偭兜冕凰剪副勒務勘動匐匏匙匿區匾參曼商啪啦啄啞啡啃啊唱啖問啕唯啤唸售啜唬啣唳啁啗圈國圉域堅堊堆埠埤基堂堵執培夠奢娶婁婉婦婪婀�".split(""), e = 0; e != r[176].length; ++e)
        r[176][e].charCodeAt(0) !== 65533 && (c[r[176][e]] = 45056 + e, o[45056 + e] = r[176][e]);
      for (r[177] = "����������������������������������������������������������������娼婢婚婆婊孰寇寅寄寂宿密尉專將屠屜屝崇崆崎崛崖崢崑崩崔崙崤崧崗巢常帶帳帷康庸庶庵庾張強彗彬彩彫得徙從徘御徠徜恿患悉悠您惋悴惦悽����������������������������������情悻悵惜悼惘惕惆惟悸惚惇戚戛扈掠控捲掖探接捷捧掘措捱掩掉掃掛捫推掄授掙採掬排掏掀捻捩捨捺敝敖救教敗啟敏敘敕敔斜斛斬族旋旌旎晝晚晤晨晦晞曹勗望梁梯梢梓梵桿桶梱梧梗械梃棄梭梆梅梔條梨梟梡梂欲殺�".split(""), e = 0; e != r[177].length; ++e)
        r[177][e].charCodeAt(0) !== 65533 && (c[r[177][e]] = 45312 + e, o[45312 + e] = r[177][e]);
      for (r[178] = "����������������������������������������������������������������毫毬氫涎涼淳淙液淡淌淤添淺清淇淋涯淑涮淞淹涸混淵淅淒渚涵淚淫淘淪深淮淨淆淄涪淬涿淦烹焉焊烽烯爽牽犁猜猛猖猓猙率琅琊球理現琍瓠瓶����������������������������������瓷甜產略畦畢異疏痔痕疵痊痍皎盔盒盛眷眾眼眶眸眺硫硃硎祥票祭移窒窕笠笨笛第符笙笞笮粒粗粕絆絃統紮紹紼絀細紳組累終紲紱缽羞羚翌翎習耜聊聆脯脖脣脫脩脰脤舂舵舷舶船莎莞莘荸莢莖莽莫莒莊莓莉莠荷荻荼�".split(""), e = 0; e != r[178].length; ++e)
        r[178][e].charCodeAt(0) !== 65533 && (c[r[178][e]] = 45568 + e, o[45568 + e] = r[178][e]);
      for (r[179] = "����������������������������������������������������������������莆莧處彪蛇蛀蚶蛄蚵蛆蛋蚱蚯蛉術袞袈被袒袖袍袋覓規訪訝訣訥許設訟訛訢豉豚販責貫貨貪貧赧赦趾趺軛軟這逍通逗連速逝逐逕逞造透逢逖逛途����������������������������������部郭都酗野釵釦釣釧釭釩閉陪陵陳陸陰陴陶陷陬雀雪雩章竟頂頃魚鳥鹵鹿麥麻傢傍傅備傑傀傖傘傚最凱割剴創剩勞勝勛博厥啻喀喧啼喊喝喘喂喜喪喔喇喋喃喳單喟唾喲喚喻喬喱啾喉喫喙圍堯堪場堤堰報堡堝堠壹壺奠�".split(""), e = 0; e != r[179].length; ++e)
        r[179][e].charCodeAt(0) !== 65533 && (c[r[179][e]] = 45824 + e, o[45824 + e] = r[179][e]);
      for (r[180] = "����������������������������������������������������������������婷媚婿媒媛媧孳孱寒富寓寐尊尋就嵌嵐崴嵇巽幅帽幀幃幾廊廁廂廄弼彭復循徨惑惡悲悶惠愜愣惺愕惰惻惴慨惱愎惶愉愀愒戟扉掣掌描揀揩揉揆揍����������������������������������插揣提握揖揭揮捶援揪換摒揚揹敞敦敢散斑斐斯普晰晴晶景暑智晾晷曾替期朝棺棕棠棘棗椅棟棵森棧棹棒棲棣棋棍植椒椎棉棚楮棻款欺欽殘殖殼毯氮氯氬港游湔渡渲湧湊渠渥渣減湛湘渤湖湮渭渦湯渴湍渺測湃渝渾滋�".split(""), e = 0; e != r[180].length; ++e)
        r[180][e].charCodeAt(0) !== 65533 && (c[r[180][e]] = 46080 + e, o[46080 + e] = r[180][e]);
      for (r[181] = "����������������������������������������������������������������溉渙湎湣湄湲湩湟焙焚焦焰無然煮焜牌犄犀猶猥猴猩琺琪琳琢琥琵琶琴琯琛琦琨甥甦畫番痢痛痣痙痘痞痠登發皖皓皴盜睏短硝硬硯稍稈程稅稀窘����������������������������������窗窖童竣等策筆筐筒答筍筋筏筑粟粥絞結絨絕紫絮絲絡給絢絰絳善翔翕耋聒肅腕腔腋腑腎脹腆脾腌腓腴舒舜菩萃菸萍菠菅萋菁華菱菴著萊菰萌菌菽菲菊萸萎萄菜萇菔菟虛蛟蛙蛭蛔蛛蛤蛐蛞街裁裂袱覃視註詠評詞証詁�".split(""), e = 0; e != r[181].length; ++e)
        r[181][e].charCodeAt(0) !== 65533 && (c[r[181][e]] = 46336 + e, o[46336 + e] = r[181][e]);
      for (r[182] = "����������������������������������������������������������������詔詛詐詆訴診訶詖象貂貯貼貳貽賁費賀貴買貶貿貸越超趁跎距跋跚跑跌跛跆軻軸軼辜逮逵週逸進逶鄂郵鄉郾酣酥量鈔鈕鈣鈉鈞鈍鈐鈇鈑閔閏開閑����������������������������������間閒閎隊階隋陽隅隆隍陲隄雁雅雄集雇雯雲韌項順須飧飪飯飩飲飭馮馭黃黍黑亂傭債傲傳僅傾催傷傻傯僇剿剷剽募勦勤勢勣匯嗟嗨嗓嗦嗎嗜嗇嗑嗣嗤嗯嗚嗡嗅嗆嗥嗉園圓塞塑塘塗塚塔填塌塭塊塢塒塋奧嫁嫉嫌媾媽媼�".split(""), e = 0; e != r[182].length; ++e)
        r[182][e].charCodeAt(0) !== 65533 && (c[r[182][e]] = 46592 + e, o[46592 + e] = r[182][e]);
      for (r[183] = "����������������������������������������������������������������媳嫂媲嵩嵯幌幹廉廈弒彙徬微愚意慈感想愛惹愁愈慎慌慄慍愾愴愧愍愆愷戡戢搓搾搞搪搭搽搬搏搜搔損搶搖搗搆敬斟新暗暉暇暈暖暄暘暍會榔業����������������������������������楚楷楠楔極椰概楊楨楫楞楓楹榆楝楣楛歇歲毀殿毓毽溢溯滓溶滂源溝滇滅溥溘溼溺溫滑準溜滄滔溪溧溴煎煙煩煤煉照煜煬煦煌煥煞煆煨煖爺牒猷獅猿猾瑯瑚瑕瑟瑞瑁琿瑙瑛瑜當畸瘀痰瘁痲痱痺痿痴痳盞盟睛睫睦睞督�".split(""), e = 0; e != r[183].length; ++e)
        r[183][e].charCodeAt(0) !== 65533 && (c[r[183][e]] = 46848 + e, o[46848 + e] = r[183][e]);
      for (r[184] = "����������������������������������������������������������������睹睪睬睜睥睨睢矮碎碰碗碘碌碉硼碑碓硿祺祿禁萬禽稜稚稠稔稟稞窟窠筷節筠筮筧粱粳粵經絹綑綁綏絛置罩罪署義羨群聖聘肆肄腱腰腸腥腮腳腫����������������������������������腹腺腦舅艇蒂葷落萱葵葦葫葉葬葛萼萵葡董葩葭葆虞虜號蛹蜓蜈蜇蜀蛾蛻蜂蜃蜆蜊衙裟裔裙補裘裝裡裊裕裒覜解詫該詳試詩詰誇詼詣誠話誅詭詢詮詬詹詻訾詨豢貊貉賊資賈賄貲賃賂賅跡跟跨路跳跺跪跤跦躲較載軾輊�".split(""), e = 0; e != r[184].length; ++e)
        r[184][e].charCodeAt(0) !== 65533 && (c[r[184][e]] = 47104 + e, o[47104 + e] = r[184][e]);
      for (r[185] = "����������������������������������������������������������������辟農運遊道遂達逼違遐遇遏過遍遑逾遁鄒鄗酬酪酩釉鈷鉗鈸鈽鉀鈾鉛鉋鉤鉑鈴鉉鉍鉅鈹鈿鉚閘隘隔隕雍雋雉雊雷電雹零靖靴靶預頑頓頊頒頌飼飴����������������������������������飽飾馳馱馴髡鳩麂鼎鼓鼠僧僮僥僖僭僚僕像僑僱僎僩兢凳劃劂匱厭嗾嘀嘛嘗嗽嘔嘆嘉嘍嘎嗷嘖嘟嘈嘐嗶團圖塵塾境墓墊塹墅塽壽夥夢夤奪奩嫡嫦嫩嫗嫖嫘嫣孵寞寧寡寥實寨寢寤察對屢嶄嶇幛幣幕幗幔廓廖弊彆彰徹慇�".split(""), e = 0; e != r[185].length; ++e)
        r[185][e].charCodeAt(0) !== 65533 && (c[r[185][e]] = 47360 + e, o[47360 + e] = r[185][e]);
      for (r[186] = "����������������������������������������������������������������愿態慷慢慣慟慚慘慵截撇摘摔撤摸摟摺摑摧搴摭摻敲斡旗旖暢暨暝榜榨榕槁榮槓構榛榷榻榫榴槐槍榭槌榦槃榣歉歌氳漳演滾漓滴漩漾漠漬漏漂漢����������������������������������滿滯漆漱漸漲漣漕漫漯澈漪滬漁滲滌滷熔熙煽熊熄熒爾犒犖獄獐瑤瑣瑪瑰瑭甄疑瘧瘍瘋瘉瘓盡監瞄睽睿睡磁碟碧碳碩碣禎福禍種稱窪窩竭端管箕箋筵算箝箔箏箸箇箄粹粽精綻綰綜綽綾綠緊綴網綱綺綢綿綵綸維緒緇綬�".split(""), e = 0; e != r[186].length; ++e)
        r[186][e].charCodeAt(0) !== 65533 && (c[r[186][e]] = 47616 + e, o[47616 + e] = r[186][e]);
      for (r[187] = "����������������������������������������������������������������罰翠翡翟聞聚肇腐膀膏膈膊腿膂臧臺與舔舞艋蓉蒿蓆蓄蒙蒞蒲蒜蓋蒸蓀蓓蒐蒼蓑蓊蜿蜜蜻蜢蜥蜴蜘蝕蜷蜩裳褂裴裹裸製裨褚裯誦誌語誣認誡誓誤����������������������������������說誥誨誘誑誚誧豪貍貌賓賑賒赫趙趕跼輔輒輕輓辣遠遘遜遣遙遞遢遝遛鄙鄘鄞酵酸酷酴鉸銀銅銘銖鉻銓銜銨鉼銑閡閨閩閣閥閤隙障際雌雒需靼鞅韶頗領颯颱餃餅餌餉駁骯骰髦魁魂鳴鳶鳳麼鼻齊億儀僻僵價儂儈儉儅凜�".split(""), e = 0; e != r[187].length; ++e)
        r[187][e].charCodeAt(0) !== 65533 && (c[r[187][e]] = 47872 + e, o[47872 + e] = r[187][e]);
      for (r[188] = "����������������������������������������������������������������劇劈劉劍劊勰厲嘮嘻嘹嘲嘿嘴嘩噓噎噗噴嘶嘯嘰墀墟增墳墜墮墩墦奭嬉嫻嬋嫵嬌嬈寮寬審寫層履嶝嶔幢幟幡廢廚廟廝廣廠彈影德徵慶慧慮慝慕憂����������������������������������慼慰慫慾憧憐憫憎憬憚憤憔憮戮摩摯摹撞撲撈撐撰撥撓撕撩撒撮播撫撚撬撙撢撳敵敷數暮暫暴暱樣樟槨樁樞標槽模樓樊槳樂樅槭樑歐歎殤毅毆漿潼澄潑潦潔澆潭潛潸潮澎潺潰潤澗潘滕潯潠潟熟熬熱熨牖犛獎獗瑩璋璃�".split(""), e = 0; e != r[188].length; ++e)
        r[188][e].charCodeAt(0) !== 65533 && (c[r[188][e]] = 48128 + e, o[48128 + e] = r[188][e]);
      for (r[189] = "����������������������������������������������������������������瑾璀畿瘠瘩瘟瘤瘦瘡瘢皚皺盤瞎瞇瞌瞑瞋磋磅確磊碾磕碼磐稿稼穀稽稷稻窯窮箭箱範箴篆篇篁箠篌糊締練緯緻緘緬緝編緣線緞緩綞緙緲緹罵罷羯����������������������������������翩耦膛膜膝膠膚膘蔗蔽蔚蓮蔬蔭蔓蔑蔣蔡蔔蓬蔥蓿蔆螂蝴蝶蝠蝦蝸蝨蝙蝗蝌蝓衛衝褐複褒褓褕褊誼諒談諄誕請諸課諉諂調誰論諍誶誹諛豌豎豬賠賞賦賤賬賭賢賣賜質賡赭趟趣踫踐踝踢踏踩踟踡踞躺輝輛輟輩輦輪輜輞�".split(""), e = 0; e != r[189].length; ++e)
        r[189][e].charCodeAt(0) !== 65533 && (c[r[189][e]] = 48384 + e, o[48384 + e] = r[189][e]);
      for (r[190] = "����������������������������������������������������������������輥適遮遨遭遷鄰鄭鄧鄱醇醉醋醃鋅銻銷鋪銬鋤鋁銳銼鋒鋇鋰銲閭閱霄霆震霉靠鞍鞋鞏頡頫頜颳養餓餒餘駝駐駟駛駑駕駒駙骷髮髯鬧魅魄魷魯鴆鴉����������������������������������鴃麩麾黎墨齒儒儘儔儐儕冀冪凝劑劓勳噙噫噹噩噤噸噪器噥噱噯噬噢噶壁墾壇壅奮嬝嬴學寰導彊憲憑憩憊懍憶憾懊懈戰擅擁擋撻撼據擄擇擂操撿擒擔撾整曆曉暹曄曇暸樽樸樺橙橫橘樹橄橢橡橋橇樵機橈歙歷氅濂澱澡�".split(""), e = 0; e != r[190].length; ++e)
        r[190][e].charCodeAt(0) !== 65533 && (c[r[190][e]] = 48640 + e, o[48640 + e] = r[190][e]);
      for (r[191] = "����������������������������������������������������������������濃澤濁澧澳激澹澶澦澠澴熾燉燐燒燈燕熹燎燙燜燃燄獨璜璣璘璟璞瓢甌甍瘴瘸瘺盧盥瞠瞞瞟瞥磨磚磬磧禦積穎穆穌穋窺篙簑築篤篛篡篩篦糕糖縊����������������������������������縑縈縛縣縞縝縉縐罹羲翰翱翮耨膳膩膨臻興艘艙蕊蕙蕈蕨蕩蕃蕉蕭蕪蕞螃螟螞螢融衡褪褲褥褫褡親覦諦諺諫諱謀諜諧諮諾謁謂諷諭諳諶諼豫豭貓賴蹄踱踴蹂踹踵輻輯輸輳辨辦遵遴選遲遼遺鄴醒錠錶鋸錳錯錢鋼錫錄錚�".split(""), e = 0; e != r[191].length; ++e)
        r[191][e].charCodeAt(0) !== 65533 && (c[r[191][e]] = 48896 + e, o[48896 + e] = r[191][e]);
      for (r[192] = "����������������������������������������������������������������錐錦錡錕錮錙閻隧隨險雕霎霑霖霍霓霏靛靜靦鞘頰頸頻頷頭頹頤餐館餞餛餡餚駭駢駱骸骼髻髭鬨鮑鴕鴣鴦鴨鴒鴛默黔龍龜優償儡儲勵嚎嚀嚐嚅嚇����������������������������������嚏壕壓壑壎嬰嬪嬤孺尷屨嶼嶺嶽嶸幫彌徽應懂懇懦懋戲戴擎擊擘擠擰擦擬擱擢擭斂斃曙曖檀檔檄檢檜櫛檣橾檗檐檠歜殮毚氈濘濱濟濠濛濤濫濯澀濬濡濩濕濮濰燧營燮燦燥燭燬燴燠爵牆獰獲璩環璦璨癆療癌盪瞳瞪瞰瞬�".split(""), e = 0; e != r[192].length; ++e)
        r[192][e].charCodeAt(0) !== 65533 && (c[r[192][e]] = 49152 + e, o[49152 + e] = r[192][e]);
      for (r[193] = "����������������������������������������������������������������瞧瞭矯磷磺磴磯礁禧禪穗窿簇簍篾篷簌篠糠糜糞糢糟糙糝縮績繆縷縲繃縫總縱繅繁縴縹繈縵縿縯罄翳翼聱聲聰聯聳臆臃膺臂臀膿膽臉膾臨舉艱薪����������������������������������薄蕾薜薑薔薯薛薇薨薊虧蟀蟑螳蟒蟆螫螻螺蟈蟋褻褶襄褸褽覬謎謗謙講謊謠謝謄謐豁谿豳賺賽購賸賻趨蹉蹋蹈蹊轄輾轂轅輿避遽還邁邂邀鄹醣醞醜鍍鎂錨鍵鍊鍥鍋錘鍾鍬鍛鍰鍚鍔闊闋闌闈闆隱隸雖霜霞鞠韓顆颶餵騁�".split(""), e = 0; e != r[193].length; ++e)
        r[193][e].charCodeAt(0) !== 65533 && (c[r[193][e]] = 49408 + e, o[49408 + e] = r[193][e]);
      for (r[194] = "����������������������������������������������������������������駿鮮鮫鮪鮭鴻鴿麋黏點黜黝黛鼾齋叢嚕嚮壙壘嬸彝懣戳擴擲擾攆擺擻擷斷曜朦檳檬櫃檻檸櫂檮檯歟歸殯瀉瀋濾瀆濺瀑瀏燻燼燾燸獷獵璧璿甕癖癘����������������������������������癒瞽瞿瞻瞼礎禮穡穢穠竄竅簫簧簪簞簣簡糧織繕繞繚繡繒繙罈翹翻職聶臍臏舊藏薩藍藐藉薰薺薹薦蟯蟬蟲蟠覆覲觴謨謹謬謫豐贅蹙蹣蹦蹤蹟蹕軀轉轍邇邃邈醫醬釐鎔鎊鎖鎢鎳鎮鎬鎰鎘鎚鎗闔闖闐闕離雜雙雛雞霤鞣鞦�".split(""), e = 0; e != r[194].length; ++e)
        r[194][e].charCodeAt(0) !== 65533 && (c[r[194][e]] = 49664 + e, o[49664 + e] = r[194][e]);
      for (r[195] = "����������������������������������������������������������������鞭韹額顏題顎顓颺餾餿餽餮馥騎髁鬃鬆魏魎魍鯊鯉鯽鯈鯀鵑鵝鵠黠鼕鼬儳嚥壞壟壢寵龐廬懲懷懶懵攀攏曠曝櫥櫝櫚櫓瀛瀟瀨瀚瀝瀕瀘爆爍牘犢獸����������������������������������獺璽瓊瓣疇疆癟癡矇礙禱穫穩簾簿簸簽簷籀繫繭繹繩繪羅繳羶羹羸臘藩藝藪藕藤藥藷蟻蠅蠍蟹蟾襠襟襖襞譁譜識證譚譎譏譆譙贈贊蹼蹲躇蹶蹬蹺蹴轔轎辭邊邋醱醮鏡鏑鏟鏃鏈鏜鏝鏖鏢鏍鏘鏤鏗鏨關隴難霪霧靡韜韻類�".split(""), e = 0; e != r[195].length; ++e)
        r[195][e].charCodeAt(0) !== 65533 && (c[r[195][e]] = 49920 + e, o[49920 + e] = r[195][e]);
      for (r[196] = "����������������������������������������������������������������願顛颼饅饉騖騙鬍鯨鯧鯖鯛鶉鵡鵲鵪鵬麒麗麓麴勸嚨嚷嚶嚴嚼壤孀孃孽寶巉懸懺攘攔攙曦朧櫬瀾瀰瀲爐獻瓏癢癥礦礪礬礫竇競籌籃籍糯糰辮繽繼����������������������������������纂罌耀臚艦藻藹蘑藺蘆蘋蘇蘊蠔蠕襤覺觸議譬警譯譟譫贏贍躉躁躅躂醴釋鐘鐃鏽闡霰飄饒饑馨騫騰騷騵鰓鰍鹹麵黨鼯齟齣齡儷儸囁囀囂夔屬巍懼懾攝攜斕曩櫻欄櫺殲灌爛犧瓖瓔癩矓籐纏續羼蘗蘭蘚蠣蠢蠡蠟襪襬覽譴�".split(""), e = 0; e != r[196].length; ++e)
        r[196][e].charCodeAt(0) !== 65533 && (c[r[196][e]] = 50176 + e, o[50176 + e] = r[196][e]);
      for (r[197] = "����������������������������������������������������������������護譽贓躊躍躋轟辯醺鐮鐳鐵鐺鐸鐲鐫闢霸霹露響顧顥饗驅驃驀騾髏魔魑鰭鰥鶯鶴鷂鶸麝黯鼙齜齦齧儼儻囈囊囉孿巔巒彎懿攤權歡灑灘玀瓤疊癮癬����������������������������������禳籠籟聾聽臟襲襯觼讀贖贗躑躓轡酈鑄鑑鑒霽霾韃韁顫饕驕驍髒鬚鱉鰱鰾鰻鷓鷗鼴齬齪龔囌巖戀攣攫攪曬欐瓚竊籤籣籥纓纖纔臢蘸蘿蠱變邐邏鑣鑠鑤靨顯饜驚驛驗髓體髑鱔鱗鱖鷥麟黴囑壩攬灞癱癲矗罐羈蠶蠹衢讓讒�".split(""), e = 0; e != r[197].length; ++e)
        r[197][e].charCodeAt(0) !== 65533 && (c[r[197][e]] = 50432 + e, o[50432 + e] = r[197][e]);
      for (r[198] = "����������������������������������������������������������������讖艷贛釀鑪靂靈靄韆顰驟鬢魘鱟鷹鷺鹼鹽鼇齷齲廳欖灣籬籮蠻觀躡釁鑲鑰顱饞髖鬣黌灤矚讚鑷韉驢驥纜讜躪釅鑽鑾鑼鱷鱸黷豔鑿鸚爨驪鬱鸛鸞籲���������������������������������������������������������������������������������������������������������������������������������".split(""), e = 0; e != r[198].length; ++e)
        r[198][e].charCodeAt(0) !== 65533 && (c[r[198][e]] = 50688 + e, o[50688 + e] = r[198][e]);
      for (r[201] = "����������������������������������������������������������������乂乜凵匚厂万丌乇亍囗兀屮彳丏冇与丮亓仂仉仈冘勼卬厹圠夃夬尐巿旡殳毌气爿丱丼仨仜仩仡仝仚刌匜卌圢圣夗夯宁宄尒尻屴屳帄庀庂忉戉扐氕����������������������������������氶汃氿氻犮犰玊禸肊阞伎优伬仵伔仱伀价伈伝伂伅伢伓伄仴伒冱刓刉刐劦匢匟卍厊吇囡囟圮圪圴夼妀奼妅奻奾奷奿孖尕尥屼屺屻屾巟幵庄异弚彴忕忔忏扜扞扤扡扦扢扙扠扚扥旯旮朾朹朸朻机朿朼朳氘汆汒汜汏汊汔汋�".split(""), e = 0; e != r[201].length; ++e)
        r[201][e].charCodeAt(0) !== 65533 && (c[r[201][e]] = 51456 + e, o[51456 + e] = r[201][e]);
      for (r[202] = "����������������������������������������������������������������汌灱牞犴犵玎甪癿穵网艸艼芀艽艿虍襾邙邗邘邛邔阢阤阠阣佖伻佢佉体佤伾佧佒佟佁佘伭伳伿佡冏冹刜刞刡劭劮匉卣卲厎厏吰吷吪呔呅吙吜吥吘����������������������������������吽呏呁吨吤呇囮囧囥坁坅坌坉坋坒夆奀妦妘妠妗妎妢妐妏妧妡宎宒尨尪岍岏岈岋岉岒岊岆岓岕巠帊帎庋庉庌庈庍弅弝彸彶忒忑忐忭忨忮忳忡忤忣忺忯忷忻怀忴戺抃抌抎抏抔抇扱扻扺扰抁抈扷扽扲扴攷旰旴旳旲旵杅杇�".split(""), e = 0; e != r[202].length; ++e)
        r[202][e].charCodeAt(0) !== 65533 && (c[r[202][e]] = 51712 + e, o[51712 + e] = r[202][e]);
      for (r[203] = "����������������������������������������������������������������杙杕杌杈杝杍杚杋毐氙氚汸汧汫沄沋沏汱汯汩沚汭沇沕沜汦汳汥汻沎灴灺牣犿犽狃狆狁犺狅玕玗玓玔玒町甹疔疕皁礽耴肕肙肐肒肜芐芏芅芎芑芓����������������������������������芊芃芄豸迉辿邟邡邥邞邧邠阰阨阯阭丳侘佼侅佽侀侇佶佴侉侄佷佌侗佪侚佹侁佸侐侜侔侞侒侂侕佫佮冞冼冾刵刲刳剆刱劼匊匋匼厒厔咇呿咁咑咂咈呫呺呾呥呬呴呦咍呯呡呠咘呣呧呤囷囹坯坲坭坫坱坰坶垀坵坻坳坴坢�".split(""), e = 0; e != r[203].length; ++e)
        r[203][e].charCodeAt(0) !== 65533 && (c[r[203][e]] = 51968 + e, o[51968 + e] = r[203][e]);
      for (r[204] = "����������������������������������������������������������������坨坽夌奅妵妺姏姎妲姌姁妶妼姃姖妱妽姀姈妴姇孢孥宓宕屄屇岮岤岠岵岯岨岬岟岣岭岢岪岧岝岥岶岰岦帗帔帙弨弢弣弤彔徂彾彽忞忥怭怦怙怲怋����������������������������������怴怊怗怳怚怞怬怢怍怐怮怓怑怌怉怜戔戽抭抴拑抾抪抶拊抮抳抯抻抩抰抸攽斨斻昉旼昄昒昈旻昃昋昍昅旽昑昐曶朊枅杬枎枒杶杻枘枆构杴枍枌杺枟枑枙枃杽极杸杹枔欥殀歾毞氝沓泬泫泮泙沶泔沭泧沷泐泂沺泃泆泭泲�".split(""), e = 0; e != r[204].length; ++e)
        r[204][e].charCodeAt(0) !== 65533 && (c[r[204][e]] = 52224 + e, o[52224 + e] = r[204][e]);
      for (r[205] = "����������������������������������������������������������������泒泝沴沊沝沀泞泀洰泍泇沰泹泏泩泑炔炘炅炓炆炄炑炖炂炚炃牪狖狋狘狉狜狒狔狚狌狑玤玡玭玦玢玠玬玝瓝瓨甿畀甾疌疘皯盳盱盰盵矸矼矹矻矺����������������������������������矷祂礿秅穸穻竻籵糽耵肏肮肣肸肵肭舠芠苀芫芚芘芛芵芧芮芼芞芺芴芨芡芩苂芤苃芶芢虰虯虭虮豖迒迋迓迍迖迕迗邲邴邯邳邰阹阽阼阺陃俍俅俓侲俉俋俁俔俜俙侻侳俛俇俖侺俀侹俬剄剉勀勂匽卼厗厖厙厘咺咡咭咥哏�".split(""), e = 0; e != r[205].length; ++e)
        r[205][e].charCodeAt(0) !== 65533 && (c[r[205][e]] = 52480 + e, o[52480 + e] = r[205][e]);
      for (r[206] = "����������������������������������������������������������������哃茍咷咮哖咶哅哆咠呰咼咢咾呲哞咰垵垞垟垤垌垗垝垛垔垘垏垙垥垚垕壴复奓姡姞姮娀姱姝姺姽姼姶姤姲姷姛姩姳姵姠姾姴姭宨屌峐峘峌峗峋峛����������������������������������峞峚峉峇峊峖峓峔峏峈峆峎峟峸巹帡帢帣帠帤庰庤庢庛庣庥弇弮彖徆怷怹恔恲恞恅恓恇恉恛恌恀恂恟怤恄恘恦恮扂扃拏挍挋拵挎挃拫拹挏挌拸拶挀挓挔拺挕拻拰敁敃斪斿昶昡昲昵昜昦昢昳昫昺昝昴昹昮朏朐柁柲柈枺�".split(""), e = 0; e != r[206].length; ++e)
        r[206][e].charCodeAt(0) !== 65533 && (c[r[206][e]] = 52736 + e, o[52736 + e] = r[206][e]);
      for (r[207] = "����������������������������������������������������������������柜枻柸柘柀枷柅柫柤柟枵柍枳柷柶柮柣柂枹柎柧柰枲柼柆柭柌枮柦柛柺柉柊柃柪柋欨殂殄殶毖毘毠氠氡洨洴洭洟洼洿洒洊泚洳洄洙洺洚洑洀洝浂����������������������������������洁洘洷洃洏浀洇洠洬洈洢洉洐炷炟炾炱炰炡炴炵炩牁牉牊牬牰牳牮狊狤狨狫狟狪狦狣玅珌珂珈珅玹玶玵玴珫玿珇玾珃珆玸珋瓬瓮甮畇畈疧疪癹盄眈眃眄眅眊盷盻盺矧矨砆砑砒砅砐砏砎砉砃砓祊祌祋祅祄秕种秏秖秎窀�".split(""), e = 0; e != r[207].length; ++e)
        r[207][e].charCodeAt(0) !== 65533 && (c[r[207][e]] = 52992 + e, o[52992 + e] = r[207][e]);
      for (r[208] = "����������������������������������������������������������������穾竑笀笁籺籸籹籿粀粁紃紈紁罘羑羍羾耇耎耏耔耷胘胇胠胑胈胂胐胅胣胙胜胊胕胉胏胗胦胍臿舡芔苙苾苹茇苨茀苕茺苫苖苴苬苡苲苵茌苻苶苰苪����������������������������������苤苠苺苳苭虷虴虼虳衁衎衧衪衩觓訄訇赲迣迡迮迠郱邽邿郕郅邾郇郋郈釔釓陔陏陑陓陊陎倞倅倇倓倢倰倛俵俴倳倷倬俶俷倗倜倠倧倵倯倱倎党冔冓凊凄凅凈凎剡剚剒剞剟剕剢勍匎厞唦哢唗唒哧哳哤唚哿唄唈哫唑唅哱�".split(""), e = 0; e != r[208].length; ++e)
        r[208][e].charCodeAt(0) !== 65533 && (c[r[208][e]] = 53248 + e, o[53248 + e] = r[208][e]);
      for (r[209] = "����������������������������������������������������������������唊哻哷哸哠唎唃唋圁圂埌堲埕埒垺埆垽垼垸垶垿埇埐垹埁夎奊娙娖娭娮娕娏娗娊娞娳孬宧宭宬尃屖屔峬峿峮峱峷崀峹帩帨庨庮庪庬弳弰彧恝恚恧����������������������������������恁悢悈悀悒悁悝悃悕悛悗悇悜悎戙扆拲挐捖挬捄捅挶捃揤挹捋捊挼挩捁挴捘捔捙挭捇挳捚捑挸捗捀捈敊敆旆旃旄旂晊晟晇晑朒朓栟栚桉栲栳栻桋桏栖栱栜栵栫栭栯桎桄栴栝栒栔栦栨栮桍栺栥栠欬欯欭欱欴歭肂殈毦毤�".split(""), e = 0; e != r[209].length; ++e)
        r[209][e].charCodeAt(0) !== 65533 && (c[r[209][e]] = 53504 + e, o[53504 + e] = r[209][e]);
      for (r[210] = "����������������������������������������������������������������毨毣毢毧氥浺浣浤浶洍浡涒浘浢浭浯涑涍淯浿涆浞浧浠涗浰浼浟涂涘洯浨涋浾涀涄洖涃浻浽浵涐烜烓烑烝烋缹烢烗烒烞烠烔烍烅烆烇烚烎烡牂牸����������������������������������牷牶猀狺狴狾狶狳狻猁珓珙珥珖玼珧珣珩珜珒珛珔珝珚珗珘珨瓞瓟瓴瓵甡畛畟疰痁疻痄痀疿疶疺皊盉眝眛眐眓眒眣眑眕眙眚眢眧砣砬砢砵砯砨砮砫砡砩砳砪砱祔祛祏祜祓祒祑秫秬秠秮秭秪秜秞秝窆窉窅窋窌窊窇竘笐�".split(""), e = 0; e != r[210].length; ++e)
        r[210][e].charCodeAt(0) !== 65533 && (c[r[210][e]] = 53760 + e, o[53760 + e] = r[210][e]);
      for (r[211] = "����������������������������������������������������������������笄笓笅笏笈笊笎笉笒粄粑粊粌粈粍粅紞紝紑紎紘紖紓紟紒紏紌罜罡罞罠罝罛羖羒翃翂翀耖耾耹胺胲胹胵脁胻脀舁舯舥茳茭荄茙荑茥荖茿荁茦茜茢����������������������������������荂荎茛茪茈茼荍茖茤茠茷茯茩荇荅荌荓茞茬荋茧荈虓虒蚢蚨蚖蚍蚑蚞蚇蚗蚆蚋蚚蚅蚥蚙蚡蚧蚕蚘蚎蚝蚐蚔衃衄衭衵衶衲袀衱衿衯袃衾衴衼訒豇豗豻貤貣赶赸趵趷趶軑軓迾迵适迿迻逄迼迶郖郠郙郚郣郟郥郘郛郗郜郤酐�".split(""), e = 0; e != r[211].length; ++e)
        r[211][e].charCodeAt(0) !== 65533 && (c[r[211][e]] = 54016 + e, o[54016 + e] = r[211][e]);
      for (r[212] = "����������������������������������������������������������������酎酏釕釢釚陜陟隼飣髟鬯乿偰偪偡偞偠偓偋偝偲偈偍偁偛偊偢倕偅偟偩偫偣偤偆偀偮偳偗偑凐剫剭剬剮勖勓匭厜啵啶唼啍啐唴唪啑啢唶唵唰啒啅����������������������������������唌唲啥啎唹啈唭唻啀啋圊圇埻堔埢埶埜埴堀埭埽堈埸堋埳埏堇埮埣埲埥埬埡堎埼堐埧堁堌埱埩埰堍堄奜婠婘婕婧婞娸娵婭婐婟婥婬婓婤婗婃婝婒婄婛婈媎娾婍娹婌婰婩婇婑婖婂婜孲孮寁寀屙崞崋崝崚崠崌崨崍崦崥崏�".split(""), e = 0; e != r[212].length; ++e)
        r[212][e].charCodeAt(0) !== 65533 && (c[r[212][e]] = 54272 + e, o[54272 + e] = r[212][e]);
      for (r[213] = "����������������������������������������������������������������崰崒崣崟崮帾帴庱庴庹庲庳弶弸徛徖徟悊悐悆悾悰悺惓惔惏惤惙惝惈悱惛悷惊悿惃惍惀挲捥掊掂捽掽掞掭掝掗掫掎捯掇掐据掯捵掜捭掮捼掤挻掟����������������������������������捸掅掁掑掍捰敓旍晥晡晛晙晜晢朘桹梇梐梜桭桮梮梫楖桯梣梬梩桵桴梲梏桷梒桼桫桲梪梀桱桾梛梖梋梠梉梤桸桻梑梌梊桽欶欳欷欸殑殏殍殎殌氪淀涫涴涳湴涬淩淢涷淶淔渀淈淠淟淖涾淥淜淝淛淴淊涽淭淰涺淕淂淏淉�".split(""), e = 0; e != r[213].length; ++e)
        r[213][e].charCodeAt(0) !== 65533 && (c[r[213][e]] = 54528 + e, o[54528 + e] = r[213][e]);
      for (r[214] = "����������������������������������������������������������������淐淲淓淽淗淍淣涻烺焍烷焗烴焌烰焄烳焐烼烿焆焓焀烸烶焋焂焎牾牻牼牿猝猗猇猑猘猊猈狿猏猞玈珶珸珵琄琁珽琇琀珺珼珿琌琋珴琈畤畣痎痒痏����������������������������������痋痌痑痐皏皉盓眹眯眭眱眲眴眳眽眥眻眵硈硒硉硍硊硌砦硅硐祤祧祩祪祣祫祡离秺秸秶秷窏窔窐笵筇笴笥笰笢笤笳笘笪笝笱笫笭笯笲笸笚笣粔粘粖粣紵紽紸紶紺絅紬紩絁絇紾紿絊紻紨罣羕羜羝羛翊翋翍翐翑翇翏翉耟�".split(""), e = 0; e != r[214].length; ++e)
        r[214][e].charCodeAt(0) !== 65533 && (c[r[214][e]] = 54784 + e, o[54784 + e] = r[214][e]);
      for (r[215] = "����������������������������������������������������������������耞耛聇聃聈脘脥脙脛脭脟脬脞脡脕脧脝脢舑舸舳舺舴舲艴莐莣莨莍荺荳莤荴莏莁莕莙荵莔莩荽莃莌莝莛莪莋荾莥莯莈莗莰荿莦莇莮荶莚虙虖蚿蚷����������������������������������蛂蛁蛅蚺蚰蛈蚹蚳蚸蛌蚴蚻蚼蛃蚽蚾衒袉袕袨袢袪袚袑袡袟袘袧袙袛袗袤袬袌袓袎覂觖觙觕訰訧訬訞谹谻豜豝豽貥赽赻赹趼跂趹趿跁軘軞軝軜軗軠軡逤逋逑逜逌逡郯郪郰郴郲郳郔郫郬郩酖酘酚酓酕釬釴釱釳釸釤釹釪�".split(""), e = 0; e != r[215].length; ++e)
        r[215][e].charCodeAt(0) !== 65533 && (c[r[215][e]] = 55040 + e, o[55040 + e] = r[215][e]);
      for (r[216] = "����������������������������������������������������������������釫釷釨釮镺閆閈陼陭陫陱陯隿靪頄飥馗傛傕傔傞傋傣傃傌傎傝偨傜傒傂傇兟凔匒匑厤厧喑喨喥喭啷噅喢喓喈喏喵喁喣喒喤啽喌喦啿喕喡喎圌堩堷����������������������������������堙堞堧堣堨埵塈堥堜堛堳堿堶堮堹堸堭堬堻奡媯媔媟婺媢媞婸媦婼媥媬媕媮娷媄媊媗媃媋媩婻婽媌媜媏媓媝寪寍寋寔寑寊寎尌尰崷嵃嵫嵁嵋崿崵嵑嵎嵕崳崺嵒崽崱嵙嵂崹嵉崸崼崲崶嵀嵅幄幁彘徦徥徫惉悹惌惢惎惄愔�".split(""), e = 0; e != r[216].length; ++e)
        r[216][e].charCodeAt(0) !== 65533 && (c[r[216][e]] = 55296 + e, o[55296 + e] = r[216][e]);
      for (r[217] = "����������������������������������������������������������������惲愊愖愅惵愓惸惼惾惁愃愘愝愐惿愄愋扊掔掱掰揎揥揨揯揃撝揳揊揠揶揕揲揵摡揟掾揝揜揄揘揓揂揇揌揋揈揰揗揙攲敧敪敤敜敨敥斌斝斞斮旐旒����������������������������������晼晬晻暀晱晹晪晲朁椌棓椄棜椪棬棪棱椏棖棷棫棤棶椓椐棳棡椇棌椈楰梴椑棯棆椔棸棐棽棼棨椋椊椗棎棈棝棞棦棴棑椆棔棩椕椥棇欹欻欿欼殔殗殙殕殽毰毲毳氰淼湆湇渟湉溈渼渽湅湢渫渿湁湝湳渜渳湋湀湑渻渃渮湞�".split(""), e = 0; e != r[217].length; ++e)
        r[217][e].charCodeAt(0) !== 65533 && (c[r[217][e]] = 55552 + e, o[55552 + e] = r[217][e]);
      for (r[218] = "����������������������������������������������������������������湨湜湡渱渨湠湱湫渹渢渰湓湥渧湸湤湷湕湹湒湦渵渶湚焠焞焯烻焮焱焣焥焢焲焟焨焺焛牋牚犈犉犆犅犋猒猋猰猢猱猳猧猲猭猦猣猵猌琮琬琰琫琖����������������������������������琚琡琭琱琤琣琝琩琠琲瓻甯畯畬痧痚痡痦痝痟痤痗皕皒盚睆睇睄睍睅睊睎睋睌矞矬硠硤硥硜硭硱硪确硰硩硨硞硢祴祳祲祰稂稊稃稌稄窙竦竤筊笻筄筈筌筎筀筘筅粢粞粨粡絘絯絣絓絖絧絪絏絭絜絫絒絔絩絑絟絎缾缿罥�".split(""), e = 0; e != r[218].length; ++e)
        r[218][e].charCodeAt(0) !== 65533 && (c[r[218][e]] = 55808 + e, o[55808 + e] = r[218][e]);
      for (r[219] = "����������������������������������������������������������������罦羢羠羡翗聑聏聐胾胔腃腊腒腏腇脽腍脺臦臮臷臸臹舄舼舽舿艵茻菏菹萣菀菨萒菧菤菼菶萐菆菈菫菣莿萁菝菥菘菿菡菋菎菖菵菉萉萏菞萑萆菂菳����������������������������������菕菺菇菑菪萓菃菬菮菄菻菗菢萛菛菾蛘蛢蛦蛓蛣蛚蛪蛝蛫蛜蛬蛩蛗蛨蛑衈衖衕袺裗袹袸裀袾袶袼袷袽袲褁裉覕覘覗觝觚觛詎詍訹詙詀詗詘詄詅詒詈詑詊詌詏豟貁貀貺貾貰貹貵趄趀趉跘跓跍跇跖跜跏跕跙跈跗跅軯軷軺�".split(""), e = 0; e != r[219].length; ++e)
        r[219][e].charCodeAt(0) !== 65533 && (c[r[219][e]] = 56064 + e, o[56064 + e] = r[219][e]);
      for (r[220] = "����������������������������������������������������������������軹軦軮軥軵軧軨軶軫軱軬軴軩逭逴逯鄆鄬鄄郿郼鄈郹郻鄁鄀鄇鄅鄃酡酤酟酢酠鈁鈊鈥鈃鈚鈦鈏鈌鈀鈒釿釽鈆鈄鈧鈂鈜鈤鈙鈗鈅鈖镻閍閌閐隇陾隈����������������������������������隉隃隀雂雈雃雱雰靬靰靮頇颩飫鳦黹亃亄亶傽傿僆傮僄僊傴僈僂傰僁傺傱僋僉傶傸凗剺剸剻剼嗃嗛嗌嗐嗋嗊嗝嗀嗔嗄嗩喿嗒喍嗏嗕嗢嗖嗈嗲嗍嗙嗂圔塓塨塤塏塍塉塯塕塎塝塙塥塛堽塣塱壼嫇嫄嫋媺媸媱媵媰媿嫈媻嫆�".split(""), e = 0; e != r[220].length; ++e)
        r[220][e].charCodeAt(0) !== 65533 && (c[r[220][e]] = 56320 + e, o[56320 + e] = r[220][e]);
      for (r[221] = "����������������������������������������������������������������媷嫀嫊媴媶嫍媹媐寖寘寙尟尳嵱嵣嵊嵥嵲嵬嵞嵨嵧嵢巰幏幎幊幍幋廅廌廆廋廇彀徯徭惷慉慊愫慅愶愲愮慆愯慏愩慀戠酨戣戥戤揅揱揫搐搒搉搠搤����������������������������������搳摃搟搕搘搹搷搢搣搌搦搰搨摁搵搯搊搚摀搥搧搋揧搛搮搡搎敯斒旓暆暌暕暐暋暊暙暔晸朠楦楟椸楎楢楱椿楅楪椹楂楗楙楺楈楉椵楬椳椽楥棰楸椴楩楀楯楄楶楘楁楴楌椻楋椷楜楏楑椲楒椯楻椼歆歅歃歂歈歁殛嗀毻毼�".split(""), e = 0; e != r[221].length; ++e)
        r[221][e].charCodeAt(0) !== 65533 && (c[r[221][e]] = 56576 + e, o[56576 + e] = r[221][e]);
      for (r[222] = "����������������������������������������������������������������毹毷毸溛滖滈溏滀溟溓溔溠溱溹滆滒溽滁溞滉溷溰滍溦滏溲溾滃滜滘溙溒溎溍溤溡溿溳滐滊溗溮溣煇煔煒煣煠煁煝煢煲煸煪煡煂煘煃煋煰煟煐煓����������������������������������煄煍煚牏犍犌犑犐犎猼獂猻猺獀獊獉瑄瑊瑋瑒瑑瑗瑀瑏瑐瑎瑂瑆瑍瑔瓡瓿瓾瓽甝畹畷榃痯瘏瘃痷痾痼痹痸瘐痻痶痭痵痽皙皵盝睕睟睠睒睖睚睩睧睔睙睭矠碇碚碔碏碄碕碅碆碡碃硹碙碀碖硻祼禂祽祹稑稘稙稒稗稕稢稓�".split(""), e = 0; e != r[222].length; ++e)
        r[222][e].charCodeAt(0) !== 65533 && (c[r[222][e]] = 56832 + e, o[56832 + e] = r[222][e]);
      for (r[223] = "����������������������������������������������������������������稛稐窣窢窞竫筦筤筭筴筩筲筥筳筱筰筡筸筶筣粲粴粯綈綆綀綍絿綅絺綎絻綃絼綌綔綄絽綒罭罫罧罨罬羦羥羧翛翜耡腤腠腷腜腩腛腢腲朡腞腶腧腯����������������������������������腄腡舝艉艄艀艂艅蓱萿葖葶葹蒏蒍葥葑葀蒆葧萰葍葽葚葙葴葳葝蔇葞萷萺萴葺葃葸萲葅萩菙葋萯葂萭葟葰萹葎葌葒葯蓅蒎萻葇萶萳葨葾葄萫葠葔葮葐蜋蜄蛷蜌蛺蛖蛵蝍蛸蜎蜉蜁蛶蜍蜅裖裋裍裎裞裛裚裌裐覅覛觟觥觤�".split(""), e = 0; e != r[223].length; ++e)
        r[223][e].charCodeAt(0) !== 65533 && (c[r[223][e]] = 57088 + e, o[57088 + e] = r[223][e]);
      for (r[224] = "����������������������������������������������������������������觡觠觢觜触詶誆詿詡訿詷誂誄詵誃誁詴詺谼豋豊豥豤豦貆貄貅賌赨赩趑趌趎趏趍趓趔趐趒跰跠跬跱跮跐跩跣跢跧跲跫跴輆軿輁輀輅輇輈輂輋遒逿����������������������������������遄遉逽鄐鄍鄏鄑鄖鄔鄋鄎酮酯鉈鉒鈰鈺鉦鈳鉥鉞銃鈮鉊鉆鉭鉬鉏鉠鉧鉯鈶鉡鉰鈱鉔鉣鉐鉲鉎鉓鉌鉖鈲閟閜閞閛隒隓隑隗雎雺雽雸雵靳靷靸靲頏頍頎颬飶飹馯馲馰馵骭骫魛鳪鳭鳧麀黽僦僔僗僨僳僛僪僝僤僓僬僰僯僣僠�".split(""), e = 0; e != r[224].length; ++e)
        r[224][e].charCodeAt(0) !== 65533 && (c[r[224][e]] = 57344 + e, o[57344 + e] = r[224][e]);
      for (r[225] = "����������������������������������������������������������������凘劀劁勩勫匰厬嘧嘕嘌嘒嗼嘏嘜嘁嘓嘂嗺嘝嘄嗿嗹墉塼墐墘墆墁塿塴墋塺墇墑墎塶墂墈塻墔墏壾奫嫜嫮嫥嫕嫪嫚嫭嫫嫳嫢嫠嫛嫬嫞嫝嫙嫨嫟孷寠����������������������������������寣屣嶂嶀嵽嶆嵺嶁嵷嶊嶉嶈嵾嵼嶍嵹嵿幘幙幓廘廑廗廎廜廕廙廒廔彄彃彯徶愬愨慁慞慱慳慒慓慲慬憀慴慔慺慛慥愻慪慡慖戩戧戫搫摍摛摝摴摶摲摳摽摵摦撦摎撂摞摜摋摓摠摐摿搿摬摫摙摥摷敳斠暡暠暟朅朄朢榱榶槉�".split(""), e = 0; e != r[225].length; ++e)
        r[225][e].charCodeAt(0) !== 65533 && (c[r[225][e]] = 57600 + e, o[57600 + e] = r[225][e]);
      for (r[226] = "����������������������������������������������������������������榠槎榖榰榬榼榑榙榎榧榍榩榾榯榿槄榽榤槔榹槊榚槏榳榓榪榡榞槙榗榐槂榵榥槆歊歍歋殞殟殠毃毄毾滎滵滱漃漥滸漷滻漮漉潎漙漚漧漘漻漒滭漊����������������������������������漶潳滹滮漭潀漰漼漵滫漇漎潃漅滽滶漹漜滼漺漟漍漞漈漡熇熐熉熀熅熂熏煻熆熁熗牄牓犗犕犓獃獍獑獌瑢瑳瑱瑵瑲瑧瑮甀甂甃畽疐瘖瘈瘌瘕瘑瘊瘔皸瞁睼瞅瞂睮瞀睯睾瞃碲碪碴碭碨硾碫碞碥碠碬碢碤禘禊禋禖禕禔禓�".split(""), e = 0; e != r[226].length; ++e)
        r[226][e].charCodeAt(0) !== 65533 && (c[r[226][e]] = 57856 + e, o[57856 + e] = r[226][e]);
      for (r[227] = "����������������������������������������������������������������禗禈禒禐稫穊稰稯稨稦窨窫窬竮箈箜箊箑箐箖箍箌箛箎箅箘劄箙箤箂粻粿粼粺綧綷緂綣綪緁緀緅綝緎緄緆緋緌綯綹綖綼綟綦綮綩綡緉罳翢翣翥翞����������������������������������耤聝聜膉膆膃膇膍膌膋舕蒗蒤蒡蒟蒺蓎蓂蒬蒮蒫蒹蒴蓁蓍蒪蒚蒱蓐蒝蒧蒻蒢蒔蓇蓌蒛蒩蒯蒨蓖蒘蒶蓏蒠蓗蓔蓒蓛蒰蒑虡蜳蜣蜨蝫蝀蜮蜞蜡蜙蜛蝃蜬蝁蜾蝆蜠蜲蜪蜭蜼蜒蜺蜱蜵蝂蜦蜧蜸蜤蜚蜰蜑裷裧裱裲裺裾裮裼裶裻�".split(""), e = 0; e != r[227].length; ++e)
        r[227][e].charCodeAt(0) !== 65533 && (c[r[227][e]] = 58112 + e, o[58112 + e] = r[227][e]);
      for (r[228] = "����������������������������������������������������������������裰裬裫覝覡覟覞觩觫觨誫誙誋誒誏誖谽豨豩賕賏賗趖踉踂跿踍跽踊踃踇踆踅跾踀踄輐輑輎輍鄣鄜鄠鄢鄟鄝鄚鄤鄡鄛酺酲酹酳銥銤鉶銛鉺銠銔銪銍����������������������������������銦銚銫鉹銗鉿銣鋮銎銂銕銢鉽銈銡銊銆銌銙銧鉾銇銩銝銋鈭隞隡雿靘靽靺靾鞃鞀鞂靻鞄鞁靿韎韍頖颭颮餂餀餇馝馜駃馹馻馺駂馽駇骱髣髧鬾鬿魠魡魟鳱鳲鳵麧僿儃儰僸儆儇僶僾儋儌僽儊劋劌勱勯噈噂噌嘵噁噊噉噆噘�".split(""), e = 0; e != r[228].length; ++e)
        r[228][e].charCodeAt(0) !== 65533 && (c[r[228][e]] = 58368 + e, o[58368 + e] = r[228][e]);
      for (r[229] = "����������������������������������������������������������������噚噀嘳嘽嘬嘾嘸嘪嘺圚墫墝墱墠墣墯墬墥墡壿嫿嫴嫽嫷嫶嬃嫸嬂嫹嬁嬇嬅嬏屧嶙嶗嶟嶒嶢嶓嶕嶠嶜嶡嶚嶞幩幝幠幜緳廛廞廡彉徲憋憃慹憱憰憢憉����������������������������������憛憓憯憭憟憒憪憡憍慦憳戭摮摰撖撠撅撗撜撏撋撊撌撣撟摨撱撘敶敺敹敻斲斳暵暰暩暲暷暪暯樀樆樗槥槸樕槱槤樠槿槬槢樛樝槾樧槲槮樔槷槧橀樈槦槻樍槼槫樉樄樘樥樏槶樦樇槴樖歑殥殣殢殦氁氀毿氂潁漦潾澇濆澒�".split(""), e = 0; e != r[229].length; ++e)
        r[229][e].charCodeAt(0) !== 65533 && (c[r[229][e]] = 58624 + e, o[58624 + e] = r[229][e]);
      for (r[230] = "����������������������������������������������������������������澍澉澌潢潏澅潚澖潶潬澂潕潲潒潐潗澔澓潝漀潡潫潽潧澐潓澋潩潿澕潣潷潪潻熲熯熛熰熠熚熩熵熝熥熞熤熡熪熜熧熳犘犚獘獒獞獟獠獝獛獡獚獙����������������������������������獢璇璉璊璆璁瑽璅璈瑼瑹甈甇畾瘥瘞瘙瘝瘜瘣瘚瘨瘛皜皝皞皛瞍瞏瞉瞈磍碻磏磌磑磎磔磈磃磄磉禚禡禠禜禢禛歶稹窲窴窳箷篋箾箬篎箯箹篊箵糅糈糌糋緷緛緪緧緗緡縃緺緦緶緱緰緮緟罶羬羰羭翭翫翪翬翦翨聤聧膣膟�".split(""), e = 0; e != r[230].length; ++e)
        r[230][e].charCodeAt(0) !== 65533 && (c[r[230][e]] = 58880 + e, o[58880 + e] = r[230][e]);
      for (r[231] = "����������������������������������������������������������������膞膕膢膙膗舖艏艓艒艐艎艑蔤蔻蔏蔀蔩蔎蔉蔍蔟蔊蔧蔜蓻蔫蓺蔈蔌蓴蔪蓲蔕蓷蓫蓳蓼蔒蓪蓩蔖蓾蔨蔝蔮蔂蓽蔞蓶蔱蔦蓧蓨蓰蓯蓹蔘蔠蔰蔋蔙蔯虢����������������������������������蝖蝣蝤蝷蟡蝳蝘蝔蝛蝒蝡蝚蝑蝞蝭蝪蝐蝎蝟蝝蝯蝬蝺蝮蝜蝥蝏蝻蝵蝢蝧蝩衚褅褌褔褋褗褘褙褆褖褑褎褉覢覤覣觭觰觬諏諆誸諓諑諔諕誻諗誾諀諅諘諃誺誽諙谾豍貏賥賟賙賨賚賝賧趠趜趡趛踠踣踥踤踮踕踛踖踑踙踦踧�".split(""), e = 0; e != r[231].length; ++e)
        r[231][e].charCodeAt(0) !== 65533 && (c[r[231][e]] = 59136 + e, o[59136 + e] = r[231][e]);
      for (r[232] = "����������������������������������������������������������������踔踒踘踓踜踗踚輬輤輘輚輠輣輖輗遳遰遯遧遫鄯鄫鄩鄪鄲鄦鄮醅醆醊醁醂醄醀鋐鋃鋄鋀鋙銶鋏鋱鋟鋘鋩鋗鋝鋌鋯鋂鋨鋊鋈鋎鋦鋍鋕鋉鋠鋞鋧鋑鋓����������������������������������銵鋡鋆銴镼閬閫閮閰隤隢雓霅霈霂靚鞊鞎鞈韐韏頞頝頦頩頨頠頛頧颲餈飺餑餔餖餗餕駜駍駏駓駔駎駉駖駘駋駗駌骳髬髫髳髲髱魆魃魧魴魱魦魶魵魰魨魤魬鳼鳺鳽鳿鳷鴇鴀鳹鳻鴈鴅鴄麃黓鼏鼐儜儓儗儚儑凞匴叡噰噠噮�".split(""), e = 0; e != r[232].length; ++e)
        r[232][e].charCodeAt(0) !== 65533 && (c[r[232][e]] = 59392 + e, o[59392 + e] = r[232][e]);
      for (r[233] = "����������������������������������������������������������������噳噦噣噭噲噞噷圜圛壈墽壉墿墺壂墼壆嬗嬙嬛嬡嬔嬓嬐嬖嬨嬚嬠嬞寯嶬嶱嶩嶧嶵嶰嶮嶪嶨嶲嶭嶯嶴幧幨幦幯廩廧廦廨廥彋徼憝憨憖懅憴懆懁懌憺����������������������������������憿憸憌擗擖擐擏擉撽撉擃擛擳擙攳敿敼斢曈暾曀曊曋曏暽暻暺曌朣樴橦橉橧樲橨樾橝橭橶橛橑樨橚樻樿橁橪橤橐橏橔橯橩橠樼橞橖橕橍橎橆歕歔歖殧殪殫毈毇氄氃氆澭濋澣濇澼濎濈潞濄澽澞濊澨瀄澥澮澺澬澪濏澿澸�".split(""), e = 0; e != r[233].length; ++e)
        r[233][e].charCodeAt(0) !== 65533 && (c[r[233][e]] = 59648 + e, o[59648 + e] = r[233][e]);
      for (r[234] = "����������������������������������������������������������������澢濉澫濍澯澲澰燅燂熿熸燖燀燁燋燔燊燇燏熽燘熼燆燚燛犝犞獩獦獧獬獥獫獪瑿璚璠璔璒璕璡甋疀瘯瘭瘱瘽瘳瘼瘵瘲瘰皻盦瞚瞝瞡瞜瞛瞢瞣瞕瞙����������������������������������瞗磝磩磥磪磞磣磛磡磢磭磟磠禤穄穈穇窶窸窵窱窷篞篣篧篝篕篥篚篨篹篔篪篢篜篫篘篟糒糔糗糐糑縒縡縗縌縟縠縓縎縜縕縚縢縋縏縖縍縔縥縤罃罻罼罺羱翯耪耩聬膱膦膮膹膵膫膰膬膴膲膷膧臲艕艖艗蕖蕅蕫蕍蕓蕡蕘�".split(""), e = 0; e != r[234].length; ++e)
        r[234][e].charCodeAt(0) !== 65533 && (c[r[234][e]] = 59904 + e, o[59904 + e] = r[234][e]);
      for (r[235] = "����������������������������������������������������������������蕀蕆蕤蕁蕢蕄蕑蕇蕣蔾蕛蕱蕎蕮蕵蕕蕧蕠薌蕦蕝蕔蕥蕬虣虥虤螛螏螗螓螒螈螁螖螘蝹螇螣螅螐螑螝螄螔螜螚螉褞褦褰褭褮褧褱褢褩褣褯褬褟觱諠����������������������������������諢諲諴諵諝謔諤諟諰諈諞諡諨諿諯諻貑貒貐賵賮賱賰賳赬赮趥趧踳踾踸蹀蹅踶踼踽蹁踰踿躽輶輮輵輲輹輷輴遶遹遻邆郺鄳鄵鄶醓醐醑醍醏錧錞錈錟錆錏鍺錸錼錛錣錒錁鍆錭錎錍鋋錝鋺錥錓鋹鋷錴錂錤鋿錩錹錵錪錔錌�".split(""), e = 0; e != r[235].length; ++e)
        r[235][e].charCodeAt(0) !== 65533 && (c[r[235][e]] = 60160 + e, o[60160 + e] = r[235][e]);
      for (r[236] = "����������������������������������������������������������������錋鋾錉錀鋻錖閼闍閾閹閺閶閿閵閽隩雔霋霒霐鞙鞗鞔韰韸頵頯頲餤餟餧餩馞駮駬駥駤駰駣駪駩駧骹骿骴骻髶髺髹髷鬳鮀鮅鮇魼魾魻鮂鮓鮒鮐魺鮕����������������������������������魽鮈鴥鴗鴠鴞鴔鴩鴝鴘鴢鴐鴙鴟麈麆麇麮麭黕黖黺鼒鼽儦儥儢儤儠儩勴嚓嚌嚍嚆嚄嚃噾嚂噿嚁壖壔壏壒嬭嬥嬲嬣嬬嬧嬦嬯嬮孻寱寲嶷幬幪徾徻懃憵憼懧懠懥懤懨懞擯擩擣擫擤擨斁斀斶旚曒檍檖檁檥檉檟檛檡檞檇檓檎�".split(""), e = 0; e != r[236].length; ++e)
        r[236][e].charCodeAt(0) !== 65533 && (c[r[236][e]] = 60416 + e, o[60416 + e] = r[236][e]);
      for (r[237] = "����������������������������������������������������������������檕檃檨檤檑橿檦檚檅檌檒歛殭氉濌澩濴濔濣濜濭濧濦濞濲濝濢濨燡燱燨燲燤燰燢獳獮獯璗璲璫璐璪璭璱璥璯甐甑甒甏疄癃癈癉癇皤盩瞵瞫瞲瞷瞶����������������������������������瞴瞱瞨矰磳磽礂磻磼磲礅磹磾礄禫禨穜穛穖穘穔穚窾竀竁簅簏篲簀篿篻簎篴簋篳簂簉簃簁篸篽簆篰篱簐簊糨縭縼繂縳顈縸縪繉繀繇縩繌縰縻縶繄縺罅罿罾罽翴翲耬膻臄臌臊臅臇膼臩艛艚艜薃薀薏薧薕薠薋薣蕻薤薚薞�".split(""), e = 0; e != r[237].length; ++e)
        r[237][e].charCodeAt(0) !== 65533 && (c[r[237][e]] = 60672 + e, o[60672 + e] = r[237][e]);
      for (r[238] = "����������������������������������������������������������������蕷蕼薉薡蕺蕸蕗薎薖薆薍薙薝薁薢薂薈薅蕹蕶薘薐薟虨螾螪螭蟅螰螬螹螵螼螮蟉蟃蟂蟌螷螯蟄蟊螴螶螿螸螽蟞螲褵褳褼褾襁襒褷襂覭覯覮觲觳謞����������������������������������謘謖謑謅謋謢謏謒謕謇謍謈謆謜謓謚豏豰豲豱豯貕貔賹赯蹎蹍蹓蹐蹌蹇轃轀邅遾鄸醚醢醛醙醟醡醝醠鎡鎃鎯鍤鍖鍇鍼鍘鍜鍶鍉鍐鍑鍠鍭鎏鍌鍪鍹鍗鍕鍒鍏鍱鍷鍻鍡鍞鍣鍧鎀鍎鍙闇闀闉闃闅閷隮隰隬霠霟霘霝霙鞚鞡鞜�".split(""), e = 0; e != r[238].length; ++e)
        r[238][e].charCodeAt(0) !== 65533 && (c[r[238][e]] = 60928 + e, o[60928 + e] = r[238][e]);
      for (r[239] = "����������������������������������������������������������������鞞鞝韕韔韱顁顄顊顉顅顃餥餫餬餪餳餲餯餭餱餰馘馣馡騂駺駴駷駹駸駶駻駽駾駼騃骾髾髽鬁髼魈鮚鮨鮞鮛鮦鮡鮥鮤鮆鮢鮠鮯鴳鵁鵧鴶鴮鴯鴱鴸鴰����������������������������������鵅鵂鵃鴾鴷鵀鴽翵鴭麊麉麍麰黈黚黻黿鼤鼣鼢齔龠儱儭儮嚘嚜嚗嚚嚝嚙奰嬼屩屪巀幭幮懘懟懭懮懱懪懰懫懖懩擿攄擽擸攁攃擼斔旛曚曛曘櫅檹檽櫡櫆檺檶檷櫇檴檭歞毉氋瀇瀌瀍瀁瀅瀔瀎濿瀀濻瀦濼濷瀊爁燿燹爃燽獶�".split(""), e = 0; e != r[239].length; ++e)
        r[239][e].charCodeAt(0) !== 65533 && (c[r[239][e]] = 61184 + e, o[61184 + e] = r[239][e]);
      for (r[240] = "����������������������������������������������������������������璸瓀璵瓁璾璶璻瓂甔甓癜癤癙癐癓癗癚皦皽盬矂瞺磿礌礓礔礉礐礒礑禭禬穟簜簩簙簠簟簭簝簦簨簢簥簰繜繐繖繣繘繢繟繑繠繗繓羵羳翷翸聵臑臒����������������������������������臐艟艞薴藆藀藃藂薳薵薽藇藄薿藋藎藈藅薱薶藒蘤薸薷薾虩蟧蟦蟢蟛蟫蟪蟥蟟蟳蟤蟔蟜蟓蟭蟘蟣螤蟗蟙蠁蟴蟨蟝襓襋襏襌襆襐襑襉謪謧謣謳謰謵譇謯謼謾謱謥謷謦謶謮謤謻謽謺豂豵貙貘貗賾贄贂贀蹜蹢蹠蹗蹖蹞蹥蹧�".split(""), e = 0; e != r[240].length; ++e)
        r[240][e].charCodeAt(0) !== 65533 && (c[r[240][e]] = 61440 + e, o[61440 + e] = r[240][e]);
      for (r[241] = "����������������������������������������������������������������蹛蹚蹡蹝蹩蹔轆轇轈轋鄨鄺鄻鄾醨醥醧醯醪鎵鎌鎒鎷鎛鎝鎉鎧鎎鎪鎞鎦鎕鎈鎙鎟鎍鎱鎑鎲鎤鎨鎴鎣鎥闒闓闑隳雗雚巂雟雘雝霣霢霥鞬鞮鞨鞫鞤鞪����������������������������������鞢鞥韗韙韖韘韺顐顑顒颸饁餼餺騏騋騉騍騄騑騊騅騇騆髀髜鬈鬄鬅鬩鬵魊魌魋鯇鯆鯃鮿鯁鮵鮸鯓鮶鯄鮹鮽鵜鵓鵏鵊鵛鵋鵙鵖鵌鵗鵒鵔鵟鵘鵚麎麌黟鼁鼀鼖鼥鼫鼪鼩鼨齌齕儴儵劖勷厴嚫嚭嚦嚧嚪嚬壚壝壛夒嬽嬾嬿巃幰�".split(""), e = 0; e != r[241].length; ++e)
        r[241][e].charCodeAt(0) !== 65533 && (c[r[241][e]] = 61696 + e, o[61696 + e] = r[241][e]);
      for (r[242] = "����������������������������������������������������������������徿懻攇攐攍攉攌攎斄旞旝曞櫧櫠櫌櫑櫙櫋櫟櫜櫐櫫櫏櫍櫞歠殰氌瀙瀧瀠瀖瀫瀡瀢瀣瀩瀗瀤瀜瀪爌爊爇爂爅犥犦犤犣犡瓋瓅璷瓃甖癠矉矊矄矱礝礛����������������������������������礡礜礗礞禰穧穨簳簼簹簬簻糬糪繶繵繸繰繷繯繺繲繴繨罋罊羃羆羷翽翾聸臗臕艤艡艣藫藱藭藙藡藨藚藗藬藲藸藘藟藣藜藑藰藦藯藞藢蠀蟺蠃蟶蟷蠉蠌蠋蠆蟼蠈蟿蠊蠂襢襚襛襗襡襜襘襝襙覈覷覶觶譐譈譊譀譓譖譔譋譕�".split(""), e = 0; e != r[242].length; ++e)
        r[242][e].charCodeAt(0) !== 65533 && (c[r[242][e]] = 61952 + e, o[61952 + e] = r[242][e]);
      for (r[243] = "����������������������������������������������������������������譑譂譒譗豃豷豶貚贆贇贉趬趪趭趫蹭蹸蹳蹪蹯蹻軂轒轑轏轐轓辴酀鄿醰醭鏞鏇鏏鏂鏚鏐鏹鏬鏌鏙鎩鏦鏊鏔鏮鏣鏕鏄鏎鏀鏒鏧镽闚闛雡霩霫霬霨霦����������������������������������鞳鞷鞶韝韞韟顜顙顝顗颿颽颻颾饈饇饃馦馧騚騕騥騝騤騛騢騠騧騣騞騜騔髂鬋鬊鬎鬌鬷鯪鯫鯠鯞鯤鯦鯢鯰鯔鯗鯬鯜鯙鯥鯕鯡鯚鵷鶁鶊鶄鶈鵱鶀鵸鶆鶋鶌鵽鵫鵴鵵鵰鵩鶅鵳鵻鶂鵯鵹鵿鶇鵨麔麑黀黼鼭齀齁齍齖齗齘匷嚲�".split(""), e = 0; e != r[243].length; ++e)
        r[243][e].charCodeAt(0) !== 65533 && (c[r[243][e]] = 62208 + e, o[62208 + e] = r[243][e]);
      for (r[244] = "����������������������������������������������������������������嚵嚳壣孅巆巇廮廯忀忁懹攗攖攕攓旟曨曣曤櫳櫰櫪櫨櫹櫱櫮櫯瀼瀵瀯瀷瀴瀱灂瀸瀿瀺瀹灀瀻瀳灁爓爔犨獽獼璺皫皪皾盭矌矎矏矍矲礥礣礧礨礤礩����������������������������������禲穮穬穭竷籉籈籊籇籅糮繻繾纁纀羺翿聹臛臙舋艨艩蘢藿蘁藾蘛蘀藶蘄蘉蘅蘌藽蠙蠐蠑蠗蠓蠖襣襦覹觷譠譪譝譨譣譥譧譭趮躆躈躄轙轖轗轕轘轚邍酃酁醷醵醲醳鐋鐓鏻鐠鐏鐔鏾鐕鐐鐨鐙鐍鏵鐀鏷鐇鐎鐖鐒鏺鐉鏸鐊鏿�".split(""), e = 0; e != r[244].length; ++e)
        r[244][e].charCodeAt(0) !== 65533 && (c[r[244][e]] = 62464 + e, o[62464 + e] = r[244][e]);
      for (r[245] = "����������������������������������������������������������������鏼鐌鏶鐑鐆闞闠闟霮霯鞹鞻韽韾顠顢顣顟飁飂饐饎饙饌饋饓騲騴騱騬騪騶騩騮騸騭髇髊髆鬐鬒鬑鰋鰈鯷鰅鰒鯸鱀鰇鰎鰆鰗鰔鰉鶟鶙鶤鶝鶒鶘鶐鶛����������������������������������鶠鶔鶜鶪鶗鶡鶚鶢鶨鶞鶣鶿鶩鶖鶦鶧麙麛麚黥黤黧黦鼰鼮齛齠齞齝齙龑儺儹劘劗囃嚽嚾孈孇巋巏廱懽攛欂櫼欃櫸欀灃灄灊灈灉灅灆爝爚爙獾甗癪矐礭礱礯籔籓糲纊纇纈纋纆纍罍羻耰臝蘘蘪蘦蘟蘣蘜蘙蘧蘮蘡蘠蘩蘞蘥�".split(""), e = 0; e != r[245].length; ++e)
        r[245][e].charCodeAt(0) !== 65533 && (c[r[245][e]] = 62720 + e, o[62720 + e] = r[245][e]);
      for (r[246] = "����������������������������������������������������������������蠩蠝蠛蠠蠤蠜蠫衊襭襩襮襫觺譹譸譅譺譻贐贔趯躎躌轞轛轝酆酄酅醹鐿鐻鐶鐩鐽鐼鐰鐹鐪鐷鐬鑀鐱闥闤闣霵霺鞿韡顤飉飆飀饘饖騹騽驆驄驂驁騺����������������������������������騿髍鬕鬗鬘鬖鬺魒鰫鰝鰜鰬鰣鰨鰩鰤鰡鶷鶶鶼鷁鷇鷊鷏鶾鷅鷃鶻鶵鷎鶹鶺鶬鷈鶱鶭鷌鶳鷍鶲鹺麜黫黮黭鼛鼘鼚鼱齎齥齤龒亹囆囅囋奱孋孌巕巑廲攡攠攦攢欋欈欉氍灕灖灗灒爞爟犩獿瓘瓕瓙瓗癭皭礵禴穰穱籗籜籙籛籚�".split(""), e = 0; e != r[246].length; ++e)
        r[246][e].charCodeAt(0) !== 65533 && (c[r[246][e]] = 62976 + e, o[62976 + e] = r[246][e]);
      for (r[247] = "����������������������������������������������������������������糴糱纑罏羇臞艫蘴蘵蘳蘬蘲蘶蠬蠨蠦蠪蠥襱覿覾觻譾讄讂讆讅譿贕躕躔躚躒躐躖躗轠轢酇鑌鑐鑊鑋鑏鑇鑅鑈鑉鑆霿韣顪顩飋饔饛驎驓驔驌驏驈驊����������������������������������驉驒驐髐鬙鬫鬻魖魕鱆鱈鰿鱄鰹鰳鱁鰼鰷鰴鰲鰽鰶鷛鷒鷞鷚鷋鷐鷜鷑鷟鷩鷙鷘鷖鷵鷕鷝麶黰鼵鼳鼲齂齫龕龢儽劙壨壧奲孍巘蠯彏戁戃戄攩攥斖曫欑欒欏毊灛灚爢玂玁玃癰矔籧籦纕艬蘺虀蘹蘼蘱蘻蘾蠰蠲蠮蠳襶襴襳觾�".split(""), e = 0; e != r[247].length; ++e)
        r[247][e].charCodeAt(0) !== 65533 && (c[r[247][e]] = 63232 + e, o[63232 + e] = r[247][e]);
      for (r[248] = "����������������������������������������������������������������讌讎讋讈豅贙躘轤轣醼鑢鑕鑝鑗鑞韄韅頀驖驙鬞鬟鬠鱒鱘鱐鱊鱍鱋鱕鱙鱌鱎鷻鷷鷯鷣鷫鷸鷤鷶鷡鷮鷦鷲鷰鷢鷬鷴鷳鷨鷭黂黐黲黳鼆鼜鼸鼷鼶齃齏����������������������������������齱齰齮齯囓囍孎屭攭曭曮欓灟灡灝灠爣瓛瓥矕礸禷禶籪纗羉艭虃蠸蠷蠵衋讔讕躞躟躠躝醾醽釂鑫鑨鑩雥靆靃靇韇韥驞髕魙鱣鱧鱦鱢鱞鱠鸂鷾鸇鸃鸆鸅鸀鸁鸉鷿鷽鸄麠鼞齆齴齵齶囔攮斸欘欙欗欚灢爦犪矘矙礹籩籫糶纚�".split(""), e = 0; e != r[248].length; ++e)
        r[248][e].charCodeAt(0) !== 65533 && (c[r[248][e]] = 63488 + e, o[63488 + e] = r[248][e]);
      for (r[249] = "����������������������������������������������������������������纘纛纙臠臡虆虇虈襹襺襼襻觿讘讙躥躤躣鑮鑭鑯鑱鑳靉顲饟鱨鱮鱭鸋鸍鸐鸏鸒鸑麡黵鼉齇齸齻齺齹圞灦籯蠼趲躦釃鑴鑸鑶鑵驠鱴鱳鱱鱵鸔鸓黶鼊����������������������������������龤灨灥糷虪蠾蠽蠿讞貜躩軉靋顳顴飌饡馫驤驦驧鬤鸕鸗齈戇欞爧虌躨钂钀钁驩驨鬮鸙爩虋讟钃鱹麷癵驫鱺鸝灩灪麤齾齉龘碁銹裏墻恒粧嫺╔╦╗╠╬╣╚╩╝╒╤╕╞╪╡╘╧╛╓╥╖╟╫╢╙╨╜║═╭╮╰╯▓�".split(""), e = 0; e != r[249].length; ++e)
        r[249][e].charCodeAt(0) !== 65533 && (c[r[249][e]] = 63744 + e, o[63744 + e] = r[249][e]);
      return { enc: c, dec: o };
    }(), i[1250] = function() {
      for (var o = `\0\x07\b	
\v\f\r\x1B !"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_\`abcdefghijklmnopqrstuvwxyz{|}~€�‚�„…†‡�‰Š‹ŚŤŽŹ�‘’“”•–—�™š›śťžź ˇ˘Ł¤Ą¦§¨©Ş«¬­®Ż°±˛ł´µ¶·¸ąş»Ľ˝ľżŔÁÂĂÄĹĆÇČÉĘËĚÍÎĎĐŃŇÓÔŐÖ×ŘŮÚŰÜÝŢßŕáâăäĺćçčéęëěíîďđńňóôőö÷řůúűüýţ˙`, c = [], r = {}, e = 0; e != o.length; ++e)
        o.charCodeAt(e) !== 65533 && (r[o.charAt(e)] = e), c[e] = o.charAt(e);
      return { enc: r, dec: c };
    }(), i[1251] = function() {
      for (var o = `\0\x07\b	
\v\f\r\x1B !"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_\`abcdefghijklmnopqrstuvwxyz{|}~ЂЃ‚ѓ„…†‡€‰Љ‹ЊЌЋЏђ‘’“”•–—�™љ›њќћџ ЎўЈ¤Ґ¦§Ё©Є«¬­®Ї°±Ііґµ¶·ё№є»јЅѕїАБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯабвгдежзийклмнопрстуфхцчшщъыьэюя`, c = [], r = {}, e = 0; e != o.length; ++e)
        o.charCodeAt(e) !== 65533 && (r[o.charAt(e)] = e), c[e] = o.charAt(e);
      return { enc: r, dec: c };
    }(), i[1252] = function() {
      for (var o = `\0\x07\b	
\v\f\r\x1B !"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_\`abcdefghijklmnopqrstuvwxyz{|}~€�‚ƒ„…†‡ˆ‰Š‹Œ�Ž��‘’“”•–—˜™š›œ�žŸ ¡¢£¤¥¦§¨©ª«¬­®¯°±²³´µ¶·¸¹º»¼½¾¿ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏÐÑÒÓÔÕÖ×ØÙÚÛÜÝÞßàáâãäåæçèéêëìíîïðñòóôõö÷øùúûüýþÿ`, c = [], r = {}, e = 0; e != o.length; ++e)
        o.charCodeAt(e) !== 65533 && (r[o.charAt(e)] = e), c[e] = o.charAt(e);
      return { enc: r, dec: c };
    }(), i[1253] = function() {
      for (var o = `\0\x07\b	
\v\f\r\x1B !"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_\`abcdefghijklmnopqrstuvwxyz{|}~€�‚ƒ„…†‡�‰�‹�����‘’“”•–—�™�›���� ΅Ά£¤¥¦§¨©�«¬­®―°±²³΄µ¶·ΈΉΊ»Ό½ΎΏΐΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡ�ΣΤΥΦΧΨΩΪΫάέήίΰαβγδεζηθικλμνξοπρςστυφχψωϊϋόύώ�`, c = [], r = {}, e = 0; e != o.length; ++e)
        o.charCodeAt(e) !== 65533 && (r[o.charAt(e)] = e), c[e] = o.charAt(e);
      return { enc: r, dec: c };
    }(), i[1254] = function() {
      for (var o = `\0\x07\b	
\v\f\r\x1B !"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_\`abcdefghijklmnopqrstuvwxyz{|}~€�‚ƒ„…†‡ˆ‰Š‹Œ����‘’“”•–—˜™š›œ��Ÿ ¡¢£¤¥¦§¨©ª«¬­®¯°±²³´µ¶·¸¹º»¼½¾¿ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏĞÑÒÓÔÕÖ×ØÙÚÛÜİŞßàáâãäåæçèéêëìíîïğñòóôõö÷øùúûüışÿ`, c = [], r = {}, e = 0; e != o.length; ++e)
        o.charCodeAt(e) !== 65533 && (r[o.charAt(e)] = e), c[e] = o.charAt(e);
      return { enc: r, dec: c };
    }(), i[1255] = function() {
      for (var o = `\0\x07\b	
\v\f\r\x1B !"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_\`abcdefghijklmnopqrstuvwxyz{|}~€�‚ƒ„…†‡ˆ‰�‹�����‘’“”•–—˜™�›���� ¡¢£₪¥¦§¨©×«¬­®¯°±²³´µ¶·¸¹÷»¼½¾¿ְֱֲֳִֵֶַָֹ�ֻּֽ־ֿ׀ׁׂ׃װױײ׳״�������אבגדהוזחטיךכלםמןנסעףפץצקרשת��‎‏�`, c = [], r = {}, e = 0; e != o.length; ++e)
        o.charCodeAt(e) !== 65533 && (r[o.charAt(e)] = e), c[e] = o.charAt(e);
      return { enc: r, dec: c };
    }(), i[1256] = function() {
      for (var o = `\0\x07\b	
\v\f\r\x1B !"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_\`abcdefghijklmnopqrstuvwxyz{|}~€پ‚ƒ„…†‡ˆ‰ٹ‹Œچژڈگ‘’“”•–—ک™ڑ›œ‌‍ں ،¢£¤¥¦§¨©ھ«¬­®¯°±²³´µ¶·¸¹؛»¼½¾؟ہءآأؤإئابةتثجحخدذرزسشصض×طظعغـفقكàلâمنهوçèéêëىيîïًٌٍَôُِ÷ّùْûü‎‏ے`, c = [], r = {}, e = 0; e != o.length; ++e)
        o.charCodeAt(e) !== 65533 && (r[o.charAt(e)] = e), c[e] = o.charAt(e);
      return { enc: r, dec: c };
    }(), i[1257] = function() {
      for (var o = `\0\x07\b	
\v\f\r\x1B !"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_\`abcdefghijklmnopqrstuvwxyz{|}~€�‚�„…†‡�‰�‹�¨ˇ¸�‘’“”•–—�™�›�¯˛� �¢£¤�¦§Ø©Ŗ«¬­®Æ°±²³´µ¶·ø¹ŗ»¼½¾æĄĮĀĆÄÅĘĒČÉŹĖĢĶĪĻŠŃŅÓŌÕÖ×ŲŁŚŪÜŻŽßąįāćäåęēčéźėģķīļšńņóōõö÷ųłśūüżž˙`, c = [], r = {}, e = 0; e != o.length; ++e)
        o.charCodeAt(e) !== 65533 && (r[o.charAt(e)] = e), c[e] = o.charAt(e);
      return { enc: r, dec: c };
    }(), i[1258] = function() {
      for (var o = `\0\x07\b	
\v\f\r\x1B !"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_\`abcdefghijklmnopqrstuvwxyz{|}~€�‚ƒ„…†‡ˆ‰�‹Œ����‘’“”•–—˜™�›œ��Ÿ ¡¢£¤¥¦§¨©ª«¬­®¯°±²³´µ¶·¸¹º»¼½¾¿ÀÁÂĂÄÅÆÇÈÉÊË̀ÍÎÏĐÑ̉ÓÔƠÖ×ØÙÚÛÜỮßàáâăäåæçèéêë́íîïđṇ̃óôơö÷øùúûüư₫ÿ`, c = [], r = {}, e = 0; e != o.length; ++e)
        o.charCodeAt(e) !== 65533 && (r[o.charAt(e)] = e), c[e] = o.charAt(e);
      return { enc: r, dec: c };
    }(), i[1e4] = function() {
      for (var o = `\0\x07\b	
\v\f\r\x1B !"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_\`abcdefghijklmnopqrstuvwxyz{|}~ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûü†°¢£§•¶ß®©™´¨≠ÆØ∞±≤≥¥µ∂∑∏π∫ªºΩæø¿¡¬√ƒ≈∆«»… ÀÃÕŒœ–—“”‘’÷◊ÿŸ⁄¤‹›ﬁﬂ‡·‚„‰ÂÊÁËÈÍÎÏÌÓÔ�ÒÚÛÙıˆ˜¯˘˙˚¸˝˛ˇ`, c = [], r = {}, e = 0; e != o.length; ++e)
        o.charCodeAt(e) !== 65533 && (r[o.charAt(e)] = e), c[e] = o.charAt(e);
      return { enc: r, dec: c };
    }(), i[10006] = function() {
      for (var o = `\0\x07\b	
\v\f\r\x1B !"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_\`abcdefghijklmnopqrstuvwxyz{|}~Ä¹²É³ÖÜ΅àâä΄¨çéèêë£™îï•½‰ôö¦­ùûü†ΓΔΘΛΞΠß®©ΣΪ§≠°·Α±≤≥¥ΒΕΖΗΙΚΜΦΫΨΩάΝ¬ΟΡ≈Τ«»… ΥΧΆΈœ–―“”‘’÷ΉΊΌΎέήίόΏύαβψδεφγηιξκλμνοπώρστθωςχυζϊϋΐΰ�`, c = [], r = {}, e = 0; e != o.length; ++e)
        o.charCodeAt(e) !== 65533 && (r[o.charAt(e)] = e), c[e] = o.charAt(e);
      return { enc: r, dec: c };
    }(), i[10007] = function() {
      for (var o = `\0\x07\b	
\v\f\r\x1B !"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_\`abcdefghijklmnopqrstuvwxyz{|}~АБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯ†°¢£§•¶І®©™Ђђ≠Ѓѓ∞±≤≥іµ∂ЈЄєЇїЉљЊњјЅ¬√ƒ≈∆«»… ЋћЌќѕ–—“”‘’÷„ЎўЏџ№Ёёяабвгдежзийклмнопрстуфхцчшщъыьэю¤`, c = [], r = {}, e = 0; e != o.length; ++e)
        o.charCodeAt(e) !== 65533 && (r[o.charAt(e)] = e), c[e] = o.charAt(e);
      return { enc: r, dec: c };
    }(), i[10008] = function() {
      var o = [], c = {}, r = [], e;
      for (r[0] = `\0\x07\b	
\v\f\r\x1B !"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_\`abcdefghijklmnopqrstuvwxyz{|}~���������������������������������������������������������������������������������������`.split(""), e = 0; e != r[0].length; ++e)
        r[0][e].charCodeAt(0) !== 65533 && (c[r[0][e]] = 0 + e, o[0 + e] = r[0][e]);
      for (r[161] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������　、。・ˉˇ¨〃々―～�…‘’“”〔〕〈〉《》「」『』〖〗【】±×÷∶∧∨∑∏∪∩∈∷√⊥∥∠⌒⊙∫∮≡≌≈∽∝≠≮≯≤≥∞∵∴♂♀°′″℃＄¤￠￡‰§№☆★○●◎◇◆□■△▲※→←↑↓〓�".split(""), e = 0; e != r[161].length; ++e)
        r[161][e].charCodeAt(0) !== 65533 && (c[r[161][e]] = 41216 + e, o[41216 + e] = r[161][e]);
      for (r[162] = "���������������������������������������������������������������������������������������������������������������������������������������������������������������������������������⒈⒉⒊⒋⒌⒍⒎⒏⒐⒑⒒⒓⒔⒕⒖⒗⒘⒙⒚⒛⑴⑵⑶⑷⑸⑹⑺⑻⑼⑽⑾⑿⒀⒁⒂⒃⒄⒅⒆⒇①②③④⑤⑥⑦⑧⑨⑩��㈠㈡㈢㈣㈤㈥㈦㈧㈨㈩��ⅠⅡⅢⅣⅤⅥⅦⅧⅨⅩⅪⅫ���".split(""), e = 0; e != r[162].length; ++e)
        r[162][e].charCodeAt(0) !== 65533 && (c[r[162][e]] = 41472 + e, o[41472 + e] = r[162][e]);
      for (r[163] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������！＂＃￥％＆＇（）＊＋，－．／０１２３４５６７８９：；＜＝＞？＠ＡＢＣＤＥＦＧＨＩＪＫＬＭＮＯＰＱＲＳＴＵＶＷＸＹＺ［＼］＾＿｀ａｂｃｄｅｆｇｈｉｊｋｌｍｎｏｐｑｒｓｔｕｖｗｘｙｚ｛｜｝￣�".split(""), e = 0; e != r[163].length; ++e)
        r[163][e].charCodeAt(0) !== 65533 && (c[r[163][e]] = 41728 + e, o[41728 + e] = r[163][e]);
      for (r[164] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������ぁあぃいぅうぇえぉおかがきぎくぐけげこごさざしじすずせぜそぞただちぢっつづてでとどなにぬねのはばぱひびぴふぶぷへべぺほぼぽまみむめもゃやゅゆょよらりるれろゎわゐゑをん������������".split(""), e = 0; e != r[164].length; ++e)
        r[164][e].charCodeAt(0) !== 65533 && (c[r[164][e]] = 41984 + e, o[41984 + e] = r[164][e]);
      for (r[165] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������ァアィイゥウェエォオカガキギクグケゲコゴサザシジスズセゼソゾタダチヂッツヅテデトドナニヌネノハバパヒビピフブプヘベペホボポマミムメモャヤュユョヨラリルレロヮワヰヱヲンヴヵヶ���������".split(""), e = 0; e != r[165].length; ++e)
        r[165][e].charCodeAt(0) !== 65533 && (c[r[165][e]] = 42240 + e, o[42240 + e] = r[165][e]);
      for (r[166] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������ΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡΣΤΥΦΧΨΩ��������αβγδεζηθικλμνξοπρστυφχψω���������������������������������������".split(""), e = 0; e != r[166].length; ++e)
        r[166][e].charCodeAt(0) !== 65533 && (c[r[166][e]] = 42496 + e, o[42496 + e] = r[166][e]);
      for (r[167] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������АБВГДЕЁЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯ���������������абвгдеёжзийклмнопрстуфхцчшщъыьэюя��������������".split(""), e = 0; e != r[167].length; ++e)
        r[167][e].charCodeAt(0) !== 65533 && (c[r[167][e]] = 42752 + e, o[42752 + e] = r[167][e]);
      for (r[168] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������āáǎàēéěèīíǐìōóǒòūúǔùǖǘǚǜüê����������ㄅㄆㄇㄈㄉㄊㄋㄌㄍㄎㄏㄐㄑㄒㄓㄔㄕㄖㄗㄘㄙㄚㄛㄜㄝㄞㄟㄠㄡㄢㄣㄤㄥㄦㄧㄨㄩ����������������������".split(""), e = 0; e != r[168].length; ++e)
        r[168][e].charCodeAt(0) !== 65533 && (c[r[168][e]] = 43008 + e, o[43008 + e] = r[168][e]);
      for (r[169] = "��������������������������������������������������������������������������������������������������������������������������������������������������������������������─━│┃┄┅┆┇┈┉┊┋┌┍┎┏┐┑┒┓└┕┖┗┘┙┚┛├┝┞┟┠┡┢┣┤┥┦┧┨┩┪┫┬┭┮┯┰┱┲┳┴┵┶┷┸┹┺┻┼┽┾┿╀╁╂╃╄╅╆╇╈╉╊╋����������������".split(""), e = 0; e != r[169].length; ++e)
        r[169][e].charCodeAt(0) !== 65533 && (c[r[169][e]] = 43264 + e, o[43264 + e] = r[169][e]);
      for (r[176] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������啊阿埃挨哎唉哀皑癌蔼矮艾碍爱隘鞍氨安俺按暗岸胺案肮昂盎凹敖熬翱袄傲奥懊澳芭捌扒叭吧笆八疤巴拔跋靶把耙坝霸罢爸白柏百摆佰败拜稗斑班搬扳般颁板版扮拌伴瓣半办绊邦帮梆榜膀绑棒磅蚌镑傍谤苞胞包褒剥�".split(""), e = 0; e != r[176].length; ++e)
        r[176][e].charCodeAt(0) !== 65533 && (c[r[176][e]] = 45056 + e, o[45056 + e] = r[176][e]);
      for (r[177] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������薄雹保堡饱宝抱报暴豹鲍爆杯碑悲卑北辈背贝钡倍狈备惫焙被奔苯本笨崩绷甭泵蹦迸逼鼻比鄙笔彼碧蓖蔽毕毙毖币庇痹闭敝弊必辟壁臂避陛鞭边编贬扁便变卞辨辩辫遍标彪膘表鳖憋别瘪彬斌濒滨宾摈兵冰柄丙秉饼炳�".split(""), e = 0; e != r[177].length; ++e)
        r[177][e].charCodeAt(0) !== 65533 && (c[r[177][e]] = 45312 + e, o[45312 + e] = r[177][e]);
      for (r[178] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������病并玻菠播拨钵波博勃搏铂箔伯帛舶脖膊渤泊驳捕卜哺补埠不布步簿部怖擦猜裁材才财睬踩采彩菜蔡餐参蚕残惭惨灿苍舱仓沧藏操糙槽曹草厕策侧册测层蹭插叉茬茶查碴搽察岔差诧拆柴豺搀掺蝉馋谗缠铲产阐颤昌猖�".split(""), e = 0; e != r[178].length; ++e)
        r[178][e].charCodeAt(0) !== 65533 && (c[r[178][e]] = 45568 + e, o[45568 + e] = r[178][e]);
      for (r[179] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������场尝常长偿肠厂敞畅唱倡超抄钞朝嘲潮巢吵炒车扯撤掣彻澈郴臣辰尘晨忱沉陈趁衬撑称城橙成呈乘程惩澄诚承逞骋秤吃痴持匙池迟弛驰耻齿侈尺赤翅斥炽充冲虫崇宠抽酬畴踌稠愁筹仇绸瞅丑臭初出橱厨躇锄雏滁除楚�".split(""), e = 0; e != r[179].length; ++e)
        r[179][e].charCodeAt(0) !== 65533 && (c[r[179][e]] = 45824 + e, o[45824 + e] = r[179][e]);
      for (r[180] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������础储矗搐触处揣川穿椽传船喘串疮窗幢床闯创吹炊捶锤垂春椿醇唇淳纯蠢戳绰疵茨磁雌辞慈瓷词此刺赐次聪葱囱匆从丛凑粗醋簇促蹿篡窜摧崔催脆瘁粹淬翠村存寸磋撮搓措挫错搭达答瘩打大呆歹傣戴带殆代贷袋待逮�".split(""), e = 0; e != r[180].length; ++e)
        r[180][e].charCodeAt(0) !== 65533 && (c[r[180][e]] = 46080 + e, o[46080 + e] = r[180][e]);
      for (r[181] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������怠耽担丹单郸掸胆旦氮但惮淡诞弹蛋当挡党荡档刀捣蹈倒岛祷导到稻悼道盗德得的蹬灯登等瞪凳邓堤低滴迪敌笛狄涤翟嫡抵底地蒂第帝弟递缔颠掂滇碘点典靛垫电佃甸店惦奠淀殿碉叼雕凋刁掉吊钓调跌爹碟蝶迭谍叠�".split(""), e = 0; e != r[181].length; ++e)
        r[181][e].charCodeAt(0) !== 65533 && (c[r[181][e]] = 46336 + e, o[46336 + e] = r[181][e]);
      for (r[182] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������丁盯叮钉顶鼎锭定订丢东冬董懂动栋侗恫冻洞兜抖斗陡豆逗痘都督毒犊独读堵睹赌杜镀肚度渡妒端短锻段断缎堆兑队对墩吨蹲敦顿囤钝盾遁掇哆多夺垛躲朵跺舵剁惰堕蛾峨鹅俄额讹娥恶厄扼遏鄂饿恩而儿耳尔饵洱二�".split(""), e = 0; e != r[182].length; ++e)
        r[182][e].charCodeAt(0) !== 65533 && (c[r[182][e]] = 46592 + e, o[46592 + e] = r[182][e]);
      for (r[183] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������贰发罚筏伐乏阀法珐藩帆番翻樊矾钒繁凡烦反返范贩犯饭泛坊芳方肪房防妨仿访纺放菲非啡飞肥匪诽吠肺废沸费芬酚吩氛分纷坟焚汾粉奋份忿愤粪丰封枫蜂峰锋风疯烽逢冯缝讽奉凤佛否夫敷肤孵扶拂辐幅氟符伏俘服�".split(""), e = 0; e != r[183].length; ++e)
        r[183][e].charCodeAt(0) !== 65533 && (c[r[183][e]] = 46848 + e, o[46848 + e] = r[183][e]);
      for (r[184] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������浮涪福袱弗甫抚辅俯釜斧脯腑府腐赴副覆赋复傅付阜父腹负富讣附妇缚咐噶嘎该改概钙盖溉干甘杆柑竿肝赶感秆敢赣冈刚钢缸肛纲岗港杠篙皋高膏羔糕搞镐稿告哥歌搁戈鸽胳疙割革葛格蛤阁隔铬个各给根跟耕更庚羹�".split(""), e = 0; e != r[184].length; ++e)
        r[184][e].charCodeAt(0) !== 65533 && (c[r[184][e]] = 47104 + e, o[47104 + e] = r[184][e]);
      for (r[185] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������埂耿梗工攻功恭龚供躬公宫弓巩汞拱贡共钩勾沟苟狗垢构购够辜菇咕箍估沽孤姑鼓古蛊骨谷股故顾固雇刮瓜剐寡挂褂乖拐怪棺关官冠观管馆罐惯灌贯光广逛瑰规圭硅归龟闺轨鬼诡癸桂柜跪贵刽辊滚棍锅郭国果裹过哈�".split(""), e = 0; e != r[185].length; ++e)
        r[185][e].charCodeAt(0) !== 65533 && (c[r[185][e]] = 47360 + e, o[47360 + e] = r[185][e]);
      for (r[186] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������骸孩海氦亥害骇酣憨邯韩含涵寒函喊罕翰撼捍旱憾悍焊汗汉夯杭航壕嚎豪毫郝好耗号浩呵喝荷菏核禾和何合盒貉阂河涸赫褐鹤贺嘿黑痕很狠恨哼亨横衡恒轰哄烘虹鸿洪宏弘红喉侯猴吼厚候后呼乎忽瑚壶葫胡蝴狐糊湖�".split(""), e = 0; e != r[186].length; ++e)
        r[186][e].charCodeAt(0) !== 65533 && (c[r[186][e]] = 47616 + e, o[47616 + e] = r[186][e]);
      for (r[187] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������弧虎唬护互沪户花哗华猾滑画划化话槐徊怀淮坏欢环桓还缓换患唤痪豢焕涣宦幻荒慌黄磺蝗簧皇凰惶煌晃幌恍谎灰挥辉徽恢蛔回毁悔慧卉惠晦贿秽会烩汇讳诲绘荤昏婚魂浑混豁活伙火获或惑霍货祸击圾基机畸稽积箕�".split(""), e = 0; e != r[187].length; ++e)
        r[187][e].charCodeAt(0) !== 65533 && (c[r[187][e]] = 47872 + e, o[47872 + e] = r[187][e]);
      for (r[188] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������肌饥迹激讥鸡姬绩缉吉极棘辑籍集及急疾汲即嫉级挤几脊己蓟技冀季伎祭剂悸济寄寂计记既忌际妓继纪嘉枷夹佳家加荚颊贾甲钾假稼价架驾嫁歼监坚尖笺间煎兼肩艰奸缄茧检柬碱硷拣捡简俭剪减荐槛鉴践贱见键箭件�".split(""), e = 0; e != r[188].length; ++e)
        r[188][e].charCodeAt(0) !== 65533 && (c[r[188][e]] = 48128 + e, o[48128 + e] = r[188][e]);
      for (r[189] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������健舰剑饯渐溅涧建僵姜将浆江疆蒋桨奖讲匠酱降蕉椒礁焦胶交郊浇骄娇嚼搅铰矫侥脚狡角饺缴绞剿教酵轿较叫窖揭接皆秸街阶截劫节桔杰捷睫竭洁结解姐戒藉芥界借介疥诫届巾筋斤金今津襟紧锦仅谨进靳晋禁近烬浸�".split(""), e = 0; e != r[189].length; ++e)
        r[189][e].charCodeAt(0) !== 65533 && (c[r[189][e]] = 48384 + e, o[48384 + e] = r[189][e]);
      for (r[190] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������尽劲荆兢茎睛晶鲸京惊精粳经井警景颈静境敬镜径痉靖竟竞净炯窘揪究纠玖韭久灸九酒厩救旧臼舅咎就疚鞠拘狙疽居驹菊局咀矩举沮聚拒据巨具距踞锯俱句惧炬剧捐鹃娟倦眷卷绢撅攫抉掘倔爵觉决诀绝均菌钧军君峻�".split(""), e = 0; e != r[190].length; ++e)
        r[190][e].charCodeAt(0) !== 65533 && (c[r[190][e]] = 48640 + e, o[48640 + e] = r[190][e]);
      for (r[191] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������俊竣浚郡骏喀咖卡咯开揩楷凯慨刊堪勘坎砍看康慷糠扛抗亢炕考拷烤靠坷苛柯棵磕颗科壳咳可渴克刻客课肯啃垦恳坑吭空恐孔控抠口扣寇枯哭窟苦酷库裤夸垮挎跨胯块筷侩快宽款匡筐狂框矿眶旷况亏盔岿窥葵奎魁傀�".split(""), e = 0; e != r[191].length; ++e)
        r[191][e].charCodeAt(0) !== 65533 && (c[r[191][e]] = 48896 + e, o[48896 + e] = r[191][e]);
      for (r[192] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������馈愧溃坤昆捆困括扩廓阔垃拉喇蜡腊辣啦莱来赖蓝婪栏拦篮阑兰澜谰揽览懒缆烂滥琅榔狼廊郎朗浪捞劳牢老佬姥酪烙涝勒乐雷镭蕾磊累儡垒擂肋类泪棱楞冷厘梨犁黎篱狸离漓理李里鲤礼莉荔吏栗丽厉励砾历利傈例俐�".split(""), e = 0; e != r[192].length; ++e)
        r[192][e].charCodeAt(0) !== 65533 && (c[r[192][e]] = 49152 + e, o[49152 + e] = r[192][e]);
      for (r[193] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������痢立粒沥隶力璃哩俩联莲连镰廉怜涟帘敛脸链恋炼练粮凉梁粱良两辆量晾亮谅撩聊僚疗燎寥辽潦了撂镣廖料列裂烈劣猎琳林磷霖临邻鳞淋凛赁吝拎玲菱零龄铃伶羚凌灵陵岭领另令溜琉榴硫馏留刘瘤流柳六龙聋咙笼窿�".split(""), e = 0; e != r[193].length; ++e)
        r[193][e].charCodeAt(0) !== 65533 && (c[r[193][e]] = 49408 + e, o[49408 + e] = r[193][e]);
      for (r[194] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������隆垄拢陇楼娄搂篓漏陋芦卢颅庐炉掳卤虏鲁麓碌露路赂鹿潞禄录陆戮驴吕铝侣旅履屡缕虑氯律率滤绿峦挛孪滦卵乱掠略抡轮伦仑沦纶论萝螺罗逻锣箩骡裸落洛骆络妈麻玛码蚂马骂嘛吗埋买麦卖迈脉瞒馒蛮满蔓曼慢漫�".split(""), e = 0; e != r[194].length; ++e)
        r[194][e].charCodeAt(0) !== 65533 && (c[r[194][e]] = 49664 + e, o[49664 + e] = r[194][e]);
      for (r[195] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������谩芒茫盲氓忙莽猫茅锚毛矛铆卯茂冒帽貌贸么玫枚梅酶霉煤没眉媒镁每美昧寐妹媚门闷们萌蒙檬盟锰猛梦孟眯醚靡糜迷谜弥米秘觅泌蜜密幂棉眠绵冕免勉娩缅面苗描瞄藐秒渺庙妙蔑灭民抿皿敏悯闽明螟鸣铭名命谬摸�".split(""), e = 0; e != r[195].length; ++e)
        r[195][e].charCodeAt(0) !== 65533 && (c[r[195][e]] = 49920 + e, o[49920 + e] = r[195][e]);
      for (r[196] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������摹蘑模膜磨摩魔抹末莫墨默沫漠寞陌谋牟某拇牡亩姆母墓暮幕募慕木目睦牧穆拿哪呐钠那娜纳氖乃奶耐奈南男难囊挠脑恼闹淖呢馁内嫩能妮霓倪泥尼拟你匿腻逆溺蔫拈年碾撵捻念娘酿鸟尿捏聂孽啮镊镍涅您柠狞凝宁�".split(""), e = 0; e != r[196].length; ++e)
        r[196][e].charCodeAt(0) !== 65533 && (c[r[196][e]] = 50176 + e, o[50176 + e] = r[196][e]);
      for (r[197] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������拧泞牛扭钮纽脓浓农弄奴努怒女暖虐疟挪懦糯诺哦欧鸥殴藕呕偶沤啪趴爬帕怕琶拍排牌徘湃派攀潘盘磐盼畔判叛乓庞旁耪胖抛咆刨炮袍跑泡呸胚培裴赔陪配佩沛喷盆砰抨烹澎彭蓬棚硼篷膨朋鹏捧碰坯砒霹批披劈琵毗�".split(""), e = 0; e != r[197].length; ++e)
        r[197][e].charCodeAt(0) !== 65533 && (c[r[197][e]] = 50432 + e, o[50432 + e] = r[197][e]);
      for (r[198] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������啤脾疲皮匹痞僻屁譬篇偏片骗飘漂瓢票撇瞥拼频贫品聘乒坪苹萍平凭瓶评屏坡泼颇婆破魄迫粕剖扑铺仆莆葡菩蒲埔朴圃普浦谱曝瀑期欺栖戚妻七凄漆柒沏其棋奇歧畦崎脐齐旗祈祁骑起岂乞企启契砌器气迄弃汽泣讫掐�".split(""), e = 0; e != r[198].length; ++e)
        r[198][e].charCodeAt(0) !== 65533 && (c[r[198][e]] = 50688 + e, o[50688 + e] = r[198][e]);
      for (r[199] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������恰洽牵扦钎铅千迁签仟谦乾黔钱钳前潜遣浅谴堑嵌欠歉枪呛腔羌墙蔷强抢橇锹敲悄桥瞧乔侨巧鞘撬翘峭俏窍切茄且怯窃钦侵亲秦琴勤芹擒禽寝沁青轻氢倾卿清擎晴氰情顷请庆琼穷秋丘邱球求囚酋泅趋区蛆曲躯屈驱渠�".split(""), e = 0; e != r[199].length; ++e)
        r[199][e].charCodeAt(0) !== 65533 && (c[r[199][e]] = 50944 + e, o[50944 + e] = r[199][e]);
      for (r[200] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������取娶龋趣去圈颧权醛泉全痊拳犬券劝缺炔瘸却鹊榷确雀裙群然燃冉染瓤壤攘嚷让饶扰绕惹热壬仁人忍韧任认刃妊纫扔仍日戎茸蓉荣融熔溶容绒冗揉柔肉茹蠕儒孺如辱乳汝入褥软阮蕊瑞锐闰润若弱撒洒萨腮鳃塞赛三叁�".split(""), e = 0; e != r[200].length; ++e)
        r[200][e].charCodeAt(0) !== 65533 && (c[r[200][e]] = 51200 + e, o[51200 + e] = r[200][e]);
      for (r[201] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������伞散桑嗓丧搔骚扫嫂瑟色涩森僧莎砂杀刹沙纱傻啥煞筛晒珊苫杉山删煽衫闪陕擅赡膳善汕扇缮墒伤商赏晌上尚裳梢捎稍烧芍勺韶少哨邵绍奢赊蛇舌舍赦摄射慑涉社设砷申呻伸身深娠绅神沈审婶甚肾慎渗声生甥牲升绳�".split(""), e = 0; e != r[201].length; ++e)
        r[201][e].charCodeAt(0) !== 65533 && (c[r[201][e]] = 51456 + e, o[51456 + e] = r[201][e]);
      for (r[202] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������省盛剩胜圣师失狮施湿诗尸虱十石拾时什食蚀实识史矢使屎驶始式示士世柿事拭誓逝势是嗜噬适仕侍释饰氏市恃室视试收手首守寿授售受瘦兽蔬枢梳殊抒输叔舒淑疏书赎孰熟薯暑曙署蜀黍鼠属术述树束戍竖墅庶数漱�".split(""), e = 0; e != r[202].length; ++e)
        r[202][e].charCodeAt(0) !== 65533 && (c[r[202][e]] = 51712 + e, o[51712 + e] = r[202][e]);
      for (r[203] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������恕刷耍摔衰甩帅栓拴霜双爽谁水睡税吮瞬顺舜说硕朔烁斯撕嘶思私司丝死肆寺嗣四伺似饲巳松耸怂颂送宋讼诵搜艘擞嗽苏酥俗素速粟僳塑溯宿诉肃酸蒜算虽隋随绥髓碎岁穗遂隧祟孙损笋蓑梭唆缩琐索锁所塌他它她塔�".split(""), e = 0; e != r[203].length; ++e)
        r[203][e].charCodeAt(0) !== 65533 && (c[r[203][e]] = 51968 + e, o[51968 + e] = r[203][e]);
      for (r[204] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������獭挞蹋踏胎苔抬台泰酞太态汰坍摊贪瘫滩坛檀痰潭谭谈坦毯袒碳探叹炭汤塘搪堂棠膛唐糖倘躺淌趟烫掏涛滔绦萄桃逃淘陶讨套特藤腾疼誊梯剔踢锑提题蹄啼体替嚏惕涕剃屉天添填田甜恬舔腆挑条迢眺跳贴铁帖厅听烃�".split(""), e = 0; e != r[204].length; ++e)
        r[204][e].charCodeAt(0) !== 65533 && (c[r[204][e]] = 52224 + e, o[52224 + e] = r[204][e]);
      for (r[205] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������汀廷停亭庭挺艇通桐酮瞳同铜彤童桶捅筒统痛偷投头透凸秃突图徒途涂屠土吐兔湍团推颓腿蜕褪退吞屯臀拖托脱鸵陀驮驼椭妥拓唾挖哇蛙洼娃瓦袜歪外豌弯湾玩顽丸烷完碗挽晚皖惋宛婉万腕汪王亡枉网往旺望忘妄威�".split(""), e = 0; e != r[205].length; ++e)
        r[205][e].charCodeAt(0) !== 65533 && (c[r[205][e]] = 52480 + e, o[52480 + e] = r[205][e]);
      for (r[206] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������巍微危韦违桅围唯惟为潍维苇萎委伟伪尾纬未蔚味畏胃喂魏位渭谓尉慰卫瘟温蚊文闻纹吻稳紊问嗡翁瓮挝蜗涡窝我斡卧握沃巫呜钨乌污诬屋无芜梧吾吴毋武五捂午舞伍侮坞戊雾晤物勿务悟误昔熙析西硒矽晰嘻吸锡牺�".split(""), e = 0; e != r[206].length; ++e)
        r[206][e].charCodeAt(0) !== 65533 && (c[r[206][e]] = 52736 + e, o[52736 + e] = r[206][e]);
      for (r[207] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������稀息希悉膝夕惜熄烯溪汐犀檄袭席习媳喜铣洗系隙戏细瞎虾匣霞辖暇峡侠狭下厦夏吓掀锨先仙鲜纤咸贤衔舷闲涎弦嫌显险现献县腺馅羡宪陷限线相厢镶香箱襄湘乡翔祥详想响享项巷橡像向象萧硝霄削哮嚣销消宵淆晓�".split(""), e = 0; e != r[207].length; ++e)
        r[207][e].charCodeAt(0) !== 65533 && (c[r[207][e]] = 52992 + e, o[52992 + e] = r[207][e]);
      for (r[208] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������小孝校肖啸笑效楔些歇蝎鞋协挟携邪斜胁谐写械卸蟹懈泄泻谢屑薪芯锌欣辛新忻心信衅星腥猩惺兴刑型形邢行醒幸杏性姓兄凶胸匈汹雄熊休修羞朽嗅锈秀袖绣墟戌需虚嘘须徐许蓄酗叙旭序畜恤絮婿绪续轩喧宣悬旋玄�".split(""), e = 0; e != r[208].length; ++e)
        r[208][e].charCodeAt(0) !== 65533 && (c[r[208][e]] = 53248 + e, o[53248 + e] = r[208][e]);
      for (r[209] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������选癣眩绚靴薛学穴雪血勋熏循旬询寻驯巡殉汛训讯逊迅压押鸦鸭呀丫芽牙蚜崖衙涯雅哑亚讶焉咽阉烟淹盐严研蜒岩延言颜阎炎沿奄掩眼衍演艳堰燕厌砚雁唁彦焰宴谚验殃央鸯秧杨扬佯疡羊洋阳氧仰痒养样漾邀腰妖瑶�".split(""), e = 0; e != r[209].length; ++e)
        r[209][e].charCodeAt(0) !== 65533 && (c[r[209][e]] = 53504 + e, o[53504 + e] = r[209][e]);
      for (r[210] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������摇尧遥窑谣姚咬舀药要耀椰噎耶爷野冶也页掖业叶曳腋夜液一壹医揖铱依伊衣颐夷遗移仪胰疑沂宜姨彝椅蚁倚已乙矣以艺抑易邑屹亿役臆逸肄疫亦裔意毅忆义益溢诣议谊译异翼翌绎茵荫因殷音阴姻吟银淫寅饮尹引隐�".split(""), e = 0; e != r[210].length; ++e)
        r[210][e].charCodeAt(0) !== 65533 && (c[r[210][e]] = 53760 + e, o[53760 + e] = r[210][e]);
      for (r[211] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������印英樱婴鹰应缨莹萤营荧蝇迎赢盈影颖硬映哟拥佣臃痈庸雍踊蛹咏泳涌永恿勇用幽优悠忧尤由邮铀犹油游酉有友右佑釉诱又幼迂淤于盂榆虞愚舆余俞逾鱼愉渝渔隅予娱雨与屿禹宇语羽玉域芋郁吁遇喻峪御愈欲狱育誉�".split(""), e = 0; e != r[211].length; ++e)
        r[211][e].charCodeAt(0) !== 65533 && (c[r[211][e]] = 54016 + e, o[54016 + e] = r[211][e]);
      for (r[212] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������浴寓裕预豫驭鸳渊冤元垣袁原援辕园员圆猿源缘远苑愿怨院曰约越跃钥岳粤月悦阅耘云郧匀陨允运蕴酝晕韵孕匝砸杂栽哉灾宰载再在咱攒暂赞赃脏葬遭糟凿藻枣早澡蚤躁噪造皂灶燥责择则泽贼怎增憎曾赠扎喳渣札轧�".split(""), e = 0; e != r[212].length; ++e)
        r[212][e].charCodeAt(0) !== 65533 && (c[r[212][e]] = 54272 + e, o[54272 + e] = r[212][e]);
      for (r[213] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������铡闸眨栅榨咋乍炸诈摘斋宅窄债寨瞻毡詹粘沾盏斩辗崭展蘸栈占战站湛绽樟章彰漳张掌涨杖丈帐账仗胀瘴障招昭找沼赵照罩兆肇召遮折哲蛰辙者锗蔗这浙珍斟真甄砧臻贞针侦枕疹诊震振镇阵蒸挣睁征狰争怔整拯正政�".split(""), e = 0; e != r[213].length; ++e)
        r[213][e].charCodeAt(0) !== 65533 && (c[r[213][e]] = 54528 + e, o[54528 + e] = r[213][e]);
      for (r[214] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������帧症郑证芝枝支吱蜘知肢脂汁之织职直植殖执值侄址指止趾只旨纸志挚掷至致置帜峙制智秩稚质炙痔滞治窒中盅忠钟衷终种肿重仲众舟周州洲诌粥轴肘帚咒皱宙昼骤珠株蛛朱猪诸诛逐竹烛煮拄瞩嘱主著柱助蛀贮铸筑�".split(""), e = 0; e != r[214].length; ++e)
        r[214][e].charCodeAt(0) !== 65533 && (c[r[214][e]] = 54784 + e, o[54784 + e] = r[214][e]);
      for (r[215] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������住注祝驻抓爪拽专砖转撰赚篆桩庄装妆撞壮状椎锥追赘坠缀谆准捉拙卓桌琢茁酌啄着灼浊兹咨资姿滋淄孜紫仔籽滓子自渍字鬃棕踪宗综总纵邹走奏揍租足卒族祖诅阻组钻纂嘴醉最罪尊遵昨左佐柞做作坐座������".split(""), e = 0; e != r[215].length; ++e)
        r[215][e].charCodeAt(0) !== 65533 && (c[r[215][e]] = 55040 + e, o[55040 + e] = r[215][e]);
      for (r[216] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������亍丌兀丐廿卅丕亘丞鬲孬噩丨禺丿匕乇夭爻卮氐囟胤馗毓睾鼗丶亟鼐乜乩亓芈孛啬嘏仄厍厝厣厥厮靥赝匚叵匦匮匾赜卦卣刂刈刎刭刳刿剀剌剞剡剜蒯剽劂劁劐劓冂罔亻仃仉仂仨仡仫仞伛仳伢佤仵伥伧伉伫佞佧攸佚佝�".split(""), e = 0; e != r[216].length; ++e)
        r[216][e].charCodeAt(0) !== 65533 && (c[r[216][e]] = 55296 + e, o[55296 + e] = r[216][e]);
      for (r[217] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������佟佗伲伽佶佴侑侉侃侏佾佻侪佼侬侔俦俨俪俅俚俣俜俑俟俸倩偌俳倬倏倮倭俾倜倌倥倨偾偃偕偈偎偬偻傥傧傩傺僖儆僭僬僦僮儇儋仝氽佘佥俎龠汆籴兮巽黉馘冁夔勹匍訇匐凫夙兕亠兖亳衮袤亵脔裒禀嬴蠃羸冫冱冽冼�".split(""), e = 0; e != r[217].length; ++e)
        r[217][e].charCodeAt(0) !== 65533 && (c[r[217][e]] = 55552 + e, o[55552 + e] = r[217][e]);
      for (r[218] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������凇冖冢冥讠讦讧讪讴讵讷诂诃诋诏诎诒诓诔诖诘诙诜诟诠诤诨诩诮诰诳诶诹诼诿谀谂谄谇谌谏谑谒谔谕谖谙谛谘谝谟谠谡谥谧谪谫谮谯谲谳谵谶卩卺阝阢阡阱阪阽阼陂陉陔陟陧陬陲陴隈隍隗隰邗邛邝邙邬邡邴邳邶邺�".split(""), e = 0; e != r[218].length; ++e)
        r[218][e].charCodeAt(0) !== 65533 && (c[r[218][e]] = 55808 + e, o[55808 + e] = r[218][e]);
      for (r[219] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������邸邰郏郅邾郐郄郇郓郦郢郜郗郛郫郯郾鄄鄢鄞鄣鄱鄯鄹酃酆刍奂劢劬劭劾哿勐勖勰叟燮矍廴凵凼鬯厶弁畚巯坌垩垡塾墼壅壑圩圬圪圳圹圮圯坜圻坂坩垅坫垆坼坻坨坭坶坳垭垤垌垲埏垧垴垓垠埕埘埚埙埒垸埴埯埸埤埝�".split(""), e = 0; e != r[219].length; ++e)
        r[219][e].charCodeAt(0) !== 65533 && (c[r[219][e]] = 56064 + e, o[56064 + e] = r[219][e]);
      for (r[220] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������堋堍埽埭堀堞堙塄堠塥塬墁墉墚墀馨鼙懿艹艽艿芏芊芨芄芎芑芗芙芫芸芾芰苈苊苣芘芷芮苋苌苁芩芴芡芪芟苄苎芤苡茉苷苤茏茇苜苴苒苘茌苻苓茑茚茆茔茕苠苕茜荑荛荜茈莒茼茴茱莛荞茯荏荇荃荟荀茗荠茭茺茳荦荥�".split(""), e = 0; e != r[220].length; ++e)
        r[220][e].charCodeAt(0) !== 65533 && (c[r[220][e]] = 56320 + e, o[56320 + e] = r[220][e]);
      for (r[221] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������荨茛荩荬荪荭荮莰荸莳莴莠莪莓莜莅荼莶莩荽莸荻莘莞莨莺莼菁萁菥菘堇萘萋菝菽菖萜萸萑萆菔菟萏萃菸菹菪菅菀萦菰菡葜葑葚葙葳蒇蒈葺蒉葸萼葆葩葶蒌蒎萱葭蓁蓍蓐蓦蒽蓓蓊蒿蒺蓠蒡蒹蒴蒗蓥蓣蔌甍蔸蓰蔹蔟蔺�".split(""), e = 0; e != r[221].length; ++e)
        r[221][e].charCodeAt(0) !== 65533 && (c[r[221][e]] = 56576 + e, o[56576 + e] = r[221][e]);
      for (r[222] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������蕖蔻蓿蓼蕙蕈蕨蕤蕞蕺瞢蕃蕲蕻薤薨薇薏蕹薮薜薅薹薷薰藓藁藜藿蘧蘅蘩蘖蘼廾弈夼奁耷奕奚奘匏尢尥尬尴扌扪抟抻拊拚拗拮挢拶挹捋捃掭揶捱捺掎掴捭掬掊捩掮掼揲揸揠揿揄揞揎摒揆掾摅摁搋搛搠搌搦搡摞撄摭撖�".split(""), e = 0; e != r[222].length; ++e)
        r[222][e].charCodeAt(0) !== 65533 && (c[r[222][e]] = 56832 + e, o[56832 + e] = r[222][e]);
      for (r[223] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������摺撷撸撙撺擀擐擗擤擢攉攥攮弋忒甙弑卟叱叽叩叨叻吒吖吆呋呒呓呔呖呃吡呗呙吣吲咂咔呷呱呤咚咛咄呶呦咝哐咭哂咴哒咧咦哓哔呲咣哕咻咿哌哙哚哜咩咪咤哝哏哞唛哧唠哽唔哳唢唣唏唑唧唪啧喏喵啉啭啁啕唿啐唼�".split(""), e = 0; e != r[223].length; ++e)
        r[223][e].charCodeAt(0) !== 65533 && (c[r[223][e]] = 57088 + e, o[57088 + e] = r[223][e]);
      for (r[224] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������唷啖啵啶啷唳唰啜喋嗒喃喱喹喈喁喟啾嗖喑啻嗟喽喾喔喙嗪嗷嗉嘟嗑嗫嗬嗔嗦嗝嗄嗯嗥嗲嗳嗌嗍嗨嗵嗤辔嘞嘈嘌嘁嘤嘣嗾嘀嘧嘭噘嘹噗嘬噍噢噙噜噌噔嚆噤噱噫噻噼嚅嚓嚯囔囗囝囡囵囫囹囿圄圊圉圜帏帙帔帑帱帻帼�".split(""), e = 0; e != r[224].length; ++e)
        r[224][e].charCodeAt(0) !== 65533 && (c[r[224][e]] = 57344 + e, o[57344 + e] = r[224][e]);
      for (r[225] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������帷幄幔幛幞幡岌屺岍岐岖岈岘岙岑岚岜岵岢岽岬岫岱岣峁岷峄峒峤峋峥崂崃崧崦崮崤崞崆崛嵘崾崴崽嵬嵛嵯嵝嵫嵋嵊嵩嵴嶂嶙嶝豳嶷巅彳彷徂徇徉後徕徙徜徨徭徵徼衢彡犭犰犴犷犸狃狁狎狍狒狨狯狩狲狴狷猁狳猃狺�".split(""), e = 0; e != r[225].length; ++e)
        r[225][e].charCodeAt(0) !== 65533 && (c[r[225][e]] = 57600 + e, o[57600 + e] = r[225][e]);
      for (r[226] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������狻猗猓猡猊猞猝猕猢猹猥猬猸猱獐獍獗獠獬獯獾舛夥飧夤夂饣饧饨饩饪饫饬饴饷饽馀馄馇馊馍馐馑馓馔馕庀庑庋庖庥庠庹庵庾庳赓廒廑廛廨廪膺忄忉忖忏怃忮怄忡忤忾怅怆忪忭忸怙怵怦怛怏怍怩怫怊怿怡恸恹恻恺恂�".split(""), e = 0; e != r[226].length; ++e)
        r[226][e].charCodeAt(0) !== 65533 && (c[r[226][e]] = 57856 + e, o[57856 + e] = r[226][e]);
      for (r[227] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������恪恽悖悚悭悝悃悒悌悛惬悻悱惝惘惆惚悴愠愦愕愣惴愀愎愫慊慵憬憔憧憷懔懵忝隳闩闫闱闳闵闶闼闾阃阄阆阈阊阋阌阍阏阒阕阖阗阙阚丬爿戕氵汔汜汊沣沅沐沔沌汨汩汴汶沆沩泐泔沭泷泸泱泗沲泠泖泺泫泮沱泓泯泾�".split(""), e = 0; e != r[227].length; ++e)
        r[227][e].charCodeAt(0) !== 65533 && (c[r[227][e]] = 58112 + e, o[58112 + e] = r[227][e]);
      for (r[228] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������洹洧洌浃浈洇洄洙洎洫浍洮洵洚浏浒浔洳涑浯涞涠浞涓涔浜浠浼浣渚淇淅淞渎涿淠渑淦淝淙渖涫渌涮渫湮湎湫溲湟溆湓湔渲渥湄滟溱溘滠漭滢溥溧溽溻溷滗溴滏溏滂溟潢潆潇漤漕滹漯漶潋潴漪漉漩澉澍澌潸潲潼潺濑�".split(""), e = 0; e != r[228].length; ++e)
        r[228][e].charCodeAt(0) !== 65533 && (c[r[228][e]] = 58368 + e, o[58368 + e] = r[228][e]);
      for (r[229] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������濉澧澹澶濂濡濮濞濠濯瀚瀣瀛瀹瀵灏灞宀宄宕宓宥宸甯骞搴寤寮褰寰蹇謇辶迓迕迥迮迤迩迦迳迨逅逄逋逦逑逍逖逡逵逶逭逯遄遑遒遐遨遘遢遛暹遴遽邂邈邃邋彐彗彖彘尻咫屐屙孱屣屦羼弪弩弭艴弼鬻屮妁妃妍妩妪妣�".split(""), e = 0; e != r[229].length; ++e)
        r[229][e].charCodeAt(0) !== 65533 && (c[r[229][e]] = 58624 + e, o[58624 + e] = r[229][e]);
      for (r[230] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������妗姊妫妞妤姒妲妯姗妾娅娆姝娈姣姘姹娌娉娲娴娑娣娓婀婧婊婕娼婢婵胬媪媛婷婺媾嫫媲嫒嫔媸嫠嫣嫱嫖嫦嫘嫜嬉嬗嬖嬲嬷孀尕尜孚孥孳孑孓孢驵驷驸驺驿驽骀骁骅骈骊骐骒骓骖骘骛骜骝骟骠骢骣骥骧纟纡纣纥纨纩�".split(""), e = 0; e != r[230].length; ++e)
        r[230][e].charCodeAt(0) !== 65533 && (c[r[230][e]] = 58880 + e, o[58880 + e] = r[230][e]);
      for (r[231] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������纭纰纾绀绁绂绉绋绌绐绔绗绛绠绡绨绫绮绯绱绲缍绶绺绻绾缁缂缃缇缈缋缌缏缑缒缗缙缜缛缟缡缢缣缤缥缦缧缪缫缬缭缯缰缱缲缳缵幺畿巛甾邕玎玑玮玢玟珏珂珑玷玳珀珉珈珥珙顼琊珩珧珞玺珲琏琪瑛琦琥琨琰琮琬�".split(""), e = 0; e != r[231].length; ++e)
        r[231][e].charCodeAt(0) !== 65533 && (c[r[231][e]] = 59136 + e, o[59136 + e] = r[231][e]);
      for (r[232] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������琛琚瑁瑜瑗瑕瑙瑷瑭瑾璜璎璀璁璇璋璞璨璩璐璧瓒璺韪韫韬杌杓杞杈杩枥枇杪杳枘枧杵枨枞枭枋杷杼柰栉柘栊柩枰栌柙枵柚枳柝栀柃枸柢栎柁柽栲栳桠桡桎桢桄桤梃栝桕桦桁桧桀栾桊桉栩梵梏桴桷梓桫棂楮棼椟椠棹�".split(""), e = 0; e != r[232].length; ++e)
        r[232][e].charCodeAt(0) !== 65533 && (c[r[232][e]] = 59392 + e, o[59392 + e] = r[232][e]);
      for (r[233] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������椤棰椋椁楗棣椐楱椹楠楂楝榄楫榀榘楸椴槌榇榈槎榉楦楣楹榛榧榻榫榭槔榱槁槊槟榕槠榍槿樯槭樗樘橥槲橄樾檠橐橛樵檎橹樽樨橘橼檑檐檩檗檫猷獒殁殂殇殄殒殓殍殚殛殡殪轫轭轱轲轳轵轶轸轷轹轺轼轾辁辂辄辇辋�".split(""), e = 0; e != r[233].length; ++e)
        r[233][e].charCodeAt(0) !== 65533 && (c[r[233][e]] = 59648 + e, o[59648 + e] = r[233][e]);
      for (r[234] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������辍辎辏辘辚軎戋戗戛戟戢戡戥戤戬臧瓯瓴瓿甏甑甓攴旮旯旰昊昙杲昃昕昀炅曷昝昴昱昶昵耆晟晔晁晏晖晡晗晷暄暌暧暝暾曛曜曦曩贲贳贶贻贽赀赅赆赈赉赇赍赕赙觇觊觋觌觎觏觐觑牮犟牝牦牯牾牿犄犋犍犏犒挈挲掰�".split(""), e = 0; e != r[234].length; ++e)
        r[234][e].charCodeAt(0) !== 65533 && (c[r[234][e]] = 59904 + e, o[59904 + e] = r[234][e]);
      for (r[235] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������搿擘耄毪毳毽毵毹氅氇氆氍氕氘氙氚氡氩氤氪氲攵敕敫牍牒牖爰虢刖肟肜肓肼朊肽肱肫肭肴肷胧胨胩胪胛胂胄胙胍胗朐胝胫胱胴胭脍脎胲胼朕脒豚脶脞脬脘脲腈腌腓腴腙腚腱腠腩腼腽腭腧塍媵膈膂膑滕膣膪臌朦臊膻�".split(""), e = 0; e != r[235].length; ++e)
        r[235][e].charCodeAt(0) !== 65533 && (c[r[235][e]] = 60160 + e, o[60160 + e] = r[235][e]);
      for (r[236] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������臁膦欤欷欹歃歆歙飑飒飓飕飙飚殳彀毂觳斐齑斓於旆旄旃旌旎旒旖炀炜炖炝炻烀炷炫炱烨烊焐焓焖焯焱煳煜煨煅煲煊煸煺熘熳熵熨熠燠燔燧燹爝爨灬焘煦熹戾戽扃扈扉礻祀祆祉祛祜祓祚祢祗祠祯祧祺禅禊禚禧禳忑忐�".split(""), e = 0; e != r[236].length; ++e)
        r[236][e].charCodeAt(0) !== 65533 && (c[r[236][e]] = 60416 + e, o[60416 + e] = r[236][e]);
      for (r[237] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������怼恝恚恧恁恙恣悫愆愍慝憩憝懋懑戆肀聿沓泶淼矶矸砀砉砗砘砑斫砭砜砝砹砺砻砟砼砥砬砣砩硎硭硖硗砦硐硇硌硪碛碓碚碇碜碡碣碲碹碥磔磙磉磬磲礅磴礓礤礞礴龛黹黻黼盱眄眍盹眇眈眚眢眙眭眦眵眸睐睑睇睃睚睨�".split(""), e = 0; e != r[237].length; ++e)
        r[237][e].charCodeAt(0) !== 65533 && (c[r[237][e]] = 60672 + e, o[60672 + e] = r[237][e]);
      for (r[238] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������睢睥睿瞍睽瞀瞌瞑瞟瞠瞰瞵瞽町畀畎畋畈畛畲畹疃罘罡罟詈罨罴罱罹羁罾盍盥蠲钅钆钇钋钊钌钍钏钐钔钗钕钚钛钜钣钤钫钪钭钬钯钰钲钴钶钷钸钹钺钼钽钿铄铈铉铊铋铌铍铎铐铑铒铕铖铗铙铘铛铞铟铠铢铤铥铧铨铪�".split(""), e = 0; e != r[238].length; ++e)
        r[238][e].charCodeAt(0) !== 65533 && (c[r[238][e]] = 60928 + e, o[60928 + e] = r[238][e]);
      for (r[239] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������铩铫铮铯铳铴铵铷铹铼铽铿锃锂锆锇锉锊锍锎锏锒锓锔锕锖锘锛锝锞锟锢锪锫锩锬锱锲锴锶锷锸锼锾锿镂锵镄镅镆镉镌镎镏镒镓镔镖镗镘镙镛镞镟镝镡镢镤镥镦镧镨镩镪镫镬镯镱镲镳锺矧矬雉秕秭秣秫稆嵇稃稂稞稔�".split(""), e = 0; e != r[239].length; ++e)
        r[239][e].charCodeAt(0) !== 65533 && (c[r[239][e]] = 61184 + e, o[61184 + e] = r[239][e]);
      for (r[240] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������稹稷穑黏馥穰皈皎皓皙皤瓞瓠甬鸠鸢鸨鸩鸪鸫鸬鸲鸱鸶鸸鸷鸹鸺鸾鹁鹂鹄鹆鹇鹈鹉鹋鹌鹎鹑鹕鹗鹚鹛鹜鹞鹣鹦鹧鹨鹩鹪鹫鹬鹱鹭鹳疒疔疖疠疝疬疣疳疴疸痄疱疰痃痂痖痍痣痨痦痤痫痧瘃痱痼痿瘐瘀瘅瘌瘗瘊瘥瘘瘕瘙�".split(""), e = 0; e != r[240].length; ++e)
        r[240][e].charCodeAt(0) !== 65533 && (c[r[240][e]] = 61440 + e, o[61440 + e] = r[240][e]);
      for (r[241] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������瘛瘼瘢瘠癀瘭瘰瘿瘵癃瘾瘳癍癞癔癜癖癫癯翊竦穸穹窀窆窈窕窦窠窬窨窭窳衤衩衲衽衿袂袢裆袷袼裉裢裎裣裥裱褚裼裨裾裰褡褙褓褛褊褴褫褶襁襦襻疋胥皲皴矜耒耔耖耜耠耢耥耦耧耩耨耱耋耵聃聆聍聒聩聱覃顸颀颃�".split(""), e = 0; e != r[241].length; ++e)
        r[241][e].charCodeAt(0) !== 65533 && (c[r[241][e]] = 61696 + e, o[61696 + e] = r[241][e]);
      for (r[242] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������颉颌颍颏颔颚颛颞颟颡颢颥颦虍虔虬虮虿虺虼虻蚨蚍蚋蚬蚝蚧蚣蚪蚓蚩蚶蛄蚵蛎蚰蚺蚱蚯蛉蛏蚴蛩蛱蛲蛭蛳蛐蜓蛞蛴蛟蛘蛑蜃蜇蛸蜈蜊蜍蜉蜣蜻蜞蜥蜮蜚蜾蝈蜴蜱蜩蜷蜿螂蜢蝽蝾蝻蝠蝰蝌蝮螋蝓蝣蝼蝤蝙蝥螓螯螨蟒�".split(""), e = 0; e != r[242].length; ++e)
        r[242][e].charCodeAt(0) !== 65533 && (c[r[242][e]] = 61952 + e, o[61952 + e] = r[242][e]);
      for (r[243] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������蟆螈螅螭螗螃螫蟥螬螵螳蟋蟓螽蟑蟀蟊蟛蟪蟠蟮蠖蠓蟾蠊蠛蠡蠹蠼缶罂罄罅舐竺竽笈笃笄笕笊笫笏筇笸笪笙笮笱笠笥笤笳笾笞筘筚筅筵筌筝筠筮筻筢筲筱箐箦箧箸箬箝箨箅箪箜箢箫箴篑篁篌篝篚篥篦篪簌篾篼簏簖簋�".split(""), e = 0; e != r[243].length; ++e)
        r[243][e].charCodeAt(0) !== 65533 && (c[r[243][e]] = 62208 + e, o[62208 + e] = r[243][e]);
      for (r[244] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������簟簪簦簸籁籀臾舁舂舄臬衄舡舢舣舭舯舨舫舸舻舳舴舾艄艉艋艏艚艟艨衾袅袈裘裟襞羝羟羧羯羰羲籼敉粑粝粜粞粢粲粼粽糁糇糌糍糈糅糗糨艮暨羿翎翕翥翡翦翩翮翳糸絷綦綮繇纛麸麴赳趄趔趑趱赧赭豇豉酊酐酎酏酤�".split(""), e = 0; e != r[244].length; ++e)
        r[244][e].charCodeAt(0) !== 65533 && (c[r[244][e]] = 62464 + e, o[62464 + e] = r[244][e]);
      for (r[245] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������酢酡酰酩酯酽酾酲酴酹醌醅醐醍醑醢醣醪醭醮醯醵醴醺豕鹾趸跫踅蹙蹩趵趿趼趺跄跖跗跚跞跎跏跛跆跬跷跸跣跹跻跤踉跽踔踝踟踬踮踣踯踺蹀踹踵踽踱蹉蹁蹂蹑蹒蹊蹰蹶蹼蹯蹴躅躏躔躐躜躞豸貂貊貅貘貔斛觖觞觚觜�".split(""), e = 0; e != r[245].length; ++e)
        r[245][e].charCodeAt(0) !== 65533 && (c[r[245][e]] = 62720 + e, o[62720 + e] = r[245][e]);
      for (r[246] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������觥觫觯訾謦靓雩雳雯霆霁霈霏霎霪霭霰霾龀龃龅龆龇龈龉龊龌黾鼋鼍隹隼隽雎雒瞿雠銎銮鋈錾鍪鏊鎏鐾鑫鱿鲂鲅鲆鲇鲈稣鲋鲎鲐鲑鲒鲔鲕鲚鲛鲞鲟鲠鲡鲢鲣鲥鲦鲧鲨鲩鲫鲭鲮鲰鲱鲲鲳鲴鲵鲶鲷鲺鲻鲼鲽鳄鳅鳆鳇鳊鳋�".split(""), e = 0; e != r[246].length; ++e)
        r[246][e].charCodeAt(0) !== 65533 && (c[r[246][e]] = 62976 + e, o[62976 + e] = r[246][e]);
      for (r[247] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������鳌鳍鳎鳏鳐鳓鳔鳕鳗鳘鳙鳜鳝鳟鳢靼鞅鞑鞒鞔鞯鞫鞣鞲鞴骱骰骷鹘骶骺骼髁髀髅髂髋髌髑魅魃魇魉魈魍魑飨餍餮饕饔髟髡髦髯髫髻髭髹鬈鬏鬓鬟鬣麽麾縻麂麇麈麋麒鏖麝麟黛黜黝黠黟黢黩黧黥黪黯鼢鼬鼯鼹鼷鼽鼾齄�".split(""), e = 0; e != r[247].length; ++e)
        r[247][e].charCodeAt(0) !== 65533 && (c[r[247][e]] = 63232 + e, o[63232 + e] = r[247][e]);
      return { enc: c, dec: o };
    }(), i[10029] = function() {
      for (var o = `\0\x07\b	
\v\f\r\x1B !"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_\`abcdefghijklmnopqrstuvwxyz{|}~ÄĀāÉĄÖÜáąČäčĆćéŹźĎíďĒēĖóėôöõúĚěü†°Ę£§•¶ß®©™ę¨≠ģĮįĪ≤≥īĶ∂∑łĻļĽľĹĺŅņŃ¬√ńŇ∆«»… ňŐÕőŌ–—“”‘’÷◊ōŔŕŘ‹›řŖŗŠ‚„šŚśÁŤťÍŽžŪÓÔūŮÚůŰűŲųÝýķŻŁżĢˇ`, c = [], r = {}, e = 0; e != o.length; ++e)
        o.charCodeAt(e) !== 65533 && (r[o.charAt(e)] = e), c[e] = o.charAt(e);
      return { enc: r, dec: c };
    }(), i[10079] = function() {
      for (var o = `\0\x07\b	
\v\f\r\x1B !"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_\`abcdefghijklmnopqrstuvwxyz{|}~ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûüÝ°¢£§•¶ß®©™´¨≠ÆØ∞±≤≥¥µ∂∑∏π∫ªºΩæø¿¡¬√ƒ≈∆«»… ÀÃÕŒœ–—“”‘’÷◊ÿŸ⁄¤ÐðÞþý·‚„‰ÂÊÁËÈÍÎÏÌÓÔ�ÒÚÛÙıˆ˜¯˘˙˚¸˝˛ˇ`, c = [], r = {}, e = 0; e != o.length; ++e)
        o.charCodeAt(e) !== 65533 && (r[o.charAt(e)] = e), c[e] = o.charAt(e);
      return { enc: r, dec: c };
    }(), i[10081] = function() {
      for (var o = `\0\x07\b	
\v\f\r\x1B !"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_\`abcdefghijklmnopqrstuvwxyz{|}~ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûü†°¢£§•¶ß®©™´¨≠ÆØ∞±≤≥¥µ∂∑∏π∫ªºΩæø¿¡¬√ƒ≈∆«»… ÀÃÕŒœ–—“”‘’÷◊ÿŸĞğİıŞş‡·‚„‰ÂÊÁËÈÍÎÏÌÓÔ�ÒÚÛÙ�ˆ˜¯˘˙˚¸˝˛ˇ`, c = [], r = {}, e = 0; e != o.length; ++e)
        o.charCodeAt(e) !== 65533 && (r[o.charAt(e)] = e), c[e] = o.charAt(e);
      return { enc: r, dec: c };
    }(), i[28591] = function() {
      for (var o = `\0\x07\b	
\v\f\r\x1B !"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_\`abcdefghijklmnopqrstuvwxyz{|}~ ¡¢£¤¥¦§¨©ª«¬­®¯°±²³´µ¶·¸¹º»¼½¾¿ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏÐÑÒÓÔÕÖ×ØÙÚÛÜÝÞßàáâãäåæçèéêëìíîïðñòóôõö÷øùúûüýþÿ`, c = [], r = {}, e = 0; e != o.length; ++e)
        o.charCodeAt(e) !== 65533 && (r[o.charAt(e)] = e), c[e] = o.charAt(e);
      return { enc: r, dec: c };
    }(), s.exports && typeof DO_NOT_EXPORT_CODEPAGE > "u" && (s.exports = i);
    /*! cputils.js (C) 2013-present SheetJS -- http://sheetjs.com */
    (function(o, c) {
      if (typeof i > "u")
        if (typeof el < "u") {
          var r = i;
          s.exports && typeof DO_NOT_EXPORT_CODEPAGE > "u" ? s.exports = c(r) : o.cptable = c(r);
        } else
          throw new Error("cptable not found");
      else
        i = c(i);
    })(v1, function(o) {
      var c = {
        1200: "utf16le",
        1201: "utf16be",
        12e3: "utf32le",
        12001: "utf32be",
        16969: "utf64le",
        20127: "ascii",
        65e3: "utf7",
        65001: "utf8"
      }, r = [874, 1250, 1251, 1252, 1253, 1254, 1255, 1256, 1e4], e = [932, 936, 949, 950], g = [65001], h = {}, S = {}, C = {}, O = {}, N = function(ie) {
        return String.fromCharCode(ie);
      }, D = function(ie) {
        return ie.charCodeAt(0);
      }, x = typeof Buffer < "u", L = function() {
      };
      if (x) {
        var G = !Buffer.from;
        if (!G)
          try {
            Buffer.from("foo", "utf8");
          } catch {
            G = !0;
          }
        L = G ? function(de, ie) {
          return ie ? new Buffer(de, ie) : new Buffer(de);
        } : Buffer.from.bind(Buffer), Buffer.allocUnsafe || (Buffer.allocUnsafe = function(de) {
          return new Buffer(de);
        });
        var Y = 1024, k = Buffer.allocUnsafe(Y), W = function(ie) {
          for (var X = Buffer.allocUnsafe(65536), ue = 0; ue < 65536; ++ue)
            X[ue] = 0;
          for (var Oe = Object.keys(ie), Re = Oe.length, ae = 0, Ee = Oe[ae]; ae < Re; ++ae)
            (Ee = Oe[ae]) && (X[Ee.charCodeAt(0)] = ie[Ee]);
          return X;
        }, Z = function(ie) {
          var X = W(o[ie].enc);
          return function(Oe, Re) {
            var ae = Oe.length, Ee, ne = 0, Ge = 0, we = 0, st = 0;
            if (typeof Oe == "string")
              for (Ee = Buffer.allocUnsafe(ae), ne = 0; ne < ae; ++ne)
                Ee[ne] = X[Oe.charCodeAt(ne)];
            else if (Buffer.isBuffer(Oe)) {
              for (Ee = Buffer.allocUnsafe(2 * ae), Ge = 0, ne = 0; ne < ae; ++ne)
                we = Oe[ne], we < 128 ? Ee[Ge++] = X[we] : we < 224 ? (Ee[Ge++] = X[((we & 31) << 6) + (Oe[ne + 1] & 63)], ++ne) : we < 240 ? (Ee[Ge++] = X[((we & 15) << 12) + ((Oe[ne + 1] & 63) << 6) + (Oe[ne + 2] & 63)], ne += 2) : (st = ((we & 7) << 18) + ((Oe[ne + 1] & 63) << 12) + ((Oe[ne + 2] & 63) << 6) + (Oe[ne + 3] & 63), ne += 3, st < 65536 ? Ee[Ge++] = X[st] : (st -= 65536, Ee[Ge++] = X[55296 + (st >> 10 & 1023)], Ee[Ge++] = X[56320 + (st & 1023)]));
              Ee = Ee.slice(0, Ge);
            } else
              for (Ee = Buffer.allocUnsafe(ae), ne = 0; ne < ae; ++ne)
                Ee[ne] = X[Oe[ne].charCodeAt(0)];
            return !Re || Re === "buf" ? Ee : Re !== "arr" ? Ee.toString("binary") : [].slice.call(Ee);
          };
        }, H = function(ie) {
          var X = o[ie].dec, ue = Buffer.allocUnsafe(131072), Oe = 0, Re = "";
          for (Oe = 0; Oe < X.length; ++Oe)
            if (Re = X[Oe]) {
              var ae = Re.charCodeAt(0);
              ue[2 * Oe] = ae & 255, ue[2 * Oe + 1] = ae >> 8;
            }
          return function(ne) {
            var Ge = ne.length, we = 0, st = 0;
            if (2 * Ge > Y && (Y = 2 * Ge, k = Buffer.allocUnsafe(Y)), Buffer.isBuffer(ne))
              for (we = 0; we < Ge; we++)
                st = 2 * ne[we], k[2 * we] = ue[st], k[2 * we + 1] = ue[st + 1];
            else if (typeof ne == "string")
              for (we = 0; we < Ge; we++)
                st = 2 * ne.charCodeAt(we), k[2 * we] = ue[st], k[2 * we + 1] = ue[st + 1];
            else
              for (we = 0; we < Ge; we++)
                st = 2 * ne[we], k[2 * we] = ue[st], k[2 * we + 1] = ue[st + 1];
            return k.slice(0, 2 * Ge).toString("ucs2");
          };
        }, K = function(ie) {
          for (var X = o[ie].enc, ue = Buffer.allocUnsafe(131072), Oe = 0; Oe < 131072; ++Oe)
            ue[Oe] = 0;
          for (var Re = Object.keys(X), ae = 0, Ee = Re[ae]; ae < Re.length; ++ae)
            if (Ee = Re[ae]) {
              var ne = Ee.charCodeAt(0);
              ue[2 * ne] = X[Ee] & 255, ue[2 * ne + 1] = X[Ee] >> 8;
            }
          return function(we, st) {
            var Rt = we.length, rt = Buffer.allocUnsafe(2 * Rt), z = 0, V = 0, Te = 0, Be = 0, Le = 0;
            if (typeof we == "string") {
              for (z = Be = 0; z < Rt; ++z)
                V = we.charCodeAt(z) * 2, rt[Be++] = ue[V + 1] || ue[V], ue[V + 1] > 0 && (rt[Be++] = ue[V]);
              rt = rt.slice(0, Be);
            } else if (Buffer.isBuffer(we)) {
              for (z = Be = 0; z < Rt; ++z)
                Le = we[z], Le < 128 ? V = Le : Le < 224 ? (V = ((Le & 31) << 6) + (we[z + 1] & 63), ++z) : Le < 240 ? (V = ((Le & 15) << 12) + ((we[z + 1] & 63) << 6) + (we[z + 2] & 63), z += 2) : (V = ((Le & 7) << 18) + ((we[z + 1] & 63) << 12) + ((we[z + 2] & 63) << 6) + (we[z + 3] & 63), z += 3), V < 65536 ? (V *= 2, rt[Be++] = ue[V + 1] || ue[V], ue[V + 1] > 0 && (rt[Be++] = ue[V])) : (Te = V - 65536, V = 2 * (55296 + (Te >> 10 & 1023)), rt[Be++] = ue[V + 1] || ue[V], ue[V + 1] > 0 && (rt[Be++] = ue[V]), V = 2 * (56320 + (Te & 1023)), rt[Be++] = ue[V + 1] || ue[V], ue[V + 1] > 0 && (rt[Be++] = ue[V]));
              rt = rt.slice(0, Be);
            } else
              for (z = Be = 0; z < Rt; z++)
                V = we[z].charCodeAt(0) * 2, rt[Be++] = ue[V + 1] || ue[V], ue[V + 1] > 0 && (rt[Be++] = ue[V]);
            return !st || st === "buf" ? rt : st !== "arr" ? rt.toString("binary") : [].slice.call(rt);
          };
        }, Q = function(ie) {
          var X = o[ie].dec, ue = Buffer.allocUnsafe(131072), Oe = 0, Re, ae = 0, Ee = 0, ne = 0;
          for (ne = 0; ne < 65536; ++ne)
            ue[2 * ne] = 255, ue[2 * ne + 1] = 253;
          for (Oe = 0; Oe < X.length; ++Oe)
            (Re = X[Oe]) && (ae = Re.charCodeAt(0), Ee = 2 * Oe, ue[Ee] = ae & 255, ue[Ee + 1] = ae >> 8);
          return function(we) {
            var st = we.length, Rt = Buffer.allocUnsafe(2 * st), rt = 0, z = 0, V = 0;
            if (Buffer.isBuffer(we))
              for (rt = 0; rt < st; rt++)
                z = 2 * we[rt], ue[z] === 255 && ue[z + 1] === 253 && (z = 2 * ((we[rt] << 8) + we[rt + 1]), ++rt), Rt[V++] = ue[z], Rt[V++] = ue[z + 1];
            else if (typeof we == "string")
              for (rt = 0; rt < st; rt++)
                z = 2 * we.charCodeAt(rt), ue[z] === 255 && ue[z + 1] === 253 && (z = 2 * ((we.charCodeAt(rt) << 8) + we.charCodeAt(rt + 1)), ++rt), Rt[V++] = ue[z], Rt[V++] = ue[z + 1];
            else
              for (rt = 0; rt < st; rt++)
                z = 2 * we[rt], ue[z] === 255 && ue[z + 1] === 253 && (z = 2 * ((we[rt] << 8) + we[rt + 1]), ++rt), Rt[V++] = ue[z], Rt[V++] = ue[z + 1];
            return Rt.slice(0, V).toString("ucs2");
          };
        };
        h[65001] = function de(ie) {
          if (typeof ie == "string")
            return de(ie.split("").map(D));
          var X = ie.length, ue = 0, Oe = 0;
          4 * X > Y && (Y = 4 * X, k = Buffer.allocUnsafe(Y));
          var Re = 0;
          X >= 3 && ie[0] == 239 && ie[1] == 187 && ie[2] == 191 && (Re = 3);
          for (var ae = 1, Ee = 0, ne = 0; Re < X; Re += ae)
            ae = 1, ne = ie[Re], ne < 128 ? ue = ne : ne < 224 ? (ue = (ne & 31) * 64 + (ie[Re + 1] & 63), ae = 2) : ne < 240 ? (ue = ((ne & 15) << 12) + (ie[Re + 1] & 63) * 64 + (ie[Re + 2] & 63), ae = 3) : (ue = (ne & 7) * 262144 + ((ie[Re + 1] & 63) << 12) + (ie[Re + 2] & 63) * 64 + (ie[Re + 3] & 63), ae = 4), ue < 65536 ? (k[Ee++] = ue & 255, k[Ee++] = ue >> 8) : (ue -= 65536, Oe = 55296 + (ue >> 10 & 1023), ue = 56320 + (ue & 1023), k[Ee++] = Oe & 255, k[Ee++] = Oe >>> 8, k[Ee++] = ue & 255, k[Ee++] = ue >>> 8 & 255);
          return k.slice(0, Ee).toString("ucs2");
        }, S[65001] = function(ie, X) {
          if (x && Buffer.isBuffer(ie))
            return !X || X === "buf" ? ie : X !== "arr" ? ie.toString("binary") : [].slice.call(ie);
          var ue = ie.length, Oe = 0, Re = 0, ae = 0, Ee = typeof ie == "string";
          4 * ue > Y && (Y = 4 * ue, k = Buffer.allocUnsafe(Y));
          for (var ne = 0; ne < ue; ++ne)
            Oe = Ee ? ie.charCodeAt(ne) : ie[ne].charCodeAt(0), Oe <= 127 ? k[ae++] = Oe : Oe <= 2047 ? (k[ae++] = 192 + (Oe >> 6), k[ae++] = 128 + (Oe & 63)) : Oe >= 55296 && Oe <= 57343 ? (Oe -= 55296, ++ne, Re = (Ee ? ie.charCodeAt(ne) : ie[ne].charCodeAt(0)) - 56320 + (Oe << 10), k[ae++] = 240 + (Re >>> 18 & 7), k[ae++] = 144 + (Re >>> 12 & 63), k[ae++] = 128 + (Re >>> 6 & 63), k[ae++] = 128 + (Re & 63)) : (k[ae++] = 224 + (Oe >> 12), k[ae++] = 128 + (Oe >> 6 & 63), k[ae++] = 128 + (Oe & 63));
          return !X || X === "buf" ? k.slice(0, ae) : X !== "arr" ? k.slice(0, ae).toString("binary") : [].slice.call(k, 0, ae);
        };
      }
      var _e = function() {
        if (x) {
          if (C[r[0]])
            return;
          var ie = 0, X = 0;
          for (ie = 0; ie < r.length; ++ie)
            X = r[ie], o[X] && (C[X] = H(X), O[X] = Z(X));
          for (ie = 0; ie < e.length; ++ie)
            X = e[ie], o[X] && (C[X] = Q(X), O[X] = K(X));
          for (ie = 0; ie < g.length; ++ie)
            X = g[ie], h[X] && (C[X] = h[X]), S[X] && (O[X] = S[X]);
        }
      }, se = function(de, ie) {
        return "";
      }, Pe = function(ie) {
        delete C[ie], delete O[ie];
      }, Ke = function() {
        if (x) {
          if (!C[r[0]])
            return;
          r.forEach(Pe), e.forEach(Pe), g.forEach(Pe);
        }
        ge = se, w = 0;
      }, ye = {
        encache: _e,
        decache: Ke,
        sbcs: r,
        dbcs: e
      };
      _e();
      var Je = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", mt = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'(),-./:?", ge = se, w = 0, fe = function de(ie, X, ue) {
        if (ie === w && ge)
          return ge(X, ue);
        if (O[ie])
          return ge = O[w = ie], ge(X, ue);
        x && Buffer.isBuffer(X) && (X = X.toString("utf8"));
        var Oe = X.length, Re = x ? Buffer.allocUnsafe(4 * Oe) : [], ae = 0, Ee = 0, ne = 0, Ge = 0, we = o[ie], st, Rt = "", rt = typeof X == "string";
        if (we && (st = we.enc))
          for (Ee = 0; Ee < Oe; ++Ee, ++ne)
            ae = st[rt ? X.charAt(Ee) : X[Ee]], ae > 255 ? (Re[ne] = ae >> 8, Re[++ne] = ae & 255) : Re[ne] = ae & 255;
        else if (Rt = c[ie])
          switch (Rt) {
            case "utf8":
              if (x && rt) {
                Re = L(X, Rt), ne = Re.length;
                break;
              }
              for (Ee = 0; Ee < Oe; ++Ee, ++ne)
                ae = rt ? X.charCodeAt(Ee) : X[Ee].charCodeAt(0), ae <= 127 ? Re[ne] = ae : ae <= 2047 ? (Re[ne] = 192 + (ae >> 6), Re[++ne] = 128 + (ae & 63)) : ae >= 55296 && ae <= 57343 ? (ae -= 55296, Ge = (rt ? X.charCodeAt(++Ee) : X[++Ee].charCodeAt(0)) - 56320 + (ae << 10), Re[ne] = 240 + (Ge >>> 18 & 7), Re[++ne] = 144 + (Ge >>> 12 & 63), Re[++ne] = 128 + (Ge >>> 6 & 63), Re[++ne] = 128 + (Ge & 63)) : (Re[ne] = 224 + (ae >> 12), Re[++ne] = 128 + (ae >> 6 & 63), Re[++ne] = 128 + (ae & 63));
              break;
            case "ascii":
              if (x && typeof X == "string") {
                Re = L(X, Rt), ne = Re.length;
                break;
              }
              for (Ee = 0; Ee < Oe; ++Ee, ++ne)
                if (ae = rt ? X.charCodeAt(Ee) : X[Ee].charCodeAt(0), ae <= 127)
                  Re[ne] = ae;
                else
                  throw new Error("bad ascii " + ae);
              break;
            case "utf16le":
              if (x && typeof X == "string") {
                Re = L(X, Rt), ne = Re.length;
                break;
              }
              for (Ee = 0; Ee < Oe; ++Ee)
                ae = rt ? X.charCodeAt(Ee) : X[Ee].charCodeAt(0), Re[ne++] = ae & 255, Re[ne++] = ae >> 8;
              break;
            case "utf16be":
              for (Ee = 0; Ee < Oe; ++Ee)
                ae = rt ? X.charCodeAt(Ee) : X[Ee].charCodeAt(0), Re[ne++] = ae >> 8, Re[ne++] = ae & 255;
              break;
            case "utf32le":
              for (Ee = 0; Ee < Oe; ++Ee)
                ae = rt ? X.charCodeAt(Ee) : X[Ee].charCodeAt(0), ae >= 55296 && ae <= 57343 && (ae = 65536 + (ae - 55296 << 10) + (X[++Ee].charCodeAt(0) - 56320)), Re[ne++] = ae & 255, ae >>= 8, Re[ne++] = ae & 255, ae >>= 8, Re[ne++] = ae & 255, ae >>= 8, Re[ne++] = ae & 255;
              break;
            case "utf32be":
              for (Ee = 0; Ee < Oe; ++Ee)
                ae = rt ? X.charCodeAt(Ee) : X[Ee].charCodeAt(0), ae >= 55296 && ae <= 57343 && (ae = 65536 + (ae - 55296 << 10) + (X[++Ee].charCodeAt(0) - 56320)), Re[ne + 3] = ae & 255, ae >>= 8, Re[ne + 2] = ae & 255, ae >>= 8, Re[ne + 1] = ae & 255, ae >>= 8, Re[ne] = ae & 255, ne += 4;
              break;
            case "utf7":
              for (Ee = 0; Ee < Oe; Ee++) {
                var z = rt ? X.charAt(Ee) : X[Ee].charAt(0);
                if (z === "+") {
                  Re[ne++] = 43, Re[ne++] = 45;
                  continue;
                }
                if (mt.indexOf(z) > -1) {
                  Re[ne++] = z.charCodeAt(0);
                  continue;
                }
                var V = de(1201, z);
                Re[ne++] = 43, Re[ne++] = Je.charCodeAt(V[0] >> 2), Re[ne++] = Je.charCodeAt(((V[0] & 3) << 4) + ((V[1] || 0) >> 4)), Re[ne++] = Je.charCodeAt(((V[1] & 15) << 2) + ((V[2] || 0) >> 6)), Re[ne++] = 45;
              }
              break;
            default:
              throw new Error("Unsupported magic: " + ie + " " + c[ie]);
          }
        else
          throw new Error("Unrecognized CP: " + ie);
        return Re = Re.slice(0, ne), x ? !ue || ue === "buf" ? Re : ue !== "arr" ? Re.toString("binary") : [].slice.call(Re) : ue == "str" ? Re.map(N).join("") : Re;
      }, j = function de(ie, X) {
        var ue;
        if (ue = C[ie])
          return ue(X);
        if (typeof X == "string")
          return de(ie, X.split("").map(D));
        var Oe = X.length, Re = new Array(Oe), ae = "", Ee = 0, ne = 0, Ge = 1, we = 0, st = 0, Rt = o[ie], rt, z = "";
        if (Rt && (rt = Rt.dec))
          for (ne = 0; ne < Oe; ne += Ge) {
            if (Ge = 2, ae = rt[(X[ne] << 8) + X[ne + 1]], ae || (Ge = 1, ae = rt[X[ne]]), !ae)
              throw new Error("Unrecognized code: " + X[ne] + " " + X[ne + Ge - 1] + " " + ne + " " + Ge + " " + rt[X[ne]]);
            Re[we++] = ae;
          }
        else if (z = c[ie])
          switch (z) {
            case "utf8":
              for (Oe >= 3 && X[0] == 239 && X[1] == 187 && X[2] == 191 && (ne = 3); ne < Oe; ne += Ge)
                Ge = 1, X[ne] < 128 ? Ee = X[ne] : X[ne] < 224 ? (Ee = (X[ne] & 31) * 64 + (X[ne + 1] & 63), Ge = 2) : X[ne] < 240 ? (Ee = ((X[ne] & 15) << 12) + (X[ne + 1] & 63) * 64 + (X[ne + 2] & 63), Ge = 3) : (Ee = (X[ne] & 7) * 262144 + ((X[ne + 1] & 63) << 12) + (X[ne + 2] & 63) * 64 + (X[ne + 3] & 63), Ge = 4), Ee < 65536 || (Ee -= 65536, st = 55296 + (Ee >> 10 & 1023), Ee = 56320 + (Ee & 1023), Re[we++] = String.fromCharCode(st)), Re[we++] = String.fromCharCode(Ee);
              break;
            case "ascii":
              if (x && Buffer.isBuffer(X))
                return X.toString(z);
              for (ne = 0; ne < Oe; ne++)
                Re[ne] = String.fromCharCode(X[ne]);
              we = Oe;
              break;
            case "utf16le":
              if (Oe >= 2 && X[0] == 255 && X[1] == 254 && (ne = 2), x && Buffer.isBuffer(X))
                return X.toString(z);
              for (Ge = 2; ne + 1 < Oe; ne += Ge)
                Re[we++] = String.fromCharCode((X[ne + 1] << 8) + X[ne]);
              break;
            case "utf16be":
              for (Oe >= 2 && X[0] == 254 && X[1] == 255 && (ne = 2), Ge = 2; ne + 1 < Oe; ne += Ge)
                Re[we++] = String.fromCharCode((X[ne] << 8) + X[ne + 1]);
              break;
            case "utf32le":
              for (Oe >= 4 && X[0] == 255 && X[1] == 254 && X[2] === 0 && X[3] === 0 && (ne = 4), Ge = 4; ne < Oe; ne += Ge)
                Ee = (X[ne + 3] << 24) + (X[ne + 2] << 16) + (X[ne + 1] << 8) + X[ne], Ee > 65535 ? (Ee -= 65536, Re[we++] = String.fromCharCode(55296 + (Ee >> 10 & 1023)), Re[we++] = String.fromCharCode(56320 + (Ee & 1023))) : Re[we++] = String.fromCharCode(Ee);
              break;
            case "utf32be":
              for (Oe >= 4 && X[3] == 255 && X[2] == 254 && X[1] === 0 && X[0] === 0 && (ne = 4), Ge = 4; ne < Oe; ne += Ge)
                Ee = (X[ne] << 24) + (X[ne + 1] << 16) + (X[ne + 2] << 8) + X[ne + 3], Ee > 65535 ? (Ee -= 65536, Re[we++] = String.fromCharCode(55296 + (Ee >> 10 & 1023)), Re[we++] = String.fromCharCode(56320 + (Ee & 1023))) : Re[we++] = String.fromCharCode(Ee);
              break;
            case "utf7":
              for (Oe >= 4 && X[0] == 43 && X[1] == 47 && X[2] == 118 && (Oe >= 5 && X[3] == 56 && X[4] == 45 ? ne = 5 : (X[3] == 56 || X[3] == 57 || X[3] == 43 || X[3] == 47) && (ne = 4)); ne < Oe; ne += Ge) {
                if (X[ne] !== 43) {
                  Ge = 1, Re[we++] = String.fromCharCode(X[ne]);
                  continue;
                }
                if (Ge = 1, X[ne + 1] === 45) {
                  Ge = 2, Re[we++] = "+";
                  continue;
                }
                for (; String.fromCharCode(X[ne + Ge]).match(/[A-Za-z0-9+\/]/); )
                  Ge++;
                var V = 0;
                X[ne + Ge] === 45 && (++Ge, V = 1);
                for (var Te = [], Be = "", Le = 0, Yt = 0, Nt = 0, Hr = 0, Er = 0, tr = 0, vr = 0, Pr = 1; Pr < Ge - V && (Hr = Je.indexOf(String.fromCharCode(X[ne + Pr++])), Er = Je.indexOf(String.fromCharCode(X[ne + Pr++])), Le = Hr << 2 | Er >> 4, Te.push(Le), tr = Je.indexOf(String.fromCharCode(X[ne + Pr++])), !(tr === -1 || (Yt = (Er & 15) << 4 | tr >> 2, Te.push(Yt), vr = Je.indexOf(String.fromCharCode(X[ne + Pr++])), vr === -1))); )
                  Nt = (tr & 3) << 6 | vr, vr < 64 && Te.push(Nt);
                for (Be = de(1201, Te), Pr = 0; Pr < Be.length; ++Pr)
                  Re[we++] = Be.charAt(Pr);
              }
              break;
            default:
              throw new Error("Unsupported magic: " + ie + " " + c[ie]);
          }
        else
          throw new Error("Unrecognized CP: " + ie);
        return Re.slice(0, we).join("");
      }, J = function(ie) {
        return !!(o[ie] || c[ie]);
      };
      return o.utils = { decode: j, encode: fe, hascp: J, magic: c, cache: ye }, o;
    });
  }(Xc)), Xc.exports;
}
const TA = {}, vA = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: TA
}, Symbol.toStringTag, { value: "Module" })), Zc = /* @__PURE__ */ pA(vA);
(function(s, i) {
  var o = {};
  function c(r) {
    r.version = "0.18.5", r.style_version = "1.2.0";
    var e, g = 1200, h = 1252;
    typeof cptable < "u" ? e = cptable : typeof el < "u" && (e = bA());
    var S = [874, 932, 936, 949, 950, 1250, 1251, 1252, 1253, 1254, 1255, 1256, 1257, 1258, 1e4], C = { 0: 1252, 1: 65001, 2: 65001, 77: 1e4, 128: 932, 129: 949, 130: 1361, 134: 936, 136: 950, 161: 1253, 162: 1254, 163: 1258, 177: 1255, 178: 1256, 186: 1257, 204: 1251, 222: 874, 238: 1250, 255: 1252, 69: 6969 }, O = function(t) {
      S.indexOf(t) != -1 && (h = C[0] = t);
    }, N = function(t) {
      O(g = t);
    };
    function D() {
      N(1200), O(1252);
    }
    function x(t) {
      for (var n = [], a = 0, l = t.length; a < l; ++a)
        n[a] = t.charCodeAt(a);
      return n;
    }
    function L(t) {
      for (var n = [], a = 0; a < t.length >> 1; ++a)
        n[a] = String.fromCharCode(t.charCodeAt(2 * a + 1) + (t.charCodeAt(2 * a) << 8));
      return n.join("");
    }
    var G = function(t) {
      var n = t.charCodeAt(0), a = t.charCodeAt(1);
      return n == 255 && a == 254 ? function(l) {
        for (var d = [], _ = 0; _ < l.length >> 1; ++_)
          d[_] = String.fromCharCode(l.charCodeAt(2 * _) + (l.charCodeAt(2 * _ + 1) << 8));
        return d.join("");
      }(t.slice(2)) : n == 254 && a == 255 ? L(t.slice(2)) : n == 65279 ? t.slice(1) : t;
    }, Y = function(t) {
      return String.fromCharCode(t);
    }, k = function(t) {
      return String.fromCharCode(t);
    };
    e !== void 0 && (N = function(t) {
      O(g = t);
    }, G = function(t) {
      return t.charCodeAt(0) === 255 && t.charCodeAt(1) === 254 ? e.utils.decode(1200, x(t.slice(2))) : t;
    }, Y = function(t) {
      return g === 1200 ? String.fromCharCode(t) : e.utils.decode(g, [255 & t, t >> 8])[0];
    }, k = function(t) {
      return e.utils.decode(h, [t])[0];
    });
    var W = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
    function Z(t) {
      for (var n, a, l, d, _, u = "", p = 0, m = 0, f = 0; f < t.length; )
        d = (n = t.charCodeAt(f++)) >> 2, _ = (3 & n) << 4 | (a = t.charCodeAt(f++)) >> 4, p = (15 & a) << 2 | (l = t.charCodeAt(f++)) >> 6, m = 63 & l, isNaN(a) ? p = m = 64 : isNaN(l) && (m = 64), u += W.charAt(d) + W.charAt(_) + W.charAt(p) + W.charAt(m);
      return u;
    }
    function H(t) {
      var n, a, l, d, _, u, p = "";
      t = t.replace(/[^\w\+\/\=]/g, "");
      for (var m = 0; m < t.length; )
        n = W.indexOf(t.charAt(m++)) << 2 | (d = W.indexOf(t.charAt(m++))) >> 4, p += String.fromCharCode(n), a = (15 & d) << 4 | (_ = W.indexOf(t.charAt(m++))) >> 2, _ !== 64 && (p += String.fromCharCode(a)), l = (3 & _) << 6 | (u = W.indexOf(t.charAt(m++))), u !== 64 && (p += String.fromCharCode(l));
      return p;
    }
    var K = typeof Buffer < "u" && typeof process < "u" && process.versions !== void 0 && !!process.versions.node, Q = function() {
      if (typeof Buffer > "u")
        return function() {
        };
      var t = !Buffer.from;
      if (!t)
        try {
          Buffer.from("foo", "utf8");
        } catch {
          t = !0;
        }
      return t ? function(n, a) {
        return a ? new Buffer(n, a) : new Buffer(n);
      } : Buffer.from.bind(Buffer);
    }();
    function _e(t) {
      return K ? Buffer.alloc ? Buffer.alloc(t) : new Buffer(t) : new (typeof Uint8Array < "u" ? Uint8Array : Array)(t);
    }
    function se(t) {
      return K ? Buffer.allocUnsafe ? Buffer.allocUnsafe(t) : new Buffer(t) : new (typeof Uint8Array < "u" ? Uint8Array : Array)(t);
    }
    var Pe = function(t) {
      return K ? Q(t, "binary") : t.split("").map(function(n) {
        return 255 & n.charCodeAt(0);
      });
    };
    function Ke(t) {
      if (typeof ArrayBuffer > "u")
        return Pe(t);
      for (var n = new ArrayBuffer(t.length), a = new Uint8Array(n), l = 0; l != t.length; ++l)
        a[l] = 255 & t.charCodeAt(l);
      return n;
    }
    function ye(t) {
      if (Array.isArray(t))
        return t.map(function(l) {
          return String.fromCharCode(l);
        }).join("");
      for (var n = [], a = 0; a < t.length; ++a)
        n[a] = String.fromCharCode(t[a]);
      return n.join("");
    }
    function Je(t) {
      if (typeof ArrayBuffer > "u")
        throw new Error("Unsupported");
      if (t instanceof ArrayBuffer)
        return Je(new Uint8Array(t));
      for (var n = new Array(t.length), a = 0; a < t.length; ++a)
        n[a] = t[a];
      return n;
    }
    var mt = K ? function(t) {
      return Buffer.concat(t.map(function(n) {
        return Buffer.isBuffer(n) ? n : Q(n);
      }));
    } : function(t) {
      if (typeof Uint8Array > "u")
        return [].concat.apply([], t.map(function(_) {
          return Array.isArray(_) ? _ : [].slice.call(_);
        }));
      for (var a = 0, n = 0, a = 0; a < t.length; ++a)
        n += t[a].length;
      for (var l, d = new Uint8Array(n), n = a = 0; a < t.length; n += l, ++a)
        if (l = t[a].length, t[a] instanceof Uint8Array)
          d.set(t[a], n);
        else {
          if (typeof t[a] == "string")
            throw "wtf";
          d.set(new Uint8Array(t[a]), n);
        }
      return d;
    }, ge = /\u0000/g, w = /[\u0001-\u0006]/g;
    function fe(t) {
      for (var n = "", a = t.length - 1; 0 <= a; )
        n += t.charAt(a--);
      return n;
    }
    function j(t, n) {
      return t = "" + t, n <= t.length ? t : Wr("0", n - t.length) + t;
    }
    function J(t, n) {
      return t = "" + t, n <= t.length ? t : Wr(" ", n - t.length) + t;
    }
    function de(t, n) {
      return t = "" + t, n <= t.length ? t : t + Wr(" ", n - t.length);
    }
    var ie = Math.pow(2, 32);
    function X(d, n) {
      if (ie < d || d < -ie)
        return a = d, l = n, a = "" + Math.round(a), l <= a.length ? a : Wr("0", l - a.length) + a;
      var a, l, d = Math.round(d);
      return (n = n) <= (d = "" + (d = d)).length ? d : Wr("0", n - d.length) + d;
    }
    function ue(t, n) {
      return n = n || 0, t.length >= 7 + n && (32 | t.charCodeAt(n)) == 103 && (32 | t.charCodeAt(n + 1)) == 101 && (32 | t.charCodeAt(n + 2)) == 110 && (32 | t.charCodeAt(n + 3)) == 101 && (32 | t.charCodeAt(n + 4)) == 114 && (32 | t.charCodeAt(n + 5)) == 97 && (32 | t.charCodeAt(n + 6)) == 108;
    }
    var Oe = [["Sun", "Sunday"], ["Mon", "Monday"], ["Tue", "Tuesday"], ["Wed", "Wednesday"], ["Thu", "Thursday"], ["Fri", "Friday"], ["Sat", "Saturday"]], Re = [["J", "Jan", "January"], ["F", "Feb", "February"], ["M", "Mar", "March"], ["A", "Apr", "April"], ["M", "May", "May"], ["J", "Jun", "June"], ["J", "Jul", "July"], ["A", "Aug", "August"], ["S", "Sep", "September"], ["O", "Oct", "October"], ["N", "Nov", "November"], ["D", "Dec", "December"]], ae = { 0: "General", 1: "0", 2: "0.00", 3: "#,##0", 4: "#,##0.00", 9: "0%", 10: "0.00%", 11: "0.00E+00", 12: "# ?/?", 13: "# ??/??", 14: "m/d/yy", 15: "d-mmm-yy", 16: "d-mmm", 17: "mmm-yy", 18: "h:mm AM/PM", 19: "h:mm:ss AM/PM", 20: "h:mm", 21: "h:mm:ss", 22: "m/d/yy h:mm", 37: "#,##0 ;(#,##0)", 38: "#,##0 ;[Red](#,##0)", 39: "#,##0.00;(#,##0.00)", 40: "#,##0.00;[Red](#,##0.00)", 45: "mm:ss", 46: "[h]:mm:ss", 47: "mmss.0", 48: "##0.0E+0", 49: "@", 56: '"上午/下午 "hh"時"mm"分"ss"秒 "' }, Ee = { 5: 37, 6: 38, 7: 39, 8: 40, 23: 0, 24: 0, 25: 0, 26: 0, 27: 14, 28: 14, 29: 14, 30: 14, 31: 14, 50: 14, 51: 14, 52: 14, 53: 14, 54: 14, 55: 14, 56: 14, 57: 14, 58: 14, 59: 1, 60: 2, 61: 3, 62: 4, 67: 9, 68: 10, 69: 12, 70: 13, 71: 14, 72: 14, 73: 15, 74: 16, 75: 17, 76: 20, 77: 21, 78: 22, 79: 45, 80: 46, 81: 47, 82: 0 }, ne = { 5: '"$"#,##0_);\\("$"#,##0\\)', 63: '"$"#,##0_);\\("$"#,##0\\)', 6: '"$"#,##0_);[Red]\\("$"#,##0\\)', 64: '"$"#,##0_);[Red]\\("$"#,##0\\)', 7: '"$"#,##0.00_);\\("$"#,##0.00\\)', 65: '"$"#,##0.00_);\\("$"#,##0.00\\)', 8: '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)', 66: '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)', 41: '_(* #,##0_);_(* \\(#,##0\\);_(* "-"_);_(@_)', 42: '_("$"* #,##0_);_("$"* \\(#,##0\\);_("$"* "-"_);_(@_)', 43: '_(* #,##0.00_);_(* \\(#,##0.00\\);_(* "-"??_);_(@_)', 44: '_("$"* #,##0.00_);_("$"* \\(#,##0.00\\);_("$"* "-"??_);_(@_)' };
    function Ge(t, n, a) {
      for (var l = t < 0 ? -1 : 1, d = t * l, _ = 0, u = 1, p = 0, m = 1, f = 0, E = 0, b = Math.floor(d); f < n && (p = (b = Math.floor(d)) * u + _, E = b * f + m, !(d - b < 5e-8)); )
        d = 1 / (d - b), _ = u, u = p, m = f, f = E;
      return n < E && (p = n < f ? (E = m, _) : (E = f, u)), a ? (a = Math.floor(l * p / E), [a, l * p - a * E, E]) : [0, l * p, E];
    }
    function we(p, n, a) {
      if (2958465 < p || p < 0)
        return null;
      var l = 0 | p, d = Math.floor(86400 * (p - l)), _ = 0, u = [], p = { D: l, T: d, u: 86400 * (p - l) - d, y: 0, m: 0, d: 0, H: 0, M: 0, S: 0, q: 0 };
      return Math.abs(p.u) < 1e-6 && (p.u = 0), n && n.date1904 && (l += 1462), 0.9999 < p.u && (p.u = 0, ++d == 86400 && (p.T = d = 0, ++l, ++p.D)), l === 60 ? (u = a ? [1317, 10, 29] : [1900, 2, 29], _ = 3) : l === 0 ? (u = a ? [1317, 8, 29] : [1900, 1, 0], _ = 6) : (60 < l && --l, (n = new Date(1900, 0, 1)).setDate(n.getDate() + l - 1), u = [n.getFullYear(), n.getMonth() + 1, n.getDate()], _ = n.getDay(), l < 60 && (_ = (_ + 6) % 7), a && (_ = function(m, f) {
        return f[0] -= 581, f = m.getDay(), m < 60 && (f = (f + 6) % 7), f;
      }(n, u))), p.y = u[0], p.m = u[1], p.d = u[2], p.S = d % 60, d = Math.floor(d / 60), p.M = d % 60, d = Math.floor(d / 60), p.H = d, p.q = _, p;
    }
    var st = new Date(1899, 11, 31, 0, 0, 0), Rt = st.getTime(), rt = new Date(1900, 2, 1, 0, 0, 0);
    function z(t, n) {
      var a = t.getTime();
      return n ? a -= 1262304e5 : rt <= t && (a += 864e5), (a - (Rt + 6e4 * (t.getTimezoneOffset() - st.getTimezoneOffset()))) / 864e5;
    }
    function V(t) {
      return t.indexOf(".") == -1 ? t : t.replace(/(?:\.0*|(\.\d*[1-9])0+)$/, "$1");
    }
    function Te(t) {
      var n, a, l, d = Math.floor(Math.log(Math.abs(t)) * Math.LOG10E), _ = -4 <= d && d <= -1 ? t.toPrecision(10 + d) : Math.abs(d) <= 9 ? (a = (n = t) < 0 ? 12 : 11, (l = V(n.toFixed(12))).length <= a || (l = n.toPrecision(10)).length <= a ? l : n.toExponential(5)) : d === 10 ? t.toFixed(10).substr(0, 12) : (_ = V((t = t).toFixed(11))).length > (t < 0 ? 12 : 11) || _ === "0" || _ === "-0" ? t.toPrecision(6) : _;
      return V((_ = _.toUpperCase()).indexOf("E") == -1 ? _ : _.replace(/(?:\.0*|(\.\d*[1-9])0+)[Ee]/, "$1E").replace(/(E[+-])(\d)$/, "$10$2"));
    }
    function Be(t, n) {
      switch (typeof t) {
        case "string":
          return t;
        case "boolean":
          return t ? "TRUE" : "FALSE";
        case "number":
          return (0 | t) === t ? t.toString(10) : Te(t);
        case "undefined":
          return "";
        case "object":
          if (t == null)
            return "";
          if (t instanceof Date)
            return dn(14, z(t, n && n.date1904), n);
      }
      throw new Error("unsupported value in General format: " + t);
    }
    function Le(t) {
      if (t.length <= 3)
        return t;
      for (var n = t.length % 3, a = t.substr(0, n); n != t.length; n += 3)
        a += (0 < a.length ? "," : "") + t.substr(n, 3);
      return a;
    }
    var Yt = /%/g, Nt = /# (\?+)( ?)\/( ?)(\d+)/, Hr = /^#*0*\.([0#]+)/, Er = /\).*[0#]/, tr = /\(###\) ###\\?-####/;
    function vr(t) {
      for (var n, a = "", l = 0; l != t.length; ++l)
        switch (n = t.charCodeAt(l)) {
          case 35:
            break;
          case 63:
            a += " ";
            break;
          case 48:
            a += "0";
            break;
          default:
            a += String.fromCharCode(n);
        }
      return a;
    }
    function Pr(t, n) {
      return n = Math.pow(10, n), "" + Math.round(t * n) / n;
    }
    function ur(l, n) {
      var a = l - Math.floor(l), l = Math.pow(10, n);
      return n < ("" + Math.round(a * l)).length ? 0 : Math.round(a * l);
    }
    function Ae(t, n, a) {
      if (t.charCodeAt(0) === 40 && !n.match(Er)) {
        var l = n.replace(/\( */, "").replace(/ \)/, "").replace(/\)/, "");
        return 0 <= a ? Ae("n", l, a) : "(" + Ae("n", l, -a) + ")";
      }
      if (n.charCodeAt(n.length - 1) === 44)
        return function(A, M, F) {
          for (var B = M.length - 1; M.charCodeAt(B - 1) === 44; )
            --B;
          return qe(A, M.substr(0, B), F / Math.pow(10, 3 * (M.length - B)));
        }(t, n, a);
      if (n.indexOf("%") !== -1)
        return p = t, f = a, m = (E = n).replace(Yt, ""), E = E.length - m.length, qe(p, m, f * Math.pow(10, 2 * E)) + Wr("%", E);
      var d;
      if (n.indexOf("E") !== -1)
        return function A(M, F) {
          var B, re = M.indexOf("E") - M.indexOf(".") - 1;
          if (M.match(/^#+0.0E\+0$/)) {
            if (F == 0)
              return "0.0E+0";
            if (F < 0)
              return "-" + A(M, -F);
            var me = M.indexOf(".");
            me === -1 && (me = M.indexOf("E"));
            var le = Math.floor(Math.log(F) * Math.LOG10E) % me;
            if (le < 0 && (le += me), (B = (F / Math.pow(10, le)).toPrecision(1 + re + (me + le) % me)).indexOf("e") === -1) {
              var be = Math.floor(Math.log(F) * Math.LOG10E);
              for (B.indexOf(".") === -1 ? B = B.charAt(0) + "." + B.substr(1) + "E+" + (be - B.length + le) : B += "E+" + (be - le); B.substr(0, 2) === "0."; )
                B = (B = B.charAt(0) + B.substr(2, me) + "." + B.substr(2 + me)).replace(/^0+([1-9])/, "$1").replace(/^0+\./, "0.");
              B = B.replace(/\+-/, "-");
            }
            B = B.replace(/^([+-]?)(\d*)\.(\d*)[Ee]/, function(Fe, Ue, Ne, ze) {
              return Ue + Ne + ze.substr(0, (me + le) % me) + "." + ze.substr(le) + "E";
            });
          } else
            B = F.toExponential(re);
          return M.match(/E\+00$/) && B.match(/e[+-]\d$/) && (B = B.substr(0, B.length - 1) + "0" + B.charAt(B.length - 1)), (B = M.match(/E\-/) && B.match(/e\+/) ? B.replace(/e\+/, "e") : B).replace("e", "E");
        }(n, a);
      if (n.charCodeAt(0) === 36)
        return "$" + Ae(t, n.substr(n.charAt(1) == " " ? 2 : 1), a);
      var _, u, p, m, f, E, b, T = Math.abs(a), v = a < 0 ? "-" : "";
      if (n.match(/^00+$/))
        return v + X(T, n.length);
      if (n.match(/^[#?]+$/))
        return (d = (d = X(a, 0)) === "0" ? "" : d).length > n.length ? d : vr(n.substr(0, n.length - d.length)) + d;
      if (_ = n.match(Nt))
        return b = _, p = T, m = v, f = parseInt(b[4], 10), E = Math.round(p * f), p = Math.floor(E / f), m + (p === 0 ? "" : "" + p) + " " + ((E -= p * f) == 0 ? Wr(" ", b[1].length + 1 + b[4].length) : J(E, b[1].length) + b[2] + "/" + b[3] + j(f, b[4].length));
      if (n.match(/^#+0+$/))
        return v + X(T, n.length - n.indexOf("0"));
      if (_ = n.match(Hr))
        return d = Pr(a, _[1].length).replace(/^([^\.]+)$/, "$1." + vr(_[1])).replace(/\.$/, "." + vr(_[1])).replace(/\.(\d*)$/, function(A, M) {
          return "." + M + Wr("0", vr(_[1]).length - M.length);
        }), n.indexOf("0.") !== -1 ? d : d.replace(/^0\./, ".");
      if (n = n.replace(/^#+([0.])/, "$1"), _ = n.match(/^(0*)\.(#*)$/))
        return v + Pr(T, _[2].length).replace(/\.(\d*[1-9])0*$/, ".$1").replace(/^(-?\d*)$/, "$1.").replace(/^0\./, _[1].length ? "0." : ".");
      if (_ = n.match(/^#{1,3},##0(\.?)$/))
        return v + Le(X(T, 0));
      if (_ = n.match(/^#,##0\.([#0]*0)$/))
        return a < 0 ? "-" + Ae(t, n, -a) : Le("" + (Math.floor(a) + (b = a, (y = _[1].length) < ("" + Math.round((b - Math.floor(b)) * Math.pow(10, y))).length ? 1 : 0))) + "." + j(ur(a, _[1].length), _[1].length);
      if (_ = n.match(/^#,#*,#0/))
        return Ae(t, n.replace(/^#,#*,/, ""), a);
      if (_ = n.match(/^([0#]+)(\\?-([0#]+))+$/))
        return d = fe(Ae(t, n.replace(/[\\-]/g, ""), a)), u = 0, fe(fe(n.replace(/\\/g, "")).replace(/[0#]/g, function(A) {
          return u < d.length ? d.charAt(u++) : A === "0" ? "0" : "";
        }));
      if (n.match(tr))
        return "(" + (d = Ae(t, "##########", a)).substr(0, 3) + ") " + d.substr(3, 3) + "-" + d.substr(6);
      var y = "";
      if (_ = n.match(/^([#0?]+)( ?)\/( ?)([#0?]+)/))
        return u = Math.min(_[4].length, 7), R = Ge(T, Math.pow(10, u) - 1, !1), d = v, (y = qe("n", _[1], R[1])).charAt(y.length - 1) == " " && (y = y.substr(0, y.length - 1) + "0"), d += y + _[2] + "/" + _[3], (y = de(R[2], u)).length < _[4].length && (y = vr(_[4].substr(_[4].length - y.length)) + y), d += y;
      if (_ = n.match(/^# ([#0?]+)( ?)\/( ?)([#0?]+)/))
        return u = Math.min(Math.max(_[1].length, _[4].length), 7), v + ((R = Ge(T, Math.pow(10, u) - 1, !0))[0] || (R[1] ? "" : "0")) + " " + (R[1] ? J(R[1], u) + _[2] + "/" + _[3] + de(R[2], u) : Wr(" ", 2 * u + 1 + _[2].length + _[3].length));
      if (_ = n.match(/^[#0?]+$/))
        return d = X(a, 0), n.length <= d.length ? d : vr(n.substr(0, n.length - d.length)) + d;
      if (_ = n.match(/^([#0?]+)\.([#0]+)$/)) {
        d = "" + a.toFixed(Math.min(_[2].length, 10)).replace(/([^0])0+$/, "$1"), u = d.indexOf(".");
        var R = n.indexOf(".") - u, P = n.length - d.length - R;
        return vr(n.substr(0, R) + d + n.substr(n.length - P));
      }
      if (_ = n.match(/^00,000\.([#0]*0)$/))
        return u = ur(a, _[1].length), a < 0 ? "-" + Ae(t, n, -a) : Le((P = a) < 2147483647 && -2147483648 < P ? "" + (0 <= P ? 0 | P : P - 1 | 0) : "" + Math.floor(P)).replace(/^\d,\d{3}$/, "0$&").replace(/^\d*$/, function(A) {
          return "00," + (A.length < 3 ? j(0, 3 - A.length) : "") + A;
        }) + "." + j(u, _[1].length);
      switch (n) {
        case "###,##0.00":
          return Ae(t, "#,##0.00", a);
        case "###,###":
        case "##,###":
        case "#,###":
          var I = Le(X(T, 0));
          return I !== "0" ? v + I : "";
        case "###,###.00":
          return Ae(t, "###,##0.00", a).replace(/^0\./, ".");
        case "#,###.00":
          return Ae(t, "#,##0.00", a).replace(/^0\./, ".");
      }
      throw new Error("unsupported format |" + n + "|");
    }
    function pe(t, n, a) {
      if (t.charCodeAt(0) === 40 && !n.match(Er)) {
        var l = n.replace(/\( */, "").replace(/ \)/, "").replace(/\)/, "");
        return 0 <= a ? pe("n", l, a) : "(" + pe("n", l, -a) + ")";
      }
      if (n.charCodeAt(n.length - 1) === 44)
        return function(R, P, I) {
          for (var A = P.length - 1; P.charCodeAt(A - 1) === 44; )
            --A;
          return qe(R, P.substr(0, A), I / Math.pow(10, 3 * (P.length - A)));
        }(t, n, a);
      if (n.indexOf("%") !== -1)
        return d = t, u = a, l = (_ = n).replace(Yt, ""), _ = _.length - l.length, qe(d, l, u * Math.pow(10, 2 * _)) + Wr("%", _);
      var d, _, u, p;
      if (n.indexOf("E") !== -1)
        return function R(P, I) {
          var A, M = P.indexOf("E") - P.indexOf(".") - 1;
          if (P.match(/^#+0.0E\+0$/)) {
            if (I == 0)
              return "0.0E+0";
            if (I < 0)
              return "-" + R(P, -I);
            var F = P.indexOf(".");
            F === -1 && (F = P.indexOf("E"));
            var B, re = Math.floor(Math.log(I) * Math.LOG10E) % F;
            re < 0 && (re += F), (A = (I / Math.pow(10, re)).toPrecision(1 + M + (F + re) % F)).match(/[Ee]/) || (B = Math.floor(Math.log(I) * Math.LOG10E), A.indexOf(".") === -1 ? A = A.charAt(0) + "." + A.substr(1) + "E+" + (B - A.length + re) : A += "E+" + (B - re), A = A.replace(/\+-/, "-")), A = A.replace(/^([+-]?)(\d*)\.(\d*)[Ee]/, function(me, le, be, Fe) {
              return le + be + Fe.substr(0, (F + re) % F) + "." + Fe.substr(re) + "E";
            });
          } else
            A = I.toExponential(M);
          return P.match(/E\+00$/) && A.match(/e[+-]\d$/) && (A = A.substr(0, A.length - 1) + "0" + A.charAt(A.length - 1)), (A = P.match(/E\-/) && A.match(/e\+/) ? A.replace(/e\+/, "e") : A).replace("e", "E");
        }(n, a);
      if (n.charCodeAt(0) === 36)
        return "$" + pe(t, n.substr(n.charAt(1) == " " ? 2 : 1), a);
      var m, f, E = Math.abs(a), b = a < 0 ? "-" : "";
      if (n.match(/^00+$/))
        return b + j(E, n.length);
      if (n.match(/^[#?]+$/))
        return (p = a === 0 ? "" : "" + a).length > n.length ? p : vr(n.substr(0, n.length - p.length)) + p;
      if (m = n.match(Nt))
        return b + ((T = E) === 0 ? "" : "" + T) + Wr(" ", (T = m)[1].length + 2 + T[4].length);
      if (n.match(/^#+0+$/))
        return b + j(E, n.length - n.indexOf("0"));
      if (m = n.match(Hr))
        return p = (p = ("" + a).replace(/^([^\.]+)$/, "$1." + vr(m[1])).replace(/\.$/, "." + vr(m[1]))).replace(/\.(\d*)$/, function(R, P) {
          return "." + P + Wr("0", vr(m[1]).length - P.length);
        }), n.indexOf("0.") !== -1 ? p : p.replace(/^0\./, ".");
      if (n = n.replace(/^#+([0.])/, "$1"), m = n.match(/^(0*)\.(#*)$/))
        return b + ("" + E).replace(/\.(\d*[1-9])0*$/, ".$1").replace(/^(-?\d*)$/, "$1.").replace(/^0\./, m[1].length ? "0." : ".");
      if (m = n.match(/^#{1,3},##0(\.?)$/))
        return b + Le("" + E);
      if (m = n.match(/^#,##0\.([#0]*0)$/))
        return a < 0 ? "-" + pe(t, n, -a) : Le("" + a) + "." + Wr("0", m[1].length);
      if (m = n.match(/^#,#*,#0/))
        return pe(t, n.replace(/^#,#*,/, ""), a);
      if (m = n.match(/^([0#]+)(\\?-([0#]+))+$/))
        return p = fe(pe(t, n.replace(/[\\-]/g, ""), a)), f = 0, fe(fe(n.replace(/\\/g, "")).replace(/[0#]/g, function(R) {
          return f < p.length ? p.charAt(f++) : R === "0" ? "0" : "";
        }));
      if (n.match(tr))
        return "(" + (p = pe(t, "##########", a)).substr(0, 3) + ") " + p.substr(3, 3) + "-" + p.substr(6);
      var T = "";
      if (m = n.match(/^([#0?]+)( ?)\/( ?)([#0?]+)/))
        return f = Math.min(m[4].length, 7), v = Ge(E, Math.pow(10, f) - 1, !1), p = b, (T = qe("n", m[1], v[1])).charAt(T.length - 1) == " " && (T = T.substr(0, T.length - 1) + "0"), p += T + m[2] + "/" + m[3], (T = de(v[2], f)).length < m[4].length && (T = vr(m[4].substr(m[4].length - T.length)) + T), p += T;
      if (m = n.match(/^# ([#0?]+)( ?)\/( ?)([#0?]+)/))
        return f = Math.min(Math.max(m[1].length, m[4].length), 7), b + ((v = Ge(E, Math.pow(10, f) - 1, !0))[0] || (v[1] ? "" : "0")) + " " + (v[1] ? J(v[1], f) + m[2] + "/" + m[3] + de(v[2], f) : Wr(" ", 2 * f + 1 + m[2].length + m[3].length));
      if (m = n.match(/^[#0?]+$/))
        return p = "" + a, n.length <= p.length ? p : vr(n.substr(0, n.length - p.length)) + p;
      if (m = n.match(/^([#0]+)\.([#0]+)$/)) {
        p = "" + a.toFixed(Math.min(m[2].length, 10)).replace(/([^0])0+$/, "$1"), f = p.indexOf(".");
        var T = n.indexOf(".") - f, v = n.length - p.length - T;
        return vr(n.substr(0, T) + p + n.substr(n.length - v));
      }
      if (m = n.match(/^00,000\.([#0]*0)$/))
        return a < 0 ? "-" + pe(t, n, -a) : Le("" + a).replace(/^\d,\d{3}$/, "0$&").replace(/^\d*$/, function(R) {
          return "00," + (R.length < 3 ? j(0, 3 - R.length) : "") + R;
        }) + "." + j(0, m[1].length);
      switch (n) {
        case "###,###":
        case "##,###":
        case "#,###":
          var y = Le("" + E);
          return y !== "0" ? b + y : "";
        default:
          if (n.match(/\.[0#?]*$/))
            return pe(t, n.slice(0, n.lastIndexOf(".")), a) + vr(n.slice(n.lastIndexOf(".")));
      }
      throw new Error("unsupported format |" + n + "|");
    }
    function qe(t, n, a) {
      return ((0 | a) === a ? pe : Ae)(t, n, a);
    }
    var bt = /\[[HhMmSs\u0E0A\u0E19\u0E17]*\]/;
    function Gt(t) {
      for (var n = 0, a = "", l = ""; n < t.length; )
        switch (a = t.charAt(n)) {
          case "G":
            ue(t, n) && (n += 6), n++;
            break;
          case '"':
            for (; t.charCodeAt(++n) !== 34 && n < t.length; )
              ;
            ++n;
            break;
          case "\\":
          case "_":
            n += 2;
            break;
          case "@":
            ++n;
            break;
          case "B":
          case "b":
            if (t.charAt(n + 1) === "1" || t.charAt(n + 1) === "2")
              return !0;
          case "M":
          case "D":
          case "Y":
          case "H":
          case "S":
          case "E":
          case "m":
          case "d":
          case "y":
          case "h":
          case "s":
          case "e":
          case "g":
            return !0;
          case "A":
          case "a":
          case "上":
            if (t.substr(n, 3).toUpperCase() === "A/P" || t.substr(n, 5).toUpperCase() === "AM/PM" || t.substr(n, 5).toUpperCase() === "上午/下午")
              return !0;
            ++n;
            break;
          case "[":
            for (l = a; t.charAt(n++) !== "]" && n < t.length; )
              l += t.charAt(n);
            if (l.match(bt))
              return !0;
            break;
          case ".":
          case "0":
          case "#":
            for (; n < t.length && (-1 < "0#?.,E+-%".indexOf(a = t.charAt(++n)) || a == "\\" && t.charAt(n + 1) == "-" && -1 < "0#".indexOf(t.charAt(n + 2))); )
              ;
            break;
          case "?":
            for (; t.charAt(++n) === a; )
              ;
            break;
          case "*":
            ++n, t.charAt(n) != " " && t.charAt(n) != "*" || ++n;
            break;
          case "(":
          case ")":
            ++n;
            break;
          case "1":
          case "2":
          case "3":
          case "4":
          case "5":
          case "6":
          case "7":
          case "8":
          case "9":
            for (; n < t.length && -1 < "0123456789".indexOf(t.charAt(++n)); )
              ;
            break;
          case " ":
          default:
            ++n;
        }
      return !1;
    }
    function Ur(t, n, a, l) {
      for (var d, _, u, p = [], m = "", f = 0, E = "", b = "t", T = "H"; f < t.length; )
        switch (E = t.charAt(f)) {
          case "G":
            if (!ue(t, f))
              throw new Error("unrecognized character " + E + " in " + t);
            p[p.length] = { t: "G", v: "General" }, f += 7;
            break;
          case '"':
            for (m = ""; (u = t.charCodeAt(++f)) !== 34 && f < t.length; )
              m += String.fromCharCode(u);
            p[p.length] = { t: "t", v: m }, ++f;
            break;
          case "\\":
            var v = t.charAt(++f), y = v === "(" || v === ")" ? v : "t";
            p[p.length] = { t: y, v }, ++f;
            break;
          case "_":
            p[p.length] = { t: "t", v: " " }, f += 2;
            break;
          case "@":
            p[p.length] = { t: "T", v: n }, ++f;
            break;
          case "B":
          case "b":
            if (t.charAt(f + 1) === "1" || t.charAt(f + 1) === "2") {
              if (d == null && (d = we(n, a, t.charAt(f + 1) === "2")) == null)
                return "";
              p[p.length] = { t: "X", v: t.substr(f, 2) }, b = E, f += 2;
              break;
            }
          case "M":
          case "D":
          case "Y":
          case "H":
          case "S":
          case "E":
            E = E.toLowerCase();
          case "m":
          case "d":
          case "y":
          case "h":
          case "s":
          case "e":
          case "g":
            if (n < 0 || d == null && (d = we(n, a)) == null)
              return "";
            for (m = E; ++f < t.length && t.charAt(f).toLowerCase() === E; )
              m += E;
            (E = E === "m" && b.toLowerCase() === "h" ? "M" : E) === "h" && (E = T), p[p.length] = { t: E, v: m }, b = E;
            break;
          case "A":
          case "a":
          case "上":
            if (v = { t: E, v: E }, d == null && (d = we(n, a)), t.substr(f, 3).toUpperCase() === "A/P" ? (d != null && (v.v = 12 <= d.H ? "P" : "A"), v.t = "T", T = "h", f += 3) : t.substr(f, 5).toUpperCase() === "AM/PM" ? (d != null && (v.v = 12 <= d.H ? "PM" : "AM"), v.t = "T", f += 5, T = "h") : t.substr(f, 5).toUpperCase() === "上午/下午" ? (d != null && (v.v = 12 <= d.H ? "下午" : "上午"), v.t = "T", f += 5, T = "h") : (v.t = "t", ++f), d == null && v.t === "T")
              return "";
            p[p.length] = v, b = E;
            break;
          case "[":
            for (m = E; t.charAt(f++) !== "]" && f < t.length; )
              m += t.charAt(f);
            if (m.slice(-1) !== "]")
              throw 'unterminated "[" block: |' + m + "|";
            if (m.match(bt)) {
              if (d == null && (d = we(n, a)) == null)
                return "";
              p[p.length] = { t: "Z", v: m.toLowerCase() }, b = m.charAt(1);
            } else
              -1 < m.indexOf("$") && (m = (m.match(/\$([^-\[\]]*)/) || [])[1] || "$", Gt(t) || (p[p.length] = { t: "t", v: m }));
            break;
          case ".":
            if (d != null) {
              for (m = E; ++f < t.length && (E = t.charAt(f)) === "0"; )
                m += E;
              p[p.length] = { t: "s", v: m };
              break;
            }
          case "0":
          case "#":
            for (m = E; ++f < t.length && -1 < "0#?.,E+-%".indexOf(E = t.charAt(f)); )
              m += E;
            p[p.length] = { t: "n", v: m };
            break;
          case "?":
            for (m = E; t.charAt(++f) === E; )
              m += E;
            p[p.length] = { t: E, v: m }, b = E;
            break;
          case "*":
            ++f, t.charAt(f) != " " && t.charAt(f) != "*" || ++f;
            break;
          case "(":
          case ")":
            p[p.length] = { t: l === 1 ? "t" : E, v: E }, ++f;
            break;
          case "1":
          case "2":
          case "3":
          case "4":
          case "5":
          case "6":
          case "7":
          case "8":
          case "9":
            for (m = E; f < t.length && -1 < "0123456789".indexOf(t.charAt(++f)); )
              m += t.charAt(f);
            p[p.length] = { t: "D", v: m };
            break;
          case " ":
            p[p.length] = { t: E, v: E }, ++f;
            break;
          case "$":
            p[p.length] = { t: "t", v: "$" }, ++f;
            break;
          default:
            if (",$-+/():!^&'~{}<>=€acfijklopqrtuvwxzP".indexOf(E) === -1)
              throw new Error("unrecognized character " + E + " in " + t);
            p[p.length] = { t: "t", v: E }, ++f;
        }
      var R, P = 0, I = 0;
      for (f = p.length - 1, b = "t"; 0 <= f; --f)
        switch (p[f].t) {
          case "h":
          case "H":
            p[f].t = T, b = "h", P < 1 && (P = 1);
            break;
          case "s":
            (R = p[f].v.match(/\.0+$/)) && (I = Math.max(I, R[0].length - 1)), P < 3 && (P = 3);
          case "d":
          case "y":
          case "M":
          case "e":
            b = p[f].t;
            break;
          case "m":
            b === "s" && (p[f].t = "M", P < 2 && (P = 2));
            break;
          case "X":
            break;
          case "Z":
            (P = (P = P < 1 && p[f].v.match(/[Hh]/) ? 1 : P) < 2 && p[f].v.match(/[Mm]/) ? 2 : P) < 3 && p[f].v.match(/[Ss]/) && (P = 3);
        }
      switch (P) {
        case 0:
          break;
        case 1:
          0.5 <= d.u && (d.u = 0, ++d.S), 60 <= d.S && (d.S = 0, ++d.M), 60 <= d.M && (d.M = 0, ++d.H);
          break;
        case 2:
          0.5 <= d.u && (d.u = 0, ++d.S), 60 <= d.S && (d.S = 0, ++d.M);
      }
      var A, M = "";
      for (f = 0; f < p.length; ++f)
        switch (p[f].t) {
          case "t":
          case "T":
          case " ":
          case "D":
            break;
          case "X":
            p[f].v = "", p[f].t = ";";
            break;
          case "d":
          case "m":
          case "y":
          case "h":
          case "H":
          case "M":
          case "s":
          case "e":
          case "b":
          case "Z":
            p[f].v = function(Fe, Ue, Ne, ze) {
              var ut, lt = "", et = 0, nt = 0, je = Ne.y, Ye = 0;
              switch (Fe) {
                case 98:
                  je = Ne.y + 543;
                case 121:
                  switch (Ue.length) {
                    case 1:
                    case 2:
                      ut = je % 100, Ye = 2;
                      break;
                    default:
                      ut = je % 1e4, Ye = 4;
                  }
                  break;
                case 109:
                  switch (Ue.length) {
                    case 1:
                    case 2:
                      ut = Ne.m, Ye = Ue.length;
                      break;
                    case 3:
                      return Re[Ne.m - 1][1];
                    case 5:
                      return Re[Ne.m - 1][0];
                    default:
                      return Re[Ne.m - 1][2];
                  }
                  break;
                case 100:
                  switch (Ue.length) {
                    case 1:
                    case 2:
                      ut = Ne.d, Ye = Ue.length;
                      break;
                    case 3:
                      return Oe[Ne.q][0];
                    default:
                      return Oe[Ne.q][1];
                  }
                  break;
                case 104:
                  switch (Ue.length) {
                    case 1:
                    case 2:
                      ut = 1 + (Ne.H + 11) % 12, Ye = Ue.length;
                      break;
                    default:
                      throw "bad hour format: " + Ue;
                  }
                  break;
                case 72:
                  switch (Ue.length) {
                    case 1:
                    case 2:
                      ut = Ne.H, Ye = Ue.length;
                      break;
                    default:
                      throw "bad hour format: " + Ue;
                  }
                  break;
                case 77:
                  switch (Ue.length) {
                    case 1:
                    case 2:
                      ut = Ne.M, Ye = Ue.length;
                      break;
                    default:
                      throw "bad minute format: " + Ue;
                  }
                  break;
                case 115:
                  if (Ue != "s" && Ue != "ss" && Ue != ".0" && Ue != ".00" && Ue != ".000")
                    throw "bad second format: " + Ue;
                  return Ne.u !== 0 || Ue != "s" && Ue != "ss" ? (60 * (nt = 2 <= ze ? ze === 3 ? 1e3 : 100 : ze === 1 ? 10 : 1) <= (et = Math.round(nt * (Ne.S + Ne.u))) && (et = 0), Ue === "s" ? et === 0 ? "0" : "" + et / nt : (lt = j(et, 2 + ze), Ue === "ss" ? lt.substr(0, 2) : "." + lt.substr(2, Ue.length - 1))) : j(Ne.S, Ue.length);
                case 90:
                  switch (Ue) {
                    case "[h]":
                    case "[hh]":
                      ut = 24 * Ne.D + Ne.H;
                      break;
                    case "[m]":
                    case "[mm]":
                      ut = 60 * (24 * Ne.D + Ne.H) + Ne.M;
                      break;
                    case "[s]":
                    case "[ss]":
                      ut = 60 * (60 * (24 * Ne.D + Ne.H) + Ne.M) + Math.round(Ne.S + Ne.u);
                      break;
                    default:
                      throw "bad abstime format: " + Ue;
                  }
                  Ye = Ue.length === 3 ? 1 : 2;
                  break;
                case 101:
                  ut = je, Ye = 1;
              }
              return 0 < Ye ? j(ut, Ye) : "";
            }(p[f].t.charCodeAt(0), p[f].v, d, I), p[f].t = "t";
            break;
          case "n":
          case "?":
            for (A = f + 1; p[A] != null && ((E = p[A].t) === "?" || E === "D" || (E === " " || E === "t") && p[A + 1] != null && (p[A + 1].t === "?" || p[A + 1].t === "t" && p[A + 1].v === "/") || p[f].t === "(" && (E === " " || E === "n" || E === ")") || E === "t" && (p[A].v === "/" || p[A].v === " " && p[A + 1] != null && p[A + 1].t == "?")); )
              p[f].v += p[A].v, p[A] = { v: "", t: ";" }, ++A;
            M += p[f].v, f = A - 1;
            break;
          case "G":
            p[f].t = "t", p[f].v = Be(n, a);
        }
      var F, B, re = "";
      if (0 < M.length) {
        M.charCodeAt(0) == 40 ? (F = n < 0 && M.charCodeAt(0) === 45 ? -n : n, B = qe("n", M, F)) : (B = qe("n", M, F = n < 0 && 1 < l ? -n : n), F < 0 && p[0] && p[0].t == "t" && (B = B.substr(1), p[0].v = "-" + p[0].v)), A = B.length - 1;
        for (var me = p.length, f = 0; f < p.length; ++f)
          if (p[f] != null && p[f].t != "t" && -1 < p[f].v.indexOf(".")) {
            me = f;
            break;
          }
        var le = p.length;
        if (me === p.length && B.indexOf("E") === -1) {
          for (f = p.length - 1; 0 <= f; --f)
            p[f] != null && "n?".indexOf(p[f].t) !== -1 && (A >= p[f].v.length - 1 ? (A -= p[f].v.length, p[f].v = B.substr(A + 1, p[f].v.length)) : A < 0 ? p[f].v = "" : (p[f].v = B.substr(0, A + 1), A = -1), p[f].t = "t", le = f);
          0 <= A && le < p.length && (p[le].v = B.substr(0, A + 1) + p[le].v);
        } else if (me !== p.length && B.indexOf("E") === -1) {
          for (A = B.indexOf(".") - 1, f = me; 0 <= f; --f)
            if (p[f] != null && "n?".indexOf(p[f].t) !== -1) {
              for (_ = -1 < p[f].v.indexOf(".") && f === me ? p[f].v.indexOf(".") - 1 : p[f].v.length - 1, re = p[f].v.substr(_ + 1); 0 <= _; --_)
                0 <= A && (p[f].v.charAt(_) === "0" || p[f].v.charAt(_) === "#") && (re = B.charAt(A--) + re);
              p[f].v = re, p[f].t = "t", le = f;
            }
          for (0 <= A && le < p.length && (p[le].v = B.substr(0, A + 1) + p[le].v), A = B.indexOf(".") + 1, f = me; f < p.length; ++f)
            if (p[f] != null && ("n?(".indexOf(p[f].t) !== -1 || f === me)) {
              for (_ = -1 < p[f].v.indexOf(".") && f === me ? p[f].v.indexOf(".") + 1 : 0, re = p[f].v.substr(0, _); _ < p[f].v.length; ++_)
                A < B.length && (re += B.charAt(A++));
              p[f].v = re, p[f].t = "t", le = f;
            }
        }
      }
      for (f = 0; f < p.length; ++f)
        p[f] != null && -1 < "n?".indexOf(p[f].t) && (F = 1 < l && n < 0 && 0 < f && p[f - 1].v === "-" ? -n : n, p[f].v = qe(p[f].t, p[f].v, F), p[f].t = "t");
      var be = "";
      for (f = 0; f !== p.length; ++f)
        p[f] != null && (be += p[f].v);
      return be;
    }
    var qr = /\[(=|>[=]?|<[>=]?)(-?\d+(?:\.\d*)?)\]/;
    function Fn(t, n) {
      if (n != null) {
        var a = parseFloat(n[2]);
        switch (n[1]) {
          case "=":
            if (t == a)
              return 1;
            break;
          case ">":
            if (a < t)
              return 1;
            break;
          case "<":
            if (t < a)
              return 1;
            break;
          case "<>":
            if (t != a)
              return 1;
            break;
          case ">=":
            if (a <= t)
              return 1;
            break;
          case "<=":
            if (t <= a)
              return 1;
        }
      }
    }
    function Ga(t, n) {
      var a = function(u) {
        for (var p = [], m = !1, f = 0, E = 0; f < u.length; ++f)
          switch (u.charCodeAt(f)) {
            case 34:
              m = !m;
              break;
            case 95:
            case 42:
            case 92:
              ++f;
              break;
            case 59:
              p[p.length] = u.substr(E, f - E), E = f + 1;
          }
        if (p[p.length] = u.substr(E), m === !0)
          throw new Error("Format |" + u + "| unterminated string ");
        return p;
      }(t), l = a.length, d = a[l - 1].indexOf("@");
      if (l < 4 && -1 < d && --l, 4 < a.length)
        throw new Error("cannot find right format for |" + a.join("|") + "|");
      if (typeof n != "number")
        return [4, a.length === 4 || -1 < d ? a[a.length - 1] : "@"];
      switch (a.length) {
        case 1:
          a = -1 < d ? ["General", "General", "General", a[0]] : [a[0], a[0], a[0], "@"];
          break;
        case 2:
          a = -1 < d ? [a[0], a[0], a[0], a[1]] : [a[0], a[1], a[0], "@"];
          break;
        case 3:
          a = -1 < d ? [a[0], a[1], a[0], a[2]] : [a[0], a[1], a[2], "@"];
      }
      var _ = 0 < n ? a[0] : n < 0 ? a[1] : a[2];
      return a[0].indexOf("[") === -1 && a[1].indexOf("[") === -1 ? [l, _] : a[0].match(/\[[=<>]/) == null && a[1].match(/\[[=<>]/) == null ? [l, _] : (t = a[0].match(qr), _ = a[1].match(qr), Fn(n, t) ? [l, a[0]] : Fn(n, _) ? [l, a[1]] : [l, a[t != null && _ != null ? 2 : 1]]);
    }
    function dn(t, n, a) {
      a == null && (a = {});
      var l = "";
      switch (typeof t) {
        case "string":
          l = t == "m/d/yy" && a.dateNF ? a.dateNF : t;
          break;
        case "number":
          (l = (l = t == 14 && a.dateNF ? a.dateNF : (a.table != null ? a.table : ae)[t]) == null ? a.table && a.table[Ee[t]] || ae[Ee[t]] : l) == null && (l = ne[t] || "General");
      }
      if (ue(l, 0))
        return Be(n, a);
      var d = Ga(l, n = n instanceof Date ? z(n, a.date1904) : n);
      if (ue(d[1]))
        return Be(n, a);
      if (n === !0)
        n = "TRUE";
      else if (n === !1)
        n = "FALSE";
      else if (n === "" || n == null)
        return "";
      return Ur(d[1], n, a, d[0]);
    }
    function Qn(t, n) {
      if (typeof n != "number") {
        n = +n || -1;
        for (var a = 0; a < 392; ++a)
          if (ae[a] != null) {
            if (ae[a] == t) {
              n = a;
              break;
            }
          } else
            n < 0 && (n = a);
        n < 0 && (n = 391);
      }
      return ae[n] = t, n;
    }
    function hr(t) {
      for (var n = 0; n != 392; ++n)
        t[n] !== void 0 && Qn(t[n], n);
    }
    function ra() {
      var t;
      (t = t || {})[0] = "General", t[1] = "0", t[2] = "0.00", t[3] = "#,##0", t[4] = "#,##0.00", t[9] = "0%", t[10] = "0.00%", t[11] = "0.00E+00", t[12] = "# ?/?", t[13] = "# ??/??", t[14] = "m/d/yy", t[15] = "d-mmm-yy", t[16] = "d-mmm", t[17] = "mmm-yy", t[18] = "h:mm AM/PM", t[19] = "h:mm:ss AM/PM", t[20] = "h:mm", t[21] = "h:mm:ss", t[22] = "m/d/yy h:mm", t[37] = "#,##0 ;(#,##0)", t[38] = "#,##0 ;[Red](#,##0)", t[39] = "#,##0.00;(#,##0.00)", t[40] = "#,##0.00;[Red](#,##0.00)", t[45] = "mm:ss", t[46] = "[h]:mm:ss", t[47] = "mmss.0", t[48] = "##0.0E+0", t[49] = "@", t[56] = '"上午/下午 "hh"時"mm"分"ss"秒 "', ae = t;
    }
    var ya = { format: dn, load: Qn, _table: ae, load_table: hr, parse_date_code: we, is_date: Gt, get_table: function() {
      return ya._table = ae;
    } }, is = { 5: '"$"#,##0_);\\("$"#,##0\\)', 6: '"$"#,##0_);[Red]\\("$"#,##0\\)', 7: '"$"#,##0.00_);\\("$"#,##0.00\\)', 8: '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)', 23: "General", 24: "General", 25: "General", 26: "General", 27: "m/d/yy", 28: "m/d/yy", 29: "m/d/yy", 30: "m/d/yy", 31: "m/d/yy", 32: "h:mm:ss", 33: "h:mm:ss", 34: "h:mm:ss", 35: "h:mm:ss", 36: "m/d/yy", 41: '_(* #,##0_);_(* (#,##0);_(* "-"_);_(@_)', 42: '_("$"* #,##0_);_("$"* (#,##0);_("$"* "-"_);_(@_)', 43: '_(* #,##0.00_);_(* (#,##0.00);_(* "-"??_);_(@_)', 44: '_("$"* #,##0.00_);_("$"* (#,##0.00);_("$"* "-"??_);_(@_)', 50: "m/d/yy", 51: "m/d/yy", 52: "m/d/yy", 53: "m/d/yy", 54: "m/d/yy", 55: "m/d/yy", 56: "m/d/yy", 57: "m/d/yy", 58: "m/d/yy", 59: "0", 60: "0.00", 61: "#,##0", 62: "#,##0.00", 63: '"$"#,##0_);\\("$"#,##0\\)', 64: '"$"#,##0_);[Red]\\("$"#,##0\\)', 65: '"$"#,##0.00_);\\("$"#,##0.00\\)', 66: '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)', 67: "0%", 68: "0.00%", 69: "# ?/?", 70: "# ??/??", 71: "m/d/yy", 72: "m/d/yy", 73: "d-mmm-yy", 74: "d-mmm", 75: "mmm-yy", 76: "h:mm", 77: "h:mm:ss", 78: "m/d/yy h:mm", 79: "mm:ss", 80: "[h]:mm:ss", 81: "mmss.0" }, Nl = /[dD]+|[mM]+|[yYeE]+|[Hh]+|[Ss]+/g, Ia, Bm = function() {
      var t = {};
      t.version = "1.2.0";
      var n = function() {
        for (var A = 0, M = new Array(256), F = 0; F != 256; ++F)
          A = 1 & (A = 1 & (A = 1 & (A = 1 & (A = 1 & (A = 1 & (A = 1 & (A = 1 & (A = F) ? -306674912 ^ A >>> 1 : A >>> 1) ? -306674912 ^ A >>> 1 : A >>> 1) ? -306674912 ^ A >>> 1 : A >>> 1) ? -306674912 ^ A >>> 1 : A >>> 1) ? -306674912 ^ A >>> 1 : A >>> 1) ? -306674912 ^ A >>> 1 : A >>> 1) ? -306674912 ^ A >>> 1 : A >>> 1) ? -306674912 ^ A >>> 1 : A >>> 1, M[F] = A;
        return typeof Int32Array < "u" ? new Int32Array(M) : M;
      }(), a = function(A) {
        for (var M = 0, F = 0, re = 0, B = new (typeof Int32Array < "u" ? Int32Array : Array)(4096), re = 0; re != 256; ++re)
          B[re] = A[re];
        for (re = 0; re != 256; ++re)
          for (F = A[re], M = 256 + re; M < 4096; M += 256)
            F = B[M] = F >>> 8 ^ A[255 & F];
        var me = [];
        for (re = 1; re != 16; ++re)
          me[re - 1] = typeof Int32Array < "u" ? B.subarray(256 * re, 256 * re + 256) : B.slice(256 * re, 256 * re + 256);
        return me;
      }(n), l = a[0], d = a[1], _ = a[2], u = a[3], p = a[4], m = a[5], f = a[6], E = a[7], b = a[8], T = a[9], v = a[10], y = a[11], R = a[12], P = a[13], I = a[14];
      return t.table = n, t.bstr = function(A, M) {
        for (var F = -1 ^ M, B = 0, re = A.length; B < re; )
          F = F >>> 8 ^ n[255 & (F ^ A.charCodeAt(B++))];
        return ~F;
      }, t.buf = function(A, M) {
        for (var F = -1 ^ M, B = A.length - 15, re = 0; re < B; )
          F = I[A[re++] ^ 255 & F] ^ P[A[re++] ^ F >> 8 & 255] ^ R[A[re++] ^ F >> 16 & 255] ^ y[A[re++] ^ F >>> 24] ^ v[A[re++]] ^ T[A[re++]] ^ b[A[re++]] ^ E[A[re++]] ^ f[A[re++]] ^ m[A[re++]] ^ p[A[re++]] ^ u[A[re++]] ^ _[A[re++]] ^ d[A[re++]] ^ l[A[re++]] ^ n[A[re++]];
        for (B += 15; re < B; )
          F = F >>> 8 ^ n[255 & (F ^ A[re++])];
        return ~F;
      }, t.str = function(A, M) {
        for (var F, B = -1 ^ M, re = 0, me = A.length, le = 0; re < me; )
          B = (le = A.charCodeAt(re++)) < 128 ? B >>> 8 ^ n[255 & (B ^ le)] : le < 2048 ? (B = B >>> 8 ^ n[255 & (B ^ (192 | le >> 6 & 31))]) >>> 8 ^ n[255 & (B ^ (128 | 63 & le))] : 55296 <= le && le < 57344 ? (le = 64 + (1023 & le), F = 1023 & A.charCodeAt(re++), (B = (B = (B = B >>> 8 ^ n[255 & (B ^ (240 | le >> 8 & 7))]) >>> 8 ^ n[255 & (B ^ (128 | le >> 2 & 63))]) >>> 8 ^ n[255 & (B ^ (128 | F >> 6 & 15 | (3 & le) << 4))]) >>> 8 ^ n[255 & (B ^ (128 | 63 & F))]) : (B = (B = B >>> 8 ^ n[255 & (B ^ (224 | le >> 12 & 15))]) >>> 8 ^ n[255 & (B ^ (128 | le >> 6 & 63))]) >>> 8 ^ n[255 & (B ^ (128 | 63 & le))];
        return ~B;
      }, t;
    }(), Lt = function() {
      var t, n = {};
      function a(q) {
        if (q.charAt(q.length - 1) == "/")
          return q.slice(0, -1).indexOf("/") === -1 ? q : a(q.slice(0, -1));
        var Ie = q.lastIndexOf("/");
        return Ie === -1 ? q : q.slice(0, Ie + 1);
      }
      function l(q) {
        if (q.charAt(q.length - 1) == "/")
          return l(q.slice(0, -1));
        var Ie = q.lastIndexOf("/");
        return Ie === -1 ? q : q.slice(Ie + 1);
      }
      function d(q) {
        Nn(q, 0);
        for (var Ie, te = {}; q.l <= q.length - 4; ) {
          var ve = q.read_shift(2), ee = q.read_shift(2), $e = q.l + ee, Ce = {};
          ve === 21589 && (1 & (Ie = q.read_shift(1)) && (Ce.mtime = q.read_shift(4)), 5 < ee && (2 & Ie && (Ce.atime = q.read_shift(4)), 4 & Ie && (Ce.ctime = q.read_shift(4))), Ce.mtime && (Ce.mt = new Date(1e3 * Ce.mtime))), q.l = $e, te[ve] = Ce;
        }
        return te;
      }
      function _() {
        return t = t || Zc;
      }
      function u(q, Ie) {
        if (q[0] == 80 && q[1] == 75)
          return Rr(q, Ie);
        if ((32 | q[0]) == 109 && (32 | q[1]) == 105)
          return function(Xe, Dt) {
            if (A(Xe.slice(0, 13)).toLowerCase() != "mime-version:")
              throw new Error("Unsupported MAD header");
            var gt = Dt && Dt.root || "", tt = (K && Buffer.isBuffer(Xe) ? Xe.toString("binary") : A(Xe)).split(`\r
`), Mt = 0, Pt = "";
            for (Mt = 0; Mt < tt.length; ++Mt)
              if (Pt = tt[Mt], /^Content-Location:/i.test(Pt) && (Pt = Pt.slice(Pt.indexOf("file")), gt = gt || Pt.slice(0, Pt.lastIndexOf("/") + 1), Pt.slice(0, gt.length) != gt))
                for (; 0 < gt.length && (gt = (gt = gt.slice(0, gt.length - 1)).slice(0, gt.lastIndexOf("/") + 1), Pt.slice(0, gt.length) != gt); )
                  ;
            if (Xe = (tt[1] || "").match(/boundary="(.*?)"/), !Xe)
              throw new Error("MAD cannot find boundary");
            var kr = "--" + (Xe[1] || ""), Bt = { FileIndex: [], FullPaths: [] };
            m(Bt);
            var Kt, Ot = 0;
            for (Mt = 0; Mt < tt.length; ++Mt) {
              var or = tt[Mt];
              or !== kr && or !== kr + "--" || (Ot++ && function(sr, _t, Ct) {
                for (var St, er = "", br = "", pn = "", bn = 0; bn < 10; ++bn) {
                  var cn = _t[bn];
                  if (!cn || cn.match(/^\s*$/))
                    break;
                  var Mn = cn.match(/^(.*?):\s*([^\s].*)$/);
                  if (Mn)
                    switch (Mn[1].toLowerCase()) {
                      case "content-location":
                        er = Mn[2].trim();
                        break;
                      case "content-type":
                        pn = Mn[2].trim();
                        break;
                      case "content-transfer-encoding":
                        br = Mn[2].trim();
                    }
                }
                switch (++bn, br.toLowerCase()) {
                  case "base64":
                    St = Pe(H(_t.slice(bn).join("")));
                    break;
                  case "quoted-printable":
                    St = function(Pn) {
                      for (var hi = [], Vn = 0; Vn < Pn.length; ++Vn) {
                        for (var ka = Pn[Vn]; Vn <= Pn.length && ka.charAt(ka.length - 1) == "="; )
                          ka = ka.slice(0, ka.length - 1) + Pn[++Vn];
                        hi.push(ka);
                      }
                      for (var Si = 0; Si < hi.length; ++Si)
                        hi[Si] = hi[Si].replace(/[=][0-9A-Fa-f]{2}/g, function(jN) {
                          return String.fromCharCode(parseInt(jN.slice(1), 16));
                        });
                      return Pe(hi.join(`\r
`));
                    }(_t.slice(bn));
                    break;
                  default:
                    throw new Error("Unsupported Content-Transfer-Encoding " + br);
                }
                Ct = da(sr, er.slice(Ct.length), St, { unsafe: !0 }), pn && (Ct.ctype = pn);
              }(Bt, tt.slice(Kt, Mt), gt), Kt = Mt);
            }
            return Bt;
          }(q, Ie);
        if (q.length < 512)
          throw new Error("CFB file size " + q.length + " < 512");
        var te, ve, ee, $e = 3, Ce = 512, at = 0, xe = [], Se = q.slice(0, 512);
        Nn(Se, 0);
        var ke = function(Xe) {
          if (Xe[Xe.l] == 80 && Xe[Xe.l + 1] == 75)
            return [0, 0];
          Xe.chk(y, "Header Signature: "), Xe.l += 16;
          var Dt = Xe.read_shift(2, "u");
          return [Xe.read_shift(2, "u"), Dt];
        }(Se);
        switch ($e = ke[0]) {
          case 3:
            Ce = 512;
            break;
          case 4:
            Ce = 4096;
            break;
          case 0:
            if (ke[1] == 0)
              return Rr(q, Ie);
          default:
            throw new Error("Major Version: Expected 3 or 4 saw " + $e);
        }
        Ce !== 512 && Nn(Se = q.slice(0, Ce), 28);
        var Qe = q.slice(0, Ce);
        (function(Xe, Dt) {
          var gt = 9;
          switch (Xe.l += 2, gt = Xe.read_shift(2)) {
            case 9:
              if (Dt != 3)
                throw new Error("Sector Shift: Expected 9 saw " + gt);
              break;
            case 12:
              if (Dt != 4)
                throw new Error("Sector Shift: Expected 12 saw " + gt);
              break;
            default:
              throw new Error("Sector Shift: Expected 9 or 12 saw " + gt);
          }
          Xe.chk("0600", "Mini Sector Shift: "), Xe.chk("000000000000", "Reserved: ");
        })(Se, $e);
        var yt = Se.read_shift(4, "i");
        if ($e === 3 && yt !== 0)
          throw new Error("# Directory Sectors: Expected 0 saw " + yt);
        Se.l += 4, ve = Se.read_shift(4, "i"), Se.l += 4, Se.chk("00100000", "Mini Stream Cutoff Size: "), ee = Se.read_shift(4, "i"), te = Se.read_shift(4, "i"), It = Se.read_shift(4, "i"), at = Se.read_shift(4, "i");
        for (var At, Et = 0; Et < 109 && !((At = Se.read_shift(4, "i")) < 0); ++Et)
          xe[Et] = At;
        var ct = function(Xe, Dt) {
          for (var gt = Math.ceil(Xe.length / Dt) - 1, tt = [], Mt = 1; Mt < gt; ++Mt)
            tt[Mt - 1] = Xe.slice(Mt * Dt, (Mt + 1) * Dt);
          return tt[gt - 1] = Xe.slice(gt * Dt), tt;
        }(q, Ce);
        (function Xe(Dt, gt, tt, Mt, Pt) {
          var kr = v;
          if (Dt === v) {
            if (gt !== 0)
              throw new Error("DIFAT chain shorter than expected");
          } else if (Dt !== -1) {
            var Bt = tt[Dt], Kt = (Mt >>> 2) - 1;
            if (Bt) {
              for (var Ot = 0; Ot < Kt && (kr = ii(Bt, 4 * Ot)) !== v; ++Ot)
                Pt.push(kr);
              Xe(ii(Bt, Mt - 4), gt - 1, tt, Mt, Pt);
            }
          }
        })(It, at, ct, Ce, xe);
        var vt = function(Xe, Dt, gt, tt) {
          var Mt = Xe.length, Pt = [], kr = [], Bt = [], Kt = [], Ot = tt - 1, or = 0, sr = 0, _t = 0, Ct = 0;
          for (or = 0; or < Mt; ++or)
            if (Bt = [], Mt <= (_t = or + Dt) && (_t -= Mt), !kr[_t]) {
              Kt = [];
              var St = [];
              for (sr = _t; 0 <= sr; ) {
                St[sr] = !0, kr[sr] = !0, Bt[Bt.length] = sr, Kt.push(Xe[sr]);
                var er = gt[Math.floor(4 * sr / tt)];
                if (tt < 4 + (Ct = 4 * sr & Ot))
                  throw new Error("FAT boundary crossed: " + sr + " 4 " + tt);
                if (!Xe[er] || (sr = ii(Xe[er], Ct), St[sr]))
                  break;
              }
              Pt[_t] = { nodes: Bt, data: df([Kt]) };
            }
          return Pt;
        }(ct, ve, xe, Ce);
        vt[ve].name = "!Directory", 0 < te && ee !== v && (vt[ee].name = "!MiniFAT"), vt[xe[0]].name = "!FAT", vt.fat_addrs = xe, vt.ssz = Ce;
        var yt = [], It = [], at = [];
        return function(Xe, Dt, gt, tt, Mt, Pt, kr) {
          for (var Bt, Kt = 0, Ot = gt.length ? 2 : 0, or = Xe[ve].data, sr = 0, _t = 0; sr < or.length; sr += 128) {
            var Ct = or.slice(sr, sr + 128);
            Nn(Ct, 64), _t = Ct.read_shift(2), Bt = fs(Ct, 0, _t - Ot), gt.push(Bt);
            var St = { name: Bt, type: Ct.read_shift(1), color: Ct.read_shift(1), L: Ct.read_shift(4, "i"), R: Ct.read_shift(4, "i"), C: Ct.read_shift(4, "i"), clsid: Ct.read_shift(16), state: Ct.read_shift(4, "i"), start: 0, size: 0 };
            Ct.read_shift(2) + Ct.read_shift(2) + Ct.read_shift(2) + Ct.read_shift(2) !== 0 && (St.ct = p(Ct, Ct.l - 8)), Ct.read_shift(2) + Ct.read_shift(2) + Ct.read_shift(2) + Ct.read_shift(2) !== 0 && (St.mt = p(Ct, Ct.l - 8)), St.start = Ct.read_shift(4, "i"), St.size = Ct.read_shift(4, "i"), St.size < 0 && St.start < 0 && (St.size = St.type = 0, St.start = v, St.name = ""), St.type === 5 ? (Kt = St.start, 0 < tt && Kt !== v && (Xe[Kt].name = "!StreamData")) : 4096 <= St.size ? (St.storage = "fat", Xe[St.start] === void 0 && (Xe[St.start] = function(er, br, pn, bn, cn) {
              var Mn = [], Pn = [];
              cn = cn || [];
              var hi = bn - 1, Vn = 0, ka = 0;
              for (Vn = br; 0 <= Vn; ) {
                cn[Vn] = !0, Mn[Mn.length] = Vn, Pn.push(er[Vn]);
                var Si = pn[Math.floor(4 * Vn / bn)];
                if (bn < 4 + (ka = 4 * Vn & hi))
                  throw new Error("FAT boundary crossed: " + Vn + " 4 " + bn);
                if (!er[Si])
                  break;
                Vn = ii(er[Si], ka);
              }
              return { nodes: Mn, data: df([Pn]) };
            }(Dt, St.start, Xe.fat_addrs, Xe.ssz)), Xe[St.start].name = St.name, St.content = Xe[St.start].data.slice(0, St.size)) : (St.storage = "minifat", St.size < 0 ? St.size = 0 : Kt !== v && St.start !== v && Xe[Kt] && (St.content = function(er, br, pn) {
              for (var bn = er.start, cn = er.size, Mn = [], Pn = bn; pn && 0 < cn && 0 <= Pn; )
                Mn.push(br.slice(Pn * T, Pn * T + T)), cn -= T, Pn = ii(pn, 4 * Pn);
              return Mn.length === 0 ? Me(0) : mt(Mn).slice(0, er.size);
            }(St, Xe[Kt].data, (Xe[kr] || {}).data))), St.content && Nn(St.content, 0), Mt[Bt] = St, Pt.push(St);
          }
        }(vt, ct, yt, te, {}, It, ee), function(Xe, Dt, gt) {
          for (var tt = 0, Mt = 0, Pt = 0, kr = 0, Bt = 0, Kt = gt.length, Ot = [], or = []; tt < Kt; ++tt)
            Ot[tt] = or[tt] = tt, Dt[tt] = gt[tt];
          for (; Bt < or.length; ++Bt)
            tt = or[Bt], Mt = Xe[tt].L, Pt = Xe[tt].R, kr = Xe[tt].C, Ot[tt] === tt && (Mt !== -1 && Ot[Mt] !== Mt && (Ot[tt] = Ot[Mt]), Pt !== -1 && Ot[Pt] !== Pt && (Ot[tt] = Ot[Pt])), kr !== -1 && (Ot[kr] = tt), Mt !== -1 && tt != Ot[tt] && (Ot[Mt] = Ot[tt], or.lastIndexOf(Mt) < Bt && or.push(Mt)), Pt !== -1 && tt != Ot[tt] && (Ot[Pt] = Ot[tt], or.lastIndexOf(Pt) < Bt && or.push(Pt));
          for (tt = 1; tt < Kt; ++tt)
            Ot[tt] === tt && (Pt !== -1 && Ot[Pt] !== Pt ? Ot[tt] = Ot[Pt] : Mt !== -1 && Ot[Mt] !== Mt && (Ot[tt] = Ot[Mt]));
          for (tt = 1; tt < Kt; ++tt)
            if (Xe[tt].type !== 0) {
              if ((Bt = tt) != Ot[Bt])
                for (; Bt = Ot[Bt], Dt[tt] = Dt[Bt] + "/" + Dt[tt], Bt !== 0 && Ot[Bt] !== -1 && Bt != Ot[Bt]; )
                  ;
              Ot[tt] = -1;
            }
          for (Dt[0] += "/", tt = 1; tt < Kt; ++tt)
            Xe[tt].type !== 2 && (Dt[tt] += "/");
        }(It, at, yt), yt.shift(), at = { FileIndex: It, FullPaths: at }, Ie && Ie.raw && (at.raw = { header: Qe, sectors: ct }), at;
      }
      function p(q, Ie) {
        return new Date(1e3 * (hn(q, Ie + 4) / 1e7 * Math.pow(2, 32) + hn(q, Ie) / 1e7 - 11644473600));
      }
      function m(q, ve) {
        var te = ve || {}, ve = te.root || "Root Entry";
        if (q.FullPaths || (q.FullPaths = []), q.FileIndex || (q.FileIndex = []), q.FullPaths.length !== q.FileIndex.length)
          throw new Error("inconsistent CFB structure");
        q.FullPaths.length === 0 && (q.FullPaths[0] = ve + "/", q.FileIndex[0] = { name: ve, type: 5 }), te.CLSID && (q.FileIndex[0].clsid = te.CLSID), ve = q, te = "Sh33tJ5", Lt.find(ve, "/" + te) || ((q = Me(4))[0] = 55, q[1] = q[3] = 50, q[2] = 54, ve.FileIndex.push({ name: te, type: 2, content: q, size: 4, L: 69, R: 69, C: 69 }), ve.FullPaths.push(ve.FullPaths[0] + te), f(ve));
      }
      function f(q, Ie) {
        m(q);
        for (var te = !1, ve = !1, ee = q.FullPaths.length - 1; 0 <= ee; --ee) {
          var $e = q.FileIndex[ee];
          switch ($e.type) {
            case 0:
              ve ? te = !0 : (q.FileIndex.pop(), q.FullPaths.pop());
              break;
            case 1:
            case 2:
            case 5:
              ve = !0, isNaN($e.R * $e.L * $e.C) && (te = !0), -1 < $e.R && -1 < $e.L && $e.R == $e.L && (te = !0);
              break;
            default:
              te = !0;
          }
        }
        if (te || Ie) {
          for (var Ce = new Date(1987, 1, 19), xe = 0, Se = Object.create ? /* @__PURE__ */ Object.create(null) : {}, ke = [], ee = 0; ee < q.FullPaths.length; ++ee)
            Se[q.FullPaths[ee]] = !0, q.FileIndex[ee].type !== 0 && ke.push([q.FullPaths[ee], q.FileIndex[ee]]);
          for (ee = 0; ee < ke.length; ++ee) {
            var Qe = a(ke[ee][0]);
            (ve = Se[Qe]) || (ke.push([Qe, { name: l(Qe).replace("/", ""), type: 1, clsid: P, ct: Ce, mt: Ce, content: null }]), Se[Qe] = !0);
          }
          for (ke.sort(function(ct, vt) {
            return function(yt, It) {
              for (var at, Xe = yt.split("/"), Dt = It.split("/"), gt = 0, tt = Math.min(Xe.length, Dt.length); gt < tt; ++gt) {
                if (at = Xe[gt].length - Dt[gt].length)
                  return at;
                if (Xe[gt] != Dt[gt])
                  return Xe[gt] < Dt[gt] ? -1 : 1;
              }
              return Xe.length - Dt.length;
            }(ct[0], vt[0]);
          }), q.FullPaths = [], q.FileIndex = [], ee = 0; ee < ke.length; ++ee)
            q.FullPaths[ee] = ke[ee][0], q.FileIndex[ee] = ke[ee][1];
          for (ee = 0; ee < ke.length; ++ee) {
            var At = q.FileIndex[ee], Et = q.FullPaths[ee];
            if (At.name = l(Et).replace("/", ""), At.L = At.R = At.C = -(At.color = 1), At.size = At.content ? At.content.length : 0, At.start = 0, At.clsid = At.clsid || P, ee === 0)
              At.C = 1 < ke.length ? 1 : -1, At.size = 0, At.type = 5;
            else if (Et.slice(-1) == "/") {
              for (xe = ee + 1; xe < ke.length && a(q.FullPaths[xe]) != Et; ++xe)
                ;
              for (At.C = xe >= ke.length ? -1 : xe, xe = ee + 1; xe < ke.length && a(q.FullPaths[xe]) != a(Et); ++xe)
                ;
              At.R = xe >= ke.length ? -1 : xe, At.type = 1;
            } else
              a(q.FullPaths[ee + 1] || "") == a(Et) && (At.R = ee + 1), At.type = 2;
          }
        }
      }
      function E(q, Ie) {
        var te = Ie || {};
        if (te.fileType == "mad")
          return function(Et, ct) {
            for (var vt = ct || {}, yt = vt.boundary || "SheetJS", It = ["MIME-Version: 1.0", 'Content-Type: multipart/related; boundary="' + (yt = "------=" + yt).slice(2) + '"', "", "", ""], at = Et.FullPaths[0], Xe = at, Dt = Et.FileIndex[0], gt = 1; gt < Et.FullPaths.length; ++gt)
              if (Xe = Et.FullPaths[gt].slice(at.length), (Dt = Et.FileIndex[gt]).size && Dt.content && Xe != "Sh33tJ5") {
                Xe = Xe.replace(/[\x00-\x08\x0B\x0C\x0E-\x1F\x7E-\xFF]/g, function(Ot) {
                  return "_x" + Ot.charCodeAt(0).toString(16) + "_";
                }).replace(/[\u0080-\uFFFF]/g, function(Ot) {
                  return "_u" + Ot.charCodeAt(0).toString(16) + "_";
                });
                for (var tt = Dt.content, Mt = K && Buffer.isBuffer(tt) ? tt.toString("binary") : A(tt), Pt = 0, kr = Math.min(1024, Mt.length), Bt = 0, Kt = 0; Kt <= kr; ++Kt)
                  32 <= (Bt = Mt.charCodeAt(Kt)) && Bt < 128 && ++Pt;
                tt = 4 * kr / 5 <= Pt, It.push(yt), It.push("Content-Location: " + (vt.root || "file:///C:/SheetJS/") + Xe), It.push("Content-Transfer-Encoding: " + (tt ? "quoted-printable" : "base64")), It.push("Content-Type: " + function(_t, or) {
                  if (_t.ctype)
                    return _t.ctype;
                  var sr = _t.name || "", _t = sr.match(/\.([^\.]+)$/);
                  return _t && _n[_t[1]] || or && (_t = (sr = or).match(/[\.\\]([^\.\\])+$/)) && _n[_t[1]] ? _n[_t[1]] : "application/octet-stream";
                }(Dt, Xe)), It.push(""), It.push((tt ? function(Ot) {
                  Ot = Ot.replace(/[\x00-\x08\x0B\x0C\x0E-\x1F\x7E-\xFF=]/g, function(pn) {
                    return pn = pn.charCodeAt(0).toString(16).toUpperCase(), "=" + (pn.length == 1 ? "0" + pn : pn);
                  }), (Ot = Ot.replace(/ $/gm, "=20").replace(/\t$/gm, "=09")).charAt(0) == `
` && (Ot = "=0D" + Ot.slice(1)), Ot = Ot.replace(/\r(?!\n)/gm, "=0D").replace(/\n\n/gm, `
=0A`).replace(/([^\r\n])\n/gm, "$1=0A");
                  for (var or = [], sr = Ot.split(`\r
`), _t = 0; _t < sr.length; ++_t) {
                    var Ct = sr[_t];
                    if (Ct.length != 0)
                      for (var St = 0; St < Ct.length; ) {
                        var er = 76, br = Ct.slice(St, St + er);
                        br.charAt(er - 1) == "=" ? er-- : br.charAt(er - 2) == "=" ? er -= 2 : br.charAt(er - 3) == "=" && (er -= 3), br = Ct.slice(St, St + er), (St += er) < Ct.length && (br += "="), or.push(br);
                      }
                    else
                      or.push("");
                  }
                  return or.join(`\r
`);
                } : function(Ot) {
                  for (var or = Z(Ot), sr = [], _t = 0; _t < or.length; _t += 76)
                    sr.push(or.slice(_t, _t + 76));
                  return sr.join(`\r
`) + `\r
`;
                })(Mt));
              }
            return It.push(yt + `--\r
`), It.join(`\r
`);
          }(q, te);
        if (f(q), te.fileType === "zip")
          return function(Et, vt) {
            var vt = vt || {}, yt = [], It = [], at = Me(1), Xe = vt.compression ? 8 : 0, Dt = 0, gt = 0, tt = 0, Mt = 0, Pt = 0, kr = Et.FullPaths[0], Bt = kr, Kt = Et.FileIndex[0], Ot = [], or = 0;
            for (gt = 1; gt < Et.FullPaths.length; ++gt)
              if (Bt = Et.FullPaths[gt].slice(kr.length), (Kt = Et.FileIndex[gt]).size && Kt.content && Bt != "Sh33tJ5") {
                var sr = Mt, _t = Me(Bt.length);
                for (tt = 0; tt < Bt.length; ++tt)
                  _t.write_shift(1, 127 & Bt.charCodeAt(tt));
                _t = _t.slice(0, _t.l), Ot[Pt] = Bm.buf(Kt.content, 0);
                var Ct = Kt.content;
                Xe == 8 && (Ct = function(St) {
                  return b ? b.deflateRawSync(St) : ft(St);
                }(Ct)), (at = Me(30)).write_shift(4, 67324752), at.write_shift(2, 20), at.write_shift(2, Dt), at.write_shift(2, Xe), Kt.mt ? function(St, er) {
                  var br = (er = typeof er == "string" ? new Date(er) : er).getHours();
                  br = (br = br << 6 | er.getMinutes()) << 5 | er.getSeconds() >>> 1, St.write_shift(2, br), br = (br = (br = er.getFullYear() - 1980) << 4 | er.getMonth() + 1) << 5 | er.getDate(), St.write_shift(2, br);
                }(at, Kt.mt) : at.write_shift(4, 0), at.write_shift(-4, Ot[Pt]), at.write_shift(4, Ct.length), at.write_shift(4, Kt.content.length), at.write_shift(2, _t.length), at.write_shift(2, 0), Mt += at.length, yt.push(at), Mt += _t.length, yt.push(_t), Mt += Ct.length, yt.push(Ct), (at = Me(46)).write_shift(4, 33639248), at.write_shift(2, 0), at.write_shift(2, 20), at.write_shift(2, Dt), at.write_shift(2, Xe), at.write_shift(4, 0), at.write_shift(-4, Ot[Pt]), at.write_shift(4, Ct.length), at.write_shift(4, Kt.content.length), at.write_shift(2, _t.length), at.write_shift(2, 0), at.write_shift(2, 0), at.write_shift(2, 0), at.write_shift(2, 0), at.write_shift(4, 0), at.write_shift(4, sr), or += at.l, It.push(at), or += _t.length, It.push(_t), ++Pt;
              }
            return (at = Me(22)).write_shift(4, 101010256), at.write_shift(2, 0), at.write_shift(2, 0), at.write_shift(2, Pt), at.write_shift(2, Pt), at.write_shift(4, or), at.write_shift(4, Mt), at.write_shift(2, 0), mt([mt(yt), mt(It), at]);
          }(q, te);
        for (var ve = function(Et) {
          for (var ct = 0, vt = 0, yt = 0; yt < Et.FileIndex.length; ++yt) {
            var It = Et.FileIndex[yt];
            It.content && 0 < (It = It.content.length) && (It < 4096 ? ct += It + 63 >> 6 : vt += It + 511 >> 9);
          }
          for (var at = Et.FullPaths.length + 3 >> 2, Xe = ct + 127 >> 7, Dt = (ct + 7 >> 3) + vt + at + Xe, gt = Dt + 127 >> 7, tt = gt <= 109 ? 0 : Math.ceil((gt - 109) / 127); gt < Dt + gt + tt + 127 >> 7; )
            tt = ++gt <= 109 ? 0 : Math.ceil((gt - 109) / 127);
          return at = [1, tt, gt, Xe, at, vt, ct, 0], Et.FileIndex[0].size = ct << 6, at[7] = (Et.FileIndex[0].start = at[0] + at[1] + at[2] + at[3] + at[4] + at[5]) + (at[6] + 7 >> 3), at;
        }(q), ee = Me(ve[7] << 9), Ce = 0, $e = 0, Ce = 0; Ce < 8; ++Ce)
          ee.write_shift(1, R[Ce]);
        for (Ce = 0; Ce < 8; ++Ce)
          ee.write_shift(2, 0);
        for (ee.write_shift(2, 62), ee.write_shift(2, 3), ee.write_shift(2, 65534), ee.write_shift(2, 9), ee.write_shift(2, 6), Ce = 0; Ce < 3; ++Ce)
          ee.write_shift(2, 0);
        for (ee.write_shift(4, 0), ee.write_shift(4, ve[2]), ee.write_shift(4, ve[0] + ve[1] + ve[2] + ve[3] - 1), ee.write_shift(4, 0), ee.write_shift(4, 4096), ee.write_shift(4, ve[3] ? ve[0] + ve[1] + ve[2] - 1 : v), ee.write_shift(4, ve[3]), ee.write_shift(-4, ve[1] ? ve[0] - 1 : v), ee.write_shift(4, ve[1]), Ce = 0; Ce < 109; ++Ce)
          ee.write_shift(-4, Ce < ve[2] ? ve[1] + Ce : -1);
        if (ve[1])
          for ($e = 0; $e < ve[1]; ++$e) {
            for (; Ce < 236 + 127 * $e; ++Ce)
              ee.write_shift(-4, Ce < ve[2] ? ve[1] + Ce : -1);
            ee.write_shift(-4, $e === ve[1] - 1 ? v : $e + 1);
          }
        function xe(Et) {
          for ($e += Et; Ce < $e - 1; ++Ce)
            ee.write_shift(-4, Ce + 1);
          Et && (++Ce, ee.write_shift(-4, v));
        }
        for ($e = Ce = 0, $e += ve[1]; Ce < $e; ++Ce)
          ee.write_shift(-4, I.DIFSECT);
        for ($e += ve[2]; Ce < $e; ++Ce)
          ee.write_shift(-4, I.FATSECT);
        xe(ve[3]), xe(ve[4]);
        for (var Se = 0, ke = 0, Qe = q.FileIndex[0]; Se < q.FileIndex.length; ++Se)
          (Qe = q.FileIndex[Se]).content && ((ke = Qe.content.length) < 4096 || (Qe.start = $e, xe(ke + 511 >> 9)));
        for (xe(ve[6] + 7 >> 3); 511 & ee.l; )
          ee.write_shift(-4, I.ENDOFCHAIN);
        for (Se = $e = Ce = 0; Se < q.FileIndex.length; ++Se)
          (Qe = q.FileIndex[Se]).content && (!(ke = Qe.content.length) || 4096 <= ke || (Qe.start = $e, xe(ke + 63 >> 6)));
        for (; 511 & ee.l; )
          ee.write_shift(-4, I.ENDOFCHAIN);
        for (Ce = 0; Ce < ve[4] << 2; ++Ce) {
          var At = q.FullPaths[Ce];
          if (At && At.length !== 0) {
            if (Qe = q.FileIndex[Ce], Ce === 0 && (Qe.start = Qe.size ? Qe.start - 1 : v), At = Ce === 0 && te.root || Qe.name, ke = 2 * (At.length + 1), ee.write_shift(64, At, "utf16le"), ee.write_shift(2, ke), ee.write_shift(1, Qe.type), ee.write_shift(1, Qe.color), ee.write_shift(-4, Qe.L), ee.write_shift(-4, Qe.R), ee.write_shift(-4, Qe.C), Qe.clsid)
              ee.write_shift(16, Qe.clsid, "hex");
            else
              for (Se = 0; Se < 4; ++Se)
                ee.write_shift(4, 0);
            ee.write_shift(4, Qe.state || 0), ee.write_shift(4, 0), ee.write_shift(4, 0), ee.write_shift(4, 0), ee.write_shift(4, 0), ee.write_shift(4, Qe.start), ee.write_shift(4, Qe.size), ee.write_shift(4, 0);
          } else {
            for (Se = 0; Se < 17; ++Se)
              ee.write_shift(4, 0);
            for (Se = 0; Se < 3; ++Se)
              ee.write_shift(4, -1);
            for (Se = 0; Se < 12; ++Se)
              ee.write_shift(4, 0);
          }
        }
        for (Ce = 1; Ce < q.FileIndex.length; ++Ce)
          if (4096 <= (Qe = q.FileIndex[Ce]).size)
            if (ee.l = Qe.start + 1 << 9, K && Buffer.isBuffer(Qe.content))
              Qe.content.copy(ee, ee.l, 0, Qe.size), ee.l += Qe.size + 511 & -512;
            else {
              for (Se = 0; Se < Qe.size; ++Se)
                ee.write_shift(1, Qe.content[Se]);
              for (; 511 & Se; ++Se)
                ee.write_shift(1, 0);
            }
        for (Ce = 1; Ce < q.FileIndex.length; ++Ce)
          if (0 < (Qe = q.FileIndex[Ce]).size && Qe.size < 4096)
            if (K && Buffer.isBuffer(Qe.content))
              Qe.content.copy(ee, ee.l, 0, Qe.size), ee.l += Qe.size + 63 & -64;
            else {
              for (Se = 0; Se < Qe.size; ++Se)
                ee.write_shift(1, Qe.content[Se]);
              for (; 63 & Se; ++Se)
                ee.write_shift(1, 0);
            }
        if (K)
          ee.l = ee.length;
        else
          for (; ee.l < ee.length; )
            ee.write_shift(1, 0);
        return ee;
      }
      n.version = "1.2.1";
      var b, T = 64, v = -2, y = "d0cf11e0a1b11ae1", R = [208, 207, 17, 224, 161, 177, 26, 225], P = "00000000000000000000000000000000", I = { MAXREGSECT: -6, DIFSECT: -4, FATSECT: -3, ENDOFCHAIN: v, FREESECT: -1, HEADER_SIGNATURE: y, HEADER_MINOR_VERSION: "3e00", MAXREGSID: -6, NOSTREAM: -1, HEADER_CLSID: P, EntryTypes: ["unknown", "storage", "stream", "lockbytes", "property", "root"] };
      function A(q) {
        for (var Ie = new Array(q.length), te = 0; te < q.length; ++te)
          Ie[te] = String.fromCharCode(q[te]);
        return Ie.join("");
      }
      for (var M = [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15], F = [3, 4, 5, 6, 7, 8, 9, 10, 11, 13, 15, 17, 19, 23, 27, 31, 35, 43, 51, 59, 67, 83, 99, 115, 131, 163, 195, 227, 258], B = [1, 2, 3, 4, 5, 7, 9, 13, 17, 25, 33, 49, 65, 97, 129, 193, 257, 385, 513, 769, 1025, 1537, 2049, 3073, 4097, 6145, 8193, 12289, 16385, 24577], re, me = typeof Uint8Array < "u", le = me ? new Uint8Array(256) : [], be = 0; be < 256; ++be)
        le[be] = 255 & ((re = 139536 & ((re = be) << 1 | re << 11) | 558144 & (re << 5 | re << 15)) >> 16 | re >> 8 | re);
      function Fe(q, ve) {
        var te = 7 & ve, ve = ve >>> 3;
        return (q[ve] | (te <= 5 ? 0 : q[1 + ve] << 8)) >>> te & 7;
      }
      function Ue(q, ve) {
        var te = 7 & ve, ve = ve >>> 3;
        return (q[ve] | (te <= 3 ? 0 : q[1 + ve] << 8)) >>> te & 31;
      }
      function Ne(q, ve) {
        var te = 7 & ve, ve = ve >>> 3;
        return (q[ve] | (te <= 1 ? 0 : q[1 + ve] << 8)) >>> te & 127;
      }
      function ze(q, Ce, te) {
        var ve = 7 & Ce, ee = Ce >>> 3, $e = (1 << te) - 1, Ce = q[ee] >>> ve;
        return te < 8 - ve ? Ce & $e : (Ce |= q[1 + ee] << 8 - ve, te < 16 - ve ? Ce & $e : (Ce |= q[2 + ee] << 16 - ve, te < 24 - ve ? Ce & $e : (Ce |= q[3 + ee] << 24 - ve) & $e));
      }
      function ut(q, Ie, te) {
        var ve = 7 & Ie, ee = Ie >>> 3;
        return ve <= 5 ? q[ee] |= (7 & te) << ve : (q[ee] |= te << ve & 255, q[1 + ee] = (7 & te) >> 8 - ve), Ie + 3;
      }
      function lt(q, Ie, te) {
        var ve = Ie >>> 3;
        return te <<= 7 & Ie, q[ve] |= 255 & te, te >>>= 8, q[1 + ve] = te, Ie + 8;
      }
      function et(q, Ie, te) {
        var ve = Ie >>> 3;
        return te <<= 7 & Ie, q[ve] |= 255 & te, te >>>= 8, q[1 + ve] = 255 & te, q[2 + ve] = te >>> 8, Ie + 16;
      }
      function nt(q, Ie) {
        var te = q.length, ve = Ie < 2 * te ? 2 * te : Ie + 5, ee = 0;
        if (Ie <= te)
          return q;
        if (K) {
          var $e = se(ve);
          if (q.copy)
            q.copy($e);
          else
            for (; ee < q.length; ++ee)
              $e[ee] = q[ee];
          return $e;
        }
        if (me) {
          var Ce = new Uint8Array(ve);
          if (Ce.set)
            Ce.set(q);
          else
            for (; ee < te; ++ee)
              Ce[ee] = q[ee];
          return Ce;
        }
        return q.length = ve, q;
      }
      function je(q) {
        for (var Ie = new Array(q), te = 0; te < q; ++te)
          Ie[te] = 0;
        return Ie;
      }
      function Ye(q, Ie, te) {
        for (var ve, ee = 1, ke = 0, $e = 0, Ce = 0, xe = q.length, Se = me ? new Uint16Array(32) : je(32), ke = 0; ke < 32; ++ke)
          Se[ke] = 0;
        for (ke = xe; ke < te; ++ke)
          q[ke] = 0;
        xe = q.length;
        var Qe = me ? new Uint16Array(xe) : je(xe);
        for (ke = 0; ke < xe; ++ke)
          Se[ve = q[ke]]++, ee < ve && (ee = ve), Qe[ke] = 0;
        for (Se[0] = 0, ke = 1; ke <= ee; ++ke)
          Se[ke + 16] = Ce = Ce + Se[ke - 1] << 1;
        for (ke = 0; ke < xe; ++ke)
          (Ce = q[ke]) != 0 && (Qe[ke] = Se[Ce + 16]++);
        var At, Et, ct, vt;
        for (ke = 0; ke < xe; ++ke)
          if ((At = q[ke]) != 0)
            for (Et = Qe[ke], ct = ee, vt = void 0, vt = le[255 & Et], Ce = (ct <= 8 ? vt >>> 8 - ct : (vt = vt << 8 | le[Et >> 8 & 255], ct <= 16 ? vt >>> 16 - ct : (vt = vt << 8 | le[Et >> 16 & 255]) >>> 24 - ct)) >> ee - At, $e = (1 << ee + 4 - At) - 1; 0 <= $e; --$e)
              Ie[Ce | $e << At] = 15 & At | ke << 4;
        return ee;
      }
      var ht = me ? new Uint16Array(512) : je(512), Tt = me ? new Uint16Array(32) : je(32);
      if (!me) {
        for (var xt = 0; xt < 512; ++xt)
          ht[xt] = 0;
        for (xt = 0; xt < 32; ++xt)
          Tt[xt] = 0;
      }
      (function() {
        for (var q = [], Ie = 0; Ie < 32; Ie++)
          q.push(5);
        Ye(q, Tt, 32);
        for (var te = [], Ie = 0; Ie <= 143; Ie++)
          te.push(8);
        for (; Ie <= 255; Ie++)
          te.push(9);
        for (; Ie <= 279; Ie++)
          te.push(7);
        for (; Ie <= 287; Ie++)
          te.push(8);
        Ye(te, ht, 288);
      })();
      var Zt = function() {
        for (var q = me ? new Uint8Array(32768) : [], Ie = 0, te = 0; Ie < B.length - 1; ++Ie)
          for (; te < B[Ie + 1]; ++te)
            q[te] = Ie;
        for (; te < 32768; ++te)
          q[te] = 29;
        for (var ve = me ? new Uint8Array(259) : [], Ie = 0, te = 0; Ie < F.length - 1; ++Ie)
          for (; te < F[Ie + 1]; ++te)
            ve[te] = Ie;
        return function(ee, $e) {
          return (ee.length < 8 ? function(Ce, xe) {
            for (var Se = 0; Se < Ce.length; ) {
              var ke = Math.min(65535, Ce.length - Se), Qe = Se + ke == Ce.length;
              for (xe.write_shift(1, +Qe), xe.write_shift(2, ke), xe.write_shift(2, 65535 & ~ke); 0 < ke--; )
                xe[xe.l++] = Ce[Se++];
            }
            return xe.l;
          } : function(Ce, xe) {
            for (var Se = 0, ke = 0, Qe = me ? new Uint16Array(32768) : []; ke < Ce.length; ) {
              var At = Math.min(65535, Ce.length - ke);
              if (At < 10) {
                for (7 & (Se = ut(xe, Se, +(ke + At == Ce.length))) && (Se += 8 - (7 & Se)), xe.l = Se / 8 | 0, xe.write_shift(2, At), xe.write_shift(2, 65535 & ~At); 0 < At--; )
                  xe[xe.l++] = Ce[ke++];
                Se = 8 * xe.l;
              } else {
                Se = ut(xe, Se, +(ke + At == Ce.length) + 2);
                for (var Et = 0; 0 < At--; ) {
                  var ct = Ce[ke], Et = 32767 & (Et << 5 ^ ct), vt = -1, yt = 0;
                  if ((vt = Qe[Et]) && (ke < (vt |= -32768 & ke) && (vt -= 32768), vt < ke))
                    for (; Ce[vt + yt] == Ce[ke + yt] && yt < 250; )
                      ++yt;
                  if (2 < yt) {
                    (ct = ve[yt]) <= 22 ? Se = lt(xe, Se, le[ct + 1] >> 1) - 1 : (lt(xe, Se, 3), lt(xe, Se += 5, le[ct - 23] >> 5), Se += 3);
                    var It = ct < 8 ? 0 : ct - 4 >> 2;
                    0 < It && (et(xe, Se, yt - F[ct]), Se += It), ct = q[ke - vt], Se = lt(xe, Se, le[ct] >> 3), Se -= 3;
                    var at = ct < 4 ? 0 : ct - 2 >> 1;
                    0 < at && (et(xe, Se, ke - vt - B[ct]), Se += at);
                    for (var Xe = 0; Xe < yt; ++Xe)
                      Qe[Et] = 32767 & ke, Et = 32767 & (Et << 5 ^ Ce[ke]), ++ke;
                    At -= yt - 1;
                  } else
                    ct <= 143 ? ct += 48 : (It = ((It = 1) & It) << (7 & (at = Se)), xe[at >>> 3] |= It, Se = at + 1), Se = lt(xe, Se, le[ct]), Qe[Et] = 32767 & ke, ++ke;
                }
                Se = lt(xe, Se, 0) - 1;
              }
            }
            return xe.l = (Se + 7) / 8 | 0, xe.l;
          })(ee, $e);
        };
      }();
      function ft(te) {
        var Ie = Me(50 + Math.floor(1.1 * te.length)), te = Zt(te, Ie);
        return Ie.slice(0, te);
      }
      var We = me ? new Uint16Array(32768) : je(32768), Wt = me ? new Uint16Array(32768) : je(32768), dr = me ? new Uint16Array(128) : je(128), ir = 1, Or = 1;
      function Zr(q, Ie) {
        if (q[0] == 3 && !(3 & q[1]))
          return [_e(Ie), 2];
        for (var te = 0, ve = 0, ee = se(Ie || 1 << 18), $e = 0, Ce = ee.length >>> 0, xe = 0, Se = 0; !(1 & ve); )
          if (ve = Fe(q, te), te += 3, ve >>> 1 != 0)
            for (Se = ve >> 1 == 1 ? (xe = 9, 5) : (te = function(yt, It) {
              var at, Xe, Dt, gt = Ue(yt, It) + 257, tt = Ue(yt, It += 5) + 1, Mt = (Dt = 7 & (Xe = It += 5), 4 + (((at = yt)[Xe = Xe >>> 3] | (Dt <= 4 ? 0 : at[1 + Xe] << 8)) >>> Dt & 15));
              It += 4;
              for (var Pt = 0, kr = me ? new Uint8Array(19) : je(19), Bt = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], Kt = 1, Ot = me ? new Uint8Array(8) : je(8), or = me ? new Uint8Array(8) : je(8), sr = kr.length, _t = 0; _t < Mt; ++_t)
                kr[M[_t]] = Pt = Fe(yt, It), Kt < Pt && (Kt = Pt), Ot[Pt]++, It += 3;
              var Ct = 0;
              for (Ot[0] = 0, _t = 1; _t <= Kt; ++_t)
                or[_t] = Ct = Ct + Ot[_t - 1] << 1;
              for (_t = 0; _t < sr; ++_t)
                (Ct = kr[_t]) != 0 && (Bt[_t] = or[Ct]++);
              for (var St, _t = 0; _t < sr; ++_t)
                if ((St = kr[_t]) != 0) {
                  Ct = le[Bt[_t]] >> 8 - St;
                  for (var er = (1 << 7 - St) - 1; 0 <= er; --er)
                    dr[Ct | er << St] = 7 & St | _t << 3;
                }
              for (var br, pn, bn, cn = [], Kt = 1; cn.length < gt + tt; )
                switch (It += 7 & (Ct = dr[Ne(yt, It)]), Ct >>>= 3) {
                  case 16:
                    for (Pt = 3 + (bn = void 0, bn = 7 & (pn = It), ((br = yt)[pn = pn >>> 3] | (bn <= 6 ? 0 : br[1 + pn] << 8)) >>> bn & 3), It += 2, Ct = cn[cn.length - 1]; 0 < Pt--; )
                      cn.push(Ct);
                    break;
                  case 17:
                    for (Pt = 3 + Fe(yt, It), It += 3; 0 < Pt--; )
                      cn.push(0);
                    break;
                  case 18:
                    for (Pt = 11 + Ne(yt, It), It += 7; 0 < Pt--; )
                      cn.push(0);
                    break;
                  default:
                    cn.push(Ct), Kt < Ct && (Kt = Ct);
                }
              var Mn = cn.slice(0, gt), Pn = cn.slice(gt);
              for (_t = gt; _t < 286; ++_t)
                Mn[_t] = 0;
              for (_t = tt; _t < 30; ++_t)
                Pn[_t] = 0;
              return ir = Ye(Mn, We, 286), Or = Ye(Pn, Wt, 30), It;
            }(q, te), xe = ir, Or); ; ) {
              !Ie && Ce < $e + 32767 && (Ce = (ee = nt(ee, $e + 32767)).length);
              var ke = ze(q, te, xe), Qe = (ve >>> 1 == 1 ? ht : We)[ke];
              if (te += 15 & Qe, ((Qe >>>= 4) >>> 8 & 255) == 0)
                ee[$e++] = Qe;
              else {
                if (Qe == 256)
                  break;
                var At = (Qe -= 257) < 8 ? 0 : Qe - 4 >> 2;
                5 < At && (At = 0);
                var Et = $e + F[Qe];
                0 < At && (Et += ze(q, te, At), te += At), ke = ze(q, te, Se), te += 15 & (Qe = (ve >>> 1 == 1 ? Tt : Wt)[ke]);
                var ke = (Qe >>>= 4) < 4 ? 0 : Qe - 2 >> 1, ct = B[Qe];
                for (0 < ke && (ct += ze(q, te, ke), te += ke), !Ie && Ce < Et && (Ce = (ee = nt(ee, Et + 100)).length); $e < Et; )
                  ee[$e] = ee[$e - ct], ++$e;
              }
            }
          else {
            7 & te && (te += 8 - (7 & te));
            var vt = q[te >>> 3] | q[1 + (te >>> 3)] << 8;
            if (te += 32, 0 < vt)
              for (!Ie && Ce < $e + vt && (Ce = (ee = nt(ee, $e + vt)).length); 0 < vt--; )
                ee[$e++] = q[te >>> 3], te += 8;
          }
        return Ie ? [ee, te + 7 >>> 3] : [ee.slice(0, $e), te + 7 >>> 3];
      }
      function oe(q, Ie) {
        return Ie = Zr(q.slice(q.l || 0), Ie), q.l += Ie[1], Ie[0];
      }
      function yr(q, Ie) {
        if (!q)
          throw new Error(Ie);
        typeof console < "u" && console.error(Ie);
      }
      function Rr(q, Ie) {
        var te = q;
        Nn(te, 0);
        var ve = { FileIndex: [], FullPaths: [] };
        m(ve, { root: Ie.root });
        for (var ee = te.length - 4; (te[ee] != 80 || te[ee + 1] != 75 || te[ee + 2] != 5 || te[ee + 3] != 6) && 0 <= ee; )
          --ee;
        te.l = ee + 4, te.l += 4;
        var $e = te.read_shift(2);
        for (te.l += 6, Ie = te.read_shift(4), te.l = Ie, ee = 0; ee < $e; ++ee) {
          te.l += 20;
          var Ce = te.read_shift(4), xe = te.read_shift(4), Se = te.read_shift(2), ke = te.read_shift(2), Qe = te.read_shift(2);
          te.l += 8;
          var At = te.read_shift(4), Et = d(te.slice(te.l + Se, te.l + Se + ke));
          te.l += Se + ke + Qe, Qe = te.l, te.l = At + 4, function(ct, vt, yt, It, at) {
            ct.l += 2;
            var Xe = ct.read_shift(2), Dt = ct.read_shift(2), gt = function(br) {
              var _t = 65535 & br.read_shift(2), Ct = 65535 & br.read_shift(2), St = /* @__PURE__ */ new Date(), er = 31 & Ct, br = 15 & (Ct >>>= 5);
              return Ct >>>= 4, St.setMilliseconds(0), St.setFullYear(1980 + Ct), St.setMonth(br - 1), St.setDate(er), br = 31 & _t, er = 63 & (_t >>>= 5), _t >>>= 6, St.setHours(_t), St.setMinutes(er), St.setSeconds(br << 1), St;
            }(ct);
            if (8257 & Xe)
              throw new Error("Unsupported ZIP encryption");
            ct.read_shift(4);
            for (var tt, Mt = ct.read_shift(4), Pt = ct.read_shift(4), kr = ct.read_shift(2), Bt = ct.read_shift(2), Kt = "", Ot = 0; Ot < kr; ++Ot)
              Kt += String.fromCharCode(ct[ct.l++]);
            Bt && (((tt = d(ct.slice(ct.l, ct.l + Bt)))[21589] || {}).mt && (gt = tt[21589].mt), ((at || {})[21589] || {}).mt && (gt = at[21589].mt)), ct.l += Bt;
            var or = ct.slice(ct.l, ct.l + Mt);
            switch (Dt) {
              case 8:
                or = function(sr, St) {
                  if (!b)
                    return oe(sr, St);
                  var Ct = new b.InflateRaw(), St = Ct._processChunk(sr.slice(sr.l), Ct._finishFlushFlag);
                  return sr.l += Ct.bytesRead, St;
                }(ct, Pt);
                break;
              case 0:
                break;
              default:
                throw new Error("Unsupported ZIP Compression method " + Dt);
            }
            Bt = !1, 8 & Xe && (ct.read_shift(4) == 134695760 && (ct.read_shift(4), Bt = !0), Mt = ct.read_shift(4), Pt = ct.read_shift(4)), Mt != vt && yr(Bt, "Bad compressed size: " + vt + " != " + Mt), Pt != yt && yr(Bt, "Bad uncompressed size: " + yt + " != " + Pt), da(It, Kt, or, { unsafe: !0, mt: gt });
          }(te, Ce, xe, ve, Et), te.l = Qe;
        }
        return ve;
      }
      var _n = { htm: "text/html", xml: "text/xml", gif: "image/gif", jpg: "image/jpeg", png: "image/png", mso: "application/x-mso", thmx: "application/vnd.ms-officetheme", sh33tj5: "application/octet-stream" };
      function da(q, Ie, te, ve) {
        var ee = ve && ve.unsafe;
        ee || m(q);
        var $e, Ce = !ee && Lt.find(q, Ie);
        return Ce || ($e = q.FullPaths[0], $e = Ie.slice(0, $e.length) == $e ? Ie : ($e.slice(-1) != "/" && ($e += "/"), ($e + Ie).replace("//", "/")), Ce = { name: l(Ie), type: 2 }, q.FileIndex.push(Ce), q.FullPaths.push($e), ee || Lt.utils.cfb_gc(q)), Ce.content = te, Ce.size = te ? te.length : 0, ve && (ve.CLSID && (Ce.clsid = ve.CLSID), ve.mt && (Ce.mt = ve.mt), ve.ct && (Ce.ct = ve.ct)), Ce;
      }
      return n.find = function(q, Ie) {
        var te = q.FullPaths.map(function(Se) {
          return Se.toUpperCase();
        }), ve = te.map(function(Se) {
          var ke = Se.split("/");
          return ke[ke.length - (Se.slice(-1) == "/" ? 2 : 1)];
        }), ee = !1;
        Ie.charCodeAt(0) === 47 ? (ee = !0, Ie = te[0].slice(0, -1) + Ie) : ee = Ie.indexOf("/") !== -1;
        var xe = Ie.toUpperCase(), $e = (ee === !0 ? te : ve).indexOf(xe);
        if ($e !== -1)
          return q.FileIndex[$e];
        var Ce = !xe.match(w), xe = xe.replace(ge, "");
        for (Ce && (xe = xe.replace(w, "!")), $e = 0; $e < te.length; ++$e)
          if ((Ce ? te[$e].replace(w, "!") : te[$e]).replace(ge, "") == xe || (Ce ? ve[$e].replace(w, "!") : ve[$e]).replace(ge, "") == xe)
            return q.FileIndex[$e];
        return null;
      }, n.read = function(q, Ie) {
        var te, ve, ee = Ie && Ie.type;
        switch (ee || K && Buffer.isBuffer(q) && (ee = "buffer"), ee || "base64") {
          case "file":
            return te = q, ve = Ie, _(), u(t.readFileSync(te), ve);
          case "base64":
            return u(Pe(H(q)), Ie);
          case "binary":
            return u(Pe(q), Ie);
        }
        return u(q, Ie);
      }, n.parse = u, n.write = function(q, Ie) {
        var te = E(q, Ie);
        switch (Ie && Ie.type || "buffer") {
          case "file":
            return _(), t.writeFileSync(Ie.filename, te), te;
          case "binary":
            return typeof te == "string" ? te : A(te);
          case "base64":
            return Z(typeof te == "string" ? te : A(te));
          case "buffer":
            if (K)
              return Buffer.isBuffer(te) ? te : Q(te);
          case "array":
            return typeof te == "string" ? Pe(te) : te;
        }
        return te;
      }, n.writeFile = function(q, Ie, te) {
        _(), te = E(q, te), t.writeFileSync(Ie, te);
      }, n.utils = { cfb_new: function(q) {
        var Ie = {};
        return m(Ie, q), Ie;
      }, cfb_add: da, cfb_del: function(q, Ie) {
        m(q);
        var te = Lt.find(q, Ie);
        if (te) {
          for (var ve = 0; ve < q.FileIndex.length; ++ve)
            if (q.FileIndex[ve] == te)
              return q.FileIndex.splice(ve, 1), q.FullPaths.splice(ve, 1), !0;
        }
        return !1;
      }, cfb_mov: function(q, Ie, te) {
        m(q);
        var ve = Lt.find(q, Ie);
        if (ve) {
          for (var ee = 0; ee < q.FileIndex.length; ++ee)
            if (q.FileIndex[ee] == ve)
              return q.FileIndex[ee].name = l(te), q.FullPaths[ee] = te, !0;
        }
        return !1;
      }, cfb_gc: function(q) {
        f(q, !0);
      }, ReadShift: Eo, CheckField: _f, prep_blob: Nn, bconcat: mt, use_zlib: function(q) {
        try {
          var Ie = new q.InflateRaw();
          if (Ie._processChunk(new Uint8Array([3, 0]), Ie._finishFlushFlag), !Ie.bytesRead)
            throw new Error("zlib does not expose bytesRead");
          b = q;
        } catch (te) {
          console.error("cannot use native zlib: " + (te.message || te));
        }
      }, _deflateRaw: ft, _inflateRaw: oe, consts: I }, n;
    }();
    if (typeof el < "u")
      try {
        Ia = Zc;
      } catch {
      }
    function Gm(t) {
      return typeof t == "string" ? Ke(t) : Array.isArray(t) ? function(n) {
        if (typeof Uint8Array > "u")
          throw new Error("Unsupported");
        return new Uint8Array(n);
      }(t) : t;
    }
    function Di(t, n, a) {
      if (Ia !== void 0 && Ia.writeFileSync)
        return a ? Ia.writeFileSync(t, n, a) : Ia.writeFileSync(t, n);
      if (typeof Deno < "u") {
        if (a && typeof n == "string")
          switch (a) {
            case "utf8":
              n = new TextEncoder(a).encode(n);
              break;
            case "binary":
              n = Ke(n);
              break;
            default:
              throw new Error("Unsupported encoding " + a);
          }
        return Deno.writeFileSync(t, n);
      }
      var l = a == "utf8" ? Zn(n) : n;
      if (typeof IE_SaveFile < "u")
        return IE_SaveFile(l, t);
      if (typeof Blob < "u") {
        if (l = new Blob([Gm(l)], { type: "application/octet-stream" }), typeof navigator < "u" && navigator.msSaveBlob)
          return navigator.msSaveBlob(l, t);
        if (typeof saveAs < "u")
          return saveAs(l, t);
        if (typeof URL < "u" && typeof document < "u" && document.createElement && URL.createObjectURL) {
          var d = URL.createObjectURL(l);
          if (typeof chrome == "object" && typeof (chrome.downloads || {}).download == "function")
            return URL.revokeObjectURL && typeof setTimeout < "u" && setTimeout(function() {
              URL.revokeObjectURL(d);
            }, 6e4), chrome.downloads.download({ url: d, filename: t, saveAs: !0 });
          if (l = document.createElement("a"), l.download != null)
            return l.download = t, l.href = d, document.body.appendChild(l), l.click(), document.body.removeChild(l), URL.revokeObjectURL && typeof setTimeout < "u" && setTimeout(function() {
              URL.revokeObjectURL(d);
            }, 6e4), d;
        }
      }
      if (typeof $ < "u" && typeof File < "u" && typeof Folder < "u")
        try {
          var _ = File(t);
          return _.open("w"), _.encoding = "binary", Array.isArray(n) && (n = ye(n)), _.write(n), _.close(), n;
        } catch (u) {
          if (!u.message || !u.message.match(/onstruct/))
            throw u;
        }
      throw new Error("cannot save file " + t);
    }
    function $r(t) {
      for (var n = Object.keys(t), a = [], l = 0; l < n.length; ++l)
        Object.prototype.hasOwnProperty.call(t, n[l]) && a.push(n[l]);
      return a;
    }
    function Al(t, n) {
      for (var a = [], l = $r(t), d = 0; d !== l.length; ++d)
        a[t[l[d]][n]] == null && (a[t[l[d]][n]] = l[d]);
      return a;
    }
    function ao(t) {
      for (var n = [], a = $r(t), l = 0; l !== a.length; ++l)
        n[t[a[l]]] = a[l];
      return n;
    }
    function io(t) {
      for (var n = [], a = $r(t), l = 0; l !== a.length; ++l)
        n[t[a[l]]] = parseInt(a[l], 10);
      return n;
    }
    var oo = new Date(1899, 11, 30, 0, 0, 0);
    function on(t, n) {
      var a = t.getTime();
      return n && (a -= 1263168e5), (a - (oo.getTime() + 6e4 * (t.getTimezoneOffset() - oo.getTimezoneOffset()))) / 864e5;
    }
    var so = /* @__PURE__ */ new Date(), Vm = oo.getTime() + 6e4 * (so.getTimezoneOffset() - oo.getTimezoneOffset()), Ol = so.getTimezoneOffset();
    function lo(t) {
      var n = /* @__PURE__ */ new Date();
      return n.setTime(24 * t * 60 * 60 * 1e3 + Vm), n.getTimezoneOffset() !== Ol && n.setTime(n.getTime() + 6e4 * (n.getTimezoneOffset() - Ol)), n;
    }
    var co = /* @__PURE__ */ new Date("2017-02-19T19:06:09.000Z"), yl = isNaN(co.getFullYear()) ? /* @__PURE__ */ new Date("2/19/17") : co, Ym = yl.getFullYear() == 2017;
    function Br(t, n) {
      var a = new Date(t);
      return Ym ? (0 < n ? a.setTime(a.getTime() + 60 * a.getTimezoneOffset() * 1e3) : n < 0 && a.setTime(a.getTime() - 60 * a.getTimezoneOffset() * 1e3), a) : t instanceof Date ? t : yl.getFullYear() == 1917 && !isNaN(a.getFullYear()) ? (n = a.getFullYear(), -1 < t.indexOf("" + n) || a.setFullYear(a.getFullYear() + 100), a) : (a = t.match(/\d+/g) || ["2017", "2", "19", "0", "0", "0"], a = new Date(+a[0], +a[1] - 1, +a[2], +a[3] || 0, +a[4] || 0, +a[5] || 0), a = -1 < t.indexOf("Z") ? new Date(a.getTime() - 60 * a.getTimezoneOffset() * 1e3) : a);
    }
    function Va(t, n) {
      if (K && Buffer.isBuffer(t)) {
        if (n) {
          if (t[0] == 255 && t[1] == 254)
            return Zn(t.slice(2).toString("utf16le"));
          if (t[1] == 254 && t[2] == 255)
            return Zn(L(t.slice(2).toString("binary")));
        }
        return t.toString("binary");
      }
      if (typeof TextDecoder < "u")
        try {
          if (n) {
            if (t[0] == 255 && t[1] == 254)
              return Zn(new TextDecoder("utf-16le").decode(t.slice(2)));
            if (t[0] == 254 && t[1] == 255)
              return Zn(new TextDecoder("utf-16be").decode(t.slice(2)));
          }
          var a = { "€": "", "‚": "", ƒ: "", "„": "", "…": "", "†": "", "‡": "", "ˆ": "", "‰": "", Š: "", "‹": "", Œ: "", Ž: "", "‘": "", "’": "", "“": "", "”": "", "•": "", "–": "", "—": "", "˜": "", "™": "", š: "", "›": "", œ: "", ž: "", Ÿ: "" };
          return Array.isArray(t) && (t = new Uint8Array(t)), new TextDecoder("latin1").decode(t).replace(/[€‚ƒ„…†‡ˆ‰Š‹ŒŽ‘’“”•–—˜™š›œžŸ]/g, function(_) {
            return a[_] || _;
          });
        } catch {
        }
      for (var l = [], d = 0; d != t.length; ++d)
        l.push(String.fromCharCode(t[d]));
      return l.join("");
    }
    function xr(t) {
      if (typeof JSON < "u" && !Array.isArray(t))
        return JSON.parse(JSON.stringify(t));
      if (typeof t != "object" || t == null)
        return t;
      if (t instanceof Date)
        return new Date(t.getTime());
      var n, a = {};
      for (n in t)
        Object.prototype.hasOwnProperty.call(t, n) && (a[n] = xr(t[n]));
      return a;
    }
    function Wr(t, n) {
      for (var a = ""; a.length < n; )
        a += t;
      return a;
    }
    function na(l) {
      var n = Number(l);
      if (!isNaN(n))
        return isFinite(n) ? n : NaN;
      if (!/\d/.test(l))
        return n;
      var a = 1, l = l.replace(/([\d]),([\d])/g, "$1$2").replace(/[$]/g, "").replace(/[%]/g, function() {
        return a *= 100, "";
      });
      return isNaN(n = Number(l)) ? (l = l.replace(/[(](.*)[)]/, function(d, _) {
        return a = -a, _;
      }), isNaN(n = Number(l)) ? n : n / a) : n / a;
    }
    var Hm = ["january", "february", "march", "april", "may", "june", "july", "august", "september", "october", "november", "december"];
    function ri(t) {
      var n = new Date(t), a = /* @__PURE__ */ new Date(NaN), l = n.getYear(), d = n.getMonth(), _ = n.getDate();
      if (isNaN(_))
        return a;
      var u = t.toLowerCase();
      if (u.match(/jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec/)) {
        if (3 < (u = u.replace(/[^a-z]/g, "").replace(/([^a-z]|^)[ap]m?([^a-z]|$)/, "")).length && Hm.indexOf(u) == -1)
          return a;
      } else if (u.match(/[a-z]/))
        return a;
      return l < 0 || 8099 < l || (!(0 < d || 1 < _) || l == 101) && t.match(/[^-0-9:,\/\\]/) ? a : n;
    }
    var Il, qm = (Il = "abacaba".split(/(:?b)/i).length == 5, function(t, n, a) {
      if (Il || typeof n == "string")
        return t.split(n);
      for (var l = t.split(n), d = [l[0]], _ = 1; _ < l.length; ++_)
        d.push(a), d.push(l[_]);
      return d;
    });
    function Dl(t) {
      return t ? t.content && t.type ? Va(t.content, !0) : t.data ? G(t.data) : t.asNodeBuffer && K ? G(t.asNodeBuffer().toString("binary")) : t.asBinary ? G(t.asBinary()) : t._data && t._data.getContent ? G(Va(Array.prototype.slice.call(t._data.getContent(), 0))) : null : null;
    }
    function wl(t) {
      if (!t)
        return null;
      if (t.data)
        return x(t.data);
      if (t.asNodeBuffer && K)
        return t.asNodeBuffer();
      if (t._data && t._data.getContent) {
        var n = t._data.getContent();
        return typeof n == "string" ? x(n) : Array.prototype.slice.call(n);
      }
      return t.content && t.type ? t.content : null;
    }
    function Xn(t, n) {
      for (var a = t.FullPaths || $r(t.files), l = n.toLowerCase().replace(/[\/]/g, "\\"), d = l.replace(/\\/g, "/"), _ = 0; _ < a.length; ++_) {
        var u = a[_].replace(/^Root Entry[\/]/, "").toLowerCase();
        if (l == u || d == u)
          return t.files ? t.files[a[_]] : t.FileIndex[_];
      }
      return null;
    }
    function os(t, n) {
      if (t = Xn(t, n), t == null)
        throw new Error("Cannot find file " + n + " in zip");
      return t;
    }
    function en(t, n, a) {
      if (!a)
        return ((a = os(t, n)) && a.name.slice(-4) === ".bin" ? wl : Dl)(a);
      if (!n)
        return null;
      try {
        return en(t, n);
      } catch {
        return null;
      }
    }
    function $n(t, n, a) {
      if (!a)
        return Dl(os(t, n));
      if (!n)
        return null;
      try {
        return $n(t, n);
      } catch {
        return null;
      }
    }
    function xl(t) {
      for (var n = t.FullPaths || $r(t.files), a = [], l = 0; l < n.length; ++l)
        n[l].slice(-1) != "/" && a.push(n[l].replace(/^Root Entry[\/]/, ""));
      return a.sort();
    }
    function Qt(t, n, a) {
      if (t.FullPaths) {
        if (typeof a == "string") {
          var l = (K ? Q : function(d) {
            for (var _ = [], u = 0, p = d.length + 250, m = _e(d.length + 255), f = 0; f < d.length; ++f) {
              var E, b = d.charCodeAt(f);
              b < 128 ? m[u++] = b : b < 2048 ? (m[u++] = 192 | b >> 6 & 31, m[u++] = 128 | 63 & b) : 55296 <= b && b < 57344 ? (b = 64 + (1023 & b), E = 1023 & d.charCodeAt(++f), m[u++] = 240 | b >> 8 & 7, m[u++] = 128 | b >> 2 & 63, m[u++] = 128 | E >> 6 & 15 | (3 & b) << 4, m[u++] = 128 | 63 & E) : (m[u++] = 224 | b >> 12 & 15, m[u++] = 128 | b >> 6 & 63, m[u++] = 128 | 63 & b), p < u && (_.push(m.slice(0, u)), u = 0, m = _e(65535), p = 65530);
            }
            return _.push(m.slice(0, u)), mt(_);
          })(a);
          return Lt.utils.cfb_add(t, n, l);
        }
        Lt.utils.cfb_add(t, n, a);
      } else
        t.file(n, a);
    }
    function ss() {
      return Lt.utils.cfb_new();
    }
    function Ll(t, n) {
      switch (n.type) {
        case "base64":
          return Lt.read(t, { type: "base64" });
        case "binary":
          return Lt.read(t, { type: "binary" });
        case "buffer":
        case "array":
          return Lt.read(t, { type: "buffer" });
      }
      throw new Error("Unrecognized type " + n.type);
    }
    function wi(t, n) {
      if (t.charAt(0) == "/")
        return t.slice(1);
      var a = n.split("/");
      n.slice(-1) != "/" && a.pop();
      for (var l = t.split("/"); l.length !== 0; ) {
        var d = l.shift();
        d === ".." ? a.pop() : d !== "." && a.push(d);
      }
      return a.join("/");
    }
    var Qr = `<?xml version="1.0" encoding="UTF-8" standalone="yes"?>\r
`, $m = /([^"\s?>\/]+)\s*=\s*((?:")([^"]*)(?:")|(?:')([^']*)(?:')|([^'">\s]+))/g, Gs = /<[\/\?]?[a-zA-Z0-9:_-]+(?:\s+[^"\s?>\/]+\s*=\s*(?:"[^"]*"|'[^']*'|[^'">\s=]+))*\s*[\/\?]?>/gm, Cn = Qr.match(Gs) ? Gs : /<[^>]*>/g, Wm = /<\w*:/, zm = /<(\/?)\w+:/;
    function Ht(t, n, a) {
      for (var l = {}, d = 0, _ = 0; d !== t.length && (_ = t.charCodeAt(d)) !== 32 && _ !== 10 && _ !== 13; ++d)
        ;
      if (n || (l[0] = t.slice(0, d)), d === t.length)
        return l;
      var u, p, m, f = t.match($m), E = 0, b = 0, T = "", v = "";
      if (f)
        for (b = 0; b != f.length; ++b) {
          for (v = f[b], _ = 0; _ != v.length && v.charCodeAt(_) !== 61; ++_)
            ;
          for (T = v.slice(0, _).trim(); v.charCodeAt(_ + 1) == 32; )
            ++_;
          for (p = (d = v.charCodeAt(_ + 1)) == 34 || d == 39 ? 1 : 0, u = v.slice(_ + 1 + p, v.length - p), E = 0; E != T.length && T.charCodeAt(E) !== 58; ++E)
            ;
          E === T.length ? (l[T = 0 < T.indexOf("_") ? T.slice(0, T.indexOf("_")) : T] = u, a || (l[T.toLowerCase()] = u)) : l[m = (E === 5 && T.slice(0, 5) === "xmlns" ? "xmlns" : "") + T.slice(E + 1)] && T.slice(E - 3, E) == "ext" || (l[m] = u, a || (l[m.toLowerCase()] = u));
        }
      return l;
    }
    function pa(t) {
      return t.replace(zm, "<$1");
    }
    var Ml, Pl, kl = { "&quot;": '"', "&apos;": "'", "&gt;": ">", "&lt;": "<", "&amp;": "&" }, ls = ao(kl), mr = (Ml = /&(?:quot|apos|gt|lt|amp|#x?([\da-fA-F]+));/gi, Pl = /_x([\da-fA-F]{4})_/gi, function t(n) {
      var a = n + "", l = a.indexOf("<![CDATA[");
      return l == -1 ? a.replace(Ml, function(d, _) {
        return kl[d] || String.fromCharCode(parseInt(_, -1 < d.indexOf("x") ? 16 : 10)) || d;
      }).replace(Pl, function(d, _) {
        return String.fromCharCode(parseInt(_, 16));
      }) : (n = a.indexOf("]]>"), t(a.slice(0, l)) + a.slice(l + 9, n) + t(a.slice(n + 3)));
    }), cs = /[&<>'"]/g, Km = /[\u0000-\u0008\u000b-\u001f]/g;
    function Ar(t) {
      return (t + "").replace(cs, function(n) {
        return ls[n];
      }).replace(Km, function(n) {
        return "_x" + ("000" + n.charCodeAt(0).toString(16)).slice(-4) + "_";
      });
    }
    function ds(t) {
      return Ar(t).replace(/ /g, "_x0020_");
    }
    var us = /[\u0000-\u001f]/g;
    function uo(t) {
      return (t + "").replace(cs, function(n) {
        return ls[n];
      }).replace(/\n/g, "<br/>").replace(us, function(n) {
        return "&#x" + ("000" + n.charCodeAt(0).toString(16)).slice(-4) + ";";
      });
    }
    var _s, ps = (_s = /&#(\d+);/g, function(t) {
      return t.replace(_s, Fl);
    });
    function Fl(t, n) {
      return String.fromCharCode(parseInt(n, 10));
    }
    function Lr(t) {
      switch (t) {
        case 1:
        case !0:
        case "1":
        case "true":
        case "TRUE":
          return !0;
        default:
          return !1;
      }
    }
    function xi(t) {
      for (var n, a, l, d, _ = "", u = 0, p = 0; u < t.length; )
        (n = t.charCodeAt(u++)) < 128 ? _ += String.fromCharCode(n) : (a = t.charCodeAt(u++), 191 < n && n < 224 ? (p = (31 & n) << 6, p |= 63 & a, _ += String.fromCharCode(p)) : (l = t.charCodeAt(u++), n < 240 ? _ += String.fromCharCode((15 & n) << 12 | (63 & a) << 6 | 63 & l) : (d = ((7 & n) << 18 | (63 & a) << 12 | (63 & l) << 6 | 63 & (p = t.charCodeAt(u++))) - 65536, _ += String.fromCharCode(55296 + (d >>> 10 & 1023)), _ += String.fromCharCode(56320 + (1023 & d)))));
      return _;
    }
    function _o(t) {
      for (var n, a, l = _e(2 * t.length), d = 1, _ = 0, u = 0, p = 0; p < t.length; p += d)
        d = 1, (a = t.charCodeAt(p)) < 128 ? n = a : a < 224 ? (n = 64 * (31 & a) + (63 & t.charCodeAt(p + 1)), d = 2) : a < 240 ? (n = 4096 * (15 & a) + 64 * (63 & t.charCodeAt(p + 1)) + (63 & t.charCodeAt(p + 2)), d = 3) : (d = 4, n = 262144 * (7 & a) + 4096 * (63 & t.charCodeAt(p + 1)) + 64 * (63 & t.charCodeAt(p + 2)) + (63 & t.charCodeAt(p + 3)), u = 55296 + ((n -= 65536) >>> 10 & 1023), n = 56320 + (1023 & n)), u !== 0 && (l[_++] = 255 & u, l[_++] = u >>> 8, u = 0), l[_++] = n % 256, l[_++] = n >>> 8;
      return l.slice(0, _).toString("ucs2");
    }
    function ms(t) {
      return Q(t, "binary").toString("utf8");
    }
    var po, ni, Da, Wi = "foo bar bazâð£", Cr = K && (ms(Wi) == xi(Wi) ? ms : _o(Wi) == xi(Wi) && _o) || xi, Zn = K ? function(t) {
      return Q(t, "utf8").toString("binary");
    } : function(t) {
      for (var n, a = [], l = 0, d = 0; l < t.length; )
        switch (!0) {
          case (d = t.charCodeAt(l++)) < 128:
            a.push(String.fromCharCode(d));
            break;
          case d < 2048:
            a.push(String.fromCharCode(192 + (d >> 6))), a.push(String.fromCharCode(128 + (63 & d)));
            break;
          case (55296 <= d && d < 57344):
            d -= 55296, n = t.charCodeAt(l++) - 56320 + (d << 10), a.push(String.fromCharCode(240 + (n >> 18 & 7))), a.push(String.fromCharCode(144 + (n >> 12 & 63))), a.push(String.fromCharCode(128 + (n >> 6 & 63))), a.push(String.fromCharCode(128 + (63 & n)));
            break;
          default:
            a.push(String.fromCharCode(224 + (d >> 12))), a.push(String.fromCharCode(128 + (d >> 6 & 63))), a.push(String.fromCharCode(128 + (63 & d)));
        }
      return a.join("");
    }, Ya = (po = {}, function(t, n) {
      var a = t + "|" + (n || "");
      return po[a] || (po[a] = new RegExp("<(?:\\w+:)?" + t + '(?: xml:space="preserve")?(?:[^>]*)>([\\s\\S]*?)</(?:\\w+:)?' + t + ">", n || ""));
    }), mo = (ni = [["nbsp", " "], ["middot", "·"], ["quot", '"'], ["apos", "'"], ["gt", ">"], ["lt", "<"], ["amp", "&"]].map(function(t) {
      return [new RegExp("&" + t[0] + ";", "ig"), t[1]];
    }), function(t) {
      for (var n = t.replace(/^[\t\n\r ]+/, "").replace(/[\t\n\r ]+$/, "").replace(/>\s+/g, ">").replace(/\s+</g, "<").replace(/[\t\n\r ]+/g, " ").replace(/<\s*[bB][rR]\s*\/?>/g, `
`).replace(/<[^>]*>/g, ""), a = 0; a < ni.length; ++a)
        n = n.replace(ni[a][0], ni[a][1]);
      return n;
    }), Qm = (Da = {}, function(t) {
      return Da[t] !== void 0 ? Da[t] : Da[t] = new RegExp("<(?:vt:)?" + t + ">([\\s\\S]*?)</(?:vt:)?" + t + ">", "g");
    }), Xm = /<\/?(?:vt:)?variant>/g, Zv = /<(?:vt:)([^>]*)>([\s\S]*)</;
    function Zm(l, n) {
      var a = Ht(l), l = l.match(Qm(a.baseType)) || [], d = [];
      if (l.length == a.size)
        return l.forEach(function(_) {
          _ = _.replace(Xm, "").match(Zv), _ && d.push({ v: Cr(_[2]), t: _[1] });
        }), d;
      if (n.WTF)
        throw new Error("unexpected vector length " + l.length + " != " + a.size);
      return d;
    }
    var jm = /(^\s|\s$|\n)/;
    function Rn(t, n) {
      return "<" + t + (n.match(jm) ? ' xml:space="preserve"' : "") + ">" + n + "</" + t + ">";
    }
    function fo(t) {
      return $r(t).map(function(n) {
        return " " + n + '="' + t[n] + '"';
      }).join("");
    }
    function it(t, n, a) {
      return "<" + t + (a != null ? fo(a) : "") + (n != null ? (n.match(jm) ? ' xml:space="preserve"' : "") + ">" + n + "</" + t : "/") + ">";
    }
    function Ul(t, n) {
      try {
        return t.toISOString().replace(/\.\d*/, "");
      } catch (a) {
        if (n)
          throw a;
      }
      return "";
    }
    function Bl(t) {
      if (K && Buffer.isBuffer(t))
        return t.toString("utf8");
      if (typeof t == "string")
        return t;
      if (typeof Uint8Array < "u" && t instanceof Uint8Array)
        return Cr(ye(Je(t)));
      throw new Error("Bad input format: expected Buffer or string");
    }
    var go = /<(\/?)([^\s?><!\/:]*:|)([^\s?<>:\/]+)(?:[\s?:\/][^>]*)?>/gm, un = { CORE_PROPS: "http://schemas.openxmlformats.org/package/2006/metadata/core-properties", CUST_PROPS: "http://schemas.openxmlformats.org/officeDocument/2006/custom-properties", EXT_PROPS: "http://schemas.openxmlformats.org/officeDocument/2006/extended-properties", CT: "http://schemas.openxmlformats.org/package/2006/content-types", RELS: "http://schemas.openxmlformats.org/package/2006/relationships", TCMNT: "http://schemas.microsoft.com/office/spreadsheetml/2018/threadedcomments", dc: "http://purl.org/dc/elements/1.1/", dcterms: "http://purl.org/dc/terms/", dcmitype: "http://purl.org/dc/dcmitype/", mx: "http://schemas.microsoft.com/office/mac/excel/2008/main", r: "http://schemas.openxmlformats.org/officeDocument/2006/relationships", sjs: "http://schemas.openxmlformats.org/package/2006/sheetjs/core-properties", vt: "http://schemas.openxmlformats.org/officeDocument/2006/docPropsVTypes", xsi: "http://www.w3.org/2001/XMLSchema-instance", xsd: "http://www.w3.org/2001/XMLSchema" }, ai = ["http://schemas.openxmlformats.org/spreadsheetml/2006/main", "http://purl.oclc.org/ooxml/spreadsheetml/main", "http://schemas.microsoft.com/office/excel/2006/main", "http://schemas.microsoft.com/office/excel/2006/2"], jn = { o: "urn:schemas-microsoft-com:office:office", x: "urn:schemas-microsoft-com:office:excel", ss: "urn:schemas-microsoft-com:office:spreadsheet", dt: "uuid:C2F41010-65B3-11d1-A29F-00AA00C14882", mv: "http://macVmlSchemaUri", v: "urn:schemas-microsoft-com:vml", html: "http://www.w3.org/TR/REC-html40" };
    function Jm(t) {
      for (var n = [], a = 0; a < t[0].length; ++a)
        if (t[0][a])
          for (var l = 0, d = t[0][a].length; l < d; l += 10240)
            n.push.apply(n, t[0][a].slice(l, l + 10240));
      return n;
    }
    function ef(t, n, a) {
      for (var l = [], d = n; d < a; d += 2)
        l.push(String.fromCharCode(wa(t, d)));
      return l.join("").replace(ge, "");
    }
    function tf(t, n, a) {
      for (var l = [], d = n; d < n + a; ++d)
        l.push(("0" + t[d].toString(16)).slice(-2));
      return l.join("");
    }
    function rf(t, n, a) {
      for (var l = [], d = n; d < a; d++)
        l.push(String.fromCharCode(Mi(t, d)));
      return l.join("");
    }
    function nf(t, n) {
      var a = hn(t, n);
      return 0 < a ? Li(t, n + 4, n + 4 + a - 1) : "";
    }
    function af(t, n) {
      var a = hn(t, n);
      return 0 < a ? Li(t, n + 4, n + 4 + a - 1) : "";
    }
    function of(t, n) {
      var a = 2 * hn(t, n);
      return 0 < a ? Li(t, n + 4, n + 4 + a - 1) : "";
    }
    function sf(t, n) {
      var a = hn(t, n);
      return 0 < a ? fs(t, n + 4, n + 4 + a) : "";
    }
    function lf(t, n) {
      var a = hn(t, n);
      return 0 < a ? Li(t, n + 4, n + 4 + a) : "";
    }
    function cf(t, n) {
      for (var a = 1 - 2 * (t[n + 7] >>> 7), l = ((127 & t[n + 7]) << 4) + (t[n + 6] >>> 4 & 15), d = 15 & t[n + 6], _ = 5; 0 <= _; --_)
        d = 256 * d + t[n + _];
      return l == 2047 ? d == 0 ? 1 / 0 * a : NaN : (l == 0 ? l = -1022 : (l -= 1023, d += Math.pow(2, 52)), a * Math.pow(2, l - 52) * d);
    }
    var df = K ? function(t) {
      return 0 < t[0].length && Buffer.isBuffer(t[0][0]) ? Buffer.concat(t[0].map(function(n) {
        return Buffer.isBuffer(n) ? n : Q(n);
      })) : Jm(t);
    } : Jm, fs = K ? function(t, n, a) {
      return Buffer.isBuffer(t) ? t.toString("utf16le", n, a).replace(ge, "") : ef(t, n, a);
    } : ef, uf = K ? function(t, n, a) {
      return Buffer.isBuffer(t) ? t.toString("hex", n, n + a) : tf(t, n, a);
    } : tf, Li = K ? function(t, n, a) {
      return Buffer.isBuffer(t) ? t.toString("utf8", n, a) : rf(t, n, a);
    } : rf, Gl = nf, Vl = af, Yl = of, Hl = sf, ql = lf, gs = cf, $l = function(t) {
      return Array.isArray(t) || typeof Uint8Array < "u" && t instanceof Uint8Array;
    };
    K && (Gl = function(t, n) {
      if (!Buffer.isBuffer(t))
        return nf(t, n);
      var a = t.readUInt32LE(n);
      return 0 < a ? t.toString("utf8", n + 4, n + 4 + a - 1) : "";
    }, Vl = function(t, n) {
      if (!Buffer.isBuffer(t))
        return af(t, n);
      var a = t.readUInt32LE(n);
      return 0 < a ? t.toString("utf8", n + 4, n + 4 + a - 1) : "";
    }, Yl = function(t, n) {
      if (!Buffer.isBuffer(t))
        return of(t, n);
      var a = 2 * t.readUInt32LE(n);
      return t.toString("utf16le", n + 4, n + 4 + a - 1);
    }, Hl = function(t, n) {
      if (!Buffer.isBuffer(t))
        return sf(t, n);
      var a = t.readUInt32LE(n);
      return t.toString("utf16le", n + 4, n + 4 + a);
    }, ql = function(t, n) {
      if (!Buffer.isBuffer(t))
        return lf(t, n);
      var a = t.readUInt32LE(n);
      return t.toString("utf8", n + 4, n + 4 + a);
    }, gs = function(t, n) {
      return Buffer.isBuffer(t) ? t.readDoubleLE(n) : cf(t, n);
    }, $l = function(t) {
      return Buffer.isBuffer(t) || Array.isArray(t) || typeof Uint8Array < "u" && t instanceof Uint8Array;
    }), e !== void 0 && (fs = function(t, n, a) {
      return e.utils.decode(1200, t.slice(n, a)).replace(ge, "");
    }, Li = function(t, n, a) {
      return e.utils.decode(65001, t.slice(n, a));
    }, Gl = function(t, n) {
      var a = hn(t, n);
      return 0 < a ? e.utils.decode(h, t.slice(n + 4, n + 4 + a - 1)) : "";
    }, Vl = function(t, n) {
      var a = hn(t, n);
      return 0 < a ? e.utils.decode(g, t.slice(n + 4, n + 4 + a - 1)) : "";
    }, Yl = function(t, n) {
      var a = 2 * hn(t, n);
      return 0 < a ? e.utils.decode(1200, t.slice(n + 4, n + 4 + a - 1)) : "";
    }, Hl = function(t, n) {
      var a = hn(t, n);
      return 0 < a ? e.utils.decode(1200, t.slice(n + 4, n + 4 + a)) : "";
    }, ql = function(t, n) {
      var a = hn(t, n);
      return 0 < a ? e.utils.decode(65001, t.slice(n + 4, n + 4 + a)) : "";
    });
    var Mi = function(t, n) {
      return t[n];
    }, wa = function(t, n) {
      return 256 * t[n + 1] + t[n];
    }, jv = function(t, n) {
      return n = 256 * t[n + 1] + t[n], n < 32768 ? n : -1 * (65535 - n + 1);
    }, hn = function(t, n) {
      return t[n + 3] * (1 << 24) + (t[n + 2] << 16) + (t[n + 1] << 8) + t[n];
    }, ii = function(t, n) {
      return t[n + 3] << 24 | t[n + 2] << 16 | t[n + 1] << 8 | t[n];
    }, Jv = function(t, n) {
      return t[n] << 24 | t[n + 1] << 16 | t[n + 2] << 8 | t[n + 3];
    };
    function Eo(t, n) {
      var a, l, d, _, u, p, m = "", f = [];
      switch (n) {
        case "dbcs":
          if (p = this.l, K && Buffer.isBuffer(this))
            m = this.slice(this.l, this.l + 2 * t).toString("utf16le");
          else
            for (u = 0; u < t; ++u)
              m += String.fromCharCode(wa(this, p)), p += 2;
          t *= 2;
          break;
        case "utf8":
          m = Li(this, this.l, this.l + t);
          break;
        case "utf16le":
          t *= 2, m = fs(this, this.l, this.l + t);
          break;
        case "wstr":
          if (e === void 0)
            return Eo.call(this, t, "dbcs");
          m = e.utils.decode(g, this.slice(this.l, this.l + 2 * t)), t *= 2;
          break;
        case "lpstr-ansi":
          m = Gl(this, this.l), t = 4 + hn(this, this.l);
          break;
        case "lpstr-cp":
          m = Vl(this, this.l), t = 4 + hn(this, this.l);
          break;
        case "lpwstr":
          m = Yl(this, this.l), t = 4 + 2 * hn(this, this.l);
          break;
        case "lpp4":
          t = 4 + hn(this, this.l), m = Hl(this, this.l), 2 & t && (t += 2);
          break;
        case "8lpp4":
          t = 4 + hn(this, this.l), m = ql(this, this.l), 3 & t && (t += 4 - (3 & t));
          break;
        case "cstr":
          for (t = 0, m = ""; (d = Mi(this, this.l + t++)) !== 0; )
            f.push(Y(d));
          m = f.join("");
          break;
        case "_wstr":
          for (t = 0, m = ""; (d = wa(this, this.l + t)) !== 0; )
            f.push(Y(d)), t += 2;
          t += 2, m = f.join("");
          break;
        case "dbcs-cont":
          for (m = "", p = this.l, u = 0; u < t; ++u) {
            if (this.lens && this.lens.indexOf(p) !== -1)
              return d = Mi(this, p), this.l = p + 1, _ = Eo.call(this, t - u, d ? "dbcs-cont" : "sbcs-cont"), f.join("") + _;
            f.push(Y(wa(this, p))), p += 2;
          }
          m = f.join(""), t *= 2;
          break;
        case "cpstr":
          if (e !== void 0) {
            m = e.utils.decode(g, this.slice(this.l, this.l + t));
            break;
          }
        case "sbcs-cont":
          for (m = "", p = this.l, u = 0; u != t; ++u) {
            if (this.lens && this.lens.indexOf(p) !== -1)
              return d = Mi(this, p), this.l = p + 1, _ = Eo.call(this, t - u, d ? "dbcs-cont" : "sbcs-cont"), f.join("") + _;
            f.push(Y(Mi(this, p))), p += 1;
          }
          m = f.join("");
          break;
        default:
          switch (t) {
            case 1:
              return a = Mi(this, this.l), this.l++, a;
            case 2:
              return a = (n === "i" ? jv : wa)(this, this.l), this.l += 2, a;
            case 4:
            case -4:
              return n === "i" || !(128 & this[this.l + 3]) ? (a = (0 < t ? ii : Jv)(this, this.l), this.l += 4, a) : (l = hn(this, this.l), this.l += 4, l);
            case 8:
            case -8:
              if (n === "f")
                return l = t == 8 ? gs(this, this.l) : gs([this[this.l + 7], this[this.l + 6], this[this.l + 5], this[this.l + 4], this[this.l + 3], this[this.l + 2], this[this.l + 1], this[this.l + 0]], 0), this.l += 8, l;
              t = 8;
            case 16:
              m = uf(this, this.l, t);
          }
      }
      return this.l += t, m;
    }
    var eC = function(t, n, a) {
      t[a] = 255 & n, t[a + 1] = n >>> 8 & 255, t[a + 2] = n >>> 16 & 255, t[a + 3] = n >>> 24 & 255;
    }, tC = function(t, n, a) {
      t[a] = 255 & n, t[a + 1] = n >> 8 & 255, t[a + 2] = n >> 16 & 255, t[a + 3] = n >> 24 & 255;
    }, rC = function(t, n, a) {
      t[a] = 255 & n, t[a + 1] = n >>> 8 & 255;
    };
    function nC(t, n, a) {
      var l = 0, d = 0;
      if (a === "dbcs") {
        for (d = 0; d != n.length; ++d)
          rC(this, n.charCodeAt(d), this.l + 2 * d);
        l = 2 * n.length;
      } else if (a === "sbcs") {
        if (e !== void 0 && h == 874)
          for (d = 0; d != n.length; ++d) {
            var _ = e.utils.encode(h, n.charAt(d));
            this[this.l + d] = _[0];
          }
        else
          for (n = n.replace(/[^\x00-\x7F]/g, "_"), d = 0; d != n.length; ++d)
            this[this.l + d] = 255 & n.charCodeAt(d);
        l = n.length;
      } else {
        if (a === "hex") {
          for (; d < t; ++d)
            this[this.l++] = parseInt(n.slice(2 * d, 2 * d + 2), 16) || 0;
          return this;
        }
        if (a === "utf16le") {
          for (var u = Math.min(this.l + t, this.length), d = 0; d < Math.min(n.length, t); ++d) {
            var p = n.charCodeAt(d);
            this[this.l++] = 255 & p, this[this.l++] = p >> 8;
          }
          for (; this.l < u; )
            this[this.l++] = 0;
          return this;
        }
        switch (t) {
          case 1:
            l = 1, this[this.l] = 255 & n;
            break;
          case 2:
            l = 2, this[this.l] = 255 & n, n >>>= 8, this[this.l + 1] = 255 & n;
            break;
          case 3:
            l = 3, this[this.l] = 255 & n, n >>>= 8, this[this.l + 1] = 255 & n, n >>>= 8, this[this.l + 2] = 255 & n;
            break;
          case 4:
            l = 4, eC(this, n, this.l);
            break;
          case 8:
            if (l = 8, a === "f") {
              (function(m, f, E) {
                var b = (f < 0 || 1 / f == -1 / 0 ? 1 : 0) << 7, T = 0, v = 0, y = b ? -f : f;
                isFinite(y) ? y == 0 ? T = v = 0 : (T = Math.floor(Math.log(y) / Math.LN2), v = y * Math.pow(2, 52 - T), T <= -1023 && (!isFinite(v) || v < Math.pow(2, 52)) ? T = -1022 : (v -= Math.pow(2, 52), T += 1023)) : (T = 2047, v = isNaN(f) ? 26985 : 0);
                for (var R = 0; R <= 5; ++R, v /= 256)
                  m[E + R] = 255 & v;
                m[E + 6] = (15 & T) << 4 | 15 & v, m[E + 7] = T >> 4 | b;
              })(this, n, this.l);
              break;
            }
          case 16:
            break;
          case -4:
            l = 4, tC(this, n, this.l);
        }
      }
      return this.l += l, this;
    }
    function _f(t, n) {
      var a = uf(this, this.l, t.length >> 1);
      if (a !== t)
        throw new Error(n + "Expected " + t + " saw " + a);
      this.l += t.length >> 1;
    }
    function Nn(t, n) {
      t.l = n, t.read_shift = Eo, t.chk = _f, t.write_shift = nC;
    }
    function In(t, n) {
      t.l += n;
    }
    function Me(t) {
      return t = _e(t), Nn(t, 0), t;
    }
    function xa(t, n, a) {
      if (t) {
        Nn(t, t.l || 0);
        for (var l, d = t.length, _ = 0; t.l < d; ) {
          128 & (_ = t.read_shift(1)) && (_ = (127 & _) + ((127 & t.read_shift(1)) << 7));
          for (var u, p = Bo[_] || Bo[65535], m = 127 & (u = t.read_shift(1)), f = 1; f < 4 && 128 & u; ++f)
            m += (127 & (u = t.read_shift(1))) << 7 * f;
          l = t.l + m;
          var E = p.f && p.f(t, m, a);
          if (t.l = l, n(E, p, _))
            return;
        }
      }
    }
    function Wn() {
      function t(u) {
        return Nn(u = Me(u), 0), u;
      }
      function n() {
        _ && (_.length > _.l && ((_ = _.slice(0, _.l)).l = _.length), 0 < _.length && l.push(_), _ = null);
      }
      function a(u) {
        return _ && u < _.length - _.l ? _ : (n(), _ = t(Math.max(u + 1, d)));
      }
      var l = [], d = K ? 256 : 2048, _ = t(d);
      return { next: a, push: function(u) {
        n(), (_ = u).l == null && (_.l = _.length), a(d);
      }, end: function() {
        return n(), mt(l);
      }, _bufs: l };
    }
    function He(t, n, a, l) {
      var d = +n;
      if (!isNaN(d)) {
        n = 1 + (128 <= d ? 1 : 0) + 1, 128 <= (l = l || Bo[d].p || (a || []).length || 0) && ++n, 16384 <= l && ++n, 2097152 <= l && ++n;
        var _ = t.next(n);
        d <= 127 ? _.write_shift(1, d) : (_.write_shift(1, 128 + (127 & d)), _.write_shift(1, d >> 7));
        for (var u = 0; u != 4; ++u) {
          if (!(128 <= l)) {
            _.write_shift(1, l);
            break;
          }
          _.write_shift(1, 128 + (127 & l)), l >>= 7;
        }
        0 < l && $l(a) && t.push(a);
      }
    }
    function ho(t, n, a) {
      var l = xr(t);
      if (n.s ? (l.cRel && (l.c += n.s.c), l.rRel && (l.r += n.s.r)) : (l.cRel && (l.c += n.c), l.rRel && (l.r += n.r)), !a || a.biff < 12) {
        for (; 256 <= l.c; )
          l.c -= 256;
        for (; 65536 <= l.r; )
          l.r -= 65536;
      }
      return l;
    }
    function pf(t, n, a) {
      return t = xr(t), t.s = ho(t.s, n.s, a), t.e = ho(t.e, n.s, a), t;
    }
    function So(t, n) {
      if (t.cRel && t.c < 0)
        for (t = xr(t); t.c < 0; )
          t.c += 8 < n ? 16384 : 256;
      if (t.rRel && t.r < 0)
        for (t = xr(t); t.r < 0; )
          t.r += 8 < n ? 1048576 : 5 < n ? 65536 : 16384;
      var a = $t(t);
      return t.cRel || t.cRel == null || (a = a.replace(/^([A-Z])/, "$$$1")), a = !t.rRel && t.rRel != null ? a.replace(/([A-Z]|^)(\d+)$/, "$1$$$2") : a;
    }
    function Wl(t, n) {
      return t.s.r != 0 || t.s.rRel || t.e.r != (12 <= n.biff ? 1048575 : 8 <= n.biff ? 65536 : 16384) || t.e.rRel ? t.s.c != 0 || t.s.cRel || t.e.c != (12 <= n.biff ? 16383 : 255) || t.e.cRel ? So(t.s, n.biff) + ":" + So(t.e, n.biff) : (t.s.rRel ? "" : "$") + Xr(t.s.r) + ":" + (t.e.rRel ? "" : "$") + Xr(t.e.r) : (t.s.cRel ? "" : "$") + Vr(t.s.c) + ":" + (t.e.cRel ? "" : "$") + Vr(t.e.c);
    }
    function zl(t) {
      return parseInt(t.replace(/\$(\d+)$/, "$1"), 10) - 1;
    }
    function Xr(t) {
      return "" + (t + 1);
    }
    function Kl(t) {
      for (var n = t.replace(/^\$([A-Z])/, "$1"), a = 0, l = 0; l !== n.length; ++l)
        a = 26 * a + n.charCodeAt(l) - 64;
      return a - 1;
    }
    function Vr(t) {
      if (t < 0)
        throw new Error("invalid column " + t);
      var n = "";
      for (++t; t; t = Math.floor((t - 1) / 26))
        n = String.fromCharCode((t - 1) % 26 + 65) + n;
      return n;
    }
    function zr(t) {
      for (var n = 0, a = 0, l = 0; l < t.length; ++l) {
        var d = t.charCodeAt(l);
        48 <= d && d <= 57 ? n = 10 * n + (d - 48) : 65 <= d && d <= 90 && (a = 26 * a + (d - 64));
      }
      return { c: a - 1, r: n - 1 };
    }
    function $t(t) {
      for (var n = t.c + 1, a = ""; n; n = (n - 1) / 26 | 0)
        a = String.fromCharCode((n - 1) % 26 + 65) + a;
      return a + (t.r + 1);
    }
    function Un(t) {
      var n = t.indexOf(":");
      return n == -1 ? { s: zr(t), e: zr(t) } : { s: zr(t.slice(0, n)), e: zr(t.slice(n + 1)) };
    }
    function Xt(t, n) {
      return n === void 0 || typeof n == "number" ? Xt(t.s, t.e) : (t = typeof t != "string" ? $t(t) : t) == (n = typeof n != "string" ? $t(n) : n) ? t : t + ":" + n;
    }
    function lr(t) {
      for (var n = { s: { c: 0, r: 0 }, e: { c: 0, r: 0 } }, _ = 0, a = 0, l = 0, d = t.length, _ = 0; a < d && !((l = t.charCodeAt(a) - 64) < 1 || 26 < l); ++a)
        _ = 26 * _ + l;
      for (n.s.c = --_, _ = 0; a < d && !((l = t.charCodeAt(a) - 48) < 0 || 9 < l); ++a)
        _ = 10 * _ + l;
      if (n.s.r = --_, a === d || l != 10)
        return n.e.c = n.s.c, n.e.r = n.s.r, n;
      for (++a, _ = 0; a != d && !((l = t.charCodeAt(a) - 64) < 1 || 26 < l); ++a)
        _ = 26 * _ + l;
      for (n.e.c = --_, _ = 0; a != d && !((l = t.charCodeAt(a) - 48) < 0 || 9 < l); ++a)
        _ = 10 * _ + l;
      return n.e.r = --_, n;
    }
    function aC(t, n) {
      var a = t.t == "d" && n instanceof Date;
      if (t.z != null)
        try {
          return t.w = dn(t.z, a ? on(n) : n);
        } catch {
        }
      try {
        return t.w = dn((t.XF || {}).numFmtId || (a ? 14 : 0), a ? on(n) : n);
      } catch {
        return "" + n;
      }
    }
    function Ea(t, n, a) {
      return t == null || t.t == null || t.t == "z" ? "" : t.w !== void 0 ? t.w : (t.t == "d" && !t.z && a && a.dateNF && (t.z = a.dateNF), t.t == "e" ? La[t.v] || t.v : aC(t, n ?? t.v));
    }
    function Ha(t, l) {
      var a = l && l.sheet ? l.sheet : "Sheet1", l = {};
      return l[a] = t, { SheetNames: [a], Sheets: l };
    }
    function mf(t, n, a) {
      var l = a || {}, d = t ? Array.isArray(t) : l.dense, _ = t || (d ? [] : {}), u = 0, p = 0;
      _ && l.origin != null && (typeof l.origin == "number" ? u = l.origin : (u = (m = typeof l.origin == "string" ? zr(l.origin) : l.origin).r, p = m.c), _["!ref"] || (_["!ref"] = "A1:A1"));
      var m, f = { s: { c: 1e7, r: 1e7 }, e: { c: 0, r: 0 } };
      _["!ref"] && (m = lr(_["!ref"]), f.s.c = m.s.c, f.s.r = m.s.r, f.e.c = Math.max(f.e.c, m.e.c), f.e.r = Math.max(f.e.r, m.e.r), u == -1 && (f.e.r = u = m.e.r + 1));
      for (var E = 0; E != n.length; ++E)
        if (n[E]) {
          if (!Array.isArray(n[E]))
            throw new Error("aoa_to_sheet expects an array of arrays");
          for (var b = 0; b != n[E].length; ++b)
            if (n[E][b] !== void 0) {
              var T = { v: n[E][b] }, v = u + E, y = p + b;
              if (f.s.r > v && (f.s.r = v), f.s.c > y && (f.s.c = y), f.e.r < v && (f.e.r = v), f.e.c < y && (f.e.c = y), !n[E][b] || typeof n[E][b] != "object" || Array.isArray(n[E][b]) || n[E][b] instanceof Date)
                if (Array.isArray(T.v) && (T.f = n[E][b][1], T.v = T.v[0]), T.v === null)
                  if (T.f)
                    T.t = "n";
                  else if (l.nullError)
                    T.t = "e", T.v = 0;
                  else {
                    if (!l.sheetStubs)
                      continue;
                    T.t = "z";
                  }
                else
                  typeof T.v == "number" ? T.t = "n" : typeof T.v == "boolean" ? T.t = "b" : T.v instanceof Date ? (T.z = l.dateNF || ae[14], l.cellDates ? (T.t = "d", T.w = dn(T.z, on(T.v))) : (T.t = "n", T.v = on(T.v), T.w = dn(T.z, T.v))) : T.t = "s";
              else
                T = n[E][b];
              d ? (_[v] || (_[v] = []), _[v][y] && _[v][y].z && (T.z = _[v][y].z), _[v][y] = T) : (_[v = $t({ c: y, r: v })] && _[v].z && (T.z = _[v].z), _[v] = T);
            }
        }
      return f.s.c < 1e7 && (_["!ref"] = Xt(f)), _;
    }
    function Pi(t, n) {
      return mf(null, t, n);
    }
    function ma(t, n) {
      return (n = n || Me(4)).write_shift(4, t), n;
    }
    function Dn(t) {
      var n = t.read_shift(4);
      return n === 0 ? "" : t.read_shift(n, "dbcs");
    }
    function Sn(t, n) {
      var a = !1;
      return n == null && (a = !0, n = Me(4 + 2 * t.length)), n.write_shift(4, t.length), 0 < t.length && n.write_shift(0, t, "dbcs"), a ? n.slice(0, n.l) : n;
    }
    function Ql(t, n) {
      var a, l = t.l, d = t.read_shift(1), u = Dn(t), _ = [], u = { t: u, h: u };
      if (1 & d) {
        for (var p = t.read_shift(4), m = 0; m != p; ++m)
          _.push({ ich: (a = t).read_shift(2), ifnt: a.read_shift(2) });
        u.r = _;
      } else
        u.r = [{ ich: 0, ifnt: 0 }];
      return t.l = l + n, u;
    }
    var iC = Ql;
    function oC(t, n) {
      var a, l = !1;
      return n == null && (l = !0, n = Me(23 + 4 * t.t.length)), n.write_shift(1, 1), Sn(t.t, n), n.write_shift(4, 1), a = { ich: 0, ifnt: 0 }, (t = (t = n) || Me(4)).write_shift(2, a.ich || 0), t.write_shift(2, a.ifnt || 0), l ? n.slice(0, n.l) : n;
    }
    function aa(t) {
      var n = t.read_shift(4), a = t.read_shift(2);
      return a += t.read_shift(1) << 16, t.l++, { c: n, iStyleRef: a };
    }
    function oi(t, n) {
      return (n = n ?? Me(8)).write_shift(-4, t.c), n.write_shift(3, t.iStyleRef || t.s), n.write_shift(1, 0), n;
    }
    function si(t) {
      var n = t.read_shift(2);
      return n += t.read_shift(1) << 16, t.l++, { c: -1, iStyleRef: n };
    }
    function li(t, n) {
      return (n = n ?? Me(4)).write_shift(3, t.iStyleRef || t.s), n.write_shift(1, 0), n;
    }
    var sC = Dn, ff = Sn;
    function Xl(t) {
      var n = t.read_shift(4);
      return n === 0 || n === 4294967295 ? "" : t.read_shift(n, "dbcs");
    }
    function Es(t, n) {
      var a = !1;
      return n == null && (a = !0, n = Me(127)), n.write_shift(4, 0 < t.length ? t.length : 4294967295), 0 < t.length && n.write_shift(0, t, "dbcs"), a ? n.slice(0, n.l) : n;
    }
    var lC = Dn, Zl = Xl, jl = Es;
    function Jl(t) {
      var n = t.slice(t.l, t.l + 4), a = 1 & n[0], l = 2 & n[0];
      return t.l += 4, n = l == 0 ? gs([0, 0, 0, 0, 252 & n[0], n[1], n[2], n[3]], 0) : ii(n, 0) >> 2, a ? n / 100 : n;
    }
    function gf(t, n) {
      n == null && (n = Me(4));
      var a = 0, l = 0, d = 100 * t;
      if (t == (0 | t) && -(1 << 29) <= t && t < 1 << 29 ? l = 1 : d == (0 | d) && -(1 << 29) <= d && d < 1 << 29 && (a = l = 1), !l)
        throw new Error("unsupported RkNumber " + t);
      n.write_shift(-4, ((a ? d : t) << 2) + (a + 2));
    }
    function Ef(t) {
      var n = { s: {}, e: {} };
      return n.s.r = t.read_shift(4), n.e.r = t.read_shift(4), n.s.c = t.read_shift(4), n.e.c = t.read_shift(4), n;
    }
    var ci = Ef, ki = function(t, n) {
      return (n = n || Me(16)).write_shift(4, t.s.r), n.write_shift(4, t.e.r), n.write_shift(4, t.s.c), n.write_shift(4, t.e.c), n;
    };
    function wn(t) {
      if (t.length - t.l < 8)
        throw "XLS Xnum Buffer underflow";
      return t.read_shift(8, "f");
    }
    function Fi(t, n) {
      return (n || Me(8)).write_shift(8, t, "f");
    }
    function hs(t, n) {
      if (n = n || Me(8), !t || t.auto)
        return n.write_shift(4, 0), n.write_shift(4, 0), n;
      t.index != null ? (n.write_shift(1, 2), n.write_shift(1, t.index)) : t.theme != null ? (n.write_shift(1, 6), n.write_shift(1, t.theme)) : (n.write_shift(1, 5), n.write_shift(1, 0));
      var a = t.tint || 0;
      return 0 < a ? a *= 32767 : a < 0 && (a *= 32768), n.write_shift(2, a), t.rgb && t.theme == null ? (typeof (t = t.rgb || "FFFFFF") == "number" && (t = ("000000" + t.toString(16)).slice(-6)), n.write_shift(1, parseInt(t.slice(0, 2), 16)), n.write_shift(1, parseInt(t.slice(2, 4), 16)), n.write_shift(1, parseInt(t.slice(4, 6), 16)), n.write_shift(1, 255)) : (n.write_shift(2, 0), n.write_shift(1, 0), n.write_shift(1, 0)), n;
    }
    function hf(t, n) {
      var a = t.read_shift(4);
      switch (a) {
        case 0:
          return "";
        case 4294967295:
        case 4294967294:
          return { 2: "BITMAP", 3: "METAFILEPICT", 8: "DIB", 14: "ENHMETAFILE" }[t.read_shift(4)] || "";
      }
      if (400 < a)
        throw new Error("Unsupported Clipboard: " + a.toString(16));
      return t.l -= 4, t.read_shift(0, n == 1 ? "lpstr" : "lpwstr");
    }
    var ec = 2, zn = 3, Sf = 12, bf = 81, cC = [80, bf], tc = { 1: { n: "CodePage", t: ec }, 2: { n: "Category", t: 80 }, 3: { n: "PresentationFormat", t: 80 }, 4: { n: "ByteCount", t: zn }, 5: { n: "LineCount", t: zn }, 6: { n: "ParagraphCount", t: zn }, 7: { n: "SlideCount", t: zn }, 8: { n: "NoteCount", t: zn }, 9: { n: "HiddenCount", t: zn }, 10: { n: "MultimediaClipCount", t: zn }, 11: { n: "ScaleCrop", t: 11 }, 12: { n: "HeadingPairs", t: 4108 }, 13: { n: "TitlesOfParts", t: 4126 }, 14: { n: "Manager", t: 80 }, 15: { n: "Company", t: 80 }, 16: { n: "LinksUpToDate", t: 11 }, 17: { n: "CharacterCount", t: zn }, 19: { n: "SharedDoc", t: 11 }, 22: { n: "HyperlinksChanged", t: 11 }, 23: { n: "AppVersion", t: zn, p: "version" }, 24: { n: "DigSig", t: 65 }, 26: { n: "ContentType", t: 80 }, 27: { n: "ContentStatus", t: 80 }, 28: { n: "Language", t: 80 }, 29: { n: "Version", t: 80 }, 255: {}, 2147483648: { n: "Locale", t: 19 }, 2147483651: { n: "Behavior", t: 19 }, 1919054434: {} }, rc = { 1: { n: "CodePage", t: ec }, 2: { n: "Title", t: 80 }, 3: { n: "Subject", t: 80 }, 4: { n: "Author", t: 80 }, 5: { n: "Keywords", t: 80 }, 6: { n: "Comments", t: 80 }, 7: { n: "Template", t: 80 }, 8: { n: "LastAuthor", t: 80 }, 9: { n: "RevNumber", t: 80 }, 10: { n: "EditTime", t: 64 }, 11: { n: "LastPrinted", t: 64 }, 12: { n: "CreatedDate", t: 64 }, 13: { n: "ModifiedDate", t: 64 }, 14: { n: "PageCount", t: zn }, 15: { n: "WordCount", t: zn }, 16: { n: "CharCount", t: zn }, 17: { n: "Thumbnail", t: 71 }, 18: { n: "Application", t: 80 }, 19: { n: "DocSecurity", t: zn }, 255: {}, 2147483648: { n: "Locale", t: 19 }, 2147483651: { n: "Behavior", t: 19 }, 1919054434: {} }, Tf = { 1: "US", 2: "CA", 3: "", 7: "RU", 20: "EG", 30: "GR", 31: "NL", 32: "BE", 33: "FR", 34: "ES", 36: "HU", 39: "IT", 41: "CH", 43: "AT", 44: "GB", 45: "DK", 46: "SE", 47: "NO", 48: "PL", 49: "DE", 52: "MX", 55: "BR", 61: "AU", 64: "NZ", 66: "TH", 81: "JP", 82: "KR", 84: "VN", 86: "CN", 90: "TR", 105: "JS", 213: "DZ", 216: "MA", 218: "LY", 351: "PT", 354: "IS", 358: "FI", 420: "CZ", 886: "TW", 961: "LB", 962: "JO", 963: "SY", 964: "IQ", 965: "KW", 966: "SA", 971: "AE", 972: "IL", 974: "QA", 981: "IR", 65535: "US" }, dC = [null, "solid", "mediumGray", "darkGray", "lightGray", "darkHorizontal", "darkVertical", "darkDown", "darkUp", "darkGrid", "darkTrellis", "lightHorizontal", "lightVertical", "lightDown", "lightUp", "lightGrid", "lightTrellis", "gray125", "gray0625"], bo = xr([0, 16777215, 16711680, 65280, 255, 16776960, 16711935, 65535, 0, 16777215, 16711680, 65280, 255, 16776960, 16711935, 65535, 8388608, 32768, 128, 8421376, 8388736, 32896, 12632256, 8421504, 10066431, 10040166, 16777164, 13434879, 6684774, 16744576, 26316, 13421823, 128, 16711935, 16776960, 65535, 8388736, 8388608, 32896, 255, 52479, 13434879, 13434828, 16777113, 10079487, 16751052, 13408767, 16764057, 3368703, 3394764, 10079232, 16763904, 16750848, 16737792, 6710937, 9868950, 13158, 3381606, 13056, 3355392, 10040064, 10040166, 3355545, 3355443, 16777215, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0].map(function(t) {
      return [t >> 16 & 255, t >> 8 & 255, 255 & t];
    })), La = { 0: "#NULL!", 7: "#DIV/0!", 15: "#VALUE!", 23: "#REF!", 29: "#NAME?", 36: "#NUM!", 42: "#N/A", 43: "#GETTING_DATA", 255: "#WTF?" }, vf = { "#NULL!": 0, "#DIV/0!": 7, "#VALUE!": 15, "#REF!": 23, "#NAME?": 29, "#NUM!": 36, "#N/A": 42, "#GETTING_DATA": 43, "#WTF?": 255 }, nc = { "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml": "workbooks", "application/vnd.ms-excel.sheet.macroEnabled.main+xml": "workbooks", "application/vnd.ms-excel.sheet.binary.macroEnabled.main": "workbooks", "application/vnd.ms-excel.addin.macroEnabled.main+xml": "workbooks", "application/vnd.openxmlformats-officedocument.spreadsheetml.template.main+xml": "workbooks", "application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml": "sheets", "application/vnd.ms-excel.worksheet": "sheets", "application/vnd.ms-excel.binIndexWs": "TODO", "application/vnd.openxmlformats-officedocument.spreadsheetml.chartsheet+xml": "charts", "application/vnd.ms-excel.chartsheet": "charts", "application/vnd.ms-excel.macrosheet+xml": "macros", "application/vnd.ms-excel.macrosheet": "macros", "application/vnd.ms-excel.intlmacrosheet": "TODO", "application/vnd.ms-excel.binIndexMs": "TODO", "application/vnd.openxmlformats-officedocument.spreadsheetml.dialogsheet+xml": "dialogs", "application/vnd.ms-excel.dialogsheet": "dialogs", "application/vnd.openxmlformats-officedocument.spreadsheetml.sharedStrings+xml": "strs", "application/vnd.ms-excel.sharedStrings": "strs", "application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml": "styles", "application/vnd.ms-excel.styles": "styles", "application/vnd.openxmlformats-package.core-properties+xml": "coreprops", "application/vnd.openxmlformats-officedocument.custom-properties+xml": "custprops", "application/vnd.openxmlformats-officedocument.extended-properties+xml": "extprops", "application/vnd.openxmlformats-officedocument.customXmlProperties+xml": "TODO", "application/vnd.openxmlformats-officedocument.spreadsheetml.customProperty": "TODO", "application/vnd.openxmlformats-officedocument.spreadsheetml.comments+xml": "comments", "application/vnd.ms-excel.comments": "comments", "application/vnd.ms-excel.threadedcomments+xml": "threadedcomments", "application/vnd.ms-excel.person+xml": "people", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheetMetadata+xml": "metadata", "application/vnd.ms-excel.sheetMetadata": "metadata", "application/vnd.ms-excel.pivotTable": "TODO", "application/vnd.openxmlformats-officedocument.spreadsheetml.pivotTable+xml": "TODO", "application/vnd.openxmlformats-officedocument.drawingml.chart+xml": "TODO", "application/vnd.ms-office.chartcolorstyle+xml": "TODO", "application/vnd.ms-office.chartstyle+xml": "TODO", "application/vnd.ms-office.chartex+xml": "TODO", "application/vnd.ms-excel.calcChain": "calcchains", "application/vnd.openxmlformats-officedocument.spreadsheetml.calcChain+xml": "calcchains", "application/vnd.openxmlformats-officedocument.spreadsheetml.printerSettings": "TODO", "application/vnd.ms-office.activeX": "TODO", "application/vnd.ms-office.activeX+xml": "TODO", "application/vnd.ms-excel.attachedToolbars": "TODO", "application/vnd.ms-excel.connections": "TODO", "application/vnd.openxmlformats-officedocument.spreadsheetml.connections+xml": "TODO", "application/vnd.ms-excel.externalLink": "links", "application/vnd.openxmlformats-officedocument.spreadsheetml.externalLink+xml": "links", "application/vnd.ms-excel.pivotCacheDefinition": "TODO", "application/vnd.ms-excel.pivotCacheRecords": "TODO", "application/vnd.openxmlformats-officedocument.spreadsheetml.pivotCacheDefinition+xml": "TODO", "application/vnd.openxmlformats-officedocument.spreadsheetml.pivotCacheRecords+xml": "TODO", "application/vnd.ms-excel.queryTable": "TODO", "application/vnd.openxmlformats-officedocument.spreadsheetml.queryTable+xml": "TODO", "application/vnd.ms-excel.userNames": "TODO", "application/vnd.ms-excel.revisionHeaders": "TODO", "application/vnd.ms-excel.revisionLog": "TODO", "application/vnd.openxmlformats-officedocument.spreadsheetml.revisionHeaders+xml": "TODO", "application/vnd.openxmlformats-officedocument.spreadsheetml.revisionLog+xml": "TODO", "application/vnd.openxmlformats-officedocument.spreadsheetml.userNames+xml": "TODO", "application/vnd.ms-excel.tableSingleCells": "TODO", "application/vnd.openxmlformats-officedocument.spreadsheetml.tableSingleCells+xml": "TODO", "application/vnd.ms-excel.slicer": "TODO", "application/vnd.ms-excel.slicerCache": "TODO", "application/vnd.ms-excel.slicer+xml": "TODO", "application/vnd.ms-excel.slicerCache+xml": "TODO", "application/vnd.ms-excel.wsSortMap": "TODO", "application/vnd.ms-excel.table": "TODO", "application/vnd.openxmlformats-officedocument.spreadsheetml.table+xml": "TODO", "application/vnd.openxmlformats-officedocument.theme+xml": "themes", "application/vnd.openxmlformats-officedocument.themeOverride+xml": "TODO", "application/vnd.ms-excel.Timeline+xml": "TODO", "application/vnd.ms-excel.TimelineCache+xml": "TODO", "application/vnd.ms-office.vbaProject": "vba", "application/vnd.ms-office.vbaProjectSignature": "TODO", "application/vnd.ms-office.volatileDependencies": "TODO", "application/vnd.openxmlformats-officedocument.spreadsheetml.volatileDependencies+xml": "TODO", "application/vnd.ms-excel.controlproperties+xml": "TODO", "application/vnd.openxmlformats-officedocument.model+data": "TODO", "application/vnd.ms-excel.Survey+xml": "TODO", "application/vnd.openxmlformats-officedocument.drawing+xml": "drawings", "application/vnd.openxmlformats-officedocument.drawingml.chartshapes+xml": "TODO", "application/vnd.openxmlformats-officedocument.drawingml.diagramColors+xml": "TODO", "application/vnd.openxmlformats-officedocument.drawingml.diagramData+xml": "TODO", "application/vnd.openxmlformats-officedocument.drawingml.diagramLayout+xml": "TODO", "application/vnd.openxmlformats-officedocument.drawingml.diagramStyle+xml": "TODO", "application/vnd.openxmlformats-officedocument.vmlDrawing": "TODO", "application/vnd.openxmlformats-package.relationships+xml": "rels", "application/vnd.openxmlformats-officedocument.oleObject": "TODO", "image/png": "TODO", sheet: "js" }, Ss = { workbooks: { xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml", xlsm: "application/vnd.ms-excel.sheet.macroEnabled.main+xml", xlsb: "application/vnd.ms-excel.sheet.binary.macroEnabled.main", xlam: "application/vnd.ms-excel.addin.macroEnabled.main+xml", xltx: "application/vnd.openxmlformats-officedocument.spreadsheetml.template.main+xml" }, strs: { xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sharedStrings+xml", xlsb: "application/vnd.ms-excel.sharedStrings" }, comments: { xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.comments+xml", xlsb: "application/vnd.ms-excel.comments" }, sheets: { xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml", xlsb: "application/vnd.ms-excel.worksheet" }, charts: { xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.chartsheet+xml", xlsb: "application/vnd.ms-excel.chartsheet" }, dialogs: { xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.dialogsheet+xml", xlsb: "application/vnd.ms-excel.dialogsheet" }, macros: { xlsx: "application/vnd.ms-excel.macrosheet+xml", xlsb: "application/vnd.ms-excel.macrosheet" }, metadata: { xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheetMetadata+xml", xlsb: "application/vnd.ms-excel.sheetMetadata" }, styles: { xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml", xlsb: "application/vnd.ms-excel.styles" } };
    function ac() {
      return { workbooks: [], sheets: [], charts: [], dialogs: [], macros: [], rels: [], strs: [], comments: [], threadedcomments: [], links: [], coreprops: [], extprops: [], custprops: [], themes: [], styles: [], calcchains: [], vba: [], drawings: [], metadata: [], people: [], TODO: [], xmlns: "" };
    }
    function Cf(t, n) {
      var a, l = function(m) {
        for (var f = [], E = $r(m), b = 0; b !== E.length; ++b)
          f[m[E[b]]] == null && (f[m[E[b]]] = []), f[m[E[b]]].push(E[b]);
        return f;
      }(nc), d = [];
      d[d.length] = Qr, d[d.length] = it("Types", null, { xmlns: un.CT, "xmlns:xsd": un.xsd, "xmlns:xsi": un.xsi }), d = d.concat([["xml", "application/xml"], ["bin", "application/vnd.ms-excel.sheet.binary.macroEnabled.main"], ["vml", "application/vnd.openxmlformats-officedocument.vmlDrawing"], ["data", "application/vnd.openxmlformats-officedocument.model+data"], ["bmp", "image/bmp"], ["png", "image/png"], ["gif", "image/gif"], ["emf", "image/x-emf"], ["wmf", "image/x-wmf"], ["jpg", "image/jpeg"], ["jpeg", "image/jpeg"], ["tif", "image/tiff"], ["tiff", "image/tiff"], ["pdf", "application/pdf"], ["rels", "application/vnd.openxmlformats-package.relationships+xml"]].map(function(m) {
        return it("Default", null, { Extension: m[0], ContentType: m[1] });
      }));
      function _(m) {
        t[m] && 0 < t[m].length && (a = t[m][0], d[d.length] = it("Override", null, { PartName: (a[0] == "/" ? "" : "/") + a, ContentType: Ss[m][n.bookType] || Ss[m].xlsx }));
      }
      function u(m) {
        (t[m] || []).forEach(function(f) {
          d[d.length] = it("Override", null, { PartName: (f[0] == "/" ? "" : "/") + f, ContentType: Ss[m][n.bookType] || Ss[m].xlsx });
        });
      }
      function p(m) {
        (t[m] || []).forEach(function(f) {
          d[d.length] = it("Override", null, { PartName: (f[0] == "/" ? "" : "/") + f, ContentType: l[m][0] });
        });
      }
      return _("workbooks"), u("sheets"), u("charts"), p("themes"), ["strs", "styles"].forEach(_), ["coreprops", "extprops", "custprops"].forEach(p), p("vba"), p("comments"), p("threadedcomments"), p("drawings"), u("metadata"), p("people"), 2 < d.length && (d[d.length] = "</Types>", d[1] = d[1].replace("/>", ">")), d.join("");
    }
    var Jt = { WB: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/officeDocument", SHEET: "http://sheetjs.openxmlformats.org/officeDocument/2006/relationships/officeDocument", HLINK: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/hyperlink", VML: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/vmlDrawing", XPATH: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/externalLinkPath", XMISS: "http://schemas.microsoft.com/office/2006/relationships/xlExternalLinkPath/xlPathMissing", XLINK: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/externalLink", CXML: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/customXml", CXMLP: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/customXmlProps", CMNT: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/comments", CORE_PROPS: "http://schemas.openxmlformats.org/package/2006/relationships/metadata/core-properties", EXT_PROPS: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/extended-properties", CUST_PROPS: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/custom-properties", SST: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/sharedStrings", STY: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/styles", THEME: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/theme", CHART: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/chart", CHARTEX: "http://schemas.microsoft.com/office/2014/relationships/chartEx", CS: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/chartsheet", WS: ["http://schemas.openxmlformats.org/officeDocument/2006/relationships/worksheet", "http://purl.oclc.org/ooxml/officeDocument/relationships/worksheet"], DS: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/dialogsheet", MS: "http://schemas.microsoft.com/office/2006/relationships/xlMacrosheet", IMG: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/image", DRAW: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/drawing", XLMETA: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/sheetMetadata", TCMNT: "http://schemas.microsoft.com/office/2017/10/relationships/threadedComment", PEOPLE: "http://schemas.microsoft.com/office/2017/10/relationships/person", VBA: "http://schemas.microsoft.com/office/2006/relationships/vbaProject" };
    function To(t) {
      var n = t.lastIndexOf("/");
      return t.slice(0, n + 1) + "_rels/" + t.slice(n + 1) + ".rels";
    }
    function vo(t, n) {
      var a = { "!id": {} };
      if (!t)
        return a;
      n.charAt(0) !== "/" && (n = "/" + n);
      var l = {};
      return (t.match(Cn) || []).forEach(function(d) {
        var _, u = Ht(d);
        u[0] === "<Relationship" && ((_ = {}).Type = u.Type, _.Target = u.Target, _.Id = u.Id, u.TargetMode && (_.TargetMode = u.TargetMode), d = u.TargetMode === "External" ? u.Target : wi(u.Target, n), a[d] = _, l[u.Id] = _);
      }), a["!id"] = l, a;
    }
    function Ui(t) {
      var n = [Qr, it("Relationships", null, { xmlns: un.RELS })];
      return $r(t["!id"]).forEach(function(a) {
        n[n.length] = it("Relationship", null, t["!id"][a]);
      }), 2 < n.length && (n[n.length] = "</Relationships>", n[1] = n[1].replace("/>", ">")), n.join("");
    }
    function Ir(t, n, a, l, d, _) {
      if (d = d || {}, t["!id"] || (t["!id"] = {}), t["!idx"] || (t["!idx"] = 1), n < 0)
        for (n = t["!idx"]; t["!id"]["rId" + n]; ++n)
          ;
      if (t["!idx"] = n + 1, d.Id = "rId" + n, d.Type = l, d.Target = a, _ ? d.TargetMode = _ : -1 < [Jt.HLINK, Jt.XPATH, Jt.XMISS].indexOf(d.Type) && (d.TargetMode = "External"), t["!id"][d.Id])
        throw new Error("Cannot rewrite rId " + n);
      return t["!id"][d.Id] = d, t[("/" + d.Target).replace("//", "/")] = d, n;
    }
    var uC = "application/vnd.oasis.opendocument.spreadsheet";
    function Rf(t, n, a) {
      return ['  <rdf:Description rdf:about="' + t + `">
`, '    <rdf:type rdf:resource="http://docs.oasis-open.org/ns/office/1.2/meta/' + (a || "odf") + "#" + n + `"/>
`, `  </rdf:Description>
`].join("");
    }
    function Nf() {
      return '<office:document-meta xmlns:office="urn:oasis:names:tc:opendocument:xmlns:office:1.0" xmlns:meta="urn:oasis:names:tc:opendocument:xmlns:meta:1.0" xmlns:dc="http://purl.org/dc/elements/1.1/" xmlns:xlink="http://www.w3.org/1999/xlink" office:version="1.2"><office:meta><meta:generator>SheetJS ' + r.version + "</meta:generator></office:meta></office:document-meta>";
    }
    var ia = [["cp:category", "Category"], ["cp:contentStatus", "ContentStatus"], ["cp:keywords", "Keywords"], ["cp:lastModifiedBy", "LastAuthor"], ["cp:lastPrinted", "LastPrinted"], ["cp:revision", "RevNumber"], ["cp:version", "Version"], ["dc:creator", "Author"], ["dc:description", "Comments"], ["dc:identifier", "Identifier"], ["dc:language", "Language"], ["dc:subject", "Subject"], ["dc:title", "Title"], ["dcterms:created", "CreatedDate", "date"], ["dcterms:modified", "ModifiedDate", "date"]], _C = function() {
      for (var t = new Array(ia.length), n = 0; n < ia.length; ++n) {
        var a = ia[n], a = "(?:" + a[0].slice(0, a[0].indexOf(":")) + ":)" + a[0].slice(a[0].indexOf(":") + 1);
        t[n] = new RegExp("<" + a + "[^>]*>([\\s\\S]*?)</" + a + ">");
      }
      return t;
    }();
    function Af(t) {
      var n = {};
      t = Cr(t);
      for (var a = 0; a < ia.length; ++a) {
        var l = ia[a], d = t.match(_C[a]);
        d != null && 0 < d.length && (n[l[1]] = mr(d[1])), l[2] === "date" && n[l[1]] && (n[l[1]] = Br(n[l[1]]));
      }
      return n;
    }
    function ic(t, n, a, l, d) {
      d[t] == null && n != null && n !== "" && (n = Ar(d[t] = n), l[l.length] = a ? it(t, n, a) : Rn(t, n));
    }
    function Of(t, n) {
      var a = n || {}, l = [Qr, it("cp:coreProperties", null, { "xmlns:cp": un.CORE_PROPS, "xmlns:dc": un.dc, "xmlns:dcterms": un.dcterms, "xmlns:dcmitype": un.dcmitype, "xmlns:xsi": un.xsi })], d = {};
      if (!t && !a.Props)
        return l.join("");
      t && (t.CreatedDate != null && ic("dcterms:created", typeof t.CreatedDate == "string" ? t.CreatedDate : Ul(t.CreatedDate, a.WTF), { "xsi:type": "dcterms:W3CDTF" }, l, d), t.ModifiedDate != null && ic("dcterms:modified", typeof t.ModifiedDate == "string" ? t.ModifiedDate : Ul(t.ModifiedDate, a.WTF), { "xsi:type": "dcterms:W3CDTF" }, l, d));
      for (var _ = 0; _ != ia.length; ++_) {
        var u = ia[_], p = a.Props && a.Props[u[1]] != null ? a.Props[u[1]] : t ? t[u[1]] : null;
        p === !0 ? p = "1" : p === !1 ? p = "0" : typeof p == "number" && (p = String(p)), p != null && ic(u[0], p, null, l, d);
      }
      return 2 < l.length && (l[l.length] = "</cp:coreProperties>", l[1] = l[1].replace("/>", ">")), l.join("");
    }
    var di = [["Application", "Application", "string"], ["AppVersion", "AppVersion", "string"], ["Company", "Company", "string"], ["DocSecurity", "DocSecurity", "string"], ["Manager", "Manager", "string"], ["HyperlinksChanged", "HyperlinksChanged", "bool"], ["SharedDoc", "SharedDoc", "bool"], ["LinksUpToDate", "LinksUpToDate", "bool"], ["ScaleCrop", "ScaleCrop", "bool"], ["HeadingPairs", "HeadingPairs", "raw"], ["TitlesOfParts", "TitlesOfParts", "raw"]], yf = ["Worksheets", "SheetNames", "NamedRanges", "DefinedNames", "Chartsheets", "ChartNames"];
    function If(t, n, a, l) {
      var d = [];
      if (typeof t == "string")
        d = Zm(t, l);
      else
        for (var _ = 0; _ < t.length; ++_)
          d = d.concat(t[_].map(function(E) {
            return { v: E };
          }));
      var u, p = typeof n == "string" ? Zm(n, l).map(function(E) {
        return E.v;
      }) : n, m = 0;
      if (0 < p.length)
        for (var f = 0; f !== d.length; f += 2) {
          switch (u = +d[f + 1].v, d[f].v) {
            case "Worksheets":
            case "工作表":
            case "Листы":
            case "أوراق العمل":
            case "ワークシート":
            case "גליונות עבודה":
            case "Arbeitsblätter":
            case "Çalışma Sayfaları":
            case "Feuilles de calcul":
            case "Fogli di lavoro":
            case "Folhas de cálculo":
            case "Planilhas":
            case "Regneark":
            case "Hojas de cálculo":
            case "Werkbladen":
              a.Worksheets = u, a.SheetNames = p.slice(m, m + u);
              break;
            case "Named Ranges":
            case "Rangos con nombre":
            case "名前付き一覧":
            case "Benannte Bereiche":
            case "Navngivne områder":
              a.NamedRanges = u, a.DefinedNames = p.slice(m, m + u);
              break;
            case "Charts":
            case "Diagramme":
              a.Chartsheets = u, a.ChartNames = p.slice(m, m + u);
          }
          m += u;
        }
    }
    function Df(t) {
      var n = [], a = it;
      return (t = t || {}).Application = "SheetJS", n[n.length] = Qr, n[n.length] = it("Properties", null, { xmlns: un.EXT_PROPS, "xmlns:vt": un.vt }), di.forEach(function(l) {
        if (t[l[1]] !== void 0) {
          var d;
          switch (l[2]) {
            case "string":
              d = Ar(String(t[l[1]]));
              break;
            case "bool":
              d = t[l[1]] ? "true" : "false";
          }
          d !== void 0 && (n[n.length] = a(l[0], d));
        }
      }), n[n.length] = a("HeadingPairs", a("vt:vector", a("vt:variant", "<vt:lpstr>Worksheets</vt:lpstr>") + a("vt:variant", a("vt:i4", String(t.Worksheets))), { size: 2, baseType: "variant" })), n[n.length] = a("TitlesOfParts", a("vt:vector", t.SheetNames.map(function(l) {
        return "<vt:lpstr>" + Ar(l) + "</vt:lpstr>";
      }).join(""), { size: t.Worksheets, baseType: "lpstr" })), 2 < n.length && (n[n.length] = "</Properties>", n[1] = n[1].replace("/>", ">")), n.join("");
    }
    var pC = /<[^>]+>[^<]*/g;
    function wf(t) {
      var n = [Qr, it("Properties", null, { xmlns: un.CUST_PROPS, "xmlns:vt": un.vt })];
      if (!t)
        return n.join("");
      var a = 1;
      return $r(t).forEach(function(l) {
        ++a, n[n.length] = it("property", function(d, _) {
          switch (typeof d) {
            case "string":
              var u = it("vt:lpwstr", Ar(d));
              return u = _ ? u.replace(/&quot;/g, "_x0022_") : u;
            case "number":
              return it((0 | d) == d ? "vt:i4" : "vt:r8", Ar(String(d)));
            case "boolean":
              return it("vt:bool", d ? "true" : "false");
          }
          if (d instanceof Date)
            return it("vt:filetime", Ul(d));
          throw new Error("Unable to serialize " + d);
        }(t[l], !0), { fmtid: "{D5CDD505-2E9C-101B-9397-08002B2CF9AE}", pid: a, name: Ar(l) });
      }), 2 < n.length && (n[n.length] = "</Properties>", n[1] = n[1].replace("/>", ">")), n.join("");
    }
    var xf, oc = { Title: "Title", Subject: "Subject", Author: "Author", Keywords: "Keywords", Comments: "Description", LastAuthor: "LastAuthor", RevNumber: "Revision", Application: "AppName", LastPrinted: "LastPrinted", CreatedDate: "Created", ModifiedDate: "LastSaved", Category: "Category", Manager: "Manager", Company: "Company", AppVersion: "Version", ContentStatus: "ContentStatus", Identifier: "Identifier", Language: "Language" };
    function sc(a) {
      var n = a.read_shift(4), a = a.read_shift(4);
      return new Date(1e3 * (a / 1e7 * Math.pow(2, 32) + n / 1e7 - 11644473600)).toISOString().replace(/\.000/, "");
    }
    function Lf(t, n, a) {
      var l = t.l, d = t.read_shift(0, "lpstr-cp");
      if (a)
        for (; t.l - l & 3; )
          ++t.l;
      return d;
    }
    function Mf(t, n, a) {
      var l = t.read_shift(0, "lpwstr");
      return a && (t.l += 4 - (l.length + 1 & 3) & 3), l;
    }
    function Pf(t, n, a) {
      return n === 31 ? Mf(t) : Lf(t, 0, a);
    }
    function kf(t, n, a) {
      return Pf(t, n, a === !1 ? 0 : 4);
    }
    function mC(t) {
      for (var n, a, l, d = t.read_shift(4), _ = [], u = 0; u < d / 2; ++u)
        _.push((l = a = void 0, a = (n = t).l, l = bs(n, bf), n[n.l] == 0 && n[n.l + 1] == 0 && n.l - a & 2 && (n.l += 2), [l, bs(n, zn)]));
      return _;
    }
    function Ff(t, n) {
      for (var a = t.read_shift(4), l = {}, d = 0; d != a; ++d) {
        var _ = t.read_shift(4), u = t.read_shift(4);
        l[_] = t.read_shift(u, n === 1200 ? "utf16le" : "utf8").replace(ge, "").replace(w, "!"), n === 1200 && u % 2 && (t.l += 2);
      }
      return 3 & t.l && (t.l = t.l >> 3 << 2), l;
    }
    function Uf(t) {
      var n = t.read_shift(4), a = t.slice(t.l, t.l + n);
      return t.l += n, 0 < (3 & n) && (t.l += 4 - (3 & n) & 3), a;
    }
    function bs(t, n, a) {
      var l, d, _ = t.read_shift(2), u = a || {};
      if (t.l += 2, n !== Sf && _ !== n && cC.indexOf(n) === -1 && ((65534 & n) != 4126 || (65534 & _) != 4126))
        throw new Error("Expected type " + n + " saw " + _);
      switch (n === Sf ? _ : n) {
        case 2:
          return l = t.read_shift(2, "i"), u.raw || (t.l += 2), l;
        case 3:
          return l = t.read_shift(4, "i");
        case 11:
          return t.read_shift(4) !== 0;
        case 19:
          return l = t.read_shift(4);
        case 30:
          return Lf(t, 0, 4).replace(ge, "");
        case 31:
          return Mf(t);
        case 64:
          return sc(t);
        case 65:
          return Uf(t);
        case 71:
          return (d = {}).Size = (l = t).read_shift(4), l.l += d.Size + 3 - (d.Size - 1) % 4, d;
        case 80:
          return kf(t, _, !u.raw).replace(ge, "");
        case 81:
          return function(p, m) {
            if (!m)
              throw new Error("VtUnalignedString must have positive length");
            return Pf(p, m, 0);
          }(t, _).replace(ge, "");
        case 4108:
          return mC(t);
        case 4126:
        case 4127:
          return (_ == 4127 ? function(p) {
            for (var m = p.read_shift(4), f = [], E = 0; E != m; ++E) {
              var b = p.l;
              f[E] = p.read_shift(0, "lpwstr").replace(ge, ""), p.l - b & 2 && (p.l += 2);
            }
            return f;
          } : function(p) {
            for (var m = p.read_shift(4), f = [], E = 0; E != m; ++E)
              f[E] = p.read_shift(0, "lpstr-cp").replace(ge, "");
            return f;
          })(t);
        default:
          throw new Error("TypedPropertyValue unrecognized type " + n + " " + _);
      }
    }
    function Bf(t, n) {
      var a, l, d, _ = Me(4), u = Me(4);
      switch (_.write_shift(4, t == 80 ? 31 : t), t) {
        case 3:
          u.write_shift(-4, n);
          break;
        case 5:
          (u = Me(8)).write_shift(8, n, "f");
          break;
        case 11:
          u.write_shift(4, n ? 1 : 0);
          break;
        case 64:
          l = (typeof (a = n) == "string" ? new Date(Date.parse(a)) : a).getTime() / 1e3 + 11644473600, d = l % Math.pow(2, 32), a = (l - d) / Math.pow(2, 32), a *= 1e7, 0 < (l = (d *= 1e7) / Math.pow(2, 32) | 0) && (d %= Math.pow(2, 32), a += l), (l = Me(8)).write_shift(4, d), l.write_shift(4, a), u = l;
          break;
        case 31:
        case 80:
          for ((u = Me(4 + 2 * (n.length + 1) + (n.length % 2 ? 0 : 2))).write_shift(4, n.length + 1), u.write_shift(0, n, "dbcs"); u.l != u.length; )
            u.write_shift(1, 0);
          break;
        default:
          throw new Error("TypedPropertyValue unrecognized type " + t + " " + n);
      }
      return mt([_, u]);
    }
    function Gf(t, n) {
      for (var a = t.l, l = t.read_shift(4), d = t.read_shift(4), _ = [], f = 0, u = 0, p = -1, m = {}, f = 0; f != d; ++f) {
        var E = t.read_shift(4), b = t.read_shift(4);
        _[f] = [E, b + a];
      }
      _.sort(function(I, A) {
        return I[1] - A[1];
      });
      var T = {};
      for (f = 0; f != d; ++f) {
        if (t.l !== _[f][1]) {
          var v = !0;
          if (0 < f && n)
            switch (n[_[f - 1][0]].t) {
              case 2:
                t.l + 2 === _[f][1] && (t.l += 2, v = !1);
                break;
              case 80:
              case 4108:
                t.l <= _[f][1] && (t.l = _[f][1], v = !1);
            }
          if ((!n || f == 0) && t.l <= _[f][1] && (v = !1, t.l = _[f][1]), v)
            throw new Error("Read Error: Expected address " + _[f][1] + " at " + t.l + " :" + f);
        }
        if (n) {
          var y = n[_[f][0]];
          if (T[y.n] = bs(t, y.t, { raw: !0 }), y.p === "version" && (T[y.n] = String(T[y.n] >> 16) + "." + ("0000" + String(65535 & T[y.n])).slice(-4)), y.n == "CodePage")
            switch (T[y.n]) {
              case 0:
                T[y.n] = 1252;
              case 874:
              case 932:
              case 936:
              case 949:
              case 950:
              case 1250:
              case 1251:
              case 1253:
              case 1254:
              case 1255:
              case 1256:
              case 1257:
              case 1258:
              case 1e4:
              case 1200:
              case 1201:
              case 1252:
              case 65e3:
              case -536:
              case 65001:
              case -535:
                N(u = T[y.n] >>> 0 & 65535);
                break;
              default:
                throw new Error("Unsupported CodePage: " + T[y.n]);
            }
        } else if (_[f][0] === 1)
          u = T.CodePage = bs(t, ec), N(u), p !== -1 && (P = t.l, t.l = _[p][1], m = Ff(t, u), t.l = P);
        else if (_[f][0] === 0)
          u !== 0 ? m = Ff(t, u) : (p = f, t.l = _[f + 1][1]);
        else {
          var R, P = m[_[f][0]];
          switch (t[t.l]) {
            case 65:
              t.l += 4, R = Uf(t);
              break;
            case 30:
            case 31:
              t.l += 4, R = kf(t, t[t.l - 4]).replace(/\u0000+$/, "");
              break;
            case 3:
              t.l += 4, R = t.read_shift(4, "i");
              break;
            case 19:
              t.l += 4, R = t.read_shift(4);
              break;
            case 5:
              t.l += 4, R = t.read_shift(8, "f");
              break;
            case 11:
              t.l += 4, R = tn(t, 4);
              break;
            case 64:
              t.l += 4, R = Br(sc(t));
              break;
            default:
              throw new Error("unparsed value: " + t[t.l]);
          }
          T[P] = R;
        }
      }
      return t.l = a + l, T;
    }
    var Vf = ["CodePage", "Thumbnail", "_PID_LINKBASE", "_PID_HLINKS", "SystemIdentifier", "FMTID"];
    function Yf(t, n, a) {
      var l, d, _, u, p = Me(8), m = [], f = [], E = 8, b = 0, T = Me(8), v = Me(8);
      if (T.write_shift(4, 2), T.write_shift(4, 1200), v.write_shift(4, 1), f.push(T), m.push(v), E += 8 + T.length, !n) {
        (v = Me(8)).write_shift(4, 0), m.unshift(v);
        var y = [Me(4)];
        for (y[0].write_shift(4, t.length), b = 0; b < t.length; ++b) {
          var R = t[b][0];
          for ((T = Me(8 + 2 * (R.length + 1) + (R.length % 2 ? 0 : 2))).write_shift(4, b + 2), T.write_shift(4, R.length + 1), T.write_shift(0, R, "dbcs"); T.l != T.length; )
            T.write_shift(1, 0);
          y.push(T);
        }
        T = mt(y), f.unshift(T), E += 8 + T.length;
      }
      for (b = 0; b < t.length; ++b)
        n && !n[t[b][0]] || -1 < Vf.indexOf(t[b][0]) || -1 < yf.indexOf(t[b][0]) || t[b][1] != null && (_ = t[b][1], l = 0, T = n ? ((u = a[l = +n[t[b][0]]]).p == "version" && typeof _ == "string" && (_ = (+(d = _.split("."))[0] << 16) + (+d[1] || 0)), Bf(u.t, _)) : ((u = function(I) {
          switch (typeof I) {
            case "boolean":
              return 11;
            case "number":
              return (0 | I) == I ? 3 : 5;
            case "string":
              return 31;
            case "object":
              if (I instanceof Date)
                return 64;
          }
          return -1;
        }(_)) == -1 && (u = 31, _ = String(_)), Bf(u, _)), f.push(T), (v = Me(8)).write_shift(4, n ? l : 2 + b), m.push(v), E += 8 + T.length);
      for (var P = 8 * (f.length + 1), b = 0; b < f.length; ++b)
        m[b].write_shift(4, P), P += f[b].length;
      return p.write_shift(4, E), p.write_shift(4, f.length), mt([p].concat(m).concat(f));
    }
    function Hf(t, n, a) {
      var l = t.content;
      if (!l)
        return {};
      Nn(l, 0);
      var d, _ = 0;
      l.chk("feff", "Byte Order: "), l.read_shift(2);
      var u = l.read_shift(4), p = l.read_shift(16);
      if (p !== Lt.utils.consts.HEADER_CLSID && p !== a)
        throw new Error("Bad PropertySet CLSID " + p);
      if ((t = l.read_shift(4)) !== 1 && t !== 2)
        throw new Error("Unrecognized #Sets: " + t);
      if (a = l.read_shift(16), p = l.read_shift(4), t === 1 && p !== l.l)
        throw new Error("Length mismatch: " + p + " !== " + l.l);
      t === 2 && (d = l.read_shift(16), _ = l.read_shift(4));
      var m, f, E = Gf(l, n), b = { SystemIdentifier: u };
      for (m in E)
        b[m] = E[m];
      if (b.FMTID = a, t === 1)
        return b;
      if (_ - l.l == 2 && (l.l += 2), l.l !== _)
        throw new Error("Length mismatch 2: " + l.l + " !== " + _);
      try {
        f = Gf(l, null);
      } catch {
      }
      for (m in f)
        b[m] = f[m];
      return b.FMTID = [a, d], b;
    }
    function qf(t, n, a, l, d, _) {
      var u = Me(d ? 68 : 48), p = [u];
      return u.write_shift(2, 65534), u.write_shift(2, 0), u.write_shift(4, 842412599), u.write_shift(16, Lt.utils.consts.HEADER_CLSID, "hex"), u.write_shift(4, d ? 2 : 1), u.write_shift(16, n, "hex"), u.write_shift(4, d ? 68 : 48), l = Yf(t, a, l), p.push(l), d && (d = Yf(d, null, null), u.write_shift(16, _, "hex"), u.write_shift(4, 68 + l.length), p.push(d)), mt(p);
    }
    function qa(t, n) {
      return t.read_shift(n), null;
    }
    function tn(t, n) {
      return t.read_shift(n) === 1;
    }
    function Bn(t, n) {
      return (n = n || Me(2)).write_shift(2, +!!t), n;
    }
    function sn(t) {
      return t.read_shift(2, "u");
    }
    function oa(t, n) {
      return (n = n || Me(2)).write_shift(2, t), n;
    }
    function $f(t, n) {
      return function(a, l, d) {
        for (var _ = [], u = a.l + l; a.l < u; )
          _.push(d(a, u - a.l));
        if (u !== a.l)
          throw new Error("Slurp error");
        return _;
      }(t, n, sn);
    }
    function Wf(t, n, a) {
      return (a = a || Me(2)).write_shift(1, n == "e" ? +t : +!!t), a.write_shift(1, n == "e" ? 1 : 0), a;
    }
    function Co(t, n, a) {
      var l = t.read_shift(a && 12 <= a.biff ? 2 : 1), d = "sbcs-cont", _ = g;
      return a && 8 <= a.biff && (g = 1200), a && a.biff != 8 ? a.biff == 12 && (d = "wstr") : t.read_shift(1) && (d = "dbcs-cont"), 2 <= a.biff && a.biff <= 5 && (d = "cpstr"), d = l ? t.read_shift(l, d) : "", g = _, d;
    }
    function ui(t, n, a) {
      if (a) {
        if (2 <= a.biff && a.biff <= 5)
          return t.read_shift(n, "cpstr");
        if (12 <= a.biff)
          return t.read_shift(n, "dbcs-cont");
      }
      return t.read_shift(1) === 0 ? t.read_shift(n, "sbcs-cont") : t.read_shift(n, "dbcs-cont");
    }
    function Ro(t, n, a) {
      var l = t.read_shift(a && a.biff == 2 ? 1 : 2);
      return l === 0 ? (t.l++, "") : ui(t, l, a);
    }
    function _i(t, n, a) {
      if (5 < a.biff)
        return Ro(t, 0, a);
      var l = t.read_shift(1);
      return l === 0 ? (t.l++, "") : t.read_shift(l, a.biff <= 4 || !t.lens ? "cpstr" : "sbcs-cont");
    }
    function zf(t, n, a) {
      return (a = a || Me(3 + 2 * t.length)).write_shift(2, t.length), a.write_shift(1, 1), a.write_shift(31, t, "utf16le"), a;
    }
    function fC(t) {
      var n, a, l, d, _ = t.read_shift(16);
      switch (_) {
        case "e0c9ea79f9bace118c8200aa004ba90b":
          return a = (n = t).read_shift(4), l = n.l, d = !1, 24 < a && (n.l += a - 24, n.read_shift(16) === "795881f43b1d7f48af2c825dc4852763" && (d = !0), n.l = l), a = n.read_shift((d ? a - 24 : a) >> 1, "utf16le").replace(ge, ""), d && (n.l += 24), a;
        case "0303000000000000c000000000000046":
          return function(u) {
            for (var p = u.read_shift(2), m = ""; 0 < p--; )
              m += "../";
            var f = u.read_shift(0, "lpstr-ansi");
            if (u.l += 2, u.read_shift(2) != 57005)
              throw new Error("Bad FileMoniker");
            if (u.read_shift(4) === 0)
              return m + f.replace(/\\/g, "/");
            if (f = u.read_shift(4), u.read_shift(2) != 3)
              throw new Error("Bad FileMoniker");
            return m + u.read_shift(f >> 1, "utf16le").replace(ge, "");
          }(t);
        default:
          throw new Error("Unsupported Moniker " + _);
      }
    }
    function Ts(t) {
      var n = t.read_shift(4);
      return 0 < n ? t.read_shift(n, "utf16le").replace(ge, "") : "";
    }
    function Kf(t, n) {
      (n = n || Me(6 + 2 * t.length)).write_shift(4, 1 + t.length);
      for (var a = 0; a < t.length; ++a)
        n.write_shift(2, t.charCodeAt(a));
      return n.write_shift(2, 0), n;
    }
    function Qf(t) {
      return [t.read_shift(1), t.read_shift(1), t.read_shift(1), t.read_shift(1)];
    }
    function Xf(t) {
      return t = Qf(t), t[3] = 0, t;
    }
    function ha(t) {
      return { r: t.read_shift(2), c: t.read_shift(2), ixfe: t.read_shift(2) };
    }
    function pi(t, n, a, l) {
      return (l = l || Me(6)).write_shift(2, t), l.write_shift(2, n), l.write_shift(2, a || 0), l;
    }
    function Zf(t) {
      return [t.read_shift(2), Jl(t)];
    }
    function vs(t) {
      var n = t.read_shift(2), a = t.read_shift(2);
      return { s: { c: t.read_shift(2), r: n }, e: { c: t.read_shift(2), r: a } };
    }
    function jf(t, n) {
      return (n = n || Me(8)).write_shift(2, t.s.r), n.write_shift(2, t.e.r), n.write_shift(2, t.s.c), n.write_shift(2, t.e.c), n;
    }
    function Jf(t) {
      var n = t.read_shift(2), a = t.read_shift(2);
      return { s: { c: t.read_shift(1), r: n }, e: { c: t.read_shift(1), r: a } };
    }
    var gC = Jf;
    function eg(t) {
      t.l += 4;
      var n = t.read_shift(2), a = t.read_shift(2), l = t.read_shift(2);
      return t.l += 12, [a, n, l];
    }
    function xn(t) {
      t.l += 2, t.l += t.read_shift(2);
    }
    var EC = { 0: xn, 4: xn, 5: xn, 6: xn, 7: function(t) {
      return t.l += 4, t.cf = t.read_shift(2), {};
    }, 8: xn, 9: xn, 10: xn, 11: xn, 12: xn, 13: function(t) {
      var n = {};
      return t.l += 4, t.l += 16, n.fSharedNote = t.read_shift(2), t.l += 4, n;
    }, 14: xn, 15: xn, 16: xn, 17: xn, 18: xn, 19: xn, 20: xn, 21: eg };
    function Cs(t, n) {
      var a = { BIFFVer: 0, dt: 0 };
      switch (a.BIFFVer = t.read_shift(2), 2 <= (n -= 2) && (a.dt = t.read_shift(2), t.l -= 2), a.BIFFVer) {
        case 1536:
        case 1280:
        case 1024:
        case 768:
        case 512:
        case 2:
        case 7:
          break;
        default:
          if (6 < n)
            throw new Error("Unexpected BIFF Ver " + a.BIFFVer);
      }
      return t.read_shift(n), a;
    }
    function lc(t, n, a) {
      var l = 1536, d = 16;
      switch (a.bookType) {
        case "biff8":
          break;
        case "biff5":
          l = 1280, d = 8;
          break;
        case "biff4":
          l = 4, d = 6;
          break;
        case "biff3":
          l = 3, d = 6;
          break;
        case "biff2":
          l = 2, d = 4;
          break;
        case "xla":
          break;
        default:
          throw new Error("unsupported BIFF version");
      }
      return a = Me(d), a.write_shift(2, l), a.write_shift(2, n), 4 < d && a.write_shift(2, 29282), 6 < d && a.write_shift(2, 1997), 8 < d && (a.write_shift(2, 49161), a.write_shift(2, 1), a.write_shift(2, 1798), a.write_shift(2, 0)), a;
    }
    function hC(t) {
      var n = Me(8);
      n.write_shift(4, t.Count), n.write_shift(4, t.Unique);
      for (var a, l, d, _ = [], u = 0; u < t.length; ++u)
        _[u] = (a = t[u], d = l = void 0, l = a.t || "", (d = Me(3)).write_shift(2, l.length), d.write_shift(1, 1), (a = Me(2 * l.length)).write_shift(2 * l.length, l, "utf16le"), mt([d, a]));
      var p = mt([n].concat(_));
      return p.parts = [n.length].concat(_.map(function(m) {
        return m.length;
      })), p;
    }
    function tg(t, n, a) {
      var l = 0;
      return a && a.biff == 2 || (l = t.read_shift(2)), t = t.read_shift(2), a && a.biff == 2 && (l = 1 - (t >> 15), t &= 32767), [{ Unsynced: 1 & l, DyZero: (2 & l) >> 1, ExAsc: (4 & l) >> 2, ExDsc: (8 & l) >> 3 }, t];
    }
    var zi = _i;
    function rg(t, _, u) {
      var l = t.l + _, p = u.biff != 8 && u.biff ? 2 : 4, d = t.read_shift(p), _ = t.read_shift(p), u = t.read_shift(2), p = t.read_shift(2);
      return t.l = l, { s: { r: d, c: u }, e: { r: _, c: p } };
    }
    function ng(t, n, a, l) {
      return a = a && a.biff == 5, (l = l || Me(a ? 16 : 20)).write_shift(2, 0), t.style ? (l.write_shift(2, t.numFmtId || 0), l.write_shift(2, 65524)) : (l.write_shift(2, t.numFmtId || 0), l.write_shift(2, n << 4)), n = 0, 0 < t.numFmtId && a && (n |= 1024), l.write_shift(4, n), l.write_shift(4, 0), a || l.write_shift(4, 0), l.write_shift(2, 0), l;
    }
    function ag(t, n, a) {
      var l = ha(t);
      return a.biff != 2 && n != 9 || ++t.l, t = (n = t).read_shift(1), t = n.read_shift(1) === 1 ? t : t === 1, l.val = t, l.t = t === !0 || t === !1 ? "b" : "e", l;
    }
    function ig(t, n, a) {
      return n === 0 ? "" : _i(t, 0, a);
    }
    function og(t, n, a) {
      var l, d = t.read_shift(2), d = { fBuiltIn: 1 & d, fWantAdvise: d >>> 1 & 1, fWantPict: d >>> 2 & 1, fOle: d >>> 3 & 1, fOleLink: d >>> 4 & 1, cf: d >>> 5 & 1023, fIcon: d >>> 15 & 1 };
      return a.sbcch === 14849 && (l = function(_, f, p) {
        _.l += 4, f -= 4;
        var m = _.l + f, f = Co(_, 0, p);
        if ((p = _.read_shift(2)) !== (m -= _.l))
          throw new Error("Malformed AddinUdf: padding = " + m + " != " + p);
        return _.l += p, f;
      }(t, n - 2, a)), d.body = l || t.read_shift(n - 2), typeof l == "string" && (d.Name = l), d;
    }
    var SC = ["_xlnm.Consolidate_Area", "_xlnm.Auto_Open", "_xlnm.Auto_Close", "_xlnm.Extract", "_xlnm.Database", "_xlnm.Criteria", "_xlnm.Print_Area", "_xlnm.Print_Titles", "_xlnm.Recorder", "_xlnm.Data_Form", "_xlnm.Auto_Activate", "_xlnm.Auto_Deactivate", "_xlnm.Sheet_Title", "_xlnm._FilterDatabase"];
    function sg(t, m, a) {
      var l = t.l + m, d = t.read_shift(2), _ = t.read_shift(1), u = t.read_shift(1), p = t.read_shift(a && a.biff == 2 ? 1 : 2), m = 0;
      return (!a || 5 <= a.biff) && (a.biff != 5 && (t.l += 2), m = t.read_shift(2), a.biff == 5 && (t.l += 2), t.l += 4), u = ui(t, u, a), 32 & d && (u = SC[u.charCodeAt(0)]), d = l - t.l, a && a.biff == 2 && --d, { chKey: _, Name: u, itab: m, rgce: l != t.l && p !== 0 && 0 < d ? function(f, y, b, R) {
        var v, y = f.l + y, R = Mo(f, R, b);
        return y !== f.l && (v = Lo(f, y - f.l, R, b)), [R, v];
      }(t, d, a, p) : [] };
    }
    function lg(t, n, a) {
      if (a.biff < 8)
        return function(p, m) {
          return p[p.l + 1] == 3 && p[p.l]++, m = Co(p, 0, m), m.charCodeAt(0) == 3 ? m.slice(1) : m;
        }(t, a);
      for (var l, d, _ = [], n = t.l + n, u = t.read_shift(8 < a.biff ? 4 : 2); u-- != 0; )
        _.push((l = t, a.biff, d = 8 < (d = a).biff ? 4 : 2, [l.read_shift(d), l.read_shift(d, "i"), l.read_shift(d, "i")]));
      if (t.l != n)
        throw new Error("Bad ExternSheet: " + t.l + " != " + n);
      return _;
    }
    function cg(t, n, a) {
      var l = gC(t);
      switch (a.biff) {
        case 2:
          t.l++, n -= 7;
          break;
        case 3:
        case 4:
          t.l += 2, n -= 8;
          break;
        default:
          t.l += 6, n -= 12;
      }
      return [l, function(d, _, u) {
        var p, m = d.l + _, f = u.biff == 2 ? 1 : 2, E = d.read_shift(f);
        if (E == 65535)
          return [[], In(d, _ - 2)];
        var b = Mo(d, E, u);
        return _ !== E + f && (p = Lo(d, _ - E - f, b, u)), d.l = m, [b, p];
      }(t, n, a)];
    }
    var bC = { 8: function(t, n) {
      var a = t.l + n;
      t.l += 10;
      var l = t.read_shift(2);
      return t.l += 4, t.l += 2, t.l += 2, t.l += 2, t.l += 4, n = t.read_shift(1), t.l += n, t.l = a, { fmt: l };
    } };
    function TC(t) {
      var n = Me(24), a = zr(t[0]);
      n.write_shift(2, a.r), n.write_shift(2, a.r), n.write_shift(2, a.c), n.write_shift(2, a.c);
      for (var l = "d0 c9 ea 79 f9 ba ce 11 8c 82 00 aa 00 4b a9 0b".split(" "), d = 0; d < 16; ++d)
        n.write_shift(1, parseInt(l[d], 16));
      return mt([n, function(_) {
        var u = Me(512), p = 0, m = _.Target, f = -1 < (_ = (m = m.slice(0, 7) == "file://" ? m.slice(7) : m).indexOf("#")) ? 31 : 23;
        switch (m.charAt(0)) {
          case "#":
            f = 28;
            break;
          case ".":
            f &= -3;
        }
        u.write_shift(4, 2), u.write_shift(4, f);
        for (var E = [8, 6815827, 6619237, 4849780, 83], p = 0; p < E.length; ++p)
          u.write_shift(4, E[p]);
        if (f == 28)
          Kf(m = m.slice(1), u);
        else if (2 & f) {
          for (E = "e0 c9 ea 79 f9 ba ce 11 8c 82 00 aa 00 4b a9 0b".split(" "), p = 0; p < E.length; ++p)
            u.write_shift(1, parseInt(E[p], 16));
          var b = -1 < _ ? m.slice(0, _) : m;
          for (u.write_shift(4, 2 * (b.length + 1)), p = 0; p < b.length; ++p)
            u.write_shift(2, b.charCodeAt(p));
          u.write_shift(2, 0), 8 & f && Kf(-1 < _ ? m.slice(_ + 1) : "", u);
        } else {
          for (E = "03 03 00 00 00 00 00 00 c0 00 00 00 00 00 00 46".split(" "), p = 0; p < E.length; ++p)
            u.write_shift(1, parseInt(E[p], 16));
          for (var T = 0; m.slice(3 * T, 3 * T + 3) == "../" || m.slice(3 * T, 3 * T + 3) == "..\\"; )
            ++T;
          for (u.write_shift(2, T), u.write_shift(4, m.length - 3 * T + 1), p = 0; p < m.length - 3 * T; ++p)
            u.write_shift(1, 255 & m.charCodeAt(p + 3 * T));
          for (u.write_shift(1, 0), u.write_shift(2, 65535), u.write_shift(2, 57005), p = 0; p < 6; ++p)
            u.write_shift(4, 0);
        }
        return u.slice(0, u.l);
      }(t[1])]);
    }
    function dg(t, m, a) {
      if (!a.cellStyles)
        return In(t, m);
      var l = a && 12 <= a.biff ? 4 : 2, d = t.read_shift(l), _ = t.read_shift(l), u = t.read_shift(l), p = t.read_shift(l), m = t.read_shift(2);
      return l == 2 && (t.l += 2), p = { s: d, e: _, w: u, ixfe: p, flags: m }, (5 <= a.biff || !a.biff) && (p.level = m >> 8 & 7), p;
    }
    var vC = ha, CC = $f, zc = Ro, ug, _g, Rs, RC = [2, 3, 48, 49, 131, 139, 140, 245], cc = (ug = { 1: 437, 2: 850, 3: 1252, 4: 1e4, 100: 852, 101: 866, 102: 865, 103: 861, 104: 895, 105: 620, 106: 737, 107: 857, 120: 950, 121: 949, 122: 936, 123: 932, 124: 874, 125: 1255, 126: 1256, 150: 10007, 151: 10029, 152: 10006, 200: 1250, 201: 1251, 202: 1254, 203: 1253, 0: 20127, 8: 865, 9: 437, 10: 850, 11: 437, 13: 437, 14: 850, 15: 437, 16: 850, 17: 437, 18: 850, 19: 932, 20: 850, 21: 437, 22: 850, 23: 865, 24: 437, 25: 437, 26: 850, 27: 437, 28: 863, 29: 850, 31: 852, 34: 852, 35: 852, 36: 860, 37: 850, 38: 866, 55: 850, 64: 852, 77: 936, 78: 949, 79: 950, 80: 874, 87: 1252, 88: 1252, 89: 1252, 108: 863, 134: 737, 135: 852, 136: 857, 204: 1257, 255: 16969 }, _g = ao({ 1: 437, 2: 850, 3: 1252, 4: 1e4, 100: 852, 101: 866, 102: 865, 103: 861, 104: 895, 105: 620, 106: 737, 107: 857, 120: 950, 121: 949, 122: 936, 123: 932, 124: 874, 125: 1255, 126: 1256, 150: 10007, 151: 10029, 152: 10006, 200: 1250, 201: 1251, 202: 1254, 203: 1253, 0: 20127 }), Rs = { B: 8, C: 250, L: 1, D: 8, "?": 0, "": 0 }, { to_workbook: function(t, n) {
      try {
        return Ha(pg(t, n), n);
      } catch (a) {
        if (n && n.WTF)
          throw a;
      }
      return { SheetNames: [], Sheets: {} };
    }, to_sheet: pg, from_sheet: function(t, n) {
      if (0 <= +(n = n || {}).codepage && N(+n.codepage), n.type == "string")
        throw new Error("Cannot write DBF to JS string");
      for (var a = Wn(), l = (n = Ws(t, { header: 1, raw: !0, cellDates: !0 }))[0], d = n.slice(1), _ = t["!cols"] || [], f = 0, u = 0, p = 0, m = 1, f = 0; f < l.length; ++f)
        if (((_[f] || {}).DBF || {}).name)
          l[f] = _[f].DBF.name, ++p;
        else if (l[f] != null) {
          if (++p, typeof l[f] == "number" && (l[f] = l[f].toString(10)), typeof l[f] != "string")
            throw new Error("DBF Invalid column name " + l[f] + " |" + typeof l[f] + "|");
          if (l.indexOf(l[f]) !== f) {
            for (u = 0; u < 1024; ++u)
              if (l.indexOf(l[f] + "_" + u) == -1) {
                l[f] += "_" + u;
                break;
              }
          }
        }
      var E = lr(t["!ref"]), b = [], T = [], v = [];
      for (f = 0; f <= E.e.c - E.s.c; ++f) {
        for (var y = "", R = "", P = 0, I = [], u = 0; u < d.length; ++u)
          d[u][f] != null && I.push(d[u][f]);
        if (I.length != 0 && l[f] != null) {
          for (u = 0; u < I.length; ++u) {
            switch (typeof I[u]) {
              case "number":
                R = "B";
                break;
              case "string":
                R = "C";
                break;
              case "boolean":
                R = "L";
                break;
              case "object":
                R = I[u] instanceof Date ? "D" : "C";
                break;
              default:
                R = "C";
            }
            P = Math.max(P, String(I[u]).length), y = y && y != R ? "C" : R;
          }
          250 < P && (P = 250), (R = ((_[f] || {}).DBF || {}).type) == "C" && _[f].DBF.len > P && (P = _[f].DBF.len), y == "B" && R == "N" && (y = "N", v[f] = _[f].DBF.dec, P = _[f].DBF.len), T[f] = y == "C" || R == "N" ? P : Rs[y] || 0, m += T[f], b[f] = y;
        } else
          b[f] = "?";
      }
      var A, M, F = a.next(32);
      for (F.write_shift(4, 318902576), F.write_shift(4, d.length), F.write_shift(2, 296 + 32 * p), F.write_shift(2, m), f = 0; f < 4; ++f)
        F.write_shift(4, 0);
      for (F.write_shift(4, 0 | (+_g[h] || 3) << 8), u = f = 0; f < l.length; ++f)
        l[f] != null && (A = a.next(32), M = (l[f].slice(-10) + "\0\0\0\0\0\0\0\0\0\0\0").slice(0, 11), A.write_shift(1, M, "sbcs"), A.write_shift(1, b[f] == "?" ? "C" : b[f], "sbcs"), A.write_shift(4, u), A.write_shift(1, T[f] || Rs[b[f]] || 0), A.write_shift(1, v[f] || 0), A.write_shift(1, 2), A.write_shift(4, 0), A.write_shift(1, 0), A.write_shift(4, 0), A.write_shift(4, 0), u += T[f] || Rs[b[f]] || 0);
      var B = a.next(264);
      for (B.write_shift(4, 13), f = 0; f < 65; ++f)
        B.write_shift(4, 0);
      for (f = 0; f < d.length; ++f) {
        var re = a.next(m);
        for (re.write_shift(1, 0), u = 0; u < l.length; ++u)
          if (l[u] != null)
            switch (b[u]) {
              case "L":
                re.write_shift(1, d[f][u] == null ? 63 : d[f][u] ? 84 : 70);
                break;
              case "B":
                re.write_shift(8, d[f][u] || 0, "f");
                break;
              case "N":
                var me = "0";
                for (typeof d[f][u] == "number" && (me = d[f][u].toFixed(v[u] || 0)), p = 0; p < T[u] - me.length; ++p)
                  re.write_shift(1, 32);
                re.write_shift(1, me, "sbcs");
                break;
              case "D":
                d[f][u] ? (re.write_shift(4, ("0000" + d[f][u].getFullYear()).slice(-4), "sbcs"), re.write_shift(2, ("00" + (d[f][u].getMonth() + 1)).slice(-2), "sbcs"), re.write_shift(2, ("00" + d[f][u].getDate()).slice(-2), "sbcs")) : re.write_shift(8, "00000000", "sbcs");
                break;
              case "C":
                var le = String(d[f][u] != null ? d[f][u] : "").slice(0, T[u]);
                for (re.write_shift(1, le, "sbcs"), p = 0; p < T[u] - le.length; ++p)
                  re.write_shift(1, 32);
            }
      }
      return a.next(1).write_shift(1, 26), a.end();
    } });
    function pg(t, n) {
      return n = n || {}, n.dateNF || (n.dateNF = "yyyymmdd"), t = Pi(function(a, l) {
        var d = [], _ = _e(1);
        switch (l.type) {
          case "base64":
            _ = Pe(H(a));
            break;
          case "binary":
            _ = Pe(a);
            break;
          case "buffer":
          case "array":
            _ = a;
        }
        Nn(_, 0);
        var u = _.read_shift(1), p = !!(136 & u), m = !1, f = !1;
        switch (u) {
          case 2:
          case 3:
            break;
          case 48:
          case 49:
            p = m = !0;
            break;
          case 131:
          case 139:
            break;
          case 140:
            f = !0;
            break;
          case 245:
            break;
          default:
            throw new Error("DBF Unsupported Version: " + u.toString(16));
        }
        var E = 0, b = 521;
        u == 2 && (E = _.read_shift(2)), _.l += 3, 1048576 < (E = u != 2 ? _.read_shift(4) : E) && (E = 1e6), u != 2 && (b = _.read_shift(2));
        var T = _.read_shift(2), v = l.codepage || 1252;
        u != 2 && (_.l += 16, _.read_shift(1), _[_.l] !== 0 && (v = ug[_[_.l]]), _.l += 1, _.l += 2), f && (_.l += 36);
        for (var y = [], R = {}, P = Math.min(_.length, u == 2 ? 521 : b - 10 - (m ? 264 : 0)), I = f ? 32 : 11; _.l < P && _[_.l] != 13; )
          switch ((R = {}).name = e.utils.decode(v, _.slice(_.l, _.l + I)).replace(/[\u0000\r\n].*$/g, ""), _.l += I, R.type = String.fromCharCode(_.read_shift(1)), u == 2 || f || (R.offset = _.read_shift(4)), R.len = _.read_shift(1), u == 2 && (R.offset = _.read_shift(2)), R.dec = _.read_shift(1), R.name.length && y.push(R), u != 2 && (_.l += f ? 13 : 14), R.type) {
            case "B":
              m && R.len == 8 || !l.WTF || console.log("Skipping " + R.name + ":" + R.type);
              break;
            case "G":
            case "P":
              l.WTF && console.log("Skipping " + R.name + ":" + R.type);
              break;
            case "+":
            case "0":
            case "@":
            case "C":
            case "D":
            case "F":
            case "I":
            case "L":
            case "M":
            case "N":
            case "O":
            case "T":
            case "Y":
              break;
            default:
              throw new Error("Unknown Field Type: " + R.type);
          }
        if (_[_.l] !== 13 && (_.l = b - 1), _.read_shift(1) !== 13)
          throw new Error("DBF Terminator not found " + _.l + " " + _[_.l]);
        _.l = b;
        var A = 0, M = 0;
        for (d[0] = [], M = 0; M != y.length; ++M)
          d[0][M] = y[M].name;
        for (; 0 < E--; )
          if (_[_.l] !== 42)
            for (++_.l, d[++A] = [], M = M = 0; M != y.length; ++M) {
              var F = _.slice(_.l, _.l + y[M].len);
              _.l += y[M].len, Nn(F, 0);
              var B = e.utils.decode(v, F);
              switch (y[M].type) {
                case "C":
                  B.trim().length && (d[A][M] = B.replace(/\s+$/, ""));
                  break;
                case "D":
                  B.length === 8 ? d[A][M] = new Date(+B.slice(0, 4), +B.slice(4, 6) - 1, +B.slice(6, 8)) : d[A][M] = B;
                  break;
                case "F":
                  d[A][M] = parseFloat(B.trim());
                  break;
                case "+":
                case "I":
                  d[A][M] = f ? 2147483648 ^ F.read_shift(-4, "i") : F.read_shift(4, "i");
                  break;
                case "L":
                  switch (B.trim().toUpperCase()) {
                    case "Y":
                    case "T":
                      d[A][M] = !0;
                      break;
                    case "N":
                    case "F":
                      d[A][M] = !1;
                      break;
                    case "":
                    case "?":
                      break;
                    default:
                      throw new Error("DBF Unrecognized L:|" + B + "|");
                  }
                  break;
                case "M":
                  if (!p)
                    throw new Error("DBF Unexpected MEMO for type " + u.toString(16));
                  d[A][M] = "##MEMO##" + (f ? parseInt(B.trim(), 10) : F.read_shift(4));
                  break;
                case "N":
                  (B = B.replace(/\u0000/g, "").trim()) && B != "." && (d[A][M] = +B || 0);
                  break;
                case "@":
                  d[A][M] = new Date(F.read_shift(-8, "f") - 621356832e5);
                  break;
                case "T":
                  d[A][M] = new Date(864e5 * (F.read_shift(4) - 2440588) + F.read_shift(4));
                  break;
                case "Y":
                  d[A][M] = F.read_shift(4, "i") / 1e4 + F.read_shift(4, "i") / 1e4 * Math.pow(2, 32);
                  break;
                case "O":
                  d[A][M] = -F.read_shift(-8, "f");
                  break;
                case "B":
                  if (m && y[M].len == 8) {
                    d[A][M] = F.read_shift(8, "f");
                    break;
                  }
                case "G":
                case "P":
                  F.l += y[M].len;
                  break;
                case "0":
                  if (y[M].name === "_NullFlags")
                    break;
                default:
                  throw new Error("DBF Unsupported data type " + y[M].type);
              }
            }
          else
            _.l += T;
        if (u != 2 && _.l < _.length && _[_.l++] != 26)
          throw new Error("DBF EOF Marker missing " + (_.l - 1) + " of " + _.length + " " + _[_.l - 1].toString(16));
        return l && l.sheetRows && (d = d.slice(0, l.sheetRows)), l.DBF = y, d;
      }(t, n), n), t["!cols"] = n.DBF.map(function(a) {
        return { wch: a.len, DBF: a };
      }), delete n.DBF, t;
    }
    var Ns, mg, fg, gg, Eg = (Ns = { AA: "À", BA: "Á", CA: "Â", DA: 195, HA: "Ä", JA: 197, AE: "È", BE: "É", CE: "Ê", HE: "Ë", AI: "Ì", BI: "Í", CI: "Î", HI: "Ï", AO: "Ò", BO: "Ó", CO: "Ô", DO: 213, HO: "Ö", AU: "Ù", BU: "Ú", CU: "Û", HU: "Ü", Aa: "à", Ba: "á", Ca: "â", Da: 227, Ha: "ä", Ja: 229, Ae: "è", Be: "é", Ce: "ê", He: "ë", Ai: "ì", Bi: "í", Ci: "î", Hi: "ï", Ao: "ò", Bo: "ó", Co: "ô", Do: 245, Ho: "ö", Au: "ù", Bu: "ú", Cu: "û", Hu: "ü", KC: "Ç", Kc: "ç", q: "æ", z: "œ", a: "Æ", j: "Œ", DN: 209, Dn: 241, Hy: 255, S: 169, c: 170, R: 174, "B ": 180, 0: 176, 1: 177, 2: 178, 3: 179, 5: 181, 6: 182, 7: 183, Q: 185, k: 186, b: 208, i: 216, l: 222, s: 240, y: 248, "!": 161, '"': 162, "#": 163, "(": 164, "%": 165, "'": 167, "H ": 168, "+": 171, ";": 187, "<": 188, "=": 189, ">": 190, "?": 191, "{": 223 }, mg = new RegExp("\x1BN(" + $r(Ns).join("|").replace(/\|\|\|/, "|\\||").replace(/([?()+])/g, "\\$1") + "|\\|)", "gm"), fg = function(t, n) {
      return n = Ns[n], typeof n == "number" ? k(n) : n;
    }, gg = function(t, n, a) {
      return a = n.charCodeAt(0) - 32 << 4 | a.charCodeAt(0) - 48, a == 59 ? t : k(a);
    }, Ns["|"] = 254, { to_workbook: function(t, n) {
      return Ha(hg(t, n), n);
    }, to_sheet: hg, from_sheet: function(t, n) {
      var a, l, d = ["ID;PWXL;N;E"], _ = [], u = lr(t["!ref"]), p = Array.isArray(t), m = `\r
`;
      d.push("P;PGeneral"), d.push("F;P0;DG0G8;M255"), t["!cols"] && (a = d, t["!cols"].forEach(function(T, v) {
        v = "F;W" + (v + 1) + " " + (v + 1) + " ", T.hidden ? v += "0" : (typeof T.width != "number" || T.wpx || (T.wpx = Oo(T.width)), typeof T.wpx != "number" || T.wch || (T.wch = yo(T.wpx)), typeof T.wch == "number" && (v += Math.round(T.wch))), v.charAt(v.length - 1) != " " && a.push(v);
      })), t["!rows"] && (l = d, t["!rows"].forEach(function(T, v) {
        var y = "F;";
        T.hidden ? y += "M0;" : T.hpt ? y += "M" + 20 * T.hpt + ";" : T.hpx && (y += "M" + 20 * Io(T.hpx) + ";"), 2 < y.length && l.push(y + "R" + (v + 1));
      })), d.push("B;Y" + (u.e.r - u.s.r + 1) + ";X" + (u.e.c - u.s.c + 1) + ";D" + [u.s.c, u.s.r, u.e.c, u.e.r].join(" "));
      for (var f = u.s.r; f <= u.e.r; ++f)
        for (var E = u.s.c; E <= u.e.c; ++E) {
          var b = $t({ r: f, c: E });
          (b = p ? (t[f] || [])[E] : t[b]) && (b.v != null || b.f && !b.F) && _.push(function(T, v, y) {
            var R = "C;Y" + (v + 1) + ";X" + (y + 1) + ";K";
            switch (T.t) {
              case "n":
                R += T.v || 0, T.f && !T.F && (R += ";E" + Rc(T.f, { r: v, c: y }));
                break;
              case "b":
                R += T.v ? "TRUE" : "FALSE";
                break;
              case "e":
                R += T.w || T.v;
                break;
              case "d":
                R += '"' + (T.w || T.v) + '"';
                break;
              case "s":
                R += '"' + T.v.replace(/"/g, "").replace(/;/g, ";;") + '"';
            }
            return R;
          }(b, f, E));
        }
      return d.join(m) + m + _.join(m) + m + "E" + m;
    } });
    function As(T, n) {
      var a, l, d = T.split(/[\n\r]+/), _ = -1, u = -1, p = 0, m = 0, f = [], E = [], b = null, T = {}, v = [], y = [], R = 0;
      for (0 <= +n.codepage && N(+n.codepage); p !== d.length; ++p) {
        R = 0;
        var P, I = d[p].trim().replace(/\x1B([\x20-\x2F])([\x30-\x3F])/g, gg).replace(mg, fg), A = I.replace(/;;/g, "\0").split(";").map(function(ze) {
          return ze.replace(/\u0000/g, ";");
        }), M = A[0];
        if (0 < I.length)
          switch (M) {
            case "ID":
            case "E":
            case "B":
            case "O":
            case "W":
              break;
            case "P":
              A[1].charAt(0) == "P" && E.push(I.slice(3).replace(/;;/g, ";"));
              break;
            case "C":
              for (var F = !1, B = !1, re = !1, me = !1, le = -1, be = -1, m = 1; m < A.length; ++m)
                switch (A[m].charAt(0)) {
                  case "A":
                    break;
                  case "X":
                    u = parseInt(A[m].slice(1)) - 1, B = !0;
                    break;
                  case "Y":
                    for (_ = parseInt(A[m].slice(1)) - 1, B || (u = 0), l = f.length; l <= _; ++l)
                      f[l] = [];
                    break;
                  case "K":
                    (P = A[m].slice(1)).charAt(0) === '"' ? P = P.slice(1, P.length - 1) : P === "TRUE" ? P = !0 : P === "FALSE" ? P = !1 : isNaN(na(P)) ? isNaN(ri(P).getDate()) || (P = Br(P)) : (P = na(P), b !== null && Gt(b) && (P = lo(P))), e !== void 0 && typeof P == "string" && (n || {}).type != "string" && (n || {}).codepage && (P = e.utils.decode(n.codepage, P)), F = !0;
                    break;
                  case "E":
                    me = !0;
                    var Fe = qi(A[m].slice(1), { r: _, c: u });
                    f[_][u] = [f[_][u], Fe];
                    break;
                  case "S":
                    re = !0, f[_][u] = [f[_][u], "S5S"];
                    break;
                  case "G":
                    break;
                  case "R":
                    le = parseInt(A[m].slice(1)) - 1;
                    break;
                  case "C":
                    be = parseInt(A[m].slice(1)) - 1;
                    break;
                  default:
                    if (n && n.WTF)
                      throw new Error("SYLK bad record " + I);
                }
              if (F && (f[_][u] && f[_][u].length == 2 ? f[_][u][0] = P : f[_][u] = P, b = null), re) {
                if (me)
                  throw new Error("SYLK shared formula cannot have own formula");
                var Ue = -1 < le && f[le][be];
                if (!Ue || !Ue[1])
                  throw new Error("SYLK shared formula cannot find base");
                f[_][u][1] = pE(Ue[1], { r: _ - le, c: u - be });
              }
              break;
            case "F":
              var Ne = 0;
              for (m = 1; m < A.length; ++m)
                switch (A[m].charAt(0)) {
                  case "X":
                    u = parseInt(A[m].slice(1)) - 1, ++Ne;
                    break;
                  case "Y":
                    for (_ = parseInt(A[m].slice(1)) - 1, l = f.length; l <= _; ++l)
                      f[l] = [];
                    break;
                  case "M":
                    R = parseInt(A[m].slice(1)) / 20;
                    break;
                  case "F":
                  case "G":
                    break;
                  case "P":
                    b = E[parseInt(A[m].slice(1))];
                    break;
                  case "S":
                  case "D":
                  case "N":
                    break;
                  case "W":
                    for (a = A[m].slice(1).split(" "), l = parseInt(a[0], 10); l <= parseInt(a[1], 10); ++l)
                      R = parseInt(a[2], 10), y[l - 1] = R === 0 ? { hidden: !0 } : { wch: R }, $a(y[l - 1]);
                    break;
                  case "C":
                    y[u = parseInt(A[m].slice(1)) - 1] || (y[u] = {});
                    break;
                  case "R":
                    v[_ = parseInt(A[m].slice(1)) - 1] || (v[_] = {}), 0 < R ? (v[_].hpt = R, v[_].hpx = Yi(R)) : R === 0 && (v[_].hidden = !0);
                    break;
                  default:
                    if (n && n.WTF)
                      throw new Error("SYLK bad record " + I);
                }
              Ne < 1 && (b = null);
              break;
            default:
              if (n && n.WTF)
                throw new Error("SYLK bad record " + I);
          }
      }
      return 0 < v.length && (T["!rows"] = v), 0 < y.length && (T["!cols"] = y), [f = n && n.sheetRows ? f.slice(0, n.sheetRows) : f, T];
    }
    function hg(l, n) {
      var a = function(u, p) {
        switch (p.type) {
          case "base64":
            return As(H(u), p);
          case "binary":
            return As(u, p);
          case "buffer":
            return As(K && Buffer.isBuffer(u) ? u.toString("binary") : ye(u), p);
          case "array":
            return As(Va(u), p);
        }
        throw new Error("Unrecognized type " + p.type);
      }(l, n), l = a[0], d = a[1], _ = Pi(l, n);
      return $r(d).forEach(function(u) {
        _[u] = d[u];
      }), _;
    }
    var Sg = { to_workbook: function(t, n) {
      return Ha(bg(t, n), n);
    }, to_sheet: bg, from_sheet: function(t) {
      var n = [], a = lr(t["!ref"]), l = Array.isArray(t);
      ys(n, "TABLE", 0, 1, "sheetjs"), ys(n, "VECTORS", 0, a.e.r - a.s.r + 1, ""), ys(n, "TUPLES", 0, a.e.c - a.s.c + 1, ""), ys(n, "DATA", 0, 0, "");
      for (var d = a.s.r; d <= a.e.r; ++d) {
        Sa(n, -1, 0, "BOT");
        for (var _ = a.s.c; _ <= a.e.c; ++_) {
          var u, p = $t({ r: d, c: _ });
          if (u = l ? (t[d] || [])[_] : t[p])
            switch (u.t) {
              case "n":
                var m = u.w;
                (m = !m && u.v != null ? u.v : m) == null ? u.f && !u.F ? Sa(n, 1, 0, "=" + u.f) : Sa(n, 1, 0, "") : Sa(n, 0, m, "V");
                break;
              case "b":
                Sa(n, 0, u.v ? 1 : 0, u.v ? "TRUE" : "FALSE");
                break;
              case "s":
                Sa(n, 1, 0, isNaN(u.v) ? u.v : '="' + u.v + '"');
                break;
              case "d":
                u.w || (u.w = dn(u.z || ae[14], on(Br(u.v)))), Sa(n, 0, u.w, "V");
                break;
              default:
                Sa(n, 1, 0, "");
            }
          else
            Sa(n, 1, 0, "");
        }
      }
      return Sa(n, -1, 0, "EOD"), n.join(`\r
`);
    } };
    function Os(t, n) {
      for (var a = t.split(`
`), l = -1, d = -1, _ = 0, u = []; _ !== a.length; ++_)
        if (a[_].trim() !== "BOT") {
          if (!(l < 0)) {
            for (var p = a[_].trim().split(","), m = p[0], f = p[1], E = a[++_] || ""; 1 & (E.match(/["]/g) || []).length && _ < a.length - 1; )
              E += `
` + a[++_];
            switch (E = E.trim(), +m) {
              case -1:
                if (E === "BOT") {
                  u[++l] = [], d = 0;
                  continue;
                }
                if (E !== "EOD")
                  throw new Error("Unrecognized DIF special command " + E);
                break;
              case 0:
                E === "TRUE" ? u[l][d] = !0 : E === "FALSE" ? u[l][d] = !1 : isNaN(na(f)) ? isNaN(ri(f).getDate()) ? u[l][d] = f : u[l][d] = Br(f) : u[l][d] = na(f), ++d;
                break;
              case 1:
                E = (E = E.slice(1, E.length - 1)).replace(/""/g, '"'), E && E.match(/^=".*"$/) && (E = E.slice(2, -1)), u[l][d++] = E !== "" ? E : null;
            }
            if (E === "EOD")
              break;
          }
        } else
          u[++l] = [], d = 0;
      return u = n && n.sheetRows ? u.slice(0, n.sheetRows) : u;
    }
    function bg(t, n) {
      return Pi(function(a, l) {
        switch (l.type) {
          case "base64":
            return Os(H(a), l);
          case "binary":
            return Os(a, l);
          case "buffer":
            return Os(K && Buffer.isBuffer(a) ? a.toString("binary") : ye(a), l);
          case "array":
            return Os(Va(a), l);
        }
        throw new Error("Unrecognized type " + l.type);
      }(t, n), n);
    }
    function ys(t, n, a, l, d) {
      t.push(n), t.push(a + "," + l), t.push('"' + d.replace(/"/g, '""') + '"');
    }
    function Sa(t, n, a, l) {
      t.push(n + "," + a), t.push(n == 1 ? '"' + l.replace(/"/g, '""') + '"' : l);
    }
    var Tg, dc, vg, Cg, Rg = (Tg = ["socialcalc:version:1.5", "MIME-Version: 1.0", "Content-Type: multipart/mixed; boundary=SocialCalcSpreadsheetControlSave"].join(`
`), dc = ["--SocialCalcSpreadsheetControlSave", "Content-type: text/plain; charset=UTF-8"].join(`
`) + `
`, vg = ["# SocialCalc Spreadsheet Control Save", "part:sheet"].join(`
`), Cg = "--SocialCalcSpreadsheetControlSave--", { to_workbook: function(t, n) {
      return Ha(Ng(t, n), n);
    }, to_sheet: Ng, from_sheet: function(t) {
      return [Tg, dc, vg, dc, function(n) {
        if (!n || !n["!ref"])
          return "";
        for (var a, l, d = [], _ = [], u = Un(n["!ref"]), p = Array.isArray(n), m = u.s.r; m <= u.e.r; ++m)
          for (var f = u.s.c; f <= u.e.c; ++f)
            if (l = $t({ r: m, c: f }), (a = p ? (n[m] || [])[f] : n[l]) && a.v != null && a.t !== "z") {
              switch (_ = ["cell", l, "t"], a.t) {
                case "s":
                case "str":
                  _.push(uc(a.v));
                  break;
                case "n":
                  a.f ? (_[2] = "vtf", _[3] = "n", _[4] = a.v, _[5] = uc(a.f)) : (_[2] = "v", _[3] = a.v);
                  break;
                case "b":
                  _[2] = "vt" + (a.f ? "f" : "c"), _[3] = "nl", _[4] = a.v ? "1" : "0", _[5] = uc(a.f || (a.v ? "TRUE" : "FALSE"));
                  break;
                case "d":
                  var E = on(Br(a.v));
                  _[2] = "vtc", _[3] = "nd", _[4] = "" + E, _[5] = a.w || dn(a.z || ae[14], E);
                  break;
                case "e":
                  continue;
              }
              d.push(_.join(":"));
            }
        return d.push("sheet:c:" + (u.e.c - u.s.c + 1) + ":r:" + (u.e.r - u.s.r + 1) + ":tvf:1"), d.push("valueformat:1:text-wiki"), d.join(`
`);
      }(t), Cg].join(`
`);
    } });
    function uc(t) {
      return t.replace(/\\/g, "\\b").replace(/:/g, "\\c").replace(/\n/g, "\\n");
    }
    function Ng(t, n) {
      return Pi(function(a, l) {
        for (var d, _ = a.split(`
`), u = -1, p = 0, m = []; p !== _.length; ++p) {
          var f = _[p].trim().split(":");
          if (f[0] === "cell") {
            var E = zr(f[1]);
            if (m.length <= E.r)
              for (u = m.length; u <= E.r; ++u)
                m[u] || (m[u] = []);
            switch (u = E.r, d = E.c, f[2]) {
              case "t":
                m[u][d] = f[3].replace(/\\b/g, "\\").replace(/\\c/g, ":").replace(/\\n/g, `
`);
                break;
              case "v":
                m[u][d] = +f[3];
                break;
              case "vtf":
                var b = f[f.length - 1];
              case "vtc":
                f[3] === "nl" ? m[u][d] = !!+f[4] : m[u][d] = +f[4], f[2] == "vtf" && (m[u][d] = [m[u][d], b]);
            }
          }
        }
        return m = l && l.sheetRows ? m.slice(0, l.sheetRows) : m;
      }(t, n), n);
    }
    var _c, Is, Bi = (_c = { 44: ",", 9: "	", 59: ";", 124: "|" }, Is = { 44: 3, 9: 2, 59: 1, 124: 0 }, { to_workbook: function(t, n) {
      return Ha(yg(t, n), n);
    }, to_sheet: yg, from_sheet: function(t) {
      for (var n = [], a = lr(t["!ref"]), l = Array.isArray(t), d = a.s.r; d <= a.e.r; ++d) {
        for (var _ = [], u = a.s.c; u <= a.e.c; ++u) {
          var p = $t({ r: d, c: u });
          if ((p = l ? (t[d] || [])[u] : t[p]) && p.v != null) {
            for (var m = (p.w || (Ea(p), p.w) || "").slice(0, 10); m.length < 10; )
              m += " ";
            _.push(m + (u === 0 ? " " : ""));
          } else
            _.push("          ");
        }
        n.push(_.join(""));
      }
      return n.join(`
`);
    } });
    function Ag(t, n, a, l, d) {
      d.raw ? n[a][l] = t : t === "" || (t === "TRUE" ? n[a][l] = !0 : t === "FALSE" ? n[a][l] = !1 : isNaN(na(t)) ? isNaN(ri(t).getDate()) ? n[a][l] = t : n[a][l] = Br(t) : n[a][l] = na(t));
    }
    function Og(t) {
      for (var n = {}, a = !1, l = 0, d = 0; l < t.length; ++l)
        (d = t.charCodeAt(l)) == 34 ? a = !a : !a && d in _c && (n[d] = (n[d] || 0) + 1);
      for (l in d = [], n)
        Object.prototype.hasOwnProperty.call(n, l) && d.push([n[l], l]);
      if (!d.length)
        for (l in n = Is)
          Object.prototype.hasOwnProperty.call(n, l) && d.push([n[l], l]);
      return d.sort(function(_, u) {
        return _[0] - u[0] || Is[_[1]] - Is[u[1]];
      }), _c[d.pop()[1]] || 44;
    }
    function NC(t, l) {
      var a = l || {}, l = "", d = a.dense ? [] : {}, _ = { s: { c: 0, r: 0 }, e: { c: 0, r: 0 } };
      t.slice(0, 4) == "sep=" ? t.charCodeAt(5) == 13 && t.charCodeAt(6) == 10 ? (l = t.charAt(4), t = t.slice(7)) : t.charCodeAt(5) == 13 || t.charCodeAt(5) == 10 ? (l = t.charAt(4), t = t.slice(6)) : l = Og(t.slice(0, 1024)) : l = a && a.FS ? a.FS : Og(t.slice(0, 1024));
      var u = 0, p = 0, m = 0, f = 0, E = 0, b = l.charCodeAt(0), T = !1, v = 0, y = t.charCodeAt(0);
      t = t.replace(/\r\n/gm, `
`);
      var R = a.dateNF != null ? (l = (l = typeof (l = a.dateNF) == "number" ? ae[l] : l).replace(Nl, "(\\d+)"), new RegExp("^" + l + "$")) : null;
      function P() {
        var I, A = t.slice(f, E), M = {};
        if ((A = A.charAt(0) == '"' && A.charAt(A.length - 1) == '"' ? A.slice(1, -1).replace(/""/g, '"') : A).length === 0 ? M.t = "z" : a.raw || A.trim().length === 0 ? (M.t = "s", M.v = A) : A.charCodeAt(0) == 61 ? A.charCodeAt(1) == 34 && A.charCodeAt(A.length - 1) == 34 ? (M.t = "s", M.v = A.slice(2, -1).replace(/""/g, '"')) : A.length != 1 ? (M.t = "n", M.f = A.slice(1)) : (M.t = "s", M.v = A) : A == "TRUE" ? (M.t = "b", M.v = !0) : A == "FALSE" ? (M.t = "b", M.v = !1) : isNaN(m = na(A)) ? !isNaN(ri(A).getDate()) || R && A.match(R) ? (M.z = a.dateNF || ae[14], I = 0, R && A.match(R) && (A = function(F, B) {
          var re = -1, me = -1, le = -1, be = -1, Fe = -1, Ue = -1;
          (F.match(Nl) || []).forEach(function(ze, ut) {
            var lt = parseInt(B[ut + 1], 10);
            switch (ze.toLowerCase().charAt(0)) {
              case "y":
                re = lt;
                break;
              case "d":
                le = lt;
                break;
              case "h":
                be = lt;
                break;
              case "s":
                Ue = lt;
                break;
              case "m":
                0 <= be ? Fe = lt : me = lt;
            }
          }), 0 <= Ue && Fe == -1 && 0 <= me && (Fe = me, me = -1);
          var Ne = ("" + (0 <= re ? re : (/* @__PURE__ */ new Date()).getFullYear())).slice(-4) + "-" + ("00" + (1 <= me ? me : 1)).slice(-2) + "-" + ("00" + (1 <= le ? le : 1)).slice(-2);
          return (Ne = Ne.length == 7 ? "0" + Ne : Ne).length == 8 && (Ne = "20" + Ne), F = ("00" + (0 <= be ? be : 0)).slice(-2) + ":" + ("00" + (0 <= Fe ? Fe : 0)).slice(-2) + ":" + ("00" + (0 <= Ue ? Ue : 0)).slice(-2), be == -1 && Fe == -1 && Ue == -1 ? Ne : re == -1 && me == -1 && le == -1 ? F : Ne + "T" + F;
        }(a.dateNF, A.match(R) || []), I = 1), a.cellDates ? (M.t = "d", M.v = Br(A, I)) : (M.t = "n", M.v = on(Br(A, I))), a.cellText !== !1 && (M.w = dn(M.z, M.v instanceof Date ? on(M.v) : M.v)), a.cellNF || delete M.z) : (M.t = "s", M.v = A) : (!(M.t = "n") !== a.cellText && (M.w = A), M.v = m), M.t == "z" || (a.dense ? (d[u] || (d[u] = []), d[u][p] = M) : d[$t({ c: p, r: u })] = M), f = E + 1, y = t.charCodeAt(f), _.e.c < p && (_.e.c = p), _.e.r < u && (_.e.r = u), v != b)
          return p = 0, ++u, a.sheetRows && a.sheetRows <= u ? 1 : void 0;
        ++p;
      }
      e:
        for (; E < t.length; ++E)
          switch (v = t.charCodeAt(E)) {
            case 34:
              y === 34 && (T = !T);
              break;
            case b:
            case 10:
            case 13:
              if (!T && P())
                break e;
          }
      return 0 < E - f && P(), d["!ref"] = Xt(_), d;
    }
    function AC(t, n) {
      return !n || !n.PRN || n.FS || t.slice(0, 4) == "sep=" || 0 <= t.indexOf("	") || 0 <= t.indexOf(",") || 0 <= t.indexOf(";") ? NC(t, n) : Pi(function(a, l) {
        var d = l || {}, _ = [];
        if (!a || a.length === 0)
          return _;
        for (var u = a.split(/[\r\n]/), p = u.length - 1; 0 <= p && u[p].length === 0; )
          --p;
        for (var m = 10, f = 0, E = 0; E <= p; ++E)
          (f = u[E].indexOf(" ")) == -1 ? f = u[E].length : f++, m = Math.max(m, f);
        for (E = 0; E <= p; ++E) {
          _[E] = [];
          var b = 0;
          for (Ag(u[E].slice(0, m).trim(), _, E, b, d), b = 1; b <= (u[E].length - m) / 10 + 1; ++b)
            Ag(u[E].slice(m + 10 * (b - 1), m + 10 * b).trim(), _, E, b, d);
        }
        return _ = d.sheetRows ? _.slice(0, d.sheetRows) : _;
      }(t, n), n);
    }
    function yg(t, n) {
      var a = "", l = n.type == "string" ? [0, 0, 0, 0] : Gc(t, n);
      switch (n.type) {
        case "base64":
          a = H(t);
          break;
        case "binary":
          a = t;
          break;
        case "buffer":
          a = n.codepage == 65001 ? t.toString("utf8") : n.codepage && e !== void 0 ? e.utils.decode(n.codepage, t) : K && Buffer.isBuffer(t) ? t.toString("binary") : ye(t);
          break;
        case "array":
          a = Va(t);
          break;
        case "string":
          a = t;
          break;
        default:
          throw new Error("Unrecognized type " + n.type);
      }
      return l[0] == 239 && l[1] == 187 && l[2] == 191 ? a = Cr(a.slice(3)) : n.type != "string" && n.type != "buffer" && n.codepage == 65001 ? a = Cr(a) : n.type == "binary" && e !== void 0 && n.codepage && (a = e.utils.decode(n.codepage, e.utils.encode(28591, a))), a.slice(0, 19) == "socialcalc:version:" ? Rg.to_sheet(n.type == "string" ? a : Cr(a), n) : AC(a, n);
    }
    var Ds, pc, mc, Ig, mi = (Ds = { 51: ["FALSE", 0], 52: ["TRUE", 0], 70: ["LEN", 1], 80: ["SUM", 69], 81: ["AVERAGEA", 69], 82: ["COUNTA", 69], 83: ["MINA", 69], 84: ["MAXA", 69], 111: ["T", 1] }, pc = ["", "", "", "", "", "", "", "", "", "+", "-", "*", "/", "^", "=", "<>", "<=", ">=", "<", ">", "", "", "", "", "&", "", "", "", "", "", "", ""], mc = { 0: { n: "BOF", f: sn }, 1: { n: "EOF" }, 2: { n: "CALCMODE" }, 3: { n: "CALCORDER" }, 4: { n: "SPLIT" }, 5: { n: "SYNC" }, 6: { n: "RANGE", f: function(t, n, a) {
      var l = { s: { c: 0, r: 0 }, e: { c: 0, r: 0 } };
      return n == 8 && a.qpro ? (l.s.c = t.read_shift(1), t.l++, l.s.r = t.read_shift(2), l.e.c = t.read_shift(1), t.l++, l.e.r = t.read_shift(2)) : (l.s.c = t.read_shift(2), l.s.r = t.read_shift(2), n == 12 && a.qpro && (t.l += 2), l.e.c = t.read_shift(2), l.e.r = t.read_shift(2), n == 12 && a.qpro && (t.l += 2), l.s.c == 65535 && (l.s.c = l.e.c = l.s.r = l.e.r = 0)), l;
    } }, 7: { n: "WINDOW1" }, 8: { n: "COLW1" }, 9: { n: "WINTWO" }, 10: { n: "COLW2" }, 11: { n: "NAME" }, 12: { n: "BLANK" }, 13: { n: "INTEGER", f: function(t, n, a) {
      return (a = ws(t, 0, a))[1].v = t.read_shift(2, "i"), a;
    } }, 14: { n: "NUMBER", f: function(t, n, a) {
      return (a = ws(t, 0, a))[1].v = t.read_shift(8, "f"), a;
    } }, 15: { n: "LABEL", f: wg }, 16: { n: "FORMULA", f: function(t, n, a) {
      var l = t.l + n;
      return (n = ws(t, 0, a))[1].v = t.read_shift(8, "f"), a.qpro ? t.l = l : (l = t.read_shift(2), function(d, _) {
        Nn(d, 0);
        for (var u = [], p = 0, m = "", f = "", E = "", b = ""; d.l < d.length; ) {
          var T = d[d.l++];
          switch (T) {
            case 0:
              u.push(d.read_shift(8, "f"));
              break;
            case 1:
              f = Gi(_[0].c, d.read_shift(2), !0), m = Gi(_[0].r, d.read_shift(2), !1), u.push(f + m);
              break;
            case 2:
              var v = Gi(_[0].c, d.read_shift(2), !0), y = Gi(_[0].r, d.read_shift(2), !1);
              f = Gi(_[0].c, d.read_shift(2), !0), m = Gi(_[0].r, d.read_shift(2), !1), u.push(v + y + ":" + f + m);
              break;
            case 3:
              if (d.l < d.length)
                return console.error("WK1 premature formula end");
              break;
            case 4:
              u.push("(" + u.pop() + ")");
              break;
            case 5:
              u.push(d.read_shift(2));
              break;
            case 6:
              for (var R = ""; T = d[d.l++]; )
                R += String.fromCharCode(T);
              u.push('"' + R.replace(/"/g, '""') + '"');
              break;
            case 8:
              u.push("-" + u.pop());
              break;
            case 23:
              u.push("+" + u.pop());
              break;
            case 22:
              u.push("NOT(" + u.pop() + ")");
              break;
            case 20:
            case 21:
              b = u.pop(), E = u.pop(), u.push(["AND", "OR"][T - 20] + "(" + E + "," + b + ")");
              break;
            default:
              if (T < 32 && pc[T])
                b = u.pop(), E = u.pop(), u.push(E + pc[T] + b);
              else {
                if (!Ds[T])
                  return T <= 7 ? console.error("WK1 invalid opcode " + T.toString(16)) : T <= 24 ? console.error("WK1 unsupported op " + T.toString(16)) : T <= 30 ? console.error("WK1 invalid opcode " + T.toString(16)) : T <= 115 ? console.error("WK1 unsupported function opcode " + T.toString(16)) : console.error("WK1 unrecognized opcode " + T.toString(16));
                if ((p = (p = Ds[T][1]) == 69 ? d[d.l++] : p) > u.length)
                  return console.error("WK1 bad formula parse 0x" + T.toString(16) + ":|" + u.join("|") + "|");
                y = u.slice(-p), u.length -= p, u.push(Ds[T][0] + "(" + y.join(",") + ")");
              }
          }
        }
        u.length == 1 ? _[1].f = "" + u[0] : console.error("WK1 bad formula parse |" + u.join("|") + "|");
      }(t.slice(t.l, t.l + l), n), t.l += l), n;
    } }, 24: { n: "TABLE" }, 25: { n: "ORANGE" }, 26: { n: "PRANGE" }, 27: { n: "SRANGE" }, 28: { n: "FRANGE" }, 29: { n: "KRANGE1" }, 32: { n: "HRANGE" }, 35: { n: "KRANGE2" }, 36: { n: "PROTEC" }, 37: { n: "FOOTER" }, 38: { n: "HEADER" }, 39: { n: "SETUP" }, 40: { n: "MARGINS" }, 41: { n: "LABELFMT" }, 42: { n: "TITLES" }, 43: { n: "SHEETJS" }, 45: { n: "GRAPH" }, 46: { n: "NGRAPH" }, 47: { n: "CALCCOUNT" }, 48: { n: "UNFORMATTED" }, 49: { n: "CURSORW12" }, 50: { n: "WINDOW" }, 51: { n: "STRING", f: wg }, 55: { n: "PASSWORD" }, 56: { n: "LOCKED" }, 60: { n: "QUERY" }, 61: { n: "QUERYNAME" }, 62: { n: "PRINT" }, 63: { n: "PRINTNAME" }, 64: { n: "GRAPH2" }, 65: { n: "GRAPHNAME" }, 66: { n: "ZOOM" }, 67: { n: "SYMSPLIT" }, 68: { n: "NSROWS" }, 69: { n: "NSCOLS" }, 70: { n: "RULER" }, 71: { n: "NNAME" }, 72: { n: "ACOMM" }, 73: { n: "AMACRO" }, 74: { n: "PARSE" }, 102: { n: "PRANGES??" }, 103: { n: "RRANGES??" }, 104: { n: "FNAME??" }, 105: { n: "MRANGES??" }, 204: { n: "SHEETNAMECS", f: Mg }, 222: { n: "SHEETNAMELP", f: function(t, n) {
      var a = t[t.l++];
      n - 1 < a && (a = n - 1);
      for (var l = ""; l.length < a; )
        l += String.fromCharCode(t[t.l++]);
      return l;
    } }, 65535: { n: "" } }, Ig = { 0: { n: "BOF" }, 1: { n: "EOF" }, 2: { n: "PASSWORD" }, 3: { n: "CALCSET" }, 4: { n: "WINDOWSET" }, 5: { n: "SHEETCELLPTR" }, 6: { n: "SHEETLAYOUT" }, 7: { n: "COLUMNWIDTH" }, 8: { n: "HIDDENCOLUMN" }, 9: { n: "USERRANGE" }, 10: { n: "SYSTEMRANGE" }, 11: { n: "ZEROFORCE" }, 12: { n: "SORTKEYDIR" }, 13: { n: "FILESEAL" }, 14: { n: "DATAFILLNUMS" }, 15: { n: "PRINTMAIN" }, 16: { n: "PRINTSTRING" }, 17: { n: "GRAPHMAIN" }, 18: { n: "GRAPHSTRING" }, 19: { n: "??" }, 20: { n: "ERRCELL" }, 21: { n: "NACELL" }, 22: { n: "LABEL16", f: function(t, n) {
      var a = No(t);
      return a[1].t = "s", a[1].v = t.read_shift(n - 4, "cstr"), a;
    } }, 23: { n: "NUMBER17", f: xg }, 24: { n: "NUMBER18", f: function(t, n) {
      var a = No(t);
      a[1].v = t.read_shift(2);
      var l = a[1].v >> 1;
      if (1 & a[1].v)
        switch (7 & l) {
          case 0:
            l = 5e3 * (l >> 3);
            break;
          case 1:
            l = 500 * (l >> 3);
            break;
          case 2:
            l = (l >> 3) / 20;
            break;
          case 3:
            l = (l >> 3) / 200;
            break;
          case 4:
            l = (l >> 3) / 2e3;
            break;
          case 5:
            l = (l >> 3) / 2e4;
            break;
          case 6:
            l = (l >> 3) / 16;
            break;
          case 7:
            l = (l >> 3) / 64;
        }
      return a[1].v = l, a;
    } }, 25: { n: "FORMULA19", f: function(t, n) {
      var a = xg(t);
      return t.l += n - 14, a;
    } }, 26: { n: "FORMULA1A" }, 27: { n: "XFORMAT", f: function(t, n) {
      for (var a = {}, l = t.l + n; t.l < l; ) {
        var d = t.read_shift(2);
        if (d == 14e3) {
          for (a[d] = [0, ""], a[d][0] = t.read_shift(2); t[t.l]; )
            a[d][1] += String.fromCharCode(t[t.l]), t.l++;
          t.l++;
        }
      }
      return a;
    } }, 28: { n: "DTLABELMISC" }, 29: { n: "DTLABELCELL" }, 30: { n: "GRAPHWINDOW" }, 31: { n: "CPA" }, 32: { n: "LPLAUTO" }, 33: { n: "QUERY" }, 34: { n: "HIDDENSHEET" }, 35: { n: "??" }, 37: { n: "NUMBER25", f: function(l, n) {
      var a = No(l), l = l.read_shift(4);
      return a[1].v = l >> 6, a;
    } }, 38: { n: "??" }, 39: { n: "NUMBER27", f: Lg }, 40: { n: "FORMULA28", f: function(t, n) {
      var a = Lg(t);
      return t.l += n - 10, a;
    } }, 142: { n: "??" }, 147: { n: "??" }, 150: { n: "??" }, 151: { n: "??" }, 152: { n: "??" }, 153: { n: "??" }, 154: { n: "??" }, 155: { n: "??" }, 156: { n: "??" }, 163: { n: "??" }, 174: { n: "??" }, 175: { n: "??" }, 176: { n: "??" }, 177: { n: "??" }, 184: { n: "??" }, 185: { n: "??" }, 186: { n: "??" }, 187: { n: "??" }, 188: { n: "??" }, 195: { n: "??" }, 201: { n: "??" }, 204: { n: "SHEETNAMECS", f: Mg }, 205: { n: "??" }, 206: { n: "??" }, 207: { n: "??" }, 208: { n: "??" }, 256: { n: "??" }, 259: { n: "??" }, 260: { n: "??" }, 261: { n: "??" }, 262: { n: "??" }, 263: { n: "??" }, 265: { n: "??" }, 266: { n: "??" }, 267: { n: "??" }, 268: { n: "??" }, 270: { n: "??" }, 271: { n: "??" }, 384: { n: "??" }, 389: { n: "??" }, 390: { n: "??" }, 393: { n: "??" }, 396: { n: "??" }, 512: { n: "??" }, 514: { n: "??" }, 513: { n: "??" }, 516: { n: "??" }, 517: { n: "??" }, 640: { n: "??" }, 641: { n: "??" }, 642: { n: "??" }, 643: { n: "??" }, 644: { n: "??" }, 645: { n: "??" }, 646: { n: "??" }, 647: { n: "??" }, 648: { n: "??" }, 658: { n: "??" }, 659: { n: "??" }, 660: { n: "??" }, 661: { n: "??" }, 662: { n: "??" }, 665: { n: "??" }, 666: { n: "??" }, 768: { n: "??" }, 772: { n: "??" }, 1537: { n: "SHEETINFOQP", f: function(t, n, a) {
      if (a.qpro && !(n < 21))
        return a = t.read_shift(1), t.l += 17, t.l += 1, t.l += 2, [a, t.read_shift(n - 21, "cstr")];
    } }, 1600: { n: "??" }, 1602: { n: "??" }, 1793: { n: "??" }, 1794: { n: "??" }, 1795: { n: "??" }, 1796: { n: "??" }, 1920: { n: "??" }, 2048: { n: "??" }, 2049: { n: "??" }, 2052: { n: "??" }, 2688: { n: "??" }, 10998: { n: "??" }, 12849: { n: "??" }, 28233: { n: "??" }, 28484: { n: "??" }, 65535: { n: "" } }, { sheet_to_wk1: function(t, n) {
      var a = n || {};
      if (0 <= +a.codepage && N(+a.codepage), a.type == "string")
        throw new Error("Cannot write WK1 to JS string");
      var l = Wn(), d = lr(t["!ref"]), _ = Array.isArray(t), u = [];
      ot(l, 0, (n = 1030, (a = Me(2)).write_shift(2, n), a)), ot(l, 6, (n = d, (a = Me(8)).write_shift(2, n.s.c), a.write_shift(2, n.s.r), a.write_shift(2, n.e.c), a.write_shift(2, n.e.r), a));
      for (var p, m, f, E, b = Math.min(d.e.r, 8191), T = d.s.r; T <= b; ++T)
        for (var v = Xr(T), y = d.s.c; y <= d.e.c; ++y) {
          T === d.s.r && (u[y] = Vr(y));
          var R = u[y] + v, R = _ ? (t[T] || [])[y] : t[R];
          R && R.t != "z" && (R.t == "n" ? (0 | R.v) == R.v && -32768 <= R.v && R.v <= 32767 ? ot(l, 13, (p = T, m = y, f = R.v, E = void 0, (E = Me(7)).write_shift(1, 255), E.write_shift(2, m), E.write_shift(2, p), E.write_shift(2, f, "i"), E)) : ot(l, 14, (m = T, p = y, f = R.v, E = void 0, (E = Me(13)).write_shift(1, 255), E.write_shift(2, p), E.write_shift(2, m), E.write_shift(8, f, "f"), E)) : ot(l, 15, function(P, I, A) {
            var M = Me(7 + A.length);
            M.write_shift(1, 255), M.write_shift(2, I), M.write_shift(2, P), M.write_shift(1, 39);
            for (var F = 0; F < M.length; ++F) {
              var B = A.charCodeAt(F);
              M.write_shift(1, 128 <= B ? 95 : B);
            }
            return M.write_shift(1, 0), M;
          }(T, y, Ea(R).slice(0, 239))));
        }
      return ot(l, 1), l.end();
    }, book_to_wk3: function(t, n) {
      if (0 <= +(n = n || {}).codepage && N(+n.codepage), n.type == "string")
        throw new Error("Cannot write WK3 to JS string");
      var a = Wn();
      ot(a, 0, function(R) {
        var P = Me(26);
        P.write_shift(2, 4096), P.write_shift(2, 4), P.write_shift(4, 0);
        for (var I = 0, A = 0, M = 0, F = 0; F < R.SheetNames.length; ++F) {
          var B = R.SheetNames[F], B = R.Sheets[B];
          B && B["!ref"] && (++M, B = Un(B["!ref"]), I < B.e.r && (I = B.e.r), A < B.e.c && (A = B.e.c));
        }
        return 8191 < I && (I = 8191), P.write_shift(2, I), P.write_shift(1, M), P.write_shift(1, A), P.write_shift(2, 0), P.write_shift(2, 0), P.write_shift(1, 1), P.write_shift(1, 2), P.write_shift(4, 0), P.write_shift(4, 0), P;
      }(t));
      for (var l = 0, d = 0; l < t.SheetNames.length; ++l)
        (t.Sheets[t.SheetNames[l]] || {})["!ref"] && ot(a, 27, function(R, P) {
          var I = Me(5 + R.length);
          I.write_shift(2, 14e3), I.write_shift(2, P);
          for (var A = 0; A < R.length; ++A) {
            var M = R.charCodeAt(A);
            I[I.l++] = 127 < M ? 95 : M;
          }
          return I[I.l++] = 0, I;
        }(t.SheetNames[l], d++));
      for (var _ = 0, l = 0; l < t.SheetNames.length; ++l) {
        var u = t.Sheets[t.SheetNames[l]];
        if (u && u["!ref"]) {
          for (var p = lr(u["!ref"]), m = Array.isArray(u), f = [], E = Math.min(p.e.r, 8191), b = p.s.r; b <= E; ++b)
            for (var T = Xr(b), v = p.s.c; v <= p.e.c; ++v) {
              b === p.s.r && (f[v] = Vr(v));
              var y = f[v] + T, y = m ? (u[b] || [])[v] : u[y];
              y && y.t != "z" && (y.t == "n" ? ot(a, 23, function(re, le, me, M) {
                var F = Me(14);
                if (F.write_shift(2, re), F.write_shift(1, me), F.write_shift(1, le), M == 0)
                  return F.write_shift(4, 0), F.write_shift(4, 0), F.write_shift(2, 65535), F;
                var B = 0, re = 0, me = 0, le = 0;
                return M < 0 && (B = 1, M = -M), re = 0 | Math.log2(M), M /= Math.pow(2, re - 31), !(2147483648 & (le = M >>> 0)) && (++re, le = (M /= 2) >>> 0), M -= le, le |= 2147483648, le >>>= 0, M *= Math.pow(2, 32), me = M >>> 0, F.write_shift(4, me), F.write_shift(4, le), re += 16383 + (B ? 32768 : 0), F.write_shift(2, re), F;
              }(b, v, _, y.v)) : ot(a, 22, function(P, I, A, M) {
                var F = Me(6 + M.length);
                F.write_shift(2, P), F.write_shift(1, A), F.write_shift(1, I), F.write_shift(1, 39);
                for (var B = 0; B < M.length; ++B) {
                  var re = M.charCodeAt(B);
                  F.write_shift(1, 128 <= re ? 95 : re);
                }
                return F.write_shift(1, 0), F;
              }(b, v, _, Ea(y).slice(0, 239))));
            }
          ++_;
        }
      }
      return ot(a, 1), a.end();
    }, to_workbook: function(t, n) {
      switch (n.type) {
        case "base64":
          return fc(Pe(H(t)), n);
        case "binary":
          return fc(Pe(t), n);
        case "buffer":
        case "array":
          return fc(t, n);
      }
      throw "Unsupported type " + n.type;
    } });
    function Dg(t, n, a) {
      if (t) {
        Nn(t, t.l || 0);
        for (var l = a.Enum || mc; t.l < t.length; ) {
          var d = t.read_shift(2), _ = l[d] || l[65535], p = t.read_shift(2), u = t.l + p, p = _.f && _.f(t, p, a);
          if (t.l = u, n(p, _, d))
            return;
        }
      }
    }
    function fc(t, n) {
      if (!t)
        return t;
      var a = n || {}, l = a.dense ? [] : {}, d = "Sheet1", _ = "", u = 0, p = {}, m = [], f = [], E = { s: { r: 0, c: 0 }, e: { r: 0, c: 0 } }, b = a.sheetRows || 0;
      if (t[2] == 0 && (t[3] == 8 || t[3] == 9) && 16 <= t.length && t[14] == 5 && t[15] === 108)
        throw new Error("Unsupported Works 3 for Mac file");
      if (t[2] == 2)
        a.Enum = mc, Dg(t, function(R, P, I) {
          switch (I) {
            case 0:
              4096 <= (a.vers = R) && (a.qpro = !0);
              break;
            case 6:
              E = R;
              break;
            case 204:
              R && (_ = R);
              break;
            case 222:
              _ = R;
              break;
            case 15:
            case 51:
              a.qpro || (R[1].v = R[1].v.slice(1));
            case 13:
            case 14:
            case 16:
              I == 14 && (112 & R[2]) == 112 && 1 < (15 & R[2]) && (15 & R[2]) < 15 && (R[1].z = a.dateNF || ae[14], a.cellDates && (R[1].t = "d", R[1].v = lo(R[1].v))), a.qpro && R[3] > u && (l["!ref"] = Xt(E), p[d] = l, m.push(d), l = a.dense ? [] : {}, E = { s: { r: 0, c: 0 }, e: { r: 0, c: 0 } }, u = R[3], d = _ || "Sheet" + (u + 1), _ = "");
              var A = a.dense ? (l[R[0].r] || [])[R[0].c] : l[$t(R[0])];
              if (A) {
                A.t = R[1].t, A.v = R[1].v, R[1].z != null && (A.z = R[1].z), R[1].f != null && (A.f = R[1].f);
                break;
              }
              a.dense ? (l[R[0].r] || (l[R[0].r] = []), l[R[0].r][R[0].c] = R[1]) : l[$t(R[0])] = R[1];
          }
        }, a);
      else {
        if (t[2] != 26 && t[2] != 14)
          throw new Error("Unrecognized LOTUS BOF " + t[2]);
        a.Enum = Ig, t[2] == 14 && (a.qpro = !0, t.l = 0), Dg(t, function(R, P, I) {
          switch (I) {
            case 204:
              d = R;
              break;
            case 22:
              R[1].v = R[1].v.slice(1);
            case 23:
            case 24:
            case 25:
            case 37:
            case 39:
            case 40:
              if (R[3] > u && (l["!ref"] = Xt(E), p[d] = l, m.push(d), l = a.dense ? [] : {}, E = { s: { r: 0, c: 0 }, e: { r: 0, c: 0 } }, u = R[3], d = "Sheet" + (u + 1)), 0 < b && R[0].r >= b)
                break;
              a.dense ? (l[R[0].r] || (l[R[0].r] = []), l[R[0].r][R[0].c] = R[1]) : l[$t(R[0])] = R[1], E.e.c < R[0].c && (E.e.c = R[0].c), E.e.r < R[0].r && (E.e.r = R[0].r);
              break;
            case 27:
              R[14e3] && (f[R[14e3][0]] = R[14e3][1]);
              break;
            case 1537:
              f[R[0]] = R[1], R[0] == u && (d = R[1]);
          }
        }, a);
      }
      if (l["!ref"] = Xt(E), p[_ || d] = l, m.push(_ || d), !f.length)
        return { SheetNames: m, Sheets: p };
      for (var T = {}, v = [], y = 0; y < f.length; ++y)
        p[m[y]] ? (v.push(f[y] || m[y]), T[f[y]] = p[f[y]] || p[m[y]]) : (v.push(f[y]), T[f[y]] = { "!ref": "A1" });
      return { SheetNames: v, Sheets: T };
    }
    function ws(t, n, a) {
      var l = [{ c: 0, r: 0 }, { t: "n", v: 0 }, 0, 0];
      return a.qpro && a.vers != 20768 ? (l[0].c = t.read_shift(1), l[3] = t.read_shift(1), l[0].r = t.read_shift(2), t.l += 2) : (l[2] = t.read_shift(1), l[0].c = t.read_shift(2), l[0].r = t.read_shift(2)), l;
    }
    function wg(t, d, a) {
      var l = t.l + d, d = ws(t, 0, a);
      return d[1].t = "s", a.vers != 20768 ? (a.qpro && t.l++, d[1].v = t.read_shift(l - t.l, "cstr"), d) : (t.l++, l = t.read_shift(1), d[1].v = t.read_shift(l, "utf8"), d);
    }
    function Gi(t, n, a) {
      var l = 32768 & n;
      return (l ? "" : "$") + (a ? Vr : Xr)(n = (l ? t : 0) + (8192 <= (n &= -32769) ? n - 16384 : n));
    }
    function No(t) {
      var n = [{ c: 0, r: 0 }, { t: "n", v: 0 }, 0];
      return n[0].r = t.read_shift(2), n[3] = t[t.l++], n[0].c = t[t.l++], n;
    }
    function xg(_, n) {
      var a = No(_), l = _.read_shift(4), d = _.read_shift(4);
      if ((u = _.read_shift(2)) == 65535)
        return l === 0 && d === 3221225472 ? (a[1].t = "e", a[1].v = 15) : l === 0 && d === 3489660928 ? (a[1].t = "e", a[1].v = 42) : a[1].v = 0, a;
      var _ = 32768 & u, u = (32767 & u) - 16446;
      return a[1].v = (1 - 2 * _) * (d * Math.pow(2, 32 + u) + l * Math.pow(2, u)), a;
    }
    function Lg(l, n) {
      var a = No(l), l = l.read_shift(8, "f");
      return a[1].v = l, a;
    }
    function Mg(t, n) {
      return t[t.l + n - 1] == 0 ? t.read_shift(n, "cstr") : "";
    }
    var Pg, kg, Fg, Ug, OC = (Pg = Ya("t"), kg = Ya("rPr"), Fg = /<(?:\w+:)?r>/g, Ug = /<\/(?:\w+:)?r>/, function(t) {
      return t.replace(Fg, "").split(Ug).map(yC).filter(function(n) {
        return n.v;
      });
    });
    function yC(t) {
      var n = t.match(Pg);
      return n ? (n = { t: "s", v: mr(n[1]) }, t = t.match(kg), t && (n.s = function(a) {
        var l = {}, d = a.match(Cn), _ = 0, u = !1;
        if (d)
          for (; _ != d.length; ++_) {
            var p = Ht(d[_]);
            switch (p[0].replace(/\w*:/g, "")) {
              case "<condense":
              case "<extend":
                break;
              case "<shadow":
                if (!p.val)
                  break;
              case "<shadow>":
              case "<shadow/>":
                l.shadow = 1;
                break;
              case "</shadow>":
                break;
              case "<charset":
                if (p.val == "1")
                  break;
                l.cp = C[parseInt(p.val, 10)];
                break;
              case "<outline":
                if (!p.val)
                  break;
              case "<outline>":
              case "<outline/>":
                l.outline = 1;
                break;
              case "</outline>":
                break;
              case "<rFont":
                l.name = p.val;
                break;
              case "<sz":
                l.sz = p.val;
                break;
              case "<strike":
                if (!p.val)
                  break;
              case "<strike>":
              case "<strike/>":
                l.strike = 1;
                break;
              case "</strike>":
                break;
              case "<u":
                if (!p.val)
                  break;
                switch (p.val) {
                  case "double":
                    l.uval = "double";
                    break;
                  case "singleAccounting":
                    l.uval = "single-accounting";
                    break;
                  case "doubleAccounting":
                    l.uval = "double-accounting";
                }
              case "<u>":
              case "<u/>":
                l.u = 1;
                break;
              case "</u>":
                break;
              case "<b":
                if (p.val == "0")
                  break;
              case "<b>":
              case "<b/>":
                l.b = 1;
                break;
              case "</b>":
                break;
              case "<i":
                if (p.val == "0")
                  break;
              case "<i>":
              case "<i/>":
                l.i = 1;
                break;
              case "</i>":
                break;
              case "<color":
                p.rgb && (l.color = p.rgb.slice(2, 8));
                break;
              case "<color>":
              case "<color/>":
              case "</color>":
                break;
              case "<family":
                l.family = p.val;
                break;
              case "<family>":
              case "<family/>":
              case "</family>":
                break;
              case "<vertAlign":
                l.valign = p.val;
                break;
              case "<vertAlign>":
              case "<vertAlign/>":
              case "</vertAlign>":
              case "<scheme":
                break;
              case "<scheme>":
              case "<scheme/>":
              case "</scheme>":
                break;
              case "<extLst":
              case "<extLst>":
              case "</extLst>":
                break;
              case "<ext":
                u = !0;
                break;
              case "</ext>":
                u = !1;
                break;
              default:
                if (p[0].charCodeAt(1) !== 47 && !u)
                  throw new Error("Unrecognized rich format " + p[0]);
            }
          }
        return l;
      }(t[1])), n) : { t: "s", v: "" };
    }
    var Bg, IC = (Bg = /(\r\n|\n)/g, function(t) {
      return t.map(DC).join("");
    });
    function DC(t) {
      var n, a, l, d = [[], t.v, []];
      return t.v ? (t.s && (n = t.s, a = d[0], l = d[2], t = [], n.u && t.push("text-decoration: underline;"), n.uval && t.push("text-underline-style:" + n.uval + ";"), n.sz && t.push("font-size:" + n.sz + "pt;"), n.outline && t.push("text-effect: outline;"), n.shadow && t.push("text-shadow: auto;"), a.push('<span style="' + t.join("") + '">'), n.b && (a.push("<b>"), l.push("</b>")), n.i && (a.push("<i>"), l.push("</i>")), n.strike && (a.push("<s>"), l.push("</s>")), (t = n.valign || "") == "superscript" || t == "super" ? t = "sup" : t == "subscript" && (t = "sub"), t != "" && (a.push("<" + t + ">"), l.push("</" + t + ">")), l.push("</span>")), d[0].join("") + d[1].replace(Bg, "<br/>") + d[2].join("")) : "";
    }
    var wC = /<(?:\w+:)?t[^>]*>([^<]*)<\/(?:\w+:)?t>/g, xC = /<(?:\w+:)?r>/, LC = /<(?:\w+:)?rPh.*?>([\s\S]*?)<\/(?:\w+:)?rPh>/g;
    function gc(t, l) {
      var a = !l || l.cellHTML, l = {};
      return t ? (t.match(/^\s*<(?:\w+:)?t[^>]*>/) ? (l.t = mr(Cr(t.slice(t.indexOf(">") + 1).split(/<\/(?:\w+:)?t>/)[0] || "")), l.r = Cr(t), a && (l.h = uo(l.t))) : t.match(xC) && (l.r = Cr(t), l.t = mr(Cr((t.replace(LC, "").match(wC) || []).join("").replace(Cn, ""))), a && (l.h = IC(OC(l.r)))), l) : { t: "" };
    }
    var MC = /<(?:\w+:)?sst([^>]*)>([\s\S]*)<\/(?:\w+:)?sst>/, PC = /<(?:\w+:)?(?:si|sstItem)>/g, kC = /<\/(?:\w+:)?(?:si|sstItem)>/, FC = /^\s|\s$|[\t\n\r]/;
    function Gg(t, n) {
      if (!n.bookSST)
        return "";
      var a = [Qr];
      a[a.length] = it("sst", null, { xmlns: ai[0], count: t.Count, uniqueCount: t.Unique });
      for (var l, d, _ = 0; _ != t.length; ++_)
        t[_] != null && (d = "<si>", (l = t[_]).r ? d += l.r : (d += "<t", l.t || (l.t = ""), l.t.match(FC) && (d += ' xml:space="preserve"'), d += ">" + Ar(l.t) + "</t>"), d += "</si>", a[a.length] = d);
      return 2 < a.length && (a[a.length] = "</sst>", a[1] = a[1].replace("/>", ">")), a.join("");
    }
    var UC = function(t, n) {
      var a = !1;
      return n == null && (a = !0, n = Me(15 + 4 * t.t.length)), n.write_shift(1, 0), Sn(t.t, n), a ? n.slice(0, n.l) : n;
    };
    function BC(t) {
      var n, a, l = Wn();
      He(l, 159, (n = t, (a = a || Me(8)).write_shift(4, n.Count), a.write_shift(4, n.Unique), a));
      for (var d = 0; d < t.length; ++d)
        He(l, 19, UC(t[d]));
      return He(l, 160), l.end();
    }
    function Vg(t) {
      if (e !== void 0)
        return e.utils.encode(h, t);
      for (var n = [], a = t.split(""), l = 0; l < a.length; ++l)
        n[l] = a[l].charCodeAt(0);
      return n;
    }
    function Ma(t, n) {
      var a = {};
      return a.Major = t.read_shift(2), a.Minor = t.read_shift(2), 4 <= n && (t.l += n - 4), a;
    }
    function GC(t) {
      var n = [];
      t.l += 4;
      for (var a = t.read_shift(4); 0 < a--; )
        n.push(function(l) {
          for (var _ = l.read_shift(4), d = l.l + _ - 4, _ = {}, u = l.read_shift(4), p = []; 0 < u--; )
            p.push({ t: l.read_shift(4), v: l.read_shift(0, "lpp4") });
          if (_.name = l.read_shift(0, "lpp4"), _.comps = p, l.l != d)
            throw new Error("Bad DataSpaceMapEntry: " + l.l + " != " + d);
          return _;
        }(t));
      return n;
    }
    function VC(t) {
      var n, a, a = (a = {}, (n = t).read_shift(4), n.l += 4, a.id = n.read_shift(0, "lpp4"), a.name = n.read_shift(0, "lpp4"), a.R = Ma(n, 4), a.U = Ma(n, 4), a.W = Ma(n, 4), a);
      if (a.ename = t.read_shift(0, "8lpp4"), a.blksz = t.read_shift(4), a.cmode = t.read_shift(4), t.read_shift(4) != 4)
        throw new Error("Bad !Primary record");
      return a;
    }
    function Yg(t, a) {
      var a = t.l + a, l = {};
      l.Flags = 63 & t.read_shift(4), t.l += 4, l.AlgID = t.read_shift(4);
      var d = !1;
      switch (l.AlgID) {
        case 26126:
        case 26127:
        case 26128:
          d = l.Flags == 36;
          break;
        case 26625:
          d = l.Flags == 4;
          break;
        case 0:
          d = l.Flags == 16 || l.Flags == 4 || l.Flags == 36;
          break;
        default:
          throw "Unrecognized encryption algorithm: " + l.AlgID;
      }
      if (!d)
        throw new Error("Encryption Flags/AlgID mismatch");
      return l.AlgIDHash = t.read_shift(4), l.KeySize = t.read_shift(4), l.ProviderType = t.read_shift(4), t.l += 8, l.CSPName = t.read_shift(a - t.l >> 1, "utf16le"), t.l = a, l;
    }
    function Hg(t, l) {
      var a = {}, l = t.l + l;
      return t.l += 4, a.Salt = t.slice(t.l, t.l + 16), t.l += 16, a.Verifier = t.slice(t.l, t.l + 16), t.l += 16, t.read_shift(4), a.VerifierHash = t.slice(t.l, l), t.l = l, a;
    }
    function YC(t) {
      var n = Ma(t);
      switch (n.Minor) {
        case 2:
          return [n.Minor, function(d) {
            if ((63 & d.read_shift(4)) != 36)
              throw new Error("EncryptionInfo mismatch");
            var l = d.read_shift(4), l = Yg(d, l), d = Hg(d, d.length - d.l);
            return { t: "Std", h: l, v: d };
          }(t)];
        case 3:
          return [n.Minor, function() {
            throw new Error("File is password-protected: ECMA-376 Extensible");
          }()];
        case 4:
          return [n.Minor, function(d) {
            var l = ["saltSize", "blockSize", "keyBits", "hashSize", "cipherAlgorithm", "cipherChaining", "hashAlgorithm", "saltValue"];
            d.l += 4;
            var d = d.read_shift(d.length - d.l, "utf8"), _ = {};
            return d.replace(Cn, function(u) {
              var p = Ht(u);
              switch (pa(p[0])) {
                case "<?xml":
                  break;
                case "<encryption":
                case "</encryption>":
                  break;
                case "<keyData":
                  l.forEach(function(m) {
                    _[m] = p[m];
                  });
                  break;
                case "<dataIntegrity":
                  _.encryptedHmacKey = p.encryptedHmacKey, _.encryptedHmacValue = p.encryptedHmacValue;
                  break;
                case "<keyEncryptors>":
                case "<keyEncryptors":
                  _.encs = [];
                  break;
                case "</keyEncryptors>":
                  break;
                case "<keyEncryptor":
                  _.uri = p.uri;
                  break;
                case "</keyEncryptor>":
                  break;
                case "<encryptedKey":
                  _.encs.push(p);
                  break;
                default:
                  throw p[0];
              }
            }), _;
          }(t)];
      }
      throw new Error("ECMA-376 Encrypted file unrecognized Version: " + n.Minor);
    }
    function Ec(t) {
      var n, a = 0, l = Vg(t), d = l.length + 1, _ = _e(d);
      for (_[0] = l.length, n = 1; n != d; ++n)
        _[n] = l[n - 1];
      for (n = d - 1; 0 <= n; --n)
        a = ((16384 & a ? 1 : 0) | a << 1 & 32767) ^ _[n];
      return 52811 ^ a;
    }
    var hc, qg, $g, Wg = (hc = [187, 255, 255, 186, 255, 255, 185, 128, 0, 190, 15, 0, 191, 15, 0], qg = [57840, 7439, 52380, 33984, 4364, 3600, 61902, 12606, 6258, 57657, 54287, 34041, 10252, 43370, 20163], $g = [44796, 19929, 39858, 10053, 20106, 40212, 10761, 31585, 63170, 64933, 60267, 50935, 40399, 11199, 17763, 35526, 1453, 2906, 5812, 11624, 23248, 885, 1770, 3540, 7080, 14160, 28320, 56640, 55369, 41139, 20807, 41614, 21821, 43642, 17621, 28485, 56970, 44341, 19019, 38038, 14605, 29210, 60195, 50791, 40175, 10751, 21502, 43004, 24537, 18387, 36774, 3949, 7898, 15796, 31592, 63184, 47201, 24803, 49606, 37805, 14203, 28406, 56812, 17824, 35648, 1697, 3394, 6788, 13576, 27152, 43601, 17539, 35078, 557, 1114, 2228, 4456, 30388, 60776, 51953, 34243, 7079, 14158, 28316, 14128, 28256, 56512, 43425, 17251, 34502, 7597, 13105, 26210, 52420, 35241, 883, 1766, 3532, 4129, 8258, 16516, 33032, 4657, 9314, 18628], function(t) {
      for (var n, a, l = Vg(t), d = function(m) {
        for (var f = qg[m.length - 1], E = 104, b = m.length - 1; 0 <= b; --b)
          for (var T = m[b], v = 0; v != 7; ++v)
            64 & T && (f ^= $g[E]), T *= 2, --E;
        return f;
      }(l), _ = l.length, u = _e(16), p = 0; p != 16; ++p)
        u[p] = 0;
      for ((1 & _) == 1 && (n = d >> 8, u[_] = Vi(hc[0], n), --_, n = 255 & d, t = l[l.length - 1], u[_] = Vi(t, n)); 0 < _; )
        n = d >> 8, u[--_] = Vi(l[_], n), n = 255 & d, u[--_] = Vi(l[_], n);
      for (a = (_ = 15) - l.length; 0 < a; )
        n = d >> 8, u[_] = Vi(hc[a], n), --a, n = 255 & d, u[--_] = Vi(l[_], n), --_, --a;
      return u;
    });
    function Vi(t, n) {
      return 255 & ((n = t ^ n) / 2 | 128 * n);
    }
    var HC = function(t) {
      var n = 0, a = Wg(t);
      return function(l) {
        return l = function(d, _, u, p, m) {
          var f, E;
          for (m = m || _, p = p || Wg(d), f = 0; f != _.length; ++f)
            E = _[f], E = 255 & ((E ^= p[u]) >> 5 | E << 3), m[f] = E, ++u;
          return [m, u, p];
        }("", l, n, a), n = l[1], l[0];
      };
    };
    function qC(t, n, a) {
      return a = a || {}, a.Info = t.read_shift(2), t.l -= 2, a.Info === 1 ? a.Data = function(l) {
        var d = {}, _ = d.EncryptionVersionInfo = Ma(l, 4);
        if (_.Major != 1 || _.Minor != 1)
          throw "unrecognized version code " + _.Major + " : " + _.Minor;
        return d.Salt = l.read_shift(16), d.EncryptedVerifier = l.read_shift(16), d.EncryptedVerifierHash = l.read_shift(16), d;
      }(t) : a.Data = function(l, d) {
        var _ = {}, u = _.EncryptionVersionInfo = Ma(l, 4);
        if (d -= 4, u.Minor != 2)
          throw new Error("unrecognized minor version code: " + u.Minor);
        if (4 < u.Major || u.Major < 2)
          throw new Error("unrecognized major version code: " + u.Major);
        return _.Flags = l.read_shift(4), d -= 4, u = l.read_shift(4), d -= 4, _.EncryptionHeader = Yg(l, u), d -= u, _.EncryptionVerifier = Hg(l, d), _;
      }(t, n), a;
    }
    var zg = { to_workbook: function(t, n) {
      return Ha(Kg(t, n), n);
    }, to_sheet: Kg, from_sheet: function(t) {
      for (var n = ["{\\rtf1\\ansi"], a = lr(t["!ref"]), l = Array.isArray(t), d = a.s.r; d <= a.e.r; ++d) {
        n.push("\\trowd\\trautofit1");
        for (var _ = a.s.c; _ <= a.e.c; ++_)
          n.push("\\cellx" + (_ + 1));
        for (n.push("\\pard\\intbl"), _ = a.s.c; _ <= a.e.c; ++_) {
          var u = $t({ r: d, c: _ });
          (u = l ? (t[d] || [])[_] : t[u]) && (u.v != null || u.f && !u.F) && (n.push(" " + (u.w || (Ea(u), u.w))), n.push("\\cell"));
        }
        n.push("\\pard\\intbl\\row");
      }
      return n.join("") + "}";
    } };
    function Kg(t, n) {
      switch (n.type) {
        case "base64":
          return xs(H(t), n);
        case "binary":
          return xs(t, n);
        case "buffer":
          return xs(K && Buffer.isBuffer(t) ? t.toString("binary") : ye(t), n);
        case "array":
          return xs(Va(t), n);
      }
      throw new Error("Unrecognized type " + n.type);
    }
    function xs(l, n) {
      var a = (n || {}).dense ? [] : {}, l = l.match(/\\trowd.*?\\row\b/g);
      if (!l.length)
        throw new Error("RTF missing table");
      var d = { s: { c: 0, r: 0 }, e: { c: 0, r: l.length - 1 } };
      return l.forEach(function(_, u) {
        Array.isArray(a) && (a[u] = []);
        for (var p, m = /\\\w+\b/g, f = 0, E = -1; p = m.exec(_); )
          p[0] === "\\cell" && (++E, (p = (p = _.slice(f, m.lastIndex - p[0].length))[0] == " " ? p.slice(1) : p).length && (p = { v: p, t: "s" }, Array.isArray(a) ? a[u][E] = p : a[$t({ r: u, c: E })] = p)), f = m.lastIndex;
        E > d.e.c && (d.e.c = E);
      }), a["!ref"] = Xt(d), a;
    }
    function Ao(t) {
      for (var n = 0, a = 1; n != 3; ++n)
        a = 256 * a + (255 < t[n] ? 255 : t[n] < 0 ? 0 : t[n]);
      return a.toString(16).toUpperCase().slice(1);
    }
    function Ls(t, n) {
      return n === 0 ? t : (t = function(E) {
        var l = E[0] / 255, d = E[1] / 255, _ = E[2] / 255, u = Math.max(l, d, _), p = Math.min(l, d, _), m = u - p;
        if (m == 0)
          return [0, 0, l];
        var f = 0, E = 0, E = m / (1 < (p = u + p) ? 2 - p : p);
        switch (u) {
          case l:
            f = ((d - _) / m + 6) % 6;
            break;
          case d:
            f = (_ - l) / m + 2;
            break;
          case _:
            f = (l - d) / m + 4;
        }
        return [f / 6, E, p / 2];
      }((t = (t = t).slice(t[0] === "#" ? 1 : 0).slice(0, 6), [parseInt(t.slice(0, 2), 16), parseInt(t.slice(2, 4), 16), parseInt(t.slice(4, 6), 16)])), t[2] = n < 0 ? t[2] * (1 + n) : 1 - (1 - t[2]) * (1 - n), Ao(function(u) {
        var l, d = u[0], _ = u[1], u = u[2], p = 2 * _ * (u < 0.5 ? u : 1 - u), m = [u = u - p / 2, u, u], f = 6 * d;
        if (_ !== 0)
          switch (0 | f) {
            case 0:
            case 6:
              l = p * f, m[0] += p, m[1] += l;
              break;
            case 1:
              l = p * (2 - f), m[0] += l, m[1] += p;
              break;
            case 2:
              l = p * (f - 2), m[1] += p, m[2] += l;
              break;
            case 3:
              l = p * (4 - f), m[1] += l, m[2] += p;
              break;
            case 4:
              l = p * (f - 4), m[2] += p, m[0] += l;
              break;
            case 5:
              l = p * (6 - f), m[2] += l, m[0] += p;
          }
        for (var E = 0; E != 3; ++E)
          m[E] = Math.round(255 * m[E]);
        return m;
      }(t)));
    }
    var Qg = 6, $C = 15, WC = 1, Ln = Qg;
    function Oo(t) {
      return Math.floor((t + Math.round(128 / Ln) / 256) * Ln);
    }
    function yo(t) {
      return Math.floor((t - 5) / Ln * 100 + 0.5) / 100;
    }
    function Ms(t) {
      return Math.round((t * Ln + 5) / Ln * 256) / 256;
    }
    function Sc(t) {
      return Ms(yo(Oo(t)));
    }
    function bc(t) {
      var n = Math.abs(t - Sc(t)), a = Ln;
      if (5e-3 < n)
        for (Ln = WC; Ln < $C; ++Ln)
          Math.abs(t - Sc(t)) <= n && (n = Math.abs(t - Sc(t)), a = Ln);
      Ln = a;
    }
    function $a(t) {
      t.width ? (t.wpx = Oo(t.width), t.wch = yo(t.wpx), t.MDW = Ln) : t.wpx ? (t.wch = yo(t.wpx), t.width = Ms(t.wch), t.MDW = Ln) : typeof t.wch == "number" && (t.width = Ms(t.wch), t.wpx = Oo(t.width), t.MDW = Ln), t.customWidth && delete t.customWidth;
    }
    var Xg = 96;
    function Io(t) {
      return 96 * t / Xg;
    }
    function Yi(t) {
      return t * Xg / 96;
    }
    var zC = { None: "none", Solid: "solid", Gray50: "mediumGray", Gray75: "darkGray", Gray25: "lightGray", HorzStripe: "darkHorizontal", VertStripe: "darkVertical", ReverseDiagStripe: "darkDown", DiagStripe: "darkUp", DiagCross: "darkGrid", ThickDiagCross: "darkTrellis", ThinHorzStripe: "lightHorizontal", ThinVertStripe: "lightVertical", ThinReverseDiagStripe: "lightDown", ThinHorzCross: "lightGrid" }, Ps = ["numFmtId", "fillId", "fontId", "borderId", "xfId"], ks = ["applyAlignment", "applyBorder", "applyFill", "applyFont", "applyNumberFormat", "applyProtection", "pivotButton", "quotePrefix"], Zg, jg, Jg, eE, tE, Do, KC = (Zg = /<(?:\w+:)?numFmts([^>]*)>[\S\s]*?<\/(?:\w+:)?numFmts>/, jg = /<(?:\w+:)?cellXfs([^>]*)>[\S\s]*?<\/(?:\w+:)?cellXfs>/, Jg = /<(?:\w+:)?fills([^>]*)>[\S\s]*?<\/(?:\w+:)?fills>/, eE = /<(?:\w+:)?fonts([^>]*)>[\S\s]*?<\/(?:\w+:)?fonts>/, tE = /<(?:\w+:)?borders([^>]*)>[\S\s]*?<\/(?:\w+:)?borders>/, function(t, n, a) {
      var l, d, _, u, p, m = {};
      return t && ((l = (t = t.replace(/<!--([\s\S]*?)-->/gm, "").replace(/<!DOCTYPE[^\[]*\[[^\]]*\]>/gm, "")).match(Zg)) && function(f, E, b) {
        E.NumberFmt = [];
        for (var T = $r(ae), v = 0; v < T.length; ++v)
          E.NumberFmt[T[v]] = ae[T[v]];
        var y = f[0].match(Cn);
        if (y)
          for (v = 0; v < y.length; ++v) {
            var R = Ht(y[v]);
            switch (pa(R[0])) {
              case "<numFmts":
              case "</numFmts>":
              case "<numFmts/>":
              case "<numFmts>":
                break;
              case "<numFmt":
                var P = mr(Cr(R.formatCode)), I = parseInt(R.numFmtId, 10);
                if (E.NumberFmt[I] = P, 0 < I) {
                  if (392 < I) {
                    for (I = 392; 60 < I && E.NumberFmt[I] != null; --I)
                      ;
                    E.NumberFmt[I] = P;
                  }
                  Qn(P, I);
                }
                break;
              case "</numFmt>":
                break;
              default:
                if (b.WTF)
                  throw new Error("unrecognized " + R[0] + " in numFmts");
            }
          }
      }(l, m, a), (l = t.match(eE)) && function(f, E, b, T) {
        E.Fonts = [];
        var v = {}, y = !1;
        (f[0].match(Cn) || []).forEach(function(R) {
          var P, I = Ht(R);
          switch (pa(I[0])) {
            case "<fonts":
            case "<fonts>":
            case "</fonts>":
              break;
            case "<font":
            case "<font>":
              break;
            case "</font>":
            case "<font/>":
              E.Fonts.push(v), v = {};
              break;
            case "<name":
              I.val && (v.name = Cr(I.val));
              break;
            case "<name/>":
            case "</name>":
              break;
            case "<b":
              v.bold = I.val ? Lr(I.val) : 1;
              break;
            case "<b/>":
              v.bold = 1;
              break;
            case "<i":
              v.italic = I.val ? Lr(I.val) : 1;
              break;
            case "<i/>":
              v.italic = 1;
              break;
            case "<u":
              switch (I.val) {
                case "none":
                  v.underline = 0;
                  break;
                case "single":
                  v.underline = 1;
                  break;
                case "double":
                  v.underline = 2;
                  break;
                case "singleAccounting":
                  v.underline = 33;
                  break;
                case "doubleAccounting":
                  v.underline = 34;
              }
              break;
            case "<u/>":
              v.underline = 1;
              break;
            case "<strike":
              v.strike = I.val ? Lr(I.val) : 1;
              break;
            case "<strike/>":
              v.strike = 1;
              break;
            case "<outline":
              v.outline = I.val ? Lr(I.val) : 1;
              break;
            case "<outline/>":
              v.outline = 1;
              break;
            case "<shadow":
              v.shadow = I.val ? Lr(I.val) : 1;
              break;
            case "<shadow/>":
              v.shadow = 1;
              break;
            case "<condense":
              v.condense = I.val ? Lr(I.val) : 1;
              break;
            case "<condense/>":
              v.condense = 1;
              break;
            case "<extend":
              v.extend = I.val ? Lr(I.val) : 1;
              break;
            case "<extend/>":
              v.extend = 1;
              break;
            case "<sz":
              I.val && (v.sz = +I.val);
              break;
            case "<sz/>":
            case "</sz>":
              break;
            case "<vertAlign":
              I.val && (v.vertAlign = I.val);
              break;
            case "<vertAlign/>":
            case "</vertAlign>":
              break;
            case "<family":
              I.val && (v.family = parseInt(I.val, 10));
              break;
            case "<family/>":
            case "</family>":
              break;
            case "<scheme":
              I.val && (v.scheme = I.val);
              break;
            case "<scheme/>":
            case "</scheme>":
              break;
            case "<charset":
              if (I.val == "1")
                break;
              I.codepage = C[parseInt(I.val, 10)];
              break;
            case "<color":
              v.color || (v.color = {}), I.auto && (v.color.auto = Lr(I.auto)), I.rgb ? v.color.rgb = I.rgb.slice(-6) : I.indexed ? (v.color.index = parseInt(I.indexed, 10), P = bo[v.color.index], P = (P = v.color.index == 81 ? bo[1] : P) || bo[1], v.color.rgb = P[0].toString(16) + P[1].toString(16) + P[2].toString(16)) : I.theme && (v.color.theme = parseInt(I.theme, 10), I.tint && (v.color.tint = parseFloat(I.tint)), I.theme && b.themeElements && b.themeElements.clrScheme && (v.color.rgb = Ls(b.themeElements.clrScheme[v.color.theme].rgb, v.color.tint || 0)));
              break;
            case "<color/>":
            case "</color>":
              break;
            case "<AlternateContent":
              y = !0;
              break;
            case "</AlternateContent>":
              y = !1;
              break;
            case "<extLst":
            case "<extLst>":
            case "</extLst>":
              break;
            case "<ext":
              y = !0;
              break;
            case "</ext>":
              y = !1;
              break;
            default:
              if (T && T.WTF && !y)
                throw new Error("unrecognized " + I[0] + " in fonts");
          }
        });
      }(l, m, n, a), (l = t.match(Jg)) && function(f, E, b) {
        E.Fills = [];
        var T = {}, v = !1;
        (f[0].match(Cn) || []).forEach(function(y) {
          var R = Ht(y);
          switch (pa(R[0])) {
            case "<fills":
            case "<fills>":
            case "</fills>":
              break;
            case "<fill>":
            case "<fill":
            case "<fill/>":
              T = {}, E.Fills.push(T);
              break;
            case "</fill>":
            case "<gradientFill>":
              break;
            case "<gradientFill":
            case "</gradientFill>":
              E.Fills.push(T), T = {};
              break;
            case "<patternFill":
            case "<patternFill>":
              R.patternType && (T.patternType = R.patternType);
              break;
            case "<patternFill/>":
            case "</patternFill>":
              break;
            case "<bgColor":
              T.bgColor || (T.bgColor = {}), R.indexed && (T.bgColor.indexed = parseInt(R.indexed, 10)), R.theme && (T.bgColor.theme = parseInt(R.theme, 10)), R.tint && (T.bgColor.tint = parseFloat(R.tint)), R.rgb && (T.bgColor.rgb = R.rgb.slice(-6));
              break;
            case "<bgColor/>":
            case "</bgColor>":
              break;
            case "<fgColor":
              T.fgColor || (T.fgColor = {}), R.theme && (T.fgColor.theme = parseInt(R.theme, 10)), R.tint && (T.fgColor.tint = parseFloat(R.tint)), R.rgb != null && (T.fgColor.rgb = R.rgb.slice(-6));
              break;
            case "<fgColor/>":
            case "</fgColor>":
              break;
            case "<stop":
            case "<stop/>":
            case "</stop>":
              break;
            case "<color":
            case "<color/>":
            case "</color>":
              break;
            case "<extLst":
            case "<extLst>":
            case "</extLst>":
              break;
            case "<ext":
              v = !0;
              break;
            case "</ext>":
              v = !1;
              break;
            default:
              if (b && b.WTF && !v)
                throw new Error("unrecognized " + R[0] + " in fills");
          }
        });
      }(l, m, a), (l = t.match(tE)) && function(f, E, b) {
        E.Borders = [];
        var T = {}, v = !1;
        (f[0].match(Cn) || []).forEach(function(y) {
          var R = Ht(y);
          switch (pa(R[0])) {
            case "<borders":
            case "<borders>":
            case "</borders>":
              break;
            case "<border":
            case "<border>":
            case "<border/>":
              T = {}, R.diagonalUp && (T.diagonalUp = Lr(R.diagonalUp)), R.diagonalDown && (T.diagonalDown = Lr(R.diagonalDown)), E.Borders.push(T);
              break;
            case "</border>":
            case "<left/>":
              break;
            case "<left":
            case "<left>":
            case "</left>":
            case "<right/>":
              break;
            case "<right":
            case "<right>":
            case "</right>":
            case "<top/>":
              break;
            case "<top":
            case "<top>":
            case "</top>":
            case "<bottom/>":
              break;
            case "<bottom":
            case "<bottom>":
            case "</bottom>":
              break;
            case "<diagonal":
            case "<diagonal>":
            case "<diagonal/>":
            case "</diagonal>":
              break;
            case "<horizontal":
            case "<horizontal>":
            case "<horizontal/>":
            case "</horizontal>":
              break;
            case "<vertical":
            case "<vertical>":
            case "<vertical/>":
            case "</vertical>":
              break;
            case "<start":
            case "<start>":
            case "<start/>":
            case "</start>":
              break;
            case "<end":
            case "<end>":
            case "<end/>":
            case "</end>":
              break;
            case "<color":
            case "<color>":
              break;
            case "<color/>":
            case "</color>":
              break;
            case "<extLst":
            case "<extLst>":
            case "</extLst>":
              break;
            case "<ext":
              v = !0;
              break;
            case "</ext>":
              v = !1;
              break;
            default:
              if (b && b.WTF && !v)
                throw new Error("unrecognized " + R[0] + " in borders");
          }
        });
      }(l, m, a), (l = t.match(jg)) && (l = l, _ = a, p = !((d = m).CellXf = []), (l[0].match(Cn) || []).forEach(function(f) {
        var E = Ht(f), b = 0;
        switch (pa(E[0])) {
          case "<cellXfs":
          case "<cellXfs>":
          case "<cellXfs/>":
          case "</cellXfs>":
            break;
          case "<xf":
          case "<xf/>":
            for (delete (u = E)[0], b = 0; b < Ps.length; ++b)
              u[Ps[b]] && (u[Ps[b]] = parseInt(u[Ps[b]], 10));
            for (b = 0; b < ks.length; ++b)
              u[ks[b]] && (u[ks[b]] = Lr(u[ks[b]]));
            if (d.NumberFmt && 392 < u.numFmtId) {
              for (b = 392; 60 < b; --b)
                if (d.NumberFmt[u.numFmtId] == d.NumberFmt[b]) {
                  u.numFmtId = b;
                  break;
                }
            }
            d.CellXf.push(u);
            break;
          case "</xf>":
            break;
          case "<alignment":
          case "<alignment/>":
            var T = {};
            E.vertical && (T.vertical = E.vertical), E.horizontal && (T.horizontal = E.horizontal), E.textRotation != null && (T.textRotation = E.textRotation), E.indent && (T.indent = E.indent), E.wrapText && (T.wrapText = Lr(E.wrapText)), u.alignment = T;
            break;
          case "</alignment>":
          case "<protection":
            break;
          case "</protection>":
          case "<protection/>":
            break;
          case "<AlternateContent":
            p = !0;
            break;
          case "</AlternateContent>":
            p = !1;
            break;
          case "<extLst":
          case "<extLst>":
          case "</extLst>":
            break;
          case "<ext":
            p = !0;
            break;
          case "</ext>":
            p = !1;
            break;
          default:
            if (_ && _.WTF && !p)
              throw new Error("unrecognized " + E[0] + " in cellXfs");
        }
      }))), m;
    });
    function rE(t, n) {
      if (Do !== void 0)
        return Do.toXml();
      var a, l, d, _, u = [Qr, it("styleSheet", null, { xmlns: ai[0], "xmlns:vt": un.vt })];
      return t.SSF && (l = t.SSF, d = ["<numFmts>"], [[5, 8], [23, 26], [41, 44], [50, 392]].forEach(function(p) {
        for (var m = p[0]; m <= p[1]; ++m)
          l[m] != null && (d[d.length] = it("numFmt", null, { numFmtId: m, formatCode: Ar(l[m]) }));
      }), (a = d.length === 1 ? "" : (d[d.length] = "</numFmts>", d[0] = it("numFmts", null, { count: d.length - 2 }).replace("/>", ">"), d.join(""))) != null) && (u[u.length] = a), u[u.length] = '<fonts count="1"><font><sz val="12"/><color theme="1"/><name val="Calibri"/><family val="2"/><scheme val="minor"/></font></fonts>', u[u.length] = '<fills count="2"><fill><patternFill patternType="none"/></fill><fill><patternFill patternType="gray125"/></fill></fills>', u[u.length] = '<borders count="1"><border><left/><right/><top/><bottom/><diagonal/></border></borders>', u[u.length] = '<cellStyleXfs count="1"><xf numFmtId="0" fontId="0" fillId="0" borderId="0"/></cellStyleXfs>', n = n.cellXfs, (_ = [])[_.length] = "<cellXfs/>", n.forEach(function(p) {
        _[_.length] = it("xf", null, p);
      }), _[_.length] = "</cellXfs>", (a = _.length === 2 ? "" : (_[0] = it("cellXfs", null, { count: _.length - 2 }).replace("/>", ">"), _.join(""))) && (u[u.length] = a), u[u.length] = '<cellStyles count="1"><cellStyle name="Normal" xfId="0" builtinId="0"/></cellStyles>', u[u.length] = '<dxfs count="0"/>', u[u.length] = '<tableStyles count="0" defaultTableStyle="TableStyleMedium9" defaultPivotStyle="PivotStyleMedium4"/>', 2 < u.length && (u[u.length] = "</styleSheet>", u[1] = u[1].replace("/>", ">")), u.join("");
    }
    function QC(t, n) {
      var a;
      (n = n || Me(153)).write_shift(2, 20 * t.sz), a = t, l = (l = n) || Me(2), a = (a.italic ? 2 : 0) | (a.strike ? 8 : 0) | (a.outline ? 16 : 0) | (a.shadow ? 32 : 0) | (a.condense ? 64 : 0) | (a.extend ? 128 : 0), l.write_shift(1, a), l.write_shift(1, 0), n.write_shift(2, t.bold ? 700 : 400);
      var l = 0;
      return t.vertAlign == "superscript" ? l = 1 : t.vertAlign == "subscript" && (l = 2), n.write_shift(2, l), n.write_shift(1, t.underline || 0), n.write_shift(1, t.family || 0), n.write_shift(1, t.charset || 0), n.write_shift(1, 0), hs(t.color, n), l = 0, t.scheme == "major" && (l = 1), t.scheme == "minor" && (l = 2), n.write_shift(1, l), Sn(t.name, n), n.length > n.l ? n.slice(0, n.l) : n;
    }
    var nE, XC = ["none", "solid", "mediumGray", "darkGray", "lightGray", "darkHorizontal", "darkVertical", "darkDown", "darkUp", "darkGrid", "darkTrellis", "lightHorizontal", "lightVertical", "lightDown", "lightUp", "lightGrid", "lightTrellis", "gray125", "gray0625"], ZC = In;
    function aE(t, n) {
      n = n || Me(84), t = (nE = nE || ao(XC))[t.patternType], t == null && (t = 40), n.write_shift(4, t);
      var a = 0;
      if (t != 40)
        for (hs({ auto: 1 }, n), hs({ auto: 1 }, n); a < 12; ++a)
          n.write_shift(4, 0);
      else {
        for (; a < 4; ++a)
          n.write_shift(4, 0);
        for (; a < 12; ++a)
          n.write_shift(4, 0);
      }
      return n.length > n.l ? n.slice(0, n.l) : n;
    }
    function iE(t, n, a) {
      return (a = a || Me(16)).write_shift(2, n || 0), a.write_shift(2, t.numFmtId || 0), a.write_shift(2, 0), a.write_shift(2, 0), a.write_shift(2, 0), a.write_shift(1, 0), a.write_shift(1, 0), a.write_shift(1, 0), a.write_shift(1, 0), a.write_shift(1, 0), a.write_shift(1, 0), a;
    }
    function wo(t, n) {
      return (n = n || Me(10)).write_shift(1, 0), n.write_shift(1, 0), n.write_shift(4, 0), n.write_shift(4, 0), n;
    }
    so = In;
    function jC(t, n) {
      var a;
      n && (a = 0, [[5, 8], [23, 26], [41, 44], [50, 392]].forEach(function(l) {
        for (var d = l[0]; d <= l[1]; ++d)
          n[d] != null && ++a;
      }), a != 0 && (He(t, 615, ma(a)), [[5, 8], [23, 26], [41, 44], [50, 392]].forEach(function(l) {
        for (var d, _, u, p = l[0]; p <= l[1]; ++p)
          n[p] != null && He(t, 44, (d = p, _ = n[p], (u = (u = void 0) || Me(6 + 4 * _.length)).write_shift(2, d), Sn(_, u), _ = u.length > u.l ? u.slice(0, u.l) : u, u.l == null && (u.l = u.length), _));
      }), He(t, 616)));
    }
    function JC(t) {
      var n;
      He(t, 613, ma(1)), He(t, 46, ((n = n || Me(51)).write_shift(1, 0), wo(0, n), wo(0, n), wo(0, n), wo(0, n), wo(0, n), n.length > n.l ? n.slice(0, n.l) : n)), He(t, 614);
    }
    function eR(t) {
      var n, a;
      He(t, 619, ma(1)), He(t, 48, (n = { xfId: 0, builtinId: 0, name: "Normal" }, (a = a || Me(52)).write_shift(4, n.xfId), a.write_shift(2, 1), a.write_shift(1, +n.builtinId), a.write_shift(1, 0), Es(n.name || "", a), a.length > a.l ? a.slice(0, a.l) : a)), He(t, 620);
    }
    function tR(t) {
      var n, a, l, d;
      He(t, 508, (n = 0, a = "TableStyleMedium9", l = "PivotStyleMedium4", (d = Me(2052)).write_shift(4, n), Es(a, d), Es(l, d), d.length > d.l ? d.slice(0, d.l) : d)), He(t, 509);
    }
    function rR(t, n) {
      var a, l = Wn();
      return He(l, 278), jC(l, t.SSF), He(t = l, 611, ma(1)), He(t, 43, QC({ sz: 12, color: { theme: 1 }, name: "Calibri", family: 2, scheme: "minor" })), He(t, 612), He(t = l, 603, ma(2)), He(t, 45, aE({ patternType: "none" })), He(t, 45, aE({ patternType: "gray125" })), He(t, 604), JC(l), He(t = l, 626, ma(1)), He(t, 47, iE({ numFmtId: 0, fontId: 0, fillId: 0, borderId: 0 }, 65535)), He(t, 627), a = l, n = n.cellXfs, He(a, 617, ma(n.length)), n.forEach(function(d) {
        He(a, 47, iE(d, 0));
      }), He(a, 618), eR(l), He(n = l, 505, ma(0)), He(n, 506), tR(l), He(l, 279), l.end();
    }
    var nR = ["</a:lt1>", "</a:dk1>", "</a:lt2>", "</a:dk2>", "</a:accent1>", "</a:accent2>", "</a:accent3>", "</a:accent4>", "</a:accent5>", "</a:accent6>", "</a:hlink>", "</a:folHlink>"];
    function aR(t, n, a) {
      n.themeElements.clrScheme = [];
      var l = {};
      (t[0].match(Cn) || []).forEach(function(d) {
        var _ = Ht(d);
        switch (_[0]) {
          case "<a:clrScheme":
          case "</a:clrScheme>":
            break;
          case "<a:srgbClr":
            l.rgb = _.val;
            break;
          case "<a:sysClr":
            l.rgb = _.lastClr;
            break;
          case "<a:dk1>":
          case "</a:dk1>":
          case "<a:lt1>":
          case "</a:lt1>":
          case "<a:dk2>":
          case "</a:dk2>":
          case "<a:lt2>":
          case "</a:lt2>":
          case "<a:accent1>":
          case "</a:accent1>":
          case "<a:accent2>":
          case "</a:accent2>":
          case "<a:accent3>":
          case "</a:accent3>":
          case "<a:accent4>":
          case "</a:accent4>":
          case "<a:accent5>":
          case "</a:accent5>":
          case "<a:accent6>":
          case "</a:accent6>":
          case "<a:hlink>":
          case "</a:hlink>":
          case "<a:folHlink>":
          case "</a:folHlink>":
            _[0].charAt(1) === "/" ? (n.themeElements.clrScheme[nR.indexOf(_[0])] = l, l = {}) : l.name = _[0].slice(3, _[0].length - 1);
            break;
          default:
            if (a && a.WTF)
              throw new Error("Unrecognized " + _[0] + " in clrScheme");
        }
      });
    }
    function iR() {
    }
    function oR() {
    }
    var sR = /<a:clrScheme([^>]*)>[\s\S]*<\/a:clrScheme>/, lR = /<a:fontScheme([^>]*)>[\s\S]*<\/a:fontScheme>/, cR = /<a:fmtScheme([^>]*)>[\s\S]*<\/a:fmtScheme>/, dR = /<a:themeElements([^>]*)>[\s\S]*<\/a:themeElements>/;
    function oE(t, n) {
      var a, l, d, _, u, p = {};
      if (!(a = (t = !t || t.length === 0 ? Tc() : t).match(dR)))
        throw new Error("themeElements not found in theme");
      return l = a[0], _ = n, (d = p).themeElements = {}, [["clrScheme", sR, aR], ["fontScheme", lR, iR], ["fmtScheme", cR, oR]].forEach(function(m) {
        if (!(u = l.match(m[1])))
          throw new Error(m[0] + " not found in themeElements");
        m[2](u, d, _);
      }), p.raw = t, p;
    }
    function Tc(t, n) {
      return n && n.themeXLSX ? n.themeXLSX : t && typeof t.raw == "string" ? t.raw : (t = [Qr], t[t.length] = '<a:theme xmlns:a="http://schemas.openxmlformats.org/drawingml/2006/main" name="Office Theme">', t[t.length] = "<a:themeElements>", t[t.length] = '<a:clrScheme name="Office">', t[t.length] = '<a:dk1><a:sysClr val="windowText" lastClr="000000"/></a:dk1>', t[t.length] = '<a:lt1><a:sysClr val="window" lastClr="FFFFFF"/></a:lt1>', t[t.length] = '<a:dk2><a:srgbClr val="1F497D"/></a:dk2>', t[t.length] = '<a:lt2><a:srgbClr val="EEECE1"/></a:lt2>', t[t.length] = '<a:accent1><a:srgbClr val="4F81BD"/></a:accent1>', t[t.length] = '<a:accent2><a:srgbClr val="C0504D"/></a:accent2>', t[t.length] = '<a:accent3><a:srgbClr val="9BBB59"/></a:accent3>', t[t.length] = '<a:accent4><a:srgbClr val="8064A2"/></a:accent4>', t[t.length] = '<a:accent5><a:srgbClr val="4BACC6"/></a:accent5>', t[t.length] = '<a:accent6><a:srgbClr val="F79646"/></a:accent6>', t[t.length] = '<a:hlink><a:srgbClr val="0000FF"/></a:hlink>', t[t.length] = '<a:folHlink><a:srgbClr val="800080"/></a:folHlink>', t[t.length] = "</a:clrScheme>", t[t.length] = '<a:fontScheme name="Office">', t[t.length] = "<a:majorFont>", t[t.length] = '<a:latin typeface="Cambria"/>', t[t.length] = '<a:ea typeface=""/>', t[t.length] = '<a:cs typeface=""/>', t[t.length] = '<a:font script="Jpan" typeface="ＭＳ Ｐゴシック"/>', t[t.length] = '<a:font script="Hang" typeface="맑은 고딕"/>', t[t.length] = '<a:font script="Hans" typeface="宋体"/>', t[t.length] = '<a:font script="Hant" typeface="新細明體"/>', t[t.length] = '<a:font script="Arab" typeface="Times New Roman"/>', t[t.length] = '<a:font script="Hebr" typeface="Times New Roman"/>', t[t.length] = '<a:font script="Thai" typeface="Tahoma"/>', t[t.length] = '<a:font script="Ethi" typeface="Nyala"/>', t[t.length] = '<a:font script="Beng" typeface="Vrinda"/>', t[t.length] = '<a:font script="Gujr" typeface="Shruti"/>', t[t.length] = '<a:font script="Khmr" typeface="MoolBoran"/>', t[t.length] = '<a:font script="Knda" typeface="Tunga"/>', t[t.length] = '<a:font script="Guru" typeface="Raavi"/>', t[t.length] = '<a:font script="Cans" typeface="Euphemia"/>', t[t.length] = '<a:font script="Cher" typeface="Plantagenet Cherokee"/>', t[t.length] = '<a:font script="Yiii" typeface="Microsoft Yi Baiti"/>', t[t.length] = '<a:font script="Tibt" typeface="Microsoft Himalaya"/>', t[t.length] = '<a:font script="Thaa" typeface="MV Boli"/>', t[t.length] = '<a:font script="Deva" typeface="Mangal"/>', t[t.length] = '<a:font script="Telu" typeface="Gautami"/>', t[t.length] = '<a:font script="Taml" typeface="Latha"/>', t[t.length] = '<a:font script="Syrc" typeface="Estrangelo Edessa"/>', t[t.length] = '<a:font script="Orya" typeface="Kalinga"/>', t[t.length] = '<a:font script="Mlym" typeface="Kartika"/>', t[t.length] = '<a:font script="Laoo" typeface="DokChampa"/>', t[t.length] = '<a:font script="Sinh" typeface="Iskoola Pota"/>', t[t.length] = '<a:font script="Mong" typeface="Mongolian Baiti"/>', t[t.length] = '<a:font script="Viet" typeface="Times New Roman"/>', t[t.length] = '<a:font script="Uigh" typeface="Microsoft Uighur"/>', t[t.length] = '<a:font script="Geor" typeface="Sylfaen"/>', t[t.length] = "</a:majorFont>", t[t.length] = "<a:minorFont>", t[t.length] = '<a:latin typeface="Calibri"/>', t[t.length] = '<a:ea typeface=""/>', t[t.length] = '<a:cs typeface=""/>', t[t.length] = '<a:font script="Jpan" typeface="ＭＳ Ｐゴシック"/>', t[t.length] = '<a:font script="Hang" typeface="맑은 고딕"/>', t[t.length] = '<a:font script="Hans" typeface="宋体"/>', t[t.length] = '<a:font script="Hant" typeface="新細明體"/>', t[t.length] = '<a:font script="Arab" typeface="Arial"/>', t[t.length] = '<a:font script="Hebr" typeface="Arial"/>', t[t.length] = '<a:font script="Thai" typeface="Tahoma"/>', t[t.length] = '<a:font script="Ethi" typeface="Nyala"/>', t[t.length] = '<a:font script="Beng" typeface="Vrinda"/>', t[t.length] = '<a:font script="Gujr" typeface="Shruti"/>', t[t.length] = '<a:font script="Khmr" typeface="DaunPenh"/>', t[t.length] = '<a:font script="Knda" typeface="Tunga"/>', t[t.length] = '<a:font script="Guru" typeface="Raavi"/>', t[t.length] = '<a:font script="Cans" typeface="Euphemia"/>', t[t.length] = '<a:font script="Cher" typeface="Plantagenet Cherokee"/>', t[t.length] = '<a:font script="Yiii" typeface="Microsoft Yi Baiti"/>', t[t.length] = '<a:font script="Tibt" typeface="Microsoft Himalaya"/>', t[t.length] = '<a:font script="Thaa" typeface="MV Boli"/>', t[t.length] = '<a:font script="Deva" typeface="Mangal"/>', t[t.length] = '<a:font script="Telu" typeface="Gautami"/>', t[t.length] = '<a:font script="Taml" typeface="Latha"/>', t[t.length] = '<a:font script="Syrc" typeface="Estrangelo Edessa"/>', t[t.length] = '<a:font script="Orya" typeface="Kalinga"/>', t[t.length] = '<a:font script="Mlym" typeface="Kartika"/>', t[t.length] = '<a:font script="Laoo" typeface="DokChampa"/>', t[t.length] = '<a:font script="Sinh" typeface="Iskoola Pota"/>', t[t.length] = '<a:font script="Mong" typeface="Mongolian Baiti"/>', t[t.length] = '<a:font script="Viet" typeface="Arial"/>', t[t.length] = '<a:font script="Uigh" typeface="Microsoft Uighur"/>', t[t.length] = '<a:font script="Geor" typeface="Sylfaen"/>', t[t.length] = "</a:minorFont>", t[t.length] = "</a:fontScheme>", t[t.length] = '<a:fmtScheme name="Office">', t[t.length] = "<a:fillStyleLst>", t[t.length] = '<a:solidFill><a:schemeClr val="phClr"/></a:solidFill>', t[t.length] = '<a:gradFill rotWithShape="1">', t[t.length] = "<a:gsLst>", t[t.length] = '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="50000"/><a:satMod val="300000"/></a:schemeClr></a:gs>', t[t.length] = '<a:gs pos="35000"><a:schemeClr val="phClr"><a:tint val="37000"/><a:satMod val="300000"/></a:schemeClr></a:gs>', t[t.length] = '<a:gs pos="100000"><a:schemeClr val="phClr"><a:tint val="15000"/><a:satMod val="350000"/></a:schemeClr></a:gs>', t[t.length] = "</a:gsLst>", t[t.length] = '<a:lin ang="16200000" scaled="1"/>', t[t.length] = "</a:gradFill>", t[t.length] = '<a:gradFill rotWithShape="1">', t[t.length] = "<a:gsLst>", t[t.length] = '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="100000"/><a:shade val="100000"/><a:satMod val="130000"/></a:schemeClr></a:gs>', t[t.length] = '<a:gs pos="100000"><a:schemeClr val="phClr"><a:tint val="50000"/><a:shade val="100000"/><a:satMod val="350000"/></a:schemeClr></a:gs>', t[t.length] = "</a:gsLst>", t[t.length] = '<a:lin ang="16200000" scaled="0"/>', t[t.length] = "</a:gradFill>", t[t.length] = "</a:fillStyleLst>", t[t.length] = "<a:lnStyleLst>", t[t.length] = '<a:ln w="9525" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"><a:shade val="95000"/><a:satMod val="105000"/></a:schemeClr></a:solidFill><a:prstDash val="solid"/></a:ln>', t[t.length] = '<a:ln w="25400" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"/></a:solidFill><a:prstDash val="solid"/></a:ln>', t[t.length] = '<a:ln w="38100" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"/></a:solidFill><a:prstDash val="solid"/></a:ln>', t[t.length] = "</a:lnStyleLst>", t[t.length] = "<a:effectStyleLst>", t[t.length] = "<a:effectStyle>", t[t.length] = "<a:effectLst>", t[t.length] = '<a:outerShdw blurRad="40000" dist="20000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="38000"/></a:srgbClr></a:outerShdw>', t[t.length] = "</a:effectLst>", t[t.length] = "</a:effectStyle>", t[t.length] = "<a:effectStyle>", t[t.length] = "<a:effectLst>", t[t.length] = '<a:outerShdw blurRad="40000" dist="23000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="35000"/></a:srgbClr></a:outerShdw>', t[t.length] = "</a:effectLst>", t[t.length] = "</a:effectStyle>", t[t.length] = "<a:effectStyle>", t[t.length] = "<a:effectLst>", t[t.length] = '<a:outerShdw blurRad="40000" dist="23000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="35000"/></a:srgbClr></a:outerShdw>', t[t.length] = "</a:effectLst>", t[t.length] = '<a:scene3d><a:camera prst="orthographicFront"><a:rot lat="0" lon="0" rev="0"/></a:camera><a:lightRig rig="threePt" dir="t"><a:rot lat="0" lon="0" rev="1200000"/></a:lightRig></a:scene3d>', t[t.length] = '<a:sp3d><a:bevelT w="63500" h="25400"/></a:sp3d>', t[t.length] = "</a:effectStyle>", t[t.length] = "</a:effectStyleLst>", t[t.length] = "<a:bgFillStyleLst>", t[t.length] = '<a:solidFill><a:schemeClr val="phClr"/></a:solidFill>', t[t.length] = '<a:gradFill rotWithShape="1">', t[t.length] = "<a:gsLst>", t[t.length] = '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="40000"/><a:satMod val="350000"/></a:schemeClr></a:gs>', t[t.length] = '<a:gs pos="40000"><a:schemeClr val="phClr"><a:tint val="45000"/><a:shade val="99000"/><a:satMod val="350000"/></a:schemeClr></a:gs>', t[t.length] = '<a:gs pos="100000"><a:schemeClr val="phClr"><a:shade val="20000"/><a:satMod val="255000"/></a:schemeClr></a:gs>', t[t.length] = "</a:gsLst>", t[t.length] = '<a:path path="circle"><a:fillToRect l="50000" t="-80000" r="50000" b="180000"/></a:path>', t[t.length] = "</a:gradFill>", t[t.length] = '<a:gradFill rotWithShape="1">', t[t.length] = "<a:gsLst>", t[t.length] = '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="80000"/><a:satMod val="300000"/></a:schemeClr></a:gs>', t[t.length] = '<a:gs pos="100000"><a:schemeClr val="phClr"><a:shade val="30000"/><a:satMod val="200000"/></a:schemeClr></a:gs>', t[t.length] = "</a:gsLst>", t[t.length] = '<a:path path="circle"><a:fillToRect l="50000" t="50000" r="50000" b="50000"/></a:path>', t[t.length] = "</a:gradFill>", t[t.length] = "</a:bgFillStyleLst>", t[t.length] = "</a:fmtScheme>", t[t.length] = "</a:themeElements>", t[t.length] = "<a:objectDefaults>", t[t.length] = "<a:spDef>", t[t.length] = '<a:spPr/><a:bodyPr/><a:lstStyle/><a:style><a:lnRef idx="1"><a:schemeClr val="accent1"/></a:lnRef><a:fillRef idx="3"><a:schemeClr val="accent1"/></a:fillRef><a:effectRef idx="2"><a:schemeClr val="accent1"/></a:effectRef><a:fontRef idx="minor"><a:schemeClr val="lt1"/></a:fontRef></a:style>', t[t.length] = "</a:spDef>", t[t.length] = "<a:lnDef>", t[t.length] = '<a:spPr/><a:bodyPr/><a:lstStyle/><a:style><a:lnRef idx="2"><a:schemeClr val="accent1"/></a:lnRef><a:fillRef idx="0"><a:schemeClr val="accent1"/></a:fillRef><a:effectRef idx="1"><a:schemeClr val="accent1"/></a:effectRef><a:fontRef idx="minor"><a:schemeClr val="tx1"/></a:fontRef></a:style>', t[t.length] = "</a:lnDef>", t[t.length] = "</a:objectDefaults>", t[t.length] = "<a:extraClrSchemeLst/>", t[t.length] = "</a:theme>", t.join(""));
    }
    function uR(t) {
      var n = {};
      switch (n.xclrType = t.read_shift(2), n.nTintShade = t.read_shift(2), n.xclrType) {
        case 0:
          t.l += 4;
          break;
        case 1:
          n.xclrValue = In(t, 4);
          break;
        case 2:
          n.xclrValue = Qf(t);
          break;
        case 3:
          n.xclrValue = t.read_shift(4);
          break;
        case 4:
          t.l += 4;
      }
      return t.l += 8, n;
    }
    function _R(t) {
      var n = t.read_shift(2), a = t.read_shift(2) - 4, l = [n];
      switch (n) {
        case 4:
        case 5:
        case 7:
        case 8:
        case 9:
        case 10:
        case 11:
        case 13:
          l[1] = uR(t);
          break;
        case 6:
          l[1] = In(t, a);
          break;
        case 14:
        case 15:
          l[1] = t.read_shift(a == 1 ? 1 : 2);
          break;
        default:
          throw new Error("Unrecognized ExtProp type: " + n + " " + a);
      }
      return l;
    }
    function pR() {
      var t, n, a, l = Wn();
      return He(l, 332), He(l, 334, ma(1)), He(l, 335, ((a = Me(12 + 2 * (n = { name: "XLDAPR", version: 12e4, flags: 3496657072 }).name.length)).write_shift(4, n.flags), a.write_shift(4, n.version), Sn(n.name, a), a.slice(0, a.l))), He(l, 336), He(l, 339, (t = 1, (a = Me(8 + 2 * (n = "XLDAPR").length)).write_shift(4, t), Sn(n, a), a.slice(0, a.l))), He(l, 52), He(l, 35, ma(514)), He(l, 4096, ma(0)), He(l, 4097, oa(1)), He(l, 36), He(l, 53), He(l, 340), He(l, 337, (t = 1, n = !0, (a = Me(8)).write_shift(4, t), a.write_shift(4, n ? 1 : 0), a)), He(l, 51, function(d) {
        var _ = Me(4 + 8 * d.length);
        _.write_shift(4, d.length);
        for (var u = 0; u < d.length; ++u)
          _.write_shift(4, d[u][0]), _.write_shift(4, d[u][1]);
        return _;
      }([[1, 0]])), He(l, 338), He(l, 333), l.end();
    }
    function sE() {
      var t = [Qr];
      return t.push(`<metadata xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main" xmlns:xlrd="http://schemas.microsoft.com/office/spreadsheetml/2017/richdata" xmlns:xda="http://schemas.microsoft.com/office/spreadsheetml/2017/dynamicarray">
  <metadataTypes count="1">
    <metadataType name="XLDAPR" minSupportedVersion="120000" copy="1" pasteAll="1" pasteValues="1" merge="1" splitFirst="1" rowColShift="1" clearFormats="1" clearComments="1" assign="1" coerce="1" cellMeta="1"/>
  </metadataTypes>
  <futureMetadata name="XLDAPR" count="1">
    <bk>
      <extLst>
        <ext uri="{bdbb8cdc-fa1e-496e-a857-3c3f30c029c3}">
          <xda:dynamicArrayProperties fDynamic="1" fCollapsed="0"/>
        </ext>
      </extLst>
    </bk>
  </futureMetadata>
  <cellMetadata count="1">
    <bk>
      <rc t="1" v="0"/>
    </bk>
  </cellMetadata>
</metadata>`), t.join("");
    }
    var Hi = 1024;
    function lE(t, n) {
      for (var a = [21600, 21600], l = ["m0,0l0", a[1], a[0], a[1], a[0], "0xe"].join(","), d = [it("xml", null, { "xmlns:v": jn.v, "xmlns:o": jn.o, "xmlns:x": jn.x, "xmlns:mv": jn.mv }).replace(/\/>/, ">"), it("o:shapelayout", it("o:idmap", null, { "v:ext": "edit", data: t }), { "v:ext": "edit" }), it("v:shapetype", [it("v:stroke", null, { joinstyle: "miter" }), it("v:path", null, { gradientshapeok: "t", "o:connecttype": "rect" })].join(""), { id: "_x0000_t202", "o:spt": 202, coordsize: a.join(","), path: l })]; Hi < 1e3 * t; )
        Hi += 1e3;
      return n.forEach(function(_) {
        var u = zr(_[0]), m = { color2: "#BEFF82", type: "gradient" };
        m.type == "gradient" && (m.angle = "-180");
        var p = m.type == "gradient" ? it("o:fill", null, { type: "gradientUnscaled", "v:ext": "view" }) : null, m = it("v:fill", p, m);
        ++Hi, d = d.concat(["<v:shape" + fo({ id: "_x0000_s" + Hi, type: "#_x0000_t202", style: "position:absolute; margin-left:80pt;margin-top:5pt;width:104pt;height:64pt;z-index:10" + (_[1].hidden ? ";visibility:hidden" : ""), fillcolor: "#ECFAD4", strokecolor: "#edeaa1" }) + ">", m, it("v:shadow", null, { on: "t", obscured: "t" }), it("v:path", null, { "o:connecttype": "none" }), '<v:textbox><div style="text-align:left"></div></v:textbox>', '<x:ClientData ObjectType="Note">', "<x:MoveWithCells/>", "<x:SizeWithCells/>", Rn("x:Anchor", [u.c + 1, 0, u.r + 1, 0, u.c + 3, 20, u.r + 5, 20].join(",")), Rn("x:AutoFill", "False"), Rn("x:Row", String(u.r)), Rn("x:Column", String(u.c)), _[1].hidden ? "" : "<x:Visible/>", "</x:ClientData>", "</v:shape>"]);
      }), d.push("</xml>"), d.join("");
    }
    function cE(t, n, a, l) {
      var d, _ = Array.isArray(t);
      n.forEach(function(u) {
        var p, m = zr(u.ref);
        (d = _ ? (t[m.r] || (t[m.r] = []), t[m.r][m.c]) : t[u.ref]) || (d = { t: "z" }, _ ? t[m.r][m.c] = d : t[u.ref] = d, (p = lr(t["!ref"] || "BDWGO1000001:A1")).s.r > m.r && (p.s.r = m.r), p.e.r < m.r && (p.e.r = m.r), p.s.c > m.c && (p.s.c = m.c), p.e.c < m.c && (p.e.c = m.c), (p = Xt(p)) !== t["!ref"] && (t["!ref"] = p)), d.c || (d.c = []);
        var f = { a: u.author, t: u.t, r: u.r, T: a };
        u.h && (f.h = u.h);
        for (var E = d.c.length - 1; 0 <= E; --E) {
          if (!a && d.c[E].T)
            return;
          a && !d.c[E].T && d.c.splice(E, 1);
        }
        if (a && l) {
          for (E = 0; E < l.length; ++E)
            if (f.a == l[E].id) {
              f.a = l[E].name || f.a;
              break;
            }
        }
        d.c.push(f);
      });
    }
    function dE(t) {
      var n = [Qr, it("comments", null, { xmlns: ai[0] })], a = [];
      return n.push("<authors>"), t.forEach(function(l) {
        l[1].forEach(function(d) {
          var _ = Ar(d.a);
          a.indexOf(_) == -1 && (a.push(_), n.push("<author>" + _ + "</author>")), d.T && d.ID && a.indexOf("tc=" + d.ID) == -1 && (a.push("tc=" + d.ID), n.push("<author>tc=" + d.ID + "</author>"));
        });
      }), a.length == 0 && (a.push("SheetJ5"), n.push("<author>SheetJ5</author>")), n.push("</authors>"), n.push("<commentList>"), t.forEach(function(l) {
        var d = 0, _ = [];
        if (l[1][0] && l[1][0].T && l[1][0].ID ? d = a.indexOf("tc=" + l[1][0].ID) : l[1].forEach(function(m) {
          m.a && (d = a.indexOf(Ar(m.a))), _.push(m.t || "");
        }), n.push('<comment ref="' + l[0] + '" authorId="' + d + '"><text>'), _.length <= 1)
          n.push(Rn("t", Ar(_[0] || "")));
        else {
          for (var u = `Comment:
    ` + _[0] + `
`, p = 1; p < _.length; ++p)
            u += `Reply:
    ` + _[p] + `
`;
          n.push(Rn("t", Ar(u)));
        }
        n.push("</text></comment>");
      }), n.push("</commentList>"), 2 < n.length && (n[n.length] = "</comments>", n[1] = n[1].replace("/>", ">")), n.join("");
    }
    co = Dn;
    function mR(t) {
      var n = Wn(), a = [];
      return He(n, 628), He(n, 630), t.forEach(function(l) {
        l[1].forEach(function(d) {
          -1 < a.indexOf(d.a) || (a.push(d.a.slice(0, 54)), He(n, 632, Sn(d.a.slice(0, 54))));
        });
      }), He(n, 631), He(n, 633), t.forEach(function(l) {
        l[1].forEach(function(d) {
          d.iauthor = a.indexOf(d.a);
          var _, u = { s: zr(l[0]), e: zr(l[0]) };
          He(n, 635, (u = [u, d], (_ = _ ?? Me(36)).write_shift(4, u[1].iauthor), ki(u[0], _), _.write_shift(4, 0), _.write_shift(4, 0), _.write_shift(4, 0), _.write_shift(4, 0), _)), d.t && 0 < d.t.length && He(n, 637, oC(d)), He(n, 636), delete d.iauthor;
        });
      }), He(n, 634), He(n, 629), n.end();
    }
    var fR = "application/vnd.ms-office.vbaProject", uE = ["xlsb", "xlsm", "xlam", "biff8", "xla"], vc, _E, qi = (_E = /(^|[^A-Za-z_])R(\[?-?\d+\]|[1-9]\d*|)C(\[?-?\d+\]|[1-9]\d*|)(?![A-Za-z0-9_])/g, function(t, n) {
      return vc = n, t.replace(_E, gR);
    });
    function gR(t, n, a, l) {
      var d = !1, _ = !1;
      return a.length == 0 ? _ = !0 : a.charAt(0) == "[" && (_ = !0, a = a.slice(1, -1)), l.length == 0 ? d = !0 : l.charAt(0) == "[" && (d = !0, l = l.slice(1, -1)), a = 0 < a.length ? 0 | parseInt(a, 10) : 0, l = 0 < l.length ? 0 | parseInt(l, 10) : 0, d ? l += vc.c : --l, _ ? a += vc.r : --a, n + (d ? "" : "$") + Vr(l) + (_ ? "" : "$") + Xr(a);
    }
    var Cc = /(^|[^._A-Z0-9])([$]?)([A-Z]{1,2}|[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D])([$]?)(10[0-3]\d{4}|104[0-7]\d{3}|1048[0-4]\d{2}|10485[0-6]\d|104857[0-6]|[1-9]\d{0,5})(?![_.\(A-Za-z0-9])/g, Rc = function(t, n) {
      return t.replace(Cc, function(a, l, d, _, u, p) {
        return _ = Kl(_) - (d ? 0 : n.c), p = zl(p) - (u ? 0 : n.r), l + "R" + (p == 0 ? "" : u ? 1 + p : "[" + p + "]") + "C" + (_ == 0 ? "" : d ? 1 + _ : "[" + _ + "]");
      });
    };
    function pE(t, n) {
      return t.replace(Cc, function(a, l, d, _, u, p) {
        return l + (d == "$" ? d + _ : Vr(Kl(_) + n.c)) + (u == "$" ? u + p : Xr(zl(p) + n.r));
      });
    }
    function mE(t) {
      return t.replace(/_xlfn\./g, "");
    }
    function ln(t) {
      t.l += 1;
    }
    function Wa(t, n) {
      return n = t.read_shift(n == 1 ? 1 : 2), [16383 & n, n >> 14 & 1, n >> 15 & 1];
    }
    function fE(u, n, d) {
      var _ = 2;
      if (d) {
        if (2 <= d.biff && d.biff <= 5)
          return gE(u);
        d.biff == 12 && (_ = 4);
      }
      var l = u.read_shift(_), d = u.read_shift(_), _ = Wa(u, 2), u = Wa(u, 2);
      return { s: { r: l, c: _[0], cRel: _[1], rRel: _[2] }, e: { r: d, c: u[0], cRel: u[1], rRel: u[2] } };
    }
    function gE(d) {
      var n = Wa(d, 2), a = Wa(d, 2), l = d.read_shift(1), d = d.read_shift(1);
      return { s: { r: n[0], c: l, cRel: n[1], rRel: n[2] }, e: { r: a[0], c: d, cRel: a[1], rRel: a[2] } };
    }
    function EE(u, n, _) {
      if (_ && 2 <= _.biff && _.biff <= 5)
        return d = Wa(l = u, 2), l = l.read_shift(1), { r: d[0], c: l, cRel: d[1], rRel: d[2] };
      var l, d, _ = u.read_shift(_ && _.biff == 12 ? 4 : 2), u = Wa(u, 2);
      return { r: _, c: u[0], cRel: u[1], rRel: u[2] };
    }
    function ER(u, n, _) {
      if (_ = _ && _.biff ? _.biff : 8, 2 <= _ && _ <= 5)
        return function(b) {
          var m = b.read_shift(2), f = b.read_shift(1), E = (32768 & m) >> 15, b = (16384 & m) >> 14;
          return m &= 16383, E == 1 && 8192 <= m && (m -= 16384), b == 1 && 128 <= f && (f -= 256), { r: m, c: f, cRel: b, rRel: E };
        }(u);
      var l = u.read_shift(12 <= _ ? 4 : 2), d = u.read_shift(2), _ = (16384 & d) >> 14, u = (32768 & d) >> 15;
      if (d &= 16383, u == 1)
        for (; 524287 < l; )
          l -= 1048576;
      if (_ == 1)
        for (; 8191 < d; )
          d -= 16384;
      return { r: l, c: d, cRel: _, rRel: u };
    }
    function hE(t) {
      var n = 1 & t[t.l + 1];
      return t.l += 4, [n, 1];
    }
    function SE(t) {
      return [t.read_shift(1), t.read_shift(1)];
    }
    function hR(t, n, a) {
      var l = 0, d = 0;
      a.biff == 12 ? (l = t.read_shift(4), d = t.read_shift(4)) : (d = 1 + t.read_shift(1), l = 1 + t.read_shift(2)), 2 <= a.biff && a.biff < 8 && (--l, --d == 0 && (d = 256));
      for (var _ = 0, u = []; _ != l && (u[_] = []); ++_)
        for (var p = 0; p != d; ++p)
          u[_][p] = function(m, f) {
            var E = [m.read_shift(1)];
            if (f == 12)
              switch (E[0]) {
                case 2:
                  E[0] = 4;
                  break;
                case 4:
                  E[0] = 16;
                  break;
                case 0:
                  E[0] = 1;
                  break;
                case 1:
                  E[0] = 2;
              }
            switch (E[0]) {
              case 4:
                E[1] = tn(m, 1) ? "TRUE" : "FALSE", f != 12 && (m.l += 7);
                break;
              case 37:
              case 16:
                E[1] = La[m[m.l]], m.l += f == 12 ? 4 : 8;
                break;
              case 0:
                m.l += 8;
                break;
              case 1:
                E[1] = wn(m);
                break;
              case 2:
                E[1] = _i(m, 0, { biff: 0 < f && f < 8 ? 2 : f });
                break;
              default:
                throw new Error("Bad SerAr: " + E[0]);
            }
            return E;
          }(t, a.biff);
      return u;
    }
    function xo(t, n, a) {
      return t.l += 2, [(t = (l = t).read_shift(2), l = l.read_shift(2), { r: t, c: 255 & l, fQuoted: !!(16384 & l), cRel: l >> 15, rRel: l >> 15 })];
      var l;
    }
    function Nc(t) {
      return t.l += 6, [];
    }
    function bE(t) {
      return t.l += 2, [sn(t), 1 & t.read_shift(2)];
    }
    var SR = ["Data", "All", "Headers", "??", "?Data2", "??", "?DataHeaders", "??", "Totals", "??", "??", "??", "?DataTotals", "??", "??", "??", "?Current"], TE = { 1: { n: "PtgExp", f: function(t, n, a) {
      return t.l++, a && a.biff == 12 ? [t.read_shift(4, "i"), 0] : [t.read_shift(2), t.read_shift(a && a.biff == 2 ? 1 : 2)];
    } }, 2: { n: "PtgTbl", f: In }, 3: { n: "PtgAdd", f: ln }, 4: { n: "PtgSub", f: ln }, 5: { n: "PtgMul", f: ln }, 6: { n: "PtgDiv", f: ln }, 7: { n: "PtgPower", f: ln }, 8: { n: "PtgConcat", f: ln }, 9: { n: "PtgLt", f: ln }, 10: { n: "PtgLe", f: ln }, 11: { n: "PtgEq", f: ln }, 12: { n: "PtgGe", f: ln }, 13: { n: "PtgGt", f: ln }, 14: { n: "PtgNe", f: ln }, 15: { n: "PtgIsect", f: ln }, 16: { n: "PtgUnion", f: ln }, 17: { n: "PtgRange", f: ln }, 18: { n: "PtgUplus", f: ln }, 19: { n: "PtgUminus", f: ln }, 20: { n: "PtgPercent", f: ln }, 21: { n: "PtgParen", f: ln }, 22: { n: "PtgMissArg", f: ln }, 23: { n: "PtgStr", f: function(t, n, a) {
      return t.l++, Co(t, 0, a);
    } }, 26: { n: "PtgSheet", f: function(t, n, a) {
      return t.l += 5, t.l += 2, t.l += a.biff == 2 ? 1 : 4, ["PTGSHEET"];
    } }, 27: { n: "PtgEndSheet", f: function(t, n, a) {
      return t.l += a.biff == 2 ? 4 : 5, ["PTGENDSHEET"];
    } }, 28: { n: "PtgErr", f: function(t) {
      return t.l++, La[t.read_shift(1)];
    } }, 29: { n: "PtgBool", f: function(t) {
      return t.l++, t.read_shift(1) !== 0;
    } }, 30: { n: "PtgInt", f: function(t) {
      return t.l++, t.read_shift(2);
    } }, 31: { n: "PtgNum", f: function(t) {
      return t.l++, wn(t);
    } }, 32: { n: "PtgArray", f: function(t, n, a) {
      var l = (96 & t[t.l++]) >> 5;
      return t.l += a.biff == 2 ? 6 : a.biff == 12 ? 14 : 7, [l];
    } }, 33: { n: "PtgFunc", f: function(t, n, a) {
      var l = (96 & t[t.l]) >> 5;
      return t.l += 1, a = t.read_shift(a && a.biff <= 3 ? 1 : 2), [IR[a], RE[a], l];
    } }, 34: { n: "PtgFuncVar", f: function(t, n, a) {
      var l = t[t.l++], d = t.read_shift(1), _ = a && a.biff <= 3 ? [l == 88 ? -1 : 0, t.read_shift(1)] : [(_ = t)[_.l + 1] >> 7, 32767 & _.read_shift(2)];
      return [d, (_[0] === 0 ? RE : yR)[_[1]]];
    } }, 35: { n: "PtgName", f: function(t, n, a) {
      var l = t.read_shift(1) >>> 5 & 3, d = !a || 8 <= a.biff ? 4 : 2, d = t.read_shift(d);
      switch (a.biff) {
        case 2:
          t.l += 5;
          break;
        case 3:
        case 4:
          t.l += 8;
          break;
        case 5:
          t.l += 12;
      }
      return [l, 0, d];
    } }, 36: { n: "PtgRef", f: function(t, n, a) {
      var l = (96 & t[t.l]) >> 5;
      return t.l += 1, [l, EE(t, 0, a)];
    } }, 37: { n: "PtgArea", f: function(t, n, a) {
      return [(96 & t[t.l++]) >> 5, fE(t, 2 <= a.biff && a.biff, a)];
    } }, 38: { n: "PtgMemArea", f: function(t, n, a) {
      var l = t.read_shift(1) >>> 5 & 3;
      return t.l += a && a.biff == 2 ? 3 : 4, [l, t.read_shift(a && a.biff == 2 ? 1 : 2)];
    } }, 39: { n: "PtgMemErr", f: In }, 40: { n: "PtgMemNoMem", f: In }, 41: { n: "PtgMemFunc", f: function(t, n, a) {
      return [t.read_shift(1) >>> 5 & 3, t.read_shift(a && a.biff == 2 ? 1 : 2)];
    } }, 42: { n: "PtgRefErr", f: function(t, n, a) {
      var l = t.read_shift(1) >>> 5 & 3;
      return t.l += 4, a.biff < 8 && t.l--, a.biff == 12 && (t.l += 2), [l];
    } }, 43: { n: "PtgAreaErr", f: function(t, n, a) {
      var l = (96 & t[t.l++]) >> 5;
      return t.l += a && 8 < a.biff ? 12 : a.biff < 8 ? 6 : 8, [l];
    } }, 44: { n: "PtgRefN", f: function(t, n, a) {
      var l = (96 & t[t.l]) >> 5;
      return t.l += 1, [l, ER(t, 0, a)];
    } }, 45: { n: "PtgAreaN", f: function(t, n, a) {
      return [(96 & t[t.l++]) >> 5, function(m, p) {
        if (p.biff < 8)
          return gE(m);
        var _ = m.read_shift(p.biff == 12 ? 4 : 2), u = m.read_shift(p.biff == 12 ? 4 : 2), p = Wa(m, 2), m = Wa(m, 2);
        return { s: { r: _, c: p[0], cRel: p[1], rRel: p[2] }, e: { r: u, c: m[0], cRel: m[1], rRel: m[2] } };
      }(t, a)];
    } }, 46: { n: "PtgMemAreaN", f: function(t) {
      return [t.read_shift(1) >>> 5 & 3, t.read_shift(2)];
    } }, 47: { n: "PtgMemNoMemN", f: function(t) {
      return [t.read_shift(1) >>> 5 & 3, t.read_shift(2)];
    } }, 57: { n: "PtgNameX", f: function(t, n, a) {
      return a.biff == 5 ? function(l) {
        var d = l.read_shift(1) >>> 5 & 3, _ = l.read_shift(2, "i");
        l.l += 8;
        var u = l.read_shift(2);
        return l.l += 12, [d, _, u];
      }(t) : [t.read_shift(1) >>> 5 & 3, t.read_shift(2), t.read_shift(4)];
    } }, 58: { n: "PtgRef3d", f: function(t, n, a) {
      var l = (96 & t[t.l]) >> 5;
      t.l += 1;
      var d = t.read_shift(2);
      return a && a.biff == 5 && (t.l += 12), [l, d, EE(t, 0, a)];
    } }, 59: { n: "PtgArea3d", f: function(t, n, a) {
      var l = (96 & t[t.l++]) >> 5, d = t.read_shift(2, "i");
      if (a)
        switch (a.biff) {
          case 5:
            t.l += 12;
            break;
        }
      return [l, d, fE(t, 0, a)];
    } }, 60: { n: "PtgRefErr3d", f: function(t, n, a) {
      var l = (96 & t[t.l++]) >> 5, d = t.read_shift(2), _ = 4;
      if (a)
        switch (a.biff) {
          case 5:
            _ = 15;
            break;
          case 12:
            _ = 6;
        }
      return t.l += _, [l, d];
    } }, 61: { n: "PtgAreaErr3d", f: function(t, n, a) {
      var l = (96 & t[t.l++]) >> 5, d = t.read_shift(2), _ = 8;
      if (a)
        switch (a.biff) {
          case 5:
            t.l += 12, _ = 6;
            break;
          case 12:
            _ = 12;
        }
      return t.l += _, [l, d];
    } }, 255: {} }, bR = { 64: 32, 96: 32, 65: 33, 97: 33, 66: 34, 98: 34, 67: 35, 99: 35, 68: 36, 100: 36, 69: 37, 101: 37, 70: 38, 102: 38, 71: 39, 103: 39, 72: 40, 104: 40, 73: 41, 105: 41, 74: 42, 106: 42, 75: 43, 107: 43, 76: 44, 108: 44, 77: 45, 109: 45, 78: 46, 110: 46, 79: 47, 111: 47, 88: 34, 120: 34, 89: 57, 121: 57, 90: 58, 122: 58, 91: 59, 123: 59, 92: 60, 124: 60, 93: 61, 125: 61 }, TR = { 1: { n: "PtgElfLel", f: bE }, 2: { n: "PtgElfRw", f: xo }, 3: { n: "PtgElfCol", f: xo }, 6: { n: "PtgElfRwV", f: xo }, 7: { n: "PtgElfColV", f: xo }, 10: { n: "PtgElfRadical", f: xo }, 11: { n: "PtgElfRadicalS", f: Nc }, 13: { n: "PtgElfColS", f: Nc }, 15: { n: "PtgElfColSV", f: Nc }, 16: { n: "PtgElfRadicalLel", f: bE }, 25: { n: "PtgList", f: function(_) {
      _.l += 2;
      var n = _.read_shift(2), a = _.read_shift(2), l = _.read_shift(4), d = _.read_shift(2), _ = _.read_shift(2);
      return { ixti: n, coltype: 3 & a, rt: SR[a >> 2 & 31], idx: l, c: d, C: _ };
    } }, 29: { n: "PtgSxName", f: function(t) {
      return t.l += 2, [t.read_shift(4)];
    } }, 255: {} }, vR = { 0: { n: "PtgAttrNoop", f: function(t) {
      return t.l += 4, [0, 0];
    } }, 1: { n: "PtgAttrSemi", f: function(t, n, a) {
      var l = 255 & t[t.l + 1] ? 1 : 0;
      return t.l += a && a.biff == 2 ? 3 : 4, [l];
    } }, 2: { n: "PtgAttrIf", f: function(t, n, a) {
      var l = 255 & t[t.l + 1] ? 1 : 0;
      return t.l += 2, [l, t.read_shift(a && a.biff == 2 ? 1 : 2)];
    } }, 4: { n: "PtgAttrChoose", f: function(t, n, a) {
      t.l += 2;
      for (var l = t.read_shift(a && a.biff == 2 ? 1 : 2), d = [], _ = 0; _ <= l; ++_)
        d.push(t.read_shift(a && a.biff == 2 ? 1 : 2));
      return d;
    } }, 8: { n: "PtgAttrGoto", f: function(t, n, a) {
      var l = 255 & t[t.l + 1] ? 1 : 0;
      return t.l += 2, [l, t.read_shift(a && a.biff == 2 ? 1 : 2)];
    } }, 16: { n: "PtgAttrSum", f: function(t, n, a) {
      t.l += a && a.biff == 2 ? 3 : 4;
    } }, 32: { n: "PtgAttrBaxcel", f: hE }, 33: { n: "PtgAttrBaxcel", f: hE }, 64: { n: "PtgAttrSpace", f: function(t) {
      return t.read_shift(2), SE(t);
    } }, 65: { n: "PtgAttrSpaceSemi", f: function(t) {
      return t.read_shift(2), SE(t);
    } }, 128: { n: "PtgAttrIfError", f: function(t) {
      var n = 255 & t[t.l + 1] ? 1 : 0;
      return t.l += 2, [n, t.read_shift(2)];
    } }, 255: {} };
    function Lo(t, n, a, l) {
      if (l.biff < 8)
        return In(t, n);
      for (var d = t.l + n, _ = [], u = 0; u !== a.length; ++u)
        switch (a[u][0]) {
          case "PtgArray":
            a[u][1] = hR(t, 0, l), _.push(a[u][1]);
            break;
          case "PtgMemArea":
            a[u][2] = function(p, m) {
              for (var f = p.read_shift(m.biff == 12 ? 4 : 2), E = [], b = 0; b != f; ++b)
                E.push((m.biff == 12 ? ci : vs)(p));
              return E;
            }(t, (a[u][1], l)), _.push(a[u][2]);
            break;
          case "PtgExp":
            l && l.biff == 12 && (a[u][1][1] = t.read_shift(4), _.push(a[u][1]));
            break;
          case "PtgList":
          case "PtgElfRadicalS":
          case "PtgElfColS":
          case "PtgElfColSV":
            throw "Unsupported " + a[u][0];
        }
      return (n = d - t.l) !== 0 && _.push(In(t, n)), _;
    }
    function Mo(t, n, a) {
      for (var l, d, _ = t.l + n, u = []; _ != t.l; )
        n = _ - t.l, d = t[t.l], l = TE[d] || TE[bR[d]], (l = d === 24 || d === 25 ? (d === 24 ? TR : vR)[t[t.l + 1]] : l) && l.f ? u.push([l.n, l.f(t, n, a)]) : In(t, n);
      return u;
    }
    var CR = { PtgAdd: "+", PtgConcat: "&", PtgDiv: "/", PtgEq: "=", PtgGe: ">=", PtgGt: ">", PtgLe: "<=", PtgLt: "<", PtgMul: "*", PtgNe: "<>", PtgPower: "^", PtgSub: "-" };
    function vE(t, n, a) {
      if (!t)
        return "SH33TJSERR0";
      if (8 < a.biff && (!t.XTI || !t.XTI[n]))
        return t.SheetNames[n];
      if (!t.XTI)
        return "SH33TJSERR6";
      var l = t.XTI[n];
      if (a.biff < 8)
        return 1e4 < n && (n -= 65536), (n = n < 0 ? -n : n) == 0 ? "" : t.XTI[n - 1];
      if (!l)
        return "SH33TJSERR1";
      var d = "";
      if (8 < a.biff)
        switch (t[l[0]][0]) {
          case 357:
            return d = l[1] == -1 ? "#REF" : t.SheetNames[l[1]], l[1] == l[2] ? d : d + ":" + t.SheetNames[l[2]];
          case 358:
            return a.SID != null ? t.SheetNames[a.SID] : "SH33TJSSAME" + t[l[0]][0];
          case 355:
          default:
            return "SH33TJSSRC" + t[l[0]][0];
        }
      switch (t[l[0]][0][0]) {
        case 1025:
          return d = l[1] == -1 ? "#REF" : t.SheetNames[l[1]] || "SH33TJSERR3", l[1] == l[2] ? d : d + ":" + t.SheetNames[l[2]];
        case 14849:
          return t[l[0]].slice(1).map(function(_) {
            return _.Name;
          }).join(";;");
        default:
          return t[l[0]][0][3] ? (d = l[1] == -1 ? "#REF" : t[l[0]][0][3][l[1]] || "SH33TJSERR4", l[1] == l[2] ? d : d + ":" + t[l[0]][0][3][l[2]]) : "SH33TJSERR2";
      }
    }
    function CE(t, n, a) {
      return n = vE(t, n, a), n == "#REF" ? n : function(l, d) {
        if (!(l || d && d.biff <= 5 && 2 <= d.biff))
          throw new Error("empty sheet name");
        return /[^\w\u4E00-\u9FFF\u3040-\u30FF]/.test(l) ? "'" + l + "'" : l;
      }(n, a);
    }
    function Gn(t, n, a, l, d) {
      var _, u, p, m = d && d.biff || 8, f = { s: { c: 0, r: 0 }, e: { c: 0, r: 0 } }, E = [], b = 0, T = 0, v = "";
      if (!t[0] || !t[0][0])
        return "";
      for (var y = -1, R = "", P = 0, I = t[0].length; P < I; ++P) {
        var A = t[0][P];
        switch (A[0]) {
          case "PtgUminus":
            E.push("-" + E.pop());
            break;
          case "PtgUplus":
            E.push("+" + E.pop());
            break;
          case "PtgPercent":
            E.push(E.pop() + "%");
            break;
          case "PtgAdd":
          case "PtgConcat":
          case "PtgDiv":
          case "PtgEq":
          case "PtgGe":
          case "PtgGt":
          case "PtgLe":
          case "PtgLt":
          case "PtgMul":
          case "PtgNe":
          case "PtgPower":
          case "PtgSub":
            if (ut = E.pop(), _ = E.pop(), 0 <= y) {
              switch (t[0][y][1][0]) {
                case 0:
                  R = Wr(" ", t[0][y][1][1]);
                  break;
                case 1:
                  R = Wr("\r", t[0][y][1][1]);
                  break;
                default:
                  if (R = "", d.WTF)
                    throw new Error("Unexpected PtgAttrSpaceType " + t[0][y][1][0]);
              }
              _ += R, y = -1;
            }
            E.push(_ + CR[A[0]] + ut);
            break;
          case "PtgIsect":
            ut = E.pop(), _ = E.pop(), E.push(_ + " " + ut);
            break;
          case "PtgUnion":
            ut = E.pop(), _ = E.pop(), E.push(_ + "," + ut);
            break;
          case "PtgRange":
            ut = E.pop(), _ = E.pop(), E.push(_ + ":" + ut);
            break;
          case "PtgAttrChoose":
          case "PtgAttrGoto":
          case "PtgAttrIf":
          case "PtgAttrIfError":
            break;
          case "PtgRef":
            u = ho(A[1][1], f, d), E.push(So(u, m));
            break;
          case "PtgRefN":
            u = a ? ho(A[1][1], a, d) : A[1][1], E.push(So(u, m));
            break;
          case "PtgRef3d":
            b = A[1][1], u = ho(A[1][2], f, d), v = CE(l, b, d), E.push(v + "!" + So(u, m));
            break;
          case "PtgFunc":
          case "PtgFuncVar":
            var F = A[1][0], M = A[1][1], F = F || 0, B = (F &= 127) == 0 ? [] : E.slice(-F);
            E.length -= F, M === "User" && (M = B.shift()), E.push(M + "(" + B.join(",") + ")");
            break;
          case "PtgBool":
            E.push(A[1] ? "TRUE" : "FALSE");
            break;
          case "PtgInt":
            E.push(A[1]);
            break;
          case "PtgNum":
            E.push(String(A[1]));
            break;
          case "PtgStr":
            E.push('"' + A[1].replace(/"/g, '""') + '"');
            break;
          case "PtgErr":
            E.push(A[1]);
            break;
          case "PtgAreaN":
            p = pf(A[1][1], a ? { s: a } : f, d), E.push(Wl(p, d));
            break;
          case "PtgArea":
            p = pf(A[1][1], f, d), E.push(Wl(p, d));
            break;
          case "PtgArea3d":
            b = A[1][1], p = A[1][2], v = CE(l, b, d), E.push(v + "!" + Wl(p, d));
            break;
          case "PtgAttrSum":
            E.push("SUM(" + E.pop() + ")");
            break;
          case "PtgAttrBaxcel":
          case "PtgAttrSemi":
            break;
          case "PtgName":
            T = A[1][2];
            var re = (l.names || [])[T - 1] || (l[0] || [])[T], me = re ? re.Name : "SH33TJSNAME" + String(T);
            me && me.slice(0, 6) == "_xlfn." && !d.xlfn && (me = me.slice(6)), E.push(me);
            break;
          case "PtgNameX":
            var le, be = A[1][1], T = A[1][2];
            if (!(d.biff <= 5)) {
              re = "", ((l[be] || [])[0] || [])[0] == 14849 || (((l[be] || [])[0] || [])[0] == 1025 ? l[be][T] && 0 < l[be][T].itab && (re = l.SheetNames[l[be][T].itab - 1] + "!") : re = l.SheetNames[T - 1] + "!"), l[be] && l[be][T] ? re += l[be][T].Name : l[0] && l[0][T] ? re += l[0][T].Name : (me = (vE(l, be, d) || "").split(";;"))[T - 1] ? re = me[T - 1] : re += "SH33TJSERRX", E.push(re);
              break;
            }
            le = (le = l[be = be < 0 ? -be : be] ? l[be][T] : le) || { Name: "SH33TJSERRY" }, E.push(le.Name);
            break;
          case "PtgParen":
            var Fe = "(", Ue = ")";
            if (0 <= y) {
              switch (R = "", t[0][y][1][0]) {
                case 2:
                  Fe = Wr(" ", t[0][y][1][1]) + Fe;
                  break;
                case 3:
                  Fe = Wr("\r", t[0][y][1][1]) + Fe;
                  break;
                case 4:
                  Ue = Wr(" ", t[0][y][1][1]) + Ue;
                  break;
                case 5:
                  Ue = Wr("\r", t[0][y][1][1]) + Ue;
                  break;
                default:
                  if (d.WTF)
                    throw new Error("Unexpected PtgAttrSpaceType " + t[0][y][1][0]);
              }
              y = -1;
            }
            E.push(Fe + E.pop() + Ue);
            break;
          case "PtgRefErr":
          case "PtgRefErr3d":
            E.push("#REF!");
            break;
          case "PtgExp":
            u = { c: A[1][1], r: A[1][0] };
            var Ne = { c: a.c, r: a.r };
            if (l.sharedf[$t(u)])
              be = l.sharedf[$t(u)], E.push(Gn(be, 0, Ne, l, d));
            else {
              for (var ze = !1, ut = 0; ut != l.arrayf.length; ++ut)
                if (_ = l.arrayf[ut], !(u.c < _[0].s.c || u.c > _[0].e.c || u.r < _[0].s.r || u.r > _[0].e.r)) {
                  E.push(Gn(_[1], 0, Ne, l, d)), ze = !0;
                  break;
                }
              ze || E.push(A[1]);
            }
            break;
          case "PtgArray":
            E.push("{" + function(nt) {
              for (var je = [], Ye = 0; Ye < nt.length; ++Ye) {
                for (var ht = nt[Ye], Tt = [], xt = 0; xt < ht.length; ++xt) {
                  var Zt = ht[xt];
                  Zt ? Zt[0] === 2 ? Tt.push('"' + Zt[1].replace(/"/g, '""') + '"') : Tt.push(Zt[1]) : Tt.push("");
                }
                je.push(Tt.join(","));
              }
              return je.join(";");
            }(A[1]) + "}");
            break;
          case "PtgMemArea":
            break;
          case "PtgAttrSpace":
          case "PtgAttrSpaceSemi":
            y = P;
            break;
          case "PtgTbl":
          case "PtgMemErr":
            break;
          case "PtgMissArg":
            E.push("");
            break;
          case "PtgAreaErr":
          case "PtgAreaErr3d":
            E.push("#REF!");
            break;
          case "PtgList":
            E.push("Table" + A[1].idx + "[#" + A[1].rt + "]");
            break;
          case "PtgMemAreaN":
          case "PtgMemNoMemN":
          case "PtgAttrNoop":
          case "PtgSheet":
          case "PtgEndSheet":
          case "PtgMemFunc":
          case "PtgMemNoMem":
            break;
          case "PtgElfCol":
          case "PtgElfColS":
          case "PtgElfColSV":
          case "PtgElfColV":
          case "PtgElfLel":
          case "PtgElfRadical":
          case "PtgElfRadicalLel":
          case "PtgElfRadicalS":
          case "PtgElfRw":
          case "PtgElfRwV":
            throw new Error("Unsupported ELFs");
          case "PtgSxName":
          default:
            throw new Error("Unrecognized Formula Token: " + String(A));
        }
        if (d.biff != 3 && 0 <= y && ["PtgAttrSpace", "PtgAttrSpaceSemi", "PtgAttrGoto"].indexOf(t[0][P][0]) == -1) {
          var lt = !0;
          switch ((A = t[0][y])[1][0]) {
            case 4:
              lt = !1;
            case 0:
              R = Wr(" ", A[1][1]);
              break;
            case 5:
              lt = !1;
            case 1:
              R = Wr("\r", A[1][1]);
              break;
            default:
              if (R = "", d.WTF)
                throw new Error("Unexpected PtgAttrSpaceType " + A[1][0]);
          }
          E.push((lt ? R : "") + E.pop() + (lt ? "" : R)), y = -1;
        }
      }
      if (1 < E.length && d.WTF)
        throw new Error("bad formula stack");
      return E[0];
    }
    function Ac(t, u, a) {
      var l = t.l + u, d = ha(t);
      a.biff == 2 && ++t.l;
      var _ = function(p) {
        var m;
        if (wa(p, p.l + 6) !== 65535)
          return [wn(p), "n"];
        switch (p[p.l]) {
          case 0:
            return p.l += 8, ["String", "s"];
          case 1:
            return m = p[p.l + 2] === 1, p.l += 8, [m, "b"];
          case 2:
            return m = p[p.l + 2], p.l += 8, [m, "e"];
          case 3:
            return p.l += 8, ["", "s"];
        }
        return [];
      }(t), u = t.read_shift(1);
      return a.biff != 2 && (t.read_shift(1), 5 <= a.biff && t.read_shift(4)), a = function(p, m, f) {
        var E, b = p.l + m, T = f.biff == 2 ? 1 : 2, v = p.read_shift(T);
        if (v == 65535)
          return [[], In(p, m - 2)];
        var y = Mo(p, v, f);
        return m !== v + T && (E = Lo(p, m - v - T, y, f)), p.l = b, [y, E];
      }(t, l - t.l, a), { cell: d, val: _[0], formula: a, shared: u >> 3 & 1, tt: _[1] };
    }
    function RR(t, n, a, l, d) {
      n = pi(n, a, d), d = (a = t.v) != null ? Fi(typeof a == "number" ? a : 0) : ((a = Me(8)).write_shift(1, 3), a.write_shift(1, 0), a.write_shift(2, 0), a.write_shift(2, 0), a.write_shift(2, 65535), a), a = Me(6), a.write_shift(2, 33), a.write_shift(4, 0);
      for (var _ = Me(t.bf.length), u = 0; u < t.bf.length; ++u)
        _[u] = t.bf[u];
      return mt([n, d, a, _]);
    }
    function Fs(t, n, a) {
      var d = t.read_shift(4), l = Mo(t, d, a), d = t.read_shift(4);
      return [l, 0 < d ? Lo(t, d, l, a) : null];
    }
    var NR = Fs, Us = Fs, AR = Fs, OR = Fs, yR = { 0: "BEEP", 1: "OPEN", 2: "OPEN.LINKS", 3: "CLOSE.ALL", 4: "SAVE", 5: "SAVE.AS", 6: "FILE.DELETE", 7: "PAGE.SETUP", 8: "PRINT", 9: "PRINTER.SETUP", 10: "QUIT", 11: "NEW.WINDOW", 12: "ARRANGE.ALL", 13: "WINDOW.SIZE", 14: "WINDOW.MOVE", 15: "FULL", 16: "CLOSE", 17: "RUN", 22: "SET.PRINT.AREA", 23: "SET.PRINT.TITLES", 24: "SET.PAGE.BREAK", 25: "REMOVE.PAGE.BREAK", 26: "FONT", 27: "DISPLAY", 28: "PROTECT.DOCUMENT", 29: "PRECISION", 30: "A1.R1C1", 31: "CALCULATE.NOW", 32: "CALCULATION", 34: "DATA.FIND", 35: "EXTRACT", 36: "DATA.DELETE", 37: "SET.DATABASE", 38: "SET.CRITERIA", 39: "SORT", 40: "DATA.SERIES", 41: "TABLE", 42: "FORMAT.NUMBER", 43: "ALIGNMENT", 44: "STYLE", 45: "BORDER", 46: "CELL.PROTECTION", 47: "COLUMN.WIDTH", 48: "UNDO", 49: "CUT", 50: "COPY", 51: "PASTE", 52: "CLEAR", 53: "PASTE.SPECIAL", 54: "EDIT.DELETE", 55: "INSERT", 56: "FILL.RIGHT", 57: "FILL.DOWN", 61: "DEFINE.NAME", 62: "CREATE.NAMES", 63: "FORMULA.GOTO", 64: "FORMULA.FIND", 65: "SELECT.LAST.CELL", 66: "SHOW.ACTIVE.CELL", 67: "GALLERY.AREA", 68: "GALLERY.BAR", 69: "GALLERY.COLUMN", 70: "GALLERY.LINE", 71: "GALLERY.PIE", 72: "GALLERY.SCATTER", 73: "COMBINATION", 74: "PREFERRED", 75: "ADD.OVERLAY", 76: "GRIDLINES", 77: "SET.PREFERRED", 78: "AXES", 79: "LEGEND", 80: "ATTACH.TEXT", 81: "ADD.ARROW", 82: "SELECT.CHART", 83: "SELECT.PLOT.AREA", 84: "PATTERNS", 85: "MAIN.CHART", 86: "OVERLAY", 87: "SCALE", 88: "FORMAT.LEGEND", 89: "FORMAT.TEXT", 90: "EDIT.REPEAT", 91: "PARSE", 92: "JUSTIFY", 93: "HIDE", 94: "UNHIDE", 95: "WORKSPACE", 96: "FORMULA", 97: "FORMULA.FILL", 98: "FORMULA.ARRAY", 99: "DATA.FIND.NEXT", 100: "DATA.FIND.PREV", 101: "FORMULA.FIND.NEXT", 102: "FORMULA.FIND.PREV", 103: "ACTIVATE", 104: "ACTIVATE.NEXT", 105: "ACTIVATE.PREV", 106: "UNLOCKED.NEXT", 107: "UNLOCKED.PREV", 108: "COPY.PICTURE", 109: "SELECT", 110: "DELETE.NAME", 111: "DELETE.FORMAT", 112: "VLINE", 113: "HLINE", 114: "VPAGE", 115: "HPAGE", 116: "VSCROLL", 117: "HSCROLL", 118: "ALERT", 119: "NEW", 120: "CANCEL.COPY", 121: "SHOW.CLIPBOARD", 122: "MESSAGE", 124: "PASTE.LINK", 125: "APP.ACTIVATE", 126: "DELETE.ARROW", 127: "ROW.HEIGHT", 128: "FORMAT.MOVE", 129: "FORMAT.SIZE", 130: "FORMULA.REPLACE", 131: "SEND.KEYS", 132: "SELECT.SPECIAL", 133: "APPLY.NAMES", 134: "REPLACE.FONT", 135: "FREEZE.PANES", 136: "SHOW.INFO", 137: "SPLIT", 138: "ON.WINDOW", 139: "ON.DATA", 140: "DISABLE.INPUT", 142: "OUTLINE", 143: "LIST.NAMES", 144: "FILE.CLOSE", 145: "SAVE.WORKBOOK", 146: "DATA.FORM", 147: "COPY.CHART", 148: "ON.TIME", 149: "WAIT", 150: "FORMAT.FONT", 151: "FILL.UP", 152: "FILL.LEFT", 153: "DELETE.OVERLAY", 155: "SHORT.MENUS", 159: "SET.UPDATE.STATUS", 161: "COLOR.PALETTE", 162: "DELETE.STYLE", 163: "WINDOW.RESTORE", 164: "WINDOW.MAXIMIZE", 166: "CHANGE.LINK", 167: "CALCULATE.DOCUMENT", 168: "ON.KEY", 169: "APP.RESTORE", 170: "APP.MOVE", 171: "APP.SIZE", 172: "APP.MINIMIZE", 173: "APP.MAXIMIZE", 174: "BRING.TO.FRONT", 175: "SEND.TO.BACK", 185: "MAIN.CHART.TYPE", 186: "OVERLAY.CHART.TYPE", 187: "SELECT.END", 188: "OPEN.MAIL", 189: "SEND.MAIL", 190: "STANDARD.FONT", 191: "CONSOLIDATE", 192: "SORT.SPECIAL", 193: "GALLERY.3D.AREA", 194: "GALLERY.3D.COLUMN", 195: "GALLERY.3D.LINE", 196: "GALLERY.3D.PIE", 197: "VIEW.3D", 198: "GOAL.SEEK", 199: "WORKGROUP", 200: "FILL.GROUP", 201: "UPDATE.LINK", 202: "PROMOTE", 203: "DEMOTE", 204: "SHOW.DETAIL", 206: "UNGROUP", 207: "OBJECT.PROPERTIES", 208: "SAVE.NEW.OBJECT", 209: "SHARE", 210: "SHARE.NAME", 211: "DUPLICATE", 212: "APPLY.STYLE", 213: "ASSIGN.TO.OBJECT", 214: "OBJECT.PROTECTION", 215: "HIDE.OBJECT", 216: "SET.EXTRACT", 217: "CREATE.PUBLISHER", 218: "SUBSCRIBE.TO", 219: "ATTRIBUTES", 220: "SHOW.TOOLBAR", 222: "PRINT.PREVIEW", 223: "EDIT.COLOR", 224: "SHOW.LEVELS", 225: "FORMAT.MAIN", 226: "FORMAT.OVERLAY", 227: "ON.RECALC", 228: "EDIT.SERIES", 229: "DEFINE.STYLE", 240: "LINE.PRINT", 243: "ENTER.DATA", 249: "GALLERY.RADAR", 250: "MERGE.STYLES", 251: "EDITION.OPTIONS", 252: "PASTE.PICTURE", 253: "PASTE.PICTURE.LINK", 254: "SPELLING", 256: "ZOOM", 259: "INSERT.OBJECT", 260: "WINDOW.MINIMIZE", 265: "SOUND.NOTE", 266: "SOUND.PLAY", 267: "FORMAT.SHAPE", 268: "EXTEND.POLYGON", 269: "FORMAT.AUTO", 272: "GALLERY.3D.BAR", 273: "GALLERY.3D.SURFACE", 274: "FILL.AUTO", 276: "CUSTOMIZE.TOOLBAR", 277: "ADD.TOOL", 278: "EDIT.OBJECT", 279: "ON.DOUBLECLICK", 280: "ON.ENTRY", 281: "WORKBOOK.ADD", 282: "WORKBOOK.MOVE", 283: "WORKBOOK.COPY", 284: "WORKBOOK.OPTIONS", 285: "SAVE.WORKSPACE", 288: "CHART.WIZARD", 289: "DELETE.TOOL", 290: "MOVE.TOOL", 291: "WORKBOOK.SELECT", 292: "WORKBOOK.ACTIVATE", 293: "ASSIGN.TO.TOOL", 295: "COPY.TOOL", 296: "RESET.TOOL", 297: "CONSTRAIN.NUMERIC", 298: "PASTE.TOOL", 302: "WORKBOOK.NEW", 305: "SCENARIO.CELLS", 306: "SCENARIO.DELETE", 307: "SCENARIO.ADD", 308: "SCENARIO.EDIT", 309: "SCENARIO.SHOW", 310: "SCENARIO.SHOW.NEXT", 311: "SCENARIO.SUMMARY", 312: "PIVOT.TABLE.WIZARD", 313: "PIVOT.FIELD.PROPERTIES", 314: "PIVOT.FIELD", 315: "PIVOT.ITEM", 316: "PIVOT.ADD.FIELDS", 318: "OPTIONS.CALCULATION", 319: "OPTIONS.EDIT", 320: "OPTIONS.VIEW", 321: "ADDIN.MANAGER", 322: "MENU.EDITOR", 323: "ATTACH.TOOLBARS", 324: "VBAActivate", 325: "OPTIONS.CHART", 328: "VBA.INSERT.FILE", 330: "VBA.PROCEDURE.DEFINITION", 336: "ROUTING.SLIP", 338: "ROUTE.DOCUMENT", 339: "MAIL.LOGON", 342: "INSERT.PICTURE", 343: "EDIT.TOOL", 344: "GALLERY.DOUGHNUT", 350: "CHART.TREND", 352: "PIVOT.ITEM.PROPERTIES", 354: "WORKBOOK.INSERT", 355: "OPTIONS.TRANSITION", 356: "OPTIONS.GENERAL", 370: "FILTER.ADVANCED", 373: "MAIL.ADD.MAILER", 374: "MAIL.DELETE.MAILER", 375: "MAIL.REPLY", 376: "MAIL.REPLY.ALL", 377: "MAIL.FORWARD", 378: "MAIL.NEXT.LETTER", 379: "DATA.LABEL", 380: "INSERT.TITLE", 381: "FONT.PROPERTIES", 382: "MACRO.OPTIONS", 383: "WORKBOOK.HIDE", 384: "WORKBOOK.UNHIDE", 385: "WORKBOOK.DELETE", 386: "WORKBOOK.NAME", 388: "GALLERY.CUSTOM", 390: "ADD.CHART.AUTOFORMAT", 391: "DELETE.CHART.AUTOFORMAT", 392: "CHART.ADD.DATA", 393: "AUTO.OUTLINE", 394: "TAB.ORDER", 395: "SHOW.DIALOG", 396: "SELECT.ALL", 397: "UNGROUP.SHEETS", 398: "SUBTOTAL.CREATE", 399: "SUBTOTAL.REMOVE", 400: "RENAME.OBJECT", 412: "WORKBOOK.SCROLL", 413: "WORKBOOK.NEXT", 414: "WORKBOOK.PREV", 415: "WORKBOOK.TAB.SPLIT", 416: "FULL.SCREEN", 417: "WORKBOOK.PROTECT", 420: "SCROLLBAR.PROPERTIES", 421: "PIVOT.SHOW.PAGES", 422: "TEXT.TO.COLUMNS", 423: "FORMAT.CHARTTYPE", 424: "LINK.FORMAT", 425: "TRACER.DISPLAY", 430: "TRACER.NAVIGATE", 431: "TRACER.CLEAR", 432: "TRACER.ERROR", 433: "PIVOT.FIELD.GROUP", 434: "PIVOT.FIELD.UNGROUP", 435: "CHECKBOX.PROPERTIES", 436: "LABEL.PROPERTIES", 437: "LISTBOX.PROPERTIES", 438: "EDITBOX.PROPERTIES", 439: "PIVOT.REFRESH", 440: "LINK.COMBO", 441: "OPEN.TEXT", 442: "HIDE.DIALOG", 443: "SET.DIALOG.FOCUS", 444: "ENABLE.OBJECT", 445: "PUSHBUTTON.PROPERTIES", 446: "SET.DIALOG.DEFAULT", 447: "FILTER", 448: "FILTER.SHOW.ALL", 449: "CLEAR.OUTLINE", 450: "FUNCTION.WIZARD", 451: "ADD.LIST.ITEM", 452: "SET.LIST.ITEM", 453: "REMOVE.LIST.ITEM", 454: "SELECT.LIST.ITEM", 455: "SET.CONTROL.VALUE", 456: "SAVE.COPY.AS", 458: "OPTIONS.LISTS.ADD", 459: "OPTIONS.LISTS.DELETE", 460: "SERIES.AXES", 461: "SERIES.X", 462: "SERIES.Y", 463: "ERRORBAR.X", 464: "ERRORBAR.Y", 465: "FORMAT.CHART", 466: "SERIES.ORDER", 467: "MAIL.LOGOFF", 468: "CLEAR.ROUTING.SLIP", 469: "APP.ACTIVATE.MICROSOFT", 470: "MAIL.EDIT.MAILER", 471: "ON.SHEET", 472: "STANDARD.WIDTH", 473: "SCENARIO.MERGE", 474: "SUMMARY.INFO", 475: "FIND.FILE", 476: "ACTIVE.CELL.FONT", 477: "ENABLE.TIPWIZARD", 478: "VBA.MAKE.ADDIN", 480: "INSERTDATATABLE", 481: "WORKGROUP.OPTIONS", 482: "MAIL.SEND.MAILER", 485: "AUTOCORRECT", 489: "POST.DOCUMENT", 491: "PICKLIST", 493: "VIEW.SHOW", 494: "VIEW.DEFINE", 495: "VIEW.DELETE", 509: "SHEET.BACKGROUND", 510: "INSERT.MAP.OBJECT", 511: "OPTIONS.MENONO", 517: "MSOCHECKS", 518: "NORMAL", 519: "LAYOUT", 520: "RM.PRINT.AREA", 521: "CLEAR.PRINT.AREA", 522: "ADD.PRINT.AREA", 523: "MOVE.BRK", 545: "HIDECURR.NOTE", 546: "HIDEALL.NOTES", 547: "DELETE.NOTE", 548: "TRAVERSE.NOTES", 549: "ACTIVATE.NOTES", 620: "PROTECT.REVISIONS", 621: "UNPROTECT.REVISIONS", 647: "OPTIONS.ME", 653: "WEB.PUBLISH", 667: "NEWWEBQUERY", 673: "PIVOT.TABLE.CHART", 753: "OPTIONS.SAVE", 755: "OPTIONS.SPELL", 808: "HIDEALL.INKANNOTS" }, RE = { 0: "COUNT", 1: "IF", 2: "ISNA", 3: "ISERROR", 4: "SUM", 5: "AVERAGE", 6: "MIN", 7: "MAX", 8: "ROW", 9: "COLUMN", 10: "NA", 11: "NPV", 12: "STDEV", 13: "DOLLAR", 14: "FIXED", 15: "SIN", 16: "COS", 17: "TAN", 18: "ATAN", 19: "PI", 20: "SQRT", 21: "EXP", 22: "LN", 23: "LOG10", 24: "ABS", 25: "INT", 26: "SIGN", 27: "ROUND", 28: "LOOKUP", 29: "INDEX", 30: "REPT", 31: "MID", 32: "LEN", 33: "VALUE", 34: "TRUE", 35: "FALSE", 36: "AND", 37: "OR", 38: "NOT", 39: "MOD", 40: "DCOUNT", 41: "DSUM", 42: "DAVERAGE", 43: "DMIN", 44: "DMAX", 45: "DSTDEV", 46: "VAR", 47: "DVAR", 48: "TEXT", 49: "LINEST", 50: "TREND", 51: "LOGEST", 52: "GROWTH", 53: "GOTO", 54: "HALT", 55: "RETURN", 56: "PV", 57: "FV", 58: "NPER", 59: "PMT", 60: "RATE", 61: "MIRR", 62: "IRR", 63: "RAND", 64: "MATCH", 65: "DATE", 66: "TIME", 67: "DAY", 68: "MONTH", 69: "YEAR", 70: "WEEKDAY", 71: "HOUR", 72: "MINUTE", 73: "SECOND", 74: "NOW", 75: "AREAS", 76: "ROWS", 77: "COLUMNS", 78: "OFFSET", 79: "ABSREF", 80: "RELREF", 81: "ARGUMENT", 82: "SEARCH", 83: "TRANSPOSE", 84: "ERROR", 85: "STEP", 86: "TYPE", 87: "ECHO", 88: "SET.NAME", 89: "CALLER", 90: "DEREF", 91: "WINDOWS", 92: "SERIES", 93: "DOCUMENTS", 94: "ACTIVE.CELL", 95: "SELECTION", 96: "RESULT", 97: "ATAN2", 98: "ASIN", 99: "ACOS", 100: "CHOOSE", 101: "HLOOKUP", 102: "VLOOKUP", 103: "LINKS", 104: "INPUT", 105: "ISREF", 106: "GET.FORMULA", 107: "GET.NAME", 108: "SET.VALUE", 109: "LOG", 110: "EXEC", 111: "CHAR", 112: "LOWER", 113: "UPPER", 114: "PROPER", 115: "LEFT", 116: "RIGHT", 117: "EXACT", 118: "TRIM", 119: "REPLACE", 120: "SUBSTITUTE", 121: "CODE", 122: "NAMES", 123: "DIRECTORY", 124: "FIND", 125: "CELL", 126: "ISERR", 127: "ISTEXT", 128: "ISNUMBER", 129: "ISBLANK", 130: "T", 131: "N", 132: "FOPEN", 133: "FCLOSE", 134: "FSIZE", 135: "FREADLN", 136: "FREAD", 137: "FWRITELN", 138: "FWRITE", 139: "FPOS", 140: "DATEVALUE", 141: "TIMEVALUE", 142: "SLN", 143: "SYD", 144: "DDB", 145: "GET.DEF", 146: "REFTEXT", 147: "TEXTREF", 148: "INDIRECT", 149: "REGISTER", 150: "CALL", 151: "ADD.BAR", 152: "ADD.MENU", 153: "ADD.COMMAND", 154: "ENABLE.COMMAND", 155: "CHECK.COMMAND", 156: "RENAME.COMMAND", 157: "SHOW.BAR", 158: "DELETE.MENU", 159: "DELETE.COMMAND", 160: "GET.CHART.ITEM", 161: "DIALOG.BOX", 162: "CLEAN", 163: "MDETERM", 164: "MINVERSE", 165: "MMULT", 166: "FILES", 167: "IPMT", 168: "PPMT", 169: "COUNTA", 170: "CANCEL.KEY", 171: "FOR", 172: "WHILE", 173: "BREAK", 174: "NEXT", 175: "INITIATE", 176: "REQUEST", 177: "POKE", 178: "EXECUTE", 179: "TERMINATE", 180: "RESTART", 181: "HELP", 182: "GET.BAR", 183: "PRODUCT", 184: "FACT", 185: "GET.CELL", 186: "GET.WORKSPACE", 187: "GET.WINDOW", 188: "GET.DOCUMENT", 189: "DPRODUCT", 190: "ISNONTEXT", 191: "GET.NOTE", 192: "NOTE", 193: "STDEVP", 194: "VARP", 195: "DSTDEVP", 196: "DVARP", 197: "TRUNC", 198: "ISLOGICAL", 199: "DCOUNTA", 200: "DELETE.BAR", 201: "UNREGISTER", 204: "USDOLLAR", 205: "FINDB", 206: "SEARCHB", 207: "REPLACEB", 208: "LEFTB", 209: "RIGHTB", 210: "MIDB", 211: "LENB", 212: "ROUNDUP", 213: "ROUNDDOWN", 214: "ASC", 215: "DBCS", 216: "RANK", 219: "ADDRESS", 220: "DAYS360", 221: "TODAY", 222: "VDB", 223: "ELSE", 224: "ELSE.IF", 225: "END.IF", 226: "FOR.CELL", 227: "MEDIAN", 228: "SUMPRODUCT", 229: "SINH", 230: "COSH", 231: "TANH", 232: "ASINH", 233: "ACOSH", 234: "ATANH", 235: "DGET", 236: "CREATE.OBJECT", 237: "VOLATILE", 238: "LAST.ERROR", 239: "CUSTOM.UNDO", 240: "CUSTOM.REPEAT", 241: "FORMULA.CONVERT", 242: "GET.LINK.INFO", 243: "TEXT.BOX", 244: "INFO", 245: "GROUP", 246: "GET.OBJECT", 247: "DB", 248: "PAUSE", 251: "RESUME", 252: "FREQUENCY", 253: "ADD.TOOLBAR", 254: "DELETE.TOOLBAR", 255: "User", 256: "RESET.TOOLBAR", 257: "EVALUATE", 258: "GET.TOOLBAR", 259: "GET.TOOL", 260: "SPELLING.CHECK", 261: "ERROR.TYPE", 262: "APP.TITLE", 263: "WINDOW.TITLE", 264: "SAVE.TOOLBAR", 265: "ENABLE.TOOL", 266: "PRESS.TOOL", 267: "REGISTER.ID", 268: "GET.WORKBOOK", 269: "AVEDEV", 270: "BETADIST", 271: "GAMMALN", 272: "BETAINV", 273: "BINOMDIST", 274: "CHIDIST", 275: "CHIINV", 276: "COMBIN", 277: "CONFIDENCE", 278: "CRITBINOM", 279: "EVEN", 280: "EXPONDIST", 281: "FDIST", 282: "FINV", 283: "FISHER", 284: "FISHERINV", 285: "FLOOR", 286: "GAMMADIST", 287: "GAMMAINV", 288: "CEILING", 289: "HYPGEOMDIST", 290: "LOGNORMDIST", 291: "LOGINV", 292: "NEGBINOMDIST", 293: "NORMDIST", 294: "NORMSDIST", 295: "NORMINV", 296: "NORMSINV", 297: "STANDARDIZE", 298: "ODD", 299: "PERMUT", 300: "POISSON", 301: "TDIST", 302: "WEIBULL", 303: "SUMXMY2", 304: "SUMX2MY2", 305: "SUMX2PY2", 306: "CHITEST", 307: "CORREL", 308: "COVAR", 309: "FORECAST", 310: "FTEST", 311: "INTERCEPT", 312: "PEARSON", 313: "RSQ", 314: "STEYX", 315: "SLOPE", 316: "TTEST", 317: "PROB", 318: "DEVSQ", 319: "GEOMEAN", 320: "HARMEAN", 321: "SUMSQ", 322: "KURT", 323: "SKEW", 324: "ZTEST", 325: "LARGE", 326: "SMALL", 327: "QUARTILE", 328: "PERCENTILE", 329: "PERCENTRANK", 330: "MODE", 331: "TRIMMEAN", 332: "TINV", 334: "MOVIE.COMMAND", 335: "GET.MOVIE", 336: "CONCATENATE", 337: "POWER", 338: "PIVOT.ADD.DATA", 339: "GET.PIVOT.TABLE", 340: "GET.PIVOT.FIELD", 341: "GET.PIVOT.ITEM", 342: "RADIANS", 343: "DEGREES", 344: "SUBTOTAL", 345: "SUMIF", 346: "COUNTIF", 347: "COUNTBLANK", 348: "SCENARIO.GET", 349: "OPTIONS.LISTS.GET", 350: "ISPMT", 351: "DATEDIF", 352: "DATESTRING", 353: "NUMBERSTRING", 354: "ROMAN", 355: "OPEN.DIALOG", 356: "SAVE.DIALOG", 357: "VIEW.GET", 358: "GETPIVOTDATA", 359: "HYPERLINK", 360: "PHONETIC", 361: "AVERAGEA", 362: "MAXA", 363: "MINA", 364: "STDEVPA", 365: "VARPA", 366: "STDEVA", 367: "VARA", 368: "BAHTTEXT", 369: "THAIDAYOFWEEK", 370: "THAIDIGIT", 371: "THAIMONTHOFYEAR", 372: "THAINUMSOUND", 373: "THAINUMSTRING", 374: "THAISTRINGLENGTH", 375: "ISTHAIDIGIT", 376: "ROUNDBAHTDOWN", 377: "ROUNDBAHTUP", 378: "THAIYEAR", 379: "RTD", 380: "CUBEVALUE", 381: "CUBEMEMBER", 382: "CUBEMEMBERPROPERTY", 383: "CUBERANKEDMEMBER", 384: "HEX2BIN", 385: "HEX2DEC", 386: "HEX2OCT", 387: "DEC2BIN", 388: "DEC2HEX", 389: "DEC2OCT", 390: "OCT2BIN", 391: "OCT2HEX", 392: "OCT2DEC", 393: "BIN2DEC", 394: "BIN2OCT", 395: "BIN2HEX", 396: "IMSUB", 397: "IMDIV", 398: "IMPOWER", 399: "IMABS", 400: "IMSQRT", 401: "IMLN", 402: "IMLOG2", 403: "IMLOG10", 404: "IMSIN", 405: "IMCOS", 406: "IMEXP", 407: "IMARGUMENT", 408: "IMCONJUGATE", 409: "IMAGINARY", 410: "IMREAL", 411: "COMPLEX", 412: "IMSUM", 413: "IMPRODUCT", 414: "SERIESSUM", 415: "FACTDOUBLE", 416: "SQRTPI", 417: "QUOTIENT", 418: "DELTA", 419: "GESTEP", 420: "ISEVEN", 421: "ISODD", 422: "MROUND", 423: "ERF", 424: "ERFC", 425: "BESSELJ", 426: "BESSELK", 427: "BESSELY", 428: "BESSELI", 429: "XIRR", 430: "XNPV", 431: "PRICEMAT", 432: "YIELDMAT", 433: "INTRATE", 434: "RECEIVED", 435: "DISC", 436: "PRICEDISC", 437: "YIELDDISC", 438: "TBILLEQ", 439: "TBILLPRICE", 440: "TBILLYIELD", 441: "PRICE", 442: "YIELD", 443: "DOLLARDE", 444: "DOLLARFR", 445: "NOMINAL", 446: "EFFECT", 447: "CUMPRINC", 448: "CUMIPMT", 449: "EDATE", 450: "EOMONTH", 451: "YEARFRAC", 452: "COUPDAYBS", 453: "COUPDAYS", 454: "COUPDAYSNC", 455: "COUPNCD", 456: "COUPNUM", 457: "COUPPCD", 458: "DURATION", 459: "MDURATION", 460: "ODDLPRICE", 461: "ODDLYIELD", 462: "ODDFPRICE", 463: "ODDFYIELD", 464: "RANDBETWEEN", 465: "WEEKNUM", 466: "AMORDEGRC", 467: "AMORLINC", 468: "CONVERT", 724: "SHEETJS", 469: "ACCRINT", 470: "ACCRINTM", 471: "WORKDAY", 472: "NETWORKDAYS", 473: "GCD", 474: "MULTINOMIAL", 475: "LCM", 476: "FVSCHEDULE", 477: "CUBEKPIMEMBER", 478: "CUBESET", 479: "CUBESETCOUNT", 480: "IFERROR", 481: "COUNTIFS", 482: "SUMIFS", 483: "AVERAGEIF", 484: "AVERAGEIFS" }, IR = { 2: 1, 3: 1, 10: 0, 15: 1, 16: 1, 17: 1, 18: 1, 19: 0, 20: 1, 21: 1, 22: 1, 23: 1, 24: 1, 25: 1, 26: 1, 27: 2, 30: 2, 31: 3, 32: 1, 33: 1, 34: 0, 35: 0, 38: 1, 39: 2, 40: 3, 41: 3, 42: 3, 43: 3, 44: 3, 45: 3, 47: 3, 48: 2, 53: 1, 61: 3, 63: 0, 65: 3, 66: 3, 67: 1, 68: 1, 69: 1, 70: 1, 71: 1, 72: 1, 73: 1, 74: 0, 75: 1, 76: 1, 77: 1, 79: 2, 80: 2, 83: 1, 85: 0, 86: 1, 89: 0, 90: 1, 94: 0, 95: 0, 97: 2, 98: 1, 99: 1, 101: 3, 102: 3, 105: 1, 106: 1, 108: 2, 111: 1, 112: 1, 113: 1, 114: 1, 117: 2, 118: 1, 119: 4, 121: 1, 126: 1, 127: 1, 128: 1, 129: 1, 130: 1, 131: 1, 133: 1, 134: 1, 135: 1, 136: 2, 137: 2, 138: 2, 140: 1, 141: 1, 142: 3, 143: 4, 144: 4, 161: 1, 162: 1, 163: 1, 164: 1, 165: 2, 172: 1, 175: 2, 176: 2, 177: 3, 178: 2, 179: 1, 184: 1, 186: 1, 189: 3, 190: 1, 195: 3, 196: 3, 197: 1, 198: 1, 199: 3, 201: 1, 207: 4, 210: 3, 211: 1, 212: 2, 213: 2, 214: 1, 215: 1, 225: 0, 229: 1, 230: 1, 231: 1, 232: 1, 233: 1, 234: 1, 235: 3, 244: 1, 247: 4, 252: 2, 257: 1, 261: 1, 271: 1, 273: 4, 274: 2, 275: 2, 276: 2, 277: 3, 278: 3, 279: 1, 280: 3, 281: 3, 282: 3, 283: 1, 284: 1, 285: 2, 286: 4, 287: 3, 288: 2, 289: 4, 290: 3, 291: 3, 292: 3, 293: 4, 294: 1, 295: 3, 296: 1, 297: 3, 298: 1, 299: 2, 300: 3, 301: 3, 302: 4, 303: 2, 304: 2, 305: 2, 306: 2, 307: 2, 308: 2, 309: 3, 310: 2, 311: 2, 312: 2, 313: 2, 314: 2, 315: 2, 316: 4, 325: 2, 326: 2, 327: 2, 328: 2, 331: 2, 332: 2, 337: 2, 342: 1, 343: 1, 346: 2, 347: 1, 350: 4, 351: 3, 352: 1, 353: 2, 360: 1, 368: 1, 369: 1, 370: 1, 371: 1, 372: 1, 373: 1, 374: 1, 375: 1, 376: 1, 377: 1, 378: 1, 382: 3, 385: 1, 392: 1, 393: 1, 396: 2, 397: 2, 398: 2, 399: 1, 400: 1, 401: 1, 402: 1, 403: 1, 404: 1, 405: 1, 406: 1, 407: 1, 408: 1, 409: 1, 410: 1, 414: 4, 415: 1, 416: 1, 417: 2, 420: 1, 421: 1, 422: 2, 424: 1, 425: 2, 426: 2, 427: 2, 428: 2, 430: 3, 438: 3, 439: 3, 440: 3, 443: 2, 444: 2, 445: 2, 446: 2, 447: 6, 448: 6, 449: 2, 450: 2, 464: 2, 468: 3, 476: 2, 479: 1, 480: 2, 65535: 0 };
    function NE(t) {
      return (t = (t = (t = (t = (t = t.slice(0, 3) == "of:" ? t.slice(3) : t).charCodeAt(0) == 61 && (t = t.slice(1)).charCodeAt(0) == 61 ? t.slice(1) : t).replace(/COM\.MICROSOFT\./g, "")).replace(/\[((?:\.[A-Z]+[0-9]+)(?::\.[A-Z]+[0-9]+)?)\]/g, function(n, a) {
        return a.replace(/\./g, "");
      })).replace(/\[.(#[A-Z]*[?!])\]/g, "$1")).replace(/[;~]/g, ",").replace(/\|/g, ";");
    }
    function Oc(t) {
      return t = t.split(":"), [t[0].split(".")[0], t[0].split(".")[1] + (1 < t.length ? ":" + (t[1].split(".")[1] || t[1].split(".")[0]) : "")];
    }
    var Po = {}, $i = {}, ko = typeof Map < "u";
    function yc(t, n, a) {
      var l = 0, d = t.length;
      if (a) {
        if (ko ? a.has(n) : Object.prototype.hasOwnProperty.call(a, n)) {
          for (var _ = ko ? a.get(n) : a[n]; l < _.length; ++l)
            if (t[_[l]].t === n)
              return t.Count++, _[l];
        }
      } else
        for (; l < d; ++l)
          if (t[l].t === n)
            return t.Count++, l;
      return t[d] = { t: n }, t.Count++, t.Unique++, a && (ko ? (a.has(n) || a.set(n, []), a.get(n).push(d)) : (Object.prototype.hasOwnProperty.call(a, n) || (a[n] = []), a[n].push(d))), d;
    }
    function Bs(l, n) {
      var a = { min: l + 1, max: l + 1 }, l = -1;
      return n.MDW && (Ln = n.MDW), n.width != null ? a.customWidth = 1 : n.wpx != null ? l = yo(n.wpx) : n.wch != null && (l = n.wch), -1 < l ? (a.width = Ms(l), a.customWidth = 1) : n.width != null && (a.width = n.width), n.hidden && (a.hidden = !0), n.level != null && (a.outlineLevel = a.level = n.level), a;
    }
    function fi(t, n) {
      t && (n = n == "xlml" ? [1, 1, 1, 1, 0.5, 0.5] : [0.7, 0.7, 0.75, 0.75, 0.3, 0.3], t.left == null && (t.left = n[0]), t.right == null && (t.right = n[1]), t.top == null && (t.top = n[2]), t.bottom == null && (t.bottom = n[3]), t.header == null && (t.header = n[4]), t.footer == null && (t.footer = n[5]));
    }
    function za(t, n, a) {
      if (Do !== void 0) {
        if (/^\d+$/.exec(n.s) || n.s && n.s == +n.s)
          return n.s;
        var l = n.s || {};
        return n.z && (l.numFmt = n.z), Do.addStyle(l);
      }
      var d = a.revssf[n.z != null ? n.z : "General"], _ = 60, u = t.length;
      if (d == null && a.ssf) {
        for (; _ < 392; ++_)
          if (a.ssf[_] == null) {
            Qn(n.z, _), a.ssf[_] = n.z, a.revssf[n.z] = d = _;
            break;
          }
      }
      for (_ = 0; _ != u; ++_)
        if (t[_].numFmtId === d)
          return _;
      return t[u] = { numFmtId: d, fontId: 0, fillId: 0, borderId: 0, xfId: 0, applyNumberFormat: 1 }, u;
    }
    function AE(t, n, a, l, d, _) {
      try {
        l.cellNF && (t.z = ae[n]);
      } catch (p) {
        if (l.WTF)
          throw p;
      }
      if (t.t !== "z" || l.cellStyles) {
        if (t.t === "d" && typeof t.v == "string" && (t.v = Br(t.v)), (!l || l.cellText !== !1) && t.t !== "z")
          try {
            if (ae[n] == null && Qn(is[n] || "General", n), t.t === "e")
              t.w = t.w || La[t.v];
            else if (n === 0)
              if (t.t === "n")
                (0 | t.v) === t.v ? t.w = t.v.toString(10) : t.w = Te(t.v);
              else if (t.t === "d") {
                var u = on(t.v);
                t.w = (0 | u) === u ? u.toString(10) : Te(u);
              } else {
                if (t.v === void 0)
                  return;
                t.w = Be(t.v, $i);
              }
            else
              t.t === "d" ? t.w = dn(n, on(t.v), $i) : t.w = dn(n, t.v, $i);
          } catch (p) {
            if (l.WTF)
              throw p;
          }
        if (l.cellStyles && a != null)
          try {
            t.s = _.Fills[a], t.s.fgColor && t.s.fgColor.theme && !t.s.fgColor.rgb && (t.s.fgColor.rgb = Ls(d.themeElements.clrScheme[t.s.fgColor.theme].rgb, t.s.fgColor.tint || 0), l.WTF && (t.s.fgColor.raw_rgb = d.themeElements.clrScheme[t.s.fgColor.theme].rgb)), t.s.bgColor && t.s.bgColor.theme && (t.s.bgColor.rgb = Ls(d.themeElements.clrScheme[t.s.bgColor.theme].rgb, t.s.bgColor.tint || 0), l.WTF && (t.s.bgColor.raw_rgb = d.themeElements.clrScheme[t.s.bgColor.theme].rgb));
          } catch (p) {
            if (l.WTF && _.Fills)
              throw p;
          }
      }
    }
    var DR = /<(?:\w:)?mergeCell ref="[A-Z0-9:]+"\s*[\/]?>/g, wR = /<(?:\w+:)?sheetData[^>]*>([\s\S]*)<\/(?:\w+:)?sheetData>/, xR = /<(?:\w:)?hyperlink [^>]*>/gm, LR = /"(\w*:\w*)"/, MR = /<(?:\w:)?col\b[^>]*[\/]?>/g, PR = /<(?:\w:)?autoFilter[^>]*([\/]|>([\s\S]*)<\/(?:\w:)?autoFilter)>/g, kR = /<(?:\w:)?pageMargins[^>]*\/>/g, OE = /<(?:\w:)?sheetPr\b(?:[^>a-z][^>]*)?\/>/, FR = /<(?:\w:)?sheetPr[^>]*(?:[\/]|>([\s\S]*)<\/(?:\w:)?sheetPr)>/, UR = /<(?:\w:)?sheetViews[^>]*(?:[\/]|>([\s\S]*)<\/(?:\w:)?sheetViews)>/;
    function BR(t, n, a, l, d, _, u) {
      if (!t)
        return t;
      l = l || { "!id": {} };
      var p = n.dense ? [] : {}, m = { s: { r: 2e6, c: 2e6 }, e: { r: 0, c: 0 } }, f = "", me = "", E = t.match(wR);
      E ? (f = t.slice(0, E.index), me = t.slice(E.index + E[0].length)) : f = me = t;
      var b = f.match(OE);
      b ? Ic(b[0], 0, d, a) : (b = f.match(FR)) && (t = b[0], b[1], b = p, T = d, v = a, Ic(t.slice(0, t.indexOf(">")), 0, T, v));
      var T, v, y = (f.match(/<(?:\w*:)?dimension/) || { index: -1 }).index;
      0 < y && (T = f.slice(y, y + 50).match(LR)) && (v = p, (P = lr(P = T[1])).s.r <= P.e.r && P.s.c <= P.e.c && 0 <= P.s.r && 0 <= P.s.c && (v["!ref"] = Xt(P)));
      var R, P = f.match(UR);
      P && P[1] && (A = P[1], (R = d).Views || (R.Views = [{}]), (A.match(YR) || []).forEach(function(le, be) {
        le = Ht(le), R.Views[be] || (R.Views[be] = {}), +le.zoomScale && (R.Views[be].zoom = +le.zoomScale), Lr(le.rightToLeft) && (R.Views[be].RTL = !0);
      }));
      var I, A = [];
      n.cellStyles && (I = f.match(MR)) && function(le, be) {
        for (var Fe = !1, Ue = 0; Ue != be.length; ++Ue) {
          var Ne = Ht(be[Ue], !0);
          Ne.hidden && (Ne.hidden = Lr(Ne.hidden));
          var ze = parseInt(Ne.min, 10) - 1, ut = parseInt(Ne.max, 10) - 1;
          for (Ne.outlineLevel && (Ne.level = +Ne.outlineLevel || 0), delete Ne.min, delete Ne.max, Ne.width = +Ne.width, !Fe && Ne.width && (Fe = !0, bc(Ne.width)), $a(Ne); ze <= ut; )
            le[ze++] = xr(Ne);
        }
      }(A, I), E && HR(E[1], p, n, m, _, u), u = me.match(PR), u && (p["!autofilter"] = { ref: (u[0].match(/ref="([^"]*)"/) || [])[1] });
      var M = [], F = me.match(DR);
      if (F)
        for (y = 0; y != F.length; ++y)
          M[y] = lr(F[y].slice(F[y].indexOf('"') + 1));
      u = me.match(xR), u && function(le, be, Fe) {
        for (var Ue = Array.isArray(le), Ne = 0; Ne != be.length; ++Ne) {
          var ze = Ht(Cr(be[Ne]), !0);
          if (!ze.ref)
            return;
          var ut = ((Fe || {})["!id"] || [])[ze.id];
          ut ? (ze.Target = ut.Target, ze.location && (ze.Target += "#" + mr(ze.location))) : (ze.Target = "#" + mr(ze.location), ut = { Target: ze.Target, TargetMode: "Internal" }), ze.Rel = ut, ze.tooltip && (ze.Tooltip = ze.tooltip, delete ze.tooltip);
          for (var lt = lr(ze.ref), et = lt.s.r; et <= lt.e.r; ++et)
            for (var nt = lt.s.c; nt <= lt.e.c; ++nt) {
              var je = $t({ c: nt, r: et });
              Ue ? (le[et] || (le[et] = []), le[et][nt] || (le[et][nt] = { t: "z", v: void 0 }), le[et][nt].l = ze) : (le[je] || (le[je] = { t: "z", v: void 0 }), le[je].l = ze);
            }
        }
      }(p, u, l);
      var B, re, me = me.match(kR);
      return me && (p["!margins"] = (B = Ht(me[0]), re = {}, ["left", "right", "top", "bottom", "header", "footer"].forEach(function(le) {
        B[le] && (re[le] = parseFloat(B[le]));
      }), re)), !p["!ref"] && m.e.c >= m.s.c && m.e.r >= m.s.r && (p["!ref"] = Xt(m)), 0 < n.sheetRows && p["!ref"] && (me = lr(p["!ref"]), n.sheetRows <= +me.e.r && (me.e.r = n.sheetRows - 1, me.e.r > m.e.r && (me.e.r = m.e.r), me.e.r < me.s.r && (me.s.r = me.e.r), me.e.c > m.e.c && (me.e.c = m.e.c), me.e.c < me.s.c && (me.s.c = me.e.c), p["!fullref"] = p["!ref"], p["!ref"] = Xt(me))), 0 < A.length && (p["!cols"] = A), 0 < M.length && (p["!merges"] = M), p;
    }
    function Ic(t, n, a, l) {
      t = Ht(t), a.Sheets[l] || (a.Sheets[l] = {}), t.codeName && (a.Sheets[l].CodeName = mr(Cr(t.codeName)));
    }
    var GR = ["objects", "scenarios", "selectLockedCells", "selectUnlockedCells"], VR = ["formatColumns", "formatRows", "formatCells", "insertColumns", "insertRows", "insertHyperlinks", "deleteColumns", "deleteRows", "sort", "autoFilter", "pivotTables"], YR = /<(?:\w:)?sheetView(?:[^>a-z][^>]*)?\/?>/, yE, IE, DE, wE, xE, LE, ME, HR = (yE = /<(?:\w+:)?c[ \/>]/, IE = /<\/(?:\w+:)?row>/, DE = /r=["']([^"']*)["']/, wE = /<(?:\w+:)?is>([\S\s]*?)<\/(?:\w+:)?is>/, xE = /ref=["']([^"']*)["']/, LE = Ya("v"), ME = Ya("f"), function(t, n, a, l, d, _) {
      for (var u, p, m, f, E, b, T = 0, v = "", y = [], R = [], P = 0, I = 0, A = "", M = 0, F = 0, B = 0, re = 0, me = Array.isArray(_.CellXf), le = [], be = [], Fe = Array.isArray(n), Ue = [], Ne = {}, ze = !1, ut = !!a.sheetStubs, lt = t.split(IE), et = 0, nt = lt.length; et != nt; ++et) {
        var je = (v = lt[et].trim()).length;
        if (je !== 0) {
          var Ye = 0;
          e:
            for (T = 0; T < je; ++T)
              switch (v[T]) {
                case ">":
                  if (v[T - 1] != "/") {
                    ++T;
                    break e;
                  }
                  if (a && a.cellStyles) {
                    if (M = (m = Ht(v.slice(Ye, T), !0)).r != null ? parseInt(m.r, 10) : M + 1, F = -1, a.sheetRows && a.sheetRows < M)
                      continue;
                    ze = !(Ne = {}), m.ht && (ze = !0, Ne.hpt = parseFloat(m.ht), Ne.hpx = Yi(Ne.hpt)), m.hidden == "1" && (ze = !0, Ne.hidden = !0), m.outlineLevel != null && (ze = !0, Ne.level = +m.outlineLevel), ze && (Ue[M - 1] = Ne);
                  }
                  break;
                case "<":
                  Ye = T;
              }
          if (T <= Ye)
            break;
          if (M = (m = Ht(v.slice(Ye, T), !0)).r != null ? parseInt(m.r, 10) : M + 1, F = -1, !(a.sheetRows && a.sheetRows < M)) {
            l.s.r > M - 1 && (l.s.r = M - 1), l.e.r < M - 1 && (l.e.r = M - 1), a && a.cellStyles && (ze = !(Ne = {}), m.ht && (ze = !0, Ne.hpt = parseFloat(m.ht), Ne.hpx = Yi(Ne.hpt)), m.hidden == "1" && (ze = !0, Ne.hidden = !0), m.outlineLevel != null && (ze = !0, Ne.level = +m.outlineLevel), ze && (Ue[M - 1] = Ne)), y = v.slice(T).split(yE);
            for (var ht, Tt = 0; Tt != y.length && y[Tt].trim().charAt(0) == "<"; ++Tt)
              ;
            for (y = y.slice(Tt), T = 0; T != y.length; ++T)
              if ((v = y[T].trim()).length !== 0) {
                if (R = v.match(DE), P = T, I = 0, v = "<c " + (v.slice(0, 1) == "<" ? ">" : "") + v, R != null && R.length === 2) {
                  for (P = 0, A = R[1], I = 0; I != A.length && !((u = A.charCodeAt(I) - 64) < 1 || 26 < u); ++I)
                    P = 26 * P + u;
                  F = --P;
                } else
                  ++F;
                for (I = 0; I != v.length && v.charCodeAt(I) !== 62; ++I)
                  ;
                if (++I, (m = Ht(v.slice(0, I), !0)).r || (m.r = $t({ r: M - 1, c: F })), p = { t: "" }, (R = (A = v.slice(I)).match(LE)) != null && R[1] !== "" && (p.v = mr(R[1])), a.cellFormula) {
                  (R = A.match(ME)) != null && R[1] !== "" ? (p.f = mr(Cr(R[1])).replace(/\r\n/g, `
`), a.xlfn || (p.f = mE(p.f)), -1 < R[0].indexOf('t="array"') ? (p.F = (A.match(xE) || [])[1], -1 < p.F.indexOf(":") && le.push([lr(p.F), p.F])) : -1 < R[0].indexOf('t="shared"') && (E = Ht(R[0]), ht = mr(Cr(R[1])), a.xlfn || (ht = mE(ht)), be[parseInt(E.si, 10)] = [E, ht, m.r])) : (R = A.match(/<f[^>]*\/>/)) && be[(E = Ht(R[0])).si] && (p.f = (b = be[E.si][1], ft = be[E.si][2], ht = m.r, ft = Un(ft).s, ht = zr(ht), pE(b, { r: ht.r - ft.r, c: ht.c - ft.c })));
                  for (var xt = zr(m.r), I = 0; I < le.length; ++I)
                    xt.r >= le[I][0].s.r && xt.r <= le[I][0].e.r && xt.c >= le[I][0].s.c && xt.c <= le[I][0].e.c && (p.F = le[I][1]);
                }
                if (m.t == null && p.v === void 0)
                  if (p.f || p.F)
                    p.v = 0, p.t = "n";
                  else {
                    if (!ut)
                      continue;
                    p.t = "z";
                  }
                else
                  p.t = m.t || "n";
                switch (l.s.c > F && (l.s.c = F), l.e.c < F && (l.e.c = F), p.t) {
                  case "n":
                    if (p.v == "" || p.v == null) {
                      if (!ut)
                        continue;
                      p.t = "z";
                    } else
                      p.v = parseFloat(p.v);
                    break;
                  case "s":
                    if (p.v === void 0) {
                      if (!ut)
                        continue;
                      p.t = "z";
                    } else
                      f = Po[parseInt(p.v, 10)], p.v = f.t, p.r = f.r, a.cellHTML && (p.h = f.h);
                    break;
                  case "str":
                    p.t = "s", p.v = p.v != null ? Cr(p.v) : "", a.cellHTML && (p.h = uo(p.v));
                    break;
                  case "inlineStr":
                    R = A.match(wE), p.t = "s", R != null && (f = gc(R[1])) ? (p.v = f.t, a.cellHTML && (p.h = f.h)) : p.v = "";
                    break;
                  case "b":
                    p.v = Lr(p.v);
                    break;
                  case "d":
                    a.cellDates ? p.v = Br(p.v, 1) : (p.v = on(Br(p.v, 1)), p.t = "n");
                    break;
                  case "e":
                    a && a.cellText === !1 || (p.w = p.v), p.v = vf[p.v];
                }
                var Zt, B = re = 0, ft = null;
                me && m.s !== void 0 && (ft = _.CellXf[m.s]) != null && (ft.numFmtId != null && (B = ft.numFmtId), a.cellStyles && ft.fillId != null && (re = ft.fillId)), AE(p, B, re, a, d, _), a.cellDates && me && p.t == "n" && Gt(ae[B]) && (p.t = "d", p.v = lo(p.v)), m.cm && a.xlmeta && (Zt = (a.xlmeta.Cell || [])[+m.cm - 1]) && Zt.type == "XLDAPR" && (p.D = !0), Fe ? (n[(Zt = zr(m.r)).r] || (n[Zt.r] = []), n[Zt.r][Zt.c] = p) : n[m.r] = p;
              }
          }
        }
      }
      0 < Ue.length && (n["!rows"] = Ue);
    });
    function qR(t, n) {
      for (var a, l, d, _, u = [], p = [], m = lr(t["!ref"]), f = [], E = 0, R = 0, b = t["!rows"], T = Array.isArray(t), v = { r: "" }, y = -1, R = m.s.c; R <= m.e.c; ++R)
        f[R] = Vr(R);
      for (E = m.s.r; E <= m.e.r; ++E) {
        for (p = [], d = Xr(E), R = m.s.c; R <= m.e.c; ++R) {
          l = f[R] + d;
          var P = T ? (t[E] || [])[R] : t[l];
          P !== void 0 && (a = function(I, A, M, F) {
            if (I.c && M["!comments"].push([A, I.c]), I.v === void 0 && typeof I.f != "string" || I.t === "z" && !I.f)
              return "";
            var B = "", re = I.t, me = I.v;
            if (I.t !== "z")
              switch (I.t) {
                case "b":
                  B = I.v ? "1" : "0";
                  break;
                case "n":
                  B = "" + I.v;
                  break;
                case "e":
                  B = La[I.v];
                  break;
                case "d":
                  B = F && F.cellDates ? Br(I.v, -1).toISOString() : ((I = xr(I)).t = "n", "" + (I.v = on(Br(I.v)))), I.z === void 0 && (I.z = ae[14]);
                  break;
                default:
                  B = I.v;
              }
            var le = Rn("v", Ar(B)), be = { r: A }, Fe = za(F.cellXfs, I, F);
            switch (Fe !== 0 && (be.s = Fe), I.t) {
              case "n":
                break;
              case "d":
                be.t = "d";
                break;
              case "b":
                be.t = "b";
                break;
              case "e":
                be.t = "e";
                break;
              case "z":
                break;
              default:
                if (I.v == null) {
                  delete I.t;
                  break;
                }
                if (32767 < I.v.length)
                  throw new Error("Text length must not exceed 32767 characters");
                if (F && F.bookSST) {
                  le = Rn("v", "" + yc(F.Strings, I.v, F.revStrings)), be.t = "s";
                  break;
                }
                be.t = "str";
            }
            return I.t != re && (I.t = re, I.v = me), typeof I.f == "string" && I.f && (me = I.F && I.F.slice(0, A.length) == A ? { t: "array", ref: I.F } : null, le = it("f", Ar(I.f), me) + (I.v != null ? le : "")), I.l && M["!links"].push([A, I.l]), I.D && (be.cm = 1), it("c", le, be);
          }(P, l, t, n)) != null && p.push(a);
        }
        (0 < p.length || b && b[E]) && (v = { r: d }, b && b[E] && ((_ = b[E]).hidden && (v.hidden = 1), y = -1, _.hpx ? y = Io(_.hpx) : _.hpt && (y = _.hpt), -1 < y && (v.ht = y, v.customHeight = 1), _.level && (v.outlineLevel = _.level)), u[u.length] = it("row", p.join(""), v));
      }
      if (b)
        for (; E < b.length; ++E)
          b && b[E] && (v = { r: E + 1 }, (_ = b[E]).hidden && (v.hidden = 1), y = -1, _.hpx ? y = Io(_.hpx) : _.hpt && (y = _.hpt), -1 < y && (v.ht = y, v.customHeight = 1), _.level && (v.outlineLevel = _.level), u[u.length] = it("row", "", v));
      return u.join("");
    }
    function PE(t, n, a, l) {
      var d, _, u = [Qr, it("worksheet", null, { xmlns: ai[0], "xmlns:r": un.r })], p = a.SheetNames[t], m = a.Sheets[p], f = (m = m ?? {})["!ref"] || "A1", E = lr(f);
      if (16383 < E.e.c || 1048575 < E.e.r) {
        if (n.WTF)
          throw new Error("Range " + f + " exceeds format limit A1:XFD1048576");
        E.e.c = Math.min(E.e.c, 16383), E.e.r = Math.min(E.e.c, 1048575), f = Xt(E);
      }
      l = l || {}, m["!comments"] = [];
      var b, T, v = [];
      (function(I, A, M, F, B) {
        var re = !1, me = {}, le = null;
        if (F.bookType !== "xlsx" && A.vbaraw) {
          var be = A.SheetNames[M];
          try {
            A.Workbook && (be = A.Workbook.Sheets[M].CodeName || be);
          } catch {
          }
          re = !0, me.codeName = Zn(Ar(be));
        }
        I && I["!outline"] && (F = { summaryBelow: 1, summaryRight: 1 }, I["!outline"].above && (F.summaryBelow = 0), I["!outline"].left && (F.summaryRight = 0), le = (le || "") + it("outlinePr", null, F)), (re || le) && (B[B.length] = it("sheetPr", le, me));
      })(m, a, t, n, u), u[u.length] = it("dimension", null, { ref: f }), u[u.length] = (p = { workbookViewId: "0" }, ((((E = a) || {}).Workbook || {}).Views || [])[0] && (p.rightToLeft = E.Workbook.Views[0].RTL ? "1" : "0"), it("sheetViews", it("sheetView", null, p), {})), n.sheetFormat && (u[u.length] = it("sheetFormatPr", null, { defaultRowHeight: n.sheetFormat.defaultRowHeight || "16", baseColWidth: n.sheetFormat.baseColWidth || "10", outlineLevelRow: n.sheetFormat.outlineLevelRow || "7" })), m["!cols"] != null && 0 < m["!cols"].length && (u[u.length] = function(I) {
        for (var A, M = ["<cols>"], F = 0; F != I.length; ++F)
          (A = I[F]) && (M[M.length] = it("col", null, Bs(F, A)));
        return M[M.length] = "</cols>", M.join("");
      }(m["!cols"])), u[d = u.length] = "<sheetData/>", m["!links"] = [], m["!ref"] != null && 0 < (_ = qR(m, n)).length && (u[u.length] = _), u.length > d + 1 && (u[u.length] = "</sheetData>", u[d] = u[d].replace("/>", ">")), m["!protect"] && (u[u.length] = (b = m["!protect"], T = { sheet: 1 }, GR.forEach(function(I) {
        b[I] != null && b[I] && (T[I] = "1");
      }), VR.forEach(function(I) {
        b[I] == null || b[I] || (T[I] = "0");
      }), b.password && (T.password = Ec(b.password).toString(16).toUpperCase()), it("sheetProtection", null, T))), m["!autofilter"] != null && (u[u.length] = function(I, A, M, F) {
        var B = typeof I.ref == "string" ? I.ref : Xt(I.ref);
        M.Workbook || (M.Workbook = { Sheets: [] }), M.Workbook.Names || (M.Workbook.Names = []);
        var re = M.Workbook.Names;
        (I = Un(B)).s.r == I.e.r && (I.e.r = Un(A["!ref"]).e.r, B = Xt(I));
        for (var me = 0; me < re.length; ++me) {
          var le = re[me];
          if (le.Name == "_xlnm._FilterDatabase" && le.Sheet == F) {
            le.Ref = "'" + M.SheetNames[F] + "'!" + B;
            break;
          }
        }
        return me == re.length && re.push({ Name: "_xlnm._FilterDatabase", Sheet: F, Ref: "'" + M.SheetNames[F] + "'!" + B }), it("autoFilter", null, { ref: B });
      }(m["!autofilter"], m, a, t)), m["!merges"] != null && 0 < m["!merges"].length && (u[u.length] = function(I) {
        if (I.length === 0)
          return "";
        for (var A = '<mergeCells count="' + I.length + '">', M = 0; M != I.length; ++M)
          A += '<mergeCell ref="' + Xt(I[M]) + '"/>';
        return A + "</mergeCells>";
      }(m["!merges"]));
      var y, R, P = -1;
      return 0 < m["!links"].length && (u[u.length] = "<hyperlinks>", m["!links"].forEach(function(I) {
        I[1].Target && (R = { ref: I[0] }, I[1].Target.charAt(0) != "#" && (P = Ir(l, -1, Ar(I[1].Target).replace(/#.*$/, ""), Jt.HLINK), R["r:id"] = "rId" + P), -1 < (y = I[1].Target.indexOf("#")) && (R.location = Ar(I[1].Target.slice(y + 1))), I[1].Tooltip && (R.tooltip = Ar(I[1].Tooltip)), u[u.length] = it("hyperlink", null, R));
      }), u[u.length] = "</hyperlinks>"), delete m["!links"], m["!margins"] != null && (u[u.length] = (fi(a = m["!margins"]), it("pageMargins", null, a))), n && !n.ignoreEC && n.ignoreEC != null || (u[u.length] = Rn("ignoredErrors", it("ignoredError", null, { numberStoredAsText: 1, sqref: f }))), 0 < v.length && (P = Ir(l, -1, "../drawings/drawing" + (t + 1) + ".xml", Jt.DRAW), u[u.length] = it("drawing", null, { "r:id": "rId" + P }), m["!drawing"] = v), 0 < m["!comments"].length && (P = Ir(l, -1, "../drawings/vmlDrawing" + (t + 1) + ".vml", Jt.VML), u[u.length] = it("legacyDrawing", null, { "r:id": "rId" + P }), m["!legacy"] = P), 1 < u.length && (u[u.length] = "</worksheet>", u[1] = u[1].replace("/>", ">")), u.join("");
    }
    function $R(t, n, a, l) {
      a = function(d, _, u) {
        var p = Me(145), m = (u["!rows"] || [])[d] || {};
        p.write_shift(4, d), p.write_shift(4, 0);
        var E = 320;
        m.hpx ? E = 20 * Io(m.hpx) : m.hpt && (E = 20 * m.hpt), p.write_shift(2, E), p.write_shift(1, 0), E = 0, m.level && (E |= m.level), m.hidden && (E |= 16), (m.hpx || m.hpt) && (E |= 32), p.write_shift(1, E), p.write_shift(1, 0);
        var f = 0, E = p.l;
        p.l += 4;
        for (var b = { r: d, c: 0 }, T = 0; T < 16; ++T)
          if (!(_.s.c > T + 1 << 10 || _.e.c < T << 10)) {
            for (var v = -1, y = -1, R = T << 10; R < T + 1 << 10; ++R)
              b.c = R, (Array.isArray(u) ? (u[b.r] || [])[b.c] : u[$t(b)]) && (v < 0 && (v = R), y = R);
            v < 0 || (++f, p.write_shift(4, v), p.write_shift(4, y));
          }
        return d = p.l, p.l = E, p.write_shift(4, f), p.l = d, p.length > p.l ? p.slice(0, p.l) : p;
      }(l, a, n), (17 < a.length || (n["!rows"] || [])[l]) && He(t, 0, a);
    }
    var Gs = ci, WR = ki;
    function kE(t) {
      return [si(t), wn(t), "n"];
    }
    var Wi = ci, zR = ki, FE = ["left", "right", "top", "bottom", "header", "footer"];
    function KR(t, n, a, l, d, _, u) {
      if (n.v === void 0)
        return !1;
      var p = "";
      switch (n.t) {
        case "b":
          p = n.v ? "1" : "0";
          break;
        case "d":
          (n = xr(n)).z = n.z || ae[14], n.v = on(Br(n.v)), n.t = "n";
          break;
        case "n":
        case "e":
          p = "" + n.v;
          break;
        default:
          p = n.v;
      }
      var m, f, E, b, T, v, y, R, P, I, A, M, F, B, re, me, le, be, Fe, Ue, Ne = { r: a, c: l };
      switch (Ne.s = za(d.cellXfs, n, d), n.l && _["!links"].push([$t(Ne), n.l]), n.c && _["!comments"].push([$t(Ne), n.c]), n.t) {
        case "s":
        case "str":
          return d.bookSST ? (p = yc(d.Strings, n.v, d.revStrings), Ne.t = "s", Ne.v = p, u ? He(t, 18, (li(le = Ne, be = be ?? Me(8)), be.write_shift(4, le.v), be)) : He(t, 7, (oi(le = Ne, me = me ?? Me(12)), me.write_shift(4, le.v), me))) : (Ne.t = "str", u ? He(t, 17, (B = n, li(Ne, re = re ?? Me(8 + 4 * B.v.length)), Sn(B.v, re), re.length > re.l ? re.slice(0, re.l) : re)) : He(t, 6, (B = n, oi(Ne, F = F ?? Me(12 + 4 * B.v.length)), Sn(B.v, F), F.length > F.l ? F.slice(0, F.l) : F))), !0;
        case "n":
          return n.v == (0 | n.v) && -1e3 < n.v && n.v < 1e3 ? u ? He(t, 13, (A = n, li(Ne, M = M ?? Me(8)), gf(A.v, M), M)) : He(t, 2, (A = n, oi(Ne, I = I ?? Me(12)), gf(A.v, I), I)) : u ? He(t, 16, (R = n, li(Ne, P = P ?? Me(12)), Fi(R.v, P), P)) : He(t, 5, (R = n, oi(Ne, y = y ?? Me(16)), Fi(R.v, y), y)), !0;
        case "b":
          return Ne.t = "b", u ? He(t, 15, (T = n, li(Ne, v = v ?? Me(5)), v.write_shift(1, T.v ? 1 : 0), v)) : He(t, 4, (T = n, oi(Ne, b = b ?? Me(9)), b.write_shift(1, T.v ? 1 : 0), b)), !0;
        case "e":
          return Ne.t = "e", u ? He(t, 14, (f = n, li(Ne, E = E ?? Me(8)), E.write_shift(1, f.v), E.write_shift(2, 0), E.write_shift(1, 0), E)) : He(t, 3, (f = n, oi(Ne, m = m ?? Me(9)), m.write_shift(1, f.v), m)), !0;
      }
      return u ? He(t, 12, li(Ne, Ue = Ue ?? Me(4))) : He(t, 1, oi(Ne, Fe = Fe ?? Me(8))), !0;
    }
    function QR(t, n) {
      var a, l;
      n && n["!merges"] && (He(t, 177, (a = n["!merges"].length, (l = l ?? Me(4)).write_shift(4, a), l)), n["!merges"].forEach(function(d) {
        He(t, 176, zR(d));
      }), He(t, 178));
    }
    function XR(t, n) {
      n && n["!cols"] && (He(t, 390), n["!cols"].forEach(function(a, l) {
        a && He(t, 60, function(d, _, u) {
          u == null && (u = Me(18));
          var p = Bs(d, _);
          return u.write_shift(-4, d), u.write_shift(-4, d), u.write_shift(4, 256 * (p.width || 10)), u.write_shift(4, 0), d = 0, _.hidden && (d |= 1), typeof p.width == "number" && (d |= 2), _.level && (d |= _.level << 8), u.write_shift(2, d), u;
        }(l, a));
      }), He(t, 391));
    }
    function ZR(t, n) {
      var a;
      n && n["!ref"] && (He(t, 648), He(t, 649, (a = lr(n["!ref"]), (n = Me(24)).write_shift(4, 4), n.write_shift(4, 1), ki(a, n), n)), He(t, 650));
    }
    function jR(t, n, a) {
      n["!links"].forEach(function(l) {
        var d, _;
        l[1].Target && (d = Ir(a, -1, l[1].Target.replace(/#.*$/, ""), Jt.HLINK), He(t, 494, (_ = d, l = Me(50 + 4 * ((d = l)[1].Target.length + (d[1].Tooltip || "").length)), ki({ s: zr(d[0]), e: zr(d[0]) }, l), jl("rId" + _, l), Sn(((_ = d[1].Target.indexOf("#")) == -1 ? "" : d[1].Target.slice(_ + 1)) || "", l), Sn(d[1].Tooltip || "", l), Sn("", l), l.slice(0, l.l))));
      }), delete n["!links"];
    }
    function JR(t, n, a) {
      He(t, 133), He(t, 137, function(l, d) {
        d == null && (d = Me(30));
        var _ = 924;
        return (((l || {}).Views || [])[0] || {}).RTL && (_ |= 32), d.write_shift(2, _), d.write_shift(4, 0), d.write_shift(4, 0), d.write_shift(4, 0), d.write_shift(1, 0), d.write_shift(1, 0), d.write_shift(2, 0), d.write_shift(2, 100), d.write_shift(2, 0), d.write_shift(2, 0), d.write_shift(2, 0), d.write_shift(4, 0), d;
      }(a)), He(t, 138), He(t, 134);
    }
    function eN(t, n) {
      var a, l;
      n["!protect"] && He(t, 535, (a = n["!protect"], (l = l ?? Me(66)).write_shift(2, a.password ? Ec(a.password) : 0), l.write_shift(4, 1), [["objects", !1], ["scenarios", !1], ["formatCells", !0], ["formatColumns", !0], ["formatRows", !0], ["insertColumns", !0], ["insertRows", !0], ["insertHyperlinks", !0], ["deleteColumns", !0], ["deleteRows", !0], ["selectLockedCells", !1], ["sort", !0], ["autoFilter", !0], ["pivotTables", !0], ["selectUnlockedCells", !1]].forEach(function(d) {
        d[1] ? l.write_shift(4, a[d[0]] == null || a[d[0]] ? 0 : 1) : l.write_shift(4, a[d[0]] != null && a[d[0]] ? 0 : 1);
      }), l));
    }
    function tN(t, n, a, l) {
      var d = Wn(), f = a.SheetNames[t], _ = a.Sheets[f] || {}, u = f;
      try {
        a && a.Workbook && (u = a.Workbook.Sheets[t].CodeName || u);
      } catch {
      }
      var p, m, f = lr(_["!ref"] || "A1");
      if (16383 < f.e.c || 1048575 < f.e.r) {
        if (n.WTF)
          throw new Error("Range " + (_["!ref"] || "A1") + " exceeds format limit A1:XFD1048576");
        f.e.c = Math.min(f.e.c, 16383), f.e.r = Math.min(f.e.c, 1048575);
      }
      return _["!links"] = [], _["!comments"] = [], He(d, 129), (a.vbaraw || _["!outline"]) && He(d, 147, function(E, b, T) {
        T == null && (T = Me(84 + 4 * E.length));
        var v = 192;
        b && (b.above && (v &= -65), b.left && (v &= -129)), T.write_shift(1, v);
        for (var y = 1; y < 3; ++y)
          T.write_shift(1, 0);
        return hs({ auto: 1 }, T), T.write_shift(-4, -1), T.write_shift(-4, -1), ff(E, T), T.slice(0, T.l);
      }(u, _["!outline"])), He(d, 148, WR(f)), JR(d, 0, a.Workbook), XR(d, _), function(E, b, T) {
        var v, y = lr(b["!ref"] || "A1"), R = [];
        He(E, 145);
        var P = Array.isArray(b), I = y.e.r;
        b["!rows"] && (I = Math.max(y.e.r, b["!rows"].length - 1));
        for (var A = y.s.r; A <= I; ++A) {
          v = Xr(A), $R(E, b, y, A);
          var M = !1;
          if (A <= y.e.r)
            for (var F = y.s.c; F <= y.e.c; ++F) {
              A === y.s.r && (R[F] = Vr(F)), B = R[F] + v;
              var B = P ? (b[A] || [])[F] : b[B];
              B ? M = KR(E, B, A, F, T, b, M) : M = !1;
            }
        }
        He(E, 146);
      }(d, _, n), eN(d, _), function(E, b, T, v) {
        if (b["!autofilter"]) {
          var P = b["!autofilter"], y = typeof P.ref == "string" ? P.ref : Xt(P.ref);
          T.Workbook || (T.Workbook = { Sheets: [] }), T.Workbook.Names || (T.Workbook.Names = []);
          var R = T.Workbook.Names, P = Un(y);
          P.s.r == P.e.r && (P.e.r = Un(b["!ref"]).e.r, y = Xt(P));
          for (var I = 0; I < R.length; ++I) {
            var A = R[I];
            if (A.Name == "_xlnm._FilterDatabase" && A.Sheet == v) {
              A.Ref = "'" + T.SheetNames[v] + "'!" + y;
              break;
            }
          }
          I == R.length && R.push({ Name: "_xlnm._FilterDatabase", Sheet: v, Ref: "'" + T.SheetNames[v] + "'!" + y }), He(E, 161, ki(lr(y))), He(E, 162);
        }
      }(d, _, a, t), QR(d, _), jR(d, _, l), _["!margins"] && He(d, 476, (p = _["!margins"], m == null && (m = Me(48)), fi(p), FE.forEach(function(E) {
        Fi(p[E], m);
      }), m)), n && !n.ignoreEC && n.ignoreEC != null || ZR(d, _), f = d, n = t, l = l, 0 < (_ = _)["!comments"].length && (n = Ir(l, -1, "../drawings/vmlDrawing" + (n + 1) + ".vml", Jt.VML), He(f, 551, jl("rId" + n)), _["!legacy"] = n), He(d, 130), d.end();
    }
    function rN(t, n, a, l, d, _) {
      var u = _ || { "!type": "chart" };
      if (!t)
        return _;
      var p, m = 0, f = 0, E = { s: { r: 2e6, c: 2e6 }, e: { r: 0, c: 0 } };
      return (t.match(/<c:numCache>[\s\S]*?<\/c:numCache>/gm) || []).forEach(function(b) {
        var T = function(v) {
          var y, R = [], P = v.match(/^<c:numCache>/);
          (v.match(/<c:pt idx="(\d*)">(.*?)<\/c:pt>/gm) || []).forEach(function(A) {
            A = A.match(/<c:pt idx="(\d*?)"><c:v>(.*)<\/c:v><\/c:pt>/), A && (R[+A[1]] = P ? +A[2] : A[2]);
          });
          var I = mr((v.match(/<c:formatCode>([\s\S]*?)<\/c:formatCode>/) || ["", "General"])[1]);
          return (v.match(/<c:f>(.*?)<\/c:f>/gm) || []).forEach(function(A) {
            y = A.replace(/<.*?>/g, "");
          }), [R, I, y];
        }(b);
        E.s.r = E.s.c = 0, E.e.c = m, p = Vr(m), T[0].forEach(function(v, y) {
          u[p + Xr(y)] = { t: "n", v, z: T[1] }, f = y;
        }), E.e.r < f && (E.e.r = f), ++m;
      }), 0 < m && (u["!ref"] = Xt(E)), u;
    }
    var Dc = [["allowRefreshQuery", !1, "bool"], ["autoCompressPictures", !0, "bool"], ["backupFile", !1, "bool"], ["checkCompatibility", !1, "bool"], ["CodeName", ""], ["date1904", !1, "bool"], ["defaultThemeVersion", 0, "int"], ["filterPrivacy", !1, "bool"], ["hidePivotFieldList", !1, "bool"], ["promptedSolutions", !1, "bool"], ["publishItems", !1, "bool"], ["refreshAllConnections", !1, "bool"], ["saveExternalLinkValues", !0, "bool"], ["showBorderUnselectedTables", !0, "bool"], ["showInkAnnotation", !0, "bool"], ["showObjects", "all"], ["showPivotChartFilter", !1, "bool"], ["updateLinks", "userSet"]], nN = [["activeTab", 0, "int"], ["autoFilterDateGrouping", !0, "bool"], ["firstSheet", 0, "int"], ["minimized", !1, "bool"], ["showHorizontalScroll", !0, "bool"], ["showSheetTabs", !0, "bool"], ["showVerticalScroll", !0, "bool"], ["tabRatio", 600, "int"], ["visibility", "visible"]], aN = [], iN = [["calcCompleted", "true"], ["calcMode", "auto"], ["calcOnSave", "true"], ["concurrentCalc", "true"], ["fullCalcOnLoad", "false"], ["fullPrecision", "true"], ["iterate", "false"], ["iterateCount", "100"], ["iterateDelta", "0.001"], ["refMode", "A1"]];
    function UE(t, n) {
      for (var a = 0; a != t.length; ++a)
        for (var l = t[a], d = 0; d != n.length; ++d) {
          var _ = n[d];
          if (l[_[0]] == null)
            l[_[0]] = _[1];
          else
            switch (_[2]) {
              case "bool":
                typeof l[_[0]] == "string" && (l[_[0]] = Lr(l[_[0]]));
                break;
              case "int":
                typeof l[_[0]] == "string" && (l[_[0]] = parseInt(l[_[0]], 10));
            }
        }
    }
    function BE(t, n) {
      for (var a = 0; a != n.length; ++a) {
        var l = n[a];
        if (t[l[0]] == null)
          t[l[0]] = l[1];
        else
          switch (l[2]) {
            case "bool":
              typeof t[l[0]] == "string" && (t[l[0]] = Lr(t[l[0]]));
              break;
            case "int":
              typeof t[l[0]] == "string" && (t[l[0]] = parseInt(t[l[0]], 10));
          }
      }
    }
    function GE(t) {
      BE(t.WBProps, Dc), BE(t.CalcPr, iN), UE(t.WBView, nN), UE(t.Sheets, aN), $i.date1904 = Lr(t.WBProps.date1904);
    }
    var oN = "][*?/\\".split("");
    function VE(t, n) {
      if (31 < t.length) {
        if (n)
          return;
        throw new Error("Sheet names cannot exceed 31 chars");
      }
      var a = !0;
      return oN.forEach(function(l) {
        if (t.indexOf(l) != -1) {
          if (!n)
            throw new Error("Sheet name cannot contain : \\ / ? * [ ]");
          a = !1;
        }
      }), a;
    }
    function YE(t) {
      if (!t || !t.SheetNames || !t.Sheets)
        throw new Error("Invalid Workbook");
      if (!t.SheetNames.length)
        throw new Error("Workbook is empty");
      var n, a, l, d = t.Workbook && t.Workbook.Sheets || [];
      n = t.SheetNames, a = d, l = !!t.vbaraw, n.forEach(function(u, p) {
        VE(u);
        for (var m = 0; m < p; ++m)
          if (u == n[m])
            throw new Error("Duplicate Sheet Name: " + u);
        if (l) {
          var f = a && a[p] && a[p].CodeName || u;
          if (f.charCodeAt(0) == 95 && 22 < f.length)
            throw new Error("Bad Code Name: Worksheet" + f);
        }
      });
      for (var _ = 0; _ < t.SheetNames.length; ++_)
        (function(u, p) {
          if (u && u["!ref"]) {
            var m = lr(u["!ref"]);
            if (m.e.c < m.s.c || m.e.r < m.s.r)
              throw new Error("Bad range (" + p + "): " + u["!ref"]);
          }
        })(t.Sheets[t.SheetNames[_]], (t.SheetNames[_], _));
    }
    var sN = /<\w+:workbook/;
    function HE(t) {
      var n = [Qr];
      n[n.length] = it("workbook", null, { xmlns: ai[0], "xmlns:r": un.r });
      var a = t.Workbook && 0 < (t.Workbook.Names || []).length, l = { codeName: "ThisWorkbook" };
      t.Workbook && t.Workbook.WBProps && (Dc.forEach(function(p) {
        t.Workbook.WBProps[p[0]] != null && t.Workbook.WBProps[p[0]] != p[1] && (l[p[0]] = t.Workbook.WBProps[p[0]]);
      }), t.Workbook.WBProps.CodeName && (l.codeName = t.Workbook.WBProps.CodeName, delete l.CodeName)), n[n.length] = it("workbookPr", null, l);
      var d = t.Workbook && t.Workbook.Sheets || [], _ = 0;
      if (d && d[0] && d[0].Hidden) {
        for (n[n.length] = "<bookViews>", _ = 0; _ != t.SheetNames.length && d[_] && d[_].Hidden; ++_)
          ;
        _ == t.SheetNames.length && (_ = 0), n[n.length] = '<workbookView firstSheet="' + _ + '" activeTab="' + _ + '"/>', n[n.length] = "</bookViews>";
      }
      for (n[n.length] = "<sheets>", _ = 0; _ != t.SheetNames.length; ++_) {
        var u = { name: Ar(t.SheetNames[_].slice(0, 31)) };
        if (u.sheetId = "" + (_ + 1), u["r:id"] = "rId" + (_ + 1), d[_])
          switch (d[_].Hidden) {
            case 1:
              u.state = "hidden";
              break;
            case 2:
              u.state = "veryHidden";
          }
        n[n.length] = it("sheet", null, u);
      }
      return n[n.length] = "</sheets>", a && (n[n.length] = "<definedNames>", t.Workbook && t.Workbook.Names && t.Workbook.Names.forEach(function(p) {
        var m = { name: p.Name };
        p.Comment && (m.comment = p.Comment), p.Sheet != null && (m.localSheetId = "" + p.Sheet), p.Hidden && (m.hidden = "1"), p.Ref && (n[n.length] = it("definedName", Ar(p.Ref), m));
      }), n[n.length] = "</definedNames>"), 2 < n.length && (n[n.length] = "</workbook>", n[1] = n[1].replace("/>", ">")), n.join("");
    }
    function lN(t, n) {
      var a = {};
      return t.read_shift(4), a.ArchID = t.read_shift(4), t.l += n - 8, a;
    }
    function cN(t, n) {
      He(t, 143);
      for (var a, l = 0; l != n.SheetNames.length; ++l) {
        var d = { Hidden: n.Workbook && n.Workbook.Sheets && n.Workbook.Sheets[l] && n.Workbook.Sheets[l].Hidden || 0, iTabID: l + 1, strRelID: "rId" + (l + 1), name: n.SheetNames[l] };
        He(t, 156, (a = d, (d = (d = void 0) || Me(127)).write_shift(4, a.Hidden), d.write_shift(4, a.iTabID), jl(a.strRelID, d), Sn(a.name.slice(0, 31), d), d.length > d.l ? d.slice(0, d.l) : d));
      }
      He(t, 144);
    }
    function dN(t, n) {
      if (n.Workbook && n.Workbook.Sheets) {
        for (var a, l = n.Workbook.Sheets, d = 0, _ = -1, u = -1; d < l.length; ++d)
          !l[d] || !l[d].Hidden && _ == -1 ? _ = d : l[d].Hidden == 1 && u == -1 && (u = d);
        _ < u || (He(t, 135), He(t, 158, (n = _, (a = a || Me(29)).write_shift(-4, 0), a.write_shift(-4, 460), a.write_shift(4, 28800), a.write_shift(4, 17600), a.write_shift(4, 500), a.write_shift(4, n), a.write_shift(4, n), a.write_shift(1, 120), a.length > a.l ? a.slice(0, a.l) : a)), He(t, 136));
      }
    }
    function uN(t, n) {
      var a = Wn();
      return He(a, 131), He(a, 128, function(l) {
        l = l || Me(127);
        for (var d = 0; d != 4; ++d)
          l.write_shift(4, 0);
        return Sn("SheetJS", l), Sn(r.version, l), Sn(r.version, l), Sn("7262", l), l.length > l.l ? l.slice(0, l.l) : l;
      }()), He(a, 153, function(l, d) {
        d = d || Me(72);
        var _ = 0;
        return l && l.filterPrivacy && (_ |= 8), d.write_shift(4, _), d.write_shift(4, 0), ff(l && l.CodeName || "ThisWorkbook", d), d.slice(0, d.l);
      }(t.Workbook && t.Workbook.WBProps || null)), dN(a, t), cN(a, t), He(a, 132), a.end();
    }
    function _N(t, n, a) {
      return (n.slice(-4) === ".bin" ? function(l, d) {
        var _ = { AppVersion: {}, WBProps: {}, WBView: [], Sheets: [], CalcPr: {}, xmlns: "" }, u = [], p = !1;
        (d = d || {}).biff = 12;
        var m = [], f = [[]];
        return f.SheetNames = [], f.XTI = [], Bo[16] = { n: "BrtFRTArchID$", f: lN }, xa(l, function(E, b, T) {
          switch (T) {
            case 156:
              f.SheetNames.push(E.name), _.Sheets.push(E);
              break;
            case 153:
              _.WBProps = E;
              break;
            case 39:
              E.Sheet != null && (d.SID = E.Sheet), E.Ref = Gn(E.Ptg, 0, null, f, d), delete d.SID, delete E.Ptg, m.push(E);
              break;
            case 1036:
              break;
            case 357:
            case 358:
            case 355:
            case 667:
              f[0].length ? f.push([T, E]) : f[0] = [T, E], f[f.length - 1].XTI = [];
              break;
            case 362:
              f.length === 0 && (f[0] = [], f[0].XTI = []), f[f.length - 1].XTI = f[f.length - 1].XTI.concat(E), f.XTI = f.XTI.concat(E);
              break;
            case 361:
              break;
            case 2071:
            case 158:
            case 143:
            case 664:
            case 353:
              break;
            case 3072:
            case 3073:
            case 534:
            case 677:
            case 157:
            case 610:
            case 2050:
            case 155:
            case 548:
            case 676:
            case 128:
            case 665:
            case 2128:
            case 2125:
            case 549:
            case 2053:
            case 596:
            case 2076:
            case 2075:
            case 2082:
            case 397:
            case 154:
            case 1117:
            case 553:
            case 2091:
              break;
            case 35:
              u.push(T), p = !0;
              break;
            case 36:
              u.pop(), p = !1;
              break;
            case 37:
              u.push(T), p = !0;
              break;
            case 38:
              u.pop(), p = !1;
              break;
            case 16:
              break;
            default:
              if (!b.T && (!p || d.WTF && u[u.length - 1] != 37 && u[u.length - 1] != 35))
                throw new Error("Unexpected record 0x" + T.toString(16));
          }
        }, d), GE(_), _.Names = m, _.supbooks = f, _;
      } : function(l, d) {
        if (!l)
          throw new Error("Could not find file");
        var _ = { AppVersion: {}, WBProps: {}, WBView: [], Sheets: [], CalcPr: {}, Names: [], xmlns: "" }, u = !1, p = "xmlns", m = {}, f = 0;
        if (l.replace(Cn, function(E, b) {
          var T = Ht(E);
          switch (pa(T[0])) {
            case "<?xml":
              break;
            case "<workbook":
              E.match(sN) && (p = "xmlns" + E.match(/<(\w+):/)[1]), _.xmlns = T[p];
              break;
            case "</workbook>":
              break;
            case "<fileVersion":
              delete T[0], _.AppVersion = T;
              break;
            case "<fileVersion/>":
            case "</fileVersion>":
            case "<fileSharing":
            case "<fileSharing/>":
              break;
            case "<workbookPr":
            case "<workbookPr/>":
              Dc.forEach(function(v) {
                if (T[v[0]] != null)
                  switch (v[2]) {
                    case "bool":
                      _.WBProps[v[0]] = Lr(T[v[0]]);
                      break;
                    case "int":
                      _.WBProps[v[0]] = parseInt(T[v[0]], 10);
                      break;
                    default:
                      _.WBProps[v[0]] = T[v[0]];
                  }
              }), T.codeName && (_.WBProps.CodeName = Cr(T.codeName));
              break;
            case "</workbookPr>":
            case "<workbookProtection":
            case "<workbookProtection/>":
              break;
            case "<bookViews":
            case "<bookViews>":
            case "</bookViews>":
              break;
            case "<workbookView":
            case "<workbookView/>":
              delete T[0], _.WBView.push(T);
              break;
            case "</workbookView>":
              break;
            case "<sheets":
            case "<sheets>":
            case "</sheets>":
              break;
            case "<sheet":
              switch (T.state) {
                case "hidden":
                  T.Hidden = 1;
                  break;
                case "veryHidden":
                  T.Hidden = 2;
                  break;
                default:
                  T.Hidden = 0;
              }
              delete T.state, T.name = mr(Cr(T.name)), delete T[0], _.Sheets.push(T);
              break;
            case "</sheet>":
              break;
            case "<functionGroups":
            case "<functionGroups/>":
            case "<functionGroup":
              break;
            case "<externalReferences":
            case "</externalReferences>":
            case "<externalReferences>":
            case "<externalReference":
            case "<definedNames/>":
              break;
            case "<definedNames>":
            case "<definedNames":
              u = !0;
              break;
            case "</definedNames>":
              u = !1;
              break;
            case "<definedName":
              (m = {}).Name = Cr(T.name), T.comment && (m.Comment = T.comment), T.localSheetId && (m.Sheet = +T.localSheetId), Lr(T.hidden || "0") && (m.Hidden = !0), f = b + E.length;
              break;
            case "</definedName>":
              m.Ref = mr(Cr(l.slice(f, b))), _.Names.push(m);
              break;
            case "<definedName/>":
              break;
            case "<calcPr":
            case "<calcPr/>":
              delete T[0], _.CalcPr = T;
              break;
            case "</calcPr>":
            case "<oleSize":
              break;
            case "<customWorkbookViews>":
            case "</customWorkbookViews>":
            case "<customWorkbookViews":
              break;
            case "<customWorkbookView":
            case "</customWorkbookView>":
              break;
            case "<pivotCaches>":
            case "</pivotCaches>":
            case "<pivotCaches":
            case "<pivotCache":
              break;
            case "<smartTagPr":
            case "<smartTagPr/>":
              break;
            case "<smartTagTypes":
            case "<smartTagTypes>":
            case "</smartTagTypes>":
            case "<smartTagType":
              break;
            case "<webPublishing":
            case "<webPublishing/>":
              break;
            case "<fileRecoveryPr":
            case "<fileRecoveryPr/>":
              break;
            case "<webPublishObjects>":
            case "<webPublishObjects":
            case "</webPublishObjects>":
            case "<webPublishObject":
              break;
            case "<extLst":
            case "<extLst>":
            case "</extLst>":
            case "<extLst/>":
              break;
            case "<ext":
              u = !0;
              break;
            case "</ext>":
              u = !1;
              break;
            case "<ArchID":
              break;
            case "<AlternateContent":
            case "<AlternateContent>":
              u = !0;
              break;
            case "</AlternateContent>":
              u = !1;
              break;
            case "<revisionPtr":
              break;
            default:
              if (!u && d.WTF)
                throw new Error("unrecognized " + T[0] + " in workbook");
          }
          return E;
        }), ai.indexOf(_.xmlns) === -1)
          throw new Error("Unknown Namespace: " + _.xmlns);
        return GE(_), _;
      })(t, a);
    }
    function pN(t, n, a, l, d, _, u, p) {
      return (n.slice(-4) === ".bin" ? function(m, f, E, b, T, v, y) {
        if (!m)
          return m;
        var R = f || {};
        b = b || { "!id": {} };
        var P, I, A, M, F, B, re, me, le, be, Fe = R.dense ? [] : {}, Ue = { s: { r: 2e6, c: 2e6 }, e: { r: 0, c: 0 } }, Ne = !1, ze = !1, ut = [];
        R.biff = 12;
        var lt = R["!row"] = 0, et = !1, nt = [], je = {}, Ye = R.supbooks || T.supbooks || [[]];
        if (Ye.sharedf = je, Ye.arrayf = nt, Ye.SheetNames = T.SheetNames || T.Sheets.map(function(We) {
          return We.name;
        }), !R.supbooks && (R.supbooks = Ye, T.Names))
          for (var ht = 0; ht < T.Names.length; ++ht)
            Ye[0][ht + 1] = T.Names[ht];
        var Tt, xt = [], Zt = [], ft = !1;
        return Bo[16] = { n: "BrtShortReal", f: kE }, xa(m, function(We, Wt, dr) {
          if (!ze)
            switch (dr) {
              case 148:
                P = We;
                break;
              case 0:
                I = We, R.sheetRows && R.sheetRows <= I.r && (ze = !0), le = Xr(F = I.r), R["!row"] = I.r, (We.hidden || We.hpt || We.level != null) && (We.hpt && (We.hpx = Yi(We.hpt)), Zt[We.r] = We);
                break;
              case 2:
              case 3:
              case 4:
              case 5:
              case 6:
              case 7:
              case 8:
              case 9:
              case 10:
              case 11:
              case 13:
              case 14:
              case 15:
              case 16:
              case 17:
              case 18:
              case 62:
                switch (A = { t: We[2] }, We[2]) {
                  case "n":
                    A.v = We[1];
                    break;
                  case "s":
                    me = Po[We[1]], A.v = me.t, A.r = me.r;
                    break;
                  case "b":
                    A.v = !!We[1];
                    break;
                  case "e":
                    A.v = We[1], R.cellText !== !1 && (A.w = La[A.v]);
                    break;
                  case "str":
                    A.t = "s", A.v = We[1];
                    break;
                  case "is":
                    A.t = "s", A.v = We[1].t;
                }
                if ((M = y.CellXf[We[0].iStyleRef]) && AE(A, M.numFmtId, null, R, v, y), B = We[0].c == -1 ? B + 1 : We[0].c, R.dense ? (Fe[F] || (Fe[F] = []), Fe[F][B] = A) : Fe[Vr(B) + le] = A, R.cellFormula) {
                  for (et = !1, lt = 0; lt < nt.length; ++lt) {
                    var ir = nt[lt];
                    I.r >= ir[0].s.r && I.r <= ir[0].e.r && B >= ir[0].s.c && B <= ir[0].e.c && (A.F = Xt(ir[0]), et = !0);
                  }
                  !et && 3 < We.length && (A.f = We[3]);
                }
                Ue.s.r > I.r && (Ue.s.r = I.r), Ue.s.c > B && (Ue.s.c = B), Ue.e.r < I.r && (Ue.e.r = I.r), Ue.e.c < B && (Ue.e.c = B), R.cellDates && M && A.t == "n" && Gt(ae[M.numFmtId]) && (Or = we(A.v)) && (A.t = "d", A.v = new Date(Or.y, Or.m - 1, Or.d, Or.H, Or.M, Or.S, Or.u)), Tt && (Tt.type == "XLDAPR" && (A.D = !0), Tt = void 0);
                break;
              case 1:
              case 12:
                if (!R.sheetStubs || Ne)
                  break;
                A = { t: "z", v: void 0 }, B = We[0].c == -1 ? B + 1 : We[0].c, R.dense ? (Fe[F] || (Fe[F] = []), Fe[F][B] = A) : Fe[Vr(B) + le] = A, Ue.s.r > I.r && (Ue.s.r = I.r), Ue.s.c > B && (Ue.s.c = B), Ue.e.r < I.r && (Ue.e.r = I.r), Ue.e.c < B && (Ue.e.c = B), Tt && (Tt.type == "XLDAPR" && (A.D = !0), Tt = void 0);
                break;
              case 176:
                ut.push(We);
                break;
              case 49:
                Tt = ((R.xlmeta || {}).Cell || [])[We - 1];
                break;
              case 494:
                var Or = b["!id"][We.relId];
                for (Or ? (We.Target = Or.Target, We.loc && (We.Target += "#" + We.loc), We.Rel = Or) : We.relId == "" && (We.Target = "#" + We.loc), F = We.rfx.s.r; F <= We.rfx.e.r; ++F)
                  for (B = We.rfx.s.c; B <= We.rfx.e.c; ++B)
                    R.dense ? (Fe[F] || (Fe[F] = []), Fe[F][B] || (Fe[F][B] = { t: "z", v: void 0 }), Fe[F][B].l = We) : (re = $t({ c: B, r: F }), Fe[re] || (Fe[re] = { t: "z", v: void 0 }), Fe[re].l = We);
                break;
              case 426:
                if (!R.cellFormula)
                  break;
                nt.push(We), (be = R.dense ? Fe[F][B] : Fe[Vr(B) + le]).f = Gn(We[1], 0, { r: I.r, c: B }, Ye, R), be.F = Xt(We[0]);
                break;
              case 427:
                if (!R.cellFormula)
                  break;
                je[$t(We[0].s)] = We[1], (be = R.dense ? Fe[F][B] : Fe[Vr(B) + le]).f = Gn(We[1], 0, { r: I.r, c: B }, Ye, R);
                break;
              case 60:
                if (!R.cellStyles)
                  break;
                for (; We.e >= We.s; )
                  xt[We.e--] = { width: We.w / 256, hidden: !!(1 & We.flags), level: We.level }, ft || (ft = !0, bc(We.w / 256)), $a(xt[We.e + 1]);
                break;
              case 161:
                Fe["!autofilter"] = { ref: Xt(We) };
                break;
              case 476:
                Fe["!margins"] = We;
                break;
              case 147:
                T.Sheets[E] || (T.Sheets[E] = {}), We.name && (T.Sheets[E].CodeName = We.name), (We.above || We.left) && (Fe["!outline"] = { above: We.above, left: We.left });
                break;
              case 137:
                T.Views || (T.Views = [{}]), T.Views[0] || (T.Views[0] = {}), We.RTL && (T.Views[0].RTL = !0);
                break;
              case 485:
                break;
              case 64:
              case 1053:
              case 151:
                break;
              case 152:
              case 175:
              case 644:
              case 625:
              case 562:
              case 396:
              case 1112:
              case 1146:
              case 471:
              case 1050:
              case 649:
              case 1105:
              case 589:
              case 607:
              case 564:
              case 1055:
              case 168:
              case 174:
              case 1180:
              case 499:
              case 507:
              case 550:
              case 171:
              case 167:
              case 1177:
              case 169:
              case 1181:
              case 551:
              case 552:
              case 661:
              case 639:
              case 478:
              case 537:
              case 477:
              case 536:
              case 1103:
              case 680:
              case 1104:
              case 1024:
              case 663:
              case 535:
              case 678:
              case 504:
              case 1043:
              case 428:
              case 170:
              case 3072:
              case 50:
              case 2070:
              case 1045:
                break;
              case 35:
                Ne = !0;
                break;
              case 36:
                Ne = !1;
                break;
              case 37:
                Ne = !0;
                break;
              case 38:
                Ne = !1;
                break;
              default:
                if (!Wt.T && (!Ne || R.WTF))
                  throw new Error("Unexpected record 0x" + dr.toString(16));
            }
        }, R), delete R.supbooks, delete R["!row"], !Fe["!ref"] && (Ue.s.r < 2e6 || P && (0 < P.e.r || 0 < P.e.c || 0 < P.s.r || 0 < P.s.c)) && (Fe["!ref"] = Xt(P || Ue)), R.sheetRows && Fe["!ref"] && (m = lr(Fe["!ref"]), R.sheetRows <= +m.e.r && (m.e.r = R.sheetRows - 1, m.e.r > Ue.e.r && (m.e.r = Ue.e.r), m.e.r < m.s.r && (m.s.r = m.e.r), m.e.c > Ue.e.c && (m.e.c = Ue.e.c), m.e.c < m.s.c && (m.s.c = m.e.c), Fe["!fullref"] = Fe["!ref"], Fe["!ref"] = Xt(m))), 0 < ut.length && (Fe["!merges"] = ut), 0 < xt.length && (Fe["!cols"] = xt), 0 < Zt.length && (Fe["!rows"] = Zt), Fe;
      } : BR)(t, l, a, d, _, u, p);
    }
    function mN(t, n, a, l, d, _) {
      return n.slice(-4) === ".bin" ? function(u, p, m, f, E) {
        if (!u)
          return u;
        f = f || { "!id": {} };
        var b = { "!type": "chart", "!drawel": null, "!rel": "" }, T = !1;
        return xa(u, function(v, y, R) {
          switch (R) {
            case 550:
              b["!rel"] = v;
              break;
            case 651:
              E.Sheets[m] || (E.Sheets[m] = {}), v.name && (E.Sheets[m].CodeName = v.name);
              break;
            case 562:
            case 652:
            case 669:
            case 679:
            case 551:
            case 552:
            case 476:
            case 3072:
              break;
            case 35:
              T = !0;
              break;
            case 36:
              T = !1;
              break;
            case 37:
              break;
            case 38:
              break;
            default:
              if (!(0 < y.T)) {
                if (!(y.T < 0)) {
                  if (!T || p.WTF)
                    throw new Error("Unexpected record 0x" + R.toString(16));
                }
              }
          }
        }, p), f["!id"][b["!rel"]] && (b["!drawel"] = f["!id"][b["!rel"]]), b;
      }(t, l, a, d, _) : function(u, p, m, f) {
        if (!u)
          return u;
        m = m || { "!id": {} };
        var E = { "!type": "chart", "!drawel": null, "!rel": "" }, b = u.match(OE);
        return b && Ic(b[0], 0, f, p), (u = u.match(/drawing r:id="(.*?)"/)) && (E["!rel"] = u[1]), m["!id"][E["!rel"]] && (E["!drawel"] = m["!id"][E["!rel"]]), E;
      }(t, a, d, _);
    }
    function fN(t, n, a, l) {
      return (n.slice(-4) === ".bin" ? function(d, _, u) {
        var p, m = { NumberFmt: [] };
        for (p in ae)
          m.NumberFmt[p] = ae[p];
        m.CellXf = [], m.Fonts = [];
        var f = [], E = !1;
        return xa(d, function(b, T, v) {
          switch (v) {
            case 44:
              m.NumberFmt[b[0]] = b[1], Qn(b[1], b[0]);
              break;
            case 43:
              m.Fonts.push(b), b.color.theme != null && _ && _.themeElements && _.themeElements.clrScheme && (b.color.rgb = Ls(_.themeElements.clrScheme[b.color.theme].rgb, b.color.tint || 0));
              break;
            case 1025:
            case 45:
            case 46:
              break;
            case 47:
              f[f.length - 1] == 617 && m.CellXf.push(b);
              break;
            case 48:
            case 507:
            case 572:
            case 475:
              break;
            case 1171:
            case 2102:
            case 1130:
            case 512:
            case 2095:
            case 3072:
              break;
            case 35:
              E = !0;
              break;
            case 36:
              E = !1;
              break;
            case 37:
              f.push(v), E = !0;
              break;
            case 38:
              f.pop(), E = !1;
              break;
            default:
              if (0 < T.T)
                f.push(v);
              else if (T.T < 0)
                f.pop();
              else if (!E || u.WTF && f[f.length - 1] != 37)
                throw new Error("Unexpected record 0x" + v.toString(16));
          }
        }), m;
      } : KC)(t, a, l);
    }
    function gN(t, n, a) {
      return n.slice(-4) === ".bin" ? (l = a, _ = !(d = []), xa(t, function(u, p, m) {
        switch (m) {
          case 159:
            d.Count = u[0], d.Unique = u[1];
            break;
          case 19:
            d.push(u);
            break;
          case 160:
            return 1;
          case 35:
            _ = !0;
            break;
          case 36:
            _ = !1;
            break;
          default:
            if (p.T, !_ || l.WTF)
              throw new Error("Unexpected record 0x" + m.toString(16));
        }
      }), d) : function(u, p) {
        var m = [], f = "";
        if (!u)
          return m;
        if (u = u.match(MC)) {
          f = u[2].replace(PC, "").split(kC);
          for (var E = 0; E != f.length; ++E) {
            var b = gc(f[E].trim(), p);
            b != null && (m[m.length] = b);
          }
          u = Ht(u[1]), m.Count = u.count, m.Unique = u.uniqueCount;
        }
        return m;
      }(t, a);
      var l, d, _;
    }
    function EN(t, n, a) {
      return n.slice(-4) === ".bin" ? (l = a, d = [], _ = [], p = !(u = {}), xa(t, function(m, f, E) {
        switch (E) {
          case 632:
            _.push(m);
            break;
          case 635:
            u = m;
            break;
          case 637:
            u.t = m.t, u.h = m.h, u.r = m.r;
            break;
          case 636:
            if (u.author = _[u.iauthor], delete u.iauthor, l.sheetRows && u.rfx && l.sheetRows <= u.rfx.r)
              break;
            u.t || (u.t = ""), delete u.rfx, d.push(u);
            break;
          case 3072:
            break;
          case 35:
            p = !0;
            break;
          case 36:
            p = !1;
            break;
          case 37:
          case 38:
            break;
          default:
            if (!f.T && (!p || l.WTF))
              throw new Error("Unexpected record 0x" + E.toString(16));
        }
      }), d) : function(m, f) {
        if (m.match(/<(?:\w+:)?comments *\/>/))
          return [];
        var E = [], b = [], T = m.match(/<(?:\w+:)?authors>([\s\S]*)<\/(?:\w+:)?authors>/);
        return T && T[1] && T[1].split(/<\/\w*:?author>/).forEach(function(v) {
          v === "" || v.trim() === "" || (v = v.match(/<(?:\w+:)?author[^>]*>(.*)/)) && E.push(v[1]);
        }), (m = m.match(/<(?:\w+:)?commentList>([\s\S]*)<\/(?:\w+:)?commentList>/)) && m[1] && m[1].split(/<\/\w*:?comment>/).forEach(function(v) {
          var y, R;
          v === "" || v.trim() === "" || (y = v.match(/<(?:\w+:)?comment[^>]*>/)) && (y = { author: (R = Ht(y[0])).authorId && E[R.authorId] || "sheetjsghost", ref: R.ref, guid: R.guid }, R = zr(R.ref), f.sheetRows && f.sheetRows <= R.r || (v = !!(v = v.match(/<(?:\w+:)?text>([\s\S]*)<\/(?:\w+:)?text>/)) && !!v[1] && gc(v[1]) || { r: "", t: "", h: "" }, y.r = v.r, v.r == "<t></t>" && (v.t = v.h = ""), y.t = (v.t || "").replace(/\r\n/g, `
`).replace(/\r/g, `
`), f.cellHTML && (y.h = v.h), b.push(y)));
        }), b;
      }(t, a);
      var l, d, _, u, p;
    }
    function hN(t, n) {
      return n.slice(-4) === ".bin" ? (a = [], xa(t, function(l, d, _) {
        if (_ === 63)
          a.push(l);
        else if (!d.T)
          throw new Error("Unexpected record 0x" + _.toString(16));
      }), a) : function(l) {
        var d = [];
        if (!l)
          return d;
        var _ = 1;
        return (l.match(Cn) || []).forEach(function(u) {
          var p = Ht(u);
          switch (p[0]) {
            case "<?xml":
              break;
            case "<calcChain":
            case "<calcChain>":
            case "</calcChain>":
              break;
            case "<c":
              delete p[0], p.i ? _ = p.i : p.i = _, d.push(p);
          }
        }), d;
      }(t);
      var a;
    }
    function SN(t, n, a, l) {
      if (a.slice(-4) === ".bin")
        return function(d, _) {
          if (!d)
            return d;
          var u = _ || {}, p = !1;
          xa(d, function(m, f, E) {
            switch (E) {
              case 359:
              case 363:
              case 364:
              case 366:
              case 367:
              case 368:
              case 369:
              case 370:
              case 371:
              case 472:
              case 577:
              case 578:
              case 579:
              case 580:
              case 581:
              case 582:
              case 583:
              case 584:
              case 585:
              case 586:
              case 587:
                break;
              case 35:
                p = !0;
                break;
              case 36:
                p = !1;
                break;
              default:
                if (!f.T && (!p || u.WTF))
                  throw new Error("Unexpected record 0x" + E.toString(16));
            }
          }, u);
        }(t, l);
    }
    function bN(t, n, a) {
      return n.slice(-4) === ".bin" ? (l = { Types: [], Cell: [], Value: [] }, d = a || {}, u = !(_ = []), p = 2, xa(t, function(m, f, E) {
        switch (E) {
          case 335:
            l.Types.push({ name: m.name });
            break;
          case 51:
            m.forEach(function(b) {
              p == 1 ? l.Cell.push({ type: l.Types[b[0] - 1].name, index: b[1] }) : p == 0 && l.Value.push({ type: l.Types[b[0] - 1].name, index: b[1] });
            });
            break;
          case 337:
            p = m ? 1 : 0;
            break;
          case 338:
            p = 2;
            break;
          case 35:
            _.push(E), u = !0;
            break;
          case 36:
            _.pop(), u = !1;
            break;
          default:
            if (!f.T && (!u || d.WTF && _[_.length - 1] != 35))
              throw new Error("Unexpected record 0x" + E.toString(16));
        }
      }), l) : function(m, f) {
        var E = { Types: [], Cell: [], Value: [] };
        if (!m)
          return E;
        var b, T = !1, v = 2;
        return m.replace(Cn, function(y) {
          var R = Ht(y);
          switch (pa(R[0])) {
            case "<?xml":
              break;
            case "<metadata":
            case "</metadata>":
              break;
            case "<metadataTypes":
            case "</metadataTypes>":
              break;
            case "<metadataType":
              E.Types.push({ name: R.name });
              break;
            case "</metadataType>":
              break;
            case "<futureMetadata":
              for (var P = 0; P < E.Types.length; ++P)
                E.Types[P].name == R.name && (b = E.Types[P]);
              break;
            case "</futureMetadata>":
            case "<bk>":
            case "</bk>":
              break;
            case "<rc":
              v == 1 ? E.Cell.push({ type: E.Types[R.t - 1].name, index: +R.v }) : v == 0 && E.Value.push({ type: E.Types[R.t - 1].name, index: +R.v });
              break;
            case "</rc>":
              break;
            case "<cellMetadata":
              v = 1;
              break;
            case "</cellMetadata>":
              v = 2;
              break;
            case "<valueMetadata":
              v = 0;
              break;
            case "</valueMetadata>":
              v = 2;
              break;
            case "<extLst":
            case "<extLst>":
            case "</extLst>":
            case "<extLst/>":
              break;
            case "<ext":
              T = !0;
              break;
            case "</ext>":
              T = !1;
              break;
            case "<rvb":
              if (!b)
                break;
              b.offsets || (b.offsets = []), b.offsets.push(+R.i);
              break;
            default:
              if (!T && f.WTF)
                throw new Error("unrecognized " + R[0] + " in metadata");
          }
          return y;
        }), E;
      }(t, a);
      var l, d, _, u, p;
    }
    var Fo, qE = /([\w:]+)=((?:")([^"]*)(?:")|(?:')([^']*)(?:'))/g, $E = /([\w:]+)=((?:")(?:[^"]*)(?:")|(?:')(?:[^']*)(?:'))/;
    function fa(t, n) {
      var a = t.split(/\s+/), l = [];
      if (n || (l[0] = a[0]), a.length === 1)
        return l;
      var d, _, u, p = t.match(qE);
      if (p)
        for (u = 0; u != p.length; ++u)
          (_ = (d = p[u].match($E))[1].indexOf(":")) === -1 ? l[d[1]] = d[2].slice(1, d[2].length - 1) : l[d[1].slice(0, 6) === "xmlns:" ? "xmlns" + d[1].slice(6) : d[1].slice(_ + 1)] = d[2].slice(1, d[2].length - 1);
      return l;
    }
    function TN(t, n, a) {
      if (t.t !== "z") {
        if (!a || a.cellText !== !1)
          try {
            t.t === "e" ? t.w = t.w || La[t.v] : n === "General" ? t.t === "n" ? (0 | t.v) === t.v ? t.w = t.v.toString(10) : t.w = Te(t.v) : t.w = Be(t.v) : t.w = (l = n || "General", d = t.v, (l = Fo[l] || mr(l)) === "General" ? Be(d) : dn(l, d));
          } catch (u) {
            if (a.WTF)
              throw u;
          }
        var l, d;
        try {
          var _ = Fo[n] || n || "General";
          a.cellNF && (t.z = _), a.cellDates && t.t == "n" && Gt(_) && (_ = we(t.v)) && (t.t = "d", t.v = new Date(_.y, _.m - 1, _.d, _.H, _.M, _.S, _.u));
        } catch (u) {
          if (a.WTF)
            throw u;
        }
      }
    }
    function wc(t, n) {
      var a = n || {};
      ra();
      var l, d = G(Bl(t)), _ = (d = a.type == "binary" || a.type == "array" || a.type == "base64" ? e !== void 0 ? e.utils.decode(65001, x(d)) : Cr(d) : d).slice(0, 1024).toLowerCase(), u = !1;
      if ((1023 & (_ = _.replace(/".*?"/g, "")).indexOf(">")) > Math.min(1023 & _.indexOf(","), 1023 & _.indexOf(";"))) {
        var p = xr(a);
        return p.type = "string", Bi.to_workbook(d, p);
      }
      if (_.indexOf("<?xml") == -1 && ["html", "table", "head", "meta", "script", "style", "div"].forEach(function(ee) {
        0 <= _.indexOf("<" + ee) && (u = !0);
      }), u)
        return function(ee, $e) {
          if (ee = ee.match(/<table[\s\S]*?>[\s\S]*?<\/table>/gi), !ee || ee.length == 0)
            throw new Error("Invalid HTML: could not find <table>");
          if (ee.length == 1)
            return Ha(KE(ee[0], $e), $e);
          var Ce = $c();
          return ee.forEach(function(xe, Se) {
            Wc(Ce, KE(xe, $e), "Sheet" + (Se + 1));
          }), Ce;
        }(d, a);
      Fo = { "General Number": "General", "General Date": ae[22], "Long Date": "dddd, mmmm dd, yyyy", "Medium Date": ae[15], "Short Date": ae[14], "Long Time": ae[19], "Medium Time": ae[18], "Short Time": ae[20], Currency: '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)', Fixed: ae[2], Standard: ae[4], Percent: ae[10], Scientific: ae[11], "Yes/No": '"Yes";"Yes";"No";@', "True/False": '"True";"True";"False";@', "On/Off": '"Yes";"Yes";"No";@' };
      var m, f = [], E, b = {}, T = [], v = a.dense ? [] : {}, y = "", R = {}, P = {}, I = fa('<Data ss:Type="String">'), A = 0, M = 0, F = 0, B = { s: { r: 2e6, c: 2e6 }, e: { r: 0, c: 0 } }, re = {}, me = {}, le = "", be = 0, Fe = [], Ue = {}, Ne = {}, ze = 0, ut = [], lt = [], et = {}, nt = [], je = !1, Ye = [], ht = [], Tt = {}, xt = 0, Zt = 0, ft = { Sheets: [], WBProps: { date1904: !1 } }, We = {};
      go.lastIndex = 0, d = d.replace(/<!--([\s\S]*?)-->/gm, "");
      for (var Wt, dr, ir, Or, Zr = ""; l = go.exec(d); )
        switch (l[3] = (Zr = l[3]).toLowerCase()) {
          case "data":
            if (Zr == "data") {
              if (l[1] === "/") {
                if ((m = f.pop())[0] !== l[3])
                  throw new Error("Bad state: " + m.join("|"));
              } else
                l[0].charAt(l[0].length - 2) !== "/" && f.push([l[3], !0]);
              break;
            }
            if (f[f.length - 1][1])
              break;
            l[1] === "/" ? function(ee, $e, Ce, xe, Se, ke, Qe, At, Et, ct) {
              var vt = "General", yt = xe.StyleID, It = {};
              ct = ct || {};
              var at = [], Xe = 0;
              for ((yt = yt === void 0 && At ? At.StyleID : yt) === void 0 && Qe && (yt = Qe.StyleID); ke[yt] !== void 0 && (ke[yt].nf && (vt = ke[yt].nf), ke[yt].Interior && at.push(ke[yt].Interior), ke[yt].Parent); )
                yt = ke[yt].Parent;
              switch (Ce.Type) {
                case "Boolean":
                  xe.t = "b", xe.v = Lr(ee);
                  break;
                case "String":
                  xe.t = "s", xe.r = ps(mr(ee)), xe.v = -1 < ee.indexOf("<") ? mr($e || ee).replace(/<.*?>/g, "") : xe.r;
                  break;
                case "DateTime":
                  ee.slice(-1) != "Z" && (ee += "Z"), xe.v = (Br(ee) - new Date(Date.UTC(1899, 11, 30))) / 864e5, xe.v != xe.v ? xe.v = mr(ee) : xe.v < 60 && (xe.v = xe.v - 1), vt && vt != "General" || (vt = "yyyy-mm-dd");
                case "Number":
                  xe.v === void 0 && (xe.v = +ee), xe.t || (xe.t = "n");
                  break;
                case "Error":
                  xe.t = "e", xe.v = vf[ee], ct.cellText !== !1 && (xe.w = ee);
                  break;
                default:
                  ee == "" && $e == "" ? xe.t = "z" : (xe.t = "s", xe.v = ps($e || ee));
              }
              if (TN(xe, vt, ct), ct.cellFormula !== !1)
                if (xe.Formula)
                  Ce = mr(xe.Formula), Ce.charCodeAt(0) == 61 && (Ce = Ce.slice(1)), xe.f = qi(Ce, Se), delete xe.Formula, xe.ArrayRange == "RC" ? xe.F = qi("RC:RC", Se) : xe.ArrayRange && (xe.F = qi(xe.ArrayRange, Se), Et.push([lr(xe.F), xe.F]));
                else
                  for (Xe = 0; Xe < Et.length; ++Xe)
                    Se.r >= Et[Xe][0].s.r && Se.r <= Et[Xe][0].e.r && Se.c >= Et[Xe][0].s.c && Se.c <= Et[Xe][0].e.c && (xe.F = Et[Xe][1]);
              ct.cellStyles && (at.forEach(function(Dt) {
                !It.patternType && Dt.patternType && (It.patternType = Dt.patternType);
              }), xe.s = It), xe.StyleID !== void 0 && (xe.ixfe = xe.StyleID);
            }(d.slice(A, l.index), le, I, f[f.length - 1][0] == "comment" ? et : R, { c: M, r: F }, re, nt[M], P, Ye, a) : (le = "", I = fa(l[0]), A = l.index + l[0].length);
            break;
          case "cell":
            if (l[1] === "/")
              if (0 < lt.length && (R.c = lt), (!a.sheetRows || a.sheetRows > F) && R.v !== void 0 && (a.dense ? (v[F] || (v[F] = []), v[F][M] = R) : v[Vr(M) + Xr(F)] = R), R.HRef && (R.l = { Target: mr(R.HRef) }, R.HRefScreenTip && (R.l.Tooltip = R.HRefScreenTip), delete R.HRef, delete R.HRefScreenTip), (R.MergeAcross || R.MergeDown) && (xt = M + (0 | parseInt(R.MergeAcross, 10)), Zt = F + (0 | parseInt(R.MergeDown, 10)), Fe.push({ s: { c: M, r: F }, e: { c: xt, r: Zt } })), a.sheetStubs)
                if (R.MergeAcross || R.MergeDown) {
                  for (var oe = M; oe <= xt; ++oe)
                    for (var yr = F; yr <= Zt; ++yr)
                      (M < oe || F < yr) && (a.dense ? (v[yr] || (v[yr] = []), v[yr][oe] = { t: "z" }) : v[Vr(oe) + Xr(yr)] = { t: "z" });
                  M = xt + 1;
                } else
                  ++M;
              else
                R.MergeAcross ? M = xt + 1 : ++M;
            else
              (M = (R = function(ee) {
                var $e = {};
                if (ee.split(/\s+/).length === 1)
                  return $e;
                var Ce, xe, Se, ke = ee.match(qE);
                if (ke)
                  for (Se = 0; Se != ke.length; ++Se)
                    (xe = (Ce = ke[Se].match($E))[1].indexOf(":")) === -1 ? $e[Ce[1]] = Ce[2].slice(1, Ce[2].length - 1) : $e[Ce[1].slice(0, 6) === "xmlns:" ? "xmlns" + Ce[1].slice(6) : Ce[1].slice(xe + 1)] = Ce[2].slice(1, Ce[2].length - 1);
                return $e;
              }(l[0])).Index ? +R.Index - 1 : M) < B.s.c && (B.s.c = M), M > B.e.c && (B.e.c = M), l[0].slice(-2) === "/>" && ++M, lt = [];
            break;
          case "row":
            l[1] === "/" || l[0].slice(-2) === "/>" ? (F < B.s.r && (B.s.r = F), F > B.e.r && (B.e.r = F), l[0].slice(-2) === "/>" && (P = fa(l[0])).Index && (F = +P.Index - 1), M = 0, ++F) : ((P = fa(l[0])).Index && (F = +P.Index - 1), Tt = {}, P.AutoFitHeight != "0" && !P.Height || (Tt.hpx = parseInt(P.Height, 10), Tt.hpt = Io(Tt.hpx), ht[F] = Tt), P.Hidden == "1" && (Tt.hidden = !0, ht[F] = Tt));
            break;
          case "worksheet":
            if (l[1] === "/") {
              if ((m = f.pop())[0] !== l[3])
                throw new Error("Bad state: " + m.join("|"));
              T.push(y), B.s.r <= B.e.r && B.s.c <= B.e.c && (v["!ref"] = Xt(B), a.sheetRows && a.sheetRows <= B.e.r && (v["!fullref"] = v["!ref"], B.e.r = a.sheetRows - 1, v["!ref"] = Xt(B))), Fe.length && (v["!merges"] = Fe), 0 < nt.length && (v["!cols"] = nt), 0 < ht.length && (v["!rows"] = ht), b[y] = v;
            } else
              B = { s: { r: 2e6, c: 2e6 }, e: { r: 0, c: 0 } }, F = M = 0, f.push([l[3], !1]), m = fa(l[0]), y = mr(m.Name), v = a.dense ? [] : {}, Fe = [], Ye = [], ht = [], We = { name: y, Hidden: 0 }, ft.Sheets.push(We);
            break;
          case "table":
            if (l[1] === "/") {
              if ((m = f.pop())[0] !== l[3])
                throw new Error("Bad state: " + m.join("|"));
            } else {
              if (l[0].slice(-2) == "/>")
                break;
              f.push([l[3], !1]), je = !(nt = []);
            }
            break;
          case "style":
            l[1] === "/" ? (dr = re, ir = me, (Or = a).cellStyles && (!ir.Interior || (Or = ir.Interior).Pattern && (Or.patternType = zC[Or.Pattern] || Or.Pattern)), dr[ir.ID] = ir) : me = fa(l[0]);
            break;
          case "numberformat":
            me.nf = mr(fa(l[0]).Format || "General"), Fo[me.nf] && (me.nf = Fo[me.nf]);
            for (var Rr = 0; Rr != 392 && ae[Rr] != me.nf; ++Rr)
              ;
            if (Rr == 392) {
              for (Rr = 57; Rr != 392; ++Rr)
                if (ae[Rr] == null) {
                  Qn(me.nf, Rr);
                  break;
                }
            }
            break;
          case "column":
            if (f[f.length - 1][0] !== "table")
              break;
            if ((E = fa(l[0])).Hidden && (E.hidden = !0, delete E.Hidden), E.Width && (E.wpx = parseInt(E.Width, 10)), !je && 10 < E.wpx) {
              je = !0, Ln = Qg;
              for (var _n = 0; _n < nt.length; ++_n)
                nt[_n] && $a(nt[_n]);
            }
            je && $a(E), nt[E.Index - 1 || nt.length] = E;
            for (var da = 0; da < +E.Span; ++da)
              nt[nt.length] = xr(E);
            break;
          case "namedrange":
            if (l[1] === "/")
              break;
            ft.Names || (ft.Names = []);
            var q = Ht(l[0]), Ie = { Name: q.Name, Ref: qi(q.RefersTo.slice(1), { r: 0, c: 0 }) };
            0 < ft.Sheets.length && (Ie.Sheet = ft.Sheets.length - 1), ft.Names.push(Ie);
            break;
          case "namedcell":
          case "b":
          case "i":
          case "u":
          case "s":
          case "em":
          case "h2":
          case "h3":
          case "sub":
          case "sup":
          case "span":
          case "alignment":
          case "borders":
          case "border":
            break;
          case "font":
            if (l[0].slice(-2) === "/>")
              break;
            l[1] === "/" ? le += d.slice(be, l.index) : be = l.index + l[0].length;
            break;
          case "interior":
            if (!a.cellStyles)
              break;
            me.Interior = fa(l[0]);
            break;
          case "protection":
            break;
          case "author":
          case "title":
          case "description":
          case "created":
          case "keywords":
          case "subject":
          case "category":
          case "company":
          case "lastauthor":
          case "lastsaved":
          case "lastprinted":
          case "version":
          case "revision":
          case "totaltime":
          case "hyperlinkbase":
          case "manager":
          case "contentstatus":
          case "identifier":
          case "language":
          case "appname":
            if (l[0].slice(-2) === "/>")
              break;
            l[1] === "/" ? (ir = Ue, q = Zr, Ie = d.slice(ze, l.index), ir[q = (xf = xf || ao(oc))[q] || q] = Ie) : ze = l.index + l[0].length;
            break;
          case "paragraphs":
            break;
          case "styles":
          case "workbook":
            if (l[1] === "/") {
              if ((m = f.pop())[0] !== l[3])
                throw new Error("Bad state: " + m.join("|"));
            } else
              f.push([l[3], !1]);
            break;
          case "comment":
            if (l[1] === "/") {
              if ((m = f.pop())[0] !== l[3])
                throw new Error("Bad state: " + m.join("|"));
              (Wt = et).t = Wt.v || "", Wt.t = Wt.t.replace(/\r\n/g, `
`).replace(/\r/g, `
`), Wt.v = Wt.w = Wt.ixfe = void 0, lt.push(et);
            } else
              f.push([l[3], !1]), et = { a: (m = fa(l[0])).Author };
            break;
          case "autofilter":
            if (l[1] === "/") {
              if ((m = f.pop())[0] !== l[3])
                throw new Error("Bad state: " + m.join("|"));
            } else
              l[0].charAt(l[0].length - 2) !== "/" && (Wt = fa(l[0]), v["!autofilter"] = { ref: qi(Wt.Range).replace(/\$/g, "") }, f.push([l[3], !0]));
            break;
          case "name":
            break;
          case "datavalidation":
            if (l[1] === "/") {
              if ((m = f.pop())[0] !== l[3])
                throw new Error("Bad state: " + m.join("|"));
            } else
              l[0].charAt(l[0].length - 2) !== "/" && f.push([l[3], !0]);
            break;
          case "pixelsperinch":
            break;
          case "componentoptions":
          case "documentproperties":
          case "customdocumentproperties":
          case "officedocumentsettings":
          case "pivottable":
          case "pivotcache":
          case "names":
          case "mapinfo":
          case "pagebreaks":
          case "querytable":
          case "sorting":
          case "schema":
          case "conditionalformatting":
          case "smarttagtype":
          case "smarttags":
          case "excelworkbook":
          case "workbookoptions":
          case "worksheetoptions":
            if (l[1] === "/") {
              if ((m = f.pop())[0] !== l[3])
                throw new Error("Bad state: " + m.join("|"));
            } else
              l[0].charAt(l[0].length - 2) !== "/" && f.push([l[3], !0]);
            break;
          case "null":
            break;
          default:
            if (f.length == 0 && l[3] == "document" || f.length == 0 && l[3] == "uof")
              return oh(d, a);
            var te = !0;
            switch (f[f.length - 1][0]) {
              case "officedocumentsettings":
                switch (l[3]) {
                  case "allowpng":
                  case "removepersonalinformation":
                  case "downloadcomponents":
                  case "locationofcomponents":
                  case "colors":
                  case "color":
                  case "index":
                  case "rgb":
                  case "targetscreensize":
                  case "readonlyrecommended":
                    break;
                  default:
                    te = !1;
                }
                break;
              case "componentoptions":
                switch (l[3]) {
                  case "toolbar":
                  case "hideofficelogo":
                  case "spreadsheetautofit":
                  case "label":
                  case "caption":
                  case "maxheight":
                  case "maxwidth":
                  case "nextsheetnumber":
                    break;
                  default:
                    te = !1;
                }
                break;
              case "excelworkbook":
                switch (l[3]) {
                  case "date1904":
                    ft.WBProps.date1904 = !0;
                    break;
                  case "windowheight":
                  case "windowwidth":
                  case "windowtopx":
                  case "windowtopy":
                  case "tabratio":
                  case "protectstructure":
                  case "protectwindow":
                  case "protectwindows":
                  case "activesheet":
                  case "displayinknotes":
                  case "firstvisiblesheet":
                  case "supbook":
                  case "sheetname":
                  case "sheetindex":
                  case "sheetindexfirst":
                  case "sheetindexlast":
                  case "dll":
                  case "acceptlabelsinformulas":
                  case "donotsavelinkvalues":
                  case "iteration":
                  case "maxiterations":
                  case "maxchange":
                  case "path":
                  case "xct":
                  case "count":
                  case "selectedsheets":
                  case "calculation":
                  case "uncalced":
                  case "startupprompt":
                  case "crn":
                  case "externname":
                  case "formula":
                  case "colfirst":
                  case "collast":
                  case "wantadvise":
                  case "boolean":
                  case "error":
                  case "text":
                  case "ole":
                  case "noautorecover":
                  case "publishobjects":
                  case "donotcalculatebeforesave":
                  case "number":
                  case "refmoder1c1":
                  case "embedsavesmarttags":
                    break;
                  default:
                    te = !1;
                }
                break;
              case "workbookoptions":
                switch (l[3]) {
                  case "owcversion":
                  case "height":
                  case "width":
                    break;
                  default:
                    te = !1;
                }
                break;
              case "worksheetoptions":
                switch (l[3]) {
                  case "visible":
                    if (l[0].slice(-2) !== "/>")
                      if (l[1] === "/")
                        switch (d.slice(ze, l.index)) {
                          case "SheetHidden":
                            We.Hidden = 1;
                            break;
                          case "SheetVeryHidden":
                            We.Hidden = 2;
                        }
                      else
                        ze = l.index + l[0].length;
                    break;
                  case "header":
                    v["!margins"] || fi(v["!margins"] = {}, "xlml"), isNaN(+Ht(l[0]).Margin) || (v["!margins"].header = +Ht(l[0]).Margin);
                    break;
                  case "footer":
                    v["!margins"] || fi(v["!margins"] = {}, "xlml"), isNaN(+Ht(l[0]).Margin) || (v["!margins"].footer = +Ht(l[0]).Margin);
                    break;
                  case "pagemargins":
                    var ve = Ht(l[0]);
                    v["!margins"] || fi(v["!margins"] = {}, "xlml"), isNaN(+ve.Top) || (v["!margins"].top = +ve.Top), isNaN(+ve.Left) || (v["!margins"].left = +ve.Left), isNaN(+ve.Right) || (v["!margins"].right = +ve.Right), isNaN(+ve.Bottom) || (v["!margins"].bottom = +ve.Bottom);
                    break;
                  case "displayrighttoleft":
                    ft.Views || (ft.Views = []), ft.Views[0] || (ft.Views[0] = {}), ft.Views[0].RTL = !0;
                    break;
                  case "freezepanes":
                  case "frozennosplit":
                    break;
                  case "splithorizontal":
                  case "splitvertical":
                  case "donotdisplaygridlines":
                  case "activerow":
                  case "activecol":
                  case "toprowbottompane":
                  case "leftcolumnrightpane":
                  case "unsynced":
                  case "print":
                  case "printerrors":
                  case "panes":
                  case "scale":
                  case "pane":
                  case "number":
                  case "layout":
                  case "pagesetup":
                  case "selected":
                  case "protectobjects":
                  case "enableselection":
                  case "protectscenarios":
                  case "validprinterinfo":
                  case "horizontalresolution":
                  case "verticalresolution":
                  case "numberofcopies":
                  case "activepane":
                  case "toprowvisible":
                  case "leftcolumnvisible":
                  case "fittopage":
                  case "rangeselection":
                  case "papersizeindex":
                  case "pagelayoutzoom":
                  case "pagebreakzoom":
                  case "filteron":
                  case "fitwidth":
                  case "fitheight":
                  case "commentslayout":
                  case "zoom":
                  case "lefttoright":
                  case "gridlines":
                  case "allowsort":
                  case "allowfilter":
                  case "allowinsertrows":
                  case "allowdeleterows":
                  case "allowinsertcols":
                  case "allowdeletecols":
                  case "allowinserthyperlinks":
                  case "allowformatcells":
                  case "allowsizecols":
                  case "allowsizerows":
                    break;
                  case "nosummaryrowsbelowdetail":
                    v["!outline"] || (v["!outline"] = {}), v["!outline"].above = !0;
                    break;
                  case "tabcolorindex":
                  case "donotdisplayheadings":
                  case "showpagelayoutzoom":
                    break;
                  case "nosummarycolumnsrightdetail":
                    v["!outline"] || (v["!outline"] = {}), v["!outline"].left = !0;
                    break;
                  case "blackandwhite":
                  case "donotdisplayzeros":
                  case "displaypagebreak":
                  case "rowcolheadings":
                  case "donotdisplayoutline":
                  case "noorientation":
                  case "allowusepivottables":
                  case "zeroheight":
                  case "viewablerange":
                  case "selection":
                  case "protectcontents":
                    break;
                  default:
                    te = !1;
                }
                break;
              case "pivottable":
              case "pivotcache":
                switch (l[3]) {
                  case "immediateitemsondrop":
                  case "showpagemultipleitemlabel":
                  case "compactrowindent":
                  case "location":
                  case "pivotfield":
                  case "orientation":
                  case "layoutform":
                  case "layoutsubtotallocation":
                  case "layoutcompactrow":
                  case "position":
                  case "pivotitem":
                  case "datatype":
                  case "datafield":
                  case "sourcename":
                  case "parentfield":
                  case "ptlineitems":
                  case "ptlineitem":
                  case "countofsameitems":
                  case "item":
                  case "itemtype":
                  case "ptsource":
                  case "cacheindex":
                  case "consolidationreference":
                  case "filename":
                  case "reference":
                  case "nocolumngrand":
                  case "norowgrand":
                  case "blanklineafteritems":
                  case "hidden":
                  case "subtotal":
                  case "basefield":
                  case "mapchilditems":
                  case "function":
                  case "refreshonfileopen":
                  case "printsettitles":
                  case "mergelabels":
                  case "defaultversion":
                  case "refreshname":
                  case "refreshdate":
                  case "refreshdatecopy":
                  case "versionlastrefresh":
                  case "versionlastupdate":
                  case "versionupdateablemin":
                  case "versionrefreshablemin":
                  case "calculation":
                    break;
                  default:
                    te = !1;
                }
                break;
              case "pagebreaks":
                switch (l[3]) {
                  case "colbreaks":
                  case "colbreak":
                  case "rowbreaks":
                  case "rowbreak":
                  case "colstart":
                  case "colend":
                  case "rowend":
                    break;
                  default:
                    te = !1;
                }
                break;
              case "autofilter":
                switch (l[3]) {
                  case "autofiltercolumn":
                  case "autofiltercondition":
                  case "autofilterand":
                  case "autofilteror":
                    break;
                  default:
                    te = !1;
                }
                break;
              case "querytable":
                switch (l[3]) {
                  case "id":
                  case "autoformatfont":
                  case "autoformatpattern":
                  case "querysource":
                  case "querytype":
                  case "enableredirections":
                  case "refreshedinxl9":
                  case "urlstring":
                  case "htmltables":
                  case "connection":
                  case "commandtext":
                  case "refreshinfo":
                  case "notitles":
                  case "nextid":
                  case "columninfo":
                  case "overwritecells":
                  case "donotpromptforfile":
                  case "textwizardsettings":
                  case "source":
                  case "number":
                  case "decimal":
                  case "thousandseparator":
                  case "trailingminusnumbers":
                  case "formatsettings":
                  case "fieldtype":
                  case "delimiters":
                  case "tab":
                  case "comma":
                  case "autoformatname":
                  case "versionlastedit":
                  case "versionlastrefresh":
                    break;
                  default:
                    te = !1;
                }
                break;
              case "datavalidation":
                switch (l[3]) {
                  case "range":
                  case "type":
                  case "min":
                  case "max":
                  case "sort":
                  case "descending":
                  case "order":
                  case "casesensitive":
                  case "value":
                  case "errorstyle":
                  case "errormessage":
                  case "errortitle":
                  case "inputmessage":
                  case "inputtitle":
                  case "combohide":
                  case "inputhide":
                  case "condition":
                  case "qualifier":
                  case "useblank":
                  case "value1":
                  case "value2":
                  case "format":
                  case "cellrangelist":
                    break;
                  default:
                    te = !1;
                }
                break;
              case "sorting":
              case "conditionalformatting":
                switch (l[3]) {
                  case "range":
                  case "type":
                  case "min":
                  case "max":
                  case "sort":
                  case "descending":
                  case "order":
                  case "casesensitive":
                  case "value":
                  case "errorstyle":
                  case "errormessage":
                  case "errortitle":
                  case "cellrangelist":
                  case "inputmessage":
                  case "inputtitle":
                  case "combohide":
                  case "inputhide":
                  case "condition":
                  case "qualifier":
                  case "useblank":
                  case "value1":
                  case "value2":
                  case "format":
                    break;
                  default:
                    te = !1;
                }
                break;
              case "mapinfo":
              case "schema":
              case "data":
                switch (l[3]) {
                  case "map":
                  case "entry":
                  case "range":
                  case "xpath":
                  case "field":
                  case "xsdtype":
                  case "filteron":
                  case "aggregate":
                  case "elementtype":
                  case "attributetype":
                    break;
                  case "schema":
                  case "element":
                  case "complextype":
                  case "datatype":
                  case "all":
                  case "attribute":
                  case "extends":
                  case "row":
                    break;
                  default:
                    te = !1;
                }
                break;
              case "smarttags":
                break;
              default:
                te = !1;
            }
            if (te || l[3].match(/!\[CDATA/))
              break;
            if (!f[f.length - 1][1])
              throw "Unrecognized tag: " + l[3] + "|" + f.join("|");
            if (f[f.length - 1][0] === "customdocumentproperties") {
              if (l[0].slice(-2) === "/>")
                break;
              l[1] === "/" ? function(ee, $e, Ce, xe) {
                var Se = xe;
                switch ((Ce[0].match(/dt:dt="([\w.]+)"/) || ["", ""])[1]) {
                  case "boolean":
                    Se = Lr(xe);
                    break;
                  case "i2":
                  case "int":
                    Se = parseInt(xe, 10);
                    break;
                  case "r4":
                  case "float":
                    Se = parseFloat(xe);
                    break;
                  case "date":
                  case "dateTime.tz":
                    Se = Br(xe);
                    break;
                  case "i8":
                  case "string":
                  case "fixed":
                  case "uuid":
                  case "bin.base64":
                    break;
                  default:
                    throw new Error("bad custprop:" + Ce[0]);
                }
                ee[mr($e)] = Se;
              }(Ne, Zr, ut, d.slice(ze, l.index)) : ze = (ut = l).index + l[0].length;
              break;
            }
            if (a.WTF)
              throw "Unrecognized tag: " + l[3] + "|" + f.join("|");
        }
      return p = {}, a.bookSheets || a.bookProps || (p.Sheets = b), p.SheetNames = T, p.Workbook = ft, p.SSF = xr(ae), p.Props = Ue, p.Custprops = Ne, p;
    }
    function xc(t, n) {
      switch (Uc(n = n || {}), n.type || "base64") {
        case "base64":
          return wc(H(t), n);
        case "binary":
        case "buffer":
        case "file":
          return wc(t, n);
        case "array":
          return wc(ye(t), n);
      }
    }
    function vN(t, n) {
      var a, l, d, _, u, p, m, f = [];
      return t.Props && f.push((a = t.Props, l = n, d = [], $r(oc).map(function(E) {
        for (var b = 0; b < ia.length; ++b)
          if (ia[b][1] == E)
            return ia[b];
        for (b = 0; b < di.length; ++b)
          if (di[b][1] == E)
            return di[b];
        throw E;
      }).forEach(function(E) {
        var b;
        a[E[1]] != null && (b = (l && l.Props && l.Props[E[1]] != null ? l.Props : a)[E[1]], typeof (b = E[2] === "date" ? new Date(b).toISOString().replace(/\.\d*Z/, "Z") : b) == "number" ? b = String(b) : b === !0 || b === !1 ? b = b ? "1" : "0" : b instanceof Date && (b = new Date(b).toISOString().replace(/\.\d*Z/, "")), d.push(Rn(oc[E[1]] || E[1], b)));
      }), it("DocumentProperties", d.join(""), { xmlns: jn.o }))), t.Custprops && f.push((_ = t.Props, u = t.Custprops, p = ["Worksheets", "SheetNames"], t = "CustomDocumentProperties", m = [], _ && $r(_).forEach(function(E) {
        if (Object.prototype.hasOwnProperty.call(_, E)) {
          for (var b = 0; b < ia.length; ++b)
            if (E == ia[b][1])
              return;
          for (b = 0; b < di.length; ++b)
            if (E == di[b][1])
              return;
          for (b = 0; b < p.length; ++b)
            if (E == p[b])
              return;
          var T = "string", v = typeof (v = _[E]) == "number" ? (T = "float", String(v)) : v === !0 || v === !1 ? (T = "boolean", v ? "1" : "0") : String(v);
          m.push(it(ds(E), v, { "dt:dt": T }));
        }
      }), u && $r(u).forEach(function(E) {
        var b, T;
        Object.prototype.hasOwnProperty.call(u, E) && (_ && Object.prototype.hasOwnProperty.call(_, E) || (b = "string", T = typeof (T = u[E]) == "number" ? (b = "float", String(T)) : T === !0 || T === !1 ? (b = "boolean", T ? "1" : "0") : T instanceof Date ? (b = "dateTime.tz", T.toISOString()) : String(T), m.push(it(ds(E), T, { "dt:dt": b }))));
      }), "<" + t + ' xmlns="' + jn.o + '">' + m.join("") + "</" + t + ">")), f.join("");
    }
    function WE(t) {
      return it("NamedRange", null, { "ss:Name": t.Name, "ss:RefersTo": "=" + Rc(t.Ref, { r: 0, c: 0 }) });
    }
    function CN(t, n, a, l, d, _, u) {
      if (!t || t.v == null && t.f == null)
        return "";
      var p = {};
      if (t.f && (p["ss:Formula"] = "=" + Ar(Rc(t.f, u))), t.F && t.F.slice(0, n.length) == n && (n = zr(t.F.slice(n.length + 1)), p["ss:ArrayRange"] = "RC:R" + (n.r == u.r ? "" : "[" + (n.r - u.r) + "]") + "C" + (n.c == u.c ? "" : "[" + (n.c - u.c) + "]")), t.l && t.l.Target && (p["ss:HRef"] = Ar(t.l.Target), t.l.Tooltip && (p["x:HRefScreenTip"] = Ar(t.l.Tooltip))), a["!merges"])
        for (var m = a["!merges"], f = 0; f != m.length; ++f)
          m[f].s.c == u.c && m[f].s.r == u.r && (m[f].e.c > m[f].s.c && (p["ss:MergeAcross"] = m[f].e.c - m[f].s.c), m[f].e.r > m[f].s.r && (p["ss:MergeDown"] = m[f].e.r - m[f].s.r));
      var E = "", b = "";
      switch (t.t) {
        case "z":
          if (!l.sheetStubs)
            return "";
          break;
        case "n":
          E = "Number", b = String(t.v);
          break;
        case "b":
          E = "Boolean", b = t.v ? "1" : "0";
          break;
        case "e":
          E = "Error", b = La[t.v];
          break;
        case "d":
          E = "DateTime", b = new Date(t.v).toISOString(), t.z == null && (t.z = t.z || ae[14]);
          break;
        case "s":
          E = "String", b = ((t.v || "") + "").replace(cs, function(T) {
            return ls[T];
          }).replace(us, function(T) {
            return "&#x" + T.charCodeAt(0).toString(16).toUpperCase() + ";";
          });
      }
      return a = za(l.cellXfs, t, l), p["ss:StyleID"] = "s" + (21 + a), p["ss:Index"] = u.c + 1, a = t.v != null ? b : "", a = t.t == "z" ? "" : '<Data ss:Type="' + E + '">' + a + "</Data>", 0 < (t.c || []).length && (a += t.c.map(function(T) {
        var v = it("ss:Data", (T.t || "").replace(/(\r\n|[\r\n])/g, "&#10;"), { xmlns: "http://www.w3.org/TR/REC-html40" });
        return it("Comment", v, { "ss:Author": T.a });
      }).join("")), it("Cell", a, p);
    }
    function RN(t, n) {
      if (!t["!ref"])
        return "";
      var a = lr(t["!ref"]), l = t["!merges"] || [], d = 0, _ = [];
      t["!cols"] && t["!cols"].forEach(function(P, F) {
        $a(P);
        var A = !!P.width, M = Bs(F, P), F = { "ss:Index": F + 1 };
        A && (F["ss:Width"] = Oo(M.width)), P.hidden && (F["ss:Hidden"] = "1"), _.push(it("Column", null, F));
      });
      for (var u, p, m = Array.isArray(t), f = a.s.r; f <= a.e.r; ++f) {
        for (var E = [(u = f, p = (t["!rows"] || [])[f], u = '<Row ss:Index="' + (u + 1) + '"', p && (p.hpt && !p.hpx && (p.hpx = Yi(p.hpt)), p.hpx && (u += ' ss:AutoFitHeight="0" ss:Height="' + p.hpx + '"'), p.hidden && (u += ' ss:Hidden="1"')), u + ">")], b = a.s.c; b <= a.e.c; ++b) {
          for (var T, v, y, R = !1, d = 0; d != l.length; ++d)
            if (!(l[d].s.c > b || l[d].s.r > f || l[d].e.c < b || l[d].e.r < f)) {
              l[d].s.c == b && l[d].s.r == f || (R = !0);
              break;
            }
          R || (v = $t(T = { r: f, c: b }), y = m ? (t[f] || [])[b] : t[v], E.push(CN(y, v, t, n, 0, 0, T)));
        }
        E.push("</Row>"), 2 < E.length && _.push(E.join(""));
      }
      return _.join("");
    }
    function NN(t, n, a) {
      var l = [], _ = a.SheetNames[t], d = a.Sheets[_], _ = d ? function(u, p, m) {
        if (!u || !((m || {}).Workbook || {}).Names)
          return "";
        for (var f = m.Workbook.Names, E = [], b = 0; b < f.length; ++b) {
          var T = f[b];
          T.Sheet == p && (T.Name.match(/^_xlfn\./) || E.push(WE(T)));
        }
        return E.join("");
      }(d, t, a) : "";
      return 0 < _.length && l.push("<Names>" + _ + "</Names>"), 0 < (_ = d ? RN(d, n) : "").length && l.push("<Table>" + _ + "</Table>"), l.push(function(u, p, m) {
        if (!u)
          return "";
        var f = [];
        if (u["!margins"] && (f.push("<PageSetup>"), u["!margins"].header && f.push(it("Header", null, { "x:Margin": u["!margins"].header })), u["!margins"].footer && f.push(it("Footer", null, { "x:Margin": u["!margins"].footer })), f.push(it("PageMargins", null, { "x:Bottom": u["!margins"].bottom || "0.75", "x:Left": u["!margins"].left || "0.7", "x:Right": u["!margins"].right || "0.7", "x:Top": u["!margins"].top || "0.75" })), f.push("</PageSetup>")), m && m.Workbook && m.Workbook.Sheets && m.Workbook.Sheets[p])
          if (m.Workbook.Sheets[p].Hidden)
            f.push(it("Visible", m.Workbook.Sheets[p].Hidden == 1 ? "SheetHidden" : "SheetVeryHidden", {}));
          else {
            for (var E = 0; E < p && (!m.Workbook.Sheets[E] || m.Workbook.Sheets[E].Hidden); ++E)
              ;
            E == p && f.push("<Selected/>");
          }
        return ((((m || {}).Workbook || {}).Views || [])[0] || {}).RTL && f.push("<DisplayRightToLeft/>"), u["!protect"] && (f.push(Rn("ProtectContents", "True")), u["!protect"].objects && f.push(Rn("ProtectObjects", "True")), u["!protect"].scenarios && f.push(Rn("ProtectScenarios", "True")), u["!protect"].selectLockedCells == null || u["!protect"].selectLockedCells ? u["!protect"].selectUnlockedCells == null || u["!protect"].selectUnlockedCells || f.push(Rn("EnableSelection", "UnlockedCells")) : f.push(Rn("EnableSelection", "NoSelection")), [["formatCells", "AllowFormatCells"], ["formatColumns", "AllowSizeCols"], ["formatRows", "AllowSizeRows"], ["insertColumns", "AllowInsertCols"], ["insertRows", "AllowInsertRows"], ["insertHyperlinks", "AllowInsertHyperlinks"], ["deleteColumns", "AllowDeleteCols"], ["deleteRows", "AllowDeleteRows"], ["sort", "AllowSort"], ["autoFilter", "AllowFilter"], ["pivotTables", "AllowUsePivotTables"]].forEach(function(b) {
          u["!protect"][b[0]] && f.push("<" + b[1] + "/>");
        })), f.length == 0 ? "" : it("WorksheetOptions", f.join(""), { xmlns: jn.x });
      }(d, t, a)), l.join("");
    }
    function AN(t, n) {
      n = n || {}, t.SSF || (t.SSF = xr(ae)), t.SSF && (ra(), hr(t.SSF), n.revssf = io(t.SSF), n.revssf[t.SSF[65535]] = 0, n.ssf = t.SSF, n.cellXfs = [], za(n.cellXfs, {}, { revssf: { General: 0 } }));
      var a = [];
      a.push(vN(t, n)), a.push(""), a.push(""), a.push("");
      for (var l, d = 0; d < t.SheetNames.length; ++d)
        a.push(it("Worksheet", NN(d, n, t), { "ss:Name": Ar(t.SheetNames[d]) }));
      return a[2] = (l = ['<Style ss:ID="Default" ss:Name="Normal"><NumberFormat/></Style>'], n.cellXfs.forEach(function(_, u) {
        var p = [];
        p.push(it("NumberFormat", null, { "ss:Format": Ar(ae[_.numFmtId]) })), u = { "ss:ID": "s" + (21 + u) }, l.push(it("Style", p.join(""), u));
      }), it("Styles", l.join(""))), a[3] = function(_) {
        if (!((_ || {}).Workbook || {}).Names)
          return "";
        for (var u = _.Workbook.Names, p = [], m = 0; m < u.length; ++m) {
          var f = u[m];
          f.Sheet == null && (f.Name.match(/^_xlfn\./) || p.push(WE(f)));
        }
        return it("Names", p.join(""));
      }(t), Qr + it("Workbook", a.join(""), { xmlns: jn.ss, "xmlns:o": jn.o, "xmlns:x": jn.x, "xmlns:ss": jn.ss, "xmlns:dt": jn.dt, "xmlns:html": jn.html });
    }
    function ON(t) {
      var n = {}, a = t.content;
      return a.l = 28, n.AnsiUserType = a.read_shift(0, "lpstr-ansi"), n.AnsiClipboardFormat = hf(a, 1), a.length - a.l <= 4 ? n : (t = a.read_shift(4), t == 0 || 40 < t ? n : (a.l -= 4, n.Reserved1 = a.read_shift(0, "lpstr-ansi"), a.length - a.l <= 4 || (t = a.read_shift(4)) !== 1907505652 ? n : (n.UnicodeClipboardFormat = hf(a, 2), (t = a.read_shift(4)) == 0 || 40 < t ? n : (a.l -= 4, void (n.Reserved2 = a.read_shift(0, "lpwstr"))))));
    }
    var yN = [60, 1084, 2066, 2165, 2175];
    function ba(t, n, a) {
      if (t.t !== "z" && t.XF) {
        var l, d = 0;
        try {
          d = t.z || t.XF.numFmtId || 0, n.cellNF && (t.z = ae[d]);
        } catch (_) {
          if (n.WTF)
            throw _;
        }
        if (!n || n.cellText !== !1)
          try {
            t.t === "e" ? t.w = t.w || La[t.v] : d === 0 || d == "General" ? t.t === "n" ? (0 | t.v) === t.v ? t.w = t.v.toString(10) : t.w = Te(t.v) : t.w = Be(t.v) : t.w = dn(d, t.v, { date1904: !!a, dateNF: n && n.dateNF });
          } catch (_) {
            if (n.WTF)
              throw _;
          }
        n.cellDates && d && t.t == "n" && Gt(ae[d] || String(d)) && (l = we(t.v)) && (t.t = "d", t.v = new Date(l.y, l.m - 1, l.d, l.H, l.M, l.S, l.u));
      }
    }
    function Vs(t, n, a) {
      return { v: t, ixfe: n, t: a };
    }
    function IN(t, n) {
      var a = { opts: {} }, l = {};
      function d(Se) {
        return !(Se < 8) && Se < 64 && re[Se - 8] || bo[Se];
      }
      function _(Se, ke, Qe) {
        if (!(1 < je || Qe.sheetRows && Se.r >= Qe.sheetRows)) {
          var At, Et, ct;
          if (Qe.cellStyles && ke.XF && ke.XF.data && (Et = Qe, (ct = (At = ke).XF.data) && ct.patternType && Et && Et.cellStyles && (At.s = {}, At.s.patternType = ct.patternType, (Et = Ao(d(ct.icvFore))) && (At.s.fgColor = { rgb: Et }), (Et = Ao(d(ct.icvBack))) && (At.s.bgColor = { rgb: Et }))), delete ke.ixfe, delete ke.XF, A = $t(u = Se), v && v.s && v.e || (v = { s: { r: 0, c: 0 }, e: { r: 0, c: 0 } }), Se.r < v.s.r && (v.s.r = Se.r), Se.c < v.s.c && (v.s.c = Se.c), Se.r + 1 > v.e.r && (v.e.r = Se.r + 1), Se.c + 1 > v.e.c && (v.e.c = Se.c + 1), Qe.cellFormula && ke.f) {
            for (var vt = 0; vt < F.length; ++vt)
              if (!(F[vt][0].s.c > Se.c || F[vt][0].s.r > Se.r || F[vt][0].e.c < Se.c || F[vt][0].e.r < Se.r)) {
                ke.F = Xt(F[vt][0]), F[vt][0].s.c == Se.c && F[vt][0].s.r == Se.r || delete ke.f, ke.f && (ke.f = "" + Gn(F[vt][1], 0, Se, lt, be));
                break;
              }
          }
          Qe.dense ? (b[Se.r] || (b[Se.r] = []), b[Se.r][Se.c] = ke) : b[A] = ke;
        }
      }
      var u, p, m, f, E, b = n.dense ? [] : {}, T = {}, v = {}, y = null, R = [], P = "", I = {}, A = "", M = {}, F = [], B = [], re = [], me = { Sheets: [], WBProps: { date1904: !1 }, Views: [{}] }, le = {}, be = { enc: !1, sbcch: 0, snames: [], sharedf: M, arrayf: F, rrtabid: [], lastuser: "", biff: 8, codepage: 0, winlocked: 0, cellStyles: !!n && !!n.cellStyles, WTF: !!n && !!n.wtf };
      n.password && (be.password = n.password);
      var Fe = [], Ue = [], Ne = [], ze = [], ut = !1, lt = [];
      lt.SheetNames = be.snames, lt.sharedf = be.sharedf, lt.arrayf = be.arrayf, lt.names = [], lt.XTI = [];
      var et, nt = 0, je = 0, Ye = 0, ht = [], Tt = [];
      be.codepage = 1200, N(1200);
      for (var xt = !1; t.l < t.length - 1; ) {
        var Zt = t.l, ft = t.read_shift(2);
        if (ft === 0 && nt === 10)
          break;
        var We = t.l === t.length ? 0 : t.read_shift(2), Wt = Lc[ft];
        if (Wt && Wt.f) {
          if (n.bookSheets && nt === 133 && ft !== 133)
            break;
          if (nt = ft, Wt.r === 2 || Wt.r == 12) {
            var dr = t.read_shift(2);
            if (We -= 2, !be.enc && dr !== ft && ((255 & dr) << 8 | dr >> 8) !== ft)
              throw new Error("rt mismatch: " + dr + "!=" + ft);
            Wt.r == 12 && (t.l += 10, We -= 10);
          }
          var ir, Or, Zr, oe = {}, oe = ft === 10 ? Wt.f(t, We, be) : function(Se, ke, Qe, At, Et) {
            var ct = At, vt = [], yt = Qe.slice(Qe.l, Qe.l + ct);
            if (Et && Et.enc && Et.enc.insitu && 0 < yt.length)
              switch (Se) {
                case 9:
                case 521:
                case 1033:
                case 2057:
                case 47:
                case 405:
                case 225:
                case 406:
                case 312:
                case 404:
                case 10:
                case 133:
                  break;
                default:
                  Et.enc.insitu(yt);
              }
            vt.push(yt), Qe.l += ct;
            for (var It = wa(Qe, Qe.l), at = Lc[It], Xe = 0; at != null && -1 < yN.indexOf(It); )
              ct = wa(Qe, Qe.l + 2), Xe = Qe.l + 4, It == 2066 ? Xe += 4 : It != 2165 && It != 2175 || (Xe += 12), yt = Qe.slice(Xe, Qe.l + 4 + ct), vt.push(yt), Qe.l += 4 + ct, at = Lc[It = wa(Qe, Qe.l)];
            var Dt = mt(vt);
            Nn(Dt, 0);
            var gt = 0;
            Dt.lens = [];
            for (var tt = 0; tt < vt.length; ++tt)
              Dt.lens.push(gt), gt += vt[tt].length;
            if (Dt.length < At)
              throw "XLS Record 0x" + Se.toString(16) + " Truncated: " + Dt.length + " < " + At;
            return ke.f(Dt, Dt.length, Et);
          }(ft, Wt, t, We, be);
          if (je != 0 || [9, 521, 1033, 2057].indexOf(nt) !== -1)
            switch (ft) {
              case 34:
                a.opts.Date1904 = me.WBProps.date1904 = oe;
                break;
              case 134:
                a.opts.WriteProtect = !0;
                break;
              case 47:
                if (be.enc || (t.l = 0), be.enc = oe, !n.password)
                  throw new Error("File is password-protected");
                if (oe.valid == null)
                  throw new Error("Encryption scheme unsupported");
                if (!oe.valid)
                  throw new Error("Password is incorrect");
                break;
              case 92:
                be.lastuser = oe;
                break;
              case 66:
                var yr = Number(oe);
                switch (yr) {
                  case 21010:
                    yr = 1200;
                    break;
                  case 32768:
                    yr = 1e4;
                    break;
                  case 32769:
                    yr = 1252;
                }
                N(be.codepage = yr), xt = !0;
                break;
              case 317:
                be.rrtabid = oe;
                break;
              case 25:
                be.winlocked = oe;
                break;
              case 439:
                a.opts.RefreshAll = oe;
                break;
              case 12:
                a.opts.CalcCount = oe;
                break;
              case 16:
                a.opts.CalcDelta = oe;
                break;
              case 17:
                a.opts.CalcIter = oe;
                break;
              case 13:
                a.opts.CalcMode = oe;
                break;
              case 14:
                a.opts.CalcPrecision = oe;
                break;
              case 95:
                a.opts.CalcSaveRecalc = oe;
                break;
              case 15:
                be.CalcRefMode = oe;
                break;
              case 2211:
                a.opts.FullCalc = oe;
                break;
              case 129:
                oe.fDialog && (b["!type"] = "dialog"), oe.fBelow || ((b["!outline"] || (b["!outline"] = {})).above = !0), oe.fRight || ((b["!outline"] || (b["!outline"] = {})).left = !0);
                break;
              case 224:
                B.push(oe);
                break;
              case 430:
                lt.push([oe]), lt[lt.length - 1].XTI = [];
                break;
              case 35:
              case 547:
                lt[lt.length - 1].push(oe);
                break;
              case 24:
              case 536:
                et = { Name: oe.Name, Ref: Gn(oe.rgce, 0, null, lt, be) }, 0 < oe.itab && (et.Sheet = oe.itab - 1), lt.names.push(et), lt[0] || (lt[0] = [], lt[0].XTI = []), lt[lt.length - 1].push(oe), oe.Name == "_xlnm._FilterDatabase" && 0 < oe.itab && oe.rgce && oe.rgce[0] && oe.rgce[0][0] && oe.rgce[0][0][0] == "PtgArea3d" && (Tt[oe.itab - 1] = { ref: Xt(oe.rgce[0][0][1][2]) });
                break;
              case 22:
                be.ExternCount = oe;
                break;
              case 23:
                lt.length == 0 && (lt[0] = [], lt[0].XTI = []), lt[lt.length - 1].XTI = lt[lt.length - 1].XTI.concat(oe), lt.XTI = lt.XTI.concat(oe);
                break;
              case 2196:
                if (be.biff < 8)
                  break;
                et != null && (et.Comment = oe[1]);
                break;
              case 18:
                b["!protect"] = oe;
                break;
              case 19:
                oe !== 0 && be.WTF && console.error("Password verifier: " + oe);
                break;
              case 133:
                T[oe.pos] = oe, be.snames.push(oe.name);
                break;
              case 10:
                if (--je)
                  break;
                v.e && (0 < v.e.r && 0 < v.e.c && (v.e.r--, v.e.c--, b["!ref"] = Xt(v), n.sheetRows && n.sheetRows <= v.e.r && (Rr = v.e.r, v.e.r = n.sheetRows - 1, b["!fullref"] = b["!ref"], b["!ref"] = Xt(v), v.e.r = Rr), v.e.r++, v.e.c++), 0 < Fe.length && (b["!merges"] = Fe), 0 < Ue.length && (b["!objects"] = Ue), 0 < Ne.length && (b["!cols"] = Ne), 0 < ze.length && (b["!rows"] = ze), me.Sheets.push(le)), P === "" ? I = b : l[P] = b, b = n.dense ? [] : {};
                break;
              case 9:
              case 521:
              case 1033:
              case 2057:
                if (be.biff === 8 && (be.biff = { 9: 2, 521: 3, 1033: 4 }[ft] || { 512: 2, 768: 3, 1024: 4, 1280: 5, 1536: 8, 2: 2, 7: 2 }[oe.BIFFVer] || 8), be.biffguess = oe.BIFFVer == 0, oe.BIFFVer == 0 && oe.dt == 4096 && (be.biff = 5, xt = !0, N(be.codepage = 28591)), be.biff == 8 && oe.BIFFVer == 0 && oe.dt == 16 && (be.biff = 2), je++)
                  break;
                var Rr, b = n.dense ? [] : {};
                be.biff < 8 && !xt && (xt = !0, N(be.codepage = n.codepage || 1252)), be.biff < 5 || oe.BIFFVer == 0 && oe.dt == 4096 ? (P === "" && (P = "Sheet1"), v = { s: { r: 0, c: 0 }, e: { r: 0, c: 0 } }, Rr = { pos: t.l - We, name: P }, T[Rr.pos] = Rr, be.snames.push(P)) : P = (T[Zt] || { name: "" }).name, oe.dt == 32 && (b["!type"] = "chart"), oe.dt == 64 && (b["!type"] = "macro"), Fe = [], Ue = [], be.arrayf = F = [], Ne = [], ut = !(ze = []), le = { Hidden: (T[Zt] || { hs: 0 }).hs, name: P };
                break;
              case 515:
              case 3:
              case 2:
                b["!type"] == "chart" && (n.dense ? (b[oe.r] || [])[oe.c] : b[$t({ c: oe.c, r: oe.r })]) && ++oe.c, q = { ixfe: oe.ixfe, XF: B[oe.ixfe] || {}, v: oe.val, t: "n" }, 0 < Ye && (q.z = ht[q.ixfe >> 8 & 63]), ba(q, n, a.opts.Date1904), _({ c: oe.c, r: oe.r }, q, n);
                break;
              case 5:
              case 517:
                q = { ixfe: oe.ixfe, XF: B[oe.ixfe], v: oe.val, t: oe.t }, 0 < Ye && (q.z = ht[q.ixfe >> 8 & 63]), ba(q, n, a.opts.Date1904), _({ c: oe.c, r: oe.r }, q, n);
                break;
              case 638:
                q = { ixfe: oe.ixfe, XF: B[oe.ixfe], v: oe.rknum, t: "n" }, 0 < Ye && (q.z = ht[q.ixfe >> 8 & 63]), ba(q, n, a.opts.Date1904), _({ c: oe.c, r: oe.r }, q, n);
                break;
              case 189:
                for (var _n = oe.c; _n <= oe.C; ++_n) {
                  var da = oe.rkrec[_n - oe.c][0], q = { ixfe: da, XF: B[da], v: oe.rkrec[_n - oe.c][1], t: "n" };
                  0 < Ye && (q.z = ht[q.ixfe >> 8 & 63]), ba(q, n, a.opts.Date1904), _({ c: _n, r: oe.r }, q, n);
                }
                break;
              case 6:
              case 518:
              case 1030:
                if (oe.val == "String") {
                  y = oe;
                  break;
                }
                (q = Vs(oe.val, oe.cell.ixfe, oe.tt)).XF = B[q.ixfe], n.cellFormula && (!((Ie = oe.formula) && Ie[0] && Ie[0][0] && Ie[0][0][0] == "PtgExp") || M[Zr = $t({ r: ir = Ie[0][0][1][0], c: Or = Ie[0][0][1][1] })] ? q.f = "" + Gn(oe.formula, 0, oe.cell, lt, be) : q.F = ((n.dense ? (b[ir] || [])[Or] : b[Zr]) || {}).F), 0 < Ye && (q.z = ht[q.ixfe >> 8 & 63]), ba(q, n, a.opts.Date1904), _(oe.cell, q, n), y = oe;
                break;
              case 7:
              case 519:
                if (!y)
                  throw new Error("String record expects Formula");
                (q = Vs(y.val = oe, y.cell.ixfe, "s")).XF = B[q.ixfe], n.cellFormula && (q.f = "" + Gn(y.formula, 0, y.cell, lt, be)), 0 < Ye && (q.z = ht[q.ixfe >> 8 & 63]), ba(q, n, a.opts.Date1904), _(y.cell, q, n), y = null;
                break;
              case 33:
              case 545:
                F.push(oe);
                var Ie = $t(oe[0].s), te = n.dense ? (b[oe[0].s.r] || [])[oe[0].s.c] : b[Ie];
                if (n.cellFormula && te) {
                  if (!y || !Ie || !te)
                    break;
                  te.f = "" + Gn(oe[1], 0, oe[0], lt, be), te.F = Xt(oe[0]);
                }
                break;
              case 1212:
                if (!n.cellFormula)
                  break;
                if (A) {
                  if (!y)
                    break;
                  M[$t(y.cell)] = oe[0], ((te = n.dense ? (b[y.cell.r] || [])[y.cell.c] : b[$t(y.cell)]) || {}).f = "" + Gn(oe[0], 0, u, lt, be);
                }
                break;
              case 253:
                q = Vs(R[oe.isst].t, oe.ixfe, "s"), R[oe.isst].h && (q.h = R[oe.isst].h), q.XF = B[q.ixfe], 0 < Ye && (q.z = ht[q.ixfe >> 8 & 63]), ba(q, n, a.opts.Date1904), _({ c: oe.c, r: oe.r }, q, n);
                break;
              case 513:
                n.sheetStubs && (q = { ixfe: oe.ixfe, XF: B[oe.ixfe], t: "z" }, 0 < Ye && (q.z = ht[q.ixfe >> 8 & 63]), ba(q, n, a.opts.Date1904), _({ c: oe.c, r: oe.r }, q, n));
                break;
              case 190:
                if (n.sheetStubs)
                  for (var ve = oe.c; ve <= oe.C; ++ve) {
                    var ee = oe.ixfe[ve - oe.c];
                    q = { ixfe: ee, XF: B[ee], t: "z" }, 0 < Ye && (q.z = ht[q.ixfe >> 8 & 63]), ba(q, n, a.opts.Date1904), _({ c: ve, r: oe.r }, q, n);
                  }
                break;
              case 214:
              case 516:
              case 4:
                (q = Vs(oe.val, oe.ixfe, "s")).XF = B[q.ixfe], 0 < Ye && (q.z = ht[q.ixfe >> 8 & 63]), ba(q, n, a.opts.Date1904), _({ c: oe.c, r: oe.r }, q, n);
                break;
              case 0:
              case 512:
                je === 1 && (v = oe);
                break;
              case 252:
                R = oe;
                break;
              case 1054:
                if (be.biff == 4) {
                  ht[Ye++] = oe[1];
                  for (var $e = 0; $e < Ye + 163 && ae[$e] != oe[1]; ++$e)
                    ;
                  163 <= $e && Qn(oe[1], Ye + 163);
                } else
                  Qn(oe[1], oe[0]);
                break;
              case 30:
                ht[Ye++] = oe;
                for (var Ce = 0; Ce < Ye + 163 && ae[Ce] != oe; ++Ce)
                  ;
                163 <= Ce && Qn(oe, Ye + 163);
                break;
              case 229:
                Fe = Fe.concat(oe);
                break;
              case 93:
                Ue[oe.cmo[0]] = be.lastobj = oe;
                break;
              case 438:
                be.lastobj.TxO = oe;
                break;
              case 127:
                be.lastobj.ImData = oe;
                break;
              case 440:
                for (m = oe[0].s.r; m <= oe[0].e.r; ++m)
                  for (p = oe[0].s.c; p <= oe[0].e.c; ++p)
                    (te = n.dense ? (b[m] || [])[p] : b[$t({ c: p, r: m })]) && (te.l = oe[1]);
                break;
              case 2048:
                for (m = oe[0].s.r; m <= oe[0].e.r; ++m)
                  for (p = oe[0].s.c; p <= oe[0].e.c; ++p)
                    (te = n.dense ? (b[m] || [])[p] : b[$t({ c: p, r: m })]) && te.l && (te.l.Tooltip = oe[1]);
                break;
              case 28:
                if (be.biff <= 5 && 2 <= be.biff)
                  break;
                te = n.dense ? (b[oe[0].r] || [])[oe[0].c] : b[$t(oe[0])];
                var xe = Ue[oe[2]];
                te || (te = n.dense ? (b[oe[0].r] || (b[oe[0].r] = []), b[oe[0].r][oe[0].c] = { t: "z" }) : b[$t(oe[0])] = { t: "z" }, v.e.r = Math.max(v.e.r, oe[0].r), v.s.r = Math.min(v.s.r, oe[0].r), v.e.c = Math.max(v.e.c, oe[0].c), v.s.c = Math.min(v.s.c, oe[0].c)), te.c || (te.c = []), xe = { a: oe[1], t: xe.TxO.t }, te.c.push(xe);
                break;
              case 2173:
                B[oe.ixfe], oe.ext.forEach(function(ke) {
                  ke[0];
                });
                break;
              case 125:
                if (!be.cellStyles)
                  break;
                for (; oe.e >= oe.s; )
                  Ne[oe.e--] = { width: oe.w / 256, level: oe.level || 0, hidden: !!(1 & oe.flags) }, ut || (ut = !0, bc(oe.w / 256)), $a(Ne[oe.e + 1]);
                break;
              case 520:
                xe = {}, oe.level != null && ((ze[oe.r] = xe).level = oe.level), oe.hidden && ((ze[oe.r] = xe).hidden = !0), oe.hpt && ((ze[oe.r] = xe).hpt = oe.hpt, xe.hpx = Yi(oe.hpt));
                break;
              case 38:
              case 39:
              case 40:
              case 41:
                b["!margins"] || fi(b["!margins"] = {}), b["!margins"][{ 38: "left", 39: "right", 40: "top", 41: "bottom" }[ft]] = oe;
                break;
              case 161:
                b["!margins"] || fi(b["!margins"] = {}), b["!margins"].header = oe.header, b["!margins"].footer = oe.footer;
                break;
              case 574:
                oe.RTL && (me.Views[0].RTL = !0);
                break;
              case 146:
                re = oe;
                break;
              case 2198:
                E = oe;
                break;
              case 140:
                f = oe;
                break;
              case 442:
                P ? le.CodeName = oe || le.name : me.WBProps.CodeName = oe || "ThisWorkbook";
            }
        } else
          Wt || console.error("Missing Info for XLS Record 0x" + ft.toString(16)), t.l += We;
      }
      return a.SheetNames = $r(T).sort(function(Se, ke) {
        return Number(Se) - Number(ke);
      }).map(function(Se) {
        return T[Se].name;
      }), n.bookSheets || (a.Sheets = l), !a.SheetNames.length && I["!ref"] ? (a.SheetNames.push("Sheet1"), a.Sheets && (a.Sheets.Sheet1 = I)) : a.Preamble = I, a.Sheets && Tt.forEach(function(Se, ke) {
        a.Sheets[a.SheetNames[ke]]["!autofilter"] = Se;
      }), a.Strings = R, a.SSF = xr(ae), be.enc && (a.Encryption = be.enc), E && (a.Themes = E), a.Metadata = {}, f !== void 0 && (a.Metadata.Country = f), 0 < lt.names.length && (me.Names = lt.names), a.Workbook = me, a;
    }
    var Uo = { SI: "e0859ff2f94f6810ab9108002b27b3d9", DSI: "02d5cdd59c2e1b10939708002b2cf9ae", UDI: "05d5cdd59c2e1b10939708002b2cf9ae" };
    function Ys(t, n) {
      var a, l, d, _, u;
      if (Uc(n = n || {}), D(), n.codepage && O(n.codepage), t.FullPaths) {
        if (Lt.find(t, "/encryption"))
          throw new Error("File is password-protected");
        a = Lt.find(t, "!CompObj"), d = Lt.find(t, "/Workbook") || Lt.find(t, "/Book");
      } else {
        switch (n.type) {
          case "base64":
            t = Pe(H(t));
            break;
          case "binary":
            t = Pe(t);
            break;
          case "buffer":
            break;
          case "array":
            Array.isArray(t) || (t = Array.prototype.slice.call(t));
        }
        Nn(t, 0), d = { content: t };
      }
      if (a && ON(a), n.bookProps && !n.bookSheets)
        l = {};
      else {
        var p = K ? "buffer" : "array";
        if (d && d.content)
          l = IN(d.content, n);
        else if ((d = Lt.find(t, "PerfectOffice_MAIN")) && d.content)
          l = mi.to_workbook(d.content, (n.type = p, n));
        else {
          if (!(d = Lt.find(t, "NativeContent_MAIN")) || !d.content)
            throw (d = Lt.find(t, "MN0")) && d.content ? new Error("Unsupported Works 4 for Mac file") : new Error("Cannot find Workbook stream");
          l = mi.to_workbook(d.content, (n.type = p, n));
        }
        n.bookVBA && t.FullPaths && Lt.find(t, "/_VBA_PROJECT_CUR/VBA/dir") && (l.vbaraw = (_ = t, u = Lt.utils.cfb_new({ root: "R" }), _.FullPaths.forEach(function(m, f) {
          m.slice(-1) !== "/" && m.match(/_VBA_PROJECT_CUR/) && (m = m.replace(/^[^\/]*/, "R").replace(/\/_VBA_PROJECT_CUR\u0000*/, ""), Lt.utils.cfb_add(u, m, _.FileIndex[f].content));
        }), Lt.write(u)));
      }
      return p = {}, t.FullPaths && function(m, f, E) {
        var b = Lt.find(m, "/!DocumentSummaryInformation");
        if (b && 0 < b.size)
          try {
            var T, v = Hf(b, tc, Uo.DSI);
            for (T in v)
              f[T] = v[T];
          } catch (I) {
            if (E.WTF)
              throw I;
          }
        var y = Lt.find(m, "/!SummaryInformation");
        if (y && 0 < y.size)
          try {
            var R, P = Hf(y, rc, Uo.SI);
            for (R in P)
              f[R] == null && (f[R] = P[R]);
          } catch (I) {
            if (E.WTF)
              throw I;
          }
        f.HeadingPairs && f.TitlesOfParts && (If(f.HeadingPairs, f.TitlesOfParts, f, E), delete f.HeadingPairs, delete f.TitlesOfParts);
      }(t, p, n), l.Props = l.Custprops = p, n.bookFiles && (l.cfb = t), l;
    }
    function DN(t, _) {
      var a, l, d = _ || {}, _ = Lt.utils.cfb_new({ root: "R" }), u = "/Workbook";
      switch (d.bookType || "xls") {
        case "xls":
          d.bookType = "biff8";
        case "xla":
          d.bookType || (d.bookType = "xla");
        case "biff8":
          u = "/Workbook", d.biff = 8;
          break;
        case "biff5":
          u = "/Book", d.biff = 5;
          break;
        default:
          throw new Error("invalid type " + d.bookType + " for XLS CFB");
      }
      return Lt.utils.cfb_add(_, u, zE(t, d)), d.biff == 8 && (t.Props || t.Custprops) && function(p, m) {
        var f, E = [], b = [], T = [], v = 0, y = Al(tc, "n"), R = Al(rc, "n");
        if (p.Props)
          for (f = $r(p.Props), v = 0; v < f.length; ++v)
            (Object.prototype.hasOwnProperty.call(y, f[v]) ? E : Object.prototype.hasOwnProperty.call(R, f[v]) ? b : T).push([f[v], p.Props[f[v]]]);
        if (p.Custprops)
          for (f = $r(p.Custprops), v = 0; v < f.length; ++v)
            Object.prototype.hasOwnProperty.call(p.Props || {}, f[v]) || (Object.prototype.hasOwnProperty.call(y, f[v]) ? E : Object.prototype.hasOwnProperty.call(R, f[v]) ? b : T).push([f[v], p.Custprops[f[v]]]);
        for (var P = [], v = 0; v < T.length; ++v)
          -1 < Vf.indexOf(T[v][0]) || -1 < yf.indexOf(T[v][0]) || T[v][1] != null && P.push(T[v]);
        b.length && Lt.utils.cfb_add(m, "/SummaryInformation", qf(b, Uo.SI, R, rc)), (E.length || P.length) && Lt.utils.cfb_add(m, "/DocumentSummaryInformation", qf(E, Uo.DSI, y, tc, P.length ? P : null, Uo.UDI));
      }(t, _), d.biff == 8 && t.vbaraw && (a = _, (l = Lt.read(t.vbaraw, { type: typeof t.vbaraw == "string" ? "binary" : "buffer" })).FullPaths.forEach(function(p, m) {
        m == 0 || (p = p.replace(/[^\/]*[\/]/, "/_VBA_PROJECT_CUR/")).slice(-1) !== "/" && Lt.utils.cfb_add(a, p, l.FileIndex[m].content);
      })), _;
    }
    var Bo = { 0: { f: function(t, n) {
      var a = {}, l = t.l + n;
      a.r = t.read_shift(4), t.l += 4;
      var d = t.read_shift(2);
      return t.l += 1, n = t.read_shift(1), t.l = l, 7 & n && (a.level = 7 & n), 16 & n && (a.hidden = !0), 32 & n && (a.hpt = d / 20), a;
    } }, 1: { f: function(t) {
      return [aa(t)];
    } }, 2: { f: function(t) {
      return [aa(t), Jl(t), "n"];
    } }, 3: { f: function(t) {
      return [aa(t), t.read_shift(1), "e"];
    } }, 4: { f: function(t) {
      return [aa(t), t.read_shift(1), "b"];
    } }, 5: { f: function(t) {
      return [aa(t), wn(t), "n"];
    } }, 6: { f: function(t) {
      return [aa(t), Dn(t), "str"];
    } }, 7: { f: function(t) {
      return [aa(t), t.read_shift(4), "s"];
    } }, 8: { f: function(t, n, a) {
      var l = t.l + n, d = aa(t);
      d.r = a["!row"];
      var _ = [d, Dn(t), "str"];
      return a.cellFormula ? (t.l += 2, n = Us(t, l - t.l, a), _[3] = Gn(n, 0, d, a.supbooks, a)) : t.l = l, _;
    } }, 9: { f: function(t, n, a) {
      var l = t.l + n, d = aa(t);
      d.r = a["!row"];
      var _ = [d, wn(t), "n"];
      return a.cellFormula ? (t.l += 2, n = Us(t, l - t.l, a), _[3] = Gn(n, 0, d, a.supbooks, a)) : t.l = l, _;
    } }, 10: { f: function(t, n, a) {
      var l = t.l + n, d = aa(t);
      d.r = a["!row"];
      var _ = [d, t.read_shift(1), "b"];
      return a.cellFormula ? (t.l += 2, n = Us(t, l - t.l, a), _[3] = Gn(n, 0, d, a.supbooks, a)) : t.l = l, _;
    } }, 11: { f: function(t, n, a) {
      var l = t.l + n, d = aa(t);
      d.r = a["!row"];
      var _ = [d, t.read_shift(1), "e"];
      return a.cellFormula ? (t.l += 2, n = Us(t, l - t.l, a), _[3] = Gn(n, 0, d, a.supbooks, a)) : t.l = l, _;
    } }, 12: { f: function(t) {
      return [si(t)];
    } }, 13: { f: function(t) {
      return [si(t), Jl(t), "n"];
    } }, 14: { f: function(t) {
      return [si(t), t.read_shift(1), "e"];
    } }, 15: { f: function(t) {
      return [si(t), t.read_shift(1), "b"];
    } }, 16: { f: kE }, 17: { f: function(t) {
      return [si(t), Dn(t), "str"];
    } }, 18: { f: function(t) {
      return [si(t), t.read_shift(4), "s"];
    } }, 19: { f: Ql }, 20: {}, 21: {}, 22: {}, 23: {}, 24: {}, 25: {}, 26: {}, 27: {}, 28: {}, 29: {}, 30: {}, 31: {}, 32: {}, 33: {}, 34: {}, 35: { T: 1 }, 36: { T: -1 }, 37: { T: 1 }, 38: { T: -1 }, 39: { f: function(t, u, p) {
      var l = t.l + u;
      t.l += 4, t.l += 1;
      var d = t.read_shift(4), _ = lC(t), u = AR(t, 0, p), p = Xl(t);
      return t.l = l, u = { Name: _, Ptg: u }, d < 268435455 && (u.Sheet = d), p && (u.Comment = p), u;
    } }, 40: {}, 42: {}, 43: { f: function(t, n, a) {
      var l = {};
      l.sz = t.read_shift(2) / 20;
      var d, _ = (_ = (d = t).read_shift(1), d.l++, { fBold: 1 & _, fItalic: 2 & _, fUnderline: 4 & _, fStrikeout: 8 & _, fOutline: 16 & _, fShadow: 32 & _, fCondense: 64 & _, fExtend: 128 & _ });
      switch (_.fItalic && (l.italic = 1), _.fCondense && (l.condense = 1), _.fExtend && (l.extend = 1), _.fShadow && (l.shadow = 1), _.fOutline && (l.outline = 1), _.fStrikeout && (l.strike = 1), t.read_shift(2) === 700 && (l.bold = 1), t.read_shift(2)) {
        case 1:
          l.vertAlign = "superscript";
          break;
        case 2:
          l.vertAlign = "subscript";
      }
      switch ((_ = t.read_shift(1)) != 0 && (l.underline = _), 0 < (_ = t.read_shift(1)) && (l.family = _), 0 < (_ = t.read_shift(1)) && (l.charset = _), t.l++, l.color = function(u) {
        var p = {}, m = u.read_shift(1) >>> 1, f = u.read_shift(1), E = u.read_shift(2, "i"), b = u.read_shift(1), T = u.read_shift(1), v = u.read_shift(1);
        switch (u.l++, m) {
          case 0:
            p.auto = 1;
            break;
          case 1:
            p.index = f;
            var y = bo[f];
            y && (p.rgb = Ao(y));
            break;
          case 2:
            p.rgb = Ao([b, T, v]);
            break;
          case 3:
            p.theme = f;
        }
        return E != 0 && (p.tint = 0 < E ? E / 32767 : E / 32768), p;
      }(t), t.read_shift(1)) {
        case 1:
          l.scheme = "major";
          break;
        case 2:
          l.scheme = "minor";
      }
      return l.name = Dn(t), l;
    } }, 44: { f: function(t, n) {
      return [t.read_shift(2), Dn(t)];
    } }, 45: { f: ZC }, 46: { f: so }, 47: { f: function(t, d) {
      var a = t.l + d, l = t.read_shift(2), d = t.read_shift(2);
      return t.l = a, { ixfe: l, numFmtId: d };
    } }, 48: {}, 49: { f: function(t) {
      return t.read_shift(4, "i");
    } }, 50: {}, 51: { f: function(t) {
      for (var n = [], a = t.read_shift(4); 0 < a--; )
        n.push([t.read_shift(4), t.read_shift(4)]);
      return n;
    } }, 52: { T: 1 }, 53: { T: -1 }, 54: { T: 1 }, 55: { T: -1 }, 56: { T: 1 }, 57: { T: -1 }, 58: {}, 59: {}, 60: { f: dg }, 62: { f: function(t) {
      return [aa(t), Ql(t), "is"];
    } }, 63: { f: function(t) {
      var n = {};
      n.i = t.read_shift(4);
      var a = {};
      return a.r = t.read_shift(4), a.c = t.read_shift(4), n.r = $t(a), 2 & (t = t.read_shift(1)) && (n.l = "1"), 8 & t && (n.a = "1"), n;
    } }, 64: { f: function() {
    } }, 65: {}, 66: {}, 67: {}, 68: {}, 69: {}, 70: {}, 128: {}, 129: { T: 1 }, 130: { T: -1 }, 131: { T: 1, f: In, p: 0 }, 132: { T: -1 }, 133: { T: 1 }, 134: { T: -1 }, 135: { T: 1 }, 136: { T: -1 }, 137: { T: 1, f: function(t) {
      var n = t.read_shift(2);
      return t.l += 28, { RTL: 32 & n };
    } }, 138: { T: -1 }, 139: { T: 1 }, 140: { T: -1 }, 141: { T: 1 }, 142: { T: -1 }, 143: { T: 1 }, 144: { T: -1 }, 145: { T: 1 }, 146: { T: -1 }, 147: { f: function(t, n) {
      var a = {}, l = t[t.l];
      return ++t.l, a.above = !(64 & l), a.left = !(128 & l), t.l += 18, a.name = sC(t), a;
    } }, 148: { f: Gs, p: 16 }, 151: { f: function() {
    } }, 152: {}, 153: { f: function(t, n) {
      var a = {}, l = t.read_shift(4);
      return a.defaultThemeVersion = t.read_shift(4), 0 < (t = 8 < n ? Dn(t) : "").length && (a.CodeName = t), a.autoCompressPictures = !!(65536 & l), a.backupFile = !!(64 & l), a.checkCompatibility = !!(4096 & l), a.date1904 = !!(1 & l), a.filterPrivacy = !!(8 & l), a.hidePivotFieldList = !!(1024 & l), a.promptedSolutions = !!(16 & l), a.publishItems = !!(2048 & l), a.refreshAllConnections = !!(262144 & l), a.saveExternalLinkValues = !!(128 & l), a.showBorderUnselectedTables = !!(4 & l), a.showInkAnnotation = !!(32 & l), a.showObjects = ["all", "placeholders", "none"][l >> 13 & 3], a.showPivotChartFilter = !!(32768 & l), a.updateLinks = ["userSet", "never", "always"][l >> 8 & 3], a;
    } }, 154: {}, 155: {}, 156: { f: function(t, n) {
      var a = {};
      return a.Hidden = t.read_shift(4), a.iTabID = t.read_shift(4), a.strRelID = Zl(t), a.name = Dn(t), a;
    } }, 157: {}, 158: {}, 159: { T: 1, f: function(t) {
      return [t.read_shift(4), t.read_shift(4)];
    } }, 160: { T: -1 }, 161: { T: 1, f: ci }, 162: { T: -1 }, 163: { T: 1 }, 164: { T: -1 }, 165: { T: 1 }, 166: { T: -1 }, 167: {}, 168: {}, 169: {}, 170: {}, 171: {}, 172: { T: 1 }, 173: { T: -1 }, 174: {}, 175: {}, 176: { f: Wi }, 177: { T: 1 }, 178: { T: -1 }, 179: { T: 1 }, 180: { T: -1 }, 181: { T: 1 }, 182: { T: -1 }, 183: { T: 1 }, 184: { T: -1 }, 185: { T: 1 }, 186: { T: -1 }, 187: { T: 1 }, 188: { T: -1 }, 189: { T: 1 }, 190: { T: -1 }, 191: { T: 1 }, 192: { T: -1 }, 193: { T: 1 }, 194: { T: -1 }, 195: { T: 1 }, 196: { T: -1 }, 197: { T: 1 }, 198: { T: -1 }, 199: { T: 1 }, 200: { T: -1 }, 201: { T: 1 }, 202: { T: -1 }, 203: { T: 1 }, 204: { T: -1 }, 205: { T: 1 }, 206: { T: -1 }, 207: { T: 1 }, 208: { T: -1 }, 209: { T: 1 }, 210: { T: -1 }, 211: { T: 1 }, 212: { T: -1 }, 213: { T: 1 }, 214: { T: -1 }, 215: { T: 1 }, 216: { T: -1 }, 217: { T: 1 }, 218: { T: -1 }, 219: { T: 1 }, 220: { T: -1 }, 221: { T: 1 }, 222: { T: -1 }, 223: { T: 1 }, 224: { T: -1 }, 225: { T: 1 }, 226: { T: -1 }, 227: { T: 1 }, 228: { T: -1 }, 229: { T: 1 }, 230: { T: -1 }, 231: { T: 1 }, 232: { T: -1 }, 233: { T: 1 }, 234: { T: -1 }, 235: { T: 1 }, 236: { T: -1 }, 237: { T: 1 }, 238: { T: -1 }, 239: { T: 1 }, 240: { T: -1 }, 241: { T: 1 }, 242: { T: -1 }, 243: { T: 1 }, 244: { T: -1 }, 245: { T: 1 }, 246: { T: -1 }, 247: { T: 1 }, 248: { T: -1 }, 249: { T: 1 }, 250: { T: -1 }, 251: { T: 1 }, 252: { T: -1 }, 253: { T: 1 }, 254: { T: -1 }, 255: { T: 1 }, 256: { T: -1 }, 257: { T: 1 }, 258: { T: -1 }, 259: { T: 1 }, 260: { T: -1 }, 261: { T: 1 }, 262: { T: -1 }, 263: { T: 1 }, 264: { T: -1 }, 265: { T: 1 }, 266: { T: -1 }, 267: { T: 1 }, 268: { T: -1 }, 269: { T: 1 }, 270: { T: -1 }, 271: { T: 1 }, 272: { T: -1 }, 273: { T: 1 }, 274: { T: -1 }, 275: { T: 1 }, 276: { T: -1 }, 277: {}, 278: { T: 1 }, 279: { T: -1 }, 280: { T: 1 }, 281: { T: -1 }, 282: { T: 1 }, 283: { T: 1 }, 284: { T: -1 }, 285: { T: 1 }, 286: { T: -1 }, 287: { T: 1 }, 288: { T: -1 }, 289: { T: 1 }, 290: { T: -1 }, 291: { T: 1 }, 292: { T: -1 }, 293: { T: 1 }, 294: { T: -1 }, 295: { T: 1 }, 296: { T: -1 }, 297: { T: 1 }, 298: { T: -1 }, 299: { T: 1 }, 300: { T: -1 }, 301: { T: 1 }, 302: { T: -1 }, 303: { T: 1 }, 304: { T: -1 }, 305: { T: 1 }, 306: { T: -1 }, 307: { T: 1 }, 308: { T: -1 }, 309: { T: 1 }, 310: { T: -1 }, 311: { T: 1 }, 312: { T: -1 }, 313: { T: -1 }, 314: { T: 1 }, 315: { T: -1 }, 316: { T: 1 }, 317: { T: -1 }, 318: { T: 1 }, 319: { T: -1 }, 320: { T: 1 }, 321: { T: -1 }, 322: { T: 1 }, 323: { T: -1 }, 324: { T: 1 }, 325: { T: -1 }, 326: { T: 1 }, 327: { T: -1 }, 328: { T: 1 }, 329: { T: -1 }, 330: { T: 1 }, 331: { T: -1 }, 332: { T: 1 }, 333: { T: -1 }, 334: { T: 1 }, 335: { f: function(t, n) {
      return { flags: t.read_shift(4), version: t.read_shift(4), name: Dn(t) };
    } }, 336: { T: -1 }, 337: { f: function(t) {
      return t.l += 4, t.read_shift(4) != 0;
    }, T: 1 }, 338: { T: -1 }, 339: { T: 1 }, 340: { T: -1 }, 341: { T: 1 }, 342: { T: -1 }, 343: { T: 1 }, 344: { T: -1 }, 345: { T: 1 }, 346: { T: -1 }, 347: { T: 1 }, 348: { T: -1 }, 349: { T: 1 }, 350: { T: -1 }, 351: {}, 352: {}, 353: { T: 1 }, 354: { T: -1 }, 355: { f: Zl }, 357: {}, 358: {}, 359: {}, 360: { T: 1 }, 361: {}, 362: { f: lg }, 363: {}, 364: {}, 366: {}, 367: {}, 368: {}, 369: {}, 370: {}, 371: {}, 372: { T: 1 }, 373: { T: -1 }, 374: { T: 1 }, 375: { T: -1 }, 376: { T: 1 }, 377: { T: -1 }, 378: { T: 1 }, 379: { T: -1 }, 380: { T: 1 }, 381: { T: -1 }, 382: { T: 1 }, 383: { T: -1 }, 384: { T: 1 }, 385: { T: -1 }, 386: { T: 1 }, 387: { T: -1 }, 388: { T: 1 }, 389: { T: -1 }, 390: { T: 1 }, 391: { T: -1 }, 392: { T: 1 }, 393: { T: -1 }, 394: { T: 1 }, 395: { T: -1 }, 396: {}, 397: {}, 398: {}, 399: {}, 400: {}, 401: { T: 1 }, 403: {}, 404: {}, 405: {}, 406: {}, 407: {}, 408: {}, 409: {}, 410: {}, 411: {}, 412: {}, 413: {}, 414: {}, 415: {}, 416: {}, 417: {}, 418: {}, 419: {}, 420: {}, 421: {}, 422: { T: 1 }, 423: { T: 1 }, 424: { T: -1 }, 425: { T: -1 }, 426: { f: function(t, _, a) {
      var l = t.l + _, d = Ef(t), _ = t.read_shift(1);
      return (d = [d])[2] = _, a.cellFormula ? (a = NR(t, l - t.l, a), d[1] = a) : t.l = l, d;
    } }, 427: { f: function(t, d, a) {
      var l = t.l + d, d = [ci(t)];
      return a.cellFormula && (a = OR(t, l - t.l, a), d[1] = a), t.l = l, d;
    } }, 428: {}, 429: { T: 1 }, 430: { T: -1 }, 431: { T: 1 }, 432: { T: -1 }, 433: { T: 1 }, 434: { T: -1 }, 435: { T: 1 }, 436: { T: -1 }, 437: { T: 1 }, 438: { T: -1 }, 439: { T: 1 }, 440: { T: -1 }, 441: { T: 1 }, 442: { T: -1 }, 443: { T: 1 }, 444: { T: -1 }, 445: { T: 1 }, 446: { T: -1 }, 447: { T: 1 }, 448: { T: -1 }, 449: { T: 1 }, 450: { T: -1 }, 451: { T: 1 }, 452: { T: -1 }, 453: { T: 1 }, 454: { T: -1 }, 455: { T: 1 }, 456: { T: -1 }, 457: { T: 1 }, 458: { T: -1 }, 459: { T: 1 }, 460: { T: -1 }, 461: { T: 1 }, 462: { T: -1 }, 463: { T: 1 }, 464: { T: -1 }, 465: { T: 1 }, 466: { T: -1 }, 467: { T: 1 }, 468: { T: -1 }, 469: { T: 1 }, 470: { T: -1 }, 471: {}, 472: {}, 473: { T: 1 }, 474: { T: -1 }, 475: {}, 476: { f: function(t) {
      var n = {};
      return FE.forEach(function(a) {
        n[a] = wn(t);
      }), n;
    } }, 477: {}, 478: {}, 479: { T: 1 }, 480: { T: -1 }, 481: { T: 1 }, 482: { T: -1 }, 483: { T: 1 }, 484: { T: -1 }, 485: { f: function() {
    } }, 486: { T: 1 }, 487: { T: -1 }, 488: { T: 1 }, 489: { T: -1 }, 490: { T: 1 }, 491: { T: -1 }, 492: { T: 1 }, 493: { T: -1 }, 494: { f: function(t, p) {
      var a = t.l + p, l = ci(t), d = Xl(t), _ = Dn(t), u = Dn(t), p = Dn(t);
      return t.l = a, p = { rfx: l, relId: d, loc: _, display: p }, u && (p.Tooltip = u), p;
    } }, 495: { T: 1 }, 496: { T: -1 }, 497: { T: 1 }, 498: { T: -1 }, 499: {}, 500: { T: 1 }, 501: { T: -1 }, 502: { T: 1 }, 503: { T: -1 }, 504: {}, 505: { T: 1 }, 506: { T: -1 }, 507: {}, 508: { T: 1 }, 509: { T: -1 }, 510: { T: 1 }, 511: { T: -1 }, 512: {}, 513: {}, 514: { T: 1 }, 515: { T: -1 }, 516: { T: 1 }, 517: { T: -1 }, 518: { T: 1 }, 519: { T: -1 }, 520: { T: 1 }, 521: { T: -1 }, 522: {}, 523: {}, 524: {}, 525: {}, 526: {}, 527: {}, 528: { T: 1 }, 529: { T: -1 }, 530: { T: 1 }, 531: { T: -1 }, 532: { T: 1 }, 533: { T: -1 }, 534: {}, 535: {}, 536: {}, 537: {}, 538: { T: 1 }, 539: { T: -1 }, 540: { T: 1 }, 541: { T: -1 }, 542: { T: 1 }, 548: {}, 549: {}, 550: { f: Zl }, 551: {}, 552: {}, 553: {}, 554: { T: 1 }, 555: { T: -1 }, 556: { T: 1 }, 557: { T: -1 }, 558: { T: 1 }, 559: { T: -1 }, 560: { T: 1 }, 561: { T: -1 }, 562: {}, 564: {}, 565: { T: 1 }, 566: { T: -1 }, 569: { T: 1 }, 570: { T: -1 }, 572: {}, 573: { T: 1 }, 574: { T: -1 }, 577: {}, 578: {}, 579: {}, 580: {}, 581: {}, 582: {}, 583: {}, 584: {}, 585: {}, 586: {}, 587: {}, 588: { T: -1 }, 589: {}, 590: { T: 1 }, 591: { T: -1 }, 592: { T: 1 }, 593: { T: -1 }, 594: { T: 1 }, 595: { T: -1 }, 596: {}, 597: { T: 1 }, 598: { T: -1 }, 599: { T: 1 }, 600: { T: -1 }, 601: { T: 1 }, 602: { T: -1 }, 603: { T: 1 }, 604: { T: -1 }, 605: { T: 1 }, 606: { T: -1 }, 607: {}, 608: { T: 1 }, 609: { T: -1 }, 610: {}, 611: { T: 1 }, 612: { T: -1 }, 613: { T: 1 }, 614: { T: -1 }, 615: { T: 1 }, 616: { T: -1 }, 617: { T: 1 }, 618: { T: -1 }, 619: { T: 1 }, 620: { T: -1 }, 625: {}, 626: { T: 1 }, 627: { T: -1 }, 628: { T: 1 }, 629: { T: -1 }, 630: { T: 1 }, 631: { T: -1 }, 632: { f: co }, 633: { T: 1 }, 634: { T: -1 }, 635: { T: 1, f: function(t) {
      var n = {};
      n.iauthor = t.read_shift(4);
      var a = ci(t);
      return n.rfx = a.s, n.ref = $t(a.s), t.l += 16, n;
    } }, 636: { T: -1 }, 637: { f: iC }, 638: { T: 1 }, 639: {}, 640: { T: -1 }, 641: { T: 1 }, 642: { T: -1 }, 643: { T: 1 }, 644: {}, 645: { T: -1 }, 646: { T: 1 }, 648: { T: 1 }, 649: {}, 650: { T: -1 }, 651: { f: function(t, n) {
      return t.l += 10, { name: Dn(t) };
    } }, 652: {}, 653: { T: 1 }, 654: { T: -1 }, 655: { T: 1 }, 656: { T: -1 }, 657: { T: 1 }, 658: { T: -1 }, 659: {}, 660: { T: 1 }, 661: {}, 662: { T: -1 }, 663: {}, 664: { T: 1 }, 665: {}, 666: { T: -1 }, 667: {}, 668: {}, 669: {}, 671: { T: 1 }, 672: { T: -1 }, 673: { T: 1 }, 674: { T: -1 }, 675: {}, 676: {}, 677: {}, 678: {}, 679: {}, 680: {}, 681: {}, 1024: {}, 1025: {}, 1026: { T: 1 }, 1027: { T: -1 }, 1028: { T: 1 }, 1029: { T: -1 }, 1030: {}, 1031: { T: 1 }, 1032: { T: -1 }, 1033: { T: 1 }, 1034: { T: -1 }, 1035: {}, 1036: {}, 1037: {}, 1038: { T: 1 }, 1039: { T: -1 }, 1040: {}, 1041: { T: 1 }, 1042: { T: -1 }, 1043: {}, 1044: {}, 1045: {}, 1046: { T: 1 }, 1047: { T: -1 }, 1048: { T: 1 }, 1049: { T: -1 }, 1050: {}, 1051: { T: 1 }, 1052: { T: 1 }, 1053: { f: function() {
    } }, 1054: { T: 1 }, 1055: {}, 1056: { T: 1 }, 1057: { T: -1 }, 1058: { T: 1 }, 1059: { T: -1 }, 1061: {}, 1062: { T: 1 }, 1063: { T: -1 }, 1064: { T: 1 }, 1065: { T: -1 }, 1066: { T: 1 }, 1067: { T: -1 }, 1068: { T: 1 }, 1069: { T: -1 }, 1070: { T: 1 }, 1071: { T: -1 }, 1072: { T: 1 }, 1073: { T: -1 }, 1075: { T: 1 }, 1076: { T: -1 }, 1077: { T: 1 }, 1078: { T: -1 }, 1079: { T: 1 }, 1080: { T: -1 }, 1081: { T: 1 }, 1082: { T: -1 }, 1083: { T: 1 }, 1084: { T: -1 }, 1085: {}, 1086: { T: 1 }, 1087: { T: -1 }, 1088: { T: 1 }, 1089: { T: -1 }, 1090: { T: 1 }, 1091: { T: -1 }, 1092: { T: 1 }, 1093: { T: -1 }, 1094: { T: 1 }, 1095: { T: -1 }, 1096: {}, 1097: { T: 1 }, 1098: {}, 1099: { T: -1 }, 1100: { T: 1 }, 1101: { T: -1 }, 1102: {}, 1103: {}, 1104: {}, 1105: {}, 1111: {}, 1112: {}, 1113: { T: 1 }, 1114: { T: -1 }, 1115: { T: 1 }, 1116: { T: -1 }, 1117: {}, 1118: { T: 1 }, 1119: { T: -1 }, 1120: { T: 1 }, 1121: { T: -1 }, 1122: { T: 1 }, 1123: { T: -1 }, 1124: { T: 1 }, 1125: { T: -1 }, 1126: {}, 1128: { T: 1 }, 1129: { T: -1 }, 1130: {}, 1131: { T: 1 }, 1132: { T: -1 }, 1133: { T: 1 }, 1134: { T: -1 }, 1135: { T: 1 }, 1136: { T: -1 }, 1137: { T: 1 }, 1138: { T: -1 }, 1139: { T: 1 }, 1140: { T: -1 }, 1141: {}, 1142: { T: 1 }, 1143: { T: -1 }, 1144: { T: 1 }, 1145: { T: -1 }, 1146: {}, 1147: { T: 1 }, 1148: { T: -1 }, 1149: { T: 1 }, 1150: { T: -1 }, 1152: { T: 1 }, 1153: { T: -1 }, 1154: { T: -1 }, 1155: { T: -1 }, 1156: { T: -1 }, 1157: { T: 1 }, 1158: { T: -1 }, 1159: { T: 1 }, 1160: { T: -1 }, 1161: { T: 1 }, 1162: { T: -1 }, 1163: { T: 1 }, 1164: { T: -1 }, 1165: { T: 1 }, 1166: { T: -1 }, 1167: { T: 1 }, 1168: { T: -1 }, 1169: { T: 1 }, 1170: { T: -1 }, 1171: {}, 1172: { T: 1 }, 1173: { T: -1 }, 1177: {}, 1178: { T: 1 }, 1180: {}, 1181: {}, 1182: {}, 2048: { T: 1 }, 2049: { T: -1 }, 2050: {}, 2051: { T: 1 }, 2052: { T: -1 }, 2053: {}, 2054: {}, 2055: { T: 1 }, 2056: { T: -1 }, 2057: { T: 1 }, 2058: { T: -1 }, 2060: {}, 2067: {}, 2068: { T: 1 }, 2069: { T: -1 }, 2070: {}, 2071: {}, 2072: { T: 1 }, 2073: { T: -1 }, 2075: {}, 2076: {}, 2077: { T: 1 }, 2078: { T: -1 }, 2079: {}, 2080: { T: 1 }, 2081: { T: -1 }, 2082: {}, 2083: { T: 1 }, 2084: { T: -1 }, 2085: { T: 1 }, 2086: { T: -1 }, 2087: { T: 1 }, 2088: { T: -1 }, 2089: { T: 1 }, 2090: { T: -1 }, 2091: {}, 2092: {}, 2093: { T: 1 }, 2094: { T: -1 }, 2095: {}, 2096: { T: 1 }, 2097: { T: -1 }, 2098: { T: 1 }, 2099: { T: -1 }, 2100: { T: 1 }, 2101: { T: -1 }, 2102: {}, 2103: { T: 1 }, 2104: { T: -1 }, 2105: {}, 2106: { T: 1 }, 2107: { T: -1 }, 2108: {}, 2109: { T: 1 }, 2110: { T: -1 }, 2111: { T: 1 }, 2112: { T: -1 }, 2113: { T: 1 }, 2114: { T: -1 }, 2115: {}, 2116: {}, 2117: {}, 2118: { T: 1 }, 2119: { T: -1 }, 2120: {}, 2121: { T: 1 }, 2122: { T: -1 }, 2123: { T: 1 }, 2124: { T: -1 }, 2125: {}, 2126: { T: 1 }, 2127: { T: -1 }, 2128: {}, 2129: { T: 1 }, 2130: { T: -1 }, 2131: { T: 1 }, 2132: { T: -1 }, 2133: { T: 1 }, 2134: {}, 2135: {}, 2136: {}, 2137: { T: 1 }, 2138: { T: -1 }, 2139: { T: 1 }, 2140: { T: -1 }, 2141: {}, 3072: {}, 3073: {}, 4096: { T: 1 }, 4097: { T: -1 }, 5002: { T: 1 }, 5003: { T: -1 }, 5081: { T: 1 }, 5082: { T: -1 }, 5083: {}, 5084: { T: 1 }, 5085: { T: -1 }, 5086: { T: 1 }, 5087: { T: -1 }, 5088: {}, 5089: {}, 5090: {}, 5092: { T: 1 }, 5093: { T: -1 }, 5094: {}, 5095: { T: 1 }, 5096: { T: -1 }, 5097: {}, 5099: {}, 65535: { n: "" } }, Lc = { 6: { f: Ac }, 10: { f: qa }, 12: { f: sn }, 13: { f: sn }, 14: { f: tn }, 15: { f: tn }, 16: { f: wn }, 17: { f: tn }, 18: { f: tn }, 19: { f: sn }, 20: { f: ig }, 21: { f: ig }, 23: { f: lg }, 24: { f: sg }, 25: { f: tn }, 26: {}, 27: {}, 28: { f: function(t, n, a) {
      return function(l, d) {
        if (!(d.biff < 8)) {
          var _ = l.read_shift(2), u = l.read_shift(2), p = l.read_shift(2), m = l.read_shift(2), f = _i(l, 0, d);
          return d.biff < 8 && l.read_shift(1), [{ r: _, c: u }, f, m, p];
        }
      }(t, a);
    } }, 29: {}, 34: { f: tn }, 35: { f: og }, 38: { f: wn }, 39: { f: wn }, 40: { f: wn }, 41: { f: wn }, 42: { f: tn }, 43: { f: tn }, 47: { f: function(t, n, a) {
      var l = { Type: 8 <= a.biff ? t.read_shift(2) : 0 };
      return l.Type ? qC(t, n - 2, l) : (n = t, a.biff, t = a, a = l, n = { key: sn(n), verificationBytes: sn(n) }, t.password && (n.verifier = Ec(t.password)), a.valid = n.verificationBytes === n.verifier, a.valid && (a.insitu = HC(t.password))), l;
    } }, 49: { f: function(t, n, a) {
      var l = { dyHeight: t.read_shift(2), fl: t.read_shift(2) };
      switch (a && a.biff || 8) {
        case 2:
          break;
        case 3:
        case 4:
          t.l += 2;
          break;
        default:
          t.l += 10;
      }
      return l.name = Co(t, 0, a), l;
    } }, 51: { f: sn }, 60: {}, 61: { f: function(t) {
      return { Pos: [t.read_shift(2), t.read_shift(2)], Dim: [t.read_shift(2), t.read_shift(2)], Flags: t.read_shift(2), CurTab: t.read_shift(2), FirstTab: t.read_shift(2), Selected: t.read_shift(2), TabRatio: t.read_shift(2) };
    } }, 64: { f: tn }, 65: { f: function() {
    } }, 66: { f: sn }, 77: {}, 80: {}, 81: {}, 82: {}, 85: { f: sn }, 89: {}, 90: {}, 91: {}, 92: { f: function(t, n, d) {
      if (d.enc)
        return t.l += n, "";
      var l = t.l, d = _i(t, 0, d);
      return t.read_shift(n + l - t.l), d;
    } }, 93: { f: function(t, n, a) {
      return a && a.biff < 8 ? function(l, d, _) {
        l.l += 4;
        var u = l.read_shift(2), p = l.read_shift(2), m = l.read_shift(2);
        l.l += 2, l.l += 2, l.l += 2, l.l += 2, l.l += 2, l.l += 2, l.l += 2, l.l += 2, l.l += 2, l.l += 6, d -= 36;
        var f = [];
        return f.push((bC[u] || In)(l, d, _)), { cmo: [p, u, m], ft: f };
      }(t, n, a) : { cmo: a = eg(t), ft: function(l, d) {
        for (var _ = l.l + d, u = []; l.l < _; ) {
          var p = l.read_shift(2);
          l.l -= 2;
          try {
            u.push(EC[p](l, _ - l.l));
          } catch {
            return l.l = _, u;
          }
        }
        return l.l != _ && (l.l = _), u;
      }(t, n - 22, a[1]) };
    } }, 94: {}, 95: { f: tn }, 96: {}, 97: {}, 99: { f: tn }, 125: { f: dg }, 128: { f: function(t) {
      if (t.l += 4, (t = [t.read_shift(2), t.read_shift(2)])[0] !== 0 && t[0]--, t[1] !== 0 && t[1]--, 7 < t[0] || 7 < t[1])
        throw new Error("Bad Gutters: " + t.join("|"));
      return t;
    } }, 129: { f: function(t, n, a) {
      return { fDialog: 16 & (n = a && a.biff == 8 || n == 2 ? t.read_shift(2) : (t.l += n, 0)), fBelow: 64 & n, fRight: 128 & n };
    } }, 130: { f: sn }, 131: { f: tn }, 132: { f: tn }, 133: { f: function(t, n, a) {
      var l = t.read_shift(4), d = 3 & t.read_shift(1), _ = t.read_shift(1);
      switch (_) {
        case 0:
          _ = "Worksheet";
          break;
        case 1:
          _ = "Macrosheet";
          break;
        case 2:
          _ = "Chartsheet";
          break;
        case 6:
          _ = "VBAModule";
      }
      return a = Co(t, 0, a), { pos: l, hs: d, dt: _, name: a = a.length === 0 ? "Sheet1" : a };
    } }, 134: {}, 140: { f: function(t) {
      var n = [0, 0], a = t.read_shift(2);
      return n[0] = Tf[a] || a, a = t.read_shift(2), n[1] = Tf[a] || a, n;
    } }, 141: { f: sn }, 144: {}, 146: { f: function(t) {
      for (var n = t.read_shift(2), a = []; 0 < n--; )
        a.push(Xf(t));
      return a;
    } }, 151: {}, 152: {}, 153: {}, 154: {}, 155: {}, 156: { f: sn }, 157: {}, 158: {}, 160: { f: CC }, 161: { f: function(t, n) {
      var a = {};
      return n < 32 || (t.l += 16, a.header = wn(t), a.footer = wn(t), t.l += 2), a;
    } }, 174: {}, 175: {}, 176: {}, 177: {}, 178: {}, 180: {}, 181: {}, 182: {}, 184: {}, 185: {}, 189: { f: function(t, n) {
      for (var a = t.l + n - 2, l = t.read_shift(2), d = t.read_shift(2), _ = []; t.l < a; )
        _.push(Zf(t));
      if (t.l !== a)
        throw new Error("MulRK read error");
      if (n = t.read_shift(2), _.length != n - d + 1)
        throw new Error("MulRK length mismatch");
      return { r: l, c: d, C: n, rkrec: _ };
    } }, 190: { f: function(t, n) {
      for (var a = t.l + n - 2, l = t.read_shift(2), d = t.read_shift(2), _ = []; t.l < a; )
        _.push(t.read_shift(2));
      if (t.l !== a)
        throw new Error("MulBlank read error");
      if (n = t.read_shift(2), _.length != n - d + 1)
        throw new Error("MulBlank length mismatch");
      return { r: l, c: d, C: n, ixfe: _ };
    } }, 193: { f: qa }, 197: {}, 198: {}, 199: {}, 200: {}, 201: {}, 202: { f: tn }, 203: {}, 204: {}, 205: {}, 206: {}, 207: {}, 208: {}, 209: {}, 210: {}, 211: {}, 213: {}, 215: {}, 216: {}, 217: {}, 218: { f: sn }, 220: {}, 221: { f: tn }, 222: {}, 224: { f: function(t, n, a) {
      var l, d, _, u = {};
      return u.ifnt = t.read_shift(2), u.numFmtId = t.read_shift(2), u.flags = t.read_shift(2), u.fStyle = u.flags >> 2 & 1, n -= 6, u.data = (l = t, u.fStyle, d = a, _ = {}, n = l.read_shift(4), t = l.read_shift(4), a = l.read_shift(4), l = l.read_shift(2), _.patternType = dC[a >> 26], d.cellStyles && (_.alc = 7 & n, _.fWrap = n >> 3 & 1, _.alcV = n >> 4 & 7, _.fJustLast = n >> 7 & 1, _.trot = n >> 8 & 255, _.cIndent = n >> 16 & 15, _.fShrinkToFit = n >> 20 & 1, _.iReadOrder = n >> 22 & 2, _.fAtrNum = n >> 26 & 1, _.fAtrFnt = n >> 27 & 1, _.fAtrAlc = n >> 28 & 1, _.fAtrBdr = n >> 29 & 1, _.fAtrPat = n >> 30 & 1, _.fAtrProt = n >> 31 & 1, _.dgLeft = 15 & t, _.dgRight = t >> 4 & 15, _.dgTop = t >> 8 & 15, _.dgBottom = t >> 12 & 15, _.icvLeft = t >> 16 & 127, _.icvRight = t >> 23 & 127, _.grbitDiag = t >> 30 & 3, _.icvTop = 127 & a, _.icvBottom = a >> 7 & 127, _.icvDiag = a >> 14 & 127, _.dgDiag = a >> 21 & 15, _.icvFore = 127 & l, _.icvBack = l >> 7 & 127, _.fsxButton = l >> 14 & 1), _), u;
    } }, 225: { f: function(t, n) {
      return n === 0 || t.read_shift(2), 1200;
    } }, 226: { f: qa }, 227: {}, 229: { f: function(t, n) {
      for (var a = [], l = t.read_shift(2); l--; )
        a.push(vs(t));
      return a;
    } }, 233: {}, 235: {}, 236: {}, 237: {}, 239: {}, 240: {}, 241: {}, 242: {}, 244: {}, 245: {}, 246: {}, 247: {}, 248: {}, 249: {}, 251: {}, 252: { f: function(t, n) {
      for (var a = t.l + n, n = t.read_shift(4), l = t.read_shift(4), d = [], _ = 0; _ != l && t.l < a; ++_)
        d.push(function(p) {
          var m = g;
          g = 1200;
          var f, E = p.read_shift(2), b = 4 & (R = p.read_shift(1)), T = 8 & R, v = 1 + (1 & R), y = 0, R = {};
          return T && (y = p.read_shift(2)), b && (f = p.read_shift(4)), v = v == 2 ? "dbcs-cont" : "sbcs-cont", v = E === 0 ? "" : p.read_shift(E, v), T && (p.l += 4 * y), b && (p.l += f), R.t = v, T || (R.raw = "<t>" + R.t + "</t>", R.r = R.t), g = m, R;
        }(t));
      return d.Count = n, d.Unique = l, d;
    } }, 253: { f: function(t) {
      var n = ha(t);
      return n.isst = t.read_shift(4), n;
    } }, 255: { f: function(t, n) {
      var a = {};
      return a.dsst = t.read_shift(2), t.l += n - 2, a;
    } }, 256: {}, 259: {}, 290: {}, 311: {}, 312: {}, 315: {}, 317: { f: $f }, 318: {}, 319: {}, 320: {}, 330: {}, 331: {}, 333: {}, 334: {}, 335: {}, 336: {}, 337: {}, 338: {}, 339: {}, 340: {}, 351: {}, 352: { f: tn }, 353: { f: qa }, 401: {}, 402: {}, 403: {}, 404: {}, 405: {}, 406: {}, 407: {}, 408: {}, 425: {}, 426: {}, 427: {}, 428: {}, 429: {}, 430: { f: function(t, _, a) {
      var l = t.l + _, d = t.read_shift(2), _ = t.read_shift(2);
      if ((a.sbcch = _) == 1025 || _ == 14849)
        return [_, d];
      if (_ < 1 || 255 < _)
        throw new Error("Unexpected SupBook type: " + _);
      for (var a = ui(t, _), u = []; l > t.l; )
        u.push(Ro(t));
      return [_, d, a, u];
    } }, 431: { f: tn }, 432: {}, 433: {}, 434: {}, 437: {}, 438: { f: function(t, n, a) {
      var l = t.l, d = "";
      try {
        t.l += 4;
        var _ = (a.lastobj || { cmo: [0, 0] }).cmo[1];
        [0, 5, 7, 11, 12, 14].indexOf(_) == -1 ? t.l += 6 : function(f) {
          var E = f.read_shift(1);
          f.l++;
          var b = f.read_shift(2);
          f.l += 2;
        }(t);
        var u = t.read_shift(2);
        t.read_shift(2), sn(t), _ = t.read_shift(2), t.l += _;
        for (var p = 1; p < t.lens.length - 1; ++p) {
          if (t.l - l != t.lens[p])
            throw new Error("TxO: bad continue record");
          var m = t[t.l];
          if ((d += ui(t, t.lens[p + 1] - t.lens[p] - 1)).length >= (m ? u : 2 * u))
            break;
        }
        if (d.length !== u && d.length !== 2 * u)
          throw new Error("cchText: " + u + " != " + d.length);
        return t.l = l + n, { t: d };
      } catch {
        return t.l = l + n, { t: d };
      }
    } }, 439: { f: tn }, 440: { f: function(t, n) {
      var a = vs(t);
      return t.l += 16, [a, function(l, d) {
        var _ = l.l + d;
        if ((b = l.read_shift(4)) !== 2)
          throw new Error("Unrecognized streamVersion: " + b);
        d = l.read_shift(2), l.l += 2;
        var u, p, m, f, E, b = "";
        16 & d && (u = Ts(l, l.l)), 128 & d && (p = Ts(l, l.l)), (257 & d) == 257 && (m = Ts(l, l.l)), (257 & d) == 1 && (T = fC(l, l.l)), 8 & d && (b = Ts(l, l.l)), 32 & d && (f = l.read_shift(16)), 64 & d && (E = sc(l)), l.l = _;
        var T = p || m || T || "";
        return T && b && (T += "#" + b), T = T || "#" + b, T = { Target: T = 2 & d && T.charAt(0) == "/" && T.charAt(1) != "/" ? "file://" + T : T }, f && (T.guid = f), E && (T.time = E), u && (T.Tooltip = u), T;
      }(t, n - 24)];
    } }, 441: {}, 442: { f: Ro }, 443: {}, 444: { f: sn }, 445: {}, 446: {}, 448: { f: qa }, 449: { f: function(t) {
      return t.read_shift(2), t.read_shift(4);
    }, r: 2 }, 450: { f: qa }, 512: { f: rg }, 513: { f: vC }, 515: { f: function(t, n, a) {
      return a.biffguess && a.biff == 2 && (a.biff = 5), a = ha(t), t = wn(t), a.val = t, a;
    } }, 516: { f: function(t, n, a) {
      return a.biffguess && a.biff == 2 && (a.biff = 5), t.l, n = ha(t), a.biff == 2 && t.l++, a = Ro(t, t.l, a), n.val = a, n;
    } }, 517: { f: ag }, 519: { f: zc }, 520: { f: function(t) {
      var n = {};
      n.r = t.read_shift(2), n.c = t.read_shift(2), n.cnt = t.read_shift(2) - n.c;
      var a = t.read_shift(2);
      t.l += 4;
      var l = t.read_shift(1);
      return t.l += 3, 7 & l && (n.level = 7 & l), 32 & l && (n.hidden = !0), 64 & l && (n.hpt = a / 20), n;
    } }, 523: {}, 545: { f: cg }, 549: { f: tg }, 566: {}, 574: { f: function(t, n, a) {
      return a && 2 <= a.biff && a.biff < 5 ? {} : { RTL: 64 & t.read_shift(2) };
    } }, 638: { f: function(l) {
      var n = l.read_shift(2), a = l.read_shift(2), l = Zf(l);
      return { r: n, c: a, ixfe: l[0], rknum: l[1] };
    } }, 659: {}, 1048: {}, 1054: { f: function(t, n, a) {
      return [t.read_shift(2), _i(t, 0, a)];
    } }, 1084: {}, 1212: { f: function(t, n, a) {
      var l = Jf(t);
      t.l++;
      var d = t.read_shift(1);
      return [function(_, u, p) {
        var m, f = _.l + u, E = _.read_shift(2), b = Mo(_, E, p);
        return E == 65535 ? [[], In(_, u - 2)] : (u !== E + 2 && (m = Lo(_, f - E - 2, b, p)), [b, m]);
      }(t, n -= 8, a), d, l];
    } }, 2048: { f: function(t, n) {
      return t.read_shift(2), [vs(t), t.read_shift((n - 10) / 2, "dbcs-cont").replace(ge, "")];
    } }, 2049: {}, 2050: {}, 2051: {}, 2052: {}, 2053: {}, 2054: {}, 2055: {}, 2056: {}, 2057: { f: Cs }, 2058: {}, 2059: {}, 2060: {}, 2061: {}, 2062: {}, 2063: {}, 2064: {}, 2066: {}, 2067: {}, 2128: {}, 2129: {}, 2130: {}, 2131: {}, 2132: {}, 2133: {}, 2134: {}, 2135: {}, 2136: {}, 2137: {}, 2138: {}, 2146: {}, 2147: { r: 12 }, 2148: {}, 2149: {}, 2150: {}, 2151: { f: qa }, 2152: {}, 2154: {}, 2155: {}, 2156: {}, 2161: {}, 2162: {}, 2164: {}, 2165: {}, 2166: {}, 2167: {}, 2168: {}, 2169: {}, 2170: {}, 2171: {}, 2172: { f: function(t) {
      t.l += 2;
      var n = { cxfs: 0, crc: 0 };
      return n.cxfs = t.read_shift(2), n.crc = t.read_shift(4), n;
    }, r: 12 }, 2173: { f: function(t, n) {
      t.l, t.l += 2, n = t.read_shift(2), t.l += 2;
      for (var a = t.read_shift(2), l = []; 0 < a--; )
        l.push(_R(t, t.l));
      return { ixfe: n, ext: l };
    }, r: 12 }, 2174: {}, 2175: {}, 2180: {}, 2181: {}, 2182: {}, 2183: {}, 2184: {}, 2185: {}, 2186: {}, 2187: {}, 2188: { f: tn, r: 12 }, 2189: {}, 2190: { r: 12 }, 2191: {}, 2192: {}, 2194: {}, 2195: {}, 2196: { f: function(t, n, a) {
      if (!(a.biff < 8)) {
        var l = t.read_shift(2), d = t.read_shift(2);
        return [ui(t, l, a), ui(t, d, a)];
      }
      t.l += n;
    }, r: 12 }, 2197: {}, 2198: { f: function(t, n, a) {
      var l = t.l + n;
      if (t.read_shift(4) !== 124226)
        if (a.cellStyles) {
          var d, _ = t.slice(t.l);
          t.l = l;
          try {
            d = Ll(_, { type: "array" });
          } catch {
            return;
          }
          if (n = $n(d, "theme/theme/theme1.xml", !0), n)
            return oE(n, a);
        } else
          t.l = l;
    }, r: 12 }, 2199: {}, 2200: {}, 2201: {}, 2202: { f: function(t) {
      return [t.read_shift(4) !== 0, t.read_shift(4) !== 0, t.read_shift(4)];
    }, r: 12 }, 2203: { f: qa }, 2204: {}, 2205: {}, 2206: {}, 2207: {}, 2211: { f: function(t) {
      var n, a, l = (a = (n = t).read_shift(2), l = n.read_shift(2), n.l += 8, { type: a, flags: l });
      if (l.type != 2211)
        throw new Error("Invalid Future Record " + l.type);
      return t.read_shift(4) !== 0;
    } }, 2212: {}, 2213: {}, 2214: {}, 2215: {}, 4097: {}, 4098: {}, 4099: {}, 4102: {}, 4103: {}, 4105: {}, 4106: {}, 4107: {}, 4108: {}, 4109: {}, 4116: {}, 4117: {}, 4118: {}, 4119: {}, 4120: {}, 4121: {}, 4122: {}, 4123: {}, 4124: {}, 4125: {}, 4126: {}, 4127: {}, 4128: {}, 4129: {}, 4130: {}, 4132: {}, 4133: {}, 4134: { f: sn }, 4135: {}, 4146: {}, 4147: {}, 4148: {}, 4149: {}, 4154: {}, 4156: {}, 4157: {}, 4158: {}, 4159: {}, 4160: {}, 4161: {}, 4163: {}, 4164: { f: function(t, n, a) {
      var l = { area: !1 };
      return a.biff != 5 ? t.l += n : (n = t.read_shift(1), t.l += 3, 16 & n && (l.area = !0)), l;
    } }, 4165: {}, 4166: {}, 4168: {}, 4170: {}, 4171: {}, 4174: {}, 4175: {}, 4176: {}, 4177: {}, 4187: {}, 4188: { f: function(t) {
      for (var n = t.read_shift(2), a = []; 0 < n--; )
        a.push(Xf(t));
      return a;
    } }, 4189: {}, 4191: {}, 4192: {}, 4193: {}, 4194: {}, 4195: {}, 4196: {}, 4197: {}, 4198: {}, 4199: {}, 4200: {}, 0: { f: rg }, 1: {}, 2: { f: function(t) {
      var n = ha(t);
      return ++t.l, t = t.read_shift(2), n.t = "n", n.val = t, n;
    } }, 3: { f: function(t) {
      var n = ha(t);
      return ++t.l, t = wn(t), n.t = "n", n.val = t, n;
    } }, 4: { f: function(t, n, a) {
      a.biffguess && a.biff == 5 && (a.biff = 2);
      var l = ha(t);
      return ++t.l, a = _i(t, 0, a), l.t = "str", l.val = a, l;
    } }, 5: { f: ag }, 7: { f: function(t) {
      var n = t.read_shift(1);
      return n === 0 ? (t.l++, "") : t.read_shift(n, "sbcs-cont");
    } }, 8: {}, 9: { f: Cs }, 11: {}, 22: { f: sn }, 30: { f: zi }, 31: {}, 32: {}, 33: { f: cg }, 36: {}, 37: { f: tg }, 50: { f: function(t, n) {
      t.l += 6, t.l += 2, t.l += 1, t.l += 3, t.l += 1, t.l += n - 13;
    } }, 62: {}, 52: {}, 67: {}, 68: { f: sn }, 69: {}, 86: {}, 126: {}, 127: { f: function(t) {
      var n = t.read_shift(2), l = t.read_shift(2), a = t.read_shift(4), l = { fmt: n, env: l, len: a, data: t.slice(t.l, t.l + a) };
      return t.l += a, l;
    } }, 135: {}, 136: {}, 137: {}, 145: {}, 148: {}, 149: {}, 150: {}, 169: {}, 171: {}, 188: {}, 191: {}, 192: {}, 194: {}, 195: {}, 214: { f: function(t, _, u) {
      var l = t.l + _, d = ha(t), _ = t.read_shift(2), u = ui(t, _, u);
      return t.l = l, d.t = "str", d.val = u, d;
    } }, 223: {}, 234: {}, 354: {}, 421: {}, 518: { f: Ac }, 521: { f: Cs }, 536: { f: sg }, 547: { f: og }, 561: {}, 579: {}, 1030: { f: Ac }, 1033: { f: Cs }, 1091: {}, 2157: {}, 2163: {}, 2177: {}, 2240: {}, 2241: {}, 2242: {}, 2243: {}, 2244: {}, 2245: {}, 2246: {}, 2247: {}, 2248: {}, 2249: {}, 2250: {}, 2251: {}, 2262: { r: 12 }, 29282: {} };
    function ot(t, n, a, l) {
      var d = n;
      isNaN(d) || (n = l || (a || []).length || 0, (l = t.next(4)).write_shift(2, d), l.write_shift(2, n), 0 < n && $l(a) && t.push(a));
    }
    function Go(t, n, a) {
      return (t = t || Me(7)).write_shift(2, n), t.write_shift(2, a), t.write_shift(2, 0), t.write_shift(1, 0), t;
    }
    function wN(t, n, a, l) {
      if (n.v != null)
        switch (n.t) {
          case "d":
          case "n":
            var d = n.t == "d" ? on(Br(n.v)) : n.v;
            return void (d == (0 | d) && 0 <= d && d < 65536 ? ot(t, 2, (E = a, b = l, T = d, Go(v = Me(9), E, b), v.write_shift(2, T), v)) : ot(t, 3, (T = a, v = l, d = d, Go(f = Me(15), T, v), f.write_shift(8, d, "f"), f)));
          case "b":
          case "e":
            return void ot(t, 5, (f = a, _ = l, u = n.v, p = n.t, Go(m = Me(9), f, _), Wf(u, p || "b", m), m));
          case "s":
          case "str":
            return void ot(t, 4, (_ = a, u = l, p = (n.v || "").slice(0, 255), Go(m = Me(8 + 2 * p.length), _, u), m.write_shift(1, p.length), m.write_shift(p.length, p, "sbcs"), m.l < m.length ? m.slice(0, m.l) : m));
        }
      var _, u, p, m, f, E, b, T, v;
      ot(t, 1, Go(null, a, l));
    }
    function xN(t, n) {
      for (var a = n || {}, n = Wn(), l = 0, d = 0; d < t.SheetNames.length; ++d)
        t.SheetNames[d] == a.sheet && (l = d);
      if (l == 0 && a.sheet && t.SheetNames[0] != a.sheet)
        throw new Error("Sheet not found: " + a.sheet);
      return ot(n, a.biff == 4 ? 1033 : a.biff == 3 ? 521 : 9, lc(0, 16, a)), function(_, u, p) {
        var m, f, E = Array.isArray(u), b = lr(u["!ref"] || "A1"), T = [];
        if (255 < b.e.c || 16383 < b.e.r) {
          if (p.WTF)
            throw new Error("Range " + (u["!ref"] || "A1") + " exceeds format limit A1:IV16384");
          b.e.c = Math.min(b.e.c, 255), b.e.r = Math.min(b.e.c, 16383), m = Xt(b);
        }
        for (var v = b.s.r; v <= b.e.r; ++v) {
          f = Xr(v);
          for (var y = b.s.c; y <= b.e.c; ++y) {
            v === b.s.r && (T[y] = Vr(y)), m = T[y] + f;
            var R = E ? (u[v] || [])[y] : u[m];
            R && wN(_, R, v, y);
          }
        }
      }(n, t.Sheets[t.SheetNames[l]], a), ot(n, 10), n.end();
    }
    function LN(t, n, a) {
      var l, d;
      ot(t, 49, (d = (l = { sz: 12, color: { theme: 1 }, name: "Arial", family: 2, scheme: "minor" }).name || "Arial", (t = Me((a = (t = a) && t.biff == 5) ? 15 + d.length : 16 + 2 * d.length)).write_shift(2, 20 * (l.sz || 12)), t.write_shift(4, 0), t.write_shift(2, 400), t.write_shift(4, 0), t.write_shift(2, 0), t.write_shift(1, d.length), a || t.write_shift(1, 1), t.write_shift((a ? 1 : 2) * d.length, d, a ? "sbcs" : "utf16le"), t));
    }
    function MN(t, n, a) {
      n && [[5, 8], [23, 26], [41, 44], [50, 392]].forEach(function(l) {
        for (var d, _, u, p, m = l[0]; m <= l[1]; ++m)
          n[m] != null && ot(t, 1054, (d = m, _ = n[m], p = void 0, u = (u = a) && u.biff == 5, (p = p || Me(u ? 3 + _.length : 5 + 2 * _.length)).write_shift(2, d), p.write_shift(u ? 1 : 2, _.length), u || p.write_shift(1, 1), p.write_shift((u ? 1 : 2) * _.length, _, u ? "sbcs" : "utf16le"), (p = p.length > p.l ? p.slice(0, p.l) : p).l == null && (p.l = p.length), p));
      });
    }
    function PN(t, n) {
      for (var a = 0; a < n["!links"].length; ++a) {
        var l = n["!links"][a];
        ot(t, 440, TC(l)), l[1].Tooltip && ot(t, 2048, function(d) {
          var _ = d[1].Tooltip, u = Me(10 + 2 * (_.length + 1));
          u.write_shift(2, 2048), d = zr(d[0]), u.write_shift(2, d.r), u.write_shift(2, d.r), u.write_shift(2, d.c), u.write_shift(2, d.c);
          for (var p = 0; p < _.length; ++p)
            u.write_shift(2, _.charCodeAt(p));
          return u.write_shift(2, 0), u;
        }(l));
      }
      delete n["!links"];
    }
    function kN(t, n) {
      var a;
      n && (a = 0, n.forEach(function(l, d) {
        var _;
        ++a <= 256 && l && ot(t, 125, (_ = Bs(d, l), l = d, (d = Me(12)).write_shift(2, l), d.write_shift(2, l), d.write_shift(2, 256 * _.width), d.write_shift(2, 0), l = 0, _.hidden && (l |= 1), d.write_shift(1, l), l = _.level || 0, d.write_shift(1, l), d.write_shift(2, 0), d));
      }));
    }
    function FN(t, n, a, l, d) {
      var _, u, p, m, f, E, b, T, v, y, R, P = 16 + za(d.cellXfs, n, d);
      if (n.v != null || n.bf)
        if (n.bf)
          ot(t, 6, RR(n, a, l, 0, P));
        else
          switch (n.t) {
            case "d":
            case "n":
              var I = n.t == "d" ? on(Br(n.v)) : n.v;
              ot(t, 515, (E = a, b = l, T = I, v = P, y = Me(14), pi(E, b, v, y), Fi(T, y), y));
              break;
            case "b":
            case "e":
              ot(t, 517, (I = a, E = l, b = n.v, v = P, T = n.t, y = Me(8), pi(I, E, v, y), Wf(b, T, y), y));
              break;
            case "s":
            case "str":
              d.bookSST ? (R = yc(d.Strings, n.v, d.revStrings), ot(t, 253, (_ = a, u = l, p = R, m = P, f = Me(10), pi(_, u, m, f), f.write_shift(4, p), f))) : ot(t, 516, (R = a, _ = l, u = (n.v || "").slice(0, 255), m = P, p = Me(+(f = !(p = d) || p.biff == 8) + 8 + (1 + f) * u.length), pi(R, _, m, p), p.write_shift(2, u.length), f && p.write_shift(1, 1), p.write_shift((1 + f) * u.length, u, f ? "utf16le" : "sbcs"), p));
              break;
            default:
              ot(t, 513, pi(a, l, P));
          }
      else
        ot(t, 513, pi(a, l, P));
    }
    function UN(t, n, a) {
      var l, d, _ = Wn(), M = a.SheetNames[t], u = a.Sheets[M] || {}, p = (a || {}).Workbook || {}, m = (p.Sheets || [])[t] || {}, f = Array.isArray(u), E = n.biff == 8, b = [], T = lr(u["!ref"] || "A1"), v = E ? 65536 : 16384;
      if (255 < T.e.c || T.e.r >= v) {
        if (n.WTF)
          throw new Error("Range " + (u["!ref"] || "A1") + " exceeds format limit A1:IV16384");
        T.e.c = Math.min(T.e.c, 255), T.e.r = Math.min(T.e.c, v - 1);
      }
      ot(_, 2057, lc(0, 16, n)), ot(_, 13, oa(1)), ot(_, 12, oa(100)), ot(_, 15, Bn(!0)), ot(_, 17, Bn(!1)), ot(_, 16, Fi(1e-3)), ot(_, 95, Bn(!0)), ot(_, 42, Bn(!1)), ot(_, 43, Bn(!1)), ot(_, 130, oa(1)), ot(_, 128, (a = [0, 0], (t = Me(8)).write_shift(4, 0), t.write_shift(2, a[0] ? a[0] + 1 : 0), t.write_shift(2, a[1] ? a[1] + 1 : 0), t)), ot(_, 131, Bn(!1)), ot(_, 132, Bn(!1)), E && kN(_, u["!cols"]), ot(_, 512, (v = T, (a = Me(2 * (t = (a = n).biff != 8 && a.biff ? 2 : 4) + 6)).write_shift(t, v.s.r), a.write_shift(t, v.e.r + 1), a.write_shift(2, v.s.c), a.write_shift(2, v.e.c + 1), a.write_shift(2, 0), a)), E && (u["!links"] = []);
      for (var y = T.s.r; y <= T.e.r; ++y) {
        d = Xr(y);
        for (var R = T.s.c; R <= T.e.c; ++R) {
          y === T.s.r && (b[R] = Vr(R)), l = b[R] + d;
          var P = f ? (u[y] || [])[R] : u[l];
          P && (FN(_, P, y, R, n), E && P.l && u["!links"].push([l, P.l]));
        }
      }
      var I, A, M = m.CodeName || m.name || M;
      return E && ot(_, 574, (p = (p.Views || [])[0], A = Me(18), I = 1718, p && p.RTL && (I |= 64), A.write_shift(2, I), A.write_shift(4, 0), A.write_shift(4, 64), A.write_shift(4, 0), A.write_shift(4, 0), A)), E && (u["!merges"] || []).length && ot(_, 229, function(F) {
        var B = Me(2 + 8 * F.length);
        B.write_shift(2, F.length);
        for (var re = 0; re < F.length; ++re)
          jf(F[re], B);
        return B;
      }(u["!merges"])), E && PN(_, u), ot(_, 442, zf(M)), E && (I = _, A = u, (M = Me(19)).write_shift(4, 2151), M.write_shift(4, 0), M.write_shift(4, 0), M.write_shift(2, 3), M.write_shift(1, 1), M.write_shift(4, 0), ot(I, 2151, M), (M = Me(39)).write_shift(4, 2152), M.write_shift(4, 0), M.write_shift(4, 0), M.write_shift(2, 3), M.write_shift(1, 0), M.write_shift(4, 0), M.write_shift(2, 1), M.write_shift(4, 4), M.write_shift(2, 0), jf(lr(A["!ref"] || "A1"), M), M.write_shift(4, 4), ot(I, 2152, M)), ot(_, 10), _.end();
    }
    function BN(t, n, a) {
      var l = Wn(), p = (t || {}).Workbook || {}, d = p.Sheets || [], _ = p.WBProps || {}, u = a.biff == 8, p = a.biff == 5;
      ot(l, 2057, lc(0, 5, a)), a.bookType == "xla" && ot(l, 135), ot(l, 225, u ? oa(1200) : null), ot(l, 193, function(I, A) {
        A = A || Me(I);
        for (var M = 0; M < I; ++M)
          A.write_shift(1, 0);
        return A;
      }(2)), p && ot(l, 191), p && ot(l, 192), ot(l, 226), ot(l, 92, function(I) {
        var A = !I || I.biff == 8, M = Me(A ? 112 : 54);
        for (M.write_shift(I.biff == 8 ? 2 : 1, 7), A && M.write_shift(1, 0), M.write_shift(4, 859007059), M.write_shift(4, 5458548 | (A ? 0 : 536870912)); M.l < M.length; )
          M.write_shift(1, A ? 0 : 32);
        return M;
      }(a)), ot(l, 66, oa(u ? 1200 : 1252)), u && ot(l, 353, oa(0)), u && ot(l, 448), ot(l, 317, function(I) {
        for (var A = Me(2 * I), M = 0; M < I; ++M)
          A.write_shift(2, M + 1);
        return A;
      }(t.SheetNames.length)), u && t.vbaraw && ot(l, 211), u && t.vbaraw && ot(l, 442, zf(_.CodeName || "ThisWorkbook")), ot(l, 156, oa(17)), ot(l, 25, Bn(!1)), ot(l, 18, Bn(!1)), ot(l, 19, oa(0)), u && ot(l, 431, Bn(!1)), u && ot(l, 444, oa(0)), ot(l, 61, ((p = Me(18)).write_shift(2, 0), p.write_shift(2, 0), p.write_shift(2, 29280), p.write_shift(2, 17600), p.write_shift(2, 56), p.write_shift(2, 0), p.write_shift(2, 0), p.write_shift(2, 1), p.write_shift(2, 500), p)), ot(l, 64, Bn(!1)), ot(l, 141, oa(0)), ot(l, 34, Bn(((_ = t).Workbook && _.Workbook.WBProps && Lr(_.Workbook.WBProps.date1904) ? "true" : "false") == "true")), ot(l, 14, Bn(!0)), u && ot(l, 439, Bn(!1)), ot(l, 218, oa(0)), LN(l, 0, a), MN(l, t.SSF, a), function(I, A) {
        for (var M = 0; M < 16; ++M)
          ot(I, 224, ng({ numFmtId: 0, style: !0 }, 0, A));
        A.cellXfs.forEach(function(F) {
          ot(I, 224, ng(F, 0, A));
        });
      }(l, a), u && ot(l, 352, Bn(!1)), p = l.end(), _ = Wn(), u && ot(_, 140, ((P = P || Me(4)).write_shift(2, 1), P.write_shift(2, 1), P)), u && a.Strings && function(I, A, M) {
        var F = (M || []).length || 0;
        if (F <= 8224)
          return ot(I, A, M, F);
        if (!isNaN(A)) {
          for (var B = M.parts || [], re = 0, me = 0, le = 0; le + (B[re] || 8224) <= 8224; )
            le += B[re] || 8224, re++;
          var be = I.next(4);
          for (be.write_shift(2, A), be.write_shift(2, le), I.push(M.slice(me, me + le)), me += le; me < F; ) {
            for ((be = I.next(4)).write_shift(2, 60), le = 0; le + (B[re] || 8224) <= 8224; )
              le += B[re] || 8224, re++;
            be.write_shift(2, le), I.push(M.slice(me, me + le)), me += le;
          }
        }
      }(_, 252, hC(a.Strings)), ot(_, 10);
      for (var l = _.end(), m = Wn(), f = 0, E = 0, E = 0; E < t.SheetNames.length; ++E)
        f += (u ? 12 : 11) + (u ? 2 : 1) * t.SheetNames[E].length;
      var b, T, v, y, R = p.length + f + l.length;
      for (E = 0; E < t.SheetNames.length; ++E)
        ot(m, 133, (b = { pos: R, hs: (d[E] || {}).Hidden || 0, dt: 0, name: t.SheetNames[E] }, y = v = void 0, v = !(T = a) || 8 <= T.biff ? 2 : 1, (y = Me(8 + v * b.name.length)).write_shift(4, b.pos), y.write_shift(1, b.hs || 0), y.write_shift(1, b.dt), y.write_shift(1, b.name.length), 8 <= T.biff && y.write_shift(1, 1), y.write_shift(v * b.name.length, b.name, T.biff < 8 ? "sbcs" : "utf16le"), (T = y.slice(0, y.l)).l = y.l, T)), R += n[E].length;
      var P = m.end();
      if (f != P.length)
        throw new Error("BS8 " + f + " != " + P.length);
      return _ = [], p.length && _.push(p), P.length && _.push(P), l.length && _.push(l), mt(_);
    }
    function zE(t, n) {
      for (var a = 0; a <= t.SheetNames.length; ++a) {
        var l = t.Sheets[t.SheetNames[a]];
        l && l["!ref"] && 255 < Un(l["!ref"]).e.c && typeof console < "u" && console.error && console.error("Worksheet '" + t.SheetNames[a] + "' extends beyond column IV (255).  Data may be lost.");
      }
      var d = n || {};
      switch (d.biff || 2) {
        case 8:
        case 5:
          return function(_, u) {
            var p = u || {}, m = [];
            _ && !_.SSF && (_.SSF = xr(ae)), _ && _.SSF && (ra(), hr(_.SSF), p.revssf = io(_.SSF), p.revssf[_.SSF[65535]] = 0, p.ssf = _.SSF), p.Strings = [], p.Strings.Count = 0, p.Strings.Unique = 0, Bc(p), p.cellXfs = [], za(p.cellXfs, {}, { revssf: { General: 0 } }), _.Props || (_.Props = {});
            for (var f = 0; f < _.SheetNames.length; ++f)
              m[m.length] = UN(f, p, _);
            return m.unshift(BN(_, m, p)), mt(m);
          }(t, n);
        case 4:
        case 3:
        case 2:
          return xN(t, n);
      }
      throw new Error("invalid type " + d.bookType + " for BIFF");
    }
    function KE(t, n) {
      var a = n || {}, l = a.dense ? [] : {}, d = (t = t.replace(/<!--.*?-->/g, "")).match(/<table/i);
      if (!d)
        throw new Error("Invalid HTML: could not find <table>");
      for (var _, n = t.match(/<\/table/i), T = d.index, u = n && n.index || t.length, p = qm(t.slice(T, u), /(:?<tr[^>]*>)/i, "<tr>"), m = -1, f = 0, E = { s: { r: 1e7, c: 1e7 }, e: { r: 0, c: 0 } }, b = [], T = 0; T < p.length; ++T) {
        var v = p[T].trim(), y = v.slice(0, 3).toLowerCase();
        if (y != "<tr") {
          if (y == "<td" || y == "<th")
            for (var R = v.split(/<\/t[dh]>/i), u = 0; u < R.length; ++u) {
              var P = R[u].trim();
              if (P.match(/<t[dh]/i)) {
                for (var I = P, A = 0; I.charAt(0) == "<" && -1 < (A = I.indexOf(">")); )
                  I = I.slice(A + 1);
                for (var M = 0; M < b.length; ++M) {
                  var F = b[M];
                  F.s.c == f && F.s.r < m && m <= F.e.r && (f = F.e.c + 1, M = -1);
                }
                var B = Ht(P.slice(0, P.indexOf(">"))), re = B.colspan ? +B.colspan : 1;
                (1 < (_ = +B.rowspan) || 1 < re) && b.push({ s: { r: m, c: f }, e: { r: m + (_ || 1) - 1, c: f + re - 1 } }), P = B.t || B["data-t"] || "", I.length && (I = mo(I), E.s.r > m && (E.s.r = m), E.e.r < m && (E.e.r = m), E.s.c > f && (E.s.c = f), E.e.c < f && (E.e.c = f), I.length && (B = { t: "s", v: I }, a.raw || !I.trim().length || P == "s" || (I === "TRUE" ? B = { t: "b", v: !0 } : I === "FALSE" ? B = { t: "b", v: !1 } : isNaN(na(I)) ? isNaN(ri(I).getDate()) || (B = { t: "d", v: Br(I) }, (B = a.cellDates ? B : { t: "n", v: on(B.v) }).z = a.dateNF || ae[14]) : B = { t: "n", v: na(I) }), a.dense ? (l[m] || (l[m] = []), l[m][f] = B) : l[$t({ r: m, c: f })] = B)), f += re;
              }
            }
        } else {
          if (++m, a.sheetRows && a.sheetRows <= m) {
            --m;
            break;
          }
          f = 0;
        }
      }
      return l["!ref"] = Xt(E), b.length && (l["!merges"] = b), l;
    }
    function QE(t, n, a, l) {
      for (var d = t["!merges"] || [], _ = [], u = n.s.c; u <= n.e.c; ++u) {
        for (var p, m, f, E, b = 0, T = 0, v = 0; v < d.length; ++v)
          if (!(d[v].s.r > a || d[v].s.c > u || d[v].e.r < a || d[v].e.c < u)) {
            if (d[v].s.r < a || d[v].s.c < u) {
              b = -1;
              break;
            }
            b = d[v].e.r - d[v].s.r + 1, T = d[v].e.c - d[v].s.c + 1;
            break;
          }
        b < 0 || (p = $t({ r: a, c: u }), f = (m = l.dense ? (t[a] || [])[u] : t[p]) && m.v != null && (m.h || uo(m.w || (Ea(m), m.w) || "")) || "", E = {}, 1 < b && (E.rowspan = b), 1 < T && (E.colspan = T), l.editable ? f = '<span contenteditable="true">' + f + "</span>" : m && (E["data-t"] = m && m.t || "z", m.v != null && (E["data-v"] = m.v), m.z != null && (E["data-z"] = m.z), m.l && (m.l.Target || "#").charAt(0) != "#" && (f = '<a href="' + m.l.Target + '">' + f + "</a>")), E.id = (l.id || "sjs") + "-" + p, _.push(it("td", f, E)));
      }
      return "<tr>" + _.join("") + "</tr>";
    }
    var XE = '<html><head><meta charset="utf-8"/><title>SheetJS Table Export</title></head><body>', ZE = "</body></html>";
    function jE(t, n, a) {
      return [].join("") + "<table" + (a && a.id ? ' id="' + a.id + '"' : "") + ">";
    }
    function JE(t, d) {
      var a = d || {}, l = a.header != null ? a.header : XE, d = a.footer != null ? a.footer : ZE, _ = [l], u = Un(t["!ref"]);
      a.dense = Array.isArray(t), _.push(jE(0, 0, a));
      for (var p = u.s.r; p <= u.e.r; ++p)
        _.push(QE(t, u, p, a));
      return _.push("</table>" + d), _.join("");
    }
    function eh(t, n, a) {
      var l = a || {}, d = 0, _ = 0;
      l.origin != null && (typeof l.origin == "number" ? d = l.origin : (d = (a = typeof l.origin == "string" ? zr(l.origin) : l.origin).r, _ = a.c));
      var u = n.getElementsByTagName("tr"), p = Math.min(l.sheetRows || 1e7, u.length), m = { s: { r: 0, c: 0 }, e: { r: d, c: _ } };
      t["!ref"] && (n = Un(t["!ref"]), m.s.r = Math.min(m.s.r, n.s.r), m.s.c = Math.min(m.s.c, n.s.c), m.e.r = Math.max(m.e.r, n.e.r), m.e.c = Math.max(m.e.c, n.e.c), d == -1 && (m.e.r = d = n.e.r + 1));
      var f, E, b = [], T = 0, v = t["!rows"] || (t["!rows"] = []), y = 0, R = 0, P = 0, I = 0;
      for (t["!cols"] || (t["!cols"] = []); y < u.length && R < p; ++y) {
        var A = u[y];
        if (rh(A)) {
          if (l.display)
            continue;
          v[R] = { hidden: !0 };
        }
        for (var M = A.children, P = I = 0; P < M.length; ++P) {
          var F = M[P];
          if (!l.display || !rh(F)) {
            for (var B = F.hasAttribute("data-v") ? F.getAttribute("data-v") : F.hasAttribute("v") ? F.getAttribute("v") : mo(F.innerHTML), re = F.getAttribute("data-z") || F.getAttribute("z"), T = 0; T < b.length; ++T) {
              var me = b[T];
              me.s.c == I + _ && me.s.r < R + d && R + d <= me.e.r && (I = me.e.c + 1 - _, T = -1);
            }
            E = +F.getAttribute("colspan") || 1, (1 < (f = +F.getAttribute("rowspan") || 1) || 1 < E) && b.push({ s: { r: R + d, c: I + _ }, e: { r: R + d + (f || 1) - 1, c: I + _ + (E || 1) - 1 } });
            var le = { t: "s", v: B }, be = F.getAttribute("data-t") || F.getAttribute("t") || "";
            B != null && (B.length == 0 ? le.t = be || "z" : l.raw || B.trim().length == 0 || be == "s" || (B === "TRUE" ? le = { t: "b", v: !0 } : B === "FALSE" ? le = { t: "b", v: !1 } : isNaN(na(B)) ? isNaN(ri(B).getDate()) || (le = { t: "d", v: Br(B) }, (le = l.cellDates ? le : { t: "n", v: on(le.v) }).z = l.dateNF || ae[14]) : le = { t: "n", v: na(B) })), le.z === void 0 && re != null && (le.z = re);
            var Fe = "", Ue = F.getElementsByTagName("A");
            if (Ue && Ue.length)
              for (var Ne = 0; Ne < Ue.length && (!Ue[Ne].hasAttribute("href") || (Fe = Ue[Ne].getAttribute("href")).charAt(0) == "#"); ++Ne)
                ;
            Fe && Fe.charAt(0) != "#" && (le.l = { Target: Fe }), l.dense ? (t[R + d] || (t[R + d] = []), t[R + d][I + _] = le) : t[$t({ c: I + _, r: R + d })] = le, m.e.c < I + _ && (m.e.c = I + _), I += E;
          }
        }
        ++R;
      }
      return b.length && (t["!merges"] = (t["!merges"] || []).concat(b)), m.e.r = Math.max(m.e.r, R - 1 + d), t["!ref"] = Xt(m), p <= R && (t["!fullref"] = Xt((m.e.r = u.length - y + R - 1 + d, m))), t;
    }
    function th(t, n) {
      return eh((n || {}).dense ? [] : {}, t, n);
    }
    function rh(t) {
      var a, n = "", a = (a = t).ownerDocument.defaultView && typeof a.ownerDocument.defaultView.getComputedStyle == "function" ? a.ownerDocument.defaultView.getComputedStyle : typeof getComputedStyle == "function" ? getComputedStyle : null;
      return (n = (n = a ? a(t).getPropertyValue("display") : n) || t.style && t.style.display) === "none";
    }
    var nh = { day: ["d", "dd"], month: ["m", "mm"], year: ["y", "yy"], hours: ["h", "hh"], minutes: ["m", "mm"], seconds: ["s", "ss"], "am-pm": ["A/P", "AM/PM"], "day-of-week": ["ddd", "dddd"], era: ["e", "ee"], quarter: ["\\Qm", 'm\\"th quarter"'] };
    function ah(t, n) {
      var a = n || {}, l, d, _, u, p, m = Bl(t), f = [], E = { name: "" }, b = "", T = 0, v = {}, y = [], R = a.dense ? [] : {}, P = { value: "" }, I = "", A = 0, M = [], F = -1, B = -1, re = { s: { r: 1e6, c: 1e7 }, e: { r: 0, c: 0 } }, me = 0, le = {}, be = [], Fe = {}, Ue = [], Ne = 1, ze = 1, ut = [], lt = { Names: [] }, et = {}, nt = ["", ""], je = [], Ye = {}, ht = "", Tt = 0, xt = !1, Zt = !1, ft = 0;
      for (go.lastIndex = 0, m = m.replace(/<!--([\s\S]*?)-->/gm, "").replace(/<!DOCTYPE[^\[]*\[[^\]]*\]>/gm, ""); u = go.exec(m); )
        switch (u[3] = u[3].replace(/_.*$/, "")) {
          case "table":
          case "工作表":
            u[1] === "/" ? (re.e.c >= re.s.c && re.e.r >= re.s.r ? R["!ref"] = Xt(re) : R["!ref"] = "A1:A1", 0 < a.sheetRows && a.sheetRows <= re.e.r && (R["!fullref"] = R["!ref"], re.e.r = a.sheetRows - 1, R["!ref"] = Xt(re)), be.length && (R["!merges"] = be), Ue.length && (R["!rows"] = Ue), _.name = _.名称 || _.name, typeof JSON < "u" && JSON.stringify(_), y.push(_.name), v[_.name] = R, Zt = !1) : u[0].charAt(u[0].length - 2) !== "/" && (_ = Ht(u[0], !1), F = B = -1, re.s.r = re.s.c = 1e7, re.e.r = re.e.c = 0, R = a.dense ? [] : {}, be = [], Ue = [], Zt = !0);
            break;
          case "table-row-group":
            u[1] === "/" ? --me : ++me;
            break;
          case "table-row":
          case "行":
            if (u[1] === "/") {
              F += Ne, Ne = 1;
              break;
            }
            if ((We = Ht(u[0], !1)).行号 ? F = We.行号 - 1 : F == -1 && (F = 0), (Ne = +We["number-rows-repeated"] || 1) < 10)
              for (ft = 0; ft < Ne; ++ft)
                0 < me && (Ue[F + ft] = { level: me });
            B = -1;
            break;
          case "covered-table-cell":
            u[1] !== "/" && ++B, a.sheetStubs && (a.dense ? (R[F] || (R[F] = []), R[F][B] = { t: "z" }) : R[$t({ r: F, c: B })] = { t: "z" }), I = "", M = [];
            break;
          case "table-cell":
          case "数据":
            if (u[0].charAt(u[0].length - 2) === "/")
              ++B, P = Ht(u[0], !1), ze = parseInt(P["number-columns-repeated"] || "1", 10), p = { t: "z", v: null }, P.formula && a.cellFormula != 0 && (p.f = NE(mr(P.formula))), (P.数据类型 || P["value-type"]) == "string" && (p.t = "s", p.v = mr(P["string-value"] || ""), a.dense ? (R[F] || (R[F] = []), R[F][B] = p) : R[$t({ r: F, c: B })] = p), B += ze - 1;
            else if (u[1] !== "/") {
              I = "", A = 0, M = [], ze = 1;
              var We = Ne ? F + Ne - 1 : F;
              if (++B > re.e.c && (re.e.c = B), B < re.s.c && (re.s.c = B), F < re.s.r && (re.s.r = F), We > re.e.r && (re.e.r = We), je = [], Ye = {}, p = { t: (P = Ht(u[0], !1)).数据类型 || P["value-type"], v: null }, a.cellFormula)
                if (P.formula && (P.formula = mr(P.formula)), P["number-matrix-columns-spanned"] && P["number-matrix-rows-spanned"] && (Fe = { s: { r: F, c: B }, e: { r: F + (parseInt(P["number-matrix-rows-spanned"], 10) || 0) - 1, c: B + (parseInt(P["number-matrix-columns-spanned"], 10) || 0) - 1 } }, p.F = Xt(Fe), ut.push([Fe, p.F])), P.formula)
                  p.f = NE(P.formula);
                else
                  for (ft = 0; ft < ut.length; ++ft)
                    F >= ut[ft][0].s.r && F <= ut[ft][0].e.r && B >= ut[ft][0].s.c && B <= ut[ft][0].e.c && (p.F = ut[ft][1]);
              switch ((P["number-columns-spanned"] || P["number-rows-spanned"]) && (Fe = { s: { r: F, c: B }, e: { r: F + (parseInt(P["number-rows-spanned"], 10) || 0) - 1, c: B + (parseInt(P["number-columns-spanned"], 10) || 0) - 1 } }, be.push(Fe)), P["number-columns-repeated"] && (ze = parseInt(P["number-columns-repeated"], 10)), p.t) {
                case "boolean":
                  p.t = "b", p.v = Lr(P["boolean-value"]);
                  break;
                case "float":
                case "percentage":
                case "currency":
                  p.t = "n", p.v = parseFloat(P.value);
                  break;
                case "date":
                  p.t = "d", p.v = Br(P["date-value"]), a.cellDates || (p.t = "n", p.v = on(p.v)), p.z = "m/d/yy";
                  break;
                case "time":
                  p.t = "n", p.v = function(ir) {
                    var Or = 0, Zr = 0, oe = !1, yr = ir.match(/P([0-9\.]+Y)?([0-9\.]+M)?([0-9\.]+D)?T([0-9\.]+H)?([0-9\.]+M)?([0-9\.]+S)?/);
                    if (!yr)
                      throw new Error("|" + ir + "| is not an ISO8601 Duration");
                    for (var Rr = 1; Rr != yr.length; ++Rr)
                      if (yr[Rr]) {
                        switch (Zr = 1, 3 < Rr && (oe = !0), yr[Rr].slice(yr[Rr].length - 1)) {
                          case "Y":
                            throw new Error("Unsupported ISO Duration Field: " + yr[Rr].slice(yr[Rr].length - 1));
                          case "D":
                            Zr *= 24;
                          case "H":
                            Zr *= 60;
                          case "M":
                            if (!oe)
                              throw new Error("Unsupported ISO Duration Field: M");
                            Zr *= 60;
                        }
                        Or += Zr * parseInt(yr[Rr], 10);
                      }
                    return Or;
                  }(P["time-value"]) / 86400, a.cellDates && (p.t = "d", p.v = lo(p.v)), p.z = "HH:MM:SS";
                  break;
                case "number":
                  p.t = "n", p.v = parseFloat(P.数据数值);
                  break;
                default:
                  if (p.t !== "string" && p.t !== "text" && p.t)
                    throw new Error("Unsupported value type " + p.t);
                  p.t = "s", P["string-value"] != null && (I = mr(P["string-value"]), M = []);
              }
            } else {
              if (xt = !1, p.t === "s" && (p.v = I || "", M.length && (p.R = M), xt = A == 0), et.Target && (p.l = et), 0 < je.length && (p.c = je, je = []), I && a.cellText !== !1 && (p.w = I), xt && (p.t = "z", delete p.v), (!xt || a.sheetStubs) && !(a.sheetRows && a.sheetRows <= F))
                for (var Wt = 0; Wt < Ne; ++Wt) {
                  if (ze = parseInt(P["number-columns-repeated"] || "1", 10), a.dense)
                    for (R[F + Wt] || (R[F + Wt] = []), R[F + Wt][B] = Wt == 0 ? p : xr(p); 0 < --ze; )
                      R[F + Wt][B + ze] = xr(p);
                  else
                    for (R[$t({ r: F + Wt, c: B })] = p; 0 < --ze; )
                      R[$t({ r: F + Wt, c: B + ze })] = xr(p);
                  re.e.c <= B && (re.e.c = B);
                }
              B += (ze = parseInt(P["number-columns-repeated"] || "1", 10)) - 1, ze = 0, p = {}, I = "", M = [];
            }
            et = {};
            break;
          case "document":
          case "document-content":
          case "电子表格文档":
          case "spreadsheet":
          case "主体":
          case "scripts":
          case "styles":
          case "font-face-decls":
          case "master-styles":
            if (u[1] === "/") {
              if ((l = f.pop())[0] !== u[3])
                throw "Bad state: " + l;
            } else
              u[0].charAt(u[0].length - 2) !== "/" && f.push([u[3], !0]);
            break;
          case "annotation":
            if (u[1] === "/") {
              if ((l = f.pop())[0] !== u[3])
                throw "Bad state: " + l;
              Ye.t = I, M.length && (Ye.R = M), Ye.a = ht, je.push(Ye);
            } else
              u[0].charAt(u[0].length - 2) !== "/" && f.push([u[3], !1]);
            I = ht = "", A = Tt = 0, M = [];
            break;
          case "creator":
            u[1] === "/" ? ht = m.slice(Tt, u.index) : Tt = u.index + u[0].length;
            break;
          case "meta":
          case "元数据":
          case "settings":
          case "config-item-set":
          case "config-item-map-indexed":
          case "config-item-map-entry":
          case "config-item-map-named":
          case "shapes":
          case "frame":
          case "text-box":
          case "image":
          case "data-pilot-tables":
          case "list-style":
          case "form":
          case "dde-links":
          case "event-listeners":
          case "chart":
            if (u[1] === "/") {
              if ((l = f.pop())[0] !== u[3])
                throw "Bad state: " + l;
            } else
              u[0].charAt(u[0].length - 2) !== "/" && f.push([u[3], !1]);
            I = "", A = 0, M = [];
            break;
          case "scientific-number":
          case "currency-symbol":
          case "currency-style":
            break;
          case "number-style":
          case "percentage-style":
          case "date-style":
          case "time-style":
            if (u[1] === "/") {
              if (le[E.name] = b, (l = f.pop())[0] !== u[3])
                throw "Bad state: " + l;
            } else
              u[0].charAt(u[0].length - 2) !== "/" && (b = "", E = Ht(u[0], !1), f.push([u[3], !0]));
            break;
          case "script":
          case "libraries":
          case "automatic-styles":
            break;
          case "default-style":
          case "page-layout":
          case "style":
          case "map":
          case "font-face":
          case "paragraph-properties":
          case "table-properties":
          case "table-column-properties":
          case "table-row-properties":
          case "table-cell-properties":
            break;
          case "number":
            switch (f[f.length - 1][0]) {
              case "time-style":
              case "date-style":
                d = Ht(u[0], !1), b += nh[u[3]][d.style === "long" ? 1 : 0];
            }
            break;
          case "fraction":
            break;
          case "day":
          case "month":
          case "year":
          case "era":
          case "day-of-week":
          case "week-of-year":
          case "quarter":
          case "hours":
          case "minutes":
          case "seconds":
          case "am-pm":
            switch (f[f.length - 1][0]) {
              case "time-style":
              case "date-style":
                d = Ht(u[0], !1), b += nh[u[3]][d.style === "long" ? 1 : 0];
            }
            break;
          case "boolean-style":
          case "boolean":
          case "text-style":
            break;
          case "text":
            if (u[0].slice(-2) === "/>")
              break;
            if (u[1] === "/")
              switch (f[f.length - 1][0]) {
                case "number-style":
                case "date-style":
                case "time-style":
                  b += m.slice(T, u.index);
              }
            else
              T = u.index + u[0].length;
            break;
          case "named-range":
            nt = Oc((d = Ht(u[0], !1))["cell-range-address"]);
            var dr = { Name: d.name, Ref: nt[0] + "!" + nt[1] };
            Zt && (dr.Sheet = y.length), lt.Names.push(dr);
            break;
          case "text-content":
          case "text-properties":
          case "embedded-text":
            break;
          case "body":
          case "电子表格":
          case "forms":
          case "table-column":
          case "table-header-rows":
          case "table-rows":
          case "table-column-group":
          case "table-header-columns":
          case "table-columns":
          case "null-date":
          case "graphic-properties":
          case "calculation-settings":
          case "named-expressions":
          case "label-range":
          case "label-ranges":
          case "named-expression":
          case "sort":
          case "sort-by":
          case "sort-groups":
          case "tab":
          case "line-break":
          case "span":
            break;
          case "p":
          case "文本串":
            if (-1 < ["master-styles"].indexOf(f[f.length - 1][0]))
              break;
            u[1] !== "/" || P && P["string-value"] ? (Ht(u[0], !1), A = u.index + u[0].length) : (dr = (dr = m.slice(A, u.index)).replace(/[\t\r\n]/g, " ").trim().replace(/ +/g, " ").replace(/<text:s\/>/g, " ").replace(/<text:s text:c="(\d+)"\/>/g, function(ir, Or) {
              return Array(parseInt(Or, 10) + 1).join(" ");
            }).replace(/<text:tab[^>]*\/>/g, "	").replace(/<text:line-break\/>/g, `
`), dr = [mr(dr.replace(/<[^>]*>/g, ""))], I = (0 < I.length ? I + `
` : "") + dr[0]);
            break;
          case "s":
            break;
          case "database-range":
            if (u[1] === "/")
              break;
            try {
              v[(nt = Oc(Ht(u[0])["target-range-address"]))[0]]["!autofilter"] = { ref: nt[1] };
            } catch {
            }
            break;
          case "date":
          case "object":
            break;
          case "title":
          case "标题":
          case "desc":
          case "binary-data":
          case "table-source":
          case "scenario":
          case "iteration":
          case "content-validations":
          case "content-validation":
          case "help-message":
          case "error-message":
          case "database-ranges":
          case "filter":
          case "filter-and":
          case "filter-or":
          case "filter-condition":
          case "list-level-style-bullet":
          case "list-level-style-number":
          case "list-level-properties":
            break;
          case "sender-firstname":
          case "sender-lastname":
          case "sender-initials":
          case "sender-title":
          case "sender-position":
          case "sender-email":
          case "sender-phone-private":
          case "sender-fax":
          case "sender-company":
          case "sender-phone-work":
          case "sender-street":
          case "sender-city":
          case "sender-postal-code":
          case "sender-country":
          case "sender-state-or-province":
          case "author-name":
          case "author-initials":
          case "chapter":
          case "file-name":
          case "template-name":
          case "sheet-name":
          case "event-listener":
            break;
          case "initial-creator":
          case "creation-date":
          case "print-date":
          case "generator":
          case "document-statistic":
          case "user-defined":
          case "editing-duration":
          case "editing-cycles":
          case "config-item":
          case "page-number":
          case "page-count":
          case "time":
          case "cell-range-source":
          case "detective":
          case "operation":
          case "highlighted-range":
            break;
          case "data-pilot-table":
          case "source-cell-range":
          case "source-service":
          case "data-pilot-field":
          case "data-pilot-level":
          case "data-pilot-subtotals":
          case "data-pilot-subtotal":
          case "data-pilot-members":
          case "data-pilot-member":
          case "data-pilot-display-info":
          case "data-pilot-sort-info":
          case "data-pilot-layout-info":
          case "data-pilot-field-reference":
          case "data-pilot-groups":
          case "data-pilot-group":
          case "data-pilot-group-member":
          case "rect":
            break;
          case "dde-connection-decls":
          case "dde-connection-decl":
          case "dde-link":
          case "dde-source":
          case "properties":
          case "property":
            break;
          case "a":
            if (u[1] !== "/") {
              if (!(et = Ht(u[0], !1)).href)
                break;
              et.Target = mr(et.href), delete et.href, et.Target.charAt(0) == "#" && -1 < et.Target.indexOf(".") ? (nt = Oc(et.Target.slice(1)), et.Target = "#" + nt[0] + "!" + nt[1]) : et.Target.match(/^\.\.[\\\/]/) && (et.Target = et.Target.slice(3));
            }
            break;
          case "table-protection":
          case "data-pilot-grand-total":
          case "office-document-common-attrs":
            break;
          default:
            switch (u[2]) {
              case "dc:":
              case "calcext:":
              case "loext:":
              case "ooo:":
              case "chartooo:":
              case "draw:":
              case "style:":
              case "chart:":
              case "form:":
              case "uof:":
              case "表:":
              case "字:":
                break;
              default:
                if (a.WTF)
                  throw new Error(u);
            }
        }
      return t = { Sheets: v, SheetNames: y, Workbook: lt }, a.bookSheets && delete t.Sheets, t;
    }
    function ih(t, n) {
      n = n || {}, Xn(t, "META-INF/manifest.xml") && function(l, d) {
        for (var _, u, p = Bl(l); _ = go.exec(p); )
          switch (_[3]) {
            case "manifest":
              break;
            case "file-entry":
              if ((u = Ht(_[0], !1)).path == "/" && u.type !== uC)
                throw new Error("This OpenDocument is not a spreadsheet");
              break;
            case "encryption-data":
            case "algorithm":
            case "start-key-generation":
            case "key-derivation":
              throw new Error("Unsupported ODS Encryption");
            default:
              if (d && d.WTF)
                throw _;
          }
      }(en(t, "META-INF/manifest.xml"), n);
      var a = $n(t, "content.xml");
      if (!a)
        throw new Error("Missing content.xml in ODS / UOF file");
      return n = ah(Cr(a), n), Xn(t, "meta.xml") && (n.Props = Af(en(t, "meta.xml"))), n;
    }
    function oh(t, n) {
      return ah(t, n);
    }
    var GN = function() {
      var t = ["<office:master-styles>", '<style:master-page style:name="mp1" style:page-layout-name="mp1">', "<style:header/>", '<style:header-left style:display="false"/>', "<style:footer/>", '<style:footer-left style:display="false"/>', "</style:master-page>", "</office:master-styles>"].join(""), n = "<office:document-styles " + fo({ "xmlns:office": "urn:oasis:names:tc:opendocument:xmlns:office:1.0", "xmlns:table": "urn:oasis:names:tc:opendocument:xmlns:table:1.0", "xmlns:style": "urn:oasis:names:tc:opendocument:xmlns:style:1.0", "xmlns:text": "urn:oasis:names:tc:opendocument:xmlns:text:1.0", "xmlns:draw": "urn:oasis:names:tc:opendocument:xmlns:drawing:1.0", "xmlns:fo": "urn:oasis:names:tc:opendocument:xmlns:xsl-fo-compatible:1.0", "xmlns:xlink": "http://www.w3.org/1999/xlink", "xmlns:dc": "http://purl.org/dc/elements/1.1/", "xmlns:number": "urn:oasis:names:tc:opendocument:xmlns:datastyle:1.0", "xmlns:svg": "urn:oasis:names:tc:opendocument:xmlns:svg-compatible:1.0", "xmlns:of": "urn:oasis:names:tc:opendocument:xmlns:of:1.2", "office:version": "1.2" }) + ">" + t + "</office:document-styles>";
      return function() {
        return Qr + n;
      };
    }(), sh = /* @__PURE__ */ function() {
      function t(a, l, d) {
        var _ = [];
        _.push('      <table:table table:name="' + Ar(l.SheetNames[d]) + `" table:style-name="ta1">
`);
        var u = 0, p = 0, m = Un(a["!ref"] || "A1"), f = a["!merges"] || [], E = 0, b = Array.isArray(a);
        if (a["!cols"])
          for (p = 0; p <= m.e.c; ++p)
            _.push("        <table:table-column" + (a["!cols"][p] ? ' table:style-name="co' + a["!cols"][p].ods + '"' : "") + `></table:table-column>
`);
        for (var T = "", v = a["!rows"] || [], u = 0; u < m.s.r; ++u)
          T = v[u] ? ' table:style-name="ro' + v[u].ods + '"' : "", _.push("        <table:table-row" + T + `></table:table-row>
`);
        for (; u <= m.e.r; ++u) {
          for (T = v[u] ? ' table:style-name="ro' + v[u].ods + '"' : "", _.push("        <table:table-row" + T + `>
`), p = 0; p < m.s.c; ++p)
            _.push(n);
          for (; p <= m.e.c; ++p) {
            for (var y = !1, R = {}, P = "", E = 0; E != f.length; ++E)
              if (!(f[E].s.c > p || f[E].s.r > u || f[E].e.c < p || f[E].e.r < u)) {
                f[E].s.c == p && f[E].s.r == u || (y = !0), R["table:number-columns-spanned"] = f[E].e.c - f[E].s.c + 1, R["table:number-rows-spanned"] = f[E].e.r - f[E].s.r + 1;
                break;
              }
            if (y)
              _.push(`          <table:covered-table-cell/>
`);
            else {
              var I = $t({ r: u, c: p }), A = b ? (a[u] || [])[p] : a[I];
              if (A && A.f && (R["table:formula"] = Ar(("of:=" + A.f.replace(Cc, "$1[.$2$3$4$5]").replace(/\]:\[/g, ":")).replace(/;/g, "|").replace(/,/g, ";")), A.F && A.F.slice(0, I.length) == I && (M = Un(A.F), R["table:number-matrix-columns-spanned"] = M.e.c - M.s.c + 1, R["table:number-matrix-rows-spanned"] = M.e.r - M.s.r + 1)), A) {
                switch (A.t) {
                  case "b":
                    P = A.v ? "TRUE" : "FALSE", R["office:value-type"] = "boolean", R["office:boolean-value"] = A.v ? "true" : "false";
                    break;
                  case "n":
                    P = A.w || String(A.v || 0), R["office:value-type"] = "float", R["office:value"] = A.v || 0;
                    break;
                  case "s":
                  case "str":
                    P = A.v == null ? "" : A.v, R["office:value-type"] = "string";
                    break;
                  case "d":
                    P = A.w || Br(A.v).toISOString(), R["office:value-type"] = "date", R["office:date-value"] = Br(A.v).toISOString(), R["table:style-name"] = "ce1";
                    break;
                  default:
                    _.push(n);
                    continue;
                }
                var M, I = Ar(P).replace(/  +/g, function(B) {
                  return '<text:s text:c="' + B.length + '"/>';
                }).replace(/\t/g, "<text:tab/>").replace(/\n/g, "</text:p><text:p>").replace(/^ /, "<text:s/>").replace(/ $/, "<text:s/>");
                A.l && A.l.Target && (I = it("text:a", I, { "xlink:href": (M = (M = (M = A.l.Target).charAt(0) == "#" ? "#" + M.slice(1).replace(/\./, "!") : M).charAt(0) != "#" && !M.match(/^\w+:/) ? "../" + M : M).replace(/&/g, "&amp;") })), _.push("          " + it("table:table-cell", it("text:p", I, {}), R) + `
`);
              } else
                _.push(n);
            }
          }
          _.push(`        </table:table-row>
`);
        }
        return _.push(`      </table:table>
`), _.join("");
      }
      var n = `          <table:table-cell />
`;
      return function(a, l) {
        var d = [Qr], _ = fo({ "xmlns:office": "urn:oasis:names:tc:opendocument:xmlns:office:1.0", "xmlns:table": "urn:oasis:names:tc:opendocument:xmlns:table:1.0", "xmlns:style": "urn:oasis:names:tc:opendocument:xmlns:style:1.0", "xmlns:text": "urn:oasis:names:tc:opendocument:xmlns:text:1.0", "xmlns:draw": "urn:oasis:names:tc:opendocument:xmlns:drawing:1.0", "xmlns:fo": "urn:oasis:names:tc:opendocument:xmlns:xsl-fo-compatible:1.0", "xmlns:xlink": "http://www.w3.org/1999/xlink", "xmlns:dc": "http://purl.org/dc/elements/1.1/", "xmlns:meta": "urn:oasis:names:tc:opendocument:xmlns:meta:1.0", "xmlns:number": "urn:oasis:names:tc:opendocument:xmlns:datastyle:1.0", "xmlns:presentation": "urn:oasis:names:tc:opendocument:xmlns:presentation:1.0", "xmlns:svg": "urn:oasis:names:tc:opendocument:xmlns:svg-compatible:1.0", "xmlns:chart": "urn:oasis:names:tc:opendocument:xmlns:chart:1.0", "xmlns:dr3d": "urn:oasis:names:tc:opendocument:xmlns:dr3d:1.0", "xmlns:math": "http://www.w3.org/1998/Math/MathML", "xmlns:form": "urn:oasis:names:tc:opendocument:xmlns:form:1.0", "xmlns:script": "urn:oasis:names:tc:opendocument:xmlns:script:1.0", "xmlns:ooo": "http://openoffice.org/2004/office", "xmlns:ooow": "http://openoffice.org/2004/writer", "xmlns:oooc": "http://openoffice.org/2004/calc", "xmlns:dom": "http://www.w3.org/2001/xml-events", "xmlns:xforms": "http://www.w3.org/2002/xforms", "xmlns:xsd": "http://www.w3.org/2001/XMLSchema", "xmlns:xsi": "http://www.w3.org/2001/XMLSchema-instance", "xmlns:sheet": "urn:oasis:names:tc:opendocument:sh33tjs:1.0", "xmlns:rpt": "http://openoffice.org/2005/report", "xmlns:of": "urn:oasis:names:tc:opendocument:xmlns:of:1.2", "xmlns:xhtml": "http://www.w3.org/1999/xhtml", "xmlns:grddl": "http://www.w3.org/2003/g/data-view#", "xmlns:tableooo": "http://openoffice.org/2009/table", "xmlns:drawooo": "http://openoffice.org/2010/draw", "xmlns:calcext": "urn:org:documentfoundation:names:experimental:calc:xmlns:calcext:1.0", "xmlns:loext": "urn:org:documentfoundation:names:experimental:office:xmlns:loext:1.0", "xmlns:field": "urn:openoffice:names:experimental:ooo-ms-interop:xmlns:field:1.0", "xmlns:formx": "urn:openoffice:names:experimental:ooxml-odf-interop:xmlns:form:1.0", "xmlns:css3t": "http://www.w3.org/TR/css3-text/", "office:version": "1.2" }), u = fo({ "xmlns:config": "urn:oasis:names:tc:opendocument:xmlns:config:1.0", "office:mimetype": "application/vnd.oasis.opendocument.spreadsheet" });
        l.bookType == "fods" ? (d.push("<office:document" + _ + u + `>
`), d.push(Nf().replace(/office:document-meta/g, "office:meta"))) : d.push("<office:document-content" + _ + `>
`), function(m, f) {
          m.push(` <office:automatic-styles>
`), m.push(`  <number:date-style style:name="N37" number:automatic-order="true">
`), m.push(`   <number:month number:style="long"/>
`), m.push(`   <number:text>/</number:text>
`), m.push(`   <number:day number:style="long"/>
`), m.push(`   <number:text>/</number:text>
`), m.push(`   <number:year/>
`), m.push(`  </number:date-style>
`);
          var E = 0;
          f.SheetNames.map(function(T) {
            return f.Sheets[T];
          }).forEach(function(T) {
            if (T && T["!cols"]) {
              for (var v = 0; v < T["!cols"].length; ++v)
                if (T["!cols"][v]) {
                  var y = T["!cols"][v];
                  if (y.width == null && y.wpx == null && y.wch == null)
                    continue;
                  $a(y), y.ods = E, y = T["!cols"][v].wpx + "px", m.push('  <style:style style:name="co' + E + `" style:family="table-column">
`), m.push('   <style:table-column-properties fo:break-before="auto" style:column-width="' + y + `"/>
`), m.push(`  </style:style>
`), ++E;
                }
            }
          });
          var b = 0;
          f.SheetNames.map(function(T) {
            return f.Sheets[T];
          }).forEach(function(T) {
            if (T && T["!rows"])
              for (var v, y = 0; y < T["!rows"].length; ++y)
                T["!rows"][y] && (T["!rows"][y].ods = b, v = T["!rows"][y].hpx + "px", m.push('  <style:style style:name="ro' + b + `" style:family="table-row">
`), m.push('   <style:table-row-properties fo:break-before="auto" style:row-height="' + v + `"/>
`), m.push(`  </style:style>
`), ++b);
          }), m.push(`  <style:style style:name="ta1" style:family="table" style:master-page-name="mp1">
`), m.push(`   <style:table-properties table:display="true" style:writing-mode="lr-tb"/>
`), m.push(`  </style:style>
`), m.push(`  <style:style style:name="ce1" style:family="table-cell" style:parent-style-name="Default" style:data-style-name="N37"/>
`), m.push(` </office:automatic-styles>
`);
        }(d, a), d.push(`  <office:body>
`), d.push(`    <office:spreadsheet>
`);
        for (var p = 0; p != a.SheetNames.length; ++p)
          d.push(t(a.Sheets[a.SheetNames[p]], a, p));
        return d.push(`    </office:spreadsheet>
`), d.push(`  </office:body>
`), l.bookType == "fods" ? d.push("</office:document>") : d.push("</office:document-content>"), d.join("");
      };
    }();
    function lh(t, n) {
      if (n.bookType == "fods")
        return sh(t, n);
      var a = ss(), l = [], d = [];
      return Qt(a, "mimetype", "application/vnd.oasis.opendocument.spreadsheet"), Qt(a, "content.xml", sh(t, n)), l.push(["content.xml", "text/xml"]), d.push(["content.xml", "ContentFile"]), Qt(a, "styles.xml", GN(t, n)), l.push(["styles.xml", "text/xml"]), d.push(["styles.xml", "StylesFile"]), Qt(a, "meta.xml", Qr + Nf()), l.push(["meta.xml", "text/xml"]), d.push(["meta.xml", "MetadataFile"]), Qt(a, "manifest.rdf", function(_) {
        var u = [Qr];
        u.push(`<rdf:RDF xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#">
`);
        for (var p = 0; p != _.length; ++p)
          u.push(Rf(_[p][0], _[p][1])), u.push([`  <rdf:Description rdf:about="">
`, '    <ns0:hasPart xmlns:ns0="http://docs.oasis-open.org/ns/office/1.2/meta/pkg#" rdf:resource="' + _[p][0] + `"/>
`, `  </rdf:Description>
`].join(""));
        return u.push(Rf("", "Document", "pkg")), u.push("</rdf:RDF>"), u.join("");
      }(d)), l.push(["manifest.rdf", "application/rdf+xml"]), Qt(a, "META-INF/manifest.xml", function(_) {
        var u = [Qr];
        u.push(`<manifest:manifest xmlns:manifest="urn:oasis:names:tc:opendocument:xmlns:manifest:1.0" manifest:version="1.2">
`), u.push(`  <manifest:file-entry manifest:full-path="/" manifest:version="1.2" manifest:media-type="application/vnd.oasis.opendocument.spreadsheet"/>
`);
        for (var p = 0; p < _.length; ++p)
          u.push('  <manifest:file-entry manifest:full-path="' + _[p][0] + '" manifest:media-type="' + _[p][1] + `"/>
`);
        return u.push("</manifest:manifest>"), u.join("");
      }(l)), a;
    }
    function Pa(t) {
      return new DataView(t.buffer, t.byteOffset, t.byteLength);
    }
    function Mc(t) {
      return typeof TextDecoder < "u" ? new TextDecoder().decode(t) : Cr(ye(t));
    }
    function ch(t) {
      return typeof TextEncoder < "u" ? new TextEncoder().encode(t) : Pe(Zn(t));
    }
    function Ka(t) {
      var n = t.reduce(function(d, _) {
        return d + _.length;
      }, 0), a = new Uint8Array(n), l = 0;
      return t.forEach(function(d) {
        a.set(d, l), l += d.length;
      }), a;
    }
    function dh(t) {
      return 16843009 * ((t = (858993459 & (t -= t >> 1 & 1431655765)) + (t >> 2 & 858993459)) + (t >> 4) & 252645135) >>> 24;
    }
    function Vo(t, n) {
      var a = n ? n[0] : 0, l = 127 & t[a];
      return 128 <= t[a++] && (l |= (127 & t[a]) << 7, t[a++] < 128 || (l |= (127 & t[a]) << 14, t[a++] < 128 || (l |= (127 & t[a]) << 21, t[a++] < 128 || (l += (127 & t[a]) * Math.pow(2, 28), ++a, t[a++] < 128 || (l += (127 & t[a]) * Math.pow(2, 35), ++a, t[a++] < 128 || (l += (127 & t[a]) * Math.pow(2, 42), ++a, t[a++])))))), n && (n[0] = a), l;
    }
    function Sr(t) {
      var n = new Uint8Array(7);
      n[0] = 127 & t;
      var a = 1;
      return 127 < t && (n[a - 1] |= 128, n[a] = t >> 7 & 127, ++a, t <= 16383 || (n[a - 1] |= 128, n[a] = t >> 14 & 127, ++a, t <= 2097151 || (n[a - 1] |= 128, n[a] = t >> 21 & 127, ++a, t <= 268435455 || (n[a - 1] |= 128, n[a] = t / 256 >>> 21 & 127, ++a, t <= 34359738367 || (n[a - 1] |= 128, n[a] = t / 65536 >>> 21 & 127, ++a, t <= 4398046511103 || (n[a - 1] |= 128, n[a] = t / 16777216 >>> 21 & 127, ++a)))))), n.slice(0, a);
    }
    function Yr(t) {
      var n = 0, a = 127 & t[0];
      return 128 <= t[n++] && (a |= (127 & t[1]) << 7, t[n++] < 128 || (a |= (127 & t[2]) << 14, t[n++] < 128 || (a |= (127 & t[3]) << 21, t[+n] < 128 || (a |= (127 & t[4]) << 28)))), a;
    }
    function cr(t) {
      for (var n = [], a = [0]; a[0] < t.length; ) {
        var l, d = a[0], _ = Vo(t, a), u = 7 & _, p = 0;
        if ((_ = Math.floor(_ / 8)) == 0)
          break;
        switch (u) {
          case 0:
            for (var m = a[0]; 128 <= t[a[0]++]; )
              ;
            l = t.slice(m, a[0]);
            break;
          case 5:
            p = 4, l = t.slice(a[0], a[0] + p), a[0] += p;
            break;
          case 1:
            p = 8, l = t.slice(a[0], a[0] + p), a[0] += p;
            break;
          case 2:
            p = Vo(t, a), l = t.slice(a[0], a[0] + p), a[0] += p;
            break;
          case 3:
          case 4:
          default:
            throw new Error("PB Type ".concat(u, " for Field ").concat(_, " at offset ").concat(d));
        }
        var f = { data: l, type: u };
        n[_] == null ? n[_] = [f] : n[_].push(f);
      }
      return n;
    }
    function Kr(t) {
      var n = [];
      return t.forEach(function(a, l) {
        l != 0 && a.forEach(function(d) {
          d.data && (n.push(Sr(8 * l + d.type)), d.type == 2 && n.push(Sr(d.data.length)), n.push(d.data));
        });
      }), Ka(n);
    }
    function Pc(t, n) {
      return (t == null ? void 0 : t.map(function(a) {
        return n(a.data);
      })) || [];
    }
    function sa(t) {
      for (var n = [], a = [0]; a[0] < t.length; ) {
        var l = Vo(t, a), d = cr(t.slice(a[0], a[0] + l));
        a[0] += l;
        var _ = { id: Yr(d[1][0].data), messages: [] };
        d[2].forEach(function(m) {
          var p = cr(m.data), m = Yr(p[3][0].data);
          _.messages.push({ meta: p, data: t.slice(a[0], a[0] + m) }), a[0] += m;
        }), (l = d[3]) != null && l[0] && (_.merge = 0 < Yr(d[3][0].data) >>> 0), n.push(_);
      }
      return n;
    }
    function gi(t) {
      var n = [];
      return t.forEach(function(a) {
        var l = [[], [{ data: Sr(a.id), type: 0 }], []];
        a.merge != null && (l[3] = [{ data: Sr(+!!a.merge), type: 0 }]);
        var d = [];
        a.messages.forEach(function(_) {
          d.push(_.data), _.meta[3] = [{ type: 0, data: Sr(_.data.length) }], l[2].push({ data: Kr(_.meta), type: 2 });
        }), a = Kr(l), n.push(Sr(a.length)), n.push(a), d.forEach(function(_) {
          return n.push(_);
        });
      }), Ka(n);
    }
    function la(t) {
      for (var n = [], a = 0; a < t.length; ) {
        var l = t[a++], d = t[a] | t[a + 1] << 8 | t[a + 2] << 16;
        a += 3, n.push(function(_, u) {
          if (_ != 0)
            throw new Error("Unexpected Snappy chunk type ".concat(_));
          for (var p = [0], m = Vo(u, p), f = []; p[0] < u.length; ) {
            var E = 3 & u[p[0]];
            if (E != 0) {
              var b = 0, T = 0;
              if (E == 1 ? (T = 4 + (u[p[0]] >> 2 & 7), b = (224 & u[p[0]++]) << 3, b |= u[p[0]++]) : (T = 1 + (u[p[0]++] >> 2), E == 2 ? (b = u[p[0]] | u[p[0] + 1] << 8, p[0] += 2) : (b = (u[p[0]] | u[p[0] + 1] << 8 | u[p[0] + 2] << 16 | u[p[0] + 3] << 24) >>> 0, p[0] += 4)), f = [Ka(f)], b == 0)
                throw new Error("Invalid offset 0");
              if (b > f[0].length)
                throw new Error("Invalid offset beyond length");
              if (b <= T)
                for (f.push(f[0].slice(-b)), T -= b; T >= f[f.length - 1].length; )
                  f.push(f[f.length - 1]), T -= f[f.length - 1].length;
              f.push(f[0].slice(-b, -b + T));
            } else
              E = u[p[0]++] >> 2, E < 60 ? ++E : (b = E - 59, E = u[p[0]], 1 < b && (E |= u[p[0] + 1] << 8), 2 < b && (E |= u[p[0] + 2] << 16), 3 < b && (E |= u[p[0] + 3] << 24), E >>>= 0, E++, p[0] += b), f.push(u.slice(p[0], p[0] + E)), p[0] += E;
          }
          if ((_ = Ka(f)).length != m)
            throw new Error("Unexpected length: ".concat(_.length, " != ").concat(m));
          return _;
        }(l, t.slice(a, a + d))), a += d;
      }
      if (a !== t.length)
        throw new Error("data is not a valid framed stream!");
      return Ka(n);
    }
    function Ei(t) {
      for (var n = [], a = 0; a < t.length; ) {
        var l = Math.min(t.length - a, 268435455), d = new Uint8Array(4);
        n.push(d);
        var _ = Sr(l), u = _.length;
        n.push(_), l <= 60 ? (u++, n.push(new Uint8Array([l - 1 << 2]))) : l <= 256 ? (u += 2, n.push(new Uint8Array([240, l - 1 & 255]))) : l <= 65536 ? (u += 3, n.push(new Uint8Array([244, l - 1 & 255, l - 1 >> 8 & 255]))) : l <= 16777216 ? (u += 4, n.push(new Uint8Array([248, l - 1 & 255, l - 1 >> 8 & 255, l - 1 >> 16 & 255]))) : l <= 4294967296 && (u += 5, n.push(new Uint8Array([252, l - 1 & 255, l - 1 >> 8 & 255, l - 1 >> 16 & 255, l - 1 >>> 24 & 255]))), n.push(t.slice(a, a + l)), u += l, d[0] = 0, d[1] = 255 & u, d[2] = u >> 8 & 255, d[3] = u >> 16 & 255, a += l;
      }
      return Ka(n);
    }
    function VN(t, n, a) {
      var l, d = Pa(t), _ = d.getUint32(8, !0), u = 12, p = -1, m = -1, f = NaN, E = NaN, b = new Date(2001, 0, 1);
      switch (1 & _ && (f = function(T, v) {
        for (var y = (127 & T[v + 15]) << 7 | T[v + 14] >> 1, R = 1 & T[v + 14], P = v + 13; v <= P; --P)
          R = 256 * R + T[P];
        return (128 & T[v + 15] ? -R : R) * Math.pow(10, y - 6176);
      }(t, u), u += 16), 2 & _ && (E = d.getFloat64(u, !0), u += 8), 4 & _ && (b.setTime(b.getTime() + 1e3 * d.getFloat64(u, !0)), u += 8), 8 & _ && (m = d.getUint32(u, !0), u += 4), 16 & _ && (p = d.getUint32(u, !0), u += 4), t[1]) {
        case 0:
          break;
        case 2:
          l = { t: "n", v: f };
          break;
        case 3:
          l = { t: "s", v: n[m] };
          break;
        case 5:
          l = { t: "d", v: b };
          break;
        case 6:
          l = { t: "b", v: 0 < E };
          break;
        case 7:
          l = { t: "n", v: E / 86400 };
          break;
        case 8:
          l = { t: "e", v: 0 };
          break;
        case 9:
          if (!(-1 < p))
            throw new Error("Unsupported cell type ".concat(t[1], " : ").concat(31 & _, " : ").concat(t.slice(0, 4)));
          l = { t: "s", v: a[p] };
          break;
        case 10:
          l = { t: "n", v: f };
          break;
        default:
          throw new Error("Unsupported cell type ".concat(t[1], " : ").concat(31 & _, " : ").concat(t.slice(0, 4)));
      }
      return l;
    }
    function kc(t, n) {
      var a = new Uint8Array(32), l = Pa(a), d = 12, _ = 0;
      switch (a[0] = 5, t.t) {
        case "n":
          a[1] = 2, function(u, p, m) {
            var f = Math.floor(m == 0 ? 0 : Math.LOG10E * Math.log(Math.abs(m))) + 6176 - 16, E = m / Math.pow(10, f - 6176);
            u[p + 15] |= f >> 7, u[p + 14] |= (127 & f) << 1;
            for (var b = 0; 1 <= E; ++b, E /= 256)
              u[p + b] = 255 & E;
            u[p + 15] |= 0 <= m ? 0 : 128;
          }(a, d, t.v), _ |= 1, d += 16;
          break;
        case "b":
          a[1] = 6, l.setFloat64(d, t.v ? 1 : 0, !0), _ |= 2, d += 8;
          break;
        case "s":
          if (n.indexOf(t.v) == -1)
            throw new Error("Value ".concat(t.v, " missing from SST!"));
          a[1] = 3, l.setUint32(d, n.indexOf(t.v), !0), _ |= 8, d += 4;
          break;
        default:
          throw "unsupported cell type " + t.t;
      }
      return l.setUint32(8, _, !0), a.slice(0, d);
    }
    function Fc(t, n) {
      var a = new Uint8Array(32), l = Pa(a), d = 12, _ = 0;
      switch (a[0] = 3, t.t) {
        case "n":
          a[2] = 2, l.setFloat64(d, t.v, !0), _ |= 32, d += 8;
          break;
        case "b":
          a[2] = 6, l.setFloat64(d, t.v ? 1 : 0, !0), _ |= 32, d += 8;
          break;
        case "s":
          if (n.indexOf(t.v) == -1)
            throw new Error("Value ".concat(t.v, " missing from SST!"));
          a[2] = 3, l.setUint32(d, n.indexOf(t.v), !0), _ |= 16, d += 4;
          break;
        default:
          throw "unsupported cell type " + t.t;
      }
      return l.setUint32(4, _, !0), a.slice(0, d);
    }
    function YN(t, n, a) {
      switch (t[0]) {
        case 0:
        case 1:
        case 2:
        case 3:
          return function(l, d, _, u) {
            var p, m = Pa(l), f = m.getUint32(4, !0), E = (1 < u ? 12 : 8) + 4 * dh(f & (1 < u ? 3470 : 398)), b = -1, T = -1, v = NaN, y = new Date(2001, 0, 1);
            switch (512 & f && (b = m.getUint32(E, !0), E += 4), E += 4 * dh(f & (1 < u ? 12288 : 4096)), 16 & f && (T = m.getUint32(E, !0), E += 4), 32 & f && (v = m.getFloat64(E, !0), E += 8), 64 & f && (y.setTime(y.getTime() + 1e3 * m.getFloat64(E, !0)), E += 8), l[2]) {
              case 0:
                break;
              case 2:
                p = { t: "n", v };
                break;
              case 3:
                p = { t: "s", v: d[T] };
                break;
              case 5:
                p = { t: "d", v: y };
                break;
              case 6:
                p = { t: "b", v: 0 < v };
                break;
              case 7:
                p = { t: "n", v: v / 86400 };
                break;
              case 8:
                p = { t: "e", v: 0 };
                break;
              case 9:
                if (-1 < b)
                  p = { t: "s", v: _[b] };
                else if (-1 < T)
                  p = { t: "s", v: d[T] };
                else {
                  if (isNaN(v))
                    throw new Error("Unsupported cell type ".concat(l.slice(0, 4)));
                  p = { t: "n", v };
                }
                break;
              default:
                throw new Error("Unsupported cell type ".concat(l.slice(0, 4)));
            }
            return p;
          }(t, n, a, t[0]);
        case 5:
          return VN(t, n, a);
        default:
          throw new Error("Unsupported payload version ".concat(t[0]));
      }
    }
    function An(t) {
      return Vo(cr(t)[1][0].data);
    }
    function uh(t, l) {
      var l = cr(l.data), a = Yr(l[1][0].data), l = l[3], d = [];
      return (l || []).forEach(function(_) {
        var u = cr(_.data), p = Yr(u[1][0].data) >>> 0;
        switch (a) {
          case 1:
            d[p] = Mc(u[3][0].data);
            break;
          case 8:
            var f = cr(t[An(u[9][0].data)][0].data), m = t[An(f[1][0].data)][0], f = Yr(m.meta[1][0].data);
            if (f != 2001)
              throw new Error("2000 unexpected reference to ".concat(f));
            m = cr(m.data), d[p] = m[3].map(function(E) {
              return Mc(E.data);
            }).join("");
        }
      }), d;
    }
    function HN(t, d) {
      var a = cr(d.data), l = (d = a == null ? void 0 : a[7]) != null && d[0] ? 0 < Yr(a[7][0].data) >>> 0 ? 1 : 0 : -1, d = Pc(a[5], function(_) {
        return function(u, p) {
          var m, f, E, b = cr(u), T = Yr(b[1][0].data) >>> 0, v = Yr(b[2][0].data) >>> 0, y = ((u = (y = b[8]) == null ? void 0 : y[0]) == null ? void 0 : u.data) && 0 < Yr(b[8][0].data) || !1;
          if ((u = (u = b[7]) == null ? void 0 : u[0]) != null && u.data && p != 0)
            f = (m = (m = b[7]) == null ? void 0 : m[0]) == null ? void 0 : m.data, E = (m = (m = b[6]) == null ? void 0 : m[0]) == null ? void 0 : m.data;
          else {
            if ((m = (m = b[4]) == null ? void 0 : m[0]) == null || !m.data || p == 1)
              throw "NUMBERS Tile missing ".concat(p, " cell storage");
            f = (p = (p = b[4]) == null ? void 0 : p[0]) == null ? void 0 : p.data, E = (b = (b = b[3]) == null ? void 0 : b[0]) == null ? void 0 : b.data;
          }
          for (var R = y ? 4 : 1, P = Pa(f), I = [], A = 0; A < f.length / 2; ++A) {
            var M = P.getUint16(2 * A, !0);
            M < 65535 && I.push([A, M]);
          }
          if (I.length != v)
            throw "Expected ".concat(v, " cells, found ").concat(I.length);
          for (var F = [], A = 0; A < I.length - 1; ++A)
            F[I[A][0]] = E.subarray(I[A][1] * R, I[A + 1][1] * R);
          return 1 <= I.length && (F[I[I.length - 1][0]] = E.subarray(I[I.length - 1][1] * R)), { R: T, cells: F };
        }(_, l);
      });
      return { nrows: Yr(a[4][0].data) >>> 0, data: d.reduce(function(_, u) {
        return _[u.R] || (_[u.R] = []), u.cells.forEach(function(p, m) {
          if (_[u.R][m])
            throw new Error("Duplicate cell r=".concat(u.R, " c=").concat(m));
          _[u.R][m] = p;
        }), _;
      }, []) };
    }
    function qN(t, d) {
      var a = { "!ref": "A1" }, l = t[An(cr(d.data)[2][0].data)], d = Yr(l[0].meta[1][0].data);
      if (d != 6001)
        throw new Error("6000 unexpected reference to ".concat(d));
      return function(_, m, p) {
        var b = cr(m.data);
        if ((m = { s: { r: 0, c: 0 }, e: { r: 0, c: 0 } }).e.r = (Yr(b[6][0].data) >>> 0) - 1, m.e.r < 0)
          throw new Error("Invalid row varint ".concat(b[6][0].data));
        if (m.e.c = (Yr(b[7][0].data) >>> 0) - 1, m.e.c < 0)
          throw new Error("Invalid col varint ".concat(b[7][0].data));
        p["!ref"] = Xt(m);
        var m = cr(b[4][0].data), f = uh(_, _[An(m[4][0].data)][0]), E = (b = m[17]) != null && b[0] ? uh(_, _[An(m[17][0].data)][0]) : [], b = cr(m[3][0].data), T = 0;
        if (b[1].forEach(function(y) {
          var R = cr(y.data), y = _[An(R[2][0].data)][0], R = Yr(y.meta[1][0].data);
          if (R != 6002)
            throw new Error("6001 unexpected reference to ".concat(R));
          y = HN(0, y), y.data.forEach(function(P, I) {
            P.forEach(function(A, M) {
              M = $t({ r: T + I, c: M }), A = YN(A, f, E), A && (p[M] = A);
            });
          }), T += y.nrows;
        }), (b = m[13]) != null && b[0]) {
          if (b = _[An(m[13][0].data)][0], m = Yr(b.meta[1][0].data), m != 6144)
            throw new Error("Expected merge type 6144, found ".concat(m));
          p["!merges"] = (b = cr(b.data)) == null ? void 0 : b[1].map(function(y) {
            var R = cr(y.data), y = Pa(cr(R[1][0].data)[1][0].data), R = Pa(cr(R[2][0].data)[1][0].data);
            return { s: { r: y.getUint16(0, !0), c: y.getUint16(2, !0) }, e: { r: y.getUint16(0, !0) + R.getUint16(0, !0) - 1, c: y.getUint16(2, !0) + R.getUint16(2, !0) - 1 } };
          });
        }
      }(t, l[0], a), a;
    }
    function $N(t, n) {
      var a = $c(), l = cr(n.data);
      if ((n = l[2]) != null && n[0])
        throw new Error("Keynote presentations are not supported");
      if (Pc(l[1], An).forEach(function(d) {
        t[d].forEach(function(_) {
          var u, p, m, f;
          Yr(_.meta[1][0].data) == 2 && (p = t, _ = cr((m = _).data), f = { name: (m = _[1]) != null && m[0] ? Mc(_[1][0].data) : "", sheets: [] }, Pc(_[2], An).forEach(function(E) {
            p[E].forEach(function(b) {
              Yr(b.meta[1][0].data) == 6e3 && f.sheets.push(qN(p, b));
            });
          }), (u = f).sheets.forEach(function(E, b) {
            Wc(a, E, b == 0 ? u.name : u.name + "_" + b, !0);
          }));
        });
      }), a.SheetNames.length == 0)
        throw new Error("Empty NUMBERS file");
      return a;
    }
    function _h(t) {
      var n = {}, a = [];
      if (t.FullPaths.forEach(function(d) {
        if (d.match(/\.iwpv2/))
          throw new Error("Unsupported password protection");
      }), t.FileIndex.forEach(function(d) {
        if (d.name.match(/\.iwa$/)) {
          var _, u;
          try {
            _ = la(d.content);
          } catch (p) {
            return console.log("?? " + d.content.length + " " + (p.message || p));
          }
          try {
            u = sa(_);
          } catch (p) {
            return console.log("## " + (p.message || p));
          }
          u.forEach(function(p) {
            n[p.id] = p.messages, a.push(p.id);
          });
        }
      }), !a.length)
        throw new Error("File has no messages");
      if ((t = (t = (t = (t = n == null ? void 0 : n[1]) == null ? void 0 : t[0]) == null ? void 0 : t.meta) == null ? void 0 : t[1]) != null && t[0].data && Yr(n[1][0].meta[1][0].data) == 1e4)
        throw new Error("Pages documents are not supported");
      var l = ((t = (t = (t = (t = n == null ? void 0 : n[1]) == null ? void 0 : t[0]) == null ? void 0 : t.meta) == null ? void 0 : t[1]) == null ? void 0 : t[0].data) && Yr(n[1][0].meta[1][0].data) == 1 && n[1][0];
      if (l || a.forEach(function(d) {
        n[d].forEach(function(_) {
          if (Yr(_.meta[1][0].data) >>> 0 == 1) {
            if (l)
              throw new Error("Document has multiple roots");
            l = _;
          }
        });
      }), !l)
        throw new Error("Cannot find Document root");
      return $N(n, l);
    }
    function WN(t, n) {
      if (!n || !n.numbers)
        throw new Error("Must pass a `numbers` option -- check the README");
      var a = t.Sheets[t.SheetNames[0]];
      1 < t.SheetNames.length && console.error("The Numbers writer currently writes only the first table");
      var l = Un(a["!ref"]);
      l.s.r = l.s.c = 0;
      var d = !1;
      9 < l.e.c && (d = !0, l.e.c = 9), 49 < l.e.r && (d = !0, l.e.r = 49), d && console.error("The Numbers writer is currently limited to ".concat(Xt(l)));
      var _ = Ws(a, { range: l, header: 1 }), u = ["~Sh33tJ5~"];
      _.forEach(function(et) {
        return et.forEach(function(nt) {
          typeof nt == "string" && u.push(nt);
        });
      });
      var p = {}, m = [], f = Lt.read(n.numbers, { type: "base64" });
      f.FileIndex.map(function(et, nt) {
        return [et, f.FullPaths[nt]];
      }).forEach(function(et) {
        var nt = et[0], je = et[1];
        nt.type == 2 && nt.name.match(/\.iwa/) && sa(la(nt.content)).forEach(function(Ye) {
          m.push(Ye.id), p[Ye.id] = { deps: [], location: je, type: Yr(Ye.messages[0].meta[1][0].data) };
        });
      }), m.sort(function(et, nt) {
        return et - nt;
      });
      var E = m.filter(function(et) {
        return 1 < et;
      }).map(function(et) {
        return [et, Sr(et)];
      });
      f.FileIndex.map(function(et, nt) {
        return [et, f.FullPaths[nt]];
      }).forEach(function(et) {
        var nt = et[0];
        et[1], nt.name.match(/\.iwa/) && sa(la(nt.content)).forEach(function(je) {
          je.messages.forEach(function(Ye) {
            E.forEach(function(ht) {
              je.messages.some(function(Tt) {
                return Yr(Tt.meta[1][0].data) != 11006 && function(xt, Zt) {
                  e:
                    for (var ft = 0; ft <= xt.length - Zt.length; ++ft) {
                      for (var We = 0; We < Zt.length; ++We)
                        if (xt[ft + We] != Zt[We])
                          continue e;
                      return !0;
                    }
                  return !1;
                }(Tt.data, ht[1]);
              }) && p[ht[0]].deps.push(je.id);
            });
          });
        });
      });
      for (var b, T = Lt.find(f, p[1].location), v = sa(la(T.content)), y = 0; y < v.length; ++y) {
        var R = v[y];
        R.id == 1 && (b = R);
      }
      for (var P = An(cr(b.messages[0].data)[1][0].data), v = sa(la((T = Lt.find(f, p[P].location)).content)), y = 0; y < v.length; ++y)
        (R = v[y]).id == P && (b = R);
      var Fe = cr(b.messages[0].data);
      for (Fe[1] = [{ type: 2, data: ch(t.SheetNames[0]) }], b.messages[0].data = Kr(Fe), T.content = Ei(gi(v)), T.size = T.content.length, P = An(Fe[2][0].data), v = sa(la((T = Lt.find(f, p[P].location)).content)), y = 0; y < v.length; ++y)
        (R = v[y]).id == P && (b = R);
      for (P = An(cr(b.messages[0].data)[2][0].data), v = sa(la((T = Lt.find(f, p[P].location)).content)), y = 0; y < v.length; ++y)
        (R = v[y]).id == P && (b = R);
      d = cr(b.messages[0].data), d[6][0].data = Sr(l.e.r + 1), d[7][0].data = Sr(l.e.c + 1);
      for (var I = An(d[46][0].data), n = Lt.find(f, p[I].location), A = sa(la(n.content)), M = 0; M < A.length && A[M].id != I; ++M)
        ;
      if (A[M].id != I)
        throw "Bad ColumnRowUIDMapArchive";
      var F = cr(A[M].messages[0].data);
      F[1] = [], F[2] = [], F[3] = [];
      for (var B = 0; B <= l.e.c; ++B)
        F[1].push({ type: 2, data: Kr([[], [{ type: 0, data: Sr(B + 420690) }], [{ type: 0, data: Sr(B + 420690) }]]) }), F[2].push({ type: 0, data: Sr(B) }), F[3].push({ type: 0, data: Sr(B) });
      F[4] = [], F[5] = [], F[6] = [];
      for (var re = 0; re <= l.e.r; ++re)
        F[4].push({ type: 2, data: Kr([[], [{ type: 0, data: Sr(re + 726270) }], [{ type: 0, data: Sr(re + 726270) }]]) }), F[5].push({ type: 0, data: Sr(re) }), F[6].push({ type: 0, data: Sr(re) });
      if (A[M].messages[0].data = Kr(F), n.content = Ei(gi(A)), n.size = n.content.length, delete d[46], t = cr(d[4][0].data), t[7][0].data = Sr(l.e.r + 1), Fe = An(cr(t[1][0].data)[2][0].data), (A = sa(la((n = Lt.find(f, p[Fe].location)).content)))[0].id != Fe)
        throw "Bad HeaderStorageBucket";
      for (var me = cr(A[0].messages[0].data), re = 0; re < _.length; ++re) {
        var le = cr(me[2][0].data);
        le[1][0].data = Sr(re), le[4][0].data = Sr(_[re].length), me[2][re] = { type: me[2][0].type, data: Kr(le) };
      }
      A[0].messages[0].data = Kr(me), n.content = Ei(gi(A)), n.size = n.content.length;
      var be, Fe = An(t[2][0].data);
      if ((A = sa(la((n = Lt.find(f, p[Fe].location)).content)))[0].id != Fe)
        throw "Bad HeaderStorageBucket";
      for (me = cr(A[0].messages[0].data), B = 0; B <= l.e.c; ++B)
        (le = cr(me[2][0].data))[1][0].data = Sr(B), le[4][0].data = Sr(l.e.r + 1), me[2][B] = { type: me[2][0].type, data: Kr(le) };
      A[0].messages[0].data = Kr(me), n.content = Ei(gi(A)), n.size = n.content.length, a["!merges"] && (ut = function(et) {
        for (var nt = 927262; nt < 2e6; ++nt)
          if (!p[nt])
            return p[nt] = et, nt;
        throw new Error("Too many messages");
      }({ type: 6144, deps: [P], location: p[P].location }), be = [[], []], a["!merges"].forEach(function(et) {
        be[1].push({ type: 2, data: Kr([[], [{ type: 2, data: Kr([[], [{ type: 5, data: new Uint8Array(new Uint16Array([et.s.r, et.s.c]).buffer) }]]) }], [{ type: 2, data: Kr([[], [{ type: 5, data: new Uint8Array(new Uint16Array([et.e.r - et.s.r + 1, et.e.c - et.s.c + 1]).buffer) }]]) }]]) });
      }), t[13] = [{ type: 2, data: Kr([[], [{ type: 0, data: Sr(ut) }]]) }], v.push({ id: ut, messages: [(ze = 6144, ut = Kr(be), { meta: [[], [{ type: 0, data: Sr(ze) }]], data: ut })] }));
      var Ue = An(t[4][0].data);
      (function() {
        for (var et, nt = Lt.find(f, p[Ue].location), je = sa(la(nt.content)), Ye = 0; Ye < je.length; ++Ye) {
          var ht = je[Ye];
          ht.id == Ue && (et = ht);
        }
        var Tt = cr(et.messages[0].data);
        Tt[3] = [], u.forEach(function(xt, Zt) {
          Tt[3].push({ type: 2, data: Kr([[], [{ type: 0, data: Sr(Zt) }], [{ type: 0, data: Sr(1) }], [{ type: 2, data: ch(xt) }]]) });
        }), et.messages[0].data = Kr(Tt), nt.content = Ei(gi(je)), nt.size = nt.content.length;
      })();
      var Ne = cr(t[3][0].data), ze = Ne[1][0];
      delete Ne[2];
      var ze, ut, ut = cr(ze.data), lt = An(ut[2][0].data);
      return function() {
        for (var et, nt = Lt.find(f, p[lt].location), je = sa(la(nt.content)), Ye = 0; Ye < je.length; ++Ye) {
          var ht = je[Ye];
          ht.id == lt && (et = ht);
        }
        var Tt = cr(et.messages[0].data);
        delete Tt[6], delete Ne[7];
        var xt = new Uint8Array(Tt[5][0].data);
        Tt[5] = [];
        for (var Zt = 0, ft = 0; ft <= l.e.r; ++ft) {
          var We = cr(xt);
          Zt += function(Wt, dr, ir) {
            var Or, Zr;
            if ((Or = Wt[6]) == null || !Or[0] || (Zr = Wt[7]) == null || !Zr[0])
              throw "Mutation only works on post-BNC storages!";
            if ((Zr = (Zr = Wt[8]) == null ? void 0 : Zr[0]) != null && Zr.data && 0 < Yr(Wt[8][0].data))
              throw "Math only works with normal offsets";
            for (var oe, yr, Rr = 0, _n = Pa(Wt[7][0].data), da = 0, q = [], Ie = Pa(Wt[4][0].data), te = 0, ve = [], ee = 0; ee < dr.length; ++ee)
              if (dr[ee] != null) {
                switch (_n.setUint16(2 * ee, da, !0), Ie.setUint16(2 * ee, te, !0), typeof dr[ee]) {
                  case "string":
                    oe = kc({ t: "s", v: dr[ee] }, ir), yr = Fc({ t: "s", v: dr[ee] }, ir);
                    break;
                  case "number":
                    oe = kc({ t: "n", v: dr[ee] }, ir), yr = Fc({ t: "n", v: dr[ee] }, ir);
                    break;
                  case "boolean":
                    oe = kc({ t: "b", v: dr[ee] }, ir), yr = Fc({ t: "b", v: dr[ee] }, ir);
                    break;
                  default:
                    throw new Error("Unsupported value " + dr[ee]);
                }
                q.push(oe), da += oe.length, ve.push(yr), te += yr.length, ++Rr;
              } else
                _n.setUint16(2 * ee, 65535, !0), Ie.setUint16(2 * ee, 65535);
            for (Wt[2][0].data = Sr(Rr); ee < Wt[7][0].data.length / 2; ++ee)
              _n.setUint16(2 * ee, 65535, !0), Ie.setUint16(2 * ee, 65535, !0);
            return Wt[6][0].data = Ka(q), Wt[3][0].data = Ka(ve), Rr;
          }(We, _[ft], u), We[1][0].data = Sr(ft), Tt[5].push({ data: Kr(We), type: 2 });
        }
        Tt[1] = [{ type: 0, data: Sr(l.e.c + 1) }], Tt[2] = [{ type: 0, data: Sr(l.e.r + 1) }], Tt[3] = [{ type: 0, data: Sr(Zt) }], Tt[4] = [{ type: 0, data: Sr(l.e.r + 1) }], et.messages[0].data = Kr(Tt), nt.content = Ei(gi(je)), nt.size = nt.content.length;
      }(), ze.data = Kr(ut), t[3][0].data = Kr(Ne), d[4][0].data = Kr(t), b.messages[0].data = Kr(d), T.content = Ei(gi(v)), T.size = T.content.length, f;
    }
    function ph(t) {
      return function(n) {
        for (var a = 0; a != t.length; ++a) {
          var l = t[a];
          n[l[0]] === void 0 && (n[l[0]] = l[1]), l[2] === "n" && (n[l[0]] = Number(n[l[0]]));
        }
      };
    }
    function Uc(t) {
      ph([["cellNF", !1], ["cellHTML", !0], ["cellFormula", !0], ["cellStyles", !1], ["cellText", !0], ["cellDates", !1], ["sheetStubs", !1], ["sheetRows", 0, "n"], ["bookDeps", !1], ["bookSheets", !1], ["bookProps", !1], ["bookFiles", !1], ["bookVBA", !1], ["password", ""], ["WTF", !1]])(t);
    }
    function Bc(t) {
      ph([["cellDates", !1], ["bookSST", !1], ["bookType", "xlsx"], ["compression", !1], ["WTF", !1]])(t);
    }
    function zN(t, n) {
      if (!t)
        return 0;
      try {
        t = n.map(function(a) {
          return a.id || (a.id = a.strRelID), [a.name, t["!id"][a.id].Target, (a = t["!id"][a.id].Type, -1 < Jt.WS.indexOf(a) ? "sheet" : Jt.CS && a == Jt.CS ? "chart" : Jt.DS && a == Jt.DS ? "dialog" : Jt.MS && a == Jt.MS ? "macro" : a && a.length ? a : "sheet")];
        });
      } catch {
        return null;
      }
      return t && t.length !== 0 ? t : null;
    }
    function KN(t, n, a, l, d, _, u, p, m, f, E, b) {
      try {
        _[l] = vo($n(t, a, !0), n);
        var T = en(t, n);
        switch (p) {
          case "sheet":
            R = pN(T, n, d, m, _[l], f, E, b);
            break;
          case "chart":
            if (!(R = mN(T, n, d, m, _[l], f)) || !R["!drawel"])
              break;
            var y = wi(R["!drawel"].Target, n), v = To(y), A = wi((A = $n(t, y, !0), v = vo($n(t, v, !0), y), A ? (A = (A.match(/<c:chart [^>]*r:id="([^"]*)"/) || ["", ""])[1], v["!id"][A].Target) : "??"), y), y = To(A), R = rN($n(t, A, !0), 0, 0, vo($n(t, y, !0), A), 0, R);
            break;
          case "macro":
            I = n, _[l], I.slice(-4), R = { "!type": "macro" };
            break;
          case "dialog":
            I = n, _[l], I.slice(-4), R = { "!type": "dialog" };
            break;
          default:
            throw new Error("Unrecognized sheet type " + p);
        }
        u[l] = R;
        var P = [];
        _ && _[l] && $r(_[l]).forEach(function(M) {
          var F, B, re, me, le, be, Fe = "";
          if (_[l][M].Type == Jt.CMNT) {
            Fe = wi(_[l][M].Target, n);
            var Ue = EN(en(t, Fe, !0), Fe, m);
            if (!Ue || !Ue.length)
              return;
            cE(R, Ue, !1);
          }
          _[l][M].Type == Jt.TCMNT && (Fe = wi(_[l][M].Target, n), P = P.concat((F = en(t, Fe, !0), B = m, me = !(re = []), le = {}, be = 0, F.replace(Cn, function(Ne, ze) {
            var ut = Ht(Ne);
            switch (pa(ut[0])) {
              case "<?xml":
              case "<ThreadedComments":
              case "</ThreadedComments>":
                break;
              case "<threadedComment":
                le = { author: ut.personId, guid: ut.id, ref: ut.ref, T: 1 };
                break;
              case "</threadedComment>":
                le.t != null && re.push(le);
                break;
              case "<text>":
              case "<text":
                be = ze + Ne.length;
                break;
              case "</text>":
                le.t = F.slice(be, ze).replace(/\r\n/g, `
`).replace(/\r/g, `
`);
                break;
              case "<mentions":
              case "<mentions>":
                me = !0;
                break;
              case "</mentions>":
                me = !1;
                break;
              case "<extLst":
              case "<extLst>":
              case "</extLst>":
              case "<extLst/>":
                break;
              case "<ext":
                me = !0;
                break;
              case "</ext>":
                me = !1;
                break;
              default:
                if (!me && B.WTF)
                  throw new Error("unrecognized " + ut[0] + " in threaded comments");
            }
            return Ne;
          }), re)));
        }), P && P.length && cE(R, P, !0, m.people || []);
      } catch (M) {
        if (m.WTF)
          throw M;
      }
      var I, A;
    }
    function ca(t) {
      return t.charAt(0) == "/" ? t.slice(1) : t;
    }
    function mh(t, n) {
      if (ra(), Uc(n = n || {}), Xn(t, "META-INF/manifest.xml") || Xn(t, "objectdata.xml"))
        return ih(t, n);
      if (Xn(t, "Index/Document.iwa")) {
        if (typeof Uint8Array > "u")
          throw new Error("NUMBERS file parsing requires Uint8Array support");
        if (t.FileIndex)
          return _h(t);
        var a = Lt.utils.cfb_new();
        return xl(t).forEach(function(je) {
          Qt(a, je, function Ye(ht, Tt, xt) {
            if (!xt)
              return wl(os(ht, Tt));
            if (!Tt)
              return null;
            try {
              return Ye(ht, Tt);
            } catch {
              return null;
            }
          }(t, je));
        }), _h(a);
      }
      if (!Xn(t, "[Content_Types].xml"))
        throw Xn(t, "index.xml.gz") ? new Error("Unsupported NUMBERS 08 file") : Xn(t, "index.xml") ? new Error("Unsupported NUMBERS 09 file") : new Error("Unsupported ZIP file");
      var l, d, _ = xl(t), u = function(je) {
        var Ye = ac();
        if (!je || !je.match)
          return Ye;
        var ht = {};
        if ((je.match(Cn) || []).forEach(function(Tt) {
          var xt = Ht(Tt);
          switch (xt[0].replace(Wm, "<")) {
            case "<?xml":
              break;
            case "<Types":
              Ye.xmlns = xt["xmlns" + (xt[0].match(/<(\w+):/) || ["", ""])[1]];
              break;
            case "<Default":
              ht[xt.Extension] = xt.ContentType;
              break;
            case "<Override":
              Ye[nc[xt.ContentType]] !== void 0 && Ye[nc[xt.ContentType]].push(xt.PartName);
          }
        }), Ye.xmlns !== un.CT)
          throw new Error("Unknown Namespace: " + Ye.xmlns);
        return Ye.calcchain = 0 < Ye.calcchains.length ? Ye.calcchains[0] : "", Ye.sst = 0 < Ye.strs.length ? Ye.strs[0] : "", Ye.style = 0 < Ye.styles.length ? Ye.styles[0] : "", Ye.defaults = ht, delete Ye.calcchains, Ye;
      }($n(t, "[Content_Types].xml")), le = !1;
      if (u.workbooks.length === 0 && en(t, d = "xl/workbook.xml", !0) && u.workbooks.push(d), u.workbooks.length === 0) {
        if (!en(t, d = "xl/workbook.bin", !0))
          throw new Error("Could not find workbook");
        u.workbooks.push(d), le = !0;
      }
      u.workbooks[0].slice(-3) == "bin" && (le = !0);
      var p = {}, m = {};
      if (!n.bookSheets && !n.bookProps) {
        if (Po = [], u.sst)
          try {
            Po = gN(en(t, ca(u.sst)), u.sst, n);
          } catch (je) {
            if (n.WTF)
              throw je;
          }
        n.cellStyles && u.themes.length && (y = $n(t, u.themes[0].replace(/^\//, ""), !0) || "", u.themes[0], p = oE(y, n)), u.style && (m = fN(en(t, ca(u.style)), u.style, p, n));
      }
      u.links.map(function(je) {
        try {
          return vo($n(t, To(ca(je))), je), SN(en(t, ca(je)), 0, je, n);
        } catch {
        }
      });
      var f, E, b, T = _N(en(t, ca(u.workbooks[0])), u.workbooks[0], n), v = {}, y = "";
      u.coreprops.length && ((y = en(t, ca(u.coreprops[0]), !0)) && (v = Af(y)), u.extprops.length !== 0 && (y = en(t, ca(u.extprops[0]), !0)) && (R = n, b = {}, E = (E = v) || {}, f = Cr(f = y), di.forEach(function(je) {
        var Ye = (f.match(Ya(je[0])) || [])[1];
        switch (je[2]) {
          case "string":
            Ye && (E[je[1]] = mr(Ye));
            break;
          case "bool":
            E[je[1]] = Ye === "true";
            break;
          case "raw":
            var ht = f.match(new RegExp("<" + je[0] + "[^>]*>([\\s\\S]*?)</" + je[0] + ">"));
            ht && 0 < ht.length && (b[je[1]] = ht[1]);
        }
      }), b.HeadingPairs && b.TitlesOfParts && If(b.HeadingPairs, b.TitlesOfParts, E, R)));
      var R = {};
      n.bookSheets && !n.bookProps || u.custprops.length !== 0 && (y = $n(t, ca(u.custprops[0]), !0)) && (R = function(je, Ye) {
        var ht = {}, Tt = "", xt = je.match(pC);
        if (xt)
          for (var Zt = 0; Zt != xt.length; ++Zt) {
            var ft = xt[Zt], We = Ht(ft);
            switch (We[0]) {
              case "<?xml":
              case "<Properties":
                break;
              case "<property":
                Tt = mr(We.name);
                break;
              case "</property>":
                Tt = null;
                break;
              default:
                if (ft.indexOf("<vt:") === 0) {
                  var Wt = ft.split(">"), dr = Wt[0].slice(4), ir = Wt[1];
                  switch (dr) {
                    case "lpstr":
                    case "bstr":
                    case "lpwstr":
                      ht[Tt] = mr(ir);
                      break;
                    case "bool":
                      ht[Tt] = Lr(ir);
                      break;
                    case "i1":
                    case "i2":
                    case "i4":
                    case "i8":
                    case "int":
                    case "uint":
                      ht[Tt] = parseInt(ir, 10);
                      break;
                    case "r4":
                    case "r8":
                    case "decimal":
                      ht[Tt] = parseFloat(ir);
                      break;
                    case "filetime":
                    case "date":
                      ht[Tt] = Br(ir);
                      break;
                    case "cy":
                    case "error":
                      ht[Tt] = mr(ir);
                      break;
                    default:
                      if (dr.slice(-1) == "/")
                        break;
                      Ye.WTF && typeof console < "u" && console.warn("Unexpected", ft, dr, Wt);
                  }
                } else if (ft.slice(0, 2) !== "</" && Ye.WTF)
                  throw new Error(ft);
            }
          }
        return ht;
      }(y, n));
      var P = {};
      if ((n.bookSheets || n.bookProps) && (T.Sheets ? l = T.Sheets.map(function(je) {
        return je.name;
      }) : v.Worksheets && 0 < v.SheetNames.length && (l = v.SheetNames), n.bookProps && (P.Props = v, P.Custprops = R), n.bookSheets && l !== void 0 && (P.SheetNames = l), n.bookSheets ? P.SheetNames : n.bookProps))
        return P;
      l = {}, y = {}, n.bookDeps && u.calcchain && (y = hN(en(t, ca(u.calcchain)), u.calcchain));
      var I, A, M = 0, F = {}, B = T.Sheets;
      v.Worksheets = B.length, v.SheetNames = [];
      for (var re = 0; re != B.length; ++re)
        v.SheetNames[re] = B[re].name;
      var me = le ? "bin" : "xml", le = u.workbooks[0].lastIndexOf("/"), be = (u.workbooks[0].slice(0, le + 1) + "_rels/" + u.workbooks[0].slice(le + 1) + ".rels").replace(/^\//, "");
      Xn(t, be) || (be = "xl/_rels/workbook." + me + ".rels");
      var Fe, Ue, Ne, ze = vo($n(t, be, !0), be.replace(/_rels.*/, "s5s"));
      1 <= (u.metadata || []).length && (n.xlmeta = bN(en(t, ca(u.metadata[0])), u.metadata[0], n)), 1 <= (u.people || []).length && (n.people = (le = en(t, ca(u.people[0])), Fe = n, Ne = !(Ue = []), le.replace(Cn, function(je) {
        var Ye = Ht(je);
        switch (pa(Ye[0])) {
          case "<?xml":
          case "<personList":
          case "</personList>":
            break;
          case "<person":
            Ue.push({ name: Ye.displayname, id: Ye.id });
            break;
          case "</person>":
            break;
          case "<extLst":
          case "<extLst>":
          case "</extLst>":
          case "<extLst/>":
            break;
          case "<ext":
            Ne = !0;
            break;
          case "</ext>":
            Ne = !1;
            break;
          default:
            if (!Ne && Fe.WTF)
              throw new Error("unrecognized " + Ye[0] + " in threaded comments");
        }
        return je;
      }), Ue)), ze = ze && zN(ze, T.Sheets);
      var ut = en(t, "xl/worksheets/sheet.xml", !0) ? 1 : 0;
      e:
        for (M = 0; M != v.Worksheets; ++M) {
          var lt = "sheet";
          if (ze && ze[M] ? (I = "xl/" + ze[M][1].replace(/[\/]?xl\//, ""), Xn(t, I) || (I = ze[M][1]), Xn(t, I) || (I = be.replace(/_rels\/.*$/, "") + ze[M][1]), lt = ze[M][2]) : I = (I = "xl/worksheets/sheet" + (M + 1 - ut) + "." + me).replace(/sheet0\./, "sheet."), A = I.replace(/^(.*)(\/)([^\/]*)$/, "$1/_rels/$3.rels"), n && n.sheets != null)
            switch (typeof n.sheets) {
              case "number":
                if (M != n.sheets)
                  continue e;
                break;
              case "string":
                if (v.SheetNames[M].toLowerCase() != n.sheets.toLowerCase())
                  continue e;
                break;
              default:
                if (Array.isArray && Array.isArray(n.sheets)) {
                  for (var et = !1, nt = 0; nt != n.sheets.length; ++nt)
                    typeof n.sheets[nt] == "number" && n.sheets[nt] == M && (et = 1), typeof n.sheets[nt] == "string" && n.sheets[nt].toLowerCase() == v.SheetNames[M].toLowerCase() && (et = 1);
                  if (!et)
                    continue e;
                }
            }
          KN(t, I, A, v.SheetNames[M], M, F, l, lt, n, T, p, m);
        }
      return P = { Directory: u, Workbook: T, Props: v, Custprops: R, Deps: y, Sheets: l, SheetNames: v.SheetNames, Strings: Po, Styles: m, Themes: p, SSF: xr(ae) }, n && n.bookFiles && (t.files ? (P.keys = _, P.files = t.files) : (P.keys = [], P.files = {}, t.FullPaths.forEach(function(je, Ye) {
        je = je.replace(/^Root Entry[\/]/, ""), P.keys.push(je), P.files[je] = t.FileIndex[Ye];
      }))), n && n.bookVBA && (0 < u.vba.length ? P.vbaraw = en(t, ca(u.vba[0]), !0) : u.defaults && u.defaults.bin === fR && (P.vbaraw = en(t, "xl/vbaProject.bin", !0))), P;
    }
    function QN(t, n) {
      var a, l = n || {}, d = "Workbook", _ = Lt.find(t, d);
      try {
        if (d = "/!DataSpaces/Version", !(_ = Lt.find(t, d)) || !_.content)
          throw new Error("ECMA-376 Encrypted file missing " + d);
        if (u = _.content, (a = {}).id = u.read_shift(0, "lpp4"), a.R = Ma(u, 4), a.U = Ma(u, 4), a.W = Ma(u, 4), d = "/!DataSpaces/DataSpaceMap", !(_ = Lt.find(t, d)) || !_.content)
          throw new Error("ECMA-376 Encrypted file missing " + d);
        var u = GC(_.content);
        if (u.length !== 1 || u[0].comps.length !== 1 || u[0].comps[0].t !== 0 || u[0].name !== "StrongEncryptionDataSpace" || u[0].comps[0].v !== "EncryptedPackage")
          throw new Error("ECMA-376 Encrypted file bad " + d);
        if (d = "/!DataSpaces/DataSpaceInfo/StrongEncryptionDataSpace", !(_ = Lt.find(t, d)) || !_.content)
          throw new Error("ECMA-376 Encrypted file missing " + d);
        if (u = function(p) {
          var m = [];
          p.l += 4;
          for (var f = p.read_shift(4); 0 < f--; )
            m.push(p.read_shift(0, "lpp4"));
          return m;
        }(_.content), u.length != 1 || u[0] != "StrongEncryptionTransform")
          throw new Error("ECMA-376 Encrypted file bad " + d);
        if (d = "/!DataSpaces/TransformInfo/StrongEncryptionTransform/!Primary", !(_ = Lt.find(t, d)) || !_.content)
          throw new Error("ECMA-376 Encrypted file missing " + d);
        VC(_.content);
      } catch {
      }
      if (d = "/EncryptionInfo", !(_ = Lt.find(t, d)) || !_.content)
        throw new Error("ECMA-376 Encrypted file missing " + d);
      if (n = YC(_.content), d = "/EncryptedPackage", !(_ = Lt.find(t, d)) || !_.content)
        throw new Error("ECMA-376 Encrypted file missing " + d);
      if (n[0] == 4 && typeof decrypt_agile < "u")
        return decrypt_agile(n[1], _.content, l.password || "", l);
      if (n[0] == 2 && typeof decrypt_std76 < "u")
        return decrypt_std76(n[1], _.content, l.password || "", l);
      throw new Error("File is password-protected");
    }
    function XN(t, n) {
      return (n.bookType == "ods" ? lh : n.bookType == "numbers" ? WN : n.bookType == "xlsb" ? function(a, l) {
        Hi = 1024, a && !a.SSF && (a.SSF = xr(ae)), a && a.SSF && (ra(), hr(a.SSF), l.revssf = io(a.SSF), l.revssf[a.SSF[65535]] = 0, l.ssf = a.SSF), l.rels = {}, l.wbrels = {}, l.Strings = [], l.Strings.Count = 0, l.Strings.Unique = 0, ko ? l.revStrings = /* @__PURE__ */ new Map() : (l.revStrings = {}, l.revStrings.foo = [], delete l.revStrings.foo);
        var d = l.bookType == "xlsb" ? "bin" : "xml", _ = -1 < uE.indexOf(l.bookType), u = ac();
        Bc(l = l || {});
        var p = ss(), m = "", f = 0;
        if (l.cellXfs = [], za(l.cellXfs, {}, { revssf: { General: 0 } }), a.Props || (a.Props = {}), Qt(p, m = "docProps/core.xml", Of(a.Props, l)), u.coreprops.push(m), Ir(l.rels, 2, m, Jt.CORE_PROPS), m = "docProps/app.xml", !a.Props || !a.Props.SheetNames)
          if (a.Workbook && a.Workbook.Sheets) {
            for (var E = [], b = 0; b < a.SheetNames.length; ++b)
              (a.Workbook.Sheets[b] || {}).Hidden != 2 && E.push(a.SheetNames[b]);
            a.Props.SheetNames = E;
          } else
            a.Props.SheetNames = a.SheetNames;
        for (a.Props.Worksheets = a.Props.SheetNames.length, Qt(p, m, Df(a.Props)), u.extprops.push(m), Ir(l.rels, 3, m, Jt.EXT_PROPS), a.Custprops !== a.Props && 0 < $r(a.Custprops || {}).length && (Qt(p, m = "docProps/custom.xml", wf(a.Custprops)), u.custprops.push(m), Ir(l.rels, 4, m, Jt.CUST_PROPS)), f = 1; f <= a.SheetNames.length; ++f) {
          var T, v, y, R = { "!id": {} }, P = a.Sheets[a.SheetNames[f - 1]];
          Qt(p, m = "xl/worksheets/sheet" + f + "." + d, function(I, A, M, F, B) {
            return (A.slice(-4) === ".bin" ? tN : PE)(I, M, F, B);
          }(f - 1, m, l, a, R)), u.sheets.push(m), Ir(l.wbrels, -1, "worksheets/sheet" + f + "." + d, Jt.WS[0]), P && (T = P["!comments"], v = !1, y = "", T && 0 < T.length && (Qt(p, y = "xl/comments" + f + "." + d, function(I, A, M) {
            return (A.slice(-4) === ".bin" ? mR : dE)(I);
          }(T, y)), u.comments.push(y), Ir(R, -1, "../comments" + f + "." + d, Jt.CMNT), v = !0), P["!legacy"] && v && Qt(p, "xl/drawings/vmlDrawing" + f + ".vml", lE(f, P["!comments"])), delete P["!comments"], delete P["!legacy"]), R["!id"].rId1 && Qt(p, To(m), Ui(R));
        }
        return l.Strings != null && 0 < l.Strings.length && (Qt(p, m = "xl/sharedStrings." + d, function(I, A, M) {
          return (A.slice(-4) === ".bin" ? BC : Gg)(I, M);
        }(l.Strings, m, l)), u.strs.push(m), Ir(l.wbrels, -1, "sharedStrings." + d, Jt.SST)), Qt(p, m = "xl/workbook." + d, function(I, A, M) {
          return (A.slice(-4) === ".bin" ? uN : HE)(I);
        }(a, m)), u.workbooks.push(m), Ir(l.rels, 1, m, Jt.WB), Qt(p, m = "xl/theme/theme1.xml", Tc(a.Themes, l)), u.themes.push(m), Ir(l.wbrels, -1, "theme/theme1.xml", Jt.THEME), Qt(p, m = "xl/styles." + d, function(I, A, M) {
          return (A.slice(-4) === ".bin" ? rR : rE)(I, M);
        }(a, m, l)), u.styles.push(m), Ir(l.wbrels, -1, "styles." + d, Jt.STY), a.vbaraw && _ && (Qt(p, m = "xl/vbaProject.bin", a.vbaraw), u.vba.push(m), Ir(l.wbrels, -1, "vbaProject.bin", Jt.VBA)), Qt(p, m = "xl/metadata." + d, function(I) {
          return (I.slice(-4) === ".bin" ? pR : sE)();
        }(m)), u.metadata.push(m), Ir(l.wbrels, -1, "metadata." + d, Jt.XLMETA), Qt(p, "[Content_Types].xml", Cf(u, l)), Qt(p, "_rels/.rels", Ui(l.rels)), Qt(p, "xl/_rels/workbook." + d + ".rels", Ui(l.wbrels)), delete l.revssf, delete l.ssf, p;
      } : fh)(t, n);
    }
    function fh(t, n) {
      Hi = 1024, t && !t.SSF && (t.SSF = xr(ae)), t && t.SSF && (ra(), hr(t.SSF), n.revssf = io(t.SSF), n.revssf[t.SSF[65535]] = 0, n.ssf = t.SSF), n.rels = {}, n.wbrels = {}, n.Strings = [], n.Strings.Count = 0, n.Strings.Unique = 0, ko ? n.revStrings = /* @__PURE__ */ new Map() : (n.revStrings = {}, n.revStrings.foo = [], delete n.revStrings.foo);
      var a = "xml", l = -1 < uE.indexOf(n.bookType), d = ac();
      Bc(n = n || {});
      var _ = ss(), u = "", p = 0;
      if (n.cellXfs = [], za(n.cellXfs, {}, { revssf: { General: 0 } }), t.Props || (t.Props = {}), u = "docProps/core.xml", Qt(_, u, Of(t.Props, n)), d.coreprops.push(u), Ir(n.rels, 2, u, Jt.CORE_PROPS), u = "docProps/app.xml", !t.Props || !t.Props.SheetNames)
        if (t.Workbook && t.Workbook.Sheets) {
          for (var m = [], f = 0; f < t.SheetNames.length; ++f)
            (t.Workbook.Sheets[f] || {}).Hidden != 2 && m.push(t.SheetNames[f]);
          t.Props.SheetNames = m;
        } else
          t.Props.SheetNames = t.SheetNames;
      t.Props.Worksheets = t.Props.SheetNames.length, Qt(_, u, Df(t.Props)), d.extprops.push(u), Ir(n.rels, 3, u, Jt.EXT_PROPS), t.Custprops !== t.Props && 0 < $r(t.Custprops || {}).length && (Qt(_, u = "docProps/custom.xml", wf(t.Custprops)), d.custprops.push(u), Ir(n.rels, 4, u, Jt.CUST_PROPS));
      var E, b = ["SheetJ5"];
      for (n.tcid = 0, p = 1; p <= t.SheetNames.length; ++p) {
        var T, v, y, R, P = { "!id": {} }, I = t.Sheets[t.SheetNames[p - 1]];
        Qt(_, u = "xl/worksheets/sheet" + p + "." + a, PE(p - 1, n, t, P)), d.sheets.push(u), Ir(n.wbrels, -1, "worksheets/sheet" + p + "." + a, Jt.WS[0]), I && (v = !1, y = "", (T = I["!comments"]) && 0 < T.length && (R = !1, T.forEach(function(A) {
          A[1].forEach(function(M) {
            M.T == 1 && (R = !0);
          });
        }), R && (Qt(_, y = "xl/threadedComments/threadedComment" + p + "." + a, function(A, M, F) {
          var B = [Qr, it("ThreadedComments", null, { xmlns: un.TCMNT }).replace(/[\/]>/, ">")];
          return A.forEach(function(re) {
            var me = "";
            (re[1] || []).forEach(function(le, be) {
              var Fe;
              le.T ? (le.a && M.indexOf(le.a) == -1 && M.push(le.a), Fe = { ref: re[0], id: "{54EE7951-7262-4200-6969-" + ("000000000000" + F.tcid++).slice(-12) + "}" }, be == 0 ? me = Fe.id : Fe.parentId = me, le.ID = Fe.id, le.a && (Fe.personId = "{54EE7950-7262-4200-6969-" + ("000000000000" + M.indexOf(le.a)).slice(-12) + "}"), B.push(it("threadedComment", Rn("text", le.t || ""), Fe))) : delete le.ID;
            });
          }), B.push("</ThreadedComments>"), B.join("");
        }(T, b, n)), d.threadedcomments.push(y), Ir(P, -1, "../threadedComments/threadedComment" + p + "." + a, Jt.TCMNT)), Qt(_, y = "xl/comments" + p + "." + a, dE(T)), d.comments.push(y), Ir(P, -1, "../comments" + p + "." + a, Jt.CMNT), v = !0), I["!legacy"] && v && Qt(_, "xl/drawings/vmlDrawing" + p + ".vml", lE(p, I["!comments"])), delete I["!comments"], delete I["!legacy"]), P["!id"].rId1 && Qt(_, To(u), Ui(P));
      }
      return n.Strings != null && 0 < n.Strings.length && (Qt(_, u = "xl/sharedStrings.xml", Gg(n.Strings, n)), d.strs.push(u), Ir(n.wbrels, -1, "sharedStrings.xml", Jt.SST)), Qt(_, u = "xl/workbook.xml", HE(t)), d.workbooks.push(u), Ir(n.rels, 1, u, Jt.WB), Qt(_, u = "xl/theme/theme1.xml", Tc(t.Themes, n)), d.themes.push(u), Ir(n.wbrels, -1, "theme/theme1.xml", Jt.THEME), Qt(_, u = "xl/styles.xml", rE(t, n)), d.styles.push(u), Ir(n.wbrels, -1, "styles.xml", Jt.STY), t.vbaraw && l && (Qt(_, u = "xl/vbaProject.bin", t.vbaraw), d.vba.push(u), Ir(n.wbrels, -1, "vbaProject.bin", Jt.VBA)), Qt(_, u = "xl/metadata.xml", sE()), d.metadata.push(u), Ir(n.wbrels, -1, "metadata.xml", Jt.XLMETA), 1 < b.length && (Qt(_, u = "xl/persons/person.xml", (l = b, E = [Qr, it("personList", null, { xmlns: un.TCMNT, "xmlns:x": ai[0] }).replace(/[\/]>/, ">")], l.forEach(function(A, M) {
        E.push(it("person", null, { displayName: A, id: "{54EE7950-7262-4200-6969-" + ("000000000000" + M).slice(-12) + "}", userId: A, providerId: "None" }));
      }), E.push("</personList>"), E.join(""))), d.people.push(u), Ir(n.wbrels, -1, "persons/person.xml", Jt.PEOPLE)), Qt(_, "[Content_Types].xml", Cf(d, n)), Qt(_, "_rels/.rels", Ui(n.rels)), Qt(_, "xl/_rels/workbook.xml.rels", Ui(n.wbrels)), delete n.revssf, delete n.ssf, _;
    }
    function Gc(t, n) {
      var a = "";
      switch ((n || {}).type || "base64") {
        case "buffer":
          return [t[0], t[1], t[2], t[3], t[4], t[5], t[6], t[7]];
        case "base64":
          a = H(t.slice(0, 12));
          break;
        case "binary":
          a = t;
          break;
        case "array":
          return [t[0], t[1], t[2], t[3], t[4], t[5], t[6], t[7]];
        default:
          throw new Error("Unrecognized type " + (n && n.type || "undefined"));
      }
      return [a.charCodeAt(0), a.charCodeAt(1), a.charCodeAt(2), a.charCodeAt(3), a.charCodeAt(4), a.charCodeAt(5), a.charCodeAt(6), a.charCodeAt(7)];
    }
    function gh(t, n) {
      var a = 0;
      e:
        for (; a < t.length; )
          switch (t.charCodeAt(a)) {
            case 10:
            case 13:
            case 32:
              ++a;
              break;
            case 60:
              return xc(t.slice(a), n);
            default:
              break e;
          }
      return Bi.to_workbook(t, n);
    }
    function Vc(t, n, a, l) {
      return l ? (a.type = "string", Bi.to_workbook(t, a)) : Bi.to_workbook(n, a);
    }
    function Hs(t, n) {
      D();
      var a = n || {};
      if (typeof ArrayBuffer < "u" && t instanceof ArrayBuffer)
        return Hs(new Uint8Array(t), ((a = xr(a)).type = "array", a));
      typeof Uint8Array < "u" && t instanceof Uint8Array && !a.type && (a.type = typeof Deno < "u" ? "buffer" : "array");
      var l, d, _, u, p, m = t, f = !1;
      if (a.cellStyles && (a.cellNF = !0, a.sheetStubs = !0), $i = {}, a.dateNF && ($i.dateNF = a.dateNF), a.type || (a.type = K && Buffer.isBuffer(t) ? "buffer" : "base64"), a.type == "file" && (a.type = K ? "buffer" : "binary", m = function(b) {
        if (Ia !== void 0)
          return Ia.readFileSync(b);
        if (typeof Deno < "u")
          return Deno.readFileSync(b);
        if (typeof $ < "u" && typeof File < "u" && typeof Folder < "u")
          try {
            var T = File(b);
            T.open("r"), T.encoding = "binary";
            var v = T.read();
            return T.close(), v;
          } catch (y) {
            if (!y.message || !y.message.match(/onstruct/))
              throw y;
          }
        throw new Error("Cannot access file " + b);
      }(t), typeof Uint8Array > "u" || K || (a.type = "array")), a.type == "string" && (f = !0, a.type = "binary", a.codepage = 65001, m = (E = t).match(/[^\x00-\x7F]/) ? Zn(E) : E), a.type == "array" && typeof Uint8Array < "u" && t instanceof Uint8Array && typeof ArrayBuffer < "u") {
        var E = new ArrayBuffer(3), E = new Uint8Array(E);
        if (E.foo = "bar", !E.foo)
          return (a = xr(a)).type = "array", Hs(Je(m), a);
      }
      switch ((l = Gc(m, a))[0]) {
        case 208:
          if (l[1] === 207 && l[2] === 17 && l[3] === 224 && l[4] === 161 && l[5] === 177 && l[6] === 26 && l[7] === 225)
            return u = Lt.read(m, a), p = a, (Lt.find(u, "EncryptedPackage") ? QN : Ys)(u, p);
          break;
        case 9:
          if (l[1] <= 8)
            return Ys(m, a);
          break;
        case 60:
          return xc(m, a);
        case 73:
          if (l[1] === 73 && l[2] === 42 && l[3] === 0)
            throw new Error("TIFF Image File is not a spreadsheet");
          if (l[1] === 68)
            return function(b, T) {
              var v = T || {}, y = !!v.WTF;
              v.WTF = !0;
              try {
                var R = Eg.to_workbook(b, v);
                return v.WTF = y, R;
              } catch (P) {
                if (v.WTF = y, !P.message.match(/SYLK bad record ID/) && y)
                  throw P;
                return Bi.to_workbook(b, T);
              }
            }(m, a);
          break;
        case 84:
          if (l[1] === 65 && l[2] === 66 && l[3] === 76)
            return Sg.to_workbook(m, a);
          break;
        case 80:
          return l[1] === 75 && l[2] < 9 && l[3] < 9 ? (_ = p = m, (d = (d = a) || {}).type || (d.type = K && Buffer.isBuffer(p) ? "buffer" : "base64"), mh(Ll(_, d), d)) : Vc(t, m, a, f);
        case 239:
          return l[3] === 60 ? xc(m, a) : Vc(t, m, a, f);
        case 255:
          if (l[1] === 254)
            return _ = m, (d = a).type == "base64" && (_ = H(_)), _ = e.utils.decode(1200, _.slice(2), "str"), d.type = "binary", gh(_, d);
          if (l[1] === 0 && l[2] === 2 && l[3] === 0)
            return mi.to_workbook(m, a);
          break;
        case 0:
          if (l[1] === 0 && (2 <= l[2] && l[3] === 0 || l[2] === 0 && (l[3] === 8 || l[3] === 9)))
            return mi.to_workbook(m, a);
          break;
        case 3:
        case 131:
        case 139:
        case 140:
          return cc.to_workbook(m, a);
        case 123:
          if (l[1] === 92 && l[2] === 114 && l[3] === 116)
            return zg.to_workbook(m, a);
          break;
        case 10:
        case 13:
        case 32:
          return function(b, T) {
            var v = "", y = Gc(b, T);
            switch (T.type) {
              case "base64":
                v = H(b);
                break;
              case "binary":
                v = b;
                break;
              case "buffer":
                v = b.toString("binary");
                break;
              case "array":
                v = Va(b);
                break;
              default:
                throw new Error("Unrecognized type " + T.type);
            }
            return y[0] == 239 && y[1] == 187 && y[2] == 191 && (v = Cr(v)), T.type = "binary", gh(v, T);
          }(m, a);
        case 137:
          if (l[1] === 80 && l[2] === 78 && l[3] === 71)
            throw new Error("PNG Image File is not a spreadsheet");
      }
      return -1 < RC.indexOf(l[0]) && l[2] <= 12 && l[3] <= 31 ? cc.to_workbook(m, a) : Vc(t, m, a, f);
    }
    function Eh(t, n) {
      return n = n || {}, n.type = "file", Hs(t, n);
    }
    function hh(t, n) {
      switch (n.type) {
        case "base64":
        case "binary":
          break;
        case "buffer":
        case "array":
          n.type = "";
          break;
        case "file":
          return Di(n.file, Lt.write(t, { type: K ? "buffer" : "" }));
        case "string":
          throw new Error("'string' output type invalid for '" + n.bookType + "' files");
        default:
          throw new Error("Unrecognized type " + n.type);
      }
      return Lt.write(t, n);
    }
    function Sh(t, n) {
      var a = {}, l = K ? "nodebuffer" : typeof Uint8Array < "u" ? "array" : "string";
      if (n.compression && (a.compression = "DEFLATE"), n.password)
        a.type = l;
      else
        switch (n.type) {
          case "base64":
            a.type = "base64";
            break;
          case "binary":
            a.type = "string";
            break;
          case "string":
            throw new Error("'string' output type invalid for '" + n.bookType + "' files");
          case "buffer":
          case "file":
            a.type = l;
            break;
          default:
            throw new Error("Unrecognized type " + n.type);
        }
      if (t = t.FullPaths ? Lt.write(t, { fileType: "zip", type: { nodebuffer: "buffer", string: "binary" }[a.type] || a.type, compression: !!n.compression }) : t.generate(a), typeof Deno < "u" && typeof t == "string") {
        if (n.type == "binary" || n.type == "base64")
          return t;
        t = new Uint8Array(Ke(t));
      }
      return n.password && typeof encrypt_agile < "u" ? hh(encrypt_agile(t, n.password), n) : n.type === "file" ? Di(n.file, t) : n.type == "string" ? Cr(t) : t;
    }
    function Ta(t, n, a) {
      var l = (a = a || "") + t;
      switch (n.type) {
        case "base64":
          return Z(Zn(l));
        case "binary":
          return Zn(l);
        case "string":
          return t;
        case "file":
          return Di(n.file, l, "utf8");
        case "buffer":
          return K ? Q(l, "utf8") : typeof TextEncoder < "u" ? new TextEncoder().encode(l) : Ta(l, { type: "binary" }).split("").map(function(d) {
            return d.charCodeAt(0);
          });
      }
      throw new Error("Unrecognized type " + n.type);
    }
    function qs(t, n) {
      switch (n.type) {
        case "string":
        case "base64":
        case "binary":
          for (var a = "", l = 0; l < t.length; ++l)
            a += String.fromCharCode(t[l]);
          return n.type == "base64" ? Z(a) : n.type == "string" ? Cr(a) : a;
        case "file":
          return Di(n.file, t);
        case "buffer":
          return t;
        default:
          throw new Error("Unrecognized type " + n.type);
      }
    }
    function Yc(t, n) {
      D(), YE(t);
      var a, l = xr(n || {});
      return l.cellStyles && (l.cellNF = !0, l.sheetStubs = !0), l.type != "array" ? (a = t, n = xr((n = l) || {}), Sh(fh(a, n), n)) : (l.type = "binary", t = Yc(t, l), l.type = "array", Ke(t));
    }
    function $s(t, n) {
      D(), YE(t);
      var a = xr(n || {});
      if (a.cellStyles && (a.cellNF = !0, a.sheetStubs = !0), a.type == "array")
        return a.type = "binary", n = $s(t, a), a.type = "array", Ke(n);
      var l, d, _, u = 0;
      if (a.sheet && (u = typeof a.sheet == "number" ? a.sheet : t.SheetNames.indexOf(a.sheet), !t.SheetNames[u]))
        throw new Error("Sheet not found: " + a.sheet + " : " + typeof a.sheet);
      switch (a.bookType || "xlsb") {
        case "xml":
        case "xlml":
          return Ta(AN(t, a), a);
        case "slk":
        case "sylk":
          return Ta(Eg.from_sheet(t.Sheets[t.SheetNames[u]], a), a);
        case "htm":
        case "html":
          return Ta(JE(t.Sheets[t.SheetNames[u]], a), a);
        case "txt":
          return function(p, m) {
            switch (m.type) {
              case "base64":
                return Z(p);
              case "binary":
              case "string":
                return p;
              case "file":
                return Di(m.file, p, "binary");
              case "buffer":
                return K ? Q(p, "binary") : p.split("").map(function(f) {
                  return f.charCodeAt(0);
                });
            }
            throw new Error("Unrecognized type " + m.type);
          }(Rh(t.Sheets[t.SheetNames[u]], a), a);
        case "csv":
          return Ta(qc(t.Sheets[t.SheetNames[u]], a), a, "\uFEFF");
        case "dif":
          return Ta(Sg.from_sheet(t.Sheets[t.SheetNames[u]], a), a);
        case "dbf":
          return qs(cc.from_sheet(t.Sheets[t.SheetNames[u]], a), a);
        case "prn":
          return Ta(Bi.from_sheet(t.Sheets[t.SheetNames[u]], a), a);
        case "rtf":
          return Ta(zg.from_sheet(t.Sheets[t.SheetNames[u]], a), a);
        case "eth":
          return Ta(Rg.from_sheet(t.Sheets[t.SheetNames[u]], a), a);
        case "fods":
          return Ta(lh(t, a), a);
        case "wk1":
          return qs(mi.sheet_to_wk1(t.Sheets[t.SheetNames[u]], a), a);
        case "wk3":
          return qs(mi.book_to_wk3(t, a), a);
        case "biff2":
          a.biff || (a.biff = 2);
        case "biff3":
          a.biff || (a.biff = 3);
        case "biff4":
          return a.biff || (a.biff = 4), qs(zE(t, a), a);
        case "biff5":
          a.biff || (a.biff = 5);
        case "biff8":
        case "xla":
        case "xls":
          return a.biff || (a.biff = 8), hh(DN(t, _ = (_ = a) || {}), _);
        case "xlsx":
        case "xlsm":
        case "xlam":
        case "xlsb":
        case "numbers":
        case "ods":
          return l = t, _ = xr((d = a) || {}), Do = new ZN(d), Sh(XN(l, _), _);
        default:
          throw new Error("Unrecognized bookType |" + a.bookType + "|");
      }
    }
    function Hc(t) {
      var n;
      t.bookType || ((n = t.file.slice(t.file.lastIndexOf(".")).toLowerCase()).match(/^\.[a-z]+$/) && (t.bookType = n.slice(1)), t.bookType = { xls: "biff8", htm: "html", slk: "sylk", socialcalc: "eth", Sh33tJS: "WTF" }[t.bookType] || t.bookType);
    }
    function bh(t, n, a) {
      return a = a || {}, a.type = "file", a.file = n, Hc(a), $s(t, a);
    }
    function Th(t, n, a, l, d, _, u, p) {
      var m = Xr(a), f = p.defval, E = p.raw || !Object.prototype.hasOwnProperty.call(p, "raw"), b = !0, T = d === 1 ? [] : {};
      if (d !== 1)
        if (Object.defineProperty)
          try {
            Object.defineProperty(T, "__rowNum__", { value: a, enumerable: !1 });
          } catch {
            T.__rowNum__ = a;
          }
        else
          T.__rowNum__ = a;
      if (!u || t[a])
        for (var v = n.s.c; v <= n.e.c; ++v) {
          var y = u ? t[a][v] : t[l[v] + m];
          if (y !== void 0 && y.t !== void 0) {
            var R = y.v;
            switch (y.t) {
              case "z":
                if (R == null)
                  break;
                continue;
              case "e":
                R = R == 0 ? null : void 0;
                break;
              case "s":
              case "d":
              case "b":
              case "n":
                break;
              default:
                throw new Error("unrecognized type " + y.t);
            }
            if (_[v] != null) {
              if (R == null)
                if (y.t == "e" && R === null)
                  T[_[v]] = null;
                else if (f !== void 0)
                  T[_[v]] = f;
                else {
                  if (!E || R !== null)
                    continue;
                  T[_[v]] = null;
                }
              else
                T[_[v]] = E && (y.t !== "n" || y.t === "n" && p.rawNumbers !== !1) ? R : Ea(y, R, p);
              R != null && (b = !1);
            }
          } else
            f !== void 0 && _[v] != null && (T[_[v]] = f);
        }
      return { row: T, isempty: b };
    }
    function Ws(t, n) {
      if (t == null || t["!ref"] == null)
        return [];
      var a, l = { t: "n", v: 0 }, d = 0, _ = 1, u = [], p = "", m = { s: { r: 0, c: 0 }, e: { r: 0, c: 0 } }, f = n || {}, E = f.range != null ? f.range : t["!ref"];
      switch (f.header === 1 ? d = 1 : f.header === "A" ? d = 2 : Array.isArray(f.header) ? d = 3 : f.header == null && (d = 0), typeof E) {
        case "string":
          m = lr(E);
          break;
        case "number":
          (m = lr(t["!ref"])).s.r = E;
          break;
        default:
          m = E;
      }
      0 < d && (_ = 0);
      var b = Xr(m.s.r), T = [], v = [], y = 0, R = 0, P = Array.isArray(t), I = m.s.r, A = 0, M = {};
      P && !t[I] && (t[I] = []);
      for (var F, B = f.skipHidden && t["!cols"] || [], re = f.skipHidden && t["!rows"] || [], A = m.s.c; A <= m.e.c; ++A)
        if (!(B[A] || {}).hidden)
          switch (T[A] = Vr(A), l = P ? t[I][A] : t[T[A] + b], d) {
            case 1:
              u[A] = A - m.s.c;
              break;
            case 2:
              u[A] = T[A];
              break;
            case 3:
              u[A] = f.header[A - m.s.c];
              break;
            default:
              if (p = a = Ea(l = l ?? { w: "__EMPTY", t: "s" }, null, f), R = M[a] || 0) {
                for (; p = a + "_" + R++, M[p]; )
                  ;
                M[a] = R, M[p] = 1;
              } else
                M[a] = 1;
              u[A] = p;
          }
      for (I = m.s.r + _; I <= m.e.r; ++I)
        (re[I] || {}).hidden || (F = Th(t, m, I, T, d, u, P, f)).isempty !== !1 && (d === 1 ? f.blankrows === !1 : !f.blankrows) || (v[y++] = F.row);
      return v.length = y, v;
    }
    var vh = /"/g;
    function Ch(t, n, a, l, d, _, u, p) {
      for (var m = !0, f = [], E = "", b = Xr(a), T = n.s.c; T <= n.e.c; ++T)
        if (l[T]) {
          var v = p.dense ? (t[a] || [])[T] : t[l[T] + b];
          if (v == null)
            E = "";
          else if (v.v != null) {
            m = !1, E = "" + (p.rawNumbers && v.t == "n" ? v.v : Ea(v, null, p));
            for (var y, R = 0; R !== E.length; ++R)
              if ((y = E.charCodeAt(R)) === d || y === _ || y === 34 || p.forceQuotes) {
                E = '"' + E.replace(vh, '""') + '"';
                break;
              }
            E == "ID" && (E = '"ID"');
          } else
            v.f == null || v.F ? E = "" : (m = !1, 0 <= (E = "=" + v.f).indexOf(",") && (E = '"' + E.replace(vh, '""') + '"'));
          f.push(E);
        }
      return p.blankrows === !1 && m ? null : f.join(u);
    }
    function qc(t, n) {
      var a = [], l = n ?? {};
      if (t == null || t["!ref"] == null)
        return "";
      var d = lr(t["!ref"]), _ = l.FS !== void 0 ? l.FS : ",", u = _.charCodeAt(0), p = l.RS !== void 0 ? l.RS : `
`, m = p.charCodeAt(0), f = new RegExp((_ == "|" ? "\\|" : _) + "+$"), E = "", b = [];
      l.dense = Array.isArray(t);
      for (var T = l.skipHidden && t["!cols"] || [], v = l.skipHidden && t["!rows"] || [], y = d.s.c; y <= d.e.c; ++y)
        (T[y] || {}).hidden || (b[y] = Vr(y));
      for (var R = 0, P = d.s.r; P <= d.e.r; ++P)
        (v[P] || {}).hidden || (E = Ch(t, d, P, b, u, m, _, l)) != null && (!(E = l.strip ? E.replace(f, "") : E) && l.blankrows === !1 || a.push((R++ ? p : "") + E));
      return delete l.dense, a.join("");
    }
    function Rh(t, n) {
      return (n = n || {}).FS = "	", n.RS = `
`, t = qc(t, n), e === void 0 || n.type == "string" ? t : (t = e.utils.encode(1200, t, "str"), "ÿþ" + t);
    }
    function Nh(E, n, a) {
      var l, d = a || {}, _ = +!d.skipHeader, u = E || {}, p = 0, m = 0;
      u && d.origin != null && (typeof d.origin == "number" ? p = d.origin : (f = typeof d.origin == "string" ? zr(d.origin) : d.origin, p = f.r, m = f.c));
      var f, E = { s: { c: 0, r: 0 }, e: { c: m, r: p + n.length - 1 + _ } };
      u["!ref"] ? (f = lr(u["!ref"]), E.e.c = Math.max(E.e.c, f.e.c), E.e.r = Math.max(E.e.r, f.e.r), p == -1 && (p = f.e.r + 1, E.e.r = p + n.length - 1 + _)) : p == -1 && (p = 0, E.e.r = n.length - 1 + _);
      var b = d.header || [], T = 0;
      n.forEach(function(y, R) {
        $r(y).forEach(function(F) {
          (T = b.indexOf(F)) == -1 && (b[T = b.length] = F);
          var I = y[F], A = "z", M = "", F = $t({ c: m + T, r: p + R + _ });
          l = zs(u, F), !I || typeof I != "object" || I instanceof Date ? (typeof I == "number" ? A = "n" : typeof I == "boolean" ? A = "b" : typeof I == "string" ? A = "s" : I instanceof Date ? (A = "d", d.cellDates || (A = "n", I = on(I)), M = d.dateNF || ae[14]) : I === null && d.nullError && (A = "e", I = 0), l ? (l.t = A, l.v = I, delete l.w, delete l.R, M && (l.z = M)) : u[F] = l = { t: A, v: I }, M && (l.z = M)) : u[F] = I;
        });
      }), E.e.c = Math.max(E.e.c, m + b.length - 1);
      var v = Xr(p);
      if (_)
        for (T = 0; T < b.length; ++T)
          u[Vr(T + m) + v] = { t: "s", v: b[T] };
      return u["!ref"] = Xt(E), u;
    }
    function zs(t, n, a) {
      return typeof n != "string" ? zs(t, $t(typeof n != "number" ? n : { r: n, c: a || 0 })) : Array.isArray(t) ? (a = zr(n), t[a.r] || (t[a.r] = []), t[a.r][a.c] || (t[a.r][a.c] = { t: "z" })) : t[n] || (t[n] = { t: "z" });
    }
    function $c() {
      return { SheetNames: [], Sheets: {} };
    }
    function Wc(t, n, a, l) {
      var d = 1;
      if (!a)
        for (; d <= 65535 && t.SheetNames.indexOf(a = "Sheet" + d) != -1; ++d, a = void 0)
          ;
      if (!a || 65535 <= t.SheetNames.length)
        throw new Error("Too many worksheets");
      if (l && 0 <= t.SheetNames.indexOf(a)) {
        var l = a.match(/(^.*?)(\d+)$/), d = l && +l[2] || 0, _ = l && l[1] || a;
        for (++d; d <= 65535 && t.SheetNames.indexOf(a = _ + d) != -1; ++d)
          ;
      }
      if (VE(a), 0 <= t.SheetNames.indexOf(a))
        throw new Error("Worksheet with name |" + a + "| already exists!");
      return t.SheetNames.push(a), t.Sheets[a] = n, a;
    }
    function Ah(t, n, a) {
      return n ? (t.l = { Target: n }, a && (t.l.Tooltip = a)) : delete t.l, t;
    }
    var Ks, zc = { encode_col: Vr, encode_row: Xr, encode_cell: $t, encode_range: Xt, decode_col: Kl, decode_row: zl, split_cell: function(t) {
      return t.replace(/(\$?[A-Z]*)(\$?\d*)/, "$1,$2").split(",");
    }, decode_cell: zr, decode_range: Un, format_cell: Ea, sheet_add_aoa: mf, sheet_add_json: Nh, sheet_add_dom: eh, aoa_to_sheet: Pi, json_to_sheet: function(t, n) {
      return Nh(null, t, n);
    }, table_to_sheet: th, table_to_book: function(t, n) {
      return Ha(th(t, n), n);
    }, sheet_to_csv: qc, sheet_to_txt: Rh, sheet_to_json: Ws, sheet_to_html: JE, sheet_to_formulae: function(t) {
      var n, a = "", l = "";
      if (t == null || t["!ref"] == null)
        return [];
      for (var d, _ = lr(t["!ref"]), u = [], p = [], m = Array.isArray(t), f = _.s.c; f <= _.e.c; ++f)
        u[f] = Vr(f);
      for (var E = _.s.r; E <= _.e.r; ++E)
        for (d = Xr(E), f = _.s.c; f <= _.e.c; ++f)
          if (a = u[f] + d, l = "", (n = m ? (t[E] || [])[f] : t[a]) !== void 0) {
            if (n.F != null) {
              if (a = n.F, !n.f)
                continue;
              l = n.f, a.indexOf(":") == -1 && (a = a + ":" + a);
            }
            if (n.f != null)
              l = n.f;
            else {
              if (n.t == "z")
                continue;
              if (n.t == "n" && n.v != null)
                l = "" + n.v;
              else if (n.t == "b")
                l = n.v ? "TRUE" : "FALSE";
              else if (n.w !== void 0)
                l = "'" + n.w;
              else {
                if (n.v === void 0)
                  continue;
                l = n.t == "s" ? "'" + n.v : "" + n.v;
              }
            }
            p[p.length] = a + "=" + l;
          }
      return p;
    }, sheet_to_row_object_array: Ws, sheet_get_cell: zs, book_new: $c, book_append_sheet: Wc, book_set_sheet_visibility: function(t, n, a) {
      switch (t.Workbook || (t.Workbook = {}), t.Workbook.Sheets || (t.Workbook.Sheets = []), n = function(l, d) {
        if (typeof d == "number") {
          if (0 <= d && l.SheetNames.length > d)
            return d;
          throw new Error("Cannot find sheet # " + d);
        }
        if (typeof d != "string")
          throw new Error("Cannot find sheet |" + d + "|");
        if (-1 < (l = l.SheetNames.indexOf(d)))
          return l;
        throw new Error("Cannot find sheet name |" + d + "|");
      }(t, n), t.Workbook.Sheets[n] || (t.Workbook.Sheets[n] = {}), a) {
        case 0:
        case 1:
        case 2:
          break;
        default:
          throw new Error("Bad sheet visibility setting " + a);
      }
      t.Workbook.Sheets[n].Hidden = a;
    }, cell_set_number_format: function(t, n) {
      return t.z = n, t;
    }, cell_set_hyperlink: Ah, cell_set_internal_link: function(t, n, a) {
      return Ah(t, "#" + n, a);
    }, cell_add_comment: function(t, n, a) {
      t.c || (t.c = []), t.c.push({ t: n, a: a || "SheetJS" });
    }, sheet_set_array_formula: function(t, n, a, l) {
      for (var d = typeof n != "string" ? n : lr(n), _ = typeof n == "string" ? n : Xt(n), u = d.s.r; u <= d.e.r; ++u)
        for (var p = d.s.c; p <= d.e.c; ++p) {
          var m = zs(t, u, p);
          m.t = "n", m.F = _, delete m.v, u == d.s.r && p == d.s.c && (m.f = a, l && (m.D = !0));
        }
      return t;
    }, consts: { SHEET_VISIBLE: 0, SHEET_HIDDEN: 1, SHEET_VERY_HIDDEN: 2 } };
    function Oh(t) {
      Ks = t;
    }
    var zi = { to_json: function(t, n) {
      var a = Ks({ objectMode: !0 });
      if (t == null || t["!ref"] == null)
        return a.push(null), a;
      var l, d = { t: "n", v: 0 }, _ = 0, u = 1, p = [], m = "", f = { s: { r: 0, c: 0 }, e: { r: 0, c: 0 } }, E = n || {}, b = E.range != null ? E.range : t["!ref"];
      switch (E.header === 1 ? _ = 1 : E.header === "A" ? _ = 2 : Array.isArray(E.header) && (_ = 3), typeof b) {
        case "string":
          f = lr(b);
          break;
        case "number":
          (f = lr(t["!ref"])).s.r = b;
          break;
        default:
          f = b;
      }
      0 < _ && (u = 0);
      var T = Xr(f.s.r), v = [], y = 0, R = Array.isArray(t), P = f.s.r, I = 0, A = {};
      R && !t[P] && (t[P] = []);
      for (var M = E.skipHidden && t["!cols"] || [], F = E.skipHidden && t["!rows"] || [], I = f.s.c; I <= f.e.c; ++I)
        if (!(M[I] || {}).hidden)
          switch (v[I] = Vr(I), d = R ? t[P][I] : t[v[I] + T], _) {
            case 1:
              p[I] = I - f.s.c;
              break;
            case 2:
              p[I] = v[I];
              break;
            case 3:
              p[I] = E.header[I - f.s.c];
              break;
            default:
              if (m = l = Ea(d = d ?? { w: "__EMPTY", t: "s" }, null, E), y = A[l] || 0) {
                for (; m = l + "_" + y++, A[m]; )
                  ;
                A[l] = y, A[m] = 1;
              } else
                A[l] = 1;
              p[I] = m;
          }
      return P = f.s.r + u, a._read = function() {
        for (; P <= f.e.r; )
          if (!(F[P - 1] || {}).hidden) {
            var B = Th(t, f, P, v, _, p, R, E);
            if (++P, B.isempty === !1 || (_ === 1 ? E.blankrows !== !1 : E.blankrows))
              return void a.push(B.row);
          }
        return a.push(null);
      }, a;
    }, to_html: function(t, d) {
      var a = Ks(), l = d || {}, d = l.header != null ? l.header : XE, _ = l.footer != null ? l.footer : ZE;
      a.push(d);
      var u = Un(t["!ref"]);
      l.dense = Array.isArray(t), a.push(jE(0, 0, l));
      var p = u.s.r, m = !1;
      return a._read = function() {
        if (p > u.e.r)
          return m || (m = !0, a.push("</table>" + _)), a.push(null);
        for (; p <= u.e.r; ) {
          a.push(QE(t, u, p, l)), ++p;
          break;
        }
      }, a;
    }, to_csv: function(t, n) {
      var a = Ks(), l = n ?? {};
      if (t == null || t["!ref"] == null)
        return a.push(null), a;
      var d = lr(t["!ref"]), _ = l.FS !== void 0 ? l.FS : ",", u = _.charCodeAt(0), p = l.RS !== void 0 ? l.RS : `
`, m = p.charCodeAt(0), f = new RegExp((_ == "|" ? "\\|" : _) + "+$"), E = "", b = [];
      l.dense = Array.isArray(t);
      for (var T = l.skipHidden && t["!cols"] || [], v = l.skipHidden && t["!rows"] || [], y = d.s.c; y <= d.e.c; ++y)
        (T[y] || {}).hidden || (b[y] = Vr(y));
      var R = d.s.r, P = !1, I = 0;
      return a._read = function() {
        if (!P)
          return P = !0, a.push("\uFEFF");
        for (; R <= d.e.r; )
          if (++R, !(v[R - 1] || {}).hidden && (E = Ch(t, d, R - 1, b, u, m, _, l), E != null && ((E = l.strip ? E.replace(f, "") : E) || l.blankrows !== !1)))
            return a.push((I++ ? p : "") + E);
        return a.push(null);
      }, a;
    }, set_readable: Oh }, _r = function() {
      function t(n, a, l) {
        return this instanceof t ? (this.tagName = n, this._attributes = a || {}, this._children = l || [], this._prefix = "", this) : new t(n, a, l);
      }
      return t.prototype.createElement = function() {
        return new t(arguments);
      }, t.prototype.children = function() {
        return this._children;
      }, t.prototype.append = function(n) {
        return this._children.push(n), this;
      }, t.prototype.prefix = function(n) {
        return arguments.length == 0 ? this._prefix : (this._prefix = n, this);
      }, t.prototype.attr = function(n, a) {
        if (a == null)
          return delete this._attributes[n], this;
        if (arguments.length == 0)
          return this._attributes;
        if (typeof n == "string" && arguments.length == 1)
          return this._attributes.attr[n];
        if (typeof n == "object" && arguments.length == 1)
          for (var l in n)
            this._attributes[l] = n[l];
        else
          arguments.length == 2 && typeof n == "string" && (this._attributes[n] = a);
        return this;
      }, t.prototype.escapeAttributeValue = function(n) {
        return '"' + n.replace(/\"/g, "&quot;") + '"';
      }, t.prototype.toXml = function(n) {
        var a = (n = n || this)._prefix;
        if (a += "<" + n.tagName, n._attributes)
          for (var l in n._attributes)
            a += " " + l + "=" + this.escapeAttributeValue("" + n._attributes[l]);
        if (n._children && 0 < n._children.length) {
          a += ">";
          for (var d = 0; d < n._children.length; d++)
            a += this.toXml(n._children[d]);
          a += "</" + n.tagName + ">";
        } else
          a += "/>";
        return a;
      }, t;
    }(), ZN = function(t) {
      var n, a = 164, l = { 0: "General", 1: "0", 2: "0.00", 3: "#,##0", 4: "#,##0.00", 9: "0%", 10: "0.00%", 11: "0.00E+00", 12: "# ?/?", 13: "# ??/??", 14: "m/d/yy", 15: "d-mmm-yy", 16: "d-mmm", 17: "mmm-yy", 18: "h:mm AM/PM", 19: "h:mm:ss AM/PM", 20: "h:mm", 21: "h:mm:ss", 22: "m/d/yy h:mm", 37: "#,##0 ;(#,##0)", 38: "#,##0 ;[Red](#,##0)", 39: "#,##0.00;(#,##0.00)", 40: "#,##0.00;[Red](#,##0.00)", 45: "mm:ss", 46: "[h]:mm:ss", 47: "mmss.0", 48: "##0.0E+0", 49: "@", 56: '"上午/下午 "hh"時"mm"分"ss"秒 "' }, d = {};
      for (n in l)
        d[l[n]] = n;
      var _ = {};
      return { initialize: function(u) {
        this.$fonts = _r("fonts").attr("count", 0).attr("x14ac:knownFonts", "1"), this.$fills = _r("fills").attr("count", 0), this.$borders = _r("borders").attr("count", 0), this.$numFmts = _r("numFmts").attr("count", 0), this.$cellStyleXfs = _r("cellStyleXfs"), this.$xf = _r("xf").attr("numFmtId", 0).attr("fontId", 0).attr("fillId", 0).attr("borderId", 0), this.$cellXfs = _r("cellXfs").attr("count", 0), this.$cellStyles = _r("cellStyles").append(_r("cellStyle").attr("name", "Normal").attr("xfId", 0).attr("builtinId", 0)), this.$dxfs = _r("dxfs").attr("count", "0"), this.$tableStyles = _r("tableStyles").attr("count", "0").attr("defaultTableStyle", "TableStyleMedium9").attr("defaultPivotStyle", "PivotStyleMedium4"), this.$styles = _r("styleSheet").attr("xmlns:mc", "http://schemas.openxmlformats.org/markup-compatibility/2006").attr("xmlns:x14ac", "http://schemas.microsoft.com/office/spreadsheetml/2009/9/ac").attr("xmlns", "http://schemas.openxmlformats.org/spreadsheetml/2006/main").attr("mc:Ignorable", "x14ac").prefix('<?xml version="1.0" encoding="UTF-8" standalone="yes"?>').append(this.$numFmts).append(this.$fonts).append(this.$fills).append(this.$borders).append(this.$cellStyleXfs.append(this.$xf)).append(this.$cellXfs).append(this.$cellStyles).append(this.$dxfs).append(this.$tableStyles);
        var p = u.defaultCellStyle || {};
        return p.font || (p.font = { name: "Calibri", sz: "11" }), p.font.name || (p.font.name = "Calibri"), p.font.sz || (p.font.sz = 11), p.fill || (p.fill = { patternType: "none", fgColor: {} }), p.border || (p.border = {}), p.numFmt || (p.numFmt = 0), this.defaultStyle = p, u = JSON.parse(JSON.stringify(p)), u.fill = { patternType: "gray125", fgColor: {} }, this.addStyles([p, u]), this;
      }, addStyle: function(u) {
        var p = JSON.stringify(u), m = _[p];
        return m == null ? (m = this._addXf(u), _[p] = m) : m = _[p], m;
      }, addStyles: function(u) {
        var p = this;
        return u.map(function(m) {
          return p.addStyle(m);
        });
      }, _duckTypeStyle: function(u) {
        return typeof u == "object" && (u.patternFill || u.fgColor) ? { fill: u } : u.font || u.numFmt || u.border || u.fill ? u : this._getStyleCSS(u);
      }, _getStyleCSS: function(u) {
        return u;
      }, _addXf: function(u) {
        var p = this._addFont(u.font), m = this._addFill(u.fill), f = this._addBorder(u.border), E = this._addNumFmt(u.numFmt), b = _r("xf").attr("numFmtId", E).attr("fontId", p).attr("fillId", m).attr("borderId", f).attr("xfId", "0");
        return 0 < p && b.attr("applyFont", "1"), 0 < m && b.attr("applyFill", "1"), 0 < f && b.attr("applyBorder", "1"), 0 < E && b.attr("applyNumberFormat", "1"), u.alignment && (E = _r("alignment"), u.alignment.horizontal && E.attr("horizontal", u.alignment.horizontal), u.alignment.vertical && E.attr("vertical", u.alignment.vertical), u.alignment.indent && E.attr("indent", u.alignment.indent), u.alignment.readingOrder && E.attr("readingOrder", u.alignment.readingOrder), u.alignment.wrapText && E.attr("wrapText", u.alignment.wrapText), u.alignment.textRotation != null && E.attr("textRotation", u.alignment.textRotation), b.append(E).attr("applyAlignment", 1)), this.$cellXfs.append(b), b = +this.$cellXfs.children().length, this.$cellXfs.attr("count", b), b - 1;
      }, _addFont: function(u) {
        if (!u)
          return 0;
        var p = _r("font").append(_r("sz").attr("val", u.sz || this.defaultStyle.font.sz)).append(_r("name").attr("val", u.name || this.defaultStyle.font.name));
        return u.bold && p.append(_r("b")), u.underline && p.append(_r("u")), u.italic && p.append(_r("i")), u.strike && p.append(_r("strike")), u.outline && p.append(_r("outline")), u.shadow && p.append(_r("shadow")), u.vertAlign && p.append(_r("vertAlign").attr("val", u.vertAlign)), u.color && (u.color.theme ? (p.append(_r("color").attr("theme", u.color.theme)), u.color.tint && p.append(_r("tint").attr("theme", u.color.tint))) : u.color.rgb && p.append(_r("color").attr("rgb", u.color.rgb))), this.$fonts.append(p), p = this.$fonts.children().length, this.$fonts.attr("count", p), p - 1;
      }, _addNumFmt: function(u) {
        if (!u)
          return 0;
        if (typeof u == "string") {
          var p = d[u];
          if (0 <= p)
            return p;
        }
        return /^[0-9]+$/.exec(u) ? u : (u = u.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&apos;"), u = _r("numFmt").attr("numFmtId", ++a).attr("formatCode", u), this.$numFmts.append(u), u = this.$numFmts.children().length, this.$numFmts.attr("count", u), a);
      }, _addFill: function(u) {
        if (!u)
          return 0;
        var p, m = _r("patternFill").attr("patternType", u.patternType || "solid");
        return u.fgColor && (p = _r("fgColor"), u.fgColor.rgb ? (u.fgColor.rgb.length == 6 && (u.fgColor.rgb = "FF" + u.fgColor.rgb), p.attr("rgb", u.fgColor.rgb), m.append(p)) : u.fgColor.theme && (p.attr("theme", u.fgColor.theme), u.fgColor.tint && p.attr("tint", u.fgColor.tint), m.append(p)), u.bgColor || (u.bgColor = { indexed: "64" })), u.bgColor && (u = _r("bgColor").attr(u.bgColor), m.append(u)), m = _r("fill").append(m), this.$fills.append(m), m = this.$fills.children().length, this.$fills.attr("count", m), m - 1;
      }, _getSubBorder: function(u, p) {
        var m = _r(u);
        return p && (m.attr("style", p.style || "medium"), p.color && (u = _r("color"), p.color.auto ? u.attr("auto", p.color.auto) : p.color.rgb ? u.attr("rgb", p.color.rgb) : (p.color.theme || p.color.tint) && (u.attr("theme", p.color.theme || "1"), u.attr("tint", p.color.tint || "0")), m.append(u))), m;
      }, _addBorder: function(u) {
        if (!u)
          return 0;
        var p = this, m = _r("border").attr("diagonalUp", u.diagonalUp).attr("diagonalDown", u.diagonalDown);
        ["left", "right", "top", "bottom", "diagonal"].forEach(function(E) {
          m.append(p._getSubBorder(E, u[E]));
        }), this.$borders.append(m);
        var f = this.$borders.children().length;
        return this.$borders.attr("count", f), f - 1;
      }, toXml: function() {
        return this.$styles.toXml();
      } }.initialize(t || {});
    };
    Ys !== void 0 && (r.parse_xlscfb = Ys), r.parse_zip = mh, r.read = Hs, r.readFile = Eh, r.readFileSync = Eh, r.write = $s, r.writeFile = bh, r.writeFileSync = bh, r.writeFileAsync = function(t, n, a, l) {
      var d = a || {};
      return d.type = "file", d.file = t, Hc(d), d.type = "buffer", l instanceof Function || (l = a), Ia.writeFile(t, $s(n, d), l);
    }, r.utils = zc, r.writeXLSX = Yc, r.writeFileXLSX = function(t, n, a) {
      return (a = a || {}).type = "file", a.file = n, Hc(a), Yc(t, a);
    }, r.SSF = ya, zi !== void 0 && (r.stream = zi), Lt !== void 0 && (r.CFB = Lt), typeof el > "u" || ((zi = Zc) || {}).Readable && Oh(zi.Readable);
  }
  if (c(i), typeof window < "u" && !window.XLSX)
    try {
      window.XLSX = o;
    } catch {
    }
})(Dh, Dh.exports);
function jc(s, i) {
  const o = [];
  for (let c = 0; c < s.length; c += i)
    o.push(s.slice(c, c + i));
  return o;
}
const CA = (s) => s.map((i) => ({ ...i }));
function um(s = 0, i, o) {
  const c = pt(!1), r = pt(null), e = pt(null), g = pt({}), h = async () => {
    if (!r.value || !e.value)
      return;
    let N = i;
    const { left: D, top: x, height: L } = r.value.getBoundingClientRect(), G = D + window.scrollX, Y = x + window.scrollY, k = window.innerHeight < x + L + N;
    g.value = {
      left: `${G}px`,
      top: k ? "auto" : `${Y + L + s}px`,
      bottom: k ? `${window.innerHeight - Y + s}px` : "auto"
    };
  };
  function S(N) {
    e.value && N.target instanceof HTMLElement && r.value && !e.value.contains(N.target) && !r.value.contains(N.target) && !N.target.classList.contains("item") && (o && o(), c.value = !1);
  }
  function C() {
    h();
  }
  function O(N) {
    N.target instanceof HTMLElement && e.value && e.value.contains(N.target) || (c.value = !1);
  }
  return an(c, (N) => {
    N ? (document.body.addEventListener("click", S), window.addEventListener("scroll", C), window.addEventListener("resize", O), window.addEventListener("scroll", O, !0)) : (document.body.removeEventListener("click", S), window.removeEventListener("scroll", C), window.removeEventListener("resize", O), window.removeEventListener("scroll", O, !0));
  }), { position: g, targetElement: r, element: e, toggleHandler: h, isHidden: c };
}
let Qs;
const RA = new Uint8Array(16);
function NA() {
  if (!Qs && (Qs = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto), !Qs))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return Qs(RA);
}
const On = [];
for (let s = 0; s < 256; ++s)
  On.push((s + 256).toString(16).slice(1));
function AA(s, i = 0) {
  return On[s[i + 0]] + On[s[i + 1]] + On[s[i + 2]] + On[s[i + 3]] + "-" + On[s[i + 4]] + On[s[i + 5]] + "-" + On[s[i + 6]] + On[s[i + 7]] + "-" + On[s[i + 8]] + On[s[i + 9]] + "-" + On[s[i + 10]] + On[s[i + 11]] + On[s[i + 12]] + On[s[i + 13]] + On[s[i + 14]] + On[s[i + 15]];
}
const OA = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto), xh = {
  randomUUID: OA
};
function yi(s, i, o) {
  if (xh.randomUUID && !i && !s)
    return xh.randomUUID();
  s = s || {};
  const c = s.random || (s.rng || NA)();
  if (c[6] = c[6] & 15 | 64, c[8] = c[8] & 63 | 128, i) {
    o = o || 0;
    for (let r = 0; r < 16; ++r)
      i[o + r] = c[r];
    return i;
  }
  return AA(c);
}
const yA = ["for"], IA = ["id", "placeholder", "maxlength", "value", "readonly", "name"], DA = { class: "dp-head" }, wA = { class: "dp-body" }, xA = ["onKeydown", "onClick"], LA = ["onClick", "onKeydown"], MA = ["onKeydown", "onClick"], PA = ["onKeydown", "onClick"], kA = /* @__PURE__ */ Nr({
  __name: "VDatepicker",
  props: {
    disabled: { type: Boolean, default: !1 },
    modelValue: { default: null },
    range: {},
    type: { default: "nomal" },
    width: {},
    monthPicker: { type: Boolean, default: !1 },
    yearPicker: { type: Boolean, default: !1 },
    placeholder: { default: "날짜를 선택하세요." },
    minDate: {},
    maxDate: {},
    name: {},
    resetCalendar: { type: Boolean },
    defaultDate: { default: () => /* @__PURE__ */ new Date() }
  },
  emits: ["change", "update:modelValue", "update:range", "blur", "input"],
  setup(s, { emit: i }) {
    var ge, w, fe;
    const o = s, c = i, r = pt("D"), e = Vt(
      () => ({
        D: "YYYY-MM-DD",
        M: "YYYY-MM",
        Y: "YYYY"
      })[r.value]
    );
    o.monthPicker && (r.value = "M"), o.yearPicker && (r.value = "Y");
    const g = pt((o.modelValue || ((ge = o.range) == null ? void 0 : ge[0])) ?? o.defaultDate), h = pt((w = o.range) != null && w[0] && ((fe = o.range) != null && fe[1]) ? [o.range[0], o.range[1]] : []), S = pt(o.modelValue ? rr(o.modelValue).format(e.value) : ""), C = Vt(() => o.range && o.range.length === 2 ? `${rr(o.range[0]).format("YYYY-MM-DD")} ~ ${rr(o.range[1]).format("YYYY-MM-DD")}` : ""), O = rr().format("YYYY-MM-DD"), N = Vt(() => {
      if (!o.modelValue)
        return "";
      const j = rr(o.modelValue);
      return r.value === "D" ? j.format("YYYY-MM-DD") : r.value === "M" ? j.format("YYYY-MM") : j.format("YYYY");
    }), D = Vt(() => [...h.value].sort((J, de) => J < de ? -1 : 1).map((J) => rr(J).format("YYYY-MM-DD"))), x = Vt(() => jc(
      [
        ...fA(g.value),
        ...L(gA(g.value)),
        ...EA(g.value)
      ],
      7
    ));
    function L(j) {
      return j.map((J) => (o.minDate && J.format < rr(o.minDate).format(e.value) && (J.unable = !0), o.maxDate && J.format > rr(o.maxDate).format(e.value) && (J.unable = !0), J));
    }
    const G = (j) => !(o.minDate && j < o.minDate || o.maxDate && j > o.maxDate), Y = Vt(() => jc(L(hA(g.value)), 4)), k = Vt(() => jc(L(SA(g.value)), 4)), W = (j) => {
      if (r.value === "D")
        g.value = rr(g.value).add(j, "month").toDate();
      else if (r.value === "M")
        g.value = rr(g.value).add(j, "year").toDate();
      else if (r.value === "Y") {
        const J = rr(g.value), de = +(Number(J.format("YYYY").slice(0, 3)) + j + "0");
        g.value = rr(de + "-" + J.format("MM-DD")).toDate();
      }
    }, Z = (j) => {
      if (g.value = rr(j).toDate(), S.value = rr(j).format(j), c("input", S.value), r.value === "Y") {
        if (o.yearPicker) {
          c("update:modelValue", g.value), c("change", g.value), Q.value = !1;
          return;
        }
        r.value = "M";
      } else if (r.value === "M") {
        if (o.monthPicker) {
          c("update:modelValue", g.value), c("change", g.value), Q.value = !1;
          return;
        }
        r.value = "D";
      } else
        r.value === "D" && (c("update:modelValue", g.value), c("change", g.value), Q.value = !1);
    }, H = (j) => {
      const J = rr(j).toDate();
      h.value.length === 2 ? h.value = [J] : h.value[0] < J ? h.value.push(J) : h.value.unshift(J), h.value.length === 2 && (S.value = rr(h.value[0]).format("YYYY-MM-DD") + " ~ " + rr(h.value[1]).format("YYYY-MM-DD")), c("update:range", h.value), c("change", h.value);
    }, K = (j) => {
      if (j >= D.value[0] && j <= D.value[1])
        return !0;
    };
    an(
      () => o.modelValue,
      (j) => {
        j ? (S.value = rr(o.modelValue).format(e.value), g.value = new Date(j)) : (S.value = "", g.value = o.defaultDate);
      }
    ), an(
      () => o.defaultDate,
      (j) => {
        o.modelValue || (g.value = j);
      }
    );
    const { isHidden: Q, toggleHandler: _e, position: se, element: Pe, targetElement: Ke } = um(4, 280, () => {
      c("blur");
    }), ye = (j) => {
      const J = j.target;
      if (c("input", J.value), J.value === "" && (c("update:modelValue", null), c("change", null)), J.value.length < S.value.length)
        return S.value = J.value;
      const de = J.value.replace(/\s/g, "").replace(/-/g, "").replace(/\./g, "");
      if (!isNaN(Number(de))) {
        if (de.length === 4 && (S.value = de.substring(0, 4) + "-", g.value = rr(g.value).set("year", Number(de.substring(0, 4))).toDate()), de.length === 6) {
          var ie = de.substring(0, 4), X = de.substring(4, 6);
          if (S.value = ie + "-" + X + (r.value === "D" ? "-" : ""), g.value = rr(g.value).set("month", Number(X) - 1).toDate(), r.value === "M") {
            const Oe = rr(S.value).toDate();
            if (!G(Oe) && o.modelValue) {
              c("update:modelValue", new Date(o.modelValue)), c("change", new Date(o.modelValue)), J.blur(), Q.value = !1;
              return;
            }
            g.value = Oe, c("update:modelValue", Oe), c("change", Oe), Q.value = !1, J.blur();
            return;
          }
        }
        if (r.value !== "M" && de.length === 8) {
          var ie = de.substring(0, 4), X = de.substring(4, 6), ue = de.substring(6, 8);
          S.value = ie + "-" + X + "-" + ue;
          const ae = rr(S.value).toDate();
          if (!G(ae) && o.modelValue) {
            c("update:modelValue", new Date(o.modelValue)), c("change", new Date(o.modelValue)), J.blur(), Q.value = !1;
            return;
          }
          c("update:modelValue", ae), c("change", ae), J.blur(), Q.value = !1;
        }
      }
    }, Je = ts(), mt = Vt(() => Je.id ? Je.id : `VTextInput-${yi()}`);
    return (j, J) => {
      const de = pr("VIconFont");
      return he(), De("div", {
        class: jt(["VDatepicker", { "is-disabled": j.disabled, resetCalendar: j.resetCalendar }]),
        style: nn({ width: j.width }),
        onKeydown: J[6] || (J[6] = vi((ie) => {
          Q.value = !kt(Q), kt(_e)();
        }, ["enter"])),
        tabindex: "0"
      }, [
        U("label", {
          for: mt.value,
          class: "sr-only"
        }, "Text label", 8, yA),
        U("input", {
          type: "text",
          id: mt.value,
          ref_key: "targetElement",
          ref: Ke,
          class: jt(["date-text", { "is-disabled": j.disabled, "is-focus": kt(Q) }]),
          style: nn({ width: /px/.test(j.width || "") ? j.width : "100%" }),
          placeholder: j.placeholder,
          maxlength: r.value === "M" ? 7 : 10,
          onClick: J[0] || (J[0] = (ie) => {
            Q.value = !0, kt(_e)();
          }),
          value: j.type === "range" ? C.value : S.value,
          readonly: !/(D|M)/.test(r.value) || j.type === "range" || !kt(Q),
          onInput: ye,
          name: j.name
        }, null, 46, IA),
        Ze(de, {
          icon: "ic_calendar",
          class: "VDatepicker-icon"
        }),
        j.resetCalendar ? (he(), De("button", {
          key: 0,
          type: "button",
          "aria-label": "캘린더값 초기화",
          class: "reset-calendar",
          onClick: J[1] || (J[1] = (ie) => c("update:modelValue", null))
        }, [
          Ze(de, { icon: "ic_close" })
        ])) : Ut("", !0),
        (he(), gn(ul, { to: "body" }, [
          fn(U("div", {
            class: "dp-group",
            ref_key: "element",
            ref: Pe,
            style: nn(kt(se))
          }, [
            U("div", DA, [
              U("button", {
                type: "button",
                class: "arrow-left mr-20",
                onClick: J[2] || (J[2] = (ie) => W(-1))
              }, [
                Ze(de, { icon: "ic_arrow" })
              ]),
              j.yearPicker ? Ut("", !0) : (he(), De("div", {
                key: 0,
                class: "month mr-10",
                onClick: J[3] || (J[3] = (ie) => r.value = "M")
              }, wt(kt(rr)(g.value).format("MM")) + "월 ", 1)),
              U("div", {
                class: "year mr-20",
                onClick: J[4] || (J[4] = (ie) => r.value = "Y")
              }, wt(kt(rr)(g.value).format("YYYY")) + "년", 1),
              U("button", {
                type: "button",
                class: "arrow-right",
                onClick: J[5] || (J[5] = (ie) => W(1))
              }, [
                Ze(de, { icon: "ic_arrow" })
              ])
            ]),
            U("div", wA, [
              r.value === "D" ? (he(), De(nr, { key: 0 }, [
                J[7] || (J[7] = U("div", { class: "dp-week" }, [
                  U("div", { class: "item" }, "월"),
                  U("div", { class: "item" }, "화"),
                  U("div", { class: "item" }, "수"),
                  U("div", { class: "item" }, "목"),
                  U("div", { class: "item" }, "금"),
                  U("div", { class: "item" }, "토"),
                  U("div", { class: "item" }, "일")
                ], -1)),
                j.type === "nomal" ? (he(!0), De(nr, { key: 0 }, Fr(x.value, (ie, X) => (he(), De("div", {
                  class: "dp-day",
                  key: X
                }, [
                  (he(!0), De(nr, null, Fr(ie, (ue) => (he(), De("div", {
                    class: "item",
                    key: ue.month + ue.day
                  }, [
                    ue.disabled ? Ut("", !0) : (he(), De("div", {
                      key: 0,
                      class: jt(["item-circle", {
                        "is-disabled": ue.disabled,
                        "has-today": ue.format === kt(O),
                        "is-active": ue.format === N.value,
                        unabled: ue.unable
                      }]),
                      tabindex: "0",
                      onKeydown: vi((Oe) => Z(ue.format), ["enter"]),
                      onClick: (Oe) => Z(ue.format)
                    }, wt(ue.day), 43, xA))
                  ]))), 128))
                ]))), 128)) : Ut("", !0),
                j.type === "range" ? (he(!0), De(nr, { key: 1 }, Fr(x.value, (ie, X) => (he(), De("div", {
                  class: "dp-day",
                  key: X
                }, [
                  (he(!0), De(nr, null, Fr(ie, (ue) => (he(), De("div", {
                    class: jt(["item", {
                      "left-radius": ue.format === D.value[0],
                      "right-radius": ue.format === D.value[1],
                      "range-bg": K(ue.format) && !ue.disabled
                    }]),
                    key: ue.month + ue.day
                  }, [
                    ue.disabled ? Ut("", !0) : (he(), De("div", {
                      key: 0,
                      onClick: (Oe) => H(ue.format),
                      class: jt(["item-circle", {
                        "is-disabled": ue.disabled,
                        "has-today": ue.format === kt(O),
                        "is-active": ue.format === D.value[0] || ue.format === D.value[1],
                        unabled: ue.unable
                      }]),
                      onKeydown: vi((Oe) => H(ue.format), ["enter"])
                    }, wt(ue.day), 43, LA))
                  ], 2))), 128))
                ]))), 128)) : Ut("", !0)
              ], 64)) : Ut("", !0),
              r.value === "M" ? (he(!0), De(nr, { key: 1 }, Fr(Y.value, (ie, X) => (he(), De("div", {
                class: "dp-month",
                key: X
              }, [
                (he(!0), De(nr, null, Fr(ie, (ue) => (he(), De("div", {
                  class: jt(["item", {
                    "is-active": ue.format === N.value,
                    unabled: ue.unable
                  }]),
                  key: ue.month,
                  tabindex: "0",
                  onKeydown: vi((Oe) => Z(ue.format), ["enter"]),
                  onClick: (Oe) => Z(ue.format)
                }, wt(ue.month), 43, MA))), 128))
              ]))), 128)) : Ut("", !0),
              r.value === "Y" ? (he(!0), De(nr, { key: 2 }, Fr(k.value, (ie, X) => (he(), De("div", {
                class: "dp-year",
                key: X
              }, [
                (he(!0), De(nr, null, Fr(ie, (ue) => (he(), De("div", {
                  class: jt(["item", {
                    "is-active": ue.format === N.value,
                    unabled: ue.unable
                  }]),
                  key: ue.year,
                  tabindex: "0",
                  onKeydown: vi((Oe) => Z(ue.format), ["enter"]),
                  onClick: (Oe) => Z(ue.format)
                }, wt(ue.year), 43, PA))), 128))
              ]))), 128)) : Ut("", !0)
            ])
          ], 4), [
            [ea, kt(Q)]
          ])
        ]))
      ], 38);
    };
  }
}), wr = (s, i) => {
  const o = s.__vccOpts || s;
  for (const [c, r] of i)
    o[c] = r;
  return o;
}, FA = /* @__PURE__ */ wr(kA, [["__scopeId", "data-v-dfa73bb5"]]), UA = ["type"], BA = /* @__PURE__ */ Nr({
  __name: "VButton",
  props: {
    color: { default: "primary" },
    type: { default: "button" },
    mini: { type: Boolean, default: !1 },
    label: { default: "" },
    icon: {}
  },
  setup(s) {
    return (i, o) => {
      const c = pr("VIconFont");
      return he(), De("button", {
        type: i.type,
        class: jt(["btn", ["btn-" + i.color, i.mini ? "btn-mini" : ""]])
      }, [
        i.icon ? (he(), gn(c, {
          key: 0,
          icon: i.icon
        }, null, 8, ["icon"])) : Ut("", !0),
        i.label ? Ut("", !0) : jr(i.$slots, "default", { key: 1 }, void 0, !0),
        Ft(" " + wt(i.label && i.$t("btn." + i.label)), 1)
      ], 10, UA);
    };
  }
}), GA = /* @__PURE__ */ wr(BA, [["__scopeId", "data-v-0d958a4f"]]), VA = /* @__PURE__ */ Nr({
  inheritAttrs: !1,
  __name: "VCheckbox",
  props: {
    modelValue: {}
  },
  emits: ["update:modelValue"],
  setup(s, { emit: i }) {
    const o = s, c = i, r = Vt({
      get() {
        return o.modelValue;
      },
      set(h) {
        c("update:modelValue", h);
      }
    }), e = ts(), g = Vt(() => {
      const { clase: h, ...S } = e;
      return S;
    });
    return (h, S) => (he(), De("span", {
      class: jt(["VCheckbox", h.$attrs.class])
    }, [
      fn(U("input", rs({
        type: "checkbox",
        "onUpdate:modelValue": S[0] || (S[0] = (C) => r.value = C)
      }, g.value), null, 16), [
        [f1, r.value]
      ]),
      S[1] || (S[1] = U("span", { class: "VCheckbox-ui" }, null, -1))
    ], 2));
  }
}), Hp = /* @__PURE__ */ wr(VA, [["__scopeId", "data-v-e1e47535"]]), YA = (s) => s.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","), HA = (s) => s.replace(/[^0-9]/g, "").replace(/^(\d{2,3})(\d{3,4})(\d{4})$/, "$1-$2-$3");
function N1(s, i) {
  return !isNaN(Number(s)) && !isNaN(Number(i)) ? Math.ceil(Number(i) / Number(s)) : 1;
}
function qp(s) {
  const i = s.match(/\d+/g);
  return i ? Number(i.join("")) : 0;
}
const Ri = /* @__PURE__ */ Nr({
  __name: "VIconFont",
  props: {
    icon: {}
  },
  setup(s) {
    return (i, o) => (he(), De("i", {
      class: jt(["icon-font ft-icon", "ic-" + i.icon])
    }, null, 2));
  }
}), qA = ["for"], $A = ["type", "value"], WA = /* @__PURE__ */ Nr({
  inheritAttrs: !1,
  __name: "VTextInput",
  props: {
    modelValue: { default: "" },
    searchInput: { type: Boolean, default: !1 },
    width: { default: "180px" },
    type: { default: "text" },
    size: {},
    textRight: { type: Boolean },
    searchIcon: { type: Boolean, default: !1 },
    resetText: { type: Boolean },
    moneyInput: { type: Boolean }
  },
  emits: ["input", "change", "blur", "search", "update:modelValue", "reset"],
  setup(s, { expose: i, emit: o }) {
    const c = s, r = o, e = ts(), g = pt(null), h = Vt(() => {
      const { class: x, style: L, ...G } = e;
      return G.id || (G.id = O.value), G;
    }), S = {
      xs: "100px",
      sm: "120px",
      md: "180px",
      lg: "300px",
      xl: "460px",
      max: "100%"
    }, C = Vt(() => c.size ? S[c.size] : c.width), O = Vt(() => c.id ? c.id : `VTextInput-${yi()}`), N = (x) => x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    i({
      focus: () => {
        var x;
        (x = g.value) == null || x.focus();
      }
    });
    function D(x) {
      r("input", x);
      const L = x.target;
      if (c.moneyInput) {
        const G = L.value.replace(/[^0-9]/g, ""), Y = N(G);
        L.value = Y, r("update:modelValue", Y);
      } else
        r("update:modelValue", L.value);
    }
    return (x, L) => {
      const G = pr("VIconFont");
      return he(), De("div", {
        class: jt(["VTextInput", kt(e).class]),
        style: nn({ ...kt(e).style ?? {}, width: C.value })
      }, [
        U("label", {
          for: h.value.id,
          class: "sr-only"
        }, "Text label", 8, qA),
        U("input", rs({
          ref_key: "dom",
          ref: g,
          type: x.type,
          value: x.modelValue
        }, h.value, {
          class: { "pr-30": x.searchInput, "text-right": x.textRight || x.moneyInput },
          onInput: D,
          onChange: L[0] || (L[0] = (Y) => r("change", Y)),
          onBlur: L[1] || (L[1] = (Y) => r("blur", Y))
        }), null, 16, $A),
        x.searchInput ? (he(), De("div", {
          key: 0,
          style: { position: "absolute", left: "0", right: "0", top: "0", bottom: "0", cursor: "pointer" },
          onClick: L[2] || (L[2] = (Y) => r("search"))
        })) : Ut("", !0),
        x.resetText ? (he(), De("button", {
          key: 1,
          type: "button",
          class: "reset-text",
          onClick: L[3] || (L[3] = (Y) => {
            r("update:modelValue", ""), r("reset");
          })
        }, [
          Ze(G, { icon: "ic_close" })
        ])) : Ut("", !0),
        x.searchInput || x.searchIcon ? (he(), De("button", {
          key: 2,
          type: "button",
          "aria-label": "search",
          class: "searchIcon",
          onClick: L[4] || (L[4] = (Y) => r("search"))
        })) : Ut("", !0)
      ], 6);
    };
  }
}), _m = /* @__PURE__ */ wr(WA, [["__scopeId", "data-v-a37a9e8d"]]), zA = { class: "select-view" }, KA = { class: "select-btn" }, QA = {
  key: 0,
  class: "select-like-search"
}, XA = { class: "select-opt-cover" }, ZA = {
  key: 0,
  class: "select-opt-list"
}, jA = ["onClick", "onKeydown"], JA = {
  key: 1,
  class: "select-opt-list"
}, eO = ["for"], tO = ["for"], rO = /* @__PURE__ */ Nr({
  __name: "VDropdown",
  props: {
    options: {},
    modelValue: {},
    multiple: {},
    placeholder: { default: "선택하세요." },
    optionsHeight: {},
    labelProperty: { default: "label" },
    valueProperty: { default: "value" },
    disabled: { type: Boolean, default: !1 },
    type: { default: "single" },
    width: { default: "180px" },
    scrollHeight: { default: "200px" },
    allOption: { type: Boolean },
    disabledProperty: {},
    readonly: { type: Boolean },
    code: {},
    name: {},
    allValue: {},
    searhDropdown: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue", "change", "update:multiple", "update:code", "blur"],
  setup(s, { emit: i }) {
    const o = yi(), c = s, r = i, e = pt(c.multiple ?? []), g = pt(""), h = Vt(() => {
      var H, K;
      if (c.type === "multiple") {
        if (!e.value.length)
          return c.placeholder;
        const Q = e.value.map((se) => se[c.valueProperty]), _e = (H = c.options) == null ? void 0 : H.filter((se) => Q.includes(se[c.valueProperty])).map((se) => se[c.labelProperty]);
        return _e != null && _e.length ? _e.join(", ") : c.placeholder;
      } else {
        if (!c.code && c.code !== "" && !c.modelValue)
          return c.placeholder;
        const Q = (K = c.options) == null ? void 0 : K.find((_e) => c.code || c.code === "" ? _e[c.valueProperty] === c.code : _e[c.valueProperty] === c.modelValue[c.valueProperty]);
        return Q ? Q[c.labelProperty] : c.placeholder;
      }
    }), S = Vt(() => {
      const H = qp(c.scrollHeight);
      return c.searhDropdown ? `${H + 54}px` : `${H}px`;
    });
    function C(H) {
      r("update:modelValue", H), r("update:code", H[c.valueProperty]), r("change", H), Y.value = !1;
    }
    function O(H, K) {
      K ? e.value.push(H) : e.value = e.value.filter(
        (Q) => Q[c.valueProperty] !== H[c.valueProperty]
      );
    }
    function N(H) {
      return c.type === "single" ? c.code || c.code === "" ? H[c.valueProperty] === c.code : c.modelValue ? H[c.valueProperty] === c.modelValue[c.valueProperty] : !1 : e.value.map((Q) => Q[c.valueProperty]).includes(H[c.valueProperty]);
    }
    const { position: D, targetElement: x, element: L, toggleHandler: G, isHidden: Y } = um(
      4,
      qp(S.value),
      () => {
      }
    );
    an(
      () => c.multiple,
      (H) => {
        H && c.type === "multiple" && (e.value = H);
      }
    );
    const k = pt("");
    an(Y, () => {
      var H;
      Y.value ? k.value = ((H = x.value) == null ? void 0 : H.offsetWidth) + "px" : (g.value = "", r("blur")), c.type === "multiple" && (Y.value || r("update:multiple", CA(e.value)));
    });
    const W = Vt(() => k.value), Z = Vt(() => c.searhDropdown && g.value && Array.isArray(c.options) ? c.options.filter((H) => {
      var Q;
      return (((Q = H[c.labelProperty]) == null ? void 0 : Q.toString().toLowerCase()) || "").includes(g.value.toLowerCase());
    }) : c.options);
    return (H, K) => (he(), De("div", {
      class: jt(["select", { disabled: H.disabled, active: kt(Y), readonly: H.readonly }]),
      role: "combobox",
      "aria-expanded": "false",
      ref_key: "targetElement",
      ref: x,
      style: nn({ width: H.width }),
      tabindex: "0",
      onKeydown: K[2] || (K[2] = vi(
        () => {
          H.readonly || (Y.value = !kt(Y), kt(G)());
        },
        ["enter"]
      )),
      onClick: K[3] || (K[3] = (Q) => {
        Y.value = !kt(Y), kt(G)();
      })
    }, [
      U("p", zA, wt(h.value), 1),
      U("div", KA, [
        H.type === "single" ? (he(), gn(Ri, {
          key: 0,
          icon: "ic_arrow"
        })) : (he(), gn(Ri, {
          key: 1,
          icon: "ic_dropdown",
          style: { "font-size": "13px" }
        }))
      ]),
      (he(), gn(ul, { to: "body" }, [
        U("div", {
          class: jt(["select-opt-animation-guard", { "is-active": kt(Y) }]),
          style: nn({
            ...kt(D),
            width: W.value,
            "max-height": kt(Y) ? S.value : "0px",
            border: kt(Y) ? "1px solid #ddd" : "#d6dce5"
          }),
          ref_key: "element",
          ref: L
        }, [
          H.searhDropdown ? (he(), De("div", QA, [
            Ze(_m, {
              "search-icon": "",
              modelValue: g.value,
              "onUpdate:modelValue": K[0] || (K[0] = (Q) => g.value = Q),
              width: "100%"
            }, null, 8, ["modelValue"])
          ])) : Ut("", !0),
          U("div", XA, [
            H.type === "single" ? (he(), De("ul", ZA, [
              (he(!0), De(nr, null, Fr(Z.value, (Q) => {
                var _e;
                return he(), De("li", {
                  class: jt(["select-opt", {
                    selected: N(Q),
                    disabled: (_e = H.disabledProperty) == null ? void 0 : _e.includes(Q[H.valueProperty])
                  }]),
                  key: Q[H.valueProperty],
                  onClick: (se) => C(Q),
                  tabindex: "0",
                  onKeydown: vi((se) => C(Q), ["enter"])
                }, [
                  U("label", null, wt(Q[H.labelProperty]), 1)
                ], 42, jA);
              }), 128))
            ])) : (he(), De("ul", JA, [
              H.options && H.allOption ? (he(), De("li", {
                key: 0,
                class: jt(["select-opt", { selected: e.value.length === H.options.length }])
              }, [
                Ze(Hp, {
                  class: "mr-10",
                  checked: e.value.length === H.options.length,
                  id: kt(o),
                  onChange: K[1] || (K[1] = (Q) => e.value = e.value.length === H.options.length ? [] : H.options)
                }, null, 8, ["checked", "id"]),
                U("label", { for: kt(o) }, "전체선택 ", 8, eO)
              ], 2)) : Ut("", !0),
              (he(!0), De(nr, null, Fr(H.options, (Q) => (he(), De("li", {
                class: jt(["select-opt", { selected: N(Q) }]),
                key: Q[H.valueProperty]
              }, [
                Ze(Hp, {
                  class: "mr-10",
                  id: Q[H.valueProperty],
                  checked: N(Q),
                  onChange: (_e) => O(Q, _e.target.checked)
                }, null, 8, ["id", "checked", "onChange"]),
                U("label", {
                  for: Q[H.valueProperty]
                }, wt(Q[H.labelProperty]), 9, tO)
              ], 2))), 128))
            ]))
          ])
        ], 6)
      ]))
    ], 38));
  }
}), pm = /* @__PURE__ */ wr(rO, [["__scopeId", "data-v-98a5e51e"]]), nO = { class: "modal-header" }, aO = { class: "modal-title" }, iO = {
  key: 0,
  class: "modal-inner"
}, oO = {
  key: 1,
  class: "modal-inner"
}, sO = { class: "modal-inner-alert" }, lO = {
  key: 0,
  class: "blue-text"
}, cO = {
  key: 0,
  class: "text-right"
}, dO = {
  key: 1,
  class: "text-right"
}, uO = /* @__PURE__ */ Nr({
  __name: "VModal",
  props: {
    bgNone: { type: Boolean, default: !1 },
    title: {},
    confirm: { type: Boolean, default: !1 },
    alert: { type: Boolean, default: !1 },
    blurText: { type: Boolean, default: !1 },
    size: {}
  },
  emits: ["close", "check"],
  setup(s, { emit: i }) {
    const o = i;
    return Na(() => {
      document.body.style.overflow = "hidden", document.body.classList.add("has-modal");
    }), _l(() => {
      document.querySelectorAll(".modal-mask").length === 0 && (document.body.style.overflow = "auto", document.body.classList.remove("has-modal"));
    }), (c, r) => {
      const e = pr("VIconFont"), g = pr("VButton"), h = tA("focus");
      return he(), gn(ul, { to: "body" }, [
        Ze(rA, null, {
          default: rn(() => [
            U("div", {
              class: "modal-mask",
              style: nn({ backgroundColor: c.bgNone ? "transparent" : "" })
            }, [
              U("section", {
                class: jt(["modal-content", { "confirm-content": c.confirm || c.alert }]),
                style: nn(c.size)
              }, [
                U("header", nO, [
                  U("h3", aO, [
                    !c.confirm && !c.alert ? (he(), De(nr, { key: 0 }, [
                      Ft(wt(c.title), 1)
                    ], 64)) : Ut("", !0)
                  ]),
                  U("button", {
                    type: "button",
                    class: "close-btn",
                    onClick: r[0] || (r[0] = (S) => o("close"))
                  }, [
                    Ze(e, { icon: "ic_close" })
                  ])
                ]),
                !c.confirm && !c.alert ? (he(), De("div", iO, [
                  jr(c.$slots, "default")
                ])) : (he(), De("div", oO, [
                  U("p", sO, [
                    jr(c.$slots, "default"),
                    c.blurText ? (he(), De("div", lO, [
                      jr(c.$slots, "blue")
                    ])) : Ut("", !0)
                  ]),
                  c.confirm ? (he(), De("div", cO, [
                    Ze(g, {
                      color: "grey",
                      class: "mr-10",
                      onClick: r[1] || (r[1] = (S) => o("close"))
                    }, {
                      default: rn(() => r[4] || (r[4] = [
                        Ft("취소")
                      ])),
                      _: 1
                    }),
                    fn((he(), gn(g, {
                      onClick: r[2] || (r[2] = (S) => o("check"))
                    }, {
                      default: rn(() => r[5] || (r[5] = [
                        Ft("확인")
                      ])),
                      _: 1
                    })), [
                      [h]
                    ])
                  ])) : Ut("", !0),
                  c.alert ? (he(), De("div", dO, [
                    fn((he(), gn(g, {
                      onClick: r[3] || (r[3] = (S) => o("close"))
                    }, {
                      default: rn(() => r[6] || (r[6] = [
                        Ft("확인")
                      ])),
                      _: 1
                    })), [
                      [h]
                    ])
                  ])) : Ut("", !0)
                ]))
              ], 6)
            ], 4)
          ]),
          _: 3
        })
      ]);
    };
  }
}), _O = /* @__PURE__ */ wr(uO, [["__scopeId", "data-v-173e8240"]]), pO = { class: "pagination" }, mO = { class: "arrow-group" }, fO = {
  class: "dobble-arrow",
  style: { transform: "rotate(180deg)" }
}, gO = { style: { transform: "rotate(90deg)" } }, EO = { class: "num-group" }, hO = ["onClick"], SO = { class: "arrow-group" }, bO = { style: { transform: "rotate(-90deg)" } }, TO = { class: "dobble-arrow" }, vO = /* @__PURE__ */ Nr({
  __name: "VPagination",
  props: {
    totalPage: {},
    modelValue: {},
    pageLength: { default: 10 }
  },
  emits: ["change", "update:modelValue"],
  setup(s, { emit: i }) {
    const o = s, c = i, r = dm({
      totalPage: o.totalPage,
      pageLength: o.pageLength
    }), e = Vt(() => {
      let N = Math.ceil(o.modelValue / r.pageLength) * r.pageLength, D = Math.max(N - (r.pageLength - 1), 1);
      N = Math.min(N, r.totalPage);
      let x = [];
      for (let L = D; L <= N; L++)
        x.push(L);
      return x;
    });
    function g(O) {
      const N = Math.max(Math.min(O, r.totalPage), 1);
      o.modelValue !== N && (c("update:modelValue", N), c("change", N));
    }
    let h = 300, S = null;
    window.addEventListener("resize", C);
    function C() {
      S && clearTimeout(S), S = setTimeout(() => {
        window.innerWidth <= 600 ? r.pageLength = 5 : r.pageLength = 10;
      }, h);
    }
    return Na(() => C()), _l(() => {
      window.removeEventListener("resize", C);
    }), g1(() => {
      r.totalPage = o.totalPage;
    }), (O, N) => {
      const D = pr("VIconFont");
      return he(), De("div", pO, [
        U("ol", mO, [
          U("li", fO, [
            U("button", {
              type: "button",
              onClick: N[0] || (N[0] = (x) => g(1))
            }, [
              Ze(D, { icon: "ic_double_arrow" })
            ])
          ]),
          U("li", gO, [
            U("button", {
              type: "button",
              onClick: N[1] || (N[1] = (x) => g(O.modelValue - r.pageLength))
            }, [
              Ze(D, { icon: "ic_arrow" })
            ])
          ])
        ]),
        U("ol", EO, [
          (he(!0), De(nr, null, Fr(e.value, (x) => (he(), De("li", {
            class: jt({ active: O.modelValue === x })
          }, [
            U("button", {
              type: "button",
              onClick: (L) => g(x)
            }, wt(x), 9, hO)
          ], 2))), 256))
        ]),
        U("ol", SO, [
          U("li", bO, [
            U("button", {
              type: "button",
              onClick: N[2] || (N[2] = (x) => g(O.modelValue + r.pageLength))
            }, [
              Ze(D, { icon: "ic_arrow" })
            ])
          ]),
          U("li", TO, [
            U("button", {
              type: "button",
              onClick: N[3] || (N[3] = (x) => g(r.totalPage))
            }, [
              Ze(D, { icon: "ic_double_arrow" })
            ])
          ])
        ])
      ]);
    };
  }
}), A1 = /* @__PURE__ */ wr(vO, [["__scopeId", "data-v-65b02ed4"]]), CO = { class: "VRadiobox" }, RO = ["value", "disabled", "id", "name"], NO = /* @__PURE__ */ Nr({
  __name: "VRadiobox",
  props: {
    id: {},
    disabled: { type: Boolean },
    modelValue: {},
    value: {},
    name: {},
    checked: { type: Boolean }
  },
  emits: ["update:modelValue", "change"],
  setup(s, { emit: i }) {
    const o = s, c = i, r = Vt({
      get() {
        return o.modelValue;
      },
      set(e) {
        c("update:modelValue", e);
      }
    });
    return (e, g) => (he(), De("div", CO, [
      fn(U("input", {
        type: "radio",
        "onUpdate:modelValue": g[0] || (g[0] = (h) => r.value = h),
        value: e.value,
        disabled: e.disabled,
        id: e.id,
        name: e.name,
        onChange: g[1] || (g[1] = (h) => c("change", h))
      }, null, 40, RO), [
        [nA, r.value]
      ]),
      g[2] || (g[2] = U("div", { class: "VRadiobox-ui" }, null, -1))
    ]));
  }
}), AO = /* @__PURE__ */ wr(NO, [["__scopeId", "data-v-57ad4cbf"]]), OO = { class: "switch" }, yO = /* @__PURE__ */ Nr({
  __name: "VSwitch",
  props: {
    modelValue: { type: Boolean }
  },
  emits: ["update:modelValue", "change"],
  setup(s, { emit: i }) {
    const o = s, c = i, r = Vt({
      get() {
        return o.modelValue ?? !1;
      },
      set(e) {
        c("update:modelValue", e);
      }
    });
    return (e, g) => (he(), De("div", OO, [
      fn(U("input", {
        type: "checkbox",
        class: "switch-checkbox",
        "onUpdate:modelValue": g[0] || (g[0] = (h) => r.value = h),
        onChange: g[1] || (g[1] = (h) => c("change", h.target.checked))
      }, null, 544), [
        [f1, r.value]
      ]),
      g[2] || (g[2] = U("span", { class: "switch-slider" }, null, -1))
    ]));
  }
}), IO = /* @__PURE__ */ wr(yO, [["__scopeId", "data-v-ba5d8386"]]), DO = /* @__PURE__ */ Nr({
  __name: "VSpinner",
  props: {
    scale: { default: 1 },
    color: { default: "#197ffa" },
    bgNone: { type: Boolean, default: !1 }
  },
  setup(s) {
    const i = s, o = pt(!1), c = pt(null), r = {
      border: `5px solid ${i.color}`,
      "border-bottom-color": "transparent",
      scale: i.scale
    };
    return Na(() => {
      c.value && (o.value = c.value.offsetHeight < 80);
    }), (e, g) => e.bgNone ? (he(), De("span", {
      key: 1,
      class: "loader",
      style: r
    })) : (he(), De("div", {
      key: 0,
      class: jt(["loader-bg", { "init-space": o.value }]),
      ref_key: "bgRef",
      ref: c
    }, [
      U("span", {
        class: "loader",
        style: r
      })
    ], 2));
  }
}), $p = /* @__PURE__ */ wr(DO, [["__scopeId", "data-v-35ec6126"]]), wO = { class: "thead-warp d-flex" }, xO = { class: "sr-only" }, LO = {
  key: 0,
  style: { width: "14px", "background-color": "#f9f9f9", "border-top": "1px solid #111" }
}, MO = { class: "sr-only" }, PO = { class: "sr-only" }, kO = /* @__PURE__ */ Nr({
  __name: "VTable",
  props: {
    type: { default: "common" },
    maxHeight: { default: "471px" },
    scrollDependancy: { default: () => [] },
    infiniteTable: { type: Boolean, default: !1 },
    loading: { type: Boolean, default: !1 },
    fixed: { type: Boolean }
  },
  emits: ["endBody"],
  setup(s, { emit: i }) {
    const o = s, c = pt(!1), r = pt(null), e = pt(null), g = i, h = async () => {
      await Yp(), r.value && (c.value = r.value.scrollHeight > r.value.clientHeight);
    }, S = (C) => {
      const O = C.currentTarget;
      O.scrollHeight - O.scrollTop - O.clientHeight <= 5 && g("endBody");
    };
    return an(
      () => o.scrollDependancy,
      () => {
        h();
        const C = r.value;
        C && o.infiniteTable && C.removeEventListener("scroll", S), Yp(() => {
          const O = r.value;
          O && o.infiniteTable && O.addEventListener("scroll", S);
        });
      },
      { immediate: !0 }
    ), _l(() => {
      const C = r.value;
      C && o.infiniteTable && C.removeEventListener("scroll", S);
    }), (C, O) => C.type === "horizon" ? (he(), De("table", {
      key: 0,
      class: jt(["table-common horizon", {
        "table-fixed": !!C.fixed
      }]),
      ref_key: "tableWrap",
      ref: e
    }, [
      O[0] || (O[0] = U("caption", { class: "sr-only" }, " 테이블 ", -1)),
      U("colgroup", null, [
        jr(C.$slots, "colgroup")
      ]),
      U("thead", null, [
        jr(C.$slots, "thead")
      ]),
      U("tbody", null, [
        jr(C.$slots, "tbody")
      ])
    ], 2)) : C.type === "common" ? (he(), De("div", {
      key: 1,
      class: "table-base",
      ref_key: "tableWrap",
      ref: e,
      style: { position: "relative" }
    }, [
      C.loading ? (he(), gn($p, { key: 0 })) : Ut("", !0),
      U("div", wO, [
        U("table", {
          class: jt(["table-common", {
            "table-fixed": !!C.fixed
          }])
        }, [
          fn(U("caption", xO, " 테이블 ", 512), [
            [ea, !1]
          ]),
          U("colgroup", null, [
            jr(C.$slots, "colgroup")
          ]),
          U("thead", null, [
            jr(C.$slots, "thead")
          ])
        ], 2),
        c.value ? (he(), De("div", LO)) : Ut("", !0)
      ]),
      U("div", {
        class: "tbody-wrap",
        style: nn({ maxHeight: C.maxHeight }),
        ref_key: "tableTarget",
        ref: r
      }, [
        U("table", {
          class: jt(["table-common", {
            "table-fixed": !!C.fixed
          }])
        }, [
          fn(U("caption", MO, " 테이블 ", 512), [
            [ea, !1]
          ]),
          U("colgroup", null, [
            jr(C.$slots, "colgroup")
          ]),
          U("tbody", null, [
            C.loading ? Ut("", !0) : jr(C.$slots, "tbody", { key: 0 })
          ])
        ], 2)
      ], 4)
    ], 512)) : C.type === "block" ? (he(), De("div", {
      key: 2,
      class: "VdataTable",
      ref_key: "tableWrap",
      ref: e,
      style: { position: "relative" }
    }, [
      C.loading ? (he(), gn($p, { key: 0 })) : Ut("", !0),
      U("table", null, [
        fn(U("caption", PO, " 테이블 ", 512), [
          [ea, !1]
        ]),
        U("colgroup", null, [
          jr(C.$slots, "colgroup")
        ]),
        U("thead", {
          class: jt({ "is-scroll": c.value })
        }, [
          jr(C.$slots, "thead")
        ], 2),
        U("tbody", {
          style: nn({ maxHeight: C.maxHeight }),
          ref_key: "tableTarget",
          ref: r
        }, [
          C.loading ? Ut("", !0) : jr(C.$slots, "tbody", { key: 0 })
        ], 4)
      ])
    ], 512)) : Ut("", !0);
  }
}), FO = /* @__PURE__ */ wr(kO, [["__scopeId", "data-v-852865e9"]]), UO = { class: "textarea-wrapper" }, BO = ["for"], GO = /* @__PURE__ */ Nr({
  inheritAttrs: !1,
  __name: "VTextarea",
  props: {
    modelValue: { default: "" }
  },
  emits: ["input", "change", "blur", "update:modelValue"],
  setup(s, { emit: i }) {
    const o = s, c = i, r = Vt({
      get() {
        return o.modelValue ?? "";
      },
      set(S) {
        c("update:modelValue", S);
      }
    }), e = ts(), g = Vt(() => {
      const { ...S } = e;
      return S.id || (S.id = h.value), S;
    }), h = Vt(() => o.id ? o.id : `VTextInput-${yi()}`);
    return (S, C) => (he(), De("div", UO, [
      U("label", {
        for: g.value.id,
        class: "sr-only"
      }, "Text label", 8, BO),
      fn(U("textarea", rs(g.value, {
        class: "VTextarea",
        onInput: C[0] || (C[0] = (O) => c("input", O)),
        onBlur: C[1] || (C[1] = (O) => c("blur", O)),
        onChange: C[2] || (C[2] = (O) => c("change", O)),
        "onUpdate:modelValue": C[3] || (C[3] = (O) => r.value = O)
      }), null, 16), [
        [aA, r.value]
      ])
    ]));
  }
}), VO = /* @__PURE__ */ wr(GO, [["__scopeId", "data-v-942469a1"]]), YO = ["for"], HO = ["id", "value"], qO = { class: "options-outer" }, $O = { class: "hours item" }, WO = ["data-index"], zO = { class: "minutes item" }, KO = ["data-index"], QO = /* @__PURE__ */ Nr({
  __name: "VTimepicker",
  props: {
    modelValue: {},
    width: { default: "180px" },
    noIcon: { type: Boolean, default: !1 },
    disabled: { type: Boolean }
  },
  emits: ["input", "blur", "change", "update:modelValue"],
  setup(s, { emit: i }) {
    const { position: o, targetElement: c, element: r, toggleHandler: e, isHidden: g } = um(3, 110), h = yi(), S = s, C = i, O = Array.from({ length: 24 }, (W, Z) => Z < 10 ? `0${Z}` : Z), N = Array.from({ length: 60 }, (W, Z) => Z < 10 ? `0${Z}` : Z), D = dm({
      hour: 0,
      minute: 0
    }), x = (W) => {
      W.preventDefault(), W.stopPropagation();
      const Z = W.currentTarget, H = Z.dataset.type;
      if (W.deltaY < 0) {
        if (D[H] === 0)
          return;
        D[H]--, Z.style.transform = `translateY(${-(D[H] * 30)}px)`;
      } else if (W.deltaY > 0) {
        if (H === "hour" && D[H] == 23 || H === "minute" && D[H] == 59)
          return;
        D[H]++, Z.style.transform = `translateY(${-(D[H] * 30)}px)`;
      }
    }, L = (W) => {
      const Z = W.target, H = Number(Z.dataset.index), K = Z.dataset.type;
      D[K] = H;
    };
    an(D, (W) => {
      const Z = W.hour < 10 ? `0${W.hour}` : W.hour, H = W.minute < 10 ? `0${W.minute}` : W.minute;
      C("change", `${Z}${H}`), C("update:modelValue", `${Z}${H}`);
    });
    const G = pt("");
    an(
      () => S.modelValue,
      (W) => {
        if (W) {
          const Z = W.replace(/[^0-9]/g, "");
          /^(0[0-9]|1[0-9]|2[0-3])[0-5][0-9]$/.test(Z) ? (D.hour = Number(Z.slice(0, 2)), D.minute = Number(Z.slice(2, 4)), G.value = `${Z[0]}${Z[1]} : ${Z[2]}${Z[3]}`) : G.value = W;
        } else
          G.value = "";
      },
      { immediate: !0 }
    );
    const Y = ts(), k = Vt(() => {
      const { class: W, ...Z } = Y;
      return Z;
    });
    return (W, Z) => {
      const H = pr("VIconFont");
      return he(), De("div", {
        class: jt(["VTimepicker", { ...kt(Y).class, disabled: W.disabled }])
      }, [
        U("div", {
          class: jt(["view", { noIcon: W.noIcon, ...kt(Y).class }]),
          style: nn({ width: W.width }),
          onClick: Z[2] || (Z[2] = (K) => {
            g.value = !kt(g), kt(e)();
          }),
          ref_key: "targetElement",
          ref: c
        }, [
          U("label", {
            for: kt(h),
            class: "sr-only"
          }, "Text label", 8, YO),
          U("input", rs({
            id: kt(h),
            type: "text",
            value: G.value,
            placeholder: "HH : MM"
          }, k.value, {
            maxlength: "5",
            onBlur: Z[0] || (Z[0] = (K) => {
              const Q = K.target.value;
              /^(0[0-9]|1[0-9]|2[0-3]) : [0-5][0-9]$/.test(Q) || (C("input", ""), C("update:modelValue", ""), G.value = ""), C("blur");
            }),
            onInput: Z[1] || (Z[1] = (K) => {
              const _e = K.target.value.replace(/[^0-9]/g, "");
              C("input", _e), C("update:modelValue", _e);
            })
          }), null, 16, HO),
          W.noIcon ? Ut("", !0) : (he(), gn(H, {
            key: 0,
            icon: "ic_input_time"
          }))
        ], 6),
        (he(), gn(ul, { to: "body" }, [
          fn(U("div", {
            class: "options",
            ref_key: "element",
            ref: r,
            style: nn(kt(o))
          }, [
            U("div", qO, [
              U("div", $O, [
                U("ul", {
                  onWheel: x,
                  "data-type": "hour",
                  style: nn({ transform: `translateY(${-(D.hour * 30)}px)` })
                }, [
                  (he(!0), De(nr, null, Fr(kt(O), (K, Q) => (he(), De("li", {
                    class: jt({
                      "is-active": Q === D.hour
                    }),
                    "data-index": Q,
                    "data-type": "hour",
                    onClick: L
                  }, wt(K), 11, WO))), 256))
                ], 36)
              ]),
              U("div", zO, [
                U("ul", {
                  onWheel: x,
                  "data-type": "minute",
                  style: nn({ transform: `translateY(${-(D.minute * 30)}px)` })
                }, [
                  (he(!0), De(nr, null, Fr(kt(N), (K, Q) => (he(), De("li", {
                    class: jt({
                      "is-active": Number(K) === D.minute
                    }),
                    "data-type": "minute",
                    "data-index": Q,
                    onClick: L
                  }, wt(K), 11, KO))), 256))
                ], 36)
              ])
            ])
          ], 4), [
            [ea, kt(g)]
          ])
        ]))
      ], 2);
    };
  }
}), XO = /* @__PURE__ */ wr(QO, [["__scopeId", "data-v-0f30d91c"]]), ZO = {
  key: 0,
  class: "more-wrap"
}, jO = /* @__PURE__ */ Nr({
  __name: "SearchMenu",
  props: {
    isMore: { type: Boolean, default: !0 }
  },
  emits: ["search"],
  setup(s) {
    const i = s, o = pt(null), c = dm({
      // 더보기 버튼 여부
      state: !1,
      active: !1
    });
    Na(() => {
      if (i.isMore && o.value) {
        const e = o.value.querySelectorAll(".search-list");
        c.state = e.length > 2, r();
      }
    });
    function r() {
      o.value instanceof HTMLElement && (o.value.querySelectorAll(".search-list").forEach((g, h) => {
        h >= 2 && g.classList.toggle("hide");
      }), c.active = !c.active);
    }
    return (e, g) => {
      const h = pr("VButton"), S = pr("VIconFont");
      return he(), De("div", {
        class: jt(["Search-menu", { "has-btn": c.state, "is-active": c.active }])
      }, [
        U("div", {
          class: "Search-menu-input",
          ref_key: "menuInputArea",
          ref: o
        }, [
          jr(e.$slots, "default")
        ], 512),
        U("div", {
          class: "Search-menu-btn",
          onClick: g[0] || (g[0] = (C) => e.$emit("search"))
        }, [
          Ze(h, {
            label: "조회",
            mini: "",
            icon: "ic_search"
          })
        ]),
        c.state ? (he(), De("div", ZO, [
          U("button", {
            type: "button",
            onClick: g[1] || (g[1] = (C) => r())
          }, [
            Ft(wt(c.active ? "더보기" : "닫기") + " ", 1),
            Ze(S, {
              icon: "ic_arrow",
              class: jt({
                "is-active": c.active
              })
            }, null, 8, ["class"])
          ])
        ])) : Ut("", !0)
      ], 2);
    };
  }
}), JO = /* @__PURE__ */ wr(jO, [["__scopeId", "data-v-cc3445cf"]]), ey = {
  key: 0,
  class: "TabTitle"
}, ty = { class: "TabTitle-list" }, ry = ["onClick"], ny = {
  key: 1,
  class: "tab-list"
}, ay = ["onClick"], iy = /* @__PURE__ */ Nr({
  __name: "TabTitle",
  props: {
    list: {},
    modelValue: {},
    type: { default: "small" },
    disabled: {}
  },
  emits: ["update:modelValue"],
  setup(s) {
    return (i, o) => i.type === "large" ? (he(), De("div", ey, [
      U("ol", ty, [
        (he(!0), De(nr, null, Fr(i.list, (c, r) => {
          var e;
          return he(), De("li", {
            key: c,
            class: jt({ "is-active": r === i.modelValue, "is-disabled": (e = i.disabled) == null ? void 0 : e.includes(c) }),
            onClick: () => {
              var g;
              (g = i.disabled) != null && g.includes(c) || i.$emit("update:modelValue", r);
            }
          }, wt(c), 11, ry);
        }), 128))
      ])
    ])) : (he(), De("div", ny, [
      U("ol", null, [
        (he(!0), De(nr, null, Fr(i.list, (c, r) => {
          var e;
          return he(), De("li", {
            key: c,
            class: jt({ "is-active": r === i.modelValue, "is-disabled": (e = i.disabled) == null ? void 0 : e.includes(c) }),
            onClick: () => {
              var g;
              (g = i.disabled) != null && g.includes(c) || i.$emit("update:modelValue", r);
            }
          }, wt(c), 11, ay);
        }), 128))
      ])
    ]));
  }
}), oy = /* @__PURE__ */ wr(iy, [["__scopeId", "data-v-e1e7c16e"]]);
function O1(s, i) {
  return function() {
    return s.apply(i, arguments);
  };
}
const { toString: sy } = Object.prototype, { getPrototypeOf: mm } = Object, pl = /* @__PURE__ */ ((s) => (i) => {
  const o = sy.call(i);
  return s[o] || (s[o] = o.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), Aa = (s) => (s = s.toLowerCase(), (i) => pl(i) === s), ml = (s) => (i) => typeof i === s, { isArray: ro } = Array, zo = ml("undefined");
function ly(s) {
  return s !== null && !zo(s) && s.constructor !== null && !zo(s.constructor) && _a(s.constructor.isBuffer) && s.constructor.isBuffer(s);
}
const y1 = Aa("ArrayBuffer");
function cy(s) {
  let i;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? i = ArrayBuffer.isView(s) : i = s && s.buffer && y1(s.buffer), i;
}
const dy = ml("string"), _a = ml("function"), I1 = ml("number"), fl = (s) => s !== null && typeof s == "object", uy = (s) => s === !0 || s === !1, tl = (s) => {
  if (pl(s) !== "object")
    return !1;
  const i = mm(s);
  return (i === null || i === Object.prototype || Object.getPrototypeOf(i) === null) && !(Symbol.toStringTag in s) && !(Symbol.iterator in s);
}, _y = Aa("Date"), py = Aa("File"), my = Aa("Blob"), fy = Aa("FileList"), gy = (s) => fl(s) && _a(s.pipe), Ey = (s) => {
  let i;
  return s && (typeof FormData == "function" && s instanceof FormData || _a(s.append) && ((i = pl(s)) === "formdata" || // detect form-data instance
  i === "object" && _a(s.toString) && s.toString() === "[object FormData]"));
}, hy = Aa("URLSearchParams"), Sy = (s) => s.trim ? s.trim() : s.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function ns(s, i, { allOwnKeys: o = !1 } = {}) {
  if (s === null || typeof s > "u")
    return;
  let c, r;
  if (typeof s != "object" && (s = [s]), ro(s))
    for (c = 0, r = s.length; c < r; c++)
      i.call(null, s[c], c, s);
  else {
    const e = o ? Object.getOwnPropertyNames(s) : Object.keys(s), g = e.length;
    let h;
    for (c = 0; c < g; c++)
      h = e[c], i.call(null, s[h], h, s);
  }
}
function D1(s, i) {
  i = i.toLowerCase();
  const o = Object.keys(s);
  let c = o.length, r;
  for (; c-- > 0; )
    if (r = o[c], i === r.toLowerCase())
      return r;
  return null;
}
const w1 = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global, x1 = (s) => !zo(s) && s !== w1;
function Wp() {
  const { caseless: s } = x1(this) && this || {}, i = {}, o = (c, r) => {
    const e = s && D1(i, r) || r;
    tl(i[e]) && tl(c) ? i[e] = Wp(i[e], c) : tl(c) ? i[e] = Wp({}, c) : ro(c) ? i[e] = c.slice() : i[e] = c;
  };
  for (let c = 0, r = arguments.length; c < r; c++)
    arguments[c] && ns(arguments[c], o);
  return i;
}
const by = (s, i, o, { allOwnKeys: c } = {}) => (ns(i, (r, e) => {
  o && _a(r) ? s[e] = O1(r, o) : s[e] = r;
}, { allOwnKeys: c }), s), Ty = (s) => (s.charCodeAt(0) === 65279 && (s = s.slice(1)), s), vy = (s, i, o, c) => {
  s.prototype = Object.create(i.prototype, c), s.prototype.constructor = s, Object.defineProperty(s, "super", {
    value: i.prototype
  }), o && Object.assign(s.prototype, o);
}, Cy = (s, i, o, c) => {
  let r, e, g;
  const h = {};
  if (i = i || {}, s == null)
    return i;
  do {
    for (r = Object.getOwnPropertyNames(s), e = r.length; e-- > 0; )
      g = r[e], (!c || c(g, s, i)) && !h[g] && (i[g] = s[g], h[g] = !0);
    s = o !== !1 && mm(s);
  } while (s && (!o || o(s, i)) && s !== Object.prototype);
  return i;
}, Ry = (s, i, o) => {
  s = String(s), (o === void 0 || o > s.length) && (o = s.length), o -= i.length;
  const c = s.indexOf(i, o);
  return c !== -1 && c === o;
}, Ny = (s) => {
  if (!s)
    return null;
  if (ro(s))
    return s;
  let i = s.length;
  if (!I1(i))
    return null;
  const o = new Array(i);
  for (; i-- > 0; )
    o[i] = s[i];
  return o;
}, Ay = /* @__PURE__ */ ((s) => (i) => s && i instanceof s)(typeof Uint8Array < "u" && mm(Uint8Array)), Oy = (s, i) => {
  const c = (s && s[Symbol.iterator]).call(s);
  let r;
  for (; (r = c.next()) && !r.done; ) {
    const e = r.value;
    i.call(s, e[0], e[1]);
  }
}, yy = (s, i) => {
  let o;
  const c = [];
  for (; (o = s.exec(i)) !== null; )
    c.push(o);
  return c;
}, Iy = Aa("HTMLFormElement"), Dy = (s) => s.toLowerCase().replace(
  /[-_\s]([a-z\d])(\w*)/g,
  function(o, c, r) {
    return c.toUpperCase() + r;
  }
), Lh = (({ hasOwnProperty: s }) => (i, o) => s.call(i, o))(Object.prototype), wy = Aa("RegExp"), L1 = (s, i) => {
  const o = Object.getOwnPropertyDescriptors(s), c = {};
  ns(o, (r, e) => {
    let g;
    (g = i(r, e, s)) !== !1 && (c[e] = g || r);
  }), Object.defineProperties(s, c);
}, xy = (s) => {
  L1(s, (i, o) => {
    if (_a(s) && ["arguments", "caller", "callee"].indexOf(o) !== -1)
      return !1;
    const c = s[o];
    if (_a(c)) {
      if (i.enumerable = !1, "writable" in i) {
        i.writable = !1;
        return;
      }
      i.set || (i.set = () => {
        throw Error("Can not rewrite read-only method '" + o + "'");
      });
    }
  });
}, Ly = (s, i) => {
  const o = {}, c = (r) => {
    r.forEach((e) => {
      o[e] = !0;
    });
  };
  return ro(s) ? c(s) : c(String(s).split(i)), o;
}, My = () => {
}, Py = (s, i) => (s = +s, Number.isFinite(s) ? s : i), Jc = "abcdefghijklmnopqrstuvwxyz", Mh = "0123456789", M1 = {
  DIGIT: Mh,
  ALPHA: Jc,
  ALPHA_DIGIT: Jc + Jc.toUpperCase() + Mh
}, ky = (s = 16, i = M1.ALPHA_DIGIT) => {
  let o = "";
  const { length: c } = i;
  for (; s--; )
    o += i[Math.random() * c | 0];
  return o;
};
function Fy(s) {
  return !!(s && _a(s.append) && s[Symbol.toStringTag] === "FormData" && s[Symbol.iterator]);
}
const Uy = (s) => {
  const i = new Array(10), o = (c, r) => {
    if (fl(c)) {
      if (i.indexOf(c) >= 0)
        return;
      if (!("toJSON" in c)) {
        i[r] = c;
        const e = ro(c) ? [] : {};
        return ns(c, (g, h) => {
          const S = o(g, r + 1);
          !zo(S) && (e[h] = S);
        }), i[r] = void 0, e;
      }
    }
    return c;
  };
  return o(s, 0);
}, By = Aa("AsyncFunction"), Gy = (s) => s && (fl(s) || _a(s)) && _a(s.then) && _a(s.catch), Ve = {
  isArray: ro,
  isArrayBuffer: y1,
  isBuffer: ly,
  isFormData: Ey,
  isArrayBufferView: cy,
  isString: dy,
  isNumber: I1,
  isBoolean: uy,
  isObject: fl,
  isPlainObject: tl,
  isUndefined: zo,
  isDate: _y,
  isFile: py,
  isBlob: my,
  isRegExp: wy,
  isFunction: _a,
  isStream: gy,
  isURLSearchParams: hy,
  isTypedArray: Ay,
  isFileList: fy,
  forEach: ns,
  merge: Wp,
  extend: by,
  trim: Sy,
  stripBOM: Ty,
  inherits: vy,
  toFlatObject: Cy,
  kindOf: pl,
  kindOfTest: Aa,
  endsWith: Ry,
  toArray: Ny,
  forEachEntry: Oy,
  matchAll: yy,
  isHTMLForm: Iy,
  hasOwnProperty: Lh,
  hasOwnProp: Lh,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors: L1,
  freezeMethods: xy,
  toObjectSet: Ly,
  toCamelCase: Dy,
  noop: My,
  toFiniteNumber: Py,
  findKey: D1,
  global: w1,
  isContextDefined: x1,
  ALPHABET: M1,
  generateString: ky,
  isSpecCompliantForm: Fy,
  toJSONObject: Uy,
  isAsyncFn: By,
  isThenable: Gy
};
function gr(s, i, o, c, r) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = s, this.name = "AxiosError", i && (this.code = i), o && (this.config = o), c && (this.request = c), r && (this.response = r);
}
Ve.inherits(gr, Error, {
  toJSON: function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: Ve.toJSONObject(this.config),
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  }
});
const P1 = gr.prototype, k1 = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
  // eslint-disable-next-line func-names
].forEach((s) => {
  k1[s] = { value: s };
});
Object.defineProperties(gr, k1);
Object.defineProperty(P1, "isAxiosError", { value: !0 });
gr.from = (s, i, o, c, r, e) => {
  const g = Object.create(P1);
  return Ve.toFlatObject(s, g, function(S) {
    return S !== Error.prototype;
  }, (h) => h !== "isAxiosError"), gr.call(g, s.message, i, o, c, r), g.cause = s, g.name = s.name, e && Object.assign(g, e), g;
};
const Vy = null;
function zp(s) {
  return Ve.isPlainObject(s) || Ve.isArray(s);
}
function F1(s) {
  return Ve.endsWith(s, "[]") ? s.slice(0, -2) : s;
}
function Ph(s, i, o) {
  return s ? s.concat(i).map(function(r, e) {
    return r = F1(r), !o && e ? "[" + r + "]" : r;
  }).join(o ? "." : "") : i;
}
function Yy(s) {
  return Ve.isArray(s) && !s.some(zp);
}
const Hy = Ve.toFlatObject(Ve, {}, null, function(i) {
  return /^is[A-Z]/.test(i);
});
function gl(s, i, o) {
  if (!Ve.isObject(s))
    throw new TypeError("target must be an object");
  i = i || new FormData(), o = Ve.toFlatObject(o, {
    metaTokens: !0,
    dots: !1,
    indexes: !1
  }, !1, function(G, Y) {
    return !Ve.isUndefined(Y[G]);
  });
  const c = o.metaTokens, r = o.visitor || O, e = o.dots, g = o.indexes, S = (o.Blob || typeof Blob < "u" && Blob) && Ve.isSpecCompliantForm(i);
  if (!Ve.isFunction(r))
    throw new TypeError("visitor must be a function");
  function C(L) {
    if (L === null)
      return "";
    if (Ve.isDate(L))
      return L.toISOString();
    if (!S && Ve.isBlob(L))
      throw new gr("Blob is not supported. Use a Buffer instead.");
    return Ve.isArrayBuffer(L) || Ve.isTypedArray(L) ? S && typeof Blob == "function" ? new Blob([L]) : Buffer.from(L) : L;
  }
  function O(L, G, Y) {
    let k = L;
    if (L && !Y && typeof L == "object") {
      if (Ve.endsWith(G, "{}"))
        G = c ? G : G.slice(0, -2), L = JSON.stringify(L);
      else if (Ve.isArray(L) && Yy(L) || (Ve.isFileList(L) || Ve.endsWith(G, "[]")) && (k = Ve.toArray(L)))
        return G = F1(G), k.forEach(function(Z, H) {
          !(Ve.isUndefined(Z) || Z === null) && i.append(
            // eslint-disable-next-line no-nested-ternary
            g === !0 ? Ph([G], H, e) : g === null ? G : G + "[]",
            C(Z)
          );
        }), !1;
    }
    return zp(L) ? !0 : (i.append(Ph(Y, G, e), C(L)), !1);
  }
  const N = [], D = Object.assign(Hy, {
    defaultVisitor: O,
    convertValue: C,
    isVisitable: zp
  });
  function x(L, G) {
    if (!Ve.isUndefined(L)) {
      if (N.indexOf(L) !== -1)
        throw Error("Circular reference detected in " + G.join("."));
      N.push(L), Ve.forEach(L, function(k, W) {
        (!(Ve.isUndefined(k) || k === null) && r.call(
          i,
          k,
          Ve.isString(W) ? W.trim() : W,
          G,
          D
        )) === !0 && x(k, G ? G.concat(W) : [W]);
      }), N.pop();
    }
  }
  if (!Ve.isObject(s))
    throw new TypeError("data must be an object");
  return x(s), i;
}
function kh(s) {
  const i = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(s).replace(/[!'()~]|%20|%00/g, function(c) {
    return i[c];
  });
}
function fm(s, i) {
  this._pairs = [], s && gl(s, this, i);
}
const U1 = fm.prototype;
U1.append = function(i, o) {
  this._pairs.push([i, o]);
};
U1.toString = function(i) {
  const o = i ? function(c) {
    return i.call(this, c, kh);
  } : kh;
  return this._pairs.map(function(r) {
    return o(r[0]) + "=" + o(r[1]);
  }, "").join("&");
};
function qy(s) {
  return encodeURIComponent(s).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function B1(s, i, o) {
  if (!i)
    return s;
  const c = o && o.encode || qy, r = o && o.serialize;
  let e;
  if (r ? e = r(i, o) : e = Ve.isURLSearchParams(i) ? i.toString() : new fm(i, o).toString(c), e) {
    const g = s.indexOf("#");
    g !== -1 && (s = s.slice(0, g)), s += (s.indexOf("?") === -1 ? "?" : "&") + e;
  }
  return s;
}
class Fh {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(i, o, c) {
    return this.handlers.push({
      fulfilled: i,
      rejected: o,
      synchronous: c ? c.synchronous : !1,
      runWhen: c ? c.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(i) {
    this.handlers[i] && (this.handlers[i] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(i) {
    Ve.forEach(this.handlers, function(c) {
      c !== null && i(c);
    });
  }
}
const G1 = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, $y = typeof URLSearchParams < "u" ? URLSearchParams : fm, Wy = typeof FormData < "u" ? FormData : null, zy = typeof Blob < "u" ? Blob : null, Ky = {
  isBrowser: !0,
  classes: {
    URLSearchParams: $y,
    FormData: Wy,
    Blob: zy
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
}, V1 = typeof window < "u" && typeof document < "u", Qy = ((s) => V1 && ["ReactNative", "NativeScript", "NS"].indexOf(s) < 0)(typeof navigator < "u" && navigator.product), Xy = typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function", Zy = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv: V1,
  hasStandardBrowserEnv: Qy,
  hasStandardBrowserWebWorkerEnv: Xy
}, Symbol.toStringTag, { value: "Module" })), Ca = {
  ...Zy,
  ...Ky
};
function jy(s, i) {
  return gl(s, new Ca.classes.URLSearchParams(), Object.assign({
    visitor: function(o, c, r, e) {
      return Ca.isNode && Ve.isBuffer(o) ? (this.append(c, o.toString("base64")), !1) : e.defaultVisitor.apply(this, arguments);
    }
  }, i));
}
function Jy(s) {
  return Ve.matchAll(/\w+|\[(\w*)]/g, s).map((i) => i[0] === "[]" ? "" : i[1] || i[0]);
}
function eI(s) {
  const i = {}, o = Object.keys(s);
  let c;
  const r = o.length;
  let e;
  for (c = 0; c < r; c++)
    e = o[c], i[e] = s[e];
  return i;
}
function Y1(s) {
  function i(o, c, r, e) {
    let g = o[e++];
    if (g === "__proto__")
      return !0;
    const h = Number.isFinite(+g), S = e >= o.length;
    return g = !g && Ve.isArray(r) ? r.length : g, S ? (Ve.hasOwnProp(r, g) ? r[g] = [r[g], c] : r[g] = c, !h) : ((!r[g] || !Ve.isObject(r[g])) && (r[g] = []), i(o, c, r[g], e) && Ve.isArray(r[g]) && (r[g] = eI(r[g])), !h);
  }
  if (Ve.isFormData(s) && Ve.isFunction(s.entries)) {
    const o = {};
    return Ve.forEachEntry(s, (c, r) => {
      i(Jy(c), r, o, 0);
    }), o;
  }
  return null;
}
function tI(s, i, o) {
  if (Ve.isString(s))
    try {
      return (i || JSON.parse)(s), Ve.trim(s);
    } catch (c) {
      if (c.name !== "SyntaxError")
        throw c;
    }
  return (o || JSON.stringify)(s);
}
const gm = {
  transitional: G1,
  adapter: ["xhr", "http"],
  transformRequest: [function(i, o) {
    const c = o.getContentType() || "", r = c.indexOf("application/json") > -1, e = Ve.isObject(i);
    if (e && Ve.isHTMLForm(i) && (i = new FormData(i)), Ve.isFormData(i))
      return r ? JSON.stringify(Y1(i)) : i;
    if (Ve.isArrayBuffer(i) || Ve.isBuffer(i) || Ve.isStream(i) || Ve.isFile(i) || Ve.isBlob(i))
      return i;
    if (Ve.isArrayBufferView(i))
      return i.buffer;
    if (Ve.isURLSearchParams(i))
      return o.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), i.toString();
    let h;
    if (e) {
      if (c.indexOf("application/x-www-form-urlencoded") > -1)
        return jy(i, this.formSerializer).toString();
      if ((h = Ve.isFileList(i)) || c.indexOf("multipart/form-data") > -1) {
        const S = this.env && this.env.FormData;
        return gl(
          h ? { "files[]": i } : i,
          S && new S(),
          this.formSerializer
        );
      }
    }
    return e || r ? (o.setContentType("application/json", !1), tI(i)) : i;
  }],
  transformResponse: [function(i) {
    const o = this.transitional || gm.transitional, c = o && o.forcedJSONParsing, r = this.responseType === "json";
    if (i && Ve.isString(i) && (c && !this.responseType || r)) {
      const g = !(o && o.silentJSONParsing) && r;
      try {
        return JSON.parse(i);
      } catch (h) {
        if (g)
          throw h.name === "SyntaxError" ? gr.from(h, gr.ERR_BAD_RESPONSE, this, null, this.response) : h;
      }
    }
    return i;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: Ca.classes.FormData,
    Blob: Ca.classes.Blob
  },
  validateStatus: function(i) {
    return i >= 200 && i < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
Ve.forEach(["delete", "get", "head", "post", "put", "patch"], (s) => {
  gm.headers[s] = {};
});
const Em = gm, rI = Ve.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), nI = (s) => {
  const i = {};
  let o, c, r;
  return s && s.split(`
`).forEach(function(g) {
    r = g.indexOf(":"), o = g.substring(0, r).trim().toLowerCase(), c = g.substring(r + 1).trim(), !(!o || i[o] && rI[o]) && (o === "set-cookie" ? i[o] ? i[o].push(c) : i[o] = [c] : i[o] = i[o] ? i[o] + ", " + c : c);
  }), i;
}, Uh = Symbol("internals");
function Yo(s) {
  return s && String(s).trim().toLowerCase();
}
function rl(s) {
  return s === !1 || s == null ? s : Ve.isArray(s) ? s.map(rl) : String(s);
}
function aI(s) {
  const i = /* @__PURE__ */ Object.create(null), o = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let c;
  for (; c = o.exec(s); )
    i[c[1]] = c[2];
  return i;
}
const iI = (s) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(s.trim());
function ed(s, i, o, c, r) {
  if (Ve.isFunction(c))
    return c.call(this, i, o);
  if (r && (i = o), !!Ve.isString(i)) {
    if (Ve.isString(c))
      return i.indexOf(c) !== -1;
    if (Ve.isRegExp(c))
      return c.test(i);
  }
}
function oI(s) {
  return s.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (i, o, c) => o.toUpperCase() + c);
}
function sI(s, i) {
  const o = Ve.toCamelCase(" " + i);
  ["get", "set", "has"].forEach((c) => {
    Object.defineProperty(s, c + o, {
      value: function(r, e, g) {
        return this[c].call(this, i, r, e, g);
      },
      configurable: !0
    });
  });
}
class El {
  constructor(i) {
    i && this.set(i);
  }
  set(i, o, c) {
    const r = this;
    function e(h, S, C) {
      const O = Yo(S);
      if (!O)
        throw new Error("header name must be a non-empty string");
      const N = Ve.findKey(r, O);
      (!N || r[N] === void 0 || C === !0 || C === void 0 && r[N] !== !1) && (r[N || S] = rl(h));
    }
    const g = (h, S) => Ve.forEach(h, (C, O) => e(C, O, S));
    return Ve.isPlainObject(i) || i instanceof this.constructor ? g(i, o) : Ve.isString(i) && (i = i.trim()) && !iI(i) ? g(nI(i), o) : i != null && e(o, i, c), this;
  }
  get(i, o) {
    if (i = Yo(i), i) {
      const c = Ve.findKey(this, i);
      if (c) {
        const r = this[c];
        if (!o)
          return r;
        if (o === !0)
          return aI(r);
        if (Ve.isFunction(o))
          return o.call(this, r, c);
        if (Ve.isRegExp(o))
          return o.exec(r);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(i, o) {
    if (i = Yo(i), i) {
      const c = Ve.findKey(this, i);
      return !!(c && this[c] !== void 0 && (!o || ed(this, this[c], c, o)));
    }
    return !1;
  }
  delete(i, o) {
    const c = this;
    let r = !1;
    function e(g) {
      if (g = Yo(g), g) {
        const h = Ve.findKey(c, g);
        h && (!o || ed(c, c[h], h, o)) && (delete c[h], r = !0);
      }
    }
    return Ve.isArray(i) ? i.forEach(e) : e(i), r;
  }
  clear(i) {
    const o = Object.keys(this);
    let c = o.length, r = !1;
    for (; c--; ) {
      const e = o[c];
      (!i || ed(this, this[e], e, i, !0)) && (delete this[e], r = !0);
    }
    return r;
  }
  normalize(i) {
    const o = this, c = {};
    return Ve.forEach(this, (r, e) => {
      const g = Ve.findKey(c, e);
      if (g) {
        o[g] = rl(r), delete o[e];
        return;
      }
      const h = i ? oI(e) : String(e).trim();
      h !== e && delete o[e], o[h] = rl(r), c[h] = !0;
    }), this;
  }
  concat(...i) {
    return this.constructor.concat(this, ...i);
  }
  toJSON(i) {
    const o = /* @__PURE__ */ Object.create(null);
    return Ve.forEach(this, (c, r) => {
      c != null && c !== !1 && (o[r] = i && Ve.isArray(c) ? c.join(", ") : c);
    }), o;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([i, o]) => i + ": " + o).join(`
`);
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(i) {
    return i instanceof this ? i : new this(i);
  }
  static concat(i, ...o) {
    const c = new this(i);
    return o.forEach((r) => c.set(r)), c;
  }
  static accessor(i) {
    const c = (this[Uh] = this[Uh] = {
      accessors: {}
    }).accessors, r = this.prototype;
    function e(g) {
      const h = Yo(g);
      c[h] || (sI(r, g), c[h] = !0);
    }
    return Ve.isArray(i) ? i.forEach(e) : e(i), this;
  }
}
El.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
Ve.reduceDescriptors(El.prototype, ({ value: s }, i) => {
  let o = i[0].toUpperCase() + i.slice(1);
  return {
    get: () => s,
    set(c) {
      this[o] = c;
    }
  };
});
Ve.freezeMethods(El);
const Ba = El;
function td(s, i) {
  const o = this || Em, c = i || o, r = Ba.from(c.headers);
  let e = c.data;
  return Ve.forEach(s, function(h) {
    e = h.call(o, e, r.normalize(), i ? i.status : void 0);
  }), r.normalize(), e;
}
function H1(s) {
  return !!(s && s.__CANCEL__);
}
function as(s, i, o) {
  gr.call(this, s ?? "canceled", gr.ERR_CANCELED, i, o), this.name = "CanceledError";
}
Ve.inherits(as, gr, {
  __CANCEL__: !0
});
function lI(s, i, o) {
  const c = o.config.validateStatus;
  !o.status || !c || c(o.status) ? s(o) : i(new gr(
    "Request failed with status code " + o.status,
    [gr.ERR_BAD_REQUEST, gr.ERR_BAD_RESPONSE][Math.floor(o.status / 100) - 4],
    o.config,
    o.request,
    o
  ));
}
const cI = Ca.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(s, i, o, c, r, e) {
      const g = [s + "=" + encodeURIComponent(i)];
      Ve.isNumber(o) && g.push("expires=" + new Date(o).toGMTString()), Ve.isString(c) && g.push("path=" + c), Ve.isString(r) && g.push("domain=" + r), e === !0 && g.push("secure"), document.cookie = g.join("; ");
    },
    read(s) {
      const i = document.cookie.match(new RegExp("(^|;\\s*)(" + s + ")=([^;]*)"));
      return i ? decodeURIComponent(i[3]) : null;
    },
    remove(s) {
      this.write(s, "", Date.now() - 864e5);
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function dI(s) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(s);
}
function uI(s, i) {
  return i ? s.replace(/\/?\/$/, "") + "/" + i.replace(/^\/+/, "") : s;
}
function q1(s, i) {
  return s && !dI(i) ? uI(s, i) : i;
}
const _I = Ca.hasStandardBrowserEnv ? (
  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  function() {
    const i = /(msie|trident)/i.test(navigator.userAgent), o = document.createElement("a");
    let c;
    function r(e) {
      let g = e;
      return i && (o.setAttribute("href", g), g = o.href), o.setAttribute("href", g), {
        href: o.href,
        protocol: o.protocol ? o.protocol.replace(/:$/, "") : "",
        host: o.host,
        search: o.search ? o.search.replace(/^\?/, "") : "",
        hash: o.hash ? o.hash.replace(/^#/, "") : "",
        hostname: o.hostname,
        port: o.port,
        pathname: o.pathname.charAt(0) === "/" ? o.pathname : "/" + o.pathname
      };
    }
    return c = r(window.location.href), function(g) {
      const h = Ve.isString(g) ? r(g) : g;
      return h.protocol === c.protocol && h.host === c.host;
    };
  }()
) : (
  // Non standard browser envs (web workers, react-native) lack needed support.
  /* @__PURE__ */ function() {
    return function() {
      return !0;
    };
  }()
);
function pI(s) {
  const i = /^([-+\w]{1,25})(:?\/\/|:)/.exec(s);
  return i && i[1] || "";
}
function mI(s, i) {
  s = s || 10;
  const o = new Array(s), c = new Array(s);
  let r = 0, e = 0, g;
  return i = i !== void 0 ? i : 1e3, function(S) {
    const C = Date.now(), O = c[e];
    g || (g = C), o[r] = S, c[r] = C;
    let N = e, D = 0;
    for (; N !== r; )
      D += o[N++], N = N % s;
    if (r = (r + 1) % s, r === e && (e = (e + 1) % s), C - g < i)
      return;
    const x = O && C - O;
    return x ? Math.round(D * 1e3 / x) : void 0;
  };
}
function Bh(s, i) {
  let o = 0;
  const c = mI(50, 250);
  return (r) => {
    const e = r.loaded, g = r.lengthComputable ? r.total : void 0, h = e - o, S = c(h), C = e <= g;
    o = e;
    const O = {
      loaded: e,
      total: g,
      progress: g ? e / g : void 0,
      bytes: h,
      rate: S || void 0,
      estimated: S && g && C ? (g - e) / S : void 0,
      event: r
    };
    O[i ? "download" : "upload"] = !0, s(O);
  };
}
const fI = typeof XMLHttpRequest < "u", gI = fI && function(s) {
  return new Promise(function(o, c) {
    let r = s.data;
    const e = Ba.from(s.headers).normalize();
    let { responseType: g, withXSRFToken: h } = s, S;
    function C() {
      s.cancelToken && s.cancelToken.unsubscribe(S), s.signal && s.signal.removeEventListener("abort", S);
    }
    let O;
    if (Ve.isFormData(r)) {
      if (Ca.hasStandardBrowserEnv || Ca.hasStandardBrowserWebWorkerEnv)
        e.setContentType(!1);
      else if ((O = e.getContentType()) !== !1) {
        const [G, ...Y] = O ? O.split(";").map((k) => k.trim()).filter(Boolean) : [];
        e.setContentType([G || "multipart/form-data", ...Y].join("; "));
      }
    }
    let N = new XMLHttpRequest();
    if (s.auth) {
      const G = s.auth.username || "", Y = s.auth.password ? unescape(encodeURIComponent(s.auth.password)) : "";
      e.set("Authorization", "Basic " + btoa(G + ":" + Y));
    }
    const D = q1(s.baseURL, s.url);
    N.open(s.method.toUpperCase(), B1(D, s.params, s.paramsSerializer), !0), N.timeout = s.timeout;
    function x() {
      if (!N)
        return;
      const G = Ba.from(
        "getAllResponseHeaders" in N && N.getAllResponseHeaders()
      ), k = {
        data: !g || g === "text" || g === "json" ? N.responseText : N.response,
        status: N.status,
        statusText: N.statusText,
        headers: G,
        config: s,
        request: N
      };
      lI(function(Z) {
        o(Z), C();
      }, function(Z) {
        c(Z), C();
      }, k), N = null;
    }
    if ("onloadend" in N ? N.onloadend = x : N.onreadystatechange = function() {
      !N || N.readyState !== 4 || N.status === 0 && !(N.responseURL && N.responseURL.indexOf("file:") === 0) || setTimeout(x);
    }, N.onabort = function() {
      N && (c(new gr("Request aborted", gr.ECONNABORTED, s, N)), N = null);
    }, N.onerror = function() {
      c(new gr("Network Error", gr.ERR_NETWORK, s, N)), N = null;
    }, N.ontimeout = function() {
      let Y = s.timeout ? "timeout of " + s.timeout + "ms exceeded" : "timeout exceeded";
      const k = s.transitional || G1;
      s.timeoutErrorMessage && (Y = s.timeoutErrorMessage), c(new gr(
        Y,
        k.clarifyTimeoutError ? gr.ETIMEDOUT : gr.ECONNABORTED,
        s,
        N
      )), N = null;
    }, Ca.hasStandardBrowserEnv && (h && Ve.isFunction(h) && (h = h(s)), h || h !== !1 && _I(D))) {
      const G = s.xsrfHeaderName && s.xsrfCookieName && cI.read(s.xsrfCookieName);
      G && e.set(s.xsrfHeaderName, G);
    }
    r === void 0 && e.setContentType(null), "setRequestHeader" in N && Ve.forEach(e.toJSON(), function(Y, k) {
      N.setRequestHeader(k, Y);
    }), Ve.isUndefined(s.withCredentials) || (N.withCredentials = !!s.withCredentials), g && g !== "json" && (N.responseType = s.responseType), typeof s.onDownloadProgress == "function" && N.addEventListener("progress", Bh(s.onDownloadProgress, !0)), typeof s.onUploadProgress == "function" && N.upload && N.upload.addEventListener("progress", Bh(s.onUploadProgress)), (s.cancelToken || s.signal) && (S = (G) => {
      N && (c(!G || G.type ? new as(null, s, N) : G), N.abort(), N = null);
    }, s.cancelToken && s.cancelToken.subscribe(S), s.signal && (s.signal.aborted ? S() : s.signal.addEventListener("abort", S)));
    const L = pI(D);
    if (L && Ca.protocols.indexOf(L) === -1) {
      c(new gr("Unsupported protocol " + L + ":", gr.ERR_BAD_REQUEST, s));
      return;
    }
    N.send(r || null);
  });
}, Kp = {
  http: Vy,
  xhr: gI
};
Ve.forEach(Kp, (s, i) => {
  if (s) {
    try {
      Object.defineProperty(s, "name", { value: i });
    } catch {
    }
    Object.defineProperty(s, "adapterName", { value: i });
  }
});
const Gh = (s) => `- ${s}`, EI = (s) => Ve.isFunction(s) || s === null || s === !1, $1 = {
  getAdapter: (s) => {
    s = Ve.isArray(s) ? s : [s];
    const { length: i } = s;
    let o, c;
    const r = {};
    for (let e = 0; e < i; e++) {
      o = s[e];
      let g;
      if (c = o, !EI(o) && (c = Kp[(g = String(o)).toLowerCase()], c === void 0))
        throw new gr(`Unknown adapter '${g}'`);
      if (c)
        break;
      r[g || "#" + e] = c;
    }
    if (!c) {
      const e = Object.entries(r).map(
        ([h, S]) => `adapter ${h} ` + (S === !1 ? "is not supported by the environment" : "is not available in the build")
      );
      let g = i ? e.length > 1 ? `since :
` + e.map(Gh).join(`
`) : " " + Gh(e[0]) : "as no adapter specified";
      throw new gr(
        "There is no suitable adapter to dispatch the request " + g,
        "ERR_NOT_SUPPORT"
      );
    }
    return c;
  },
  adapters: Kp
};
function rd(s) {
  if (s.cancelToken && s.cancelToken.throwIfRequested(), s.signal && s.signal.aborted)
    throw new as(null, s);
}
function Vh(s) {
  return rd(s), s.headers = Ba.from(s.headers), s.data = td.call(
    s,
    s.transformRequest
  ), ["post", "put", "patch"].indexOf(s.method) !== -1 && s.headers.setContentType("application/x-www-form-urlencoded", !1), $1.getAdapter(s.adapter || Em.adapter)(s).then(function(c) {
    return rd(s), c.data = td.call(
      s,
      s.transformResponse,
      c
    ), c.headers = Ba.from(c.headers), c;
  }, function(c) {
    return H1(c) || (rd(s), c && c.response && (c.response.data = td.call(
      s,
      s.transformResponse,
      c.response
    ), c.response.headers = Ba.from(c.response.headers))), Promise.reject(c);
  });
}
const Yh = (s) => s instanceof Ba ? s.toJSON() : s;
function ji(s, i) {
  i = i || {};
  const o = {};
  function c(C, O, N) {
    return Ve.isPlainObject(C) && Ve.isPlainObject(O) ? Ve.merge.call({ caseless: N }, C, O) : Ve.isPlainObject(O) ? Ve.merge({}, O) : Ve.isArray(O) ? O.slice() : O;
  }
  function r(C, O, N) {
    if (Ve.isUndefined(O)) {
      if (!Ve.isUndefined(C))
        return c(void 0, C, N);
    } else
      return c(C, O, N);
  }
  function e(C, O) {
    if (!Ve.isUndefined(O))
      return c(void 0, O);
  }
  function g(C, O) {
    if (Ve.isUndefined(O)) {
      if (!Ve.isUndefined(C))
        return c(void 0, C);
    } else
      return c(void 0, O);
  }
  function h(C, O, N) {
    if (N in i)
      return c(C, O);
    if (N in s)
      return c(void 0, C);
  }
  const S = {
    url: e,
    method: e,
    data: e,
    baseURL: g,
    transformRequest: g,
    transformResponse: g,
    paramsSerializer: g,
    timeout: g,
    timeoutMessage: g,
    withCredentials: g,
    withXSRFToken: g,
    adapter: g,
    responseType: g,
    xsrfCookieName: g,
    xsrfHeaderName: g,
    onUploadProgress: g,
    onDownloadProgress: g,
    decompress: g,
    maxContentLength: g,
    maxBodyLength: g,
    beforeRedirect: g,
    transport: g,
    httpAgent: g,
    httpsAgent: g,
    cancelToken: g,
    socketPath: g,
    responseEncoding: g,
    validateStatus: h,
    headers: (C, O) => r(Yh(C), Yh(O), !0)
  };
  return Ve.forEach(Object.keys(Object.assign({}, s, i)), function(O) {
    const N = S[O] || r, D = N(s[O], i[O], O);
    Ve.isUndefined(D) && N !== h || (o[O] = D);
  }), o;
}
const W1 = "1.6.7", hm = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((s, i) => {
  hm[s] = function(c) {
    return typeof c === s || "a" + (i < 1 ? "n " : " ") + s;
  };
});
const Hh = {};
hm.transitional = function(i, o, c) {
  function r(e, g) {
    return "[Axios v" + W1 + "] Transitional option '" + e + "'" + g + (c ? ". " + c : "");
  }
  return (e, g, h) => {
    if (i === !1)
      throw new gr(
        r(g, " has been removed" + (o ? " in " + o : "")),
        gr.ERR_DEPRECATED
      );
    return o && !Hh[g] && (Hh[g] = !0, console.warn(
      r(
        g,
        " has been deprecated since v" + o + " and will be removed in the near future"
      )
    )), i ? i(e, g, h) : !0;
  };
};
function hI(s, i, o) {
  if (typeof s != "object")
    throw new gr("options must be an object", gr.ERR_BAD_OPTION_VALUE);
  const c = Object.keys(s);
  let r = c.length;
  for (; r-- > 0; ) {
    const e = c[r], g = i[e];
    if (g) {
      const h = s[e], S = h === void 0 || g(h, e, s);
      if (S !== !0)
        throw new gr("option " + e + " must be " + S, gr.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (o !== !0)
      throw new gr("Unknown option " + e, gr.ERR_BAD_OPTION);
  }
}
const Qp = {
  assertOptions: hI,
  validators: hm
}, Qa = Qp.validators;
class il {
  constructor(i) {
    this.defaults = i, this.interceptors = {
      request: new Fh(),
      response: new Fh()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(i, o) {
    try {
      return await this._request(i, o);
    } catch (c) {
      if (c instanceof Error) {
        let r;
        Error.captureStackTrace ? Error.captureStackTrace(r = {}) : r = new Error();
        const e = r.stack ? r.stack.replace(/^.+\n/, "") : "";
        c.stack ? e && !String(c.stack).endsWith(e.replace(/^.+\n.+\n/, "")) && (c.stack += `
` + e) : c.stack = e;
      }
      throw c;
    }
  }
  _request(i, o) {
    typeof i == "string" ? (o = o || {}, o.url = i) : o = i || {}, o = ji(this.defaults, o);
    const { transitional: c, paramsSerializer: r, headers: e } = o;
    c !== void 0 && Qp.assertOptions(c, {
      silentJSONParsing: Qa.transitional(Qa.boolean),
      forcedJSONParsing: Qa.transitional(Qa.boolean),
      clarifyTimeoutError: Qa.transitional(Qa.boolean)
    }, !1), r != null && (Ve.isFunction(r) ? o.paramsSerializer = {
      serialize: r
    } : Qp.assertOptions(r, {
      encode: Qa.function,
      serialize: Qa.function
    }, !0)), o.method = (o.method || this.defaults.method || "get").toLowerCase();
    let g = e && Ve.merge(
      e.common,
      e[o.method]
    );
    e && Ve.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (L) => {
        delete e[L];
      }
    ), o.headers = Ba.concat(g, e);
    const h = [];
    let S = !0;
    this.interceptors.request.forEach(function(G) {
      typeof G.runWhen == "function" && G.runWhen(o) === !1 || (S = S && G.synchronous, h.unshift(G.fulfilled, G.rejected));
    });
    const C = [];
    this.interceptors.response.forEach(function(G) {
      C.push(G.fulfilled, G.rejected);
    });
    let O, N = 0, D;
    if (!S) {
      const L = [Vh.bind(this), void 0];
      for (L.unshift.apply(L, h), L.push.apply(L, C), D = L.length, O = Promise.resolve(o); N < D; )
        O = O.then(L[N++], L[N++]);
      return O;
    }
    D = h.length;
    let x = o;
    for (N = 0; N < D; ) {
      const L = h[N++], G = h[N++];
      try {
        x = L(x);
      } catch (Y) {
        G.call(this, Y);
        break;
      }
    }
    try {
      O = Vh.call(this, x);
    } catch (L) {
      return Promise.reject(L);
    }
    for (N = 0, D = C.length; N < D; )
      O = O.then(C[N++], C[N++]);
    return O;
  }
  getUri(i) {
    i = ji(this.defaults, i);
    const o = q1(i.baseURL, i.url);
    return B1(o, i.params, i.paramsSerializer);
  }
}
Ve.forEach(["delete", "get", "head", "options"], function(i) {
  il.prototype[i] = function(o, c) {
    return this.request(ji(c || {}, {
      method: i,
      url: o,
      data: (c || {}).data
    }));
  };
});
Ve.forEach(["post", "put", "patch"], function(i) {
  function o(c) {
    return function(e, g, h) {
      return this.request(ji(h || {}, {
        method: i,
        headers: c ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: e,
        data: g
      }));
    };
  }
  il.prototype[i] = o(), il.prototype[i + "Form"] = o(!0);
});
const nl = il;
class Sm {
  constructor(i) {
    if (typeof i != "function")
      throw new TypeError("executor must be a function.");
    let o;
    this.promise = new Promise(function(e) {
      o = e;
    });
    const c = this;
    this.promise.then((r) => {
      if (!c._listeners)
        return;
      let e = c._listeners.length;
      for (; e-- > 0; )
        c._listeners[e](r);
      c._listeners = null;
    }), this.promise.then = (r) => {
      let e;
      const g = new Promise((h) => {
        c.subscribe(h), e = h;
      }).then(r);
      return g.cancel = function() {
        c.unsubscribe(e);
      }, g;
    }, i(function(e, g, h) {
      c.reason || (c.reason = new as(e, g, h), o(c.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(i) {
    if (this.reason) {
      i(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(i) : this._listeners = [i];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(i) {
    if (!this._listeners)
      return;
    const o = this._listeners.indexOf(i);
    o !== -1 && this._listeners.splice(o, 1);
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let i;
    return {
      token: new Sm(function(r) {
        i = r;
      }),
      cancel: i
    };
  }
}
const SI = Sm;
function bI(s) {
  return function(o) {
    return s.apply(null, o);
  };
}
function TI(s) {
  return Ve.isObject(s) && s.isAxiosError === !0;
}
const Xp = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511
};
Object.entries(Xp).forEach(([s, i]) => {
  Xp[i] = s;
});
const vI = Xp;
function z1(s) {
  const i = new nl(s), o = O1(nl.prototype.request, i);
  return Ve.extend(o, nl.prototype, i, { allOwnKeys: !0 }), Ve.extend(o, i, null, { allOwnKeys: !0 }), o.create = function(r) {
    return z1(ji(s, r));
  }, o;
}
const Dr = z1(Em);
Dr.Axios = nl;
Dr.CanceledError = as;
Dr.CancelToken = SI;
Dr.isCancel = H1;
Dr.VERSION = W1;
Dr.toFormData = gl;
Dr.AxiosError = gr;
Dr.Cancel = Dr.CanceledError;
Dr.all = function(i) {
  return Promise.all(i);
};
Dr.spread = bI;
Dr.isAxiosError = TI;
Dr.mergeConfig = ji;
Dr.AxiosHeaders = Ba;
Dr.formToJSON = (s) => Y1(Ve.isHTMLForm(s) ? new FormData(s) : s);
Dr.getAdapter = $1.getAdapter;
Dr.HttpStatusCode = vI;
Dr.default = Dr;
const CI = /* @__PURE__ */ Nr({
  __name: "VCommonDropdown",
  props: {
    options: {},
    modelValue: {},
    multiple: {},
    placeholder: {},
    optionsHeight: {},
    labelProperty: { default: "label" },
    valueProperty: { default: "value" },
    disabled: { type: Boolean },
    type: {},
    width: {},
    scrollHeight: {},
    allOption: { type: Boolean },
    disabledProperty: {},
    readonly: { type: Boolean },
    code: {},
    name: {},
    allValue: { type: Boolean, default: !1 },
    searhDropdown: { type: Boolean },
    method: { default: "get" },
    allValueLabel: { default: "전체" }
  },
  emits: ["update:modelValue", "change", "blur"],
  setup(s, { emit: i }) {
    const o = s, c = i, r = pt([]), e = async () => {
      try {
        const C = (await Dr[o.method]("/api/common/code/" + o.code)).data.list.filter((O) => O.usagYn === "Y");
        if (o.allValue) {
          const O = { [o.labelProperty]: o.allValueLabel, [o.valueProperty]: "" };
          C.unshift(O);
        }
        r.value = C;
      } catch {
        console.error("공통 코드 통신 에러" + o.code);
      }
    }, g = Vt({
      get() {
        return o.modelValue;
      },
      set(S) {
        c("update:modelValue", S);
      }
    });
    e();
    const h = Vt(() => {
      const { code: S, method: C, allValue: O, allValueLabel: N, ...D } = o;
      return D;
    });
    return (S, C) => (he(), gn(pm, rs(h.value, {
      options: r.value,
      modelValue: g.value,
      "onUpdate:modelValue": C[0] || (C[0] = (O) => g.value = O),
      onBlur: C[1] || (C[1] = (O) => c("blur")),
      width: o.width,
      onChange: C[2] || (C[2] = (O) => c("change", O))
    }), null, 16, ["options", "modelValue", "width"]));
  }
}), RI = {}, NI = { class: "TextButton" };
function AI(s, i) {
  return he(), De("strong", NI, [
    jr(s.$slots, "default", {}, void 0, !0)
  ]);
}
const OI = /* @__PURE__ */ wr(RI, [["render", AI], ["__scopeId", "data-v-26455997"]]), yI = {}, II = {
  class: "VSortButton",
  "aria-label": "정렬 버튼"
};
function DI(s, i) {
  const o = pr("VIconFont");
  return he(), De("button", II, [
    Ze(o, { icon: "ic_triangle" }),
    Ze(o, {
      icon: "ic_triangle",
      class: "VSortButton-row"
    })
  ]);
}
const wI = /* @__PURE__ */ wr(yI, [["render", DI], ["__scopeId", "data-v-eadbef47"]]), xI = {}, LI = { class: "VFormGroup" };
function MI(s, i) {
  return he(), De("div", LI, [
    jr(s.$slots, "default")
  ]);
}
const PI = /* @__PURE__ */ wr(xI, [["render", MI], ["__scopeId", "data-v-e5321ba2"]]);
var kI = typeof global == "object" && global && global.Object === Object && global, FI = typeof self == "object" && self && self.Object === Object && self, K1 = kI || FI || Function("return this")(), ol = K1.Symbol, Q1 = Object.prototype, UI = Q1.hasOwnProperty, BI = Q1.toString, Ho = ol ? ol.toStringTag : void 0;
function GI(s) {
  var i = UI.call(s, Ho), o = s[Ho];
  try {
    s[Ho] = void 0;
    var c = !0;
  } catch {
  }
  var r = BI.call(s);
  return c && (i ? s[Ho] = o : delete s[Ho]), r;
}
var VI = Object.prototype, YI = VI.toString;
function HI(s) {
  return YI.call(s);
}
var qI = "[object Null]", $I = "[object Undefined]", qh = ol ? ol.toStringTag : void 0;
function WI(s) {
  return s == null ? s === void 0 ? $I : qI : qh && qh in Object(s) ? GI(s) : HI(s);
}
function zI(s) {
  return s != null && typeof s == "object";
}
var KI = "[object Symbol]";
function QI(s) {
  return typeof s == "symbol" || zI(s) && WI(s) == KI;
}
var XI = /\s/;
function ZI(s) {
  for (var i = s.length; i-- && XI.test(s.charAt(i)); )
    ;
  return i;
}
var jI = /^\s+/;
function JI(s) {
  return s && s.slice(0, ZI(s) + 1).replace(jI, "");
}
function Zp(s) {
  var i = typeof s;
  return s != null && (i == "object" || i == "function");
}
var $h = NaN, eD = /^[-+]0x[0-9a-f]+$/i, tD = /^0b[01]+$/i, rD = /^0o[0-7]+$/i, nD = parseInt;
function Wh(s) {
  if (typeof s == "number")
    return s;
  if (QI(s))
    return $h;
  if (Zp(s)) {
    var i = typeof s.valueOf == "function" ? s.valueOf() : s;
    s = Zp(i) ? i + "" : i;
  }
  if (typeof s != "string")
    return s === 0 ? s : +s;
  s = JI(s);
  var o = tD.test(s);
  return o || rD.test(s) ? nD(s.slice(2), o ? 2 : 8) : eD.test(s) ? $h : +s;
}
var nd = function() {
  return K1.Date.now();
}, aD = "Expected a function", iD = Math.max, oD = Math.min;
function sD(s, i, o) {
  var c, r, e, g, h, S, C = 0, O = !1, N = !1, D = !0;
  if (typeof s != "function")
    throw new TypeError(aD);
  i = Wh(i) || 0, Zp(o) && (O = !!o.leading, N = "maxWait" in o, e = N ? iD(Wh(o.maxWait) || 0, i) : e, D = "trailing" in o ? !!o.trailing : D);
  function x(Q) {
    var _e = c, se = r;
    return c = r = void 0, C = Q, g = s.apply(se, _e), g;
  }
  function L(Q) {
    return C = Q, h = setTimeout(k, i), O ? x(Q) : g;
  }
  function G(Q) {
    var _e = Q - S, se = Q - C, Pe = i - _e;
    return N ? oD(Pe, e - se) : Pe;
  }
  function Y(Q) {
    var _e = Q - S, se = Q - C;
    return S === void 0 || _e >= i || _e < 0 || N && se >= e;
  }
  function k() {
    var Q = nd();
    if (Y(Q))
      return W(Q);
    h = setTimeout(k, G(Q));
  }
  function W(Q) {
    return h = void 0, D && c ? x(Q) : (c = r = void 0, g);
  }
  function Z() {
    h !== void 0 && clearTimeout(h), C = 0, c = S = r = h = void 0;
  }
  function H() {
    return h === void 0 ? g : W(nd());
  }
  function K() {
    var Q = nd(), _e = Y(Q);
    if (c = arguments, r = this, S = Q, _e) {
      if (h === void 0)
        return L(S);
      if (N)
        return clearTimeout(h), h = setTimeout(k, i), x(S);
    }
    return h === void 0 && (h = setTimeout(k, i)), g;
  }
  return K.cancel = Z, K.flush = H, K;
}
/**
 * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */
/**
 * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */
function lD(s, {
  timeOutAfter: i = 500,
  retryAfter: o = 100
} = {}) {
  return new Promise((c, r) => {
    const e = Date.now();
    let g = null;
    const h = setTimeout(() => {
      r(g ?? new Error("Timeout"));
    }, i), S = async () => {
      try {
        const C = await s();
        clearTimeout(h), c(C);
      } catch (C) {
        g = C, Date.now() - e > i ? r(C) : setTimeout(S, o);
      }
    };
    S();
  });
}
/**
 * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */
const Xs = /* @__PURE__ */ new Map();
function X1(s, { attributes: i } = {}) {
  if (Xs.has(s))
    return Xs.get(s);
  const o = document.querySelector(`script[src="${s}"]`);
  o && (console.warn(`Script with "${s}" src is already present in DOM!`), o.remove());
  const c = new Promise((r, e) => {
    const g = document.createElement("script");
    g.onerror = e, g.onload = () => {
      r();
    };
    for (const [S, C] of Object.entries(i || {}))
      g.setAttribute(S, C);
    g.setAttribute("data-injected-by", "ckeditor-integration"), g.type = "text/javascript", g.async = !0, g.src = s, document.head.appendChild(g);
    const h = new MutationObserver((S) => {
      S.flatMap((O) => Array.from(O.removedNodes)).includes(g) && (Xs.delete(s), h.disconnect());
    });
    h.observe(document.head, {
      childList: !0,
      subtree: !0
    });
  });
  return Xs.set(s, c), c;
}
async function Z1(s, i) {
  await Promise.all(
    s.map((o) => X1(o, i))
  );
}
/**
 * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */
const Zs = /* @__PURE__ */ new Map();
function cD({
  href: s,
  placementInHead: i = "start",
  attributes: o = {}
}) {
  if (Zs.has(s))
    return Zs.get(s);
  const c = document.querySelector(`link[href="${s}"][rel="stylesheet"]`);
  c && (console.warn(`Stylesheet with "${s}" href is already present in DOM!`), c.remove());
  const r = (g) => {
    const h = Array.from(
      document.head.querySelectorAll('link[data-injected-by="ckeditor-integration"]')
    );
    switch (i) {
      case "start":
        h.length ? h.slice(-1)[0].after(g) : document.head.insertBefore(g, document.head.firstChild);
        break;
      case "end":
        document.head.appendChild(g);
        break;
    }
  }, e = new Promise((g, h) => {
    const S = document.createElement("link");
    for (const [O, N] of Object.entries(o || {}))
      S.setAttribute(O, N);
    S.setAttribute("data-injected-by", "ckeditor-integration"), S.rel = "stylesheet", S.href = s, S.onerror = h, S.onload = () => {
      g();
    }, r(S);
    const C = new MutationObserver((O) => {
      O.flatMap((D) => Array.from(D.removedNodes)).includes(S) && (Zs.delete(s), C.disconnect());
    });
    C.observe(document.head, {
      childList: !0,
      subtree: !0
    });
  });
  return Zs.set(s, e), e;
}
/**
 * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */
function dD(s, { attributes: i } = {}) {
  if (document.head.querySelector(`link[href="${s}"][rel="preload"]`))
    return;
  const o = document.createElement("link");
  for (const [c, r] of Object.entries(i || {}))
    o.setAttribute(c, r);
  o.setAttribute("data-injected-by", "ckeditor-integration"), o.rel = "preload", o.as = uD(s), o.href = s, document.head.insertBefore(o, document.head.firstChild);
}
function uD(s) {
  switch (!0) {
    case /\.css$/.test(s):
      return "style";
    case /\.js$/.test(s):
      return "script";
    default:
      return "fetch";
  }
}
/**
 * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */
const kn = new Array(256).fill("").map((s, i) => ("0" + i.toString(16)).slice(-2));
function _D() {
  const [s, i, o, c] = crypto.getRandomValues(new Uint32Array(4));
  return "e" + kn[s >> 0 & 255] + kn[s >> 8 & 255] + kn[s >> 16 & 255] + kn[s >> 24 & 255] + kn[i >> 0 & 255] + kn[i >> 8 & 255] + kn[i >> 16 & 255] + kn[i >> 24 & 255] + kn[o >> 0 & 255] + kn[o >> 8 & 255] + kn[o >> 16 & 255] + kn[o >> 24 & 255] + kn[c >> 0 & 255] + kn[c >> 8 & 255] + kn[c >> 16 & 255] + kn[c >> 24 & 255];
}
/**
 * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */
function ad(s) {
  return Array.from(new Set(s));
}
/**
 * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */
async function hl(s, i) {
  const o = () => s.map((c) => window[c]).filter(Boolean)[0];
  return lD(
    () => {
      const c = o();
      if (!c)
        throw new Error(`Window entry "${s.join(",")}" not found.`);
      return c;
    },
    i
  );
}
/**
 * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */
function pD(s, i) {
  const o = Object.entries(s).filter(([c, r]) => i(r, c));
  return Object.fromEntries(o);
}
/**
 * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */
function mD(s) {
  return pD(
    s,
    (i) => i != null
  );
}
/**
 * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */
function j1(s, i) {
  const o = Object.entries(s).map(([c, r]) => [c, i(r, c)]);
  return Object.fromEntries(o);
}
/**
 * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */
function bm(s, i) {
  return i.filter((o) => !s.includes(o));
}
/**
 * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */
function fD(s, i) {
  const o = s.extraPlugins || [];
  return {
    ...s,
    extraPlugins: [
      ...o,
      ...i.filter((c) => !o.includes(c))
    ]
  };
}
/**
 * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */
function Tm(s) {
  return !!s && /^\d+\.\d+\.\d+/.test(s);
}
/**
 * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */
function Sl(s) {
  return s ? ["nightly", "alpha", "internal", "nightly-", "staging"].some((i) => s.includes(i)) : !1;
}
function gD(s) {
  return Tm(s) || Sl(s);
}
/**
 * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */
function J1(s) {
  if (!Tm(s))
    throw new Error(`Invalid semantic version: ${s || "<blank>"}.`);
  const [i, o, c] = s.split(".");
  return {
    major: Number.parseInt(i, 10),
    minor: Number.parseInt(o, 10),
    patch: Number.parseInt(c, 10)
  };
}
/**
 * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */
function ev(s) {
  if (Sl(s))
    return 3;
  const { major: i } = J1(s);
  switch (!0) {
    case i >= 44:
      return 3;
    case i >= 38:
      return 2;
    default:
      return 1;
  }
}
/**
 * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */
function tv() {
  const { CKEDITOR_VERSION: s, CKEDITOR: i } = window;
  return gD(s) ? {
    source: i ? "cdn" : "npm",
    version: s
  } : null;
}
/**
 * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */
function ED() {
  const s = tv();
  return s ? ev(s.version) : null;
}
/**
 * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */
function rv(s, i) {
  switch (i || (i = ED() || void 0), i) {
    case 1:
    case 2:
      return s === void 0;
    case 3:
      return s === "GPL";
    default:
      return !1;
  }
}
/**
 * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */
function hD(s, i) {
  return function(c) {
    rv(c.config.get("licenseKey")) || c.on("collectUsageData", (r, { setUsageData: e }) => {
      e(`integration.${s}`, i);
    });
  };
}
/**
 * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */
const SD = "https://cdn.ckeditor.com";
function nv(s, i, o) {
  return `${SD}/${s}/${o}/${i}`;
}
/**
 * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */
const bD = "https://cdn.ckbox.io";
function TD(s, i, o) {
  return `${bD}/${s}/${o}/${i}`;
}
/**
 * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */
const vD = "https://ckeditor.com/docs/ckeditor5";
function CD(s, i = "latest") {
  return `${vD}/${i}/${s}`;
}
/**
 * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */
function RD({
  version: s,
  translations: i,
  createCustomCdnUrl: o = nv
}) {
  const c = {
    scripts: [
      // Load the main script of the base features.
      o("ckeditor5", "ckeditor5.umd.js", s),
      // Load all JavaScript files from the base features.
      // EN bundle is prebuilt into the main script, so we don't need to load it separately.
      ...bm(["en"], i || []).map(
        (r) => o("ckeditor5", `translations/${r}.umd.js`, s)
      )
    ],
    stylesheets: [
      o("ckeditor5", "ckeditor5.css", s)
    ]
  };
  return {
    // Preload resources specified in the pack, before loading the main script.
    preload: [
      ...c.stylesheets,
      ...c.scripts
    ],
    scripts: [
      // It's safe to load translations and the main script in parallel.
      async (r) => Z1(c.scripts, r)
    ],
    // Load all stylesheets of the base features.
    stylesheets: c.stylesheets,
    // Pick the exported global variables from the window object.
    checkPluginLoaded: async () => hl(["CKEDITOR"]),
    // Check if the CKEditor base bundle is already loaded and throw an error if it is.
    beforeInject: () => {
      const r = tv();
      switch (r == null ? void 0 : r.source) {
        case "npm":
          throw new Error(
            "CKEditor 5 is already loaded from npm. Check the migration guide for more details: " + CD("updating/migration-to-cdn/vanilla-js.html")
          );
        case "cdn":
          if (r.version !== s)
            throw new Error(
              `CKEditor 5 is already loaded from CDN in version ${r.version}. Remove the old <script> and <link> tags loading CKEditor 5 to allow loading the ${s} version.`
            );
          break;
      }
    }
  };
}
/**
 * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */
function ND({
  version: s,
  translations: i,
  createCustomCdnUrl: o = nv
}) {
  const c = {
    scripts: [
      // Load the main script of the premium features.
      o("ckeditor5-premium-features", "ckeditor5-premium-features.umd.js", s),
      // Load all JavaScript files from the premium features.
      // EN bundle is prebuilt into the main script, so we don't need to load it separately.
      ...bm(["en"], i || []).map(
        (r) => o("ckeditor5-premium-features", `translations/${r}.umd.js`, s)
      )
    ],
    stylesheets: [
      o("ckeditor5-premium-features", "ckeditor5-premium-features.css", s)
    ]
  };
  return {
    // Preload resources specified in the pack, before loading the main script.
    preload: [
      ...c.stylesheets,
      ...c.scripts
    ],
    scripts: [
      // It's safe to load translations and the main script in parallel.
      async (r) => Z1(c.scripts, r)
    ],
    // Load all stylesheets of the premium features.
    stylesheets: c.stylesheets,
    // Pick the exported global variables from the window object.
    checkPluginLoaded: async () => hl(["CKEDITOR_PREMIUM_FEATURES"])
  };
}
/**
 * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */
async function AD(s) {
  let {
    htmlAttributes: i = {},
    scripts: o = [],
    stylesheets: c = [],
    preload: r,
    beforeInject: e,
    checkPluginLoaded: g
  } = vm(s);
  e == null || e(), r || (r = ad([
    ...c.filter((h) => typeof h == "string"),
    ...o.filter((h) => typeof h == "string")
  ]));
  for (const h of r)
    dD(h, {
      attributes: i
    });
  await Promise.all(
    ad(c).map((h) => cD({
      href: h,
      attributes: i,
      placementInHead: "start"
    }))
  );
  for (const h of ad(o)) {
    const S = {
      attributes: i
    };
    typeof h == "string" ? await X1(h, S) : await h(S);
  }
  return g == null ? void 0 : g();
}
function vm(s) {
  return Array.isArray(s) ? {
    scripts: s.filter(
      (i) => typeof i == "function" || i.endsWith(".js")
    ),
    stylesheets: s.filter(
      (i) => i.endsWith(".css")
    )
  } : typeof s == "function" ? {
    checkPluginLoaded: s
  } : s;
}
/**
 * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */
function av(s) {
  const i = j1(
    mD(s),
    vm
  );
  return {
    ...Object.values(i).reduce(
      (e, g) => (e.scripts.push(...g.scripts ?? []), e.stylesheets.push(...g.stylesheets ?? []), e.preload.push(...g.preload ?? []), e),
      {
        preload: [],
        scripts: [],
        stylesheets: []
      }
    ),
    beforeInject: () => {
      var e;
      for (const g of Object.values(i))
        (e = g.beforeInject) == null || e.call(g);
    },
    checkPluginLoaded: async () => {
      var g;
      const e = /* @__PURE__ */ Object.create(null);
      for (const [h, S] of Object.entries(i))
        e[h] = await ((g = S == null ? void 0 : S.checkPluginLoaded) == null ? void 0 : g.call(S));
      return e;
    }
  };
}
/**
 * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */
function OD() {
  var i;
  const s = (i = window.CKBox) == null ? void 0 : i.version;
  return Tm(s) ? {
    source: "cdn",
    version: s
  } : null;
}
/**
 * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */
function yD({
  version: s,
  theme: i = "lark",
  translations: o,
  createCustomCdnUrl: c = TD
}) {
  return {
    // Load the main script of the base features.
    scripts: [
      c("ckbox", "ckbox.js", s),
      // EN bundle is prebuilt into the main script, so we don't need to load it separately.
      ...bm(["en"], o || []).map(
        (r) => c("ckbox", `translations/${r}.js`, s)
      )
    ],
    // Load optional theme, if provided. It's not required but recommended because it improves the look and feel.
    ...i && {
      stylesheets: [
        c("ckbox", `styles/themes/${i}.css`, s)
      ]
    },
    // Pick the exported global variables from the window object.
    checkPluginLoaded: async () => hl(["CKBox"]),
    // Check if the CKBox bundle is already loaded and throw an error if it is.
    beforeInject: () => {
      const r = OD();
      if (r && r.version !== s)
        throw new Error(
          `CKBox is already loaded from CDN in version ${r.version}. Remove the old <script> and <link> tags loading CKBox to allow loading the ${s} version.`
        );
    }
  };
}
/**
 * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */
function ID(s) {
  if (Sl(s))
    return !0;
  const { major: i } = J1(s);
  switch (ev(s)) {
    case 3:
      return !0;
    default:
      return i === 43;
  }
}
/**
 * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */
function DD(s) {
  const i = j1(s, (o, c) => {
    if (!o)
      return;
    const r = vm(o);
    return {
      // Provide default window accessor object if the plugin pack does not define it.
      checkPluginLoaded: async () => hl([c]),
      // Transform the plugin pack to a normalized advanced pack.
      ...r
    };
  });
  return av(
    i
  );
}
/**
 * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */
function wD(s) {
  const {
    version: i,
    translations: o,
    plugins: c,
    premium: r,
    ckbox: e,
    createCustomCdnUrl: g,
    injectedHtmlElementsAttributes: h = {
      crossorigin: "anonymous"
    }
  } = s;
  xD(i);
  const S = av({
    CKEditor: RD({
      version: i,
      translations: o,
      createCustomCdnUrl: g
    }),
    ...r && {
      CKEditorPremiumFeatures: ND({
        version: i,
        translations: o,
        createCustomCdnUrl: g
      })
    },
    ...e && {
      CKBox: yD(e)
    },
    loadedPlugins: DD(c ?? {})
  });
  return AD(
    {
      ...S,
      htmlAttributes: h
    }
  );
}
function xD(s) {
  if (Sl(s) && console.warn(
    "You are using a testing version of CKEditor 5. Please remember that it is not suitable for production environments."
  ), !ID(s))
    throw new Error(
      `The CKEditor 5 CDN can't be used with the given editor version: ${s}. Please make sure you are using at least the CKEditor 5 version 44.`
    );
}
/**
 * @license Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md.
 */
const LD = hD(
  "vue",
  {
    version: "7.3.0",
    frameworkVersion: lA
  }
);
/**
 * @license Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md.
 */
function MD(s) {
  return rv(s.licenseKey) ? s : fD(s, [
    /**
     * This part of the code is not executed in open-source implementations using a GPL key.
     * It only runs when a specific license key is provided. If you are uncertain whether
     * this applies to your installation, please contact our support team.
     */
    LD
  ]);
}
const id = "Lock from Vue integration (@ckeditor/ckeditor5-vue)", PD = 300, kD = /* @__PURE__ */ Nr({
  name: "CKEditor",
  __name: "ckeditor",
  props: /* @__PURE__ */ Ih({
    editor: {},
    config: { default: () => ({}) },
    tagName: { default: "div" },
    disabled: { type: Boolean, default: !1 },
    disableTwoWayDataBinding: { type: Boolean, default: !1 }
  }, {
    modelValue: { type: String, default: "" },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ Ih(["ready", "destroy", "blur", "focus", "input", "update:modelValue"], ["update:modelValue"]),
  setup(s, { expose: i, emit: o }) {
    const c = iA(s, "modelValue"), r = s, e = o, g = pt(), h = pt(), S = pt();
    i({
      instance: h,
      lastEditorData: S
    }), an(c, (N) => {
      h.value && N !== S.value && h.value.data.set(N);
    }), an(() => r.disabled, (N) => {
      N ? h.value.enableReadOnlyMode(id) : h.value.disableReadOnlyMode(id);
    });
    function C() {
      const N = window.CKEDITOR_VERSION;
      if (!N)
        return console.warn('Cannot find the "CKEDITOR_VERSION" in the "window" scope.');
      const [D] = N.split(".").map(Number);
      D >= 42 || N.startsWith("0.0.0") || console.warn("The <CKEditor> component requires using CKEditor 5 in version 42+ or nightly build.");
    }
    function O(N) {
      const D = sD((x) => {
        if (r.disableTwoWayDataBinding)
          return;
        const L = S.value = N.data.get();
        e("update:modelValue", L, x, N), e("input", L, x, N);
      }, PD, { leading: !0 });
      N.model.document.on("change:data", D), N.editing.view.document.on("focus", (x) => {
        e("focus", x, N);
      }), N.editing.view.document.on("blur", (x) => {
        e("blur", x, N);
      });
    }
    return C(), Na(() => {
      const N = MD(
        Object.assign({}, r.config)
      );
      c.value && (N.initialData = c.value), r.editor.create(g.value, N).then((D) => {
        h.value = oA(D), O(D), c.value !== N.initialData && D.data.set(c.value), r.disabled && D.enableReadOnlyMode(id), e("ready", D);
      }).catch((D) => {
        console.error(D);
      });
    }), E1(() => {
      h.value && (h.value.destroy(), h.value = void 0), e("destroy");
    }), (N, D) => (he(), gn(sA(N.tagName), {
      ref_key: "element",
      ref: g
    }, null, 512));
  }
});
/**
 * @license Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md.
 */
const FD = (s) => {
  const i = pt(null), o = pt(null), c = pt(null), r = Vt(() => i.value !== null);
  return g1(async () => {
    const e = _D();
    i.value = e, c.value = null, o.value = null;
    const g = () => i.value !== e;
    try {
      const h = await s();
      g() || (c.value = h);
    } catch (h) {
      g() || (o.value = h);
    } finally {
      g() || (i.value = null);
    }
  }), {
    loading: Qc(r),
    data: Qc(c),
    error: Qc(o)
  };
};
/**
 * @license Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md.
 */
function UD(s) {
  return FD(
    () => wD(
      $o(s)
    )
  );
}
/**
 * @license Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md.
 */
/* istanbul ignore if -- @preserve */
if (!yh.version || !yh.version.startsWith("3."))
  throw new Error(
    "The CKEditor plugin works only with Vue 3+. For more information, please refer to https://ckeditor.com/docs/ckeditor5/latest/builds/guides/integration/frameworks/vuejs-v3.html"
  );
const BD = { class: "main-container" }, GD = {
  class: "editor-container editor-container_classic-editor",
  ref: "editorContainerElement"
}, VD = { class: "editor-container__editor" }, YD = { ref: "editorElement" }, HD = "eyJhbGciOiJFUzI1NiJ9.eyJleHAiOjE3ODAxODU1OTksImp0aSI6Ijc4ZmQ1MjIxLTYxOTAtNGExZi1hNzllLTk3NjVkZjdmNDViYiIsInVzYWdlRW5kcG9pbnQiOiJodHRwczovL3Byb3h5LWV2ZW50LmNrZWRpdG9yLmNvbSIsImRpc3RyaWJ1dGlvbkNoYW5uZWwiOlsiY2xvdWQiLCJkcnVwYWwiXSwiZmVhdHVyZXMiOlsiRFJVUCIsIkUyUCIsIkUyVyJdLCJ2YyI6ImJkNGQ2OTUzIn0.zABVA2Iwf9oq-LFp8-z_QIS6jzyffaeK9XMJt-td2KeEUsv_7rorCTVYHTZ9TOCLk8yGpe788k5c5B1AMpDJew", qD = /* @__PURE__ */ Nr({
  __name: "VEditor",
  props: {
    modelValue: {},
    width: {},
    height: {},
    disabled: { type: Boolean },
    readonly: { type: Boolean },
    placeholder: { default: "내용을 입력하세요." }
  },
  emits: ["update:modelValue", "blur", "focus", "input"],
  setup(s, { emit: i }) {
    cA((D) => ({
      "424c5935": r.value.width,
      "252058d0": r.value.height
    }));
    const o = s, c = i, r = pt({
      width: o.width || "",
      height: o.height || "400px"
    }), e = Vt({
      get() {
        return o.modelValue || "";
      },
      set(D) {
        c("update:modelValue", D);
      }
    }), g = UD({ version: "45.1.0", translations: ["ko"] }), h = pt(!1), S = Vt(() => g.data.value ? g.data.value.CKEditor.ClassicEditor : null), C = Vt(() => {
      if (!h.value || !g.data.value)
        return null;
      const {
        Alignment: D,
        Autoformat: x,
        AutoImage: L,
        Autosave: G,
        BlockQuote: Y,
        Bold: k,
        Emoji: W,
        Essentials: Z,
        FindAndReplace: H,
        FontBackgroundColor: K,
        FontColor: Q,
        FontFamily: _e,
        FontSize: se,
        GeneralHtmlSupport: Pe,
        Heading: Ke,
        Highlight: ye,
        ImageBlock: Je,
        ImageCaption: mt,
        ImageInline: ge,
        ImageInsert: w,
        ImageInsertViaUrl: fe,
        ImageResize: j,
        ImageStyle: J,
        ImageTextAlternative: de,
        ImageToolbar: ie,
        ImageUpload: X,
        Indent: ue,
        IndentBlock: Oe,
        Italic: Re,
        Link: ae,
        LinkImage: Ee,
        List: ne,
        ListProperties: Ge,
        MediaEmbed: we,
        Mention: st,
        Paragraph: Rt,
        PasteFromOffice: rt,
        SimpleUploadAdapter: z,
        SourceEditing: V,
        SpecialCharacters: Te,
        SpecialCharactersArrows: Be,
        SpecialCharactersCurrency: Le,
        SpecialCharactersEssentials: Yt,
        SpecialCharactersLatin: Nt,
        SpecialCharactersMathematical: Hr,
        SpecialCharactersText: Er,
        Table: tr,
        TableCaption: vr,
        TableCellProperties: Pr,
        TableColumnResize: ur,
        TableProperties: Ae,
        TableToolbar: pe,
        TextTransformation: qe,
        TodoList: bt,
        Underline: Gt
      } = g.data.value.CKEditor;
      return {
        toolbar: {
          items: [
            "undo",
            "redo",
            "|",
            "sourceEditing",
            "findAndReplace",
            "|",
            "heading",
            "|",
            "fontSize",
            "fontFamily",
            "fontColor",
            "fontBackgroundColor",
            "|",
            "bold",
            "italic",
            "underline",
            "|",
            "emoji",
            "specialCharacters",
            "link",
            "insertImage",
            "mediaEmbed",
            "insertTable",
            "highlight",
            "blockQuote",
            "|",
            "alignment",
            "|",
            "bulletedList",
            "numberedList",
            "todoList",
            "outdent",
            "indent"
          ],
          shouldNotGroupWhenFull: !0
        },
        plugins: [
          D,
          x,
          L,
          G,
          Y,
          k,
          W,
          Z,
          H,
          K,
          Q,
          _e,
          se,
          Pe,
          Ke,
          ye,
          Je,
          mt,
          ge,
          w,
          fe,
          j,
          J,
          de,
          ie,
          X,
          ue,
          Oe,
          Re,
          ae,
          Ee,
          ne,
          Ge,
          we,
          st,
          Rt,
          rt,
          z,
          Te,
          V,
          Be,
          Le,
          Yt,
          Nt,
          Hr,
          Er,
          tr,
          vr,
          Pr,
          ur,
          Ae,
          pe,
          qe,
          bt,
          Gt,
          N
        ],
        fontFamily: {
          supportAllValues: !0
        },
        fontSize: {
          options: [10, 12, 14, "default", 18, 20, 22],
          supportAllValues: !0
        },
        heading: {
          options: [
            {
              model: "paragraph",
              title: "Paragraph",
              class: "ck-heading_paragraph"
            },
            {
              model: "heading1",
              view: "h1",
              title: "Heading 1",
              class: "ck-heading_heading1"
            },
            {
              model: "heading2",
              view: "h2",
              title: "Heading 2",
              class: "ck-heading_heading2"
            },
            {
              model: "heading3",
              view: "h3",
              title: "Heading 3",
              class: "ck-heading_heading3"
            },
            {
              model: "heading4",
              view: "h4",
              title: "Heading 4",
              class: "ck-heading_heading4"
            },
            {
              model: "heading5",
              view: "h5",
              title: "Heading 5",
              class: "ck-heading_heading5"
            },
            {
              model: "heading6",
              view: "h6",
              title: "Heading 6",
              class: "ck-heading_heading6"
            }
          ]
        },
        htmlSupport: {
          allow: [
            {
              name: /^.*$/,
              styles: !0,
              attributes: !0,
              classes: !0
            }
          ]
        },
        image: {
          toolbar: [
            "toggleImageCaption",
            "imageTextAlternative",
            "|",
            "imageStyle:inline",
            "imageStyle:wrapText",
            "imageStyle:breakText",
            "|",
            "resizeImage"
          ]
        },
        initialData: "",
        language: "ko",
        licenseKey: HD,
        link: {
          addTargetToExternalLinks: !0,
          defaultProtocol: "https://",
          decorators: {
            toggleDownloadable: {
              mode: "manual",
              label: "Downloadable",
              attributes: {
                download: "file"
              }
            }
          }
        },
        list: {
          properties: {
            styles: !0,
            startIndex: !0,
            reversed: !0
          }
        },
        mention: {
          feeds: [
            {
              marker: "@",
              feed: [
                /* See: https://ckeditor.com/docs/ckeditor5/latest/features/mentions.html */
              ]
            }
          ]
        },
        placeholder: o.placeholder,
        table: {
          contentToolbar: ["tableColumn", "tableRow", "mergeTableCells", "tableProperties", "tableCellProperties"]
        }
      };
    });
    Na(() => {
      h.value = !0;
    });
    class O {
      constructor(x) {
        Kc(this, "loader");
        Kc(this, "xhr");
        this.loader = x;
      }
      upload() {
        return this.loader.file.then(
          (x) => new Promise((L, G) => {
            this._initRequest(), this._initListeners(L, G, x), this._sendRequest(x);
          })
        );
      }
      _initRequest() {
        const x = this.xhr = new XMLHttpRequest();
        x.open("POST", "/api/common/ckeditor/upload", !0), x.responseType = "json";
      }
      _initListeners(x, L, G) {
        const Y = this.xhr, k = "파일을 업로드 할 수 없습니다.";
        Y.addEventListener("error", () => {
          L(k);
        }), Y.addEventListener("abort", () => L()), Y.addEventListener("load", () => {
          const W = Y.response;
          if (!W || W.error)
            return L(W && W.error ? W.error.message : k);
          x({
            default: W.url
            //업로드된 파일 주소
          });
        });
      }
      _sendRequest(x) {
        const L = new FormData();
        L.append("upload", x), this.xhr.send(L);
      }
    }
    function N(D) {
      D.plugins.get("FileRepository").createUploadAdapter = (x) => new O(x);
    }
    return (D, x) => (he(), De("div", BD, [
      U("div", GD, [
        U("div", VD, [
          U("div", YD, [
            S.value && C.value ? (he(), gn(kt(kD), {
              key: 0,
              modelValue: e.value,
              "onUpdate:modelValue": x[0] || (x[0] = (L) => e.value = L),
              editor: S.value,
              config: C.value,
              disabled: D.disabled || D.readonly,
              onInput: x[1] || (x[1] = (L) => c("input", L)),
              onBlur: x[2] || (x[2] = (L) => c("blur")),
              onFocus: x[3] || (x[3] = (L) => c("focus"))
            }, null, 8, ["modelValue", "editor", "config", "disabled"])) : Ut("", !0)
          ], 512)
        ])
      ], 512)
    ]));
  }
}), $D = /* @__PURE__ */ wr(qD, [["__scopeId", "data-v-e90e4b32"]]), WD = ["for"], zD = /* @__PURE__ */ Nr({
  __name: "VFileButton",
  props: {
    id: {},
    disabled: { type: Boolean, default: !1 }
  },
  setup(s) {
    return (i, o) => (he(), De("label", {
      for: i.id,
      class: jt(["VFileButton", { "is-disabled": i.disabled }])
    }, wt("파일첨부"), 10, WD));
  }
}), Ko = /* @__PURE__ */ wr(zD, [["__scopeId", "data-v-09ac84af"]]), KD = {
  key: 0,
  class: "VIconButton"
}, QD = /* @__PURE__ */ Nr({
  __name: "VIconButton",
  props: {
    icon: {}
  },
  setup(s) {
    return (i, o) => {
      const c = pr("VIconFont");
      return i.icon ? (he(), De("button", KD, [
        Ze(c, { icon: i.icon }, null, 8, ["icon"])
      ])) : Ut("", !0);
    };
  }
}), Cm = /* @__PURE__ */ wr(QD, [["__scopeId", "data-v-95a6207a"]]), iv = "data:image/svg+xml,%3csvg%20width='20'%20height='20'%20viewBox='0%200%2020%2020'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20clip-path='url(%23kyykqw7y8a)'%3e%3cpath%20d='M3.7%200h8.28L19%206.5v11a2.41%202.41%200%200%201-.79%201.768A2.814%202.814%200%200%201%2016.3%2020H3.7a2.814%202.814%200%200%201-1.91-.732A2.41%202.41%200%200%201%201%2017.5v-15c0-.663.284-1.299.79-1.768A2.813%202.813%200%200%201%203.7%200z'%20fill='%237D8EAB'/%3e%3cpath%20opacity='.4'%20d='M19.5%207h-4.162A3.33%203.33%200%200%201%2012%203.67V0l7.5%207z'%20fill='%23fff'/%3e%3cpath%20d='M7.507%2017H4.539v-4.998h2.968v1.085H5.89v.784h1.498v1.085H5.89v.945h1.617V17zm3.009%200H9.165v-3.892H7.947v-1.106h3.787v1.106h-1.218V17zm3.95-3.962a.864.864%200%200%200-.427.105.876.876%200%200%200-.322.294c-.089.126-.157.28-.203.462a2.52%202.52%200%200%200-.07.623c0%20.313.04.576.119.791.08.215.2.378.364.49a1.1%201.1%200%200%200%20.616.161c.22%200%20.432-.03.637-.091.21-.06.42-.135.63-.224v1.141a2.93%202.93%200%200%201-.68.21%203.67%203.67%200%200%201-.734.07c-.542%200-.985-.107-1.33-.322a1.912%201.912%200%200%201-.763-.896c-.164-.387-.245-.833-.245-1.337%200-.378.051-.723.154-1.036.107-.317.264-.59.469-.819.205-.233.457-.413.756-.539a2.7%202.7%200%200%201%201.043-.189%203.705%203.705%200%200%201%201.547.35l-.413%201.064a3.664%203.664%200%200%200-.553-.217%201.912%201.912%200%200%200-.595-.091z'%20fill='%23fff'/%3e%3c/g%3e%3cdefs%3e%3cclipPath%20id='kyykqw7y8a'%3e%3cpath%20fill='%23fff'%20d='M0%200h20v20H0z'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e", ov = "data:image/svg+xml,%3csvg%20width='20'%20height='20'%20viewBox='0%200%2020%2020'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20clip-path='url(%230j5sd1azua)'%3e%3cpath%20d='M3.7%200h8.28L19%206.5v11a2.41%202.41%200%200%201-.79%201.768A2.814%202.814%200%200%201%2016.3%2020H3.7a2.814%202.814%200%200%201-1.91-.732A2.41%202.41%200%200%201%201%2017.5v-15c0-.663.284-1.299.79-1.768A2.813%202.813%200%200%201%203.7%200z'%20fill='%23148349'/%3e%3cpath%20opacity='.4'%20d='M19.5%207h-4.162A3.33%203.33%200%200%201%2012%203.67V0l7.5%207z'%20fill='%23fff'/%3e%3cpath%20d='M4.64%2012.57%203.83%2014%203%2012.57H1.59l1.46%202.28-1.55%202.39h1.42l.9-1.46.91%201.46H6.2L4.6%2015l1.48-2.38-1.44-.05zM6.719%2012.57v4.67h3.06v-1h-1.78v-3.67h-1.28z'%20fill='%23fff'/%3e%3cmask%20id='auqomlyqrb'%20style='mask-type:luminance'%20maskUnits='userSpaceOnUse'%20x='1'%20y='12'%20width='18'%20height='6'%3e%3cpath%20d='M18.51%2012.5H1.5v4.8h17.01v-4.8z'%20fill='%23fff'/%3e%3c/mask%3e%3cg%20mask='url(%23auqomlyqrb)'%20fill='%23fff'%3e%3cpath%20d='M13.581%2015.82a1.41%201.41%200%200%201-.22.77c-.16.231-.382.412-.64.52a2.33%202.33%200%200%201-1%20.19c-.264%200-.528-.02-.79-.06a3.153%203.153%200%200%201-.65-.23v-1.13c.238.127.49.224.75.29.232.064.47.098.71.1a.65.65%200%200%200%20.41-.1.299.299%200%200%200%20.14-.25.27.27%200%200%200-.06-.17.39.39%200%200%200-.17-.14c-.2-.11-.41-.21-.62-.3a3.106%203.106%200%200%201-.68-.4%201.249%201.249%200%200%201-.34-.45%201.358%201.358%200%200%201-.11-.6%201.19%201.19%200%200%201%20.47-1%202%202%200%200%201%201.29-.36%203.6%203.6%200%200%201%201.48.34l-.39%201a2.75%202.75%200%200%200-1.13-.3.59.59%200%200%200-.36.09.24.24%200%200%200-.11.21.32.32%200%200%200%20.14.24c.247.158.509.292.78.4.319.13.603.333.83.59.167.226.252.501.24.78M18.499%2017.24h-1.5l-.91-1.46-.9%201.46h-1.38l1.55-2.39-1.46-2.28h1.4l.85%201.43.8-1.44h1.45L16.919%2015l1.58%202.24z'/%3e%3c/g%3e%3c/g%3e%3cdefs%3e%3cclipPath%20id='0j5sd1azua'%3e%3cpath%20fill='%23fff'%20d='M0%200h20v20H0z'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e", sl = "data:image/svg+xml,%3csvg%20width='20'%20height='20'%20viewBox='0%200%2020%2020'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20clip-path='url(%23ykbyfhi8xa)'%3e%3cpath%20d='M3.7%200h8.28L19%206.5v11a2.41%202.41%200%200%201-.79%201.768A2.814%202.814%200%200%201%2016.3%2020H3.7a2.814%202.814%200%200%201-1.91-.732A2.41%202.41%200%200%201%201%2017.5v-15c0-.663.284-1.299.79-1.768A2.813%202.813%200%200%201%203.7%200z'%20fill='%23C43E1C'/%3e%3cpath%20opacity='.4'%20d='M19.5%207h-4.162A3.33%203.33%200%200%201%2012%203.67V0l7.5%207z'%20fill='%23fff'/%3e%3cpath%20d='M8.152%2014a1.6%201.6%200%200%201-.47%201.24%202%202%200%200%201-1.35.44h-.33v1.62h-1.33v-4.8h1.66a2%202%200%200%201%201.36.4%201.39%201.39%200%200%201%20.46%201.1zm-2.15.65h.2a.631.631%200%200%200%20.46-.16.61.61%200%200%200%20.18-.49c0-.32-.18-.48-.54-.48h-.3v1.13zM12.402%2014a1.6%201.6%200%200%201-.47%201.24%202%202%200%200%201-1.35.44h-.36v1.62h-1.3v-4.8h1.66a2%202%200%200%201%201.36.4%201.391%201.391%200%200%201%20.46%201.1zm-2.18.62h.23a.67.67%200%200%200%20.47-.16.6.6%200%200%200%20.17-.46c0-.32-.18-.48-.54-.48h-.33v1.1zM15.29%2017.3H14v-3.74h-1.18V12.5h3.64v1.06h-1.17v3.74z'%20fill='%23fff'/%3e%3c/g%3e%3cdefs%3e%3cclipPath%20id='ykbyfhi8xa'%3e%3cpath%20fill='%23fff'%20d='M0%200h20v20H0z'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e", bi = "/api/common/file/";
let od = "";
async function XD() {
  return (await Dr.get("https://api64.ipify.org?format=json")).data.ip;
}
function Rm() {
  async function s(S) {
    return (await Dr.delete(bi + S.fileUuid, { params: { sortSeqNo: S.sortSeqNo } })).data === 1;
  }
  async function i(S) {
    const { fileUuid: C, ...O } = S;
    return (await Dr.get(bi + S.fileUuid, {
      params: O
    })).data.list;
  }
  function o(S) {
    const { fileUuid: C, ...O } = S;
    let N = "", D = 0;
    for (const x in O) {
      const L = x;
      O[L] && (D === 0 ? (N += `?${L}=${O[L]}`, D++) : N += `&${L}=${O[L]}`);
    }
    return bi + "image/" + S.fileUuid + N;
  }
  async function c(S) {
    try {
      const C = await Dr.get("/api/common/file/download/" + S.fileUuid, {
        params: {
          sortSeqNo: S.sortSeqNo ?? ""
        },
        responseType: "blob",
        headers: {
          "X-Client-IP": od
        }
      }), N = C.headers["content-disposition"].split("filename=")[1].replace(/"/g, ""), D = window.URL.createObjectURL(new Blob([C.data])), x = document.createElement("a");
      document.body.appendChild(x), x.download = decodeURIComponent(N), x.href = D, x.click(), document.body.removeChild(x), window.URL.revokeObjectURL(D);
    } catch (C) {
      if (C.response && C.response.data instanceof Blob)
        try {
          const O = await C.response.data.text(), N = JSON.parse(O);
          alert(N.message || N);
        } catch (O) {
          console.warn("에러 응답 파싱 실패:", O);
        }
      else
        console.error("기타 에러:", C.message);
    }
  }
  async function r(S) {
    return (await Dr.get(bi + "copy/" + S.fileUuid, {
      params: {
        sortSeqNo: S.sortSeqNo ?? ""
      }
    })).data;
  }
  async function e(S) {
    const C = new FormData();
    for (const N in S)
      if (N !== "files") {
        const D = S;
        D[N] && C.append(N, D[N]);
      }
    return S.files.forEach((N) => {
      C.append("files", N);
    }), (await Dr.post(bi + "/upload/", C, {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    })).data;
  }
  async function g(S) {
    const C = new FormData();
    for (const N in S)
      if (N !== "files") {
        const D = S;
        D[N] && C.append(N, D[N]);
      }
    return C.append("files", S.files), (await Dr.post(bi + "single/upload/", C, {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    })).data;
  }
  async function h(S) {
    const C = new FormData();
    return S.files.forEach((N) => {
      for (const D in N)
        if (D === "file") {
          const x = N;
          C.append("files", x[D] || "");
        } else {
          const x = N;
          x[D] && C.append(D, x[D]);
        }
      S.fileUuid && C.append("fileUuid", S.fileUuid);
    }), (await Dr.post(bi + "/upload/", C, {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    })).data;
  }
  return h1(() => {
    od || XD().then((S) => {
      od = S;
    });
  }), { fileList: i, fileDelete: s, fileDownload: c, fileCopy: r, fileImage: o, fileSingleUpload: g, fileUpload: e, fileMultiUpload: h };
}
const ZD = { class: "VUpload" }, jD = {
  key: 0,
  class: "VUpload-inner"
}, JD = { class: "d-flex" }, e2 = { style: { position: "relative" } }, t2 = { class: "text-box mr-10" }, r2 = {
  key: 0,
  class: "thumb-wrap"
}, n2 = ["src"], a2 = {
  key: 0,
  class: "VUpload-top"
}, i2 = { class: "VUpload-body" }, o2 = { class: "file-item-left" }, s2 = ["src"], l2 = ["onClick"], c2 = { class: "file-size" }, d2 = {
  key: 0,
  class: "file-item-right"
}, u2 = ["onClick"], _2 = ["id", "multiple", "accept"], p2 = /* @__PURE__ */ Nr({
  __name: "VFileCustomUpload",
  props: {
    totalSize: {},
    fileFormat: { default: () => [] },
    maxLength: {},
    multiple: { type: Boolean, default: !1 },
    readonlyAndDownload: { type: Boolean },
    accept: {},
    modelValue: { default: () => [] },
    thumb: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue", "change", "remove", "allRemove", "download"],
  setup(s, { emit: i }) {
    const o = s, c = i, { fileImage: r } = Rm(), e = Vt(() => o.modelValue[0] ? o.modelValue[0].name : ""), g = Vt(() => {
      var G;
      let L = ((G = o.modelValue) == null ? void 0 : G.reduce((Y, k) => Y + k.size, 0)) ?? 0;
      return x(L);
    }), h = pt("");
    an([() => o.modelValue, () => o.thumb], ([L, G]) => {
      var Y, k;
      G && ((Y = L[0]) != null && Y.fileUuid) && (h.value = r({
        fileUuid: L[0].fileUuid
      })), G && ((k = L[0]) == null ? void 0 : k.file) instanceof File && (h.value = URL.createObjectURL(L[0].file)), G && !L[0] && (h.value = "");
    });
    const S = (L) => {
      var Pe, Ke;
      if (o.maxLength && o.modelValue && o.maxLength === o.modelValue.length)
        return alert("파일 최대 업로드 개수는 " + o.maxLength + "개입니다.");
      const G = L.target, k = [...G.files];
      G.value = "";
      const W = new RegExp("(" + o.fileFormat.join("|") + ")", "i"), Z = ((Pe = o.modelValue) == null ? void 0 : Pe.map((ye) => ye.name)) ?? [];
      let H = ((Ke = o.modelValue) == null ? void 0 : Ke.reduce((ye, Je) => ye + Je.size, 0)) ?? 0;
      const K = (o.totalSize ?? 0) * 1024 * 1024;
      for (const ye of k) {
        const Je = ye.name.split(".").pop();
        if (ye.name.length > 100)
          return alert("파일명은 100자 이하로 입력해주세요.");
        if (ye.size === 0)
          return alert("파일이 비어있습니다.");
        if (!W.test(Je))
          return alert("파일 확장자를 확인해 주세요. (" + o.fileFormat.join(", ") + ")");
        if (Z.some((mt) => mt === ye.name))
          return alert("이미 같은 파일명이 존재합니다.");
        if (K && !o.multiple && ye.size > K)
          return alert(`사이즈가 너무 큽니다. (최대 ${o.totalSize}MB)`);
        if (K && H + ye.size > K)
          return alert(`사이즈가 너무 큽니다. (최대 ${o.totalSize}MB)`);
        H += ye.size;
      }
      if (K && k[0].size > K)
        return alert(`사이즈가 너무 큽니다.(최대 ${o.totalSize}MB)`);
      const Q = [...o.modelValue ?? [], ...k];
      if (o.maxLength && o.modelValue && o.maxLength < Q.length)
        return alert("파일 최대 업로드 개수는 " + o.maxLength + "개입니다.");
      const _e = o.modelValue.map((ye) => ({
        name: ye.name,
        size: ye.size,
        file: ye.file,
        sortSeqNo: ye.sortSeqNo
      })), se = k.map((ye) => ({ name: ye.name, size: ye.size, file: ye, sortSeqNo: -1 }));
      if (o.multiple) {
        const ye = [..._e, ...se];
        c("update:modelValue", ye);
      } else
        c("update:modelValue", se);
      c("change", k), G.value = "";
    }, C = yi();
    function O(L) {
      const G = L.split(".").pop();
      return {
        xlsx: ov,
        ppt: sl,
        pptx: sl
      }[G] ?? iv;
    }
    function N(L) {
      window.confirm("파일을 삭제하시겠습니까?") && (c("remove", L), c(
        "update:modelValue",
        o.modelValue.filter((G) => G.name !== L.name)
      ));
    }
    function D() {
      window.confirm("파일을 모두 삭제하시겠습니까?") && (c("update:modelValue", []), c("allRemove"));
    }
    function x(L) {
      const G = L / 1048576;
      return Math.round(G * 10) / 10;
    }
    return (L, G) => {
      var Y;
      return he(), De("div", ZD, [
        L.multiple ? (he(), De(nr, { key: 1 }, [
          L.readonlyAndDownload ? Ut("", !0) : (he(), De("div", a2, [
            U("strong", null, "Total " + wt((Y = L.modelValue) == null ? void 0 : Y.length) + " / " + wt(g.value) + "MB", 1),
            U("div", null, [
              Ze(Ko, {
                id: kt(C),
                class: "mr-10"
              }, null, 8, ["id"]),
              Ze(Cm, {
                type: "button",
                icon: "ic_delete",
                onClick: D
              })
            ])
          ])),
          U("div", i2, [
            U("ul", null, [
              (he(!0), De(nr, null, Fr(L.modelValue, (k) => (he(), De("li", {
                class: "file-item",
                key: k.name
              }, [
                U("div", o2, [
                  U("img", {
                    src: O(k.name),
                    alt: "",
                    class: "file"
                  }, null, 8, s2),
                  U("strong", {
                    class: "file-title",
                    onClick: (W) => c("download", k),
                    style: nn({ cursor: L.readonlyAndDownload ? "pointer" : "default" })
                  }, wt(k.name), 13, l2),
                  U("span", c2, wt(x(k.size)) + "MB", 1)
                ]),
                L.readonlyAndDownload ? Ut("", !0) : (he(), De("div", d2, [
                  U("button", {
                    type: "button",
                    onClick: (W) => N(k)
                  }, [
                    Ze(Ri, { icon: "ic_close" })
                  ], 8, u2)
                ]))
              ]))), 128))
            ])
          ])
        ], 64)) : (he(), De("div", jD, [
          U("div", JD, [
            U("div", e2, [
              U("div", t2, [
                U("span", {
                  class: "text-box-tx",
                  onClick: G[0] || (G[0] = (k) => c("download", L.modelValue[0]))
                }, wt(e.value), 1)
              ]),
              L.modelValue[0] && L.modelValue[0].name && !L.disabled ? (he(), De("button", {
                key: 0,
                type: "button",
                onClick: G[1] || (G[1] = (k) => N(L.modelValue[0])),
                class: "remove-item-btn"
              }, [
                Ze(Ri, { icon: "ic_close" })
              ])) : Ut("", !0)
            ]),
            Ze(Ko, {
              id: kt(C),
              disabled: L.disabled
            }, null, 8, ["id", "disabled"])
          ]),
          L.thumb ? (he(), De("div", r2, [
            h.value ? (he(), De("img", {
              key: 0,
              src: h.value ?? "",
              alt: ""
            }, null, 8, n2)) : Ut("", !0)
          ])) : Ut("", !0)
        ])),
        fn(U("input", {
          type: "file",
          id: kt(C),
          onChange: S,
          multiple: L.multiple,
          accept: L.accept
        }, null, 40, _2), [
          [ea, !1]
        ])
      ]);
    };
  }
}), m2 = /* @__PURE__ */ wr(p2, [["__scopeId", "data-v-ab081ac6"]]);
function f2() {
  return sv().__VUE_DEVTOOLS_GLOBAL_HOOK__;
}
function sv() {
  return typeof navigator < "u" && typeof window < "u" ? window : typeof globalThis < "u" ? globalThis : {};
}
const g2 = typeof Proxy == "function", E2 = "devtools-plugin:setup", h2 = "plugin:settings:set";
let Ki, jp;
function S2() {
  var s;
  return Ki !== void 0 || (typeof window < "u" && window.performance ? (Ki = !0, jp = window.performance) : typeof globalThis < "u" && (!((s = globalThis.perf_hooks) === null || s === void 0) && s.performance) ? (Ki = !0, jp = globalThis.perf_hooks.performance) : Ki = !1), Ki;
}
function b2() {
  return S2() ? jp.now() : Date.now();
}
class T2 {
  constructor(i, o) {
    this.target = null, this.targetQueue = [], this.onQueue = [], this.plugin = i, this.hook = o;
    const c = {};
    if (i.settings)
      for (const g in i.settings) {
        const h = i.settings[g];
        c[g] = h.defaultValue;
      }
    const r = `__vue-devtools-plugin-settings__${i.id}`;
    let e = Object.assign({}, c);
    try {
      const g = localStorage.getItem(r), h = JSON.parse(g);
      Object.assign(e, h);
    } catch {
    }
    this.fallbacks = {
      getSettings() {
        return e;
      },
      setSettings(g) {
        try {
          localStorage.setItem(r, JSON.stringify(g));
        } catch {
        }
        e = g;
      },
      now() {
        return b2();
      }
    }, o && o.on(h2, (g, h) => {
      g === this.plugin.id && this.fallbacks.setSettings(h);
    }), this.proxiedOn = new Proxy({}, {
      get: (g, h) => this.target ? this.target.on[h] : (...S) => {
        this.onQueue.push({
          method: h,
          args: S
        });
      }
    }), this.proxiedTarget = new Proxy({}, {
      get: (g, h) => this.target ? this.target[h] : h === "on" ? this.proxiedOn : Object.keys(this.fallbacks).includes(h) ? (...S) => (this.targetQueue.push({
        method: h,
        args: S,
        resolve: () => {
        }
      }), this.fallbacks[h](...S)) : (...S) => new Promise((C) => {
        this.targetQueue.push({
          method: h,
          args: S,
          resolve: C
        });
      })
    });
  }
  async setRealTarget(i) {
    this.target = i;
    for (const o of this.onQueue)
      this.target.on[o.method](...o.args);
    for (const o of this.targetQueue)
      o.resolve(await this.target[o.method](...o.args));
  }
}
function v2(s, i) {
  const o = s, c = sv(), r = f2(), e = g2 && o.enableEarlyProxy;
  if (r && (c.__VUE_DEVTOOLS_PLUGIN_API_AVAILABLE__ || !e))
    r.emit(E2, s, i);
  else {
    const g = e ? new T2(o, r) : null;
    (c.__VUE_DEVTOOLS_PLUGINS__ = c.__VUE_DEVTOOLS_PLUGINS__ || []).push({
      pluginDescriptor: o,
      setupFn: i,
      proxy: g
    }), g && i(g.proxiedTarget);
  }
}
/*!
  * vue-router v4.2.5
  * (c) 2023 Eduardo San Martin Morote
  * @license MIT
  */
var zh;
(function(s) {
  s.pop = "pop", s.push = "push";
})(zh || (zh = {}));
var Kh;
(function(s) {
  s.back = "back", s.forward = "forward", s.unknown = "";
})(Kh || (Kh = {}));
Symbol(process.env.NODE_ENV !== "production" ? "navigation failure" : "");
var Qh;
(function(s) {
  s[s.aborted = 4] = "aborted", s[s.cancelled = 8] = "cancelled", s[s.duplicated = 16] = "duplicated";
})(Qh || (Qh = {}));
Symbol(process.env.NODE_ENV !== "production" ? "router view location matched" : "");
Symbol(process.env.NODE_ENV !== "production" ? "router view depth" : "");
Symbol(process.env.NODE_ENV !== "production" ? "router" : "");
const C2 = Symbol(process.env.NODE_ENV !== "production" ? "route location" : "");
Symbol(process.env.NODE_ENV !== "production" ? "router view location" : "");
function R2() {
  return S1(C2);
}
const N2 = { class: "side-bar-menu" }, A2 = {
  key: 0,
  class: "bar-menu-warp"
}, O2 = { class: "side-bar-list" }, y2 = ["onClick"], I2 = { class: "depth-label" }, D2 = ["onClick"], w2 = { class: "depth-label" }, x2 = {
  key: 2,
  class: "depth2-list"
}, L2 = ["onClick"], M2 = ["onClick"], P2 = /* @__PURE__ */ Nr({
  __name: "TheSideBar",
  props: {
    apiURL: {}
  },
  setup(s, { expose: i }) {
    R2();
    const o = s, c = pt("menu"), r = pt([]), e = pt(!1), g = pt(!1), h = (x) => x.split("/").pop() ?? "", S = () => {
      r.value.forEach((x) => {
        x.active = !g.value, x.children && x.children.forEach((L) => {
          L.children && (L.active = !g.value);
        });
      });
    };
    (async function() {
      const L = await Dr.get("/api/common" + o.apiURL);
      L.data[0].children && L.data[0].children && (C(L.data[0].children), r.value = L.data[0].children);
    })();
    function C(x) {
      x.forEach((L) => {
        L.active = !1, L.children && C(L.children);
      });
    }
    an(
      r,
      () => {
        g.value = r.value.some((x) => x.active);
      },
      { deep: !0 }
    );
    function O(x) {
      const L = "/" + (x.menuTrsCtet ? x.menuId + `?${x.menuTrsCtet}` : x.menuId);
      return location.pathname.startsWith("/club/admin") ? "/admin/" + location.pathname.split("/")[3] + L : L;
    }
    i({
      toggleLnb: e
    });
    let N = !1;
    const D = pt(null);
    return window.addEventListener("scroll", () => {
      N || (window.requestAnimationFrame(() => {
        D.value && (D.value.style.left = `-${window.scrollX}px`, N = !1);
      }), N = !0);
    }), (x, L) => {
      const G = pr("VIconFont");
      return he(), De("aside", {
        class: jt(["side-bar", { "is-active": e.value }]),
        ref_key: "sideBar",
        ref: D
      }, [
        U("button", {
          type: "button",
          class: "toggle-lnb",
          onClick: L[0] || (L[0] = (Y) => e.value = !e.value)
        }, [
          Ze(G, { icon: "ic_triangle" })
        ]),
        e.value ? Ut("", !0) : (he(), De(nr, { key: 0 }, [
          U("ul", N2, [
            U("li", {
              class: jt({ "is-active": c.value === "menu" }),
              onClick: L[1] || (L[1] = (Y) => c.value = "menu")
            }, "메뉴", 2),
            U("li", {
              class: jt({ "is-active": c.value === "star" }),
              onClick: L[2] || (L[2] = (Y) => c.value = "star")
            }, "즐겨찾기", 2)
          ]),
          c.value === "menu" ? (he(), De("div", A2, [
            U("button", {
              type: "button",
              class: "bar-menu-all",
              "aria-label": "모든 메뉴 버튼 오픈",
              onClick: S
            }, [
              Ze(G, {
                icon: g.value ? "ic_minus_w" : "ic_plus_w"
              }, null, 8, ["icon"]),
              L[3] || (L[3] = Ft(" ALL "))
            ]),
            U("ul", O2, [
              (he(!0), De(nr, null, Fr(r.value, (Y) => {
                var k, W;
                return he(), De("li", {
                  key: Y.menuNm
                }, [
                  (k = Y.children) != null && k.length ? (he(), De("div", {
                    key: 0,
                    class: jt(["depth-title", {
                      "is-active": !!((W = Y.children) != null && W.some((Z) => h(x.$route.path) === Z.menuId ? !0 : Z.children ? Z.children.some((H) => h(x.$route.path) === H.menuId) : !1))
                    }]),
                    onClick: (Z) => Y.active = !Y.active
                  }, [
                    U("h3", I2, wt(Y.menuNm), 1),
                    U("div", {
                      class: "depth-arrow",
                      style: nn({ transform: Y.active ? "rotate(180deg)" : "rotate(0deg)" })
                    }, [
                      Ze(G, { icon: "ic_arrow" })
                    ], 4)
                  ], 10, y2)) : (he(), De("div", {
                    key: 1,
                    class: "depth-title",
                    onClick: (Z) => x.$router.push(O(Y))
                  }, [
                    U("h3", w2, wt(Y.menuNm), 1)
                  ], 8, D2)),
                  Y.active ? (he(), De("ol", x2, [
                    (he(!0), De(nr, null, Fr(Y.children, (Z) => {
                      var H;
                      return he(), De("li", {
                        key: Z.menuId
                      }, [
                        U("h4", {
                          class: jt(["depth2-label", {
                            "is-active": !!((H = Z.children) != null && H.some((K) => h(x.$route.path) === K.menuId)) || h(x.$route.path) === Z.menuId
                          }]),
                          onClick: () => {
                            Z.children ? Z.active = !Z.active : x.$router.push(O(Z));
                          }
                        }, wt(Z.menuNm), 11, L2),
                        Z.active ? (he(), De("ol", {
                          class: "depth3-list",
                          key: Z.menuId
                        }, [
                          (he(!0), De(nr, null, Fr(Z.children, (K) => (he(), De("li", {
                            onClick: (Q) => x.$router.push(O(K)),
                            class: jt({ "is-active": h(x.$route.path) === K.menuId })
                          }, wt(K.menuNm), 11, M2))), 256))
                        ])) : Ut("", !0)
                      ]);
                    }), 128))
                  ])) : Ut("", !0)
                ]);
              }), 128))
            ])
          ])) : (he(), De(nr, { key: 1 }, [
            Ft("즐겨찾기 입니다. ")
          ], 64))
        ], 64))
      ], 2);
    };
  }
}), _4 = /* @__PURE__ */ wr(P2, [["__scopeId", "data-v-b3c43cd8"]]);
/*!
  * shared v9.9.1
  * (c) 2024 kazuya kawaguchi
  * Released under the MIT License.
  */
const ga = typeof window < "u";
let ta, Ni;
if (process.env.NODE_ENV !== "production") {
  const s = ga && window.performance;
  s && s.mark && s.measure && s.clearMarks && // @ts-ignore browser compat
  s.clearMeasures && (ta = (i) => {
    s.mark(i);
  }, Ni = (i, o, c) => {
    s.measure(i, o, c), s.clearMarks(o), s.clearMarks(c);
  });
}
const k2 = /\{([0-9a-zA-Z]+)\}/g;
function Nm(s, ...i) {
  return i.length === 1 && Tr(i[0]) && (i = i[0]), (!i || !i.hasOwnProperty) && (i = {}), s.replace(k2, (o, c) => i.hasOwnProperty(c) ? i[c] : "");
}
const Oa = (s, i = !1) => i ? Symbol.for(s) : Symbol(s), F2 = (s, i, o) => U2({ l: s, k: i, s: o }), U2 = (s) => JSON.stringify(s).replace(/\u2028/g, "\\u2028").replace(/\u2029/g, "\\u2029").replace(/\u0027/g, "\\u0027"), mn = (s) => typeof s == "number" && isFinite(s), B2 = (s) => cv(s) === "[object Date]", Ja = (s) => cv(s) === "[object RegExp]", bl = (s) => zt(s) && Object.keys(s).length === 0, yn = Object.assign;
let Xh;
const Ua = () => Xh || (Xh = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : typeof global < "u" ? global : {});
function Zh(s) {
  return s.replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&apos;");
}
const G2 = Object.prototype.hasOwnProperty;
function ll(s, i) {
  return G2.call(s, i);
}
const Gr = Array.isArray, Mr = (s) => typeof s == "function", dt = (s) => typeof s == "string", ar = (s) => typeof s == "boolean", Tr = (s) => s !== null && typeof s == "object", V2 = (s) => Tr(s) && Mr(s.then) && Mr(s.catch), lv = Object.prototype.toString, cv = (s) => lv.call(s), zt = (s) => {
  if (!Tr(s))
    return !1;
  const i = Object.getPrototypeOf(s);
  return i === null || i.constructor === Object;
}, Y2 = (s) => s == null ? "" : Gr(s) || zt(s) && s.toString === lv ? JSON.stringify(s, null, 2) : String(s);
function H2(s, i = "") {
  return s.reduce((o, c, r) => r === 0 ? o + c : o + i + c, "");
}
const jh = 2;
function q2(s, i = 0, o = s.length) {
  const c = s.split(/\r?\n/);
  let r = 0;
  const e = [];
  for (let g = 0; g < c.length; g++)
    if (r += c[g].length + 1, r >= i) {
      for (let h = g - jh; h <= g + jh || o > r; h++) {
        if (h < 0 || h >= c.length)
          continue;
        const S = h + 1;
        e.push(`${S}${" ".repeat(3 - String(S).length)}|  ${c[h]}`);
        const C = c[h].length;
        if (h === g) {
          const O = i - (r - C) + 1, N = Math.max(1, o > r ? C - O : o - i);
          e.push("   |  " + " ".repeat(O) + "^".repeat(N));
        } else if (h > g) {
          if (o > r) {
            const O = Math.max(Math.min(o - r, C), 1);
            e.push("   |  " + "^".repeat(O));
          }
          r += C + 1;
        }
      }
      break;
    }
  return e.join(`
`);
}
function Am(s) {
  let i = s;
  return () => ++i;
}
function vn(s, i) {
  typeof console < "u" && (console.warn("[intlify] " + s), i && console.warn(i.stack));
}
const Jh = {};
function $2(s) {
  Jh[s] || (Jh[s] = !0, vn(s));
}
function Om() {
  const s = /* @__PURE__ */ new Map();
  return {
    events: s,
    on(o, c) {
      const r = s.get(o);
      r && r.push(c) || s.set(o, [c]);
    },
    off(o, c) {
      const r = s.get(o);
      r && r.splice(r.indexOf(c) >>> 0, 1);
    },
    emit(o, c) {
      (s.get(o) || []).slice().map((r) => r(c)), (s.get("*") || []).slice().map((r) => r(o, c));
    }
  };
}
const js = (s) => !Tr(s) || Gr(s);
function al(s, i) {
  if (js(s) || js(i))
    throw new Error("Invalid value");
  const o = [{ src: s, des: i }];
  for (; o.length; ) {
    const { src: c, des: r } = o.pop();
    Object.keys(c).forEach((e) => {
      js(c[e]) || js(r[e]) ? r[e] = c[e] : o.push({ src: c[e], des: r[e] });
    });
  }
}
/*!
  * message-compiler v9.9.1
  * (c) 2024 kazuya kawaguchi
  * Released under the MIT License.
  */
function W2(s, i, o) {
  return { line: s, column: i, offset: o };
}
function Jp(s, i, o) {
  const c = { start: s, end: i };
  return o != null && (c.source = o), c;
}
const z2 = /\{([0-9a-zA-Z]+)\}/g;
function K2(s, ...i) {
  return i.length === 1 && Q2(i[0]) && (i = i[0]), (!i || !i.hasOwnProperty) && (i = {}), s.replace(z2, (o, c) => i.hasOwnProperty(c) ? i[c] : "");
}
const dv = Object.assign, eS = (s) => typeof s == "string", Q2 = (s) => s !== null && typeof s == "object";
function uv(s, i = "") {
  return s.reduce((o, c, r) => r === 0 ? o + c : o + i + c, "");
}
const qt = {
  // tokenizer error codes
  EXPECTED_TOKEN: 1,
  INVALID_TOKEN_IN_PLACEHOLDER: 2,
  UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER: 3,
  UNKNOWN_ESCAPE_SEQUENCE: 4,
  INVALID_UNICODE_ESCAPE_SEQUENCE: 5,
  UNBALANCED_CLOSING_BRACE: 6,
  UNTERMINATED_CLOSING_BRACE: 7,
  EMPTY_PLACEHOLDER: 8,
  NOT_ALLOW_NEST_PLACEHOLDER: 9,
  INVALID_LINKED_FORMAT: 10,
  // parser error codes
  MUST_HAVE_MESSAGES_IN_PLURAL: 11,
  UNEXPECTED_EMPTY_LINKED_MODIFIER: 12,
  UNEXPECTED_EMPTY_LINKED_KEY: 13,
  UNEXPECTED_LEXICAL_ANALYSIS: 14,
  // generator error codes
  UNHANDLED_CODEGEN_NODE_TYPE: 15,
  // minifier error codes
  UNHANDLED_MINIFIER_NODE_TYPE: 16,
  // Special value for higher-order compilers to pick up the last code
  // to avoid collision of error codes. This should always be kept as the last
  // item.
  __EXTEND_POINT__: 17
}, X2 = {
  // tokenizer error messages
  [qt.EXPECTED_TOKEN]: "Expected token: '{0}'",
  [qt.INVALID_TOKEN_IN_PLACEHOLDER]: "Invalid token in placeholder: '{0}'",
  [qt.UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER]: "Unterminated single quote in placeholder",
  [qt.UNKNOWN_ESCAPE_SEQUENCE]: "Unknown escape sequence: \\{0}",
  [qt.INVALID_UNICODE_ESCAPE_SEQUENCE]: "Invalid unicode escape sequence: {0}",
  [qt.UNBALANCED_CLOSING_BRACE]: "Unbalanced closing brace",
  [qt.UNTERMINATED_CLOSING_BRACE]: "Unterminated closing brace",
  [qt.EMPTY_PLACEHOLDER]: "Empty placeholder",
  [qt.NOT_ALLOW_NEST_PLACEHOLDER]: "Not allowed nest placeholder",
  [qt.INVALID_LINKED_FORMAT]: "Invalid linked format",
  // parser error messages
  [qt.MUST_HAVE_MESSAGES_IN_PLURAL]: "Plural must have messages",
  [qt.UNEXPECTED_EMPTY_LINKED_MODIFIER]: "Unexpected empty linked modifier",
  [qt.UNEXPECTED_EMPTY_LINKED_KEY]: "Unexpected empty linked key",
  [qt.UNEXPECTED_LEXICAL_ANALYSIS]: "Unexpected lexical analysis in token: '{0}'",
  // generator error messages
  [qt.UNHANDLED_CODEGEN_NODE_TYPE]: "unhandled codegen node type: '{0}'",
  // minimizer error messages
  [qt.UNHANDLED_MINIFIER_NODE_TYPE]: "unhandled mimifier node type: '{0}'"
};
function no(s, i, o = {}) {
  const { domain: c, messages: r, args: e } = o, g = K2((r || X2)[s] || "", ...e || []), h = new SyntaxError(String(g));
  return h.code = s, i && (h.location = i), h.domain = c, h;
}
function Z2(s) {
  throw s;
}
const j2 = /<\/?[\w\s="/.':;#-\/]+>/, J2 = (s) => j2.test(s), Fa = " ", ew = "\r", Hn = `
`, tw = "\u2028", rw = "\u2029";
function nw(s) {
  const i = s;
  let o = 0, c = 1, r = 1, e = 0;
  const g = (_e) => i[_e] === ew && i[_e + 1] === Hn, h = (_e) => i[_e] === Hn, S = (_e) => i[_e] === rw, C = (_e) => i[_e] === tw, O = (_e) => g(_e) || h(_e) || S(_e) || C(_e), N = () => o, D = () => c, x = () => r, L = () => e, G = (_e) => g(_e) || S(_e) || C(_e) ? Hn : i[_e], Y = () => G(o), k = () => G(o + e);
  function W() {
    return e = 0, O(o) && (c++, r = 0), g(o) && o++, o++, r++, i[o];
  }
  function Z() {
    return g(o + e) && e++, e++, i[o + e];
  }
  function H() {
    o = 0, c = 1, r = 1, e = 0;
  }
  function K(_e = 0) {
    e = _e;
  }
  function Q() {
    const _e = o + e;
    for (; _e !== o; )
      W();
    e = 0;
  }
  return {
    index: N,
    line: D,
    column: x,
    peekOffset: L,
    charAt: G,
    currentChar: Y,
    currentPeek: k,
    next: W,
    peek: Z,
    reset: H,
    resetPeek: K,
    skipToPeek: Q
  };
}
const Xa = void 0, aw = ".", tS = "'", iw = "tokenizer";
function ow(s, i = {}) {
  const o = i.location !== !1, c = nw(s), r = () => c.index(), e = () => W2(c.line(), c.column(), c.index()), g = e(), h = r(), S = {
    currentType: 14,
    offset: h,
    startLoc: g,
    endLoc: g,
    lastType: 14,
    lastOffset: h,
    lastStartLoc: g,
    lastEndLoc: g,
    braceNest: 0,
    inLinked: !1,
    text: ""
  }, C = () => S, { onError: O } = i;
  function N(z, V, Te, ...Be) {
    const Le = C();
    if (V.column += Te, V.offset += Te, O) {
      const Yt = o ? Jp(Le.startLoc, V) : null, Nt = no(z, Yt, {
        domain: iw,
        args: Be
      });
      O(Nt);
    }
  }
  function D(z, V, Te) {
    z.endLoc = e(), z.currentType = V;
    const Be = { type: V };
    return o && (Be.loc = Jp(z.startLoc, z.endLoc)), Te != null && (Be.value = Te), Be;
  }
  const x = (z) => D(
    z,
    14
    /* TokenTypes.EOF */
  );
  function L(z, V) {
    return z.currentChar() === V ? (z.next(), V) : (N(qt.EXPECTED_TOKEN, e(), 0, V), "");
  }
  function G(z) {
    let V = "";
    for (; z.currentPeek() === Fa || z.currentPeek() === Hn; )
      V += z.currentPeek(), z.peek();
    return V;
  }
  function Y(z) {
    const V = G(z);
    return z.skipToPeek(), V;
  }
  function k(z) {
    if (z === Xa)
      return !1;
    const V = z.charCodeAt(0);
    return V >= 97 && V <= 122 || // a-z
    V >= 65 && V <= 90 || // A-Z
    V === 95;
  }
  function W(z) {
    if (z === Xa)
      return !1;
    const V = z.charCodeAt(0);
    return V >= 48 && V <= 57;
  }
  function Z(z, V) {
    const { currentType: Te } = V;
    if (Te !== 2)
      return !1;
    G(z);
    const Be = k(z.currentPeek());
    return z.resetPeek(), Be;
  }
  function H(z, V) {
    const { currentType: Te } = V;
    if (Te !== 2)
      return !1;
    G(z);
    const Be = z.currentPeek() === "-" ? z.peek() : z.currentPeek(), Le = W(Be);
    return z.resetPeek(), Le;
  }
  function K(z, V) {
    const { currentType: Te } = V;
    if (Te !== 2)
      return !1;
    G(z);
    const Be = z.currentPeek() === tS;
    return z.resetPeek(), Be;
  }
  function Q(z, V) {
    const { currentType: Te } = V;
    if (Te !== 8)
      return !1;
    G(z);
    const Be = z.currentPeek() === ".";
    return z.resetPeek(), Be;
  }
  function _e(z, V) {
    const { currentType: Te } = V;
    if (Te !== 9)
      return !1;
    G(z);
    const Be = k(z.currentPeek());
    return z.resetPeek(), Be;
  }
  function se(z, V) {
    const { currentType: Te } = V;
    if (!(Te === 8 || Te === 12))
      return !1;
    G(z);
    const Be = z.currentPeek() === ":";
    return z.resetPeek(), Be;
  }
  function Pe(z, V) {
    const { currentType: Te } = V;
    if (Te !== 10)
      return !1;
    const Be = () => {
      const Yt = z.currentPeek();
      return Yt === "{" ? k(z.peek()) : Yt === "@" || Yt === "%" || Yt === "|" || Yt === ":" || Yt === "." || Yt === Fa || !Yt ? !1 : Yt === Hn ? (z.peek(), Be()) : k(Yt);
    }, Le = Be();
    return z.resetPeek(), Le;
  }
  function Ke(z) {
    G(z);
    const V = z.currentPeek() === "|";
    return z.resetPeek(), V;
  }
  function ye(z) {
    const V = G(z), Te = z.currentPeek() === "%" && z.peek() === "{";
    return z.resetPeek(), {
      isModulo: Te,
      hasSpace: V.length > 0
    };
  }
  function Je(z, V = !0) {
    const Te = (Le = !1, Yt = "", Nt = !1) => {
      const Hr = z.currentPeek();
      return Hr === "{" ? Yt === "%" ? !1 : Le : Hr === "@" || !Hr ? Yt === "%" ? !0 : Le : Hr === "%" ? (z.peek(), Te(Le, "%", !0)) : Hr === "|" ? Yt === "%" || Nt ? !0 : !(Yt === Fa || Yt === Hn) : Hr === Fa ? (z.peek(), Te(!0, Fa, Nt)) : Hr === Hn ? (z.peek(), Te(!0, Hn, Nt)) : !0;
    }, Be = Te();
    return V && z.resetPeek(), Be;
  }
  function mt(z, V) {
    const Te = z.currentChar();
    return Te === Xa ? Xa : V(Te) ? (z.next(), Te) : null;
  }
  function ge(z) {
    return mt(z, (Te) => {
      const Be = Te.charCodeAt(0);
      return Be >= 97 && Be <= 122 || // a-z
      Be >= 65 && Be <= 90 || // A-Z
      Be >= 48 && Be <= 57 || // 0-9
      Be === 95 || // _
      Be === 36;
    });
  }
  function w(z) {
    return mt(z, (Te) => {
      const Be = Te.charCodeAt(0);
      return Be >= 48 && Be <= 57;
    });
  }
  function fe(z) {
    return mt(z, (Te) => {
      const Be = Te.charCodeAt(0);
      return Be >= 48 && Be <= 57 || // 0-9
      Be >= 65 && Be <= 70 || // A-F
      Be >= 97 && Be <= 102;
    });
  }
  function j(z) {
    let V = "", Te = "";
    for (; V = w(z); )
      Te += V;
    return Te;
  }
  function J(z) {
    Y(z);
    const V = z.currentChar();
    return V !== "%" && N(qt.EXPECTED_TOKEN, e(), 0, V), z.next(), "%";
  }
  function de(z) {
    let V = "";
    for (; ; ) {
      const Te = z.currentChar();
      if (Te === "{" || Te === "}" || Te === "@" || Te === "|" || !Te)
        break;
      if (Te === "%")
        if (Je(z))
          V += Te, z.next();
        else
          break;
      else if (Te === Fa || Te === Hn)
        if (Je(z))
          V += Te, z.next();
        else {
          if (Ke(z))
            break;
          V += Te, z.next();
        }
      else
        V += Te, z.next();
    }
    return V;
  }
  function ie(z) {
    Y(z);
    let V = "", Te = "";
    for (; V = ge(z); )
      Te += V;
    return z.currentChar() === Xa && N(qt.UNTERMINATED_CLOSING_BRACE, e(), 0), Te;
  }
  function X(z) {
    Y(z);
    let V = "";
    return z.currentChar() === "-" ? (z.next(), V += `-${j(z)}`) : V += j(z), z.currentChar() === Xa && N(qt.UNTERMINATED_CLOSING_BRACE, e(), 0), V;
  }
  function ue(z) {
    Y(z), L(z, "'");
    let V = "", Te = "";
    const Be = (Yt) => Yt !== tS && Yt !== Hn;
    for (; V = mt(z, Be); )
      V === "\\" ? Te += Oe(z) : Te += V;
    const Le = z.currentChar();
    return Le === Hn || Le === Xa ? (N(qt.UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER, e(), 0), Le === Hn && (z.next(), L(z, "'")), Te) : (L(z, "'"), Te);
  }
  function Oe(z) {
    const V = z.currentChar();
    switch (V) {
      case "\\":
      case "'":
        return z.next(), `\\${V}`;
      case "u":
        return Re(z, V, 4);
      case "U":
        return Re(z, V, 6);
      default:
        return N(qt.UNKNOWN_ESCAPE_SEQUENCE, e(), 0, V), "";
    }
  }
  function Re(z, V, Te) {
    L(z, V);
    let Be = "";
    for (let Le = 0; Le < Te; Le++) {
      const Yt = fe(z);
      if (!Yt) {
        N(qt.INVALID_UNICODE_ESCAPE_SEQUENCE, e(), 0, `\\${V}${Be}${z.currentChar()}`);
        break;
      }
      Be += Yt;
    }
    return `\\${V}${Be}`;
  }
  function ae(z) {
    Y(z);
    let V = "", Te = "";
    const Be = (Le) => Le !== "{" && Le !== "}" && Le !== Fa && Le !== Hn;
    for (; V = mt(z, Be); )
      Te += V;
    return Te;
  }
  function Ee(z) {
    let V = "", Te = "";
    for (; V = ge(z); )
      Te += V;
    return Te;
  }
  function ne(z) {
    const V = (Te = !1, Be) => {
      const Le = z.currentChar();
      return Le === "{" || Le === "%" || Le === "@" || Le === "|" || Le === "(" || Le === ")" || !Le || Le === Fa ? Be : Le === Hn || Le === aw ? (Be += Le, z.next(), V(Te, Be)) : (Be += Le, z.next(), V(!0, Be));
    };
    return V(!1, "");
  }
  function Ge(z) {
    Y(z);
    const V = L(
      z,
      "|"
      /* TokenChars.Pipe */
    );
    return Y(z), V;
  }
  function we(z, V) {
    let Te = null;
    switch (z.currentChar()) {
      case "{":
        return V.braceNest >= 1 && N(qt.NOT_ALLOW_NEST_PLACEHOLDER, e(), 0), z.next(), Te = D(
          V,
          2,
          "{"
          /* TokenChars.BraceLeft */
        ), Y(z), V.braceNest++, Te;
      case "}":
        return V.braceNest > 0 && V.currentType === 2 && N(qt.EMPTY_PLACEHOLDER, e(), 0), z.next(), Te = D(
          V,
          3,
          "}"
          /* TokenChars.BraceRight */
        ), V.braceNest--, V.braceNest > 0 && Y(z), V.inLinked && V.braceNest === 0 && (V.inLinked = !1), Te;
      case "@":
        return V.braceNest > 0 && N(qt.UNTERMINATED_CLOSING_BRACE, e(), 0), Te = st(z, V) || x(V), V.braceNest = 0, Te;
      default:
        let Le = !0, Yt = !0, Nt = !0;
        if (Ke(z))
          return V.braceNest > 0 && N(qt.UNTERMINATED_CLOSING_BRACE, e(), 0), Te = D(V, 1, Ge(z)), V.braceNest = 0, V.inLinked = !1, Te;
        if (V.braceNest > 0 && (V.currentType === 5 || V.currentType === 6 || V.currentType === 7))
          return N(qt.UNTERMINATED_CLOSING_BRACE, e(), 0), V.braceNest = 0, Rt(z, V);
        if (Le = Z(z, V))
          return Te = D(V, 5, ie(z)), Y(z), Te;
        if (Yt = H(z, V))
          return Te = D(V, 6, X(z)), Y(z), Te;
        if (Nt = K(z, V))
          return Te = D(V, 7, ue(z)), Y(z), Te;
        if (!Le && !Yt && !Nt)
          return Te = D(V, 13, ae(z)), N(qt.INVALID_TOKEN_IN_PLACEHOLDER, e(), 0, Te.value), Y(z), Te;
        break;
    }
    return Te;
  }
  function st(z, V) {
    const { currentType: Te } = V;
    let Be = null;
    const Le = z.currentChar();
    switch ((Te === 8 || Te === 9 || Te === 12 || Te === 10) && (Le === Hn || Le === Fa) && N(qt.INVALID_LINKED_FORMAT, e(), 0), Le) {
      case "@":
        return z.next(), Be = D(
          V,
          8,
          "@"
          /* TokenChars.LinkedAlias */
        ), V.inLinked = !0, Be;
      case ".":
        return Y(z), z.next(), D(
          V,
          9,
          "."
          /* TokenChars.LinkedDot */
        );
      case ":":
        return Y(z), z.next(), D(
          V,
          10,
          ":"
          /* TokenChars.LinkedDelimiter */
        );
      default:
        return Ke(z) ? (Be = D(V, 1, Ge(z)), V.braceNest = 0, V.inLinked = !1, Be) : Q(z, V) || se(z, V) ? (Y(z), st(z, V)) : _e(z, V) ? (Y(z), D(V, 12, Ee(z))) : Pe(z, V) ? (Y(z), Le === "{" ? we(z, V) || Be : D(V, 11, ne(z))) : (Te === 8 && N(qt.INVALID_LINKED_FORMAT, e(), 0), V.braceNest = 0, V.inLinked = !1, Rt(z, V));
    }
  }
  function Rt(z, V) {
    let Te = {
      type: 14
      /* TokenTypes.EOF */
    };
    if (V.braceNest > 0)
      return we(z, V) || x(V);
    if (V.inLinked)
      return st(z, V) || x(V);
    switch (z.currentChar()) {
      case "{":
        return we(z, V) || x(V);
      case "}":
        return N(qt.UNBALANCED_CLOSING_BRACE, e(), 0), z.next(), D(
          V,
          3,
          "}"
          /* TokenChars.BraceRight */
        );
      case "@":
        return st(z, V) || x(V);
      default:
        if (Ke(z))
          return Te = D(V, 1, Ge(z)), V.braceNest = 0, V.inLinked = !1, Te;
        const { isModulo: Le, hasSpace: Yt } = ye(z);
        if (Le)
          return Yt ? D(V, 0, de(z)) : D(V, 4, J(z));
        if (Je(z))
          return D(V, 0, de(z));
        break;
    }
    return Te;
  }
  function rt() {
    const { currentType: z, offset: V, startLoc: Te, endLoc: Be } = S;
    return S.lastType = z, S.lastOffset = V, S.lastStartLoc = Te, S.lastEndLoc = Be, S.offset = r(), S.startLoc = e(), c.currentChar() === Xa ? D(
      S,
      14
      /* TokenTypes.EOF */
    ) : Rt(c, S);
  }
  return {
    nextToken: rt,
    currentOffset: r,
    currentPosition: e,
    context: C
  };
}
const sw = "parser", lw = /(?:\\\\|\\'|\\u([0-9a-fA-F]{4})|\\U([0-9a-fA-F]{6}))/g;
function cw(s, i, o) {
  switch (s) {
    case "\\\\":
      return "\\";
    case "\\'":
      return "'";
    default: {
      const c = parseInt(i || o, 16);
      return c <= 55295 || c >= 57344 ? String.fromCodePoint(c) : "�";
    }
  }
}
function dw(s = {}) {
  const i = s.location !== !1, { onError: o } = s;
  function c(k, W, Z, H, ...K) {
    const Q = k.currentPosition();
    if (Q.offset += H, Q.column += H, o) {
      const _e = i ? Jp(Z, Q) : null, se = no(W, _e, {
        domain: sw,
        args: K
      });
      o(se);
    }
  }
  function r(k, W, Z) {
    const H = { type: k };
    return i && (H.start = W, H.end = W, H.loc = { start: Z, end: Z }), H;
  }
  function e(k, W, Z, H) {
    H && (k.type = H), i && (k.end = W, k.loc && (k.loc.end = Z));
  }
  function g(k, W) {
    const Z = k.context(), H = r(3, Z.offset, Z.startLoc);
    return H.value = W, e(H, k.currentOffset(), k.currentPosition()), H;
  }
  function h(k, W) {
    const Z = k.context(), { lastOffset: H, lastStartLoc: K } = Z, Q = r(5, H, K);
    return Q.index = parseInt(W, 10), k.nextToken(), e(Q, k.currentOffset(), k.currentPosition()), Q;
  }
  function S(k, W) {
    const Z = k.context(), { lastOffset: H, lastStartLoc: K } = Z, Q = r(4, H, K);
    return Q.key = W, k.nextToken(), e(Q, k.currentOffset(), k.currentPosition()), Q;
  }
  function C(k, W) {
    const Z = k.context(), { lastOffset: H, lastStartLoc: K } = Z, Q = r(9, H, K);
    return Q.value = W.replace(lw, cw), k.nextToken(), e(Q, k.currentOffset(), k.currentPosition()), Q;
  }
  function O(k) {
    const W = k.nextToken(), Z = k.context(), { lastOffset: H, lastStartLoc: K } = Z, Q = r(8, H, K);
    return W.type !== 12 ? (c(k, qt.UNEXPECTED_EMPTY_LINKED_MODIFIER, Z.lastStartLoc, 0), Q.value = "", e(Q, H, K), {
      nextConsumeToken: W,
      node: Q
    }) : (W.value == null && c(k, qt.UNEXPECTED_LEXICAL_ANALYSIS, Z.lastStartLoc, 0, va(W)), Q.value = W.value || "", e(Q, k.currentOffset(), k.currentPosition()), {
      node: Q
    });
  }
  function N(k, W) {
    const Z = k.context(), H = r(7, Z.offset, Z.startLoc);
    return H.value = W, e(H, k.currentOffset(), k.currentPosition()), H;
  }
  function D(k) {
    const W = k.context(), Z = r(6, W.offset, W.startLoc);
    let H = k.nextToken();
    if (H.type === 9) {
      const K = O(k);
      Z.modifier = K.node, H = K.nextConsumeToken || k.nextToken();
    }
    switch (H.type !== 10 && c(k, qt.UNEXPECTED_LEXICAL_ANALYSIS, W.lastStartLoc, 0, va(H)), H = k.nextToken(), H.type === 2 && (H = k.nextToken()), H.type) {
      case 11:
        H.value == null && c(k, qt.UNEXPECTED_LEXICAL_ANALYSIS, W.lastStartLoc, 0, va(H)), Z.key = N(k, H.value || "");
        break;
      case 5:
        H.value == null && c(k, qt.UNEXPECTED_LEXICAL_ANALYSIS, W.lastStartLoc, 0, va(H)), Z.key = S(k, H.value || "");
        break;
      case 6:
        H.value == null && c(k, qt.UNEXPECTED_LEXICAL_ANALYSIS, W.lastStartLoc, 0, va(H)), Z.key = h(k, H.value || "");
        break;
      case 7:
        H.value == null && c(k, qt.UNEXPECTED_LEXICAL_ANALYSIS, W.lastStartLoc, 0, va(H)), Z.key = C(k, H.value || "");
        break;
      default:
        c(k, qt.UNEXPECTED_EMPTY_LINKED_KEY, W.lastStartLoc, 0);
        const K = k.context(), Q = r(7, K.offset, K.startLoc);
        return Q.value = "", e(Q, K.offset, K.startLoc), Z.key = Q, e(Z, K.offset, K.startLoc), {
          nextConsumeToken: H,
          node: Z
        };
    }
    return e(Z, k.currentOffset(), k.currentPosition()), {
      node: Z
    };
  }
  function x(k) {
    const W = k.context(), Z = W.currentType === 1 ? k.currentOffset() : W.offset, H = W.currentType === 1 ? W.endLoc : W.startLoc, K = r(2, Z, H);
    K.items = [];
    let Q = null;
    do {
      const Pe = Q || k.nextToken();
      switch (Q = null, Pe.type) {
        case 0:
          Pe.value == null && c(k, qt.UNEXPECTED_LEXICAL_ANALYSIS, W.lastStartLoc, 0, va(Pe)), K.items.push(g(k, Pe.value || ""));
          break;
        case 6:
          Pe.value == null && c(k, qt.UNEXPECTED_LEXICAL_ANALYSIS, W.lastStartLoc, 0, va(Pe)), K.items.push(h(k, Pe.value || ""));
          break;
        case 5:
          Pe.value == null && c(k, qt.UNEXPECTED_LEXICAL_ANALYSIS, W.lastStartLoc, 0, va(Pe)), K.items.push(S(k, Pe.value || ""));
          break;
        case 7:
          Pe.value == null && c(k, qt.UNEXPECTED_LEXICAL_ANALYSIS, W.lastStartLoc, 0, va(Pe)), K.items.push(C(k, Pe.value || ""));
          break;
        case 8:
          const Ke = D(k);
          K.items.push(Ke.node), Q = Ke.nextConsumeToken || null;
          break;
      }
    } while (W.currentType !== 14 && W.currentType !== 1);
    const _e = W.currentType === 1 ? W.lastOffset : k.currentOffset(), se = W.currentType === 1 ? W.lastEndLoc : k.currentPosition();
    return e(K, _e, se), K;
  }
  function L(k, W, Z, H) {
    const K = k.context();
    let Q = H.items.length === 0;
    const _e = r(1, W, Z);
    _e.cases = [], _e.cases.push(H);
    do {
      const se = x(k);
      Q || (Q = se.items.length === 0), _e.cases.push(se);
    } while (K.currentType !== 14);
    return Q && c(k, qt.MUST_HAVE_MESSAGES_IN_PLURAL, Z, 0), e(_e, k.currentOffset(), k.currentPosition()), _e;
  }
  function G(k) {
    const W = k.context(), { offset: Z, startLoc: H } = W, K = x(k);
    return W.currentType === 14 ? K : L(k, Z, H, K);
  }
  function Y(k) {
    const W = ow(k, dv({}, s)), Z = W.context(), H = r(0, Z.offset, Z.startLoc);
    return i && H.loc && (H.loc.source = k), H.body = G(W), s.onCacheKey && (H.cacheKey = s.onCacheKey(k)), Z.currentType !== 14 && c(W, qt.UNEXPECTED_LEXICAL_ANALYSIS, Z.lastStartLoc, 0, k[Z.offset] || ""), e(H, W.currentOffset(), W.currentPosition()), H;
  }
  return { parse: Y };
}
function va(s) {
  if (s.type === 14)
    return "EOF";
  const i = (s.value || "").replace(/\r?\n/gu, "\\n");
  return i.length > 10 ? i.slice(0, 9) + "…" : i;
}
function uw(s, i = {}) {
  const o = {
    ast: s,
    helpers: /* @__PURE__ */ new Set()
  };
  return { context: () => o, helper: (e) => (o.helpers.add(e), e) };
}
function rS(s, i) {
  for (let o = 0; o < s.length; o++)
    ym(s[o], i);
}
function ym(s, i) {
  switch (s.type) {
    case 1:
      rS(s.cases, i), i.helper(
        "plural"
        /* HelperNameMap.PLURAL */
      );
      break;
    case 2:
      rS(s.items, i);
      break;
    case 6:
      ym(s.key, i), i.helper(
        "linked"
        /* HelperNameMap.LINKED */
      ), i.helper(
        "type"
        /* HelperNameMap.TYPE */
      );
      break;
    case 5:
      i.helper(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      ), i.helper(
        "list"
        /* HelperNameMap.LIST */
      );
      break;
    case 4:
      i.helper(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      ), i.helper(
        "named"
        /* HelperNameMap.NAMED */
      );
      break;
  }
}
function _w(s, i = {}) {
  const o = uw(s);
  o.helper(
    "normalize"
    /* HelperNameMap.NORMALIZE */
  ), s.body && ym(s.body, o);
  const c = o.context();
  s.helpers = Array.from(c.helpers);
}
function pw(s) {
  const i = s.body;
  return i.type === 2 ? nS(i) : i.cases.forEach((o) => nS(o)), s;
}
function nS(s) {
  if (s.items.length === 1) {
    const i = s.items[0];
    (i.type === 3 || i.type === 9) && (s.static = i.value, delete i.value);
  } else {
    const i = [];
    for (let o = 0; o < s.items.length; o++) {
      const c = s.items[o];
      if (!(c.type === 3 || c.type === 9) || c.value == null)
        break;
      i.push(c.value);
    }
    if (i.length === s.items.length) {
      s.static = uv(i);
      for (let o = 0; o < s.items.length; o++) {
        const c = s.items[o];
        (c.type === 3 || c.type === 9) && delete c.value;
      }
    }
  }
}
const mw = "minifier";
function Xi(s) {
  switch (s.t = s.type, s.type) {
    case 0:
      const i = s;
      Xi(i.body), i.b = i.body, delete i.body;
      break;
    case 1:
      const o = s, c = o.cases;
      for (let O = 0; O < c.length; O++)
        Xi(c[O]);
      o.c = c, delete o.cases;
      break;
    case 2:
      const r = s, e = r.items;
      for (let O = 0; O < e.length; O++)
        Xi(e[O]);
      r.i = e, delete r.items, r.static && (r.s = r.static, delete r.static);
      break;
    case 3:
    case 9:
    case 8:
    case 7:
      const g = s;
      g.value && (g.v = g.value, delete g.value);
      break;
    case 6:
      const h = s;
      Xi(h.key), h.k = h.key, delete h.key, h.modifier && (Xi(h.modifier), h.m = h.modifier, delete h.modifier);
      break;
    case 5:
      const S = s;
      S.i = S.index, delete S.index;
      break;
    case 4:
      const C = s;
      C.k = C.key, delete C.key;
      break;
    default:
      throw no(qt.UNHANDLED_MINIFIER_NODE_TYPE, null, {
        domain: mw,
        args: [s.type]
      });
  }
  delete s.type;
}
const fw = "parser";
function gw(s, i) {
  const { sourceMap: o, filename: c, breakLineCode: r, needIndent: e } = i, g = i.location !== !1, h = {
    filename: c,
    code: "",
    column: 1,
    line: 1,
    offset: 0,
    map: void 0,
    breakLineCode: r,
    needIndent: e,
    indentLevel: 0
  };
  g && s.loc && (h.source = s.loc.source);
  const S = () => h;
  function C(Y, k) {
    h.code += Y;
  }
  function O(Y, k = !0) {
    const W = k ? r : "";
    C(e ? W + "  ".repeat(Y) : W);
  }
  function N(Y = !0) {
    const k = ++h.indentLevel;
    Y && O(k);
  }
  function D(Y = !0) {
    const k = --h.indentLevel;
    Y && O(k);
  }
  function x() {
    O(h.indentLevel);
  }
  return {
    context: S,
    push: C,
    indent: N,
    deindent: D,
    newline: x,
    helper: (Y) => `_${Y}`,
    needIndent: () => h.needIndent
  };
}
function Ew(s, i) {
  const { helper: o } = s;
  s.push(`${o(
    "linked"
    /* HelperNameMap.LINKED */
  )}(`), Ji(s, i.key), i.modifier ? (s.push(", "), Ji(s, i.modifier), s.push(", _type")) : s.push(", undefined, _type"), s.push(")");
}
function hw(s, i) {
  const { helper: o, needIndent: c } = s;
  s.push(`${o(
    "normalize"
    /* HelperNameMap.NORMALIZE */
  )}([`), s.indent(c());
  const r = i.items.length;
  for (let e = 0; e < r && (Ji(s, i.items[e]), e !== r - 1); e++)
    s.push(", ");
  s.deindent(c()), s.push("])");
}
function Sw(s, i) {
  const { helper: o, needIndent: c } = s;
  if (i.cases.length > 1) {
    s.push(`${o(
      "plural"
      /* HelperNameMap.PLURAL */
    )}([`), s.indent(c());
    const r = i.cases.length;
    for (let e = 0; e < r && (Ji(s, i.cases[e]), e !== r - 1); e++)
      s.push(", ");
    s.deindent(c()), s.push("])");
  }
}
function bw(s, i) {
  i.body ? Ji(s, i.body) : s.push("null");
}
function Ji(s, i) {
  const { helper: o } = s;
  switch (i.type) {
    case 0:
      bw(s, i);
      break;
    case 1:
      Sw(s, i);
      break;
    case 2:
      hw(s, i);
      break;
    case 6:
      Ew(s, i);
      break;
    case 8:
      s.push(JSON.stringify(i.value), i);
      break;
    case 7:
      s.push(JSON.stringify(i.value), i);
      break;
    case 5:
      s.push(`${o(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      )}(${o(
        "list"
        /* HelperNameMap.LIST */
      )}(${i.index}))`, i);
      break;
    case 4:
      s.push(`${o(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      )}(${o(
        "named"
        /* HelperNameMap.NAMED */
      )}(${JSON.stringify(i.key)}))`, i);
      break;
    case 9:
      s.push(JSON.stringify(i.value), i);
      break;
    case 3:
      s.push(JSON.stringify(i.value), i);
      break;
    default:
      throw no(qt.UNHANDLED_CODEGEN_NODE_TYPE, null, {
        domain: fw,
        args: [i.type]
      });
  }
}
const Tw = (s, i = {}) => {
  const o = eS(i.mode) ? i.mode : "normal", c = eS(i.filename) ? i.filename : "message.intl", r = !!i.sourceMap, e = i.breakLineCode != null ? i.breakLineCode : o === "arrow" ? ";" : `
`, g = i.needIndent ? i.needIndent : o !== "arrow", h = s.helpers || [], S = gw(s, {
    mode: o,
    filename: c,
    sourceMap: r,
    breakLineCode: e,
    needIndent: g
  });
  S.push(o === "normal" ? "function __msg__ (ctx) {" : "(ctx) => {"), S.indent(g), h.length > 0 && (S.push(`const { ${uv(h.map((N) => `${N}: _${N}`), ", ")} } = ctx`), S.newline()), S.push("return "), Ji(S, s), S.deindent(g), S.push("}"), delete s.helpers;
  const { code: C, map: O } = S.context();
  return {
    ast: s,
    code: C,
    map: O ? O.toJSON() : void 0
    // eslint-disable-line @typescript-eslint/no-explicit-any
  };
};
function vw(s, i = {}) {
  const o = dv({}, i), c = !!o.jit, r = !!o.minify, e = o.optimize == null ? !0 : o.optimize, h = dw(o).parse(s);
  return c ? (e && pw(h), r && Xi(h), { ast: h, code: "" }) : (_w(h, o), Tw(h, o));
}
/*!
  * core-base v9.9.1
  * (c) 2024 kazuya kawaguchi
  * Released under the MIT License.
  */
function Cw() {
  typeof __INTLIFY_PROD_DEVTOOLS__ != "boolean" && (Ua().__INTLIFY_PROD_DEVTOOLS__ = !1), typeof __INTLIFY_JIT_COMPILATION__ != "boolean" && (Ua().__INTLIFY_JIT_COMPILATION__ = !1), typeof __INTLIFY_DROP_MESSAGE_COMPILER__ != "boolean" && (Ua().__INTLIFY_DROP_MESSAGE_COMPILER__ = !1);
}
const ti = [];
ti[
  0
  /* States.BEFORE_PATH */
] = {
  w: [
    0
    /* States.BEFORE_PATH */
  ],
  i: [
    3,
    0
    /* Actions.APPEND */
  ],
  "[": [
    4
    /* States.IN_SUB_PATH */
  ],
  o: [
    7
    /* States.AFTER_PATH */
  ]
};
ti[
  1
  /* States.IN_PATH */
] = {
  w: [
    1
    /* States.IN_PATH */
  ],
  ".": [
    2
    /* States.BEFORE_IDENT */
  ],
  "[": [
    4
    /* States.IN_SUB_PATH */
  ],
  o: [
    7
    /* States.AFTER_PATH */
  ]
};
ti[
  2
  /* States.BEFORE_IDENT */
] = {
  w: [
    2
    /* States.BEFORE_IDENT */
  ],
  i: [
    3,
    0
    /* Actions.APPEND */
  ],
  0: [
    3,
    0
    /* Actions.APPEND */
  ]
};
ti[
  3
  /* States.IN_IDENT */
] = {
  i: [
    3,
    0
    /* Actions.APPEND */
  ],
  0: [
    3,
    0
    /* Actions.APPEND */
  ],
  w: [
    1,
    1
    /* Actions.PUSH */
  ],
  ".": [
    2,
    1
    /* Actions.PUSH */
  ],
  "[": [
    4,
    1
    /* Actions.PUSH */
  ],
  o: [
    7,
    1
    /* Actions.PUSH */
  ]
};
ti[
  4
  /* States.IN_SUB_PATH */
] = {
  "'": [
    5,
    0
    /* Actions.APPEND */
  ],
  '"': [
    6,
    0
    /* Actions.APPEND */
  ],
  "[": [
    4,
    2
    /* Actions.INC_SUB_PATH_DEPTH */
  ],
  "]": [
    1,
    3
    /* Actions.PUSH_SUB_PATH */
  ],
  o: 8,
  l: [
    4,
    0
    /* Actions.APPEND */
  ]
};
ti[
  5
  /* States.IN_SINGLE_QUOTE */
] = {
  "'": [
    4,
    0
    /* Actions.APPEND */
  ],
  o: 8,
  l: [
    5,
    0
    /* Actions.APPEND */
  ]
};
ti[
  6
  /* States.IN_DOUBLE_QUOTE */
] = {
  '"': [
    4,
    0
    /* Actions.APPEND */
  ],
  o: 8,
  l: [
    6,
    0
    /* Actions.APPEND */
  ]
};
const Rw = /^\s?(?:true|false|-?[\d.]+|'[^']*'|"[^"]*")\s?$/;
function Nw(s) {
  return Rw.test(s);
}
function Aw(s) {
  const i = s.charCodeAt(0), o = s.charCodeAt(s.length - 1);
  return i === o && (i === 34 || i === 39) ? s.slice(1, -1) : s;
}
function Ow(s) {
  if (s == null)
    return "o";
  switch (s.charCodeAt(0)) {
    case 91:
    case 93:
    case 46:
    case 34:
    case 39:
      return s;
    case 95:
    case 36:
    case 45:
      return "i";
    case 9:
    case 10:
    case 13:
    case 160:
    case 65279:
    case 8232:
    case 8233:
      return "w";
  }
  return "i";
}
function yw(s) {
  const i = s.trim();
  return s.charAt(0) === "0" && isNaN(parseInt(s)) ? !1 : Nw(i) ? Aw(i) : "*" + i;
}
function Iw(s) {
  const i = [];
  let o = -1, c = 0, r = 0, e, g, h, S, C, O, N;
  const D = [];
  D[
    0
    /* Actions.APPEND */
  ] = () => {
    g === void 0 ? g = h : g += h;
  }, D[
    1
    /* Actions.PUSH */
  ] = () => {
    g !== void 0 && (i.push(g), g = void 0);
  }, D[
    2
    /* Actions.INC_SUB_PATH_DEPTH */
  ] = () => {
    D[
      0
      /* Actions.APPEND */
    ](), r++;
  }, D[
    3
    /* Actions.PUSH_SUB_PATH */
  ] = () => {
    if (r > 0)
      r--, c = 4, D[
        0
        /* Actions.APPEND */
      ]();
    else {
      if (r = 0, g === void 0 || (g = yw(g), g === !1))
        return !1;
      D[
        1
        /* Actions.PUSH */
      ]();
    }
  };
  function x() {
    const L = s[o + 1];
    if (c === 5 && L === "'" || c === 6 && L === '"')
      return o++, h = "\\" + L, D[
        0
        /* Actions.APPEND */
      ](), !0;
  }
  for (; c !== null; )
    if (o++, e = s[o], !(e === "\\" && x())) {
      if (S = Ow(e), N = ti[c], C = N[S] || N.l || 8, C === 8 || (c = C[0], C[1] !== void 0 && (O = D[C[1]], O && (h = e, O() === !1))))
        return;
      if (c === 7)
        return i;
    }
}
const aS = /* @__PURE__ */ new Map();
function Dw(s, i) {
  return Tr(s) ? s[i] : null;
}
function ww(s, i) {
  if (!Tr(s))
    return null;
  let o = aS.get(i);
  if (o || (o = Iw(i), o && aS.set(i, o)), !o)
    return null;
  const c = o.length;
  let r = s, e = 0;
  for (; e < c; ) {
    const g = r[o[e]];
    if (g === void 0 || Mr(r))
      return null;
    r = g, e++;
  }
  return r;
}
const xw = (s) => s, Lw = (s) => "", Mw = "text", Pw = (s) => s.length === 0 ? "" : H2(s), kw = Y2;
function iS(s, i) {
  return s = Math.abs(s), i === 2 ? s ? s > 1 ? 1 : 0 : 1 : s ? Math.min(s, 2) : 0;
}
function Fw(s) {
  const i = mn(s.pluralIndex) ? s.pluralIndex : -1;
  return s.named && (mn(s.named.count) || mn(s.named.n)) ? mn(s.named.count) ? s.named.count : mn(s.named.n) ? s.named.n : i : i;
}
function Uw(s, i) {
  i.count || (i.count = s), i.n || (i.n = s);
}
function Bw(s = {}) {
  const i = s.locale, o = Fw(s), c = Tr(s.pluralRules) && dt(i) && Mr(s.pluralRules[i]) ? s.pluralRules[i] : iS, r = Tr(s.pluralRules) && dt(i) && Mr(s.pluralRules[i]) ? iS : void 0, e = (k) => k[c(o, k.length, r)], g = s.list || [], h = (k) => g[k], S = s.named || {};
  mn(s.pluralIndex) && Uw(o, S);
  const C = (k) => S[k];
  function O(k) {
    const W = Mr(s.messages) ? s.messages(k) : Tr(s.messages) ? s.messages[k] : !1;
    return W || (s.parent ? s.parent.message(k) : Lw);
  }
  const N = (k) => s.modifiers ? s.modifiers[k] : xw, D = zt(s.processor) && Mr(s.processor.normalize) ? s.processor.normalize : Pw, x = zt(s.processor) && Mr(s.processor.interpolate) ? s.processor.interpolate : kw, L = zt(s.processor) && dt(s.processor.type) ? s.processor.type : Mw, Y = {
    list: h,
    named: C,
    plural: e,
    linked: (k, ...W) => {
      const [Z, H] = W;
      let K = "text", Q = "";
      W.length === 1 ? Tr(Z) ? (Q = Z.modifier || Q, K = Z.type || K) : dt(Z) && (Q = Z || Q) : W.length === 2 && (dt(Z) && (Q = Z || Q), dt(H) && (K = H || K));
      const _e = O(k)(Y), se = (
        // The message in vnode resolved with linked are returned as an array by processor.nomalize
        K === "vnode" && Gr(_e) && Q ? _e[0] : _e
      );
      return Q ? N(Q)(se, K) : se;
    },
    message: O,
    type: L,
    interpolate: x,
    normalize: D,
    values: yn({}, g, S)
  };
  return Y;
}
let Qo = null;
function Gw(s) {
  Qo = s;
}
function Vw(s, i, o) {
  Qo && Qo.emit("i18n:init", {
    timestamp: Date.now(),
    i18n: s,
    version: i,
    meta: o
  });
}
const Yw = /* @__PURE__ */ Hw(
  "function:translate"
  /* IntlifyDevToolsHooks.FunctionTranslate */
);
function Hw(s) {
  return (i) => Qo && Qo.emit(s, i);
}
const qn = {
  NOT_FOUND_KEY: 1,
  FALLBACK_TO_TRANSLATE: 2,
  CANNOT_FORMAT_NUMBER: 3,
  FALLBACK_TO_NUMBER_FORMAT: 4,
  CANNOT_FORMAT_DATE: 5,
  FALLBACK_TO_DATE_FORMAT: 6,
  EXPERIMENTAL_CUSTOM_MESSAGE_COMPILER: 7,
  __EXTEND_POINT__: 8
}, qw = {
  [qn.NOT_FOUND_KEY]: "Not found '{key}' key in '{locale}' locale messages.",
  [qn.FALLBACK_TO_TRANSLATE]: "Fall back to translate '{key}' key with '{target}' locale.",
  [qn.CANNOT_FORMAT_NUMBER]: "Cannot format a number value due to not supported Intl.NumberFormat.",
  [qn.FALLBACK_TO_NUMBER_FORMAT]: "Fall back to number format '{key}' key with '{target}' locale.",
  [qn.CANNOT_FORMAT_DATE]: "Cannot format a date value due to not supported Intl.DateTimeFormat.",
  [qn.FALLBACK_TO_DATE_FORMAT]: "Fall back to datetime format '{key}' key with '{target}' locale.",
  [qn.EXPERIMENTAL_CUSTOM_MESSAGE_COMPILER]: "This project is using Custom Message Compiler, which is an experimental feature. It may receive breaking changes or be removed in the future."
};
function Ai(s, ...i) {
  return Nm(qw[s], ...i);
}
const _v = qt.__EXTEND_POINT__, Ti = Am(_v), Tn = {
  INVALID_ARGUMENT: _v,
  INVALID_DATE_ARGUMENT: Ti(),
  INVALID_ISO_DATE_ARGUMENT: Ti(),
  NOT_SUPPORT_NON_STRING_MESSAGE: Ti(),
  NOT_SUPPORT_LOCALE_PROMISE_VALUE: Ti(),
  NOT_SUPPORT_LOCALE_ASYNC_FUNCTION: Ti(),
  NOT_SUPPORT_LOCALE_TYPE: Ti(),
  __EXTEND_POINT__: Ti()
  // 25
};
function Ra(s) {
  return no(s, null, process.env.NODE_ENV !== "production" ? { messages: $w } : void 0);
}
const $w = {
  [Tn.INVALID_ARGUMENT]: "Invalid arguments",
  [Tn.INVALID_DATE_ARGUMENT]: "The date provided is an invalid Date object.Make sure your Date represents a valid date.",
  [Tn.INVALID_ISO_DATE_ARGUMENT]: "The argument provided is not a valid ISO date string",
  [Tn.NOT_SUPPORT_NON_STRING_MESSAGE]: "Not support non-string message",
  [Tn.NOT_SUPPORT_LOCALE_PROMISE_VALUE]: "cannot support promise value",
  [Tn.NOT_SUPPORT_LOCALE_ASYNC_FUNCTION]: "cannot support async function",
  [Tn.NOT_SUPPORT_LOCALE_TYPE]: "cannot support locale type"
};
function Im(s, i) {
  return i.locale != null ? oS(i.locale) : oS(s.locale);
}
let sd;
function oS(s) {
  if (dt(s))
    return s;
  if (Mr(s)) {
    if (s.resolvedOnce && sd != null)
      return sd;
    if (s.constructor.name === "Function") {
      const i = s();
      if (V2(i))
        throw Ra(Tn.NOT_SUPPORT_LOCALE_PROMISE_VALUE);
      return sd = i;
    } else
      throw Ra(Tn.NOT_SUPPORT_LOCALE_ASYNC_FUNCTION);
  } else
    throw Ra(Tn.NOT_SUPPORT_LOCALE_TYPE);
}
function Ww(s, i, o) {
  return [.../* @__PURE__ */ new Set([
    o,
    ...Gr(i) ? i : Tr(i) ? Object.keys(i) : dt(i) ? [i] : [o]
  ])];
}
function pv(s, i, o) {
  const c = dt(o) ? o : eo, r = s;
  r.__localeChainCache || (r.__localeChainCache = /* @__PURE__ */ new Map());
  let e = r.__localeChainCache.get(c);
  if (!e) {
    e = [];
    let g = [o];
    for (; Gr(g); )
      g = sS(e, g, i);
    const h = Gr(i) || !zt(i) ? i : i.default ? i.default : null;
    g = dt(h) ? [h] : h, Gr(g) && sS(e, g, !1), r.__localeChainCache.set(c, e);
  }
  return e;
}
function sS(s, i, o) {
  let c = !0;
  for (let r = 0; r < i.length && ar(c); r++) {
    const e = i[r];
    dt(e) && (c = zw(s, i[r], o));
  }
  return c;
}
function zw(s, i, o) {
  let c;
  const r = i.split("-");
  do {
    const e = r.join("-");
    c = Kw(s, e, o), r.splice(-1, 1);
  } while (r.length && c === !0);
  return c;
}
function Kw(s, i, o) {
  let c = !1;
  if (!s.includes(i) && (c = !0, i)) {
    c = i[i.length - 1] !== "!";
    const r = i.replace(/!/g, "");
    s.push(r), (Gr(o) || zt(o)) && o[r] && (c = o[r]);
  }
  return c;
}
const Qw = "9.9.1", Tl = -1, eo = "en-US", cl = "", lS = (s) => `${s.charAt(0).toLocaleUpperCase()}${s.substr(1)}`;
function Xw() {
  return {
    upper: (s, i) => i === "text" && dt(s) ? s.toUpperCase() : i === "vnode" && Tr(s) && "__v_isVNode" in s ? s.children.toUpperCase() : s,
    lower: (s, i) => i === "text" && dt(s) ? s.toLowerCase() : i === "vnode" && Tr(s) && "__v_isVNode" in s ? s.children.toLowerCase() : s,
    capitalize: (s, i) => i === "text" && dt(s) ? lS(s) : i === "vnode" && Tr(s) && "__v_isVNode" in s ? lS(s.children) : s
  };
}
let mv;
function cS(s) {
  mv = s;
}
let fv;
function Zw(s) {
  fv = s;
}
let gv;
function jw(s) {
  gv = s;
}
let Ev = null;
const Jw = /* @__NO_SIDE_EFFECTS__ */ (s) => {
  Ev = s;
}, ex = /* @__NO_SIDE_EFFECTS__ */ () => Ev;
let hv = null;
const dS = (s) => {
  hv = s;
}, tx = () => hv;
let uS = 0;
function rx(s = {}) {
  const i = Mr(s.onWarn) ? s.onWarn : vn, o = dt(s.version) ? s.version : Qw, c = dt(s.locale) || Mr(s.locale) ? s.locale : eo, r = Mr(c) ? eo : c, e = Gr(s.fallbackLocale) || zt(s.fallbackLocale) || dt(s.fallbackLocale) || s.fallbackLocale === !1 ? s.fallbackLocale : r, g = zt(s.messages) ? s.messages : { [r]: {} }, h = zt(s.datetimeFormats) ? s.datetimeFormats : { [r]: {} }, S = zt(s.numberFormats) ? s.numberFormats : { [r]: {} }, C = yn({}, s.modifiers || {}, Xw()), O = s.pluralRules || {}, N = Mr(s.missing) ? s.missing : null, D = ar(s.missingWarn) || Ja(s.missingWarn) ? s.missingWarn : !0, x = ar(s.fallbackWarn) || Ja(s.fallbackWarn) ? s.fallbackWarn : !0, L = !!s.fallbackFormat, G = !!s.unresolving, Y = Mr(s.postTranslation) ? s.postTranslation : null, k = zt(s.processor) ? s.processor : null, W = ar(s.warnHtmlMessage) ? s.warnHtmlMessage : !0, Z = !!s.escapeParameter, H = Mr(s.messageCompiler) ? s.messageCompiler : mv;
  process.env.NODE_ENV !== "production" && Mr(s.messageCompiler) && $2(Ai(qn.EXPERIMENTAL_CUSTOM_MESSAGE_COMPILER));
  const K = Mr(s.messageResolver) ? s.messageResolver : fv || Dw, Q = Mr(s.localeFallbacker) ? s.localeFallbacker : gv || Ww, _e = Tr(s.fallbackContext) ? s.fallbackContext : void 0, se = s, Pe = Tr(se.__datetimeFormatters) ? se.__datetimeFormatters : /* @__PURE__ */ new Map(), Ke = Tr(se.__numberFormatters) ? se.__numberFormatters : /* @__PURE__ */ new Map(), ye = Tr(se.__meta) ? se.__meta : {};
  uS++;
  const Je = {
    version: o,
    cid: uS,
    locale: c,
    fallbackLocale: e,
    messages: g,
    modifiers: C,
    pluralRules: O,
    missing: N,
    missingWarn: D,
    fallbackWarn: x,
    fallbackFormat: L,
    unresolving: G,
    postTranslation: Y,
    processor: k,
    warnHtmlMessage: W,
    escapeParameter: Z,
    messageCompiler: H,
    messageResolver: K,
    localeFallbacker: Q,
    fallbackContext: _e,
    onWarn: i,
    __meta: ye
  };
  return Je.datetimeFormats = h, Je.numberFormats = S, Je.__datetimeFormatters = Pe, Je.__numberFormatters = Ke, process.env.NODE_ENV !== "production" && (Je.__v_emitter = se.__v_emitter != null ? se.__v_emitter : void 0), (process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__) && Vw(Je, o, ye), Je;
}
function vl(s, i) {
  return s instanceof RegExp ? s.test(i) : s;
}
function Sv(s, i) {
  return s instanceof RegExp ? s.test(i) : s;
}
function Dm(s, i, o, c, r) {
  const { missing: e, onWarn: g } = s;
  if (process.env.NODE_ENV !== "production") {
    const h = s.__v_emitter;
    h && h.emit("missing", {
      locale: o,
      key: i,
      type: r,
      groupId: `${r}:${i}`
    });
  }
  if (e !== null) {
    const h = e(s, o, i, r);
    return dt(h) ? h : i;
  } else
    return process.env.NODE_ENV !== "production" && Sv(c, i) && g(Ai(qn.NOT_FOUND_KEY, { key: i, locale: o })), i;
}
function qo(s, i, o) {
  const c = s;
  c.__localeChainCache = /* @__PURE__ */ new Map(), s.localeFallbacker(s, o, i);
}
function ld(s) {
  return (o) => nx(o, s);
}
function nx(s, i) {
  const o = i.b || i.body;
  if ((o.t || o.type) === 1) {
    const c = o, r = c.c || c.cases;
    return s.plural(r.reduce((e, g) => [
      ...e,
      _S(s, g)
    ], []));
  } else
    return _S(s, o);
}
function _S(s, i) {
  const o = i.s || i.static;
  if (o)
    return s.type === "text" ? o : s.normalize([o]);
  {
    const c = (i.i || i.items).reduce((r, e) => [...r, em(s, e)], []);
    return s.normalize(c);
  }
}
function em(s, i) {
  const o = i.t || i.type;
  switch (o) {
    case 3:
      const c = i;
      return c.v || c.value;
    case 9:
      const r = i;
      return r.v || r.value;
    case 4:
      const e = i;
      return s.interpolate(s.named(e.k || e.key));
    case 5:
      const g = i;
      return s.interpolate(s.list(g.i != null ? g.i : g.index));
    case 6:
      const h = i, S = h.m || h.modifier;
      return s.linked(em(s, h.k || h.key), S ? em(s, S) : void 0, s.type);
    case 7:
      const C = i;
      return C.v || C.value;
    case 8:
      const O = i;
      return O.v || O.value;
    default:
      throw new Error(`unhandled node type on format message part: ${o}`);
  }
}
const ax = "Detected HTML in '{source}' message. Recommend not using HTML messages to avoid XSS.";
function bv(s, i) {
  i && J2(s) && vn(Nm(ax, { source: s }));
}
const Tv = (s) => s;
let Zi = /* @__PURE__ */ Object.create(null);
const ei = (s) => Tr(s) && (s.t === 0 || s.type === 0) && ("b" in s || "body" in s);
function vv(s, i = {}) {
  let o = !1;
  const c = i.onError || Z2;
  return i.onError = (r) => {
    o = !0, c(r);
  }, { ...vw(s, i), detectError: o };
}
const ix = /* @__NO_SIDE_EFFECTS__ */ (s, i) => {
  if (!dt(s))
    throw Ra(Tn.NOT_SUPPORT_NON_STRING_MESSAGE);
  {
    const o = ar(i.warnHtmlMessage) ? i.warnHtmlMessage : !0;
    process.env.NODE_ENV !== "production" && bv(s, o);
    const r = (i.onCacheKey || Tv)(s), e = Zi[r];
    if (e)
      return e;
    const { code: g, detectError: h } = vv(s, i), S = new Function(`return ${g}`)();
    return h ? S : Zi[r] = S;
  }
};
function ox(s, i) {
  if (__INTLIFY_JIT_COMPILATION__ && !__INTLIFY_DROP_MESSAGE_COMPILER__ && dt(s)) {
    const o = ar(i.warnHtmlMessage) ? i.warnHtmlMessage : !0;
    process.env.NODE_ENV !== "production" && bv(s, o);
    const r = (i.onCacheKey || Tv)(s), e = Zi[r];
    if (e)
      return e;
    const { ast: g, detectError: h } = vv(s, {
      ...i,
      location: process.env.NODE_ENV !== "production",
      jit: !0
    }), S = ld(g);
    return h ? S : Zi[r] = S;
  } else {
    if (process.env.NODE_ENV !== "production" && !ei(s))
      return vn(`the message that is resolve with key '${i.key}' is not supported for jit compilation`), () => s;
    const o = s.cacheKey;
    if (o) {
      const c = Zi[o];
      return c || (Zi[o] = ld(s));
    } else
      return ld(s);
  }
}
const pS = () => "", ua = (s) => Mr(s);
function mS(s, ...i) {
  const { fallbackFormat: o, postTranslation: c, unresolving: r, messageCompiler: e, fallbackLocale: g, messages: h } = s, [S, C] = tm(...i), O = ar(C.missingWarn) ? C.missingWarn : s.missingWarn, N = ar(C.fallbackWarn) ? C.fallbackWarn : s.fallbackWarn, D = ar(C.escapeParameter) ? C.escapeParameter : s.escapeParameter, x = !!C.resolvedMessage, L = dt(C.default) || ar(C.default) ? ar(C.default) ? e ? S : () => S : C.default : o ? e ? S : () => S : "", G = o || L !== "", Y = Im(s, C);
  D && sx(C);
  let [k, W, Z] = x ? [
    S,
    Y,
    h[Y] || {}
  ] : Cv(s, S, Y, g, N, O), H = k, K = S;
  if (!x && !(dt(H) || ei(H) || ua(H)) && G && (H = L, K = H), !x && (!(dt(H) || ei(H) || ua(H)) || !dt(W)))
    return r ? Tl : S;
  if (process.env.NODE_ENV !== "production" && dt(H) && s.messageCompiler == null)
    return vn(`The message format compilation is not supported in this build. Because message compiler isn't included. You need to pre-compilation all message format. So translate function return '${S}'.`), S;
  let Q = !1;
  const _e = () => {
    Q = !0;
  }, se = ua(H) ? H : Rv(s, S, W, H, K, _e);
  if (Q)
    return H;
  const Pe = ux(s, W, Z, C), Ke = Bw(Pe), ye = lx(s, se, Ke), Je = c ? c(ye, S) : ye;
  if (process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__) {
    const mt = {
      timestamp: Date.now(),
      key: dt(S) ? S : ua(H) ? H.key : "",
      locale: W || (ua(H) ? H.locale : ""),
      format: dt(H) ? H : ua(H) ? H.source : "",
      message: Je
    };
    mt.meta = yn({}, s.__meta, /* @__PURE__ */ ex() || {}), Yw(mt);
  }
  return Je;
}
function sx(s) {
  Gr(s.list) ? s.list = s.list.map((i) => dt(i) ? Zh(i) : i) : Tr(s.named) && Object.keys(s.named).forEach((i) => {
    dt(s.named[i]) && (s.named[i] = Zh(s.named[i]));
  });
}
function Cv(s, i, o, c, r, e) {
  const { messages: g, onWarn: h, messageResolver: S, localeFallbacker: C } = s, O = C(s, c, o);
  let N = {}, D, x = null, L = o, G = null;
  const Y = "translate";
  for (let k = 0; k < O.length; k++) {
    if (D = G = O[k], process.env.NODE_ENV !== "production" && o !== D && vl(r, i) && h(Ai(qn.FALLBACK_TO_TRANSLATE, {
      key: i,
      target: D
    })), process.env.NODE_ENV !== "production" && o !== D) {
      const Q = s.__v_emitter;
      Q && Q.emit("fallback", {
        type: Y,
        key: i,
        from: L,
        to: G,
        groupId: `${Y}:${i}`
      });
    }
    N = g[D] || {};
    let W = null, Z, H;
    if (process.env.NODE_ENV !== "production" && ga && (W = window.performance.now(), Z = "intlify-message-resolve-start", H = "intlify-message-resolve-end", ta && ta(Z)), (x = S(N, i)) === null && (x = N[i]), process.env.NODE_ENV !== "production" && ga) {
      const Q = window.performance.now(), _e = s.__v_emitter;
      _e && W && x && _e.emit("message-resolve", {
        type: "message-resolve",
        key: i,
        message: x,
        time: Q - W,
        groupId: `${Y}:${i}`
      }), Z && H && ta && Ni && (ta(H), Ni("intlify message resolve", Z, H));
    }
    if (dt(x) || ei(x) || ua(x))
      break;
    const K = Dm(
      s,
      // eslint-disable-line @typescript-eslint/no-explicit-any
      i,
      D,
      e,
      Y
    );
    K !== i && (x = K), L = G;
  }
  return [x, D, N];
}
function Rv(s, i, o, c, r, e) {
  const { messageCompiler: g, warnHtmlMessage: h } = s;
  if (ua(c)) {
    const D = c;
    return D.locale = D.locale || o, D.key = D.key || i, D;
  }
  if (g == null) {
    const D = () => c;
    return D.locale = o, D.key = i, D;
  }
  let S = null, C, O;
  process.env.NODE_ENV !== "production" && ga && (S = window.performance.now(), C = "intlify-message-compilation-start", O = "intlify-message-compilation-end", ta && ta(C));
  const N = g(c, cx(s, o, r, c, h, e));
  if (process.env.NODE_ENV !== "production" && ga) {
    const D = window.performance.now(), x = s.__v_emitter;
    x && S && x.emit("message-compilation", {
      type: "message-compilation",
      message: c,
      time: D - S,
      groupId: `translate:${i}`
    }), C && O && ta && Ni && (ta(O), Ni("intlify message compilation", C, O));
  }
  return N.locale = o, N.key = i, N.source = c, N;
}
function lx(s, i, o) {
  let c = null, r, e;
  process.env.NODE_ENV !== "production" && ga && (c = window.performance.now(), r = "intlify-message-evaluation-start", e = "intlify-message-evaluation-end", ta && ta(r));
  const g = i(o);
  if (process.env.NODE_ENV !== "production" && ga) {
    const h = window.performance.now(), S = s.__v_emitter;
    S && c && S.emit("message-evaluation", {
      type: "message-evaluation",
      value: g,
      time: h - c,
      groupId: `translate:${i.key}`
    }), r && e && ta && Ni && (ta(e), Ni("intlify message evaluation", r, e));
  }
  return g;
}
function tm(...s) {
  const [i, o, c] = s, r = {};
  if (!dt(i) && !mn(i) && !ua(i) && !ei(i))
    throw Ra(Tn.INVALID_ARGUMENT);
  const e = mn(i) ? String(i) : (ua(i), i);
  return mn(o) ? r.plural = o : dt(o) ? r.default = o : zt(o) && !bl(o) ? r.named = o : Gr(o) && (r.list = o), mn(c) ? r.plural = c : dt(c) ? r.default = c : zt(c) && yn(r, c), [e, r];
}
function cx(s, i, o, c, r, e) {
  return {
    locale: i,
    key: o,
    warnHtmlMessage: r,
    onError: (g) => {
      if (e && e(g), process.env.NODE_ENV !== "production") {
        const h = dx(c), S = `Message compilation error: ${g.message}`, C = g.location && h && q2(h, g.location.start.offset, g.location.end.offset), O = s.__v_emitter;
        O && h && O.emit("compile-error", {
          message: h,
          error: g.message,
          start: g.location && g.location.start.offset,
          end: g.location && g.location.end.offset,
          groupId: `translate:${o}`
        }), console.error(C ? `${S}
${C}` : S);
      } else
        throw g;
    },
    onCacheKey: (g) => F2(i, o, g)
  };
}
function dx(s) {
  if (dt(s))
    return s;
  if (s.loc && s.loc.source)
    return s.loc.source;
}
function ux(s, i, o, c) {
  const { modifiers: r, pluralRules: e, messageResolver: g, fallbackLocale: h, fallbackWarn: S, missingWarn: C, fallbackContext: O } = s, D = {
    locale: i,
    modifiers: r,
    pluralRules: e,
    messages: (x) => {
      let L = g(o, x);
      if (L == null && O) {
        const [, , G] = Cv(O, x, i, h, S, C);
        L = g(G, x);
      }
      if (dt(L) || ei(L)) {
        let G = !1;
        const k = Rv(s, x, i, L, x, () => {
          G = !0;
        });
        return G ? pS : k;
      } else
        return ua(L) ? L : pS;
    }
  };
  return s.processor && (D.processor = s.processor), c.list && (D.list = c.list), c.named && (D.named = c.named), mn(c.plural) && (D.pluralIndex = c.plural), D;
}
const fS = typeof Intl < "u", Nv = {
  dateTimeFormat: fS && typeof Intl.DateTimeFormat < "u",
  numberFormat: fS && typeof Intl.NumberFormat < "u"
};
function gS(s, ...i) {
  const { datetimeFormats: o, unresolving: c, fallbackLocale: r, onWarn: e, localeFallbacker: g } = s, { __datetimeFormatters: h } = s;
  if (process.env.NODE_ENV !== "production" && !Nv.dateTimeFormat)
    return e(Ai(qn.CANNOT_FORMAT_DATE)), cl;
  const [S, C, O, N] = rm(...i), D = ar(O.missingWarn) ? O.missingWarn : s.missingWarn, x = ar(O.fallbackWarn) ? O.fallbackWarn : s.fallbackWarn, L = !!O.part, G = Im(s, O), Y = g(
    s,
    // eslint-disable-line @typescript-eslint/no-explicit-any
    r,
    G
  );
  if (!dt(S) || S === "")
    return new Intl.DateTimeFormat(G, N).format(C);
  let k = {}, W, Z = null, H = G, K = null;
  const Q = "datetime format";
  for (let Pe = 0; Pe < Y.length; Pe++) {
    if (W = K = Y[Pe], process.env.NODE_ENV !== "production" && G !== W && vl(x, S) && e(Ai(qn.FALLBACK_TO_DATE_FORMAT, {
      key: S,
      target: W
    })), process.env.NODE_ENV !== "production" && G !== W) {
      const Ke = s.__v_emitter;
      Ke && Ke.emit("fallback", {
        type: Q,
        key: S,
        from: H,
        to: K,
        groupId: `${Q}:${S}`
      });
    }
    if (k = o[W] || {}, Z = k[S], zt(Z))
      break;
    Dm(s, S, W, D, Q), H = K;
  }
  if (!zt(Z) || !dt(W))
    return c ? Tl : S;
  let _e = `${W}__${S}`;
  bl(N) || (_e = `${_e}__${JSON.stringify(N)}`);
  let se = h.get(_e);
  return se || (se = new Intl.DateTimeFormat(W, yn({}, Z, N)), h.set(_e, se)), L ? se.formatToParts(C) : se.format(C);
}
const Av = [
  "localeMatcher",
  "weekday",
  "era",
  "year",
  "month",
  "day",
  "hour",
  "minute",
  "second",
  "timeZoneName",
  "formatMatcher",
  "hour12",
  "timeZone",
  "dateStyle",
  "timeStyle",
  "calendar",
  "dayPeriod",
  "numberingSystem",
  "hourCycle",
  "fractionalSecondDigits"
];
function rm(...s) {
  const [i, o, c, r] = s, e = {};
  let g = {}, h;
  if (dt(i)) {
    const S = i.match(/(\d{4}-\d{2}-\d{2})(T|\s)?(.*)/);
    if (!S)
      throw Ra(Tn.INVALID_ISO_DATE_ARGUMENT);
    const C = S[3] ? S[3].trim().startsWith("T") ? `${S[1].trim()}${S[3].trim()}` : `${S[1].trim()}T${S[3].trim()}` : S[1].trim();
    h = new Date(C);
    try {
      h.toISOString();
    } catch {
      throw Ra(Tn.INVALID_ISO_DATE_ARGUMENT);
    }
  } else if (B2(i)) {
    if (isNaN(i.getTime()))
      throw Ra(Tn.INVALID_DATE_ARGUMENT);
    h = i;
  } else if (mn(i))
    h = i;
  else
    throw Ra(Tn.INVALID_ARGUMENT);
  return dt(o) ? e.key = o : zt(o) && Object.keys(o).forEach((S) => {
    Av.includes(S) ? g[S] = o[S] : e[S] = o[S];
  }), dt(c) ? e.locale = c : zt(c) && (g = c), zt(r) && (g = r), [e.key || "", h, e, g];
}
function ES(s, i, o) {
  const c = s;
  for (const r in o) {
    const e = `${i}__${r}`;
    c.__datetimeFormatters.has(e) && c.__datetimeFormatters.delete(e);
  }
}
function hS(s, ...i) {
  const { numberFormats: o, unresolving: c, fallbackLocale: r, onWarn: e, localeFallbacker: g } = s, { __numberFormatters: h } = s;
  if (process.env.NODE_ENV !== "production" && !Nv.numberFormat)
    return e(Ai(qn.CANNOT_FORMAT_NUMBER)), cl;
  const [S, C, O, N] = nm(...i), D = ar(O.missingWarn) ? O.missingWarn : s.missingWarn, x = ar(O.fallbackWarn) ? O.fallbackWarn : s.fallbackWarn, L = !!O.part, G = Im(s, O), Y = g(
    s,
    // eslint-disable-line @typescript-eslint/no-explicit-any
    r,
    G
  );
  if (!dt(S) || S === "")
    return new Intl.NumberFormat(G, N).format(C);
  let k = {}, W, Z = null, H = G, K = null;
  const Q = "number format";
  for (let Pe = 0; Pe < Y.length; Pe++) {
    if (W = K = Y[Pe], process.env.NODE_ENV !== "production" && G !== W && vl(x, S) && e(Ai(qn.FALLBACK_TO_NUMBER_FORMAT, {
      key: S,
      target: W
    })), process.env.NODE_ENV !== "production" && G !== W) {
      const Ke = s.__v_emitter;
      Ke && Ke.emit("fallback", {
        type: Q,
        key: S,
        from: H,
        to: K,
        groupId: `${Q}:${S}`
      });
    }
    if (k = o[W] || {}, Z = k[S], zt(Z))
      break;
    Dm(s, S, W, D, Q), H = K;
  }
  if (!zt(Z) || !dt(W))
    return c ? Tl : S;
  let _e = `${W}__${S}`;
  bl(N) || (_e = `${_e}__${JSON.stringify(N)}`);
  let se = h.get(_e);
  return se || (se = new Intl.NumberFormat(W, yn({}, Z, N)), h.set(_e, se)), L ? se.formatToParts(C) : se.format(C);
}
const Ov = [
  "localeMatcher",
  "style",
  "currency",
  "currencyDisplay",
  "currencySign",
  "useGrouping",
  "minimumIntegerDigits",
  "minimumFractionDigits",
  "maximumFractionDigits",
  "minimumSignificantDigits",
  "maximumSignificantDigits",
  "compactDisplay",
  "notation",
  "signDisplay",
  "unit",
  "unitDisplay",
  "roundingMode",
  "roundingPriority",
  "roundingIncrement",
  "trailingZeroDisplay"
];
function nm(...s) {
  const [i, o, c, r] = s, e = {};
  let g = {};
  if (!mn(i))
    throw Ra(Tn.INVALID_ARGUMENT);
  const h = i;
  return dt(o) ? e.key = o : zt(o) && Object.keys(o).forEach((S) => {
    Ov.includes(S) ? g[S] = o[S] : e[S] = o[S];
  }), dt(c) ? e.locale = c : zt(c) && (g = c), zt(r) && (g = r), [e.key || "", h, e, g];
}
function SS(s, i, o) {
  const c = s;
  for (const r in o) {
    const e = `${i}__${r}`;
    c.__numberFormatters.has(e) && c.__numberFormatters.delete(e);
  }
}
Cw();
/*!
  * vue-i18n v9.9.1
  * (c) 2024 kazuya kawaguchi
  * Released under the MIT License.
  */
const _x = "9.9.1";
function px() {
  typeof __VUE_I18N_FULL_INSTALL__ != "boolean" && (Ua().__VUE_I18N_FULL_INSTALL__ = !0), typeof __VUE_I18N_LEGACY_API__ != "boolean" && (Ua().__VUE_I18N_LEGACY_API__ = !0), typeof __INTLIFY_JIT_COMPILATION__ != "boolean" && (Ua().__INTLIFY_JIT_COMPILATION__ = !1), typeof __INTLIFY_DROP_MESSAGE_COMPILER__ != "boolean" && (Ua().__INTLIFY_DROP_MESSAGE_COMPILER__ = !1), typeof __INTLIFY_PROD_DEVTOOLS__ != "boolean" && (Ua().__INTLIFY_PROD_DEVTOOLS__ = !1);
}
const yv = qn.__EXTEND_POINT__, Za = Am(yv), Jr = {
  FALLBACK_TO_ROOT: yv,
  NOT_SUPPORTED_PRESERVE: Za(),
  NOT_SUPPORTED_FORMATTER: Za(),
  NOT_SUPPORTED_PRESERVE_DIRECTIVE: Za(),
  NOT_SUPPORTED_GET_CHOICE_INDEX: Za(),
  COMPONENT_NAME_LEGACY_COMPATIBLE: Za(),
  NOT_FOUND_PARENT_SCOPE: Za(),
  IGNORE_OBJ_FLATTEN: Za(),
  NOTICE_DROP_ALLOW_COMPOSITION: Za()
  // 17
}, mx = {
  [Jr.FALLBACK_TO_ROOT]: "Fall back to {type} '{key}' with root locale.",
  [Jr.NOT_SUPPORTED_PRESERVE]: "Not supported 'preserve'.",
  [Jr.NOT_SUPPORTED_FORMATTER]: "Not supported 'formatter'.",
  [Jr.NOT_SUPPORTED_PRESERVE_DIRECTIVE]: "Not supported 'preserveDirectiveContent'.",
  [Jr.NOT_SUPPORTED_GET_CHOICE_INDEX]: "Not supported 'getChoiceIndex'.",
  [Jr.COMPONENT_NAME_LEGACY_COMPATIBLE]: "Component name legacy compatible: '{name}' -> 'i18n'",
  [Jr.NOT_FOUND_PARENT_SCOPE]: "Not found parent scope. use the global scope.",
  [Jr.IGNORE_OBJ_FLATTEN]: "Ignore object flatten: '{key}' key has an string value",
  [Jr.NOTICE_DROP_ALLOW_COMPOSITION]: "'allowComposition' option will be dropped in the next major version. For more information, please see 👉 https://tinyurl.com/2p97mcze"
};
function Jn(s, ...i) {
  return Nm(mx[s], ...i);
}
const Iv = Tn.__EXTEND_POINT__, Kn = Am(Iv), fr = {
  // composer module errors
  UNEXPECTED_RETURN_TYPE: Iv,
  // legacy module errors
  INVALID_ARGUMENT: Kn(),
  // i18n module errors
  MUST_BE_CALL_SETUP_TOP: Kn(),
  NOT_INSTALLED: Kn(),
  NOT_AVAILABLE_IN_LEGACY_MODE: Kn(),
  // directive module errors
  REQUIRED_VALUE: Kn(),
  INVALID_VALUE: Kn(),
  // vue-devtools errors
  CANNOT_SETUP_VUE_DEVTOOLS_PLUGIN: Kn(),
  NOT_INSTALLED_WITH_PROVIDE: Kn(),
  // unexpected error
  UNEXPECTED_ERROR: Kn(),
  // not compatible legacy vue-i18n constructor
  NOT_COMPATIBLE_LEGACY_VUE_I18N: Kn(),
  // bridge support vue 2.x only
  BRIDGE_SUPPORT_VUE_2_ONLY: Kn(),
  // need to define `i18n` option in `allowComposition: true` and `useScope: 'local' at `useI18n``
  MUST_DEFINE_I18N_OPTION_IN_ALLOW_COMPOSITION: Kn(),
  // Not available Compostion API in Legacy API mode. Please make sure that the legacy API mode is working properly
  NOT_AVAILABLE_COMPOSITION_IN_LEGACY: Kn(),
  // for enhancement
  __EXTEND_POINT__: Kn()
  // 40
};
function En(s, ...i) {
  return no(s, null, process.env.NODE_ENV !== "production" ? { messages: fx, args: i } : void 0);
}
const fx = {
  [fr.UNEXPECTED_RETURN_TYPE]: "Unexpected return type in composer",
  [fr.INVALID_ARGUMENT]: "Invalid argument",
  [fr.MUST_BE_CALL_SETUP_TOP]: "Must be called at the top of a `setup` function",
  [fr.NOT_INSTALLED]: "Need to install with `app.use` function",
  [fr.UNEXPECTED_ERROR]: "Unexpected error",
  [fr.NOT_AVAILABLE_IN_LEGACY_MODE]: "Not available in legacy mode",
  [fr.REQUIRED_VALUE]: "Required in value: {0}",
  [fr.INVALID_VALUE]: "Invalid value",
  [fr.CANNOT_SETUP_VUE_DEVTOOLS_PLUGIN]: "Cannot setup vue-devtools plugin",
  [fr.NOT_INSTALLED_WITH_PROVIDE]: "Need to install with `provide` function",
  [fr.NOT_COMPATIBLE_LEGACY_VUE_I18N]: "Not compatible legacy VueI18n.",
  [fr.BRIDGE_SUPPORT_VUE_2_ONLY]: "vue-i18n-bridge support Vue 2.x only",
  [fr.MUST_DEFINE_I18N_OPTION_IN_ALLOW_COMPOSITION]: "Must define ‘i18n’ option or custom block in Composition API with using local scope in Legacy API mode",
  [fr.NOT_AVAILABLE_COMPOSITION_IN_LEGACY]: "Not available Compostion API in Legacy API mode. Please make sure that the legacy API mode is working properly"
}, am = /* @__PURE__ */ Oa("__translateVNode"), im = /* @__PURE__ */ Oa("__datetimeParts"), om = /* @__PURE__ */ Oa("__numberParts"), Oi = /* @__PURE__ */ Oa("__enableEmitter"), Xo = /* @__PURE__ */ Oa("__disableEmitter"), Dv = Oa("__setPluralRules"), wv = /* @__PURE__ */ Oa("__injectWithOption"), sm = /* @__PURE__ */ Oa("__dispose");
function Zo(s) {
  if (!Tr(s))
    return s;
  for (const i in s)
    if (ll(s, i))
      if (!i.includes("."))
        Tr(s[i]) && Zo(s[i]);
      else {
        const o = i.split("."), c = o.length - 1;
        let r = s, e = !1;
        for (let g = 0; g < c; g++) {
          if (o[g] in r || (r[o[g]] = {}), !Tr(r[o[g]])) {
            process.env.NODE_ENV !== "production" && vn(Jn(Jr.IGNORE_OBJ_FLATTEN, {
              key: o[g]
            })), e = !0;
            break;
          }
          r = r[o[g]];
        }
        e || (r[o[c]] = s[i], delete s[i]), Tr(r[o[c]]) && Zo(r[o[c]]);
      }
  return s;
}
function Cl(s, i) {
  const { messages: o, __i18n: c, messageResolver: r, flatJson: e } = i, g = zt(o) ? o : Gr(c) ? {} : { [s]: {} };
  if (Gr(c) && c.forEach((h) => {
    if ("locale" in h && "resource" in h) {
      const { locale: S, resource: C } = h;
      S ? (g[S] = g[S] || {}, al(C, g[S])) : al(C, g);
    } else
      dt(h) && al(JSON.parse(h), g);
  }), r == null && e)
    for (const h in g)
      ll(g, h) && Zo(g[h]);
  return g;
}
function xv(s) {
  return s.type;
}
function Lv(s, i, o) {
  let c = Tr(i.messages) ? i.messages : {};
  "__i18nGlobal" in o && (c = Cl(s.locale.value, {
    messages: c,
    __i18n: o.__i18nGlobal
  }));
  const r = Object.keys(c);
  r.length && r.forEach((e) => {
    s.mergeLocaleMessage(e, c[e]);
  });
  {
    if (Tr(i.datetimeFormats)) {
      const e = Object.keys(i.datetimeFormats);
      e.length && e.forEach((g) => {
        s.mergeDateTimeFormat(g, i.datetimeFormats[g]);
      });
    }
    if (Tr(i.numberFormats)) {
      const e = Object.keys(i.numberFormats);
      e.length && e.forEach((g) => {
        s.mergeNumberFormat(g, i.numberFormats[g]);
      });
    }
  }
}
function bS(s) {
  return Ze(_A, null, s, 0);
}
const TS = "__INTLIFY_META__", vS = () => [], gx = () => !1;
let CS = 0;
function RS(s) {
  return (i, o, c, r) => s(o, c, Wo() || void 0, r);
}
const Ex = /* @__NO_SIDE_EFFECTS__ */ () => {
  const s = Wo();
  let i = null;
  return s && (i = xv(s)[TS]) ? { [TS]: i } : null;
};
function wm(s = {}, i) {
  const { __root: o, __injectWithOption: c } = s, r = o === void 0, e = s.flatJson, g = ga ? pt : T1;
  let h = ar(s.inheritLocale) ? s.inheritLocale : !0;
  const S = g(
    // prettier-ignore
    o && h ? o.locale.value : dt(s.locale) ? s.locale : eo
  ), C = g(
    // prettier-ignore
    o && h ? o.fallbackLocale.value : dt(s.fallbackLocale) || Gr(s.fallbackLocale) || zt(s.fallbackLocale) || s.fallbackLocale === !1 ? s.fallbackLocale : S.value
  ), O = g(Cl(S.value, s)), N = g(zt(s.datetimeFormats) ? s.datetimeFormats : { [S.value]: {} }), D = g(zt(s.numberFormats) ? s.numberFormats : { [S.value]: {} });
  let x = o ? o.missingWarn : ar(s.missingWarn) || Ja(s.missingWarn) ? s.missingWarn : !0, L = o ? o.fallbackWarn : ar(s.fallbackWarn) || Ja(s.fallbackWarn) ? s.fallbackWarn : !0, G = o ? o.fallbackRoot : ar(s.fallbackRoot) ? s.fallbackRoot : !0, Y = !!s.fallbackFormat, k = Mr(s.missing) ? s.missing : null, W = Mr(s.missing) ? RS(s.missing) : null, Z = Mr(s.postTranslation) ? s.postTranslation : null, H = o ? o.warnHtmlMessage : ar(s.warnHtmlMessage) ? s.warnHtmlMessage : !0, K = !!s.escapeParameter;
  const Q = o ? o.modifiers : zt(s.modifiers) ? s.modifiers : {};
  let _e = s.pluralRules || o && o.pluralRules, se;
  se = (() => {
    r && dS(null);
    const Ae = {
      version: _x,
      locale: S.value,
      fallbackLocale: C.value,
      messages: O.value,
      modifiers: Q,
      pluralRules: _e,
      missing: W === null ? void 0 : W,
      missingWarn: x,
      fallbackWarn: L,
      fallbackFormat: Y,
      unresolving: !0,
      postTranslation: Z === null ? void 0 : Z,
      warnHtmlMessage: H,
      escapeParameter: K,
      messageResolver: s.messageResolver,
      messageCompiler: s.messageCompiler,
      __meta: { framework: "vue" }
    };
    Ae.datetimeFormats = N.value, Ae.numberFormats = D.value, Ae.__datetimeFormatters = zt(se) ? se.__datetimeFormatters : void 0, Ae.__numberFormatters = zt(se) ? se.__numberFormatters : void 0, process.env.NODE_ENV !== "production" && (Ae.__v_emitter = zt(se) ? se.__v_emitter : void 0);
    const pe = rx(Ae);
    return r && dS(pe), pe;
  })(), qo(se, S.value, C.value);
  function Ke() {
    return [
      S.value,
      C.value,
      O.value,
      N.value,
      D.value
    ];
  }
  const ye = Vt({
    get: () => S.value,
    set: (Ae) => {
      S.value = Ae, se.locale = S.value;
    }
  }), Je = Vt({
    get: () => C.value,
    set: (Ae) => {
      C.value = Ae, se.fallbackLocale = C.value, qo(se, S.value, Ae);
    }
  }), mt = Vt(() => O.value), ge = /* @__PURE__ */ Vt(() => N.value), w = /* @__PURE__ */ Vt(() => D.value);
  function fe() {
    return Mr(Z) ? Z : null;
  }
  function j(Ae) {
    Z = Ae, se.postTranslation = Ae;
  }
  function J() {
    return k;
  }
  function de(Ae) {
    Ae !== null && (W = RS(Ae)), k = Ae, se.missing = W;
  }
  function ie(Ae, pe) {
    return Ae !== "translate" || !pe.resolvedMessage;
  }
  const X = (Ae, pe, qe, bt, Gt, Ur) => {
    Ke();
    let qr;
    try {
      process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__, r || (se.fallbackContext = o ? tx() : void 0), qr = Ae(se);
    } finally {
      process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__, r || (se.fallbackContext = void 0);
    }
    if (qe !== "translate exists" && // for not `te` (e.g `t`)
    mn(qr) && qr === Tl || qe === "translate exists" && !qr) {
      const [Fn, Ga] = pe();
      if (process.env.NODE_ENV !== "production" && o && dt(Fn) && ie(qe, Ga) && (G && (vl(L, Fn) || Sv(x, Fn)) && vn(Jn(Jr.FALLBACK_TO_ROOT, {
        key: Fn,
        type: qe
      })), process.env.NODE_ENV !== "production")) {
        const { __v_emitter: dn } = se;
        dn && G && dn.emit("fallback", {
          type: qe,
          key: Fn,
          to: "global",
          groupId: `${qe}:${Fn}`
        });
      }
      return o && G ? bt(o) : Gt(Fn);
    } else {
      if (Ur(qr))
        return qr;
      throw En(fr.UNEXPECTED_RETURN_TYPE);
    }
  };
  function ue(...Ae) {
    return X((pe) => Reflect.apply(mS, null, [pe, ...Ae]), () => tm(...Ae), "translate", (pe) => Reflect.apply(pe.t, pe, [...Ae]), (pe) => pe, (pe) => dt(pe));
  }
  function Oe(...Ae) {
    const [pe, qe, bt] = Ae;
    if (bt && !Tr(bt))
      throw En(fr.INVALID_ARGUMENT);
    return ue(pe, qe, yn({ resolvedMessage: !0 }, bt || {}));
  }
  function Re(...Ae) {
    return X((pe) => Reflect.apply(gS, null, [pe, ...Ae]), () => rm(...Ae), "datetime format", (pe) => Reflect.apply(pe.d, pe, [...Ae]), () => cl, (pe) => dt(pe));
  }
  function ae(...Ae) {
    return X((pe) => Reflect.apply(hS, null, [pe, ...Ae]), () => nm(...Ae), "number format", (pe) => Reflect.apply(pe.n, pe, [...Ae]), () => cl, (pe) => dt(pe));
  }
  function Ee(Ae) {
    return Ae.map((pe) => dt(pe) || mn(pe) || ar(pe) ? bS(String(pe)) : pe);
  }
  const Ge = {
    normalize: Ee,
    interpolate: (Ae) => Ae,
    type: "vnode"
  };
  function we(...Ae) {
    return X(
      (pe) => {
        let qe;
        const bt = pe;
        try {
          bt.processor = Ge, qe = Reflect.apply(mS, null, [bt, ...Ae]);
        } finally {
          bt.processor = null;
        }
        return qe;
      },
      () => tm(...Ae),
      "translate",
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (pe) => pe[am](...Ae),
      (pe) => [bS(pe)],
      (pe) => Gr(pe)
    );
  }
  function st(...Ae) {
    return X(
      (pe) => Reflect.apply(hS, null, [pe, ...Ae]),
      () => nm(...Ae),
      "number format",
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (pe) => pe[om](...Ae),
      vS,
      (pe) => dt(pe) || Gr(pe)
    );
  }
  function Rt(...Ae) {
    return X(
      (pe) => Reflect.apply(gS, null, [pe, ...Ae]),
      () => rm(...Ae),
      "datetime format",
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (pe) => pe[im](...Ae),
      vS,
      (pe) => dt(pe) || Gr(pe)
    );
  }
  function rt(Ae) {
    _e = Ae, se.pluralRules = _e;
  }
  function z(Ae, pe) {
    return X(() => {
      if (!Ae)
        return !1;
      const qe = dt(pe) ? pe : S.value, bt = Be(qe), Gt = se.messageResolver(bt, Ae);
      return ei(Gt) || ua(Gt) || dt(Gt);
    }, () => [Ae], "translate exists", (qe) => Reflect.apply(qe.te, qe, [Ae, pe]), gx, (qe) => ar(qe));
  }
  function V(Ae) {
    let pe = null;
    const qe = pv(se, C.value, S.value);
    for (let bt = 0; bt < qe.length; bt++) {
      const Gt = O.value[qe[bt]] || {}, Ur = se.messageResolver(Gt, Ae);
      if (Ur != null) {
        pe = Ur;
        break;
      }
    }
    return pe;
  }
  function Te(Ae) {
    const pe = V(Ae);
    return pe ?? (o ? o.tm(Ae) || {} : {});
  }
  function Be(Ae) {
    return O.value[Ae] || {};
  }
  function Le(Ae, pe) {
    if (e) {
      const qe = { [Ae]: pe };
      for (const bt in qe)
        ll(qe, bt) && Zo(qe[bt]);
      pe = qe[Ae];
    }
    O.value[Ae] = pe, se.messages = O.value;
  }
  function Yt(Ae, pe) {
    O.value[Ae] = O.value[Ae] || {};
    const qe = { [Ae]: pe };
    if (e)
      for (const bt in qe)
        ll(qe, bt) && Zo(qe[bt]);
    pe = qe[Ae], al(pe, O.value[Ae]), se.messages = O.value;
  }
  function Nt(Ae) {
    return N.value[Ae] || {};
  }
  function Hr(Ae, pe) {
    N.value[Ae] = pe, se.datetimeFormats = N.value, ES(se, Ae, pe);
  }
  function Er(Ae, pe) {
    N.value[Ae] = yn(N.value[Ae] || {}, pe), se.datetimeFormats = N.value, ES(se, Ae, pe);
  }
  function tr(Ae) {
    return D.value[Ae] || {};
  }
  function vr(Ae, pe) {
    D.value[Ae] = pe, se.numberFormats = D.value, SS(se, Ae, pe);
  }
  function Pr(Ae, pe) {
    D.value[Ae] = yn(D.value[Ae] || {}, pe), se.numberFormats = D.value, SS(se, Ae, pe);
  }
  CS++, o && ga && (an(o.locale, (Ae) => {
    h && (S.value = Ae, se.locale = Ae, qo(se, S.value, C.value));
  }), an(o.fallbackLocale, (Ae) => {
    h && (C.value = Ae, se.fallbackLocale = Ae, qo(se, S.value, C.value));
  }));
  const ur = {
    id: CS,
    locale: ye,
    fallbackLocale: Je,
    get inheritLocale() {
      return h;
    },
    set inheritLocale(Ae) {
      h = Ae, Ae && o && (S.value = o.locale.value, C.value = o.fallbackLocale.value, qo(se, S.value, C.value));
    },
    get availableLocales() {
      return Object.keys(O.value).sort();
    },
    messages: mt,
    get modifiers() {
      return Q;
    },
    get pluralRules() {
      return _e || {};
    },
    get isGlobal() {
      return r;
    },
    get missingWarn() {
      return x;
    },
    set missingWarn(Ae) {
      x = Ae, se.missingWarn = x;
    },
    get fallbackWarn() {
      return L;
    },
    set fallbackWarn(Ae) {
      L = Ae, se.fallbackWarn = L;
    },
    get fallbackRoot() {
      return G;
    },
    set fallbackRoot(Ae) {
      G = Ae;
    },
    get fallbackFormat() {
      return Y;
    },
    set fallbackFormat(Ae) {
      Y = Ae, se.fallbackFormat = Y;
    },
    get warnHtmlMessage() {
      return H;
    },
    set warnHtmlMessage(Ae) {
      H = Ae, se.warnHtmlMessage = Ae;
    },
    get escapeParameter() {
      return K;
    },
    set escapeParameter(Ae) {
      K = Ae, se.escapeParameter = Ae;
    },
    t: ue,
    getLocaleMessage: Be,
    setLocaleMessage: Le,
    mergeLocaleMessage: Yt,
    getPostTranslationHandler: fe,
    setPostTranslationHandler: j,
    getMissingHandler: J,
    setMissingHandler: de,
    [Dv]: rt
  };
  return ur.datetimeFormats = ge, ur.numberFormats = w, ur.rt = Oe, ur.te = z, ur.tm = Te, ur.d = Re, ur.n = ae, ur.getDateTimeFormat = Nt, ur.setDateTimeFormat = Hr, ur.mergeDateTimeFormat = Er, ur.getNumberFormat = tr, ur.setNumberFormat = vr, ur.mergeNumberFormat = Pr, ur[wv] = c, ur[am] = we, ur[im] = Rt, ur[om] = st, process.env.NODE_ENV !== "production" && (ur[Oi] = (Ae) => {
    se.__v_emitter = Ae;
  }, ur[Xo] = () => {
    se.__v_emitter = void 0;
  }), ur;
}
function hx(s) {
  const i = dt(s.locale) ? s.locale : eo, o = dt(s.fallbackLocale) || Gr(s.fallbackLocale) || zt(s.fallbackLocale) || s.fallbackLocale === !1 ? s.fallbackLocale : i, c = Mr(s.missing) ? s.missing : void 0, r = ar(s.silentTranslationWarn) || Ja(s.silentTranslationWarn) ? !s.silentTranslationWarn : !0, e = ar(s.silentFallbackWarn) || Ja(s.silentFallbackWarn) ? !s.silentFallbackWarn : !0, g = ar(s.fallbackRoot) ? s.fallbackRoot : !0, h = !!s.formatFallbackMessages, S = zt(s.modifiers) ? s.modifiers : {}, C = s.pluralizationRules, O = Mr(s.postTranslation) ? s.postTranslation : void 0, N = dt(s.warnHtmlInMessage) ? s.warnHtmlInMessage !== "off" : !0, D = !!s.escapeParameterHtml, x = ar(s.sync) ? s.sync : !0;
  process.env.NODE_ENV !== "production" && s.formatter && vn(Jn(Jr.NOT_SUPPORTED_FORMATTER)), process.env.NODE_ENV !== "production" && s.preserveDirectiveContent && vn(Jn(Jr.NOT_SUPPORTED_PRESERVE_DIRECTIVE));
  let L = s.messages;
  if (zt(s.sharedMessages)) {
    const K = s.sharedMessages;
    L = Object.keys(K).reduce((_e, se) => {
      const Pe = _e[se] || (_e[se] = {});
      return yn(Pe, K[se]), _e;
    }, L || {});
  }
  const { __i18n: G, __root: Y, __injectWithOption: k } = s, W = s.datetimeFormats, Z = s.numberFormats, H = s.flatJson;
  return {
    locale: i,
    fallbackLocale: o,
    messages: L,
    flatJson: H,
    datetimeFormats: W,
    numberFormats: Z,
    missing: c,
    missingWarn: r,
    fallbackWarn: e,
    fallbackRoot: g,
    fallbackFormat: h,
    modifiers: S,
    pluralRules: C,
    postTranslation: O,
    warnHtmlMessage: N,
    escapeParameter: D,
    messageResolver: s.messageResolver,
    inheritLocale: x,
    __i18n: G,
    __root: Y,
    __injectWithOption: k
  };
}
function lm(s = {}, i) {
  {
    const o = wm(hx(s)), { __extender: c } = s, r = {
      // id
      id: o.id,
      // locale
      get locale() {
        return o.locale.value;
      },
      set locale(e) {
        o.locale.value = e;
      },
      // fallbackLocale
      get fallbackLocale() {
        return o.fallbackLocale.value;
      },
      set fallbackLocale(e) {
        o.fallbackLocale.value = e;
      },
      // messages
      get messages() {
        return o.messages.value;
      },
      // datetimeFormats
      get datetimeFormats() {
        return o.datetimeFormats.value;
      },
      // numberFormats
      get numberFormats() {
        return o.numberFormats.value;
      },
      // availableLocales
      get availableLocales() {
        return o.availableLocales;
      },
      // formatter
      get formatter() {
        return process.env.NODE_ENV !== "production" && vn(Jn(Jr.NOT_SUPPORTED_FORMATTER)), {
          interpolate() {
            return [];
          }
        };
      },
      set formatter(e) {
        process.env.NODE_ENV !== "production" && vn(Jn(Jr.NOT_SUPPORTED_FORMATTER));
      },
      // missing
      get missing() {
        return o.getMissingHandler();
      },
      set missing(e) {
        o.setMissingHandler(e);
      },
      // silentTranslationWarn
      get silentTranslationWarn() {
        return ar(o.missingWarn) ? !o.missingWarn : o.missingWarn;
      },
      set silentTranslationWarn(e) {
        o.missingWarn = ar(e) ? !e : e;
      },
      // silentFallbackWarn
      get silentFallbackWarn() {
        return ar(o.fallbackWarn) ? !o.fallbackWarn : o.fallbackWarn;
      },
      set silentFallbackWarn(e) {
        o.fallbackWarn = ar(e) ? !e : e;
      },
      // modifiers
      get modifiers() {
        return o.modifiers;
      },
      // formatFallbackMessages
      get formatFallbackMessages() {
        return o.fallbackFormat;
      },
      set formatFallbackMessages(e) {
        o.fallbackFormat = e;
      },
      // postTranslation
      get postTranslation() {
        return o.getPostTranslationHandler();
      },
      set postTranslation(e) {
        o.setPostTranslationHandler(e);
      },
      // sync
      get sync() {
        return o.inheritLocale;
      },
      set sync(e) {
        o.inheritLocale = e;
      },
      // warnInHtmlMessage
      get warnHtmlInMessage() {
        return o.warnHtmlMessage ? "warn" : "off";
      },
      set warnHtmlInMessage(e) {
        o.warnHtmlMessage = e !== "off";
      },
      // escapeParameterHtml
      get escapeParameterHtml() {
        return o.escapeParameter;
      },
      set escapeParameterHtml(e) {
        o.escapeParameter = e;
      },
      // preserveDirectiveContent
      get preserveDirectiveContent() {
        return process.env.NODE_ENV !== "production" && vn(Jn(Jr.NOT_SUPPORTED_PRESERVE_DIRECTIVE)), !0;
      },
      set preserveDirectiveContent(e) {
        process.env.NODE_ENV !== "production" && vn(Jn(Jr.NOT_SUPPORTED_PRESERVE_DIRECTIVE));
      },
      // pluralizationRules
      get pluralizationRules() {
        return o.pluralRules || {};
      },
      // for internal
      __composer: o,
      // t
      t(...e) {
        const [g, h, S] = e, C = {};
        let O = null, N = null;
        if (!dt(g))
          throw En(fr.INVALID_ARGUMENT);
        const D = g;
        return dt(h) ? C.locale = h : Gr(h) ? O = h : zt(h) && (N = h), Gr(S) ? O = S : zt(S) && (N = S), Reflect.apply(o.t, o, [
          D,
          O || N || {},
          C
        ]);
      },
      rt(...e) {
        return Reflect.apply(o.rt, o, [...e]);
      },
      // tc
      tc(...e) {
        const [g, h, S] = e, C = { plural: 1 };
        let O = null, N = null;
        if (!dt(g))
          throw En(fr.INVALID_ARGUMENT);
        const D = g;
        return dt(h) ? C.locale = h : mn(h) ? C.plural = h : Gr(h) ? O = h : zt(h) && (N = h), dt(S) ? C.locale = S : Gr(S) ? O = S : zt(S) && (N = S), Reflect.apply(o.t, o, [
          D,
          O || N || {},
          C
        ]);
      },
      // te
      te(e, g) {
        return o.te(e, g);
      },
      // tm
      tm(e) {
        return o.tm(e);
      },
      // getLocaleMessage
      getLocaleMessage(e) {
        return o.getLocaleMessage(e);
      },
      // setLocaleMessage
      setLocaleMessage(e, g) {
        o.setLocaleMessage(e, g);
      },
      // mergeLocaleMessage
      mergeLocaleMessage(e, g) {
        o.mergeLocaleMessage(e, g);
      },
      // d
      d(...e) {
        return Reflect.apply(o.d, o, [...e]);
      },
      // getDateTimeFormat
      getDateTimeFormat(e) {
        return o.getDateTimeFormat(e);
      },
      // setDateTimeFormat
      setDateTimeFormat(e, g) {
        o.setDateTimeFormat(e, g);
      },
      // mergeDateTimeFormat
      mergeDateTimeFormat(e, g) {
        o.mergeDateTimeFormat(e, g);
      },
      // n
      n(...e) {
        return Reflect.apply(o.n, o, [...e]);
      },
      // getNumberFormat
      getNumberFormat(e) {
        return o.getNumberFormat(e);
      },
      // setNumberFormat
      setNumberFormat(e, g) {
        o.setNumberFormat(e, g);
      },
      // mergeNumberFormat
      mergeNumberFormat(e, g) {
        o.mergeNumberFormat(e, g);
      },
      // getChoiceIndex
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      getChoiceIndex(e, g) {
        return process.env.NODE_ENV !== "production" && vn(Jn(Jr.NOT_SUPPORTED_GET_CHOICE_INDEX)), -1;
      }
    };
    return r.__extender = c, process.env.NODE_ENV !== "production" && (r.__enableEmitter = (e) => {
      const g = o;
      g[Oi] && g[Oi](e);
    }, r.__disableEmitter = () => {
      const e = o;
      e[Xo] && e[Xo]();
    }), r;
  }
}
const xm = {
  tag: {
    type: [String, Object]
  },
  locale: {
    type: String
  },
  scope: {
    type: String,
    // NOTE: avoid https://github.com/microsoft/rushstack/issues/1050
    validator: (s) => s === "parent" || s === "global",
    default: "parent"
    /* ComponentI18nScope */
  },
  i18n: {
    type: Object
  }
};
function Sx({ slots: s }, i) {
  return i.length === 1 && i[0] === "default" ? (s.default ? s.default() : []).reduce((c, r) => [
    ...c,
    // prettier-ignore
    ...r.type === nr ? r.children : [r]
  ], []) : i.reduce((o, c) => {
    const r = s[c];
    return r && (o[c] = r()), o;
  }, {});
}
function Mv(s) {
  return nr;
}
const bx = /* @__PURE__ */ Nr({
  /* eslint-disable */
  name: "i18n-t",
  props: yn({
    keypath: {
      type: String,
      required: !0
    },
    plural: {
      type: [Number, String],
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      validator: (s) => mn(s) || !isNaN(s)
    }
  }, xm),
  /* eslint-enable */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setup(s, i) {
    const { slots: o, attrs: c } = i, r = s.i18n || Mm({
      useScope: s.scope,
      __useComponent: !0
    });
    return () => {
      const e = Object.keys(o).filter((N) => N !== "_"), g = {};
      s.locale && (g.locale = s.locale), s.plural !== void 0 && (g.plural = dt(s.plural) ? +s.plural : s.plural);
      const h = Sx(i, e), S = r[am](s.keypath, h, g), C = yn({}, c), O = dt(s.tag) || Tr(s.tag) ? s.tag : Mv();
      return b1(O, C, S);
    };
  }
}), cd = bx;
function Tx(s) {
  return Gr(s) && !dt(s[0]);
}
function Pv(s, i, o, c) {
  const { slots: r, attrs: e } = i;
  return () => {
    const g = { part: !0 };
    let h = {};
    s.locale && (g.locale = s.locale), dt(s.format) ? g.key = s.format : Tr(s.format) && (dt(s.format.key) && (g.key = s.format.key), h = Object.keys(s.format).reduce((D, x) => o.includes(x) ? yn({}, D, { [x]: s.format[x] }) : D, {}));
    const S = c(s.value, g, h);
    let C = [g.key];
    Gr(S) ? C = S.map((D, x) => {
      const L = r[D.type], G = L ? L({ [D.type]: D.value, index: x, parts: S }) : [D.value];
      return Tx(G) && (G[0].key = `${D.type}-${x}`), G;
    }) : dt(S) && (C = [S]);
    const O = yn({}, e), N = dt(s.tag) || Tr(s.tag) ? s.tag : Mv();
    return b1(N, O, C);
  };
}
const vx = /* @__PURE__ */ Nr({
  /* eslint-disable */
  name: "i18n-n",
  props: yn({
    value: {
      type: Number,
      required: !0
    },
    format: {
      type: [String, Object]
    }
  }, xm),
  /* eslint-enable */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setup(s, i) {
    const o = s.i18n || Mm({
      useScope: "parent",
      __useComponent: !0
    });
    return Pv(s, i, Ov, (...c) => (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      o[om](...c)
    ));
  }
}), NS = vx, Cx = /* @__PURE__ */ Nr({
  /* eslint-disable */
  name: "i18n-d",
  props: yn({
    value: {
      type: [Number, Date],
      required: !0
    },
    format: {
      type: [String, Object]
    }
  }, xm),
  /* eslint-enable */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setup(s, i) {
    const o = s.i18n || Mm({
      useScope: "parent",
      __useComponent: !0
    });
    return Pv(s, i, Av, (...c) => (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      o[im](...c)
    ));
  }
}), AS = Cx;
function Rx(s, i) {
  const o = s;
  if (s.mode === "composition")
    return o.__getInstance(i) || s.global;
  {
    const c = o.__getInstance(i);
    return c != null ? c.__composer : s.global.__composer;
  }
}
function Nx(s) {
  const i = (g) => {
    const { instance: h, modifiers: S, value: C } = g;
    if (!h || !h.$)
      throw En(fr.UNEXPECTED_ERROR);
    const O = Rx(s, h.$);
    process.env.NODE_ENV !== "production" && S.preserve && vn(Jn(Jr.NOT_SUPPORTED_PRESERVE));
    const N = OS(C);
    return [
      Reflect.apply(O.t, O, [...yS(N)]),
      O
    ];
  };
  return {
    created: (g, h) => {
      const [S, C] = i(h);
      ga && s.global === C && (g.__i18nWatcher = an(C.locale, () => {
        h.instance && h.instance.$forceUpdate();
      })), g.__composer = C, g.textContent = S;
    },
    unmounted: (g) => {
      ga && g.__i18nWatcher && (g.__i18nWatcher(), g.__i18nWatcher = void 0, delete g.__i18nWatcher), g.__composer && (g.__composer = void 0, delete g.__composer);
    },
    beforeUpdate: (g, { value: h }) => {
      if (g.__composer) {
        const S = g.__composer, C = OS(h);
        g.textContent = Reflect.apply(S.t, S, [
          ...yS(C)
        ]);
      }
    },
    getSSRProps: (g) => {
      const [h] = i(g);
      return { textContent: h };
    }
  };
}
function OS(s) {
  if (dt(s))
    return { path: s };
  if (zt(s)) {
    if (!("path" in s))
      throw En(fr.REQUIRED_VALUE, "path");
    return s;
  } else
    throw En(fr.INVALID_VALUE);
}
function yS(s) {
  const { path: i, locale: o, args: c, choice: r, plural: e } = s, g = {}, h = c || {};
  return dt(o) && (g.locale = o), mn(r) && (g.plural = r), mn(e) && (g.plural = e), [i, h, g];
}
function Ax(s, i, ...o) {
  const c = zt(o[0]) ? o[0] : {}, r = !!c.useI18nComponentName, e = ar(c.globalInstall) ? c.globalInstall : !0;
  process.env.NODE_ENV !== "production" && e && r && vn(Jn(Jr.COMPONENT_NAME_LEGACY_COMPATIBLE, {
    name: cd.name
  })), e && ([r ? "i18n" : cd.name, "I18nT"].forEach((g) => s.component(g, cd)), [NS.name, "I18nN"].forEach((g) => s.component(g, NS)), [AS.name, "I18nD"].forEach((g) => s.component(g, AS))), s.directive("t", Nx(i));
}
const dd = {
  "vue-devtools-plugin-vue-i18n": "Vue I18n devtools",
  "vue-i18n-resource-inspector": "I18n Resources",
  "vue-i18n-timeline": "Vue I18n"
}, Ox = {
  "vue-i18n-resource-inspector": "Search for scopes ..."
}, yx = {
  "vue-i18n-timeline": 16764185
}, kv = "vue-i18n: composer properties";
let cm;
async function Ix(s, i) {
  return new Promise((o, c) => {
    try {
      v2({
        id: "vue-devtools-plugin-vue-i18n",
        label: dd[
          "vue-devtools-plugin-vue-i18n"
          /* VueDevToolsIDs.PLUGIN */
        ],
        packageName: "vue-i18n",
        homepage: "https://vue-i18n.intlify.dev",
        logo: "https://vue-i18n.intlify.dev/vue-i18n-devtools-logo.png",
        componentStateTypes: [kv],
        app: s
        // eslint-disable-line @typescript-eslint/no-explicit-any
      }, (r) => {
        cm = r, r.on.visitComponentTree(({ componentInstance: g, treeNode: h }) => {
          Dx(g, h, i);
        }), r.on.inspectComponent(({ componentInstance: g, instanceData: h }) => {
          g.vnode.el && g.vnode.el.__VUE_I18N__ && h && (i.mode === "legacy" ? g.vnode.el.__VUE_I18N__ !== i.global.__composer && IS(h, g.vnode.el.__VUE_I18N__) : IS(h, g.vnode.el.__VUE_I18N__));
        }), r.addInspector({
          id: "vue-i18n-resource-inspector",
          label: dd[
            "vue-i18n-resource-inspector"
            /* VueDevToolsIDs.CUSTOM_INSPECTOR */
          ],
          icon: "language",
          treeFilterPlaceholder: Ox[
            "vue-i18n-resource-inspector"
            /* VueDevToolsIDs.CUSTOM_INSPECTOR */
          ]
        }), r.on.getInspectorTree((g) => {
          g.app === s && g.inspectorId === "vue-i18n-resource-inspector" && Px(g, i);
        });
        const e = /* @__PURE__ */ new Map();
        r.on.getInspectorState(async (g) => {
          if (g.app === s && g.inspectorId === "vue-i18n-resource-inspector")
            if (r.unhighlightElement(), Fx(g, i), g.nodeId === "global") {
              if (!e.has(g.app)) {
                const [h] = await r.getComponentInstances(g.app);
                e.set(g.app, h);
              }
              r.highlightElement(e.get(g.app));
            } else {
              const h = kx(g.nodeId, i);
              h && r.highlightElement(h);
            }
        }), r.on.editInspectorState((g) => {
          g.app === s && g.inspectorId === "vue-i18n-resource-inspector" && Bx(g, i);
        }), r.addTimelineLayer({
          id: "vue-i18n-timeline",
          label: dd[
            "vue-i18n-timeline"
            /* VueDevToolsIDs.TIMELINE */
          ],
          color: yx[
            "vue-i18n-timeline"
            /* VueDevToolsIDs.TIMELINE */
          ]
        }), o(!0);
      });
    } catch (r) {
      console.error(r), c(!1);
    }
  });
}
function Fv(s) {
  return s.type.name || s.type.displayName || s.type.__file || "Anonymous";
}
function Dx(s, i, o) {
  const c = o.mode === "composition" ? o.global : o.global.__composer;
  if (s && s.vnode.el && s.vnode.el.__VUE_I18N__ && s.vnode.el.__VUE_I18N__ !== c) {
    const r = {
      label: `i18n (${Fv(s)} Scope)`,
      textColor: 0,
      backgroundColor: 16764185
    };
    i.tags.push(r);
  }
}
function IS(s, i) {
  const o = kv;
  s.state.push({
    type: o,
    key: "locale",
    editable: !0,
    value: i.locale.value
  }), s.state.push({
    type: o,
    key: "availableLocales",
    editable: !1,
    value: i.availableLocales
  }), s.state.push({
    type: o,
    key: "fallbackLocale",
    editable: !0,
    value: i.fallbackLocale.value
  }), s.state.push({
    type: o,
    key: "inheritLocale",
    editable: !0,
    value: i.inheritLocale
  }), s.state.push({
    type: o,
    key: "messages",
    editable: !1,
    value: Lm(i.messages.value)
  }), s.state.push({
    type: o,
    key: "datetimeFormats",
    editable: !1,
    value: i.datetimeFormats.value
  }), s.state.push({
    type: o,
    key: "numberFormats",
    editable: !1,
    value: i.numberFormats.value
  });
}
function Lm(s) {
  const i = {};
  return Object.keys(s).forEach((o) => {
    const c = s[o];
    Mr(c) && "source" in c ? i[o] = Mx(c) : ei(c) && c.loc && c.loc.source ? i[o] = c.loc.source : Tr(c) ? i[o] = Lm(c) : i[o] = c;
  }), i;
}
const wx = {
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "&": "&amp;"
};
function xx(s) {
  return s.replace(/[<>"&]/g, Lx);
}
function Lx(s) {
  return wx[s] || s;
}
function Mx(s) {
  return {
    _custom: {
      type: "function",
      display: `<span>ƒ</span> ${s.source ? `("${xx(s.source)}")` : "(?)"}`
    }
  };
}
function Px(s, i) {
  s.rootNodes.push({
    id: "global",
    label: "Global Scope"
  });
  const o = i.mode === "composition" ? i.global : i.global.__composer;
  for (const [c, r] of i.__instances) {
    const e = i.mode === "composition" ? r : r.__composer;
    o !== e && s.rootNodes.push({
      id: e.id.toString(),
      label: `${Fv(c)} Scope`
    });
  }
}
function kx(s, i) {
  let o = null;
  if (s !== "global") {
    for (const [c, r] of i.__instances.entries())
      if (r.id.toString() === s) {
        o = c;
        break;
      }
  }
  return o;
}
function Uv(s, i) {
  if (s === "global")
    return i.mode === "composition" ? i.global : i.global.__composer;
  {
    const o = Array.from(i.__instances.values()).find((c) => c.id.toString() === s);
    return o ? i.mode === "composition" ? o : o.__composer : null;
  }
}
function Fx(s, i) {
  const o = Uv(s.nodeId, i);
  return o && (s.state = Ux(o)), null;
}
function Ux(s) {
  const i = {}, o = "Locale related info", c = [
    {
      type: o,
      key: "locale",
      editable: !0,
      value: s.locale.value
    },
    {
      type: o,
      key: "fallbackLocale",
      editable: !0,
      value: s.fallbackLocale.value
    },
    {
      type: o,
      key: "availableLocales",
      editable: !1,
      value: s.availableLocales
    },
    {
      type: o,
      key: "inheritLocale",
      editable: !0,
      value: s.inheritLocale
    }
  ];
  i[o] = c;
  const r = "Locale messages info", e = [
    {
      type: r,
      key: "messages",
      editable: !1,
      value: Lm(s.messages.value)
    }
  ];
  i[r] = e;
  {
    const g = "Datetime formats info", h = [
      {
        type: g,
        key: "datetimeFormats",
        editable: !1,
        value: s.datetimeFormats.value
      }
    ];
    i[g] = h;
    const S = "Datetime formats info", C = [
      {
        type: S,
        key: "numberFormats",
        editable: !1,
        value: s.numberFormats.value
      }
    ];
    i[S] = C;
  }
  return i;
}
function jo(s, i) {
  if (cm) {
    let o;
    i && "groupId" in i && (o = i.groupId, delete i.groupId), cm.addTimelineEvent({
      layerId: "vue-i18n-timeline",
      event: {
        title: s,
        groupId: o,
        time: Date.now(),
        meta: {},
        data: i || {},
        logType: s === "compile-error" ? "error" : s === "fallback" || s === "missing" ? "warning" : "default"
      }
    });
  }
}
function Bx(s, i) {
  const o = Uv(s.nodeId, i);
  if (o) {
    const [c] = s.path;
    c === "locale" && dt(s.state.value) ? o.locale.value = s.state.value : c === "fallbackLocale" && (dt(s.state.value) || Gr(s.state.value) || Tr(s.state.value)) ? o.fallbackLocale.value = s.state.value : c === "inheritLocale" && ar(s.state.value) && (o.inheritLocale = s.state.value);
  }
}
function Gx(s, i, o) {
  return {
    beforeCreate() {
      const c = Wo();
      if (!c)
        throw En(fr.UNEXPECTED_ERROR);
      const r = this.$options;
      if (r.i18n) {
        const e = r.i18n;
        if (r.__i18n && (e.__i18n = r.__i18n), e.__root = i, this === this.$root)
          this.$i18n = DS(s, e);
        else {
          e.__injectWithOption = !0, e.__extender = o.__vueI18nExtend, this.$i18n = lm(e);
          const g = this.$i18n;
          g.__extender && (g.__disposer = g.__extender(this.$i18n));
        }
      } else if (r.__i18n)
        if (this === this.$root)
          this.$i18n = DS(s, r);
        else {
          this.$i18n = lm({
            __i18n: r.__i18n,
            __injectWithOption: !0,
            __extender: o.__vueI18nExtend,
            __root: i
          });
          const e = this.$i18n;
          e.__extender && (e.__disposer = e.__extender(this.$i18n));
        }
      else
        this.$i18n = s;
      r.__i18nGlobal && Lv(i, r, r), this.$t = (...e) => this.$i18n.t(...e), this.$rt = (...e) => this.$i18n.rt(...e), this.$tc = (...e) => this.$i18n.tc(...e), this.$te = (e, g) => this.$i18n.te(e, g), this.$d = (...e) => this.$i18n.d(...e), this.$n = (...e) => this.$i18n.n(...e), this.$tm = (e) => this.$i18n.tm(e), o.__setInstance(c, this.$i18n);
    },
    mounted() {
      if (process.env.NODE_ENV !== "production" && this.$el && this.$i18n) {
        const c = this.$i18n;
        this.$el.__VUE_I18N__ = c.__composer;
        const r = this.__v_emitter = Om();
        c.__enableEmitter && c.__enableEmitter(r), r.on("*", jo);
      }
    },
    unmounted() {
      const c = Wo();
      if (!c)
        throw En(fr.UNEXPECTED_ERROR);
      const r = this.$i18n;
      process.env.NODE_ENV !== "production" && this.$el && this.$el.__VUE_I18N__ && (this.__v_emitter && (this.__v_emitter.off("*", jo), delete this.__v_emitter), this.$i18n && (r.__disableEmitter && r.__disableEmitter(), delete this.$el.__VUE_I18N__)), delete this.$t, delete this.$rt, delete this.$tc, delete this.$te, delete this.$d, delete this.$n, delete this.$tm, r.__disposer && (r.__disposer(), delete r.__disposer, delete r.__extender), o.__deleteInstance(c), delete this.$i18n;
    }
  };
}
function DS(s, i) {
  s.locale = i.locale || s.locale, s.fallbackLocale = i.fallbackLocale || s.fallbackLocale, s.missing = i.missing || s.missing, s.silentTranslationWarn = i.silentTranslationWarn || s.silentFallbackWarn, s.silentFallbackWarn = i.silentFallbackWarn || s.silentFallbackWarn, s.formatFallbackMessages = i.formatFallbackMessages || s.formatFallbackMessages, s.postTranslation = i.postTranslation || s.postTranslation, s.warnHtmlInMessage = i.warnHtmlInMessage || s.warnHtmlInMessage, s.escapeParameterHtml = i.escapeParameterHtml || s.escapeParameterHtml, s.sync = i.sync || s.sync, s.__composer[Dv](i.pluralizationRules || s.pluralizationRules);
  const o = Cl(s.locale, {
    messages: i.messages,
    __i18n: i.__i18n
  });
  return Object.keys(o).forEach((c) => s.mergeLocaleMessage(c, o[c])), i.datetimeFormats && Object.keys(i.datetimeFormats).forEach((c) => s.mergeDateTimeFormat(c, i.datetimeFormats[c])), i.numberFormats && Object.keys(i.numberFormats).forEach((c) => s.mergeNumberFormat(c, i.numberFormats[c])), s;
}
const Vx = /* @__PURE__ */ Oa("global-vue-i18n");
function Yx(s = {}, i) {
  const o = __VUE_I18N_LEGACY_API__ && ar(s.legacy) ? s.legacy : __VUE_I18N_LEGACY_API__, c = ar(s.globalInjection) ? s.globalInjection : !0, r = __VUE_I18N_LEGACY_API__ && o ? !!s.allowComposition : !0, e = /* @__PURE__ */ new Map(), [g, h] = Hx(s, o), S = /* @__PURE__ */ Oa(process.env.NODE_ENV !== "production" ? "vue-i18n" : "");
  process.env.NODE_ENV !== "production" && o && r && vn(Jn(Jr.NOTICE_DROP_ALLOW_COMPOSITION));
  function C(D) {
    return e.get(D) || null;
  }
  function O(D, x) {
    e.set(D, x);
  }
  function N(D) {
    e.delete(D);
  }
  {
    const D = {
      // mode
      get mode() {
        return __VUE_I18N_LEGACY_API__ && o ? "legacy" : "composition";
      },
      // allowComposition
      get allowComposition() {
        return r;
      },
      // install plugin
      async install(x, ...L) {
        if (process.env.NODE_ENV !== "production" && (x.__VUE_I18N__ = D), x.__VUE_I18N_SYMBOL__ = S, x.provide(x.__VUE_I18N_SYMBOL__, D), zt(L[0])) {
          const k = L[0];
          D.__composerExtend = k.__composerExtend, D.__vueI18nExtend = k.__vueI18nExtend;
        }
        let G = null;
        !o && c && (G = jx(x, D.global)), __VUE_I18N_FULL_INSTALL__ && Ax(x, D, ...L), __VUE_I18N_LEGACY_API__ && o && x.mixin(Gx(h, h.__composer, D));
        const Y = x.unmount;
        if (x.unmount = () => {
          G && G(), D.dispose(), Y();
        }, process.env.NODE_ENV !== "production") {
          if (!await Ix(x, D))
            throw En(fr.CANNOT_SETUP_VUE_DEVTOOLS_PLUGIN);
          const W = Om();
          if (o) {
            const Z = h;
            Z.__enableEmitter && Z.__enableEmitter(W);
          } else {
            const Z = h;
            Z[Oi] && Z[Oi](W);
          }
          W.on("*", jo);
        }
      },
      // global accessor
      get global() {
        return h;
      },
      dispose() {
        g.stop();
      },
      // @internal
      __instances: e,
      // @internal
      __getInstance: C,
      // @internal
      __setInstance: O,
      // @internal
      __deleteInstance: N
    };
    return D;
  }
}
function Mm(s = {}) {
  const i = Wo();
  if (i == null)
    throw En(fr.MUST_BE_CALL_SETUP_TOP);
  if (!i.isCE && i.appContext.app != null && !i.appContext.app.__VUE_I18N_SYMBOL__)
    throw En(fr.NOT_INSTALLED);
  const o = qx(i), c = Wx(o), r = xv(i), e = $x(s, r);
  if (__VUE_I18N_LEGACY_API__ && o.mode === "legacy" && !s.__useComponent) {
    if (!o.allowComposition)
      throw En(fr.NOT_AVAILABLE_IN_LEGACY_MODE);
    return Xx(i, e, c, s);
  }
  if (e === "global")
    return Lv(c, s, r), c;
  if (e === "parent") {
    let S = zx(o, i, s.__useComponent);
    return S == null && (process.env.NODE_ENV !== "production" && vn(Jn(Jr.NOT_FOUND_PARENT_SCOPE)), S = c), S;
  }
  const g = o;
  let h = g.__getInstance(i);
  if (h == null) {
    const S = yn({}, s);
    "__i18n" in r && (S.__i18n = r.__i18n), c && (S.__root = c), h = wm(S), g.__composerExtend && (h[sm] = g.__composerExtend(h)), Qx(g, i, h), g.__setInstance(i, h);
  }
  return h;
}
function Hx(s, i, o) {
  const c = dA();
  {
    const r = __VUE_I18N_LEGACY_API__ && i ? c.run(() => lm(s)) : c.run(() => wm(s));
    if (r == null)
      throw En(fr.UNEXPECTED_ERROR);
    return [c, r];
  }
}
function qx(s) {
  {
    const i = S1(s.isCE ? Vx : s.appContext.app.__VUE_I18N_SYMBOL__);
    if (!i)
      throw En(s.isCE ? fr.NOT_INSTALLED_WITH_PROVIDE : fr.UNEXPECTED_ERROR);
    return i;
  }
}
function $x(s, i) {
  return bl(s) ? "__i18n" in i ? "local" : "global" : s.useScope ? s.useScope : "local";
}
function Wx(s) {
  return s.mode === "composition" ? s.global : s.global.__composer;
}
function zx(s, i, o = !1) {
  let c = null;
  const r = i.root;
  let e = Kx(i, o);
  for (; e != null; ) {
    const g = s;
    if (s.mode === "composition")
      c = g.__getInstance(e);
    else if (__VUE_I18N_LEGACY_API__) {
      const h = g.__getInstance(e);
      h != null && (c = h.__composer, o && c && !c[wv] && (c = null));
    }
    if (c != null || r === e)
      break;
    e = e.parent;
  }
  return c;
}
function Kx(s, i = !1) {
  return s == null ? null : i && s.vnode.ctx || s.parent;
}
function Qx(s, i, o) {
  let c = null;
  Na(() => {
    if (process.env.NODE_ENV !== "production" && i.vnode.el) {
      i.vnode.el.__VUE_I18N__ = o, c = Om();
      const r = o;
      r[Oi] && r[Oi](c), c.on("*", jo);
    }
  }, i), _l(() => {
    const r = o;
    process.env.NODE_ENV !== "production" && i.vnode.el && i.vnode.el.__VUE_I18N__ && (c && c.off("*", jo), r[Xo] && r[Xo](), delete i.vnode.el.__VUE_I18N__), s.__deleteInstance(i);
    const e = r[sm];
    e && (e(), delete r[sm]);
  }, i);
}
function Xx(s, i, o, c = {}) {
  const r = i === "local", e = T1(null);
  if (r && s.proxy && !(s.proxy.$options.i18n || s.proxy.$options.__i18n))
    throw En(fr.MUST_DEFINE_I18N_OPTION_IN_ALLOW_COMPOSITION);
  const g = ar(c.inheritLocale) ? c.inheritLocale : !dt(c.locale), h = pt(
    // prettier-ignore
    !r || g ? o.locale.value : dt(c.locale) ? c.locale : eo
  ), S = pt(
    // prettier-ignore
    !r || g ? o.fallbackLocale.value : dt(c.fallbackLocale) || Gr(c.fallbackLocale) || zt(c.fallbackLocale) || c.fallbackLocale === !1 ? c.fallbackLocale : h.value
  ), C = pt(Cl(h.value, c)), O = pt(zt(c.datetimeFormats) ? c.datetimeFormats : { [h.value]: {} }), N = pt(zt(c.numberFormats) ? c.numberFormats : { [h.value]: {} }), D = r ? o.missingWarn : ar(c.missingWarn) || Ja(c.missingWarn) ? c.missingWarn : !0, x = r ? o.fallbackWarn : ar(c.fallbackWarn) || Ja(c.fallbackWarn) ? c.fallbackWarn : !0, L = r ? o.fallbackRoot : ar(c.fallbackRoot) ? c.fallbackRoot : !0, G = !!c.fallbackFormat, Y = Mr(c.missing) ? c.missing : null, k = Mr(c.postTranslation) ? c.postTranslation : null, W = r ? o.warnHtmlMessage : ar(c.warnHtmlMessage) ? c.warnHtmlMessage : !0, Z = !!c.escapeParameter, H = r ? o.modifiers : zt(c.modifiers) ? c.modifiers : {}, K = c.pluralRules || r && o.pluralRules;
  function Q() {
    return [
      h.value,
      S.value,
      C.value,
      O.value,
      N.value
    ];
  }
  const _e = Vt({
    get: () => e.value ? e.value.locale.value : h.value,
    set: (V) => {
      e.value && (e.value.locale.value = V), h.value = V;
    }
  }), se = Vt({
    get: () => e.value ? e.value.fallbackLocale.value : S.value,
    set: (V) => {
      e.value && (e.value.fallbackLocale.value = V), S.value = V;
    }
  }), Pe = Vt(() => e.value ? e.value.messages.value : C.value), Ke = Vt(() => O.value), ye = Vt(() => N.value);
  function Je() {
    return e.value ? e.value.getPostTranslationHandler() : k;
  }
  function mt(V) {
    e.value && e.value.setPostTranslationHandler(V);
  }
  function ge() {
    return e.value ? e.value.getMissingHandler() : Y;
  }
  function w(V) {
    e.value && e.value.setMissingHandler(V);
  }
  function fe(V) {
    return Q(), V();
  }
  function j(...V) {
    return e.value ? fe(() => Reflect.apply(e.value.t, null, [...V])) : fe(() => "");
  }
  function J(...V) {
    return e.value ? Reflect.apply(e.value.rt, null, [...V]) : "";
  }
  function de(...V) {
    return e.value ? fe(() => Reflect.apply(e.value.d, null, [...V])) : fe(() => "");
  }
  function ie(...V) {
    return e.value ? fe(() => Reflect.apply(e.value.n, null, [...V])) : fe(() => "");
  }
  function X(V) {
    return e.value ? e.value.tm(V) : {};
  }
  function ue(V, Te) {
    return e.value ? e.value.te(V, Te) : !1;
  }
  function Oe(V) {
    return e.value ? e.value.getLocaleMessage(V) : {};
  }
  function Re(V, Te) {
    e.value && (e.value.setLocaleMessage(V, Te), C.value[V] = Te);
  }
  function ae(V, Te) {
    e.value && e.value.mergeLocaleMessage(V, Te);
  }
  function Ee(V) {
    return e.value ? e.value.getDateTimeFormat(V) : {};
  }
  function ne(V, Te) {
    e.value && (e.value.setDateTimeFormat(V, Te), O.value[V] = Te);
  }
  function Ge(V, Te) {
    e.value && e.value.mergeDateTimeFormat(V, Te);
  }
  function we(V) {
    return e.value ? e.value.getNumberFormat(V) : {};
  }
  function st(V, Te) {
    e.value && (e.value.setNumberFormat(V, Te), N.value[V] = Te);
  }
  function Rt(V, Te) {
    e.value && e.value.mergeNumberFormat(V, Te);
  }
  const rt = {
    get id() {
      return e.value ? e.value.id : -1;
    },
    locale: _e,
    fallbackLocale: se,
    messages: Pe,
    datetimeFormats: Ke,
    numberFormats: ye,
    get inheritLocale() {
      return e.value ? e.value.inheritLocale : g;
    },
    set inheritLocale(V) {
      e.value && (e.value.inheritLocale = V);
    },
    get availableLocales() {
      return e.value ? e.value.availableLocales : Object.keys(C.value);
    },
    get modifiers() {
      return e.value ? e.value.modifiers : H;
    },
    get pluralRules() {
      return e.value ? e.value.pluralRules : K;
    },
    get isGlobal() {
      return e.value ? e.value.isGlobal : !1;
    },
    get missingWarn() {
      return e.value ? e.value.missingWarn : D;
    },
    set missingWarn(V) {
      e.value && (e.value.missingWarn = V);
    },
    get fallbackWarn() {
      return e.value ? e.value.fallbackWarn : x;
    },
    set fallbackWarn(V) {
      e.value && (e.value.missingWarn = V);
    },
    get fallbackRoot() {
      return e.value ? e.value.fallbackRoot : L;
    },
    set fallbackRoot(V) {
      e.value && (e.value.fallbackRoot = V);
    },
    get fallbackFormat() {
      return e.value ? e.value.fallbackFormat : G;
    },
    set fallbackFormat(V) {
      e.value && (e.value.fallbackFormat = V);
    },
    get warnHtmlMessage() {
      return e.value ? e.value.warnHtmlMessage : W;
    },
    set warnHtmlMessage(V) {
      e.value && (e.value.warnHtmlMessage = V);
    },
    get escapeParameter() {
      return e.value ? e.value.escapeParameter : Z;
    },
    set escapeParameter(V) {
      e.value && (e.value.escapeParameter = V);
    },
    t: j,
    getPostTranslationHandler: Je,
    setPostTranslationHandler: mt,
    getMissingHandler: ge,
    setMissingHandler: w,
    rt: J,
    d: de,
    n: ie,
    tm: X,
    te: ue,
    getLocaleMessage: Oe,
    setLocaleMessage: Re,
    mergeLocaleMessage: ae,
    getDateTimeFormat: Ee,
    setDateTimeFormat: ne,
    mergeDateTimeFormat: Ge,
    getNumberFormat: we,
    setNumberFormat: st,
    mergeNumberFormat: Rt
  };
  function z(V) {
    V.locale.value = h.value, V.fallbackLocale.value = S.value, Object.keys(C.value).forEach((Te) => {
      V.mergeLocaleMessage(Te, C.value[Te]);
    }), Object.keys(O.value).forEach((Te) => {
      V.mergeDateTimeFormat(Te, O.value[Te]);
    }), Object.keys(N.value).forEach((Te) => {
      V.mergeNumberFormat(Te, N.value[Te]);
    }), V.escapeParameter = Z, V.fallbackFormat = G, V.fallbackRoot = L, V.fallbackWarn = x, V.missingWarn = D, V.warnHtmlMessage = W;
  }
  return h1(() => {
    if (s.proxy == null || s.proxy.$i18n == null)
      throw En(fr.NOT_AVAILABLE_COMPOSITION_IN_LEGACY);
    const V = e.value = s.proxy.$i18n.__composer;
    i === "global" ? (h.value = V.locale.value, S.value = V.fallbackLocale.value, C.value = V.messages.value, O.value = V.datetimeFormats.value, N.value = V.numberFormats.value) : r && z(V);
  }), rt;
}
const Zx = [
  "locale",
  "fallbackLocale",
  "availableLocales"
], wS = ["t", "rt", "d", "n", "tm", "te"];
function jx(s, i) {
  const o = /* @__PURE__ */ Object.create(null);
  return Zx.forEach((r) => {
    const e = Object.getOwnPropertyDescriptor(i, r);
    if (!e)
      throw En(fr.UNEXPECTED_ERROR);
    const g = uA(e.value) ? {
      get() {
        return e.value.value;
      },
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      set(h) {
        e.value.value = h;
      }
    } : {
      get() {
        return e.get && e.get();
      }
    };
    Object.defineProperty(o, r, g);
  }), s.config.globalProperties.$i18n = o, wS.forEach((r) => {
    const e = Object.getOwnPropertyDescriptor(i, r);
    if (!e || !e.value)
      throw En(fr.UNEXPECTED_ERROR);
    Object.defineProperty(s.config.globalProperties, `$${r}`, e);
  }), () => {
    delete s.config.globalProperties.$i18n, wS.forEach((r) => {
      delete s.config.globalProperties[`$${r}`];
    });
  };
}
px();
__INTLIFY_JIT_COMPILATION__ ? cS(ox) : cS(ix);
Zw(ww);
jw(pv);
if (process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__) {
  const s = Ua();
  s.__INTLIFY__ = !0, Gw(s.__INTLIFY_DEVTOOLS_GLOBAL_HOOK__);
}
process.env.NODE_ENV;
const Jx = {
  en: {
    btn: {
      등록: "Registration",
      목록: "List",
      번역: "Translate",
      로그아웃: "Logout",
      삭제: "Delete",
      확인: "Check",
      조회: "Search",
      엑셀다운로드: "EXCEL DOWNLOAD",
      사용자매뉴얼: "User Manual",
      ENG: "KR",
      저장: "Save",
      설정: "Setting",
      "행 추가": "Adding row",
      "행 삭제": "Deleting row",
      닫기: "Close",
      추가: "Add",
      엑셀: "EXCEL DOWNLOAD",
      참가신청: "Application for Participation",
      종료: "Finished",
      행복사: "Copy Row",
      행추가: "Add Row",
      행삭제: "Delete Row",
      신규: "New",
      승인: "Approval",
      반려: "returning",
      최종대진: "The final march",
      종합점수집계: "Score totalizing",
      "입상자 등록": "Registration of winners",
      주소검색: "Address Lookup",
      연장: "Extension",
      수정: "Edit",
      좌표가져오기: "Get Coordinates",
      우편번호찾기: "Find ZIP Code",
      강좌개강생성: "Course Reformation Creation",
      유효성검사: "Validation Test",
      현장결제: "On-site payment",
      초기화: "Reset",
      "확정/계산": "Confirmation/Calculation",
      엑셀업로드: "EXCEL DOWNLOAD",
      validation체크: "Validation check",
      사진: "Picture",
      반납: "Return",
      반납취소: "Cancellation of return",
      일괄출석: "Attendance Check",
      탈퇴: "Cancel Membership",
      전체펼치기: "Expand all",
      전체닫기: "Close all",
      다운로드: "Download",
      엔트리정보현황: "Entry information status",
      선택: "Selection",
      토너먼트대진배정: "Tournament match assignment",
      지우기: "Erase",
      상동: "LINE COPY",
      중복체크: "Duplicate check",
      "주소 검색": "Address Search",
      "승인 취소": "Approval Cancel",
      선수: "Player",
      감독: "Coach",
      "엔트리 적용": "Entry Apply",
      "그룹 정보 등록 화면이동": "Group Information Registration Screen Move",
      "체크된 팀 위치 바꾸기": "Change the checked team position",
      "자동 조편성": "Automatic team formation",
      "최종 조편성": "Final team formation",
      "레인 배정": "Lane assignment",
      "순서 배정": "Order assignment",
      "팀별 최종경기결과 처리": "Final game results processing by team",
      발급: "Issue",
      취소: "Cancel",
      적용: "Apply",
      일괄납부: "Pay in full",
      결제: "Payment",
      답글달기: "Reply",
      "스케쥴 생성": "create schedule",
      답글수정: "Edit reply",
      QR결제: "QR Payment",
      문자수신: "SMS reception",
      ID중복확인: "ID duplication check",
      파일첨부: "File attachment",
      "비밀번호 초기화": "Reset Password",
      "오류 초기화": "Reset Error",
      수강신청: "Course registration",
      권한회수: "Revocation of authority",
      권한부여: "Authorization",
      글쓰기: "writing",
      안내문서확인: "Check the guide document",
      미리보기: "preview",
      템플릿적용: "Apply template",
      대관취소: "Rental cancellation",
      온라인수강신청설정: "Online course registration settings",
      사용료감면설정: "Set usage fee reduction",
      클럽가맹점정보: "Club affiliate information",
      거부: "Refusal",
      보기: "View",
      순위초기화: "Ranking Reset",
      "참가팀 종별 일괄변경": "Bulk change by participating team type",
      "반려 취소": "Return Cancel",
      정산내역불러오기: "Load settlement details",
      "참가팀 종별 변경": "Change Competition type",
      "참가팀 종별 변경(전체)": "Change Competition type (all)",
      신청: "Apply",
      참가취소: "Cancel Participation",
      강습인원수정: "Edit class capacity",
      지도자일괄변경: "Bulk Change of Leaders",
      신용카드: "Credit Card",
      계좌이체: "Bank Transfer",
      "결제요청 문자발신": "Payment Request SMS Transmission",
      종목별실제참가자수현황: "Actual number of participants by event",
      연령대별참가자수현황: "Number of participants by age group",
      초청클럽조회: "Invited Club Inquiry",
      수강확정: "Course Confirmation",
      대기취소: "Cancel Waiting",
      일괄저장: "Bulk Save",
      청구내역추가: "Add Billing Details",
      "정산 내역 등록": "Settlement Details Registration",
      참가상품등록: "Participation Product Registration",
      "심판 정산 등록": "Referee Settlement Registration",
      "임원 정산 등록": "Executive Settlement Registration",
      "경기운영요원 정산 등록": "Game Operator Settlement Registration",
      강좌보기: "View Course",
      전체출석: "All Attendance",
      출력: "Print",
      전송: "Send",
      기타결제: "Other Payment",
      강좌적용: "Apply Course",
      강좌삭제: "Delete Course",
      상세보기: "Detail",
      패널티등록: "Penalty Registration",
      입출고내역등록: "Register entry/exit details",
      발급완료: "Issued",
      발급취소: "Cancel",
      일정일괄생성: "Bulk schedule creation",
      일정생성: "Create Schedule",
      홈페이지미리보기: "Preview",
      확정취소: "Cancel Confirmation",
      확정: "Confirmation",
      강좌추첨: "Course Lottery",
      발송: "Send",
      권한취소: "Cancel",
      SMS일괄발송: "SMS Bulk Send",
      결제권한일괄부여: "Payment Authority Bulk Grant",
      환불: "Refund",
      추가결제: "Additional Payment",
      신청취소: "Cancel Application",
      승인요청: "Request for approval",
      정산확정: "Settlement Confirmation"
    }
  },
  ko: {
    btn: {
      취소: "취소",
      ID중복확인: "ID중복확인",
      결제: "결제",
      일괄납부: "일괄납부",
      적용: "적용",
      중복체크: "중복체크",
      등록: "등록",
      목록: "목록",
      번역: "번역",
      로그아웃: "로그아웃",
      삭제: "삭제",
      확인: "확인",
      조회: "조회",
      엑셀다운로드: "엑셀 다운로드",
      사용자매뉴얼: "사용자 매뉴얼",
      ENG: "ENG",
      저장: "저장",
      설정: "설정",
      "행 추가": "행 추가",
      "행 삭제": "행 삭제",
      닫기: "닫기",
      추가: "추가",
      엑셀: "엑셀 다운로드",
      참가신청: "참가신청",
      종료: "종료",
      행복사: "행복사",
      행추가: "행추가",
      행삭제: "행삭제",
      신규: "신규",
      승인: "승인",
      반려: "반려",
      최종대진: "최종대진",
      종합점수집계: "종합점수집계",
      "입상자 등록": "입상자 등록",
      주소검색: "주소 검색",
      연장: "연장",
      수정: "수정",
      좌표가져오기: "좌표가져오기",
      우편번호찾기: "우편번호찾기",
      강좌개강생성: "강좌개강생성",
      유효성검사: "유효성검사",
      현장결제: "현장결제",
      초기화: "초기화",
      "확정/계산": "확정/계산",
      엑셀업로드: "엑셀업로드",
      validation체크: "validation체크",
      사진: "사진",
      반납: "반납",
      반납취소: "반납취소",
      일괄출석: "일괄출석",
      탈퇴: "탈퇴",
      전체펼치기: "전체펼치기",
      전체닫기: "전체닫기",
      다운로드: "다운로드",
      엔트리정보현황: "엔트리정보현황",
      선택: "선택",
      토너먼트대진배정: "토너먼트대진배정",
      지우기: "지우기",
      상동: "상동",
      "주소 검색": "주소 검색",
      "승인 취소": "승인 취소",
      선수: "선수",
      감독: "감독",
      "엔트리 적용": "엔트리 적용",
      "그룹 정보 등록 화면이동": "그룹 정보 등록 화면이동",
      "체크된 팀 위치 바꾸기": "체크된 팀 위치 바꾸기",
      "자동 조편성": "자동 조편성",
      "최종 조편성": "최종 조편성",
      "레인 배정": "레인 배정",
      "순서 배정": "순서 배정",
      "팀별 최종경기결과 처리": "팀별 최종경기결과 처리",
      발급: "발급",
      답글달기: "답글달기",
      "스케쥴 생성": "스케쥴 생성",
      답글수정: "답글수정",
      QR결제: "QR결제",
      문자수신: "문자수신",
      파일첨부: "파일첨부",
      "비밀번호 초기화": "비밀번호 초기화",
      "오류 초기화": "오류 초기화",
      수강신청: "수강신청",
      권한회수: "권한회수",
      권한부여: "권한부여",
      글쓰기: "글쓰기",
      안내문서확인: "안내문서확인",
      미리보기: "미리보기",
      템플릿적용: "템플릿적용",
      대관취소: "대관취소",
      온라인수강신청설정: "온라인수강신청설정",
      사용료감면설정: "사용료감면설정",
      클럽가맹점정보: "클럽가맹점정보",
      거부: "거부",
      보기: "보기",
      순위초기화: "순위초기화",
      "참가팀 종별 일괄변경": "참가팀 종별 일괄변경",
      "반려 취소": "반려 취소",
      정산내역불러오기: "정산내역불러오기",
      "참가팀 종별 변경": "참가팀 종별 변경",
      "참가팀 종별 변경(전체)": "참가팀 종별 변경(전체)",
      신청: "신청",
      참가취소: "참가취소",
      강습인원수정: "강습인원수정",
      지도자일괄변경: "지도자일괄변경",
      신용카드: "신용카드",
      계좌이체: "계좌이체",
      "결제요청 문자발신": "결제요청 문자발신",
      종목별실제참가자수현황: "종목별실제참가자수현황",
      연령대별참가자수현황: "연령대별참가자수현황",
      초청클럽조회: "초청클럽조회",
      수강확정: "수강확정",
      대기취소: "대기취소",
      일괄저장: "일괄저장",
      청구내역추가: "청구내역추가",
      "정산 내역 등록": "정산 내역 등록",
      참가상품등록: "참가상품등록",
      "심판 정산 등록": "심판 정산 등록",
      "임원 정산 등록": "임원 정산 등록",
      "경기운영요원 정산 등록": "경기운영요원 정산 등록",
      강좌보기: "강좌보기",
      전체출석: "전체출석",
      출력: "출력",
      전송: "전송",
      기타결제: "기타결제",
      강좌적용: "강좌적용",
      강좌삭제: "강좌삭제",
      상세보기: "상세보기",
      패널티등록: "패널티등록",
      입출고내역등록: "입출고내역등록",
      발급완료: "발급완료",
      발급취소: "발급취소",
      일정일괄생성: "일정일괄생성",
      일정생성: "일정생성",
      홈페이지미리보기: "홈페이지미리보기",
      확정취소: "확정취소",
      확정: "확정",
      강좌추첨: "강좌추첨",
      발송: "발송",
      권한취소: "권한취소",
      SMS일괄발송: "SMS일괄발송",
      결제권한일괄부여: "결제권한일괄부여",
      환불: "환불",
      추가결제: "추가결제",
      신청취소: "신청취소",
      승인요청: "승인요청",
      정산확정: "정산확정"
    }
  }
}, eL = Yx({
  legacy: !1,
  locale: "ko",
  // 기본 언어
  fallbackLocale: "en",
  // 영어를 대체 언어로 설정
  messages: Jx
});
function Bv(s) {
  return s instanceof Map ? s.clear = s.delete = s.set = function() {
    throw new Error("map is read-only");
  } : s instanceof Set && (s.add = s.clear = s.delete = function() {
    throw new Error("set is read-only");
  }), Object.freeze(s), Object.getOwnPropertyNames(s).forEach((i) => {
    const o = s[i], c = typeof o;
    (c === "object" || c === "function") && !Object.isFrozen(o) && Bv(o);
  }), s;
}
class xS {
  /**
   * @param {CompiledMode} mode
   */
  constructor(i) {
    i.data === void 0 && (i.data = {}), this.data = i.data, this.isMatchIgnored = !1;
  }
  ignoreMatch() {
    this.isMatchIgnored = !0;
  }
}
function Gv(s) {
  return s.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
}
function ja(s, ...i) {
  const o = /* @__PURE__ */ Object.create(null);
  for (const c in s)
    o[c] = s[c];
  return i.forEach(function(c) {
    for (const r in c)
      o[r] = c[r];
  }), /** @type {T} */
  o;
}
const tL = "</span>", LS = (s) => !!s.scope, rL = (s, { prefix: i }) => {
  if (s.startsWith("language:"))
    return s.replace("language:", "language-");
  if (s.includes(".")) {
    const o = s.split(".");
    return [
      `${i}${o.shift()}`,
      ...o.map((c, r) => `${c}${"_".repeat(r + 1)}`)
    ].join(" ");
  }
  return `${i}${s}`;
};
class nL {
  /**
   * Creates a new HTMLRenderer
   *
   * @param {Tree} parseTree - the parse tree (must support `walk` API)
   * @param {{classPrefix: string}} options
   */
  constructor(i, o) {
    this.buffer = "", this.classPrefix = o.classPrefix, i.walk(this);
  }
  /**
   * Adds texts to the output stream
   *
   * @param {string} text */
  addText(i) {
    this.buffer += Gv(i);
  }
  /**
   * Adds a node open to the output stream (if needed)
   *
   * @param {Node} node */
  openNode(i) {
    if (!LS(i))
      return;
    const o = rL(
      i.scope,
      { prefix: this.classPrefix }
    );
    this.span(o);
  }
  /**
   * Adds a node close to the output stream (if needed)
   *
   * @param {Node} node */
  closeNode(i) {
    LS(i) && (this.buffer += tL);
  }
  /**
   * returns the accumulated buffer
  */
  value() {
    return this.buffer;
  }
  // helpers
  /**
   * Builds a span element
   *
   * @param {string} className */
  span(i) {
    this.buffer += `<span class="${i}">`;
  }
}
const MS = (s = {}) => {
  const i = { children: [] };
  return Object.assign(i, s), i;
};
class Pm {
  constructor() {
    this.rootNode = MS(), this.stack = [this.rootNode];
  }
  get top() {
    return this.stack[this.stack.length - 1];
  }
  get root() {
    return this.rootNode;
  }
  /** @param {Node} node */
  add(i) {
    this.top.children.push(i);
  }
  /** @param {string} scope */
  openNode(i) {
    const o = MS({ scope: i });
    this.add(o), this.stack.push(o);
  }
  closeNode() {
    if (this.stack.length > 1)
      return this.stack.pop();
  }
  closeAllNodes() {
    for (; this.closeNode(); )
      ;
  }
  toJSON() {
    return JSON.stringify(this.rootNode, null, 4);
  }
  /**
   * @typedef { import("./html_renderer").Renderer } Renderer
   * @param {Renderer} builder
   */
  walk(i) {
    return this.constructor._walk(i, this.rootNode);
  }
  /**
   * @param {Renderer} builder
   * @param {Node} node
   */
  static _walk(i, o) {
    return typeof o == "string" ? i.addText(o) : o.children && (i.openNode(o), o.children.forEach((c) => this._walk(i, c)), i.closeNode(o)), i;
  }
  /**
   * @param {Node} node
   */
  static _collapse(i) {
    typeof i != "string" && i.children && (i.children.every((o) => typeof o == "string") ? i.children = [i.children.join("")] : i.children.forEach((o) => {
      Pm._collapse(o);
    }));
  }
}
class aL extends Pm {
  /**
   * @param {*} options
   */
  constructor(i) {
    super(), this.options = i;
  }
  /**
   * @param {string} text
   */
  addText(i) {
    i !== "" && this.add(i);
  }
  /** @param {string} scope */
  startScope(i) {
    this.openNode(i);
  }
  endScope() {
    this.closeNode();
  }
  /**
   * @param {Emitter & {root: DataNode}} emitter
   * @param {string} name
   */
  __addSublanguage(i, o) {
    const c = i.root;
    o && (c.scope = `language:${o}`), this.add(c);
  }
  toHTML() {
    return new nL(this, this.options).value();
  }
  finalize() {
    return this.closeAllNodes(), !0;
  }
}
function Jo(s) {
  return s ? typeof s == "string" ? s : s.source : null;
}
function Vv(s) {
  return Ii("(?=", s, ")");
}
function iL(s) {
  return Ii("(?:", s, ")*");
}
function oL(s) {
  return Ii("(?:", s, ")?");
}
function Ii(...s) {
  return s.map((o) => Jo(o)).join("");
}
function sL(s) {
  const i = s[s.length - 1];
  return typeof i == "object" && i.constructor === Object ? (s.splice(s.length - 1, 1), i) : {};
}
function km(...s) {
  return "(" + (sL(s).capture ? "" : "?:") + s.map((c) => Jo(c)).join("|") + ")";
}
function Yv(s) {
  return new RegExp(s.toString() + "|").exec("").length - 1;
}
function lL(s, i) {
  const o = s && s.exec(i);
  return o && o.index === 0;
}
const cL = /\[(?:[^\\\]]|\\.)*\]|\(\??|\\([1-9][0-9]*)|\\./;
function Fm(s, { joinWith: i }) {
  let o = 0;
  return s.map((c) => {
    o += 1;
    const r = o;
    let e = Jo(c), g = "";
    for (; e.length > 0; ) {
      const h = cL.exec(e);
      if (!h) {
        g += e;
        break;
      }
      g += e.substring(0, h.index), e = e.substring(h.index + h[0].length), h[0][0] === "\\" && h[1] ? g += "\\" + String(Number(h[1]) + r) : (g += h[0], h[0] === "(" && o++);
    }
    return g;
  }).map((c) => `(${c})`).join(i);
}
const dL = /\b\B/, Hv = "[a-zA-Z]\\w*", Um = "[a-zA-Z_]\\w*", qv = "\\b\\d+(\\.\\d+)?", $v = "(-?)(\\b0[xX][a-fA-F0-9]+|(\\b\\d+(\\.\\d*)?|\\.\\d+)([eE][-+]?\\d+)?)", Wv = "\\b(0b[01]+)", uL = "!|!=|!==|%|%=|&|&&|&=|\\*|\\*=|\\+|\\+=|,|-|-=|/=|/|:|;|<<|<<=|<=|<|===|==|=|>>>=|>>=|>=|>>>|>>|>|\\?|\\[|\\{|\\(|\\^|\\^=|\\||\\|=|\\|\\||~", _L = (s = {}) => {
  const i = /^#![ ]*\//;
  return s.binary && (s.begin = Ii(
    i,
    /.*\b/,
    s.binary,
    /\b.*/
  )), ja({
    scope: "meta",
    begin: i,
    end: /$/,
    relevance: 0,
    /** @type {ModeCallback} */
    "on:begin": (o, c) => {
      o.index !== 0 && c.ignoreMatch();
    }
  }, s);
}, es = {
  begin: "\\\\[\\s\\S]",
  relevance: 0
}, pL = {
  scope: "string",
  begin: "'",
  end: "'",
  illegal: "\\n",
  contains: [es]
}, mL = {
  scope: "string",
  begin: '"',
  end: '"',
  illegal: "\\n",
  contains: [es]
}, fL = {
  begin: /\b(a|an|the|are|I'm|isn't|don't|doesn't|won't|but|just|should|pretty|simply|enough|gonna|going|wtf|so|such|will|you|your|they|like|more)\b/
}, Rl = function(s, i, o = {}) {
  const c = ja(
    {
      scope: "comment",
      begin: s,
      end: i,
      contains: []
    },
    o
  );
  c.contains.push({
    scope: "doctag",
    // hack to avoid the space from being included. the space is necessary to
    // match here to prevent the plain text rule below from gobbling up doctags
    begin: "[ ]*(?=(TODO|FIXME|NOTE|BUG|OPTIMIZE|HACK|XXX):)",
    end: /(TODO|FIXME|NOTE|BUG|OPTIMIZE|HACK|XXX):/,
    excludeBegin: !0,
    relevance: 0
  });
  const r = km(
    // list of common 1 and 2 letter words in English
    "I",
    "a",
    "is",
    "so",
    "us",
    "to",
    "at",
    "if",
    "in",
    "it",
    "on",
    // note: this is not an exhaustive list of contractions, just popular ones
    /[A-Za-z]+['](d|ve|re|ll|t|s|n)/,
    // contractions - can't we'd they're let's, etc
    /[A-Za-z]+[-][a-z]+/,
    // `no-way`, etc.
    /[A-Za-z][a-z]{2,}/
    // allow capitalized words at beginning of sentences
  );
  return c.contains.push(
    {
      // TODO: how to include ", (, ) without breaking grammars that use these for
      // comment delimiters?
      // begin: /[ ]+([()"]?([A-Za-z'-]{3,}|is|a|I|so|us|[tT][oO]|at|if|in|it|on)[.]?[()":]?([.][ ]|[ ]|\))){3}/
      // ---
      // this tries to find sequences of 3 english words in a row (without any
      // "programming" type syntax) this gives us a strong signal that we've
      // TRULY found a comment - vs perhaps scanning with the wrong language.
      // It's possible to find something that LOOKS like the start of the
      // comment - but then if there is no readable text - good chance it is a
      // false match and not a comment.
      //
      // for a visual example please see:
      // https://github.com/highlightjs/highlight.js/issues/2827
      begin: Ii(
        /[ ]+/,
        // necessary to prevent us gobbling up doctags like /* @author Bob Mcgill */
        "(",
        r,
        /[.]?[:]?([.][ ]|[ ])/,
        "){3}"
      )
      // look for 3 words in a row
    }
  ), c;
}, gL = Rl("//", "$"), EL = Rl("/\\*", "\\*/"), hL = Rl("#", "$"), SL = {
  scope: "number",
  begin: qv,
  relevance: 0
}, bL = {
  scope: "number",
  begin: $v,
  relevance: 0
}, TL = {
  scope: "number",
  begin: Wv,
  relevance: 0
}, vL = {
  scope: "regexp",
  begin: /\/(?=[^/\n]*\/)/,
  end: /\/[gimuy]*/,
  contains: [
    es,
    {
      begin: /\[/,
      end: /\]/,
      relevance: 0,
      contains: [es]
    }
  ]
}, CL = {
  scope: "title",
  begin: Hv,
  relevance: 0
}, RL = {
  scope: "title",
  begin: Um,
  relevance: 0
}, NL = {
  // excludes method names from keyword processing
  begin: "\\.\\s*" + Um,
  relevance: 0
}, AL = function(s) {
  return Object.assign(
    s,
    {
      /** @type {ModeCallback} */
      "on:begin": (i, o) => {
        o.data._beginMatch = i[1];
      },
      /** @type {ModeCallback} */
      "on:end": (i, o) => {
        o.data._beginMatch !== i[1] && o.ignoreMatch();
      }
    }
  );
};
var Js = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  APOS_STRING_MODE: pL,
  BACKSLASH_ESCAPE: es,
  BINARY_NUMBER_MODE: TL,
  BINARY_NUMBER_RE: Wv,
  COMMENT: Rl,
  C_BLOCK_COMMENT_MODE: EL,
  C_LINE_COMMENT_MODE: gL,
  C_NUMBER_MODE: bL,
  C_NUMBER_RE: $v,
  END_SAME_AS_BEGIN: AL,
  HASH_COMMENT_MODE: hL,
  IDENT_RE: Hv,
  MATCH_NOTHING_RE: dL,
  METHOD_GUARD: NL,
  NUMBER_MODE: SL,
  NUMBER_RE: qv,
  PHRASAL_WORDS_MODE: fL,
  QUOTE_STRING_MODE: mL,
  REGEXP_MODE: vL,
  RE_STARTERS_RE: uL,
  SHEBANG: _L,
  TITLE_MODE: CL,
  UNDERSCORE_IDENT_RE: Um,
  UNDERSCORE_TITLE_MODE: RL
});
function OL(s, i) {
  s.input[s.index - 1] === "." && i.ignoreMatch();
}
function yL(s, i) {
  s.className !== void 0 && (s.scope = s.className, delete s.className);
}
function IL(s, i) {
  i && s.beginKeywords && (s.begin = "\\b(" + s.beginKeywords.split(" ").join("|") + ")(?!\\.)(?=\\b|\\s)", s.__beforeBegin = OL, s.keywords = s.keywords || s.beginKeywords, delete s.beginKeywords, s.relevance === void 0 && (s.relevance = 0));
}
function DL(s, i) {
  Array.isArray(s.illegal) && (s.illegal = km(...s.illegal));
}
function wL(s, i) {
  if (s.match) {
    if (s.begin || s.end)
      throw new Error("begin & end are not supported with match");
    s.begin = s.match, delete s.match;
  }
}
function xL(s, i) {
  s.relevance === void 0 && (s.relevance = 1);
}
const LL = (s, i) => {
  if (!s.beforeMatch)
    return;
  if (s.starts)
    throw new Error("beforeMatch cannot be used with starts");
  const o = Object.assign({}, s);
  Object.keys(s).forEach((c) => {
    delete s[c];
  }), s.keywords = o.keywords, s.begin = Ii(o.beforeMatch, Vv(o.begin)), s.starts = {
    relevance: 0,
    contains: [
      Object.assign(o, { endsParent: !0 })
    ]
  }, s.relevance = 0, delete o.beforeMatch;
}, ML = [
  "of",
  "and",
  "for",
  "in",
  "not",
  "or",
  "if",
  "then",
  "parent",
  // common variable name
  "list",
  // common variable name
  "value"
  // common variable name
], PL = "keyword";
function zv(s, i, o = PL) {
  const c = /* @__PURE__ */ Object.create(null);
  return typeof s == "string" ? r(o, s.split(" ")) : Array.isArray(s) ? r(o, s) : Object.keys(s).forEach(function(e) {
    Object.assign(
      c,
      zv(s[e], i, e)
    );
  }), c;
  function r(e, g) {
    i && (g = g.map((h) => h.toLowerCase())), g.forEach(function(h) {
      const S = h.split("|");
      c[S[0]] = [e, kL(S[0], S[1])];
    });
  }
}
function kL(s, i) {
  return i ? Number(i) : FL(s) ? 0 : 1;
}
function FL(s) {
  return ML.includes(s.toLowerCase());
}
const PS = {}, Ci = (s) => {
  console.error(s);
}, kS = (s, ...i) => {
  console.log(`WARN: ${s}`, ...i);
}, Qi = (s, i) => {
  PS[`${s}/${i}`] || (console.log(`Deprecated as of ${s}. ${i}`), PS[`${s}/${i}`] = !0);
}, dl = new Error();
function Kv(s, i, { key: o }) {
  let c = 0;
  const r = s[o], e = {}, g = {};
  for (let h = 1; h <= i.length; h++)
    g[h + c] = r[h], e[h + c] = !0, c += Yv(i[h - 1]);
  s[o] = g, s[o]._emit = e, s[o]._multi = !0;
}
function UL(s) {
  if (Array.isArray(s.begin)) {
    if (s.skip || s.excludeBegin || s.returnBegin)
      throw Ci("skip, excludeBegin, returnBegin not compatible with beginScope: {}"), dl;
    if (typeof s.beginScope != "object" || s.beginScope === null)
      throw Ci("beginScope must be object"), dl;
    Kv(s, s.begin, { key: "beginScope" }), s.begin = Fm(s.begin, { joinWith: "" });
  }
}
function BL(s) {
  if (Array.isArray(s.end)) {
    if (s.skip || s.excludeEnd || s.returnEnd)
      throw Ci("skip, excludeEnd, returnEnd not compatible with endScope: {}"), dl;
    if (typeof s.endScope != "object" || s.endScope === null)
      throw Ci("endScope must be object"), dl;
    Kv(s, s.end, { key: "endScope" }), s.end = Fm(s.end, { joinWith: "" });
  }
}
function GL(s) {
  s.scope && typeof s.scope == "object" && s.scope !== null && (s.beginScope = s.scope, delete s.scope);
}
function VL(s) {
  GL(s), typeof s.beginScope == "string" && (s.beginScope = { _wrap: s.beginScope }), typeof s.endScope == "string" && (s.endScope = { _wrap: s.endScope }), UL(s), BL(s);
}
function YL(s) {
  function i(g, h) {
    return new RegExp(
      Jo(g),
      "m" + (s.case_insensitive ? "i" : "") + (s.unicodeRegex ? "u" : "") + (h ? "g" : "")
    );
  }
  class o {
    constructor() {
      this.matchIndexes = {}, this.regexes = [], this.matchAt = 1, this.position = 0;
    }
    // @ts-ignore
    addRule(h, S) {
      S.position = this.position++, this.matchIndexes[this.matchAt] = S, this.regexes.push([S, h]), this.matchAt += Yv(h) + 1;
    }
    compile() {
      this.regexes.length === 0 && (this.exec = () => null);
      const h = this.regexes.map((S) => S[1]);
      this.matcherRe = i(Fm(h, { joinWith: "|" }), !0), this.lastIndex = 0;
    }
    /** @param {string} s */
    exec(h) {
      this.matcherRe.lastIndex = this.lastIndex;
      const S = this.matcherRe.exec(h);
      if (!S)
        return null;
      const C = S.findIndex((N, D) => D > 0 && N !== void 0), O = this.matchIndexes[C];
      return S.splice(0, C), Object.assign(S, O);
    }
  }
  class c {
    constructor() {
      this.rules = [], this.multiRegexes = [], this.count = 0, this.lastIndex = 0, this.regexIndex = 0;
    }
    // @ts-ignore
    getMatcher(h) {
      if (this.multiRegexes[h])
        return this.multiRegexes[h];
      const S = new o();
      return this.rules.slice(h).forEach(([C, O]) => S.addRule(C, O)), S.compile(), this.multiRegexes[h] = S, S;
    }
    resumingScanAtSamePosition() {
      return this.regexIndex !== 0;
    }
    considerAll() {
      this.regexIndex = 0;
    }
    // @ts-ignore
    addRule(h, S) {
      this.rules.push([h, S]), S.type === "begin" && this.count++;
    }
    /** @param {string} s */
    exec(h) {
      const S = this.getMatcher(this.regexIndex);
      S.lastIndex = this.lastIndex;
      let C = S.exec(h);
      if (this.resumingScanAtSamePosition() && !(C && C.index === this.lastIndex)) {
        const O = this.getMatcher(0);
        O.lastIndex = this.lastIndex + 1, C = O.exec(h);
      }
      return C && (this.regexIndex += C.position + 1, this.regexIndex === this.count && this.considerAll()), C;
    }
  }
  function r(g) {
    const h = new c();
    return g.contains.forEach((S) => h.addRule(S.begin, { rule: S, type: "begin" })), g.terminatorEnd && h.addRule(g.terminatorEnd, { type: "end" }), g.illegal && h.addRule(g.illegal, { type: "illegal" }), h;
  }
  function e(g, h) {
    const S = (
      /** @type CompiledMode */
      g
    );
    if (g.isCompiled)
      return S;
    [
      yL,
      // do this early so compiler extensions generally don't have to worry about
      // the distinction between match/begin
      wL,
      VL,
      LL
    ].forEach((O) => O(g, h)), s.compilerExtensions.forEach((O) => O(g, h)), g.__beforeBegin = null, [
      IL,
      // do this later so compiler extensions that come earlier have access to the
      // raw array if they wanted to perhaps manipulate it, etc.
      DL,
      // default to 1 relevance if not specified
      xL
    ].forEach((O) => O(g, h)), g.isCompiled = !0;
    let C = null;
    return typeof g.keywords == "object" && g.keywords.$pattern && (g.keywords = Object.assign({}, g.keywords), C = g.keywords.$pattern, delete g.keywords.$pattern), C = C || /\w+/, g.keywords && (g.keywords = zv(g.keywords, s.case_insensitive)), S.keywordPatternRe = i(C, !0), h && (g.begin || (g.begin = /\B|\b/), S.beginRe = i(S.begin), !g.end && !g.endsWithParent && (g.end = /\B|\b/), g.end && (S.endRe = i(S.end)), S.terminatorEnd = Jo(S.end) || "", g.endsWithParent && h.terminatorEnd && (S.terminatorEnd += (g.end ? "|" : "") + h.terminatorEnd)), g.illegal && (S.illegalRe = i(
      /** @type {RegExp | string} */
      g.illegal
    )), g.contains || (g.contains = []), g.contains = [].concat(...g.contains.map(function(O) {
      return HL(O === "self" ? g : O);
    })), g.contains.forEach(function(O) {
      e(
        /** @type Mode */
        O,
        S
      );
    }), g.starts && e(g.starts, h), S.matcher = r(S), S;
  }
  if (s.compilerExtensions || (s.compilerExtensions = []), s.contains && s.contains.includes("self"))
    throw new Error("ERR: contains `self` is not supported at the top-level of a language.  See documentation.");
  return s.classNameAliases = ja(s.classNameAliases || {}), e(
    /** @type Mode */
    s
  );
}
function Qv(s) {
  return s ? s.endsWithParent || Qv(s.starts) : !1;
}
function HL(s) {
  return s.variants && !s.cachedVariants && (s.cachedVariants = s.variants.map(function(i) {
    return ja(s, { variants: null }, i);
  })), s.cachedVariants ? s.cachedVariants : Qv(s) ? ja(s, { starts: s.starts ? ja(s.starts) : null }) : Object.isFrozen(s) ? ja(s) : s;
}
var qL = "11.9.0";
class $L extends Error {
  constructor(i, o) {
    super(i), this.name = "HTMLInjectionError", this.html = o;
  }
}
const ud = Gv, FS = ja, US = Symbol("nomatch"), WL = 7, Xv = function(s) {
  const i = /* @__PURE__ */ Object.create(null), o = /* @__PURE__ */ Object.create(null), c = [];
  let r = !0;
  const e = "Could not find the language '{}', did you forget to load/include a language module?", g = { disableAutodetect: !0, name: "Plain text", contains: [] };
  let h = {
    ignoreUnescapedHTML: !1,
    throwUnescapedHTML: !1,
    noHighlightRe: /^(no-?highlight)$/i,
    languageDetectRe: /\blang(?:uage)?-([\w-]+)\b/i,
    classPrefix: "hljs-",
    cssSelector: "pre code",
    languages: null,
    // beta configuration options, subject to change, welcome to discuss
    // https://github.com/highlightjs/highlight.js/issues/1086
    __emitter: aL
  };
  function S(j) {
    return h.noHighlightRe.test(j);
  }
  function C(j) {
    let J = j.className + " ";
    J += j.parentNode ? j.parentNode.className : "";
    const de = h.languageDetectRe.exec(J);
    if (de) {
      const ie = Pe(de[1]);
      return ie || (kS(e.replace("{}", de[1])), kS("Falling back to no-highlight mode for this block.", j)), ie ? de[1] : "no-highlight";
    }
    return J.split(/\s+/).find((ie) => S(ie) || Pe(ie));
  }
  function O(j, J, de) {
    let ie = "", X = "";
    typeof J == "object" ? (ie = j, de = J.ignoreIllegals, X = J.language) : (Qi("10.7.0", "highlight(lang, code, ...args) has been deprecated."), Qi("10.7.0", `Please use highlight(code, options) instead.
https://github.com/highlightjs/highlight.js/issues/2277`), X = j, ie = J), de === void 0 && (de = !0);
    const ue = {
      code: ie,
      language: X
    };
    w("before:highlight", ue);
    const Oe = ue.result ? ue.result : N(ue.language, ue.code, de);
    return Oe.code = ue.code, w("after:highlight", Oe), Oe;
  }
  function N(j, J, de, ie) {
    const X = /* @__PURE__ */ Object.create(null);
    function ue(pe, qe) {
      return pe.keywords[qe];
    }
    function Oe() {
      if (!Nt.keywords) {
        Er.addText(tr);
        return;
      }
      let pe = 0;
      Nt.keywordPatternRe.lastIndex = 0;
      let qe = Nt.keywordPatternRe.exec(tr), bt = "";
      for (; qe; ) {
        bt += tr.substring(pe, qe.index);
        const Gt = Be.case_insensitive ? qe[0].toLowerCase() : qe[0], Ur = ue(Nt, Gt);
        if (Ur) {
          const [qr, Fn] = Ur;
          if (Er.addText(bt), bt = "", X[Gt] = (X[Gt] || 0) + 1, X[Gt] <= WL && (vr += Fn), qr.startsWith("_"))
            bt += qe[0];
          else {
            const Ga = Be.classNameAliases[qr] || qr;
            Ee(qe[0], Ga);
          }
        } else
          bt += qe[0];
        pe = Nt.keywordPatternRe.lastIndex, qe = Nt.keywordPatternRe.exec(tr);
      }
      bt += tr.substring(pe), Er.addText(bt);
    }
    function Re() {
      if (tr === "")
        return;
      let pe = null;
      if (typeof Nt.subLanguage == "string") {
        if (!i[Nt.subLanguage]) {
          Er.addText(tr);
          return;
        }
        pe = N(Nt.subLanguage, tr, !0, Hr[Nt.subLanguage]), Hr[Nt.subLanguage] = /** @type {CompiledMode} */
        pe._top;
      } else
        pe = x(tr, Nt.subLanguage.length ? Nt.subLanguage : null);
      Nt.relevance > 0 && (vr += pe.relevance), Er.__addSublanguage(pe._emitter, pe.language);
    }
    function ae() {
      Nt.subLanguage != null ? Re() : Oe(), tr = "";
    }
    function Ee(pe, qe) {
      pe !== "" && (Er.startScope(qe), Er.addText(pe), Er.endScope());
    }
    function ne(pe, qe) {
      let bt = 1;
      const Gt = qe.length - 1;
      for (; bt <= Gt; ) {
        if (!pe._emit[bt]) {
          bt++;
          continue;
        }
        const Ur = Be.classNameAliases[pe[bt]] || pe[bt], qr = qe[bt];
        Ur ? Ee(qr, Ur) : (tr = qr, Oe(), tr = ""), bt++;
      }
    }
    function Ge(pe, qe) {
      return pe.scope && typeof pe.scope == "string" && Er.openNode(Be.classNameAliases[pe.scope] || pe.scope), pe.beginScope && (pe.beginScope._wrap ? (Ee(tr, Be.classNameAliases[pe.beginScope._wrap] || pe.beginScope._wrap), tr = "") : pe.beginScope._multi && (ne(pe.beginScope, qe), tr = "")), Nt = Object.create(pe, { parent: { value: Nt } }), Nt;
    }
    function we(pe, qe, bt) {
      let Gt = lL(pe.endRe, bt);
      if (Gt) {
        if (pe["on:end"]) {
          const Ur = new xS(pe);
          pe["on:end"](qe, Ur), Ur.isMatchIgnored && (Gt = !1);
        }
        if (Gt) {
          for (; pe.endsParent && pe.parent; )
            pe = pe.parent;
          return pe;
        }
      }
      if (pe.endsWithParent)
        return we(pe.parent, qe, bt);
    }
    function st(pe) {
      return Nt.matcher.regexIndex === 0 ? (tr += pe[0], 1) : (Ae = !0, 0);
    }
    function Rt(pe) {
      const qe = pe[0], bt = pe.rule, Gt = new xS(bt), Ur = [bt.__beforeBegin, bt["on:begin"]];
      for (const qr of Ur)
        if (qr && (qr(pe, Gt), Gt.isMatchIgnored))
          return st(qe);
      return bt.skip ? tr += qe : (bt.excludeBegin && (tr += qe), ae(), !bt.returnBegin && !bt.excludeBegin && (tr = qe)), Ge(bt, pe), bt.returnBegin ? 0 : qe.length;
    }
    function rt(pe) {
      const qe = pe[0], bt = J.substring(pe.index), Gt = we(Nt, pe, bt);
      if (!Gt)
        return US;
      const Ur = Nt;
      Nt.endScope && Nt.endScope._wrap ? (ae(), Ee(qe, Nt.endScope._wrap)) : Nt.endScope && Nt.endScope._multi ? (ae(), ne(Nt.endScope, pe)) : Ur.skip ? tr += qe : (Ur.returnEnd || Ur.excludeEnd || (tr += qe), ae(), Ur.excludeEnd && (tr = qe));
      do
        Nt.scope && Er.closeNode(), !Nt.skip && !Nt.subLanguage && (vr += Nt.relevance), Nt = Nt.parent;
      while (Nt !== Gt.parent);
      return Gt.starts && Ge(Gt.starts, pe), Ur.returnEnd ? 0 : qe.length;
    }
    function z() {
      const pe = [];
      for (let qe = Nt; qe !== Be; qe = qe.parent)
        qe.scope && pe.unshift(qe.scope);
      pe.forEach((qe) => Er.openNode(qe));
    }
    let V = {};
    function Te(pe, qe) {
      const bt = qe && qe[0];
      if (tr += pe, bt == null)
        return ae(), 0;
      if (V.type === "begin" && qe.type === "end" && V.index === qe.index && bt === "") {
        if (tr += J.slice(qe.index, qe.index + 1), !r) {
          const Gt = new Error(`0 width match regex (${j})`);
          throw Gt.languageName = j, Gt.badRule = V.rule, Gt;
        }
        return 1;
      }
      if (V = qe, qe.type === "begin")
        return Rt(qe);
      if (qe.type === "illegal" && !de) {
        const Gt = new Error('Illegal lexeme "' + bt + '" for mode "' + (Nt.scope || "<unnamed>") + '"');
        throw Gt.mode = Nt, Gt;
      } else if (qe.type === "end") {
        const Gt = rt(qe);
        if (Gt !== US)
          return Gt;
      }
      if (qe.type === "illegal" && bt === "")
        return 1;
      if (ur > 1e5 && ur > qe.index * 3)
        throw new Error("potential infinite loop, way more iterations than matches");
      return tr += bt, bt.length;
    }
    const Be = Pe(j);
    if (!Be)
      throw Ci(e.replace("{}", j)), new Error('Unknown language: "' + j + '"');
    const Le = YL(Be);
    let Yt = "", Nt = ie || Le;
    const Hr = {}, Er = new h.__emitter(h);
    z();
    let tr = "", vr = 0, Pr = 0, ur = 0, Ae = !1;
    try {
      if (Be.__emitTokens)
        Be.__emitTokens(J, Er);
      else {
        for (Nt.matcher.considerAll(); ; ) {
          ur++, Ae ? Ae = !1 : Nt.matcher.considerAll(), Nt.matcher.lastIndex = Pr;
          const pe = Nt.matcher.exec(J);
          if (!pe)
            break;
          const qe = J.substring(Pr, pe.index), bt = Te(qe, pe);
          Pr = pe.index + bt;
        }
        Te(J.substring(Pr));
      }
      return Er.finalize(), Yt = Er.toHTML(), {
        language: j,
        value: Yt,
        relevance: vr,
        illegal: !1,
        _emitter: Er,
        _top: Nt
      };
    } catch (pe) {
      if (pe.message && pe.message.includes("Illegal"))
        return {
          language: j,
          value: ud(J),
          illegal: !0,
          relevance: 0,
          _illegalBy: {
            message: pe.message,
            index: Pr,
            context: J.slice(Pr - 100, Pr + 100),
            mode: pe.mode,
            resultSoFar: Yt
          },
          _emitter: Er
        };
      if (r)
        return {
          language: j,
          value: ud(J),
          illegal: !1,
          relevance: 0,
          errorRaised: pe,
          _emitter: Er,
          _top: Nt
        };
      throw pe;
    }
  }
  function D(j) {
    const J = {
      value: ud(j),
      illegal: !1,
      relevance: 0,
      _top: g,
      _emitter: new h.__emitter(h)
    };
    return J._emitter.addText(j), J;
  }
  function x(j, J) {
    J = J || h.languages || Object.keys(i);
    const de = D(j), ie = J.filter(Pe).filter(ye).map(
      (ae) => N(ae, j, !1)
    );
    ie.unshift(de);
    const X = ie.sort((ae, Ee) => {
      if (ae.relevance !== Ee.relevance)
        return Ee.relevance - ae.relevance;
      if (ae.language && Ee.language) {
        if (Pe(ae.language).supersetOf === Ee.language)
          return 1;
        if (Pe(Ee.language).supersetOf === ae.language)
          return -1;
      }
      return 0;
    }), [ue, Oe] = X, Re = ue;
    return Re.secondBest = Oe, Re;
  }
  function L(j, J, de) {
    const ie = J && o[J] || de;
    j.classList.add("hljs"), j.classList.add(`language-${ie}`);
  }
  function G(j) {
    let J = null;
    const de = C(j);
    if (S(de))
      return;
    if (w(
      "before:highlightElement",
      { el: j, language: de }
    ), j.dataset.highlighted) {
      console.log("Element previously highlighted. To highlight again, first unset `dataset.highlighted`.", j);
      return;
    }
    if (j.children.length > 0 && (h.ignoreUnescapedHTML || (console.warn("One of your code blocks includes unescaped HTML. This is a potentially serious security risk."), console.warn("https://github.com/highlightjs/highlight.js/wiki/security"), console.warn("The element with unescaped HTML:"), console.warn(j)), h.throwUnescapedHTML))
      throw new $L(
        "One of your code blocks includes unescaped HTML.",
        j.innerHTML
      );
    J = j;
    const ie = J.textContent, X = de ? O(ie, { language: de, ignoreIllegals: !0 }) : x(ie);
    j.innerHTML = X.value, j.dataset.highlighted = "yes", L(j, de, X.language), j.result = {
      language: X.language,
      // TODO: remove with version 11.0
      re: X.relevance,
      relevance: X.relevance
    }, X.secondBest && (j.secondBest = {
      language: X.secondBest.language,
      relevance: X.secondBest.relevance
    }), w("after:highlightElement", { el: j, result: X, text: ie });
  }
  function Y(j) {
    h = FS(h, j);
  }
  const k = () => {
    H(), Qi("10.6.0", "initHighlighting() deprecated.  Use highlightAll() now.");
  };
  function W() {
    H(), Qi("10.6.0", "initHighlightingOnLoad() deprecated.  Use highlightAll() now.");
  }
  let Z = !1;
  function H() {
    if (document.readyState === "loading") {
      Z = !0;
      return;
    }
    document.querySelectorAll(h.cssSelector).forEach(G);
  }
  function K() {
    Z && H();
  }
  typeof window < "u" && window.addEventListener && window.addEventListener("DOMContentLoaded", K, !1);
  function Q(j, J) {
    let de = null;
    try {
      de = J(s);
    } catch (ie) {
      if (Ci("Language definition for '{}' could not be registered.".replace("{}", j)), r)
        Ci(ie);
      else
        throw ie;
      de = g;
    }
    de.name || (de.name = j), i[j] = de, de.rawDefinition = J.bind(null, s), de.aliases && Ke(de.aliases, { languageName: j });
  }
  function _e(j) {
    delete i[j];
    for (const J of Object.keys(o))
      o[J] === j && delete o[J];
  }
  function se() {
    return Object.keys(i);
  }
  function Pe(j) {
    return j = (j || "").toLowerCase(), i[j] || i[o[j]];
  }
  function Ke(j, { languageName: J }) {
    typeof j == "string" && (j = [j]), j.forEach((de) => {
      o[de.toLowerCase()] = J;
    });
  }
  function ye(j) {
    const J = Pe(j);
    return J && !J.disableAutodetect;
  }
  function Je(j) {
    j["before:highlightBlock"] && !j["before:highlightElement"] && (j["before:highlightElement"] = (J) => {
      j["before:highlightBlock"](
        Object.assign({ block: J.el }, J)
      );
    }), j["after:highlightBlock"] && !j["after:highlightElement"] && (j["after:highlightElement"] = (J) => {
      j["after:highlightBlock"](
        Object.assign({ block: J.el }, J)
      );
    });
  }
  function mt(j) {
    Je(j), c.push(j);
  }
  function ge(j) {
    const J = c.indexOf(j);
    J !== -1 && c.splice(J, 1);
  }
  function w(j, J) {
    const de = j;
    c.forEach(function(ie) {
      ie[de] && ie[de](J);
    });
  }
  function fe(j) {
    return Qi("10.7.0", "highlightBlock will be removed entirely in v12.0"), Qi("10.7.0", "Please use highlightElement now."), G(j);
  }
  Object.assign(s, {
    highlight: O,
    highlightAuto: x,
    highlightAll: H,
    highlightElement: G,
    // TODO: Remove with v12 API
    highlightBlock: fe,
    configure: Y,
    initHighlighting: k,
    initHighlightingOnLoad: W,
    registerLanguage: Q,
    unregisterLanguage: _e,
    listLanguages: se,
    getLanguage: Pe,
    registerAliases: Ke,
    autoDetection: ye,
    inherit: FS,
    addPlugin: mt,
    removePlugin: ge
  }), s.debugMode = function() {
    r = !1;
  }, s.safeMode = function() {
    r = !0;
  }, s.versionString = qL, s.regex = {
    concat: Ii,
    lookahead: Vv,
    either: km,
    optional: oL,
    anyNumberOfTimes: iL
  };
  for (const j in Js)
    typeof Js[j] == "object" && Bv(Js[j]);
  return Object.assign(s, Js), s;
}, to = Xv({});
to.newInstance = () => Xv({});
var zL = to;
to.HighlightJS = to;
to.default = to;
var _d, BS;
function KL() {
  if (BS)
    return _d;
  BS = 1;
  function s(i) {
    const o = "[A-Za-zА-Яа-яёЁ_][A-Za-zА-Яа-яёЁ_0-9]+", e = "далее " + "возврат вызватьисключение выполнить для если и из или иначе иначеесли исключение каждого конецесли конецпопытки конеццикла не новый перейти перем по пока попытка прервать продолжить тогда цикл экспорт ", S = "загрузитьизфайла " + "вебклиент вместо внешнеесоединение клиент конецобласти мобильноеприложениеклиент мобильноеприложениесервер наклиенте наклиентенасервере наклиентенасерверебезконтекста насервере насерверебезконтекста область перед после сервер толстыйклиентобычноеприложение толстыйклиентуправляемоеприложение тонкийклиент ", x = "разделительстраниц разделительстрок символтабуляции " + "ansitooem oemtoansi ввестивидсубконто ввестиперечисление ввестипериод ввестиплансчетов выбранныйплансчетов датагод датамесяц датачисло заголовоксистемы значениевстроку значениеизстроки каталогиб каталогпользователя кодсимв конгода конецпериодаби конецрассчитанногопериодаби конецстандартногоинтервала конквартала конмесяца коннедели лог лог10 максимальноеколичествосубконто названиеинтерфейса названиенабораправ назначитьвид назначитьсчет найтиссылки началопериодаби началостандартногоинтервала начгода начквартала начмесяца начнедели номерднягода номерднянедели номернеделигода обработкаожидания основнойжурналрасчетов основнойплансчетов основнойязык очиститьокносообщений периодстр получитьвремята получитьдатута получитьдокументта получитьзначенияотбора получитьпозициюта получитьпустоезначение получитьта префиксавтонумерации пропись пустоезначение разм разобратьпозициюдокумента рассчитатьрегистрына рассчитатьрегистрыпо симв создатьобъект статусвозврата стрколичествострок сформироватьпозициюдокумента счетпокоду текущеевремя типзначения типзначениястр установитьтана установитьтапо фиксшаблон шаблон " + "acos asin atan base64значение base64строка cos exp log log10 pow sin sqrt tan xmlзначение xmlстрока xmlтип xmlтипзнч активноеокно безопасныйрежим безопасныйрежимразделенияданных булево ввестидату ввестизначение ввестистроку ввестичисло возможностьчтенияxml вопрос восстановитьзначение врег выгрузитьжурналрегистрации выполнитьобработкуоповещения выполнитьпроверкуправдоступа вычислить год данныеформывзначение дата день деньгода деньнедели добавитьмесяц заблокироватьданныедляредактирования заблокироватьработупользователя завершитьработусистемы загрузитьвнешнююкомпоненту закрытьсправку записатьjson записатьxml записатьдатуjson записьжурналарегистрации заполнитьзначениясвойств запроситьразрешениепользователя запуститьприложение запуститьсистему зафиксироватьтранзакцию значениевданныеформы значениевстрокувнутр значениевфайл значениезаполнено значениеизстрокивнутр значениеизфайла изxmlтипа импортмоделиxdto имякомпьютера имяпользователя инициализироватьпредопределенныеданные информацияобошибке каталогбиблиотекимобильногоустройства каталогвременныхфайлов каталогдокументов каталогпрограммы кодироватьстроку кодлокализацииинформационнойбазы кодсимвола командасистемы конецгода конецдня конецквартала конецмесяца конецминуты конецнедели конецчаса конфигурациябазыданныхизмененадинамически конфигурацияизменена копироватьданныеформы копироватьфайл краткоепредставлениеошибки лев макс местноевремя месяц мин минута монопольныйрежим найти найтинедопустимыесимволыxml найтиокнопонавигационнойссылке найтипомеченныенаудаление найтипоссылкам найтифайлы началогода началодня началоквартала началомесяца началоминуты началонедели началочаса начатьзапросразрешенияпользователя начатьзапускприложения начатькопированиефайла начатьперемещениефайла начатьподключениевнешнейкомпоненты начатьподключениерасширенияработыскриптографией начатьподключениерасширенияработысфайлами начатьпоискфайлов начатьполучениекаталогавременныхфайлов начатьполучениекаталогадокументов начатьполучениерабочегокаталогаданныхпользователя начатьполучениефайлов начатьпомещениефайла начатьпомещениефайлов начатьсозданиедвоичныхданныхизфайла начатьсозданиекаталога начатьтранзакцию начатьудалениефайлов начатьустановкувнешнейкомпоненты начатьустановкурасширенияработыскриптографией начатьустановкурасширенияработысфайлами неделягода необходимостьзавершениясоединения номерсеансаинформационнойбазы номерсоединенияинформационнойбазы нрег нстр обновитьинтерфейс обновитьнумерациюобъектов обновитьповторноиспользуемыезначения обработкапрерыванияпользователя объединитьфайлы окр описаниеошибки оповестить оповеститьобизменении отключитьобработчикзапросанастроекклиенталицензирования отключитьобработчикожидания отключитьобработчикоповещения открытьзначение открытьиндекссправки открытьсодержаниесправки открытьсправку открытьформу открытьформумодально отменитьтранзакцию очиститьжурналрегистрации очиститьнастройкипользователя очиститьсообщения параметрыдоступа перейтипонавигационнойссылке переместитьфайл подключитьвнешнююкомпоненту подключитьобработчикзапросанастроекклиенталицензирования подключитьобработчикожидания подключитьобработчикоповещения подключитьрасширениеработыскриптографией подключитьрасширениеработысфайлами подробноепредставлениеошибки показатьвводдаты показатьвводзначения показатьвводстроки показатьвводчисла показатьвопрос показатьзначение показатьинформациюобошибке показатьнакарте показатьоповещениепользователя показатьпредупреждение полноеимяпользователя получитьcomобъект получитьxmlтип получитьадреспоместоположению получитьблокировкусеансов получитьвремязавершенияспящегосеанса получитьвремязасыпанияпассивногосеанса получитьвремяожиданияблокировкиданных получитьданныевыбора получитьдополнительныйпараметрклиенталицензирования получитьдопустимыекодылокализации получитьдопустимыечасовыепояса получитьзаголовокклиентскогоприложения получитьзаголовоксистемы получитьзначенияотборажурналарегистрации получитьидентификаторконфигурации получитьизвременногохранилища получитьимявременногофайла получитьимяклиенталицензирования получитьинформациюэкрановклиента получитьиспользованиежурналарегистрации получитьиспользованиесобытияжурналарегистрации получитькраткийзаголовокприложения получитьмакетоформления получитьмаскувсефайлы получитьмаскувсефайлыклиента получитьмаскувсефайлысервера получитьместоположениепоадресу получитьминимальнуюдлинупаролейпользователей получитьнавигационнуюссылку получитьнавигационнуюссылкуинформационнойбазы получитьобновлениеконфигурациибазыданных получитьобновлениепредопределенныхданныхинформационнойбазы получитьобщиймакет получитьобщуюформу получитьокна получитьоперативнуюотметкувремени получитьотключениебезопасногорежима получитьпараметрыфункциональныхопцийинтерфейса получитьполноеимяпредопределенногозначения получитьпредставлениянавигационныхссылок получитьпроверкусложностипаролейпользователей получитьразделительпути получитьразделительпутиклиента получитьразделительпутисервера получитьсеансыинформационнойбазы получитьскоростьклиентскогосоединения получитьсоединенияинформационнойбазы получитьсообщенияпользователю получитьсоответствиеобъектаиформы получитьсоставстандартногоинтерфейсаodata получитьструктурухранениябазыданных получитьтекущийсеансинформационнойбазы получитьфайл получитьфайлы получитьформу получитьфункциональнуюопцию получитьфункциональнуюопциюинтерфейса получитьчасовойпоясинформационнойбазы пользователиос поместитьвовременноехранилище поместитьфайл поместитьфайлы прав праводоступа предопределенноезначение представлениекодалокализации представлениепериода представлениеправа представлениеприложения представлениесобытияжурналарегистрации представлениечасовогопояса предупреждение прекратитьработусистемы привилегированныйрежим продолжитьвызов прочитатьjson прочитатьxml прочитатьдатуjson пустаястрока рабочийкаталогданныхпользователя разблокироватьданныедляредактирования разделитьфайл разорватьсоединениесвнешнимисточникомданных раскодироватьстроку рольдоступна секунда сигнал символ скопироватьжурналрегистрации смещениелетнеговремени смещениестандартноговремени соединитьбуферыдвоичныхданных создатькаталог создатьфабрикуxdto сокрл сокрлп сокрп сообщить состояние сохранитьзначение сохранитьнастройкипользователя сред стрдлина стрзаканчиваетсяна стрзаменить стрнайти стрначинаетсяс строка строкасоединенияинформационнойбазы стрполучитьстроку стрразделить стрсоединить стрсравнить стрчисловхождений стрчислострок стршаблон текущаядата текущаядатасеанса текущаяуниверсальнаядата текущаяуниверсальнаядатавмиллисекундах текущийвариантинтерфейсаклиентскогоприложения текущийвариантосновногошрифтаклиентскогоприложения текущийкодлокализации текущийрежимзапуска текущийязык текущийязыксистемы тип типзнч транзакцияактивна трег удалитьданныеинформационнойбазы удалитьизвременногохранилища удалитьобъекты удалитьфайлы универсальноевремя установитьбезопасныйрежим установитьбезопасныйрежимразделенияданных установитьблокировкусеансов установитьвнешнююкомпоненту установитьвремязавершенияспящегосеанса установитьвремязасыпанияпассивногосеанса установитьвремяожиданияблокировкиданных установитьзаголовокклиентскогоприложения установитьзаголовоксистемы установитьиспользованиежурналарегистрации установитьиспользованиесобытияжурналарегистрации установитькраткийзаголовокприложения установитьминимальнуюдлинупаролейпользователей установитьмонопольныйрежим установитьнастройкиклиенталицензирования установитьобновлениепредопределенныхданныхинформационнойбазы установитьотключениебезопасногорежима установитьпараметрыфункциональныхопцийинтерфейса установитьпривилегированныйрежим установитьпроверкусложностипаролейпользователей установитьрасширениеработыскриптографией установитьрасширениеработысфайлами установитьсоединениесвнешнимисточникомданных установитьсоответствиеобъектаиформы установитьсоставстандартногоинтерфейсаodata установитьчасовойпоясинформационнойбазы установитьчасовойпояссеанса формат цел час часовойпояс часовойпояссеанса число числопрописью этоадресвременногохранилища " + "wsссылки библиотекакартинок библиотекамакетовоформлениякомпоновкиданных библиотекастилей бизнеспроцессы внешниеисточникиданных внешниеобработки внешниеотчеты встроенныепокупки главныйинтерфейс главныйстиль документы доставляемыеуведомления журналыдокументов задачи информацияобинтернетсоединении использованиерабочейдаты историяработыпользователя константы критерииотбора метаданные обработки отображениерекламы отправкадоставляемыхуведомлений отчеты панельзадачос параметрзапуска параметрысеанса перечисления планывидоврасчета планывидовхарактеристик планыобмена планысчетов полнотекстовыйпоиск пользователиинформационнойбазы последовательности проверкавстроенныхпокупок рабочаядата расширенияконфигурации регистрыбухгалтерии регистрынакопления регистрырасчета регистрысведений регламентныезадания сериализаторxdto справочники средствагеопозиционирования средствакриптографии средствамультимедиа средстваотображениярекламы средствапочты средствателефонии фабрикаxdto файловыепотоки фоновыезадания хранилищанастроек хранилищевариантовотчетов хранилищенастроекданныхформ хранилищеобщихнастроек хранилищепользовательскихнастроекдинамическихсписков хранилищепользовательскихнастроекотчетов хранилищесистемныхнастроек ", ie = "webцвета windowsцвета windowsшрифты библиотекакартинок рамкистиля символы цветастиля шрифтыстиля " + "автоматическоесохранениеданныхформывнастройках автонумерациявформе автораздвижениесерий анимациядиаграммы вариантвыравниванияэлементовизаголовков вариантуправлениявысотойтаблицы вертикальнаяпрокруткаформы вертикальноеположение вертикальноеположениеэлемента видгруппыформы виддекорацииформы виддополненияэлементаформы видизмененияданных видкнопкиформы видпереключателя видподписейкдиаграмме видполяформы видфлажка влияниеразмеранапузырекдиаграммы горизонтальноеположение горизонтальноеположениеэлемента группировкаколонок группировкаподчиненныхэлементовформы группыиэлементы действиеперетаскивания дополнительныйрежимотображения допустимыедействияперетаскивания интервалмеждуэлементамиформы использованиевывода использованиеполосыпрокрутки используемоезначениеточкибиржевойдиаграммы историявыборапривводе источникзначенийоситочекдиаграммы источникзначенияразмерапузырькадиаграммы категориягруппыкоманд максимумсерий начальноеотображениедерева начальноеотображениесписка обновлениетекстаредактирования ориентациядендрограммы ориентациядиаграммы ориентацияметокдиаграммы ориентацияметоксводнойдиаграммы ориентацияэлементаформы отображениевдиаграмме отображениевлегендедиаграммы отображениегруппыкнопок отображениезаголовкашкалыдиаграммы отображениезначенийсводнойдиаграммы отображениезначенияизмерительнойдиаграммы отображениеинтерваладиаграммыганта отображениекнопки отображениекнопкивыбора отображениеобсужденийформы отображениеобычнойгруппы отображениеотрицательныхзначенийпузырьковойдиаграммы отображениепанелипоиска отображениеподсказки отображениепредупрежденияприредактировании отображениеразметкиполосырегулирования отображениестраницформы отображениетаблицы отображениетекстазначениядиаграммыганта отображениеуправленияобычнойгруппы отображениефигурыкнопки палитрацветовдиаграммы поведениеобычнойгруппы поддержкамасштабадендрограммы поддержкамасштабадиаграммыганта поддержкамасштабасводнойдиаграммы поисквтаблицепривводе положениезаголовкаэлементаформы положениекартинкикнопкиформы положениекартинкиэлементаграфическойсхемы положениекоманднойпанелиформы положениекоманднойпанелиэлементаформы положениеопорнойточкиотрисовки положениеподписейкдиаграмме положениеподписейшкалызначенийизмерительнойдиаграммы положениесостоянияпросмотра положениестрокипоиска положениетекстасоединительнойлинии положениеуправленияпоиском положениешкалывремени порядокотображенияточекгоризонтальнойгистограммы порядоксерийвлегендедиаграммы размеркартинки расположениезаголовкашкалыдиаграммы растягиваниеповертикалидиаграммыганта режимавтоотображениясостояния режимвводастроктаблицы режимвыборанезаполненного режимвыделениядаты режимвыделениястрокитаблицы режимвыделениятаблицы режимизмененияразмера режимизменениясвязанногозначения режимиспользованиядиалогапечати режимиспользованияпараметракоманды режиммасштабированияпросмотра режимосновногоокнаклиентскогоприложения режимоткрытияокнаформы режимотображениявыделения режимотображениягеографическойсхемы режимотображениязначенийсерии режимотрисовкисеткиграфическойсхемы режимполупрозрачностидиаграммы режимпробеловдиаграммы режимразмещениянастранице режимредактированияколонки режимсглаживаниядиаграммы режимсглаживанияиндикатора режимсписказадач сквозноевыравнивание сохранениеданныхформывнастройках способзаполнениятекстазаголовкашкалыдиаграммы способопределенияограничивающегозначениядиаграммы стандартнаягруппакоманд стандартноеоформление статусоповещенияпользователя стильстрелки типаппроксимациилиниитрендадиаграммы типдиаграммы типединицышкалывремени типимпортасерийслоягеографическойсхемы типлиниигеографическойсхемы типлиниидиаграммы типмаркерагеографическойсхемы типмаркерадиаграммы типобластиоформления типорганизацииисточникаданныхгеографическойсхемы типотображениясериислоягеографическойсхемы типотображенияточечногообъектагеографическойсхемы типотображенияшкалыэлементалегендыгеографическойсхемы типпоискаобъектовгеографическойсхемы типпроекциигеографическойсхемы типразмещенияизмерений типразмещенияреквизитовизмерений типрамкиэлементауправления типсводнойдиаграммы типсвязидиаграммыганта типсоединениязначенийпосериямдиаграммы типсоединенияточекдиаграммы типсоединительнойлинии типстороныэлементаграфическойсхемы типформыотчета типшкалырадарнойдиаграммы факторлиниитрендадиаграммы фигуракнопки фигурыграфическойсхемы фиксациявтаблице форматдняшкалывремени форматкартинки ширинаподчиненныхэлементовформы " + "виддвижениябухгалтерии виддвижениянакопления видпериодарегистрарасчета видсчета видточкимаршрутабизнеспроцесса использованиеагрегатарегистранакопления использованиегруппиэлементов использованиережимапроведения использованиесреза периодичностьагрегатарегистранакопления режимавтовремя режимзаписидокумента режимпроведениядокумента " + "авторегистрацияизменений допустимыйномерсообщения отправкаэлементаданных получениеэлементаданных " + "использованиерасшифровкитабличногодокумента ориентациястраницы положениеитоговколоноксводнойтаблицы положениеитоговстроксводнойтаблицы положениетекстаотносительнокартинки расположениезаголовкагруппировкитабличногодокумента способчтениязначенийтабличногодокумента типдвустороннейпечати типзаполненияобластитабличногодокумента типкурсоровтабличногодокумента типлиниирисункатабличногодокумента типлинииячейкитабличногодокумента типнаправленияпереходатабличногодокумента типотображениявыделениятабличногодокумента типотображениялинийсводнойтаблицы типразмещениятекстатабличногодокумента типрисункатабличногодокумента типсмещениятабличногодокумента типузоратабличногодокумента типфайлатабличногодокумента точностьпечати чередованиерасположениястраниц " + "отображениевремениэлементовпланировщика " + "типфайлаформатированногодокумента " + "обходрезультатазапроса типзаписизапроса " + "видзаполнениярасшифровкипостроителяотчета типдобавленияпредставлений типизмеренияпостроителяотчета типразмещенияитогов " + "доступкфайлу режимдиалогавыборафайла режимоткрытияфайла " + "типизмеренияпостроителязапроса " + "видданныханализа методкластеризации типединицыинтервалавременианализаданных типзаполнениятаблицырезультатаанализаданных типиспользованиячисловыхзначенийанализаданных типисточникаданныхпоискаассоциаций типколонкианализаданныхдереворешений типколонкианализаданныхкластеризация типколонкианализаданныхобщаястатистика типколонкианализаданныхпоискассоциаций типколонкианализаданныхпоискпоследовательностей типколонкимоделипрогноза типмерырасстоянияанализаданных типотсеченияправилассоциации типполяанализаданных типстандартизациианализаданных типупорядочиванияправилассоциациианализаданных типупорядочиванияшаблоновпоследовательностейанализаданных типупрощениядереварешений " + "wsнаправлениепараметра вариантxpathxs вариантзаписидатыjson вариантпростоготипаxs видгруппымоделиxs видфасетаxdto действиепостроителяdom завершенностьпростоготипаxs завершенностьсоставноготипаxs завершенностьсхемыxs запрещенныеподстановкиxs исключениягруппподстановкиxs категорияиспользованияатрибутаxs категорияограниченияидентичностиxs категорияограниченияпространствименxs методнаследованияxs модельсодержимогоxs назначениетипаxml недопустимыеподстановкиxs обработкапробельныхсимволовxs обработкасодержимогоxs ограничениезначенияxs параметрыотбораузловdom переносстрокjson позициявдокументеdom пробельныесимволыxml типатрибутаxml типзначенияjson типканоническогоxml типкомпонентыxs типпроверкиxml типрезультатаdomxpath типузлаdom типузлаxml формаxml формапредставленияxs форматдатыjson экранированиесимволовjson " + "видсравнениякомпоновкиданных действиеобработкирасшифровкикомпоновкиданных направлениесортировкикомпоновкиданных расположениевложенныхэлементоврезультатакомпоновкиданных расположениеитоговкомпоновкиданных расположениегруппировкикомпоновкиданных расположениеполейгруппировкикомпоновкиданных расположениеполякомпоновкиданных расположениереквизитовкомпоновкиданных расположениересурсовкомпоновкиданных типбухгалтерскогоостаткакомпоновкиданных типвыводатекстакомпоновкиданных типгруппировкикомпоновкиданных типгруппыэлементовотборакомпоновкиданных типдополненияпериодакомпоновкиданных типзаголовкаполейкомпоновкиданных типмакетагруппировкикомпоновкиданных типмакетаобластикомпоновкиданных типостаткакомпоновкиданных типпериодакомпоновкиданных типразмещениятекстакомпоновкиданных типсвязинаборовданныхкомпоновкиданных типэлементарезультатакомпоновкиданных расположениелегендыдиаграммыкомпоновкиданных типпримененияотборакомпоновкиданных режимотображенияэлементанастройкикомпоновкиданных режимотображениянастроеккомпоновкиданных состояниеэлементанастройкикомпоновкиданных способвосстановлениянастроеккомпоновкиданных режимкомпоновкирезультата использованиепараметракомпоновкиданных автопозицияресурсовкомпоновкиданных вариантиспользованиягруппировкикомпоновкиданных расположениересурсоввдиаграммекомпоновкиданных фиксациякомпоновкиданных использованиеусловногооформлениякомпоновкиданных " + "важностьинтернетпочтовогосообщения обработкатекстаинтернетпочтовогосообщения способкодированияинтернетпочтовоговложения способкодированиянеasciiсимволовинтернетпочтовогосообщения типтекстапочтовогосообщения протоколинтернетпочты статусразборапочтовогосообщения " + "режимтранзакциизаписижурналарегистрации статустранзакциизаписижурналарегистрации уровеньжурналарегистрации " + "расположениехранилищасертификатовкриптографии режимвключениясертификатовкриптографии режимпроверкисертификатакриптографии типхранилищасертификатовкриптографии " + "кодировкаименфайловвzipфайле методсжатияzip методшифрованияzip режимвосстановленияпутейфайловzip режимобработкиподкаталоговzip режимсохраненияпутейzip уровеньсжатияzip " + "звуковоеоповещение направлениепереходакстроке позициявпотоке порядокбайтов режимблокировкиданных режимуправленияблокировкойданных сервисвстроенныхпокупок состояниефоновогозадания типподписчикадоставляемыхуведомлений уровеньиспользованиязащищенногосоединенияftp " + "направлениепорядкасхемызапроса типдополненияпериодамисхемызапроса типконтрольнойточкисхемызапроса типобъединениясхемызапроса типпараметрадоступнойтаблицысхемызапроса типсоединениясхемызапроса " + "httpметод автоиспользованиеобщегореквизита автопрефиксномеразадачи вариантвстроенногоязыка видиерархии видрегистранакопления видтаблицывнешнегоисточникаданных записьдвиженийприпроведении заполнениепоследовательностей индексирование использованиебазыпланавидоврасчета использованиебыстроговыбора использованиеобщегореквизита использованиеподчинения использованиеполнотекстовогопоиска использованиеразделяемыхданныхобщегореквизита использованиереквизита назначениеиспользованияприложения назначениерасширенияконфигурации направлениепередачи обновлениепредопределенныхданных оперативноепроведение основноепредставлениевидарасчета основноепредставлениевидахарактеристики основноепредставлениезадачи основноепредставлениепланаобмена основноепредставлениесправочника основноепредставлениесчета перемещениеграницыприпроведении периодичностьномерабизнеспроцесса периодичностьномерадокумента периодичностьрегистрарасчета периодичностьрегистрасведений повторноеиспользованиевозвращаемыхзначений полнотекстовыйпоискпривводепостроке принадлежностьобъекта проведение разделениеаутентификацииобщегореквизита разделениеданныхобщегореквизита разделениерасширенийконфигурацииобщегореквизита режимавтонумерацииобъектов режимзаписирегистра режимиспользованиямодальности режимиспользованиясинхронныхвызововрасширенийплатформыивнешнихкомпонент режимповторногоиспользованиясеансов режимполученияданныхвыборапривводепостроке режимсовместимости режимсовместимостиинтерфейса режимуправленияблокировкойданныхпоумолчанию сериикодовпланавидовхарактеристик сериикодовпланасчетов сериикодовсправочника созданиепривводе способвыбора способпоискастрокипривводепостроке способредактирования типданныхтаблицывнешнегоисточникаданных типкодапланавидоврасчета типкодасправочника типмакета типномерабизнеспроцесса типномерадокумента типномеразадачи типформы удалениедвижений " + "важностьпроблемыприменениярасширенияконфигурации вариантинтерфейсаклиентскогоприложения вариантмасштабаформклиентскогоприложения вариантосновногошрифтаклиентскогоприложения вариантстандартногопериода вариантстандартнойдатыначала видграницы видкартинки видотображенияполнотекстовогопоиска видрамки видсравнения видцвета видчисловогозначения видшрифта допустимаядлина допустимыйзнак использованиеbyteordermark использованиеметаданныхполнотекстовогопоиска источникрасширенийконфигурации клавиша кодвозвратадиалога кодировкаxbase кодировкатекста направлениепоиска направлениесортировки обновлениепредопределенныхданных обновлениеприизмененииданных отображениепанелиразделов проверказаполнения режимдиалогавопрос режимзапускаклиентскогоприложения режимокругления режимоткрытияформприложения режимполнотекстовогопоиска скоростьклиентскогосоединения состояниевнешнегоисточникаданных состояниеобновленияконфигурациибазыданных способвыборасертификатаwindows способкодированиястроки статуссообщения типвнешнейкомпоненты типплатформы типповеденияклавишиenter типэлементаинформацииовыполненииобновленияконфигурациибазыданных уровеньизоляциитранзакций хешфункция частидаты", Oe = "comобъект ftpсоединение httpзапрос httpсервисответ httpсоединение wsопределения wsпрокси xbase анализданных аннотацияxs блокировкаданных буфердвоичныхданных включениеxs выражениекомпоновкиданных генераторслучайныхчисел географическаясхема географическиекоординаты графическаясхема группамоделиxs данныерасшифровкикомпоновкиданных двоичныеданные дендрограмма диаграмма диаграммаганта диалогвыборафайла диалогвыборацвета диалогвыборашрифта диалограсписаниярегламентногозадания диалогредактированиястандартногопериода диапазон документdom документhtml документацияxs доставляемоеуведомление записьdom записьfastinfoset записьhtml записьjson записьxml записьzipфайла записьданных записьтекста записьузловdom запрос защищенноесоединениеopenssl значенияполейрасшифровкикомпоновкиданных извлечениетекста импортxs интернетпочта интернетпочтовоесообщение интернетпочтовыйпрофиль интернетпрокси интернетсоединение информациядляприложенияxs использованиеатрибутаxs использованиесобытияжурналарегистрации источникдоступныхнастроеккомпоновкиданных итераторузловdom картинка квалификаторыдаты квалификаторыдвоичныхданных квалификаторыстроки квалификаторычисла компоновщикмакетакомпоновкиданных компоновщикнастроеккомпоновкиданных конструктормакетаоформлениякомпоновкиданных конструкторнастроеккомпоновкиданных конструкторформатнойстроки линия макеткомпоновкиданных макетобластикомпоновкиданных макетоформлениякомпоновкиданных маскаxs менеджеркриптографии наборсхемxml настройкикомпоновкиданных настройкисериализацииjson обработкакартинок обработкарасшифровкикомпоновкиданных обходдереваdom объявлениеатрибутаxs объявлениенотацииxs объявлениеэлементаxs описаниеиспользованиясобытиядоступжурналарегистрации описаниеиспользованиясобытияотказвдоступежурналарегистрации описаниеобработкирасшифровкикомпоновкиданных описаниепередаваемогофайла описаниетипов определениегруппыатрибутовxs определениегруппымоделиxs определениеограниченияидентичностиxs определениепростоготипаxs определениесоставноготипаxs определениетипадокументаdom определенияxpathxs отборкомпоновкиданных пакетотображаемыхдокументов параметрвыбора параметркомпоновкиданных параметрызаписиjson параметрызаписиxml параметрычтенияxml переопределениеxs планировщик полеанализаданных полекомпоновкиданных построительdom построительзапроса построительотчета построительотчетаанализаданных построительсхемxml поток потоквпамяти почта почтовоесообщение преобразованиеxsl преобразованиекканоническомуxml процессорвыводарезультатакомпоновкиданныхвколлекциюзначений процессорвыводарезультатакомпоновкиданныхвтабличныйдокумент процессоркомпоновкиданных разыменовательпространствименdom рамка расписаниерегламентногозадания расширенноеимяxml результатчтенияданных своднаядиаграмма связьпараметравыбора связьпотипу связьпотипукомпоновкиданных сериализаторxdto сертификатклиентаwindows сертификатклиентафайл сертификаткриптографии сертификатыудостоверяющихцентровwindows сертификатыудостоверяющихцентровфайл сжатиеданных системнаяинформация сообщениепользователю сочетаниеклавиш сравнениезначений стандартнаядатаначала стандартныйпериод схемаxml схемакомпоновкиданных табличныйдокумент текстовыйдокумент тестируемоеприложение типданныхxml уникальныйидентификатор фабрикаxdto файл файловыйпоток фасетдлиныxs фасетколичестваразрядовдробнойчастиxs фасетмаксимальноговключающегозначенияxs фасетмаксимальногоисключающегозначенияxs фасетмаксимальнойдлиныxs фасетминимальноговключающегозначенияxs фасетминимальногоисключающегозначенияxs фасетминимальнойдлиныxs фасетобразцаxs фасетобщегоколичестваразрядовxs фасетперечисленияxs фасетпробельныхсимволовxs фильтрузловdom форматированнаястрока форматированныйдокумент фрагментxs хешированиеданных хранилищезначения цвет чтениеfastinfoset чтениеhtml чтениеjson чтениеxml чтениеzipфайла чтениеданных чтениетекста чтениеузловdom шрифт элементрезультатакомпоновкиданных " + "comsafearray деревозначений массив соответствие списокзначений структура таблицазначений фиксированнаяструктура фиксированноесоответствие фиксированныймассив ", Re = "null истина ложь неопределено", ae = i.inherit(i.NUMBER_MODE), Ee = {
      className: "string",
      begin: '"|\\|',
      end: '"|$',
      contains: [{ begin: '""' }]
    }, ne = {
      begin: "'",
      end: "'",
      excludeBegin: !0,
      excludeEnd: !0,
      contains: [
        {
          className: "number",
          begin: "\\d{4}([\\.\\\\/:-]?\\d{2}){0,5}"
        }
      ]
    }, Ge = i.inherit(i.C_LINE_COMMENT_MODE), we = {
      className: "meta",
      begin: "#|&",
      end: "$",
      keywords: {
        $pattern: o,
        keyword: e + S
      },
      contains: [Ge]
    }, st = {
      className: "symbol",
      begin: "~",
      end: ";|:",
      excludeEnd: !0
    }, Rt = {
      className: "function",
      variants: [
        {
          begin: "процедура|функция",
          end: "\\)",
          keywords: "процедура функция"
        },
        {
          begin: "конецпроцедуры|конецфункции",
          keywords: "конецпроцедуры конецфункции"
        }
      ],
      contains: [
        {
          begin: "\\(",
          end: "\\)",
          endsParent: !0,
          contains: [
            {
              className: "params",
              begin: o,
              end: ",",
              excludeEnd: !0,
              endsWithParent: !0,
              keywords: {
                $pattern: o,
                keyword: "знач",
                literal: Re
              },
              contains: [
                ae,
                Ee,
                ne
              ]
            },
            Ge
          ]
        },
        i.inherit(i.TITLE_MODE, { begin: o })
      ]
    };
    return {
      name: "1C:Enterprise",
      case_insensitive: !0,
      keywords: {
        $pattern: o,
        keyword: e,
        built_in: x,
        class: ie,
        type: Oe,
        literal: Re
      },
      contains: [
        we,
        Rt,
        Ge,
        st,
        ae,
        Ee,
        ne
      ]
    };
  }
  return _d = s, _d;
}
var pd, GS;
function QL() {
  if (GS)
    return pd;
  GS = 1;
  function s(i) {
    const o = i.regex, c = /^[a-zA-Z][a-zA-Z0-9-]*/, r = [
      "ALPHA",
      "BIT",
      "CHAR",
      "CR",
      "CRLF",
      "CTL",
      "DIGIT",
      "DQUOTE",
      "HEXDIG",
      "HTAB",
      "LF",
      "LWSP",
      "OCTET",
      "SP",
      "VCHAR",
      "WSP"
    ], e = i.COMMENT(/;/, /$/), g = {
      scope: "symbol",
      match: /%b[0-1]+(-[0-1]+|(\.[0-1]+)+)?/
    }, h = {
      scope: "symbol",
      match: /%d[0-9]+(-[0-9]+|(\.[0-9]+)+)?/
    }, S = {
      scope: "symbol",
      match: /%x[0-9A-F]+(-[0-9A-F]+|(\.[0-9A-F]+)+)?/
    }, C = {
      scope: "symbol",
      match: /%[si](?=".*")/
    }, O = {
      scope: "attribute",
      match: o.concat(c, /(?=\s*=)/)
    };
    return {
      name: "Augmented Backus-Naur Form",
      illegal: /[!@#$^&',?+~`|:]/,
      keywords: r,
      contains: [
        {
          scope: "operator",
          match: /=\/?/
        },
        O,
        e,
        g,
        h,
        S,
        C,
        i.QUOTE_STRING_MODE,
        i.NUMBER_MODE
      ]
    };
  }
  return pd = s, pd;
}
var md, VS;
function XL() {
  if (VS)
    return md;
  VS = 1;
  function s(i) {
    const o = i.regex, c = [
      "GET",
      "POST",
      "HEAD",
      "PUT",
      "DELETE",
      "CONNECT",
      "OPTIONS",
      "PATCH",
      "TRACE"
    ];
    return {
      name: "Apache Access Log",
      contains: [
        // IP
        {
          className: "number",
          begin: /^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}(:\d{1,5})?\b/,
          relevance: 5
        },
        // Other numbers
        {
          className: "number",
          begin: /\b\d+\b/,
          relevance: 0
        },
        // Requests
        {
          className: "string",
          begin: o.concat(/"/, o.either(...c)),
          end: /"/,
          keywords: c,
          illegal: /\n/,
          relevance: 5,
          contains: [
            {
              begin: /HTTP\/[12]\.\d'/,
              relevance: 5
            }
          ]
        },
        // Dates
        {
          className: "string",
          // dates must have a certain length, this prevents matching
          // simple array accesses a[123] and [] and other common patterns
          // found in other languages
          begin: /\[\d[^\]\n]{8,}\]/,
          illegal: /\n/,
          relevance: 1
        },
        {
          className: "string",
          begin: /\[/,
          end: /\]/,
          illegal: /\n/,
          relevance: 0
        },
        // User agent / relevance boost
        {
          className: "string",
          begin: /"Mozilla\/\d\.\d \(/,
          end: /"/,
          illegal: /\n/,
          relevance: 3
        },
        // Strings
        {
          className: "string",
          begin: /"/,
          end: /"/,
          illegal: /\n/,
          relevance: 0
        }
      ]
    };
  }
  return md = s, md;
}
var fd, YS;
function ZL() {
  if (YS)
    return fd;
  YS = 1;
  function s(i) {
    const o = i.regex, c = /[a-zA-Z_$][a-zA-Z0-9_$]*/, r = o.concat(
      c,
      o.concat("(\\.", c, ")*")
    ), e = /([*]|[a-zA-Z_$][a-zA-Z0-9_$]*)/, g = {
      className: "rest_arg",
      begin: /[.]{3}/,
      end: c,
      relevance: 10
    };
    return {
      name: "ActionScript",
      aliases: ["as"],
      keywords: {
        keyword: [
          "as",
          "break",
          "case",
          "catch",
          "class",
          "const",
          "continue",
          "default",
          "delete",
          "do",
          "dynamic",
          "each",
          "else",
          "extends",
          "final",
          "finally",
          "for",
          "function",
          "get",
          "if",
          "implements",
          "import",
          "in",
          "include",
          "instanceof",
          "interface",
          "internal",
          "is",
          "namespace",
          "native",
          "new",
          "override",
          "package",
          "private",
          "protected",
          "public",
          "return",
          "set",
          "static",
          "super",
          "switch",
          "this",
          "throw",
          "try",
          "typeof",
          "use",
          "var",
          "void",
          "while",
          "with"
        ],
        literal: [
          "true",
          "false",
          "null",
          "undefined"
        ]
      },
      contains: [
        i.APOS_STRING_MODE,
        i.QUOTE_STRING_MODE,
        i.C_LINE_COMMENT_MODE,
        i.C_BLOCK_COMMENT_MODE,
        i.C_NUMBER_MODE,
        {
          match: [
            /\bpackage/,
            /\s+/,
            r
          ],
          className: {
            1: "keyword",
            3: "title.class"
          }
        },
        {
          match: [
            /\b(?:class|interface|extends|implements)/,
            /\s+/,
            c
          ],
          className: {
            1: "keyword",
            3: "title.class"
          }
        },
        {
          className: "meta",
          beginKeywords: "import include",
          end: /;/,
          keywords: { keyword: "import include" }
        },
        {
          beginKeywords: "function",
          end: /[{;]/,
          excludeEnd: !0,
          illegal: /\S/,
          contains: [
            i.inherit(i.TITLE_MODE, { className: "title.function" }),
            {
              className: "params",
              begin: /\(/,
              end: /\)/,
              contains: [
                i.APOS_STRING_MODE,
                i.QUOTE_STRING_MODE,
                i.C_LINE_COMMENT_MODE,
                i.C_BLOCK_COMMENT_MODE,
                g
              ]
            },
            { begin: o.concat(/:\s*/, e) }
          ]
        },
        i.METHOD_GUARD
      ],
      illegal: /#/
    };
  }
  return fd = s, fd;
}
var gd, HS;
function jL() {
  if (HS)
    return gd;
  HS = 1;
  function s(i) {
    const o = "\\d(_|\\d)*", c = "[eE][-+]?" + o, r = o + "(\\." + o + ")?(" + c + ")?", e = "\\w+", h = "\\b(" + (o + "#" + e + "(\\." + e + ")?#(" + c + ")?") + "|" + r + ")", S = "[A-Za-z](_?[A-Za-z0-9.])*", C = `[]\\{\\}%#'"`, O = i.COMMENT("--", "$"), N = {
      // TODO: These spaces are not required by the Ada syntax
      // however, I have yet to see handwritten Ada code where
      // someone does not put spaces around :
      begin: "\\s+:\\s+",
      end: "\\s*(:=|;|\\)|=>|$)",
      // endsWithParent: true,
      // returnBegin: true,
      illegal: C,
      contains: [
        {
          // workaround to avoid highlighting
          // named loops and declare blocks
          beginKeywords: "loop for declare others",
          endsParent: !0
        },
        {
          // properly highlight all modifiers
          className: "keyword",
          beginKeywords: "not null constant access function procedure in out aliased exception"
        },
        {
          className: "type",
          begin: S,
          endsParent: !0,
          relevance: 0
        }
      ]
    };
    return {
      name: "Ada",
      case_insensitive: !0,
      keywords: {
        keyword: [
          "abort",
          "else",
          "new",
          "return",
          "abs",
          "elsif",
          "not",
          "reverse",
          "abstract",
          "end",
          "accept",
          "entry",
          "select",
          "access",
          "exception",
          "of",
          "separate",
          "aliased",
          "exit",
          "or",
          "some",
          "all",
          "others",
          "subtype",
          "and",
          "for",
          "out",
          "synchronized",
          "array",
          "function",
          "overriding",
          "at",
          "tagged",
          "generic",
          "package",
          "task",
          "begin",
          "goto",
          "pragma",
          "terminate",
          "body",
          "private",
          "then",
          "if",
          "procedure",
          "type",
          "case",
          "in",
          "protected",
          "constant",
          "interface",
          "is",
          "raise",
          "use",
          "declare",
          "range",
          "delay",
          "limited",
          "record",
          "when",
          "delta",
          "loop",
          "rem",
          "while",
          "digits",
          "renames",
          "with",
          "do",
          "mod",
          "requeue",
          "xor"
        ],
        literal: [
          "True",
          "False"
        ]
      },
      contains: [
        O,
        // strings "foobar"
        {
          className: "string",
          begin: /"/,
          end: /"/,
          contains: [
            {
              begin: /""/,
              relevance: 0
            }
          ]
        },
        // characters ''
        {
          // character literals always contain one char
          className: "string",
          begin: /'.'/
        },
        {
          // number literals
          className: "number",
          begin: h,
          relevance: 0
        },
        {
          // Attributes
          className: "symbol",
          begin: "'" + S
        },
        {
          // package definition, maybe inside generic
          className: "title",
          begin: "(\\bwith\\s+)?(\\bprivate\\s+)?\\bpackage\\s+(\\bbody\\s+)?",
          end: "(is|$)",
          keywords: "package body",
          excludeBegin: !0,
          excludeEnd: !0,
          illegal: C
        },
        {
          // function/procedure declaration/definition
          // maybe inside generic
          begin: "(\\b(with|overriding)\\s+)?\\b(function|procedure)\\s+",
          end: "(\\bis|\\bwith|\\brenames|\\)\\s*;)",
          keywords: "overriding function procedure with is renames return",
          // we need to re-match the 'function' keyword, so that
          // the title mode below matches only exactly once
          returnBegin: !0,
          contains: [
            O,
            {
              // name of the function/procedure
              className: "title",
              begin: "(\\bwith\\s+)?\\b(function|procedure)\\s+",
              end: "(\\(|\\s+|$)",
              excludeBegin: !0,
              excludeEnd: !0,
              illegal: C
            },
            // 'self'
            // // parameter types
            N,
            {
              // return type
              className: "type",
              begin: "\\breturn\\s+",
              end: "(\\s+|;|$)",
              keywords: "return",
              excludeBegin: !0,
              excludeEnd: !0,
              // we are done with functions
              endsParent: !0,
              illegal: C
            }
          ]
        },
        {
          // new type declarations
          // maybe inside generic
          className: "type",
          begin: "\\b(sub)?type\\s+",
          end: "\\s+",
          keywords: "type",
          excludeBegin: !0,
          illegal: C
        },
        // see comment above the definition
        N
        // no markup
        // relevance boosters for small snippets
        // {begin: '\\s*=>\\s*'},
        // {begin: '\\s*:=\\s*'},
        // {begin: '\\s+:=\\s+'},
      ]
    };
  }
  return gd = s, gd;
}
var Ed, qS;
function JL() {
  if (qS)
    return Ed;
  qS = 1;
  function s(i) {
    const o = {
      className: "built_in",
      begin: "\\b(void|bool|int8|int16|int32|int64|int|uint8|uint16|uint32|uint64|uint|string|ref|array|double|float|auto|dictionary)"
    }, c = {
      className: "symbol",
      begin: "[a-zA-Z0-9_]+@"
    }, r = {
      className: "keyword",
      begin: "<",
      end: ">",
      contains: [
        o,
        c
      ]
    };
    return o.contains = [r], c.contains = [r], {
      name: "AngelScript",
      aliases: ["asc"],
      keywords: [
        "for",
        "in|0",
        "break",
        "continue",
        "while",
        "do|0",
        "return",
        "if",
        "else",
        "case",
        "switch",
        "namespace",
        "is",
        "cast",
        "or",
        "and",
        "xor",
        "not",
        "get|0",
        "in",
        "inout|10",
        "out",
        "override",
        "set|0",
        "private",
        "public",
        "const",
        "default|0",
        "final",
        "shared",
        "external",
        "mixin|10",
        "enum",
        "typedef",
        "funcdef",
        "this",
        "super",
        "import",
        "from",
        "interface",
        "abstract|0",
        "try",
        "catch",
        "protected",
        "explicit",
        "property"
      ],
      // avoid close detection with C# and JS
      illegal: "(^using\\s+[A-Za-z0-9_\\.]+;$|\\bfunction\\s*[^\\(])",
      contains: [
        {
          // 'strings'
          className: "string",
          begin: "'",
          end: "'",
          illegal: "\\n",
          contains: [i.BACKSLASH_ESCAPE],
          relevance: 0
        },
        // """heredoc strings"""
        {
          className: "string",
          begin: '"""',
          end: '"""'
        },
        {
          // "strings"
          className: "string",
          begin: '"',
          end: '"',
          illegal: "\\n",
          contains: [i.BACKSLASH_ESCAPE],
          relevance: 0
        },
        i.C_LINE_COMMENT_MODE,
        // single-line comments
        i.C_BLOCK_COMMENT_MODE,
        // comment blocks
        {
          // metadata
          className: "string",
          begin: "^\\s*\\[",
          end: "\\]"
        },
        {
          // interface or namespace declaration
          beginKeywords: "interface namespace",
          end: /\{/,
          illegal: "[;.\\-]",
          contains: [
            {
              // interface or namespace name
              className: "symbol",
              begin: "[a-zA-Z0-9_]+"
            }
          ]
        },
        {
          // class declaration
          beginKeywords: "class",
          end: /\{/,
          illegal: "[;.\\-]",
          contains: [
            {
              // class name
              className: "symbol",
              begin: "[a-zA-Z0-9_]+",
              contains: [
                {
                  begin: "[:,]\\s*",
                  contains: [
                    {
                      className: "symbol",
                      begin: "[a-zA-Z0-9_]+"
                    }
                  ]
                }
              ]
            }
          ]
        },
        o,
        // built-in types
        c,
        // object handles
        {
          // literals
          className: "literal",
          begin: "\\b(null|true|false)"
        },
        {
          // numbers
          className: "number",
          relevance: 0,
          begin: "(-?)(\\b0[xXbBoOdD][a-fA-F0-9]+|(\\b\\d+(\\.\\d*)?f?|\\.\\d+f?)([eE][-+]?\\d+f?)?)"
        }
      ]
    };
  }
  return Ed = s, Ed;
}
var hd, $S;
function eM() {
  if ($S)
    return hd;
  $S = 1;
  function s(i) {
    const o = {
      className: "number",
      begin: /[$%]\d+/
    }, c = {
      className: "number",
      begin: /\b\d+/
    }, r = {
      className: "number",
      begin: /\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}(:\d{1,5})?/
    }, e = {
      className: "number",
      begin: /:\d{1,5}/
    };
    return {
      name: "Apache config",
      aliases: ["apacheconf"],
      case_insensitive: !0,
      contains: [
        i.HASH_COMMENT_MODE,
        {
          className: "section",
          begin: /<\/?/,
          end: />/,
          contains: [
            r,
            e,
            // low relevance prevents us from claming XML/HTML where this rule would
            // match strings inside of XML tags
            i.inherit(i.QUOTE_STRING_MODE, { relevance: 0 })
          ]
        },
        {
          className: "attribute",
          begin: /\w+/,
          relevance: 0,
          // keywords aren’t needed for highlighting per se, they only boost relevance
          // for a very generally defined mode (starts with a word, ends with line-end
          keywords: { _: [
            "order",
            "deny",
            "allow",
            "setenv",
            "rewriterule",
            "rewriteengine",
            "rewritecond",
            "documentroot",
            "sethandler",
            "errordocument",
            "loadmodule",
            "options",
            "header",
            "listen",
            "serverroot",
            "servername"
          ] },
          starts: {
            end: /$/,
            relevance: 0,
            keywords: { literal: "on off all deny allow" },
            contains: [
              {
                className: "meta",
                begin: /\s\[/,
                end: /\]$/
              },
              {
                className: "variable",
                begin: /[\$%]\{/,
                end: /\}/,
                contains: [
                  "self",
                  o
                ]
              },
              r,
              c,
              i.QUOTE_STRING_MODE
            ]
          }
        }
      ],
      illegal: /\S/
    };
  }
  return hd = s, hd;
}
var Sd, WS;
function tM() {
  if (WS)
    return Sd;
  WS = 1;
  function s(i) {
    const o = i.regex, c = i.inherit(
      i.QUOTE_STRING_MODE,
      { illegal: null }
    ), r = {
      className: "params",
      begin: /\(/,
      end: /\)/,
      contains: [
        "self",
        i.C_NUMBER_MODE,
        c
      ]
    }, e = i.COMMENT(/--/, /$/), g = i.COMMENT(
      /\(\*/,
      /\*\)/,
      { contains: [
        "self",
        // allow nesting
        e
      ] }
    ), h = [
      e,
      g,
      i.HASH_COMMENT_MODE
    ], S = [
      /apart from/,
      /aside from/,
      /instead of/,
      /out of/,
      /greater than/,
      /isn't|(doesn't|does not) (equal|come before|come after|contain)/,
      /(greater|less) than( or equal)?/,
      /(starts?|ends|begins?) with/,
      /contained by/,
      /comes (before|after)/,
      /a (ref|reference)/,
      /POSIX (file|path)/,
      /(date|time) string/,
      /quoted form/
    ], C = [
      /clipboard info/,
      /the clipboard/,
      /info for/,
      /list (disks|folder)/,
      /mount volume/,
      /path to/,
      /(close|open for) access/,
      /(get|set) eof/,
      /current date/,
      /do shell script/,
      /get volume settings/,
      /random number/,
      /set volume/,
      /system attribute/,
      /system info/,
      /time to GMT/,
      /(load|run|store) script/,
      /scripting components/,
      /ASCII (character|number)/,
      /localized string/,
      /choose (application|color|file|file name|folder|from list|remote application|URL)/,
      /display (alert|dialog)/
    ];
    return {
      name: "AppleScript",
      aliases: ["osascript"],
      keywords: {
        keyword: "about above after against and around as at back before beginning behind below beneath beside between but by considering contain contains continue copy div does eighth else end equal equals error every exit fifth first for fourth from front get given global if ignoring in into is it its last local me middle mod my ninth not of on onto or over prop property put ref reference repeat returning script second set seventh since sixth some tell tenth that the|0 then third through thru timeout times to transaction try until where while whose with without",
        literal: "AppleScript false linefeed return pi quote result space tab true",
        built_in: "alias application boolean class constant date file integer list number real record string text activate beep count delay launch log offset read round run say summarize write character characters contents day frontmost id item length month name|0 paragraph paragraphs rest reverse running time version weekday word words year"
      },
      contains: [
        c,
        i.C_NUMBER_MODE,
        {
          className: "built_in",
          begin: o.concat(
            /\b/,
            o.either(...C),
            /\b/
          )
        },
        {
          className: "built_in",
          begin: /^\s*return\b/
        },
        {
          className: "literal",
          begin: /\b(text item delimiters|current application|missing value)\b/
        },
        {
          className: "keyword",
          begin: o.concat(
            /\b/,
            o.either(...S),
            /\b/
          )
        },
        {
          beginKeywords: "on",
          illegal: /[${=;\n]/,
          contains: [
            i.UNDERSCORE_TITLE_MODE,
            r
          ]
        },
        ...h
      ],
      illegal: /\/\/|->|=>|\[\[/
    };
  }
  return Sd = s, Sd;
}
var bd, zS;
function rM() {
  if (zS)
    return bd;
  zS = 1;
  function s(i) {
    const o = "[A-Za-z_][0-9A-Za-z_]*", c = {
      keyword: [
        "if",
        "for",
        "while",
        "var",
        "new",
        "function",
        "do",
        "return",
        "void",
        "else",
        "break"
      ],
      literal: [
        "BackSlash",
        "DoubleQuote",
        "false",
        "ForwardSlash",
        "Infinity",
        "NaN",
        "NewLine",
        "null",
        "PI",
        "SingleQuote",
        "Tab",
        "TextFormatting",
        "true",
        "undefined"
      ],
      built_in: [
        "Abs",
        "Acos",
        "All",
        "Angle",
        "Any",
        "Area",
        "AreaGeodetic",
        "Array",
        "Asin",
        "Atan",
        "Atan2",
        "Attachments",
        "Average",
        "Back",
        "Bearing",
        "Boolean",
        "Buffer",
        "BufferGeodetic",
        "Ceil",
        "Centroid",
        "Clip",
        "Concatenate",
        "Console",
        "Constrain",
        "Contains",
        "ConvertDirection",
        "Cos",
        "Count",
        "Crosses",
        "Cut",
        "Date",
        "DateAdd",
        "DateDiff",
        "Day",
        "Decode",
        "DefaultValue",
        "Densify",
        "DensifyGeodetic",
        "Dictionary",
        "Difference",
        "Disjoint",
        "Distance",
        "DistanceGeodetic",
        "Distinct",
        "Domain",
        "DomainCode",
        "DomainName",
        "EnvelopeIntersects",
        "Equals",
        "Erase",
        "Exp",
        "Expects",
        "Extent",
        "Feature",
        "FeatureSet",
        "FeatureSetByAssociation",
        "FeatureSetById",
        "FeatureSetByName",
        "FeatureSetByPortalItem",
        "FeatureSetByRelationshipName",
        "Filter",
        "Find",
        "First",
        "Floor",
        "FromCharCode",
        "FromCodePoint",
        "FromJSON",
        "GdbVersion",
        "Generalize",
        "Geometry",
        "GetFeatureSet",
        "GetUser",
        "GroupBy",
        "Guid",
        "Hash",
        "HasKey",
        "Hour",
        "IIf",
        "Includes",
        "IndexOf",
        "Insert",
        "Intersection",
        "Intersects",
        "IsEmpty",
        "IsNan",
        "ISOMonth",
        "ISOWeek",
        "ISOWeekday",
        "ISOYear",
        "IsSelfIntersecting",
        "IsSimple",
        "Left|0",
        "Length",
        "Length3D",
        "LengthGeodetic",
        "Log",
        "Lower",
        "Map",
        "Max",
        "Mean",
        "Mid",
        "Millisecond",
        "Min",
        "Minute",
        "Month",
        "MultiPartToSinglePart",
        "Multipoint",
        "NextSequenceValue",
        "None",
        "Now",
        "Number",
        "Offset|0",
        "OrderBy",
        "Overlaps",
        "Point",
        "Polygon",
        "Polyline",
        "Pop",
        "Portal",
        "Pow",
        "Proper",
        "Push",
        "Random",
        "Reduce",
        "Relate",
        "Replace",
        "Resize",
        "Reverse",
        "Right|0",
        "RingIsClockwise",
        "Rotate",
        "Round",
        "Schema",
        "Second",
        "SetGeometry",
        "Simplify",
        "Sin",
        "Slice",
        "Sort",
        "Splice",
        "Split",
        "Sqrt",
        "Stdev",
        "SubtypeCode",
        "SubtypeName",
        "Subtypes",
        "Sum",
        "SymmetricDifference",
        "Tan",
        "Text",
        "Timestamp",
        "ToCharCode",
        "ToCodePoint",
        "Today",
        "ToHex",
        "ToLocal",
        "Top|0",
        "Touches",
        "ToUTC",
        "TrackAccelerationAt",
        "TrackAccelerationWindow",
        "TrackCurrentAcceleration",
        "TrackCurrentDistance",
        "TrackCurrentSpeed",
        "TrackCurrentTime",
        "TrackDistanceAt",
        "TrackDistanceWindow",
        "TrackDuration",
        "TrackFieldWindow",
        "TrackGeometryWindow",
        "TrackIndex",
        "TrackSpeedAt",
        "TrackSpeedWindow",
        "TrackStartTime",
        "TrackWindow",
        "Trim",
        "TypeOf",
        "Union",
        "Upper",
        "UrlEncode",
        "Variance",
        "Week",
        "Weekday",
        "When",
        "Within",
        "Year"
      ]
    }, r = {
      className: "symbol",
      begin: "\\$[datastore|feature|layer|map|measure|sourcefeature|sourcelayer|targetfeature|targetlayer|value|view]+"
    }, e = {
      className: "number",
      variants: [
        { begin: "\\b(0[bB][01]+)" },
        { begin: "\\b(0[oO][0-7]+)" },
        { begin: i.C_NUMBER_RE }
      ],
      relevance: 0
    }, g = {
      className: "subst",
      begin: "\\$\\{",
      end: "\\}",
      keywords: c,
      contains: []
      // defined later
    }, h = {
      className: "string",
      begin: "`",
      end: "`",
      contains: [
        i.BACKSLASH_ESCAPE,
        g
      ]
    };
    g.contains = [
      i.APOS_STRING_MODE,
      i.QUOTE_STRING_MODE,
      h,
      e,
      i.REGEXP_MODE
    ];
    const S = g.contains.concat([
      i.C_BLOCK_COMMENT_MODE,
      i.C_LINE_COMMENT_MODE
    ]);
    return {
      name: "ArcGIS Arcade",
      case_insensitive: !0,
      keywords: c,
      contains: [
        i.APOS_STRING_MODE,
        i.QUOTE_STRING_MODE,
        h,
        i.C_LINE_COMMENT_MODE,
        i.C_BLOCK_COMMENT_MODE,
        r,
        e,
        {
          // object attr container
          begin: /[{,]\s*/,
          relevance: 0,
          contains: [
            {
              begin: o + "\\s*:",
              returnBegin: !0,
              relevance: 0,
              contains: [
                {
                  className: "attr",
                  begin: o,
                  relevance: 0
                }
              ]
            }
          ]
        },
        {
          // "value" container
          begin: "(" + i.RE_STARTERS_RE + "|\\b(return)\\b)\\s*",
          keywords: "return",
          contains: [
            i.C_LINE_COMMENT_MODE,
            i.C_BLOCK_COMMENT_MODE,
            i.REGEXP_MODE,
            {
              className: "function",
              begin: "(\\(.*?\\)|" + o + ")\\s*=>",
              returnBegin: !0,
              end: "\\s*=>",
              contains: [
                {
                  className: "params",
                  variants: [
                    { begin: o },
                    { begin: /\(\s*\)/ },
                    {
                      begin: /\(/,
                      end: /\)/,
                      excludeBegin: !0,
                      excludeEnd: !0,
                      keywords: c,
                      contains: S
                    }
                  ]
                }
              ]
            }
          ],
          relevance: 0
        },
        {
          beginKeywords: "function",
          end: /\{/,
          excludeEnd: !0,
          contains: [
            i.inherit(i.TITLE_MODE, {
              className: "title.function",
              begin: o
            }),
            {
              className: "params",
              begin: /\(/,
              end: /\)/,
              excludeBegin: !0,
              excludeEnd: !0,
              contains: S
            }
          ],
          illegal: /\[|%/
        },
        { begin: /\$[(.]/ }
      ],
      illegal: /#(?!!)/
    };
  }
  return bd = s, bd;
}
var Td, KS;
function nM() {
  if (KS)
    return Td;
  KS = 1;
  function s(o) {
    const c = o.regex, r = o.COMMENT("//", "$", { contains: [{ begin: /\\\n/ }] }), e = "decltype\\(auto\\)", g = "[a-zA-Z_]\\w*::", S = "(?!struct)(" + e + "|" + c.optional(g) + "[a-zA-Z_]\\w*" + c.optional("<[^<>]+>") + ")", C = {
      className: "type",
      begin: "\\b[a-z\\d_]*_t\\b"
    }, N = {
      className: "string",
      variants: [
        {
          begin: '(u8?|U|L)?"',
          end: '"',
          illegal: "\\n",
          contains: [o.BACKSLASH_ESCAPE]
        },
        {
          begin: "(u8?|U|L)?'(" + "\\\\(x[0-9A-Fa-f]{2}|u[0-9A-Fa-f]{4,8}|[0-7]{3}|\\S)" + "|.)",
          end: "'",
          illegal: "."
        },
        o.END_SAME_AS_BEGIN({
          begin: /(?:u8?|U|L)?R"([^()\\ ]{0,16})\(/,
          end: /\)([^()\\ ]{0,16})"/
        })
      ]
    }, D = {
      className: "number",
      variants: [
        { begin: "\\b(0b[01']+)" },
        { begin: "(-?)\\b([\\d']+(\\.[\\d']*)?|\\.[\\d']+)((ll|LL|l|L)(u|U)?|(u|U)(ll|LL|l|L)?|f|F|b|B)" },
        { begin: "(-?)(\\b0[xX][a-fA-F0-9']+|(\\b[\\d']+(\\.[\\d']*)?|\\.[\\d']+)([eE][-+]?[\\d']+)?)" }
      ],
      relevance: 0
    }, x = {
      className: "meta",
      begin: /#\s*[a-z]+\b/,
      end: /$/,
      keywords: { keyword: "if else elif endif define undef warning error line pragma _Pragma ifdef ifndef include" },
      contains: [
        {
          begin: /\\\n/,
          relevance: 0
        },
        o.inherit(N, { className: "string" }),
        {
          className: "string",
          begin: /<.*?>/
        },
        r,
        o.C_BLOCK_COMMENT_MODE
      ]
    }, L = {
      className: "title",
      begin: c.optional(g) + o.IDENT_RE,
      relevance: 0
    }, G = c.optional(g) + o.IDENT_RE + "\\s*\\(", Y = [
      "alignas",
      "alignof",
      "and",
      "and_eq",
      "asm",
      "atomic_cancel",
      "atomic_commit",
      "atomic_noexcept",
      "auto",
      "bitand",
      "bitor",
      "break",
      "case",
      "catch",
      "class",
      "co_await",
      "co_return",
      "co_yield",
      "compl",
      "concept",
      "const_cast|10",
      "consteval",
      "constexpr",
      "constinit",
      "continue",
      "decltype",
      "default",
      "delete",
      "do",
      "dynamic_cast|10",
      "else",
      "enum",
      "explicit",
      "export",
      "extern",
      "false",
      "final",
      "for",
      "friend",
      "goto",
      "if",
      "import",
      "inline",
      "module",
      "mutable",
      "namespace",
      "new",
      "noexcept",
      "not",
      "not_eq",
      "nullptr",
      "operator",
      "or",
      "or_eq",
      "override",
      "private",
      "protected",
      "public",
      "reflexpr",
      "register",
      "reinterpret_cast|10",
      "requires",
      "return",
      "sizeof",
      "static_assert",
      "static_cast|10",
      "struct",
      "switch",
      "synchronized",
      "template",
      "this",
      "thread_local",
      "throw",
      "transaction_safe",
      "transaction_safe_dynamic",
      "true",
      "try",
      "typedef",
      "typeid",
      "typename",
      "union",
      "using",
      "virtual",
      "volatile",
      "while",
      "xor",
      "xor_eq"
    ], k = [
      "bool",
      "char",
      "char16_t",
      "char32_t",
      "char8_t",
      "double",
      "float",
      "int",
      "long",
      "short",
      "void",
      "wchar_t",
      "unsigned",
      "signed",
      "const",
      "static"
    ], W = [
      "any",
      "auto_ptr",
      "barrier",
      "binary_semaphore",
      "bitset",
      "complex",
      "condition_variable",
      "condition_variable_any",
      "counting_semaphore",
      "deque",
      "false_type",
      "future",
      "imaginary",
      "initializer_list",
      "istringstream",
      "jthread",
      "latch",
      "lock_guard",
      "multimap",
      "multiset",
      "mutex",
      "optional",
      "ostringstream",
      "packaged_task",
      "pair",
      "promise",
      "priority_queue",
      "queue",
      "recursive_mutex",
      "recursive_timed_mutex",
      "scoped_lock",
      "set",
      "shared_future",
      "shared_lock",
      "shared_mutex",
      "shared_timed_mutex",
      "shared_ptr",
      "stack",
      "string_view",
      "stringstream",
      "timed_mutex",
      "thread",
      "true_type",
      "tuple",
      "unique_lock",
      "unique_ptr",
      "unordered_map",
      "unordered_multimap",
      "unordered_multiset",
      "unordered_set",
      "variant",
      "vector",
      "weak_ptr",
      "wstring",
      "wstring_view"
    ], Z = [
      "abort",
      "abs",
      "acos",
      "apply",
      "as_const",
      "asin",
      "atan",
      "atan2",
      "calloc",
      "ceil",
      "cerr",
      "cin",
      "clog",
      "cos",
      "cosh",
      "cout",
      "declval",
      "endl",
      "exchange",
      "exit",
      "exp",
      "fabs",
      "floor",
      "fmod",
      "forward",
      "fprintf",
      "fputs",
      "free",
      "frexp",
      "fscanf",
      "future",
      "invoke",
      "isalnum",
      "isalpha",
      "iscntrl",
      "isdigit",
      "isgraph",
      "islower",
      "isprint",
      "ispunct",
      "isspace",
      "isupper",
      "isxdigit",
      "labs",
      "launder",
      "ldexp",
      "log",
      "log10",
      "make_pair",
      "make_shared",
      "make_shared_for_overwrite",
      "make_tuple",
      "make_unique",
      "malloc",
      "memchr",
      "memcmp",
      "memcpy",
      "memset",
      "modf",
      "move",
      "pow",
      "printf",
      "putchar",
      "puts",
      "realloc",
      "scanf",
      "sin",
      "sinh",
      "snprintf",
      "sprintf",
      "sqrt",
      "sscanf",
      "std",
      "stderr",
      "stdin",
      "stdout",
      "strcat",
      "strchr",
      "strcmp",
      "strcpy",
      "strcspn",
      "strlen",
      "strncat",
      "strncmp",
      "strncpy",
      "strpbrk",
      "strrchr",
      "strspn",
      "strstr",
      "swap",
      "tan",
      "tanh",
      "terminate",
      "to_underlying",
      "tolower",
      "toupper",
      "vfprintf",
      "visit",
      "vprintf",
      "vsprintf"
    ], Q = {
      type: k,
      keyword: Y,
      literal: [
        "NULL",
        "false",
        "nullopt",
        "nullptr",
        "true"
      ],
      built_in: ["_Pragma"],
      _type_hints: W
    }, _e = {
      className: "function.dispatch",
      relevance: 0,
      keywords: {
        // Only for relevance, not highlighting.
        _hint: Z
      },
      begin: c.concat(
        /\b/,
        /(?!decltype)/,
        /(?!if)/,
        /(?!for)/,
        /(?!switch)/,
        /(?!while)/,
        o.IDENT_RE,
        c.lookahead(/(<[^<>]+>|)\s*\(/)
      )
    }, se = [
      _e,
      x,
      C,
      r,
      o.C_BLOCK_COMMENT_MODE,
      D,
      N
    ], Pe = {
      // This mode covers expression context where we can't expect a function
      // definition and shouldn't highlight anything that looks like one:
      // `return some()`, `else if()`, `(x*sum(1, 2))`
      variants: [
        {
          begin: /=/,
          end: /;/
        },
        {
          begin: /\(/,
          end: /\)/
        },
        {
          beginKeywords: "new throw return else",
          end: /;/
        }
      ],
      keywords: Q,
      contains: se.concat([
        {
          begin: /\(/,
          end: /\)/,
          keywords: Q,
          contains: se.concat(["self"]),
          relevance: 0
        }
      ]),
      relevance: 0
    }, Ke = {
      className: "function",
      begin: "(" + S + "[\\*&\\s]+)+" + G,
      returnBegin: !0,
      end: /[{;=]/,
      excludeEnd: !0,
      keywords: Q,
      illegal: /[^\w\s\*&:<>.]/,
      contains: [
        {
          // to prevent it from being confused as the function title
          begin: e,
          keywords: Q,
          relevance: 0
        },
        {
          begin: G,
          returnBegin: !0,
          contains: [L],
          relevance: 0
        },
        // needed because we do not have look-behind on the below rule
        // to prevent it from grabbing the final : in a :: pair
        {
          begin: /::/,
          relevance: 0
        },
        // initializers
        {
          begin: /:/,
          endsWithParent: !0,
          contains: [
            N,
            D
          ]
        },
        // allow for multiple declarations, e.g.:
        // extern void f(int), g(char);
        {
          relevance: 0,
          match: /,/
        },
        {
          className: "params",
          begin: /\(/,
          end: /\)/,
          keywords: Q,
          relevance: 0,
          contains: [
            r,
            o.C_BLOCK_COMMENT_MODE,
            N,
            D,
            C,
            // Count matching parentheses.
            {
              begin: /\(/,
              end: /\)/,
              keywords: Q,
              relevance: 0,
              contains: [
                "self",
                r,
                o.C_BLOCK_COMMENT_MODE,
                N,
                D,
                C
              ]
            }
          ]
        },
        C,
        r,
        o.C_BLOCK_COMMENT_MODE,
        x
      ]
    };
    return {
      name: "C++",
      aliases: [
        "cc",
        "c++",
        "h++",
        "hpp",
        "hh",
        "hxx",
        "cxx"
      ],
      keywords: Q,
      illegal: "</",
      classNameAliases: { "function.dispatch": "built_in" },
      contains: [].concat(
        Pe,
        Ke,
        _e,
        se,
        [
          x,
          {
            // containers: ie, `vector <int> rooms (9);`
            begin: "\\b(deque|list|queue|priority_queue|pair|stack|vector|map|set|bitset|multiset|multimap|unordered_map|unordered_set|unordered_multiset|unordered_multimap|array|tuple|optional|variant|function)\\s*<(?!<)",
            end: ">",
            keywords: Q,
            contains: [
              "self",
              C
            ]
          },
          {
            begin: o.IDENT_RE + "::",
            keywords: Q
          },
          {
            match: [
              // extra complexity to deal with `enum class` and `enum struct`
              /\b(?:enum(?:\s+(?:class|struct))?|class|struct|union)/,
              /\s+/,
              /\w+/
            ],
            className: {
              1: "keyword",
              3: "title.class"
            }
          }
        ]
      )
    };
  }
  function i(o) {
    const c = {
      type: [
        "boolean",
        "byte",
        "word",
        "String"
      ],
      built_in: [
        "KeyboardController",
        "MouseController",
        "SoftwareSerial",
        "EthernetServer",
        "EthernetClient",
        "LiquidCrystal",
        "RobotControl",
        "GSMVoiceCall",
        "EthernetUDP",
        "EsploraTFT",
        "HttpClient",
        "RobotMotor",
        "WiFiClient",
        "GSMScanner",
        "FileSystem",
        "Scheduler",
        "GSMServer",
        "YunClient",
        "YunServer",
        "IPAddress",
        "GSMClient",
        "GSMModem",
        "Keyboard",
        "Ethernet",
        "Console",
        "GSMBand",
        "Esplora",
        "Stepper",
        "Process",
        "WiFiUDP",
        "GSM_SMS",
        "Mailbox",
        "USBHost",
        "Firmata",
        "PImage",
        "Client",
        "Server",
        "GSMPIN",
        "FileIO",
        "Bridge",
        "Serial",
        "EEPROM",
        "Stream",
        "Mouse",
        "Audio",
        "Servo",
        "File",
        "Task",
        "GPRS",
        "WiFi",
        "Wire",
        "TFT",
        "GSM",
        "SPI",
        "SD"
      ],
      _hints: [
        "setup",
        "loop",
        "runShellCommandAsynchronously",
        "analogWriteResolution",
        "retrieveCallingNumber",
        "printFirmwareVersion",
        "analogReadResolution",
        "sendDigitalPortPair",
        "noListenOnLocalhost",
        "readJoystickButton",
        "setFirmwareVersion",
        "readJoystickSwitch",
        "scrollDisplayRight",
        "getVoiceCallStatus",
        "scrollDisplayLeft",
        "writeMicroseconds",
        "delayMicroseconds",
        "beginTransmission",
        "getSignalStrength",
        "runAsynchronously",
        "getAsynchronously",
        "listenOnLocalhost",
        "getCurrentCarrier",
        "readAccelerometer",
        "messageAvailable",
        "sendDigitalPorts",
        "lineFollowConfig",
        "countryNameWrite",
        "runShellCommand",
        "readStringUntil",
        "rewindDirectory",
        "readTemperature",
        "setClockDivider",
        "readLightSensor",
        "endTransmission",
        "analogReference",
        "detachInterrupt",
        "countryNameRead",
        "attachInterrupt",
        "encryptionType",
        "readBytesUntil",
        "robotNameWrite",
        "readMicrophone",
        "robotNameRead",
        "cityNameWrite",
        "userNameWrite",
        "readJoystickY",
        "readJoystickX",
        "mouseReleased",
        "openNextFile",
        "scanNetworks",
        "noInterrupts",
        "digitalWrite",
        "beginSpeaker",
        "mousePressed",
        "isActionDone",
        "mouseDragged",
        "displayLogos",
        "noAutoscroll",
        "addParameter",
        "remoteNumber",
        "getModifiers",
        "keyboardRead",
        "userNameRead",
        "waitContinue",
        "processInput",
        "parseCommand",
        "printVersion",
        "readNetworks",
        "writeMessage",
        "blinkVersion",
        "cityNameRead",
        "readMessage",
        "setDataMode",
        "parsePacket",
        "isListening",
        "setBitOrder",
        "beginPacket",
        "isDirectory",
        "motorsWrite",
        "drawCompass",
        "digitalRead",
        "clearScreen",
        "serialEvent",
        "rightToLeft",
        "setTextSize",
        "leftToRight",
        "requestFrom",
        "keyReleased",
        "compassRead",
        "analogWrite",
        "interrupts",
        "WiFiServer",
        "disconnect",
        "playMelody",
        "parseFloat",
        "autoscroll",
        "getPINUsed",
        "setPINUsed",
        "setTimeout",
        "sendAnalog",
        "readSlider",
        "analogRead",
        "beginWrite",
        "createChar",
        "motorsStop",
        "keyPressed",
        "tempoWrite",
        "readButton",
        "subnetMask",
        "debugPrint",
        "macAddress",
        "writeGreen",
        "randomSeed",
        "attachGPRS",
        "readString",
        "sendString",
        "remotePort",
        "releaseAll",
        "mouseMoved",
        "background",
        "getXChange",
        "getYChange",
        "answerCall",
        "getResult",
        "voiceCall",
        "endPacket",
        "constrain",
        "getSocket",
        "writeJSON",
        "getButton",
        "available",
        "connected",
        "findUntil",
        "readBytes",
        "exitValue",
        "readGreen",
        "writeBlue",
        "startLoop",
        "IPAddress",
        "isPressed",
        "sendSysex",
        "pauseMode",
        "gatewayIP",
        "setCursor",
        "getOemKey",
        "tuneWrite",
        "noDisplay",
        "loadImage",
        "switchPIN",
        "onRequest",
        "onReceive",
        "changePIN",
        "playFile",
        "noBuffer",
        "parseInt",
        "overflow",
        "checkPIN",
        "knobRead",
        "beginTFT",
        "bitClear",
        "updateIR",
        "bitWrite",
        "position",
        "writeRGB",
        "highByte",
        "writeRed",
        "setSpeed",
        "readBlue",
        "noStroke",
        "remoteIP",
        "transfer",
        "shutdown",
        "hangCall",
        "beginSMS",
        "endWrite",
        "attached",
        "maintain",
        "noCursor",
        "checkReg",
        "checkPUK",
        "shiftOut",
        "isValid",
        "shiftIn",
        "pulseIn",
        "connect",
        "println",
        "localIP",
        "pinMode",
        "getIMEI",
        "display",
        "noBlink",
        "process",
        "getBand",
        "running",
        "beginSD",
        "drawBMP",
        "lowByte",
        "setBand",
        "release",
        "bitRead",
        "prepare",
        "pointTo",
        "readRed",
        "setMode",
        "noFill",
        "remove",
        "listen",
        "stroke",
        "detach",
        "attach",
        "noTone",
        "exists",
        "buffer",
        "height",
        "bitSet",
        "circle",
        "config",
        "cursor",
        "random",
        "IRread",
        "setDNS",
        "endSMS",
        "getKey",
        "micros",
        "millis",
        "begin",
        "print",
        "write",
        "ready",
        "flush",
        "width",
        "isPIN",
        "blink",
        "clear",
        "press",
        "mkdir",
        "rmdir",
        "close",
        "point",
        "yield",
        "image",
        "BSSID",
        "click",
        "delay",
        "read",
        "text",
        "move",
        "peek",
        "beep",
        "rect",
        "line",
        "open",
        "seek",
        "fill",
        "size",
        "turn",
        "stop",
        "home",
        "find",
        "step",
        "tone",
        "sqrt",
        "RSSI",
        "SSID",
        "end",
        "bit",
        "tan",
        "cos",
        "sin",
        "pow",
        "map",
        "abs",
        "max",
        "min",
        "get",
        "run",
        "put"
      ],
      literal: [
        "DIGITAL_MESSAGE",
        "FIRMATA_STRING",
        "ANALOG_MESSAGE",
        "REPORT_DIGITAL",
        "REPORT_ANALOG",
        "INPUT_PULLUP",
        "SET_PIN_MODE",
        "INTERNAL2V56",
        "SYSTEM_RESET",
        "LED_BUILTIN",
        "INTERNAL1V1",
        "SYSEX_START",
        "INTERNAL",
        "EXTERNAL",
        "DEFAULT",
        "OUTPUT",
        "INPUT",
        "HIGH",
        "LOW"
      ]
    }, r = s(o), e = (
      /** @type {Record<string,any>} */
      r.keywords
    );
    return e.type = [
      ...e.type,
      ...c.type
    ], e.literal = [
      ...e.literal,
      ...c.literal
    ], e.built_in = [
      ...e.built_in,
      ...c.built_in
    ], e._hints = c._hints, r.name = "Arduino", r.aliases = ["ino"], r.supersetOf = "cpp", r;
  }
  return Td = i, Td;
}
var vd, QS;
function aM() {
  if (QS)
    return vd;
  QS = 1;
  function s(i) {
    const o = { variants: [
      i.COMMENT("^[ \\t]*(?=#)", "$", {
        relevance: 0,
        excludeBegin: !0
      }),
      i.COMMENT("[;@]", "$", { relevance: 0 }),
      i.C_LINE_COMMENT_MODE,
      i.C_BLOCK_COMMENT_MODE
    ] };
    return {
      name: "ARM Assembly",
      case_insensitive: !0,
      aliases: ["arm"],
      keywords: {
        $pattern: "\\.?" + i.IDENT_RE,
        meta: (
          // GNU preprocs
          ".2byte .4byte .align .ascii .asciz .balign .byte .code .data .else .end .endif .endm .endr .equ .err .exitm .extern .global .hword .if .ifdef .ifndef .include .irp .long .macro .rept .req .section .set .skip .space .text .word .arm .thumb .code16 .code32 .force_thumb .thumb_func .ltorg ALIAS ALIGN ARM AREA ASSERT ATTR CN CODE CODE16 CODE32 COMMON CP DATA DCB DCD DCDU DCDO DCFD DCFDU DCI DCQ DCQU DCW DCWU DN ELIF ELSE END ENDFUNC ENDIF ENDP ENTRY EQU EXPORT EXPORTAS EXTERN FIELD FILL FUNCTION GBLA GBLL GBLS GET GLOBAL IF IMPORT INCBIN INCLUDE INFO KEEP LCLA LCLL LCLS LTORG MACRO MAP MEND MEXIT NOFP OPT PRESERVE8 PROC QN READONLY RELOC REQUIRE REQUIRE8 RLIST FN ROUT SETA SETL SETS SN SPACE SUBT THUMB THUMBX TTL WHILE WEND "
        ),
        built_in: "r0 r1 r2 r3 r4 r5 r6 r7 r8 r9 r10 r11 r12 r13 r14 r15 w0 w1 w2 w3 w4 w5 w6 w7 w8 w9 w10 w11 w12 w13 w14 w15 w16 w17 w18 w19 w20 w21 w22 w23 w24 w25 w26 w27 w28 w29 w30 x0 x1 x2 x3 x4 x5 x6 x7 x8 x9 x10 x11 x12 x13 x14 x15 x16 x17 x18 x19 x20 x21 x22 x23 x24 x25 x26 x27 x28 x29 x30 pc lr sp ip sl sb fp a1 a2 a3 a4 v1 v2 v3 v4 v5 v6 v7 v8 f0 f1 f2 f3 f4 f5 f6 f7 p0 p1 p2 p3 p4 p5 p6 p7 p8 p9 p10 p11 p12 p13 p14 p15 c0 c1 c2 c3 c4 c5 c6 c7 c8 c9 c10 c11 c12 c13 c14 c15 q0 q1 q2 q3 q4 q5 q6 q7 q8 q9 q10 q11 q12 q13 q14 q15 cpsr_c cpsr_x cpsr_s cpsr_f cpsr_cx cpsr_cxs cpsr_xs cpsr_xsf cpsr_sf cpsr_cxsf spsr_c spsr_x spsr_s spsr_f spsr_cx spsr_cxs spsr_xs spsr_xsf spsr_sf spsr_cxsf s0 s1 s2 s3 s4 s5 s6 s7 s8 s9 s10 s11 s12 s13 s14 s15 s16 s17 s18 s19 s20 s21 s22 s23 s24 s25 s26 s27 s28 s29 s30 s31 d0 d1 d2 d3 d4 d5 d6 d7 d8 d9 d10 d11 d12 d13 d14 d15 d16 d17 d18 d19 d20 d21 d22 d23 d24 d25 d26 d27 d28 d29 d30 d31 {PC} {VAR} {TRUE} {FALSE} {OPT} {CONFIG} {ENDIAN} {CODESIZE} {CPU} {FPU} {ARCHITECTURE} {PCSTOREOFFSET} {ARMASM_VERSION} {INTER} {ROPI} {RWPI} {SWST} {NOSWST} . @"
      },
      contains: [
        {
          className: "keyword",
          begin: "\\b(adc|(qd?|sh?|u[qh]?)?add(8|16)?|usada?8|(q|sh?|u[qh]?)?(as|sa)x|and|adrl?|sbc|rs[bc]|asr|b[lx]?|blx|bxj|cbn?z|tb[bh]|bic|bfc|bfi|[su]bfx|bkpt|cdp2?|clz|clrex|cmp|cmn|cpsi[ed]|cps|setend|dbg|dmb|dsb|eor|isb|it[te]{0,3}|lsl|lsr|ror|rrx|ldm(([id][ab])|f[ds])?|ldr((s|ex)?[bhd])?|movt?|mvn|mra|mar|mul|[us]mull|smul[bwt][bt]|smu[as]d|smmul|smmla|mla|umlaal|smlal?([wbt][bt]|d)|mls|smlsl?[ds]|smc|svc|sev|mia([bt]{2}|ph)?|mrr?c2?|mcrr2?|mrs|msr|orr|orn|pkh(tb|bt)|rbit|rev(16|sh)?|sel|[su]sat(16)?|nop|pop|push|rfe([id][ab])?|stm([id][ab])?|str(ex)?[bhd]?|(qd?)?sub|(sh?|q|u[qh]?)?sub(8|16)|[su]xt(a?h|a?b(16)?)|srs([id][ab])?|swpb?|swi|smi|tst|teq|wfe|wfi|yield)(eq|ne|cs|cc|mi|pl|vs|vc|hi|ls|ge|lt|gt|le|al|hs|lo)?[sptrx]?(?=\\s)"
          // followed by space
        },
        o,
        i.QUOTE_STRING_MODE,
        {
          className: "string",
          begin: "'",
          end: "[^\\\\]'",
          relevance: 0
        },
        {
          className: "title",
          begin: "\\|",
          end: "\\|",
          illegal: "\\n",
          relevance: 0
        },
        {
          className: "number",
          variants: [
            {
              // hex
              begin: "[#$=]?0x[0-9a-f]+"
            },
            {
              // bin
              begin: "[#$=]?0b[01]+"
            },
            {
              // literal
              begin: "[#$=]\\d+"
            },
            {
              // bare number
              begin: "\\b\\d+"
            }
          ],
          relevance: 0
        },
        {
          className: "symbol",
          variants: [
            {
              // GNU ARM syntax
              begin: "^[ \\t]*[a-z_\\.\\$][a-z0-9_\\.\\$]+:"
            },
            {
              // ARM syntax
              begin: "^[a-z_\\.\\$][a-z0-9_\\.\\$]+"
            },
            {
              // label reference
              begin: "[=#]\\w+"
            }
          ],
          relevance: 0
        }
      ]
    };
  }
  return vd = s, vd;
}
var Cd, XS;
function iM() {
  if (XS)
    return Cd;
  XS = 1;
  function s(i) {
    const o = i.regex, c = o.concat(/[\p{L}_]/u, o.optional(/[\p{L}0-9_.-]*:/u), /[\p{L}0-9_.-]*/u), r = /[\p{L}0-9._:-]+/u, e = {
      className: "symbol",
      begin: /&[a-z]+;|&#[0-9]+;|&#x[a-f0-9]+;/
    }, g = {
      begin: /\s/,
      contains: [
        {
          className: "keyword",
          begin: /#?[a-z_][a-z1-9_-]+/,
          illegal: /\n/
        }
      ]
    }, h = i.inherit(g, {
      begin: /\(/,
      end: /\)/
    }), S = i.inherit(i.APOS_STRING_MODE, { className: "string" }), C = i.inherit(i.QUOTE_STRING_MODE, { className: "string" }), O = {
      endsWithParent: !0,
      illegal: /</,
      relevance: 0,
      contains: [
        {
          className: "attr",
          begin: r,
          relevance: 0
        },
        {
          begin: /=\s*/,
          relevance: 0,
          contains: [
            {
              className: "string",
              endsParent: !0,
              variants: [
                {
                  begin: /"/,
                  end: /"/,
                  contains: [e]
                },
                {
                  begin: /'/,
                  end: /'/,
                  contains: [e]
                },
                { begin: /[^\s"'=<>`]+/ }
              ]
            }
          ]
        }
      ]
    };
    return {
      name: "HTML, XML",
      aliases: [
        "html",
        "xhtml",
        "rss",
        "atom",
        "xjb",
        "xsd",
        "xsl",
        "plist",
        "wsf",
        "svg"
      ],
      case_insensitive: !0,
      unicodeRegex: !0,
      contains: [
        {
          className: "meta",
          begin: /<![a-z]/,
          end: />/,
          relevance: 10,
          contains: [
            g,
            C,
            S,
            h,
            {
              begin: /\[/,
              end: /\]/,
              contains: [
                {
                  className: "meta",
                  begin: /<![a-z]/,
                  end: />/,
                  contains: [
                    g,
                    h,
                    C,
                    S
                  ]
                }
              ]
            }
          ]
        },
        i.COMMENT(
          /<!--/,
          /-->/,
          { relevance: 10 }
        ),
        {
          begin: /<!\[CDATA\[/,
          end: /\]\]>/,
          relevance: 10
        },
        e,
        // xml processing instructions
        {
          className: "meta",
          end: /\?>/,
          variants: [
            {
              begin: /<\?xml/,
              relevance: 10,
              contains: [
                C
              ]
            },
            {
              begin: /<\?[a-z][a-z0-9]+/
            }
          ]
        },
        {
          className: "tag",
          /*
          The lookahead pattern (?=...) ensures that 'begin' only matches
          '<style' as a single word, followed by a whitespace or an
          ending bracket.
          */
          begin: /<style(?=\s|>)/,
          end: />/,
          keywords: { name: "style" },
          contains: [O],
          starts: {
            end: /<\/style>/,
            returnEnd: !0,
            subLanguage: [
              "css",
              "xml"
            ]
          }
        },
        {
          className: "tag",
          // See the comment in the <style tag about the lookahead pattern
          begin: /<script(?=\s|>)/,
          end: />/,
          keywords: { name: "script" },
          contains: [O],
          starts: {
            end: /<\/script>/,
            returnEnd: !0,
            subLanguage: [
              "javascript",
              "handlebars",
              "xml"
            ]
          }
        },
        // we need this for now for jSX
        {
          className: "tag",
          begin: /<>|<\/>/
        },
        // open tag
        {
          className: "tag",
          begin: o.concat(
            /</,
            o.lookahead(o.concat(
              c,
              // <tag/>
              // <tag>
              // <tag ...
              o.either(/\/>/, />/, /\s/)
            ))
          ),
          end: /\/?>/,
          contains: [
            {
              className: "name",
              begin: c,
              relevance: 0,
              starts: O
            }
          ]
        },
        // close tag
        {
          className: "tag",
          begin: o.concat(
            /<\//,
            o.lookahead(o.concat(
              c,
              />/
            ))
          ),
          contains: [
            {
              className: "name",
              begin: c,
              relevance: 0
            },
            {
              begin: />/,
              relevance: 0,
              endsParent: !0
            }
          ]
        }
      ]
    };
  }
  return Cd = s, Cd;
}
var Rd, ZS;
function oM() {
  if (ZS)
    return Rd;
  ZS = 1;
  function s(i) {
    const o = i.regex, c = {
      begin: "^'{3,}[ \\t]*$",
      relevance: 10
    }, r = [
      // escaped constrained formatting marks (i.e., \* \_ or \`)
      { begin: /\\[*_`]/ },
      // escaped unconstrained formatting marks (i.e., \\** \\__ or \\``)
      // must ignore until the next formatting marks
      // this rule might not be 100% compliant with Asciidoctor 2.0 but we are entering undefined behavior territory...
      { begin: /\\\\\*{2}[^\n]*?\*{2}/ },
      { begin: /\\\\_{2}[^\n]*_{2}/ },
      { begin: /\\\\`{2}[^\n]*`{2}/ },
      // guard: constrained formatting mark may not be preceded by ":", ";" or
      // "}". match these so the constrained rule doesn't see them
      { begin: /[:;}][*_`](?![*_`])/ }
    ], e = [
      // inline unconstrained strong (single line)
      {
        className: "strong",
        begin: /\*{2}([^\n]+?)\*{2}/
      },
      // inline unconstrained strong (multi-line)
      {
        className: "strong",
        begin: o.concat(
          /\*\*/,
          /((\*(?!\*)|\\[^\n]|[^*\n\\])+\n)+/,
          /(\*(?!\*)|\\[^\n]|[^*\n\\])*/,
          /\*\*/
        ),
        relevance: 0
      },
      // inline constrained strong (single line)
      {
        className: "strong",
        // must not precede or follow a word character
        begin: /\B\*(\S|\S[^\n]*?\S)\*(?!\w)/
      },
      // inline constrained strong (multi-line)
      {
        className: "strong",
        // must not precede or follow a word character
        begin: /\*[^\s]([^\n]+\n)+([^\n]+)\*/
      }
    ], g = [
      // inline unconstrained emphasis (single line)
      {
        className: "emphasis",
        begin: /_{2}([^\n]+?)_{2}/
      },
      // inline unconstrained emphasis (multi-line)
      {
        className: "emphasis",
        begin: o.concat(
          /__/,
          /((_(?!_)|\\[^\n]|[^_\n\\])+\n)+/,
          /(_(?!_)|\\[^\n]|[^_\n\\])*/,
          /__/
        ),
        relevance: 0
      },
      // inline constrained emphasis (single line)
      {
        className: "emphasis",
        // must not precede or follow a word character
        begin: /\b_(\S|\S[^\n]*?\S)_(?!\w)/
      },
      // inline constrained emphasis (multi-line)
      {
        className: "emphasis",
        // must not precede or follow a word character
        begin: /_[^\s]([^\n]+\n)+([^\n]+)_/
      },
      // inline constrained emphasis using single quote (legacy)
      {
        className: "emphasis",
        // must not follow a word character or be followed by a single quote or space
        begin: "\\B'(?!['\\s])",
        end: "(\\n{2}|')",
        // allow escaped single quote followed by word char
        contains: [
          {
            begin: "\\\\'\\w",
            relevance: 0
          }
        ],
        relevance: 0
      }
    ], h = {
      className: "symbol",
      begin: "^(NOTE|TIP|IMPORTANT|WARNING|CAUTION):\\s+",
      relevance: 10
    }, S = {
      className: "bullet",
      begin: "^(\\*+|-+|\\.+|[^\\n]+?::)\\s+"
    };
    return {
      name: "AsciiDoc",
      aliases: ["adoc"],
      contains: [
        // block comment
        i.COMMENT(
          "^/{4,}\\n",
          "\\n/{4,}$",
          // can also be done as...
          // '^/{4,}$',
          // '^/{4,}$',
          { relevance: 10 }
        ),
        // line comment
        i.COMMENT(
          "^//",
          "$",
          { relevance: 0 }
        ),
        // title
        {
          className: "title",
          begin: "^\\.\\w.*$"
        },
        // example, admonition & sidebar blocks
        {
          begin: "^[=\\*]{4,}\\n",
          end: "\\n^[=\\*]{4,}$",
          relevance: 10
        },
        // headings
        {
          className: "section",
          relevance: 10,
          variants: [
            { begin: "^(={1,6})[ 	].+?([ 	]\\1)?$" },
            { begin: "^[^\\[\\]\\n]+?\\n[=\\-~\\^\\+]{2,}$" }
          ]
        },
        // document attributes
        {
          className: "meta",
          begin: "^:.+?:",
          end: "\\s",
          excludeEnd: !0,
          relevance: 10
        },
        // block attributes
        {
          className: "meta",
          begin: "^\\[.+?\\]$",
          relevance: 0
        },
        // quoteblocks
        {
          className: "quote",
          begin: "^_{4,}\\n",
          end: "\\n_{4,}$",
          relevance: 10
        },
        // listing and literal blocks
        {
          className: "code",
          begin: "^[\\-\\.]{4,}\\n",
          end: "\\n[\\-\\.]{4,}$",
          relevance: 10
        },
        // passthrough blocks
        {
          begin: "^\\+{4,}\\n",
          end: "\\n\\+{4,}$",
          contains: [
            {
              begin: "<",
              end: ">",
              subLanguage: "xml",
              relevance: 0
            }
          ],
          relevance: 10
        },
        S,
        h,
        ...r,
        ...e,
        ...g,
        // inline smart quotes
        {
          className: "string",
          variants: [
            { begin: "``.+?''" },
            { begin: "`.+?'" }
          ]
        },
        // inline unconstrained emphasis
        {
          className: "code",
          begin: /`{2}/,
          end: /(\n{2}|`{2})/
        },
        // inline code snippets (TODO should get same treatment as strong and emphasis)
        {
          className: "code",
          begin: "(`.+?`|\\+.+?\\+)",
          relevance: 0
        },
        // indented literal block
        {
          className: "code",
          begin: "^[ \\t]",
          end: "$",
          relevance: 0
        },
        c,
        // images and links
        {
          begin: "(link:)?(http|https|ftp|file|irc|image:?):\\S+?\\[[^[]*?\\]",
          returnBegin: !0,
          contains: [
            {
              begin: "(link|image:?):",
              relevance: 0
            },
            {
              className: "link",
              begin: "\\w",
              end: "[^\\[]+",
              relevance: 0
            },
            {
              className: "string",
              begin: "\\[",
              end: "\\]",
              excludeBegin: !0,
              excludeEnd: !0,
              relevance: 0
            }
          ],
          relevance: 10
        }
      ]
    };
  }
  return Rd = s, Rd;
}
var Nd, jS;
function sM() {
  if (jS)
    return Nd;
  jS = 1;
  function s(i) {
    const o = i.regex, c = [
      "false",
      "synchronized",
      "int",
      "abstract",
      "float",
      "private",
      "char",
      "boolean",
      "static",
      "null",
      "if",
      "const",
      "for",
      "true",
      "while",
      "long",
      "throw",
      "strictfp",
      "finally",
      "protected",
      "import",
      "native",
      "final",
      "return",
      "void",
      "enum",
      "else",
      "extends",
      "implements",
      "break",
      "transient",
      "new",
      "catch",
      "instanceof",
      "byte",
      "super",
      "volatile",
      "case",
      "assert",
      "short",
      "package",
      "default",
      "double",
      "public",
      "try",
      "this",
      "switch",
      "continue",
      "throws",
      "privileged",
      "aspectOf",
      "adviceexecution",
      "proceed",
      "cflowbelow",
      "cflow",
      "initialization",
      "preinitialization",
      "staticinitialization",
      "withincode",
      "target",
      "within",
      "execution",
      "getWithinTypeName",
      "handler",
      "thisJoinPoint",
      "thisJoinPointStaticPart",
      "thisEnclosingJoinPointStaticPart",
      "declare",
      "parents",
      "warning",
      "error",
      "soft",
      "precedence",
      "thisAspectInstance"
    ], r = [
      "get",
      "set",
      "args",
      "call"
    ];
    return {
      name: "AspectJ",
      keywords: c,
      illegal: /<\/|#/,
      contains: [
        i.COMMENT(
          /\/\*\*/,
          /\*\//,
          {
            relevance: 0,
            contains: [
              {
                // eat up @'s in emails to prevent them to be recognized as doctags
                begin: /\w+@/,
                relevance: 0
              },
              {
                className: "doctag",
                begin: /@[A-Za-z]+/
              }
            ]
          }
        ),
        i.C_LINE_COMMENT_MODE,
        i.C_BLOCK_COMMENT_MODE,
        i.APOS_STRING_MODE,
        i.QUOTE_STRING_MODE,
        {
          className: "class",
          beginKeywords: "aspect",
          end: /[{;=]/,
          excludeEnd: !0,
          illegal: /[:;"\[\]]/,
          contains: [
            { beginKeywords: "extends implements pertypewithin perthis pertarget percflowbelow percflow issingleton" },
            i.UNDERSCORE_TITLE_MODE,
            {
              begin: /\([^\)]*/,
              end: /[)]+/,
              keywords: c.concat(r),
              excludeEnd: !1
            }
          ]
        },
        {
          className: "class",
          beginKeywords: "class interface",
          end: /[{;=]/,
          excludeEnd: !0,
          relevance: 0,
          keywords: "class interface",
          illegal: /[:"\[\]]/,
          contains: [
            { beginKeywords: "extends implements" },
            i.UNDERSCORE_TITLE_MODE
          ]
        },
        {
          // AspectJ Constructs
          beginKeywords: "pointcut after before around throwing returning",
          end: /[)]/,
          excludeEnd: !1,
          illegal: /["\[\]]/,
          contains: [
            {
              begin: o.concat(i.UNDERSCORE_IDENT_RE, /\s*\(/),
              returnBegin: !0,
              contains: [i.UNDERSCORE_TITLE_MODE]
            }
          ]
        },
        {
          begin: /[:]/,
          returnBegin: !0,
          end: /[{;]/,
          relevance: 0,
          excludeEnd: !1,
          keywords: c,
          illegal: /["\[\]]/,
          contains: [
            {
              begin: o.concat(i.UNDERSCORE_IDENT_RE, /\s*\(/),
              keywords: c.concat(r),
              relevance: 0
            },
            i.QUOTE_STRING_MODE
          ]
        },
        {
          // this prevents 'new Name(...), or throw ...' from being recognized as a function definition
          beginKeywords: "new throw",
          relevance: 0
        },
        {
          // the function class is a bit different for AspectJ compared to the Java language
          className: "function",
          begin: /\w+ +\w+(\.\w+)?\s*\([^\)]*\)\s*((throws)[\w\s,]+)?[\{;]/,
          returnBegin: !0,
          end: /[{;=]/,
          keywords: c,
          excludeEnd: !0,
          contains: [
            {
              begin: o.concat(i.UNDERSCORE_IDENT_RE, /\s*\(/),
              returnBegin: !0,
              relevance: 0,
              contains: [i.UNDERSCORE_TITLE_MODE]
            },
            {
              className: "params",
              begin: /\(/,
              end: /\)/,
              relevance: 0,
              keywords: c,
              contains: [
                i.APOS_STRING_MODE,
                i.QUOTE_STRING_MODE,
                i.C_NUMBER_MODE,
                i.C_BLOCK_COMMENT_MODE
              ]
            },
            i.C_LINE_COMMENT_MODE,
            i.C_BLOCK_COMMENT_MODE
          ]
        },
        i.C_NUMBER_MODE,
        {
          // annotation is also used in this language
          className: "meta",
          begin: /@[A-Za-z]+/
        }
      ]
    };
  }
  return Nd = s, Nd;
}
var Ad, JS;
function lM() {
  if (JS)
    return Ad;
  JS = 1;
  function s(i) {
    const o = { begin: "`[\\s\\S]" };
    return {
      name: "AutoHotkey",
      case_insensitive: !0,
      aliases: ["ahk"],
      keywords: {
        keyword: "Break Continue Critical Exit ExitApp Gosub Goto New OnExit Pause return SetBatchLines SetTimer Suspend Thread Throw Until ahk_id ahk_class ahk_pid ahk_exe ahk_group",
        literal: "true false NOT AND OR",
        built_in: "ComSpec Clipboard ClipboardAll ErrorLevel"
      },
      contains: [
        o,
        i.inherit(i.QUOTE_STRING_MODE, { contains: [o] }),
        i.COMMENT(";", "$", { relevance: 0 }),
        i.C_BLOCK_COMMENT_MODE,
        {
          className: "number",
          begin: i.NUMBER_RE,
          relevance: 0
        },
        {
          // subst would be the most accurate however fails the point of
          // highlighting. variable is comparably the most accurate that actually
          // has some effect
          className: "variable",
          begin: "%[a-zA-Z0-9#_$@]+%"
        },
        {
          className: "built_in",
          begin: "^\\s*\\w+\\s*(,|%)"
          // I don't really know if this is totally relevant
        },
        {
          // symbol would be most accurate however is highlighted just like
          // built_in and that makes up a lot of AutoHotkey code meaning that it
          // would fail to highlight anything
          className: "title",
          variants: [
            { begin: '^[^\\n";]+::(?!=)' },
            {
              begin: '^[^\\n";]+:(?!=)',
              // zero relevance as it catches a lot of things
              // followed by a single ':' in many languages
              relevance: 0
            }
          ]
        },
        {
          className: "meta",
          begin: "^\\s*#\\w+",
          end: "$",
          relevance: 0
        },
        {
          className: "built_in",
          begin: "A_[a-zA-Z0-9]+"
        },
        {
          // consecutive commas, not for highlighting but just for relevance
          begin: ",\\s*,"
        }
      ]
    };
  }
  return Ad = s, Ad;
}
var Od, e0;
function cM() {
  if (e0)
    return Od;
  e0 = 1;
  function s(i) {
    const o = "ByRef Case Const ContinueCase ContinueLoop Dim Do Else ElseIf EndFunc EndIf EndSelect EndSwitch EndWith Enum Exit ExitLoop For Func Global If In Local Next ReDim Return Select Static Step Switch Then To Until Volatile WEnd While With", c = [
      "EndRegion",
      "forcedef",
      "forceref",
      "ignorefunc",
      "include",
      "include-once",
      "NoTrayIcon",
      "OnAutoItStartRegister",
      "pragma",
      "Region",
      "RequireAdmin",
      "Tidy_Off",
      "Tidy_On",
      "Tidy_Parameters"
    ], r = "True False And Null Not Or Default", e = "Abs ACos AdlibRegister AdlibUnRegister Asc AscW ASin Assign ATan AutoItSetOption AutoItWinGetTitle AutoItWinSetTitle Beep Binary BinaryLen BinaryMid BinaryToString BitAND BitNOT BitOR BitRotate BitShift BitXOR BlockInput Break Call CDTray Ceiling Chr ChrW ClipGet ClipPut ConsoleRead ConsoleWrite ConsoleWriteError ControlClick ControlCommand ControlDisable ControlEnable ControlFocus ControlGetFocus ControlGetHandle ControlGetPos ControlGetText ControlHide ControlListView ControlMove ControlSend ControlSetText ControlShow ControlTreeView Cos Dec DirCopy DirCreate DirGetSize DirMove DirRemove DllCall DllCallAddress DllCallbackFree DllCallbackGetPtr DllCallbackRegister DllClose DllOpen DllStructCreate DllStructGetData DllStructGetPtr DllStructGetSize DllStructSetData DriveGetDrive DriveGetFileSystem DriveGetLabel DriveGetSerial DriveGetType DriveMapAdd DriveMapDel DriveMapGet DriveSetLabel DriveSpaceFree DriveSpaceTotal DriveStatus EnvGet EnvSet EnvUpdate Eval Execute Exp FileChangeDir FileClose FileCopy FileCreateNTFSLink FileCreateShortcut FileDelete FileExists FileFindFirstFile FileFindNextFile FileFlush FileGetAttrib FileGetEncoding FileGetLongName FileGetPos FileGetShortcut FileGetShortName FileGetSize FileGetTime FileGetVersion FileInstall FileMove FileOpen FileOpenDialog FileRead FileReadLine FileReadToArray FileRecycle FileRecycleEmpty FileSaveDialog FileSelectFolder FileSetAttrib FileSetEnd FileSetPos FileSetTime FileWrite FileWriteLine Floor FtpSetProxy FuncName GUICreate GUICtrlCreateAvi GUICtrlCreateButton GUICtrlCreateCheckbox GUICtrlCreateCombo GUICtrlCreateContextMenu GUICtrlCreateDate GUICtrlCreateDummy GUICtrlCreateEdit GUICtrlCreateGraphic GUICtrlCreateGroup GUICtrlCreateIcon GUICtrlCreateInput GUICtrlCreateLabel GUICtrlCreateList GUICtrlCreateListView GUICtrlCreateListViewItem GUICtrlCreateMenu GUICtrlCreateMenuItem GUICtrlCreateMonthCal GUICtrlCreateObj GUICtrlCreatePic GUICtrlCreateProgress GUICtrlCreateRadio GUICtrlCreateSlider GUICtrlCreateTab GUICtrlCreateTabItem GUICtrlCreateTreeView GUICtrlCreateTreeViewItem GUICtrlCreateUpdown GUICtrlDelete GUICtrlGetHandle GUICtrlGetState GUICtrlRead GUICtrlRecvMsg GUICtrlRegisterListViewSort GUICtrlSendMsg GUICtrlSendToDummy GUICtrlSetBkColor GUICtrlSetColor GUICtrlSetCursor GUICtrlSetData GUICtrlSetDefBkColor GUICtrlSetDefColor GUICtrlSetFont GUICtrlSetGraphic GUICtrlSetImage GUICtrlSetLimit GUICtrlSetOnEvent GUICtrlSetPos GUICtrlSetResizing GUICtrlSetState GUICtrlSetStyle GUICtrlSetTip GUIDelete GUIGetCursorInfo GUIGetMsg GUIGetStyle GUIRegisterMsg GUISetAccelerators GUISetBkColor GUISetCoord GUISetCursor GUISetFont GUISetHelp GUISetIcon GUISetOnEvent GUISetState GUISetStyle GUIStartGroup GUISwitch Hex HotKeySet HttpSetProxy HttpSetUserAgent HWnd InetClose InetGet InetGetInfo InetGetSize InetRead IniDelete IniRead IniReadSection IniReadSectionNames IniRenameSection IniWrite IniWriteSection InputBox Int IsAdmin IsArray IsBinary IsBool IsDeclared IsDllStruct IsFloat IsFunc IsHWnd IsInt IsKeyword IsNumber IsObj IsPtr IsString Log MemGetStats Mod MouseClick MouseClickDrag MouseDown MouseGetCursor MouseGetPos MouseMove MouseUp MouseWheel MsgBox Number ObjCreate ObjCreateInterface ObjEvent ObjGet ObjName OnAutoItExitRegister OnAutoItExitUnRegister Ping PixelChecksum PixelGetColor PixelSearch ProcessClose ProcessExists ProcessGetStats ProcessList ProcessSetPriority ProcessWait ProcessWaitClose ProgressOff ProgressOn ProgressSet Ptr Random RegDelete RegEnumKey RegEnumVal RegRead RegWrite Round Run RunAs RunAsWait RunWait Send SendKeepActive SetError SetExtended ShellExecute ShellExecuteWait Shutdown Sin Sleep SoundPlay SoundSetWaveVolume SplashImageOn SplashOff SplashTextOn Sqrt SRandom StatusbarGetText StderrRead StdinWrite StdioClose StdoutRead String StringAddCR StringCompare StringFormat StringFromASCIIArray StringInStr StringIsAlNum StringIsAlpha StringIsASCII StringIsDigit StringIsFloat StringIsInt StringIsLower StringIsSpace StringIsUpper StringIsXDigit StringLeft StringLen StringLower StringMid StringRegExp StringRegExpReplace StringReplace StringReverse StringRight StringSplit StringStripCR StringStripWS StringToASCIIArray StringToBinary StringTrimLeft StringTrimRight StringUpper Tan TCPAccept TCPCloseSocket TCPConnect TCPListen TCPNameToIP TCPRecv TCPSend TCPShutdown, UDPShutdown TCPStartup, UDPStartup TimerDiff TimerInit ToolTip TrayCreateItem TrayCreateMenu TrayGetMsg TrayItemDelete TrayItemGetHandle TrayItemGetState TrayItemGetText TrayItemSetOnEvent TrayItemSetState TrayItemSetText TraySetClick TraySetIcon TraySetOnEvent TraySetPauseIcon TraySetState TraySetToolTip TrayTip UBound UDPBind UDPCloseSocket UDPOpen UDPRecv UDPSend VarGetType WinActivate WinActive WinClose WinExists WinFlash WinGetCaretPos WinGetClassList WinGetClientSize WinGetHandle WinGetPos WinGetProcess WinGetState WinGetText WinGetTitle WinKill WinList WinMenuSelectItem WinMinimizeAll WinMinimizeAllUndo WinMove WinSetOnTop WinSetState WinSetTitle WinSetTrans WinWait WinWaitActive WinWaitClose WinWaitNotActive", g = { variants: [
      i.COMMENT(";", "$", { relevance: 0 }),
      i.COMMENT("#cs", "#ce"),
      i.COMMENT("#comments-start", "#comments-end")
    ] }, h = { begin: "\\$[A-z0-9_]+" }, S = {
      className: "string",
      variants: [
        {
          begin: /"/,
          end: /"/,
          contains: [
            {
              begin: /""/,
              relevance: 0
            }
          ]
        },
        {
          begin: /'/,
          end: /'/,
          contains: [
            {
              begin: /''/,
              relevance: 0
            }
          ]
        }
      ]
    }, C = { variants: [
      i.BINARY_NUMBER_MODE,
      i.C_NUMBER_MODE
    ] }, O = {
      className: "meta",
      begin: "#",
      end: "$",
      keywords: { keyword: c },
      contains: [
        {
          begin: /\\\n/,
          relevance: 0
        },
        {
          beginKeywords: "include",
          keywords: { keyword: "include" },
          end: "$",
          contains: [
            S,
            {
              className: "string",
              variants: [
                {
                  begin: "<",
                  end: ">"
                },
                {
                  begin: /"/,
                  end: /"/,
                  contains: [
                    {
                      begin: /""/,
                      relevance: 0
                    }
                  ]
                },
                {
                  begin: /'/,
                  end: /'/,
                  contains: [
                    {
                      begin: /''/,
                      relevance: 0
                    }
                  ]
                }
              ]
            }
          ]
        },
        S,
        g
      ]
    }, N = {
      className: "symbol",
      // begin: '@',
      // end: '$',
      // keywords: 'AppDataCommonDir AppDataDir AutoItExe AutoItPID AutoItVersion AutoItX64 COM_EventObj CommonFilesDir Compiled ComputerName ComSpec CPUArch CR CRLF DesktopCommonDir DesktopDepth DesktopDir DesktopHeight DesktopRefresh DesktopWidth DocumentsCommonDir error exitCode exitMethod extended FavoritesCommonDir FavoritesDir GUI_CtrlHandle GUI_CtrlId GUI_DragFile GUI_DragId GUI_DropId GUI_WinHandle HomeDrive HomePath HomeShare HotKeyPressed HOUR IPAddress1 IPAddress2 IPAddress3 IPAddress4 KBLayout LF LocalAppDataDir LogonDNSDomain LogonDomain LogonServer MDAY MIN MON MSEC MUILang MyDocumentsDir NumParams OSArch OSBuild OSLang OSServicePack OSType OSVersion ProgramFilesDir ProgramsCommonDir ProgramsDir ScriptDir ScriptFullPath ScriptLineNumber ScriptName SEC StartMenuCommonDir StartMenuDir StartupCommonDir StartupDir SW_DISABLE SW_ENABLE SW_HIDE SW_LOCK SW_MAXIMIZE SW_MINIMIZE SW_RESTORE SW_SHOW SW_SHOWDEFAULT SW_SHOWMAXIMIZED SW_SHOWMINIMIZED SW_SHOWMINNOACTIVE SW_SHOWNA SW_SHOWNOACTIVATE SW_SHOWNORMAL SW_UNLOCK SystemDir TAB TempDir TRAY_ID TrayIconFlashing TrayIconVisible UserName UserProfileDir WDAY WindowsDir WorkingDir YDAY YEAR',
      // relevance: 5
      begin: "@[A-z0-9_]+"
    }, D = {
      beginKeywords: "Func",
      end: "$",
      illegal: "\\$|\\[|%",
      contains: [
        i.inherit(i.UNDERSCORE_TITLE_MODE, { className: "title.function" }),
        {
          className: "params",
          begin: "\\(",
          end: "\\)",
          contains: [
            h,
            S,
            C
          ]
        }
      ]
    };
    return {
      name: "AutoIt",
      case_insensitive: !0,
      illegal: /\/\*/,
      keywords: {
        keyword: o,
        built_in: e,
        literal: r
      },
      contains: [
        g,
        h,
        S,
        C,
        O,
        N,
        D
      ]
    };
  }
  return Od = s, Od;
}
var yd, t0;
function dM() {
  if (t0)
    return yd;
  t0 = 1;
  function s(i) {
    return {
      name: "AVR Assembly",
      case_insensitive: !0,
      keywords: {
        $pattern: "\\.?" + i.IDENT_RE,
        keyword: (
          /* mnemonic */
          "adc add adiw and andi asr bclr bld brbc brbs brcc brcs break breq brge brhc brhs brid brie brlo brlt brmi brne brpl brsh brtc brts brvc brvs bset bst call cbi cbr clc clh cli cln clr cls clt clv clz com cp cpc cpi cpse dec eicall eijmp elpm eor fmul fmuls fmulsu icall ijmp in inc jmp ld ldd ldi lds lpm lsl lsr mov movw mul muls mulsu neg nop or ori out pop push rcall ret reti rjmp rol ror sbc sbr sbrc sbrs sec seh sbi sbci sbic sbis sbiw sei sen ser ses set sev sez sleep spm st std sts sub subi swap tst wdr"
        ),
        built_in: (
          /* general purpose registers */
          "r0 r1 r2 r3 r4 r5 r6 r7 r8 r9 r10 r11 r12 r13 r14 r15 r16 r17 r18 r19 r20 r21 r22 r23 r24 r25 r26 r27 r28 r29 r30 r31 x|0 xh xl y|0 yh yl z|0 zh zl ucsr1c udr1 ucsr1a ucsr1b ubrr1l ubrr1h ucsr0c ubrr0h tccr3c tccr3a tccr3b tcnt3h tcnt3l ocr3ah ocr3al ocr3bh ocr3bl ocr3ch ocr3cl icr3h icr3l etimsk etifr tccr1c ocr1ch ocr1cl twcr twdr twar twsr twbr osccal xmcra xmcrb eicra spmcsr spmcr portg ddrg ping portf ddrf sreg sph spl xdiv rampz eicrb eimsk gimsk gicr eifr gifr timsk tifr mcucr mcucsr tccr0 tcnt0 ocr0 assr tccr1a tccr1b tcnt1h tcnt1l ocr1ah ocr1al ocr1bh ocr1bl icr1h icr1l tccr2 tcnt2 ocr2 ocdr wdtcr sfior eearh eearl eedr eecr porta ddra pina portb ddrb pinb portc ddrc pinc portd ddrd pind spdr spsr spcr udr0 ucsr0a ucsr0b ubrr0l acsr admux adcsr adch adcl porte ddre pine pinf"
        ),
        meta: ".byte .cseg .db .def .device .dseg .dw .endmacro .equ .eseg .exit .include .list .listmac .macro .nolist .org .set"
      },
      contains: [
        i.C_BLOCK_COMMENT_MODE,
        i.COMMENT(
          ";",
          "$",
          { relevance: 0 }
        ),
        i.C_NUMBER_MODE,
        // 0x..., decimal, float
        i.BINARY_NUMBER_MODE,
        // 0b...
        {
          className: "number",
          begin: "\\b(\\$[a-zA-Z0-9]+|0o[0-7]+)"
          // $..., 0o...
        },
        i.QUOTE_STRING_MODE,
        {
          className: "string",
          begin: "'",
          end: "[^\\\\]'",
          illegal: "[^\\\\][^']"
        },
        {
          className: "symbol",
          begin: "^[A-Za-z0-9_.$]+:"
        },
        {
          className: "meta",
          begin: "#",
          end: "$"
        },
        {
          // substitution within a macro
          className: "subst",
          begin: "@[0-9]+"
        }
      ]
    };
  }
  return yd = s, yd;
}
var Id, r0;
function uM() {
  if (r0)
    return Id;
  r0 = 1;
  function s(i) {
    const o = {
      className: "variable",
      variants: [
        { begin: /\$[\w\d#@][\w\d_]*/ },
        { begin: /\$\{(.*?)\}/ }
      ]
    }, c = "BEGIN END if else while do for in break continue delete next nextfile function func exit|10", r = {
      className: "string",
      contains: [i.BACKSLASH_ESCAPE],
      variants: [
        {
          begin: /(u|b)?r?'''/,
          end: /'''/,
          relevance: 10
        },
        {
          begin: /(u|b)?r?"""/,
          end: /"""/,
          relevance: 10
        },
        {
          begin: /(u|r|ur)'/,
          end: /'/,
          relevance: 10
        },
        {
          begin: /(u|r|ur)"/,
          end: /"/,
          relevance: 10
        },
        {
          begin: /(b|br)'/,
          end: /'/
        },
        {
          begin: /(b|br)"/,
          end: /"/
        },
        i.APOS_STRING_MODE,
        i.QUOTE_STRING_MODE
      ]
    };
    return {
      name: "Awk",
      keywords: { keyword: c },
      contains: [
        o,
        r,
        i.REGEXP_MODE,
        i.HASH_COMMENT_MODE,
        i.NUMBER_MODE
      ]
    };
  }
  return Id = s, Id;
}
var Dd, n0;
function _M() {
  if (n0)
    return Dd;
  n0 = 1;
  function s(i) {
    const o = i.UNDERSCORE_IDENT_RE, g = {
      keyword: [
        "abstract",
        "as",
        "asc",
        "avg",
        "break",
        "breakpoint",
        "by",
        "byref",
        "case",
        "catch",
        "changecompany",
        "class",
        "client",
        "client",
        "common",
        "const",
        "continue",
        "count",
        "crosscompany",
        "delegate",
        "delete_from",
        "desc",
        "display",
        "div",
        "do",
        "edit",
        "else",
        "eventhandler",
        "exists",
        "extends",
        "final",
        "finally",
        "firstfast",
        "firstonly",
        "firstonly1",
        "firstonly10",
        "firstonly100",
        "firstonly1000",
        "flush",
        "for",
        "forceliterals",
        "forcenestedloop",
        "forceplaceholders",
        "forceselectorder",
        "forupdate",
        "from",
        "generateonly",
        "group",
        "hint",
        "if",
        "implements",
        "in",
        "index",
        "insert_recordset",
        "interface",
        "internal",
        "is",
        "join",
        "like",
        "maxof",
        "minof",
        "mod",
        "namespace",
        "new",
        "next",
        "nofetch",
        "notexists",
        "optimisticlock",
        "order",
        "outer",
        "pessimisticlock",
        "print",
        "private",
        "protected",
        "public",
        "readonly",
        "repeatableread",
        "retry",
        "return",
        "reverse",
        "select",
        "server",
        "setting",
        "static",
        "sum",
        "super",
        "switch",
        "this",
        "throw",
        "try",
        "ttsabort",
        "ttsbegin",
        "ttscommit",
        "unchecked",
        "update_recordset",
        "using",
        "validtimestate",
        "void",
        "where",
        "while"
      ],
      built_in: [
        "anytype",
        "boolean",
        "byte",
        "char",
        "container",
        "date",
        "double",
        "enum",
        "guid",
        "int",
        "int64",
        "long",
        "real",
        "short",
        "str",
        "utcdatetime",
        "var"
      ],
      literal: [
        "default",
        "false",
        "null",
        "true"
      ]
    }, h = {
      variants: [
        { match: [
          /(class|interface)\s+/,
          o,
          /\s+(extends|implements)\s+/,
          o
        ] },
        { match: [
          /class\s+/,
          o
        ] }
      ],
      scope: {
        2: "title.class",
        4: "title.class.inherited"
      },
      keywords: g
    };
    return {
      name: "X++",
      aliases: ["x++"],
      keywords: g,
      contains: [
        i.C_LINE_COMMENT_MODE,
        i.C_BLOCK_COMMENT_MODE,
        i.APOS_STRING_MODE,
        i.QUOTE_STRING_MODE,
        i.C_NUMBER_MODE,
        {
          className: "meta",
          begin: "#",
          end: "$"
        },
        h
      ]
    };
  }
  return Dd = s, Dd;
}
var wd, a0;
function pM() {
  if (a0)
    return wd;
  a0 = 1;
  function s(i) {
    const o = i.regex, c = {}, r = {
      begin: /\$\{/,
      end: /\}/,
      contains: [
        "self",
        {
          begin: /:-/,
          contains: [c]
        }
        // default values
      ]
    };
    Object.assign(c, {
      className: "variable",
      variants: [
        { begin: o.concat(
          /\$[\w\d#@][\w\d_]*/,
          // negative look-ahead tries to avoid matching patterns that are not
          // Perl at all like $ident$, @ident@, etc.
          "(?![\\w\\d])(?![$])"
        ) },
        r
      ]
    });
    const e = {
      className: "subst",
      begin: /\$\(/,
      end: /\)/,
      contains: [i.BACKSLASH_ESCAPE]
    }, g = {
      begin: /<<-?\s*(?=\w+)/,
      starts: { contains: [
        i.END_SAME_AS_BEGIN({
          begin: /(\w+)/,
          end: /(\w+)/,
          className: "string"
        })
      ] }
    }, h = {
      className: "string",
      begin: /"/,
      end: /"/,
      contains: [
        i.BACKSLASH_ESCAPE,
        c,
        e
      ]
    };
    e.contains.push(h);
    const S = {
      match: /\\"/
    }, C = {
      className: "string",
      begin: /'/,
      end: /'/
    }, O = {
      match: /\\'/
    }, N = {
      begin: /\$?\(\(/,
      end: /\)\)/,
      contains: [
        {
          begin: /\d+#[0-9a-f]+/,
          className: "number"
        },
        i.NUMBER_MODE,
        c
      ]
    }, D = [
      "fish",
      "bash",
      "zsh",
      "sh",
      "csh",
      "ksh",
      "tcsh",
      "dash",
      "scsh"
    ], x = i.SHEBANG({
      binary: `(${D.join("|")})`,
      relevance: 10
    }), L = {
      className: "function",
      begin: /\w[\w\d_]*\s*\(\s*\)\s*\{/,
      returnBegin: !0,
      contains: [i.inherit(i.TITLE_MODE, { begin: /\w[\w\d_]*/ })],
      relevance: 0
    }, G = [
      "if",
      "then",
      "else",
      "elif",
      "fi",
      "for",
      "while",
      "until",
      "in",
      "do",
      "done",
      "case",
      "esac",
      "function",
      "select"
    ], Y = [
      "true",
      "false"
    ], k = { match: /(\/[a-z._-]+)+/ }, W = [
      "break",
      "cd",
      "continue",
      "eval",
      "exec",
      "exit",
      "export",
      "getopts",
      "hash",
      "pwd",
      "readonly",
      "return",
      "shift",
      "test",
      "times",
      "trap",
      "umask",
      "unset"
    ], Z = [
      "alias",
      "bind",
      "builtin",
      "caller",
      "command",
      "declare",
      "echo",
      "enable",
      "help",
      "let",
      "local",
      "logout",
      "mapfile",
      "printf",
      "read",
      "readarray",
      "source",
      "type",
      "typeset",
      "ulimit",
      "unalias"
    ], H = [
      "autoload",
      "bg",
      "bindkey",
      "bye",
      "cap",
      "chdir",
      "clone",
      "comparguments",
      "compcall",
      "compctl",
      "compdescribe",
      "compfiles",
      "compgroups",
      "compquote",
      "comptags",
      "comptry",
      "compvalues",
      "dirs",
      "disable",
      "disown",
      "echotc",
      "echoti",
      "emulate",
      "fc",
      "fg",
      "float",
      "functions",
      "getcap",
      "getln",
      "history",
      "integer",
      "jobs",
      "kill",
      "limit",
      "log",
      "noglob",
      "popd",
      "print",
      "pushd",
      "pushln",
      "rehash",
      "sched",
      "setcap",
      "setopt",
      "stat",
      "suspend",
      "ttyctl",
      "unfunction",
      "unhash",
      "unlimit",
      "unsetopt",
      "vared",
      "wait",
      "whence",
      "where",
      "which",
      "zcompile",
      "zformat",
      "zftp",
      "zle",
      "zmodload",
      "zparseopts",
      "zprof",
      "zpty",
      "zregexparse",
      "zsocket",
      "zstyle",
      "ztcp"
    ], K = [
      "chcon",
      "chgrp",
      "chown",
      "chmod",
      "cp",
      "dd",
      "df",
      "dir",
      "dircolors",
      "ln",
      "ls",
      "mkdir",
      "mkfifo",
      "mknod",
      "mktemp",
      "mv",
      "realpath",
      "rm",
      "rmdir",
      "shred",
      "sync",
      "touch",
      "truncate",
      "vdir",
      "b2sum",
      "base32",
      "base64",
      "cat",
      "cksum",
      "comm",
      "csplit",
      "cut",
      "expand",
      "fmt",
      "fold",
      "head",
      "join",
      "md5sum",
      "nl",
      "numfmt",
      "od",
      "paste",
      "ptx",
      "pr",
      "sha1sum",
      "sha224sum",
      "sha256sum",
      "sha384sum",
      "sha512sum",
      "shuf",
      "sort",
      "split",
      "sum",
      "tac",
      "tail",
      "tr",
      "tsort",
      "unexpand",
      "uniq",
      "wc",
      "arch",
      "basename",
      "chroot",
      "date",
      "dirname",
      "du",
      "echo",
      "env",
      "expr",
      "factor",
      // "false", // keyword literal already
      "groups",
      "hostid",
      "id",
      "link",
      "logname",
      "nice",
      "nohup",
      "nproc",
      "pathchk",
      "pinky",
      "printenv",
      "printf",
      "pwd",
      "readlink",
      "runcon",
      "seq",
      "sleep",
      "stat",
      "stdbuf",
      "stty",
      "tee",
      "test",
      "timeout",
      // "true", // keyword literal already
      "tty",
      "uname",
      "unlink",
      "uptime",
      "users",
      "who",
      "whoami",
      "yes"
    ];
    return {
      name: "Bash",
      aliases: ["sh"],
      keywords: {
        $pattern: /\b[a-z][a-z0-9._-]+\b/,
        keyword: G,
        literal: Y,
        built_in: [
          ...W,
          ...Z,
          // Shell modifiers
          "set",
          "shopt",
          ...H,
          ...K
        ]
      },
      contains: [
        x,
        // to catch known shells and boost relevancy
        i.SHEBANG(),
        // to catch unknown shells but still highlight the shebang
        L,
        N,
        i.HASH_COMMENT_MODE,
        g,
        k,
        h,
        S,
        C,
        O,
        c
      ]
    };
  }
  return wd = s, wd;
}
var xd, i0;
function mM() {
  if (i0)
    return xd;
  i0 = 1;
  function s(i) {
    return {
      name: "BASIC",
      case_insensitive: !0,
      illegal: "^.",
      // Support explicitly typed variables that end with $%! or #.
      keywords: {
        $pattern: "[a-zA-Z][a-zA-Z0-9_$%!#]*",
        keyword: [
          "ABS",
          "ASC",
          "AND",
          "ATN",
          "AUTO|0",
          "BEEP",
          "BLOAD|10",
          "BSAVE|10",
          "CALL",
          "CALLS",
          "CDBL",
          "CHAIN",
          "CHDIR",
          "CHR$|10",
          "CINT",
          "CIRCLE",
          "CLEAR",
          "CLOSE",
          "CLS",
          "COLOR",
          "COM",
          "COMMON",
          "CONT",
          "COS",
          "CSNG",
          "CSRLIN",
          "CVD",
          "CVI",
          "CVS",
          "DATA",
          "DATE$",
          "DEFDBL",
          "DEFINT",
          "DEFSNG",
          "DEFSTR",
          "DEF|0",
          "SEG",
          "USR",
          "DELETE",
          "DIM",
          "DRAW",
          "EDIT",
          "END",
          "ENVIRON",
          "ENVIRON$",
          "EOF",
          "EQV",
          "ERASE",
          "ERDEV",
          "ERDEV$",
          "ERL",
          "ERR",
          "ERROR",
          "EXP",
          "FIELD",
          "FILES",
          "FIX",
          "FOR|0",
          "FRE",
          "GET",
          "GOSUB|10",
          "GOTO",
          "HEX$",
          "IF",
          "THEN",
          "ELSE|0",
          "INKEY$",
          "INP",
          "INPUT",
          "INPUT#",
          "INPUT$",
          "INSTR",
          "IMP",
          "INT",
          "IOCTL",
          "IOCTL$",
          "KEY",
          "ON",
          "OFF",
          "LIST",
          "KILL",
          "LEFT$",
          "LEN",
          "LET",
          "LINE",
          "LLIST",
          "LOAD",
          "LOC",
          "LOCATE",
          "LOF",
          "LOG",
          "LPRINT",
          "USING",
          "LSET",
          "MERGE",
          "MID$",
          "MKDIR",
          "MKD$",
          "MKI$",
          "MKS$",
          "MOD",
          "NAME",
          "NEW",
          "NEXT",
          "NOISE",
          "NOT",
          "OCT$",
          "ON",
          "OR",
          "PEN",
          "PLAY",
          "STRIG",
          "OPEN",
          "OPTION",
          "BASE",
          "OUT",
          "PAINT",
          "PALETTE",
          "PCOPY",
          "PEEK",
          "PMAP",
          "POINT",
          "POKE",
          "POS",
          "PRINT",
          "PRINT]",
          "PSET",
          "PRESET",
          "PUT",
          "RANDOMIZE",
          "READ",
          "REM",
          "RENUM",
          "RESET|0",
          "RESTORE",
          "RESUME",
          "RETURN|0",
          "RIGHT$",
          "RMDIR",
          "RND",
          "RSET",
          "RUN",
          "SAVE",
          "SCREEN",
          "SGN",
          "SHELL",
          "SIN",
          "SOUND",
          "SPACE$",
          "SPC",
          "SQR",
          "STEP",
          "STICK",
          "STOP",
          "STR$",
          "STRING$",
          "SWAP",
          "SYSTEM",
          "TAB",
          "TAN",
          "TIME$",
          "TIMER",
          "TROFF",
          "TRON",
          "TO",
          "USR",
          "VAL",
          "VARPTR",
          "VARPTR$",
          "VIEW",
          "WAIT",
          "WHILE",
          "WEND",
          "WIDTH",
          "WINDOW",
          "WRITE",
          "XOR"
        ]
      },
      contains: [
        i.QUOTE_STRING_MODE,
        i.COMMENT("REM", "$", { relevance: 10 }),
        i.COMMENT("'", "$", { relevance: 0 }),
        {
          // Match line numbers
          className: "symbol",
          begin: "^[0-9]+ ",
          relevance: 10
        },
        {
          // Match typed numeric constants (1000, 12.34!, 1.2e5, 1.5#, 1.2D2)
          className: "number",
          begin: "\\b\\d+(\\.\\d+)?([edED]\\d+)?[#!]?",
          relevance: 0
        },
        {
          // Match hexadecimal numbers (&Hxxxx)
          className: "number",
          begin: "(&[hH][0-9a-fA-F]{1,4})"
        },
        {
          // Match octal numbers (&Oxxxxxx)
          className: "number",
          begin: "(&[oO][0-7]{1,6})"
        }
      ]
    };
  }
  return xd = s, xd;
}
var Ld, o0;
function fM() {
  if (o0)
    return Ld;
  o0 = 1;
  function s(i) {
    return {
      name: "Backus–Naur Form",
      contains: [
        // Attribute
        {
          className: "attribute",
          begin: /</,
          end: />/
        },
        // Specific
        {
          begin: /::=/,
          end: /$/,
          contains: [
            {
              begin: /</,
              end: />/
            },
            // Common
            i.C_LINE_COMMENT_MODE,
            i.C_BLOCK_COMMENT_MODE,
            i.APOS_STRING_MODE,
            i.QUOTE_STRING_MODE
          ]
        }
      ]
    };
  }
  return Ld = s, Ld;
}
var Md, s0;
function gM() {
  if (s0)
    return Md;
  s0 = 1;
  function s(i) {
    const o = {
      className: "literal",
      begin: /[+-]+/,
      relevance: 0
    };
    return {
      name: "Brainfuck",
      aliases: ["bf"],
      contains: [
        i.COMMENT(
          /[^\[\]\.,\+\-<> \r\n]/,
          /[\[\]\.,\+\-<> \r\n]/,
          {
            contains: [
              {
                match: /[ ]+[^\[\]\.,\+\-<> \r\n]/,
                relevance: 0
              }
            ],
            returnEnd: !0,
            relevance: 0
          }
        ),
        {
          className: "title",
          begin: "[\\[\\]]",
          relevance: 0
        },
        {
          className: "string",
          begin: "[\\.,]",
          relevance: 0
        },
        {
          // this mode works as the only relevance counter
          // it looks ahead to find the start of a run of literals
          // so only the runs are counted as relevant
          begin: /(?=\+\+|--)/,
          contains: [o]
        },
        o
      ]
    };
  }
  return Md = s, Md;
}
var Pd, l0;
function EM() {
  if (l0)
    return Pd;
  l0 = 1;
  function s(i) {
    const o = i.regex, c = i.COMMENT("//", "$", { contains: [{ begin: /\\\n/ }] }), r = "decltype\\(auto\\)", e = "[a-zA-Z_]\\w*::", h = "(" + r + "|" + o.optional(e) + "[a-zA-Z_]\\w*" + o.optional("<[^<>]+>") + ")", S = {
      className: "type",
      variants: [
        { begin: "\\b[a-z\\d_]*_t\\b" },
        { match: /\batomic_[a-z]{3,6}\b/ }
      ]
    }, O = {
      className: "string",
      variants: [
        {
          begin: '(u8?|U|L)?"',
          end: '"',
          illegal: "\\n",
          contains: [i.BACKSLASH_ESCAPE]
        },
        {
          begin: "(u8?|U|L)?'(" + "\\\\(x[0-9A-Fa-f]{2}|u[0-9A-Fa-f]{4,8}|[0-7]{3}|\\S)" + "|.)",
          end: "'",
          illegal: "."
        },
        i.END_SAME_AS_BEGIN({
          begin: /(?:u8?|U|L)?R"([^()\\ ]{0,16})\(/,
          end: /\)([^()\\ ]{0,16})"/
        })
      ]
    }, N = {
      className: "number",
      variants: [
        { begin: "\\b(0b[01']+)" },
        { begin: "(-?)\\b([\\d']+(\\.[\\d']*)?|\\.[\\d']+)((ll|LL|l|L)(u|U)?|(u|U)(ll|LL|l|L)?|f|F|b|B)" },
        { begin: "(-?)(\\b0[xX][a-fA-F0-9']+|(\\b[\\d']+(\\.[\\d']*)?|\\.[\\d']+)([eE][-+]?[\\d']+)?)" }
      ],
      relevance: 0
    }, D = {
      className: "meta",
      begin: /#\s*[a-z]+\b/,
      end: /$/,
      keywords: { keyword: "if else elif endif define undef warning error line pragma _Pragma ifdef ifndef include" },
      contains: [
        {
          begin: /\\\n/,
          relevance: 0
        },
        i.inherit(O, { className: "string" }),
        {
          className: "string",
          begin: /<.*?>/
        },
        c,
        i.C_BLOCK_COMMENT_MODE
      ]
    }, x = {
      className: "title",
      begin: o.optional(e) + i.IDENT_RE,
      relevance: 0
    }, L = o.optional(e) + i.IDENT_RE + "\\s*\\(", k = {
      keyword: [
        "asm",
        "auto",
        "break",
        "case",
        "continue",
        "default",
        "do",
        "else",
        "enum",
        "extern",
        "for",
        "fortran",
        "goto",
        "if",
        "inline",
        "register",
        "restrict",
        "return",
        "sizeof",
        "struct",
        "switch",
        "typedef",
        "union",
        "volatile",
        "while",
        "_Alignas",
        "_Alignof",
        "_Atomic",
        "_Generic",
        "_Noreturn",
        "_Static_assert",
        "_Thread_local",
        // aliases
        "alignas",
        "alignof",
        "noreturn",
        "static_assert",
        "thread_local",
        // not a C keyword but is, for all intents and purposes, treated exactly like one.
        "_Pragma"
      ],
      type: [
        "float",
        "double",
        "signed",
        "unsigned",
        "int",
        "short",
        "long",
        "char",
        "void",
        "_Bool",
        "_Complex",
        "_Imaginary",
        "_Decimal32",
        "_Decimal64",
        "_Decimal128",
        // modifiers
        "const",
        "static",
        // aliases
        "complex",
        "bool",
        "imaginary"
      ],
      literal: "true false NULL",
      // TODO: apply hinting work similar to what was done in cpp.js
      built_in: "std string wstring cin cout cerr clog stdin stdout stderr stringstream istringstream ostringstream auto_ptr deque list queue stack vector map set pair bitset multiset multimap unordered_set unordered_map unordered_multiset unordered_multimap priority_queue make_pair array shared_ptr abort terminate abs acos asin atan2 atan calloc ceil cosh cos exit exp fabs floor fmod fprintf fputs free frexp fscanf future isalnum isalpha iscntrl isdigit isgraph islower isprint ispunct isspace isupper isxdigit tolower toupper labs ldexp log10 log malloc realloc memchr memcmp memcpy memset modf pow printf putchar puts scanf sinh sin snprintf sprintf sqrt sscanf strcat strchr strcmp strcpy strcspn strlen strncat strncmp strncpy strpbrk strrchr strspn strstr tanh tan vfprintf vprintf vsprintf endl initializer_list unique_ptr"
    }, W = [
      D,
      S,
      c,
      i.C_BLOCK_COMMENT_MODE,
      N,
      O
    ], Z = {
      // This mode covers expression context where we can't expect a function
      // definition and shouldn't highlight anything that looks like one:
      // `return some()`, `else if()`, `(x*sum(1, 2))`
      variants: [
        {
          begin: /=/,
          end: /;/
        },
        {
          begin: /\(/,
          end: /\)/
        },
        {
          beginKeywords: "new throw return else",
          end: /;/
        }
      ],
      keywords: k,
      contains: W.concat([
        {
          begin: /\(/,
          end: /\)/,
          keywords: k,
          contains: W.concat(["self"]),
          relevance: 0
        }
      ]),
      relevance: 0
    }, H = {
      begin: "(" + h + "[\\*&\\s]+)+" + L,
      returnBegin: !0,
      end: /[{;=]/,
      excludeEnd: !0,
      keywords: k,
      illegal: /[^\w\s\*&:<>.]/,
      contains: [
        {
          // to prevent it from being confused as the function title
          begin: r,
          keywords: k,
          relevance: 0
        },
        {
          begin: L,
          returnBegin: !0,
          contains: [i.inherit(x, { className: "title.function" })],
          relevance: 0
        },
        // allow for multiple declarations, e.g.:
        // extern void f(int), g(char);
        {
          relevance: 0,
          match: /,/
        },
        {
          className: "params",
          begin: /\(/,
          end: /\)/,
          keywords: k,
          relevance: 0,
          contains: [
            c,
            i.C_BLOCK_COMMENT_MODE,
            O,
            N,
            S,
            // Count matching parentheses.
            {
              begin: /\(/,
              end: /\)/,
              keywords: k,
              relevance: 0,
              contains: [
                "self",
                c,
                i.C_BLOCK_COMMENT_MODE,
                O,
                N,
                S
              ]
            }
          ]
        },
        S,
        c,
        i.C_BLOCK_COMMENT_MODE,
        D
      ]
    };
    return {
      name: "C",
      aliases: ["h"],
      keywords: k,
      // Until differentiations are added between `c` and `cpp`, `c` will
      // not be auto-detected to avoid auto-detect conflicts between C and C++
      disableAutodetect: !0,
      illegal: "</",
      contains: [].concat(
        Z,
        H,
        W,
        [
          D,
          {
            begin: i.IDENT_RE + "::",
            keywords: k
          },
          {
            className: "class",
            beginKeywords: "enum class struct union",
            end: /[{;:<>=]/,
            contains: [
              { beginKeywords: "final class struct" },
              i.TITLE_MODE
            ]
          }
        ]
      ),
      exports: {
        preprocessor: D,
        strings: O,
        keywords: k
      }
    };
  }
  return Pd = s, Pd;
}
var kd, c0;
function hM() {
  if (c0)
    return kd;
  c0 = 1;
  function s(i) {
    const o = i.regex, c = [
      "div",
      "mod",
      "in",
      "and",
      "or",
      "not",
      "xor",
      "asserterror",
      "begin",
      "case",
      "do",
      "downto",
      "else",
      "end",
      "exit",
      "for",
      "local",
      "if",
      "of",
      "repeat",
      "then",
      "to",
      "until",
      "while",
      "with",
      "var"
    ], r = "false true", e = [
      i.C_LINE_COMMENT_MODE,
      i.COMMENT(
        /\{/,
        /\}/,
        { relevance: 0 }
      ),
      i.COMMENT(
        /\(\*/,
        /\*\)/,
        { relevance: 10 }
      )
    ], g = {
      className: "string",
      begin: /'/,
      end: /'/,
      contains: [{ begin: /''/ }]
    }, h = {
      className: "string",
      begin: /(#\d+)+/
    }, S = {
      className: "number",
      begin: "\\b\\d+(\\.\\d+)?(DT|D|T)",
      relevance: 0
    }, C = {
      className: "string",
      // not a string technically but makes sense to be highlighted in the same style
      begin: '"',
      end: '"'
    }, O = {
      match: [
        /procedure/,
        /\s+/,
        /[a-zA-Z_][\w@]*/,
        /\s*/
      ],
      scope: {
        1: "keyword",
        3: "title.function"
      },
      contains: [
        {
          className: "params",
          begin: /\(/,
          end: /\)/,
          keywords: c,
          contains: [
            g,
            h,
            i.NUMBER_MODE
          ]
        },
        ...e
      ]
    }, N = [
      "Table",
      "Form",
      "Report",
      "Dataport",
      "Codeunit",
      "XMLport",
      "MenuSuite",
      "Page",
      "Query"
    ], D = {
      match: [
        /OBJECT/,
        /\s+/,
        o.either(...N),
        /\s+/,
        /\d+/,
        /\s+(?=[^\s])/,
        /.*/,
        /$/
      ],
      relevance: 3,
      scope: {
        1: "keyword",
        3: "type",
        5: "number",
        7: "title"
      }
    };
    return {
      name: "C/AL",
      case_insensitive: !0,
      keywords: {
        keyword: c,
        literal: r
      },
      illegal: /\/\*/,
      contains: [
        {
          match: /[\w]+(?=\=)/,
          scope: "attribute",
          relevance: 0
        },
        g,
        h,
        S,
        C,
        i.NUMBER_MODE,
        D,
        O
      ]
    };
  }
  return kd = s, kd;
}
var Fd, d0;
function SM() {
  if (d0)
    return Fd;
  d0 = 1;
  function s(i) {
    const o = [
      "struct",
      "enum",
      "interface",
      "union",
      "group",
      "import",
      "using",
      "const",
      "annotation",
      "extends",
      "in",
      "of",
      "on",
      "as",
      "with",
      "from",
      "fixed"
    ], c = [
      "Void",
      "Bool",
      "Int8",
      "Int16",
      "Int32",
      "Int64",
      "UInt8",
      "UInt16",
      "UInt32",
      "UInt64",
      "Float32",
      "Float64",
      "Text",
      "Data",
      "AnyPointer",
      "AnyStruct",
      "Capability",
      "List"
    ], r = [
      "true",
      "false"
    ], e = {
      variants: [
        { match: [
          /(struct|enum|interface)/,
          /\s+/,
          i.IDENT_RE
        ] },
        { match: [
          /extends/,
          /\s*\(/,
          i.IDENT_RE,
          /\s*\)/
        ] }
      ],
      scope: {
        1: "keyword",
        3: "title.class"
      }
    };
    return {
      name: "Cap’n Proto",
      aliases: ["capnp"],
      keywords: {
        keyword: o,
        type: c,
        literal: r
      },
      contains: [
        i.QUOTE_STRING_MODE,
        i.NUMBER_MODE,
        i.HASH_COMMENT_MODE,
        {
          className: "meta",
          begin: /@0x[\w\d]{16};/,
          illegal: /\n/
        },
        {
          className: "symbol",
          begin: /@\d+\b/
        },
        e
      ]
    };
  }
  return Fd = s, Fd;
}
var Ud, u0;
function bM() {
  if (u0)
    return Ud;
  u0 = 1;
  function s(i) {
    const o = [
      "assembly",
      "module",
      "package",
      "import",
      "alias",
      "class",
      "interface",
      "object",
      "given",
      "value",
      "assign",
      "void",
      "function",
      "new",
      "of",
      "extends",
      "satisfies",
      "abstracts",
      "in",
      "out",
      "return",
      "break",
      "continue",
      "throw",
      "assert",
      "dynamic",
      "if",
      "else",
      "switch",
      "case",
      "for",
      "while",
      "try",
      "catch",
      "finally",
      "then",
      "let",
      "this",
      "outer",
      "super",
      "is",
      "exists",
      "nonempty"
    ], c = [
      "shared",
      "abstract",
      "formal",
      "default",
      "actual",
      "variable",
      "late",
      "native",
      "deprecated",
      "final",
      "sealed",
      "annotation",
      "suppressWarnings",
      "small"
    ], r = [
      "doc",
      "by",
      "license",
      "see",
      "throws",
      "tagged"
    ], e = {
      className: "subst",
      excludeBegin: !0,
      excludeEnd: !0,
      begin: /``/,
      end: /``/,
      keywords: o,
      relevance: 10
    }, g = [
      {
        // verbatim string
        className: "string",
        begin: '"""',
        end: '"""',
        relevance: 10
      },
      {
        // string literal or template
        className: "string",
        begin: '"',
        end: '"',
        contains: [e]
      },
      {
        // character literal
        className: "string",
        begin: "'",
        end: "'"
      },
      {
        // numeric literal
        className: "number",
        begin: "#[0-9a-fA-F_]+|\\$[01_]+|[0-9_]+(?:\\.[0-9_](?:[eE][+-]?\\d+)?)?[kMGTPmunpf]?",
        relevance: 0
      }
    ];
    return e.contains = g, {
      name: "Ceylon",
      keywords: {
        keyword: o.concat(c),
        meta: r
      },
      illegal: "\\$[^01]|#[^0-9a-fA-F]",
      contains: [
        i.C_LINE_COMMENT_MODE,
        i.COMMENT("/\\*", "\\*/", { contains: ["self"] }),
        {
          // compiler annotation
          className: "meta",
          begin: '@[a-z]\\w*(?::"[^"]*")?'
        }
      ].concat(g)
    };
  }
  return Ud = s, Ud;
}
var Bd, _0;
function TM() {
  if (_0)
    return Bd;
  _0 = 1;
  function s(i) {
    return {
      name: "Clean",
      aliases: [
        "icl",
        "dcl"
      ],
      keywords: {
        keyword: [
          "if",
          "let",
          "in",
          "with",
          "where",
          "case",
          "of",
          "class",
          "instance",
          "otherwise",
          "implementation",
          "definition",
          "system",
          "module",
          "from",
          "import",
          "qualified",
          "as",
          "special",
          "code",
          "inline",
          "foreign",
          "export",
          "ccall",
          "stdcall",
          "generic",
          "derive",
          "infix",
          "infixl",
          "infixr"
        ],
        built_in: "Int Real Char Bool",
        literal: "True False"
      },
      contains: [
        i.C_LINE_COMMENT_MODE,
        i.C_BLOCK_COMMENT_MODE,
        i.APOS_STRING_MODE,
        i.QUOTE_STRING_MODE,
        i.C_NUMBER_MODE,
        {
          // relevance booster
          begin: "->|<-[|:]?|#!?|>>=|\\{\\||\\|\\}|:==|=:|<>"
        }
      ]
    };
  }
  return Bd = s, Bd;
}
var Gd, p0;
function vM() {
  if (p0)
    return Gd;
  p0 = 1;
  function s(i) {
    const o = "a-zA-Z_\\-!.?+*=<>&'", c = "[#]?[" + o + "][" + o + "0-9/;:$#]*", r = "def defonce defprotocol defstruct defmulti defmethod defn- defn defmacro deftype defrecord", e = {
      $pattern: c,
      built_in: (
        // Clojure keywords
        r + " cond apply if-not if-let if not not= =|0 <|0 >|0 <=|0 >=|0 ==|0 +|0 /|0 *|0 -|0 rem quot neg? pos? delay? symbol? keyword? true? false? integer? empty? coll? list? set? ifn? fn? associative? sequential? sorted? counted? reversible? number? decimal? class? distinct? isa? float? rational? reduced? ratio? odd? even? char? seq? vector? string? map? nil? contains? zero? instance? not-every? not-any? libspec? -> ->> .. . inc compare do dotimes mapcat take remove take-while drop letfn drop-last take-last drop-while while intern condp case reduced cycle split-at split-with repeat replicate iterate range merge zipmap declare line-seq sort comparator sort-by dorun doall nthnext nthrest partition eval doseq await await-for let agent atom send send-off release-pending-sends add-watch mapv filterv remove-watch agent-error restart-agent set-error-handler error-handler set-error-mode! error-mode shutdown-agents quote var fn loop recur throw try monitor-enter monitor-exit macroexpand macroexpand-1 for dosync and or when when-not when-let comp juxt partial sequence memoize constantly complement identity assert peek pop doto proxy first rest cons cast coll last butlast sigs reify second ffirst fnext nfirst nnext meta with-meta ns in-ns create-ns import refer keys select-keys vals key val rseq name namespace promise into transient persistent! conj! assoc! dissoc! pop! disj! use class type num float double short byte boolean bigint biginteger bigdec print-method print-dup throw-if printf format load compile get-in update-in pr pr-on newline flush read slurp read-line subvec with-open memfn time re-find re-groups rand-int rand mod locking assert-valid-fdecl alias resolve ref deref refset swap! reset! set-validator! compare-and-set! alter-meta! reset-meta! commute get-validator alter ref-set ref-history-count ref-min-history ref-max-history ensure sync io! new next conj set! to-array future future-call into-array aset gen-class reduce map filter find empty hash-map hash-set sorted-map sorted-map-by sorted-set sorted-set-by vec vector seq flatten reverse assoc dissoc list disj get union difference intersection extend extend-type extend-protocol int nth delay count concat chunk chunk-buffer chunk-append chunk-first chunk-rest max min dec unchecked-inc-int unchecked-inc unchecked-dec-inc unchecked-dec unchecked-negate unchecked-add-int unchecked-add unchecked-subtract-int unchecked-subtract chunk-next chunk-cons chunked-seq? prn vary-meta lazy-seq spread list* str find-keyword keyword symbol gensym force rationalize"
      )
    }, g = {
      begin: c,
      relevance: 0
    }, h = {
      scope: "number",
      relevance: 0,
      variants: [
        { match: /[-+]?0[xX][0-9a-fA-F]+N?/ },
        // hexadecimal                 // 0x2a
        { match: /[-+]?0[0-7]+N?/ },
        // octal                       // 052
        { match: /[-+]?[1-9][0-9]?[rR][0-9a-zA-Z]+N?/ },
        // variable radix from 2 to 36 // 2r101010, 8r52, 36r16
        { match: /[-+]?[0-9]+\/[0-9]+N?/ },
        // ratio                       // 1/2
        { match: /[-+]?[0-9]+((\.[0-9]*([eE][+-]?[0-9]+)?M?)|([eE][+-]?[0-9]+M?|M))/ },
        // float        // 0.42 4.2E-1M 42E1 42M
        { match: /[-+]?([1-9][0-9]*|0)N?/ }
        // int (don't match leading 0) // 42 42N
      ]
    }, S = {
      scope: "character",
      variants: [
        { match: /\\o[0-3]?[0-7]{1,2}/ },
        // Unicode Octal 0 - 377
        { match: /\\u[0-9a-fA-F]{4}/ },
        // Unicode Hex 0000 - FFFF
        { match: /\\(newline|space|tab|formfeed|backspace|return)/ },
        // special characters
        {
          match: /\\\S/,
          relevance: 0
        }
        // any non-whitespace char
      ]
    }, C = {
      scope: "regex",
      begin: /#"/,
      end: /"/,
      contains: [i.BACKSLASH_ESCAPE]
    }, O = i.inherit(i.QUOTE_STRING_MODE, { illegal: null }), N = {
      scope: "punctuation",
      match: /,/,
      relevance: 0
    }, D = i.COMMENT(
      ";",
      "$",
      { relevance: 0 }
    ), x = {
      className: "literal",
      begin: /\b(true|false|nil)\b/
    }, L = {
      begin: "\\[|(#::?" + c + ")?\\{",
      end: "[\\]\\}]",
      relevance: 0
    }, G = {
      className: "symbol",
      begin: "[:]{1,2}" + c
    }, Y = {
      begin: "\\(",
      end: "\\)"
    }, k = {
      endsWithParent: !0,
      relevance: 0
    }, W = {
      keywords: e,
      className: "name",
      begin: c,
      relevance: 0,
      starts: k
    }, Z = [
      N,
      Y,
      S,
      C,
      O,
      D,
      G,
      L,
      h,
      x,
      g
    ], H = {
      beginKeywords: r,
      keywords: {
        $pattern: c,
        keyword: r
      },
      end: '(\\[|#|\\d|"|:|\\{|\\)|\\(|$)',
      contains: [
        {
          className: "title",
          begin: c,
          relevance: 0,
          excludeEnd: !0,
          // we can only have a single title
          endsParent: !0
        }
      ].concat(Z)
    };
    return Y.contains = [
      H,
      W,
      k
    ], k.contains = Z, L.contains = Z, {
      name: "Clojure",
      aliases: [
        "clj",
        "edn"
      ],
      illegal: /\S/,
      contains: [
        N,
        Y,
        S,
        C,
        O,
        D,
        G,
        L,
        h,
        x
      ]
    };
  }
  return Gd = s, Gd;
}
var Vd, m0;
function CM() {
  if (m0)
    return Vd;
  m0 = 1;
  function s(i) {
    return {
      name: "Clojure REPL",
      contains: [
        {
          className: "meta.prompt",
          begin: /^([\w.-]+|\s*#_)?=>/,
          starts: {
            end: /$/,
            subLanguage: "clojure"
          }
        }
      ]
    };
  }
  return Vd = s, Vd;
}
var Yd, f0;
function RM() {
  if (f0)
    return Yd;
  f0 = 1;
  function s(i) {
    return {
      name: "CMake",
      aliases: ["cmake.in"],
      case_insensitive: !0,
      keywords: { keyword: (
        // scripting commands
        "break cmake_host_system_information cmake_minimum_required cmake_parse_arguments cmake_policy configure_file continue elseif else endforeach endfunction endif endmacro endwhile execute_process file find_file find_library find_package find_path find_program foreach function get_cmake_property get_directory_property get_filename_component get_property if include include_guard list macro mark_as_advanced math message option return separate_arguments set_directory_properties set_property set site_name string unset variable_watch while add_compile_definitions add_compile_options add_custom_command add_custom_target add_definitions add_dependencies add_executable add_library add_link_options add_subdirectory add_test aux_source_directory build_command create_test_sourcelist define_property enable_language enable_testing export fltk_wrap_ui get_source_file_property get_target_property get_test_property include_directories include_external_msproject include_regular_expression install link_directories link_libraries load_cache project qt_wrap_cpp qt_wrap_ui remove_definitions set_source_files_properties set_target_properties set_tests_properties source_group target_compile_definitions target_compile_features target_compile_options target_include_directories target_link_directories target_link_libraries target_link_options target_sources try_compile try_run ctest_build ctest_configure ctest_coverage ctest_empty_binary_directory ctest_memcheck ctest_read_custom_files ctest_run_script ctest_sleep ctest_start ctest_submit ctest_test ctest_update ctest_upload build_name exec_program export_library_dependencies install_files install_programs install_targets load_command make_directory output_required_files remove subdir_depends subdirs use_mangled_mesa utility_source variable_requires write_file qt5_use_modules qt5_use_package qt5_wrap_cpp on off true false and or not command policy target test exists is_newer_than is_directory is_symlink is_absolute matches less greater equal less_equal greater_equal strless strgreater strequal strless_equal strgreater_equal version_less version_greater version_equal version_less_equal version_greater_equal in_list defined"
      ) },
      contains: [
        {
          className: "variable",
          begin: /\$\{/,
          end: /\}/
        },
        i.COMMENT(/#\[\[/, /]]/),
        i.HASH_COMMENT_MODE,
        i.QUOTE_STRING_MODE,
        i.NUMBER_MODE
      ]
    };
  }
  return Yd = s, Yd;
}
var Hd, g0;
function NM() {
  if (g0)
    return Hd;
  g0 = 1;
  const s = [
    "as",
    // for exports
    "in",
    "of",
    "if",
    "for",
    "while",
    "finally",
    "var",
    "new",
    "function",
    "do",
    "return",
    "void",
    "else",
    "break",
    "catch",
    "instanceof",
    "with",
    "throw",
    "case",
    "default",
    "try",
    "switch",
    "continue",
    "typeof",
    "delete",
    "let",
    "yield",
    "const",
    "class",
    // JS handles these with a special rule
    // "get",
    // "set",
    "debugger",
    "async",
    "await",
    "static",
    "import",
    "from",
    "export",
    "extends"
  ], i = [
    "true",
    "false",
    "null",
    "undefined",
    "NaN",
    "Infinity"
  ], o = [
    // Fundamental objects
    "Object",
    "Function",
    "Boolean",
    "Symbol",
    // numbers and dates
    "Math",
    "Date",
    "Number",
    "BigInt",
    // text
    "String",
    "RegExp",
    // Indexed collections
    "Array",
    "Float32Array",
    "Float64Array",
    "Int8Array",
    "Uint8Array",
    "Uint8ClampedArray",
    "Int16Array",
    "Int32Array",
    "Uint16Array",
    "Uint32Array",
    "BigInt64Array",
    "BigUint64Array",
    // Keyed collections
    "Set",
    "Map",
    "WeakSet",
    "WeakMap",
    // Structured data
    "ArrayBuffer",
    "SharedArrayBuffer",
    "Atomics",
    "DataView",
    "JSON",
    // Control abstraction objects
    "Promise",
    "Generator",
    "GeneratorFunction",
    "AsyncFunction",
    // Reflection
    "Reflect",
    "Proxy",
    // Internationalization
    "Intl",
    // WebAssembly
    "WebAssembly"
  ], c = [
    "Error",
    "EvalError",
    "InternalError",
    "RangeError",
    "ReferenceError",
    "SyntaxError",
    "TypeError",
    "URIError"
  ], r = [
    "setInterval",
    "setTimeout",
    "clearInterval",
    "clearTimeout",
    "require",
    "exports",
    "eval",
    "isFinite",
    "isNaN",
    "parseFloat",
    "parseInt",
    "decodeURI",
    "decodeURIComponent",
    "encodeURI",
    "encodeURIComponent",
    "escape",
    "unescape"
  ], e = [].concat(
    r,
    o,
    c
  );
  function g(h) {
    const S = [
      "npm",
      "print"
    ], C = [
      "yes",
      "no",
      "on",
      "off"
    ], O = [
      "then",
      "unless",
      "until",
      "loop",
      "by",
      "when",
      "and",
      "or",
      "is",
      "isnt",
      "not"
    ], N = [
      "var",
      "const",
      "let",
      "function",
      "static"
    ], D = (K) => (Q) => !K.includes(Q), x = {
      keyword: s.concat(O).filter(D(N)),
      literal: i.concat(C),
      built_in: e.concat(S)
    }, L = "[A-Za-z$_][0-9A-Za-z$_]*", G = {
      className: "subst",
      begin: /#\{/,
      end: /\}/,
      keywords: x
    }, Y = [
      h.BINARY_NUMBER_MODE,
      h.inherit(h.C_NUMBER_MODE, { starts: {
        end: "(\\s*/)?",
        relevance: 0
      } }),
      // a number tries to eat the following slash to prevent treating it as a regexp
      {
        className: "string",
        variants: [
          {
            begin: /'''/,
            end: /'''/,
            contains: [h.BACKSLASH_ESCAPE]
          },
          {
            begin: /'/,
            end: /'/,
            contains: [h.BACKSLASH_ESCAPE]
          },
          {
            begin: /"""/,
            end: /"""/,
            contains: [
              h.BACKSLASH_ESCAPE,
              G
            ]
          },
          {
            begin: /"/,
            end: /"/,
            contains: [
              h.BACKSLASH_ESCAPE,
              G
            ]
          }
        ]
      },
      {
        className: "regexp",
        variants: [
          {
            begin: "///",
            end: "///",
            contains: [
              G,
              h.HASH_COMMENT_MODE
            ]
          },
          {
            begin: "//[gim]{0,3}(?=\\W)",
            relevance: 0
          },
          {
            // regex can't start with space to parse x / 2 / 3 as two divisions
            // regex can't start with *, and it supports an "illegal" in the main mode
            begin: /\/(?![ *]).*?(?![\\]).\/[gim]{0,3}(?=\W)/
          }
        ]
      },
      {
        begin: "@" + L
        // relevance booster
      },
      {
        subLanguage: "javascript",
        excludeBegin: !0,
        excludeEnd: !0,
        variants: [
          {
            begin: "```",
            end: "```"
          },
          {
            begin: "`",
            end: "`"
          }
        ]
      }
    ];
    G.contains = Y;
    const k = h.inherit(h.TITLE_MODE, { begin: L }), W = "(\\(.*\\)\\s*)?\\B[-=]>", Z = {
      className: "params",
      begin: "\\([^\\(]",
      returnBegin: !0,
      /* We need another contained nameless mode to not have every nested
      pair of parens to be called "params" */
      contains: [
        {
          begin: /\(/,
          end: /\)/,
          keywords: x,
          contains: ["self"].concat(Y)
        }
      ]
    }, H = {
      variants: [
        { match: [
          /class\s+/,
          L,
          /\s+extends\s+/,
          L
        ] },
        { match: [
          /class\s+/,
          L
        ] }
      ],
      scope: {
        2: "title.class",
        4: "title.class.inherited"
      },
      keywords: x
    };
    return {
      name: "CoffeeScript",
      aliases: [
        "coffee",
        "cson",
        "iced"
      ],
      keywords: x,
      illegal: /\/\*/,
      contains: [
        ...Y,
        h.COMMENT("###", "###"),
        h.HASH_COMMENT_MODE,
        {
          className: "function",
          begin: "^\\s*" + L + "\\s*=\\s*" + W,
          end: "[-=]>",
          returnBegin: !0,
          contains: [
            k,
            Z
          ]
        },
        {
          // anonymous function start
          begin: /[:\(,=]\s*/,
          relevance: 0,
          contains: [
            {
              className: "function",
              begin: W,
              end: "[-=]>",
              returnBegin: !0,
              contains: [Z]
            }
          ]
        },
        H,
        {
          begin: L + ":",
          end: ":",
          returnBegin: !0,
          returnEnd: !0,
          relevance: 0
        }
      ]
    };
  }
  return Hd = g, Hd;
}
var qd, E0;
function AM() {
  if (E0)
    return qd;
  E0 = 1;
  function s(i) {
    return {
      name: "Coq",
      keywords: {
        keyword: [
          "_|0",
          "as",
          "at",
          "cofix",
          "else",
          "end",
          "exists",
          "exists2",
          "fix",
          "for",
          "forall",
          "fun",
          "if",
          "IF",
          "in",
          "let",
          "match",
          "mod",
          "Prop",
          "return",
          "Set",
          "then",
          "Type",
          "using",
          "where",
          "with",
          "Abort",
          "About",
          "Add",
          "Admit",
          "Admitted",
          "All",
          "Arguments",
          "Assumptions",
          "Axiom",
          "Back",
          "BackTo",
          "Backtrack",
          "Bind",
          "Blacklist",
          "Canonical",
          "Cd",
          "Check",
          "Class",
          "Classes",
          "Close",
          "Coercion",
          "Coercions",
          "CoFixpoint",
          "CoInductive",
          "Collection",
          "Combined",
          "Compute",
          "Conjecture",
          "Conjectures",
          "Constant",
          "constr",
          "Constraint",
          "Constructors",
          "Context",
          "Corollary",
          "CreateHintDb",
          "Cut",
          "Declare",
          "Defined",
          "Definition",
          "Delimit",
          "Dependencies",
          "Dependent",
          "Derive",
          "Drop",
          "eauto",
          "End",
          "Equality",
          "Eval",
          "Example",
          "Existential",
          "Existentials",
          "Existing",
          "Export",
          "exporting",
          "Extern",
          "Extract",
          "Extraction",
          "Fact",
          "Field",
          "Fields",
          "File",
          "Fixpoint",
          "Focus",
          "for",
          "From",
          "Function",
          "Functional",
          "Generalizable",
          "Global",
          "Goal",
          "Grab",
          "Grammar",
          "Graph",
          "Guarded",
          "Heap",
          "Hint",
          "HintDb",
          "Hints",
          "Hypotheses",
          "Hypothesis",
          "ident",
          "Identity",
          "If",
          "Immediate",
          "Implicit",
          "Import",
          "Include",
          "Inductive",
          "Infix",
          "Info",
          "Initial",
          "Inline",
          "Inspect",
          "Instance",
          "Instances",
          "Intro",
          "Intros",
          "Inversion",
          "Inversion_clear",
          "Language",
          "Left",
          "Lemma",
          "Let",
          "Libraries",
          "Library",
          "Load",
          "LoadPath",
          "Local",
          "Locate",
          "Ltac",
          "ML",
          "Mode",
          "Module",
          "Modules",
          "Monomorphic",
          "Morphism",
          "Next",
          "NoInline",
          "Notation",
          "Obligation",
          "Obligations",
          "Opaque",
          "Open",
          "Optimize",
          "Options",
          "Parameter",
          "Parameters",
          "Parametric",
          "Path",
          "Paths",
          "pattern",
          "Polymorphic",
          "Preterm",
          "Print",
          "Printing",
          "Program",
          "Projections",
          "Proof",
          "Proposition",
          "Pwd",
          "Qed",
          "Quit",
          "Rec",
          "Record",
          "Recursive",
          "Redirect",
          "Relation",
          "Remark",
          "Remove",
          "Require",
          "Reserved",
          "Reset",
          "Resolve",
          "Restart",
          "Rewrite",
          "Right",
          "Ring",
          "Rings",
          "Save",
          "Scheme",
          "Scope",
          "Scopes",
          "Script",
          "Search",
          "SearchAbout",
          "SearchHead",
          "SearchPattern",
          "SearchRewrite",
          "Section",
          "Separate",
          "Set",
          "Setoid",
          "Show",
          "Solve",
          "Sorted",
          "Step",
          "Strategies",
          "Strategy",
          "Structure",
          "SubClass",
          "Table",
          "Tables",
          "Tactic",
          "Term",
          "Test",
          "Theorem",
          "Time",
          "Timeout",
          "Transparent",
          "Type",
          "Typeclasses",
          "Types",
          "Undelimit",
          "Undo",
          "Unfocus",
          "Unfocused",
          "Unfold",
          "Universe",
          "Universes",
          "Unset",
          "Unshelve",
          "using",
          "Variable",
          "Variables",
          "Variant",
          "Verbose",
          "Visibility",
          "where",
          "with"
        ],
        built_in: [
          "abstract",
          "absurd",
          "admit",
          "after",
          "apply",
          "as",
          "assert",
          "assumption",
          "at",
          "auto",
          "autorewrite",
          "autounfold",
          "before",
          "bottom",
          "btauto",
          "by",
          "case",
          "case_eq",
          "cbn",
          "cbv",
          "change",
          "classical_left",
          "classical_right",
          "clear",
          "clearbody",
          "cofix",
          "compare",
          "compute",
          "congruence",
          "constr_eq",
          "constructor",
          "contradict",
          "contradiction",
          "cut",
          "cutrewrite",
          "cycle",
          "decide",
          "decompose",
          "dependent",
          "destruct",
          "destruction",
          "dintuition",
          "discriminate",
          "discrR",
          "do",
          "double",
          "dtauto",
          "eapply",
          "eassumption",
          "eauto",
          "ecase",
          "econstructor",
          "edestruct",
          "ediscriminate",
          "eelim",
          "eexact",
          "eexists",
          "einduction",
          "einjection",
          "eleft",
          "elim",
          "elimtype",
          "enough",
          "equality",
          "erewrite",
          "eright",
          "esimplify_eq",
          "esplit",
          "evar",
          "exact",
          "exactly_once",
          "exfalso",
          "exists",
          "f_equal",
          "fail",
          "field",
          "field_simplify",
          "field_simplify_eq",
          "first",
          "firstorder",
          "fix",
          "fold",
          "fourier",
          "functional",
          "generalize",
          "generalizing",
          "gfail",
          "give_up",
          "has_evar",
          "hnf",
          "idtac",
          "in",
          "induction",
          "injection",
          "instantiate",
          "intro",
          "intro_pattern",
          "intros",
          "intuition",
          "inversion",
          "inversion_clear",
          "is_evar",
          "is_var",
          "lapply",
          "lazy",
          "left",
          "lia",
          "lra",
          "move",
          "native_compute",
          "nia",
          "nsatz",
          "omega",
          "once",
          "pattern",
          "pose",
          "progress",
          "proof",
          "psatz",
          "quote",
          "record",
          "red",
          "refine",
          "reflexivity",
          "remember",
          "rename",
          "repeat",
          "replace",
          "revert",
          "revgoals",
          "rewrite",
          "rewrite_strat",
          "right",
          "ring",
          "ring_simplify",
          "rtauto",
          "set",
          "setoid_reflexivity",
          "setoid_replace",
          "setoid_rewrite",
          "setoid_symmetry",
          "setoid_transitivity",
          "shelve",
          "shelve_unifiable",
          "simpl",
          "simple",
          "simplify_eq",
          "solve",
          "specialize",
          "split",
          "split_Rabs",
          "split_Rmult",
          "stepl",
          "stepr",
          "subst",
          "sum",
          "swap",
          "symmetry",
          "tactic",
          "tauto",
          "time",
          "timeout",
          "top",
          "transitivity",
          "trivial",
          "try",
          "tryif",
          "unfold",
          "unify",
          "until",
          "using",
          "vm_compute",
          "with"
        ]
      },
      contains: [
        i.QUOTE_STRING_MODE,
        i.COMMENT("\\(\\*", "\\*\\)"),
        i.C_NUMBER_MODE,
        {
          className: "type",
          excludeBegin: !0,
          begin: "\\|\\s*",
          end: "\\w+"
        },
        {
          // relevance booster
          begin: /[-=]>/
        }
      ]
    };
  }
  return qd = s, qd;
}
var $d, h0;
function OM() {
  if (h0)
    return $d;
  h0 = 1;
  function s(i) {
    return {
      name: "Caché Object Script",
      case_insensitive: !0,
      aliases: ["cls"],
      keywords: "property parameter class classmethod clientmethod extends as break catch close continue do d|0 else elseif for goto halt hang h|0 if job j|0 kill k|0 lock l|0 merge new open quit q|0 read r|0 return set s|0 tcommit throw trollback try tstart use view while write w|0 xecute x|0 zkill znspace zn ztrap zwrite zw zzdump zzwrite print zbreak zinsert zload zprint zremove zsave zzprint mv mvcall mvcrt mvdim mvprint zquit zsync ascii",
      contains: [
        {
          className: "number",
          begin: "\\b(\\d+(\\.\\d*)?|\\.\\d+)",
          relevance: 0
        },
        {
          className: "string",
          variants: [
            {
              begin: '"',
              end: '"',
              contains: [
                {
                  // escaped
                  begin: '""',
                  relevance: 0
                }
              ]
            }
          ]
        },
        i.C_LINE_COMMENT_MODE,
        i.C_BLOCK_COMMENT_MODE,
        {
          className: "comment",
          begin: /;/,
          end: "$",
          relevance: 0
        },
        {
          // Functions and user-defined functions: write $ztime(60*60*3), $$myFunc(10), $$^Val(1)
          className: "built_in",
          begin: /(?:\$\$?|\.\.)\^?[a-zA-Z]+/
        },
        {
          // Macro command: quit $$$OK
          className: "built_in",
          begin: /\$\$\$[a-zA-Z]+/
        },
        {
          // Special (global) variables: write %request.Content; Built-in classes: %Library.Integer
          className: "built_in",
          begin: /%[a-z]+(?:\.[a-z]+)*/
        },
        {
          // Global variable: set ^globalName = 12 write ^globalName
          className: "symbol",
          begin: /\^%?[a-zA-Z][\w]*/
        },
        {
          // Some control constructions: do ##class(Package.ClassName).Method(), ##super()
          className: "keyword",
          begin: /##class|##super|#define|#dim/
        },
        // sub-languages: are not fully supported by hljs by 11/15/2015
        // left for the future implementation.
        {
          begin: /&sql\(/,
          end: /\)/,
          excludeBegin: !0,
          excludeEnd: !0,
          subLanguage: "sql"
        },
        {
          begin: /&(js|jscript|javascript)</,
          end: />/,
          excludeBegin: !0,
          excludeEnd: !0,
          subLanguage: "javascript"
        },
        {
          // this brakes first and last tag, but this is the only way to embed a valid html
          begin: /&html<\s*</,
          end: />\s*>/,
          subLanguage: "xml"
        }
      ]
    };
  }
  return $d = s, $d;
}
var Wd, S0;
function yM() {
  if (S0)
    return Wd;
  S0 = 1;
  function s(i) {
    const o = i.regex, c = i.COMMENT("//", "$", { contains: [{ begin: /\\\n/ }] }), r = "decltype\\(auto\\)", e = "[a-zA-Z_]\\w*::", h = "(?!struct)(" + r + "|" + o.optional(e) + "[a-zA-Z_]\\w*" + o.optional("<[^<>]+>") + ")", S = {
      className: "type",
      begin: "\\b[a-z\\d_]*_t\\b"
    }, O = {
      className: "string",
      variants: [
        {
          begin: '(u8?|U|L)?"',
          end: '"',
          illegal: "\\n",
          contains: [i.BACKSLASH_ESCAPE]
        },
        {
          begin: "(u8?|U|L)?'(" + "\\\\(x[0-9A-Fa-f]{2}|u[0-9A-Fa-f]{4,8}|[0-7]{3}|\\S)" + "|.)",
          end: "'",
          illegal: "."
        },
        i.END_SAME_AS_BEGIN({
          begin: /(?:u8?|U|L)?R"([^()\\ ]{0,16})\(/,
          end: /\)([^()\\ ]{0,16})"/
        })
      ]
    }, N = {
      className: "number",
      variants: [
        { begin: "\\b(0b[01']+)" },
        { begin: "(-?)\\b([\\d']+(\\.[\\d']*)?|\\.[\\d']+)((ll|LL|l|L)(u|U)?|(u|U)(ll|LL|l|L)?|f|F|b|B)" },
        { begin: "(-?)(\\b0[xX][a-fA-F0-9']+|(\\b[\\d']+(\\.[\\d']*)?|\\.[\\d']+)([eE][-+]?[\\d']+)?)" }
      ],
      relevance: 0
    }, D = {
      className: "meta",
      begin: /#\s*[a-z]+\b/,
      end: /$/,
      keywords: { keyword: "if else elif endif define undef warning error line pragma _Pragma ifdef ifndef include" },
      contains: [
        {
          begin: /\\\n/,
          relevance: 0
        },
        i.inherit(O, { className: "string" }),
        {
          className: "string",
          begin: /<.*?>/
        },
        c,
        i.C_BLOCK_COMMENT_MODE
      ]
    }, x = {
      className: "title",
      begin: o.optional(e) + i.IDENT_RE,
      relevance: 0
    }, L = o.optional(e) + i.IDENT_RE + "\\s*\\(", G = [
      "alignas",
      "alignof",
      "and",
      "and_eq",
      "asm",
      "atomic_cancel",
      "atomic_commit",
      "atomic_noexcept",
      "auto",
      "bitand",
      "bitor",
      "break",
      "case",
      "catch",
      "class",
      "co_await",
      "co_return",
      "co_yield",
      "compl",
      "concept",
      "const_cast|10",
      "consteval",
      "constexpr",
      "constinit",
      "continue",
      "decltype",
      "default",
      "delete",
      "do",
      "dynamic_cast|10",
      "else",
      "enum",
      "explicit",
      "export",
      "extern",
      "false",
      "final",
      "for",
      "friend",
      "goto",
      "if",
      "import",
      "inline",
      "module",
      "mutable",
      "namespace",
      "new",
      "noexcept",
      "not",
      "not_eq",
      "nullptr",
      "operator",
      "or",
      "or_eq",
      "override",
      "private",
      "protected",
      "public",
      "reflexpr",
      "register",
      "reinterpret_cast|10",
      "requires",
      "return",
      "sizeof",
      "static_assert",
      "static_cast|10",
      "struct",
      "switch",
      "synchronized",
      "template",
      "this",
      "thread_local",
      "throw",
      "transaction_safe",
      "transaction_safe_dynamic",
      "true",
      "try",
      "typedef",
      "typeid",
      "typename",
      "union",
      "using",
      "virtual",
      "volatile",
      "while",
      "xor",
      "xor_eq"
    ], Y = [
      "bool",
      "char",
      "char16_t",
      "char32_t",
      "char8_t",
      "double",
      "float",
      "int",
      "long",
      "short",
      "void",
      "wchar_t",
      "unsigned",
      "signed",
      "const",
      "static"
    ], k = [
      "any",
      "auto_ptr",
      "barrier",
      "binary_semaphore",
      "bitset",
      "complex",
      "condition_variable",
      "condition_variable_any",
      "counting_semaphore",
      "deque",
      "false_type",
      "future",
      "imaginary",
      "initializer_list",
      "istringstream",
      "jthread",
      "latch",
      "lock_guard",
      "multimap",
      "multiset",
      "mutex",
      "optional",
      "ostringstream",
      "packaged_task",
      "pair",
      "promise",
      "priority_queue",
      "queue",
      "recursive_mutex",
      "recursive_timed_mutex",
      "scoped_lock",
      "set",
      "shared_future",
      "shared_lock",
      "shared_mutex",
      "shared_timed_mutex",
      "shared_ptr",
      "stack",
      "string_view",
      "stringstream",
      "timed_mutex",
      "thread",
      "true_type",
      "tuple",
      "unique_lock",
      "unique_ptr",
      "unordered_map",
      "unordered_multimap",
      "unordered_multiset",
      "unordered_set",
      "variant",
      "vector",
      "weak_ptr",
      "wstring",
      "wstring_view"
    ], W = [
      "abort",
      "abs",
      "acos",
      "apply",
      "as_const",
      "asin",
      "atan",
      "atan2",
      "calloc",
      "ceil",
      "cerr",
      "cin",
      "clog",
      "cos",
      "cosh",
      "cout",
      "declval",
      "endl",
      "exchange",
      "exit",
      "exp",
      "fabs",
      "floor",
      "fmod",
      "forward",
      "fprintf",
      "fputs",
      "free",
      "frexp",
      "fscanf",
      "future",
      "invoke",
      "isalnum",
      "isalpha",
      "iscntrl",
      "isdigit",
      "isgraph",
      "islower",
      "isprint",
      "ispunct",
      "isspace",
      "isupper",
      "isxdigit",
      "labs",
      "launder",
      "ldexp",
      "log",
      "log10",
      "make_pair",
      "make_shared",
      "make_shared_for_overwrite",
      "make_tuple",
      "make_unique",
      "malloc",
      "memchr",
      "memcmp",
      "memcpy",
      "memset",
      "modf",
      "move",
      "pow",
      "printf",
      "putchar",
      "puts",
      "realloc",
      "scanf",
      "sin",
      "sinh",
      "snprintf",
      "sprintf",
      "sqrt",
      "sscanf",
      "std",
      "stderr",
      "stdin",
      "stdout",
      "strcat",
      "strchr",
      "strcmp",
      "strcpy",
      "strcspn",
      "strlen",
      "strncat",
      "strncmp",
      "strncpy",
      "strpbrk",
      "strrchr",
      "strspn",
      "strstr",
      "swap",
      "tan",
      "tanh",
      "terminate",
      "to_underlying",
      "tolower",
      "toupper",
      "vfprintf",
      "visit",
      "vprintf",
      "vsprintf"
    ], K = {
      type: Y,
      keyword: G,
      literal: [
        "NULL",
        "false",
        "nullopt",
        "nullptr",
        "true"
      ],
      built_in: ["_Pragma"],
      _type_hints: k
    }, Q = {
      className: "function.dispatch",
      relevance: 0,
      keywords: {
        // Only for relevance, not highlighting.
        _hint: W
      },
      begin: o.concat(
        /\b/,
        /(?!decltype)/,
        /(?!if)/,
        /(?!for)/,
        /(?!switch)/,
        /(?!while)/,
        i.IDENT_RE,
        o.lookahead(/(<[^<>]+>|)\s*\(/)
      )
    }, _e = [
      Q,
      D,
      S,
      c,
      i.C_BLOCK_COMMENT_MODE,
      N,
      O
    ], se = {
      // This mode covers expression context where we can't expect a function
      // definition and shouldn't highlight anything that looks like one:
      // `return some()`, `else if()`, `(x*sum(1, 2))`
      variants: [
        {
          begin: /=/,
          end: /;/
        },
        {
          begin: /\(/,
          end: /\)/
        },
        {
          beginKeywords: "new throw return else",
          end: /;/
        }
      ],
      keywords: K,
      contains: _e.concat([
        {
          begin: /\(/,
          end: /\)/,
          keywords: K,
          contains: _e.concat(["self"]),
          relevance: 0
        }
      ]),
      relevance: 0
    }, Pe = {
      className: "function",
      begin: "(" + h + "[\\*&\\s]+)+" + L,
      returnBegin: !0,
      end: /[{;=]/,
      excludeEnd: !0,
      keywords: K,
      illegal: /[^\w\s\*&:<>.]/,
      contains: [
        {
          // to prevent it from being confused as the function title
          begin: r,
          keywords: K,
          relevance: 0
        },
        {
          begin: L,
          returnBegin: !0,
          contains: [x],
          relevance: 0
        },
        // needed because we do not have look-behind on the below rule
        // to prevent it from grabbing the final : in a :: pair
        {
          begin: /::/,
          relevance: 0
        },
        // initializers
        {
          begin: /:/,
          endsWithParent: !0,
          contains: [
            O,
            N
          ]
        },
        // allow for multiple declarations, e.g.:
        // extern void f(int), g(char);
        {
          relevance: 0,
          match: /,/
        },
        {
          className: "params",
          begin: /\(/,
          end: /\)/,
          keywords: K,
          relevance: 0,
          contains: [
            c,
            i.C_BLOCK_COMMENT_MODE,
            O,
            N,
            S,
            // Count matching parentheses.
            {
              begin: /\(/,
              end: /\)/,
              keywords: K,
              relevance: 0,
              contains: [
                "self",
                c,
                i.C_BLOCK_COMMENT_MODE,
                O,
                N,
                S
              ]
            }
          ]
        },
        S,
        c,
        i.C_BLOCK_COMMENT_MODE,
        D
      ]
    };
    return {
      name: "C++",
      aliases: [
        "cc",
        "c++",
        "h++",
        "hpp",
        "hh",
        "hxx",
        "cxx"
      ],
      keywords: K,
      illegal: "</",
      classNameAliases: { "function.dispatch": "built_in" },
      contains: [].concat(
        se,
        Pe,
        Q,
        _e,
        [
          D,
          {
            // containers: ie, `vector <int> rooms (9);`
            begin: "\\b(deque|list|queue|priority_queue|pair|stack|vector|map|set|bitset|multiset|multimap|unordered_map|unordered_set|unordered_multiset|unordered_multimap|array|tuple|optional|variant|function)\\s*<(?!<)",
            end: ">",
            keywords: K,
            contains: [
              "self",
              S
            ]
          },
          {
            begin: i.IDENT_RE + "::",
            keywords: K
          },
          {
            match: [
              // extra complexity to deal with `enum class` and `enum struct`
              /\b(?:enum(?:\s+(?:class|struct))?|class|struct|union)/,
              /\s+/,
              /\w+/
            ],
            className: {
              1: "keyword",
              3: "title.class"
            }
          }
        ]
      )
    };
  }
  return Wd = s, Wd;
}
var zd, b0;
function IM() {
  if (b0)
    return zd;
  b0 = 1;
  function s(i) {
    const o = "primitive rsc_template", c = "group clone ms master location colocation order fencing_topology rsc_ticket acl_target acl_group user role tag xml";
    return {
      name: "crmsh",
      aliases: [
        "crm",
        "pcmk"
      ],
      case_insensitive: !0,
      keywords: {
        keyword: "params meta operations op rule attributes utilization" + " " + "read write deny defined not_defined in_range date spec in ref reference attribute type xpath version and or lt gt tag lte gte eq ne \\" + " " + "number string",
        literal: "Master Started Slave Stopped start promote demote stop monitor true false"
      },
      contains: [
        i.HASH_COMMENT_MODE,
        {
          beginKeywords: "node",
          starts: {
            end: "\\s*([\\w_-]+:)?",
            starts: {
              className: "title",
              end: "\\s*[\\$\\w_][\\w_-]*"
            }
          }
        },
        {
          beginKeywords: o,
          starts: {
            className: "title",
            end: "\\s*[\\$\\w_][\\w_-]*",
            starts: { end: "\\s*@?[\\w_][\\w_\\.:-]*" }
          }
        },
        {
          begin: "\\b(" + c.split(" ").join("|") + ")\\s+",
          keywords: c,
          starts: {
            className: "title",
            end: "[\\$\\w_][\\w_-]*"
          }
        },
        {
          beginKeywords: "property rsc_defaults op_defaults",
          starts: {
            className: "title",
            end: "\\s*([\\w_-]+:)?"
          }
        },
        i.QUOTE_STRING_MODE,
        {
          className: "meta",
          begin: "(ocf|systemd|service|lsb):[\\w_:-]+",
          relevance: 0
        },
        {
          className: "number",
          begin: "\\b\\d+(\\.\\d+)?(ms|s|h|m)?",
          relevance: 0
        },
        {
          className: "literal",
          begin: "[-]?(infinity|inf)",
          relevance: 0
        },
        {
          className: "attr",
          begin: /([A-Za-z$_#][\w_-]+)=/,
          relevance: 0
        },
        {
          className: "tag",
          begin: "</?",
          end: "/?>",
          relevance: 0
        }
      ]
    };
  }
  return zd = s, zd;
}
var Kd, T0;
function DM() {
  if (T0)
    return Kd;
  T0 = 1;
  function s(i) {
    const o = "(_?[ui](8|16|32|64|128))?", c = "(_?f(32|64))?", r = "[a-zA-Z_]\\w*[!?=]?", e = "[a-zA-Z_]\\w*[!?=]?|[-+~]@|<<|>>|[=!]~|===?|<=>|[<>]=?|\\*\\*|[-/+%^&*~|]|//|//=|&[-+*]=?|&\\*\\*|\\[\\][=?]?", g = "[A-Za-z_]\\w*(::\\w+)*(\\?|!)?", h = {
      $pattern: r,
      keyword: "abstract alias annotation as as? asm begin break case class def do else elsif end ensure enum extend for fun if include instance_sizeof is_a? lib macro module next nil? of out pointerof private protected rescue responds_to? return require select self sizeof struct super then type typeof union uninitialized unless until verbatim when while with yield __DIR__ __END_LINE__ __FILE__ __LINE__",
      literal: "false nil true"
    }, S = {
      className: "subst",
      begin: /#\{/,
      end: /\}/,
      keywords: h
    }, C = {
      // negative-look forward attemps to prevent false matches like:
      // @ident@ or $ident$ that might indicate this is not ruby at all
      className: "variable",
      begin: "(\\$\\W)|((\\$|@@?)(\\w+))(?=[^@$?])(?![A-Za-z])(?![@$?'])"
    }, O = {
      className: "template-variable",
      variants: [
        {
          begin: "\\{\\{",
          end: "\\}\\}"
        },
        {
          begin: "\\{%",
          end: "%\\}"
        }
      ],
      keywords: h
    };
    function N(W, Z) {
      const H = [
        {
          begin: W,
          end: Z
        }
      ];
      return H[0].contains = H, H;
    }
    const D = {
      className: "string",
      contains: [
        i.BACKSLASH_ESCAPE,
        S
      ],
      variants: [
        {
          begin: /'/,
          end: /'/
        },
        {
          begin: /"/,
          end: /"/
        },
        {
          begin: /`/,
          end: /`/
        },
        {
          begin: "%[Qwi]?\\(",
          end: "\\)",
          contains: N("\\(", "\\)")
        },
        {
          begin: "%[Qwi]?\\[",
          end: "\\]",
          contains: N("\\[", "\\]")
        },
        {
          begin: "%[Qwi]?\\{",
          end: /\}/,
          contains: N(/\{/, /\}/)
        },
        {
          begin: "%[Qwi]?<",
          end: ">",
          contains: N("<", ">")
        },
        {
          begin: "%[Qwi]?\\|",
          end: "\\|"
        },
        {
          begin: /<<-\w+$/,
          end: /^\s*\w+$/
        }
      ],
      relevance: 0
    }, x = {
      className: "string",
      variants: [
        {
          begin: "%q\\(",
          end: "\\)",
          contains: N("\\(", "\\)")
        },
        {
          begin: "%q\\[",
          end: "\\]",
          contains: N("\\[", "\\]")
        },
        {
          begin: "%q\\{",
          end: /\}/,
          contains: N(/\{/, /\}/)
        },
        {
          begin: "%q<",
          end: ">",
          contains: N("<", ">")
        },
        {
          begin: "%q\\|",
          end: "\\|"
        },
        {
          begin: /<<-'\w+'$/,
          end: /^\s*\w+$/
        }
      ],
      relevance: 0
    }, L = {
      begin: "(?!%\\})(" + i.RE_STARTERS_RE + "|\\n|\\b(case|if|select|unless|until|when|while)\\b)\\s*",
      keywords: "case if select unless until when while",
      contains: [
        {
          className: "regexp",
          contains: [
            i.BACKSLASH_ESCAPE,
            S
          ],
          variants: [
            {
              begin: "//[a-z]*",
              relevance: 0
            },
            {
              begin: "/(?!\\/)",
              end: "/[a-z]*"
            }
          ]
        }
      ],
      relevance: 0
    }, G = {
      className: "regexp",
      contains: [
        i.BACKSLASH_ESCAPE,
        S
      ],
      variants: [
        {
          begin: "%r\\(",
          end: "\\)",
          contains: N("\\(", "\\)")
        },
        {
          begin: "%r\\[",
          end: "\\]",
          contains: N("\\[", "\\]")
        },
        {
          begin: "%r\\{",
          end: /\}/,
          contains: N(/\{/, /\}/)
        },
        {
          begin: "%r<",
          end: ">",
          contains: N("<", ">")
        },
        {
          begin: "%r\\|",
          end: "\\|"
        }
      ],
      relevance: 0
    }, Y = {
      className: "meta",
      begin: "@\\[",
      end: "\\]",
      contains: [i.inherit(i.QUOTE_STRING_MODE, { className: "string" })]
    }, k = [
      O,
      D,
      x,
      G,
      L,
      Y,
      C,
      i.HASH_COMMENT_MODE,
      {
        className: "class",
        beginKeywords: "class module struct",
        end: "$|;",
        illegal: /=/,
        contains: [
          i.HASH_COMMENT_MODE,
          i.inherit(i.TITLE_MODE, { begin: g }),
          {
            // relevance booster for inheritance
            begin: "<"
          }
        ]
      },
      {
        className: "class",
        beginKeywords: "lib enum union",
        end: "$|;",
        illegal: /=/,
        contains: [
          i.HASH_COMMENT_MODE,
          i.inherit(i.TITLE_MODE, { begin: g })
        ]
      },
      {
        beginKeywords: "annotation",
        end: "$|;",
        illegal: /=/,
        contains: [
          i.HASH_COMMENT_MODE,
          i.inherit(i.TITLE_MODE, { begin: g })
        ],
        relevance: 2
      },
      {
        className: "function",
        beginKeywords: "def",
        end: /\B\b/,
        contains: [
          i.inherit(i.TITLE_MODE, {
            begin: e,
            endsParent: !0
          })
        ]
      },
      {
        className: "function",
        beginKeywords: "fun macro",
        end: /\B\b/,
        contains: [
          i.inherit(i.TITLE_MODE, {
            begin: e,
            endsParent: !0
          })
        ],
        relevance: 2
      },
      {
        className: "symbol",
        begin: i.UNDERSCORE_IDENT_RE + "(!|\\?)?:",
        relevance: 0
      },
      {
        className: "symbol",
        begin: ":",
        contains: [
          D,
          { begin: e }
        ],
        relevance: 0
      },
      {
        className: "number",
        variants: [
          { begin: "\\b0b([01_]+)" + o },
          { begin: "\\b0o([0-7_]+)" + o },
          { begin: "\\b0x([A-Fa-f0-9_]+)" + o },
          { begin: "\\b([1-9][0-9_]*[0-9]|[0-9])(\\.[0-9][0-9_]*)?([eE]_?[-+]?[0-9_]*)?" + c + "(?!_)" },
          { begin: "\\b([1-9][0-9_]*|0)" + o }
        ],
        relevance: 0
      }
    ];
    return S.contains = k, O.contains = k.slice(1), {
      name: "Crystal",
      aliases: ["cr"],
      keywords: h,
      contains: k
    };
  }
  return Kd = s, Kd;
}
var Qd, v0;
function wM() {
  if (v0)
    return Qd;
  v0 = 1;
  function s(i) {
    const o = [
      "bool",
      "byte",
      "char",
      "decimal",
      "delegate",
      "double",
      "dynamic",
      "enum",
      "float",
      "int",
      "long",
      "nint",
      "nuint",
      "object",
      "sbyte",
      "short",
      "string",
      "ulong",
      "uint",
      "ushort"
    ], c = [
      "public",
      "private",
      "protected",
      "static",
      "internal",
      "protected",
      "abstract",
      "async",
      "extern",
      "override",
      "unsafe",
      "virtual",
      "new",
      "sealed",
      "partial"
    ], r = [
      "default",
      "false",
      "null",
      "true"
    ], e = [
      "abstract",
      "as",
      "base",
      "break",
      "case",
      "catch",
      "class",
      "const",
      "continue",
      "do",
      "else",
      "event",
      "explicit",
      "extern",
      "finally",
      "fixed",
      "for",
      "foreach",
      "goto",
      "if",
      "implicit",
      "in",
      "interface",
      "internal",
      "is",
      "lock",
      "namespace",
      "new",
      "operator",
      "out",
      "override",
      "params",
      "private",
      "protected",
      "public",
      "readonly",
      "record",
      "ref",
      "return",
      "scoped",
      "sealed",
      "sizeof",
      "stackalloc",
      "static",
      "struct",
      "switch",
      "this",
      "throw",
      "try",
      "typeof",
      "unchecked",
      "unsafe",
      "using",
      "virtual",
      "void",
      "volatile",
      "while"
    ], g = [
      "add",
      "alias",
      "and",
      "ascending",
      "async",
      "await",
      "by",
      "descending",
      "equals",
      "from",
      "get",
      "global",
      "group",
      "init",
      "into",
      "join",
      "let",
      "nameof",
      "not",
      "notnull",
      "on",
      "or",
      "orderby",
      "partial",
      "remove",
      "select",
      "set",
      "unmanaged",
      "value|0",
      "var",
      "when",
      "where",
      "with",
      "yield"
    ], h = {
      keyword: e.concat(g),
      built_in: o,
      literal: r
    }, S = i.inherit(i.TITLE_MODE, { begin: "[a-zA-Z](\\.?\\w)*" }), C = {
      className: "number",
      variants: [
        { begin: "\\b(0b[01']+)" },
        { begin: "(-?)\\b([\\d']+(\\.[\\d']*)?|\\.[\\d']+)(u|U|l|L|ul|UL|f|F|b|B)" },
        { begin: "(-?)(\\b0[xX][a-fA-F0-9']+|(\\b[\\d']+(\\.[\\d']*)?|\\.[\\d']+)([eE][-+]?[\\d']+)?)" }
      ],
      relevance: 0
    }, O = {
      className: "string",
      begin: '@"',
      end: '"',
      contains: [{ begin: '""' }]
    }, N = i.inherit(O, { illegal: /\n/ }), D = {
      className: "subst",
      begin: /\{/,
      end: /\}/,
      keywords: h
    }, x = i.inherit(D, { illegal: /\n/ }), L = {
      className: "string",
      begin: /\$"/,
      end: '"',
      illegal: /\n/,
      contains: [
        { begin: /\{\{/ },
        { begin: /\}\}/ },
        i.BACKSLASH_ESCAPE,
        x
      ]
    }, G = {
      className: "string",
      begin: /\$@"/,
      end: '"',
      contains: [
        { begin: /\{\{/ },
        { begin: /\}\}/ },
        { begin: '""' },
        D
      ]
    }, Y = i.inherit(G, {
      illegal: /\n/,
      contains: [
        { begin: /\{\{/ },
        { begin: /\}\}/ },
        { begin: '""' },
        x
      ]
    });
    D.contains = [
      G,
      L,
      O,
      i.APOS_STRING_MODE,
      i.QUOTE_STRING_MODE,
      C,
      i.C_BLOCK_COMMENT_MODE
    ], x.contains = [
      Y,
      L,
      N,
      i.APOS_STRING_MODE,
      i.QUOTE_STRING_MODE,
      C,
      i.inherit(i.C_BLOCK_COMMENT_MODE, { illegal: /\n/ })
    ];
    const k = { variants: [
      G,
      L,
      O,
      i.APOS_STRING_MODE,
      i.QUOTE_STRING_MODE
    ] }, W = {
      begin: "<",
      end: ">",
      contains: [
        { beginKeywords: "in out" },
        S
      ]
    }, Z = i.IDENT_RE + "(<" + i.IDENT_RE + "(\\s*,\\s*" + i.IDENT_RE + ")*>)?(\\[\\])?", H = {
      // prevents expressions like `@class` from incorrect flagging
      // `class` as a keyword
      begin: "@" + i.IDENT_RE,
      relevance: 0
    };
    return {
      name: "C#",
      aliases: [
        "cs",
        "c#"
      ],
      keywords: h,
      illegal: /::/,
      contains: [
        i.COMMENT(
          "///",
          "$",
          {
            returnBegin: !0,
            contains: [
              {
                className: "doctag",
                variants: [
                  {
                    begin: "///",
                    relevance: 0
                  },
                  { begin: "<!--|-->" },
                  {
                    begin: "</?",
                    end: ">"
                  }
                ]
              }
            ]
          }
        ),
        i.C_LINE_COMMENT_MODE,
        i.C_BLOCK_COMMENT_MODE,
        {
          className: "meta",
          begin: "#",
          end: "$",
          keywords: { keyword: "if else elif endif define undef warning error line region endregion pragma checksum" }
        },
        k,
        C,
        {
          beginKeywords: "class interface",
          relevance: 0,
          end: /[{;=]/,
          illegal: /[^\s:,]/,
          contains: [
            { beginKeywords: "where class" },
            S,
            W,
            i.C_LINE_COMMENT_MODE,
            i.C_BLOCK_COMMENT_MODE
          ]
        },
        {
          beginKeywords: "namespace",
          relevance: 0,
          end: /[{;=]/,
          illegal: /[^\s:]/,
          contains: [
            S,
            i.C_LINE_COMMENT_MODE,
            i.C_BLOCK_COMMENT_MODE
          ]
        },
        {
          beginKeywords: "record",
          relevance: 0,
          end: /[{;=]/,
          illegal: /[^\s:]/,
          contains: [
            S,
            W,
            i.C_LINE_COMMENT_MODE,
            i.C_BLOCK_COMMENT_MODE
          ]
        },
        {
          // [Attributes("")]
          className: "meta",
          begin: "^\\s*\\[(?=[\\w])",
          excludeBegin: !0,
          end: "\\]",
          excludeEnd: !0,
          contains: [
            {
              className: "string",
              begin: /"/,
              end: /"/
            }
          ]
        },
        {
          // Expression keywords prevent 'keyword Name(...)' from being
          // recognized as a function definition
          beginKeywords: "new return throw await else",
          relevance: 0
        },
        {
          className: "function",
          begin: "(" + Z + "\\s+)+" + i.IDENT_RE + "\\s*(<[^=]+>\\s*)?\\(",
          returnBegin: !0,
          end: /\s*[{;=]/,
          excludeEnd: !0,
          keywords: h,
          contains: [
            // prevents these from being highlighted `title`
            {
              beginKeywords: c.join(" "),
              relevance: 0
            },
            {
              begin: i.IDENT_RE + "\\s*(<[^=]+>\\s*)?\\(",
              returnBegin: !0,
              contains: [
                i.TITLE_MODE,
                W
              ],
              relevance: 0
            },
            { match: /\(\)/ },
            {
              className: "params",
              begin: /\(/,
              end: /\)/,
              excludeBegin: !0,
              excludeEnd: !0,
              keywords: h,
              relevance: 0,
              contains: [
                k,
                C,
                i.C_BLOCK_COMMENT_MODE
              ]
            },
            i.C_LINE_COMMENT_MODE,
            i.C_BLOCK_COMMENT_MODE
          ]
        },
        H
      ]
    };
  }
  return Qd = s, Qd;
}
var Xd, C0;
function xM() {
  if (C0)
    return Xd;
  C0 = 1;
  function s(i) {
    return {
      name: "CSP",
      case_insensitive: !1,
      keywords: {
        $pattern: "[a-zA-Z][a-zA-Z0-9_-]*",
        keyword: [
          "base-uri",
          "child-src",
          "connect-src",
          "default-src",
          "font-src",
          "form-action",
          "frame-ancestors",
          "frame-src",
          "img-src",
          "manifest-src",
          "media-src",
          "object-src",
          "plugin-types",
          "report-uri",
          "sandbox",
          "script-src",
          "style-src",
          "trusted-types",
          "unsafe-hashes",
          "worker-src"
        ]
      },
      contains: [
        {
          className: "string",
          begin: "'",
          end: "'"
        },
        {
          className: "attribute",
          begin: "^Content",
          end: ":",
          excludeEnd: !0
        }
      ]
    };
  }
  return Xd = s, Xd;
}
var Zd, R0;
function LM() {
  if (R0)
    return Zd;
  R0 = 1;
  const s = (h) => ({
    IMPORTANT: {
      scope: "meta",
      begin: "!important"
    },
    BLOCK_COMMENT: h.C_BLOCK_COMMENT_MODE,
    HEXCOLOR: {
      scope: "number",
      begin: /#(([0-9a-fA-F]{3,4})|(([0-9a-fA-F]{2}){3,4}))\b/
    },
    FUNCTION_DISPATCH: {
      className: "built_in",
      begin: /[\w-]+(?=\()/
    },
    ATTRIBUTE_SELECTOR_MODE: {
      scope: "selector-attr",
      begin: /\[/,
      end: /\]/,
      illegal: "$",
      contains: [
        h.APOS_STRING_MODE,
        h.QUOTE_STRING_MODE
      ]
    },
    CSS_NUMBER_MODE: {
      scope: "number",
      begin: h.NUMBER_RE + "(%|em|ex|ch|rem|vw|vh|vmin|vmax|cm|mm|in|pt|pc|px|deg|grad|rad|turn|s|ms|Hz|kHz|dpi|dpcm|dppx)?",
      relevance: 0
    },
    CSS_VARIABLE: {
      className: "attr",
      begin: /--[A-Za-z_][A-Za-z0-9_-]*/
    }
  }), i = [
    "a",
    "abbr",
    "address",
    "article",
    "aside",
    "audio",
    "b",
    "blockquote",
    "body",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "dd",
    "del",
    "details",
    "dfn",
    "div",
    "dl",
    "dt",
    "em",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "header",
    "hgroup",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "label",
    "legend",
    "li",
    "main",
    "mark",
    "menu",
    "nav",
    "object",
    "ol",
    "p",
    "q",
    "quote",
    "samp",
    "section",
    "span",
    "strong",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "tr",
    "ul",
    "var",
    "video"
  ], o = [
    "any-hover",
    "any-pointer",
    "aspect-ratio",
    "color",
    "color-gamut",
    "color-index",
    "device-aspect-ratio",
    "device-height",
    "device-width",
    "display-mode",
    "forced-colors",
    "grid",
    "height",
    "hover",
    "inverted-colors",
    "monochrome",
    "orientation",
    "overflow-block",
    "overflow-inline",
    "pointer",
    "prefers-color-scheme",
    "prefers-contrast",
    "prefers-reduced-motion",
    "prefers-reduced-transparency",
    "resolution",
    "scan",
    "scripting",
    "update",
    "width",
    // TODO: find a better solution?
    "min-width",
    "max-width",
    "min-height",
    "max-height"
  ], c = [
    "active",
    "any-link",
    "blank",
    "checked",
    "current",
    "default",
    "defined",
    "dir",
    // dir()
    "disabled",
    "drop",
    "empty",
    "enabled",
    "first",
    "first-child",
    "first-of-type",
    "fullscreen",
    "future",
    "focus",
    "focus-visible",
    "focus-within",
    "has",
    // has()
    "host",
    // host or host()
    "host-context",
    // host-context()
    "hover",
    "indeterminate",
    "in-range",
    "invalid",
    "is",
    // is()
    "lang",
    // lang()
    "last-child",
    "last-of-type",
    "left",
    "link",
    "local-link",
    "not",
    // not()
    "nth-child",
    // nth-child()
    "nth-col",
    // nth-col()
    "nth-last-child",
    // nth-last-child()
    "nth-last-col",
    // nth-last-col()
    "nth-last-of-type",
    //nth-last-of-type()
    "nth-of-type",
    //nth-of-type()
    "only-child",
    "only-of-type",
    "optional",
    "out-of-range",
    "past",
    "placeholder-shown",
    "read-only",
    "read-write",
    "required",
    "right",
    "root",
    "scope",
    "target",
    "target-within",
    "user-invalid",
    "valid",
    "visited",
    "where"
    // where()
  ], r = [
    "after",
    "backdrop",
    "before",
    "cue",
    "cue-region",
    "first-letter",
    "first-line",
    "grammar-error",
    "marker",
    "part",
    "placeholder",
    "selection",
    "slotted",
    "spelling-error"
  ], e = [
    "align-content",
    "align-items",
    "align-self",
    "all",
    "animation",
    "animation-delay",
    "animation-direction",
    "animation-duration",
    "animation-fill-mode",
    "animation-iteration-count",
    "animation-name",
    "animation-play-state",
    "animation-timing-function",
    "backface-visibility",
    "background",
    "background-attachment",
    "background-blend-mode",
    "background-clip",
    "background-color",
    "background-image",
    "background-origin",
    "background-position",
    "background-repeat",
    "background-size",
    "block-size",
    "border",
    "border-block",
    "border-block-color",
    "border-block-end",
    "border-block-end-color",
    "border-block-end-style",
    "border-block-end-width",
    "border-block-start",
    "border-block-start-color",
    "border-block-start-style",
    "border-block-start-width",
    "border-block-style",
    "border-block-width",
    "border-bottom",
    "border-bottom-color",
    "border-bottom-left-radius",
    "border-bottom-right-radius",
    "border-bottom-style",
    "border-bottom-width",
    "border-collapse",
    "border-color",
    "border-image",
    "border-image-outset",
    "border-image-repeat",
    "border-image-slice",
    "border-image-source",
    "border-image-width",
    "border-inline",
    "border-inline-color",
    "border-inline-end",
    "border-inline-end-color",
    "border-inline-end-style",
    "border-inline-end-width",
    "border-inline-start",
    "border-inline-start-color",
    "border-inline-start-style",
    "border-inline-start-width",
    "border-inline-style",
    "border-inline-width",
    "border-left",
    "border-left-color",
    "border-left-style",
    "border-left-width",
    "border-radius",
    "border-right",
    "border-right-color",
    "border-right-style",
    "border-right-width",
    "border-spacing",
    "border-style",
    "border-top",
    "border-top-color",
    "border-top-left-radius",
    "border-top-right-radius",
    "border-top-style",
    "border-top-width",
    "border-width",
    "bottom",
    "box-decoration-break",
    "box-shadow",
    "box-sizing",
    "break-after",
    "break-before",
    "break-inside",
    "caption-side",
    "caret-color",
    "clear",
    "clip",
    "clip-path",
    "clip-rule",
    "color",
    "column-count",
    "column-fill",
    "column-gap",
    "column-rule",
    "column-rule-color",
    "column-rule-style",
    "column-rule-width",
    "column-span",
    "column-width",
    "columns",
    "contain",
    "content",
    "content-visibility",
    "counter-increment",
    "counter-reset",
    "cue",
    "cue-after",
    "cue-before",
    "cursor",
    "direction",
    "display",
    "empty-cells",
    "filter",
    "flex",
    "flex-basis",
    "flex-direction",
    "flex-flow",
    "flex-grow",
    "flex-shrink",
    "flex-wrap",
    "float",
    "flow",
    "font",
    "font-display",
    "font-family",
    "font-feature-settings",
    "font-kerning",
    "font-language-override",
    "font-size",
    "font-size-adjust",
    "font-smoothing",
    "font-stretch",
    "font-style",
    "font-synthesis",
    "font-variant",
    "font-variant-caps",
    "font-variant-east-asian",
    "font-variant-ligatures",
    "font-variant-numeric",
    "font-variant-position",
    "font-variation-settings",
    "font-weight",
    "gap",
    "glyph-orientation-vertical",
    "grid",
    "grid-area",
    "grid-auto-columns",
    "grid-auto-flow",
    "grid-auto-rows",
    "grid-column",
    "grid-column-end",
    "grid-column-start",
    "grid-gap",
    "grid-row",
    "grid-row-end",
    "grid-row-start",
    "grid-template",
    "grid-template-areas",
    "grid-template-columns",
    "grid-template-rows",
    "hanging-punctuation",
    "height",
    "hyphens",
    "icon",
    "image-orientation",
    "image-rendering",
    "image-resolution",
    "ime-mode",
    "inline-size",
    "isolation",
    "justify-content",
    "left",
    "letter-spacing",
    "line-break",
    "line-height",
    "list-style",
    "list-style-image",
    "list-style-position",
    "list-style-type",
    "margin",
    "margin-block",
    "margin-block-end",
    "margin-block-start",
    "margin-bottom",
    "margin-inline",
    "margin-inline-end",
    "margin-inline-start",
    "margin-left",
    "margin-right",
    "margin-top",
    "marks",
    "mask",
    "mask-border",
    "mask-border-mode",
    "mask-border-outset",
    "mask-border-repeat",
    "mask-border-slice",
    "mask-border-source",
    "mask-border-width",
    "mask-clip",
    "mask-composite",
    "mask-image",
    "mask-mode",
    "mask-origin",
    "mask-position",
    "mask-repeat",
    "mask-size",
    "mask-type",
    "max-block-size",
    "max-height",
    "max-inline-size",
    "max-width",
    "min-block-size",
    "min-height",
    "min-inline-size",
    "min-width",
    "mix-blend-mode",
    "nav-down",
    "nav-index",
    "nav-left",
    "nav-right",
    "nav-up",
    "none",
    "normal",
    "object-fit",
    "object-position",
    "opacity",
    "order",
    "orphans",
    "outline",
    "outline-color",
    "outline-offset",
    "outline-style",
    "outline-width",
    "overflow",
    "overflow-wrap",
    "overflow-x",
    "overflow-y",
    "padding",
    "padding-block",
    "padding-block-end",
    "padding-block-start",
    "padding-bottom",
    "padding-inline",
    "padding-inline-end",
    "padding-inline-start",
    "padding-left",
    "padding-right",
    "padding-top",
    "page-break-after",
    "page-break-before",
    "page-break-inside",
    "pause",
    "pause-after",
    "pause-before",
    "perspective",
    "perspective-origin",
    "pointer-events",
    "position",
    "quotes",
    "resize",
    "rest",
    "rest-after",
    "rest-before",
    "right",
    "row-gap",
    "scroll-margin",
    "scroll-margin-block",
    "scroll-margin-block-end",
    "scroll-margin-block-start",
    "scroll-margin-bottom",
    "scroll-margin-inline",
    "scroll-margin-inline-end",
    "scroll-margin-inline-start",
    "scroll-margin-left",
    "scroll-margin-right",
    "scroll-margin-top",
    "scroll-padding",
    "scroll-padding-block",
    "scroll-padding-block-end",
    "scroll-padding-block-start",
    "scroll-padding-bottom",
    "scroll-padding-inline",
    "scroll-padding-inline-end",
    "scroll-padding-inline-start",
    "scroll-padding-left",
    "scroll-padding-right",
    "scroll-padding-top",
    "scroll-snap-align",
    "scroll-snap-stop",
    "scroll-snap-type",
    "scrollbar-color",
    "scrollbar-gutter",
    "scrollbar-width",
    "shape-image-threshold",
    "shape-margin",
    "shape-outside",
    "speak",
    "speak-as",
    "src",
    // @font-face
    "tab-size",
    "table-layout",
    "text-align",
    "text-align-all",
    "text-align-last",
    "text-combine-upright",
    "text-decoration",
    "text-decoration-color",
    "text-decoration-line",
    "text-decoration-style",
    "text-emphasis",
    "text-emphasis-color",
    "text-emphasis-position",
    "text-emphasis-style",
    "text-indent",
    "text-justify",
    "text-orientation",
    "text-overflow",
    "text-rendering",
    "text-shadow",
    "text-transform",
    "text-underline-position",
    "top",
    "transform",
    "transform-box",
    "transform-origin",
    "transform-style",
    "transition",
    "transition-delay",
    "transition-duration",
    "transition-property",
    "transition-timing-function",
    "unicode-bidi",
    "vertical-align",
    "visibility",
    "voice-balance",
    "voice-duration",
    "voice-family",
    "voice-pitch",
    "voice-range",
    "voice-rate",
    "voice-stress",
    "voice-volume",
    "white-space",
    "widows",
    "width",
    "will-change",
    "word-break",
    "word-spacing",
    "word-wrap",
    "writing-mode",
    "z-index"
    // reverse makes sure longer attributes `font-weight` are matched fully
    // instead of getting false positives on say `font`
  ].reverse();
  function g(h) {
    const S = h.regex, C = s(h), O = { begin: /-(webkit|moz|ms|o)-(?=[a-z])/ }, N = "and or not only", D = /@-?\w[\w]*(-\w+)*/, x = "[a-zA-Z-][a-zA-Z0-9_-]*", L = [
      h.APOS_STRING_MODE,
      h.QUOTE_STRING_MODE
    ];
    return {
      name: "CSS",
      case_insensitive: !0,
      illegal: /[=|'\$]/,
      keywords: { keyframePosition: "from to" },
      classNameAliases: {
        // for visual continuity with `tag {}` and because we
        // don't have a great class for this?
        keyframePosition: "selector-tag"
      },
      contains: [
        C.BLOCK_COMMENT,
        O,
        // to recognize keyframe 40% etc which are outside the scope of our
        // attribute value mode
        C.CSS_NUMBER_MODE,
        {
          className: "selector-id",
          begin: /#[A-Za-z0-9_-]+/,
          relevance: 0
        },
        {
          className: "selector-class",
          begin: "\\." + x,
          relevance: 0
        },
        C.ATTRIBUTE_SELECTOR_MODE,
        {
          className: "selector-pseudo",
          variants: [
            { begin: ":(" + c.join("|") + ")" },
            { begin: ":(:)?(" + r.join("|") + ")" }
          ]
        },
        // we may actually need this (12/2020)
        // { // pseudo-selector params
        //   begin: /\(/,
        //   end: /\)/,
        //   contains: [ hljs.CSS_NUMBER_MODE ]
        // },
        C.CSS_VARIABLE,
        {
          className: "attribute",
          begin: "\\b(" + e.join("|") + ")\\b"
        },
        // attribute values
        {
          begin: /:/,
          end: /[;}{]/,
          contains: [
            C.BLOCK_COMMENT,
            C.HEXCOLOR,
            C.IMPORTANT,
            C.CSS_NUMBER_MODE,
            ...L,
            // needed to highlight these as strings and to avoid issues with
            // illegal characters that might be inside urls that would tigger the
            // languages illegal stack
            {
              begin: /(url|data-uri)\(/,
              end: /\)/,
              relevance: 0,
              // from keywords
              keywords: { built_in: "url data-uri" },
              contains: [
                ...L,
                {
                  className: "string",
                  // any character other than `)` as in `url()` will be the start
                  // of a string, which ends with `)` (from the parent mode)
                  begin: /[^)]/,
                  endsWithParent: !0,
                  excludeEnd: !0
                }
              ]
            },
            C.FUNCTION_DISPATCH
          ]
        },
        {
          begin: S.lookahead(/@/),
          end: "[{;]",
          relevance: 0,
          illegal: /:/,
          // break on Less variables @var: ...
          contains: [
            {
              className: "keyword",
              begin: D
            },
            {
              begin: /\s/,
              endsWithParent: !0,
              excludeEnd: !0,
              relevance: 0,
              keywords: {
                $pattern: /[a-z-]+/,
                keyword: N,
                attribute: o.join(" ")
              },
              contains: [
                {
                  begin: /[a-z-]+(?=:)/,
                  className: "attribute"
                },
                ...L,
                C.CSS_NUMBER_MODE
              ]
            }
          ]
        },
        {
          className: "selector-tag",
          begin: "\\b(" + i.join("|") + ")\\b"
        }
      ]
    };
  }
  return Zd = g, Zd;
}
var jd, N0;
function MM() {
  if (N0)
    return jd;
  N0 = 1;
  function s(i) {
    const o = {
      $pattern: i.UNDERSCORE_IDENT_RE,
      keyword: "abstract alias align asm assert auto body break byte case cast catch class const continue debug default delete deprecated do else enum export extern final finally for foreach foreach_reverse|10 goto if immutable import in inout int interface invariant is lazy macro mixin module new nothrow out override package pragma private protected public pure ref return scope shared static struct super switch synchronized template this throw try typedef typeid typeof union unittest version void volatile while with __FILE__ __LINE__ __gshared|10 __thread __traits __DATE__ __EOF__ __TIME__ __TIMESTAMP__ __VENDOR__ __VERSION__",
      built_in: "bool cdouble cent cfloat char creal dchar delegate double dstring float function idouble ifloat ireal long real short string ubyte ucent uint ulong ushort wchar wstring",
      literal: "false null true"
    }, c = "(0|[1-9][\\d_]*)", r = "(0|[1-9][\\d_]*|\\d[\\d_]*|[\\d_]+?\\d)", e = "0[bB][01_]+", g = "([\\da-fA-F][\\da-fA-F_]*|_[\\da-fA-F][\\da-fA-F_]*)", h = "0[xX]" + g, S = "([eE][+-]?" + r + ")", C = "(" + r + "(\\.\\d*|" + S + ")|\\d+\\." + r + "|\\." + c + S + "?)", O = "(0[xX](" + g + "\\." + g + "|\\.?" + g + ")[pP][+-]?" + r + ")", N = "(" + c + "|" + e + "|" + h + ")", D = "(" + O + "|" + C + ")", x = `\\\\(['"\\?\\\\abfnrtv]|u[\\dA-Fa-f]{4}|[0-7]{1,3}|x[\\dA-Fa-f]{2}|U[\\dA-Fa-f]{8})|&[a-zA-Z\\d]{2,};`, L = {
      className: "number",
      begin: "\\b" + N + "(L|u|U|Lu|LU|uL|UL)?",
      relevance: 0
    }, G = {
      className: "number",
      begin: "\\b(" + D + "([fF]|L|i|[fF]i|Li)?|" + N + "(i|[fF]i|Li))",
      relevance: 0
    }, Y = {
      className: "string",
      begin: "'(" + x + "|.)",
      end: "'",
      illegal: "."
    }, W = {
      className: "string",
      begin: '"',
      contains: [{
        begin: x,
        relevance: 0
      }],
      end: '"[cwd]?'
    }, Z = {
      className: "string",
      begin: '[rq]"',
      end: '"[cwd]?',
      relevance: 5
    }, H = {
      className: "string",
      begin: "`",
      end: "`[cwd]?"
    }, K = {
      className: "string",
      begin: 'x"[\\da-fA-F\\s\\n\\r]*"[cwd]?',
      relevance: 10
    }, Q = {
      className: "string",
      begin: 'q"\\{',
      end: '\\}"'
    }, _e = {
      className: "meta",
      begin: "^#!",
      end: "$",
      relevance: 5
    }, se = {
      className: "meta",
      begin: "#(line)",
      end: "$",
      relevance: 5
    }, Pe = {
      className: "keyword",
      begin: "@[a-zA-Z_][a-zA-Z_\\d]*"
    }, Ke = i.COMMENT(
      "\\/\\+",
      "\\+\\/",
      {
        contains: ["self"],
        relevance: 10
      }
    );
    return {
      name: "D",
      keywords: o,
      contains: [
        i.C_LINE_COMMENT_MODE,
        i.C_BLOCK_COMMENT_MODE,
        Ke,
        K,
        W,
        Z,
        H,
        Q,
        G,
        L,
        Y,
        _e,
        se,
        Pe
      ]
    };
  }
  return jd = s, jd;
}
var Jd, A0;
function PM() {
  if (A0)
    return Jd;
  A0 = 1;
  function s(i) {
    const o = i.regex, c = {
      begin: /<\/?[A-Za-z_]/,
      end: ">",
      subLanguage: "xml",
      relevance: 0
    }, r = {
      begin: "^[-\\*]{3,}",
      end: "$"
    }, e = {
      className: "code",
      variants: [
        // TODO: fix to allow these to work with sublanguage also
        { begin: "(`{3,})[^`](.|\\n)*?\\1`*[ ]*" },
        { begin: "(~{3,})[^~](.|\\n)*?\\1~*[ ]*" },
        // needed to allow markdown as a sublanguage to work
        {
          begin: "```",
          end: "```+[ ]*$"
        },
        {
          begin: "~~~",
          end: "~~~+[ ]*$"
        },
        { begin: "`.+?`" },
        {
          begin: "(?=^( {4}|\\t))",
          // use contains to gobble up multiple lines to allow the block to be whatever size
          // but only have a single open/close tag vs one per line
          contains: [
            {
              begin: "^( {4}|\\t)",
              end: "(\\n)$"
            }
          ],
          relevance: 0
        }
      ]
    }, g = {
      className: "bullet",
      begin: "^[ 	]*([*+-]|(\\d+\\.))(?=\\s+)",
      end: "\\s+",
      excludeEnd: !0
    }, h = {
      begin: /^\[[^\n]+\]:/,
      returnBegin: !0,
      contains: [
        {
          className: "symbol",
          begin: /\[/,
          end: /\]/,
          excludeBegin: !0,
          excludeEnd: !0
        },
        {
          className: "link",
          begin: /:\s*/,
          end: /$/,
          excludeBegin: !0
        }
      ]
    }, S = /[A-Za-z][A-Za-z0-9+.-]*/, C = {
      variants: [
        // too much like nested array access in so many languages
        // to have any real relevance
        {
          begin: /\[.+?\]\[.*?\]/,
          relevance: 0
        },
        // popular internet URLs
        {
          begin: /\[.+?\]\(((data|javascript|mailto):|(?:http|ftp)s?:\/\/).*?\)/,
          relevance: 2
        },
        {
          begin: o.concat(/\[.+?\]\(/, S, /:\/\/.*?\)/),
          relevance: 2
        },
        // relative urls
        {
          begin: /\[.+?\]\([./?&#].*?\)/,
          relevance: 1
        },
        // whatever else, lower relevance (might not be a link at all)
        {
          begin: /\[.*?\]\(.*?\)/,
          relevance: 0
        }
      ],
      returnBegin: !0,
      contains: [
        {
          // empty strings for alt or link text
          match: /\[(?=\])/
        },
        {
          className: "string",
          relevance: 0,
          begin: "\\[",
          end: "\\]",
          excludeBegin: !0,
          returnEnd: !0
        },
        {
          className: "link",
          relevance: 0,
          begin: "\\]\\(",
          end: "\\)",
          excludeBegin: !0,
          excludeEnd: !0
        },
        {
          className: "symbol",
          relevance: 0,
          begin: "\\]\\[",
          end: "\\]",
          excludeBegin: !0,
          excludeEnd: !0
        }
      ]
    }, O = {
      className: "strong",
      contains: [],
      // defined later
      variants: [
        {
          begin: /_{2}(?!\s)/,
          end: /_{2}/
        },
        {
          begin: /\*{2}(?!\s)/,
          end: /\*{2}/
        }
      ]
    }, N = {
      className: "emphasis",
      contains: [],
      // defined later
      variants: [
        {
          begin: /\*(?![*\s])/,
          end: /\*/
        },
        {
          begin: /_(?![_\s])/,
          end: /_/,
          relevance: 0
        }
      ]
    }, D = i.inherit(O, { contains: [] }), x = i.inherit(N, { contains: [] });
    O.contains.push(x), N.contains.push(D);
    let L = [
      c,
      C
    ];
    return [
      O,
      N,
      D,
      x
    ].forEach((k) => {
      k.contains = k.contains.concat(L);
    }), L = L.concat(O, N), {
      name: "Markdown",
      aliases: [
        "md",
        "mkdown",
        "mkd"
      ],
      contains: [
        {
          className: "section",
          variants: [
            {
              begin: "^#{1,6}",
              end: "$",
              contains: L
            },
            {
              begin: "(?=^.+?\\n[=-]{2,}$)",
              contains: [
                { begin: "^[=-]*$" },
                {
                  begin: "^",
                  end: "\\n",
                  contains: L
                }
              ]
            }
          ]
        },
        c,
        g,
        O,
        N,
        {
          className: "quote",
          begin: "^>\\s+",
          contains: L,
          end: "$"
        },
        e,
        r,
        C,
        h
      ]
    };
  }
  return Jd = s, Jd;
}
var eu, O0;
function kM() {
  if (O0)
    return eu;
  O0 = 1;
  function s(i) {
    const o = {
      className: "subst",
      variants: [{ begin: "\\$[A-Za-z0-9_]+" }]
    }, c = {
      className: "subst",
      variants: [
        {
          begin: /\$\{/,
          end: /\}/
        }
      ],
      keywords: "true false null this is new super"
    }, r = {
      className: "string",
      variants: [
        {
          begin: "r'''",
          end: "'''"
        },
        {
          begin: 'r"""',
          end: '"""'
        },
        {
          begin: "r'",
          end: "'",
          illegal: "\\n"
        },
        {
          begin: 'r"',
          end: '"',
          illegal: "\\n"
        },
        {
          begin: "'''",
          end: "'''",
          contains: [
            i.BACKSLASH_ESCAPE,
            o,
            c
          ]
        },
        {
          begin: '"""',
          end: '"""',
          contains: [
            i.BACKSLASH_ESCAPE,
            o,
            c
          ]
        },
        {
          begin: "'",
          end: "'",
          illegal: "\\n",
          contains: [
            i.BACKSLASH_ESCAPE,
            o,
            c
          ]
        },
        {
          begin: '"',
          end: '"',
          illegal: "\\n",
          contains: [
            i.BACKSLASH_ESCAPE,
            o,
            c
          ]
        }
      ]
    };
    c.contains = [
      i.C_NUMBER_MODE,
      r
    ];
    const e = [
      // dart:core
      "Comparable",
      "DateTime",
      "Duration",
      "Function",
      "Iterable",
      "Iterator",
      "List",
      "Map",
      "Match",
      "Object",
      "Pattern",
      "RegExp",
      "Set",
      "Stopwatch",
      "String",
      "StringBuffer",
      "StringSink",
      "Symbol",
      "Type",
      "Uri",
      "bool",
      "double",
      "int",
      "num",
      // dart:html
      "Element",
      "ElementList"
    ], g = e.map((C) => `${C}?`);
    return {
      name: "Dart",
      keywords: {
        keyword: [
          "abstract",
          "as",
          "assert",
          "async",
          "await",
          "base",
          "break",
          "case",
          "catch",
          "class",
          "const",
          "continue",
          "covariant",
          "default",
          "deferred",
          "do",
          "dynamic",
          "else",
          "enum",
          "export",
          "extends",
          "extension",
          "external",
          "factory",
          "false",
          "final",
          "finally",
          "for",
          "Function",
          "get",
          "hide",
          "if",
          "implements",
          "import",
          "in",
          "interface",
          "is",
          "late",
          "library",
          "mixin",
          "new",
          "null",
          "on",
          "operator",
          "part",
          "required",
          "rethrow",
          "return",
          "sealed",
          "set",
          "show",
          "static",
          "super",
          "switch",
          "sync",
          "this",
          "throw",
          "true",
          "try",
          "typedef",
          "var",
          "void",
          "when",
          "while",
          "with",
          "yield"
        ],
        built_in: e.concat(g).concat([
          // dart:core
          "Never",
          "Null",
          "dynamic",
          "print",
          // dart:html
          "document",
          "querySelector",
          "querySelectorAll",
          "window"
        ]),
        $pattern: /[A-Za-z][A-Za-z0-9_]*\??/
      },
      contains: [
        r,
        i.COMMENT(
          /\/\*\*(?!\/)/,
          /\*\//,
          {
            subLanguage: "markdown",
            relevance: 0
          }
        ),
        i.COMMENT(
          /\/{3,} ?/,
          /$/,
          { contains: [
            {
              subLanguage: "markdown",
              begin: ".",
              end: "$",
              relevance: 0
            }
          ] }
        ),
        i.C_LINE_COMMENT_MODE,
        i.C_BLOCK_COMMENT_MODE,
        {
          className: "class",
          beginKeywords: "class interface",
          end: /\{/,
          excludeEnd: !0,
          contains: [
            { beginKeywords: "extends implements" },
            i.UNDERSCORE_TITLE_MODE
          ]
        },
        i.C_NUMBER_MODE,
        {
          className: "meta",
          begin: "@[A-Za-z]+"
        },
        {
          begin: "=>"
          // No markup, just a relevance booster
        }
      ]
    };
  }
  return eu = s, eu;
}
var tu, y0;
function FM() {
  if (y0)
    return tu;
  y0 = 1;
  function s(i) {
    const o = [
      "exports",
      "register",
      "file",
      "shl",
      "array",
      "record",
      "property",
      "for",
      "mod",
      "while",
      "set",
      "ally",
      "label",
      "uses",
      "raise",
      "not",
      "stored",
      "class",
      "safecall",
      "var",
      "interface",
      "or",
      "private",
      "static",
      "exit",
      "index",
      "inherited",
      "to",
      "else",
      "stdcall",
      "override",
      "shr",
      "asm",
      "far",
      "resourcestring",
      "finalization",
      "packed",
      "virtual",
      "out",
      "and",
      "protected",
      "library",
      "do",
      "xorwrite",
      "goto",
      "near",
      "function",
      "end",
      "div",
      "overload",
      "object",
      "unit",
      "begin",
      "string",
      "on",
      "inline",
      "repeat",
      "until",
      "destructor",
      "write",
      "message",
      "program",
      "with",
      "read",
      "initialization",
      "except",
      "default",
      "nil",
      "if",
      "case",
      "cdecl",
      "in",
      "downto",
      "threadvar",
      "of",
      "try",
      "pascal",
      "const",
      "external",
      "constructor",
      "type",
      "public",
      "then",
      "implementation",
      "finally",
      "published",
      "procedure",
      "absolute",
      "reintroduce",
      "operator",
      "as",
      "is",
      "abstract",
      "alias",
      "assembler",
      "bitpacked",
      "break",
      "continue",
      "cppdecl",
      "cvar",
      "enumerator",
      "experimental",
      "platform",
      "deprecated",
      "unimplemented",
      "dynamic",
      "export",
      "far16",
      "forward",
      "generic",
      "helper",
      "implements",
      "interrupt",
      "iochecks",
      "local",
      "name",
      "nodefault",
      "noreturn",
      "nostackframe",
      "oldfpccall",
      "otherwise",
      "saveregisters",
      "softfloat",
      "specialize",
      "strict",
      "unaligned",
      "varargs"
    ], c = [
      i.C_LINE_COMMENT_MODE,
      i.COMMENT(/\{/, /\}/, { relevance: 0 }),
      i.COMMENT(/\(\*/, /\*\)/, { relevance: 10 })
    ], r = {
      className: "meta",
      variants: [
        {
          begin: /\{\$/,
          end: /\}/
        },
        {
          begin: /\(\*\$/,
          end: /\*\)/
        }
      ]
    }, e = {
      className: "string",
      begin: /'/,
      end: /'/,
      contains: [{ begin: /''/ }]
    }, g = {
      className: "number",
      relevance: 0,
      // Source: https://www.freepascal.org/docs-html/ref/refse6.html
      variants: [
        {
          // Hexadecimal notation, e.g., $7F.
          begin: "\\$[0-9A-Fa-f]+"
        },
        {
          // Octal notation, e.g., &42.
          begin: "&[0-7]+"
        },
        {
          // Binary notation, e.g., %1010.
          begin: "%[01]+"
        }
      ]
    }, h = {
      className: "string",
      begin: /(#\d+)+/
    }, S = {
      begin: i.IDENT_RE + "\\s*=\\s*class\\s*\\(",
      returnBegin: !0,
      contains: [i.TITLE_MODE]
    }, C = {
      className: "function",
      beginKeywords: "function constructor destructor procedure",
      end: /[:;]/,
      keywords: "function constructor|10 destructor|10 procedure|10",
      contains: [
        i.TITLE_MODE,
        {
          className: "params",
          begin: /\(/,
          end: /\)/,
          keywords: o,
          contains: [
            e,
            h,
            r
          ].concat(c)
        },
        r
      ].concat(c)
    };
    return {
      name: "Delphi",
      aliases: [
        "dpr",
        "dfm",
        "pas",
        "pascal"
      ],
      case_insensitive: !0,
      keywords: o,
      illegal: /"|\$[G-Zg-z]|\/\*|<\/|\|/,
      contains: [
        e,
        h,
        i.NUMBER_MODE,
        g,
        S,
        C,
        r
      ].concat(c)
    };
  }
  return tu = s, tu;
}
var ru, I0;
function UM() {
  if (I0)
    return ru;
  I0 = 1;
  function s(i) {
    const o = i.regex;
    return {
      name: "Diff",
      aliases: ["patch"],
      contains: [
        {
          className: "meta",
          relevance: 10,
          match: o.either(
            /^@@ +-\d+,\d+ +\+\d+,\d+ +@@/,
            /^\*\*\* +\d+,\d+ +\*\*\*\*$/,
            /^--- +\d+,\d+ +----$/
          )
        },
        {
          className: "comment",
          variants: [
            {
              begin: o.either(
                /Index: /,
                /^index/,
                /={3,}/,
                /^-{3}/,
                /^\*{3} /,
                /^\+{3}/,
                /^diff --git/
              ),
              end: /$/
            },
            { match: /^\*{15}$/ }
          ]
        },
        {
          className: "addition",
          begin: /^\+/,
          end: /$/
        },
        {
          className: "deletion",
          begin: /^-/,
          end: /$/
        },
        {
          className: "addition",
          begin: /^!/,
          end: /$/
        }
      ]
    };
  }
  return ru = s, ru;
}
var nu, D0;
function BM() {
  if (D0)
    return nu;
  D0 = 1;
  function s(i) {
    const o = {
      begin: /\|[A-Za-z]+:?/,
      keywords: { name: "truncatewords removetags linebreaksbr yesno get_digit timesince random striptags filesizeformat escape linebreaks length_is ljust rjust cut urlize fix_ampersands title floatformat capfirst pprint divisibleby add make_list unordered_list urlencode timeuntil urlizetrunc wordcount stringformat linenumbers slice date dictsort dictsortreversed default_if_none pluralize lower join center default truncatewords_html upper length phone2numeric wordwrap time addslashes slugify first escapejs force_escape iriencode last safe safeseq truncatechars localize unlocalize localtime utc timezone" },
      contains: [
        i.QUOTE_STRING_MODE,
        i.APOS_STRING_MODE
      ]
    };
    return {
      name: "Django",
      aliases: ["jinja"],
      case_insensitive: !0,
      subLanguage: "xml",
      contains: [
        i.COMMENT(/\{%\s*comment\s*%\}/, /\{%\s*endcomment\s*%\}/),
        i.COMMENT(/\{#/, /#\}/),
        {
          className: "template-tag",
          begin: /\{%/,
          end: /%\}/,
          contains: [
            {
              className: "name",
              begin: /\w+/,
              keywords: { name: "comment endcomment load templatetag ifchanged endifchanged if endif firstof for endfor ifnotequal endifnotequal widthratio extends include spaceless endspaceless regroup ifequal endifequal ssi now with cycle url filter endfilter debug block endblock else autoescape endautoescape csrf_token empty elif endwith static trans blocktrans endblocktrans get_static_prefix get_media_prefix plural get_current_language language get_available_languages get_current_language_bidi get_language_info get_language_info_list localize endlocalize localtime endlocaltime timezone endtimezone get_current_timezone verbatim" },
              starts: {
                endsWithParent: !0,
                keywords: "in by as",
                contains: [o],
                relevance: 0
              }
            }
          ]
        },
        {
          className: "template-variable",
          begin: /\{\{/,
          end: /\}\}/,
          contains: [o]
        }
      ]
    };
  }
  return nu = s, nu;
}
var au, w0;
function GM() {
  if (w0)
    return au;
  w0 = 1;
  function s(i) {
    return {
      name: "DNS Zone",
      aliases: [
        "bind",
        "zone"
      ],
      keywords: [
        "IN",
        "A",
        "AAAA",
        "AFSDB",
        "APL",
        "CAA",
        "CDNSKEY",
        "CDS",
        "CERT",
        "CNAME",
        "DHCID",
        "DLV",
        "DNAME",
        "DNSKEY",
        "DS",
        "HIP",
        "IPSECKEY",
        "KEY",
        "KX",
        "LOC",
        "MX",
        "NAPTR",
        "NS",
        "NSEC",
        "NSEC3",
        "NSEC3PARAM",
        "PTR",
        "RRSIG",
        "RP",
        "SIG",
        "SOA",
        "SRV",
        "SSHFP",
        "TA",
        "TKEY",
        "TLSA",
        "TSIG",
        "TXT"
      ],
      contains: [
        i.COMMENT(";", "$", { relevance: 0 }),
        {
          className: "meta",
          begin: /^\$(TTL|GENERATE|INCLUDE|ORIGIN)\b/
        },
        // IPv6
        {
          className: "number",
          begin: "((([0-9A-Fa-f]{1,4}:){7}([0-9A-Fa-f]{1,4}|:))|(([0-9A-Fa-f]{1,4}:){6}(:[0-9A-Fa-f]{1,4}|((25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)(\\.(25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){5}(((:[0-9A-Fa-f]{1,4}){1,2})|:((25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)(\\.(25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){4}(((:[0-9A-Fa-f]{1,4}){1,3})|((:[0-9A-Fa-f]{1,4})?:((25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)(\\.(25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){3}(((:[0-9A-Fa-f]{1,4}){1,4})|((:[0-9A-Fa-f]{1,4}){0,2}:((25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)(\\.(25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){2}(((:[0-9A-Fa-f]{1,4}){1,5})|((:[0-9A-Fa-f]{1,4}){0,3}:((25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)(\\.(25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){1}(((:[0-9A-Fa-f]{1,4}){1,6})|((:[0-9A-Fa-f]{1,4}){0,4}:((25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)(\\.(25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)){3}))|:))|(:(((:[0-9A-Fa-f]{1,4}){1,7})|((:[0-9A-Fa-f]{1,4}){0,5}:((25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)(\\.(25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)){3}))|:)))\\b"
        },
        // IPv4
        {
          className: "number",
          begin: "((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]).){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\\b"
        },
        i.inherit(i.NUMBER_MODE, { begin: /\b\d+[dhwm]?/ })
      ]
    };
  }
  return au = s, au;
}
var iu, x0;
function VM() {
  if (x0)
    return iu;
  x0 = 1;
  function s(i) {
    return {
      name: "Dockerfile",
      aliases: ["docker"],
      case_insensitive: !0,
      keywords: [
        "from",
        "maintainer",
        "expose",
        "env",
        "arg",
        "user",
        "onbuild",
        "stopsignal"
      ],
      contains: [
        i.HASH_COMMENT_MODE,
        i.APOS_STRING_MODE,
        i.QUOTE_STRING_MODE,
        i.NUMBER_MODE,
        {
          beginKeywords: "run cmd entrypoint volume add copy workdir label healthcheck shell",
          starts: {
            end: /[^\\]$/,
            subLanguage: "bash"
          }
        }
      ],
      illegal: "</"
    };
  }
  return iu = s, iu;
}
var ou, L0;
function YM() {
  if (L0)
    return ou;
  L0 = 1;
  function s(i) {
    const o = i.COMMENT(
      /^\s*@?rem\b/,
      /$/,
      { relevance: 10 }
    );
    return {
      name: "Batch file (DOS)",
      aliases: [
        "bat",
        "cmd"
      ],
      case_insensitive: !0,
      illegal: /\/\*/,
      keywords: {
        keyword: [
          "if",
          "else",
          "goto",
          "for",
          "in",
          "do",
          "call",
          "exit",
          "not",
          "exist",
          "errorlevel",
          "defined",
          "equ",
          "neq",
          "lss",
          "leq",
          "gtr",
          "geq"
        ],
        built_in: [
          "prn",
          "nul",
          "lpt3",
          "lpt2",
          "lpt1",
          "con",
          "com4",
          "com3",
          "com2",
          "com1",
          "aux",
          "shift",
          "cd",
          "dir",
          "echo",
          "setlocal",
          "endlocal",
          "set",
          "pause",
          "copy",
          "append",
          "assoc",
          "at",
          "attrib",
          "break",
          "cacls",
          "cd",
          "chcp",
          "chdir",
          "chkdsk",
          "chkntfs",
          "cls",
          "cmd",
          "color",
          "comp",
          "compact",
          "convert",
          "date",
          "dir",
          "diskcomp",
          "diskcopy",
          "doskey",
          "erase",
          "fs",
          "find",
          "findstr",
          "format",
          "ftype",
          "graftabl",
          "help",
          "keyb",
          "label",
          "md",
          "mkdir",
          "mode",
          "more",
          "move",
          "path",
          "pause",
          "print",
          "popd",
          "pushd",
          "promt",
          "rd",
          "recover",
          "rem",
          "rename",
          "replace",
          "restore",
          "rmdir",
          "shift",
          "sort",
          "start",
          "subst",
          "time",
          "title",
          "tree",
          "type",
          "ver",
          "verify",
          "vol",
          // winutils
          "ping",
          "net",
          "ipconfig",
          "taskkill",
          "xcopy",
          "ren",
          "del"
        ]
      },
      contains: [
        {
          className: "variable",
          begin: /%%[^ ]|%[^ ]+?%|![^ ]+?!/
        },
        {
          className: "function",
          begin: {
            className: "symbol",
            begin: "^\\s*[A-Za-z._?][A-Za-z0-9_$#@~.?]*(:|\\s+label)",
            relevance: 0
          }.begin,
          end: "goto:eof",
          contains: [
            i.inherit(i.TITLE_MODE, { begin: "([_a-zA-Z]\\w*\\.)*([_a-zA-Z]\\w*:)?[_a-zA-Z]\\w*" }),
            o
          ]
        },
        {
          className: "number",
          begin: "\\b\\d+",
          relevance: 0
        },
        o
      ]
    };
  }
  return ou = s, ou;
}
var su, M0;
function HM() {
  if (M0)
    return su;
  M0 = 1;
  function s(i) {
    return {
      keywords: "dsconfig",
      contains: [
        {
          className: "keyword",
          begin: "^dsconfig",
          end: /\s/,
          excludeEnd: !0,
          relevance: 10
        },
        {
          className: "built_in",
          begin: /(list|create|get|set|delete)-(\w+)/,
          end: /\s/,
          excludeEnd: !0,
          illegal: "!@#$%^&*()",
          relevance: 10
        },
        {
          className: "built_in",
          begin: /--(\w+)/,
          end: /\s/,
          excludeEnd: !0
        },
        {
          className: "string",
          begin: /"/,
          end: /"/
        },
        {
          className: "string",
          begin: /'/,
          end: /'/
        },
        {
          className: "string",
          begin: /[\w\-?]+:\w+/,
          end: /\W/,
          relevance: 0
        },
        {
          className: "string",
          begin: /\w+(\-\w+)*/,
          end: /(?=\W)/,
          relevance: 0
        },
        i.HASH_COMMENT_MODE
      ]
    };
  }
  return su = s, su;
}
var lu, P0;
function qM() {
  if (P0)
    return lu;
  P0 = 1;
  function s(i) {
    const o = {
      className: "string",
      variants: [
        i.inherit(i.QUOTE_STRING_MODE, { begin: '((u8?|U)|L)?"' }),
        {
          begin: '(u8?|U)?R"',
          end: '"',
          contains: [i.BACKSLASH_ESCAPE]
        },
        {
          begin: "'\\\\?.",
          end: "'",
          illegal: "."
        }
      ]
    }, c = {
      className: "number",
      variants: [
        { begin: "\\b(\\d+(\\.\\d*)?|\\.\\d+)(u|U|l|L|ul|UL|f|F)" },
        { begin: i.C_NUMBER_RE }
      ],
      relevance: 0
    }, r = {
      className: "meta",
      begin: "#",
      end: "$",
      keywords: { keyword: "if else elif endif define undef ifdef ifndef" },
      contains: [
        {
          begin: /\\\n/,
          relevance: 0
        },
        {
          beginKeywords: "include",
          end: "$",
          keywords: { keyword: "include" },
          contains: [
            i.inherit(o, { className: "string" }),
            {
              className: "string",
              begin: "<",
              end: ">",
              illegal: "\\n"
            }
          ]
        },
        o,
        i.C_LINE_COMMENT_MODE,
        i.C_BLOCK_COMMENT_MODE
      ]
    }, e = {
      className: "variable",
      begin: /&[a-z\d_]*\b/
    }, g = {
      className: "keyword",
      begin: "/[a-z][a-z\\d-]*/"
    }, h = {
      className: "symbol",
      begin: "^\\s*[a-zA-Z_][a-zA-Z\\d_]*:"
    }, S = {
      className: "params",
      relevance: 0,
      begin: "<",
      end: ">",
      contains: [
        c,
        e
      ]
    }, C = {
      className: "title.class",
      begin: /[a-zA-Z_][a-zA-Z\d_@-]*(?=\s\{)/,
      relevance: 0.2
    }, O = {
      className: "title.class",
      begin: /^\/(?=\s*\{)/,
      relevance: 10
    }, N = {
      match: /[a-z][a-z-,]+(?=;)/,
      relevance: 0,
      scope: "attr"
    }, D = {
      relevance: 0,
      match: [
        /[a-z][a-z-,]+/,
        /\s*/,
        /=/
      ],
      scope: {
        1: "attr",
        3: "operator"
      }
    }, x = {
      scope: "punctuation",
      relevance: 0,
      // `};` combined is just to avoid tons of useless punctuation nodes
      match: /\};|[;{}]/
    };
    return {
      name: "Device Tree",
      contains: [
        O,
        e,
        g,
        h,
        C,
        D,
        N,
        S,
        i.C_LINE_COMMENT_MODE,
        i.C_BLOCK_COMMENT_MODE,
        c,
        o,
        r,
        x,
        {
          begin: i.IDENT_RE + "::",
          keywords: ""
        }
      ]
    };
  }
  return lu = s, lu;
}
var cu, k0;
function $M() {
  if (k0)
    return cu;
  k0 = 1;
  function s(i) {
    return {
      name: "Dust",
      aliases: ["dst"],
      case_insensitive: !0,
      subLanguage: "xml",
      contains: [
        {
          className: "template-tag",
          begin: /\{[#\/]/,
          end: /\}/,
          illegal: /;/,
          contains: [
            {
              className: "name",
              begin: /[a-zA-Z\.-]+/,
              starts: {
                endsWithParent: !0,
                relevance: 0,
                contains: [i.QUOTE_STRING_MODE]
              }
            }
          ]
        },
        {
          className: "template-variable",
          begin: /\{/,
          end: /\}/,
          illegal: /;/,
          keywords: "if eq ne lt lte gt gte select default math sep"
        }
      ]
    };
  }
  return cu = s, cu;
}
var du, F0;
function WM() {
  if (F0)
    return du;
  F0 = 1;
  function s(i) {
    const o = i.COMMENT(/\(\*/, /\*\)/), c = {
      className: "attribute",
      begin: /^[ ]*[a-zA-Z]+([\s_-]+[a-zA-Z]+)*/
    }, e = {
      begin: /=/,
      end: /[.;]/,
      contains: [
        o,
        {
          className: "meta",
          begin: /\?.*\?/
        },
        {
          // terminals
          className: "string",
          variants: [
            i.APOS_STRING_MODE,
            i.QUOTE_STRING_MODE,
            {
              begin: "`",
              end: "`"
            }
          ]
        }
      ]
    };
    return {
      name: "Extended Backus-Naur Form",
      illegal: /\S/,
      contains: [
        o,
        c,
        e
      ]
    };
  }
  return du = s, du;
}
var uu, U0;
function zM() {
  if (U0)
    return uu;
  U0 = 1;
  function s(i) {
    const o = i.regex, c = "[a-zA-Z_][a-zA-Z0-9_.]*(!|\\?)?", r = "[a-zA-Z_]\\w*[!?=]?|[-+~]@|<<|>>|=~|===?|<=>|[<>]=?|\\*\\*|[-/+%^&*~`|]|\\[\\]=?", h = {
      $pattern: c,
      keyword: [
        "after",
        "alias",
        "and",
        "case",
        "catch",
        "cond",
        "defstruct",
        "defguard",
        "do",
        "else",
        "end",
        "fn",
        "for",
        "if",
        "import",
        "in",
        "not",
        "or",
        "quote",
        "raise",
        "receive",
        "require",
        "reraise",
        "rescue",
        "try",
        "unless",
        "unquote",
        "unquote_splicing",
        "use",
        "when",
        "with|0"
      ],
      literal: [
        "false",
        "nil",
        "true"
      ]
    }, S = {
      className: "subst",
      begin: /#\{/,
      end: /\}/,
      keywords: h
    }, C = {
      className: "number",
      begin: "(\\b0o[0-7_]+)|(\\b0b[01_]+)|(\\b0x[0-9a-fA-F_]+)|(-?\\b[0-9][0-9_]*(\\.[0-9_]+([eE][-+]?[0-9]+)?)?)",
      relevance: 0
    }, N = {
      match: /\\[\s\S]/,
      scope: "char.escape",
      relevance: 0
    }, D = `[/|([{<"']`, x = [
      {
        begin: /"/,
        end: /"/
      },
      {
        begin: /'/,
        end: /'/
      },
      {
        begin: /\//,
        end: /\//
      },
      {
        begin: /\|/,
        end: /\|/
      },
      {
        begin: /\(/,
        end: /\)/
      },
      {
        begin: /\[/,
        end: /\]/
      },
      {
        begin: /\{/,
        end: /\}/
      },
      {
        begin: /</,
        end: />/
      }
    ], L = (Q) => ({
      scope: "char.escape",
      begin: o.concat(/\\/, Q),
      relevance: 0
    }), G = {
      className: "string",
      begin: "~[a-z](?=" + D + ")",
      contains: x.map((Q) => i.inherit(
        Q,
        { contains: [
          L(Q.end),
          N,
          S
        ] }
      ))
    }, Y = {
      className: "string",
      begin: "~[A-Z](?=" + D + ")",
      contains: x.map((Q) => i.inherit(
        Q,
        { contains: [L(Q.end)] }
      ))
    }, k = {
      className: "regex",
      variants: [
        {
          begin: "~r(?=" + D + ")",
          contains: x.map((Q) => i.inherit(
            Q,
            {
              end: o.concat(Q.end, /[uismxfU]{0,7}/),
              contains: [
                L(Q.end),
                N,
                S
              ]
            }
          ))
        },
        {
          begin: "~R(?=" + D + ")",
          contains: x.map(
            (Q) => i.inherit(
              Q,
              {
                end: o.concat(Q.end, /[uismxfU]{0,7}/),
                contains: [L(Q.end)]
              }
            )
          )
        }
      ]
    }, W = {
      className: "string",
      contains: [
        i.BACKSLASH_ESCAPE,
        S
      ],
      variants: [
        {
          begin: /"""/,
          end: /"""/
        },
        {
          begin: /'''/,
          end: /'''/
        },
        {
          begin: /~S"""/,
          end: /"""/,
          contains: []
          // override default
        },
        {
          begin: /~S"/,
          end: /"/,
          contains: []
          // override default
        },
        {
          begin: /~S'''/,
          end: /'''/,
          contains: []
          // override default
        },
        {
          begin: /~S'/,
          end: /'/,
          contains: []
          // override default
        },
        {
          begin: /'/,
          end: /'/
        },
        {
          begin: /"/,
          end: /"/
        }
      ]
    }, Z = {
      className: "function",
      beginKeywords: "def defp defmacro defmacrop",
      end: /\B\b/,
      // the mode is ended by the title
      contains: [
        i.inherit(i.TITLE_MODE, {
          begin: c,
          endsParent: !0
        })
      ]
    }, H = i.inherit(Z, {
      className: "class",
      beginKeywords: "defimpl defmodule defprotocol defrecord",
      end: /\bdo\b|$|;/
    }), K = [
      W,
      k,
      Y,
      G,
      i.HASH_COMMENT_MODE,
      H,
      Z,
      { begin: "::" },
      {
        className: "symbol",
        begin: ":(?![\\s:])",
        contains: [
          W,
          { begin: r }
        ],
        relevance: 0
      },
      {
        className: "symbol",
        begin: c + ":(?!:)",
        relevance: 0
      },
      {
        // Usage of a module, struct, etc.
        className: "title.class",
        begin: /(\b[A-Z][a-zA-Z0-9_]+)/,
        relevance: 0
      },
      C,
      {
        className: "variable",
        begin: "(\\$\\W)|((\\$|@@?)(\\w+))"
      }
      // -> has been removed, capnproto always uses this grammar construct
    ];
    return S.contains = K, {
      name: "Elixir",
      aliases: [
        "ex",
        "exs"
      ],
      keywords: h,
      contains: K
    };
  }
  return uu = s, uu;
}
var _u, B0;
function KM() {
  if (B0)
    return _u;
  B0 = 1;
  function s(i) {
    const o = { variants: [
      i.COMMENT("--", "$"),
      i.COMMENT(
        /\{-/,
        /-\}/,
        { contains: ["self"] }
      )
    ] }, c = {
      className: "type",
      begin: "\\b[A-Z][\\w']*",
      // TODO: other constructors (built-in, infix).
      relevance: 0
    }, r = {
      begin: "\\(",
      end: "\\)",
      illegal: '"',
      contains: [
        {
          className: "type",
          begin: "\\b[A-Z][\\w]*(\\((\\.\\.|,|\\w+)\\))?"
        },
        o
      ]
    }, e = {
      begin: /\{/,
      end: /\}/,
      contains: r.contains
    }, g = {
      className: "string",
      begin: "'\\\\?.",
      end: "'",
      illegal: "."
    };
    return {
      name: "Elm",
      keywords: [
        "let",
        "in",
        "if",
        "then",
        "else",
        "case",
        "of",
        "where",
        "module",
        "import",
        "exposing",
        "type",
        "alias",
        "as",
        "infix",
        "infixl",
        "infixr",
        "port",
        "effect",
        "command",
        "subscription"
      ],
      contains: [
        // Top-level constructions.
        {
          beginKeywords: "port effect module",
          end: "exposing",
          keywords: "port effect module where command subscription exposing",
          contains: [
            r,
            o
          ],
          illegal: "\\W\\.|;"
        },
        {
          begin: "import",
          end: "$",
          keywords: "import as exposing",
          contains: [
            r,
            o
          ],
          illegal: "\\W\\.|;"
        },
        {
          begin: "type",
          end: "$",
          keywords: "type alias",
          contains: [
            c,
            r,
            e,
            o
          ]
        },
        {
          beginKeywords: "infix infixl infixr",
          end: "$",
          contains: [
            i.C_NUMBER_MODE,
            o
          ]
        },
        {
          begin: "port",
          end: "$",
          keywords: "port",
          contains: [o]
        },
        // Literals and names.
        g,
        i.QUOTE_STRING_MODE,
        i.C_NUMBER_MODE,
        c,
        i.inherit(i.TITLE_MODE, { begin: "^[_a-z][\\w']*" }),
        o,
        {
          // No markup, relevance booster
          begin: "->|<-"
        }
      ],
      illegal: /;/
    };
  }
  return _u = s, _u;
}
var pu, G0;
function QM() {
  if (G0)
    return pu;
  G0 = 1;
  function s(i) {
    const o = i.regex, c = "([a-zA-Z_]\\w*[!?=]?|[-+~]@|<<|>>|=~|===?|<=>|[<>]=?|\\*\\*|[-/+%^&*~`|]|\\[\\]=?)", r = o.either(
      /\b([A-Z]+[a-z0-9]+)+/,
      // ends in caps
      /\b([A-Z]+[a-z0-9]+)+[A-Z]+/
    ), e = o.concat(r, /(::\w+)*/), h = {
      "variable.constant": [
        "__FILE__",
        "__LINE__",
        "__ENCODING__"
      ],
      "variable.language": [
        "self",
        "super"
      ],
      keyword: [
        "alias",
        "and",
        "begin",
        "BEGIN",
        "break",
        "case",
        "class",
        "defined",
        "do",
        "else",
        "elsif",
        "end",
        "END",
        "ensure",
        "for",
        "if",
        "in",
        "module",
        "next",
        "not",
        "or",
        "redo",
        "require",
        "rescue",
        "retry",
        "return",
        "then",
        "undef",
        "unless",
        "until",
        "when",
        "while",
        "yield",
        ...[
          "include",
          "extend",
          "prepend",
          "public",
          "private",
          "protected",
          "raise",
          "throw"
        ]
      ],
      built_in: [
        "proc",
        "lambda",
        "attr_accessor",
        "attr_reader",
        "attr_writer",
        "define_method",
        "private_constant",
        "module_function"
      ],
      literal: [
        "true",
        "false",
        "nil"
      ]
    }, S = {
      className: "doctag",
      begin: "@[A-Za-z]+"
    }, C = {
      begin: "#<",
      end: ">"
    }, O = [
      i.COMMENT(
        "#",
        "$",
        { contains: [S] }
      ),
      i.COMMENT(
        "^=begin",
        "^=end",
        {
          contains: [S],
          relevance: 10
        }
      ),
      i.COMMENT("^__END__", i.MATCH_NOTHING_RE)
    ], N = {
      className: "subst",
      begin: /#\{/,
      end: /\}/,
      keywords: h
    }, D = {
      className: "string",
      contains: [
        i.BACKSLASH_ESCAPE,
        N
      ],
      variants: [
        {
          begin: /'/,
          end: /'/
        },
        {
          begin: /"/,
          end: /"/
        },
        {
          begin: /`/,
          end: /`/
        },
        {
          begin: /%[qQwWx]?\(/,
          end: /\)/
        },
        {
          begin: /%[qQwWx]?\[/,
          end: /\]/
        },
        {
          begin: /%[qQwWx]?\{/,
          end: /\}/
        },
        {
          begin: /%[qQwWx]?</,
          end: />/
        },
        {
          begin: /%[qQwWx]?\//,
          end: /\//
        },
        {
          begin: /%[qQwWx]?%/,
          end: /%/
        },
        {
          begin: /%[qQwWx]?-/,
          end: /-/
        },
        {
          begin: /%[qQwWx]?\|/,
          end: /\|/
        },
        // in the following expressions, \B in the beginning suppresses recognition of ?-sequences
        // where ? is the last character of a preceding identifier, as in: `func?4`
        { begin: /\B\?(\\\d{1,3})/ },
        { begin: /\B\?(\\x[A-Fa-f0-9]{1,2})/ },
        { begin: /\B\?(\\u\{?[A-Fa-f0-9]{1,6}\}?)/ },
        { begin: /\B\?(\\M-\\C-|\\M-\\c|\\c\\M-|\\M-|\\C-\\M-)[\x20-\x7e]/ },
        { begin: /\B\?\\(c|C-)[\x20-\x7e]/ },
        { begin: /\B\?\\?\S/ },
        // heredocs
        {
          // this guard makes sure that we have an entire heredoc and not a false
          // positive (auto-detect, etc.)
          begin: o.concat(
            /<<[-~]?'?/,
            o.lookahead(/(\w+)(?=\W)[^\n]*\n(?:[^\n]*\n)*?\s*\1\b/)
          ),
          contains: [
            i.END_SAME_AS_BEGIN({
              begin: /(\w+)/,
              end: /(\w+)/,
              contains: [
                i.BACKSLASH_ESCAPE,
                N
              ]
            })
          ]
        }
      ]
    }, x = "[1-9](_?[0-9])*|0", L = "[0-9](_?[0-9])*", G = {
      className: "number",
      relevance: 0,
      variants: [
        // decimal integer/float, optionally exponential or rational, optionally imaginary
        { begin: `\\b(${x})(\\.(${L}))?([eE][+-]?(${L})|r)?i?\\b` },
        // explicit decimal/binary/octal/hexadecimal integer,
        // optionally rational and/or imaginary
        { begin: "\\b0[dD][0-9](_?[0-9])*r?i?\\b" },
        { begin: "\\b0[bB][0-1](_?[0-1])*r?i?\\b" },
        { begin: "\\b0[oO][0-7](_?[0-7])*r?i?\\b" },
        { begin: "\\b0[xX][0-9a-fA-F](_?[0-9a-fA-F])*r?i?\\b" },
        // 0-prefixed implicit octal integer, optionally rational and/or imaginary
        { begin: "\\b0(_?[0-7])+r?i?\\b" }
      ]
    }, Y = {
      variants: [
        {
          match: /\(\)/
        },
        {
          className: "params",
          begin: /\(/,
          end: /(?=\))/,
          excludeBegin: !0,
          endsParent: !0,
          keywords: h
        }
      ]
    }, _e = [
      D,
      {
        variants: [
          {
            match: [
              /class\s+/,
              e,
              /\s+<\s+/,
              e
            ]
          },
          {
            match: [
              /\b(class|module)\s+/,
              e
            ]
          }
        ],
        scope: {
          2: "title.class",
          4: "title.class.inherited"
        },
        keywords: h
      },
      {
        match: [
          /(include|extend)\s+/,
          e
        ],
        scope: {
          2: "title.class"
        },
        keywords: h
      },
      {
        relevance: 0,
        match: [
          e,
          /\.new[. (]/
        ],
        scope: {
          1: "title.class"
        }
      },
      {
        relevance: 0,
        match: /\b[A-Z][A-Z_0-9]+\b/,
        className: "variable.constant"
      },
      {
        relevance: 0,
        match: r,
        scope: "title.class"
      },
      {
        match: [
          /def/,
          /\s+/,
          c
        ],
        scope: {
          1: "keyword",
          3: "title.function"
        },
        contains: [
          Y
        ]
      },
      {
        // swallow namespace qualifiers before symbols
        begin: i.IDENT_RE + "::"
      },
      {
        className: "symbol",
        begin: i.UNDERSCORE_IDENT_RE + "(!|\\?)?:",
        relevance: 0
      },
      {
        className: "symbol",
        begin: ":(?!\\s)",
        contains: [
          D,
          { begin: c }
        ],
        relevance: 0
      },
      G,
      {
        // negative-look forward attempts to prevent false matches like:
        // @ident@ or $ident$ that might indicate this is not ruby at all
        className: "variable",
        begin: "(\\$\\W)|((\\$|@@?)(\\w+))(?=[^@$?])(?![A-Za-z])(?![@$?'])"
      },
      {
        className: "params",
        begin: /\|/,
        end: /\|/,
        excludeBegin: !0,
        excludeEnd: !0,
        relevance: 0,
        // this could be a lot of things (in other languages) other than params
        keywords: h
      },
      {
        // regexp container
        begin: "(" + i.RE_STARTERS_RE + "|unless)\\s*",
        keywords: "unless",
        contains: [
          {
            className: "regexp",
            contains: [
              i.BACKSLASH_ESCAPE,
              N
            ],
            illegal: /\n/,
            variants: [
              {
                begin: "/",
                end: "/[a-z]*"
              },
              {
                begin: /%r\{/,
                end: /\}[a-z]*/
              },
              {
                begin: "%r\\(",
                end: "\\)[a-z]*"
              },
              {
                begin: "%r!",
                end: "![a-z]*"
              },
              {
                begin: "%r\\[",
                end: "\\][a-z]*"
              }
            ]
          }
        ].concat(C, O),
        relevance: 0
      }
    ].concat(C, O);
    N.contains = _e, Y.contains = _e;
    const ye = [
      {
        begin: /^\s*=>/,
        starts: {
          end: "$",
          contains: _e
        }
      },
      {
        className: "meta.prompt",
        begin: "^(" + "[>?]>" + "|" + "[\\w#]+\\(\\w+\\):\\d+:\\d+[>*]" + "|" + "(\\w+-)?\\d+\\.\\d+\\.\\d+(p\\d+)?[^\\d][^>]+>" + ")(?=[ ])",
        starts: {
          end: "$",
          keywords: h,
          contains: _e
        }
      }
    ];
    return O.unshift(C), {
      name: "Ruby",
      aliases: [
        "rb",
        "gemspec",
        "podspec",
        "thor",
        "irb"
      ],
      keywords: h,
      illegal: /\/\*/,
      contains: [i.SHEBANG({ binary: "ruby" })].concat(ye).concat(O).concat(_e)
    };
  }
  return pu = s, pu;
}
var mu, V0;
function XM() {
  if (V0)
    return mu;
  V0 = 1;
  function s(i) {
    return {
      name: "ERB",
      subLanguage: "xml",
      contains: [
        i.COMMENT("<%#", "%>"),
        {
          begin: "<%[%=-]?",
          end: "[%-]?%>",
          subLanguage: "ruby",
          excludeBegin: !0,
          excludeEnd: !0
        }
      ]
    };
  }
  return mu = s, mu;
}
var fu, Y0;
function ZM() {
  if (Y0)
    return fu;
  Y0 = 1;
  function s(i) {
    const o = i.regex;
    return {
      name: "Erlang REPL",
      keywords: {
        built_in: "spawn spawn_link self",
        keyword: "after and andalso|10 band begin bnot bor bsl bsr bxor case catch cond div end fun if let not of or orelse|10 query receive rem try when xor"
      },
      contains: [
        {
          className: "meta.prompt",
          begin: "^[0-9]+> ",
          relevance: 10
        },
        i.COMMENT("%", "$"),
        {
          className: "number",
          begin: "\\b(\\d+(_\\d+)*#[a-fA-F0-9]+(_[a-fA-F0-9]+)*|\\d+(_\\d+)*(\\.\\d+(_\\d+)*)?([eE][-+]?\\d+)?)",
          relevance: 0
        },
        i.APOS_STRING_MODE,
        i.QUOTE_STRING_MODE,
        { begin: o.concat(
          /\?(::)?/,
          /([A-Z]\w*)/,
          // at least one identifier
          /((::)[A-Z]\w*)*/
          // perhaps more
        ) },
        { begin: "->" },
        { begin: "ok" },
        { begin: "!" },
        {
          begin: "(\\b[a-z'][a-zA-Z0-9_']*:[a-z'][a-zA-Z0-9_']*)|(\\b[a-z'][a-zA-Z0-9_']*)",
          relevance: 0
        },
        {
          begin: "[A-Z][a-zA-Z0-9_']*",
          relevance: 0
        }
      ]
    };
  }
  return fu = s, fu;
}
var gu, H0;
function jM() {
  if (H0)
    return gu;
  H0 = 1;
  function s(i) {
    const o = "[a-z'][a-zA-Z0-9_']*", c = "(" + o + ":" + o + "|" + o + ")", r = {
      keyword: "after and andalso|10 band begin bnot bor bsl bzr bxor case catch cond div end fun if let not of orelse|10 query receive rem try when xor",
      literal: "false true"
    }, e = i.COMMENT("%", "$"), g = {
      className: "number",
      begin: "\\b(\\d+(_\\d+)*#[a-fA-F0-9]+(_[a-fA-F0-9]+)*|\\d+(_\\d+)*(\\.\\d+(_\\d+)*)?([eE][-+]?\\d+)?)",
      relevance: 0
    }, h = { begin: "fun\\s+" + o + "/\\d+" }, S = {
      begin: c + "\\(",
      end: "\\)",
      returnBegin: !0,
      relevance: 0,
      contains: [
        {
          begin: c,
          relevance: 0
        },
        {
          begin: "\\(",
          end: "\\)",
          endsWithParent: !0,
          returnEnd: !0,
          relevance: 0
          // "contains" defined later
        }
      ]
    }, C = {
      begin: /\{/,
      end: /\}/,
      relevance: 0
      // "contains" defined later
    }, O = {
      begin: "\\b_([A-Z][A-Za-z0-9_]*)?",
      relevance: 0
    }, N = {
      begin: "[A-Z][a-zA-Z0-9_]*",
      relevance: 0
    }, D = {
      begin: "#" + i.UNDERSCORE_IDENT_RE,
      relevance: 0,
      returnBegin: !0,
      contains: [
        {
          begin: "#" + i.UNDERSCORE_IDENT_RE,
          relevance: 0
        },
        {
          begin: /\{/,
          end: /\}/,
          relevance: 0
          // "contains" defined later
        }
      ]
    }, x = {
      beginKeywords: "fun receive if try case",
      end: "end",
      keywords: r
    };
    x.contains = [
      e,
      h,
      i.inherit(i.APOS_STRING_MODE, { className: "" }),
      x,
      S,
      i.QUOTE_STRING_MODE,
      g,
      C,
      O,
      N,
      D
    ];
    const L = [
      e,
      h,
      x,
      S,
      i.QUOTE_STRING_MODE,
      g,
      C,
      O,
      N,
      D
    ];
    S.contains[1].contains = L, C.contains = L, D.contains[1].contains = L;
    const G = [
      "-module",
      "-record",
      "-undef",
      "-export",
      "-ifdef",
      "-ifndef",
      "-author",
      "-copyright",
      "-doc",
      "-vsn",
      "-import",
      "-include",
      "-include_lib",
      "-compile",
      "-define",
      "-else",
      "-endif",
      "-file",
      "-behaviour",
      "-behavior",
      "-spec"
    ], Y = {
      className: "params",
      begin: "\\(",
      end: "\\)",
      contains: L
    };
    return {
      name: "Erlang",
      aliases: ["erl"],
      keywords: r,
      illegal: "(</|\\*=|\\+=|-=|/\\*|\\*/|\\(\\*|\\*\\))",
      contains: [
        {
          className: "function",
          begin: "^" + o + "\\s*\\(",
          end: "->",
          returnBegin: !0,
          illegal: "\\(|#|//|/\\*|\\\\|:|;",
          contains: [
            Y,
            i.inherit(i.TITLE_MODE, { begin: o })
          ],
          starts: {
            end: ";|\\.",
            keywords: r,
            contains: L
          }
        },
        e,
        {
          begin: "^-",
          end: "\\.",
          relevance: 0,
          excludeEnd: !0,
          returnBegin: !0,
          keywords: {
            $pattern: "-" + i.IDENT_RE,
            keyword: G.map((k) => `${k}|1.5`).join(" ")
          },
          contains: [Y]
        },
        g,
        i.QUOTE_STRING_MODE,
        D,
        O,
        N,
        C,
        { begin: /\.$/ }
        // relevance booster
      ]
    };
  }
  return gu = s, gu;
}
var Eu, q0;
function JM() {
  if (q0)
    return Eu;
  q0 = 1;
  function s(i) {
    return {
      name: "Excel formulae",
      aliases: [
        "xlsx",
        "xls"
      ],
      case_insensitive: !0,
      keywords: {
        $pattern: /[a-zA-Z][\w\.]*/,
        built_in: [
          "ABS",
          "ACCRINT",
          "ACCRINTM",
          "ACOS",
          "ACOSH",
          "ACOT",
          "ACOTH",
          "AGGREGATE",
          "ADDRESS",
          "AMORDEGRC",
          "AMORLINC",
          "AND",
          "ARABIC",
          "AREAS",
          "ASC",
          "ASIN",
          "ASINH",
          "ATAN",
          "ATAN2",
          "ATANH",
          "AVEDEV",
          "AVERAGE",
          "AVERAGEA",
          "AVERAGEIF",
          "AVERAGEIFS",
          "BAHTTEXT",
          "BASE",
          "BESSELI",
          "BESSELJ",
          "BESSELK",
          "BESSELY",
          "BETADIST",
          "BETA.DIST",
          "BETAINV",
          "BETA.INV",
          "BIN2DEC",
          "BIN2HEX",
          "BIN2OCT",
          "BINOMDIST",
          "BINOM.DIST",
          "BINOM.DIST.RANGE",
          "BINOM.INV",
          "BITAND",
          "BITLSHIFT",
          "BITOR",
          "BITRSHIFT",
          "BITXOR",
          "CALL",
          "CEILING",
          "CEILING.MATH",
          "CEILING.PRECISE",
          "CELL",
          "CHAR",
          "CHIDIST",
          "CHIINV",
          "CHITEST",
          "CHISQ.DIST",
          "CHISQ.DIST.RT",
          "CHISQ.INV",
          "CHISQ.INV.RT",
          "CHISQ.TEST",
          "CHOOSE",
          "CLEAN",
          "CODE",
          "COLUMN",
          "COLUMNS",
          "COMBIN",
          "COMBINA",
          "COMPLEX",
          "CONCAT",
          "CONCATENATE",
          "CONFIDENCE",
          "CONFIDENCE.NORM",
          "CONFIDENCE.T",
          "CONVERT",
          "CORREL",
          "COS",
          "COSH",
          "COT",
          "COTH",
          "COUNT",
          "COUNTA",
          "COUNTBLANK",
          "COUNTIF",
          "COUNTIFS",
          "COUPDAYBS",
          "COUPDAYS",
          "COUPDAYSNC",
          "COUPNCD",
          "COUPNUM",
          "COUPPCD",
          "COVAR",
          "COVARIANCE.P",
          "COVARIANCE.S",
          "CRITBINOM",
          "CSC",
          "CSCH",
          "CUBEKPIMEMBER",
          "CUBEMEMBER",
          "CUBEMEMBERPROPERTY",
          "CUBERANKEDMEMBER",
          "CUBESET",
          "CUBESETCOUNT",
          "CUBEVALUE",
          "CUMIPMT",
          "CUMPRINC",
          "DATE",
          "DATEDIF",
          "DATEVALUE",
          "DAVERAGE",
          "DAY",
          "DAYS",
          "DAYS360",
          "DB",
          "DBCS",
          "DCOUNT",
          "DCOUNTA",
          "DDB",
          "DEC2BIN",
          "DEC2HEX",
          "DEC2OCT",
          "DECIMAL",
          "DEGREES",
          "DELTA",
          "DEVSQ",
          "DGET",
          "DISC",
          "DMAX",
          "DMIN",
          "DOLLAR",
          "DOLLARDE",
          "DOLLARFR",
          "DPRODUCT",
          "DSTDEV",
          "DSTDEVP",
          "DSUM",
          "DURATION",
          "DVAR",
          "DVARP",
          "EDATE",
          "EFFECT",
          "ENCODEURL",
          "EOMONTH",
          "ERF",
          "ERF.PRECISE",
          "ERFC",
          "ERFC.PRECISE",
          "ERROR.TYPE",
          "EUROCONVERT",
          "EVEN",
          "EXACT",
          "EXP",
          "EXPON.DIST",
          "EXPONDIST",
          "FACT",
          "FACTDOUBLE",
          "FALSE|0",
          "F.DIST",
          "FDIST",
          "F.DIST.RT",
          "FILTERXML",
          "FIND",
          "FINDB",
          "F.INV",
          "F.INV.RT",
          "FINV",
          "FISHER",
          "FISHERINV",
          "FIXED",
          "FLOOR",
          "FLOOR.MATH",
          "FLOOR.PRECISE",
          "FORECAST",
          "FORECAST.ETS",
          "FORECAST.ETS.CONFINT",
          "FORECAST.ETS.SEASONALITY",
          "FORECAST.ETS.STAT",
          "FORECAST.LINEAR",
          "FORMULATEXT",
          "FREQUENCY",
          "F.TEST",
          "FTEST",
          "FV",
          "FVSCHEDULE",
          "GAMMA",
          "GAMMA.DIST",
          "GAMMADIST",
          "GAMMA.INV",
          "GAMMAINV",
          "GAMMALN",
          "GAMMALN.PRECISE",
          "GAUSS",
          "GCD",
          "GEOMEAN",
          "GESTEP",
          "GETPIVOTDATA",
          "GROWTH",
          "HARMEAN",
          "HEX2BIN",
          "HEX2DEC",
          "HEX2OCT",
          "HLOOKUP",
          "HOUR",
          "HYPERLINK",
          "HYPGEOM.DIST",
          "HYPGEOMDIST",
          "IF",
          "IFERROR",
          "IFNA",
          "IFS",
          "IMABS",
          "IMAGINARY",
          "IMARGUMENT",
          "IMCONJUGATE",
          "IMCOS",
          "IMCOSH",
          "IMCOT",
          "IMCSC",
          "IMCSCH",
          "IMDIV",
          "IMEXP",
          "IMLN",
          "IMLOG10",
          "IMLOG2",
          "IMPOWER",
          "IMPRODUCT",
          "IMREAL",
          "IMSEC",
          "IMSECH",
          "IMSIN",
          "IMSINH",
          "IMSQRT",
          "IMSUB",
          "IMSUM",
          "IMTAN",
          "INDEX",
          "INDIRECT",
          "INFO",
          "INT",
          "INTERCEPT",
          "INTRATE",
          "IPMT",
          "IRR",
          "ISBLANK",
          "ISERR",
          "ISERROR",
          "ISEVEN",
          "ISFORMULA",
          "ISLOGICAL",
          "ISNA",
          "ISNONTEXT",
          "ISNUMBER",
          "ISODD",
          "ISREF",
          "ISTEXT",
          "ISO.CEILING",
          "ISOWEEKNUM",
          "ISPMT",
          "JIS",
          "KURT",
          "LARGE",
          "LCM",
          "LEFT",
          "LEFTB",
          "LEN",
          "LENB",
          "LINEST",
          "LN",
          "LOG",
          "LOG10",
          "LOGEST",
          "LOGINV",
          "LOGNORM.DIST",
          "LOGNORMDIST",
          "LOGNORM.INV",
          "LOOKUP",
          "LOWER",
          "MATCH",
          "MAX",
          "MAXA",
          "MAXIFS",
          "MDETERM",
          "MDURATION",
          "MEDIAN",
          "MID",
          "MIDBs",
          "MIN",
          "MINIFS",
          "MINA",
          "MINUTE",
          "MINVERSE",
          "MIRR",
          "MMULT",
          "MOD",
          "MODE",
          "MODE.MULT",
          "MODE.SNGL",
          "MONTH",
          "MROUND",
          "MULTINOMIAL",
          "MUNIT",
          "N",
          "NA",
          "NEGBINOM.DIST",
          "NEGBINOMDIST",
          "NETWORKDAYS",
          "NETWORKDAYS.INTL",
          "NOMINAL",
          "NORM.DIST",
          "NORMDIST",
          "NORMINV",
          "NORM.INV",
          "NORM.S.DIST",
          "NORMSDIST",
          "NORM.S.INV",
          "NORMSINV",
          "NOT",
          "NOW",
          "NPER",
          "NPV",
          "NUMBERVALUE",
          "OCT2BIN",
          "OCT2DEC",
          "OCT2HEX",
          "ODD",
          "ODDFPRICE",
          "ODDFYIELD",
          "ODDLPRICE",
          "ODDLYIELD",
          "OFFSET",
          "OR",
          "PDURATION",
          "PEARSON",
          "PERCENTILE.EXC",
          "PERCENTILE.INC",
          "PERCENTILE",
          "PERCENTRANK.EXC",
          "PERCENTRANK.INC",
          "PERCENTRANK",
          "PERMUT",
          "PERMUTATIONA",
          "PHI",
          "PHONETIC",
          "PI",
          "PMT",
          "POISSON.DIST",
          "POISSON",
          "POWER",
          "PPMT",
          "PRICE",
          "PRICEDISC",
          "PRICEMAT",
          "PROB",
          "PRODUCT",
          "PROPER",
          "PV",
          "QUARTILE",
          "QUARTILE.EXC",
          "QUARTILE.INC",
          "QUOTIENT",
          "RADIANS",
          "RAND",
          "RANDBETWEEN",
          "RANK.AVG",
          "RANK.EQ",
          "RANK",
          "RATE",
          "RECEIVED",
          "REGISTER.ID",
          "REPLACE",
          "REPLACEB",
          "REPT",
          "RIGHT",
          "RIGHTB",
          "ROMAN",
          "ROUND",
          "ROUNDDOWN",
          "ROUNDUP",
          "ROW",
          "ROWS",
          "RRI",
          "RSQ",
          "RTD",
          "SEARCH",
          "SEARCHB",
          "SEC",
          "SECH",
          "SECOND",
          "SERIESSUM",
          "SHEET",
          "SHEETS",
          "SIGN",
          "SIN",
          "SINH",
          "SKEW",
          "SKEW.P",
          "SLN",
          "SLOPE",
          "SMALL",
          "SQL.REQUEST",
          "SQRT",
          "SQRTPI",
          "STANDARDIZE",
          "STDEV",
          "STDEV.P",
          "STDEV.S",
          "STDEVA",
          "STDEVP",
          "STDEVPA",
          "STEYX",
          "SUBSTITUTE",
          "SUBTOTAL",
          "SUM",
          "SUMIF",
          "SUMIFS",
          "SUMPRODUCT",
          "SUMSQ",
          "SUMX2MY2",
          "SUMX2PY2",
          "SUMXMY2",
          "SWITCH",
          "SYD",
          "T",
          "TAN",
          "TANH",
          "TBILLEQ",
          "TBILLPRICE",
          "TBILLYIELD",
          "T.DIST",
          "T.DIST.2T",
          "T.DIST.RT",
          "TDIST",
          "TEXT",
          "TEXTJOIN",
          "TIME",
          "TIMEVALUE",
          "T.INV",
          "T.INV.2T",
          "TINV",
          "TODAY",
          "TRANSPOSE",
          "TREND",
          "TRIM",
          "TRIMMEAN",
          "TRUE|0",
          "TRUNC",
          "T.TEST",
          "TTEST",
          "TYPE",
          "UNICHAR",
          "UNICODE",
          "UPPER",
          "VALUE",
          "VAR",
          "VAR.P",
          "VAR.S",
          "VARA",
          "VARP",
          "VARPA",
          "VDB",
          "VLOOKUP",
          "WEBSERVICE",
          "WEEKDAY",
          "WEEKNUM",
          "WEIBULL",
          "WEIBULL.DIST",
          "WORKDAY",
          "WORKDAY.INTL",
          "XIRR",
          "XNPV",
          "XOR",
          "YEAR",
          "YEARFRAC",
          "YIELD",
          "YIELDDISC",
          "YIELDMAT",
          "Z.TEST",
          "ZTEST"
        ]
      },
      contains: [
        {
          /* matches a beginning equal sign found in Excel formula examples */
          begin: /^=/,
          end: /[^=]/,
          returnEnd: !0,
          illegal: /=/,
          /* only allow single equal sign at front of line */
          relevance: 10
        },
        /* technically, there can be more than 2 letters in column names, but this prevents conflict with some keywords */
        {
          /* matches a reference to a single cell */
          className: "symbol",
          begin: /\b[A-Z]{1,2}\d+\b/,
          end: /[^\d]/,
          excludeEnd: !0,
          relevance: 0
        },
        {
          /* matches a reference to a range of cells */
          className: "symbol",
          begin: /[A-Z]{0,2}\d*:[A-Z]{0,2}\d*/,
          relevance: 0
        },
        i.BACKSLASH_ESCAPE,
        i.QUOTE_STRING_MODE,
        {
          className: "number",
          begin: i.NUMBER_RE + "(%)?",
          relevance: 0
        },
        /* Excel formula comments are done by putting the comment in a function call to N() */
        i.COMMENT(
          /\bN\(/,
          /\)/,
          {
            excludeBegin: !0,
            excludeEnd: !0,
            illegal: /\n/
          }
        )
      ]
    };
  }
  return Eu = s, Eu;
}
var hu, $0;
function eP() {
  if ($0)
    return hu;
  $0 = 1;
  function s(i) {
    return {
      name: "FIX",
      contains: [
        {
          begin: /[^\u2401\u0001]+/,
          end: /[\u2401\u0001]/,
          excludeEnd: !0,
          returnBegin: !0,
          returnEnd: !1,
          contains: [
            {
              begin: /([^\u2401\u0001=]+)/,
              end: /=([^\u2401\u0001=]+)/,
              returnEnd: !0,
              returnBegin: !1,
              className: "attr"
            },
            {
              begin: /=/,
              end: /([\u2401\u0001])/,
              excludeEnd: !0,
              excludeBegin: !0,
              className: "string"
            }
          ]
        }
      ],
      case_insensitive: !0
    };
  }
  return hu = s, hu;
}
var Su, W0;
function tP() {
  if (W0)
    return Su;
  W0 = 1;
  function s(i) {
    const o = {
      className: "string",
      begin: /'(.|\\[xXuU][a-zA-Z0-9]+)'/
    }, c = {
      className: "string",
      variants: [
        {
          begin: '"',
          end: '"'
        }
      ]
    }, e = {
      className: "function",
      beginKeywords: "def",
      end: /[:={\[(\n;]/,
      excludeEnd: !0,
      contains: [{
        className: "title",
        relevance: 0,
        begin: /[^0-9\n\t "'(),.`{}\[\]:;][^\n\t "'(),.`{}\[\]:;]+|[^0-9\n\t "'(),.`{}\[\]:;=]/
      }]
    };
    return {
      name: "Flix",
      keywords: {
        keyword: [
          "case",
          "class",
          "def",
          "else",
          "enum",
          "if",
          "impl",
          "import",
          "in",
          "lat",
          "rel",
          "index",
          "let",
          "match",
          "namespace",
          "switch",
          "type",
          "yield",
          "with"
        ],
        literal: [
          "true",
          "false"
        ]
      },
      contains: [
        i.C_LINE_COMMENT_MODE,
        i.C_BLOCK_COMMENT_MODE,
        o,
        c,
        e,
        i.C_NUMBER_MODE
      ]
    };
  }
  return Su = s, Su;
}
var bu, z0;
function rP() {
  if (z0)
    return bu;
  z0 = 1;
  function s(i) {
    const o = i.regex, c = {
      className: "params",
      begin: "\\(",
      end: "\\)"
    }, r = { variants: [
      i.COMMENT("!", "$", { relevance: 0 }),
      // allow FORTRAN 77 style comments
      i.COMMENT("^C[ ]", "$", { relevance: 0 }),
      i.COMMENT("^C$", "$", { relevance: 0 })
    ] }, e = /(_[a-z_\d]+)?/, g = /([de][+-]?\d+)?/, h = {
      className: "number",
      variants: [
        { begin: o.concat(/\b\d+/, /\.(\d*)/, g, e) },
        { begin: o.concat(/\b\d+/, g, e) },
        { begin: o.concat(/\.\d+/, g, e) }
      ],
      relevance: 0
    }, S = {
      className: "function",
      beginKeywords: "subroutine function program",
      illegal: "[${=\\n]",
      contains: [
        i.UNDERSCORE_TITLE_MODE,
        c
      ]
    }, C = {
      className: "string",
      relevance: 0,
      variants: [
        i.APOS_STRING_MODE,
        i.QUOTE_STRING_MODE
      ]
    };
    return {
      name: "Fortran",
      case_insensitive: !0,
      aliases: [
        "f90",
        "f95"
      ],
      keywords: {
        keyword: [
          "kind",
          "do",
          "concurrent",
          "local",
          "shared",
          "while",
          "private",
          "call",
          "intrinsic",
          "where",
          "elsewhere",
          "type",
          "endtype",
          "endmodule",
          "endselect",
          "endinterface",
          "end",
          "enddo",
          "endif",
          "if",
          "forall",
          "endforall",
          "only",
          "contains",
          "default",
          "return",
          "stop",
          "then",
          "block",
          "endblock",
          "endassociate",
          "public",
          "subroutine|10",
          "function",
          "program",
          ".and.",
          ".or.",
          ".not.",
          ".le.",
          ".eq.",
          ".ge.",
          ".gt.",
          ".lt.",
          "goto",
          "save",
          "else",
          "use",
          "module",
          "select",
          "case",
          "access",
          "blank",
          "direct",
          "exist",
          "file",
          "fmt",
          "form",
          "formatted",
          "iostat",
          "name",
          "named",
          "nextrec",
          "number",
          "opened",
          "rec",
          "recl",
          "sequential",
          "status",
          "unformatted",
          "unit",
          "continue",
          "format",
          "pause",
          "cycle",
          "exit",
          "c_null_char",
          "c_alert",
          "c_backspace",
          "c_form_feed",
          "flush",
          "wait",
          "decimal",
          "round",
          "iomsg",
          "synchronous",
          "nopass",
          "non_overridable",
          "pass",
          "protected",
          "volatile",
          "abstract",
          "extends",
          "import",
          "non_intrinsic",
          "value",
          "deferred",
          "generic",
          "final",
          "enumerator",
          "class",
          "associate",
          "bind",
          "enum",
          "c_int",
          "c_short",
          "c_long",
          "c_long_long",
          "c_signed_char",
          "c_size_t",
          "c_int8_t",
          "c_int16_t",
          "c_int32_t",
          "c_int64_t",
          "c_int_least8_t",
          "c_int_least16_t",
          "c_int_least32_t",
          "c_int_least64_t",
          "c_int_fast8_t",
          "c_int_fast16_t",
          "c_int_fast32_t",
          "c_int_fast64_t",
          "c_intmax_t",
          "C_intptr_t",
          "c_float",
          "c_double",
          "c_long_double",
          "c_float_complex",
          "c_double_complex",
          "c_long_double_complex",
          "c_bool",
          "c_char",
          "c_null_ptr",
          "c_null_funptr",
          "c_new_line",
          "c_carriage_return",
          "c_horizontal_tab",
          "c_vertical_tab",
          "iso_c_binding",
          "c_loc",
          "c_funloc",
          "c_associated",
          "c_f_pointer",
          "c_ptr",
          "c_funptr",
          "iso_fortran_env",
          "character_storage_size",
          "error_unit",
          "file_storage_size",
          "input_unit",
          "iostat_end",
          "iostat_eor",
          "numeric_storage_size",
          "output_unit",
          "c_f_procpointer",
          "ieee_arithmetic",
          "ieee_support_underflow_control",
          "ieee_get_underflow_mode",
          "ieee_set_underflow_mode",
          "newunit",
          "contiguous",
          "recursive",
          "pad",
          "position",
          "action",
          "delim",
          "readwrite",
          "eor",
          "advance",
          "nml",
          "interface",
          "procedure",
          "namelist",
          "include",
          "sequence",
          "elemental",
          "pure",
          "impure",
          "integer",
          "real",
          "character",
          "complex",
          "logical",
          "codimension",
          "dimension",
          "allocatable|10",
          "parameter",
          "external",
          "implicit|10",
          "none",
          "double",
          "precision",
          "assign",
          "intent",
          "optional",
          "pointer",
          "target",
          "in",
          "out",
          "common",
          "equivalence",
          "data"
        ],
        literal: [
          ".False.",
          ".True."
        ],
        built_in: [
          "alog",
          "alog10",
          "amax0",
          "amax1",
          "amin0",
          "amin1",
          "amod",
          "cabs",
          "ccos",
          "cexp",
          "clog",
          "csin",
          "csqrt",
          "dabs",
          "dacos",
          "dasin",
          "datan",
          "datan2",
          "dcos",
          "dcosh",
          "ddim",
          "dexp",
          "dint",
          "dlog",
          "dlog10",
          "dmax1",
          "dmin1",
          "dmod",
          "dnint",
          "dsign",
          "dsin",
          "dsinh",
          "dsqrt",
          "dtan",
          "dtanh",
          "float",
          "iabs",
          "idim",
          "idint",
          "idnint",
          "ifix",
          "isign",
          "max0",
          "max1",
          "min0",
          "min1",
          "sngl",
          "algama",
          "cdabs",
          "cdcos",
          "cdexp",
          "cdlog",
          "cdsin",
          "cdsqrt",
          "cqabs",
          "cqcos",
          "cqexp",
          "cqlog",
          "cqsin",
          "cqsqrt",
          "dcmplx",
          "dconjg",
          "derf",
          "derfc",
          "dfloat",
          "dgamma",
          "dimag",
          "dlgama",
          "iqint",
          "qabs",
          "qacos",
          "qasin",
          "qatan",
          "qatan2",
          "qcmplx",
          "qconjg",
          "qcos",
          "qcosh",
          "qdim",
          "qerf",
          "qerfc",
          "qexp",
          "qgamma",
          "qimag",
          "qlgama",
          "qlog",
          "qlog10",
          "qmax1",
          "qmin1",
          "qmod",
          "qnint",
          "qsign",
          "qsin",
          "qsinh",
          "qsqrt",
          "qtan",
          "qtanh",
          "abs",
          "acos",
          "aimag",
          "aint",
          "anint",
          "asin",
          "atan",
          "atan2",
          "char",
          "cmplx",
          "conjg",
          "cos",
          "cosh",
          "exp",
          "ichar",
          "index",
          "int",
          "log",
          "log10",
          "max",
          "min",
          "nint",
          "sign",
          "sin",
          "sinh",
          "sqrt",
          "tan",
          "tanh",
          "print",
          "write",
          "dim",
          "lge",
          "lgt",
          "lle",
          "llt",
          "mod",
          "nullify",
          "allocate",
          "deallocate",
          "adjustl",
          "adjustr",
          "all",
          "allocated",
          "any",
          "associated",
          "bit_size",
          "btest",
          "ceiling",
          "count",
          "cshift",
          "date_and_time",
          "digits",
          "dot_product",
          "eoshift",
          "epsilon",
          "exponent",
          "floor",
          "fraction",
          "huge",
          "iand",
          "ibclr",
          "ibits",
          "ibset",
          "ieor",
          "ior",
          "ishft",
          "ishftc",
          "lbound",
          "len_trim",
          "matmul",
          "maxexponent",
          "maxloc",
          "maxval",
          "merge",
          "minexponent",
          "minloc",
          "minval",
          "modulo",
          "mvbits",
          "nearest",
          "pack",
          "present",
          "product",
          "radix",
          "random_number",
          "random_seed",
          "range",
          "repeat",
          "reshape",
          "rrspacing",
          "scale",
          "scan",
          "selected_int_kind",
          "selected_real_kind",
          "set_exponent",
          "shape",
          "size",
          "spacing",
          "spread",
          "sum",
          "system_clock",
          "tiny",
          "transpose",
          "trim",
          "ubound",
          "unpack",
          "verify",
          "achar",
          "iachar",
          "transfer",
          "dble",
          "entry",
          "dprod",
          "cpu_time",
          "command_argument_count",
          "get_command",
          "get_command_argument",
          "get_environment_variable",
          "is_iostat_end",
          "ieee_arithmetic",
          "ieee_support_underflow_control",
          "ieee_get_underflow_mode",
          "ieee_set_underflow_mode",
          "is_iostat_eor",
          "move_alloc",
          "new_line",
          "selected_char_kind",
          "same_type_as",
          "extends_type_of",
          "acosh",
          "asinh",
          "atanh",
          "bessel_j0",
          "bessel_j1",
          "bessel_jn",
          "bessel_y0",
          "bessel_y1",
          "bessel_yn",
          "erf",
          "erfc",
          "erfc_scaled",
          "gamma",
          "log_gamma",
          "hypot",
          "norm2",
          "atomic_define",
          "atomic_ref",
          "execute_command_line",
          "leadz",
          "trailz",
          "storage_size",
          "merge_bits",
          "bge",
          "bgt",
          "ble",
          "blt",
          "dshiftl",
          "dshiftr",
          "findloc",
          "iall",
          "iany",
          "iparity",
          "image_index",
          "lcobound",
          "ucobound",
          "maskl",
          "maskr",
          "num_images",
          "parity",
          "popcnt",
          "poppar",
          "shifta",
          "shiftl",
          "shiftr",
          "this_image",
          "sync",
          "change",
          "team",
          "co_broadcast",
          "co_max",
          "co_min",
          "co_sum",
          "co_reduce"
        ]
      },
      illegal: /\/\*/,
      contains: [
        C,
        S,
        // allow `C = value` for assignments so they aren't misdetected
        // as Fortran 77 style comments
        {
          begin: /^C\s*=(?!=)/,
          relevance: 0
        },
        r,
        h
      ]
    };
  }
  return bu = s, bu;
}
var Tu, K0;
function nP() {
  if (K0)
    return Tu;
  K0 = 1;
  function s(h) {
    return new RegExp(h.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&"), "m");
  }
  function i(h) {
    return h ? typeof h == "string" ? h : h.source : null;
  }
  function o(h) {
    return c("(?=", h, ")");
  }
  function c(...h) {
    return h.map((C) => i(C)).join("");
  }
  function r(h) {
    const S = h[h.length - 1];
    return typeof S == "object" && S.constructor === Object ? (h.splice(h.length - 1, 1), S) : {};
  }
  function e(...h) {
    return "(" + (r(h).capture ? "" : "?:") + h.map((O) => i(O)).join("|") + ")";
  }
  function g(h) {
    const S = [
      "abstract",
      "and",
      "as",
      "assert",
      "base",
      "begin",
      "class",
      "default",
      "delegate",
      "do",
      "done",
      "downcast",
      "downto",
      "elif",
      "else",
      "end",
      "exception",
      "extern",
      // "false", // literal
      "finally",
      "fixed",
      "for",
      "fun",
      "function",
      "global",
      "if",
      "in",
      "inherit",
      "inline",
      "interface",
      "internal",
      "lazy",
      "let",
      "match",
      "member",
      "module",
      "mutable",
      "namespace",
      "new",
      // "not", // built_in
      // "null", // literal
      "of",
      "open",
      "or",
      "override",
      "private",
      "public",
      "rec",
      "return",
      "static",
      "struct",
      "then",
      "to",
      // "true", // literal
      "try",
      "type",
      "upcast",
      "use",
      "val",
      "void",
      "when",
      "while",
      "with",
      "yield"
    ], C = {
      // monad builder keywords (matches before non-bang keywords)
      scope: "keyword",
      match: /\b(yield|return|let|do|match|use)!/
    }, O = [
      "if",
      "else",
      "endif",
      "line",
      "nowarn",
      "light",
      "r",
      "i",
      "I",
      "load",
      "time",
      "help",
      "quit"
    ], N = [
      "true",
      "false",
      "null",
      "Some",
      "None",
      "Ok",
      "Error",
      "infinity",
      "infinityf",
      "nan",
      "nanf"
    ], D = [
      "__LINE__",
      "__SOURCE_DIRECTORY__",
      "__SOURCE_FILE__"
    ], x = [
      // basic types
      "bool",
      "byte",
      "sbyte",
      "int8",
      "int16",
      "int32",
      "uint8",
      "uint16",
      "uint32",
      "int",
      "uint",
      "int64",
      "uint64",
      "nativeint",
      "unativeint",
      "decimal",
      "float",
      "double",
      "float32",
      "single",
      "char",
      "string",
      "unit",
      "bigint",
      // other native types or lowercase aliases
      "option",
      "voption",
      "list",
      "array",
      "seq",
      "byref",
      "exn",
      "inref",
      "nativeptr",
      "obj",
      "outref",
      "voidptr",
      // other important FSharp types
      "Result"
    ], G = {
      keyword: S,
      literal: N,
      built_in: [
        // Somewhat arbitrary list of builtin functions and values.
        // Most of them are declared in Microsoft.FSharp.Core
        // I tried to stay relevant by adding only the most idiomatic
        // and most used symbols that are not already declared as types.
        "not",
        "ref",
        "raise",
        "reraise",
        "dict",
        "readOnlyDict",
        "set",
        "get",
        "enum",
        "sizeof",
        "typeof",
        "typedefof",
        "nameof",
        "nullArg",
        "invalidArg",
        "invalidOp",
        "id",
        "fst",
        "snd",
        "ignore",
        "lock",
        "using",
        "box",
        "unbox",
        "tryUnbox",
        "printf",
        "printfn",
        "sprintf",
        "eprintf",
        "eprintfn",
        "fprintf",
        "fprintfn",
        "failwith",
        "failwithf"
      ],
      "variable.constant": D
    }, k = {
      variants: [
        h.COMMENT(/\(\*(?!\))/, /\*\)/, {
          contains: ["self"]
        }),
        h.C_LINE_COMMENT_MODE
      ]
    }, W = /[a-zA-Z_](\w|')*/, Z = {
      scope: "variable",
      begin: /``/,
      end: /``/
    }, H = /\B('|\^)/, K = {
      scope: "symbol",
      variants: [
        // the type name is a quoted identifier:
        { match: c(H, /``.*?``/) },
        // the type name is a normal identifier (we don't use IDENTIFIER_RE because there cannot be another apostrophe here):
        { match: c(H, h.UNDERSCORE_IDENT_RE) }
      ],
      relevance: 0
    }, Q = function({ includeEqual: ae }) {
      let Ee;
      ae ? Ee = "!%&*+-/<=>@^|~?" : Ee = "!%&*+-/<>@^|~?";
      const ne = Array.from(Ee), Ge = c("[", ...ne.map(s), "]"), we = e(Ge, /\./), st = c(we, o(we)), Rt = e(
        c(st, we, "*"),
        // Matches at least 2 chars operators
        c(Ge, "+")
        // Matches at least one char operators
      );
      return {
        scope: "operator",
        match: e(
          // symbolic operators:
          Rt,
          // other symbolic keywords:
          // Type casting and conversion operators:
          /:\?>/,
          /:\?/,
          /:>/,
          /:=/,
          // Reference cell assignment
          /::?/,
          // : or ::
          /\$/
        ),
        // A single $ can be used as an operator
        relevance: 0
      };
    }, _e = Q({ includeEqual: !0 }), se = Q({ includeEqual: !1 }), Pe = function(ae, Ee) {
      return {
        begin: c(
          // a type annotation is a
          ae,
          // should be a colon or the 'of' keyword
          o(
            // that has to be followed by
            c(
              /\s*/,
              // optional space
              e(
                // then either of:
                /\w/,
                // word
                /'/,
                // generic type name
                /\^/,
                // generic type name
                /#/,
                // flexible type name
                /``/,
                // quoted type name
                /\(/,
                // parens type expression
                /{\|/
                // anonymous type annotation
              )
            )
          )
        ),
        beginScope: Ee,
        // BUG: because ending with \n is necessary for some cases, multi-line type annotations are not properly supported.
        // Examples where \n is required at the end:
        // - abstract member definitions in classes: abstract Property : int * string
        // - return type annotations: let f f' = f' () : returnTypeAnnotation
        // - record fields definitions: { A : int \n B : string }
        end: o(
          e(
            /\n/,
            /=/
          )
        ),
        relevance: 0,
        // we need the known types, and we need the type constraint keywords and literals. e.g.: when 'a : null
        keywords: h.inherit(G, { type: x }),
        contains: [
          k,
          K,
          h.inherit(Z, { scope: null }),
          // match to avoid strange patterns inside that may break the parsing
          se
        ]
      };
    }, Ke = Pe(/:/, "operator"), ye = Pe(/\bof\b/, "keyword"), Je = {
      begin: [
        /(^|\s+)/,
        // prevents matching the following: `match s.stype with`
        /type/,
        /\s+/,
        W
      ],
      beginScope: {
        2: "keyword",
        4: "title.class"
      },
      end: o(/\(|=|$/),
      keywords: G,
      // match keywords in type constraints. e.g.: when 'a : null
      contains: [
        k,
        h.inherit(Z, { scope: null }),
        // match to avoid strange patterns inside that may break the parsing
        K,
        {
          // For visual consistency, highlight type brackets as operators.
          scope: "operator",
          match: /<|>/
        },
        Ke
        // generic types can have constraints, which are type annotations. e.g. type MyType<'T when 'T : delegate<obj * string>> =
      ]
    }, mt = {
      // computation expressions:
      scope: "computation-expression",
      // BUG: might conflict with record deconstruction. e.g. let f { Name = name } = name // will highlight f
      match: /\b[_a-z]\w*(?=\s*\{)/
    }, ge = {
      // preprocessor directives and fsi commands:
      begin: [
        /^\s*/,
        c(/#/, e(...O)),
        /\b/
      ],
      beginScope: { 2: "meta" },
      end: o(/\s|$/)
    }, w = {
      variants: [
        h.BINARY_NUMBER_MODE,
        h.C_NUMBER_MODE
      ]
    }, fe = {
      scope: "string",
      begin: /"/,
      end: /"/,
      contains: [
        h.BACKSLASH_ESCAPE
      ]
    }, j = {
      scope: "string",
      begin: /@"/,
      end: /"/,
      contains: [
        {
          match: /""/
          // escaped "
        },
        h.BACKSLASH_ESCAPE
      ]
    }, J = {
      scope: "string",
      begin: /"""/,
      end: /"""/,
      relevance: 2
    }, de = {
      scope: "subst",
      begin: /\{/,
      end: /\}/,
      keywords: G
    }, ie = {
      scope: "string",
      begin: /\$"/,
      end: /"/,
      contains: [
        {
          match: /\{\{/
          // escaped {
        },
        {
          match: /\}\}/
          // escaped }
        },
        h.BACKSLASH_ESCAPE,
        de
      ]
    }, X = {
      scope: "string",
      begin: /(\$@|@\$)"/,
      end: /"/,
      contains: [
        {
          match: /\{\{/
          // escaped {
        },
        {
          match: /\}\}/
          // escaped }
        },
        {
          match: /""/
        },
        h.BACKSLASH_ESCAPE,
        de
      ]
    }, ue = {
      scope: "string",
      begin: /\$"""/,
      end: /"""/,
      contains: [
        {
          match: /\{\{/
          // escaped {
        },
        {
          match: /\}\}/
          // escaped }
        },
        de
      ],
      relevance: 2
    }, Oe = {
      scope: "string",
      match: c(
        /'/,
        e(
          /[^\\']/,
          // either a single non escaped char...
          /\\(?:.|\d{3}|x[a-fA-F\d]{2}|u[a-fA-F\d]{4}|U[a-fA-F\d]{8})/
          // ...or an escape sequence
        ),
        /'/
      )
    };
    return de.contains = [
      X,
      ie,
      j,
      fe,
      Oe,
      C,
      k,
      Z,
      Ke,
      mt,
      ge,
      w,
      K,
      _e
    ], {
      name: "F#",
      aliases: [
        "fs",
        "f#"
      ],
      keywords: G,
      illegal: /\/\*/,
      classNameAliases: {
        "computation-expression": "keyword"
      },
      contains: [
        C,
        {
          variants: [
            ue,
            X,
            ie,
            J,
            j,
            fe,
            Oe
          ]
        },
        k,
        Z,
        Je,
        {
          // e.g. [<Attributes("")>] or [<``module``: MyCustomAttributeThatWorksOnModules>]
          // or [<Sealed; NoEquality; NoComparison; CompiledName("FSharpAsync`1")>]
          scope: "meta",
          begin: /\[</,
          end: />\]/,
          relevance: 2,
          contains: [
            Z,
            // can contain any constant value
            J,
            j,
            fe,
            Oe,
            w
          ]
        },
        ye,
        Ke,
        mt,
        ge,
        w,
        K,
        _e
      ]
    };
  }
  return Tu = g, Tu;
}
var vu, Q0;
function aP() {
  if (Q0)
    return vu;
  Q0 = 1;
  function s(i) {
    const o = i.regex, c = {
      keyword: "abort acronym acronyms alias all and assign binary card diag display else eq file files for free ge gt if integer le loop lt maximizing minimizing model models ne negative no not option options or ord positive prod put putpage puttl repeat sameas semicont semiint smax smin solve sos1 sos2 sum system table then until using while xor yes",
      literal: "eps inf na",
      built_in: "abs arccos arcsin arctan arctan2 Beta betaReg binomial ceil centropy cos cosh cvPower div div0 eDist entropy errorf execSeed exp fact floor frac gamma gammaReg log logBeta logGamma log10 log2 mapVal max min mod ncpCM ncpF ncpVUpow ncpVUsin normal pi poly power randBinomial randLinear randTriangle round rPower sigmoid sign signPower sin sinh slexp sllog10 slrec sqexp sqlog10 sqr sqrec sqrt tan tanh trunc uniform uniformInt vcPower bool_and bool_eqv bool_imp bool_not bool_or bool_xor ifThen rel_eq rel_ge rel_gt rel_le rel_lt rel_ne gday gdow ghour gleap gmillisec gminute gmonth gsecond gyear jdate jnow jstart jtime errorLevel execError gamsRelease gamsVersion handleCollect handleDelete handleStatus handleSubmit heapFree heapLimit heapSize jobHandle jobKill jobStatus jobTerminate licenseLevel licenseStatus maxExecError sleep timeClose timeComp timeElapsed timeExec timeStart"
    }, r = {
      className: "params",
      begin: /\(/,
      end: /\)/,
      excludeBegin: !0,
      excludeEnd: !0
    }, e = {
      className: "symbol",
      variants: [
        { begin: /=[lgenxc]=/ },
        { begin: /\$/ }
      ]
    }, g = {
      // One-line quoted comment string
      className: "comment",
      variants: [
        {
          begin: "'",
          end: "'"
        },
        {
          begin: '"',
          end: '"'
        }
      ],
      illegal: "\\n",
      contains: [i.BACKSLASH_ESCAPE]
    }, h = {
      begin: "/",
      end: "/",
      keywords: c,
      contains: [
        g,
        i.C_LINE_COMMENT_MODE,
        i.C_BLOCK_COMMENT_MODE,
        i.QUOTE_STRING_MODE,
        i.APOS_STRING_MODE,
        i.C_NUMBER_MODE
      ]
    }, S = /[a-z0-9&#*=?@\\><:,()$[\]_.{}!+%^-]+/, C = {
      // Parameter/set/variable description text
      begin: /[a-z][a-z0-9_]*(\([a-z0-9_, ]*\))?[ \t]+/,
      excludeBegin: !0,
      end: "$",
      endsWithParent: !0,
      contains: [
        g,
        h,
        {
          className: "comment",
          // one comment word, then possibly more
          begin: o.concat(
            S,
            // [ ] because \s would be too broad (matching newlines)
            o.anyNumberOfTimes(o.concat(/[ ]+/, S))
          ),
          relevance: 0
        }
      ]
    };
    return {
      name: "GAMS",
      aliases: ["gms"],
      case_insensitive: !0,
      keywords: c,
      contains: [
        i.COMMENT(/^\$ontext/, /^\$offtext/),
        {
          className: "meta",
          begin: "^\\$[a-z0-9]+",
          end: "$",
          returnBegin: !0,
          contains: [
            {
              className: "keyword",
              begin: "^\\$[a-z0-9]+"
            }
          ]
        },
        i.COMMENT("^\\*", "$"),
        i.C_LINE_COMMENT_MODE,
        i.C_BLOCK_COMMENT_MODE,
        i.QUOTE_STRING_MODE,
        i.APOS_STRING_MODE,
        // Declarations
        {
          beginKeywords: "set sets parameter parameters variable variables scalar scalars equation equations",
          end: ";",
          contains: [
            i.COMMENT("^\\*", "$"),
            i.C_LINE_COMMENT_MODE,
            i.C_BLOCK_COMMENT_MODE,
            i.QUOTE_STRING_MODE,
            i.APOS_STRING_MODE,
            h,
            C
          ]
        },
        {
          // table environment
          beginKeywords: "table",
          end: ";",
          returnBegin: !0,
          contains: [
            {
              // table header row
              beginKeywords: "table",
              end: "$",
              contains: [C]
            },
            i.COMMENT("^\\*", "$"),
            i.C_LINE_COMMENT_MODE,
            i.C_BLOCK_COMMENT_MODE,
            i.QUOTE_STRING_MODE,
            i.APOS_STRING_MODE,
            i.C_NUMBER_MODE
            // Table does not contain DESCTEXT or ASSIGNMENT
          ]
        },
        // Function definitions
        {
          className: "function",
          begin: /^[a-z][a-z0-9_,\-+' ()$]+\.{2}/,
          returnBegin: !0,
          contains: [
            {
              // Function title
              className: "title",
              begin: /^[a-z0-9_]+/
            },
            r,
            e
          ]
        },
        i.C_NUMBER_MODE,
        e
      ]
    };
  }
  return vu = s, vu;
}
var Cu, X0;
function iP() {
  if (X0)
    return Cu;
  X0 = 1;
  function s(i) {
    const o = {
      keyword: "bool break call callexe checkinterrupt clear clearg closeall cls comlog compile continue create debug declare delete disable dlibrary dllcall do dos ed edit else elseif enable end endfor endif endp endo errorlog errorlogat expr external fn for format goto gosub graph if keyword let lib library line load loadarray loadexe loadf loadk loadm loadp loads loadx local locate loopnextindex lprint lpwidth lshow matrix msym ndpclex new open output outwidth plot plotsym pop prcsn print printdos proc push retp return rndcon rndmod rndmult rndseed run save saveall screen scroll setarray show sparse stop string struct system trace trap threadfor threadendfor threadbegin threadjoin threadstat threadend until use while winprint ne ge le gt lt and xor or not eq eqv",
      built_in: "abs acf aconcat aeye amax amean AmericanBinomCall AmericanBinomCall_Greeks AmericanBinomCall_ImpVol AmericanBinomPut AmericanBinomPut_Greeks AmericanBinomPut_ImpVol AmericanBSCall AmericanBSCall_Greeks AmericanBSCall_ImpVol AmericanBSPut AmericanBSPut_Greeks AmericanBSPut_ImpVol amin amult annotationGetDefaults annotationSetBkd annotationSetFont annotationSetLineColor annotationSetLineStyle annotationSetLineThickness annualTradingDays arccos arcsin areshape arrayalloc arrayindex arrayinit arraytomat asciiload asclabel astd astds asum atan atan2 atranspose axmargin balance band bandchol bandcholsol bandltsol bandrv bandsolpd bar base10 begwind besselj bessely beta box boxcox cdfBeta cdfBetaInv cdfBinomial cdfBinomialInv cdfBvn cdfBvn2 cdfBvn2e cdfCauchy cdfCauchyInv cdfChic cdfChii cdfChinc cdfChincInv cdfExp cdfExpInv cdfFc cdfFnc cdfFncInv cdfGam cdfGenPareto cdfHyperGeo cdfLaplace cdfLaplaceInv cdfLogistic cdfLogisticInv cdfmControlCreate cdfMvn cdfMvn2e cdfMvnce cdfMvne cdfMvt2e cdfMvtce cdfMvte cdfN cdfN2 cdfNc cdfNegBinomial cdfNegBinomialInv cdfNi cdfPoisson cdfPoissonInv cdfRayleigh cdfRayleighInv cdfTc cdfTci cdfTnc cdfTvn cdfWeibull cdfWeibullInv cdir ceil ChangeDir chdir chiBarSquare chol choldn cholsol cholup chrs close code cols colsf combinate combinated complex con cond conj cons ConScore contour conv convertsatostr convertstrtosa corrm corrms corrvc corrx corrxs cos cosh counts countwts crossprd crout croutp csrcol csrlin csvReadM csvReadSA cumprodc cumsumc curve cvtos datacreate datacreatecomplex datalist dataload dataloop dataopen datasave date datestr datestring datestrymd dayinyr dayofweek dbAddDatabase dbClose dbCommit dbCreateQuery dbExecQuery dbGetConnectOptions dbGetDatabaseName dbGetDriverName dbGetDrivers dbGetHostName dbGetLastErrorNum dbGetLastErrorText dbGetNumericalPrecPolicy dbGetPassword dbGetPort dbGetTableHeaders dbGetTables dbGetUserName dbHasFeature dbIsDriverAvailable dbIsOpen dbIsOpenError dbOpen dbQueryBindValue dbQueryClear dbQueryCols dbQueryExecPrepared dbQueryFetchAllM dbQueryFetchAllSA dbQueryFetchOneM dbQueryFetchOneSA dbQueryFinish dbQueryGetBoundValue dbQueryGetBoundValues dbQueryGetField dbQueryGetLastErrorNum dbQueryGetLastErrorText dbQueryGetLastInsertID dbQueryGetLastQuery dbQueryGetPosition dbQueryIsActive dbQueryIsForwardOnly dbQueryIsNull dbQueryIsSelect dbQueryIsValid dbQueryPrepare dbQueryRows dbQuerySeek dbQuerySeekFirst dbQuerySeekLast dbQuerySeekNext dbQuerySeekPrevious dbQuerySetForwardOnly dbRemoveDatabase dbRollback dbSetConnectOptions dbSetDatabaseName dbSetHostName dbSetNumericalPrecPolicy dbSetPort dbSetUserName dbTransaction DeleteFile delif delrows denseToSp denseToSpRE denToZero design det detl dfft dffti diag diagrv digamma doswin DOSWinCloseall DOSWinOpen dotfeq dotfeqmt dotfge dotfgemt dotfgt dotfgtmt dotfle dotflemt dotflt dotfltmt dotfne dotfnemt draw drop dsCreate dstat dstatmt dstatmtControlCreate dtdate dtday dttime dttodtv dttostr dttoutc dtvnormal dtvtodt dtvtoutc dummy dummybr dummydn eig eigh eighv eigv elapsedTradingDays endwind envget eof eqSolve eqSolvemt eqSolvemtControlCreate eqSolvemtOutCreate eqSolveset erf erfc erfccplx erfcplx error etdays ethsec etstr EuropeanBinomCall EuropeanBinomCall_Greeks EuropeanBinomCall_ImpVol EuropeanBinomPut EuropeanBinomPut_Greeks EuropeanBinomPut_ImpVol EuropeanBSCall EuropeanBSCall_Greeks EuropeanBSCall_ImpVol EuropeanBSPut EuropeanBSPut_Greeks EuropeanBSPut_ImpVol exctsmpl exec execbg exp extern eye fcheckerr fclearerr feq feqmt fflush fft ffti fftm fftmi fftn fge fgemt fgets fgetsa fgetsat fgetst fgt fgtmt fileinfo filesa fle flemt floor flt fltmt fmod fne fnemt fonts fopen formatcv formatnv fputs fputst fseek fstrerror ftell ftocv ftos ftostrC gamma gammacplx gammaii gausset gdaAppend gdaCreate gdaDStat gdaDStatMat gdaGetIndex gdaGetName gdaGetNames gdaGetOrders gdaGetType gdaGetTypes gdaGetVarInfo gdaIsCplx gdaLoad gdaPack gdaRead gdaReadByIndex gdaReadSome gdaReadSparse gdaReadStruct gdaReportVarInfo gdaSave gdaUpdate gdaUpdateAndPack gdaVars gdaWrite gdaWrite32 gdaWriteSome getarray getdims getf getGAUSShome getmatrix getmatrix4D getname getnamef getNextTradingDay getNextWeekDay getnr getorders getpath getPreviousTradingDay getPreviousWeekDay getRow getscalar3D getscalar4D getTrRow getwind glm gradcplx gradMT gradMTm gradMTT gradMTTm gradp graphprt graphset hasimag header headermt hess hessMT hessMTg hessMTgw hessMTm hessMTmw hessMTT hessMTTg hessMTTgw hessMTTm hessMTw hessp hist histf histp hsec imag indcv indexcat indices indices2 indicesf indicesfn indnv indsav integrate1d integrateControlCreate intgrat2 intgrat3 inthp1 inthp2 inthp3 inthp4 inthpControlCreate intquad1 intquad2 intquad3 intrleav intrleavsa intrsect intsimp inv invpd invswp iscplx iscplxf isden isinfnanmiss ismiss key keyav keyw lag lag1 lagn lapEighb lapEighi lapEighvb lapEighvi lapgEig lapgEigh lapgEighv lapgEigv lapgSchur lapgSvdcst lapgSvds lapgSvdst lapSvdcusv lapSvds lapSvdusv ldlp ldlsol linSolve listwise ln lncdfbvn lncdfbvn2 lncdfmvn lncdfn lncdfn2 lncdfnc lnfact lngammacplx lnpdfmvn lnpdfmvt lnpdfn lnpdft loadd loadstruct loadwind loess loessmt loessmtControlCreate log loglog logx logy lower lowmat lowmat1 ltrisol lu lusol machEpsilon make makevars makewind margin matalloc matinit mattoarray maxbytes maxc maxindc maxv maxvec mbesselei mbesselei0 mbesselei1 mbesseli mbesseli0 mbesseli1 meanc median mergeby mergevar minc minindc minv miss missex missrv moment momentd movingave movingaveExpwgt movingaveWgt nextindex nextn nextnevn nextwind ntos null null1 numCombinations ols olsmt olsmtControlCreate olsqr olsqr2 olsqrmt ones optn optnevn orth outtyp pacf packedToSp packr parse pause pdfCauchy pdfChi pdfExp pdfGenPareto pdfHyperGeo pdfLaplace pdfLogistic pdfn pdfPoisson pdfRayleigh pdfWeibull pi pinv pinvmt plotAddArrow plotAddBar plotAddBox plotAddHist plotAddHistF plotAddHistP plotAddPolar plotAddScatter plotAddShape plotAddTextbox plotAddTS plotAddXY plotArea plotBar plotBox plotClearLayout plotContour plotCustomLayout plotGetDefaults plotHist plotHistF plotHistP plotLayout plotLogLog plotLogX plotLogY plotOpenWindow plotPolar plotSave plotScatter plotSetAxesPen plotSetBar plotSetBarFill plotSetBarStacked plotSetBkdColor plotSetFill plotSetGrid plotSetLegend plotSetLineColor plotSetLineStyle plotSetLineSymbol plotSetLineThickness plotSetNewWindow plotSetTitle plotSetWhichYAxis plotSetXAxisShow plotSetXLabel plotSetXRange plotSetXTicInterval plotSetXTicLabel plotSetYAxisShow plotSetYLabel plotSetYRange plotSetZAxisShow plotSetZLabel plotSurface plotTS plotXY polar polychar polyeval polygamma polyint polymake polymat polymroot polymult polyroot pqgwin previousindex princomp printfm printfmt prodc psi putarray putf putvals pvCreate pvGetIndex pvGetParNames pvGetParVector pvLength pvList pvPack pvPacki pvPackm pvPackmi pvPacks pvPacksi pvPacksm pvPacksmi pvPutParVector pvTest pvUnpack QNewton QNewtonmt QNewtonmtControlCreate QNewtonmtOutCreate QNewtonSet QProg QProgmt QProgmtInCreate qqr qqre qqrep qr qre qrep qrsol qrtsol qtyr qtyre qtyrep quantile quantiled qyr qyre qyrep qz rank rankindx readr real reclassify reclassifyCuts recode recserar recsercp recserrc rerun rescale reshape rets rev rfft rffti rfftip rfftn rfftnp rfftp rndBernoulli rndBeta rndBinomial rndCauchy rndChiSquare rndCon rndCreateState rndExp rndGamma rndGeo rndGumbel rndHyperGeo rndi rndKMbeta rndKMgam rndKMi rndKMn rndKMnb rndKMp rndKMu rndKMvm rndLaplace rndLCbeta rndLCgam rndLCi rndLCn rndLCnb rndLCp rndLCu rndLCvm rndLogNorm rndMTu rndMVn rndMVt rndn rndnb rndNegBinomial rndp rndPoisson rndRayleigh rndStateSkip rndu rndvm rndWeibull rndWishart rotater round rows rowsf rref sampleData satostrC saved saveStruct savewind scale scale3d scalerr scalinfnanmiss scalmiss schtoc schur searchsourcepath seekr select selif seqa seqm setdif setdifsa setvars setvwrmode setwind shell shiftr sin singleindex sinh sleep solpd sortc sortcc sortd sorthc sorthcc sortind sortindc sortmc sortr sortrc spBiconjGradSol spChol spConjGradSol spCreate spDenseSubmat spDiagRvMat spEigv spEye spLDL spline spLU spNumNZE spOnes spreadSheetReadM spreadSheetReadSA spreadSheetWrite spScale spSubmat spToDense spTrTDense spTScalar spZeros sqpSolve sqpSolveMT sqpSolveMTControlCreate sqpSolveMTlagrangeCreate sqpSolveMToutCreate sqpSolveSet sqrt statements stdc stdsc stocv stof strcombine strindx strlen strput strrindx strsect strsplit strsplitPad strtodt strtof strtofcplx strtriml strtrimr strtrunc strtruncl strtruncpad strtruncr submat subscat substute subvec sumc sumr surface svd svd1 svd2 svdcusv svds svdusv sysstate tab tan tanh tempname time timedt timestr timeutc title tkf2eps tkf2ps tocart todaydt toeplitz token topolar trapchk trigamma trimr trunc type typecv typef union unionsa uniqindx uniqindxsa unique uniquesa upmat upmat1 upper utctodt utctodtv utrisol vals varCovMS varCovXS varget vargetl varmall varmares varput varputl vartypef vcm vcms vcx vcxs vec vech vecr vector vget view viewxyz vlist vnamecv volume vput vread vtypecv wait waitc walkindex where window writer xlabel xlsGetSheetCount xlsGetSheetSize xlsGetSheetTypes xlsMakeRange xlsReadM xlsReadSA xlsWrite xlsWriteM xlsWriteSA xpnd xtics xy xyz ylabel ytics zeros zeta zlabel ztics cdfEmpirical dot h5create h5open h5read h5readAttribute h5write h5writeAttribute ldl plotAddErrorBar plotAddSurface plotCDFEmpirical plotSetColormap plotSetContourLabels plotSetLegendFont plotSetTextInterpreter plotSetXTicCount plotSetYTicCount plotSetZLevels powerm strjoin sylvester strtrim",
      literal: "DB_AFTER_LAST_ROW DB_ALL_TABLES DB_BATCH_OPERATIONS DB_BEFORE_FIRST_ROW DB_BLOB DB_EVENT_NOTIFICATIONS DB_FINISH_QUERY DB_HIGH_PRECISION DB_LAST_INSERT_ID DB_LOW_PRECISION_DOUBLE DB_LOW_PRECISION_INT32 DB_LOW_PRECISION_INT64 DB_LOW_PRECISION_NUMBERS DB_MULTIPLE_RESULT_SETS DB_NAMED_PLACEHOLDERS DB_POSITIONAL_PLACEHOLDERS DB_PREPARED_QUERIES DB_QUERY_SIZE DB_SIMPLE_LOCKING DB_SYSTEM_TABLES DB_TABLES DB_TRANSACTIONS DB_UNICODE DB_VIEWS __STDIN __STDOUT __STDERR __FILE_DIR"
    }, c = i.COMMENT("@", "@"), r = {
      className: "meta",
      begin: "#",
      end: "$",
      keywords: { keyword: "define definecs|10 undef ifdef ifndef iflight ifdllcall ifmac ifos2win ifunix else endif lineson linesoff srcfile srcline" },
      contains: [
        {
          begin: /\\\n/,
          relevance: 0
        },
        {
          beginKeywords: "include",
          end: "$",
          keywords: { keyword: "include" },
          contains: [
            {
              className: "string",
              begin: '"',
              end: '"',
              illegal: "\\n"
            }
          ]
        },
        i.C_LINE_COMMENT_MODE,
        i.C_BLOCK_COMMENT_MODE,
        c
      ]
    }, e = {
      begin: /\bstruct\s+/,
      end: /\s/,
      keywords: "struct",
      contains: [
        {
          className: "type",
          begin: i.UNDERSCORE_IDENT_RE,
          relevance: 0
        }
      ]
    }, g = [
      {
        className: "params",
        begin: /\(/,
        end: /\)/,
        excludeBegin: !0,
        excludeEnd: !0,
        endsWithParent: !0,
        relevance: 0,
        contains: [
          {
            // dots
            className: "literal",
            begin: /\.\.\./
          },
          i.C_NUMBER_MODE,
          i.C_BLOCK_COMMENT_MODE,
          c,
          e
        ]
      }
    ], h = {
      className: "title",
      begin: i.UNDERSCORE_IDENT_RE,
      relevance: 0
    }, S = function(x, L, G) {
      const Y = i.inherit(
        {
          className: "function",
          beginKeywords: x,
          end: L,
          excludeEnd: !0,
          contains: [].concat(g)
        },
        G || {}
      );
      return Y.contains.push(h), Y.contains.push(i.C_NUMBER_MODE), Y.contains.push(i.C_BLOCK_COMMENT_MODE), Y.contains.push(c), Y;
    }, C = {
      // these are explicitly named internal function calls
      className: "built_in",
      begin: "\\b(" + o.built_in.split(" ").join("|") + ")\\b"
    }, O = {
      className: "string",
      begin: '"',
      end: '"',
      contains: [i.BACKSLASH_ESCAPE],
      relevance: 0
    }, N = {
      // className: "fn_ref",
      begin: i.UNDERSCORE_IDENT_RE + "\\s*\\(",
      returnBegin: !0,
      keywords: o,
      relevance: 0,
      contains: [
        { beginKeywords: o.keyword },
        C,
        {
          // ambiguously named function calls get a relevance of 0
          className: "built_in",
          begin: i.UNDERSCORE_IDENT_RE,
          relevance: 0
        }
      ]
    }, D = {
      // className: "fn_ref_params",
      begin: /\(/,
      end: /\)/,
      relevance: 0,
      keywords: {
        built_in: o.built_in,
        literal: o.literal
      },
      contains: [
        i.C_NUMBER_MODE,
        i.C_BLOCK_COMMENT_MODE,
        c,
        C,
        N,
        O,
        "self"
      ]
    };
    return N.contains.push(D), {
      name: "GAUSS",
      aliases: ["gss"],
      case_insensitive: !0,
      // language is case-insensitive
      keywords: o,
      illegal: /(\{[%#]|[%#]\}| <- )/,
      contains: [
        i.C_NUMBER_MODE,
        i.C_LINE_COMMENT_MODE,
        i.C_BLOCK_COMMENT_MODE,
        c,
        O,
        r,
        {
          className: "keyword",
          begin: /\bexternal (matrix|string|array|sparse matrix|struct|proc|keyword|fn)/
        },
        S("proc keyword", ";"),
        S("fn", "="),
        {
          beginKeywords: "for threadfor",
          end: /;/,
          // end: /\(/,
          relevance: 0,
          contains: [
            i.C_BLOCK_COMMENT_MODE,
            c,
            D
          ]
        },
        {
          // custom method guard
          // excludes method names from keyword processing
          variants: [
            { begin: i.UNDERSCORE_IDENT_RE + "\\." + i.UNDERSCORE_IDENT_RE },
            { begin: i.UNDERSCORE_IDENT_RE + "\\s*=" }
          ],
          relevance: 0
        },
        N,
        e
      ]
    };
  }
  return Cu = s, Cu;
}
var Ru, Z0;
function oP() {
  if (Z0)
    return Ru;
  Z0 = 1;
  function s(i) {
    const o = "[A-Z_][A-Z0-9_.]*", c = "%", r = {
      $pattern: o,
      keyword: "IF DO WHILE ENDWHILE CALL ENDIF SUB ENDSUB GOTO REPEAT ENDREPEAT EQ LT GT NE GE LE OR XOR"
    }, e = {
      className: "meta",
      begin: "([O])([0-9]+)"
    }, g = i.inherit(i.C_NUMBER_MODE, { begin: "([-+]?((\\.\\d+)|(\\d+)(\\.\\d*)?))|" + i.C_NUMBER_RE }), h = [
      i.C_LINE_COMMENT_MODE,
      i.C_BLOCK_COMMENT_MODE,
      i.COMMENT(/\(/, /\)/),
      g,
      i.inherit(i.APOS_STRING_MODE, { illegal: null }),
      i.inherit(i.QUOTE_STRING_MODE, { illegal: null }),
      {
        className: "name",
        begin: "([G])([0-9]+\\.?[0-9]?)"
      },
      {
        className: "name",
        begin: "([M])([0-9]+\\.?[0-9]?)"
      },
      {
        className: "attr",
        begin: "(VC|VS|#)",
        end: "(\\d+)"
      },
      {
        className: "attr",
        begin: "(VZOFX|VZOFY|VZOFZ)"
      },
      {
        className: "built_in",
        begin: "(ATAN|ABS|ACOS|ASIN|SIN|COS|EXP|FIX|FUP|ROUND|LN|TAN)(\\[)",
        contains: [g],
        end: "\\]"
      },
      {
        className: "symbol",
        variants: [
          {
            begin: "N",
            end: "\\d+",
            illegal: "\\W"
          }
        ]
      }
    ];
    return {
      name: "G-code (ISO 6983)",
      aliases: ["nc"],
      // Some implementations (CNC controls) of G-code are interoperable with uppercase and lowercase letters seamlessly.
      // However, most prefer all uppercase and uppercase is customary.
      case_insensitive: !0,
      keywords: r,
      contains: [
        {
          className: "meta",
          begin: c
        },
        e
      ].concat(h)
    };
  }
  return Ru = s, Ru;
}
var Nu, j0;
function sP() {
  if (j0)
    return Nu;
  j0 = 1;
  function s(i) {
    return {
      name: "Gherkin",
      aliases: ["feature"],
      keywords: "Feature Background Ability Business Need Scenario Scenarios Scenario Outline Scenario Template Examples Given And Then But When",
      contains: [
        {
          className: "symbol",
          begin: "\\*",
          relevance: 0
        },
        {
          className: "meta",
          begin: "@[^@\\s]+"
        },
        {
          begin: "\\|",
          end: "\\|\\w*$",
          contains: [
            {
              className: "string",
              begin: "[^|]+"
            }
          ]
        },
        {
          className: "variable",
          begin: "<",
          end: ">"
        },
        i.HASH_COMMENT_MODE,
        {
          className: "string",
          begin: '"""',
          end: '"""'
        },
        i.QUOTE_STRING_MODE
      ]
    };
  }
  return Nu = s, Nu;
}
var Au, J0;
function lP() {
  if (J0)
    return Au;
  J0 = 1;
  function s(i) {
    return {
      name: "GLSL",
      keywords: {
        keyword: (
          // Statements
          "break continue discard do else for if return while switch case default attribute binding buffer ccw centroid centroid varying coherent column_major const cw depth_any depth_greater depth_less depth_unchanged early_fragment_tests equal_spacing flat fractional_even_spacing fractional_odd_spacing highp in index inout invariant invocations isolines layout line_strip lines lines_adjacency local_size_x local_size_y local_size_z location lowp max_vertices mediump noperspective offset origin_upper_left out packed patch pixel_center_integer point_mode points precise precision quads r11f_g11f_b10f r16 r16_snorm r16f r16i r16ui r32f r32i r32ui r8 r8_snorm r8i r8ui readonly restrict rg16 rg16_snorm rg16f rg16i rg16ui rg32f rg32i rg32ui rg8 rg8_snorm rg8i rg8ui rgb10_a2 rgb10_a2ui rgba16 rgba16_snorm rgba16f rgba16i rgba16ui rgba32f rgba32i rgba32ui rgba8 rgba8_snorm rgba8i rgba8ui row_major sample shared smooth std140 std430 stream triangle_strip triangles triangles_adjacency uniform varying vertices volatile writeonly"
        ),
        type: "atomic_uint bool bvec2 bvec3 bvec4 dmat2 dmat2x2 dmat2x3 dmat2x4 dmat3 dmat3x2 dmat3x3 dmat3x4 dmat4 dmat4x2 dmat4x3 dmat4x4 double dvec2 dvec3 dvec4 float iimage1D iimage1DArray iimage2D iimage2DArray iimage2DMS iimage2DMSArray iimage2DRect iimage3D iimageBuffer iimageCube iimageCubeArray image1D image1DArray image2D image2DArray image2DMS image2DMSArray image2DRect image3D imageBuffer imageCube imageCubeArray int isampler1D isampler1DArray isampler2D isampler2DArray isampler2DMS isampler2DMSArray isampler2DRect isampler3D isamplerBuffer isamplerCube isamplerCubeArray ivec2 ivec3 ivec4 mat2 mat2x2 mat2x3 mat2x4 mat3 mat3x2 mat3x3 mat3x4 mat4 mat4x2 mat4x3 mat4x4 sampler1D sampler1DArray sampler1DArrayShadow sampler1DShadow sampler2D sampler2DArray sampler2DArrayShadow sampler2DMS sampler2DMSArray sampler2DRect sampler2DRectShadow sampler2DShadow sampler3D samplerBuffer samplerCube samplerCubeArray samplerCubeArrayShadow samplerCubeShadow image1D uimage1DArray uimage2D uimage2DArray uimage2DMS uimage2DMSArray uimage2DRect uimage3D uimageBuffer uimageCube uimageCubeArray uint usampler1D usampler1DArray usampler2D usampler2DArray usampler2DMS usampler2DMSArray usampler2DRect usampler3D samplerBuffer usamplerCube usamplerCubeArray uvec2 uvec3 uvec4 vec2 vec3 vec4 void",
        built_in: (
          // Constants
          "gl_MaxAtomicCounterBindings gl_MaxAtomicCounterBufferSize gl_MaxClipDistances gl_MaxClipPlanes gl_MaxCombinedAtomicCounterBuffers gl_MaxCombinedAtomicCounters gl_MaxCombinedImageUniforms gl_MaxCombinedImageUnitsAndFragmentOutputs gl_MaxCombinedTextureImageUnits gl_MaxComputeAtomicCounterBuffers gl_MaxComputeAtomicCounters gl_MaxComputeImageUniforms gl_MaxComputeTextureImageUnits gl_MaxComputeUniformComponents gl_MaxComputeWorkGroupCount gl_MaxComputeWorkGroupSize gl_MaxDrawBuffers gl_MaxFragmentAtomicCounterBuffers gl_MaxFragmentAtomicCounters gl_MaxFragmentImageUniforms gl_MaxFragmentInputComponents gl_MaxFragmentInputVectors gl_MaxFragmentUniformComponents gl_MaxFragmentUniformVectors gl_MaxGeometryAtomicCounterBuffers gl_MaxGeometryAtomicCounters gl_MaxGeometryImageUniforms gl_MaxGeometryInputComponents gl_MaxGeometryOutputComponents gl_MaxGeometryOutputVertices gl_MaxGeometryTextureImageUnits gl_MaxGeometryTotalOutputComponents gl_MaxGeometryUniformComponents gl_MaxGeometryVaryingComponents gl_MaxImageSamples gl_MaxImageUnits gl_MaxLights gl_MaxPatchVertices gl_MaxProgramTexelOffset gl_MaxTessControlAtomicCounterBuffers gl_MaxTessControlAtomicCounters gl_MaxTessControlImageUniforms gl_MaxTessControlInputComponents gl_MaxTessControlOutputComponents gl_MaxTessControlTextureImageUnits gl_MaxTessControlTotalOutputComponents gl_MaxTessControlUniformComponents gl_MaxTessEvaluationAtomicCounterBuffers gl_MaxTessEvaluationAtomicCounters gl_MaxTessEvaluationImageUniforms gl_MaxTessEvaluationInputComponents gl_MaxTessEvaluationOutputComponents gl_MaxTessEvaluationTextureImageUnits gl_MaxTessEvaluationUniformComponents gl_MaxTessGenLevel gl_MaxTessPatchComponents gl_MaxTextureCoords gl_MaxTextureImageUnits gl_MaxTextureUnits gl_MaxVaryingComponents gl_MaxVaryingFloats gl_MaxVaryingVectors gl_MaxVertexAtomicCounterBuffers gl_MaxVertexAtomicCounters gl_MaxVertexAttribs gl_MaxVertexImageUniforms gl_MaxVertexOutputComponents gl_MaxVertexOutputVectors gl_MaxVertexTextureImageUnits gl_MaxVertexUniformComponents gl_MaxVertexUniformVectors gl_MaxViewports gl_MinProgramTexelOffset gl_BackColor gl_BackLightModelProduct gl_BackLightProduct gl_BackMaterial gl_BackSecondaryColor gl_ClipDistance gl_ClipPlane gl_ClipVertex gl_Color gl_DepthRange gl_EyePlaneQ gl_EyePlaneR gl_EyePlaneS gl_EyePlaneT gl_Fog gl_FogCoord gl_FogFragCoord gl_FragColor gl_FragCoord gl_FragData gl_FragDepth gl_FrontColor gl_FrontFacing gl_FrontLightModelProduct gl_FrontLightProduct gl_FrontMaterial gl_FrontSecondaryColor gl_GlobalInvocationID gl_InstanceID gl_InvocationID gl_Layer gl_LightModel gl_LightSource gl_LocalInvocationID gl_LocalInvocationIndex gl_ModelViewMatrix gl_ModelViewMatrixInverse gl_ModelViewMatrixInverseTranspose gl_ModelViewMatrixTranspose gl_ModelViewProjectionMatrix gl_ModelViewProjectionMatrixInverse gl_ModelViewProjectionMatrixInverseTranspose gl_ModelViewProjectionMatrixTranspose gl_MultiTexCoord0 gl_MultiTexCoord1 gl_MultiTexCoord2 gl_MultiTexCoord3 gl_MultiTexCoord4 gl_MultiTexCoord5 gl_MultiTexCoord6 gl_MultiTexCoord7 gl_Normal gl_NormalMatrix gl_NormalScale gl_NumSamples gl_NumWorkGroups gl_ObjectPlaneQ gl_ObjectPlaneR gl_ObjectPlaneS gl_ObjectPlaneT gl_PatchVerticesIn gl_Point gl_PointCoord gl_PointSize gl_Position gl_PrimitiveID gl_PrimitiveIDIn gl_ProjectionMatrix gl_ProjectionMatrixInverse gl_ProjectionMatrixInverseTranspose gl_ProjectionMatrixTranspose gl_SampleID gl_SampleMask gl_SampleMaskIn gl_SamplePosition gl_SecondaryColor gl_TessCoord gl_TessLevelInner gl_TessLevelOuter gl_TexCoord gl_TextureEnvColor gl_TextureMatrix gl_TextureMatrixInverse gl_TextureMatrixInverseTranspose gl_TextureMatrixTranspose gl_Vertex gl_VertexID gl_ViewportIndex gl_WorkGroupID gl_WorkGroupSize gl_in gl_out EmitStreamVertex EmitVertex EndPrimitive EndStreamPrimitive abs acos acosh all any asin asinh atan atanh atomicAdd atomicAnd atomicCompSwap atomicCounter atomicCounterDecrement atomicCounterIncrement atomicExchange atomicMax atomicMin atomicOr atomicXor barrier bitCount bitfieldExtract bitfieldInsert bitfieldReverse ceil clamp cos cosh cross dFdx dFdy degrees determinant distance dot equal exp exp2 faceforward findLSB findMSB floatBitsToInt floatBitsToUint floor fma fract frexp ftransform fwidth greaterThan greaterThanEqual groupMemoryBarrier imageAtomicAdd imageAtomicAnd imageAtomicCompSwap imageAtomicExchange imageAtomicMax imageAtomicMin imageAtomicOr imageAtomicXor imageLoad imageSize imageStore imulExtended intBitsToFloat interpolateAtCentroid interpolateAtOffset interpolateAtSample inverse inversesqrt isinf isnan ldexp length lessThan lessThanEqual log log2 matrixCompMult max memoryBarrier memoryBarrierAtomicCounter memoryBarrierBuffer memoryBarrierImage memoryBarrierShared min mix mod modf noise1 noise2 noise3 noise4 normalize not notEqual outerProduct packDouble2x32 packHalf2x16 packSnorm2x16 packSnorm4x8 packUnorm2x16 packUnorm4x8 pow radians reflect refract round roundEven shadow1D shadow1DLod shadow1DProj shadow1DProjLod shadow2D shadow2DLod shadow2DProj shadow2DProjLod sign sin sinh smoothstep sqrt step tan tanh texelFetch texelFetchOffset texture texture1D texture1DLod texture1DProj texture1DProjLod texture2D texture2DLod texture2DProj texture2DProjLod texture3D texture3DLod texture3DProj texture3DProjLod textureCube textureCubeLod textureGather textureGatherOffset textureGatherOffsets textureGrad textureGradOffset textureLod textureLodOffset textureOffset textureProj textureProjGrad textureProjGradOffset textureProjLod textureProjLodOffset textureProjOffset textureQueryLevels textureQueryLod textureSize transpose trunc uaddCarry uintBitsToFloat umulExtended unpackDouble2x32 unpackHalf2x16 unpackSnorm2x16 unpackSnorm4x8 unpackUnorm2x16 unpackUnorm4x8 usubBorrow"
        ),
        literal: "true false"
      },
      illegal: '"',
      contains: [
        i.C_LINE_COMMENT_MODE,
        i.C_BLOCK_COMMENT_MODE,
        i.C_NUMBER_MODE,
        {
          className: "meta",
          begin: "#",
          end: "$"
        }
      ]
    };
  }
  return Au = s, Au;
}
var Ou, eb;
function cP() {
  if (eb)
    return Ou;
  eb = 1;
  function s(i) {
    return {
      name: "GML",
      case_insensitive: !1,
      // language is case-insensitive
      keywords: {
        keyword: [
          "#endregion",
          "#macro",
          "#region",
          "and",
          "begin",
          "break",
          "case",
          "constructor",
          "continue",
          "default",
          "delete",
          "div",
          "do",
          "else",
          "end",
          "enum",
          "exit",
          "for",
          "function",
          "globalvar",
          "if",
          "mod",
          "not",
          "or",
          "repeat",
          "return",
          "switch",
          "then",
          "until",
          "var",
          "while",
          "with",
          "xor"
        ],
        built_in: [
          "abs",
          "achievement_available",
          "achievement_event",
          "achievement_get_challenges",
          "achievement_get_info",
          "achievement_get_pic",
          "achievement_increment",
          "achievement_load_friends",
          "achievement_load_leaderboard",
          "achievement_load_progress",
          "achievement_login",
          "achievement_login_status",
          "achievement_logout",
          "achievement_post",
          "achievement_post_score",
          "achievement_reset",
          "achievement_send_challenge",
          "achievement_show",
          "achievement_show_achievements",
          "achievement_show_challenge_notifications",
          "achievement_show_leaderboards",
          "action_inherited",
          "action_kill_object",
          "ads_disable",
          "ads_enable",
          "ads_engagement_active",
          "ads_engagement_available",
          "ads_engagement_launch",
          "ads_event",
          "ads_event_preload",
          "ads_get_display_height",
          "ads_get_display_width",
          "ads_interstitial_available",
          "ads_interstitial_display",
          "ads_move",
          "ads_set_reward_callback",
          "ads_setup",
          "alarm_get",
          "alarm_set",
          "analytics_event",
          "analytics_event_ext",
          "angle_difference",
          "ansi_char",
          "application_get_position",
          "application_surface_draw_enable",
          "application_surface_enable",
          "application_surface_is_enabled",
          "arccos",
          "arcsin",
          "arctan",
          "arctan2",
          "array_copy",
          "array_create",
          "array_delete",
          "array_equals",
          "array_height_2d",
          "array_insert",
          "array_length",
          "array_length_1d",
          "array_length_2d",
          "array_pop",
          "array_push",
          "array_resize",
          "array_sort",
          "asset_get_index",
          "asset_get_type",
          "audio_channel_num",
          "audio_create_buffer_sound",
          "audio_create_play_queue",
          "audio_create_stream",
          "audio_create_sync_group",
          "audio_debug",
          "audio_destroy_stream",
          "audio_destroy_sync_group",
          "audio_emitter_create",
          "audio_emitter_exists",
          "audio_emitter_falloff",
          "audio_emitter_free",
          "audio_emitter_gain",
          "audio_emitter_get_gain",
          "audio_emitter_get_listener_mask",
          "audio_emitter_get_pitch",
          "audio_emitter_get_vx",
          "audio_emitter_get_vy",
          "audio_emitter_get_vz",
          "audio_emitter_get_x",
          "audio_emitter_get_y",
          "audio_emitter_get_z",
          "audio_emitter_pitch",
          "audio_emitter_position",
          "audio_emitter_set_listener_mask",
          "audio_emitter_velocity",
          "audio_exists",
          "audio_falloff_set_model",
          "audio_free_buffer_sound",
          "audio_free_play_queue",
          "audio_get_listener_count",
          "audio_get_listener_info",
          "audio_get_listener_mask",
          "audio_get_master_gain",
          "audio_get_name",
          "audio_get_recorder_count",
          "audio_get_recorder_info",
          "audio_get_type",
          "audio_group_is_loaded",
          "audio_group_load",
          "audio_group_load_progress",
          "audio_group_name",
          "audio_group_set_gain",
          "audio_group_stop_all",
          "audio_group_unload",
          "audio_is_paused",
          "audio_is_playing",
          "audio_listener_get_data",
          "audio_listener_orientation",
          "audio_listener_position",
          "audio_listener_set_orientation",
          "audio_listener_set_position",
          "audio_listener_set_velocity",
          "audio_listener_velocity",
          "audio_master_gain",
          "audio_music_gain",
          "audio_music_is_playing",
          "audio_pause_all",
          "audio_pause_music",
          "audio_pause_sound",
          "audio_pause_sync_group",
          "audio_play_in_sync_group",
          "audio_play_music",
          "audio_play_sound",
          "audio_play_sound_at",
          "audio_play_sound_on",
          "audio_queue_sound",
          "audio_resume_all",
          "audio_resume_music",
          "audio_resume_sound",
          "audio_resume_sync_group",
          "audio_set_listener_mask",
          "audio_set_master_gain",
          "audio_sound_gain",
          "audio_sound_get_gain",
          "audio_sound_get_listener_mask",
          "audio_sound_get_pitch",
          "audio_sound_get_track_position",
          "audio_sound_length",
          "audio_sound_pitch",
          "audio_sound_set_listener_mask",
          "audio_sound_set_track_position",
          "audio_start_recording",
          "audio_start_sync_group",
          "audio_stop_all",
          "audio_stop_music",
          "audio_stop_recording",
          "audio_stop_sound",
          "audio_stop_sync_group",
          "audio_sync_group_debug",
          "audio_sync_group_get_track_pos",
          "audio_sync_group_is_playing",
          "audio_system",
          "background_get_height",
          "background_get_width",
          "base64_decode",
          "base64_encode",
          "browser_input_capture",
          "buffer_async_group_begin",
          "buffer_async_group_end",
          "buffer_async_group_option",
          "buffer_base64_decode",
          "buffer_base64_decode_ext",
          "buffer_base64_encode",
          "buffer_copy",
          "buffer_copy_from_vertex_buffer",
          "buffer_create",
          "buffer_create_from_vertex_buffer",
          "buffer_create_from_vertex_buffer_ext",
          "buffer_delete",
          "buffer_exists",
          "buffer_fill",
          "buffer_get_address",
          "buffer_get_alignment",
          "buffer_get_size",
          "buffer_get_surface",
          "buffer_get_type",
          "buffer_load",
          "buffer_load_async",
          "buffer_load_ext",
          "buffer_load_partial",
          "buffer_md5",
          "buffer_peek",
          "buffer_poke",
          "buffer_read",
          "buffer_resize",
          "buffer_save",
          "buffer_save_async",
          "buffer_save_ext",
          "buffer_seek",
          "buffer_set_surface",
          "buffer_sha1",
          "buffer_sizeof",
          "buffer_tell",
          "buffer_write",
          "camera_apply",
          "camera_create",
          "camera_create_view",
          "camera_destroy",
          "camera_get_active",
          "camera_get_begin_script",
          "camera_get_default",
          "camera_get_end_script",
          "camera_get_proj_mat",
          "camera_get_update_script",
          "camera_get_view_angle",
          "camera_get_view_border_x",
          "camera_get_view_border_y",
          "camera_get_view_height",
          "camera_get_view_mat",
          "camera_get_view_speed_x",
          "camera_get_view_speed_y",
          "camera_get_view_target",
          "camera_get_view_width",
          "camera_get_view_x",
          "camera_get_view_y",
          "camera_set_begin_script",
          "camera_set_default",
          "camera_set_end_script",
          "camera_set_proj_mat",
          "camera_set_update_script",
          "camera_set_view_angle",
          "camera_set_view_border",
          "camera_set_view_mat",
          "camera_set_view_pos",
          "camera_set_view_size",
          "camera_set_view_speed",
          "camera_set_view_target",
          "ceil",
          "choose",
          "chr",
          "clamp",
          "clickable_add",
          "clickable_add_ext",
          "clickable_change",
          "clickable_change_ext",
          "clickable_delete",
          "clickable_exists",
          "clickable_set_style",
          "clipboard_get_text",
          "clipboard_has_text",
          "clipboard_set_text",
          "cloud_file_save",
          "cloud_string_save",
          "cloud_synchronise",
          "code_is_compiled",
          "collision_circle",
          "collision_circle_list",
          "collision_ellipse",
          "collision_ellipse_list",
          "collision_line",
          "collision_line_list",
          "collision_point",
          "collision_point_list",
          "collision_rectangle",
          "collision_rectangle_list",
          "color_get_blue",
          "color_get_green",
          "color_get_hue",
          "color_get_red",
          "color_get_saturation",
          "color_get_value",
          "colour_get_blue",
          "colour_get_green",
          "colour_get_hue",
          "colour_get_red",
          "colour_get_saturation",
          "colour_get_value",
          "cos",
          "darccos",
          "darcsin",
          "darctan",
          "darctan2",
          "date_compare_date",
          "date_compare_datetime",
          "date_compare_time",
          "date_create_datetime",
          "date_current_datetime",
          "date_date_of",
          "date_date_string",
          "date_datetime_string",
          "date_day_span",
          "date_days_in_month",
          "date_days_in_year",
          "date_get_day",
          "date_get_day_of_year",
          "date_get_hour",
          "date_get_hour_of_year",
          "date_get_minute",
          "date_get_minute_of_year",
          "date_get_month",
          "date_get_second",
          "date_get_second_of_year",
          "date_get_timezone",
          "date_get_week",
          "date_get_weekday",
          "date_get_year",
          "date_hour_span",
          "date_inc_day",
          "date_inc_hour",
          "date_inc_minute",
          "date_inc_month",
          "date_inc_second",
          "date_inc_week",
          "date_inc_year",
          "date_is_today",
          "date_leap_year",
          "date_minute_span",
          "date_month_span",
          "date_second_span",
          "date_set_timezone",
          "date_time_of",
          "date_time_string",
          "date_valid_datetime",
          "date_week_span",
          "date_year_span",
          "dcos",
          "debug_event",
          "debug_get_callstack",
          "degtorad",
          "device_get_tilt_x",
          "device_get_tilt_y",
          "device_get_tilt_z",
          "device_is_keypad_open",
          "device_mouse_check_button",
          "device_mouse_check_button_pressed",
          "device_mouse_check_button_released",
          "device_mouse_dbclick_enable",
          "device_mouse_raw_x",
          "device_mouse_raw_y",
          "device_mouse_x",
          "device_mouse_x_to_gui",
          "device_mouse_y",
          "device_mouse_y_to_gui",
          "directory_create",
          "directory_destroy",
          "directory_exists",
          "display_get_dpi_x",
          "display_get_dpi_y",
          "display_get_gui_height",
          "display_get_gui_width",
          "display_get_height",
          "display_get_orientation",
          "display_get_sleep_margin",
          "display_get_timing_method",
          "display_get_width",
          "display_mouse_get_x",
          "display_mouse_get_y",
          "display_mouse_set",
          "display_reset",
          "display_set_gui_maximise",
          "display_set_gui_maximize",
          "display_set_gui_size",
          "display_set_sleep_margin",
          "display_set_timing_method",
          "display_set_ui_visibility",
          "distance_to_object",
          "distance_to_point",
          "dot_product",
          "dot_product_3d",
          "dot_product_3d_normalised",
          "dot_product_3d_normalized",
          "dot_product_normalised",
          "dot_product_normalized",
          "draw_arrow",
          "draw_background",
          "draw_background_ext",
          "draw_background_part_ext",
          "draw_background_tiled",
          "draw_button",
          "draw_circle",
          "draw_circle_color",
          "draw_circle_colour",
          "draw_clear",
          "draw_clear_alpha",
          "draw_ellipse",
          "draw_ellipse_color",
          "draw_ellipse_colour",
          "draw_enable_alphablend",
          "draw_enable_drawevent",
          "draw_enable_swf_aa",
          "draw_flush",
          "draw_get_alpha",
          "draw_get_color",
          "draw_get_colour",
          "draw_get_lighting",
          "draw_get_swf_aa_level",
          "draw_getpixel",
          "draw_getpixel_ext",
          "draw_healthbar",
          "draw_highscore",
          "draw_light_define_ambient",
          "draw_light_define_direction",
          "draw_light_define_point",
          "draw_light_enable",
          "draw_light_get",
          "draw_light_get_ambient",
          "draw_line",
          "draw_line_color",
          "draw_line_colour",
          "draw_line_width",
          "draw_line_width_color",
          "draw_line_width_colour",
          "draw_path",
          "draw_point",
          "draw_point_color",
          "draw_point_colour",
          "draw_primitive_begin",
          "draw_primitive_begin_texture",
          "draw_primitive_end",
          "draw_rectangle",
          "draw_rectangle_color",
          "draw_rectangle_colour",
          "draw_roundrect",
          "draw_roundrect_color",
          "draw_roundrect_color_ext",
          "draw_roundrect_colour",
          "draw_roundrect_colour_ext",
          "draw_roundrect_ext",
          "draw_self",
          "draw_set_alpha",
          "draw_set_alpha_test",
          "draw_set_alpha_test_ref_value",
          "draw_set_blend_mode",
          "draw_set_blend_mode_ext",
          "draw_set_circle_precision",
          "draw_set_color",
          "draw_set_color_write_enable",
          "draw_set_colour",
          "draw_set_font",
          "draw_set_halign",
          "draw_set_lighting",
          "draw_set_swf_aa_level",
          "draw_set_valign",
          "draw_skeleton",
          "draw_skeleton_collision",
          "draw_skeleton_instance",
          "draw_skeleton_time",
          "draw_sprite",
          "draw_sprite_ext",
          "draw_sprite_general",
          "draw_sprite_part",
          "draw_sprite_part_ext",
          "draw_sprite_pos",
          "draw_sprite_stretched",
          "draw_sprite_stretched_ext",
          "draw_sprite_tiled",
          "draw_sprite_tiled_ext",
          "draw_surface",
          "draw_surface_ext",
          "draw_surface_general",
          "draw_surface_part",
          "draw_surface_part_ext",
          "draw_surface_stretched",
          "draw_surface_stretched_ext",
          "draw_surface_tiled",
          "draw_surface_tiled_ext",
          "draw_text",
          "draw_text_color",
          "draw_text_colour",
          "draw_text_ext",
          "draw_text_ext_color",
          "draw_text_ext_colour",
          "draw_text_ext_transformed",
          "draw_text_ext_transformed_color",
          "draw_text_ext_transformed_colour",
          "draw_text_transformed",
          "draw_text_transformed_color",
          "draw_text_transformed_colour",
          "draw_texture_flush",
          "draw_tile",
          "draw_tilemap",
          "draw_triangle",
          "draw_triangle_color",
          "draw_triangle_colour",
          "draw_vertex",
          "draw_vertex_color",
          "draw_vertex_colour",
          "draw_vertex_texture",
          "draw_vertex_texture_color",
          "draw_vertex_texture_colour",
          "ds_exists",
          "ds_grid_add",
          "ds_grid_add_disk",
          "ds_grid_add_grid_region",
          "ds_grid_add_region",
          "ds_grid_clear",
          "ds_grid_copy",
          "ds_grid_create",
          "ds_grid_destroy",
          "ds_grid_get",
          "ds_grid_get_disk_max",
          "ds_grid_get_disk_mean",
          "ds_grid_get_disk_min",
          "ds_grid_get_disk_sum",
          "ds_grid_get_max",
          "ds_grid_get_mean",
          "ds_grid_get_min",
          "ds_grid_get_sum",
          "ds_grid_height",
          "ds_grid_multiply",
          "ds_grid_multiply_disk",
          "ds_grid_multiply_grid_region",
          "ds_grid_multiply_region",
          "ds_grid_read",
          "ds_grid_resize",
          "ds_grid_set",
          "ds_grid_set_disk",
          "ds_grid_set_grid_region",
          "ds_grid_set_region",
          "ds_grid_shuffle",
          "ds_grid_sort",
          "ds_grid_value_disk_exists",
          "ds_grid_value_disk_x",
          "ds_grid_value_disk_y",
          "ds_grid_value_exists",
          "ds_grid_value_x",
          "ds_grid_value_y",
          "ds_grid_width",
          "ds_grid_write",
          "ds_list_add",
          "ds_list_clear",
          "ds_list_copy",
          "ds_list_create",
          "ds_list_delete",
          "ds_list_destroy",
          "ds_list_empty",
          "ds_list_find_index",
          "ds_list_find_value",
          "ds_list_insert",
          "ds_list_mark_as_list",
          "ds_list_mark_as_map",
          "ds_list_read",
          "ds_list_replace",
          "ds_list_set",
          "ds_list_shuffle",
          "ds_list_size",
          "ds_list_sort",
          "ds_list_write",
          "ds_map_add",
          "ds_map_add_list",
          "ds_map_add_map",
          "ds_map_clear",
          "ds_map_copy",
          "ds_map_create",
          "ds_map_delete",
          "ds_map_destroy",
          "ds_map_empty",
          "ds_map_exists",
          "ds_map_find_first",
          "ds_map_find_last",
          "ds_map_find_next",
          "ds_map_find_previous",
          "ds_map_find_value",
          "ds_map_read",
          "ds_map_replace",
          "ds_map_replace_list",
          "ds_map_replace_map",
          "ds_map_secure_load",
          "ds_map_secure_load_buffer",
          "ds_map_secure_save",
          "ds_map_secure_save_buffer",
          "ds_map_set",
          "ds_map_size",
          "ds_map_write",
          "ds_priority_add",
          "ds_priority_change_priority",
          "ds_priority_clear",
          "ds_priority_copy",
          "ds_priority_create",
          "ds_priority_delete_max",
          "ds_priority_delete_min",
          "ds_priority_delete_value",
          "ds_priority_destroy",
          "ds_priority_empty",
          "ds_priority_find_max",
          "ds_priority_find_min",
          "ds_priority_find_priority",
          "ds_priority_read",
          "ds_priority_size",
          "ds_priority_write",
          "ds_queue_clear",
          "ds_queue_copy",
          "ds_queue_create",
          "ds_queue_dequeue",
          "ds_queue_destroy",
          "ds_queue_empty",
          "ds_queue_enqueue",
          "ds_queue_head",
          "ds_queue_read",
          "ds_queue_size",
          "ds_queue_tail",
          "ds_queue_write",
          "ds_set_precision",
          "ds_stack_clear",
          "ds_stack_copy",
          "ds_stack_create",
          "ds_stack_destroy",
          "ds_stack_empty",
          "ds_stack_pop",
          "ds_stack_push",
          "ds_stack_read",
          "ds_stack_size",
          "ds_stack_top",
          "ds_stack_write",
          "dsin",
          "dtan",
          "effect_clear",
          "effect_create_above",
          "effect_create_below",
          "environment_get_variable",
          "event_inherited",
          "event_perform",
          "event_perform_object",
          "event_user",
          "exp",
          "external_call",
          "external_define",
          "external_free",
          "facebook_accesstoken",
          "facebook_check_permission",
          "facebook_dialog",
          "facebook_graph_request",
          "facebook_init",
          "facebook_launch_offerwall",
          "facebook_login",
          "facebook_logout",
          "facebook_post_message",
          "facebook_request_publish_permissions",
          "facebook_request_read_permissions",
          "facebook_send_invite",
          "facebook_status",
          "facebook_user_id",
          "file_attributes",
          "file_bin_close",
          "file_bin_open",
          "file_bin_position",
          "file_bin_read_byte",
          "file_bin_rewrite",
          "file_bin_seek",
          "file_bin_size",
          "file_bin_write_byte",
          "file_copy",
          "file_delete",
          "file_exists",
          "file_find_close",
          "file_find_first",
          "file_find_next",
          "file_rename",
          "file_text_close",
          "file_text_eof",
          "file_text_eoln",
          "file_text_open_append",
          "file_text_open_from_string",
          "file_text_open_read",
          "file_text_open_write",
          "file_text_read_real",
          "file_text_read_string",
          "file_text_readln",
          "file_text_write_real",
          "file_text_write_string",
          "file_text_writeln",
          "filename_change_ext",
          "filename_dir",
          "filename_drive",
          "filename_ext",
          "filename_name",
          "filename_path",
          "floor",
          "font_add",
          "font_add_enable_aa",
          "font_add_get_enable_aa",
          "font_add_sprite",
          "font_add_sprite_ext",
          "font_delete",
          "font_exists",
          "font_get_bold",
          "font_get_first",
          "font_get_fontname",
          "font_get_italic",
          "font_get_last",
          "font_get_name",
          "font_get_size",
          "font_get_texture",
          "font_get_uvs",
          "font_replace",
          "font_replace_sprite",
          "font_replace_sprite_ext",
          "font_set_cache_size",
          "font_texture_page_size",
          "frac",
          "game_end",
          "game_get_speed",
          "game_load",
          "game_load_buffer",
          "game_restart",
          "game_save",
          "game_save_buffer",
          "game_set_speed",
          "gamepad_axis_count",
          "gamepad_axis_value",
          "gamepad_button_check",
          "gamepad_button_check_pressed",
          "gamepad_button_check_released",
          "gamepad_button_count",
          "gamepad_button_value",
          "gamepad_get_axis_deadzone",
          "gamepad_get_button_threshold",
          "gamepad_get_description",
          "gamepad_get_device_count",
          "gamepad_is_connected",
          "gamepad_is_supported",
          "gamepad_set_axis_deadzone",
          "gamepad_set_button_threshold",
          "gamepad_set_color",
          "gamepad_set_colour",
          "gamepad_set_vibration",
          "gesture_double_tap_distance",
          "gesture_double_tap_time",
          "gesture_drag_distance",
          "gesture_drag_time",
          "gesture_flick_speed",
          "gesture_get_double_tap_distance",
          "gesture_get_double_tap_time",
          "gesture_get_drag_distance",
          "gesture_get_drag_time",
          "gesture_get_flick_speed",
          "gesture_get_pinch_angle_away",
          "gesture_get_pinch_angle_towards",
          "gesture_get_pinch_distance",
          "gesture_get_rotate_angle",
          "gesture_get_rotate_time",
          "gesture_get_tap_count",
          "gesture_pinch_angle_away",
          "gesture_pinch_angle_towards",
          "gesture_pinch_distance",
          "gesture_rotate_angle",
          "gesture_rotate_time",
          "gesture_tap_count",
          "get_integer",
          "get_integer_async",
          "get_login_async",
          "get_open_filename",
          "get_open_filename_ext",
          "get_save_filename",
          "get_save_filename_ext",
          "get_string",
          "get_string_async",
          "get_timer",
          "gml_pragma",
          "gml_release_mode",
          "gpu_get_alphatestenable",
          "gpu_get_alphatestfunc",
          "gpu_get_alphatestref",
          "gpu_get_blendenable",
          "gpu_get_blendmode",
          "gpu_get_blendmode_dest",
          "gpu_get_blendmode_destalpha",
          "gpu_get_blendmode_ext",
          "gpu_get_blendmode_ext_sepalpha",
          "gpu_get_blendmode_src",
          "gpu_get_blendmode_srcalpha",
          "gpu_get_colorwriteenable",
          "gpu_get_colourwriteenable",
          "gpu_get_cullmode",
          "gpu_get_fog",
          "gpu_get_lightingenable",
          "gpu_get_state",
          "gpu_get_tex_filter",
          "gpu_get_tex_filter_ext",
          "gpu_get_tex_max_aniso",
          "gpu_get_tex_max_aniso_ext",
          "gpu_get_tex_max_mip",
          "gpu_get_tex_max_mip_ext",
          "gpu_get_tex_min_mip",
          "gpu_get_tex_min_mip_ext",
          "gpu_get_tex_mip_bias",
          "gpu_get_tex_mip_bias_ext",
          "gpu_get_tex_mip_enable",
          "gpu_get_tex_mip_enable_ext",
          "gpu_get_tex_mip_filter",
          "gpu_get_tex_mip_filter_ext",
          "gpu_get_tex_repeat",
          "gpu_get_tex_repeat_ext",
          "gpu_get_texfilter",
          "gpu_get_texfilter_ext",
          "gpu_get_texrepeat",
          "gpu_get_texrepeat_ext",
          "gpu_get_zfunc",
          "gpu_get_ztestenable",
          "gpu_get_zwriteenable",
          "gpu_pop_state",
          "gpu_push_state",
          "gpu_set_alphatestenable",
          "gpu_set_alphatestfunc",
          "gpu_set_alphatestref",
          "gpu_set_blendenable",
          "gpu_set_blendmode",
          "gpu_set_blendmode_ext",
          "gpu_set_blendmode_ext_sepalpha",
          "gpu_set_colorwriteenable",
          "gpu_set_colourwriteenable",
          "gpu_set_cullmode",
          "gpu_set_fog",
          "gpu_set_lightingenable",
          "gpu_set_state",
          "gpu_set_tex_filter",
          "gpu_set_tex_filter_ext",
          "gpu_set_tex_max_aniso",
          "gpu_set_tex_max_aniso_ext",
          "gpu_set_tex_max_mip",
          "gpu_set_tex_max_mip_ext",
          "gpu_set_tex_min_mip",
          "gpu_set_tex_min_mip_ext",
          "gpu_set_tex_mip_bias",
          "gpu_set_tex_mip_bias_ext",
          "gpu_set_tex_mip_enable",
          "gpu_set_tex_mip_enable_ext",
          "gpu_set_tex_mip_filter",
          "gpu_set_tex_mip_filter_ext",
          "gpu_set_tex_repeat",
          "gpu_set_tex_repeat_ext",
          "gpu_set_texfilter",
          "gpu_set_texfilter_ext",
          "gpu_set_texrepeat",
          "gpu_set_texrepeat_ext",
          "gpu_set_zfunc",
          "gpu_set_ztestenable",
          "gpu_set_zwriteenable",
          "highscore_add",
          "highscore_clear",
          "highscore_name",
          "highscore_value",
          "http_get",
          "http_get_file",
          "http_post_string",
          "http_request",
          "iap_acquire",
          "iap_activate",
          "iap_consume",
          "iap_enumerate_products",
          "iap_product_details",
          "iap_purchase_details",
          "iap_restore_all",
          "iap_status",
          "ini_close",
          "ini_key_delete",
          "ini_key_exists",
          "ini_open",
          "ini_open_from_string",
          "ini_read_real",
          "ini_read_string",
          "ini_section_delete",
          "ini_section_exists",
          "ini_write_real",
          "ini_write_string",
          "instance_activate_all",
          "instance_activate_layer",
          "instance_activate_object",
          "instance_activate_region",
          "instance_change",
          "instance_copy",
          "instance_create",
          "instance_create_depth",
          "instance_create_layer",
          "instance_deactivate_all",
          "instance_deactivate_layer",
          "instance_deactivate_object",
          "instance_deactivate_region",
          "instance_destroy",
          "instance_exists",
          "instance_find",
          "instance_furthest",
          "instance_id_get",
          "instance_nearest",
          "instance_number",
          "instance_place",
          "instance_place_list",
          "instance_position",
          "instance_position_list",
          "int64",
          "io_clear",
          "irandom",
          "irandom_range",
          "is_array",
          "is_bool",
          "is_infinity",
          "is_int32",
          "is_int64",
          "is_matrix",
          "is_method",
          "is_nan",
          "is_numeric",
          "is_ptr",
          "is_real",
          "is_string",
          "is_struct",
          "is_undefined",
          "is_vec3",
          "is_vec4",
          "json_decode",
          "json_encode",
          "keyboard_check",
          "keyboard_check_direct",
          "keyboard_check_pressed",
          "keyboard_check_released",
          "keyboard_clear",
          "keyboard_get_map",
          "keyboard_get_numlock",
          "keyboard_key_press",
          "keyboard_key_release",
          "keyboard_set_map",
          "keyboard_set_numlock",
          "keyboard_unset_map",
          "keyboard_virtual_height",
          "keyboard_virtual_hide",
          "keyboard_virtual_show",
          "keyboard_virtual_status",
          "layer_add_instance",
          "layer_background_alpha",
          "layer_background_blend",
          "layer_background_change",
          "layer_background_create",
          "layer_background_destroy",
          "layer_background_exists",
          "layer_background_get_alpha",
          "layer_background_get_blend",
          "layer_background_get_htiled",
          "layer_background_get_id",
          "layer_background_get_index",
          "layer_background_get_speed",
          "layer_background_get_sprite",
          "layer_background_get_stretch",
          "layer_background_get_visible",
          "layer_background_get_vtiled",
          "layer_background_get_xscale",
          "layer_background_get_yscale",
          "layer_background_htiled",
          "layer_background_index",
          "layer_background_speed",
          "layer_background_sprite",
          "layer_background_stretch",
          "layer_background_visible",
          "layer_background_vtiled",
          "layer_background_xscale",
          "layer_background_yscale",
          "layer_create",
          "layer_depth",
          "layer_destroy",
          "layer_destroy_instances",
          "layer_element_move",
          "layer_exists",
          "layer_force_draw_depth",
          "layer_get_all",
          "layer_get_all_elements",
          "layer_get_depth",
          "layer_get_element_layer",
          "layer_get_element_type",
          "layer_get_forced_depth",
          "layer_get_hspeed",
          "layer_get_id",
          "layer_get_id_at_depth",
          "layer_get_name",
          "layer_get_script_begin",
          "layer_get_script_end",
          "layer_get_shader",
          "layer_get_target_room",
          "layer_get_visible",
          "layer_get_vspeed",
          "layer_get_x",
          "layer_get_y",
          "layer_has_instance",
          "layer_hspeed",
          "layer_instance_get_instance",
          "layer_is_draw_depth_forced",
          "layer_reset_target_room",
          "layer_script_begin",
          "layer_script_end",
          "layer_set_target_room",
          "layer_set_visible",
          "layer_shader",
          "layer_sprite_alpha",
          "layer_sprite_angle",
          "layer_sprite_blend",
          "layer_sprite_change",
          "layer_sprite_create",
          "layer_sprite_destroy",
          "layer_sprite_exists",
          "layer_sprite_get_alpha",
          "layer_sprite_get_angle",
          "layer_sprite_get_blend",
          "layer_sprite_get_id",
          "layer_sprite_get_index",
          "layer_sprite_get_speed",
          "layer_sprite_get_sprite",
          "layer_sprite_get_x",
          "layer_sprite_get_xscale",
          "layer_sprite_get_y",
          "layer_sprite_get_yscale",
          "layer_sprite_index",
          "layer_sprite_speed",
          "layer_sprite_x",
          "layer_sprite_xscale",
          "layer_sprite_y",
          "layer_sprite_yscale",
          "layer_tile_alpha",
          "layer_tile_blend",
          "layer_tile_change",
          "layer_tile_create",
          "layer_tile_destroy",
          "layer_tile_exists",
          "layer_tile_get_alpha",
          "layer_tile_get_blend",
          "layer_tile_get_region",
          "layer_tile_get_sprite",
          "layer_tile_get_visible",
          "layer_tile_get_x",
          "layer_tile_get_xscale",
          "layer_tile_get_y",
          "layer_tile_get_yscale",
          "layer_tile_region",
          "layer_tile_visible",
          "layer_tile_x",
          "layer_tile_xscale",
          "layer_tile_y",
          "layer_tile_yscale",
          "layer_tilemap_create",
          "layer_tilemap_destroy",
          "layer_tilemap_exists",
          "layer_tilemap_get_id",
          "layer_vspeed",
          "layer_x",
          "layer_y",
          "lengthdir_x",
          "lengthdir_y",
          "lerp",
          "ln",
          "load_csv",
          "log10",
          "log2",
          "logn",
          "make_color_hsv",
          "make_color_rgb",
          "make_colour_hsv",
          "make_colour_rgb",
          "math_get_epsilon",
          "math_set_epsilon",
          "matrix_build",
          "matrix_build_identity",
          "matrix_build_lookat",
          "matrix_build_projection_ortho",
          "matrix_build_projection_perspective",
          "matrix_build_projection_perspective_fov",
          "matrix_get",
          "matrix_multiply",
          "matrix_set",
          "matrix_stack_clear",
          "matrix_stack_is_empty",
          "matrix_stack_multiply",
          "matrix_stack_pop",
          "matrix_stack_push",
          "matrix_stack_set",
          "matrix_stack_top",
          "matrix_transform_vertex",
          "max",
          "md5_file",
          "md5_string_unicode",
          "md5_string_utf8",
          "mean",
          "median",
          "merge_color",
          "merge_colour",
          "min",
          "motion_add",
          "motion_set",
          "mouse_check_button",
          "mouse_check_button_pressed",
          "mouse_check_button_released",
          "mouse_clear",
          "mouse_wheel_down",
          "mouse_wheel_up",
          "move_bounce_all",
          "move_bounce_solid",
          "move_contact_all",
          "move_contact_solid",
          "move_outside_all",
          "move_outside_solid",
          "move_random",
          "move_snap",
          "move_towards_point",
          "move_wrap",
          "mp_grid_add_cell",
          "mp_grid_add_instances",
          "mp_grid_add_rectangle",
          "mp_grid_clear_all",
          "mp_grid_clear_cell",
          "mp_grid_clear_rectangle",
          "mp_grid_create",
          "mp_grid_destroy",
          "mp_grid_draw",
          "mp_grid_get_cell",
          "mp_grid_path",
          "mp_grid_to_ds_grid",
          "mp_linear_path",
          "mp_linear_path_object",
          "mp_linear_step",
          "mp_linear_step_object",
          "mp_potential_path",
          "mp_potential_path_object",
          "mp_potential_settings",
          "mp_potential_step",
          "mp_potential_step_object",
          "network_connect",
          "network_connect_raw",
          "network_create_server",
          "network_create_server_raw",
          "network_create_socket",
          "network_create_socket_ext",
          "network_destroy",
          "network_resolve",
          "network_send_broadcast",
          "network_send_packet",
          "network_send_raw",
          "network_send_udp",
          "network_send_udp_raw",
          "network_set_config",
          "network_set_timeout",
          "object_exists",
          "object_get_depth",
          "object_get_mask",
          "object_get_name",
          "object_get_parent",
          "object_get_persistent",
          "object_get_physics",
          "object_get_solid",
          "object_get_sprite",
          "object_get_visible",
          "object_is_ancestor",
          "object_set_mask",
          "object_set_persistent",
          "object_set_solid",
          "object_set_sprite",
          "object_set_visible",
          "ord",
          "os_get_config",
          "os_get_info",
          "os_get_language",
          "os_get_region",
          "os_is_network_connected",
          "os_is_paused",
          "os_lock_orientation",
          "os_powersave_enable",
          "parameter_count",
          "parameter_string",
          "part_emitter_burst",
          "part_emitter_clear",
          "part_emitter_create",
          "part_emitter_destroy",
          "part_emitter_destroy_all",
          "part_emitter_exists",
          "part_emitter_region",
          "part_emitter_stream",
          "part_particles_clear",
          "part_particles_count",
          "part_particles_create",
          "part_particles_create_color",
          "part_particles_create_colour",
          "part_system_automatic_draw",
          "part_system_automatic_update",
          "part_system_clear",
          "part_system_create",
          "part_system_create_layer",
          "part_system_depth",
          "part_system_destroy",
          "part_system_draw_order",
          "part_system_drawit",
          "part_system_exists",
          "part_system_get_layer",
          "part_system_layer",
          "part_system_position",
          "part_system_update",
          "part_type_alpha1",
          "part_type_alpha2",
          "part_type_alpha3",
          "part_type_blend",
          "part_type_clear",
          "part_type_color1",
          "part_type_color2",
          "part_type_color3",
          "part_type_color_hsv",
          "part_type_color_mix",
          "part_type_color_rgb",
          "part_type_colour1",
          "part_type_colour2",
          "part_type_colour3",
          "part_type_colour_hsv",
          "part_type_colour_mix",
          "part_type_colour_rgb",
          "part_type_create",
          "part_type_death",
          "part_type_destroy",
          "part_type_direction",
          "part_type_exists",
          "part_type_gravity",
          "part_type_life",
          "part_type_orientation",
          "part_type_scale",
          "part_type_shape",
          "part_type_size",
          "part_type_speed",
          "part_type_sprite",
          "part_type_step",
          "path_add",
          "path_add_point",
          "path_append",
          "path_assign",
          "path_change_point",
          "path_clear_points",
          "path_delete",
          "path_delete_point",
          "path_duplicate",
          "path_end",
          "path_exists",
          "path_flip",
          "path_get_closed",
          "path_get_kind",
          "path_get_length",
          "path_get_name",
          "path_get_number",
          "path_get_point_speed",
          "path_get_point_x",
          "path_get_point_y",
          "path_get_precision",
          "path_get_speed",
          "path_get_time",
          "path_get_x",
          "path_get_y",
          "path_insert_point",
          "path_mirror",
          "path_rescale",
          "path_reverse",
          "path_rotate",
          "path_set_closed",
          "path_set_kind",
          "path_set_precision",
          "path_shift",
          "path_start",
          "physics_apply_angular_impulse",
          "physics_apply_force",
          "physics_apply_impulse",
          "physics_apply_local_force",
          "physics_apply_local_impulse",
          "physics_apply_torque",
          "physics_draw_debug",
          "physics_fixture_add_point",
          "physics_fixture_bind",
          "physics_fixture_bind_ext",
          "physics_fixture_create",
          "physics_fixture_delete",
          "physics_fixture_set_angular_damping",
          "physics_fixture_set_awake",
          "physics_fixture_set_box_shape",
          "physics_fixture_set_chain_shape",
          "physics_fixture_set_circle_shape",
          "physics_fixture_set_collision_group",
          "physics_fixture_set_density",
          "physics_fixture_set_edge_shape",
          "physics_fixture_set_friction",
          "physics_fixture_set_kinematic",
          "physics_fixture_set_linear_damping",
          "physics_fixture_set_polygon_shape",
          "physics_fixture_set_restitution",
          "physics_fixture_set_sensor",
          "physics_get_density",
          "physics_get_friction",
          "physics_get_restitution",
          "physics_joint_delete",
          "physics_joint_distance_create",
          "physics_joint_enable_motor",
          "physics_joint_friction_create",
          "physics_joint_gear_create",
          "physics_joint_get_value",
          "physics_joint_prismatic_create",
          "physics_joint_pulley_create",
          "physics_joint_revolute_create",
          "physics_joint_rope_create",
          "physics_joint_set_value",
          "physics_joint_weld_create",
          "physics_joint_wheel_create",
          "physics_mass_properties",
          "physics_particle_count",
          "physics_particle_create",
          "physics_particle_delete",
          "physics_particle_delete_region_box",
          "physics_particle_delete_region_circle",
          "physics_particle_delete_region_poly",
          "physics_particle_draw",
          "physics_particle_draw_ext",
          "physics_particle_get_damping",
          "physics_particle_get_data",
          "physics_particle_get_data_particle",
          "physics_particle_get_density",
          "physics_particle_get_gravity_scale",
          "physics_particle_get_group_flags",
          "physics_particle_get_max_count",
          "physics_particle_get_radius",
          "physics_particle_group_add_point",
          "physics_particle_group_begin",
          "physics_particle_group_box",
          "physics_particle_group_circle",
          "physics_particle_group_count",
          "physics_particle_group_delete",
          "physics_particle_group_end",
          "physics_particle_group_get_ang_vel",
          "physics_particle_group_get_angle",
          "physics_particle_group_get_centre_x",
          "physics_particle_group_get_centre_y",
          "physics_particle_group_get_data",
          "physics_particle_group_get_inertia",
          "physics_particle_group_get_mass",
          "physics_particle_group_get_vel_x",
          "physics_particle_group_get_vel_y",
          "physics_particle_group_get_x",
          "physics_particle_group_get_y",
          "physics_particle_group_join",
          "physics_particle_group_polygon",
          "physics_particle_set_category_flags",
          "physics_particle_set_damping",
          "physics_particle_set_density",
          "physics_particle_set_flags",
          "physics_particle_set_gravity_scale",
          "physics_particle_set_group_flags",
          "physics_particle_set_max_count",
          "physics_particle_set_radius",
          "physics_pause_enable",
          "physics_remove_fixture",
          "physics_set_density",
          "physics_set_friction",
          "physics_set_restitution",
          "physics_test_overlap",
          "physics_world_create",
          "physics_world_draw_debug",
          "physics_world_gravity",
          "physics_world_update_iterations",
          "physics_world_update_speed",
          "place_empty",
          "place_free",
          "place_meeting",
          "place_snapped",
          "point_direction",
          "point_distance",
          "point_distance_3d",
          "point_in_circle",
          "point_in_rectangle",
          "point_in_triangle",
          "position_change",
          "position_destroy",
          "position_empty",
          "position_meeting",
          "power",
          "ptr",
          "push_cancel_local_notification",
          "push_get_first_local_notification",
          "push_get_next_local_notification",
          "push_local_notification",
          "radtodeg",
          "random",
          "random_get_seed",
          "random_range",
          "random_set_seed",
          "randomise",
          "randomize",
          "real",
          "rectangle_in_circle",
          "rectangle_in_rectangle",
          "rectangle_in_triangle",
          "room_add",
          "room_assign",
          "room_duplicate",
          "room_exists",
          "room_get_camera",
          "room_get_name",
          "room_get_viewport",
          "room_goto",
          "room_goto_next",
          "room_goto_previous",
          "room_instance_add",
          "room_instance_clear",
          "room_next",
          "room_previous",
          "room_restart",
          "room_set_background_color",
          "room_set_background_colour",
          "room_set_camera",
          "room_set_height",
          "room_set_persistent",
          "room_set_view",
          "room_set_view_enabled",
          "room_set_viewport",
          "room_set_width",
          "round",
          "screen_save",
          "screen_save_part",
          "script_execute",
          "script_exists",
          "script_get_name",
          "sha1_file",
          "sha1_string_unicode",
          "sha1_string_utf8",
          "shader_current",
          "shader_enable_corner_id",
          "shader_get_name",
          "shader_get_sampler_index",
          "shader_get_uniform",
          "shader_is_compiled",
          "shader_reset",
          "shader_set",
          "shader_set_uniform_f",
          "shader_set_uniform_f_array",
          "shader_set_uniform_i",
          "shader_set_uniform_i_array",
          "shader_set_uniform_matrix",
          "shader_set_uniform_matrix_array",
          "shaders_are_supported",
          "shop_leave_rating",
          "show_debug_message",
          "show_debug_overlay",
          "show_error",
          "show_message",
          "show_message_async",
          "show_question",
          "show_question_async",
          "sign",
          "sin",
          "skeleton_animation_clear",
          "skeleton_animation_get",
          "skeleton_animation_get_duration",
          "skeleton_animation_get_ext",
          "skeleton_animation_get_frame",
          "skeleton_animation_get_frames",
          "skeleton_animation_list",
          "skeleton_animation_mix",
          "skeleton_animation_set",
          "skeleton_animation_set_ext",
          "skeleton_animation_set_frame",
          "skeleton_attachment_create",
          "skeleton_attachment_get",
          "skeleton_attachment_set",
          "skeleton_bone_data_get",
          "skeleton_bone_data_set",
          "skeleton_bone_state_get",
          "skeleton_bone_state_set",
          "skeleton_collision_draw_set",
          "skeleton_get_bounds",
          "skeleton_get_minmax",
          "skeleton_get_num_bounds",
          "skeleton_skin_get",
          "skeleton_skin_list",
          "skeleton_skin_set",
          "skeleton_slot_data",
          "sprite_add",
          "sprite_add_from_surface",
          "sprite_assign",
          "sprite_collision_mask",
          "sprite_create_from_surface",
          "sprite_delete",
          "sprite_duplicate",
          "sprite_exists",
          "sprite_flush",
          "sprite_flush_multi",
          "sprite_get_bbox_bottom",
          "sprite_get_bbox_left",
          "sprite_get_bbox_right",
          "sprite_get_bbox_top",
          "sprite_get_height",
          "sprite_get_name",
          "sprite_get_number",
          "sprite_get_speed",
          "sprite_get_speed_type",
          "sprite_get_texture",
          "sprite_get_tpe",
          "sprite_get_uvs",
          "sprite_get_width",
          "sprite_get_xoffset",
          "sprite_get_yoffset",
          "sprite_merge",
          "sprite_prefetch",
          "sprite_prefetch_multi",
          "sprite_replace",
          "sprite_save",
          "sprite_save_strip",
          "sprite_set_alpha_from_sprite",
          "sprite_set_cache_size",
          "sprite_set_cache_size_ext",
          "sprite_set_offset",
          "sprite_set_speed",
          "sqr",
          "sqrt",
          "steam_activate_overlay",
          "steam_activate_overlay_browser",
          "steam_activate_overlay_store",
          "steam_activate_overlay_user",
          "steam_available_languages",
          "steam_clear_achievement",
          "steam_create_leaderboard",
          "steam_current_game_language",
          "steam_download_friends_scores",
          "steam_download_scores",
          "steam_download_scores_around_user",
          "steam_file_delete",
          "steam_file_exists",
          "steam_file_persisted",
          "steam_file_read",
          "steam_file_share",
          "steam_file_size",
          "steam_file_write",
          "steam_file_write_file",
          "steam_get_achievement",
          "steam_get_app_id",
          "steam_get_persona_name",
          "steam_get_quota_free",
          "steam_get_quota_total",
          "steam_get_stat_avg_rate",
          "steam_get_stat_float",
          "steam_get_stat_int",
          "steam_get_user_account_id",
          "steam_get_user_persona_name",
          "steam_get_user_steam_id",
          "steam_initialised",
          "steam_is_cloud_enabled_for_account",
          "steam_is_cloud_enabled_for_app",
          "steam_is_overlay_activated",
          "steam_is_overlay_enabled",
          "steam_is_screenshot_requested",
          "steam_is_user_logged_on",
          "steam_reset_all_stats",
          "steam_reset_all_stats_achievements",
          "steam_send_screenshot",
          "steam_set_achievement",
          "steam_set_stat_avg_rate",
          "steam_set_stat_float",
          "steam_set_stat_int",
          "steam_stats_ready",
          "steam_ugc_create_item",
          "steam_ugc_create_query_all",
          "steam_ugc_create_query_all_ex",
          "steam_ugc_create_query_user",
          "steam_ugc_create_query_user_ex",
          "steam_ugc_download",
          "steam_ugc_get_item_install_info",
          "steam_ugc_get_item_update_info",
          "steam_ugc_get_item_update_progress",
          "steam_ugc_get_subscribed_items",
          "steam_ugc_num_subscribed_items",
          "steam_ugc_query_add_excluded_tag",
          "steam_ugc_query_add_required_tag",
          "steam_ugc_query_set_allow_cached_response",
          "steam_ugc_query_set_cloud_filename_filter",
          "steam_ugc_query_set_match_any_tag",
          "steam_ugc_query_set_ranked_by_trend_days",
          "steam_ugc_query_set_return_long_description",
          "steam_ugc_query_set_return_total_only",
          "steam_ugc_query_set_search_text",
          "steam_ugc_request_item_details",
          "steam_ugc_send_query",
          "steam_ugc_set_item_content",
          "steam_ugc_set_item_description",
          "steam_ugc_set_item_preview",
          "steam_ugc_set_item_tags",
          "steam_ugc_set_item_title",
          "steam_ugc_set_item_visibility",
          "steam_ugc_start_item_update",
          "steam_ugc_submit_item_update",
          "steam_ugc_subscribe_item",
          "steam_ugc_unsubscribe_item",
          "steam_upload_score",
          "steam_upload_score_buffer",
          "steam_upload_score_buffer_ext",
          "steam_upload_score_ext",
          "steam_user_installed_dlc",
          "steam_user_owns_dlc",
          "string",
          "string_byte_at",
          "string_byte_length",
          "string_char_at",
          "string_copy",
          "string_count",
          "string_delete",
          "string_digits",
          "string_format",
          "string_hash_to_newline",
          "string_height",
          "string_height_ext",
          "string_insert",
          "string_length",
          "string_letters",
          "string_lettersdigits",
          "string_lower",
          "string_ord_at",
          "string_pos",
          "string_repeat",
          "string_replace",
          "string_replace_all",
          "string_set_byte_at",
          "string_upper",
          "string_width",
          "string_width_ext",
          "surface_copy",
          "surface_copy_part",
          "surface_create",
          "surface_create_ext",
          "surface_depth_disable",
          "surface_exists",
          "surface_free",
          "surface_get_depth_disable",
          "surface_get_height",
          "surface_get_texture",
          "surface_get_width",
          "surface_getpixel",
          "surface_getpixel_ext",
          "surface_reset_target",
          "surface_resize",
          "surface_save",
          "surface_save_part",
          "surface_set_target",
          "surface_set_target_ext",
          "tan",
          "texture_get_height",
          "texture_get_texel_height",
          "texture_get_texel_width",
          "texture_get_uvs",
          "texture_get_width",
          "texture_global_scale",
          "texture_set_stage",
          "tile_get_empty",
          "tile_get_flip",
          "tile_get_index",
          "tile_get_mirror",
          "tile_get_rotate",
          "tile_set_empty",
          "tile_set_flip",
          "tile_set_index",
          "tile_set_mirror",
          "tile_set_rotate",
          "tilemap_clear",
          "tilemap_get",
          "tilemap_get_at_pixel",
          "tilemap_get_cell_x_at_pixel",
          "tilemap_get_cell_y_at_pixel",
          "tilemap_get_frame",
          "tilemap_get_global_mask",
          "tilemap_get_height",
          "tilemap_get_mask",
          "tilemap_get_tile_height",
          "tilemap_get_tile_width",
          "tilemap_get_tileset",
          "tilemap_get_width",
          "tilemap_get_x",
          "tilemap_get_y",
          "tilemap_set",
          "tilemap_set_at_pixel",
          "tilemap_set_global_mask",
          "tilemap_set_mask",
          "tilemap_tileset",
          "tilemap_x",
          "tilemap_y",
          "timeline_add",
          "timeline_clear",
          "timeline_delete",
          "timeline_exists",
          "timeline_get_name",
          "timeline_max_moment",
          "timeline_moment_add_script",
          "timeline_moment_clear",
          "timeline_size",
          "typeof",
          "url_get_domain",
          "url_open",
          "url_open_ext",
          "url_open_full",
          "variable_global_exists",
          "variable_global_get",
          "variable_global_set",
          "variable_instance_exists",
          "variable_instance_get",
          "variable_instance_get_names",
          "variable_instance_set",
          "variable_struct_exists",
          "variable_struct_get",
          "variable_struct_get_names",
          "variable_struct_names_count",
          "variable_struct_remove",
          "variable_struct_set",
          "vertex_argb",
          "vertex_begin",
          "vertex_color",
          "vertex_colour",
          "vertex_create_buffer",
          "vertex_create_buffer_ext",
          "vertex_create_buffer_from_buffer",
          "vertex_create_buffer_from_buffer_ext",
          "vertex_delete_buffer",
          "vertex_end",
          "vertex_float1",
          "vertex_float2",
          "vertex_float3",
          "vertex_float4",
          "vertex_format_add_color",
          "vertex_format_add_colour",
          "vertex_format_add_custom",
          "vertex_format_add_normal",
          "vertex_format_add_position",
          "vertex_format_add_position_3d",
          "vertex_format_add_texcoord",
          "vertex_format_add_textcoord",
          "vertex_format_begin",
          "vertex_format_delete",
          "vertex_format_end",
          "vertex_freeze",
          "vertex_get_buffer_size",
          "vertex_get_number",
          "vertex_normal",
          "vertex_position",
          "vertex_position_3d",
          "vertex_submit",
          "vertex_texcoord",
          "vertex_ubyte4",
          "view_get_camera",
          "view_get_hport",
          "view_get_surface_id",
          "view_get_visible",
          "view_get_wport",
          "view_get_xport",
          "view_get_yport",
          "view_set_camera",
          "view_set_hport",
          "view_set_surface_id",
          "view_set_visible",
          "view_set_wport",
          "view_set_xport",
          "view_set_yport",
          "virtual_key_add",
          "virtual_key_delete",
          "virtual_key_hide",
          "virtual_key_show",
          "win8_appbar_add_element",
          "win8_appbar_enable",
          "win8_appbar_remove_element",
          "win8_device_touchscreen_available",
          "win8_license_initialize_sandbox",
          "win8_license_trial_version",
          "win8_livetile_badge_clear",
          "win8_livetile_badge_notification",
          "win8_livetile_notification_begin",
          "win8_livetile_notification_end",
          "win8_livetile_notification_expiry",
          "win8_livetile_notification_image_add",
          "win8_livetile_notification_secondary_begin",
          "win8_livetile_notification_tag",
          "win8_livetile_notification_text_add",
          "win8_livetile_queue_enable",
          "win8_livetile_tile_clear",
          "win8_livetile_tile_notification",
          "win8_search_add_suggestions",
          "win8_search_disable",
          "win8_search_enable",
          "win8_secondarytile_badge_notification",
          "win8_secondarytile_delete",
          "win8_secondarytile_pin",
          "win8_settingscharm_add_entry",
          "win8_settingscharm_add_html_entry",
          "win8_settingscharm_add_xaml_entry",
          "win8_settingscharm_get_xaml_property",
          "win8_settingscharm_remove_entry",
          "win8_settingscharm_set_xaml_property",
          "win8_share_file",
          "win8_share_image",
          "win8_share_screenshot",
          "win8_share_text",
          "win8_share_url",
          "window_center",
          "window_device",
          "window_get_caption",
          "window_get_color",
          "window_get_colour",
          "window_get_cursor",
          "window_get_fullscreen",
          "window_get_height",
          "window_get_visible_rects",
          "window_get_width",
          "window_get_x",
          "window_get_y",
          "window_handle",
          "window_has_focus",
          "window_mouse_get_x",
          "window_mouse_get_y",
          "window_mouse_set",
          "window_set_caption",
          "window_set_color",
          "window_set_colour",
          "window_set_cursor",
          "window_set_fullscreen",
          "window_set_max_height",
          "window_set_max_width",
          "window_set_min_height",
          "window_set_min_width",
          "window_set_position",
          "window_set_rectangle",
          "window_set_size",
          "window_view_mouse_get_x",
          "window_view_mouse_get_y",
          "window_views_mouse_get_x",
          "window_views_mouse_get_y",
          "winphone_license_trial_version",
          "winphone_tile_back_content",
          "winphone_tile_back_content_wide",
          "winphone_tile_back_image",
          "winphone_tile_back_image_wide",
          "winphone_tile_back_title",
          "winphone_tile_background_color",
          "winphone_tile_background_colour",
          "winphone_tile_count",
          "winphone_tile_cycle_images",
          "winphone_tile_front_image",
          "winphone_tile_front_image_small",
          "winphone_tile_front_image_wide",
          "winphone_tile_icon_image",
          "winphone_tile_small_background_image",
          "winphone_tile_small_icon_image",
          "winphone_tile_title",
          "winphone_tile_wide_content",
          "zip_unzip"
        ],
        literal: [
          "all",
          "false",
          "noone",
          "pointer_invalid",
          "pointer_null",
          "true",
          "undefined"
        ],
        symbol: [
          "ANSI_CHARSET",
          "ARABIC_CHARSET",
          "BALTIC_CHARSET",
          "CHINESEBIG5_CHARSET",
          "DEFAULT_CHARSET",
          "EASTEUROPE_CHARSET",
          "GB2312_CHARSET",
          "GM_build_date",
          "GM_runtime_version",
          "GM_version",
          "GREEK_CHARSET",
          "HANGEUL_CHARSET",
          "HEBREW_CHARSET",
          "JOHAB_CHARSET",
          "MAC_CHARSET",
          "OEM_CHARSET",
          "RUSSIAN_CHARSET",
          "SHIFTJIS_CHARSET",
          "SYMBOL_CHARSET",
          "THAI_CHARSET",
          "TURKISH_CHARSET",
          "VIETNAMESE_CHARSET",
          "achievement_achievement_info",
          "achievement_filter_all_players",
          "achievement_filter_favorites_only",
          "achievement_filter_friends_only",
          "achievement_friends_info",
          "achievement_leaderboard_info",
          "achievement_our_info",
          "achievement_pic_loaded",
          "achievement_show_achievement",
          "achievement_show_bank",
          "achievement_show_friend_picker",
          "achievement_show_leaderboard",
          "achievement_show_profile",
          "achievement_show_purchase_prompt",
          "achievement_show_ui",
          "achievement_type_achievement_challenge",
          "achievement_type_score_challenge",
          "asset_font",
          "asset_object",
          "asset_path",
          "asset_room",
          "asset_script",
          "asset_shader",
          "asset_sound",
          "asset_sprite",
          "asset_tiles",
          "asset_timeline",
          "asset_unknown",
          "audio_3d",
          "audio_falloff_exponent_distance",
          "audio_falloff_exponent_distance_clamped",
          "audio_falloff_inverse_distance",
          "audio_falloff_inverse_distance_clamped",
          "audio_falloff_linear_distance",
          "audio_falloff_linear_distance_clamped",
          "audio_falloff_none",
          "audio_mono",
          "audio_new_system",
          "audio_old_system",
          "audio_stereo",
          "bm_add",
          "bm_complex",
          "bm_dest_alpha",
          "bm_dest_color",
          "bm_dest_colour",
          "bm_inv_dest_alpha",
          "bm_inv_dest_color",
          "bm_inv_dest_colour",
          "bm_inv_src_alpha",
          "bm_inv_src_color",
          "bm_inv_src_colour",
          "bm_max",
          "bm_normal",
          "bm_one",
          "bm_src_alpha",
          "bm_src_alpha_sat",
          "bm_src_color",
          "bm_src_colour",
          "bm_subtract",
          "bm_zero",
          "browser_chrome",
          "browser_edge",
          "browser_firefox",
          "browser_ie",
          "browser_ie_mobile",
          "browser_not_a_browser",
          "browser_opera",
          "browser_safari",
          "browser_safari_mobile",
          "browser_tizen",
          "browser_unknown",
          "browser_windows_store",
          "buffer_bool",
          "buffer_f16",
          "buffer_f32",
          "buffer_f64",
          "buffer_fast",
          "buffer_fixed",
          "buffer_generalerror",
          "buffer_grow",
          "buffer_invalidtype",
          "buffer_network",
          "buffer_outofbounds",
          "buffer_outofspace",
          "buffer_s16",
          "buffer_s32",
          "buffer_s8",
          "buffer_seek_end",
          "buffer_seek_relative",
          "buffer_seek_start",
          "buffer_string",
          "buffer_surface_copy",
          "buffer_text",
          "buffer_u16",
          "buffer_u32",
          "buffer_u64",
          "buffer_u8",
          "buffer_vbuffer",
          "buffer_wrap",
          "button_type",
          "c_aqua",
          "c_black",
          "c_blue",
          "c_dkgray",
          "c_fuchsia",
          "c_gray",
          "c_green",
          "c_lime",
          "c_ltgray",
          "c_maroon",
          "c_navy",
          "c_olive",
          "c_orange",
          "c_purple",
          "c_red",
          "c_silver",
          "c_teal",
          "c_white",
          "c_yellow",
          "cmpfunc_always",
          "cmpfunc_equal",
          "cmpfunc_greater",
          "cmpfunc_greaterequal",
          "cmpfunc_less",
          "cmpfunc_lessequal",
          "cmpfunc_never",
          "cmpfunc_notequal",
          "cr_appstart",
          "cr_arrow",
          "cr_beam",
          "cr_cross",
          "cr_default",
          "cr_drag",
          "cr_handpoint",
          "cr_hourglass",
          "cr_none",
          "cr_size_all",
          "cr_size_nesw",
          "cr_size_ns",
          "cr_size_nwse",
          "cr_size_we",
          "cr_uparrow",
          "cull_clockwise",
          "cull_counterclockwise",
          "cull_noculling",
          "device_emulator",
          "device_ios_ipad",
          "device_ios_ipad_retina",
          "device_ios_iphone",
          "device_ios_iphone5",
          "device_ios_iphone6",
          "device_ios_iphone6plus",
          "device_ios_iphone_retina",
          "device_ios_unknown",
          "device_tablet",
          "display_landscape",
          "display_landscape_flipped",
          "display_portrait",
          "display_portrait_flipped",
          "dll_cdecl",
          "dll_stdcall",
          "ds_type_grid",
          "ds_type_list",
          "ds_type_map",
          "ds_type_priority",
          "ds_type_queue",
          "ds_type_stack",
          "ef_cloud",
          "ef_ellipse",
          "ef_explosion",
          "ef_firework",
          "ef_flare",
          "ef_rain",
          "ef_ring",
          "ef_smoke",
          "ef_smokeup",
          "ef_snow",
          "ef_spark",
          "ef_star",
          // for example ev_ are types of events
          "ev_alarm",
          "ev_animation_end",
          "ev_boundary",
          "ev_cleanup",
          "ev_close_button",
          "ev_collision",
          "ev_create",
          "ev_destroy",
          "ev_draw",
          "ev_draw_begin",
          "ev_draw_end",
          "ev_draw_post",
          "ev_draw_pre",
          "ev_end_of_path",
          "ev_game_end",
          "ev_game_start",
          "ev_gesture",
          "ev_gesture_double_tap",
          "ev_gesture_drag_end",
          "ev_gesture_drag_start",
          "ev_gesture_dragging",
          "ev_gesture_flick",
          "ev_gesture_pinch_end",
          "ev_gesture_pinch_in",
          "ev_gesture_pinch_out",
          "ev_gesture_pinch_start",
          "ev_gesture_rotate_end",
          "ev_gesture_rotate_start",
          "ev_gesture_rotating",
          "ev_gesture_tap",
          "ev_global_gesture_double_tap",
          "ev_global_gesture_drag_end",
          "ev_global_gesture_drag_start",
          "ev_global_gesture_dragging",
          "ev_global_gesture_flick",
          "ev_global_gesture_pinch_end",
          "ev_global_gesture_pinch_in",
          "ev_global_gesture_pinch_out",
          "ev_global_gesture_pinch_start",
          "ev_global_gesture_rotate_end",
          "ev_global_gesture_rotate_start",
          "ev_global_gesture_rotating",
          "ev_global_gesture_tap",
          "ev_global_left_button",
          "ev_global_left_press",
          "ev_global_left_release",
          "ev_global_middle_button",
          "ev_global_middle_press",
          "ev_global_middle_release",
          "ev_global_right_button",
          "ev_global_right_press",
          "ev_global_right_release",
          "ev_gui",
          "ev_gui_begin",
          "ev_gui_end",
          "ev_joystick1_button1",
          "ev_joystick1_button2",
          "ev_joystick1_button3",
          "ev_joystick1_button4",
          "ev_joystick1_button5",
          "ev_joystick1_button6",
          "ev_joystick1_button7",
          "ev_joystick1_button8",
          "ev_joystick1_down",
          "ev_joystick1_left",
          "ev_joystick1_right",
          "ev_joystick1_up",
          "ev_joystick2_button1",
          "ev_joystick2_button2",
          "ev_joystick2_button3",
          "ev_joystick2_button4",
          "ev_joystick2_button5",
          "ev_joystick2_button6",
          "ev_joystick2_button7",
          "ev_joystick2_button8",
          "ev_joystick2_down",
          "ev_joystick2_left",
          "ev_joystick2_right",
          "ev_joystick2_up",
          "ev_keyboard",
          "ev_keypress",
          "ev_keyrelease",
          "ev_left_button",
          "ev_left_press",
          "ev_left_release",
          "ev_middle_button",
          "ev_middle_press",
          "ev_middle_release",
          "ev_mouse",
          "ev_mouse_enter",
          "ev_mouse_leave",
          "ev_mouse_wheel_down",
          "ev_mouse_wheel_up",
          "ev_no_button",
          "ev_no_more_health",
          "ev_no_more_lives",
          "ev_other",
          "ev_outside",
          "ev_right_button",
          "ev_right_press",
          "ev_right_release",
          "ev_room_end",
          "ev_room_start",
          "ev_step",
          "ev_step_begin",
          "ev_step_end",
          "ev_step_normal",
          "ev_trigger",
          "ev_user0",
          "ev_user1",
          "ev_user2",
          "ev_user3",
          "ev_user4",
          "ev_user5",
          "ev_user6",
          "ev_user7",
          "ev_user8",
          "ev_user9",
          "ev_user10",
          "ev_user11",
          "ev_user12",
          "ev_user13",
          "ev_user14",
          "ev_user15",
          "fa_archive",
          "fa_bottom",
          "fa_center",
          "fa_directory",
          "fa_hidden",
          "fa_left",
          "fa_middle",
          "fa_readonly",
          "fa_right",
          "fa_sysfile",
          "fa_top",
          "fa_volumeid",
          "fb_login_default",
          "fb_login_fallback_to_webview",
          "fb_login_forcing_safari",
          "fb_login_forcing_webview",
          "fb_login_no_fallback_to_webview",
          "fb_login_use_system_account",
          "gamespeed_fps",
          "gamespeed_microseconds",
          "ge_lose",
          "global",
          "gp_axislh",
          "gp_axislv",
          "gp_axisrh",
          "gp_axisrv",
          "gp_face1",
          "gp_face2",
          "gp_face3",
          "gp_face4",
          "gp_padd",
          "gp_padl",
          "gp_padr",
          "gp_padu",
          "gp_select",
          "gp_shoulderl",
          "gp_shoulderlb",
          "gp_shoulderr",
          "gp_shoulderrb",
          "gp_start",
          "gp_stickl",
          "gp_stickr",
          "iap_available",
          "iap_canceled",
          "iap_ev_consume",
          "iap_ev_product",
          "iap_ev_purchase",
          "iap_ev_restore",
          "iap_ev_storeload",
          "iap_failed",
          "iap_purchased",
          "iap_refunded",
          "iap_status_available",
          "iap_status_loading",
          "iap_status_processing",
          "iap_status_restoring",
          "iap_status_unavailable",
          "iap_status_uninitialised",
          "iap_storeload_failed",
          "iap_storeload_ok",
          "iap_unavailable",
          "input_type",
          "kbv_autocapitalize_characters",
          "kbv_autocapitalize_none",
          "kbv_autocapitalize_sentences",
          "kbv_autocapitalize_words",
          "kbv_returnkey_continue",
          "kbv_returnkey_default",
          "kbv_returnkey_done",
          "kbv_returnkey_emergency",
          "kbv_returnkey_go",
          "kbv_returnkey_google",
          "kbv_returnkey_join",
          "kbv_returnkey_next",
          "kbv_returnkey_route",
          "kbv_returnkey_search",
          "kbv_returnkey_send",
          "kbv_returnkey_yahoo",
          "kbv_type_ascii",
          "kbv_type_default",
          "kbv_type_email",
          "kbv_type_numbers",
          "kbv_type_phone",
          "kbv_type_phone_name",
          "kbv_type_url",
          "layerelementtype_background",
          "layerelementtype_instance",
          "layerelementtype_oldtilemap",
          "layerelementtype_particlesystem",
          "layerelementtype_sprite",
          "layerelementtype_tile",
          "layerelementtype_tilemap",
          "layerelementtype_undefined",
          "lb_disp_none",
          "lb_disp_numeric",
          "lb_disp_time_ms",
          "lb_disp_time_sec",
          "lb_sort_ascending",
          "lb_sort_descending",
          "lb_sort_none",
          "leaderboard_type_number",
          "leaderboard_type_time_mins_secs",
          "lighttype_dir",
          "lighttype_point",
          "local",
          "matrix_projection",
          "matrix_view",
          "matrix_world",
          "mb_any",
          "mb_left",
          "mb_middle",
          "mb_none",
          "mb_right",
          "mip_markedonly",
          "mip_off",
          "mip_on",
          "network_config_connect_timeout",
          "network_config_disable_reliable_udp",
          "network_config_enable_reliable_udp",
          "network_config_use_non_blocking_socket",
          "network_socket_bluetooth",
          "network_socket_tcp",
          "network_socket_udp",
          "network_type_connect",
          "network_type_data",
          "network_type_disconnect",
          "network_type_non_blocking_connect",
          "of_challen",
          "of_challenge_tie",
          "of_challenge_win",
          "os_3ds",
          "os_android",
          "os_bb10",
          "os_ios",
          "os_linux",
          "os_macosx",
          "os_ps3",
          "os_ps4",
          "os_psvita",
          "os_switch",
          "os_symbian",
          "os_tizen",
          "os_tvos",
          "os_unknown",
          "os_uwp",
          "os_wiiu",
          "os_win32",
          "os_win8native",
          "os_windows",
          "os_winphone",
          "os_xbox360",
          "os_xboxone",
          "other",
          "ov_achievements",
          "ov_community",
          "ov_friends",
          "ov_gamegroup",
          "ov_players",
          "ov_settings",
          "path_action_continue",
          "path_action_restart",
          "path_action_reverse",
          "path_action_stop",
          "phy_debug_render_aabb",
          "phy_debug_render_collision_pairs",
          "phy_debug_render_coms",
          "phy_debug_render_core_shapes",
          "phy_debug_render_joints",
          "phy_debug_render_obb",
          "phy_debug_render_shapes",
          "phy_joint_anchor_1_x",
          "phy_joint_anchor_1_y",
          "phy_joint_anchor_2_x",
          "phy_joint_anchor_2_y",
          "phy_joint_angle",
          "phy_joint_angle_limits",
          "phy_joint_damping_ratio",
          "phy_joint_frequency",
          "phy_joint_length_1",
          "phy_joint_length_2",
          "phy_joint_lower_angle_limit",
          "phy_joint_max_force",
          "phy_joint_max_length",
          "phy_joint_max_motor_force",
          "phy_joint_max_motor_torque",
          "phy_joint_max_torque",
          "phy_joint_motor_force",
          "phy_joint_motor_speed",
          "phy_joint_motor_torque",
          "phy_joint_reaction_force_x",
          "phy_joint_reaction_force_y",
          "phy_joint_reaction_torque",
          "phy_joint_speed",
          "phy_joint_translation",
          "phy_joint_upper_angle_limit",
          "phy_particle_data_flag_category",
          "phy_particle_data_flag_color",
          "phy_particle_data_flag_colour",
          "phy_particle_data_flag_position",
          "phy_particle_data_flag_typeflags",
          "phy_particle_data_flag_velocity",
          "phy_particle_flag_colormixing",
          "phy_particle_flag_colourmixing",
          "phy_particle_flag_elastic",
          "phy_particle_flag_powder",
          "phy_particle_flag_spring",
          "phy_particle_flag_tensile",
          "phy_particle_flag_viscous",
          "phy_particle_flag_wall",
          "phy_particle_flag_water",
          "phy_particle_flag_zombie",
          "phy_particle_group_flag_rigid",
          "phy_particle_group_flag_solid",
          "pi",
          "pr_linelist",
          "pr_linestrip",
          "pr_pointlist",
          "pr_trianglefan",
          "pr_trianglelist",
          "pr_trianglestrip",
          "ps_distr_gaussian",
          "ps_distr_invgaussian",
          "ps_distr_linear",
          "ps_shape_diamond",
          "ps_shape_ellipse",
          "ps_shape_line",
          "ps_shape_rectangle",
          "pt_shape_circle",
          "pt_shape_cloud",
          "pt_shape_disk",
          "pt_shape_explosion",
          "pt_shape_flare",
          "pt_shape_line",
          "pt_shape_pixel",
          "pt_shape_ring",
          "pt_shape_smoke",
          "pt_shape_snow",
          "pt_shape_spark",
          "pt_shape_sphere",
          "pt_shape_square",
          "pt_shape_star",
          "spritespeed_framespergameframe",
          "spritespeed_framespersecond",
          "text_type",
          "tf_anisotropic",
          "tf_linear",
          "tf_point",
          "tile_flip",
          "tile_index_mask",
          "tile_mirror",
          "tile_rotate",
          "timezone_local",
          "timezone_utc",
          "tm_countvsyncs",
          "tm_sleep",
          "ty_real",
          "ty_string",
          "ugc_filetype_community",
          "ugc_filetype_microtrans",
          "ugc_list_Favorited",
          "ugc_list_Followed",
          "ugc_list_Published",
          "ugc_list_Subscribed",
          "ugc_list_UsedOrPlayed",
          "ugc_list_VotedDown",
          "ugc_list_VotedOn",
          "ugc_list_VotedUp",
          "ugc_list_WillVoteLater",
          "ugc_match_AllGuides",
          "ugc_match_Artwork",
          "ugc_match_Collections",
          "ugc_match_ControllerBindings",
          "ugc_match_IntegratedGuides",
          "ugc_match_Items",
          "ugc_match_Items_Mtx",
          "ugc_match_Items_ReadyToUse",
          "ugc_match_Screenshots",
          "ugc_match_UsableInGame",
          "ugc_match_Videos",
          "ugc_match_WebGuides",
          "ugc_query_AcceptedForGameRankedByAcceptanceDate",
          "ugc_query_CreatedByFollowedUsersRankedByPublicationDate",
          "ugc_query_CreatedByFriendsRankedByPublicationDate",
          "ugc_query_FavoritedByFriendsRankedByPublicationDate",
          "ugc_query_NotYetRated",
          "ugc_query_RankedByNumTimesReported",
          "ugc_query_RankedByPublicationDate",
          "ugc_query_RankedByTextSearch",
          "ugc_query_RankedByTotalVotesAsc",
          "ugc_query_RankedByTrend",
          "ugc_query_RankedByVote",
          "ugc_query_RankedByVotesUp",
          "ugc_result_success",
          "ugc_sortorder_CreationOrderAsc",
          "ugc_sortorder_CreationOrderDesc",
          "ugc_sortorder_ForModeration",
          "ugc_sortorder_LastUpdatedDesc",
          "ugc_sortorder_SubscriptionDateDesc",
          "ugc_sortorder_TitleAsc",
          "ugc_sortorder_VoteScoreDesc",
          "ugc_visibility_friends_only",
          "ugc_visibility_private",
          "ugc_visibility_public",
          "vertex_type_color",
          "vertex_type_colour",
          "vertex_type_float1",
          "vertex_type_float2",
          "vertex_type_float3",
          "vertex_type_float4",
          "vertex_type_ubyte4",
          "vertex_usage_binormal",
          "vertex_usage_blendindices",
          "vertex_usage_blendweight",
          "vertex_usage_color",
          "vertex_usage_colour",
          "vertex_usage_depth",
          "vertex_usage_fog",
          "vertex_usage_normal",
          "vertex_usage_position",
          "vertex_usage_psize",
          "vertex_usage_sample",
          "vertex_usage_tangent",
          "vertex_usage_texcoord",
          "vertex_usage_textcoord",
          "vk_add",
          "vk_alt",
          "vk_anykey",
          "vk_backspace",
          "vk_control",
          "vk_decimal",
          "vk_delete",
          "vk_divide",
          "vk_down",
          "vk_end",
          "vk_enter",
          "vk_escape",
          "vk_f1",
          "vk_f2",
          "vk_f3",
          "vk_f4",
          "vk_f5",
          "vk_f6",
          "vk_f7",
          "vk_f8",
          "vk_f9",
          "vk_f10",
          "vk_f11",
          "vk_f12",
          "vk_home",
          "vk_insert",
          "vk_lalt",
          "vk_lcontrol",
          "vk_left",
          "vk_lshift",
          "vk_multiply",
          "vk_nokey",
          "vk_numpad0",
          "vk_numpad1",
          "vk_numpad2",
          "vk_numpad3",
          "vk_numpad4",
          "vk_numpad5",
          "vk_numpad6",
          "vk_numpad7",
          "vk_numpad8",
          "vk_numpad9",
          "vk_pagedown",
          "vk_pageup",
          "vk_pause",
          "vk_printscreen",
          "vk_ralt",
          "vk_rcontrol",
          "vk_return",
          "vk_right",
          "vk_rshift",
          "vk_shift",
          "vk_space",
          "vk_subtract",
          "vk_tab",
          "vk_up"
        ],
        "variable.language": [
          "alarm",
          "application_surface",
          "argument",
          "argument0",
          "argument1",
          "argument2",
          "argument3",
          "argument4",
          "argument5",
          "argument6",
          "argument7",
          "argument8",
          "argument9",
          "argument10",
          "argument11",
          "argument12",
          "argument13",
          "argument14",
          "argument15",
          "argument_count",
          "argument_relative",
          "async_load",
          "background_color",
          "background_colour",
          "background_showcolor",
          "background_showcolour",
          "bbox_bottom",
          "bbox_left",
          "bbox_right",
          "bbox_top",
          "browser_height",
          "browser_width",
          "caption_health",
          "caption_lives",
          "caption_score",
          "current_day",
          "current_hour",
          "current_minute",
          "current_month",
          "current_second",
          "current_time",
          "current_weekday",
          "current_year",
          "cursor_sprite",
          "debug_mode",
          "delta_time",
          "depth",
          "direction",
          "display_aa",
          "error_last",
          "error_occurred",
          "event_action",
          "event_data",
          "event_number",
          "event_object",
          "event_type",
          "fps",
          "fps_real",
          "friction",
          "game_display_name",
          "game_id",
          "game_project_name",
          "game_save_id",
          "gamemaker_pro",
          "gamemaker_registered",
          "gamemaker_version",
          "gravity",
          "gravity_direction",
          "health",
          "hspeed",
          "iap_data",
          "id|0",
          "image_alpha",
          "image_angle",
          "image_blend",
          "image_index",
          "image_number",
          "image_speed",
          "image_xscale",
          "image_yscale",
          "instance_count",
          "instance_id",
          "keyboard_key",
          "keyboard_lastchar",
          "keyboard_lastkey",
          "keyboard_string",
          "layer",
          "lives",
          "mask_index",
          "mouse_button",
          "mouse_lastbutton",
          "mouse_x",
          "mouse_y",
          "object_index",
          "os_browser",
          "os_device",
          "os_type",
          "os_version",
          "path_endaction",
          "path_index",
          "path_orientation",
          "path_position",
          "path_positionprevious",
          "path_scale",
          "path_speed",
          "persistent",
          "phy_active",
          "phy_angular_damping",
          "phy_angular_velocity",
          "phy_bullet",
          "phy_col_normal_x",
          "phy_col_normal_y",
          "phy_collision_points",
          "phy_collision_x",
          "phy_collision_y",
          "phy_com_x",
          "phy_com_y",
          "phy_dynamic",
          "phy_fixed_rotation",
          "phy_inertia",
          "phy_kinematic",
          "phy_linear_damping",
          "phy_linear_velocity_x",
          "phy_linear_velocity_y",
          "phy_mass",
          "phy_position_x",
          "phy_position_xprevious",
          "phy_position_y",
          "phy_position_yprevious",
          "phy_rotation",
          "phy_sleeping",
          "phy_speed",
          "phy_speed_x",
          "phy_speed_y",
          "program_directory",
          "room",
          "room_caption",
          "room_first",
          "room_height",
          "room_last",
          "room_persistent",
          "room_speed",
          "room_width",
          "score",
          "self",
          "show_health",
          "show_lives",
          "show_score",
          "solid",
          "speed",
          "sprite_height",
          "sprite_index",
          "sprite_width",
          "sprite_xoffset",
          "sprite_yoffset",
          "temp_directory",
          "timeline_index",
          "timeline_loop",
          "timeline_position",
          "timeline_running",
          "timeline_speed",
          "view_angle",
          "view_camera",
          "view_current",
          "view_enabled",
          "view_hborder",
          "view_hport",
          "view_hspeed",
          "view_hview",
          "view_object",
          "view_surface_id",
          "view_vborder",
          "view_visible",
          "view_vspeed",
          "view_wport",
          "view_wview",
          "view_xport",
          "view_xview",
          "view_yport",
          "view_yview",
          "visible",
          "vspeed",
          "webgl_enabled",
          "working_directory",
          "xprevious",
          "xstart",
          "x|0",
          "yprevious",
          "ystart",
          "y|0"
        ]
      },
      contains: [
        i.C_LINE_COMMENT_MODE,
        i.C_BLOCK_COMMENT_MODE,
        i.APOS_STRING_MODE,
        i.QUOTE_STRING_MODE,
        i.C_NUMBER_MODE
      ]
    };
  }
  return Ou = s, Ou;
}
var yu, tb;
function dP() {
  if (tb)
    return yu;
  tb = 1;
  function s(i) {
    const g = {
      keyword: [
        "break",
        "case",
        "chan",
        "const",
        "continue",
        "default",
        "defer",
        "else",
        "fallthrough",
        "for",
        "func",
        "go",
        "goto",
        "if",
        "import",
        "interface",
        "map",
        "package",
        "range",
        "return",
        "select",
        "struct",
        "switch",
        "type",
        "var"
      ],
      type: [
        "bool",
        "byte",
        "complex64",
        "complex128",
        "error",
        "float32",
        "float64",
        "int8",
        "int16",
        "int32",
        "int64",
        "string",
        "uint8",
        "uint16",
        "uint32",
        "uint64",
        "int",
        "uint",
        "uintptr",
        "rune"
      ],
      literal: [
        "true",
        "false",
        "iota",
        "nil"
      ],
      built_in: [
        "append",
        "cap",
        "close",
        "complex",
        "copy",
        "imag",
        "len",
        "make",
        "new",
        "panic",
        "print",
        "println",
        "real",
        "recover",
        "delete"
      ]
    };
    return {
      name: "Go",
      aliases: ["golang"],
      keywords: g,
      illegal: "</",
      contains: [
        i.C_LINE_COMMENT_MODE,
        i.C_BLOCK_COMMENT_MODE,
        {
          className: "string",
          variants: [
            i.QUOTE_STRING_MODE,
            i.APOS_STRING_MODE,
            {
              begin: "`",
              end: "`"
            }
          ]
        },
        {
          className: "number",
          variants: [
            {
              begin: i.C_NUMBER_RE + "[i]",
              relevance: 1
            },
            i.C_NUMBER_MODE
          ]
        },
        {
          begin: /:=/
          // relevance booster
        },
        {
          className: "function",
          beginKeywords: "func",
          end: "\\s*(\\{|$)",
          excludeEnd: !0,
          contains: [
            i.TITLE_MODE,
            {
              className: "params",
              begin: /\(/,
              end: /\)/,
              endsParent: !0,
              keywords: g,
              illegal: /["']/
            }
          ]
        }
      ]
    };
  }
  return yu = s, yu;
}
var Iu, rb;
function uP() {
  if (rb)
    return Iu;
  rb = 1;
  function s(i) {
    return {
      name: "Golo",
      keywords: {
        keyword: [
          "println",
          "readln",
          "print",
          "import",
          "module",
          "function",
          "local",
          "return",
          "let",
          "var",
          "while",
          "for",
          "foreach",
          "times",
          "in",
          "case",
          "when",
          "match",
          "with",
          "break",
          "continue",
          "augment",
          "augmentation",
          "each",
          "find",
          "filter",
          "reduce",
          "if",
          "then",
          "else",
          "otherwise",
          "try",
          "catch",
          "finally",
          "raise",
          "throw",
          "orIfNull",
          "DynamicObject|10",
          "DynamicVariable",
          "struct",
          "Observable",
          "map",
          "set",
          "vector",
          "list",
          "array"
        ],
        literal: [
          "true",
          "false",
          "null"
        ]
      },
      contains: [
        i.HASH_COMMENT_MODE,
        i.QUOTE_STRING_MODE,
        i.C_NUMBER_MODE,
        {
          className: "meta",
          begin: "@[A-Za-z]+"
        }
      ]
    };
  }
  return Iu = s, Iu;
}
var Du, nb;
function _P() {
  if (nb)
    return Du;
  nb = 1;
  function s(i) {
    return {
      name: "Gradle",
      case_insensitive: !0,
      keywords: [
        "task",
        "project",
        "allprojects",
        "subprojects",
        "artifacts",
        "buildscript",
        "configurations",
        "dependencies",
        "repositories",
        "sourceSets",
        "description",
        "delete",
        "from",
        "into",
        "include",
        "exclude",
        "source",
        "classpath",
        "destinationDir",
        "includes",
        "options",
        "sourceCompatibility",
        "targetCompatibility",
        "group",
        "flatDir",
        "doLast",
        "doFirst",
        "flatten",
        "todir",
        "fromdir",
        "ant",
        "def",
        "abstract",
        "break",
        "case",
        "catch",
        "continue",
        "default",
        "do",
        "else",
        "extends",
        "final",
        "finally",
        "for",
        "if",
        "implements",
        "instanceof",
        "native",
        "new",
        "private",
        "protected",
        "public",
        "return",
        "static",
        "switch",
        "synchronized",
        "throw",
        "throws",
        "transient",
        "try",
        "volatile",
        "while",
        "strictfp",
        "package",
        "import",
        "false",
        "null",
        "super",
        "this",
        "true",
        "antlrtask",
        "checkstyle",
        "codenarc",
        "copy",
        "boolean",
        "byte",
        "char",
        "class",
        "double",
        "float",
        "int",
        "interface",
        "long",
        "short",
        "void",
        "compile",
        "runTime",
        "file",
        "fileTree",
        "abs",
        "any",
        "append",
        "asList",
        "asWritable",
        "call",
        "collect",
        "compareTo",
        "count",
        "div",
        "dump",
        "each",
        "eachByte",
        "eachFile",
        "eachLine",
        "every",
        "find",
        "findAll",
        "flatten",
        "getAt",
        "getErr",
        "getIn",
        "getOut",
        "getText",
        "grep",
        "immutable",
        "inject",
        "inspect",
        "intersect",
        "invokeMethods",
        "isCase",
        "join",
        "leftShift",
        "minus",
        "multiply",
        "newInputStream",
        "newOutputStream",
        "newPrintWriter",
        "newReader",
        "newWriter",
        "next",
        "plus",
        "pop",
        "power",
        "previous",
        "print",
        "println",
        "push",
        "putAt",
        "read",
        "readBytes",
        "readLines",
        "reverse",
        "reverseEach",
        "round",
        "size",
        "sort",
        "splitEachLine",
        "step",
        "subMap",
        "times",
        "toInteger",
        "toList",
        "tokenize",
        "upto",
        "waitForOrKill",
        "withPrintWriter",
        "withReader",
        "withStream",
        "withWriter",
        "withWriterAppend",
        "write",
        "writeLine"
      ],
      contains: [
        i.C_LINE_COMMENT_MODE,
        i.C_BLOCK_COMMENT_MODE,
        i.APOS_STRING_MODE,
        i.QUOTE_STRING_MODE,
        i.NUMBER_MODE,
        i.REGEXP_MODE
      ]
    };
  }
  return Du = s, Du;
}
var wu, ab;
function pP() {
  if (ab)
    return wu;
  ab = 1;
  function s(i) {
    const o = i.regex, c = /[_A-Za-z][_0-9A-Za-z]*/;
    return {
      name: "GraphQL",
      aliases: ["gql"],
      case_insensitive: !0,
      disableAutodetect: !1,
      keywords: {
        keyword: [
          "query",
          "mutation",
          "subscription",
          "type",
          "input",
          "schema",
          "directive",
          "interface",
          "union",
          "scalar",
          "fragment",
          "enum",
          "on"
        ],
        literal: [
          "true",
          "false",
          "null"
        ]
      },
      contains: [
        i.HASH_COMMENT_MODE,
        i.QUOTE_STRING_MODE,
        i.NUMBER_MODE,
        {
          scope: "punctuation",
          match: /[.]{3}/,
          relevance: 0
        },
        {
          scope: "punctuation",
          begin: /[\!\(\)\:\=\[\]\{\|\}]{1}/,
          relevance: 0
        },
        {
          scope: "variable",
          begin: /\$/,
          end: /\W/,
          excludeEnd: !0,
          relevance: 0
        },
        {
          scope: "meta",
          match: /@\w+/,
          excludeEnd: !0
        },
        {
          scope: "symbol",
          begin: o.concat(c, o.lookahead(/\s*:/)),
          relevance: 0
        }
      ],
      illegal: [
        /[;<']/,
        /BEGIN/
      ]
    };
  }
  return wu = s, wu;
}
var xu, ib;
function mP() {
  if (ib)
    return xu;
  ib = 1;
  function s(o, c = {}) {
    return c.variants = o, c;
  }
  function i(o) {
    const c = o.regex, r = "[A-Za-z0-9_$]+", e = s([
      o.C_LINE_COMMENT_MODE,
      o.C_BLOCK_COMMENT_MODE,
      o.COMMENT(
        "/\\*\\*",
        "\\*/",
        {
          relevance: 0,
          contains: [
            {
              // eat up @'s in emails to prevent them to be recognized as doctags
              begin: /\w+@/,
              relevance: 0
            },
            {
              className: "doctag",
              begin: "@[A-Za-z]+"
            }
          ]
        }
      )
    ]), g = {
      className: "regexp",
      begin: /~?\/[^\/\n]+\//,
      contains: [o.BACKSLASH_ESCAPE]
    }, h = s([
      o.BINARY_NUMBER_MODE,
      o.C_NUMBER_MODE
    ]), S = s(
      [
        {
          begin: /"""/,
          end: /"""/
        },
        {
          begin: /'''/,
          end: /'''/
        },
        {
          begin: "\\$/",
          end: "/\\$",
          relevance: 10
        },
        o.APOS_STRING_MODE,
        o.QUOTE_STRING_MODE
      ],
      { className: "string" }
    ), C = {
      match: [
        /(class|interface|trait|enum|record|extends|implements)/,
        /\s+/,
        o.UNDERSCORE_IDENT_RE
      ],
      scope: {
        1: "keyword",
        3: "title.class"
      }
    };
    return {
      name: "Groovy",
      keywords: {
        "variable.language": "this super",
        literal: "true false null",
        type: [
          "byte",
          "short",
          "char",
          "int",
          "long",
          "boolean",
          "float",
          "double",
          "void"
        ],
        keyword: [
          // groovy specific keywords
          "def",
          "as",
          "in",
          "assert",
          "trait",
          // common keywords with Java
          "abstract",
          "static",
          "volatile",
          "transient",
          "public",
          "private",
          "protected",
          "synchronized",
          "final",
          "class",
          "interface",
          "enum",
          "if",
          "else",
          "for",
          "while",
          "switch",
          "case",
          "break",
          "default",
          "continue",
          "throw",
          "throws",
          "try",
          "catch",
          "finally",
          "implements",
          "extends",
          "new",
          "import",
          "package",
          "return",
          "instanceof",
          "var"
        ]
      },
      contains: [
        o.SHEBANG({
          binary: "groovy",
          relevance: 10
        }),
        e,
        S,
        g,
        h,
        C,
        {
          className: "meta",
          begin: "@[A-Za-z]+",
          relevance: 0
        },
        {
          // highlight map keys and named parameters as attrs
          className: "attr",
          begin: r + "[ 	]*:",
          relevance: 0
        },
        {
          // catch middle element of the ternary operator
          // to avoid highlight it as a label, named parameter, or map key
          begin: /\?/,
          end: /:/,
          relevance: 0,
          contains: [
            e,
            S,
            g,
            h,
            "self"
          ]
        },
        {
          // highlight labeled statements
          className: "symbol",
          begin: "^[ 	]*" + c.lookahead(r + ":"),
          excludeBegin: !0,
          end: r + ":",
          relevance: 0
        }
      ],
      illegal: /#|<\//
    };
  }
  return xu = i, xu;
}
var Lu, ob;
function fP() {
  if (ob)
    return Lu;
  ob = 1;
  function s(i) {
    return {
      name: "HAML",
      case_insensitive: !0,
      contains: [
        {
          className: "meta",
          begin: "^!!!( (5|1\\.1|Strict|Frameset|Basic|Mobile|RDFa|XML\\b.*))?$",
          relevance: 10
        },
        // FIXME these comments should be allowed to span indented lines
        i.COMMENT(
          "^\\s*(!=#|=#|-#|/).*$",
          null,
          { relevance: 0 }
        ),
        {
          begin: "^\\s*(-|=|!=)(?!#)",
          end: /$/,
          subLanguage: "ruby",
          excludeBegin: !0,
          excludeEnd: !0
        },
        {
          className: "tag",
          begin: "^\\s*%",
          contains: [
            {
              className: "selector-tag",
              begin: "\\w+"
            },
            {
              className: "selector-id",
              begin: "#[\\w-]+"
            },
            {
              className: "selector-class",
              begin: "\\.[\\w-]+"
            },
            {
              begin: /\{\s*/,
              end: /\s*\}/,
              contains: [
                {
                  begin: ":\\w+\\s*=>",
                  end: ",\\s+",
                  returnBegin: !0,
                  endsWithParent: !0,
                  contains: [
                    {
                      className: "attr",
                      begin: ":\\w+"
                    },
                    i.APOS_STRING_MODE,
                    i.QUOTE_STRING_MODE,
                    {
                      begin: "\\w+",
                      relevance: 0
                    }
                  ]
                }
              ]
            },
            {
              begin: "\\(\\s*",
              end: "\\s*\\)",
              excludeEnd: !0,
              contains: [
                {
                  begin: "\\w+\\s*=",
                  end: "\\s+",
                  returnBegin: !0,
                  endsWithParent: !0,
                  contains: [
                    {
                      className: "attr",
                      begin: "\\w+",
                      relevance: 0
                    },
                    i.APOS_STRING_MODE,
                    i.QUOTE_STRING_MODE,
                    {
                      begin: "\\w+",
                      relevance: 0
                    }
                  ]
                }
              ]
            }
          ]
        },
        { begin: "^\\s*[=~]\\s*" },
        {
          begin: /#\{/,
          end: /\}/,
          subLanguage: "ruby",
          excludeBegin: !0,
          excludeEnd: !0
        }
      ]
    };
  }
  return Lu = s, Lu;
}
var Mu, sb;
function gP() {
  if (sb)
    return Mu;
  sb = 1;
  function s(i) {
    const o = i.regex, c = {
      $pattern: /[\w.\/]+/,
      built_in: [
        "action",
        "bindattr",
        "collection",
        "component",
        "concat",
        "debugger",
        "each",
        "each-in",
        "get",
        "hash",
        "if",
        "in",
        "input",
        "link-to",
        "loc",
        "log",
        "lookup",
        "mut",
        "outlet",
        "partial",
        "query-params",
        "render",
        "template",
        "textarea",
        "unbound",
        "unless",
        "view",
        "with",
        "yield"
      ]
    }, r = {
      $pattern: /[\w.\/]+/,
      literal: [
        "true",
        "false",
        "undefined",
        "null"
      ]
    }, e = /""|"[^"]+"/, g = /''|'[^']+'/, h = /\[\]|\[[^\]]+\]/, S = /[^\s!"#%&'()*+,.\/;<=>@\[\\\]^`{|}~]+/, C = /(\.|\/)/, O = o.either(
      e,
      g,
      h,
      S
    ), N = o.concat(
      o.optional(/\.|\.\/|\//),
      // relative or absolute path
      O,
      o.anyNumberOfTimes(o.concat(
        C,
        O
      ))
    ), D = o.concat(
      "(",
      h,
      "|",
      S,
      ")(?==)"
    ), x = { begin: N }, L = i.inherit(x, { keywords: r }), G = {
      begin: /\(/,
      end: /\)/
      // the "contains" is added below when all necessary sub-modes are defined
    }, Y = {
      // fka "attribute-assignment", parameters of the form 'key=value'
      className: "attr",
      begin: D,
      relevance: 0,
      starts: {
        begin: /=/,
        end: /=/,
        starts: { contains: [
          i.NUMBER_MODE,
          i.QUOTE_STRING_MODE,
          i.APOS_STRING_MODE,
          L,
          G
        ] }
      }
    }, k = {
      // parameters of the form '{{#with x as | y |}}...{{/with}}'
      begin: /as\s+\|/,
      keywords: { keyword: "as" },
      end: /\|/,
      contains: [
        {
          // define sub-mode in order to prevent highlighting of block-parameter named "as"
          begin: /\w+/
        }
      ]
    }, W = {
      contains: [
        i.NUMBER_MODE,
        i.QUOTE_STRING_MODE,
        i.APOS_STRING_MODE,
        k,
        Y,
        L,
        G
      ],
      returnEnd: !0
      // the property "end" is defined through inheritance when the mode is used. If depends
      // on the surrounding mode, but "endsWithParent" does not work here (i.e. it includes the
      // end-token of the surrounding mode)
    }, Z = i.inherit(x, {
      className: "name",
      keywords: c,
      starts: i.inherit(W, { end: /\)/ })
    });
    G.contains = [Z];
    const H = i.inherit(x, {
      keywords: c,
      className: "name",
      starts: i.inherit(W, { end: /\}\}/ })
    }), K = i.inherit(x, {
      keywords: c,
      className: "name"
    }), Q = i.inherit(x, {
      className: "name",
      keywords: c,
      starts: i.inherit(W, { end: /\}\}/ })
    });
    return {
      name: "Handlebars",
      aliases: [
        "hbs",
        "html.hbs",
        "html.handlebars",
        "htmlbars"
      ],
      case_insensitive: !0,
      subLanguage: "xml",
      contains: [
        {
          begin: /\\\{\{/,
          skip: !0
        },
        {
          begin: /\\\\(?=\{\{)/,
          skip: !0
        },
        i.COMMENT(/\{\{!--/, /--\}\}/),
        i.COMMENT(/\{\{!/, /\}\}/),
        {
          // open raw block "{{{{raw}}}} content not evaluated {{{{/raw}}}}"
          className: "template-tag",
          begin: /\{\{\{\{(?!\/)/,
          end: /\}\}\}\}/,
          contains: [H],
          starts: {
            end: /\{\{\{\{\//,
            returnEnd: !0,
            subLanguage: "xml"
          }
        },
        {
          // close raw block
          className: "template-tag",
          begin: /\{\{\{\{\//,
          end: /\}\}\}\}/,
          contains: [K]
        },
        {
          // open block statement
          className: "template-tag",
          begin: /\{\{#/,
          end: /\}\}/,
          contains: [H]
        },
        {
          className: "template-tag",
          begin: /\{\{(?=else\}\})/,
          end: /\}\}/,
          keywords: "else"
        },
        {
          className: "template-tag",
          begin: /\{\{(?=else if)/,
          end: /\}\}/,
          keywords: "else if"
        },
        {
          // closing block statement
          className: "template-tag",
          begin: /\{\{\//,
          end: /\}\}/,
          contains: [K]
        },
        {
          // template variable or helper-call that is NOT html-escaped
          className: "template-variable",
          begin: /\{\{\{/,
          end: /\}\}\}/,
          contains: [Q]
        },
        {
          // template variable or helper-call that is html-escaped
          className: "template-variable",
          begin: /\{\{/,
          end: /\}\}/,
          contains: [Q]
        }
      ]
    };
  }
  return Mu = s, Mu;
}
var Pu, lb;
function EP() {
  if (lb)
    return Pu;
  lb = 1;
  function s(i) {
    const o = "([0-9]_*)+", c = "([0-9a-fA-F]_*)+", r = "([01]_*)+", e = "([0-7]_*)+", C = "([!#$%&*+.\\/<=>?@\\\\^~-]|(?!([(),;\\[\\]`|{}]|[_:\"']))(\\p{S}|\\p{P}))", O = { variants: [
      // Double dash forms a valid comment only if it's not part of legal lexeme.
      // See: Haskell 98 report: https://www.haskell.org/onlinereport/lexemes.html
      //
      // The commented code does the job, but we can't use negative lookbehind,
      // due to poor support by Safari browser.
      // > hljs.COMMENT(`(?<!${symbol})--+(?!${symbol})`, '$'),
      // So instead, we'll add a no-markup rule before the COMMENT rule in the rules list
      // to match the problematic infix operators that contain double dash.
      i.COMMENT("--+", "$"),
      i.COMMENT(
        /\{-/,
        /-\}/,
        { contains: ["self"] }
      )
    ] }, N = {
      className: "meta",
      begin: /\{-#/,
      end: /#-\}/
    }, D = {
      className: "meta",
      begin: "^#",
      end: "$"
    }, x = {
      className: "type",
      begin: "\\b[A-Z][\\w']*",
      // TODO: other constructors (build-in, infix).
      relevance: 0
    }, L = {
      begin: "\\(",
      end: "\\)",
      illegal: '"',
      contains: [
        N,
        D,
        {
          className: "type",
          begin: "\\b[A-Z][\\w]*(\\((\\.\\.|,|\\w+)\\))?"
        },
        i.inherit(i.TITLE_MODE, { begin: "[_a-z][\\w']*" }),
        O
      ]
    }, G = {
      begin: /\{/,
      end: /\}/,
      contains: L.contains
    }, Y = {
      className: "number",
      relevance: 0,
      variants: [
        // decimal floating-point-literal (subsumes decimal-literal)
        { match: `\\b(${o})(\\.(${o}))?([eE][+-]?(${o}))?\\b` },
        // hexadecimal floating-point-literal (subsumes hexadecimal-literal)
        { match: `\\b0[xX]_*(${c})(\\.(${c}))?([pP][+-]?(${o}))?\\b` },
        // octal-literal
        { match: `\\b0[oO](${e})\\b` },
        // binary-literal
        { match: `\\b0[bB](${r})\\b` }
      ]
    };
    return {
      name: "Haskell",
      aliases: ["hs"],
      keywords: "let in if then else case of where do module import hiding qualified type data newtype deriving class instance as default infix infixl infixr foreign export ccall stdcall cplusplus jvm dotnet safe unsafe family forall mdo proc rec",
      unicodeRegex: !0,
      contains: [
        // Top-level constructions.
        {
          beginKeywords: "module",
          end: "where",
          keywords: "module where",
          contains: [
            L,
            O
          ],
          illegal: "\\W\\.|;"
        },
        {
          begin: "\\bimport\\b",
          end: "$",
          keywords: "import qualified as hiding",
          contains: [
            L,
            O
          ],
          illegal: "\\W\\.|;"
        },
        {
          className: "class",
          begin: "^(\\s*)?(class|instance)\\b",
          end: "where",
          keywords: "class family instance where",
          contains: [
            x,
            L,
            O
          ]
        },
        {
          className: "class",
          begin: "\\b(data|(new)?type)\\b",
          end: "$",
          keywords: "data family type newtype deriving",
          contains: [
            N,
            x,
            L,
            G,
            O
          ]
        },
        {
          beginKeywords: "default",
          end: "$",
          contains: [
            x,
            L,
            O
          ]
        },
        {
          beginKeywords: "infix infixl infixr",
          end: "$",
          contains: [
            i.C_NUMBER_MODE,
            O
          ]
        },
        {
          begin: "\\bforeign\\b",
          end: "$",
          keywords: "foreign import export ccall stdcall cplusplus jvm dotnet safe unsafe",
          contains: [
            x,
            i.QUOTE_STRING_MODE,
            O
          ]
        },
        {
          className: "meta",
          begin: "#!\\/usr\\/bin\\/env runhaskell",
          end: "$"
        },
        // "Whitespaces".
        N,
        D,
        // Literals and names.
        // Single characters.
        {
          scope: "string",
          begin: /'(?=\\?.')/,
          end: /'/,
          contains: [
            {
              scope: "char.escape",
              match: /\\./
            }
          ]
        },
        i.QUOTE_STRING_MODE,
        Y,
        x,
        i.inherit(i.TITLE_MODE, { begin: "^[_a-z][\\w']*" }),
        // No markup, prevents infix operators from being recognized as comments.
        { begin: `(?!-)${C}--+|--+(?!-)${C}` },
        O,
        {
          // No markup, relevance booster
          begin: "->|<-"
        }
      ]
    };
  }
  return Pu = s, Pu;
}
var ku, cb;
function hP() {
  if (cb)
    return ku;
  cb = 1;
  function s(i) {
    const o = "[a-zA-Z_$][a-zA-Z0-9_$]*", c = /(-?)(\b0[xX][a-fA-F0-9_]+|(\b\d+(\.[\d_]*)?|\.[\d_]+)(([eE][-+]?\d+)|i32|u32|i64|f64)?)/;
    return {
      name: "Haxe",
      aliases: ["hx"],
      keywords: {
        keyword: "abstract break case cast catch continue default do dynamic else enum extern final for function here if import in inline is macro never new override package private get set public return static super switch this throw trace try typedef untyped using var while " + "Int Float String Bool Dynamic Void Array ",
        built_in: "trace this",
        literal: "true false null _"
      },
      contains: [
        {
          className: "string",
          // interpolate-able strings
          begin: "'",
          end: "'",
          contains: [
            i.BACKSLASH_ESCAPE,
            {
              className: "subst",
              // interpolation
              begin: /\$\{/,
              end: /\}/
            },
            {
              className: "subst",
              // interpolation
              begin: /\$/,
              end: /\W\}/
            }
          ]
        },
        i.QUOTE_STRING_MODE,
        i.C_LINE_COMMENT_MODE,
        i.C_BLOCK_COMMENT_MODE,
        {
          className: "number",
          begin: c,
          relevance: 0
        },
        {
          className: "variable",
          begin: "\\$" + o
        },
        {
          className: "meta",
          // compiler meta
          begin: /@:?/,
          end: /\(|$/,
          excludeEnd: !0
        },
        {
          className: "meta",
          // compiler conditionals
          begin: "#",
          end: "$",
          keywords: { keyword: "if else elseif end error" }
        },
        {
          className: "type",
          // function types
          begin: /:[ \t]*/,
          end: /[^A-Za-z0-9_ \t\->]/,
          excludeBegin: !0,
          excludeEnd: !0,
          relevance: 0
        },
        {
          className: "type",
          // types
          begin: /:[ \t]*/,
          end: /\W/,
          excludeBegin: !0,
          excludeEnd: !0
        },
        {
          className: "type",
          // instantiation
          begin: /new */,
          end: /\W/,
          excludeBegin: !0,
          excludeEnd: !0
        },
        {
          className: "title.class",
          // enums
          beginKeywords: "enum",
          end: /\{/,
          contains: [i.TITLE_MODE]
        },
        {
          className: "title.class",
          // abstracts
          begin: "\\babstract\\b(?=\\s*" + i.IDENT_RE + "\\s*\\()",
          end: /[\{$]/,
          contains: [
            {
              className: "type",
              begin: /\(/,
              end: /\)/,
              excludeBegin: !0,
              excludeEnd: !0
            },
            {
              className: "type",
              begin: /from +/,
              end: /\W/,
              excludeBegin: !0,
              excludeEnd: !0
            },
            {
              className: "type",
              begin: /to +/,
              end: /\W/,
              excludeBegin: !0,
              excludeEnd: !0
            },
            i.TITLE_MODE
          ],
          keywords: { keyword: "abstract from to" }
        },
        {
          className: "title.class",
          // classes
          begin: /\b(class|interface) +/,
          end: /[\{$]/,
          excludeEnd: !0,
          keywords: "class interface",
          contains: [
            {
              className: "keyword",
              begin: /\b(extends|implements) +/,
              keywords: "extends implements",
              contains: [
                {
                  className: "type",
                  begin: i.IDENT_RE,
                  relevance: 0
                }
              ]
            },
            i.TITLE_MODE
          ]
        },
        {
          className: "title.function",
          beginKeywords: "function",
          end: /\(/,
          excludeEnd: !0,
          illegal: /\S/,
          contains: [i.TITLE_MODE]
        }
      ],
      illegal: /<\//
    };
  }
  return ku = s, ku;
}
var Fu, db;
function SP() {
  if (db)
    return Fu;
  db = 1;
  function s(i) {
    return {
      name: "HSP",
      case_insensitive: !0,
      keywords: {
        $pattern: /[\w._]+/,
        keyword: "goto gosub return break repeat loop continue wait await dim sdim foreach dimtype dup dupptr end stop newmod delmod mref run exgoto on mcall assert logmes newlab resume yield onexit onerror onkey onclick oncmd exist delete mkdir chdir dirlist bload bsave bcopy memfile if else poke wpoke lpoke getstr chdpm memexpand memcpy memset notesel noteadd notedel noteload notesave randomize noteunsel noteget split strrep setease button chgdisp exec dialog mmload mmplay mmstop mci pset pget syscolor mes print title pos circle cls font sysfont objsize picload color palcolor palette redraw width gsel gcopy gzoom gmode bmpsave hsvcolor getkey listbox chkbox combox input mesbox buffer screen bgscr mouse objsel groll line clrobj boxf objprm objmode stick grect grotate gsquare gradf objimage objskip objenable celload celdiv celput newcom querycom delcom cnvstow comres axobj winobj sendmsg comevent comevarg sarrayconv callfunc cnvwtos comevdisp libptr system hspstat hspver stat cnt err strsize looplev sublev iparam wparam lparam refstr refdval int rnd strlen length length2 length3 length4 vartype gettime peek wpeek lpeek varptr varuse noteinfo instr abs limit getease str strmid strf getpath strtrim sin cos tan atan sqrt double absf expf logf limitf powf geteasef mousex mousey mousew hwnd hinstance hdc ginfo objinfo dirinfo sysinfo thismod __hspver__ __hsp30__ __date__ __time__ __line__ __file__ _debug __hspdef__ and or xor not screen_normal screen_palette screen_hide screen_fixedsize screen_tool screen_frame gmode_gdi gmode_mem gmode_rgb0 gmode_alpha gmode_rgb0alpha gmode_add gmode_sub gmode_pixela ginfo_mx ginfo_my ginfo_act ginfo_sel ginfo_wx1 ginfo_wy1 ginfo_wx2 ginfo_wy2 ginfo_vx ginfo_vy ginfo_sizex ginfo_sizey ginfo_winx ginfo_winy ginfo_mesx ginfo_mesy ginfo_r ginfo_g ginfo_b ginfo_paluse ginfo_dispx ginfo_dispy ginfo_cx ginfo_cy ginfo_intid ginfo_newid ginfo_sx ginfo_sy objinfo_mode objinfo_bmscr objinfo_hwnd notemax notesize dir_cur dir_exe dir_win dir_sys dir_cmdline dir_desktop dir_mydoc dir_tv font_normal font_bold font_italic font_underline font_strikeout font_antialias objmode_normal objmode_guifont objmode_usefont gsquare_grad msgothic msmincho do until while wend for next _break _continue switch case default swbreak swend ddim ldim alloc m_pi rad2deg deg2rad ease_linear ease_quad_in ease_quad_out ease_quad_inout ease_cubic_in ease_cubic_out ease_cubic_inout ease_quartic_in ease_quartic_out ease_quartic_inout ease_bounce_in ease_bounce_out ease_bounce_inout ease_shake_in ease_shake_out ease_shake_inout ease_loop"
      },
      contains: [
        i.C_LINE_COMMENT_MODE,
        i.C_BLOCK_COMMENT_MODE,
        i.QUOTE_STRING_MODE,
        i.APOS_STRING_MODE,
        {
          // multi-line string
          className: "string",
          begin: /\{"/,
          end: /"\}/,
          contains: [i.BACKSLASH_ESCAPE]
        },
        i.COMMENT(";", "$", { relevance: 0 }),
        {
          // pre-processor
          className: "meta",
          begin: "#",
          end: "$",
          keywords: { keyword: "addion cfunc cmd cmpopt comfunc const defcfunc deffunc define else endif enum epack func global if ifdef ifndef include modcfunc modfunc modinit modterm module pack packopt regcmd runtime undef usecom uselib" },
          contains: [
            i.inherit(i.QUOTE_STRING_MODE, { className: "string" }),
            i.NUMBER_MODE,
            i.C_NUMBER_MODE,
            i.C_LINE_COMMENT_MODE,
            i.C_BLOCK_COMMENT_MODE
          ]
        },
        {
          // label
          className: "symbol",
          begin: "^\\*(\\w+|@)"
        },
        i.NUMBER_MODE,
        i.C_NUMBER_MODE
      ]
    };
  }
  return Fu = s, Fu;
}
var Uu, ub;
function bP() {
  if (ub)
    return Uu;
  ub = 1;
  function s(i) {
    const o = i.regex, c = "HTTP/([32]|1\\.[01])", r = /[A-Za-z][A-Za-z0-9-]*/, e = {
      className: "attribute",
      begin: o.concat("^", r, "(?=\\:\\s)"),
      starts: { contains: [
        {
          className: "punctuation",
          begin: /: /,
          relevance: 0,
          starts: {
            end: "$",
            relevance: 0
          }
        }
      ] }
    }, g = [
      e,
      {
        begin: "\\n\\n",
        starts: {
          subLanguage: [],
          endsWithParent: !0
        }
      }
    ];
    return {
      name: "HTTP",
      aliases: ["https"],
      illegal: /\S/,
      contains: [
        // response
        {
          begin: "^(?=" + c + " \\d{3})",
          end: /$/,
          contains: [
            {
              className: "meta",
              begin: c
            },
            {
              className: "number",
              begin: "\\b\\d{3}\\b"
            }
          ],
          starts: {
            end: /\b\B/,
            illegal: /\S/,
            contains: g
          }
        },
        // request
        {
          begin: "(?=^[A-Z]+ (.*?) " + c + "$)",
          end: /$/,
          contains: [
            {
              className: "string",
              begin: " ",
              end: " ",
              excludeBegin: !0,
              excludeEnd: !0
            },
            {
              className: "meta",
              begin: c
            },
            {
              className: "keyword",
              begin: "[A-Z]+"
            }
          ],
          starts: {
            end: /\b\B/,
            illegal: /\S/,
            contains: g
          }
        },
        // to allow headers to work even without a preamble
        i.inherit(e, { relevance: 0 })
      ]
    };
  }
  return Uu = s, Uu;
}
var Bu, _b;
function TP() {
  if (_b)
    return Bu;
  _b = 1;
  function s(i) {
    const o = "a-zA-Z_\\-!.?+*=<>&#'", c = "[" + o + "][" + o + "0-9/;:]*", r = {
      $pattern: c,
      built_in: (
        // keywords
        "!= % %= & &= * ** **= *= *map + += , --build-class-- --import-- -= . / // //= /= < << <<= <= = > >= >> >>= @ @= ^ ^= abs accumulate all and any ap-compose ap-dotimes ap-each ap-each-while ap-filter ap-first ap-if ap-last ap-map ap-map-when ap-pipe ap-reduce ap-reject apply as-> ascii assert assoc bin break butlast callable calling-module-name car case cdr chain chr coll? combinations compile compress cond cons cons? continue count curry cut cycle dec def default-method defclass defmacro defmacro-alias defmacro/g! defmain defmethod defmulti defn defn-alias defnc defnr defreader defseq del delattr delete-route dict-comp dir disassemble dispatch-reader-macro distinct divmod do doto drop drop-last drop-while empty? end-sequence eval eval-and-compile eval-when-compile even? every? except exec filter first flatten float? fn fnc fnr for for* format fraction genexpr gensym get getattr global globals group-by hasattr hash hex id identity if if* if-not if-python2 import in inc input instance? integer integer-char? integer? interleave interpose is is-coll is-cons is-empty is-even is-every is-float is-instance is-integer is-integer-char is-iterable is-iterator is-keyword is-neg is-none is-not is-numeric is-odd is-pos is-string is-symbol is-zero isinstance islice issubclass iter iterable? iterate iterator? keyword keyword? lambda last len let lif lif-not list* list-comp locals loop macro-error macroexpand macroexpand-1 macroexpand-all map max merge-with method-decorator min multi-decorator multicombinations name neg? next none? nonlocal not not-in not? nth numeric? oct odd? open or ord partition permutations pos? post-route postwalk pow prewalk print product profile/calls profile/cpu put-route quasiquote quote raise range read read-str recursive-replace reduce remove repeat repeatedly repr require rest round route route-with-methods rwm second seq set-comp setattr setv some sorted string string? sum switch symbol? take take-nth take-while tee try unless unquote unquote-splicing vars walk when while with with* with-decorator with-gensyms xi xor yield yield-from zero? zip zip-longest | |= ~"
      )
    }, e = "[-+]?\\d+(\\.\\d+)?", g = {
      begin: c,
      relevance: 0
    }, h = {
      className: "number",
      begin: e,
      relevance: 0
    }, S = i.inherit(i.QUOTE_STRING_MODE, { illegal: null }), C = i.COMMENT(
      ";",
      "$",
      { relevance: 0 }
    ), O = {
      className: "literal",
      begin: /\b([Tt]rue|[Ff]alse|nil|None)\b/
    }, N = {
      begin: "[\\[\\{]",
      end: "[\\]\\}]",
      relevance: 0
    }, D = {
      className: "comment",
      begin: "\\^" + c
    }, x = i.COMMENT("\\^\\{", "\\}"), L = {
      className: "symbol",
      begin: "[:]{1,2}" + c
    }, G = {
      begin: "\\(",
      end: "\\)"
    }, Y = {
      endsWithParent: !0,
      relevance: 0
    }, k = {
      className: "name",
      relevance: 0,
      keywords: r,
      begin: c,
      starts: Y
    }, W = [
      G,
      S,
      D,
      x,
      C,
      L,
      N,
      h,
      O,
      g
    ];
    return G.contains = [
      i.COMMENT("comment", ""),
      k,
      Y
    ], Y.contains = W, N.contains = W, {
      name: "Hy",
      aliases: ["hylang"],
      illegal: /\S/,
      contains: [
        i.SHEBANG(),
        G,
        S,
        D,
        x,
        C,
        L,
        N,
        h,
        O
      ]
    };
  }
  return Bu = s, Bu;
}
var Gu, pb;
function vP() {
  if (pb)
    return Gu;
  pb = 1;
  function s(i) {
    const o = "\\[", c = "\\]";
    return {
      name: "Inform 7",
      aliases: ["i7"],
      case_insensitive: !0,
      keywords: {
        // Some keywords more or less unique to I7, for relevance.
        keyword: (
          // kind:
          "thing room person man woman animal container supporter backdrop door scenery open closed locked inside gender is are say understand kind of rule"
        )
      },
      contains: [
        {
          className: "string",
          begin: '"',
          end: '"',
          relevance: 0,
          contains: [
            {
              className: "subst",
              begin: o,
              end: c
            }
          ]
        },
        {
          className: "section",
          begin: /^(Volume|Book|Part|Chapter|Section|Table)\b/,
          end: "$"
        },
        {
          // Rule definition
          // This is here for relevance.
          begin: /^(Check|Carry out|Report|Instead of|To|Rule|When|Before|After)\b/,
          end: ":",
          contains: [
            {
              // Rule name
              begin: "\\(This",
              end: "\\)"
            }
          ]
        },
        {
          className: "comment",
          begin: o,
          end: c,
          contains: ["self"]
        }
      ]
    };
  }
  return Gu = s, Gu;
}
var Vu, mb;
function CP() {
  if (mb)
    return Vu;
  mb = 1;
  function s(i) {
    const o = i.regex, c = {
      className: "number",
      relevance: 0,
      variants: [
        { begin: /([+-]+)?[\d]+_[\d_]+/ },
        { begin: i.NUMBER_RE }
      ]
    }, r = i.COMMENT();
    r.variants = [
      {
        begin: /;/,
        end: /$/
      },
      {
        begin: /#/,
        end: /$/
      }
    ];
    const e = {
      className: "variable",
      variants: [
        { begin: /\$[\w\d"][\w\d_]*/ },
        { begin: /\$\{(.*?)\}/ }
      ]
    }, g = {
      className: "literal",
      begin: /\bon|off|true|false|yes|no\b/
    }, h = {
      className: "string",
      contains: [i.BACKSLASH_ESCAPE],
      variants: [
        {
          begin: "'''",
          end: "'''",
          relevance: 10
        },
        {
          begin: '"""',
          end: '"""',
          relevance: 10
        },
        {
          begin: '"',
          end: '"'
        },
        {
          begin: "'",
          end: "'"
        }
      ]
    }, S = {
      begin: /\[/,
      end: /\]/,
      contains: [
        r,
        g,
        e,
        h,
        c,
        "self"
      ],
      relevance: 0
    }, C = /[A-Za-z0-9_-]+/, O = /"(\\"|[^"])*"/, N = /'[^']*'/, D = o.either(
      C,
      O,
      N
    ), x = o.concat(
      D,
      "(\\s*\\.\\s*",
      D,
      ")*",
      o.lookahead(/\s*=\s*[^#\s]/)
    );
    return {
      name: "TOML, also INI",
      aliases: ["toml"],
      case_insensitive: !0,
      illegal: /\S/,
      contains: [
        r,
        {
          className: "section",
          begin: /\[+/,
          end: /\]+/
        },
        {
          begin: x,
          className: "attr",
          starts: {
            end: /$/,
            contains: [
              r,
              S,
              g,
              e,
              h,
              c
            ]
          }
        }
      ]
    };
  }
  return Vu = s, Vu;
}
var Yu, fb;
function RP() {
  if (fb)
    return Yu;
  fb = 1;
  function s(i) {
    const o = i.regex, c = {
      className: "params",
      begin: "\\(",
      end: "\\)"
    }, r = /(_[a-z_\d]+)?/, e = /([de][+-]?\d+)?/, g = {
      className: "number",
      variants: [
        { begin: o.concat(/\b\d+/, /\.(\d*)/, e, r) },
        { begin: o.concat(/\b\d+/, e, r) },
        { begin: o.concat(/\.\d+/, e, r) }
      ],
      relevance: 0
    };
    return {
      name: "IRPF90",
      case_insensitive: !0,
      keywords: {
        literal: ".False. .True.",
        keyword: "kind do while private call intrinsic where elsewhere type endtype endmodule endselect endinterface end enddo endif if forall endforall only contains default return stop then public subroutine|10 function program .and. .or. .not. .le. .eq. .ge. .gt. .lt. goto save else use module select case access blank direct exist file fmt form formatted iostat name named nextrec number opened rec recl sequential status unformatted unit continue format pause cycle exit c_null_char c_alert c_backspace c_form_feed flush wait decimal round iomsg synchronous nopass non_overridable pass protected volatile abstract extends import non_intrinsic value deferred generic final enumerator class associate bind enum c_int c_short c_long c_long_long c_signed_char c_size_t c_int8_t c_int16_t c_int32_t c_int64_t c_int_least8_t c_int_least16_t c_int_least32_t c_int_least64_t c_int_fast8_t c_int_fast16_t c_int_fast32_t c_int_fast64_t c_intmax_t C_intptr_t c_float c_double c_long_double c_float_complex c_double_complex c_long_double_complex c_bool c_char c_null_ptr c_null_funptr c_new_line c_carriage_return c_horizontal_tab c_vertical_tab iso_c_binding c_loc c_funloc c_associated  c_f_pointer c_ptr c_funptr iso_fortran_env character_storage_size error_unit file_storage_size input_unit iostat_end iostat_eor numeric_storage_size output_unit c_f_procpointer ieee_arithmetic ieee_support_underflow_control ieee_get_underflow_mode ieee_set_underflow_mode newunit contiguous recursive pad position action delim readwrite eor advance nml interface procedure namelist include sequence elemental pure integer real character complex logical dimension allocatable|10 parameter external implicit|10 none double precision assign intent optional pointer target in out common equivalence data begin_provider &begin_provider end_provider begin_shell end_shell begin_template end_template subst assert touch soft_touch provide no_dep free irp_if irp_else irp_endif irp_write irp_read",
        built_in: "alog alog10 amax0 amax1 amin0 amin1 amod cabs ccos cexp clog csin csqrt dabs dacos dasin datan datan2 dcos dcosh ddim dexp dint dlog dlog10 dmax1 dmin1 dmod dnint dsign dsin dsinh dsqrt dtan dtanh float iabs idim idint idnint ifix isign max0 max1 min0 min1 sngl algama cdabs cdcos cdexp cdlog cdsin cdsqrt cqabs cqcos cqexp cqlog cqsin cqsqrt dcmplx dconjg derf derfc dfloat dgamma dimag dlgama iqint qabs qacos qasin qatan qatan2 qcmplx qconjg qcos qcosh qdim qerf qerfc qexp qgamma qimag qlgama qlog qlog10 qmax1 qmin1 qmod qnint qsign qsin qsinh qsqrt qtan qtanh abs acos aimag aint anint asin atan atan2 char cmplx conjg cos cosh exp ichar index int log log10 max min nint sign sin sinh sqrt tan tanh print write dim lge lgt lle llt mod nullify allocate deallocate adjustl adjustr all allocated any associated bit_size btest ceiling count cshift date_and_time digits dot_product eoshift epsilon exponent floor fraction huge iand ibclr ibits ibset ieor ior ishft ishftc lbound len_trim matmul maxexponent maxloc maxval merge minexponent minloc minval modulo mvbits nearest pack present product radix random_number random_seed range repeat reshape rrspacing scale scan selected_int_kind selected_real_kind set_exponent shape size spacing spread sum system_clock tiny transpose trim ubound unpack verify achar iachar transfer dble entry dprod cpu_time command_argument_count get_command get_command_argument get_environment_variable is_iostat_end ieee_arithmetic ieee_support_underflow_control ieee_get_underflow_mode ieee_set_underflow_mode is_iostat_eor move_alloc new_line selected_char_kind same_type_as extends_type_of acosh asinh atanh bessel_j0 bessel_j1 bessel_jn bessel_y0 bessel_y1 bessel_yn erf erfc erfc_scaled gamma log_gamma hypot norm2 atomic_define atomic_ref execute_command_line leadz trailz storage_size merge_bits bge bgt ble blt dshiftl dshiftr findloc iall iany iparity image_index lcobound ucobound maskl maskr num_images parity popcnt poppar shifta shiftl shiftr this_image IRP_ALIGN irp_here"
      },
      illegal: /\/\*/,
      contains: [
        i.inherit(i.APOS_STRING_MODE, {
          className: "string",
          relevance: 0
        }),
        i.inherit(i.QUOTE_STRING_MODE, {
          className: "string",
          relevance: 0
        }),
        {
          className: "function",
          beginKeywords: "subroutine function program",
          illegal: "[${=\\n]",
          contains: [
            i.UNDERSCORE_TITLE_MODE,
            c
          ]
        },
        i.COMMENT("!", "$", { relevance: 0 }),
        i.COMMENT("begin_doc", "end_doc", { relevance: 10 }),
        g
      ]
    };
  }
  return Yu = s, Yu;
}
var Hu, gb;
function NP() {
  if (gb)
    return Hu;
  gb = 1;
  function s(i) {
    const o = "[A-Za-zА-Яа-яёЁ_!][A-Za-zА-Яа-яёЁ_0-9]*", c = "[A-Za-zА-Яа-яёЁ_][A-Za-zА-Яа-яёЁ_0-9]*", r = "and и else иначе endexcept endfinally endforeach конецвсе endif конецесли endwhile конецпока except exitfor finally foreach все if если in в not не or или try while пока ", ae = "SYSRES_CONST_ACCES_RIGHT_TYPE_EDIT SYSRES_CONST_ACCES_RIGHT_TYPE_FULL SYSRES_CONST_ACCES_RIGHT_TYPE_VIEW SYSRES_CONST_ACCESS_MODE_REQUISITE_CODE SYSRES_CONST_ACCESS_NO_ACCESS_VIEW SYSRES_CONST_ACCESS_NO_ACCESS_VIEW_CODE SYSRES_CONST_ACCESS_RIGHTS_ADD_REQUISITE_CODE SYSRES_CONST_ACCESS_RIGHTS_ADD_REQUISITE_YES_CODE SYSRES_CONST_ACCESS_RIGHTS_CHANGE_REQUISITE_CODE SYSRES_CONST_ACCESS_RIGHTS_CHANGE_REQUISITE_YES_CODE SYSRES_CONST_ACCESS_RIGHTS_DELETE_REQUISITE_CODE SYSRES_CONST_ACCESS_RIGHTS_DELETE_REQUISITE_YES_CODE SYSRES_CONST_ACCESS_RIGHTS_EXECUTE_REQUISITE_CODE SYSRES_CONST_ACCESS_RIGHTS_EXECUTE_REQUISITE_YES_CODE SYSRES_CONST_ACCESS_RIGHTS_NO_ACCESS_REQUISITE_CODE SYSRES_CONST_ACCESS_RIGHTS_NO_ACCESS_REQUISITE_YES_CODE SYSRES_CONST_ACCESS_RIGHTS_RATIFY_REQUISITE_CODE SYSRES_CONST_ACCESS_RIGHTS_RATIFY_REQUISITE_YES_CODE SYSRES_CONST_ACCESS_RIGHTS_REQUISITE_CODE SYSRES_CONST_ACCESS_RIGHTS_VIEW SYSRES_CONST_ACCESS_RIGHTS_VIEW_CODE SYSRES_CONST_ACCESS_RIGHTS_VIEW_REQUISITE_CODE SYSRES_CONST_ACCESS_RIGHTS_VIEW_REQUISITE_YES_CODE SYSRES_CONST_ACCESS_TYPE_CHANGE SYSRES_CONST_ACCESS_TYPE_CHANGE_CODE SYSRES_CONST_ACCESS_TYPE_EXISTS SYSRES_CONST_ACCESS_TYPE_EXISTS_CODE SYSRES_CONST_ACCESS_TYPE_FULL SYSRES_CONST_ACCESS_TYPE_FULL_CODE SYSRES_CONST_ACCESS_TYPE_VIEW SYSRES_CONST_ACCESS_TYPE_VIEW_CODE SYSRES_CONST_ACTION_TYPE_ABORT SYSRES_CONST_ACTION_TYPE_ACCEPT SYSRES_CONST_ACTION_TYPE_ACCESS_RIGHTS SYSRES_CONST_ACTION_TYPE_ADD_ATTACHMENT SYSRES_CONST_ACTION_TYPE_CHANGE_CARD SYSRES_CONST_ACTION_TYPE_CHANGE_KIND SYSRES_CONST_ACTION_TYPE_CHANGE_STORAGE SYSRES_CONST_ACTION_TYPE_CONTINUE SYSRES_CONST_ACTION_TYPE_COPY SYSRES_CONST_ACTION_TYPE_CREATE SYSRES_CONST_ACTION_TYPE_CREATE_VERSION SYSRES_CONST_ACTION_TYPE_DELETE SYSRES_CONST_ACTION_TYPE_DELETE_ATTACHMENT SYSRES_CONST_ACTION_TYPE_DELETE_VERSION SYSRES_CONST_ACTION_TYPE_DISABLE_DELEGATE_ACCESS_RIGHTS SYSRES_CONST_ACTION_TYPE_ENABLE_DELEGATE_ACCESS_RIGHTS SYSRES_CONST_ACTION_TYPE_ENCRYPTION_BY_CERTIFICATE SYSRES_CONST_ACTION_TYPE_ENCRYPTION_BY_CERTIFICATE_AND_PASSWORD SYSRES_CONST_ACTION_TYPE_ENCRYPTION_BY_PASSWORD SYSRES_CONST_ACTION_TYPE_EXPORT_WITH_LOCK SYSRES_CONST_ACTION_TYPE_EXPORT_WITHOUT_LOCK SYSRES_CONST_ACTION_TYPE_IMPORT_WITH_UNLOCK SYSRES_CONST_ACTION_TYPE_IMPORT_WITHOUT_UNLOCK SYSRES_CONST_ACTION_TYPE_LIFE_CYCLE_STAGE SYSRES_CONST_ACTION_TYPE_LOCK SYSRES_CONST_ACTION_TYPE_LOCK_FOR_SERVER SYSRES_CONST_ACTION_TYPE_LOCK_MODIFY SYSRES_CONST_ACTION_TYPE_MARK_AS_READED SYSRES_CONST_ACTION_TYPE_MARK_AS_UNREADED SYSRES_CONST_ACTION_TYPE_MODIFY SYSRES_CONST_ACTION_TYPE_MODIFY_CARD SYSRES_CONST_ACTION_TYPE_MOVE_TO_ARCHIVE SYSRES_CONST_ACTION_TYPE_OFF_ENCRYPTION SYSRES_CONST_ACTION_TYPE_PASSWORD_CHANGE SYSRES_CONST_ACTION_TYPE_PERFORM SYSRES_CONST_ACTION_TYPE_RECOVER_FROM_LOCAL_COPY SYSRES_CONST_ACTION_TYPE_RESTART SYSRES_CONST_ACTION_TYPE_RESTORE_FROM_ARCHIVE SYSRES_CONST_ACTION_TYPE_REVISION SYSRES_CONST_ACTION_TYPE_SEND_BY_MAIL SYSRES_CONST_ACTION_TYPE_SIGN SYSRES_CONST_ACTION_TYPE_START SYSRES_CONST_ACTION_TYPE_UNLOCK SYSRES_CONST_ACTION_TYPE_UNLOCK_FROM_SERVER SYSRES_CONST_ACTION_TYPE_VERSION_STATE SYSRES_CONST_ACTION_TYPE_VERSION_VISIBILITY SYSRES_CONST_ACTION_TYPE_VIEW SYSRES_CONST_ACTION_TYPE_VIEW_SHADOW_COPY SYSRES_CONST_ACTION_TYPE_WORKFLOW_DESCRIPTION_MODIFY SYSRES_CONST_ACTION_TYPE_WRITE_HISTORY SYSRES_CONST_ACTIVE_VERSION_STATE_PICK_VALUE SYSRES_CONST_ADD_REFERENCE_MODE_NAME SYSRES_CONST_ADDITION_REQUISITE_CODE SYSRES_CONST_ADDITIONAL_PARAMS_REQUISITE_CODE SYSRES_CONST_ADITIONAL_JOB_END_DATE_REQUISITE_NAME SYSRES_CONST_ADITIONAL_JOB_READ_REQUISITE_NAME SYSRES_CONST_ADITIONAL_JOB_START_DATE_REQUISITE_NAME SYSRES_CONST_ADITIONAL_JOB_STATE_REQUISITE_NAME SYSRES_CONST_ADMINISTRATION_HISTORY_ADDING_USER_TO_GROUP_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_ADDING_USER_TO_GROUP_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_CREATION_COMP_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_CREATION_COMP_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_CREATION_GROUP_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_CREATION_GROUP_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_CREATION_USER_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_CREATION_USER_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_DATABASE_USER_CREATION SYSRES_CONST_ADMINISTRATION_HISTORY_DATABASE_USER_CREATION_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_DATABASE_USER_DELETION SYSRES_CONST_ADMINISTRATION_HISTORY_DATABASE_USER_DELETION_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_DELETION_COMP_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_DELETION_COMP_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_DELETION_GROUP_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_DELETION_GROUP_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_DELETION_USER_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_DELETION_USER_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_DELETION_USER_FROM_GROUP_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_DELETION_USER_FROM_GROUP_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_GRANTING_FILTERER_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_GRANTING_FILTERER_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_GRANTING_FILTERER_RESTRICTION_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_GRANTING_FILTERER_RESTRICTION_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_GRANTING_PRIVILEGE_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_GRANTING_PRIVILEGE_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_GRANTING_RIGHTS_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_GRANTING_RIGHTS_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_IS_MAIN_SERVER_CHANGED_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_IS_MAIN_SERVER_CHANGED_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_IS_PUBLIC_CHANGED_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_IS_PUBLIC_CHANGED_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_REMOVING_FILTERER_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_REMOVING_FILTERER_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_REMOVING_FILTERER_RESTRICTION_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_REMOVING_FILTERER_RESTRICTION_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_REMOVING_PRIVILEGE_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_REMOVING_PRIVILEGE_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_REMOVING_RIGHTS_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_REMOVING_RIGHTS_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_SERVER_LOGIN_CREATION SYSRES_CONST_ADMINISTRATION_HISTORY_SERVER_LOGIN_CREATION_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_SERVER_LOGIN_DELETION SYSRES_CONST_ADMINISTRATION_HISTORY_SERVER_LOGIN_DELETION_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_UPDATING_CATEGORY_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_UPDATING_CATEGORY_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_UPDATING_COMP_TITLE_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_UPDATING_COMP_TITLE_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_UPDATING_FULL_NAME_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_UPDATING_FULL_NAME_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_UPDATING_GROUP_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_UPDATING_GROUP_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_UPDATING_PARENT_GROUP_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_UPDATING_PARENT_GROUP_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_UPDATING_USER_AUTH_TYPE_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_UPDATING_USER_AUTH_TYPE_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_UPDATING_USER_LOGIN_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_UPDATING_USER_LOGIN_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_UPDATING_USER_STATUS_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_UPDATING_USER_STATUS_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_USER_PASSWORD_CHANGE SYSRES_CONST_ADMINISTRATION_HISTORY_USER_PASSWORD_CHANGE_ACTION SYSRES_CONST_ALL_ACCEPT_CONDITION_RUS SYSRES_CONST_ALL_USERS_GROUP SYSRES_CONST_ALL_USERS_GROUP_NAME SYSRES_CONST_ALL_USERS_SERVER_GROUP_NAME SYSRES_CONST_ALLOWED_ACCESS_TYPE_CODE SYSRES_CONST_ALLOWED_ACCESS_TYPE_NAME SYSRES_CONST_APP_VIEWER_TYPE_REQUISITE_CODE SYSRES_CONST_APPROVING_SIGNATURE_NAME SYSRES_CONST_APPROVING_SIGNATURE_REQUISITE_CODE SYSRES_CONST_ASSISTANT_SUBSTITUE_TYPE SYSRES_CONST_ASSISTANT_SUBSTITUE_TYPE_CODE SYSRES_CONST_ATTACH_TYPE_COMPONENT_TOKEN SYSRES_CONST_ATTACH_TYPE_DOC SYSRES_CONST_ATTACH_TYPE_EDOC SYSRES_CONST_ATTACH_TYPE_FOLDER SYSRES_CONST_ATTACH_TYPE_JOB SYSRES_CONST_ATTACH_TYPE_REFERENCE SYSRES_CONST_ATTACH_TYPE_TASK SYSRES_CONST_AUTH_ENCODED_PASSWORD SYSRES_CONST_AUTH_ENCODED_PASSWORD_CODE SYSRES_CONST_AUTH_NOVELL SYSRES_CONST_AUTH_PASSWORD SYSRES_CONST_AUTH_PASSWORD_CODE SYSRES_CONST_AUTH_WINDOWS SYSRES_CONST_AUTHENTICATING_SIGNATURE_NAME SYSRES_CONST_AUTHENTICATING_SIGNATURE_REQUISITE_CODE SYSRES_CONST_AUTO_ENUM_METHOD_FLAG SYSRES_CONST_AUTO_NUMERATION_CODE SYSRES_CONST_AUTO_STRONG_ENUM_METHOD_FLAG SYSRES_CONST_AUTOTEXT_NAME_REQUISITE_CODE SYSRES_CONST_AUTOTEXT_TEXT_REQUISITE_CODE SYSRES_CONST_AUTOTEXT_USAGE_ALL SYSRES_CONST_AUTOTEXT_USAGE_ALL_CODE SYSRES_CONST_AUTOTEXT_USAGE_SIGN SYSRES_CONST_AUTOTEXT_USAGE_SIGN_CODE SYSRES_CONST_AUTOTEXT_USAGE_WORK SYSRES_CONST_AUTOTEXT_USAGE_WORK_CODE SYSRES_CONST_AUTOTEXT_USE_ANYWHERE_CODE SYSRES_CONST_AUTOTEXT_USE_ON_SIGNING_CODE SYSRES_CONST_AUTOTEXT_USE_ON_WORK_CODE SYSRES_CONST_BEGIN_DATE_REQUISITE_CODE SYSRES_CONST_BLACK_LIFE_CYCLE_STAGE_FONT_COLOR SYSRES_CONST_BLUE_LIFE_CYCLE_STAGE_FONT_COLOR SYSRES_CONST_BTN_PART SYSRES_CONST_CALCULATED_ROLE_TYPE_CODE SYSRES_CONST_CALL_TYPE_VARIABLE_BUTTON_VALUE SYSRES_CONST_CALL_TYPE_VARIABLE_PROGRAM_VALUE SYSRES_CONST_CANCEL_MESSAGE_FUNCTION_RESULT SYSRES_CONST_CARD_PART SYSRES_CONST_CARD_REFERENCE_MODE_NAME SYSRES_CONST_CERTIFICATE_TYPE_REQUISITE_ENCRYPT_VALUE SYSRES_CONST_CERTIFICATE_TYPE_REQUISITE_SIGN_AND_ENCRYPT_VALUE SYSRES_CONST_CERTIFICATE_TYPE_REQUISITE_SIGN_VALUE SYSRES_CONST_CHECK_PARAM_VALUE_DATE_PARAM_TYPE SYSRES_CONST_CHECK_PARAM_VALUE_FLOAT_PARAM_TYPE SYSRES_CONST_CHECK_PARAM_VALUE_INTEGER_PARAM_TYPE SYSRES_CONST_CHECK_PARAM_VALUE_PICK_PARAM_TYPE SYSRES_CONST_CHECK_PARAM_VALUE_REEFRENCE_PARAM_TYPE SYSRES_CONST_CLOSED_RECORD_FLAG_VALUE_FEMININE SYSRES_CONST_CLOSED_RECORD_FLAG_VALUE_MASCULINE SYSRES_CONST_CODE_COMPONENT_TYPE_ADMIN SYSRES_CONST_CODE_COMPONENT_TYPE_DEVELOPER SYSRES_CONST_CODE_COMPONENT_TYPE_DOCS SYSRES_CONST_CODE_COMPONENT_TYPE_EDOC_CARDS SYSRES_CONST_CODE_COMPONENT_TYPE_EXTERNAL_EXECUTABLE SYSRES_CONST_CODE_COMPONENT_TYPE_OTHER SYSRES_CONST_CODE_COMPONENT_TYPE_REFERENCE SYSRES_CONST_CODE_COMPONENT_TYPE_REPORT SYSRES_CONST_CODE_COMPONENT_TYPE_SCRIPT SYSRES_CONST_CODE_COMPONENT_TYPE_URL SYSRES_CONST_CODE_REQUISITE_ACCESS SYSRES_CONST_CODE_REQUISITE_CODE SYSRES_CONST_CODE_REQUISITE_COMPONENT SYSRES_CONST_CODE_REQUISITE_DESCRIPTION SYSRES_CONST_CODE_REQUISITE_EXCLUDE_COMPONENT SYSRES_CONST_CODE_REQUISITE_RECORD SYSRES_CONST_COMMENT_REQ_CODE SYSRES_CONST_COMMON_SETTINGS_REQUISITE_CODE SYSRES_CONST_COMP_CODE_GRD SYSRES_CONST_COMPONENT_GROUP_TYPE_REQUISITE_CODE SYSRES_CONST_COMPONENT_TYPE_ADMIN_COMPONENTS SYSRES_CONST_COMPONENT_TYPE_DEVELOPER_COMPONENTS SYSRES_CONST_COMPONENT_TYPE_DOCS SYSRES_CONST_COMPONENT_TYPE_EDOC_CARDS SYSRES_CONST_COMPONENT_TYPE_EDOCS SYSRES_CONST_COMPONENT_TYPE_EXTERNAL_EXECUTABLE SYSRES_CONST_COMPONENT_TYPE_OTHER SYSRES_CONST_COMPONENT_TYPE_REFERENCE_TYPES SYSRES_CONST_COMPONENT_TYPE_REFERENCES SYSRES_CONST_COMPONENT_TYPE_REPORTS SYSRES_CONST_COMPONENT_TYPE_SCRIPTS SYSRES_CONST_COMPONENT_TYPE_URL SYSRES_CONST_COMPONENTS_REMOTE_SERVERS_VIEW_CODE SYSRES_CONST_CONDITION_BLOCK_DESCRIPTION SYSRES_CONST_CONST_FIRM_STATUS_COMMON SYSRES_CONST_CONST_FIRM_STATUS_INDIVIDUAL SYSRES_CONST_CONST_NEGATIVE_VALUE SYSRES_CONST_CONST_POSITIVE_VALUE SYSRES_CONST_CONST_SERVER_STATUS_DONT_REPLICATE SYSRES_CONST_CONST_SERVER_STATUS_REPLICATE SYSRES_CONST_CONTENTS_REQUISITE_CODE SYSRES_CONST_DATA_TYPE_BOOLEAN SYSRES_CONST_DATA_TYPE_DATE SYSRES_CONST_DATA_TYPE_FLOAT SYSRES_CONST_DATA_TYPE_INTEGER SYSRES_CONST_DATA_TYPE_PICK SYSRES_CONST_DATA_TYPE_REFERENCE SYSRES_CONST_DATA_TYPE_STRING SYSRES_CONST_DATA_TYPE_TEXT SYSRES_CONST_DATA_TYPE_VARIANT SYSRES_CONST_DATE_CLOSE_REQ_CODE SYSRES_CONST_DATE_FORMAT_DATE_ONLY_CHAR SYSRES_CONST_DATE_OPEN_REQ_CODE SYSRES_CONST_DATE_REQUISITE SYSRES_CONST_DATE_REQUISITE_CODE SYSRES_CONST_DATE_REQUISITE_NAME SYSRES_CONST_DATE_REQUISITE_TYPE SYSRES_CONST_DATE_TYPE_CHAR SYSRES_CONST_DATETIME_FORMAT_VALUE SYSRES_CONST_DEA_ACCESS_RIGHTS_ACTION_CODE SYSRES_CONST_DESCRIPTION_LOCALIZE_ID_REQUISITE_CODE SYSRES_CONST_DESCRIPTION_REQUISITE_CODE SYSRES_CONST_DET1_PART SYSRES_CONST_DET2_PART SYSRES_CONST_DET3_PART SYSRES_CONST_DET4_PART SYSRES_CONST_DET5_PART SYSRES_CONST_DET6_PART SYSRES_CONST_DETAIL_DATASET_KEY_REQUISITE_CODE SYSRES_CONST_DETAIL_PICK_REQUISITE_CODE SYSRES_CONST_DETAIL_REQ_CODE SYSRES_CONST_DO_NOT_USE_ACCESS_TYPE_CODE SYSRES_CONST_DO_NOT_USE_ACCESS_TYPE_NAME SYSRES_CONST_DO_NOT_USE_ON_VIEW_ACCESS_TYPE_CODE SYSRES_CONST_DO_NOT_USE_ON_VIEW_ACCESS_TYPE_NAME SYSRES_CONST_DOCUMENT_STORAGES_CODE SYSRES_CONST_DOCUMENT_TEMPLATES_TYPE_NAME SYSRES_CONST_DOUBLE_REQUISITE_CODE SYSRES_CONST_EDITOR_CLOSE_FILE_OBSERV_TYPE_CODE SYSRES_CONST_EDITOR_CLOSE_PROCESS_OBSERV_TYPE_CODE SYSRES_CONST_EDITOR_TYPE_REQUISITE_CODE SYSRES_CONST_EDITORS_APPLICATION_NAME_REQUISITE_CODE SYSRES_CONST_EDITORS_CREATE_SEVERAL_PROCESSES_REQUISITE_CODE SYSRES_CONST_EDITORS_EXTENSION_REQUISITE_CODE SYSRES_CONST_EDITORS_OBSERVER_BY_PROCESS_TYPE SYSRES_CONST_EDITORS_REFERENCE_CODE SYSRES_CONST_EDITORS_REPLACE_SPEC_CHARS_REQUISITE_CODE SYSRES_CONST_EDITORS_USE_PLUGINS_REQUISITE_CODE SYSRES_CONST_EDITORS_VIEW_DOCUMENT_OPENED_TO_EDIT_CODE SYSRES_CONST_EDOC_CARD_TYPE_REQUISITE_CODE SYSRES_CONST_EDOC_CARD_TYPES_LINK_REQUISITE_CODE SYSRES_CONST_EDOC_CERTIFICATE_AND_PASSWORD_ENCODE_CODE SYSRES_CONST_EDOC_CERTIFICATE_ENCODE_CODE SYSRES_CONST_EDOC_DATE_REQUISITE_CODE SYSRES_CONST_EDOC_KIND_REFERENCE_CODE SYSRES_CONST_EDOC_KINDS_BY_TEMPLATE_ACTION_CODE SYSRES_CONST_EDOC_MANAGE_ACCESS_CODE SYSRES_CONST_EDOC_NONE_ENCODE_CODE SYSRES_CONST_EDOC_NUMBER_REQUISITE_CODE SYSRES_CONST_EDOC_PASSWORD_ENCODE_CODE SYSRES_CONST_EDOC_READONLY_ACCESS_CODE SYSRES_CONST_EDOC_SHELL_LIFE_TYPE_VIEW_VALUE SYSRES_CONST_EDOC_SIZE_RESTRICTION_PRIORITY_REQUISITE_CODE SYSRES_CONST_EDOC_STORAGE_CHECK_ACCESS_RIGHTS_REQUISITE_CODE SYSRES_CONST_EDOC_STORAGE_COMPUTER_NAME_REQUISITE_CODE SYSRES_CONST_EDOC_STORAGE_DATABASE_NAME_REQUISITE_CODE SYSRES_CONST_EDOC_STORAGE_EDIT_IN_STORAGE_REQUISITE_CODE SYSRES_CONST_EDOC_STORAGE_LOCAL_PATH_REQUISITE_CODE SYSRES_CONST_EDOC_STORAGE_SHARED_SOURCE_NAME_REQUISITE_CODE SYSRES_CONST_EDOC_TEMPLATE_REQUISITE_CODE SYSRES_CONST_EDOC_TYPES_REFERENCE_CODE SYSRES_CONST_EDOC_VERSION_ACTIVE_STAGE_CODE SYSRES_CONST_EDOC_VERSION_DESIGN_STAGE_CODE SYSRES_CONST_EDOC_VERSION_OBSOLETE_STAGE_CODE SYSRES_CONST_EDOC_WRITE_ACCES_CODE SYSRES_CONST_EDOCUMENT_CARD_REQUISITES_REFERENCE_CODE_SELECTED_REQUISITE SYSRES_CONST_ENCODE_CERTIFICATE_TYPE_CODE SYSRES_CONST_END_DATE_REQUISITE_CODE SYSRES_CONST_ENUMERATION_TYPE_REQUISITE_CODE SYSRES_CONST_EXECUTE_ACCESS_RIGHTS_TYPE_CODE SYSRES_CONST_EXECUTIVE_FILE_STORAGE_TYPE SYSRES_CONST_EXIST_CONST SYSRES_CONST_EXIST_VALUE SYSRES_CONST_EXPORT_LOCK_TYPE_ASK SYSRES_CONST_EXPORT_LOCK_TYPE_WITH_LOCK SYSRES_CONST_EXPORT_LOCK_TYPE_WITHOUT_LOCK SYSRES_CONST_EXPORT_VERSION_TYPE_ASK SYSRES_CONST_EXPORT_VERSION_TYPE_LAST SYSRES_CONST_EXPORT_VERSION_TYPE_LAST_ACTIVE SYSRES_CONST_EXTENSION_REQUISITE_CODE SYSRES_CONST_FILTER_NAME_REQUISITE_CODE SYSRES_CONST_FILTER_REQUISITE_CODE SYSRES_CONST_FILTER_TYPE_COMMON_CODE SYSRES_CONST_FILTER_TYPE_COMMON_NAME SYSRES_CONST_FILTER_TYPE_USER_CODE SYSRES_CONST_FILTER_TYPE_USER_NAME SYSRES_CONST_FILTER_VALUE_REQUISITE_NAME SYSRES_CONST_FLOAT_NUMBER_FORMAT_CHAR SYSRES_CONST_FLOAT_REQUISITE_TYPE SYSRES_CONST_FOLDER_AUTHOR_VALUE SYSRES_CONST_FOLDER_KIND_ANY_OBJECTS SYSRES_CONST_FOLDER_KIND_COMPONENTS SYSRES_CONST_FOLDER_KIND_EDOCS SYSRES_CONST_FOLDER_KIND_JOBS SYSRES_CONST_FOLDER_KIND_TASKS SYSRES_CONST_FOLDER_TYPE_COMMON SYSRES_CONST_FOLDER_TYPE_COMPONENT SYSRES_CONST_FOLDER_TYPE_FAVORITES SYSRES_CONST_FOLDER_TYPE_INBOX SYSRES_CONST_FOLDER_TYPE_OUTBOX SYSRES_CONST_FOLDER_TYPE_QUICK_LAUNCH SYSRES_CONST_FOLDER_TYPE_SEARCH SYSRES_CONST_FOLDER_TYPE_SHORTCUTS SYSRES_CONST_FOLDER_TYPE_USER SYSRES_CONST_FROM_DICTIONARY_ENUM_METHOD_FLAG SYSRES_CONST_FULL_SUBSTITUTE_TYPE SYSRES_CONST_FULL_SUBSTITUTE_TYPE_CODE SYSRES_CONST_FUNCTION_CANCEL_RESULT SYSRES_CONST_FUNCTION_CATEGORY_SYSTEM SYSRES_CONST_FUNCTION_CATEGORY_USER SYSRES_CONST_FUNCTION_FAILURE_RESULT SYSRES_CONST_FUNCTION_SAVE_RESULT SYSRES_CONST_GENERATED_REQUISITE SYSRES_CONST_GREEN_LIFE_CYCLE_STAGE_FONT_COLOR SYSRES_CONST_GROUP_ACCOUNT_TYPE_VALUE_CODE SYSRES_CONST_GROUP_CATEGORY_NORMAL_CODE SYSRES_CONST_GROUP_CATEGORY_NORMAL_NAME SYSRES_CONST_GROUP_CATEGORY_SERVICE_CODE SYSRES_CONST_GROUP_CATEGORY_SERVICE_NAME SYSRES_CONST_GROUP_COMMON_CATEGORY_FIELD_VALUE SYSRES_CONST_GROUP_FULL_NAME_REQUISITE_CODE SYSRES_CONST_GROUP_NAME_REQUISITE_CODE SYSRES_CONST_GROUP_RIGHTS_T_REQUISITE_CODE SYSRES_CONST_GROUP_SERVER_CODES_REQUISITE_CODE SYSRES_CONST_GROUP_SERVER_NAME_REQUISITE_CODE SYSRES_CONST_GROUP_SERVICE_CATEGORY_FIELD_VALUE SYSRES_CONST_GROUP_USER_REQUISITE_CODE SYSRES_CONST_GROUPS_REFERENCE_CODE SYSRES_CONST_GROUPS_REQUISITE_CODE SYSRES_CONST_HIDDEN_MODE_NAME SYSRES_CONST_HIGH_LVL_REQUISITE_CODE SYSRES_CONST_HISTORY_ACTION_CREATE_CODE SYSRES_CONST_HISTORY_ACTION_DELETE_CODE SYSRES_CONST_HISTORY_ACTION_EDIT_CODE SYSRES_CONST_HOUR_CHAR SYSRES_CONST_ID_REQUISITE_CODE SYSRES_CONST_IDSPS_REQUISITE_CODE SYSRES_CONST_IMAGE_MODE_COLOR SYSRES_CONST_IMAGE_MODE_GREYSCALE SYSRES_CONST_IMAGE_MODE_MONOCHROME SYSRES_CONST_IMPORTANCE_HIGH SYSRES_CONST_IMPORTANCE_LOW SYSRES_CONST_IMPORTANCE_NORMAL SYSRES_CONST_IN_DESIGN_VERSION_STATE_PICK_VALUE SYSRES_CONST_INCOMING_WORK_RULE_TYPE_CODE SYSRES_CONST_INT_REQUISITE SYSRES_CONST_INT_REQUISITE_TYPE SYSRES_CONST_INTEGER_NUMBER_FORMAT_CHAR SYSRES_CONST_INTEGER_TYPE_CHAR SYSRES_CONST_IS_GENERATED_REQUISITE_NEGATIVE_VALUE SYSRES_CONST_IS_PUBLIC_ROLE_REQUISITE_CODE SYSRES_CONST_IS_REMOTE_USER_NEGATIVE_VALUE SYSRES_CONST_IS_REMOTE_USER_POSITIVE_VALUE SYSRES_CONST_IS_STORED_REQUISITE_NEGATIVE_VALUE SYSRES_CONST_IS_STORED_REQUISITE_STORED_VALUE SYSRES_CONST_ITALIC_LIFE_CYCLE_STAGE_DRAW_STYLE SYSRES_CONST_JOB_BLOCK_DESCRIPTION SYSRES_CONST_JOB_KIND_CONTROL_JOB SYSRES_CONST_JOB_KIND_JOB SYSRES_CONST_JOB_KIND_NOTICE SYSRES_CONST_JOB_STATE_ABORTED SYSRES_CONST_JOB_STATE_COMPLETE SYSRES_CONST_JOB_STATE_WORKING SYSRES_CONST_KIND_REQUISITE_CODE SYSRES_CONST_KIND_REQUISITE_NAME SYSRES_CONST_KINDS_CREATE_SHADOW_COPIES_REQUISITE_CODE SYSRES_CONST_KINDS_DEFAULT_EDOC_LIFE_STAGE_REQUISITE_CODE SYSRES_CONST_KINDS_EDOC_ALL_TEPLATES_ALLOWED_REQUISITE_CODE SYSRES_CONST_KINDS_EDOC_ALLOW_LIFE_CYCLE_STAGE_CHANGING_REQUISITE_CODE SYSRES_CONST_KINDS_EDOC_ALLOW_MULTIPLE_ACTIVE_VERSIONS_REQUISITE_CODE SYSRES_CONST_KINDS_EDOC_SHARE_ACCES_RIGHTS_BY_DEFAULT_CODE SYSRES_CONST_KINDS_EDOC_TEMPLATE_REQUISITE_CODE SYSRES_CONST_KINDS_EDOC_TYPE_REQUISITE_CODE SYSRES_CONST_KINDS_SIGNERS_REQUISITES_CODE SYSRES_CONST_KOD_INPUT_TYPE SYSRES_CONST_LAST_UPDATE_DATE_REQUISITE_CODE SYSRES_CONST_LIFE_CYCLE_START_STAGE_REQUISITE_CODE SYSRES_CONST_LILAC_LIFE_CYCLE_STAGE_FONT_COLOR SYSRES_CONST_LINK_OBJECT_KIND_COMPONENT SYSRES_CONST_LINK_OBJECT_KIND_DOCUMENT SYSRES_CONST_LINK_OBJECT_KIND_EDOC SYSRES_CONST_LINK_OBJECT_KIND_FOLDER SYSRES_CONST_LINK_OBJECT_KIND_JOB SYSRES_CONST_LINK_OBJECT_KIND_REFERENCE SYSRES_CONST_LINK_OBJECT_KIND_TASK SYSRES_CONST_LINK_REF_TYPE_REQUISITE_CODE SYSRES_CONST_LIST_REFERENCE_MODE_NAME SYSRES_CONST_LOCALIZATION_DICTIONARY_MAIN_VIEW_CODE SYSRES_CONST_MAIN_VIEW_CODE SYSRES_CONST_MANUAL_ENUM_METHOD_FLAG SYSRES_CONST_MASTER_COMP_TYPE_REQUISITE_CODE SYSRES_CONST_MASTER_TABLE_REC_ID_REQUISITE_CODE SYSRES_CONST_MAXIMIZED_MODE_NAME SYSRES_CONST_ME_VALUE SYSRES_CONST_MESSAGE_ATTENTION_CAPTION SYSRES_CONST_MESSAGE_CONFIRMATION_CAPTION SYSRES_CONST_MESSAGE_ERROR_CAPTION SYSRES_CONST_MESSAGE_INFORMATION_CAPTION SYSRES_CONST_MINIMIZED_MODE_NAME SYSRES_CONST_MINUTE_CHAR SYSRES_CONST_MODULE_REQUISITE_CODE SYSRES_CONST_MONITORING_BLOCK_DESCRIPTION SYSRES_CONST_MONTH_FORMAT_VALUE SYSRES_CONST_NAME_LOCALIZE_ID_REQUISITE_CODE SYSRES_CONST_NAME_REQUISITE_CODE SYSRES_CONST_NAME_SINGULAR_REQUISITE_CODE SYSRES_CONST_NAMEAN_INPUT_TYPE SYSRES_CONST_NEGATIVE_PICK_VALUE SYSRES_CONST_NEGATIVE_VALUE SYSRES_CONST_NO SYSRES_CONST_NO_PICK_VALUE SYSRES_CONST_NO_SIGNATURE_REQUISITE_CODE SYSRES_CONST_NO_VALUE SYSRES_CONST_NONE_ACCESS_RIGHTS_TYPE_CODE SYSRES_CONST_NONOPERATING_RECORD_FLAG_VALUE SYSRES_CONST_NONOPERATING_RECORD_FLAG_VALUE_MASCULINE SYSRES_CONST_NORMAL_ACCESS_RIGHTS_TYPE_CODE SYSRES_CONST_NORMAL_LIFE_CYCLE_STAGE_DRAW_STYLE SYSRES_CONST_NORMAL_MODE_NAME SYSRES_CONST_NOT_ALLOWED_ACCESS_TYPE_CODE SYSRES_CONST_NOT_ALLOWED_ACCESS_TYPE_NAME SYSRES_CONST_NOTE_REQUISITE_CODE SYSRES_CONST_NOTICE_BLOCK_DESCRIPTION SYSRES_CONST_NUM_REQUISITE SYSRES_CONST_NUM_STR_REQUISITE_CODE SYSRES_CONST_NUMERATION_AUTO_NOT_STRONG SYSRES_CONST_NUMERATION_AUTO_STRONG SYSRES_CONST_NUMERATION_FROM_DICTONARY SYSRES_CONST_NUMERATION_MANUAL SYSRES_CONST_NUMERIC_TYPE_CHAR SYSRES_CONST_NUMREQ_REQUISITE_CODE SYSRES_CONST_OBSOLETE_VERSION_STATE_PICK_VALUE SYSRES_CONST_OPERATING_RECORD_FLAG_VALUE SYSRES_CONST_OPERATING_RECORD_FLAG_VALUE_CODE SYSRES_CONST_OPERATING_RECORD_FLAG_VALUE_FEMININE SYSRES_CONST_OPERATING_RECORD_FLAG_VALUE_MASCULINE SYSRES_CONST_OPTIONAL_FORM_COMP_REQCODE_PREFIX SYSRES_CONST_ORANGE_LIFE_CYCLE_STAGE_FONT_COLOR SYSRES_CONST_ORIGINALREF_REQUISITE_CODE SYSRES_CONST_OURFIRM_REF_CODE SYSRES_CONST_OURFIRM_REQUISITE_CODE SYSRES_CONST_OURFIRM_VAR SYSRES_CONST_OUTGOING_WORK_RULE_TYPE_CODE SYSRES_CONST_PICK_NEGATIVE_RESULT SYSRES_CONST_PICK_POSITIVE_RESULT SYSRES_CONST_PICK_REQUISITE SYSRES_CONST_PICK_REQUISITE_TYPE SYSRES_CONST_PICK_TYPE_CHAR SYSRES_CONST_PLAN_STATUS_REQUISITE_CODE SYSRES_CONST_PLATFORM_VERSION_COMMENT SYSRES_CONST_PLUGINS_SETTINGS_DESCRIPTION_REQUISITE_CODE SYSRES_CONST_POSITIVE_PICK_VALUE SYSRES_CONST_POWER_TO_CREATE_ACTION_CODE SYSRES_CONST_POWER_TO_SIGN_ACTION_CODE SYSRES_CONST_PRIORITY_REQUISITE_CODE SYSRES_CONST_QUALIFIED_TASK_TYPE SYSRES_CONST_QUALIFIED_TASK_TYPE_CODE SYSRES_CONST_RECSTAT_REQUISITE_CODE SYSRES_CONST_RED_LIFE_CYCLE_STAGE_FONT_COLOR SYSRES_CONST_REF_ID_T_REF_TYPE_REQUISITE_CODE SYSRES_CONST_REF_REQUISITE SYSRES_CONST_REF_REQUISITE_TYPE SYSRES_CONST_REF_REQUISITES_REFERENCE_CODE_SELECTED_REQUISITE SYSRES_CONST_REFERENCE_RECORD_HISTORY_CREATE_ACTION_CODE SYSRES_CONST_REFERENCE_RECORD_HISTORY_DELETE_ACTION_CODE SYSRES_CONST_REFERENCE_RECORD_HISTORY_MODIFY_ACTION_CODE SYSRES_CONST_REFERENCE_TYPE_CHAR SYSRES_CONST_REFERENCE_TYPE_REQUISITE_NAME SYSRES_CONST_REFERENCES_ADD_PARAMS_REQUISITE_CODE SYSRES_CONST_REFERENCES_DISPLAY_REQUISITE_REQUISITE_CODE SYSRES_CONST_REMOTE_SERVER_STATUS_WORKING SYSRES_CONST_REMOTE_SERVER_TYPE_MAIN SYSRES_CONST_REMOTE_SERVER_TYPE_SECONDARY SYSRES_CONST_REMOTE_USER_FLAG_VALUE_CODE SYSRES_CONST_REPORT_APP_EDITOR_INTERNAL SYSRES_CONST_REPORT_BASE_REPORT_ID_REQUISITE_CODE SYSRES_CONST_REPORT_BASE_REPORT_REQUISITE_CODE SYSRES_CONST_REPORT_SCRIPT_REQUISITE_CODE SYSRES_CONST_REPORT_TEMPLATE_REQUISITE_CODE SYSRES_CONST_REPORT_VIEWER_CODE_REQUISITE_CODE SYSRES_CONST_REQ_ALLOW_COMPONENT_DEFAULT_VALUE SYSRES_CONST_REQ_ALLOW_RECORD_DEFAULT_VALUE SYSRES_CONST_REQ_ALLOW_SERVER_COMPONENT_DEFAULT_VALUE SYSRES_CONST_REQ_MODE_AVAILABLE_CODE SYSRES_CONST_REQ_MODE_EDIT_CODE SYSRES_CONST_REQ_MODE_HIDDEN_CODE SYSRES_CONST_REQ_MODE_NOT_AVAILABLE_CODE SYSRES_CONST_REQ_MODE_VIEW_CODE SYSRES_CONST_REQ_NUMBER_REQUISITE_CODE SYSRES_CONST_REQ_SECTION_VALUE SYSRES_CONST_REQ_TYPE_VALUE SYSRES_CONST_REQUISITE_FORMAT_BY_UNIT SYSRES_CONST_REQUISITE_FORMAT_DATE_FULL SYSRES_CONST_REQUISITE_FORMAT_DATE_TIME SYSRES_CONST_REQUISITE_FORMAT_LEFT SYSRES_CONST_REQUISITE_FORMAT_RIGHT SYSRES_CONST_REQUISITE_FORMAT_WITHOUT_UNIT SYSRES_CONST_REQUISITE_NUMBER_REQUISITE_CODE SYSRES_CONST_REQUISITE_SECTION_ACTIONS SYSRES_CONST_REQUISITE_SECTION_BUTTON SYSRES_CONST_REQUISITE_SECTION_BUTTONS SYSRES_CONST_REQUISITE_SECTION_CARD SYSRES_CONST_REQUISITE_SECTION_TABLE SYSRES_CONST_REQUISITE_SECTION_TABLE10 SYSRES_CONST_REQUISITE_SECTION_TABLE11 SYSRES_CONST_REQUISITE_SECTION_TABLE12 SYSRES_CONST_REQUISITE_SECTION_TABLE13 SYSRES_CONST_REQUISITE_SECTION_TABLE14 SYSRES_CONST_REQUISITE_SECTION_TABLE15 SYSRES_CONST_REQUISITE_SECTION_TABLE16 SYSRES_CONST_REQUISITE_SECTION_TABLE17 SYSRES_CONST_REQUISITE_SECTION_TABLE18 SYSRES_CONST_REQUISITE_SECTION_TABLE19 SYSRES_CONST_REQUISITE_SECTION_TABLE2 SYSRES_CONST_REQUISITE_SECTION_TABLE20 SYSRES_CONST_REQUISITE_SECTION_TABLE21 SYSRES_CONST_REQUISITE_SECTION_TABLE22 SYSRES_CONST_REQUISITE_SECTION_TABLE23 SYSRES_CONST_REQUISITE_SECTION_TABLE24 SYSRES_CONST_REQUISITE_SECTION_TABLE3 SYSRES_CONST_REQUISITE_SECTION_TABLE4 SYSRES_CONST_REQUISITE_SECTION_TABLE5 SYSRES_CONST_REQUISITE_SECTION_TABLE6 SYSRES_CONST_REQUISITE_SECTION_TABLE7 SYSRES_CONST_REQUISITE_SECTION_TABLE8 SYSRES_CONST_REQUISITE_SECTION_TABLE9 SYSRES_CONST_REQUISITES_PSEUDOREFERENCE_REQUISITE_NUMBER_REQUISITE_CODE SYSRES_CONST_RIGHT_ALIGNMENT_CODE SYSRES_CONST_ROLES_REFERENCE_CODE SYSRES_CONST_ROUTE_STEP_AFTER_RUS SYSRES_CONST_ROUTE_STEP_AND_CONDITION_RUS SYSRES_CONST_ROUTE_STEP_OR_CONDITION_RUS SYSRES_CONST_ROUTE_TYPE_COMPLEX SYSRES_CONST_ROUTE_TYPE_PARALLEL SYSRES_CONST_ROUTE_TYPE_SERIAL SYSRES_CONST_SBDATASETDESC_NEGATIVE_VALUE SYSRES_CONST_SBDATASETDESC_POSITIVE_VALUE SYSRES_CONST_SBVIEWSDESC_POSITIVE_VALUE SYSRES_CONST_SCRIPT_BLOCK_DESCRIPTION SYSRES_CONST_SEARCH_BY_TEXT_REQUISITE_CODE SYSRES_CONST_SEARCHES_COMPONENT_CONTENT SYSRES_CONST_SEARCHES_CRITERIA_ACTION_NAME SYSRES_CONST_SEARCHES_EDOC_CONTENT SYSRES_CONST_SEARCHES_FOLDER_CONTENT SYSRES_CONST_SEARCHES_JOB_CONTENT SYSRES_CONST_SEARCHES_REFERENCE_CODE SYSRES_CONST_SEARCHES_TASK_CONTENT SYSRES_CONST_SECOND_CHAR SYSRES_CONST_SECTION_REQUISITE_ACTIONS_VALUE SYSRES_CONST_SECTION_REQUISITE_CARD_VALUE SYSRES_CONST_SECTION_REQUISITE_CODE SYSRES_CONST_SECTION_REQUISITE_DETAIL_1_VALUE SYSRES_CONST_SECTION_REQUISITE_DETAIL_2_VALUE SYSRES_CONST_SECTION_REQUISITE_DETAIL_3_VALUE SYSRES_CONST_SECTION_REQUISITE_DETAIL_4_VALUE SYSRES_CONST_SECTION_REQUISITE_DETAIL_5_VALUE SYSRES_CONST_SECTION_REQUISITE_DETAIL_6_VALUE SYSRES_CONST_SELECT_REFERENCE_MODE_NAME SYSRES_CONST_SELECT_TYPE_SELECTABLE SYSRES_CONST_SELECT_TYPE_SELECTABLE_ONLY_CHILD SYSRES_CONST_SELECT_TYPE_SELECTABLE_WITH_CHILD SYSRES_CONST_SELECT_TYPE_UNSLECTABLE SYSRES_CONST_SERVER_TYPE_MAIN SYSRES_CONST_SERVICE_USER_CATEGORY_FIELD_VALUE SYSRES_CONST_SETTINGS_USER_REQUISITE_CODE SYSRES_CONST_SIGNATURE_AND_ENCODE_CERTIFICATE_TYPE_CODE SYSRES_CONST_SIGNATURE_CERTIFICATE_TYPE_CODE SYSRES_CONST_SINGULAR_TITLE_REQUISITE_CODE SYSRES_CONST_SQL_SERVER_AUTHENTIFICATION_FLAG_VALUE_CODE SYSRES_CONST_SQL_SERVER_ENCODE_AUTHENTIFICATION_FLAG_VALUE_CODE SYSRES_CONST_STANDART_ROUTE_REFERENCE_CODE SYSRES_CONST_STANDART_ROUTE_REFERENCE_COMMENT_REQUISITE_CODE SYSRES_CONST_STANDART_ROUTES_GROUPS_REFERENCE_CODE SYSRES_CONST_STATE_REQ_NAME SYSRES_CONST_STATE_REQUISITE_ACTIVE_VALUE SYSRES_CONST_STATE_REQUISITE_CLOSED_VALUE SYSRES_CONST_STATE_REQUISITE_CODE SYSRES_CONST_STATIC_ROLE_TYPE_CODE SYSRES_CONST_STATUS_PLAN_DEFAULT_VALUE SYSRES_CONST_STATUS_VALUE_AUTOCLEANING SYSRES_CONST_STATUS_VALUE_BLUE_SQUARE SYSRES_CONST_STATUS_VALUE_COMPLETE SYSRES_CONST_STATUS_VALUE_GREEN_SQUARE SYSRES_CONST_STATUS_VALUE_ORANGE_SQUARE SYSRES_CONST_STATUS_VALUE_PURPLE_SQUARE SYSRES_CONST_STATUS_VALUE_RED_SQUARE SYSRES_CONST_STATUS_VALUE_SUSPEND SYSRES_CONST_STATUS_VALUE_YELLOW_SQUARE SYSRES_CONST_STDROUTE_SHOW_TO_USERS_REQUISITE_CODE SYSRES_CONST_STORAGE_TYPE_FILE SYSRES_CONST_STORAGE_TYPE_SQL_SERVER SYSRES_CONST_STR_REQUISITE SYSRES_CONST_STRIKEOUT_LIFE_CYCLE_STAGE_DRAW_STYLE SYSRES_CONST_STRING_FORMAT_LEFT_ALIGN_CHAR SYSRES_CONST_STRING_FORMAT_RIGHT_ALIGN_CHAR SYSRES_CONST_STRING_REQUISITE_CODE SYSRES_CONST_STRING_REQUISITE_TYPE SYSRES_CONST_STRING_TYPE_CHAR SYSRES_CONST_SUBSTITUTES_PSEUDOREFERENCE_CODE SYSRES_CONST_SUBTASK_BLOCK_DESCRIPTION SYSRES_CONST_SYSTEM_SETTING_CURRENT_USER_PARAM_VALUE SYSRES_CONST_SYSTEM_SETTING_EMPTY_VALUE_PARAM_VALUE SYSRES_CONST_SYSTEM_VERSION_COMMENT SYSRES_CONST_TASK_ACCESS_TYPE_ALL SYSRES_CONST_TASK_ACCESS_TYPE_ALL_MEMBERS SYSRES_CONST_TASK_ACCESS_TYPE_MANUAL SYSRES_CONST_TASK_ENCODE_TYPE_CERTIFICATION SYSRES_CONST_TASK_ENCODE_TYPE_CERTIFICATION_AND_PASSWORD SYSRES_CONST_TASK_ENCODE_TYPE_NONE SYSRES_CONST_TASK_ENCODE_TYPE_PASSWORD SYSRES_CONST_TASK_ROUTE_ALL_CONDITION SYSRES_CONST_TASK_ROUTE_AND_CONDITION SYSRES_CONST_TASK_ROUTE_OR_CONDITION SYSRES_CONST_TASK_STATE_ABORTED SYSRES_CONST_TASK_STATE_COMPLETE SYSRES_CONST_TASK_STATE_CONTINUED SYSRES_CONST_TASK_STATE_CONTROL SYSRES_CONST_TASK_STATE_INIT SYSRES_CONST_TASK_STATE_WORKING SYSRES_CONST_TASK_TITLE SYSRES_CONST_TASK_TYPES_GROUPS_REFERENCE_CODE SYSRES_CONST_TASK_TYPES_REFERENCE_CODE SYSRES_CONST_TEMPLATES_REFERENCE_CODE SYSRES_CONST_TEST_DATE_REQUISITE_NAME SYSRES_CONST_TEST_DEV_DATABASE_NAME SYSRES_CONST_TEST_DEV_SYSTEM_CODE SYSRES_CONST_TEST_EDMS_DATABASE_NAME SYSRES_CONST_TEST_EDMS_MAIN_CODE SYSRES_CONST_TEST_EDMS_MAIN_DB_NAME SYSRES_CONST_TEST_EDMS_SECOND_CODE SYSRES_CONST_TEST_EDMS_SECOND_DB_NAME SYSRES_CONST_TEST_EDMS_SYSTEM_CODE SYSRES_CONST_TEST_NUMERIC_REQUISITE_NAME SYSRES_CONST_TEXT_REQUISITE SYSRES_CONST_TEXT_REQUISITE_CODE SYSRES_CONST_TEXT_REQUISITE_TYPE SYSRES_CONST_TEXT_TYPE_CHAR SYSRES_CONST_TYPE_CODE_REQUISITE_CODE SYSRES_CONST_TYPE_REQUISITE_CODE SYSRES_CONST_UNDEFINED_LIFE_CYCLE_STAGE_FONT_COLOR SYSRES_CONST_UNITS_SECTION_ID_REQUISITE_CODE SYSRES_CONST_UNITS_SECTION_REQUISITE_CODE SYSRES_CONST_UNOPERATING_RECORD_FLAG_VALUE_CODE SYSRES_CONST_UNSTORED_DATA_REQUISITE_CODE SYSRES_CONST_UNSTORED_DATA_REQUISITE_NAME SYSRES_CONST_USE_ACCESS_TYPE_CODE SYSRES_CONST_USE_ACCESS_TYPE_NAME SYSRES_CONST_USER_ACCOUNT_TYPE_VALUE_CODE SYSRES_CONST_USER_ADDITIONAL_INFORMATION_REQUISITE_CODE SYSRES_CONST_USER_AND_GROUP_ID_FROM_PSEUDOREFERENCE_REQUISITE_CODE SYSRES_CONST_USER_CATEGORY_NORMAL SYSRES_CONST_USER_CERTIFICATE_REQUISITE_CODE SYSRES_CONST_USER_CERTIFICATE_STATE_REQUISITE_CODE SYSRES_CONST_USER_CERTIFICATE_SUBJECT_NAME_REQUISITE_CODE SYSRES_CONST_USER_CERTIFICATE_THUMBPRINT_REQUISITE_CODE SYSRES_CONST_USER_COMMON_CATEGORY SYSRES_CONST_USER_COMMON_CATEGORY_CODE SYSRES_CONST_USER_FULL_NAME_REQUISITE_CODE SYSRES_CONST_USER_GROUP_TYPE_REQUISITE_CODE SYSRES_CONST_USER_LOGIN_REQUISITE_CODE SYSRES_CONST_USER_REMOTE_CONTROLLER_REQUISITE_CODE SYSRES_CONST_USER_REMOTE_SYSTEM_REQUISITE_CODE SYSRES_CONST_USER_RIGHTS_T_REQUISITE_CODE SYSRES_CONST_USER_SERVER_NAME_REQUISITE_CODE SYSRES_CONST_USER_SERVICE_CATEGORY SYSRES_CONST_USER_SERVICE_CATEGORY_CODE SYSRES_CONST_USER_STATUS_ADMINISTRATOR_CODE SYSRES_CONST_USER_STATUS_ADMINISTRATOR_NAME SYSRES_CONST_USER_STATUS_DEVELOPER_CODE SYSRES_CONST_USER_STATUS_DEVELOPER_NAME SYSRES_CONST_USER_STATUS_DISABLED_CODE SYSRES_CONST_USER_STATUS_DISABLED_NAME SYSRES_CONST_USER_STATUS_SYSTEM_DEVELOPER_CODE SYSRES_CONST_USER_STATUS_USER_CODE SYSRES_CONST_USER_STATUS_USER_NAME SYSRES_CONST_USER_STATUS_USER_NAME_DEPRECATED SYSRES_CONST_USER_TYPE_FIELD_VALUE_USER SYSRES_CONST_USER_TYPE_REQUISITE_CODE SYSRES_CONST_USERS_CONTROLLER_REQUISITE_CODE SYSRES_CONST_USERS_IS_MAIN_SERVER_REQUISITE_CODE SYSRES_CONST_USERS_REFERENCE_CODE SYSRES_CONST_USERS_REGISTRATION_CERTIFICATES_ACTION_NAME SYSRES_CONST_USERS_REQUISITE_CODE SYSRES_CONST_USERS_SYSTEM_REQUISITE_CODE SYSRES_CONST_USERS_USER_ACCESS_RIGHTS_TYPR_REQUISITE_CODE SYSRES_CONST_USERS_USER_AUTHENTICATION_REQUISITE_CODE SYSRES_CONST_USERS_USER_COMPONENT_REQUISITE_CODE SYSRES_CONST_USERS_USER_GROUP_REQUISITE_CODE SYSRES_CONST_USERS_VIEW_CERTIFICATES_ACTION_NAME SYSRES_CONST_VIEW_DEFAULT_CODE SYSRES_CONST_VIEW_DEFAULT_NAME SYSRES_CONST_VIEWER_REQUISITE_CODE SYSRES_CONST_WAITING_BLOCK_DESCRIPTION SYSRES_CONST_WIZARD_FORM_LABEL_TEST_STRING  SYSRES_CONST_WIZARD_QUERY_PARAM_HEIGHT_ETALON_STRING SYSRES_CONST_WIZARD_REFERENCE_COMMENT_REQUISITE_CODE SYSRES_CONST_WORK_RULES_DESCRIPTION_REQUISITE_CODE SYSRES_CONST_WORK_TIME_CALENDAR_REFERENCE_CODE SYSRES_CONST_WORK_WORKFLOW_HARD_ROUTE_TYPE_VALUE SYSRES_CONST_WORK_WORKFLOW_HARD_ROUTE_TYPE_VALUE_CODE SYSRES_CONST_WORK_WORKFLOW_HARD_ROUTE_TYPE_VALUE_CODE_RUS SYSRES_CONST_WORK_WORKFLOW_SOFT_ROUTE_TYPE_VALUE_CODE_RUS SYSRES_CONST_WORKFLOW_ROUTE_TYPR_HARD SYSRES_CONST_WORKFLOW_ROUTE_TYPR_SOFT SYSRES_CONST_XML_ENCODING SYSRES_CONST_XREC_STAT_REQUISITE_CODE SYSRES_CONST_XRECID_FIELD_NAME SYSRES_CONST_YES SYSRES_CONST_YES_NO_2_REQUISITE_CODE SYSRES_CONST_YES_NO_REQUISITE_CODE SYSRES_CONST_YES_NO_T_REF_TYPE_REQUISITE_CODE SYSRES_CONST_YES_PICK_VALUE SYSRES_CONST_YES_VALUE " + "CR FALSE nil NO_VALUE NULL TAB TRUE YES_VALUE " + "ADMINISTRATORS_GROUP_NAME CUSTOMIZERS_GROUP_NAME DEVELOPERS_GROUP_NAME SERVICE_USERS_GROUP_NAME " + "DECISION_BLOCK_FIRST_OPERAND_PROPERTY DECISION_BLOCK_NAME_PROPERTY DECISION_BLOCK_OPERATION_PROPERTY DECISION_BLOCK_RESULT_TYPE_PROPERTY DECISION_BLOCK_SECOND_OPERAND_PROPERTY " + "ANY_FILE_EXTENTION COMPRESSED_DOCUMENT_EXTENSION EXTENDED_DOCUMENT_EXTENSION SHORT_COMPRESSED_DOCUMENT_EXTENSION SHORT_EXTENDED_DOCUMENT_EXTENSION " + "JOB_BLOCK_ABORT_DEADLINE_PROPERTY JOB_BLOCK_AFTER_FINISH_EVENT JOB_BLOCK_AFTER_QUERY_PARAMETERS_EVENT JOB_BLOCK_ATTACHMENT_PROPERTY JOB_BLOCK_ATTACHMENTS_RIGHTS_GROUP_PROPERTY JOB_BLOCK_ATTACHMENTS_RIGHTS_TYPE_PROPERTY JOB_BLOCK_BEFORE_QUERY_PARAMETERS_EVENT JOB_BLOCK_BEFORE_START_EVENT JOB_BLOCK_CREATED_JOBS_PROPERTY JOB_BLOCK_DEADLINE_PROPERTY JOB_BLOCK_EXECUTION_RESULTS_PROPERTY JOB_BLOCK_IS_PARALLEL_PROPERTY JOB_BLOCK_IS_RELATIVE_ABORT_DEADLINE_PROPERTY JOB_BLOCK_IS_RELATIVE_DEADLINE_PROPERTY JOB_BLOCK_JOB_TEXT_PROPERTY JOB_BLOCK_NAME_PROPERTY JOB_BLOCK_NEED_SIGN_ON_PERFORM_PROPERTY JOB_BLOCK_PERFORMER_PROPERTY JOB_BLOCK_RELATIVE_ABORT_DEADLINE_TYPE_PROPERTY JOB_BLOCK_RELATIVE_DEADLINE_TYPE_PROPERTY JOB_BLOCK_SUBJECT_PROPERTY " + "ENGLISH_LANGUAGE_CODE RUSSIAN_LANGUAGE_CODE " + "smHidden smMaximized smMinimized smNormal wmNo wmYes " + "COMPONENT_TOKEN_LINK_KIND DOCUMENT_LINK_KIND EDOCUMENT_LINK_KIND FOLDER_LINK_KIND JOB_LINK_KIND REFERENCE_LINK_KIND TASK_LINK_KIND " + "COMPONENT_TOKEN_LOCK_TYPE EDOCUMENT_VERSION_LOCK_TYPE " + "MONITOR_BLOCK_AFTER_FINISH_EVENT MONITOR_BLOCK_BEFORE_START_EVENT MONITOR_BLOCK_DEADLINE_PROPERTY MONITOR_BLOCK_INTERVAL_PROPERTY MONITOR_BLOCK_INTERVAL_TYPE_PROPERTY MONITOR_BLOCK_IS_RELATIVE_DEADLINE_PROPERTY MONITOR_BLOCK_NAME_PROPERTY MONITOR_BLOCK_RELATIVE_DEADLINE_TYPE_PROPERTY MONITOR_BLOCK_SEARCH_SCRIPT_PROPERTY " + "NOTICE_BLOCK_AFTER_FINISH_EVENT NOTICE_BLOCK_ATTACHMENT_PROPERTY NOTICE_BLOCK_ATTACHMENTS_RIGHTS_GROUP_PROPERTY NOTICE_BLOCK_ATTACHMENTS_RIGHTS_TYPE_PROPERTY NOTICE_BLOCK_BEFORE_START_EVENT NOTICE_BLOCK_CREATED_NOTICES_PROPERTY NOTICE_BLOCK_DEADLINE_PROPERTY NOTICE_BLOCK_IS_RELATIVE_DEADLINE_PROPERTY NOTICE_BLOCK_NAME_PROPERTY NOTICE_BLOCK_NOTICE_TEXT_PROPERTY NOTICE_BLOCK_PERFORMER_PROPERTY NOTICE_BLOCK_RELATIVE_DEADLINE_TYPE_PROPERTY NOTICE_BLOCK_SUBJECT_PROPERTY " + "dseAfterCancel dseAfterClose dseAfterDelete dseAfterDeleteOutOfTransaction dseAfterInsert dseAfterOpen dseAfterScroll dseAfterUpdate dseAfterUpdateOutOfTransaction dseBeforeCancel dseBeforeClose dseBeforeDelete dseBeforeDetailUpdate dseBeforeInsert dseBeforeOpen dseBeforeUpdate dseOnAnyRequisiteChange dseOnCloseRecord dseOnDeleteError dseOnOpenRecord dseOnPrepareUpdate dseOnUpdateError dseOnUpdateRatifiedRecord dseOnValidDelete dseOnValidUpdate reOnChange reOnChangeValues SELECTION_BEGIN_ROUTE_EVENT SELECTION_END_ROUTE_EVENT " + "CURRENT_PERIOD_IS_REQUIRED PREVIOUS_CARD_TYPE_NAME SHOW_RECORD_PROPERTIES_FORM " + "ACCESS_RIGHTS_SETTING_DIALOG_CODE ADMINISTRATOR_USER_CODE ANALYTIC_REPORT_TYPE asrtHideLocal asrtHideRemote CALCULATED_ROLE_TYPE_CODE COMPONENTS_REFERENCE_DEVELOPER_VIEW_CODE DCTS_TEST_PROTOCOLS_FOLDER_PATH E_EDOC_VERSION_ALREADY_APPROVINGLY_SIGNED E_EDOC_VERSION_ALREADY_APPROVINGLY_SIGNED_BY_USER E_EDOC_VERSION_ALREDY_SIGNED E_EDOC_VERSION_ALREDY_SIGNED_BY_USER EDOC_TYPES_CODE_REQUISITE_FIELD_NAME EDOCUMENTS_ALIAS_NAME FILES_FOLDER_PATH FILTER_OPERANDS_DELIMITER FILTER_OPERATIONS_DELIMITER FORMCARD_NAME FORMLIST_NAME GET_EXTENDED_DOCUMENT_EXTENSION_CREATION_MODE GET_EXTENDED_DOCUMENT_EXTENSION_IMPORT_MODE INTEGRATED_REPORT_TYPE IS_BUILDER_APPLICATION_ROLE IS_BUILDER_APPLICATION_ROLE2 IS_BUILDER_USERS ISBSYSDEV LOG_FOLDER_PATH mbCancel mbNo mbNoToAll mbOK mbYes mbYesToAll MEMORY_DATASET_DESRIPTIONS_FILENAME mrNo mrNoToAll mrYes mrYesToAll MULTIPLE_SELECT_DIALOG_CODE NONOPERATING_RECORD_FLAG_FEMININE NONOPERATING_RECORD_FLAG_MASCULINE OPERATING_RECORD_FLAG_FEMININE OPERATING_RECORD_FLAG_MASCULINE PROFILING_SETTINGS_COMMON_SETTINGS_CODE_VALUE PROGRAM_INITIATED_LOOKUP_ACTION ratDelete ratEdit ratInsert REPORT_TYPE REQUIRED_PICK_VALUES_VARIABLE rmCard rmList SBRTE_PROGID_DEV SBRTE_PROGID_RELEASE STATIC_ROLE_TYPE_CODE SUPPRESS_EMPTY_TEMPLATE_CREATION SYSTEM_USER_CODE UPDATE_DIALOG_DATASET USED_IN_OBJECT_HINT_PARAM USER_INITIATED_LOOKUP_ACTION USER_NAME_FORMAT USER_SELECTION_RESTRICTIONS WORKFLOW_TEST_PROTOCOLS_FOLDER_PATH ELS_SUBTYPE_CONTROL_NAME ELS_FOLDER_KIND_CONTROL_NAME REPEAT_PROCESS_CURRENT_OBJECT_EXCEPTION_NAME " + "PRIVILEGE_COMPONENT_FULL_ACCESS PRIVILEGE_DEVELOPMENT_EXPORT PRIVILEGE_DEVELOPMENT_IMPORT PRIVILEGE_DOCUMENT_DELETE PRIVILEGE_ESD PRIVILEGE_FOLDER_DELETE PRIVILEGE_MANAGE_ACCESS_RIGHTS PRIVILEGE_MANAGE_REPLICATION PRIVILEGE_MANAGE_SESSION_SERVER PRIVILEGE_OBJECT_FULL_ACCESS PRIVILEGE_OBJECT_VIEW PRIVILEGE_RESERVE_LICENSE PRIVILEGE_SYSTEM_CUSTOMIZE PRIVILEGE_SYSTEM_DEVELOP PRIVILEGE_SYSTEM_INSTALL PRIVILEGE_TASK_DELETE PRIVILEGE_USER_PLUGIN_SETTINGS_CUSTOMIZE PRIVILEGES_PSEUDOREFERENCE_CODE " + "ACCESS_TYPES_PSEUDOREFERENCE_CODE ALL_AVAILABLE_COMPONENTS_PSEUDOREFERENCE_CODE ALL_AVAILABLE_PRIVILEGES_PSEUDOREFERENCE_CODE ALL_REPLICATE_COMPONENTS_PSEUDOREFERENCE_CODE AVAILABLE_DEVELOPERS_COMPONENTS_PSEUDOREFERENCE_CODE COMPONENTS_PSEUDOREFERENCE_CODE FILTRATER_SETTINGS_CONFLICTS_PSEUDOREFERENCE_CODE GROUPS_PSEUDOREFERENCE_CODE RECEIVE_PROTOCOL_PSEUDOREFERENCE_CODE REFERENCE_REQUISITE_PSEUDOREFERENCE_CODE REFERENCE_REQUISITES_PSEUDOREFERENCE_CODE REFTYPES_PSEUDOREFERENCE_CODE REPLICATION_SEANCES_DIARY_PSEUDOREFERENCE_CODE SEND_PROTOCOL_PSEUDOREFERENCE_CODE SUBSTITUTES_PSEUDOREFERENCE_CODE SYSTEM_SETTINGS_PSEUDOREFERENCE_CODE UNITS_PSEUDOREFERENCE_CODE USERS_PSEUDOREFERENCE_CODE VIEWERS_PSEUDOREFERENCE_CODE " + "CERTIFICATE_TYPE_ENCRYPT CERTIFICATE_TYPE_SIGN CERTIFICATE_TYPE_SIGN_AND_ENCRYPT " + "STORAGE_TYPE_FILE STORAGE_TYPE_NAS_CIFS STORAGE_TYPE_SAPERION STORAGE_TYPE_SQL_SERVER " + "COMPTYPE2_REQUISITE_DOCUMENTS_VALUE COMPTYPE2_REQUISITE_TASKS_VALUE COMPTYPE2_REQUISITE_FOLDERS_VALUE COMPTYPE2_REQUISITE_REFERENCES_VALUE " + "SYSREQ_CODE SYSREQ_COMPTYPE2 SYSREQ_CONST_AVAILABLE_FOR_WEB SYSREQ_CONST_COMMON_CODE SYSREQ_CONST_COMMON_VALUE SYSREQ_CONST_FIRM_CODE SYSREQ_CONST_FIRM_STATUS SYSREQ_CONST_FIRM_VALUE SYSREQ_CONST_SERVER_STATUS SYSREQ_CONTENTS SYSREQ_DATE_OPEN SYSREQ_DATE_CLOSE SYSREQ_DESCRIPTION SYSREQ_DESCRIPTION_LOCALIZE_ID SYSREQ_DOUBLE SYSREQ_EDOC_ACCESS_TYPE SYSREQ_EDOC_AUTHOR SYSREQ_EDOC_CREATED SYSREQ_EDOC_DELEGATE_RIGHTS_REQUISITE_CODE SYSREQ_EDOC_EDITOR SYSREQ_EDOC_ENCODE_TYPE SYSREQ_EDOC_ENCRYPTION_PLUGIN_NAME SYSREQ_EDOC_ENCRYPTION_PLUGIN_VERSION SYSREQ_EDOC_EXPORT_DATE SYSREQ_EDOC_EXPORTER SYSREQ_EDOC_KIND SYSREQ_EDOC_LIFE_STAGE_NAME SYSREQ_EDOC_LOCKED_FOR_SERVER_CODE SYSREQ_EDOC_MODIFIED SYSREQ_EDOC_NAME SYSREQ_EDOC_NOTE SYSREQ_EDOC_QUALIFIED_ID SYSREQ_EDOC_SESSION_KEY SYSREQ_EDOC_SESSION_KEY_ENCRYPTION_PLUGIN_NAME SYSREQ_EDOC_SESSION_KEY_ENCRYPTION_PLUGIN_VERSION SYSREQ_EDOC_SIGNATURE_TYPE SYSREQ_EDOC_SIGNED SYSREQ_EDOC_STORAGE SYSREQ_EDOC_STORAGES_ARCHIVE_STORAGE SYSREQ_EDOC_STORAGES_CHECK_RIGHTS SYSREQ_EDOC_STORAGES_COMPUTER_NAME SYSREQ_EDOC_STORAGES_EDIT_IN_STORAGE SYSREQ_EDOC_STORAGES_EXECUTIVE_STORAGE SYSREQ_EDOC_STORAGES_FUNCTION SYSREQ_EDOC_STORAGES_INITIALIZED SYSREQ_EDOC_STORAGES_LOCAL_PATH SYSREQ_EDOC_STORAGES_SAPERION_DATABASE_NAME SYSREQ_EDOC_STORAGES_SEARCH_BY_TEXT SYSREQ_EDOC_STORAGES_SERVER_NAME SYSREQ_EDOC_STORAGES_SHARED_SOURCE_NAME SYSREQ_EDOC_STORAGES_TYPE SYSREQ_EDOC_TEXT_MODIFIED SYSREQ_EDOC_TYPE_ACT_CODE SYSREQ_EDOC_TYPE_ACT_DESCRIPTION SYSREQ_EDOC_TYPE_ACT_DESCRIPTION_LOCALIZE_ID SYSREQ_EDOC_TYPE_ACT_ON_EXECUTE SYSREQ_EDOC_TYPE_ACT_ON_EXECUTE_EXISTS SYSREQ_EDOC_TYPE_ACT_SECTION SYSREQ_EDOC_TYPE_ADD_PARAMS SYSREQ_EDOC_TYPE_COMMENT SYSREQ_EDOC_TYPE_EVENT_TEXT SYSREQ_EDOC_TYPE_NAME_IN_SINGULAR SYSREQ_EDOC_TYPE_NAME_IN_SINGULAR_LOCALIZE_ID SYSREQ_EDOC_TYPE_NAME_LOCALIZE_ID SYSREQ_EDOC_TYPE_NUMERATION_METHOD SYSREQ_EDOC_TYPE_PSEUDO_REQUISITE_CODE SYSREQ_EDOC_TYPE_REQ_CODE SYSREQ_EDOC_TYPE_REQ_DESCRIPTION SYSREQ_EDOC_TYPE_REQ_DESCRIPTION_LOCALIZE_ID SYSREQ_EDOC_TYPE_REQ_IS_LEADING SYSREQ_EDOC_TYPE_REQ_IS_REQUIRED SYSREQ_EDOC_TYPE_REQ_NUMBER SYSREQ_EDOC_TYPE_REQ_ON_CHANGE SYSREQ_EDOC_TYPE_REQ_ON_CHANGE_EXISTS SYSREQ_EDOC_TYPE_REQ_ON_SELECT SYSREQ_EDOC_TYPE_REQ_ON_SELECT_KIND SYSREQ_EDOC_TYPE_REQ_SECTION SYSREQ_EDOC_TYPE_VIEW_CARD SYSREQ_EDOC_TYPE_VIEW_CODE SYSREQ_EDOC_TYPE_VIEW_COMMENT SYSREQ_EDOC_TYPE_VIEW_IS_MAIN SYSREQ_EDOC_TYPE_VIEW_NAME SYSREQ_EDOC_TYPE_VIEW_NAME_LOCALIZE_ID SYSREQ_EDOC_VERSION_AUTHOR SYSREQ_EDOC_VERSION_CRC SYSREQ_EDOC_VERSION_DATA SYSREQ_EDOC_VERSION_EDITOR SYSREQ_EDOC_VERSION_EXPORT_DATE SYSREQ_EDOC_VERSION_EXPORTER SYSREQ_EDOC_VERSION_HIDDEN SYSREQ_EDOC_VERSION_LIFE_STAGE SYSREQ_EDOC_VERSION_MODIFIED SYSREQ_EDOC_VERSION_NOTE SYSREQ_EDOC_VERSION_SIGNATURE_TYPE SYSREQ_EDOC_VERSION_SIGNED SYSREQ_EDOC_VERSION_SIZE SYSREQ_EDOC_VERSION_SOURCE SYSREQ_EDOC_VERSION_TEXT_MODIFIED SYSREQ_EDOCKIND_DEFAULT_VERSION_STATE_CODE SYSREQ_FOLDER_KIND SYSREQ_FUNC_CATEGORY SYSREQ_FUNC_COMMENT SYSREQ_FUNC_GROUP SYSREQ_FUNC_GROUP_COMMENT SYSREQ_FUNC_GROUP_NUMBER SYSREQ_FUNC_HELP SYSREQ_FUNC_PARAM_DEF_VALUE SYSREQ_FUNC_PARAM_IDENT SYSREQ_FUNC_PARAM_NUMBER SYSREQ_FUNC_PARAM_TYPE SYSREQ_FUNC_TEXT SYSREQ_GROUP_CATEGORY SYSREQ_ID SYSREQ_LAST_UPDATE SYSREQ_LEADER_REFERENCE SYSREQ_LINE_NUMBER SYSREQ_MAIN_RECORD_ID SYSREQ_NAME SYSREQ_NAME_LOCALIZE_ID SYSREQ_NOTE SYSREQ_ORIGINAL_RECORD SYSREQ_OUR_FIRM SYSREQ_PROFILING_SETTINGS_BATCH_LOGING SYSREQ_PROFILING_SETTINGS_BATCH_SIZE SYSREQ_PROFILING_SETTINGS_PROFILING_ENABLED SYSREQ_PROFILING_SETTINGS_SQL_PROFILING_ENABLED SYSREQ_PROFILING_SETTINGS_START_LOGGED SYSREQ_RECORD_STATUS SYSREQ_REF_REQ_FIELD_NAME SYSREQ_REF_REQ_FORMAT SYSREQ_REF_REQ_GENERATED SYSREQ_REF_REQ_LENGTH SYSREQ_REF_REQ_PRECISION SYSREQ_REF_REQ_REFERENCE SYSREQ_REF_REQ_SECTION SYSREQ_REF_REQ_STORED SYSREQ_REF_REQ_TOKENS SYSREQ_REF_REQ_TYPE SYSREQ_REF_REQ_VIEW SYSREQ_REF_TYPE_ACT_CODE SYSREQ_REF_TYPE_ACT_DESCRIPTION SYSREQ_REF_TYPE_ACT_DESCRIPTION_LOCALIZE_ID SYSREQ_REF_TYPE_ACT_ON_EXECUTE SYSREQ_REF_TYPE_ACT_ON_EXECUTE_EXISTS SYSREQ_REF_TYPE_ACT_SECTION SYSREQ_REF_TYPE_ADD_PARAMS SYSREQ_REF_TYPE_COMMENT SYSREQ_REF_TYPE_COMMON_SETTINGS SYSREQ_REF_TYPE_DISPLAY_REQUISITE_NAME SYSREQ_REF_TYPE_EVENT_TEXT SYSREQ_REF_TYPE_MAIN_LEADING_REF SYSREQ_REF_TYPE_NAME_IN_SINGULAR SYSREQ_REF_TYPE_NAME_IN_SINGULAR_LOCALIZE_ID SYSREQ_REF_TYPE_NAME_LOCALIZE_ID SYSREQ_REF_TYPE_NUMERATION_METHOD SYSREQ_REF_TYPE_REQ_CODE SYSREQ_REF_TYPE_REQ_DESCRIPTION SYSREQ_REF_TYPE_REQ_DESCRIPTION_LOCALIZE_ID SYSREQ_REF_TYPE_REQ_IS_CONTROL SYSREQ_REF_TYPE_REQ_IS_FILTER SYSREQ_REF_TYPE_REQ_IS_LEADING SYSREQ_REF_TYPE_REQ_IS_REQUIRED SYSREQ_REF_TYPE_REQ_NUMBER SYSREQ_REF_TYPE_REQ_ON_CHANGE SYSREQ_REF_TYPE_REQ_ON_CHANGE_EXISTS SYSREQ_REF_TYPE_REQ_ON_SELECT SYSREQ_REF_TYPE_REQ_ON_SELECT_KIND SYSREQ_REF_TYPE_REQ_SECTION SYSREQ_REF_TYPE_VIEW_CARD SYSREQ_REF_TYPE_VIEW_CODE SYSREQ_REF_TYPE_VIEW_COMMENT SYSREQ_REF_TYPE_VIEW_IS_MAIN SYSREQ_REF_TYPE_VIEW_NAME SYSREQ_REF_TYPE_VIEW_NAME_LOCALIZE_ID SYSREQ_REFERENCE_TYPE_ID SYSREQ_STATE SYSREQ_STATЕ SYSREQ_SYSTEM_SETTINGS_VALUE SYSREQ_TYPE SYSREQ_UNIT SYSREQ_UNIT_ID SYSREQ_USER_GROUPS_GROUP_FULL_NAME SYSREQ_USER_GROUPS_GROUP_NAME SYSREQ_USER_GROUPS_GROUP_SERVER_NAME SYSREQ_USERS_ACCESS_RIGHTS SYSREQ_USERS_AUTHENTICATION SYSREQ_USERS_CATEGORY SYSREQ_USERS_COMPONENT SYSREQ_USERS_COMPONENT_USER_IS_PUBLIC SYSREQ_USERS_DOMAIN SYSREQ_USERS_FULL_USER_NAME SYSREQ_USERS_GROUP SYSREQ_USERS_IS_MAIN_SERVER SYSREQ_USERS_LOGIN SYSREQ_USERS_REFERENCE_USER_IS_PUBLIC SYSREQ_USERS_STATUS SYSREQ_USERS_USER_CERTIFICATE SYSREQ_USERS_USER_CERTIFICATE_INFO SYSREQ_USERS_USER_CERTIFICATE_PLUGIN_NAME SYSREQ_USERS_USER_CERTIFICATE_PLUGIN_VERSION SYSREQ_USERS_USER_CERTIFICATE_STATE SYSREQ_USERS_USER_CERTIFICATE_SUBJECT_NAME SYSREQ_USERS_USER_CERTIFICATE_THUMBPRINT SYSREQ_USERS_USER_DEFAULT_CERTIFICATE SYSREQ_USERS_USER_DESCRIPTION SYSREQ_USERS_USER_GLOBAL_NAME SYSREQ_USERS_USER_LOGIN SYSREQ_USERS_USER_MAIN_SERVER SYSREQ_USERS_USER_TYPE SYSREQ_WORK_RULES_FOLDER_ID " + "RESULT_VAR_NAME RESULT_VAR_NAME_ENG " + "AUTO_NUMERATION_RULE_ID CANT_CHANGE_ID_REQUISITE_RULE_ID CANT_CHANGE_OURFIRM_REQUISITE_RULE_ID CHECK_CHANGING_REFERENCE_RECORD_USE_RULE_ID CHECK_CODE_REQUISITE_RULE_ID CHECK_DELETING_REFERENCE_RECORD_USE_RULE_ID CHECK_FILTRATER_CHANGES_RULE_ID CHECK_RECORD_INTERVAL_RULE_ID CHECK_REFERENCE_INTERVAL_RULE_ID CHECK_REQUIRED_DATA_FULLNESS_RULE_ID CHECK_REQUIRED_REQUISITES_FULLNESS_RULE_ID MAKE_RECORD_UNRATIFIED_RULE_ID RESTORE_AUTO_NUMERATION_RULE_ID SET_FIRM_CONTEXT_FROM_RECORD_RULE_ID SET_FIRST_RECORD_IN_LIST_FORM_RULE_ID SET_IDSPS_VALUE_RULE_ID SET_NEXT_CODE_VALUE_RULE_ID SET_OURFIRM_BOUNDS_RULE_ID SET_OURFIRM_REQUISITE_RULE_ID " + "SCRIPT_BLOCK_AFTER_FINISH_EVENT SCRIPT_BLOCK_BEFORE_START_EVENT SCRIPT_BLOCK_EXECUTION_RESULTS_PROPERTY SCRIPT_BLOCK_NAME_PROPERTY SCRIPT_BLOCK_SCRIPT_PROPERTY " + "SUBTASK_BLOCK_ABORT_DEADLINE_PROPERTY SUBTASK_BLOCK_AFTER_FINISH_EVENT SUBTASK_BLOCK_ASSIGN_PARAMS_EVENT SUBTASK_BLOCK_ATTACHMENTS_PROPERTY SUBTASK_BLOCK_ATTACHMENTS_RIGHTS_GROUP_PROPERTY SUBTASK_BLOCK_ATTACHMENTS_RIGHTS_TYPE_PROPERTY SUBTASK_BLOCK_BEFORE_START_EVENT SUBTASK_BLOCK_CREATED_TASK_PROPERTY SUBTASK_BLOCK_CREATION_EVENT SUBTASK_BLOCK_DEADLINE_PROPERTY SUBTASK_BLOCK_IMPORTANCE_PROPERTY SUBTASK_BLOCK_INITIATOR_PROPERTY SUBTASK_BLOCK_IS_RELATIVE_ABORT_DEADLINE_PROPERTY SUBTASK_BLOCK_IS_RELATIVE_DEADLINE_PROPERTY SUBTASK_BLOCK_JOBS_TYPE_PROPERTY SUBTASK_BLOCK_NAME_PROPERTY SUBTASK_BLOCK_PARALLEL_ROUTE_PROPERTY SUBTASK_BLOCK_PERFORMERS_PROPERTY SUBTASK_BLOCK_RELATIVE_ABORT_DEADLINE_TYPE_PROPERTY SUBTASK_BLOCK_RELATIVE_DEADLINE_TYPE_PROPERTY SUBTASK_BLOCK_REQUIRE_SIGN_PROPERTY SUBTASK_BLOCK_STANDARD_ROUTE_PROPERTY SUBTASK_BLOCK_START_EVENT SUBTASK_BLOCK_STEP_CONTROL_PROPERTY SUBTASK_BLOCK_SUBJECT_PROPERTY SUBTASK_BLOCK_TASK_CONTROL_PROPERTY SUBTASK_BLOCK_TEXT_PROPERTY SUBTASK_BLOCK_UNLOCK_ATTACHMENTS_ON_STOP_PROPERTY SUBTASK_BLOCK_USE_STANDARD_ROUTE_PROPERTY SUBTASK_BLOCK_WAIT_FOR_TASK_COMPLETE_PROPERTY " + "SYSCOMP_CONTROL_JOBS SYSCOMP_FOLDERS SYSCOMP_JOBS SYSCOMP_NOTICES SYSCOMP_TASKS " + "SYSDLG_CREATE_EDOCUMENT SYSDLG_CREATE_EDOCUMENT_VERSION SYSDLG_CURRENT_PERIOD SYSDLG_EDIT_FUNCTION_HELP SYSDLG_EDOCUMENT_KINDS_FOR_TEMPLATE SYSDLG_EXPORT_MULTIPLE_EDOCUMENTS SYSDLG_EXPORT_SINGLE_EDOCUMENT SYSDLG_IMPORT_EDOCUMENT SYSDLG_MULTIPLE_SELECT SYSDLG_SETUP_ACCESS_RIGHTS SYSDLG_SETUP_DEFAULT_RIGHTS SYSDLG_SETUP_FILTER_CONDITION SYSDLG_SETUP_SIGN_RIGHTS SYSDLG_SETUP_TASK_OBSERVERS SYSDLG_SETUP_TASK_ROUTE SYSDLG_SETUP_USERS_LIST SYSDLG_SIGN_EDOCUMENT SYSDLG_SIGN_MULTIPLE_EDOCUMENTS " + "SYSREF_ACCESS_RIGHTS_TYPES SYSREF_ADMINISTRATION_HISTORY SYSREF_ALL_AVAILABLE_COMPONENTS SYSREF_ALL_AVAILABLE_PRIVILEGES SYSREF_ALL_REPLICATING_COMPONENTS SYSREF_AVAILABLE_DEVELOPERS_COMPONENTS SYSREF_CALENDAR_EVENTS SYSREF_COMPONENT_TOKEN_HISTORY SYSREF_COMPONENT_TOKENS SYSREF_COMPONENTS SYSREF_CONSTANTS SYSREF_DATA_RECEIVE_PROTOCOL SYSREF_DATA_SEND_PROTOCOL SYSREF_DIALOGS SYSREF_DIALOGS_REQUISITES SYSREF_EDITORS SYSREF_EDOC_CARDS SYSREF_EDOC_TYPES SYSREF_EDOCUMENT_CARD_REQUISITES SYSREF_EDOCUMENT_CARD_TYPES SYSREF_EDOCUMENT_CARD_TYPES_REFERENCE SYSREF_EDOCUMENT_CARDS SYSREF_EDOCUMENT_HISTORY SYSREF_EDOCUMENT_KINDS SYSREF_EDOCUMENT_REQUISITES SYSREF_EDOCUMENT_SIGNATURES SYSREF_EDOCUMENT_TEMPLATES SYSREF_EDOCUMENT_TEXT_STORAGES SYSREF_EDOCUMENT_VIEWS SYSREF_FILTERER_SETUP_CONFLICTS SYSREF_FILTRATER_SETTING_CONFLICTS SYSREF_FOLDER_HISTORY SYSREF_FOLDERS SYSREF_FUNCTION_GROUPS SYSREF_FUNCTION_PARAMS SYSREF_FUNCTIONS SYSREF_JOB_HISTORY SYSREF_LINKS SYSREF_LOCALIZATION_DICTIONARY SYSREF_LOCALIZATION_LANGUAGES SYSREF_MODULES SYSREF_PRIVILEGES SYSREF_RECORD_HISTORY SYSREF_REFERENCE_REQUISITES SYSREF_REFERENCE_TYPE_VIEWS SYSREF_REFERENCE_TYPES SYSREF_REFERENCES SYSREF_REFERENCES_REQUISITES SYSREF_REMOTE_SERVERS SYSREF_REPLICATION_SESSIONS_LOG SYSREF_REPLICATION_SESSIONS_PROTOCOL SYSREF_REPORTS SYSREF_ROLES SYSREF_ROUTE_BLOCK_GROUPS SYSREF_ROUTE_BLOCKS SYSREF_SCRIPTS SYSREF_SEARCHES SYSREF_SERVER_EVENTS SYSREF_SERVER_EVENTS_HISTORY SYSREF_STANDARD_ROUTE_GROUPS SYSREF_STANDARD_ROUTES SYSREF_STATUSES SYSREF_SYSTEM_SETTINGS SYSREF_TASK_HISTORY SYSREF_TASK_KIND_GROUPS SYSREF_TASK_KINDS SYSREF_TASK_RIGHTS SYSREF_TASK_SIGNATURES SYSREF_TASKS SYSREF_UNITS SYSREF_USER_GROUPS SYSREF_USER_GROUPS_REFERENCE SYSREF_USER_SUBSTITUTION SYSREF_USERS SYSREF_USERS_REFERENCE SYSREF_VIEWERS SYSREF_WORKING_TIME_CALENDARS " + "ACCESS_RIGHTS_TABLE_NAME EDMS_ACCESS_TABLE_NAME EDOC_TYPES_TABLE_NAME " + "TEST_DEV_DB_NAME TEST_DEV_SYSTEM_CODE TEST_EDMS_DB_NAME TEST_EDMS_MAIN_CODE TEST_EDMS_MAIN_DB_NAME TEST_EDMS_SECOND_CODE TEST_EDMS_SECOND_DB_NAME TEST_EDMS_SYSTEM_CODE TEST_ISB5_MAIN_CODE TEST_ISB5_SECOND_CODE TEST_SQL_SERVER_2005_NAME TEST_SQL_SERVER_NAME " + "ATTENTION_CAPTION cbsCommandLinks cbsDefault CONFIRMATION_CAPTION ERROR_CAPTION INFORMATION_CAPTION mrCancel mrOk " + "EDOC_VERSION_ACTIVE_STAGE_CODE EDOC_VERSION_DESIGN_STAGE_CODE EDOC_VERSION_OBSOLETE_STAGE_CODE " + "cpDataEnciphermentEnabled cpDigitalSignatureEnabled cpID cpIssuer cpPluginVersion cpSerial cpSubjectName cpSubjSimpleName cpValidFromDate cpValidToDate " + "ISBL_SYNTAX NO_SYNTAX XML_SYNTAX " + "WAIT_BLOCK_AFTER_FINISH_EVENT WAIT_BLOCK_BEFORE_START_EVENT WAIT_BLOCK_DEADLINE_PROPERTY WAIT_BLOCK_IS_RELATIVE_DEADLINE_PROPERTY WAIT_BLOCK_NAME_PROPERTY WAIT_BLOCK_RELATIVE_DEADLINE_TYPE_PROPERTY " + "SYSRES_COMMON SYSRES_CONST SYSRES_MBFUNC SYSRES_SBDATA SYSRES_SBGUI SYSRES_SBINTF SYSRES_SBREFDSC SYSRES_SQLERRORS SYSRES_SYSCOMP ", Ar = "atUser atGroup atRole " + "aemEnabledAlways aemDisabledAlways aemEnabledOnBrowse aemEnabledOnEdit aemDisabledOnBrowseEmpty " + "apBegin apEnd " + "alLeft alRight " + "asmNever asmNoButCustomize asmAsLastTime asmYesButCustomize asmAlways " + "cirCommon cirRevoked " + "ctSignature ctEncode ctSignatureEncode " + "clbUnchecked clbChecked clbGrayed " + "ceISB ceAlways ceNever " + "ctDocument ctReference ctScript ctUnknown ctReport ctDialog ctFunction ctFolder ctEDocument ctTask ctJob ctNotice ctControlJob " + "cfInternal cfDisplay " + "ciUnspecified ciWrite ciRead " + "ckFolder ckEDocument ckTask ckJob ckComponentToken ckAny ckReference ckScript ckReport ckDialog " + "ctISBLEditor ctBevel ctButton ctCheckListBox ctComboBox ctComboEdit ctGrid ctDBCheckBox ctDBComboBox ctDBEdit ctDBEllipsis ctDBMemo ctDBNavigator ctDBRadioGroup ctDBStatusLabel ctEdit ctGroupBox ctInplaceHint ctMemo ctPanel ctListBox ctRadioButton ctRichEdit ctTabSheet ctWebBrowser ctImage ctHyperLink ctLabel ctDBMultiEllipsis ctRibbon ctRichView ctInnerPanel ctPanelGroup ctBitButton " + "cctDate cctInteger cctNumeric cctPick cctReference cctString cctText " + "cltInternal cltPrimary cltGUI " + "dseBeforeOpen dseAfterOpen dseBeforeClose dseAfterClose dseOnValidDelete dseBeforeDelete dseAfterDelete dseAfterDeleteOutOfTransaction dseOnDeleteError dseBeforeInsert dseAfterInsert dseOnValidUpdate dseBeforeUpdate dseOnUpdateRatifiedRecord dseAfterUpdate dseAfterUpdateOutOfTransaction dseOnUpdateError dseAfterScroll dseOnOpenRecord dseOnCloseRecord dseBeforeCancel dseAfterCancel dseOnUpdateDeadlockError dseBeforeDetailUpdate dseOnPrepareUpdate dseOnAnyRequisiteChange " + "dssEdit dssInsert dssBrowse dssInActive " + "dftDate dftShortDate dftDateTime dftTimeStamp " + "dotDays dotHours dotMinutes dotSeconds " + "dtkndLocal dtkndUTC " + "arNone arView arEdit arFull " + "ddaView ddaEdit " + "emLock emEdit emSign emExportWithLock emImportWithUnlock emChangeVersionNote emOpenForModify emChangeLifeStage emDelete emCreateVersion emImport emUnlockExportedWithLock emStart emAbort emReInit emMarkAsReaded emMarkAsUnreaded emPerform emAccept emResume emChangeRights emEditRoute emEditObserver emRecoveryFromLocalCopy emChangeWorkAccessType emChangeEncodeTypeToCertificate emChangeEncodeTypeToPassword emChangeEncodeTypeToNone emChangeEncodeTypeToCertificatePassword emChangeStandardRoute emGetText emOpenForView emMoveToStorage emCreateObject emChangeVersionHidden emDeleteVersion emChangeLifeCycleStage emApprovingSign emExport emContinue emLockFromEdit emUnLockForEdit emLockForServer emUnlockFromServer emDelegateAccessRights emReEncode " + "ecotFile ecotProcess " + "eaGet eaCopy eaCreate eaCreateStandardRoute " + "edltAll edltNothing edltQuery " + "essmText essmCard " + "esvtLast esvtLastActive esvtSpecified " + "edsfExecutive edsfArchive " + "edstSQLServer edstFile " + "edvstNone edvstEDocumentVersionCopy edvstFile edvstTemplate edvstScannedFile " + "vsDefault vsDesign vsActive vsObsolete " + "etNone etCertificate etPassword etCertificatePassword " + "ecException ecWarning ecInformation " + "estAll estApprovingOnly " + "evtLast evtLastActive evtQuery " + "fdtString fdtNumeric fdtInteger fdtDate fdtText fdtUnknown fdtWideString fdtLargeInteger " + "ftInbox ftOutbox ftFavorites ftCommonFolder ftUserFolder ftComponents ftQuickLaunch ftShortcuts ftSearch " + "grhAuto grhX1 grhX2 grhX3 " + "hltText hltRTF hltHTML " + "iffBMP iffJPEG iffMultiPageTIFF iffSinglePageTIFF iffTIFF iffPNG " + "im8bGrayscale im24bRGB im1bMonochrome " + "itBMP itJPEG itWMF itPNG " + "ikhInformation ikhWarning ikhError ikhNoIcon " + "icUnknown icScript icFunction icIntegratedReport icAnalyticReport icDataSetEventHandler icActionHandler icFormEventHandler icLookUpEventHandler icRequisiteChangeEventHandler icBeforeSearchEventHandler icRoleCalculation icSelectRouteEventHandler icBlockPropertyCalculation icBlockQueryParamsEventHandler icChangeSearchResultEventHandler icBlockEventHandler icSubTaskInitEventHandler icEDocDataSetEventHandler icEDocLookUpEventHandler icEDocActionHandler icEDocFormEventHandler icEDocRequisiteChangeEventHandler icStructuredConversionRule icStructuredConversionEventBefore icStructuredConversionEventAfter icWizardEventHandler icWizardFinishEventHandler icWizardStepEventHandler icWizardStepFinishEventHandler icWizardActionEnableEventHandler icWizardActionExecuteEventHandler icCreateJobsHandler icCreateNoticesHandler icBeforeLookUpEventHandler icAfterLookUpEventHandler icTaskAbortEventHandler icWorkflowBlockActionHandler icDialogDataSetEventHandler icDialogActionHandler icDialogLookUpEventHandler icDialogRequisiteChangeEventHandler icDialogFormEventHandler icDialogValidCloseEventHandler icBlockFormEventHandler icTaskFormEventHandler icReferenceMethod icEDocMethod icDialogMethod icProcessMessageHandler " + "isShow isHide isByUserSettings " + "jkJob jkNotice jkControlJob " + "jtInner jtLeft jtRight jtFull jtCross " + "lbpAbove lbpBelow lbpLeft lbpRight " + "eltPerConnection eltPerUser " + "sfcUndefined sfcBlack sfcGreen sfcRed sfcBlue sfcOrange sfcLilac " + "sfsItalic sfsStrikeout sfsNormal " + "ldctStandardRoute ldctWizard ldctScript ldctFunction ldctRouteBlock ldctIntegratedReport ldctAnalyticReport ldctReferenceType ldctEDocumentType ldctDialog ldctServerEvents " + "mrcrtNone mrcrtUser mrcrtMaximal mrcrtCustom " + "vtEqual vtGreaterOrEqual vtLessOrEqual vtRange " + "rdYesterday rdToday rdTomorrow rdThisWeek rdThisMonth rdThisYear rdNextMonth rdNextWeek rdLastWeek rdLastMonth " + "rdWindow rdFile rdPrinter " + "rdtString rdtNumeric rdtInteger rdtDate rdtReference rdtAccount rdtText rdtPick rdtUnknown rdtLargeInteger rdtDocument " + "reOnChange reOnChangeValues " + "ttGlobal ttLocal ttUser ttSystem " + "ssmBrowse ssmSelect ssmMultiSelect ssmBrowseModal " + "smSelect smLike smCard " + "stNone stAuthenticating stApproving " + "sctString sctStream " + "sstAnsiSort sstNaturalSort " + "svtEqual svtContain " + "soatString soatNumeric soatInteger soatDatetime soatReferenceRecord soatText soatPick soatBoolean soatEDocument soatAccount soatIntegerCollection soatNumericCollection soatStringCollection soatPickCollection soatDatetimeCollection soatBooleanCollection soatReferenceRecordCollection soatEDocumentCollection soatAccountCollection soatContents soatUnknown " + "tarAbortByUser tarAbortByWorkflowException " + "tvtAllWords tvtExactPhrase tvtAnyWord " + "usNone usCompleted usRedSquare usBlueSquare usYellowSquare usGreenSquare usOrangeSquare usPurpleSquare usFollowUp " + "utUnknown utUser utDeveloper utAdministrator utSystemDeveloper utDisconnected " + "btAnd btDetailAnd btOr btNotOr btOnly " + "vmView vmSelect vmNavigation " + "vsmSingle vsmMultiple vsmMultipleCheck vsmNoSelection " + "wfatPrevious wfatNext wfatCancel wfatFinish " + "wfepUndefined wfepText3 wfepText6 wfepText9 wfepSpinEdit wfepDropDown wfepRadioGroup wfepFlag wfepText12 wfepText15 wfepText18 wfepText21 wfepText24 wfepText27 wfepText30 wfepRadioGroupColumn1 wfepRadioGroupColumn2 wfepRadioGroupColumn3 " + "wfetQueryParameter wfetText wfetDelimiter wfetLabel " + "wptString wptInteger wptNumeric wptBoolean wptDateTime wptPick wptText wptUser wptUserList wptEDocumentInfo wptEDocumentInfoList wptReferenceRecordInfo wptReferenceRecordInfoList wptFolderInfo wptTaskInfo wptContents wptFileName wptDate " + "wsrComplete wsrGoNext wsrGoPrevious wsrCustom wsrCancel wsrGoFinal " + "wstForm wstEDocument wstTaskCard wstReferenceRecordCard wstFinal " + "waAll waPerformers waManual " + "wsbStart wsbFinish wsbNotice wsbStep wsbDecision wsbWait wsbMonitor wsbScript wsbConnector wsbSubTask wsbLifeCycleStage wsbPause " + "wdtInteger wdtFloat wdtString wdtPick wdtDateTime wdtBoolean wdtTask wdtJob wdtFolder wdtEDocument wdtReferenceRecord wdtUser wdtGroup wdtRole wdtIntegerCollection wdtFloatCollection wdtStringCollection wdtPickCollection wdtDateTimeCollection wdtBooleanCollection wdtTaskCollection wdtJobCollection wdtFolderCollection wdtEDocumentCollection wdtReferenceRecordCollection wdtUserCollection wdtGroupCollection wdtRoleCollection wdtContents wdtUserList wdtSearchDescription wdtDeadLine wdtPickSet wdtAccountCollection " + "wiLow wiNormal wiHigh " + "wrtSoft wrtHard " + "wsInit wsRunning wsDone wsControlled wsAborted wsContinued " + "wtmFull wtmFromCurrent wtmOnlyCurrent ", ds = "AddSubString AdjustLineBreaks AmountInWords Analysis ArrayDimCount ArrayHighBound ArrayLowBound ArrayOf ArrayReDim Assert Assigned BeginOfMonth BeginOfPeriod BuildProfilingOperationAnalysis CallProcedure CanReadFile CArrayElement CDataSetRequisite ChangeDate ChangeReferenceDataset Char CharPos CheckParam CheckParamValue CompareStrings ConstantExists ControlState ConvertDateStr Copy CopyFile CreateArray CreateCachedReference CreateConnection CreateDialog CreateDualListDialog CreateEditor CreateException CreateFile CreateFolderDialog CreateInputDialog CreateLinkFile CreateList CreateLock CreateMemoryDataSet CreateObject CreateOpenDialog CreateProgress CreateQuery CreateReference CreateReport CreateSaveDialog CreateScript CreateSQLPivotFunction CreateStringList CreateTreeListSelectDialog CSelectSQL CSQL CSubString CurrentUserID CurrentUserName CurrentVersion DataSetLocateEx DateDiff DateTimeDiff DateToStr DayOfWeek DeleteFile DirectoryExists DisableCheckAccessRights DisableCheckFullShowingRestriction DisableMassTaskSendingRestrictions DropTable DupeString EditText EnableCheckAccessRights EnableCheckFullShowingRestriction EnableMassTaskSendingRestrictions EndOfMonth EndOfPeriod ExceptionExists ExceptionsOff ExceptionsOn Execute ExecuteProcess Exit ExpandEnvironmentVariables ExtractFileDrive ExtractFileExt ExtractFileName ExtractFilePath ExtractParams FileExists FileSize FindFile FindSubString FirmContext ForceDirectories Format FormatDate FormatNumeric FormatSQLDate FormatString FreeException GetComponent GetComponentLaunchParam GetConstant GetLastException GetReferenceRecord GetRefTypeByRefID GetTableID GetTempFolder IfThen In IndexOf InputDialog InputDialogEx InteractiveMode IsFileLocked IsGraphicFile IsNumeric Length LoadString LoadStringFmt LocalTimeToUTC LowerCase Max MessageBox MessageBoxEx MimeDecodeBinary MimeDecodeString MimeEncodeBinary MimeEncodeString Min MoneyInWords MoveFile NewID Now OpenFile Ord Precision Raise ReadCertificateFromFile ReadFile ReferenceCodeByID ReferenceNumber ReferenceRequisiteMode ReferenceRequisiteValue RegionDateSettings RegionNumberSettings RegionTimeSettings RegRead RegWrite RenameFile Replace Round SelectServerCode SelectSQL ServerDateTime SetConstant SetManagedFolderFieldsState ShowConstantsInputDialog ShowMessage Sleep Split SQL SQL2XLSTAB SQLProfilingSendReport StrToDate SubString SubStringCount SystemSetting Time TimeDiff Today Transliterate Trim UpperCase UserStatus UTCToLocalTime ValidateXML VarIsClear VarIsEmpty VarIsNull WorkTimeDiff WriteFile WriteFileEx WriteObjectHistory Анализ БазаДанных БлокЕсть БлокЕстьРасш БлокИнфо БлокСнять БлокСнятьРасш БлокУстановить Ввод ВводМеню ВедС ВедСпр ВерхняяГраницаМассива ВнешПрогр Восст ВременнаяПапка Время ВыборSQL ВыбратьЗапись ВыделитьСтр Вызвать Выполнить ВыпПрогр ГрафическийФайл ГруппаДополнительно ДатаВремяСерв ДеньНедели ДиалогДаНет ДлинаСтр ДобПодстр ЕПусто ЕслиТо ЕЧисло ЗамПодстр ЗаписьСправочника ЗначПоляСпр ИДТипСпр ИзвлечьДиск ИзвлечьИмяФайла ИзвлечьПуть ИзвлечьРасширение ИзмДат ИзменитьРазмерМассива ИзмеренийМассива ИмяОрг ИмяПоляСпр Индекс ИндикаторЗакрыть ИндикаторОткрыть ИндикаторШаг ИнтерактивныйРежим ИтогТблСпр КодВидВедСпр КодВидСпрПоИД КодПоAnalit КодСимвола КодСпр КолПодстр КолПроп КонМес Конст КонстЕсть КонстЗнач КонТран КопироватьФайл КопияСтр КПериод КСтрТблСпр Макс МаксСтрТблСпр Массив Меню МенюРасш Мин НаборДанныхНайтиРасш НаимВидСпр НаимПоAnalit НаимСпр НастроитьПереводыСтрок НачМес НачТран НижняяГраницаМассива НомерСпр НПериод Окно Окр Окружение ОтлИнфДобавить ОтлИнфУдалить Отчет ОтчетАнал ОтчетИнт ПапкаСуществует Пауза ПВыборSQL ПереименоватьФайл Переменные ПереместитьФайл Подстр ПоискПодстр ПоискСтр ПолучитьИДТаблицы ПользовательДополнительно ПользовательИД ПользовательИмя ПользовательСтатус Прервать ПроверитьПараметр ПроверитьПараметрЗнач ПроверитьУсловие РазбСтр РазнВремя РазнДат РазнДатаВремя РазнРабВремя РегУстВрем РегУстДат РегУстЧсл РедТекст РеестрЗапись РеестрСписокИменПарам РеестрЧтение РеквСпр РеквСпрПр Сегодня Сейчас Сервер СерверПроцессИД СертификатФайлСчитать СжПроб Символ СистемаДиректумКод СистемаИнформация СистемаКод Содержит СоединениеЗакрыть СоединениеОткрыть СоздатьДиалог СоздатьДиалогВыбораИзДвухСписков СоздатьДиалогВыбораПапки СоздатьДиалогОткрытияФайла СоздатьДиалогСохраненияФайла СоздатьЗапрос СоздатьИндикатор СоздатьИсключение СоздатьКэшированныйСправочник СоздатьМассив СоздатьНаборДанных СоздатьОбъект СоздатьОтчет СоздатьПапку СоздатьРедактор СоздатьСоединение СоздатьСписок СоздатьСписокСтрок СоздатьСправочник СоздатьСценарий СоздСпр СостСпр Сохр СохрСпр СписокСистем Спр Справочник СпрБлокЕсть СпрБлокСнять СпрБлокСнятьРасш СпрБлокУстановить СпрИзмНабДан СпрКод СпрНомер СпрОбновить СпрОткрыть СпрОтменить СпрПарам СпрПолеЗнач СпрПолеИмя СпрРекв СпрРеквВведЗн СпрРеквНовые СпрРеквПр СпрРеквПредЗн СпрРеквРежим СпрРеквТипТекст СпрСоздать СпрСост СпрСохранить СпрТблИтог СпрТблСтр СпрТблСтрКол СпрТблСтрМакс СпрТблСтрМин СпрТблСтрПред СпрТблСтрСлед СпрТблСтрСозд СпрТблСтрУд СпрТекПредст СпрУдалить СравнитьСтр СтрВерхРегистр СтрНижнРегистр СтрТблСпр СумПроп Сценарий СценарийПарам ТекВерсия ТекОрг Точн Тран Транслитерация УдалитьТаблицу УдалитьФайл УдСпр УдСтрТблСпр Уст УстановкиКонстант ФайлАтрибутСчитать ФайлАтрибутУстановить ФайлВремя ФайлВремяУстановить ФайлВыбрать ФайлЗанят ФайлЗаписать ФайлИскать ФайлКопировать ФайлМожноЧитать ФайлОткрыть ФайлПереименовать ФайлПерекодировать ФайлПереместить ФайлПросмотреть ФайлРазмер ФайлСоздать ФайлСсылкаСоздать ФайлСуществует ФайлСчитать ФайлУдалить ФмтSQLДат ФмтДат ФмтСтр ФмтЧсл Формат ЦМассивЭлемент ЦНаборДанныхРеквизит ЦПодстр ", us = "AltState Application CallType ComponentTokens CreatedJobs CreatedNotices ControlState DialogResult Dialogs EDocuments EDocumentVersionSource Folders GlobalIDs Job Jobs InputValue LookUpReference LookUpRequisiteNames LookUpSearch Object ParentComponent Processes References Requisite ReportName Reports Result Scripts Searches SelectedAttachments SelectedItems SelectMode Sender ServerEvents ServiceFactory ShiftState SubTask SystemDialogs Tasks Wizard Wizards Work ВызовСпособ ИмяОтчета РеквЗнач ", uo = "IApplication IAccessRights IAccountRepository IAccountSelectionRestrictions IAction IActionList IAdministrationHistoryDescription IAnchors IApplication IArchiveInfo IAttachment IAttachmentList ICheckListBox ICheckPointedList IColumn IComponent IComponentDescription IComponentToken IComponentTokenFactory IComponentTokenInfo ICompRecordInfo IConnection IContents IControl IControlJob IControlJobInfo IControlList ICrypto ICrypto2 ICustomJob ICustomJobInfo ICustomListBox ICustomObjectWizardStep ICustomWork ICustomWorkInfo IDataSet IDataSetAccessInfo IDataSigner IDateCriterion IDateRequisite IDateRequisiteDescription IDateValue IDeaAccessRights IDeaObjectInfo IDevelopmentComponentLock IDialog IDialogFactory IDialogPickRequisiteItems IDialogsFactory IDICSFactory IDocRequisite IDocumentInfo IDualListDialog IECertificate IECertificateInfo IECertificates IEditControl IEditorForm IEdmsExplorer IEdmsObject IEdmsObjectDescription IEdmsObjectFactory IEdmsObjectInfo IEDocument IEDocumentAccessRights IEDocumentDescription IEDocumentEditor IEDocumentFactory IEDocumentInfo IEDocumentStorage IEDocumentVersion IEDocumentVersionListDialog IEDocumentVersionSource IEDocumentWizardStep IEDocVerSignature IEDocVersionState IEnabledMode IEncodeProvider IEncrypter IEvent IEventList IException IExternalEvents IExternalHandler IFactory IField IFileDialog IFolder IFolderDescription IFolderDialog IFolderFactory IFolderInfo IForEach IForm IFormTitle IFormWizardStep IGlobalIDFactory IGlobalIDInfo IGrid IHasher IHistoryDescription IHyperLinkControl IImageButton IImageControl IInnerPanel IInplaceHint IIntegerCriterion IIntegerList IIntegerRequisite IIntegerValue IISBLEditorForm IJob IJobDescription IJobFactory IJobForm IJobInfo ILabelControl ILargeIntegerCriterion ILargeIntegerRequisite ILargeIntegerValue ILicenseInfo ILifeCycleStage IList IListBox ILocalIDInfo ILocalization ILock IMemoryDataSet IMessagingFactory IMetadataRepository INotice INoticeInfo INumericCriterion INumericRequisite INumericValue IObject IObjectDescription IObjectImporter IObjectInfo IObserver IPanelGroup IPickCriterion IPickProperty IPickRequisite IPickRequisiteDescription IPickRequisiteItem IPickRequisiteItems IPickValue IPrivilege IPrivilegeList IProcess IProcessFactory IProcessMessage IProgress IProperty IPropertyChangeEvent IQuery IReference IReferenceCriterion IReferenceEnabledMode IReferenceFactory IReferenceHistoryDescription IReferenceInfo IReferenceRecordCardWizardStep IReferenceRequisiteDescription IReferencesFactory IReferenceValue IRefRequisite IReport IReportFactory IRequisite IRequisiteDescription IRequisiteDescriptionList IRequisiteFactory IRichEdit IRouteStep IRule IRuleList ISchemeBlock IScript IScriptFactory ISearchCriteria ISearchCriterion ISearchDescription ISearchFactory ISearchFolderInfo ISearchForObjectDescription ISearchResultRestrictions ISecuredContext ISelectDialog IServerEvent IServerEventFactory IServiceDialog IServiceFactory ISignature ISignProvider ISignProvider2 ISignProvider3 ISimpleCriterion IStringCriterion IStringList IStringRequisite IStringRequisiteDescription IStringValue ISystemDialogsFactory ISystemInfo ITabSheet ITask ITaskAbortReasonInfo ITaskCardWizardStep ITaskDescription ITaskFactory ITaskInfo ITaskRoute ITextCriterion ITextRequisite ITextValue ITreeListSelectDialog IUser IUserList IValue IView IWebBrowserControl IWizard IWizardAction IWizardFactory IWizardFormElement IWizardParam IWizardPickParam IWizardReferenceParam IWizardStep IWorkAccessRights IWorkDescription IWorkflowAskableParam IWorkflowAskableParams IWorkflowBlock IWorkflowBlockResult IWorkflowEnabledMode IWorkflowParam IWorkflowPickParam IWorkflowReferenceParam IWorkState IWorkTreeCustomNode IWorkTreeJobNode IWorkTreeTaskNode IXMLEditorForm SBCrypto ", _s = ae + Ar, ps = us, Fl = "null true false nil ", Lr = {
      className: "number",
      begin: i.NUMBER_RE,
      relevance: 0
    }, xi = {
      className: "string",
      variants: [
        {
          begin: '"',
          end: '"'
        },
        {
          begin: "'",
          end: "'"
        }
      ]
    }, _o = {
      className: "doctag",
      begin: "\\b(?:TODO|DONE|BEGIN|END|STUB|CHG|FIXME|NOTE|BUG|XXX)\\b",
      relevance: 0
    }, ms = {
      className: "comment",
      begin: "//",
      end: "$",
      relevance: 0,
      contains: [
        i.PHRASAL_WORDS_MODE,
        _o
      ]
    }, po = {
      className: "comment",
      begin: "/\\*",
      end: "\\*/",
      relevance: 0,
      contains: [
        i.PHRASAL_WORDS_MODE,
        _o
      ]
    }, ni = { variants: [
      ms,
      po
    ] }, Da = {
      $pattern: o,
      keyword: r,
      built_in: _s,
      class: ps,
      literal: Fl
    }, Cr = {
      begin: "\\.\\s*" + i.UNDERSCORE_IDENT_RE,
      keywords: Da,
      relevance: 0
    }, Zn = {
      className: "type",
      begin: ":[ \\t]*(" + uo.trim().replace(/\s/g, "|") + ")",
      end: "[ \\t]*=",
      excludeEnd: !0
    }, Ya = {
      className: "variable",
      keywords: Da,
      begin: o,
      relevance: 0,
      contains: [
        Zn,
        Cr
      ]
    }, mo = c + "\\(";
    return {
      name: "ISBL",
      case_insensitive: !0,
      keywords: Da,
      illegal: "\\$|\\?|%|,|;$|~|#|@|</",
      contains: [
        {
          className: "function",
          begin: mo,
          end: "\\)$",
          returnBegin: !0,
          keywords: Da,
          illegal: "[\\[\\]\\|\\$\\?%,~#@]",
          contains: [
            {
              className: "title",
              keywords: {
                $pattern: o,
                built_in: ds
              },
              begin: mo,
              end: "\\(",
              returnBegin: !0,
              excludeEnd: !0
            },
            Cr,
            Ya,
            xi,
            Lr,
            ni
          ]
        },
        Zn,
        Cr,
        Ya,
        xi,
        Lr,
        ni
      ]
    };
  }
  return Hu = s, Hu;
}
var qu, Eb;
function AP() {
  if (Eb)
    return qu;
  Eb = 1;
  var s = "[0-9](_*[0-9])*", i = `\\.(${s})`, o = "[0-9a-fA-F](_*[0-9a-fA-F])*", c = {
    className: "number",
    variants: [
      // DecimalFloatingPointLiteral
      // including ExponentPart
      { begin: `(\\b(${s})((${i})|\\.)?|(${i}))[eE][+-]?(${s})[fFdD]?\\b` },
      // excluding ExponentPart
      { begin: `\\b(${s})((${i})[fFdD]?\\b|\\.([fFdD]\\b)?)` },
      { begin: `(${i})[fFdD]?\\b` },
      { begin: `\\b(${s})[fFdD]\\b` },
      // HexadecimalFloatingPointLiteral
      { begin: `\\b0[xX]((${o})\\.?|(${o})?\\.(${o}))[pP][+-]?(${s})[fFdD]?\\b` },
      // DecimalIntegerLiteral
      { begin: "\\b(0|[1-9](_*[0-9])*)[lL]?\\b" },
      // HexIntegerLiteral
      { begin: `\\b0[xX](${o})[lL]?\\b` },
      // OctalIntegerLiteral
      { begin: "\\b0(_*[0-7])*[lL]?\\b" },
      // BinaryIntegerLiteral
      { begin: "\\b0[bB][01](_*[01])*[lL]?\\b" }
    ],
    relevance: 0
  };
  function r(g, h, S) {
    return S === -1 ? "" : g.replace(h, (C) => r(g, h, S - 1));
  }
  function e(g) {
    const h = g.regex, S = "[À-ʸa-zA-Z_$][À-ʸa-zA-Z_$0-9]*", C = S + r("(?:<" + S + "~~~(?:\\s*,\\s*" + S + "~~~)*>)?", /~~~/g, 2), L = {
      keyword: [
        "synchronized",
        "abstract",
        "private",
        "var",
        "static",
        "if",
        "const ",
        "for",
        "while",
        "strictfp",
        "finally",
        "protected",
        "import",
        "native",
        "final",
        "void",
        "enum",
        "else",
        "break",
        "transient",
        "catch",
        "instanceof",
        "volatile",
        "case",
        "assert",
        "package",
        "default",
        "public",
        "try",
        "switch",
        "continue",
        "throws",
        "protected",
        "public",
        "private",
        "module",
        "requires",
        "exports",
        "do",
        "sealed",
        "yield",
        "permits"
      ],
      literal: [
        "false",
        "true",
        "null"
      ],
      type: [
        "char",
        "boolean",
        "long",
        "float",
        "int",
        "byte",
        "short",
        "double"
      ],
      built_in: [
        "super",
        "this"
      ]
    }, G = {
      className: "meta",
      begin: "@" + S,
      contains: [
        {
          begin: /\(/,
          end: /\)/,
          contains: ["self"]
          // allow nested () inside our annotation
        }
      ]
    }, Y = {
      className: "params",
      begin: /\(/,
      end: /\)/,
      keywords: L,
      relevance: 0,
      contains: [g.C_BLOCK_COMMENT_MODE],
      endsParent: !0
    };
    return {
      name: "Java",
      aliases: ["jsp"],
      keywords: L,
      illegal: /<\/|#/,
      contains: [
        g.COMMENT(
          "/\\*\\*",
          "\\*/",
          {
            relevance: 0,
            contains: [
              {
                // eat up @'s in emails to prevent them to be recognized as doctags
                begin: /\w+@/,
                relevance: 0
              },
              {
                className: "doctag",
                begin: "@[A-Za-z]+"
              }
            ]
          }
        ),
        // relevance boost
        {
          begin: /import java\.[a-z]+\./,
          keywords: "import",
          relevance: 2
        },
        g.C_LINE_COMMENT_MODE,
        g.C_BLOCK_COMMENT_MODE,
        {
          begin: /"""/,
          end: /"""/,
          className: "string",
          contains: [g.BACKSLASH_ESCAPE]
        },
        g.APOS_STRING_MODE,
        g.QUOTE_STRING_MODE,
        {
          match: [
            /\b(?:class|interface|enum|extends|implements|new)/,
            /\s+/,
            S
          ],
          className: {
            1: "keyword",
            3: "title.class"
          }
        },
        {
          // Exceptions for hyphenated keywords
          match: /non-sealed/,
          scope: "keyword"
        },
        {
          begin: [
            h.concat(/(?!else)/, S),
            /\s+/,
            S,
            /\s+/,
            /=(?!=)/
          ],
          className: {
            1: "type",
            3: "variable",
            5: "operator"
          }
        },
        {
          begin: [
            /record/,
            /\s+/,
            S
          ],
          className: {
            1: "keyword",
            3: "title.class"
          },
          contains: [
            Y,
            g.C_LINE_COMMENT_MODE,
            g.C_BLOCK_COMMENT_MODE
          ]
        },
        {
          // Expression keywords prevent 'keyword Name(...)' from being
          // recognized as a function definition
          beginKeywords: "new throw return else",
          relevance: 0
        },
        {
          begin: [
            "(?:" + C + "\\s+)",
            g.UNDERSCORE_IDENT_RE,
            /\s*(?=\()/
          ],
          className: { 2: "title.function" },
          keywords: L,
          contains: [
            {
              className: "params",
              begin: /\(/,
              end: /\)/,
              keywords: L,
              relevance: 0,
              contains: [
                G,
                g.APOS_STRING_MODE,
                g.QUOTE_STRING_MODE,
                c,
                g.C_BLOCK_COMMENT_MODE
              ]
            },
            g.C_LINE_COMMENT_MODE,
            g.C_BLOCK_COMMENT_MODE
          ]
        },
        c,
        G
      ]
    };
  }
  return qu = e, qu;
}
var $u, hb;
function OP() {
  if (hb)
    return $u;
  hb = 1;
  const s = "[A-Za-z$_][0-9A-Za-z$_]*", i = [
    "as",
    // for exports
    "in",
    "of",
    "if",
    "for",
    "while",
    "finally",
    "var",
    "new",
    "function",
    "do",
    "return",
    "void",
    "else",
    "break",
    "catch",
    "instanceof",
    "with",
    "throw",
    "case",
    "default",
    "try",
    "switch",
    "continue",
    "typeof",
    "delete",
    "let",
    "yield",
    "const",
    "class",
    // JS handles these with a special rule
    // "get",
    // "set",
    "debugger",
    "async",
    "await",
    "static",
    "import",
    "from",
    "export",
    "extends"
  ], o = [
    "true",
    "false",
    "null",
    "undefined",
    "NaN",
    "Infinity"
  ], c = [
    // Fundamental objects
    "Object",
    "Function",
    "Boolean",
    "Symbol",
    // numbers and dates
    "Math",
    "Date",
    "Number",
    "BigInt",
    // text
    "String",
    "RegExp",
    // Indexed collections
    "Array",
    "Float32Array",
    "Float64Array",
    "Int8Array",
    "Uint8Array",
    "Uint8ClampedArray",
    "Int16Array",
    "Int32Array",
    "Uint16Array",
    "Uint32Array",
    "BigInt64Array",
    "BigUint64Array",
    // Keyed collections
    "Set",
    "Map",
    "WeakSet",
    "WeakMap",
    // Structured data
    "ArrayBuffer",
    "SharedArrayBuffer",
    "Atomics",
    "DataView",
    "JSON",
    // Control abstraction objects
    "Promise",
    "Generator",
    "GeneratorFunction",
    "AsyncFunction",
    // Reflection
    "Reflect",
    "Proxy",
    // Internationalization
    "Intl",
    // WebAssembly
    "WebAssembly"
  ], r = [
    "Error",
    "EvalError",
    "InternalError",
    "RangeError",
    "ReferenceError",
    "SyntaxError",
    "TypeError",
    "URIError"
  ], e = [
    "setInterval",
    "setTimeout",
    "clearInterval",
    "clearTimeout",
    "require",
    "exports",
    "eval",
    "isFinite",
    "isNaN",
    "parseFloat",
    "parseInt",
    "decodeURI",
    "decodeURIComponent",
    "encodeURI",
    "encodeURIComponent",
    "escape",
    "unescape"
  ], g = [
    "arguments",
    "this",
    "super",
    "console",
    "window",
    "document",
    "localStorage",
    "sessionStorage",
    "module",
    "global"
    // Node.js
  ], h = [].concat(
    e,
    c,
    r
  );
  function S(C) {
    const O = C.regex, N = (ne, { after: Ge }) => {
      const we = "</" + ne[0].slice(1);
      return ne.input.indexOf(we, Ge) !== -1;
    }, D = s, x = {
      begin: "<>",
      end: "</>"
    }, L = /<[A-Za-z0-9\\._:-]+\s*\/>/, G = {
      begin: /<[A-Za-z0-9\\._:-]+/,
      end: /\/[A-Za-z0-9\\._:-]+>|\/>/,
      /**
       * @param {RegExpMatchArray} match
       * @param {CallbackResponse} response
       */
      isTrulyOpeningTag: (ne, Ge) => {
        const we = ne[0].length + ne.index, st = ne.input[we];
        if (
          // HTML should not include another raw `<` inside a tag
          // nested type?
          // `<Array<Array<number>>`, etc.
          st === "<" || // the , gives away that this is not HTML
          // `<T, A extends keyof T, V>`
          st === ","
        ) {
          Ge.ignoreMatch();
          return;
        }
        st === ">" && (N(ne, { after: we }) || Ge.ignoreMatch());
        let Rt;
        const rt = ne.input.substring(we);
        if (Rt = rt.match(/^\s*=/)) {
          Ge.ignoreMatch();
          return;
        }
        if ((Rt = rt.match(/^\s+extends\s+/)) && Rt.index === 0) {
          Ge.ignoreMatch();
          return;
        }
      }
    }, Y = {
      $pattern: s,
      keyword: i,
      literal: o,
      built_in: h,
      "variable.language": g
    }, k = "[0-9](_?[0-9])*", W = `\\.(${k})`, Z = "0|[1-9](_?[0-9])*|0[0-7]*[89][0-9]*", H = {
      className: "number",
      variants: [
        // DecimalLiteral
        { begin: `(\\b(${Z})((${W})|\\.)?|(${W}))[eE][+-]?(${k})\\b` },
        { begin: `\\b(${Z})\\b((${W})\\b|\\.)?|(${W})\\b` },
        // DecimalBigIntegerLiteral
        { begin: "\\b(0|[1-9](_?[0-9])*)n\\b" },
        // NonDecimalIntegerLiteral
        { begin: "\\b0[xX][0-9a-fA-F](_?[0-9a-fA-F])*n?\\b" },
        { begin: "\\b0[bB][0-1](_?[0-1])*n?\\b" },
        { begin: "\\b0[oO][0-7](_?[0-7])*n?\\b" },
        // LegacyOctalIntegerLiteral (does not include underscore separators)
        // https://tc39.es/ecma262/#sec-additional-syntax-numeric-literals
        { begin: "\\b0[0-7]+n?\\b" }
      ],
      relevance: 0
    }, K = {
      className: "subst",
      begin: "\\$\\{",
      end: "\\}",
      keywords: Y,
      contains: []
      // defined later
    }, Q = {
      begin: "html`",
      end: "",
      starts: {
        end: "`",
        returnEnd: !1,
        contains: [
          C.BACKSLASH_ESCAPE,
          K
        ],
        subLanguage: "xml"
      }
    }, _e = {
      begin: "css`",
      end: "",
      starts: {
        end: "`",
        returnEnd: !1,
        contains: [
          C.BACKSLASH_ESCAPE,
          K
        ],
        subLanguage: "css"
      }
    }, se = {
      begin: "gql`",
      end: "",
      starts: {
        end: "`",
        returnEnd: !1,
        contains: [
          C.BACKSLASH_ESCAPE,
          K
        ],
        subLanguage: "graphql"
      }
    }, Pe = {
      className: "string",
      begin: "`",
      end: "`",
      contains: [
        C.BACKSLASH_ESCAPE,
        K
      ]
    }, ye = {
      className: "comment",
      variants: [
        C.COMMENT(
          /\/\*\*(?!\/)/,
          "\\*/",
          {
            relevance: 0,
            contains: [
              {
                begin: "(?=@[A-Za-z]+)",
                relevance: 0,
                contains: [
                  {
                    className: "doctag",
                    begin: "@[A-Za-z]+"
                  },
                  {
                    className: "type",
                    begin: "\\{",
                    end: "\\}",
                    excludeEnd: !0,
                    excludeBegin: !0,
                    relevance: 0
                  },
                  {
                    className: "variable",
                    begin: D + "(?=\\s*(-)|$)",
                    endsParent: !0,
                    relevance: 0
                  },
                  // eat spaces (not newlines) so we can find
                  // types or variables
                  {
                    begin: /(?=[^\n])\s/,
                    relevance: 0
                  }
                ]
              }
            ]
          }
        ),
        C.C_BLOCK_COMMENT_MODE,
        C.C_LINE_COMMENT_MODE
      ]
    }, Je = [
      C.APOS_STRING_MODE,
      C.QUOTE_STRING_MODE,
      Q,
      _e,
      se,
      Pe,
      // Skip numbers when they are part of a variable name
      { match: /\$\d+/ },
      H
      // This is intentional:
      // See https://github.com/highlightjs/highlight.js/issues/3288
      // hljs.REGEXP_MODE
    ];
    K.contains = Je.concat({
      // we need to pair up {} inside our subst to prevent
      // it from ending too early by matching another }
      begin: /\{/,
      end: /\}/,
      keywords: Y,
      contains: [
        "self"
      ].concat(Je)
    });
    const mt = [].concat(ye, K.contains), ge = mt.concat([
      // eat recursive parens in sub expressions
      {
        begin: /\(/,
        end: /\)/,
        keywords: Y,
        contains: ["self"].concat(mt)
      }
    ]), w = {
      className: "params",
      begin: /\(/,
      end: /\)/,
      excludeBegin: !0,
      excludeEnd: !0,
      keywords: Y,
      contains: ge
    }, fe = {
      variants: [
        // class Car extends vehicle
        {
          match: [
            /class/,
            /\s+/,
            D,
            /\s+/,
            /extends/,
            /\s+/,
            O.concat(D, "(", O.concat(/\./, D), ")*")
          ],
          scope: {
            1: "keyword",
            3: "title.class",
            5: "keyword",
            7: "title.class.inherited"
          }
        },
        // class Car
        {
          match: [
            /class/,
            /\s+/,
            D
          ],
          scope: {
            1: "keyword",
            3: "title.class"
          }
        }
      ]
    }, j = {
      relevance: 0,
      match: O.either(
        // Hard coded exceptions
        /\bJSON/,
        // Float32Array, OutT
        /\b[A-Z][a-z]+([A-Z][a-z]*|\d)*/,
        // CSSFactory, CSSFactoryT
        /\b[A-Z]{2,}([A-Z][a-z]+|\d)+([A-Z][a-z]*)*/,
        // FPs, FPsT
        /\b[A-Z]{2,}[a-z]+([A-Z][a-z]+|\d)*([A-Z][a-z]*)*/
        // P
        // single letters are not highlighted
        // BLAH
        // this will be flagged as a UPPER_CASE_CONSTANT instead
      ),
      className: "title.class",
      keywords: {
        _: [
          // se we still get relevance credit for JS library classes
          ...c,
          ...r
        ]
      }
    }, J = {
      label: "use_strict",
      className: "meta",
      relevance: 10,
      begin: /^\s*['"]use (strict|asm)['"]/
    }, de = {
      variants: [
        {
          match: [
            /function/,
            /\s+/,
            D,
            /(?=\s*\()/
          ]
        },
        // anonymous function
        {
          match: [
            /function/,
            /\s*(?=\()/
          ]
        }
      ],
      className: {
        1: "keyword",
        3: "title.function"
      },
      label: "func.def",
      contains: [w],
      illegal: /%/
    }, ie = {
      relevance: 0,
      match: /\b[A-Z][A-Z_0-9]+\b/,
      className: "variable.constant"
    };
    function X(ne) {
      return O.concat("(?!", ne.join("|"), ")");
    }
    const ue = {
      match: O.concat(
        /\b/,
        X([
          ...e,
          "super",
          "import"
        ]),
        D,
        O.lookahead(/\(/)
      ),
      className: "title.function",
      relevance: 0
    }, Oe = {
      begin: O.concat(/\./, O.lookahead(
        O.concat(D, /(?![0-9A-Za-z$_(])/)
      )),
      end: D,
      excludeBegin: !0,
      keywords: "prototype",
      className: "property",
      relevance: 0
    }, Re = {
      match: [
        /get|set/,
        /\s+/,
        D,
        /(?=\()/
      ],
      className: {
        1: "keyword",
        3: "title.function"
      },
      contains: [
        {
          // eat to avoid empty params
          begin: /\(\)/
        },
        w
      ]
    }, ae = "(\\([^()]*(\\([^()]*(\\([^()]*\\)[^()]*)*\\)[^()]*)*\\)|" + C.UNDERSCORE_IDENT_RE + ")\\s*=>", Ee = {
      match: [
        /const|var|let/,
        /\s+/,
        D,
        /\s*/,
        /=\s*/,
        /(async\s*)?/,
        // async is optional
        O.lookahead(ae)
      ],
      keywords: "async",
      className: {
        1: "keyword",
        3: "title.function"
      },
      contains: [
        w
      ]
    };
    return {
      name: "JavaScript",
      aliases: ["js", "jsx", "mjs", "cjs"],
      keywords: Y,
      // this will be extended by TypeScript
      exports: { PARAMS_CONTAINS: ge, CLASS_REFERENCE: j },
      illegal: /#(?![$_A-z])/,
      contains: [
        C.SHEBANG({
          label: "shebang",
          binary: "node",
          relevance: 5
        }),
        J,
        C.APOS_STRING_MODE,
        C.QUOTE_STRING_MODE,
        Q,
        _e,
        se,
        Pe,
        ye,
        // Skip numbers when they are part of a variable name
        { match: /\$\d+/ },
        H,
        j,
        {
          className: "attr",
          begin: D + O.lookahead(":"),
          relevance: 0
        },
        Ee,
        {
          // "value" container
          begin: "(" + C.RE_STARTERS_RE + "|\\b(case|return|throw)\\b)\\s*",
          keywords: "return throw case",
          relevance: 0,
          contains: [
            ye,
            C.REGEXP_MODE,
            {
              className: "function",
              // we have to count the parens to make sure we actually have the
              // correct bounding ( ) before the =>.  There could be any number of
              // sub-expressions inside also surrounded by parens.
              begin: ae,
              returnBegin: !0,
              end: "\\s*=>",
              contains: [
                {
                  className: "params",
                  variants: [
                    {
                      begin: C.UNDERSCORE_IDENT_RE,
                      relevance: 0
                    },
                    {
                      className: null,
                      begin: /\(\s*\)/,
                      skip: !0
                    },
                    {
                      begin: /\(/,
                      end: /\)/,
                      excludeBegin: !0,
                      excludeEnd: !0,
                      keywords: Y,
                      contains: ge
                    }
                  ]
                }
              ]
            },
            {
              // could be a comma delimited list of params to a function call
              begin: /,/,
              relevance: 0
            },
            {
              match: /\s+/,
              relevance: 0
            },
            {
              // JSX
              variants: [
                { begin: x.begin, end: x.end },
                { match: L },
                {
                  begin: G.begin,
                  // we carefully check the opening tag to see if it truly
                  // is a tag and not a false positive
                  "on:begin": G.isTrulyOpeningTag,
                  end: G.end
                }
              ],
              subLanguage: "xml",
              contains: [
                {
                  begin: G.begin,
                  end: G.end,
                  skip: !0,
                  contains: ["self"]
                }
              ]
            }
          ]
        },
        de,
        {
          // prevent this from getting swallowed up by function
          // since they appear "function like"
          beginKeywords: "while if switch catch for"
        },
        {
          // we have to count the parens to make sure we actually have the correct
          // bounding ( ).  There could be any number of sub-expressions inside
          // also surrounded by parens.
          begin: "\\b(?!function)" + C.UNDERSCORE_IDENT_RE + "\\([^()]*(\\([^()]*(\\([^()]*\\)[^()]*)*\\)[^()]*)*\\)\\s*\\{",
          // end parens
          returnBegin: !0,
          label: "func.def",
          contains: [
            w,
            C.inherit(C.TITLE_MODE, { begin: D, className: "title.function" })
          ]
        },
        // catch ... so it won't trigger the property rule below
        {
          match: /\.\.\./,
          relevance: 0
        },
        Oe,
        // hack: prevents detection of keywords in some circumstances
        // .keyword()
        // $keyword = x
        {
          match: "\\$" + D,
          relevance: 0
        },
        {
          match: [/\bconstructor(?=\s*\()/],
          className: { 1: "title.function" },
          contains: [w]
        },
        ue,
        ie,
        fe,
        Re,
        {
          match: /\$[(.]/
          // relevance booster for a pattern common to JS libs: `$(something)` and `$.something`
        }
      ]
    };
  }
  return $u = S, $u;
}
var Wu, Sb;
function yP() {
  if (Sb)
    return Wu;
  Sb = 1;
  function s(i) {
    const c = {
      className: "params",
      begin: /\(/,
      end: /\)/,
      contains: [{
        begin: /[\w-]+ *=/,
        returnBegin: !0,
        relevance: 0,
        contains: [
          {
            className: "attr",
            begin: /[\w-]+/
          }
        ]
      }],
      relevance: 0
    }, r = {
      className: "function",
      begin: /:[\w\-.]+/,
      relevance: 0
    }, e = {
      className: "string",
      begin: /\B([\/.])[\w\-.\/=]+/
    }, g = {
      className: "params",
      begin: /--[\w\-=\/]+/
    };
    return {
      name: "JBoss CLI",
      aliases: ["wildfly-cli"],
      keywords: {
        $pattern: "[a-z-]+",
        keyword: "alias batch cd clear command connect connection-factory connection-info data-source deploy deployment-info deployment-overlay echo echo-dmr help history if jdbc-driver-info jms-queue|20 jms-topic|20 ls patch pwd quit read-attribute read-operation reload rollout-plan run-batch set shutdown try unalias undeploy unset version xa-data-source",
        // module
        literal: "true false"
      },
      contains: [
        i.HASH_COMMENT_MODE,
        i.QUOTE_STRING_MODE,
        g,
        r,
        e,
        c
      ]
    };
  }
  return Wu = s, Wu;
}
var zu, bb;
function IP() {
  if (bb)
    return zu;
  bb = 1;
  function s(i) {
    const o = {
      className: "attr",
      begin: /"(\\.|[^\\"\r\n])*"(?=\s*:)/,
      relevance: 1.01
    }, c = {
      match: /[{}[\],:]/,
      className: "punctuation",
      relevance: 0
    }, r = [
      "true",
      "false",
      "null"
    ], e = {
      scope: "literal",
      beginKeywords: r.join(" ")
    };
    return {
      name: "JSON",
      keywords: {
        literal: r
      },
      contains: [
        o,
        c,
        i.QUOTE_STRING_MODE,
        e,
        i.C_NUMBER_MODE,
        i.C_LINE_COMMENT_MODE,
        i.C_BLOCK_COMMENT_MODE
      ],
      illegal: "\\S"
    };
  }
  return zu = s, zu;
}
var Ku, Tb;
function DP() {
  if (Tb)
    return Ku;
  Tb = 1;
  function s(i) {
    const o = "[A-Za-z_\\u00A1-\\uFFFF][A-Za-z_0-9\\u00A1-\\uFFFF]*", g = {
      $pattern: o,
      keyword: [
        "baremodule",
        "begin",
        "break",
        "catch",
        "ccall",
        "const",
        "continue",
        "do",
        "else",
        "elseif",
        "end",
        "export",
        "false",
        "finally",
        "for",
        "function",
        "global",
        "if",
        "import",
        "in",
        "isa",
        "let",
        "local",
        "macro",
        "module",
        "quote",
        "return",
        "true",
        "try",
        "using",
        "where",
        "while"
      ],
      literal: [
        "ARGS",
        "C_NULL",
        "DEPOT_PATH",
        "ENDIAN_BOM",
        "ENV",
        "Inf",
        "Inf16",
        "Inf32",
        "Inf64",
        "InsertionSort",
        "LOAD_PATH",
        "MergeSort",
        "NaN",
        "NaN16",
        "NaN32",
        "NaN64",
        "PROGRAM_FILE",
        "QuickSort",
        "RoundDown",
        "RoundFromZero",
        "RoundNearest",
        "RoundNearestTiesAway",
        "RoundNearestTiesUp",
        "RoundToZero",
        "RoundUp",
        "VERSION|0",
        "devnull",
        "false",
        "im",
        "missing",
        "nothing",
        "pi",
        "stderr",
        "stdin",
        "stdout",
        "true",
        "undef",
        "π",
        "ℯ"
      ],
      built_in: [
        "AbstractArray",
        "AbstractChannel",
        "AbstractChar",
        "AbstractDict",
        "AbstractDisplay",
        "AbstractFloat",
        "AbstractIrrational",
        "AbstractMatrix",
        "AbstractRange",
        "AbstractSet",
        "AbstractString",
        "AbstractUnitRange",
        "AbstractVecOrMat",
        "AbstractVector",
        "Any",
        "ArgumentError",
        "Array",
        "AssertionError",
        "BigFloat",
        "BigInt",
        "BitArray",
        "BitMatrix",
        "BitSet",
        "BitVector",
        "Bool",
        "BoundsError",
        "CapturedException",
        "CartesianIndex",
        "CartesianIndices",
        "Cchar",
        "Cdouble",
        "Cfloat",
        "Channel",
        "Char",
        "Cint",
        "Cintmax_t",
        "Clong",
        "Clonglong",
        "Cmd",
        "Colon",
        "Complex",
        "ComplexF16",
        "ComplexF32",
        "ComplexF64",
        "CompositeException",
        "Condition",
        "Cptrdiff_t",
        "Cshort",
        "Csize_t",
        "Cssize_t",
        "Cstring",
        "Cuchar",
        "Cuint",
        "Cuintmax_t",
        "Culong",
        "Culonglong",
        "Cushort",
        "Cvoid",
        "Cwchar_t",
        "Cwstring",
        "DataType",
        "DenseArray",
        "DenseMatrix",
        "DenseVecOrMat",
        "DenseVector",
        "Dict",
        "DimensionMismatch",
        "Dims",
        "DivideError",
        "DomainError",
        "EOFError",
        "Enum",
        "ErrorException",
        "Exception",
        "ExponentialBackOff",
        "Expr",
        "Float16",
        "Float32",
        "Float64",
        "Function",
        "GlobalRef",
        "HTML",
        "IO",
        "IOBuffer",
        "IOContext",
        "IOStream",
        "IdDict",
        "IndexCartesian",
        "IndexLinear",
        "IndexStyle",
        "InexactError",
        "InitError",
        "Int",
        "Int128",
        "Int16",
        "Int32",
        "Int64",
        "Int8",
        "Integer",
        "InterruptException",
        "InvalidStateException",
        "Irrational",
        "KeyError",
        "LinRange",
        "LineNumberNode",
        "LinearIndices",
        "LoadError",
        "MIME",
        "Matrix",
        "Method",
        "MethodError",
        "Missing",
        "MissingException",
        "Module",
        "NTuple",
        "NamedTuple",
        "Nothing",
        "Number",
        "OrdinalRange",
        "OutOfMemoryError",
        "OverflowError",
        "Pair",
        "PartialQuickSort",
        "PermutedDimsArray",
        "Pipe",
        "ProcessFailedException",
        "Ptr",
        "QuoteNode",
        "Rational",
        "RawFD",
        "ReadOnlyMemoryError",
        "Real",
        "ReentrantLock",
        "Ref",
        "Regex",
        "RegexMatch",
        "RoundingMode",
        "SegmentationFault",
        "Set",
        "Signed",
        "Some",
        "StackOverflowError",
        "StepRange",
        "StepRangeLen",
        "StridedArray",
        "StridedMatrix",
        "StridedVecOrMat",
        "StridedVector",
        "String",
        "StringIndexError",
        "SubArray",
        "SubString",
        "SubstitutionString",
        "Symbol",
        "SystemError",
        "Task",
        "TaskFailedException",
        "Text",
        "TextDisplay",
        "Timer",
        "Tuple",
        "Type",
        "TypeError",
        "TypeVar",
        "UInt",
        "UInt128",
        "UInt16",
        "UInt32",
        "UInt64",
        "UInt8",
        "UndefInitializer",
        "UndefKeywordError",
        "UndefRefError",
        "UndefVarError",
        "Union",
        "UnionAll",
        "UnitRange",
        "Unsigned",
        "Val",
        "Vararg",
        "VecElement",
        "VecOrMat",
        "Vector",
        "VersionNumber",
        "WeakKeyDict",
        "WeakRef"
      ]
    }, h = {
      keywords: g,
      illegal: /<\//
    }, S = {
      className: "number",
      // supported numeric literals:
      //  * binary literal (e.g. 0x10)
      //  * octal literal (e.g. 0o76543210)
      //  * hexadecimal literal (e.g. 0xfedcba876543210)
      //  * hexadecimal floating point literal (e.g. 0x1p0, 0x1.2p2)
      //  * decimal literal (e.g. 9876543210, 100_000_000)
      //  * floating pointe literal (e.g. 1.2, 1.2f, .2, 1., 1.2e10, 1.2e-10)
      begin: /(\b0x[\d_]*(\.[\d_]*)?|0x\.\d[\d_]*)p[-+]?\d+|\b0[box][a-fA-F0-9][a-fA-F0-9_]*|(\b\d[\d_]*(\.[\d_]*)?|\.\d[\d_]*)([eEfF][-+]?\d+)?/,
      relevance: 0
    }, C = {
      className: "string",
      begin: /'(.|\\[xXuU][a-zA-Z0-9]+)'/
    }, O = {
      className: "subst",
      begin: /\$\(/,
      end: /\)/,
      keywords: g
    }, N = {
      className: "variable",
      begin: "\\$" + o
    }, D = {
      className: "string",
      contains: [
        i.BACKSLASH_ESCAPE,
        O,
        N
      ],
      variants: [
        {
          begin: /\w*"""/,
          end: /"""\w*/,
          relevance: 10
        },
        {
          begin: /\w*"/,
          end: /"\w*/
        }
      ]
    }, x = {
      className: "string",
      contains: [
        i.BACKSLASH_ESCAPE,
        O,
        N
      ],
      begin: "`",
      end: "`"
    }, L = {
      className: "meta",
      begin: "@" + o
    }, G = {
      className: "comment",
      variants: [
        {
          begin: "#=",
          end: "=#",
          relevance: 10
        },
        {
          begin: "#",
          end: "$"
        }
      ]
    };
    return h.name = "Julia", h.contains = [
      S,
      C,
      D,
      x,
      L,
      G,
      i.HASH_COMMENT_MODE,
      {
        className: "keyword",
        begin: "\\b(((abstract|primitive)\\s+)type|(mutable\\s+)?struct)\\b"
      },
      { begin: /<:/ }
      // relevance booster
    ], O.contains = h.contains, h;
  }
  return Ku = s, Ku;
}
var Qu, vb;
function wP() {
  if (vb)
    return Qu;
  vb = 1;
  function s(i) {
    return {
      name: "Julia REPL",
      contains: [
        {
          className: "meta.prompt",
          begin: /^julia>/,
          relevance: 10,
          starts: {
            // end the highlighting if we are on a new line and the line does not have at
            // least six spaces in the beginning
            end: /^(?![ ]{6})/,
            subLanguage: "julia"
          }
        }
      ],
      // jldoctest Markdown blocks are used in the Julia manual and package docs indicate
      // code snippets that should be verified when the documentation is built. They can be
      // either REPL-like or script-like, but are usually REPL-like and therefore we apply
      // julia-repl highlighting to them. More information can be found in Documenter's
      // manual: https://juliadocs.github.io/Documenter.jl/latest/man/doctests.html
      aliases: ["jldoctest"]
    };
  }
  return Qu = s, Qu;
}
var Xu, Cb;
function xP() {
  if (Cb)
    return Xu;
  Cb = 1;
  var s = "[0-9](_*[0-9])*", i = `\\.(${s})`, o = "[0-9a-fA-F](_*[0-9a-fA-F])*", c = {
    className: "number",
    variants: [
      // DecimalFloatingPointLiteral
      // including ExponentPart
      { begin: `(\\b(${s})((${i})|\\.)?|(${i}))[eE][+-]?(${s})[fFdD]?\\b` },
      // excluding ExponentPart
      { begin: `\\b(${s})((${i})[fFdD]?\\b|\\.([fFdD]\\b)?)` },
      { begin: `(${i})[fFdD]?\\b` },
      { begin: `\\b(${s})[fFdD]\\b` },
      // HexadecimalFloatingPointLiteral
      { begin: `\\b0[xX]((${o})\\.?|(${o})?\\.(${o}))[pP][+-]?(${s})[fFdD]?\\b` },
      // DecimalIntegerLiteral
      { begin: "\\b(0|[1-9](_*[0-9])*)[lL]?\\b" },
      // HexIntegerLiteral
      { begin: `\\b0[xX](${o})[lL]?\\b` },
      // OctalIntegerLiteral
      { begin: "\\b0(_*[0-7])*[lL]?\\b" },
      // BinaryIntegerLiteral
      { begin: "\\b0[bB][01](_*[01])*[lL]?\\b" }
    ],
    relevance: 0
  };
  function r(e) {
    const g = {
      keyword: "abstract as val var vararg get set class object open private protected public noinline crossinline dynamic final enum if else do while for when throw try catch finally import package is in fun override companion reified inline lateinit init interface annotation data sealed internal infix operator out by constructor super tailrec where const inner suspend typealias external expect actual",
      built_in: "Byte Short Char Int Long Boolean Float Double Void Unit Nothing",
      literal: "true false null"
    }, h = {
      className: "keyword",
      begin: /\b(break|continue|return|this)\b/,
      starts: { contains: [
        {
          className: "symbol",
          begin: /@\w+/
        }
      ] }
    }, S = {
      className: "symbol",
      begin: e.UNDERSCORE_IDENT_RE + "@"
    }, C = {
      className: "subst",
      begin: /\$\{/,
      end: /\}/,
      contains: [e.C_NUMBER_MODE]
    }, O = {
      className: "variable",
      begin: "\\$" + e.UNDERSCORE_IDENT_RE
    }, N = {
      className: "string",
      variants: [
        {
          begin: '"""',
          end: '"""(?=[^"])',
          contains: [
            O,
            C
          ]
        },
        // Can't use built-in modes easily, as we want to use STRING in the meta
        // context as 'meta-string' and there's no syntax to remove explicitly set
        // classNames in built-in modes.
        {
          begin: "'",
          end: "'",
          illegal: /\n/,
          contains: [e.BACKSLASH_ESCAPE]
        },
        {
          begin: '"',
          end: '"',
          illegal: /\n/,
          contains: [
            e.BACKSLASH_ESCAPE,
            O,
            C
          ]
        }
      ]
    };
    C.contains.push(N);
    const D = {
      className: "meta",
      begin: "@(?:file|property|field|get|set|receiver|param|setparam|delegate)\\s*:(?:\\s*" + e.UNDERSCORE_IDENT_RE + ")?"
    }, x = {
      className: "meta",
      begin: "@" + e.UNDERSCORE_IDENT_RE,
      contains: [
        {
          begin: /\(/,
          end: /\)/,
          contains: [
            e.inherit(N, { className: "string" }),
            "self"
          ]
        }
      ]
    }, L = c, G = e.COMMENT(
      "/\\*",
      "\\*/",
      { contains: [e.C_BLOCK_COMMENT_MODE] }
    ), Y = { variants: [
      {
        className: "type",
        begin: e.UNDERSCORE_IDENT_RE
      },
      {
        begin: /\(/,
        end: /\)/,
        contains: []
        // defined later
      }
    ] }, k = Y;
    return k.variants[1].contains = [Y], Y.variants[1].contains = [k], {
      name: "Kotlin",
      aliases: [
        "kt",
        "kts"
      ],
      keywords: g,
      contains: [
        e.COMMENT(
          "/\\*\\*",
          "\\*/",
          {
            relevance: 0,
            contains: [
              {
                className: "doctag",
                begin: "@[A-Za-z]+"
              }
            ]
          }
        ),
        e.C_LINE_COMMENT_MODE,
        G,
        h,
        S,
        D,
        x,
        {
          className: "function",
          beginKeywords: "fun",
          end: "[(]|$",
          returnBegin: !0,
          excludeEnd: !0,
          keywords: g,
          relevance: 5,
          contains: [
            {
              begin: e.UNDERSCORE_IDENT_RE + "\\s*\\(",
              returnBegin: !0,
              relevance: 0,
              contains: [e.UNDERSCORE_TITLE_MODE]
            },
            {
              className: "type",
              begin: /</,
              end: />/,
              keywords: "reified",
              relevance: 0
            },
            {
              className: "params",
              begin: /\(/,
              end: /\)/,
              endsParent: !0,
              keywords: g,
              relevance: 0,
              contains: [
                {
                  begin: /:/,
                  end: /[=,\/]/,
                  endsWithParent: !0,
                  contains: [
                    Y,
                    e.C_LINE_COMMENT_MODE,
                    G
                  ],
                  relevance: 0
                },
                e.C_LINE_COMMENT_MODE,
                G,
                D,
                x,
                N,
                e.C_NUMBER_MODE
              ]
            },
            G
          ]
        },
        {
          begin: [
            /class|interface|trait/,
            /\s+/,
            e.UNDERSCORE_IDENT_RE
          ],
          beginScope: {
            3: "title.class"
          },
          keywords: "class interface trait",
          end: /[:\{(]|$/,
          excludeEnd: !0,
          illegal: "extends implements",
          contains: [
            { beginKeywords: "public protected internal private constructor" },
            e.UNDERSCORE_TITLE_MODE,
            {
              className: "type",
              begin: /</,
              end: />/,
              excludeBegin: !0,
              excludeEnd: !0,
              relevance: 0
            },
            {
              className: "type",
              begin: /[,:]\s*/,
              end: /[<\(,){\s]|$/,
              excludeBegin: !0,
              returnEnd: !0
            },
            D,
            x
          ]
        },
        N,
        {
          className: "meta",
          begin: "^#!/usr/bin/env",
          end: "$",
          illegal: `
`
        },
        L
      ]
    };
  }
  return Xu = r, Xu;
}
var Zu, Rb;
function LP() {
  if (Rb)
    return Zu;
  Rb = 1;
  function s(i) {
    const o = "[a-zA-Z_][\\w.]*", c = "<\\?(lasso(script)?|=)", r = "\\]|\\?>", e = {
      $pattern: o + "|&[lg]t;",
      literal: "true false none minimal full all void and or not bw nbw ew new cn ncn lt lte gt gte eq neq rx nrx ft",
      built_in: "array date decimal duration integer map pair string tag xml null boolean bytes keyword list locale queue set stack staticarray local var variable global data self inherited currentcapture givenblock",
      keyword: "cache database_names database_schemanames database_tablenames define_tag define_type email_batch encode_set html_comment handle handle_error header if inline iterate ljax_target link link_currentaction link_currentgroup link_currentrecord link_detail link_firstgroup link_firstrecord link_lastgroup link_lastrecord link_nextgroup link_nextrecord link_prevgroup link_prevrecord log loop namespace_using output_none portal private protect records referer referrer repeating resultset rows search_args search_arguments select sort_args sort_arguments thread_atomic value_list while abort case else fail_if fail_ifnot fail if_empty if_false if_null if_true loop_abort loop_continue loop_count params params_up return return_value run_children soap_definetag soap_lastrequest soap_lastresponse tag_name ascending average by define descending do equals frozen group handle_failure import in into join let match max min on order parent protected provide public require returnhome skip split_thread sum take thread to trait type where with yield yieldhome"
    }, g = i.COMMENT(
      "<!--",
      "-->",
      { relevance: 0 }
    ), h = {
      className: "meta",
      begin: "\\[noprocess\\]",
      starts: {
        end: "\\[/noprocess\\]",
        returnEnd: !0,
        contains: [g]
      }
    }, S = {
      className: "meta",
      begin: "\\[/noprocess|" + c
    }, C = {
      className: "symbol",
      begin: "'" + o + "'"
    }, O = [
      i.C_LINE_COMMENT_MODE,
      i.C_BLOCK_COMMENT_MODE,
      i.inherit(i.C_NUMBER_MODE, { begin: i.C_NUMBER_RE + "|(-?infinity|NaN)\\b" }),
      i.inherit(i.APOS_STRING_MODE, { illegal: null }),
      i.inherit(i.QUOTE_STRING_MODE, { illegal: null }),
      {
        className: "string",
        begin: "`",
        end: "`"
      },
      {
        // variables
        variants: [
          { begin: "[#$]" + o },
          {
            begin: "#",
            end: "\\d+",
            illegal: "\\W"
          }
        ]
      },
      {
        className: "type",
        begin: "::\\s*",
        end: o,
        illegal: "\\W"
      },
      {
        className: "params",
        variants: [
          {
            begin: "-(?!infinity)" + o,
            relevance: 0
          },
          { begin: "(\\.\\.\\.)" }
        ]
      },
      {
        begin: /(->|\.)\s*/,
        relevance: 0,
        contains: [C]
      },
      {
        className: "class",
        beginKeywords: "define",
        returnEnd: !0,
        end: "\\(|=>",
        contains: [i.inherit(i.TITLE_MODE, { begin: o + "(=(?!>))?|[-+*/%](?!>)" })]
      }
    ];
    return {
      name: "Lasso",
      aliases: [
        "ls",
        "lassoscript"
      ],
      case_insensitive: !0,
      keywords: e,
      contains: [
        {
          className: "meta",
          begin: r,
          relevance: 0,
          starts: {
            // markup
            end: "\\[|" + c,
            returnEnd: !0,
            relevance: 0,
            contains: [g]
          }
        },
        h,
        S,
        {
          className: "meta",
          begin: "\\[no_square_brackets",
          starts: {
            end: "\\[/no_square_brackets\\]",
            // not implemented in the language
            keywords: e,
            contains: [
              {
                className: "meta",
                begin: r,
                relevance: 0,
                starts: {
                  end: "\\[noprocess\\]|" + c,
                  returnEnd: !0,
                  contains: [g]
                }
              },
              h,
              S
            ].concat(O)
          }
        },
        {
          className: "meta",
          begin: "\\[",
          relevance: 0
        },
        {
          className: "meta",
          begin: "^#!",
          end: "lasso9$",
          relevance: 10
        }
      ].concat(O)
    };
  }
  return Zu = s, Zu;
}
var ju, Nb;
function MP() {
  if (Nb)
    return ju;
  Nb = 1;
  function s(i) {
    const c = i.regex.either(...[
      "(?:NeedsTeXFormat|RequirePackage|GetIdInfo)",
      "Provides(?:Expl)?(?:Package|Class|File)",
      "(?:DeclareOption|ProcessOptions)",
      "(?:documentclass|usepackage|input|include)",
      "makeat(?:letter|other)",
      "ExplSyntax(?:On|Off)",
      "(?:new|renew|provide)?command",
      "(?:re)newenvironment",
      "(?:New|Renew|Provide|Declare)(?:Expandable)?DocumentCommand",
      "(?:New|Renew|Provide|Declare)DocumentEnvironment",
      "(?:(?:e|g|x)?def|let)",
      "(?:begin|end)",
      "(?:part|chapter|(?:sub){0,2}section|(?:sub)?paragraph)",
      "caption",
      "(?:label|(?:eq|page|name)?ref|(?:paren|foot|super)?cite)",
      "(?:alpha|beta|[Gg]amma|[Dd]elta|(?:var)?epsilon|zeta|eta|[Tt]heta|vartheta)",
      "(?:iota|(?:var)?kappa|[Ll]ambda|mu|nu|[Xx]i|[Pp]i|varpi|(?:var)rho)",
      "(?:[Ss]igma|varsigma|tau|[Uu]psilon|[Pp]hi|varphi|chi|[Pp]si|[Oo]mega)",
      "(?:frac|sum|prod|lim|infty|times|sqrt|leq|geq|left|right|middle|[bB]igg?)",
      "(?:[lr]angle|q?quad|[lcvdi]?dots|d?dot|hat|tilde|bar)"
    ].map((ye) => ye + "(?![a-zA-Z@:_])")), r = new RegExp([
      // A function \module_function_name:signature or \__module_function_name:signature,
      // where both module and function_name need at least two characters and
      // function_name may contain single underscores.
      "(?:__)?[a-zA-Z]{2,}_[a-zA-Z](?:_?[a-zA-Z])+:[a-zA-Z]*",
      // A variable \scope_module_and_name_type or \scope__module_ane_name_type,
      // where scope is one of l, g or c, type needs at least two characters
      // and module_and_name may contain single underscores.
      "[lgc]__?[a-zA-Z](?:_?[a-zA-Z])*_[a-zA-Z]{2,}",
      // A quark \q_the_name or \q__the_name or
      // scan mark \s_the_name or \s__vthe_name,
      // where variable_name needs at least two characters and
      // may contain single underscores.
      "[qs]__?[a-zA-Z](?:_?[a-zA-Z])+",
      // Other LaTeX3 macro names that are not covered by the three rules above.
      "use(?:_i)?:[a-zA-Z]*",
      "(?:else|fi|or):",
      "(?:if|cs|exp):w",
      "(?:hbox|vbox):n",
      "::[a-zA-Z]_unbraced",
      "::[a-zA-Z:]"
    ].map((ye) => ye + "(?![a-zA-Z:_])").join("|")), e = [
      { begin: /[a-zA-Z@]+/ },
      // control word
      { begin: /[^a-zA-Z@]?/ }
      // control symbol
    ], g = [
      { begin: /\^{6}[0-9a-f]{6}/ },
      { begin: /\^{5}[0-9a-f]{5}/ },
      { begin: /\^{4}[0-9a-f]{4}/ },
      { begin: /\^{3}[0-9a-f]{3}/ },
      { begin: /\^{2}[0-9a-f]{2}/ },
      { begin: /\^{2}[\u0000-\u007f]/ }
    ], h = {
      className: "keyword",
      begin: /\\/,
      relevance: 0,
      contains: [
        {
          endsParent: !0,
          begin: c
        },
        {
          endsParent: !0,
          begin: r
        },
        {
          endsParent: !0,
          variants: g
        },
        {
          endsParent: !0,
          relevance: 0,
          variants: e
        }
      ]
    }, S = {
      className: "params",
      relevance: 0,
      begin: /#+\d?/
    }, C = {
      // relevance: 1
      variants: g
    }, O = {
      className: "built_in",
      relevance: 0,
      begin: /[$&^_]/
    }, N = {
      className: "meta",
      begin: /% ?!(T[eE]X|tex|BIB|bib)/,
      end: "$",
      relevance: 10
    }, D = i.COMMENT(
      "%",
      "$",
      { relevance: 0 }
    ), x = [
      h,
      S,
      C,
      O,
      N,
      D
    ], L = {
      begin: /\{/,
      end: /\}/,
      relevance: 0,
      contains: [
        "self",
        ...x
      ]
    }, G = i.inherit(
      L,
      {
        relevance: 0,
        endsParent: !0,
        contains: [
          L,
          ...x
        ]
      }
    ), Y = {
      begin: /\[/,
      end: /\]/,
      endsParent: !0,
      relevance: 0,
      contains: [
        L,
        ...x
      ]
    }, k = {
      begin: /\s+/,
      relevance: 0
    }, W = [G], Z = [Y], H = function(ye, Je) {
      return {
        contains: [k],
        starts: {
          relevance: 0,
          contains: ye,
          starts: Je
        }
      };
    }, K = function(ye, Je) {
      return {
        begin: "\\\\" + ye + "(?![a-zA-Z@:_])",
        keywords: {
          $pattern: /\\[a-zA-Z]+/,
          keyword: "\\" + ye
        },
        relevance: 0,
        contains: [k],
        starts: Je
      };
    }, Q = function(ye, Je) {
      return i.inherit(
        {
          begin: "\\\\begin(?=[ 	]*(\\r?\\n[ 	]*)?\\{" + ye + "\\})",
          keywords: {
            $pattern: /\\[a-zA-Z]+/,
            keyword: "\\begin"
          },
          relevance: 0
        },
        H(W, Je)
      );
    }, _e = (ye = "string") => i.END_SAME_AS_BEGIN({
      className: ye,
      begin: /(.|\r?\n)/,
      end: /(.|\r?\n)/,
      excludeBegin: !0,
      excludeEnd: !0,
      endsParent: !0
    }), se = function(ye) {
      return {
        className: "string",
        end: "(?=\\\\end\\{" + ye + "\\})"
      };
    }, Pe = (ye = "string") => ({
      relevance: 0,
      begin: /\{/,
      starts: {
        endsParent: !0,
        contains: [
          {
            className: ye,
            end: /(?=\})/,
            endsParent: !0,
            contains: [
              {
                begin: /\{/,
                end: /\}/,
                relevance: 0,
                contains: ["self"]
              }
            ]
          }
        ]
      }
    }), Ke = [
      ...[
        "verb",
        "lstinline"
      ].map((ye) => K(ye, { contains: [_e()] })),
      K("mint", H(W, { contains: [_e()] })),
      K("mintinline", H(W, { contains: [
        Pe(),
        _e()
      ] })),
      K("url", { contains: [
        Pe("link"),
        Pe("link")
      ] }),
      K("hyperref", { contains: [Pe("link")] }),
      K("href", H(Z, { contains: [Pe("link")] })),
      ...[].concat(...[
        "",
        "\\*"
      ].map((ye) => [
        Q("verbatim" + ye, se("verbatim" + ye)),
        Q("filecontents" + ye, H(W, se("filecontents" + ye))),
        ...[
          "",
          "B",
          "L"
        ].map(
          (Je) => Q(Je + "Verbatim" + ye, H(Z, se(Je + "Verbatim" + ye)))
        )
      ])),
      Q("minted", H(Z, H(W, se("minted"))))
    ];
    return {
      name: "LaTeX",
      aliases: ["tex"],
      contains: [
        ...Ke,
        ...x
      ]
    };
  }
  return ju = s, ju;
}
var Ju, Ab;
function PP() {
  if (Ab)
    return Ju;
  Ab = 1;
  function s(i) {
    return {
      name: "LDIF",
      contains: [
        {
          className: "attribute",
          match: "^dn(?=:)",
          relevance: 10
        },
        {
          className: "attribute",
          match: "^\\w+(?=:)"
        },
        {
          className: "literal",
          match: "^-"
        },
        i.HASH_COMMENT_MODE
      ]
    };
  }
  return Ju = s, Ju;
}
var e_, Ob;
function kP() {
  if (Ob)
    return e_;
  Ob = 1;
  function s(i) {
    const o = /([A-Za-z_][A-Za-z_0-9]*)?/, r = {
      scope: "params",
      begin: /\(/,
      end: /\)(?=\:?)/,
      endsParent: !0,
      relevance: 7,
      contains: [
        {
          scope: "string",
          begin: '"',
          end: '"'
        },
        {
          scope: "keyword",
          match: [
            "true",
            "false",
            "in"
          ].join("|")
        },
        {
          scope: "variable",
          match: /[A-Za-z_][A-Za-z_0-9]*/
        },
        {
          scope: "operator",
          match: /\+|\-|\*|\/|\%|\=\=|\=|\!|\>|\<|\&\&|\|\|/
        }
      ]
    }, e = {
      match: [
        o,
        /(?=\()/
      ],
      scope: {
        1: "keyword"
      },
      contains: [r]
    };
    return r.contains.unshift(e), {
      name: "Leaf",
      contains: [
        // #ident():
        {
          match: [
            /#+/,
            o,
            /(?=\()/
          ],
          scope: {
            1: "punctuation",
            2: "keyword"
          },
          // will start up after the ending `)` match from line ~44
          // just to grab the trailing `:` if we can match it
          starts: {
            contains: [
              {
                match: /\:/,
                scope: "punctuation"
              }
            ]
          },
          contains: [
            r
          ]
        },
        // #ident or #ident:
        {
          match: [
            /#+/,
            o,
            /:?/
          ],
          scope: {
            1: "punctuation",
            2: "keyword",
            3: "punctuation"
          }
        }
      ]
    };
  }
  return e_ = s, e_;
}
var t_, yb;
function FP() {
  if (yb)
    return t_;
  yb = 1;
  const s = (S) => ({
    IMPORTANT: {
      scope: "meta",
      begin: "!important"
    },
    BLOCK_COMMENT: S.C_BLOCK_COMMENT_MODE,
    HEXCOLOR: {
      scope: "number",
      begin: /#(([0-9a-fA-F]{3,4})|(([0-9a-fA-F]{2}){3,4}))\b/
    },
    FUNCTION_DISPATCH: {
      className: "built_in",
      begin: /[\w-]+(?=\()/
    },
    ATTRIBUTE_SELECTOR_MODE: {
      scope: "selector-attr",
      begin: /\[/,
      end: /\]/,
      illegal: "$",
      contains: [
        S.APOS_STRING_MODE,
        S.QUOTE_STRING_MODE
      ]
    },
    CSS_NUMBER_MODE: {
      scope: "number",
      begin: S.NUMBER_RE + "(%|em|ex|ch|rem|vw|vh|vmin|vmax|cm|mm|in|pt|pc|px|deg|grad|rad|turn|s|ms|Hz|kHz|dpi|dpcm|dppx)?",
      relevance: 0
    },
    CSS_VARIABLE: {
      className: "attr",
      begin: /--[A-Za-z_][A-Za-z0-9_-]*/
    }
  }), i = [
    "a",
    "abbr",
    "address",
    "article",
    "aside",
    "audio",
    "b",
    "blockquote",
    "body",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "dd",
    "del",
    "details",
    "dfn",
    "div",
    "dl",
    "dt",
    "em",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "header",
    "hgroup",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "label",
    "legend",
    "li",
    "main",
    "mark",
    "menu",
    "nav",
    "object",
    "ol",
    "p",
    "q",
    "quote",
    "samp",
    "section",
    "span",
    "strong",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "tr",
    "ul",
    "var",
    "video"
  ], o = [
    "any-hover",
    "any-pointer",
    "aspect-ratio",
    "color",
    "color-gamut",
    "color-index",
    "device-aspect-ratio",
    "device-height",
    "device-width",
    "display-mode",
    "forced-colors",
    "grid",
    "height",
    "hover",
    "inverted-colors",
    "monochrome",
    "orientation",
    "overflow-block",
    "overflow-inline",
    "pointer",
    "prefers-color-scheme",
    "prefers-contrast",
    "prefers-reduced-motion",
    "prefers-reduced-transparency",
    "resolution",
    "scan",
    "scripting",
    "update",
    "width",
    // TODO: find a better solution?
    "min-width",
    "max-width",
    "min-height",
    "max-height"
  ], c = [
    "active",
    "any-link",
    "blank",
    "checked",
    "current",
    "default",
    "defined",
    "dir",
    // dir()
    "disabled",
    "drop",
    "empty",
    "enabled",
    "first",
    "first-child",
    "first-of-type",
    "fullscreen",
    "future",
    "focus",
    "focus-visible",
    "focus-within",
    "has",
    // has()
    "host",
    // host or host()
    "host-context",
    // host-context()
    "hover",
    "indeterminate",
    "in-range",
    "invalid",
    "is",
    // is()
    "lang",
    // lang()
    "last-child",
    "last-of-type",
    "left",
    "link",
    "local-link",
    "not",
    // not()
    "nth-child",
    // nth-child()
    "nth-col",
    // nth-col()
    "nth-last-child",
    // nth-last-child()
    "nth-last-col",
    // nth-last-col()
    "nth-last-of-type",
    //nth-last-of-type()
    "nth-of-type",
    //nth-of-type()
    "only-child",
    "only-of-type",
    "optional",
    "out-of-range",
    "past",
    "placeholder-shown",
    "read-only",
    "read-write",
    "required",
    "right",
    "root",
    "scope",
    "target",
    "target-within",
    "user-invalid",
    "valid",
    "visited",
    "where"
    // where()
  ], r = [
    "after",
    "backdrop",
    "before",
    "cue",
    "cue-region",
    "first-letter",
    "first-line",
    "grammar-error",
    "marker",
    "part",
    "placeholder",
    "selection",
    "slotted",
    "spelling-error"
  ], e = [
    "align-content",
    "align-items",
    "align-self",
    "all",
    "animation",
    "animation-delay",
    "animation-direction",
    "animation-duration",
    "animation-fill-mode",
    "animation-iteration-count",
    "animation-name",
    "animation-play-state",
    "animation-timing-function",
    "backface-visibility",
    "background",
    "background-attachment",
    "background-blend-mode",
    "background-clip",
    "background-color",
    "background-image",
    "background-origin",
    "background-position",
    "background-repeat",
    "background-size",
    "block-size",
    "border",
    "border-block",
    "border-block-color",
    "border-block-end",
    "border-block-end-color",
    "border-block-end-style",
    "border-block-end-width",
    "border-block-start",
    "border-block-start-color",
    "border-block-start-style",
    "border-block-start-width",
    "border-block-style",
    "border-block-width",
    "border-bottom",
    "border-bottom-color",
    "border-bottom-left-radius",
    "border-bottom-right-radius",
    "border-bottom-style",
    "border-bottom-width",
    "border-collapse",
    "border-color",
    "border-image",
    "border-image-outset",
    "border-image-repeat",
    "border-image-slice",
    "border-image-source",
    "border-image-width",
    "border-inline",
    "border-inline-color",
    "border-inline-end",
    "border-inline-end-color",
    "border-inline-end-style",
    "border-inline-end-width",
    "border-inline-start",
    "border-inline-start-color",
    "border-inline-start-style",
    "border-inline-start-width",
    "border-inline-style",
    "border-inline-width",
    "border-left",
    "border-left-color",
    "border-left-style",
    "border-left-width",
    "border-radius",
    "border-right",
    "border-right-color",
    "border-right-style",
    "border-right-width",
    "border-spacing",
    "border-style",
    "border-top",
    "border-top-color",
    "border-top-left-radius",
    "border-top-right-radius",
    "border-top-style",
    "border-top-width",
    "border-width",
    "bottom",
    "box-decoration-break",
    "box-shadow",
    "box-sizing",
    "break-after",
    "break-before",
    "break-inside",
    "caption-side",
    "caret-color",
    "clear",
    "clip",
    "clip-path",
    "clip-rule",
    "color",
    "column-count",
    "column-fill",
    "column-gap",
    "column-rule",
    "column-rule-color",
    "column-rule-style",
    "column-rule-width",
    "column-span",
    "column-width",
    "columns",
    "contain",
    "content",
    "content-visibility",
    "counter-increment",
    "counter-reset",
    "cue",
    "cue-after",
    "cue-before",
    "cursor",
    "direction",
    "display",
    "empty-cells",
    "filter",
    "flex",
    "flex-basis",
    "flex-direction",
    "flex-flow",
    "flex-grow",
    "flex-shrink",
    "flex-wrap",
    "float",
    "flow",
    "font",
    "font-display",
    "font-family",
    "font-feature-settings",
    "font-kerning",
    "font-language-override",
    "font-size",
    "font-size-adjust",
    "font-smoothing",
    "font-stretch",
    "font-style",
    "font-synthesis",
    "font-variant",
    "font-variant-caps",
    "font-variant-east-asian",
    "font-variant-ligatures",
    "font-variant-numeric",
    "font-variant-position",
    "font-variation-settings",
    "font-weight",
    "gap",
    "glyph-orientation-vertical",
    "grid",
    "grid-area",
    "grid-auto-columns",
    "grid-auto-flow",
    "grid-auto-rows",
    "grid-column",
    "grid-column-end",
    "grid-column-start",
    "grid-gap",
    "grid-row",
    "grid-row-end",
    "grid-row-start",
    "grid-template",
    "grid-template-areas",
    "grid-template-columns",
    "grid-template-rows",
    "hanging-punctuation",
    "height",
    "hyphens",
    "icon",
    "image-orientation",
    "image-rendering",
    "image-resolution",
    "ime-mode",
    "inline-size",
    "isolation",
    "justify-content",
    "left",
    "letter-spacing",
    "line-break",
    "line-height",
    "list-style",
    "list-style-image",
    "list-style-position",
    "list-style-type",
    "margin",
    "margin-block",
    "margin-block-end",
    "margin-block-start",
    "margin-bottom",
    "margin-inline",
    "margin-inline-end",
    "margin-inline-start",
    "margin-left",
    "margin-right",
    "margin-top",
    "marks",
    "mask",
    "mask-border",
    "mask-border-mode",
    "mask-border-outset",
    "mask-border-repeat",
    "mask-border-slice",
    "mask-border-source",
    "mask-border-width",
    "mask-clip",
    "mask-composite",
    "mask-image",
    "mask-mode",
    "mask-origin",
    "mask-position",
    "mask-repeat",
    "mask-size",
    "mask-type",
    "max-block-size",
    "max-height",
    "max-inline-size",
    "max-width",
    "min-block-size",
    "min-height",
    "min-inline-size",
    "min-width",
    "mix-blend-mode",
    "nav-down",
    "nav-index",
    "nav-left",
    "nav-right",
    "nav-up",
    "none",
    "normal",
    "object-fit",
    "object-position",
    "opacity",
    "order",
    "orphans",
    "outline",
    "outline-color",
    "outline-offset",
    "outline-style",
    "outline-width",
    "overflow",
    "overflow-wrap",
    "overflow-x",
    "overflow-y",
    "padding",
    "padding-block",
    "padding-block-end",
    "padding-block-start",
    "padding-bottom",
    "padding-inline",
    "padding-inline-end",
    "padding-inline-start",
    "padding-left",
    "padding-right",
    "padding-top",
    "page-break-after",
    "page-break-before",
    "page-break-inside",
    "pause",
    "pause-after",
    "pause-before",
    "perspective",
    "perspective-origin",
    "pointer-events",
    "position",
    "quotes",
    "resize",
    "rest",
    "rest-after",
    "rest-before",
    "right",
    "row-gap",
    "scroll-margin",
    "scroll-margin-block",
    "scroll-margin-block-end",
    "scroll-margin-block-start",
    "scroll-margin-bottom",
    "scroll-margin-inline",
    "scroll-margin-inline-end",
    "scroll-margin-inline-start",
    "scroll-margin-left",
    "scroll-margin-right",
    "scroll-margin-top",
    "scroll-padding",
    "scroll-padding-block",
    "scroll-padding-block-end",
    "scroll-padding-block-start",
    "scroll-padding-bottom",
    "scroll-padding-inline",
    "scroll-padding-inline-end",
    "scroll-padding-inline-start",
    "scroll-padding-left",
    "scroll-padding-right",
    "scroll-padding-top",
    "scroll-snap-align",
    "scroll-snap-stop",
    "scroll-snap-type",
    "scrollbar-color",
    "scrollbar-gutter",
    "scrollbar-width",
    "shape-image-threshold",
    "shape-margin",
    "shape-outside",
    "speak",
    "speak-as",
    "src",
    // @font-face
    "tab-size",
    "table-layout",
    "text-align",
    "text-align-all",
    "text-align-last",
    "text-combine-upright",
    "text-decoration",
    "text-decoration-color",
    "text-decoration-line",
    "text-decoration-style",
    "text-emphasis",
    "text-emphasis-color",
    "text-emphasis-position",
    "text-emphasis-style",
    "text-indent",
    "text-justify",
    "text-orientation",
    "text-overflow",
    "text-rendering",
    "text-shadow",
    "text-transform",
    "text-underline-position",
    "top",
    "transform",
    "transform-box",
    "transform-origin",
    "transform-style",
    "transition",
    "transition-delay",
    "transition-duration",
    "transition-property",
    "transition-timing-function",
    "unicode-bidi",
    "vertical-align",
    "visibility",
    "voice-balance",
    "voice-duration",
    "voice-family",
    "voice-pitch",
    "voice-range",
    "voice-rate",
    "voice-stress",
    "voice-volume",
    "white-space",
    "widows",
    "width",
    "will-change",
    "word-break",
    "word-spacing",
    "word-wrap",
    "writing-mode",
    "z-index"
    // reverse makes sure longer attributes `font-weight` are matched fully
    // instead of getting false positives on say `font`
  ].reverse(), g = c.concat(r);
  function h(S) {
    const C = s(S), O = g, N = "and or not only", D = "[\\w-]+", x = "(" + D + "|@\\{" + D + "\\})", L = [], G = [], Y = function(ye) {
      return {
        // Less strings are not multiline (also include '~' for more consistent coloring of "escaped" strings)
        className: "string",
        begin: "~?" + ye + ".*?" + ye
      };
    }, k = function(ye, Je, mt) {
      return {
        className: ye,
        begin: Je,
        relevance: mt
      };
    }, W = {
      $pattern: /[a-z-]+/,
      keyword: N,
      attribute: o.join(" ")
    }, Z = {
      // used only to properly balance nested parens inside mixin call, def. arg list
      begin: "\\(",
      end: "\\)",
      contains: G,
      keywords: W,
      relevance: 0
    };
    G.push(
      S.C_LINE_COMMENT_MODE,
      S.C_BLOCK_COMMENT_MODE,
      Y("'"),
      Y('"'),
      C.CSS_NUMBER_MODE,
      // fixme: it does not include dot for numbers like .5em :(
      {
        begin: "(url|data-uri)\\(",
        starts: {
          className: "string",
          end: "[\\)\\n]",
          excludeEnd: !0
        }
      },
      C.HEXCOLOR,
      Z,
      k("variable", "@@?" + D, 10),
      k("variable", "@\\{" + D + "\\}"),
      k("built_in", "~?`[^`]*?`"),
      // inline javascript (or whatever host language) *multiline* string
      {
        // @media features (it’s here to not duplicate things in AT_RULE_MODE with extra PARENS_MODE overriding):
        className: "attribute",
        begin: D + "\\s*:",
        end: ":",
        returnBegin: !0,
        excludeEnd: !0
      },
      C.IMPORTANT,
      { beginKeywords: "and not" },
      C.FUNCTION_DISPATCH
    );
    const H = G.concat({
      begin: /\{/,
      end: /\}/,
      contains: L
    }), K = {
      beginKeywords: "when",
      endsWithParent: !0,
      contains: [{ beginKeywords: "and not" }].concat(G)
      // using this form to override VALUE’s 'function' match
    }, Q = {
      begin: x + "\\s*:",
      returnBegin: !0,
      end: /[;}]/,
      relevance: 0,
      contains: [
        { begin: /-(webkit|moz|ms|o)-/ },
        C.CSS_VARIABLE,
        {
          className: "attribute",
          begin: "\\b(" + e.join("|") + ")\\b",
          end: /(?=:)/,
          starts: {
            endsWithParent: !0,
            illegal: "[<=$]",
            relevance: 0,
            contains: G
          }
        }
      ]
    }, _e = {
      className: "keyword",
      begin: "@(import|media|charset|font-face|(-[a-z]+-)?keyframes|supports|document|namespace|page|viewport|host)\\b",
      starts: {
        end: "[;{}]",
        keywords: W,
        returnEnd: !0,
        contains: G,
        relevance: 0
      }
    }, se = {
      className: "variable",
      variants: [
        // using more strict pattern for higher relevance to increase chances of Less detection.
        // this is *the only* Less specific statement used in most of the sources, so...
        // (we’ll still often loose to the css-parser unless there's '//' comment,
        // simply because 1 variable just can't beat 99 properties :)
        {
          begin: "@" + D + "\\s*:",
          relevance: 15
        },
        { begin: "@" + D }
      ],
      starts: {
        end: "[;}]",
        returnEnd: !0,
        contains: H
      }
    }, Pe = {
      // first parse unambiguous selectors (i.e. those not starting with tag)
      // then fall into the scary lookahead-discriminator variant.
      // this mode also handles mixin definitions and calls
      variants: [
        {
          begin: "[\\.#:&\\[>]",
          end: "[;{}]"
          // mixin calls end with ';'
        },
        {
          begin: x,
          end: /\{/
        }
      ],
      returnBegin: !0,
      returnEnd: !0,
      illegal: `[<='$"]`,
      relevance: 0,
      contains: [
        S.C_LINE_COMMENT_MODE,
        S.C_BLOCK_COMMENT_MODE,
        K,
        k("keyword", "all\\b"),
        k("variable", "@\\{" + D + "\\}"),
        // otherwise it’s identified as tag
        {
          begin: "\\b(" + i.join("|") + ")\\b",
          className: "selector-tag"
        },
        C.CSS_NUMBER_MODE,
        k("selector-tag", x, 0),
        k("selector-id", "#" + x),
        k("selector-class", "\\." + x, 0),
        k("selector-tag", "&", 0),
        C.ATTRIBUTE_SELECTOR_MODE,
        {
          className: "selector-pseudo",
          begin: ":(" + c.join("|") + ")"
        },
        {
          className: "selector-pseudo",
          begin: ":(:)?(" + r.join("|") + ")"
        },
        {
          begin: /\(/,
          end: /\)/,
          relevance: 0,
          contains: H
        },
        // argument list of parametric mixins
        { begin: "!important" },
        // eat !important after mixin call or it will be colored as tag
        C.FUNCTION_DISPATCH
      ]
    }, Ke = {
      begin: D + `:(:)?(${O.join("|")})`,
      returnBegin: !0,
      contains: [Pe]
    };
    return L.push(
      S.C_LINE_COMMENT_MODE,
      S.C_BLOCK_COMMENT_MODE,
      _e,
      se,
      Ke,
      Q,
      Pe,
      K,
      C.FUNCTION_DISPATCH
    ), {
      name: "Less",
      case_insensitive: !0,
      illegal: `[=>'/<($"]`,
      contains: L
    };
  }
  return t_ = h, t_;
}
var r_, Ib;
function UP() {
  if (Ib)
    return r_;
  Ib = 1;
  function s(i) {
    const o = "[a-zA-Z_\\-+\\*\\/<=>&#][a-zA-Z0-9_\\-+*\\/<=>&#!]*", c = "\\|[^]*?\\|", r = "(-|\\+)?\\d+(\\.\\d+|\\/\\d+)?((d|e|f|l|s|D|E|F|L|S)(\\+|-)?\\d+)?", e = {
      className: "literal",
      begin: "\\b(t{1}|nil)\\b"
    }, g = {
      className: "number",
      variants: [
        {
          begin: r,
          relevance: 0
        },
        { begin: "#(b|B)[0-1]+(/[0-1]+)?" },
        { begin: "#(o|O)[0-7]+(/[0-7]+)?" },
        { begin: "#(x|X)[0-9a-fA-F]+(/[0-9a-fA-F]+)?" },
        {
          begin: "#(c|C)\\(" + r + " +" + r,
          end: "\\)"
        }
      ]
    }, h = i.inherit(i.QUOTE_STRING_MODE, { illegal: null }), S = i.COMMENT(
      ";",
      "$",
      { relevance: 0 }
    ), C = {
      begin: "\\*",
      end: "\\*"
    }, O = {
      className: "symbol",
      begin: "[:&]" + o
    }, N = {
      begin: o,
      relevance: 0
    }, D = { begin: c }, L = {
      contains: [
        g,
        h,
        C,
        O,
        {
          begin: "\\(",
          end: "\\)",
          contains: [
            "self",
            e,
            h,
            g,
            N
          ]
        },
        N
      ],
      variants: [
        {
          begin: "['`]\\(",
          end: "\\)"
        },
        {
          begin: "\\(quote ",
          end: "\\)",
          keywords: { name: "quote" }
        },
        { begin: "'" + c }
      ]
    }, G = { variants: [
      { begin: "'" + o },
      { begin: "#'" + o + "(::" + o + ")*" }
    ] }, Y = {
      begin: "\\(\\s*",
      end: "\\)"
    }, k = {
      endsWithParent: !0,
      relevance: 0
    };
    return Y.contains = [
      {
        className: "name",
        variants: [
          {
            begin: o,
            relevance: 0
          },
          { begin: c }
        ]
      },
      k
    ], k.contains = [
      L,
      G,
      Y,
      e,
      g,
      h,
      S,
      C,
      O,
      D,
      N
    ], {
      name: "Lisp",
      illegal: /\S/,
      contains: [
        g,
        i.SHEBANG(),
        e,
        h,
        S,
        L,
        G,
        Y,
        N
      ]
    };
  }
  return r_ = s, r_;
}
var n_, Db;
function BP() {
  if (Db)
    return n_;
  Db = 1;
  function s(i) {
    const o = {
      className: "variable",
      variants: [
        { begin: "\\b([gtps][A-Z]{1}[a-zA-Z0-9]*)(\\[.+\\])?(?:\\s*?)" },
        { begin: "\\$_[A-Z]+" }
      ],
      relevance: 0
    }, c = [
      i.C_BLOCK_COMMENT_MODE,
      i.HASH_COMMENT_MODE,
      i.COMMENT("--", "$"),
      i.COMMENT("[^:]//", "$")
    ], r = i.inherit(i.TITLE_MODE, { variants: [
      { begin: "\\b_*rig[A-Z][A-Za-z0-9_\\-]*" },
      { begin: "\\b_[a-z0-9\\-]+" }
    ] }), e = i.inherit(i.TITLE_MODE, { begin: "\\b([A-Za-z0-9_\\-]+)\\b" });
    return {
      name: "LiveCode",
      case_insensitive: !1,
      keywords: {
        keyword: "$_COOKIE $_FILES $_GET $_GET_BINARY $_GET_RAW $_POST $_POST_BINARY $_POST_RAW $_SESSION $_SERVER codepoint codepoints segment segments codeunit codeunits sentence sentences trueWord trueWords paragraph after byte bytes english the until http forever descending using line real8 with seventh for stdout finally element word words fourth before black ninth sixth characters chars stderr uInt1 uInt1s uInt2 uInt2s stdin string lines relative rel any fifth items from middle mid at else of catch then third it file milliseconds seconds second secs sec int1 int1s int4 int4s internet int2 int2s normal text item last long detailed effective uInt4 uInt4s repeat end repeat URL in try into switch to words https token binfile each tenth as ticks tick system real4 by dateItems without char character ascending eighth whole dateTime numeric short first ftp integer abbreviated abbr abbrev private case while if div mod wrap and or bitAnd bitNot bitOr bitXor among not in a an within contains ends with begins the keys of keys",
        literal: "SIX TEN FORMFEED NINE ZERO NONE SPACE FOUR FALSE COLON CRLF PI COMMA ENDOFFILE EOF EIGHT FIVE QUOTE EMPTY ONE TRUE RETURN CR LINEFEED RIGHT BACKSLASH NULL SEVEN TAB THREE TWO six ten formfeed nine zero none space four false colon crlf pi comma endoffile eof eight five quote empty one true return cr linefeed right backslash null seven tab three two RIVERSION RISTATE FILE_READ_MODE FILE_WRITE_MODE FILE_WRITE_MODE DIR_WRITE_MODE FILE_READ_UMASK FILE_WRITE_UMASK DIR_READ_UMASK DIR_WRITE_UMASK",
        built_in: "put abs acos aliasReference annuity arrayDecode arrayEncode asin atan atan2 average avg avgDev base64Decode base64Encode baseConvert binaryDecode binaryEncode byteOffset byteToNum cachedURL cachedURLs charToNum cipherNames codepointOffset codepointProperty codepointToNum codeunitOffset commandNames compound compress constantNames cos date dateFormat decompress difference directories diskSpace DNSServers exp exp1 exp2 exp10 extents files flushEvents folders format functionNames geometricMean global globals hasMemory harmonicMean hostAddress hostAddressToName hostName hostNameToAddress isNumber ISOToMac itemOffset keys len length libURLErrorData libUrlFormData libURLftpCommand libURLLastHTTPHeaders libURLLastRHHeaders libUrlMultipartFormAddPart libUrlMultipartFormData libURLVersion lineOffset ln ln1 localNames log log2 log10 longFilePath lower macToISO matchChunk matchText matrixMultiply max md5Digest median merge messageAuthenticationCode messageDigest millisec millisecs millisecond milliseconds min monthNames nativeCharToNum normalizeText num number numToByte numToChar numToCodepoint numToNativeChar offset open openfiles openProcesses openProcessIDs openSockets paragraphOffset paramCount param params peerAddress pendingMessages platform popStdDev populationStandardDeviation populationVariance popVariance processID random randomBytes replaceText result revCreateXMLTree revCreateXMLTreeFromFile revCurrentRecord revCurrentRecordIsFirst revCurrentRecordIsLast revDatabaseColumnCount revDatabaseColumnIsNull revDatabaseColumnLengths revDatabaseColumnNames revDatabaseColumnNamed revDatabaseColumnNumbered revDatabaseColumnTypes revDatabaseConnectResult revDatabaseCursors revDatabaseID revDatabaseTableNames revDatabaseType revDataFromQuery revdb_closeCursor revdb_columnbynumber revdb_columncount revdb_columnisnull revdb_columnlengths revdb_columnnames revdb_columntypes revdb_commit revdb_connect revdb_connections revdb_connectionerr revdb_currentrecord revdb_cursorconnection revdb_cursorerr revdb_cursors revdb_dbtype revdb_disconnect revdb_execute revdb_iseof revdb_isbof revdb_movefirst revdb_movelast revdb_movenext revdb_moveprev revdb_query revdb_querylist revdb_recordcount revdb_rollback revdb_tablenames revGetDatabaseDriverPath revNumberOfRecords revOpenDatabase revOpenDatabases revQueryDatabase revQueryDatabaseBlob revQueryResult revQueryIsAtStart revQueryIsAtEnd revUnixFromMacPath revXMLAttribute revXMLAttributes revXMLAttributeValues revXMLChildContents revXMLChildNames revXMLCreateTreeFromFileWithNamespaces revXMLCreateTreeWithNamespaces revXMLDataFromXPathQuery revXMLEvaluateXPath revXMLFirstChild revXMLMatchingNode revXMLNextSibling revXMLNodeContents revXMLNumberOfChildren revXMLParent revXMLPreviousSibling revXMLRootNode revXMLRPC_CreateRequest revXMLRPC_Documents revXMLRPC_Error revXMLRPC_GetHost revXMLRPC_GetMethod revXMLRPC_GetParam revXMLText revXMLRPC_Execute revXMLRPC_GetParamCount revXMLRPC_GetParamNode revXMLRPC_GetParamType revXMLRPC_GetPath revXMLRPC_GetPort revXMLRPC_GetProtocol revXMLRPC_GetRequest revXMLRPC_GetResponse revXMLRPC_GetSocket revXMLTree revXMLTrees revXMLValidateDTD revZipDescribeItem revZipEnumerateItems revZipOpenArchives round sampVariance sec secs seconds sentenceOffset sha1Digest shell shortFilePath sin specialFolderPath sqrt standardDeviation statRound stdDev sum sysError systemVersion tan tempName textDecode textEncode tick ticks time to tokenOffset toLower toUpper transpose truewordOffset trunc uniDecode uniEncode upper URLDecode URLEncode URLStatus uuid value variableNames variance version waitDepth weekdayNames wordOffset xsltApplyStylesheet xsltApplyStylesheetFromFile xsltLoadStylesheet xsltLoadStylesheetFromFile add breakpoint cancel clear local variable file word line folder directory URL close socket process combine constant convert create new alias folder directory decrypt delete variable word line folder directory URL dispatch divide do encrypt filter get include intersect kill libURLDownloadToFile libURLFollowHttpRedirects libURLftpUpload libURLftpUploadFile libURLresetAll libUrlSetAuthCallback libURLSetDriver libURLSetCustomHTTPHeaders libUrlSetExpect100 libURLSetFTPListCommand libURLSetFTPMode libURLSetFTPStopTime libURLSetStatusCallback load extension loadedExtensions multiply socket prepare process post seek rel relative read from process rename replace require resetAll resolve revAddXMLNode revAppendXML revCloseCursor revCloseDatabase revCommitDatabase revCopyFile revCopyFolder revCopyXMLNode revDeleteFolder revDeleteXMLNode revDeleteAllXMLTrees revDeleteXMLTree revExecuteSQL revGoURL revInsertXMLNode revMoveFolder revMoveToFirstRecord revMoveToLastRecord revMoveToNextRecord revMoveToPreviousRecord revMoveToRecord revMoveXMLNode revPutIntoXMLNode revRollBackDatabase revSetDatabaseDriverPath revSetXMLAttribute revXMLRPC_AddParam revXMLRPC_DeleteAllDocuments revXMLAddDTD revXMLRPC_Free revXMLRPC_FreeAll revXMLRPC_DeleteDocument revXMLRPC_DeleteParam revXMLRPC_SetHost revXMLRPC_SetMethod revXMLRPC_SetPort revXMLRPC_SetProtocol revXMLRPC_SetSocket revZipAddItemWithData revZipAddItemWithFile revZipAddUncompressedItemWithData revZipAddUncompressedItemWithFile revZipCancel revZipCloseArchive revZipDeleteItem revZipExtractItemToFile revZipExtractItemToVariable revZipSetProgressCallback revZipRenameItem revZipReplaceItemWithData revZipReplaceItemWithFile revZipOpenArchive send set sort split start stop subtract symmetric union unload vectorDotProduct wait write"
      },
      contains: [
        o,
        {
          className: "keyword",
          begin: "\\bend\\sif\\b"
        },
        {
          className: "function",
          beginKeywords: "function",
          end: "$",
          contains: [
            o,
            e,
            i.APOS_STRING_MODE,
            i.QUOTE_STRING_MODE,
            i.BINARY_NUMBER_MODE,
            i.C_NUMBER_MODE,
            r
          ]
        },
        {
          className: "function",
          begin: "\\bend\\s+",
          end: "$",
          keywords: "end",
          contains: [
            e,
            r
          ],
          relevance: 0
        },
        {
          beginKeywords: "command on",
          end: "$",
          contains: [
            o,
            e,
            i.APOS_STRING_MODE,
            i.QUOTE_STRING_MODE,
            i.BINARY_NUMBER_MODE,
            i.C_NUMBER_MODE,
            r
          ]
        },
        {
          className: "meta",
          variants: [
            {
              begin: "<\\?(rev|lc|livecode)",
              relevance: 10
            },
            { begin: "<\\?" },
            { begin: "\\?>" }
          ]
        },
        i.APOS_STRING_MODE,
        i.QUOTE_STRING_MODE,
        i.BINARY_NUMBER_MODE,
        i.C_NUMBER_MODE,
        r
      ].concat(c),
      illegal: ";$|^\\[|^=|&|\\{"
    };
  }
  return n_ = s, n_;
}
var a_, wb;
function GP() {
  if (wb)
    return a_;
  wb = 1;
  const s = [
    "as",
    // for exports
    "in",
    "of",
    "if",
    "for",
    "while",
    "finally",
    "var",
    "new",
    "function",
    "do",
    "return",
    "void",
    "else",
    "break",
    "catch",
    "instanceof",
    "with",
    "throw",
    "case",
    "default",
    "try",
    "switch",
    "continue",
    "typeof",
    "delete",
    "let",
    "yield",
    "const",
    "class",
    // JS handles these with a special rule
    // "get",
    // "set",
    "debugger",
    "async",
    "await",
    "static",
    "import",
    "from",
    "export",
    "extends"
  ], i = [
    "true",
    "false",
    "null",
    "undefined",
    "NaN",
    "Infinity"
  ], o = [
    // Fundamental objects
    "Object",
    "Function",
    "Boolean",
    "Symbol",
    // numbers and dates
    "Math",
    "Date",
    "Number",
    "BigInt",
    // text
    "String",
    "RegExp",
    // Indexed collections
    "Array",
    "Float32Array",
    "Float64Array",
    "Int8Array",
    "Uint8Array",
    "Uint8ClampedArray",
    "Int16Array",
    "Int32Array",
    "Uint16Array",
    "Uint32Array",
    "BigInt64Array",
    "BigUint64Array",
    // Keyed collections
    "Set",
    "Map",
    "WeakSet",
    "WeakMap",
    // Structured data
    "ArrayBuffer",
    "SharedArrayBuffer",
    "Atomics",
    "DataView",
    "JSON",
    // Control abstraction objects
    "Promise",
    "Generator",
    "GeneratorFunction",
    "AsyncFunction",
    // Reflection
    "Reflect",
    "Proxy",
    // Internationalization
    "Intl",
    // WebAssembly
    "WebAssembly"
  ], c = [
    "Error",
    "EvalError",
    "InternalError",
    "RangeError",
    "ReferenceError",
    "SyntaxError",
    "TypeError",
    "URIError"
  ], r = [
    "setInterval",
    "setTimeout",
    "clearInterval",
    "clearTimeout",
    "require",
    "exports",
    "eval",
    "isFinite",
    "isNaN",
    "parseFloat",
    "parseInt",
    "decodeURI",
    "decodeURIComponent",
    "encodeURI",
    "encodeURIComponent",
    "escape",
    "unescape"
  ], e = [].concat(
    r,
    o,
    c
  );
  function g(h) {
    const S = [
      "npm",
      "print"
    ], C = [
      "yes",
      "no",
      "on",
      "off",
      "it",
      "that",
      "void"
    ], O = [
      "then",
      "unless",
      "until",
      "loop",
      "of",
      "by",
      "when",
      "and",
      "or",
      "is",
      "isnt",
      "not",
      "it",
      "that",
      "otherwise",
      "from",
      "to",
      "til",
      "fallthrough",
      "case",
      "enum",
      "native",
      "list",
      "map",
      "__hasProp",
      "__extends",
      "__slice",
      "__bind",
      "__indexOf"
    ], N = {
      keyword: s.concat(O),
      literal: i.concat(C),
      built_in: e.concat(S)
    }, D = "[A-Za-z$_](?:-[0-9A-Za-z$_]|[0-9A-Za-z$_])*", x = h.inherit(h.TITLE_MODE, { begin: D }), L = {
      className: "subst",
      begin: /#\{/,
      end: /\}/,
      keywords: N
    }, G = {
      className: "subst",
      begin: /#[A-Za-z$_]/,
      end: /(?:-[0-9A-Za-z$_]|[0-9A-Za-z$_])*/,
      keywords: N
    }, Y = [
      h.BINARY_NUMBER_MODE,
      {
        className: "number",
        begin: "(\\b0[xX][a-fA-F0-9_]+)|(\\b\\d(\\d|_\\d)*(\\.(\\d(\\d|_\\d)*)?)?(_*[eE]([-+]\\d(_\\d|\\d)*)?)?[_a-z]*)",
        relevance: 0,
        starts: {
          end: "(\\s*/)?",
          relevance: 0
        }
        // a number tries to eat the following slash to prevent treating it as a regexp
      },
      {
        className: "string",
        variants: [
          {
            begin: /'''/,
            end: /'''/,
            contains: [h.BACKSLASH_ESCAPE]
          },
          {
            begin: /'/,
            end: /'/,
            contains: [h.BACKSLASH_ESCAPE]
          },
          {
            begin: /"""/,
            end: /"""/,
            contains: [
              h.BACKSLASH_ESCAPE,
              L,
              G
            ]
          },
          {
            begin: /"/,
            end: /"/,
            contains: [
              h.BACKSLASH_ESCAPE,
              L,
              G
            ]
          },
          {
            begin: /\\/,
            end: /(\s|$)/,
            excludeEnd: !0
          }
        ]
      },
      {
        className: "regexp",
        variants: [
          {
            begin: "//",
            end: "//[gim]*",
            contains: [
              L,
              h.HASH_COMMENT_MODE
            ]
          },
          {
            // regex can't start with space to parse x / 2 / 3 as two divisions
            // regex can't start with *, and it supports an "illegal" in the main mode
            begin: /\/(?![ *])(\\.|[^\\\n])*?\/[gim]*(?=\W)/
          }
        ]
      },
      { begin: "@" + D },
      {
        begin: "``",
        end: "``",
        excludeBegin: !0,
        excludeEnd: !0,
        subLanguage: "javascript"
      }
    ];
    L.contains = Y;
    const k = {
      className: "params",
      begin: "\\(",
      returnBegin: !0,
      /* We need another contained nameless mode to not have every nested
      pair of parens to be called "params" */
      contains: [
        {
          begin: /\(/,
          end: /\)/,
          keywords: N,
          contains: ["self"].concat(Y)
        }
      ]
    }, W = { begin: "(#=>|=>|\\|>>|-?->|!->)" }, Z = {
      variants: [
        { match: [
          /class\s+/,
          D,
          /\s+extends\s+/,
          D
        ] },
        { match: [
          /class\s+/,
          D
        ] }
      ],
      scope: {
        2: "title.class",
        4: "title.class.inherited"
      },
      keywords: N
    };
    return {
      name: "LiveScript",
      aliases: ["ls"],
      keywords: N,
      illegal: /\/\*/,
      contains: Y.concat([
        h.COMMENT("\\/\\*", "\\*\\/"),
        h.HASH_COMMENT_MODE,
        W,
        // relevance booster
        {
          className: "function",
          contains: [
            x,
            k
          ],
          returnBegin: !0,
          variants: [
            {
              begin: "(" + D + "\\s*(?:=|:=)\\s*)?(\\(.*\\)\\s*)?\\B->\\*?",
              end: "->\\*?"
            },
            {
              begin: "(" + D + "\\s*(?:=|:=)\\s*)?!?(\\(.*\\)\\s*)?\\B[-~]{1,2}>\\*?",
              end: "[-~]{1,2}>\\*?"
            },
            {
              begin: "(" + D + "\\s*(?:=|:=)\\s*)?(\\(.*\\)\\s*)?\\B!?[-~]{1,2}>\\*?",
              end: "!?[-~]{1,2}>\\*?"
            }
          ]
        },
        Z,
        {
          begin: D + ":",
          end: ":",
          returnBegin: !0,
          returnEnd: !0,
          relevance: 0
        }
      ])
    };
  }
  return a_ = g, a_;
}
var i_, xb;
function VP() {
  if (xb)
    return i_;
  xb = 1;
  function s(i) {
    const o = i.regex, c = /([-a-zA-Z$._][\w$.-]*)/, r = {
      className: "type",
      begin: /\bi\d+(?=\s|\b)/
    }, e = {
      className: "operator",
      relevance: 0,
      begin: /=/
    }, g = {
      className: "punctuation",
      relevance: 0,
      begin: /,/
    }, h = {
      className: "number",
      variants: [
        { begin: /[su]?0[xX][KMLHR]?[a-fA-F0-9]+/ },
        { begin: /[-+]?\d+(?:[.]\d+)?(?:[eE][-+]?\d+(?:[.]\d+)?)?/ }
      ],
      relevance: 0
    }, S = {
      className: "symbol",
      variants: [
        { begin: /^\s*[a-z]+:/ }
        // labels
      ],
      relevance: 0
    }, C = {
      className: "variable",
      variants: [
        { begin: o.concat(/%/, c) },
        { begin: /%\d+/ },
        { begin: /#\d+/ }
      ]
    }, O = {
      className: "title",
      variants: [
        { begin: o.concat(/@/, c) },
        { begin: /@\d+/ },
        { begin: o.concat(/!/, c) },
        { begin: o.concat(/!\d+/, c) },
        // https://llvm.org/docs/LangRef.html#namedmetadatastructure
        // obviously a single digit can also be used in this fashion
        { begin: /!\d+/ }
      ]
    };
    return {
      name: "LLVM IR",
      // TODO: split into different categories of keywords
      keywords: "begin end true false declare define global constant private linker_private internal available_externally linkonce linkonce_odr weak weak_odr appending dllimport dllexport common default hidden protected extern_weak external thread_local zeroinitializer undef null to tail target triple datalayout volatile nuw nsw nnan ninf nsz arcp fast exact inbounds align addrspace section alias module asm sideeffect gc dbg linker_private_weak attributes blockaddress initialexec localdynamic localexec prefix unnamed_addr ccc fastcc coldcc x86_stdcallcc x86_fastcallcc arm_apcscc arm_aapcscc arm_aapcs_vfpcc ptx_device ptx_kernel intel_ocl_bicc msp430_intrcc spir_func spir_kernel x86_64_sysvcc x86_64_win64cc x86_thiscallcc cc c signext zeroext inreg sret nounwind noreturn noalias nocapture byval nest readnone readonly inlinehint noinline alwaysinline optsize ssp sspreq noredzone noimplicitfloat naked builtin cold nobuiltin noduplicate nonlazybind optnone returns_twice sanitize_address sanitize_memory sanitize_thread sspstrong uwtable returned type opaque eq ne slt sgt sle sge ult ugt ule uge oeq one olt ogt ole oge ord uno ueq une x acq_rel acquire alignstack atomic catch cleanup filter inteldialect max min monotonic nand personality release seq_cst singlethread umax umin unordered xchg add fadd sub fsub mul fmul udiv sdiv fdiv urem srem frem shl lshr ashr and or xor icmp fcmp phi call trunc zext sext fptrunc fpext uitofp sitofp fptoui fptosi inttoptr ptrtoint bitcast addrspacecast select va_arg ret br switch invoke unwind unreachable indirectbr landingpad resume malloc alloca free load store getelementptr extractelement insertelement shufflevector getresult extractvalue insertvalue atomicrmw cmpxchg fence argmemonly double",
      contains: [
        r,
        // this matches "empty comments"...
        // ...because it's far more likely this is a statement terminator in
        // another language than an actual comment
        i.COMMENT(/;\s*$/, null, { relevance: 0 }),
        i.COMMENT(/;/, /$/),
        {
          className: "string",
          begin: /"/,
          end: /"/,
          contains: [
            {
              className: "char.escape",
              match: /\\\d\d/
            }
          ]
        },
        O,
        g,
        e,
        C,
        S,
        h
      ]
    };
  }
  return i_ = s, i_;
}
var o_, Lb;
function YP() {
  if (Lb)
    return o_;
  Lb = 1;
  function s(i) {
    const c = {
      className: "string",
      begin: '"',
      end: '"',
      contains: [{
        className: "subst",
        begin: /\\[tn"\\]/
      }]
    }, r = {
      className: "number",
      relevance: 0,
      begin: i.C_NUMBER_RE
    }, e = {
      className: "literal",
      variants: [
        { begin: "\\b(PI|TWO_PI|PI_BY_TWO|DEG_TO_RAD|RAD_TO_DEG|SQRT2)\\b" },
        { begin: "\\b(XP_ERROR_(EXPERIENCES_DISABLED|EXPERIENCE_(DISABLED|SUSPENDED)|INVALID_(EXPERIENCE|PARAMETERS)|KEY_NOT_FOUND|MATURITY_EXCEEDED|NONE|NOT_(FOUND|PERMITTED(_LAND)?)|NO_EXPERIENCE|QUOTA_EXCEEDED|RETRY_UPDATE|STORAGE_EXCEPTION|STORE_DISABLED|THROTTLED|UNKNOWN_ERROR)|JSON_APPEND|STATUS_(PHYSICS|ROTATE_[XYZ]|PHANTOM|SANDBOX|BLOCK_GRAB(_OBJECT)?|(DIE|RETURN)_AT_EDGE|CAST_SHADOWS|OK|MALFORMED_PARAMS|TYPE_MISMATCH|BOUNDS_ERROR|NOT_(FOUND|SUPPORTED)|INTERNAL_ERROR|WHITELIST_FAILED)|AGENT(_(BY_(LEGACY_|USER)NAME|FLYING|ATTACHMENTS|SCRIPTED|MOUSELOOK|SITTING|ON_OBJECT|AWAY|WALKING|IN_AIR|TYPING|CROUCHING|BUSY|ALWAYS_RUN|AUTOPILOT|LIST_(PARCEL(_OWNER)?|REGION)))?|CAMERA_(PITCH|DISTANCE|BEHINDNESS_(ANGLE|LAG)|(FOCUS|POSITION)(_(THRESHOLD|LOCKED|LAG))?|FOCUS_OFFSET|ACTIVE)|ANIM_ON|LOOP|REVERSE|PING_PONG|SMOOTH|ROTATE|SCALE|ALL_SIDES|LINK_(ROOT|SET|ALL_(OTHERS|CHILDREN)|THIS)|ACTIVE|PASS(IVE|_(ALWAYS|IF_NOT_HANDLED|NEVER))|SCRIPTED|CONTROL_(FWD|BACK|(ROT_)?(LEFT|RIGHT)|UP|DOWN|(ML_)?LBUTTON)|PERMISSION_(RETURN_OBJECTS|DEBIT|OVERRIDE_ANIMATIONS|SILENT_ESTATE_MANAGEMENT|TAKE_CONTROLS|TRIGGER_ANIMATION|ATTACH|CHANGE_LINKS|(CONTROL|TRACK)_CAMERA|TELEPORT)|INVENTORY_(TEXTURE|SOUND|OBJECT|SCRIPT|LANDMARK|CLOTHING|NOTECARD|BODYPART|ANIMATION|GESTURE|ALL|NONE)|CHANGED_(INVENTORY|COLOR|SHAPE|SCALE|TEXTURE|LINK|ALLOWED_DROP|OWNER|REGION(_START)?|TELEPORT|MEDIA)|OBJECT_(CLICK_ACTION|HOVER_HEIGHT|LAST_OWNER_ID|(PHYSICS|SERVER|STREAMING)_COST|UNKNOWN_DETAIL|CHARACTER_TIME|PHANTOM|PHYSICS|TEMP_(ATTACHED|ON_REZ)|NAME|DESC|POS|PRIM_(COUNT|EQUIVALENCE)|RETURN_(PARCEL(_OWNER)?|REGION)|REZZER_KEY|ROO?T|VELOCITY|OMEGA|OWNER|GROUP(_TAG)?|CREATOR|ATTACHED_(POINT|SLOTS_AVAILABLE)|RENDER_WEIGHT|(BODY_SHAPE|PATHFINDING)_TYPE|(RUNNING|TOTAL)_SCRIPT_COUNT|TOTAL_INVENTORY_COUNT|SCRIPT_(MEMORY|TIME))|TYPE_(INTEGER|FLOAT|STRING|KEY|VECTOR|ROTATION|INVALID)|(DEBUG|PUBLIC)_CHANNEL|ATTACH_(AVATAR_CENTER|CHEST|HEAD|BACK|PELVIS|MOUTH|CHIN|NECK|NOSE|BELLY|[LR](SHOULDER|HAND|FOOT|EAR|EYE|[UL](ARM|LEG)|HIP)|(LEFT|RIGHT)_PEC|HUD_(CENTER_[12]|TOP_(RIGHT|CENTER|LEFT)|BOTTOM(_(RIGHT|LEFT))?)|[LR]HAND_RING1|TAIL_(BASE|TIP)|[LR]WING|FACE_(JAW|[LR]EAR|[LR]EYE|TOUNGE)|GROIN|HIND_[LR]FOOT)|LAND_(LEVEL|RAISE|LOWER|SMOOTH|NOISE|REVERT)|DATA_(ONLINE|NAME|BORN|SIM_(POS|STATUS|RATING)|PAYINFO)|PAYMENT_INFO_(ON_FILE|USED)|REMOTE_DATA_(CHANNEL|REQUEST|REPLY)|PSYS_(PART_(BF_(ZERO|ONE(_MINUS_(DEST_COLOR|SOURCE_(ALPHA|COLOR)))?|DEST_COLOR|SOURCE_(ALPHA|COLOR))|BLEND_FUNC_(DEST|SOURCE)|FLAGS|(START|END)_(COLOR|ALPHA|SCALE|GLOW)|MAX_AGE|(RIBBON|WIND|INTERP_(COLOR|SCALE)|BOUNCE|FOLLOW_(SRC|VELOCITY)|TARGET_(POS|LINEAR)|EMISSIVE)_MASK)|SRC_(MAX_AGE|PATTERN|ANGLE_(BEGIN|END)|BURST_(RATE|PART_COUNT|RADIUS|SPEED_(MIN|MAX))|ACCEL|TEXTURE|TARGET_KEY|OMEGA|PATTERN_(DROP|EXPLODE|ANGLE(_CONE(_EMPTY)?)?)))|VEHICLE_(REFERENCE_FRAME|TYPE_(NONE|SLED|CAR|BOAT|AIRPLANE|BALLOON)|(LINEAR|ANGULAR)_(FRICTION_TIMESCALE|MOTOR_DIRECTION)|LINEAR_MOTOR_OFFSET|HOVER_(HEIGHT|EFFICIENCY|TIMESCALE)|BUOYANCY|(LINEAR|ANGULAR)_(DEFLECTION_(EFFICIENCY|TIMESCALE)|MOTOR_(DECAY_)?TIMESCALE)|VERTICAL_ATTRACTION_(EFFICIENCY|TIMESCALE)|BANKING_(EFFICIENCY|MIX|TIMESCALE)|FLAG_(NO_DEFLECTION_UP|LIMIT_(ROLL_ONLY|MOTOR_UP)|HOVER_((WATER|TERRAIN|UP)_ONLY|GLOBAL_HEIGHT)|MOUSELOOK_(STEER|BANK)|CAMERA_DECOUPLED))|PRIM_(ALLOW_UNSIT|ALPHA_MODE(_(BLEND|EMISSIVE|MASK|NONE))?|NORMAL|SPECULAR|TYPE(_(BOX|CYLINDER|PRISM|SPHERE|TORUS|TUBE|RING|SCULPT))?|HOLE_(DEFAULT|CIRCLE|SQUARE|TRIANGLE)|MATERIAL(_(STONE|METAL|GLASS|WOOD|FLESH|PLASTIC|RUBBER))?|SHINY_(NONE|LOW|MEDIUM|HIGH)|BUMP_(NONE|BRIGHT|DARK|WOOD|BARK|BRICKS|CHECKER|CONCRETE|TILE|STONE|DISKS|GRAVEL|BLOBS|SIDING|LARGETILE|STUCCO|SUCTION|WEAVE)|TEXGEN_(DEFAULT|PLANAR)|SCRIPTED_SIT_ONLY|SCULPT_(TYPE_(SPHERE|TORUS|PLANE|CYLINDER|MASK)|FLAG_(MIRROR|INVERT))|PHYSICS(_(SHAPE_(CONVEX|NONE|PRIM|TYPE)))?|(POS|ROT)_LOCAL|SLICE|TEXT|FLEXIBLE|POINT_LIGHT|TEMP_ON_REZ|PHANTOM|POSITION|SIT_TARGET|SIZE|ROTATION|TEXTURE|NAME|OMEGA|DESC|LINK_TARGET|COLOR|BUMP_SHINY|FULLBRIGHT|TEXGEN|GLOW|MEDIA_(ALT_IMAGE_ENABLE|CONTROLS|(CURRENT|HOME)_URL|AUTO_(LOOP|PLAY|SCALE|ZOOM)|FIRST_CLICK_INTERACT|(WIDTH|HEIGHT)_PIXELS|WHITELIST(_ENABLE)?|PERMS_(INTERACT|CONTROL)|PARAM_MAX|CONTROLS_(STANDARD|MINI)|PERM_(NONE|OWNER|GROUP|ANYONE)|MAX_(URL_LENGTH|WHITELIST_(SIZE|COUNT)|(WIDTH|HEIGHT)_PIXELS)))|MASK_(BASE|OWNER|GROUP|EVERYONE|NEXT)|PERM_(TRANSFER|MODIFY|COPY|MOVE|ALL)|PARCEL_(MEDIA_COMMAND_(STOP|PAUSE|PLAY|LOOP|TEXTURE|URL|TIME|AGENT|UNLOAD|AUTO_ALIGN|TYPE|SIZE|DESC|LOOP_SET)|FLAG_(ALLOW_(FLY|(GROUP_)?SCRIPTS|LANDMARK|TERRAFORM|DAMAGE|CREATE_(GROUP_)?OBJECTS)|USE_(ACCESS_(GROUP|LIST)|BAN_LIST|LAND_PASS_LIST)|LOCAL_SOUND_ONLY|RESTRICT_PUSHOBJECT|ALLOW_(GROUP|ALL)_OBJECT_ENTRY)|COUNT_(TOTAL|OWNER|GROUP|OTHER|SELECTED|TEMP)|DETAILS_(NAME|DESC|OWNER|GROUP|AREA|ID|SEE_AVATARS))|LIST_STAT_(MAX|MIN|MEAN|MEDIAN|STD_DEV|SUM(_SQUARES)?|NUM_COUNT|GEOMETRIC_MEAN|RANGE)|PAY_(HIDE|DEFAULT)|REGION_FLAG_(ALLOW_DAMAGE|FIXED_SUN|BLOCK_TERRAFORM|SANDBOX|DISABLE_(COLLISIONS|PHYSICS)|BLOCK_FLY|ALLOW_DIRECT_TELEPORT|RESTRICT_PUSHOBJECT)|HTTP_(METHOD|MIMETYPE|BODY_(MAXLENGTH|TRUNCATED)|CUSTOM_HEADER|PRAGMA_NO_CACHE|VERBOSE_THROTTLE|VERIFY_CERT)|SIT_(INVALID_(AGENT|LINK_OBJECT)|NO(T_EXPERIENCE|_(ACCESS|EXPERIENCE_PERMISSION|SIT_TARGET)))|STRING_(TRIM(_(HEAD|TAIL))?)|CLICK_ACTION_(NONE|TOUCH|SIT|BUY|PAY|OPEN(_MEDIA)?|PLAY|ZOOM)|TOUCH_INVALID_FACE|PROFILE_(NONE|SCRIPT_MEMORY)|RC_(DATA_FLAGS|DETECT_PHANTOM|GET_(LINK_NUM|NORMAL|ROOT_KEY)|MAX_HITS|REJECT_(TYPES|AGENTS|(NON)?PHYSICAL|LAND))|RCERR_(CAST_TIME_EXCEEDED|SIM_PERF_LOW|UNKNOWN)|ESTATE_ACCESS_(ALLOWED_(AGENT|GROUP)_(ADD|REMOVE)|BANNED_AGENT_(ADD|REMOVE))|DENSITY|FRICTION|RESTITUTION|GRAVITY_MULTIPLIER|KFM_(COMMAND|CMD_(PLAY|STOP|PAUSE)|MODE|FORWARD|LOOP|PING_PONG|REVERSE|DATA|ROTATION|TRANSLATION)|ERR_(GENERIC|PARCEL_PERMISSIONS|MALFORMED_PARAMS|RUNTIME_PERMISSIONS|THROTTLED)|CHARACTER_(CMD_((SMOOTH_)?STOP|JUMP)|DESIRED_(TURN_)?SPEED|RADIUS|STAY_WITHIN_PARCEL|LENGTH|ORIENTATION|ACCOUNT_FOR_SKIPPED_FRAMES|AVOIDANCE_MODE|TYPE(_([ABCD]|NONE))?|MAX_(DECEL|TURN_RADIUS|(ACCEL|SPEED)))|PURSUIT_(OFFSET|FUZZ_FACTOR|GOAL_TOLERANCE|INTERCEPT)|REQUIRE_LINE_OF_SIGHT|FORCE_DIRECT_PATH|VERTICAL|HORIZONTAL|AVOID_(CHARACTERS|DYNAMIC_OBSTACLES|NONE)|PU_(EVADE_(HIDDEN|SPOTTED)|FAILURE_(DYNAMIC_PATHFINDING_DISABLED|INVALID_(GOAL|START)|NO_(NAVMESH|VALID_DESTINATION)|OTHER|TARGET_GONE|(PARCEL_)?UNREACHABLE)|(GOAL|SLOWDOWN_DISTANCE)_REACHED)|TRAVERSAL_TYPE(_(FAST|NONE|SLOW))?|CONTENT_TYPE_(ATOM|FORM|HTML|JSON|LLSD|RSS|TEXT|XHTML|XML)|GCNP_(RADIUS|STATIC)|(PATROL|WANDER)_PAUSE_AT_WAYPOINTS|OPT_(AVATAR|CHARACTER|EXCLUSION_VOLUME|LEGACY_LINKSET|MATERIAL_VOLUME|OTHER|STATIC_OBSTACLE|WALKABLE)|SIM_STAT_PCT_CHARS_STEPPED)\\b" },
        { begin: "\\b(FALSE|TRUE)\\b" },
        { begin: "\\b(ZERO_ROTATION)\\b" },
        { begin: "\\b(EOF|JSON_(ARRAY|DELETE|FALSE|INVALID|NULL|NUMBER|OBJECT|STRING|TRUE)|NULL_KEY|TEXTURE_(BLANK|DEFAULT|MEDIA|PLYWOOD|TRANSPARENT)|URL_REQUEST_(GRANTED|DENIED))\\b" },
        { begin: "\\b(ZERO_VECTOR|TOUCH_INVALID_(TEXCOORD|VECTOR))\\b" }
      ]
    }, g = {
      className: "built_in",
      begin: "\\b(ll(AgentInExperience|(Create|DataSize|Delete|KeyCount|Keys|Read|Update)KeyValue|GetExperience(Details|ErrorMessage)|ReturnObjectsBy(ID|Owner)|Json(2List|[GS]etValue|ValueType)|Sin|Cos|Tan|Atan2|Sqrt|Pow|Abs|Fabs|Frand|Floor|Ceil|Round|Vec(Mag|Norm|Dist)|Rot(Between|2(Euler|Fwd|Left|Up))|(Euler|Axes)2Rot|Whisper|(Region|Owner)?Say|Shout|Listen(Control|Remove)?|Sensor(Repeat|Remove)?|Detected(Name|Key|Owner|Type|Pos|Vel|Grab|Rot|Group|LinkNumber)|Die|Ground|Wind|([GS]et)(AnimationOverride|MemoryLimit|PrimMediaParams|ParcelMusicURL|Object(Desc|Name)|PhysicsMaterial|Status|Scale|Color|Alpha|Texture|Pos|Rot|Force|Torque)|ResetAnimationOverride|(Scale|Offset|Rotate)Texture|(Rot)?Target(Remove)?|(Stop)?MoveToTarget|Apply(Rotational)?Impulse|Set(KeyframedMotion|ContentType|RegionPos|(Angular)?Velocity|Buoyancy|HoverHeight|ForceAndTorque|TimerEvent|ScriptState|Damage|TextureAnim|Sound(Queueing|Radius)|Vehicle(Type|(Float|Vector|Rotation)Param)|(Touch|Sit)?Text|Camera(Eye|At)Offset|PrimitiveParams|ClickAction|Link(Alpha|Color|PrimitiveParams(Fast)?|Texture(Anim)?|Camera|Media)|RemoteScriptAccessPin|PayPrice|LocalRot)|ScaleByFactor|Get((Max|Min)ScaleFactor|ClosestNavPoint|StaticPath|SimStats|Env|PrimitiveParams|Link(PrimitiveParams|Number(OfSides)?|Key|Name|Media)|HTTPHeader|FreeURLs|Object(Details|PermMask|PrimCount)|Parcel(MaxPrims|Details|Prim(Count|Owners))|Attached(List)?|(SPMax|Free|Used)Memory|Region(Name|TimeDilation|FPS|Corner|AgentCount)|Root(Position|Rotation)|UnixTime|(Parcel|Region)Flags|(Wall|GMT)clock|SimulatorHostname|BoundingBox|GeometricCenter|Creator|NumberOf(Prims|NotecardLines|Sides)|Animation(List)?|(Camera|Local)(Pos|Rot)|Vel|Accel|Omega|Time(stamp|OfDay)|(Object|CenterOf)?Mass|MassMKS|Energy|Owner|(Owner)?Key|SunDirection|Texture(Offset|Scale|Rot)|Inventory(Number|Name|Key|Type|Creator|PermMask)|Permissions(Key)?|StartParameter|List(Length|EntryType)|Date|Agent(Size|Info|Language|List)|LandOwnerAt|NotecardLine|Script(Name|State))|(Get|Reset|GetAndReset)Time|PlaySound(Slave)?|LoopSound(Master|Slave)?|(Trigger|Stop|Preload)Sound|((Get|Delete)Sub|Insert)String|To(Upper|Lower)|Give(InventoryList|Money)|RezObject|(Stop)?LookAt|Sleep|CollisionFilter|(Take|Release)Controls|DetachFromAvatar|AttachToAvatar(Temp)?|InstantMessage|(GetNext)?Email|StopHover|MinEventDelay|RotLookAt|String(Length|Trim)|(Start|Stop)Animation|TargetOmega|Request(Experience)?Permissions|(Create|Break)Link|BreakAllLinks|(Give|Remove)Inventory|Water|PassTouches|Request(Agent|Inventory)Data|TeleportAgent(Home|GlobalCoords)?|ModifyLand|CollisionSound|ResetScript|MessageLinked|PushObject|PassCollisions|AxisAngle2Rot|Rot2(Axis|Angle)|A(cos|sin)|AngleBetween|AllowInventoryDrop|SubStringIndex|List2(CSV|Integer|Json|Float|String|Key|Vector|Rot|List(Strided)?)|DeleteSubList|List(Statistics|Sort|Randomize|(Insert|Find|Replace)List)|EdgeOfWorld|AdjustSoundVolume|Key2Name|TriggerSoundLimited|EjectFromLand|(CSV|ParseString)2List|OverMyLand|SameGroup|UnSit|Ground(Slope|Normal|Contour)|GroundRepel|(Set|Remove)VehicleFlags|SitOnLink|(AvatarOn)?(Link)?SitTarget|Script(Danger|Profiler)|Dialog|VolumeDetect|ResetOtherScript|RemoteLoadScriptPin|(Open|Close)RemoteDataChannel|SendRemoteData|RemoteDataReply|(Integer|String)ToBase64|XorBase64|Log(10)?|Base64To(String|Integer)|ParseStringKeepNulls|RezAtRoot|RequestSimulatorData|ForceMouselook|(Load|Release|(E|Une)scape)URL|ParcelMedia(CommandList|Query)|ModPow|MapDestination|(RemoveFrom|AddTo|Reset)Land(Pass|Ban)List|(Set|Clear)CameraParams|HTTP(Request|Response)|TextBox|DetectedTouch(UV|Face|Pos|(N|Bin)ormal|ST)|(MD5|SHA1|DumpList2)String|Request(Secure)?URL|Clear(Prim|Link)Media|(Link)?ParticleSystem|(Get|Request)(Username|DisplayName)|RegionSayTo|CastRay|GenerateKey|TransferLindenDollars|ManageEstateAccess|(Create|Delete)Character|ExecCharacterCmd|Evade|FleeFrom|NavigateTo|PatrolPoints|Pursue|UpdateCharacter|WanderWithin))\\b"
    };
    return {
      name: "LSL (Linden Scripting Language)",
      illegal: ":",
      contains: [
        c,
        {
          className: "comment",
          variants: [
            i.COMMENT("//", "$"),
            i.COMMENT("/\\*", "\\*/")
          ],
          relevance: 0
        },
        r,
        {
          className: "section",
          variants: [
            { begin: "\\b(state|default)\\b" },
            { begin: "\\b(state_(entry|exit)|touch(_(start|end))?|(land_)?collision(_(start|end))?|timer|listen|(no_)?sensor|control|(not_)?at_(rot_)?target|money|email|experience_permissions(_denied)?|run_time_permissions|changed|attach|dataserver|moving_(start|end)|link_message|(on|object)_rez|remote_data|http_re(sponse|quest)|path_update|transaction_result)\\b" }
          ]
        },
        g,
        e,
        {
          className: "type",
          begin: "\\b(integer|float|string|key|vector|quaternion|rotation|list)\\b"
        }
      ]
    };
  }
  return o_ = s, o_;
}
var s_, Mb;
function HP() {
  if (Mb)
    return s_;
  Mb = 1;
  function s(i) {
    const o = "\\[=*\\[", c = "\\]=*\\]", r = {
      begin: o,
      end: c,
      contains: ["self"]
    }, e = [
      i.COMMENT("--(?!" + o + ")", "$"),
      i.COMMENT(
        "--" + o,
        c,
        {
          contains: [r],
          relevance: 10
        }
      )
    ];
    return {
      name: "Lua",
      keywords: {
        $pattern: i.UNDERSCORE_IDENT_RE,
        literal: "true false nil",
        keyword: "and break do else elseif end for goto if in local not or repeat return then until while",
        built_in: (
          // Metatags and globals:
          "_G _ENV _VERSION __index __newindex __mode __call __metatable __tostring __len __gc __add __sub __mul __div __mod __pow __concat __unm __eq __lt __le assert collectgarbage dofile error getfenv getmetatable ipairs load loadfile loadstring module next pairs pcall print rawequal rawget rawset require select setfenv setmetatable tonumber tostring type unpack xpcall arg self coroutine resume yield status wrap create running debug getupvalue debug sethook getmetatable gethook setmetatable setlocal traceback setfenv getinfo setupvalue getlocal getregistry getfenv io lines write close flush open output type read stderr stdin input stdout popen tmpfile math log max acos huge ldexp pi cos tanh pow deg tan cosh sinh random randomseed frexp ceil floor rad abs sqrt modf asin min mod fmod log10 atan2 exp sin atan os exit setlocale date getenv difftime remove time clock tmpname rename execute package preload loadlib loaded loaders cpath config path seeall string sub upper len gfind rep find match char dump gmatch reverse byte format gsub lower table setn insert getn foreachi maxn foreach concat sort remove"
        )
      },
      contains: e.concat([
        {
          className: "function",
          beginKeywords: "function",
          end: "\\)",
          contains: [
            i.inherit(i.TITLE_MODE, { begin: "([_a-zA-Z]\\w*\\.)*([_a-zA-Z]\\w*:)?[_a-zA-Z]\\w*" }),
            {
              className: "params",
              begin: "\\(",
              endsWithParent: !0,
              contains: e
            }
          ].concat(e)
        },
        i.C_NUMBER_MODE,
        i.APOS_STRING_MODE,
        i.QUOTE_STRING_MODE,
        {
          className: "string",
          begin: o,
          end: c,
          contains: [r],
          relevance: 5
        }
      ])
    };
  }
  return s_ = s, s_;
}
var l_, Pb;
function qP() {
  if (Pb)
    return l_;
  Pb = 1;
  function s(i) {
    const o = {
      className: "variable",
      variants: [
        {
          begin: "\\$\\(" + i.UNDERSCORE_IDENT_RE + "\\)",
          contains: [i.BACKSLASH_ESCAPE]
        },
        { begin: /\$[@%<?\^\+\*]/ }
      ]
    }, c = {
      className: "string",
      begin: /"/,
      end: /"/,
      contains: [
        i.BACKSLASH_ESCAPE,
        o
      ]
    }, r = {
      className: "variable",
      begin: /\$\([\w-]+\s/,
      end: /\)/,
      keywords: { built_in: "subst patsubst strip findstring filter filter-out sort word wordlist firstword lastword dir notdir suffix basename addsuffix addprefix join wildcard realpath abspath error warning shell origin flavor foreach if or and call eval file value" },
      contains: [o]
    }, e = { begin: "^" + i.UNDERSCORE_IDENT_RE + "\\s*(?=[:+?]?=)" }, g = {
      className: "meta",
      begin: /^\.PHONY:/,
      end: /$/,
      keywords: {
        $pattern: /[\.\w]+/,
        keyword: ".PHONY"
      }
    }, h = {
      className: "section",
      begin: /^[^\s]+:/,
      end: /$/,
      contains: [o]
    };
    return {
      name: "Makefile",
      aliases: [
        "mk",
        "mak",
        "make"
      ],
      keywords: {
        $pattern: /[\w-]+/,
        keyword: "define endef undefine ifdef ifndef ifeq ifneq else endif include -include sinclude override export unexport private vpath"
      },
      contains: [
        i.HASH_COMMENT_MODE,
        o,
        c,
        r,
        e,
        g,
        h
      ]
    };
  }
  return l_ = s, l_;
}
var c_, kb;
function $P() {
  if (kb)
    return c_;
  kb = 1;
  const s = [
    "AASTriangle",
    "AbelianGroup",
    "Abort",
    "AbortKernels",
    "AbortProtect",
    "AbortScheduledTask",
    "Above",
    "Abs",
    "AbsArg",
    "AbsArgPlot",
    "Absolute",
    "AbsoluteCorrelation",
    "AbsoluteCorrelationFunction",
    "AbsoluteCurrentValue",
    "AbsoluteDashing",
    "AbsoluteFileName",
    "AbsoluteOptions",
    "AbsolutePointSize",
    "AbsoluteThickness",
    "AbsoluteTime",
    "AbsoluteTiming",
    "AcceptanceThreshold",
    "AccountingForm",
    "Accumulate",
    "Accuracy",
    "AccuracyGoal",
    "AcousticAbsorbingValue",
    "AcousticImpedanceValue",
    "AcousticNormalVelocityValue",
    "AcousticPDEComponent",
    "AcousticPressureCondition",
    "AcousticRadiationValue",
    "AcousticSoundHardValue",
    "AcousticSoundSoftCondition",
    "ActionDelay",
    "ActionMenu",
    "ActionMenuBox",
    "ActionMenuBoxOptions",
    "Activate",
    "Active",
    "ActiveClassification",
    "ActiveClassificationObject",
    "ActiveItem",
    "ActivePrediction",
    "ActivePredictionObject",
    "ActiveStyle",
    "AcyclicGraphQ",
    "AddOnHelpPath",
    "AddSides",
    "AddTo",
    "AddToSearchIndex",
    "AddUsers",
    "AdjacencyGraph",
    "AdjacencyList",
    "AdjacencyMatrix",
    "AdjacentMeshCells",
    "Adjugate",
    "AdjustmentBox",
    "AdjustmentBoxOptions",
    "AdjustTimeSeriesForecast",
    "AdministrativeDivisionData",
    "AffineHalfSpace",
    "AffineSpace",
    "AffineStateSpaceModel",
    "AffineTransform",
    "After",
    "AggregatedEntityClass",
    "AggregationLayer",
    "AircraftData",
    "AirportData",
    "AirPressureData",
    "AirSoundAttenuation",
    "AirTemperatureData",
    "AiryAi",
    "AiryAiPrime",
    "AiryAiZero",
    "AiryBi",
    "AiryBiPrime",
    "AiryBiZero",
    "AlgebraicIntegerQ",
    "AlgebraicNumber",
    "AlgebraicNumberDenominator",
    "AlgebraicNumberNorm",
    "AlgebraicNumberPolynomial",
    "AlgebraicNumberTrace",
    "AlgebraicRules",
    "AlgebraicRulesData",
    "Algebraics",
    "AlgebraicUnitQ",
    "Alignment",
    "AlignmentMarker",
    "AlignmentPoint",
    "All",
    "AllowAdultContent",
    "AllowChatServices",
    "AllowedCloudExtraParameters",
    "AllowedCloudParameterExtensions",
    "AllowedDimensions",
    "AllowedFrequencyRange",
    "AllowedHeads",
    "AllowGroupClose",
    "AllowIncomplete",
    "AllowInlineCells",
    "AllowKernelInitialization",
    "AllowLooseGrammar",
    "AllowReverseGroupClose",
    "AllowScriptLevelChange",
    "AllowVersionUpdate",
    "AllTrue",
    "Alphabet",
    "AlphabeticOrder",
    "AlphabeticSort",
    "AlphaChannel",
    "AlternateImage",
    "AlternatingFactorial",
    "AlternatingGroup",
    "AlternativeHypothesis",
    "Alternatives",
    "AltitudeMethod",
    "AmbientLight",
    "AmbiguityFunction",
    "AmbiguityList",
    "Analytic",
    "AnatomyData",
    "AnatomyForm",
    "AnatomyPlot3D",
    "AnatomySkinStyle",
    "AnatomyStyling",
    "AnchoredSearch",
    "And",
    "AndersonDarlingTest",
    "AngerJ",
    "AngleBisector",
    "AngleBracket",
    "AnglePath",
    "AnglePath3D",
    "AngleVector",
    "AngularGauge",
    "Animate",
    "AnimatedImage",
    "AnimationCycleOffset",
    "AnimationCycleRepetitions",
    "AnimationDirection",
    "AnimationDisplayTime",
    "AnimationRate",
    "AnimationRepetitions",
    "AnimationRunning",
    "AnimationRunTime",
    "AnimationTimeIndex",
    "AnimationVideo",
    "Animator",
    "AnimatorBox",
    "AnimatorBoxOptions",
    "AnimatorElements",
    "Annotate",
    "Annotation",
    "AnnotationDelete",
    "AnnotationKeys",
    "AnnotationRules",
    "AnnotationValue",
    "Annuity",
    "AnnuityDue",
    "Annulus",
    "AnomalyDetection",
    "AnomalyDetector",
    "AnomalyDetectorFunction",
    "Anonymous",
    "Antialiasing",
    "Antihermitian",
    "AntihermitianMatrixQ",
    "Antisymmetric",
    "AntisymmetricMatrixQ",
    "Antonyms",
    "AnyOrder",
    "AnySubset",
    "AnyTrue",
    "Apart",
    "ApartSquareFree",
    "APIFunction",
    "Appearance",
    "AppearanceElements",
    "AppearanceRules",
    "AppellF1",
    "Append",
    "AppendCheck",
    "AppendLayer",
    "AppendTo",
    "Application",
    "Apply",
    "ApplyReaction",
    "ApplySides",
    "ApplyTo",
    "ArcCos",
    "ArcCosh",
    "ArcCot",
    "ArcCoth",
    "ArcCsc",
    "ArcCsch",
    "ArcCurvature",
    "ARCHProcess",
    "ArcLength",
    "ArcSec",
    "ArcSech",
    "ArcSin",
    "ArcSinDistribution",
    "ArcSinh",
    "ArcTan",
    "ArcTanh",
    "Area",
    "Arg",
    "ArgMax",
    "ArgMin",
    "ArgumentCountQ",
    "ArgumentsOptions",
    "ARIMAProcess",
    "ArithmeticGeometricMean",
    "ARMAProcess",
    "Around",
    "AroundReplace",
    "ARProcess",
    "Array",
    "ArrayComponents",
    "ArrayDepth",
    "ArrayFilter",
    "ArrayFlatten",
    "ArrayMesh",
    "ArrayPad",
    "ArrayPlot",
    "ArrayPlot3D",
    "ArrayQ",
    "ArrayReduce",
    "ArrayResample",
    "ArrayReshape",
    "ArrayRules",
    "Arrays",
    "Arrow",
    "Arrow3DBox",
    "ArrowBox",
    "Arrowheads",
    "ASATriangle",
    "Ask",
    "AskAppend",
    "AskConfirm",
    "AskDisplay",
    "AskedQ",
    "AskedValue",
    "AskFunction",
    "AskState",
    "AskTemplateDisplay",
    "AspectRatio",
    "AspectRatioFixed",
    "Assert",
    "AssessmentFunction",
    "AssessmentResultObject",
    "AssociateTo",
    "Association",
    "AssociationFormat",
    "AssociationMap",
    "AssociationQ",
    "AssociationThread",
    "AssumeDeterministic",
    "Assuming",
    "Assumptions",
    "AstroAngularSeparation",
    "AstroBackground",
    "AstroCenter",
    "AstroDistance",
    "AstroGraphics",
    "AstroGridLines",
    "AstroGridLinesStyle",
    "AstronomicalData",
    "AstroPosition",
    "AstroProjection",
    "AstroRange",
    "AstroRangePadding",
    "AstroReferenceFrame",
    "AstroStyling",
    "AstroZoomLevel",
    "Asymptotic",
    "AsymptoticDSolveValue",
    "AsymptoticEqual",
    "AsymptoticEquivalent",
    "AsymptoticExpectation",
    "AsymptoticGreater",
    "AsymptoticGreaterEqual",
    "AsymptoticIntegrate",
    "AsymptoticLess",
    "AsymptoticLessEqual",
    "AsymptoticOutputTracker",
    "AsymptoticProbability",
    "AsymptoticProduct",
    "AsymptoticRSolveValue",
    "AsymptoticSolve",
    "AsymptoticSum",
    "Asynchronous",
    "AsynchronousTaskObject",
    "AsynchronousTasks",
    "Atom",
    "AtomCoordinates",
    "AtomCount",
    "AtomDiagramCoordinates",
    "AtomLabels",
    "AtomLabelStyle",
    "AtomList",
    "AtomQ",
    "AttachCell",
    "AttachedCell",
    "AttentionLayer",
    "Attributes",
    "Audio",
    "AudioAmplify",
    "AudioAnnotate",
    "AudioAnnotationLookup",
    "AudioBlockMap",
    "AudioCapture",
    "AudioChannelAssignment",
    "AudioChannelCombine",
    "AudioChannelMix",
    "AudioChannels",
    "AudioChannelSeparate",
    "AudioData",
    "AudioDelay",
    "AudioDelete",
    "AudioDevice",
    "AudioDistance",
    "AudioEncoding",
    "AudioFade",
    "AudioFrequencyShift",
    "AudioGenerator",
    "AudioIdentify",
    "AudioInputDevice",
    "AudioInsert",
    "AudioInstanceQ",
    "AudioIntervals",
    "AudioJoin",
    "AudioLabel",
    "AudioLength",
    "AudioLocalMeasurements",
    "AudioLooping",
    "AudioLoudness",
    "AudioMeasurements",
    "AudioNormalize",
    "AudioOutputDevice",
    "AudioOverlay",
    "AudioPad",
    "AudioPan",
    "AudioPartition",
    "AudioPause",
    "AudioPitchShift",
    "AudioPlay",
    "AudioPlot",
    "AudioQ",
    "AudioRecord",
    "AudioReplace",
    "AudioResample",
    "AudioReverb",
    "AudioReverse",
    "AudioSampleRate",
    "AudioSpectralMap",
    "AudioSpectralTransformation",
    "AudioSplit",
    "AudioStop",
    "AudioStream",
    "AudioStreams",
    "AudioTimeStretch",
    "AudioTrackApply",
    "AudioTrackSelection",
    "AudioTrim",
    "AudioType",
    "AugmentedPolyhedron",
    "AugmentedSymmetricPolynomial",
    "Authenticate",
    "Authentication",
    "AuthenticationDialog",
    "AutoAction",
    "Autocomplete",
    "AutocompletionFunction",
    "AutoCopy",
    "AutocorrelationTest",
    "AutoDelete",
    "AutoEvaluateEvents",
    "AutoGeneratedPackage",
    "AutoIndent",
    "AutoIndentSpacings",
    "AutoItalicWords",
    "AutoloadPath",
    "AutoMatch",
    "Automatic",
    "AutomaticImageSize",
    "AutoMultiplicationSymbol",
    "AutoNumberFormatting",
    "AutoOpenNotebooks",
    "AutoOpenPalettes",
    "AutoOperatorRenderings",
    "AutoQuoteCharacters",
    "AutoRefreshed",
    "AutoRemove",
    "AutorunSequencing",
    "AutoScaling",
    "AutoScroll",
    "AutoSpacing",
    "AutoStyleOptions",
    "AutoStyleWords",
    "AutoSubmitting",
    "Axes",
    "AxesEdge",
    "AxesLabel",
    "AxesOrigin",
    "AxesStyle",
    "AxiomaticTheory",
    "Axis",
    "Axis3DBox",
    "Axis3DBoxOptions",
    "AxisBox",
    "AxisBoxOptions",
    "AxisLabel",
    "AxisObject",
    "AxisStyle",
    "BabyMonsterGroupB",
    "Back",
    "BackFaceColor",
    "BackFaceGlowColor",
    "BackFaceOpacity",
    "BackFaceSpecularColor",
    "BackFaceSpecularExponent",
    "BackFaceSurfaceAppearance",
    "BackFaceTexture",
    "Background",
    "BackgroundAppearance",
    "BackgroundTasksSettings",
    "Backslash",
    "Backsubstitution",
    "Backward",
    "Ball",
    "Band",
    "BandpassFilter",
    "BandstopFilter",
    "BarabasiAlbertGraphDistribution",
    "BarChart",
    "BarChart3D",
    "BarcodeImage",
    "BarcodeRecognize",
    "BaringhausHenzeTest",
    "BarLegend",
    "BarlowProschanImportance",
    "BarnesG",
    "BarOrigin",
    "BarSpacing",
    "BartlettHannWindow",
    "BartlettWindow",
    "BaseDecode",
    "BaseEncode",
    "BaseForm",
    "Baseline",
    "BaselinePosition",
    "BaseStyle",
    "BasicRecurrentLayer",
    "BatchNormalizationLayer",
    "BatchSize",
    "BatesDistribution",
    "BattleLemarieWavelet",
    "BayesianMaximization",
    "BayesianMaximizationObject",
    "BayesianMinimization",
    "BayesianMinimizationObject",
    "Because",
    "BeckmannDistribution",
    "Beep",
    "Before",
    "Begin",
    "BeginDialogPacket",
    "BeginPackage",
    "BellB",
    "BellY",
    "Below",
    "BenfordDistribution",
    "BeniniDistribution",
    "BenktanderGibratDistribution",
    "BenktanderWeibullDistribution",
    "BernoulliB",
    "BernoulliDistribution",
    "BernoulliGraphDistribution",
    "BernoulliProcess",
    "BernsteinBasis",
    "BesagL",
    "BesselFilterModel",
    "BesselI",
    "BesselJ",
    "BesselJZero",
    "BesselK",
    "BesselY",
    "BesselYZero",
    "Beta",
    "BetaBinomialDistribution",
    "BetaDistribution",
    "BetaNegativeBinomialDistribution",
    "BetaPrimeDistribution",
    "BetaRegularized",
    "Between",
    "BetweennessCentrality",
    "Beveled",
    "BeveledPolyhedron",
    "BezierCurve",
    "BezierCurve3DBox",
    "BezierCurve3DBoxOptions",
    "BezierCurveBox",
    "BezierCurveBoxOptions",
    "BezierFunction",
    "BilateralFilter",
    "BilateralLaplaceTransform",
    "BilateralZTransform",
    "Binarize",
    "BinaryDeserialize",
    "BinaryDistance",
    "BinaryFormat",
    "BinaryImageQ",
    "BinaryRead",
    "BinaryReadList",
    "BinarySerialize",
    "BinaryWrite",
    "BinCounts",
    "BinLists",
    "BinnedVariogramList",
    "Binomial",
    "BinomialDistribution",
    "BinomialPointProcess",
    "BinomialProcess",
    "BinormalDistribution",
    "BiorthogonalSplineWavelet",
    "BioSequence",
    "BioSequenceBackTranslateList",
    "BioSequenceComplement",
    "BioSequenceInstances",
    "BioSequenceModify",
    "BioSequencePlot",
    "BioSequenceQ",
    "BioSequenceReverseComplement",
    "BioSequenceTranscribe",
    "BioSequenceTranslate",
    "BipartiteGraphQ",
    "BiquadraticFilterModel",
    "BirnbaumImportance",
    "BirnbaumSaundersDistribution",
    "BitAnd",
    "BitClear",
    "BitGet",
    "BitLength",
    "BitNot",
    "BitOr",
    "BitRate",
    "BitSet",
    "BitShiftLeft",
    "BitShiftRight",
    "BitXor",
    "BiweightLocation",
    "BiweightMidvariance",
    "Black",
    "BlackmanHarrisWindow",
    "BlackmanNuttallWindow",
    "BlackmanWindow",
    "Blank",
    "BlankForm",
    "BlankNullSequence",
    "BlankSequence",
    "Blend",
    "Block",
    "BlockchainAddressData",
    "BlockchainBase",
    "BlockchainBlockData",
    "BlockchainContractValue",
    "BlockchainData",
    "BlockchainGet",
    "BlockchainKeyEncode",
    "BlockchainPut",
    "BlockchainTokenData",
    "BlockchainTransaction",
    "BlockchainTransactionData",
    "BlockchainTransactionSign",
    "BlockchainTransactionSubmit",
    "BlockDiagonalMatrix",
    "BlockLowerTriangularMatrix",
    "BlockMap",
    "BlockRandom",
    "BlockUpperTriangularMatrix",
    "BlomqvistBeta",
    "BlomqvistBetaTest",
    "Blue",
    "Blur",
    "Blurring",
    "BodePlot",
    "BohmanWindow",
    "Bold",
    "Bond",
    "BondCount",
    "BondLabels",
    "BondLabelStyle",
    "BondList",
    "BondQ",
    "Bookmarks",
    "Boole",
    "BooleanConsecutiveFunction",
    "BooleanConvert",
    "BooleanCountingFunction",
    "BooleanFunction",
    "BooleanGraph",
    "BooleanMaxterms",
    "BooleanMinimize",
    "BooleanMinterms",
    "BooleanQ",
    "BooleanRegion",
    "Booleans",
    "BooleanStrings",
    "BooleanTable",
    "BooleanVariables",
    "BorderDimensions",
    "BorelTannerDistribution",
    "Bottom",
    "BottomHatTransform",
    "BoundaryDiscretizeGraphics",
    "BoundaryDiscretizeRegion",
    "BoundaryMesh",
    "BoundaryMeshRegion",
    "BoundaryMeshRegionQ",
    "BoundaryStyle",
    "BoundedRegionQ",
    "BoundingRegion",
    "Bounds",
    "Box",
    "BoxBaselineShift",
    "BoxData",
    "BoxDimensions",
    "Boxed",
    "Boxes",
    "BoxForm",
    "BoxFormFormatTypes",
    "BoxFrame",
    "BoxID",
    "BoxMargins",
    "BoxMatrix",
    "BoxObject",
    "BoxRatios",
    "BoxRotation",
    "BoxRotationPoint",
    "BoxStyle",
    "BoxWhiskerChart",
    "Bra",
    "BracketingBar",
    "BraKet",
    "BrayCurtisDistance",
    "BreadthFirstScan",
    "Break",
    "BridgeData",
    "BrightnessEqualize",
    "BroadcastStationData",
    "Brown",
    "BrownForsytheTest",
    "BrownianBridgeProcess",
    "BrowserCategory",
    "BSplineBasis",
    "BSplineCurve",
    "BSplineCurve3DBox",
    "BSplineCurve3DBoxOptions",
    "BSplineCurveBox",
    "BSplineCurveBoxOptions",
    "BSplineFunction",
    "BSplineSurface",
    "BSplineSurface3DBox",
    "BSplineSurface3DBoxOptions",
    "BubbleChart",
    "BubbleChart3D",
    "BubbleScale",
    "BubbleSizes",
    "BuckyballGraph",
    "BuildCompiledComponent",
    "BuildingData",
    "BulletGauge",
    "BusinessDayQ",
    "ButterflyGraph",
    "ButterworthFilterModel",
    "Button",
    "ButtonBar",
    "ButtonBox",
    "ButtonBoxOptions",
    "ButtonCell",
    "ButtonContents",
    "ButtonData",
    "ButtonEvaluator",
    "ButtonExpandable",
    "ButtonFrame",
    "ButtonFunction",
    "ButtonMargins",
    "ButtonMinHeight",
    "ButtonNote",
    "ButtonNotebook",
    "ButtonSource",
    "ButtonStyle",
    "ButtonStyleMenuListing",
    "Byte",
    "ByteArray",
    "ByteArrayFormat",
    "ByteArrayFormatQ",
    "ByteArrayQ",
    "ByteArrayToString",
    "ByteCount",
    "ByteOrdering",
    "C",
    "CachedValue",
    "CacheGraphics",
    "CachePersistence",
    "CalendarConvert",
    "CalendarData",
    "CalendarType",
    "Callout",
    "CalloutMarker",
    "CalloutStyle",
    "CallPacket",
    "CanberraDistance",
    "Cancel",
    "CancelButton",
    "CandlestickChart",
    "CanonicalGraph",
    "CanonicalizePolygon",
    "CanonicalizePolyhedron",
    "CanonicalizeRegion",
    "CanonicalName",
    "CanonicalWarpingCorrespondence",
    "CanonicalWarpingDistance",
    "CantorMesh",
    "CantorStaircase",
    "Canvas",
    "Cap",
    "CapForm",
    "CapitalDifferentialD",
    "Capitalize",
    "CapsuleShape",
    "CaptureRunning",
    "CaputoD",
    "CardinalBSplineBasis",
    "CarlemanLinearize",
    "CarlsonRC",
    "CarlsonRD",
    "CarlsonRE",
    "CarlsonRF",
    "CarlsonRG",
    "CarlsonRJ",
    "CarlsonRK",
    "CarlsonRM",
    "CarmichaelLambda",
    "CaseOrdering",
    "Cases",
    "CaseSensitive",
    "Cashflow",
    "Casoratian",
    "Cast",
    "Catalan",
    "CatalanNumber",
    "Catch",
    "CategoricalDistribution",
    "Catenate",
    "CatenateLayer",
    "CauchyDistribution",
    "CauchyMatrix",
    "CauchyPointProcess",
    "CauchyWindow",
    "CayleyGraph",
    "CDF",
    "CDFDeploy",
    "CDFInformation",
    "CDFWavelet",
    "Ceiling",
    "CelestialSystem",
    "Cell",
    "CellAutoOverwrite",
    "CellBaseline",
    "CellBoundingBox",
    "CellBracketOptions",
    "CellChangeTimes",
    "CellContents",
    "CellContext",
    "CellDingbat",
    "CellDingbatMargin",
    "CellDynamicExpression",
    "CellEditDuplicate",
    "CellElementsBoundingBox",
    "CellElementSpacings",
    "CellEpilog",
    "CellEvaluationDuplicate",
    "CellEvaluationFunction",
    "CellEvaluationLanguage",
    "CellEventActions",
    "CellFrame",
    "CellFrameColor",
    "CellFrameLabelMargins",
    "CellFrameLabels",
    "CellFrameMargins",
    "CellFrameStyle",
    "CellGroup",
    "CellGroupData",
    "CellGrouping",
    "CellGroupingRules",
    "CellHorizontalScrolling",
    "CellID",
    "CellInsertionPointCell",
    "CellLabel",
    "CellLabelAutoDelete",
    "CellLabelMargins",
    "CellLabelPositioning",
    "CellLabelStyle",
    "CellLabelTemplate",
    "CellMargins",
    "CellObject",
    "CellOpen",
    "CellPrint",
    "CellProlog",
    "Cells",
    "CellSize",
    "CellStyle",
    "CellTags",
    "CellTrayPosition",
    "CellTrayWidgets",
    "CellularAutomaton",
    "CensoredDistribution",
    "Censoring",
    "Center",
    "CenterArray",
    "CenterDot",
    "CenteredInterval",
    "CentralFeature",
    "CentralMoment",
    "CentralMomentGeneratingFunction",
    "Cepstrogram",
    "CepstrogramArray",
    "CepstrumArray",
    "CForm",
    "ChampernowneNumber",
    "ChangeOptions",
    "ChannelBase",
    "ChannelBrokerAction",
    "ChannelDatabin",
    "ChannelHistoryLength",
    "ChannelListen",
    "ChannelListener",
    "ChannelListeners",
    "ChannelListenerWait",
    "ChannelObject",
    "ChannelPreSendFunction",
    "ChannelReceiverFunction",
    "ChannelSend",
    "ChannelSubscribers",
    "ChanVeseBinarize",
    "Character",
    "CharacterCounts",
    "CharacterEncoding",
    "CharacterEncodingsPath",
    "CharacteristicFunction",
    "CharacteristicPolynomial",
    "CharacterName",
    "CharacterNormalize",
    "CharacterRange",
    "Characters",
    "ChartBaseStyle",
    "ChartElementData",
    "ChartElementDataFunction",
    "ChartElementFunction",
    "ChartElements",
    "ChartLabels",
    "ChartLayout",
    "ChartLegends",
    "ChartStyle",
    "Chebyshev1FilterModel",
    "Chebyshev2FilterModel",
    "ChebyshevDistance",
    "ChebyshevT",
    "ChebyshevU",
    "Check",
    "CheckAbort",
    "CheckAll",
    "CheckArguments",
    "Checkbox",
    "CheckboxBar",
    "CheckboxBox",
    "CheckboxBoxOptions",
    "ChemicalConvert",
    "ChemicalData",
    "ChemicalFormula",
    "ChemicalInstance",
    "ChemicalReaction",
    "ChessboardDistance",
    "ChiDistribution",
    "ChineseRemainder",
    "ChiSquareDistribution",
    "ChoiceButtons",
    "ChoiceDialog",
    "CholeskyDecomposition",
    "Chop",
    "ChromaticityPlot",
    "ChromaticityPlot3D",
    "ChromaticPolynomial",
    "Circle",
    "CircleBox",
    "CircleDot",
    "CircleMinus",
    "CirclePlus",
    "CirclePoints",
    "CircleThrough",
    "CircleTimes",
    "CirculantGraph",
    "CircularArcThrough",
    "CircularOrthogonalMatrixDistribution",
    "CircularQuaternionMatrixDistribution",
    "CircularRealMatrixDistribution",
    "CircularSymplecticMatrixDistribution",
    "CircularUnitaryMatrixDistribution",
    "Circumsphere",
    "CityData",
    "ClassifierFunction",
    "ClassifierInformation",
    "ClassifierMeasurements",
    "ClassifierMeasurementsObject",
    "Classify",
    "ClassPriors",
    "Clear",
    "ClearAll",
    "ClearAttributes",
    "ClearCookies",
    "ClearPermissions",
    "ClearSystemCache",
    "ClebschGordan",
    "ClickPane",
    "ClickToCopy",
    "ClickToCopyEnabled",
    "Clip",
    "ClipboardNotebook",
    "ClipFill",
    "ClippingStyle",
    "ClipPlanes",
    "ClipPlanesStyle",
    "ClipRange",
    "Clock",
    "ClockGauge",
    "ClockwiseContourIntegral",
    "Close",
    "Closed",
    "CloseKernels",
    "ClosenessCentrality",
    "Closing",
    "ClosingAutoSave",
    "ClosingEvent",
    "CloudAccountData",
    "CloudBase",
    "CloudConnect",
    "CloudConnections",
    "CloudDeploy",
    "CloudDirectory",
    "CloudDisconnect",
    "CloudEvaluate",
    "CloudExport",
    "CloudExpression",
    "CloudExpressions",
    "CloudFunction",
    "CloudGet",
    "CloudImport",
    "CloudLoggingData",
    "CloudObject",
    "CloudObjectInformation",
    "CloudObjectInformationData",
    "CloudObjectNameFormat",
    "CloudObjects",
    "CloudObjectURLType",
    "CloudPublish",
    "CloudPut",
    "CloudRenderingMethod",
    "CloudSave",
    "CloudShare",
    "CloudSubmit",
    "CloudSymbol",
    "CloudUnshare",
    "CloudUserID",
    "ClusterClassify",
    "ClusterDissimilarityFunction",
    "ClusteringComponents",
    "ClusteringMeasurements",
    "ClusteringTree",
    "CMYKColor",
    "Coarse",
    "CodeAssistOptions",
    "Coefficient",
    "CoefficientArrays",
    "CoefficientDomain",
    "CoefficientList",
    "CoefficientRules",
    "CoifletWavelet",
    "Collect",
    "CollinearPoints",
    "Colon",
    "ColonForm",
    "ColorBalance",
    "ColorCombine",
    "ColorConvert",
    "ColorCoverage",
    "ColorData",
    "ColorDataFunction",
    "ColorDetect",
    "ColorDistance",
    "ColorFunction",
    "ColorFunctionBinning",
    "ColorFunctionScaling",
    "Colorize",
    "ColorNegate",
    "ColorOutput",
    "ColorProfileData",
    "ColorQ",
    "ColorQuantize",
    "ColorReplace",
    "ColorRules",
    "ColorSelectorSettings",
    "ColorSeparate",
    "ColorSetter",
    "ColorSetterBox",
    "ColorSetterBoxOptions",
    "ColorSlider",
    "ColorsNear",
    "ColorSpace",
    "ColorToneMapping",
    "Column",
    "ColumnAlignments",
    "ColumnBackgrounds",
    "ColumnForm",
    "ColumnLines",
    "ColumnsEqual",
    "ColumnSpacings",
    "ColumnWidths",
    "CombinatorB",
    "CombinatorC",
    "CombinatorI",
    "CombinatorK",
    "CombinatorS",
    "CombinatorW",
    "CombinatorY",
    "CombinedEntityClass",
    "CombinerFunction",
    "CometData",
    "CommonDefaultFormatTypes",
    "Commonest",
    "CommonestFilter",
    "CommonName",
    "CommonUnits",
    "CommunityBoundaryStyle",
    "CommunityGraphPlot",
    "CommunityLabels",
    "CommunityRegionStyle",
    "CompanyData",
    "CompatibleUnitQ",
    "CompilationOptions",
    "CompilationTarget",
    "Compile",
    "Compiled",
    "CompiledCodeFunction",
    "CompiledComponent",
    "CompiledExpressionDeclaration",
    "CompiledFunction",
    "CompiledLayer",
    "CompilerCallback",
    "CompilerEnvironment",
    "CompilerEnvironmentAppend",
    "CompilerEnvironmentAppendTo",
    "CompilerEnvironmentObject",
    "CompilerOptions",
    "Complement",
    "ComplementedEntityClass",
    "CompleteGraph",
    "CompleteGraphQ",
    "CompleteIntegral",
    "CompleteKaryTree",
    "CompletionsListPacket",
    "Complex",
    "ComplexArrayPlot",
    "ComplexContourPlot",
    "Complexes",
    "ComplexExpand",
    "ComplexInfinity",
    "ComplexityFunction",
    "ComplexListPlot",
    "ComplexPlot",
    "ComplexPlot3D",
    "ComplexRegionPlot",
    "ComplexStreamPlot",
    "ComplexVectorPlot",
    "ComponentMeasurements",
    "ComponentwiseContextMenu",
    "Compose",
    "ComposeList",
    "ComposeSeries",
    "CompositeQ",
    "Composition",
    "CompoundElement",
    "CompoundExpression",
    "CompoundPoissonDistribution",
    "CompoundPoissonProcess",
    "CompoundRenewalProcess",
    "Compress",
    "CompressedData",
    "CompressionLevel",
    "ComputeUncertainty",
    "ConcaveHullMesh",
    "Condition",
    "ConditionalExpression",
    "Conditioned",
    "Cone",
    "ConeBox",
    "ConfidenceLevel",
    "ConfidenceRange",
    "ConfidenceTransform",
    "ConfigurationPath",
    "Confirm",
    "ConfirmAssert",
    "ConfirmBy",
    "ConfirmMatch",
    "ConfirmQuiet",
    "ConformationMethod",
    "ConformAudio",
    "ConformImages",
    "Congruent",
    "ConicGradientFilling",
    "ConicHullRegion",
    "ConicHullRegion3DBox",
    "ConicHullRegion3DBoxOptions",
    "ConicHullRegionBox",
    "ConicHullRegionBoxOptions",
    "ConicOptimization",
    "Conjugate",
    "ConjugateTranspose",
    "Conjunction",
    "Connect",
    "ConnectedComponents",
    "ConnectedGraphComponents",
    "ConnectedGraphQ",
    "ConnectedMeshComponents",
    "ConnectedMoleculeComponents",
    "ConnectedMoleculeQ",
    "ConnectionSettings",
    "ConnectLibraryCallbackFunction",
    "ConnectSystemModelComponents",
    "ConnectSystemModelController",
    "ConnesWindow",
    "ConoverTest",
    "ConservativeConvectionPDETerm",
    "ConsoleMessage",
    "Constant",
    "ConstantArray",
    "ConstantArrayLayer",
    "ConstantImage",
    "ConstantPlusLayer",
    "ConstantRegionQ",
    "Constants",
    "ConstantTimesLayer",
    "ConstellationData",
    "ConstrainedMax",
    "ConstrainedMin",
    "Construct",
    "Containing",
    "ContainsAll",
    "ContainsAny",
    "ContainsExactly",
    "ContainsNone",
    "ContainsOnly",
    "ContentDetectorFunction",
    "ContentFieldOptions",
    "ContentLocationFunction",
    "ContentObject",
    "ContentPadding",
    "ContentsBoundingBox",
    "ContentSelectable",
    "ContentSize",
    "Context",
    "ContextMenu",
    "Contexts",
    "ContextToFileName",
    "Continuation",
    "Continue",
    "ContinuedFraction",
    "ContinuedFractionK",
    "ContinuousAction",
    "ContinuousMarkovProcess",
    "ContinuousTask",
    "ContinuousTimeModelQ",
    "ContinuousWaveletData",
    "ContinuousWaveletTransform",
    "ContourDetect",
    "ContourGraphics",
    "ContourIntegral",
    "ContourLabels",
    "ContourLines",
    "ContourPlot",
    "ContourPlot3D",
    "Contours",
    "ContourShading",
    "ContourSmoothing",
    "ContourStyle",
    "ContraharmonicMean",
    "ContrastiveLossLayer",
    "Control",
    "ControlActive",
    "ControlAlignment",
    "ControlGroupContentsBox",
    "ControllabilityGramian",
    "ControllabilityMatrix",
    "ControllableDecomposition",
    "ControllableModelQ",
    "ControllerDuration",
    "ControllerInformation",
    "ControllerInformationData",
    "ControllerLinking",
    "ControllerManipulate",
    "ControllerMethod",
    "ControllerPath",
    "ControllerState",
    "ControlPlacement",
    "ControlsRendering",
    "ControlType",
    "ConvectionPDETerm",
    "Convergents",
    "ConversionOptions",
    "ConversionRules",
    "ConvertToPostScript",
    "ConvertToPostScriptPacket",
    "ConvexHullMesh",
    "ConvexHullRegion",
    "ConvexOptimization",
    "ConvexPolygonQ",
    "ConvexPolyhedronQ",
    "ConvexRegionQ",
    "ConvolutionLayer",
    "Convolve",
    "ConwayGroupCo1",
    "ConwayGroupCo2",
    "ConwayGroupCo3",
    "CookieFunction",
    "Cookies",
    "CoordinateBoundingBox",
    "CoordinateBoundingBoxArray",
    "CoordinateBounds",
    "CoordinateBoundsArray",
    "CoordinateChartData",
    "CoordinatesToolOptions",
    "CoordinateTransform",
    "CoordinateTransformData",
    "CoplanarPoints",
    "CoprimeQ",
    "Coproduct",
    "CopulaDistribution",
    "Copyable",
    "CopyDatabin",
    "CopyDirectory",
    "CopyFile",
    "CopyFunction",
    "CopyTag",
    "CopyToClipboard",
    "CoreNilpotentDecomposition",
    "CornerFilter",
    "CornerNeighbors",
    "Correlation",
    "CorrelationDistance",
    "CorrelationFunction",
    "CorrelationTest",
    "Cos",
    "Cosh",
    "CoshIntegral",
    "CosineDistance",
    "CosineWindow",
    "CosIntegral",
    "Cot",
    "Coth",
    "CoulombF",
    "CoulombG",
    "CoulombH1",
    "CoulombH2",
    "Count",
    "CountDistinct",
    "CountDistinctBy",
    "CounterAssignments",
    "CounterBox",
    "CounterBoxOptions",
    "CounterClockwiseContourIntegral",
    "CounterEvaluator",
    "CounterFunction",
    "CounterIncrements",
    "CounterStyle",
    "CounterStyleMenuListing",
    "CountRoots",
    "CountryData",
    "Counts",
    "CountsBy",
    "Covariance",
    "CovarianceEstimatorFunction",
    "CovarianceFunction",
    "CoxianDistribution",
    "CoxIngersollRossProcess",
    "CoxModel",
    "CoxModelFit",
    "CramerVonMisesTest",
    "CreateArchive",
    "CreateCellID",
    "CreateChannel",
    "CreateCloudExpression",
    "CreateCompilerEnvironment",
    "CreateDatabin",
    "CreateDataStructure",
    "CreateDataSystemModel",
    "CreateDialog",
    "CreateDirectory",
    "CreateDocument",
    "CreateFile",
    "CreateIntermediateDirectories",
    "CreateLicenseEntitlement",
    "CreateManagedLibraryExpression",
    "CreateNotebook",
    "CreatePacletArchive",
    "CreatePalette",
    "CreatePermissionsGroup",
    "CreateScheduledTask",
    "CreateSearchIndex",
    "CreateSystemModel",
    "CreateTemporary",
    "CreateTypeInstance",
    "CreateUUID",
    "CreateWindow",
    "CriterionFunction",
    "CriticalityFailureImportance",
    "CriticalitySuccessImportance",
    "CriticalSection",
    "Cross",
    "CrossEntropyLossLayer",
    "CrossingCount",
    "CrossingDetect",
    "CrossingPolygon",
    "CrossMatrix",
    "Csc",
    "Csch",
    "CSGRegion",
    "CSGRegionQ",
    "CSGRegionTree",
    "CTCLossLayer",
    "Cube",
    "CubeRoot",
    "Cubics",
    "Cuboid",
    "CuboidBox",
    "CuboidBoxOptions",
    "Cumulant",
    "CumulantGeneratingFunction",
    "CumulativeFeatureImpactPlot",
    "Cup",
    "CupCap",
    "Curl",
    "CurlyDoubleQuote",
    "CurlyQuote",
    "CurrencyConvert",
    "CurrentDate",
    "CurrentImage",
    "CurrentNotebookImage",
    "CurrentScreenImage",
    "CurrentValue",
    "Curry",
    "CurryApplied",
    "CurvatureFlowFilter",
    "CurveClosed",
    "Cyan",
    "CycleGraph",
    "CycleIndexPolynomial",
    "Cycles",
    "CyclicGroup",
    "Cyclotomic",
    "Cylinder",
    "CylinderBox",
    "CylinderBoxOptions",
    "CylindricalDecomposition",
    "CylindricalDecompositionFunction",
    "D",
    "DagumDistribution",
    "DamData",
    "DamerauLevenshteinDistance",
    "DampingFactor",
    "Darker",
    "Dashed",
    "Dashing",
    "DatabaseConnect",
    "DatabaseDisconnect",
    "DatabaseReference",
    "Databin",
    "DatabinAdd",
    "DatabinRemove",
    "Databins",
    "DatabinSubmit",
    "DatabinUpload",
    "DataCompression",
    "DataDistribution",
    "DataRange",
    "DataReversed",
    "Dataset",
    "DatasetDisplayPanel",
    "DatasetTheme",
    "DataStructure",
    "DataStructureQ",
    "Date",
    "DateBounds",
    "Dated",
    "DateDelimiters",
    "DateDifference",
    "DatedUnit",
    "DateFormat",
    "DateFunction",
    "DateGranularity",
    "DateHistogram",
    "DateInterval",
    "DateList",
    "DateListLogPlot",
    "DateListPlot",
    "DateListStepPlot",
    "DateObject",
    "DateObjectQ",
    "DateOverlapsQ",
    "DatePattern",
    "DatePlus",
    "DateRange",
    "DateReduction",
    "DateScale",
    "DateSelect",
    "DateString",
    "DateTicksFormat",
    "DateValue",
    "DateWithinQ",
    "DaubechiesWavelet",
    "DavisDistribution",
    "DawsonF",
    "DayCount",
    "DayCountConvention",
    "DayHemisphere",
    "DaylightQ",
    "DayMatchQ",
    "DayName",
    "DayNightTerminator",
    "DayPlus",
    "DayRange",
    "DayRound",
    "DeBruijnGraph",
    "DeBruijnSequence",
    "Debug",
    "DebugTag",
    "Decapitalize",
    "Decimal",
    "DecimalForm",
    "DeclareCompiledComponent",
    "DeclareKnownSymbols",
    "DeclarePackage",
    "Decompose",
    "DeconvolutionLayer",
    "Decrement",
    "Decrypt",
    "DecryptFile",
    "DedekindEta",
    "DeepSpaceProbeData",
    "Default",
    "Default2DTool",
    "Default3DTool",
    "DefaultAttachedCellStyle",
    "DefaultAxesStyle",
    "DefaultBaseStyle",
    "DefaultBoxStyle",
    "DefaultButton",
    "DefaultColor",
    "DefaultControlPlacement",
    "DefaultDockedCellStyle",
    "DefaultDuplicateCellStyle",
    "DefaultDuration",
    "DefaultElement",
    "DefaultFaceGridsStyle",
    "DefaultFieldHintStyle",
    "DefaultFont",
    "DefaultFontProperties",
    "DefaultFormatType",
    "DefaultFrameStyle",
    "DefaultFrameTicksStyle",
    "DefaultGridLinesStyle",
    "DefaultInlineFormatType",
    "DefaultInputFormatType",
    "DefaultLabelStyle",
    "DefaultMenuStyle",
    "DefaultNaturalLanguage",
    "DefaultNewCellStyle",
    "DefaultNewInlineCellStyle",
    "DefaultNotebook",
    "DefaultOptions",
    "DefaultOutputFormatType",
    "DefaultPrintPrecision",
    "DefaultStyle",
    "DefaultStyleDefinitions",
    "DefaultTextFormatType",
    "DefaultTextInlineFormatType",
    "DefaultTicksStyle",
    "DefaultTooltipStyle",
    "DefaultValue",
    "DefaultValues",
    "Defer",
    "DefineExternal",
    "DefineInputStreamMethod",
    "DefineOutputStreamMethod",
    "DefineResourceFunction",
    "Definition",
    "Degree",
    "DegreeCentrality",
    "DegreeGraphDistribution",
    "DegreeLexicographic",
    "DegreeReverseLexicographic",
    "DEigensystem",
    "DEigenvalues",
    "Deinitialization",
    "Del",
    "DelaunayMesh",
    "Delayed",
    "Deletable",
    "Delete",
    "DeleteAdjacentDuplicates",
    "DeleteAnomalies",
    "DeleteBorderComponents",
    "DeleteCases",
    "DeleteChannel",
    "DeleteCloudExpression",
    "DeleteContents",
    "DeleteDirectory",
    "DeleteDuplicates",
    "DeleteDuplicatesBy",
    "DeleteElements",
    "DeleteFile",
    "DeleteMissing",
    "DeleteObject",
    "DeletePermissionsKey",
    "DeleteSearchIndex",
    "DeleteSmallComponents",
    "DeleteStopwords",
    "DeleteWithContents",
    "DeletionWarning",
    "DelimitedArray",
    "DelimitedSequence",
    "Delimiter",
    "DelimiterAutoMatching",
    "DelimiterFlashTime",
    "DelimiterMatching",
    "Delimiters",
    "DeliveryFunction",
    "Dendrogram",
    "Denominator",
    "DensityGraphics",
    "DensityHistogram",
    "DensityPlot",
    "DensityPlot3D",
    "DependentVariables",
    "Deploy",
    "Deployed",
    "Depth",
    "DepthFirstScan",
    "Derivative",
    "DerivativeFilter",
    "DerivativePDETerm",
    "DerivedKey",
    "DescriptorStateSpace",
    "DesignMatrix",
    "DestroyAfterEvaluation",
    "Det",
    "DeviceClose",
    "DeviceConfigure",
    "DeviceExecute",
    "DeviceExecuteAsynchronous",
    "DeviceObject",
    "DeviceOpen",
    "DeviceOpenQ",
    "DeviceRead",
    "DeviceReadBuffer",
    "DeviceReadLatest",
    "DeviceReadList",
    "DeviceReadTimeSeries",
    "Devices",
    "DeviceStreams",
    "DeviceWrite",
    "DeviceWriteBuffer",
    "DGaussianWavelet",
    "DiacriticalPositioning",
    "Diagonal",
    "DiagonalizableMatrixQ",
    "DiagonalMatrix",
    "DiagonalMatrixQ",
    "Dialog",
    "DialogIndent",
    "DialogInput",
    "DialogLevel",
    "DialogNotebook",
    "DialogProlog",
    "DialogReturn",
    "DialogSymbols",
    "Diamond",
    "DiamondMatrix",
    "DiceDissimilarity",
    "DictionaryLookup",
    "DictionaryWordQ",
    "DifferenceDelta",
    "DifferenceOrder",
    "DifferenceQuotient",
    "DifferenceRoot",
    "DifferenceRootReduce",
    "Differences",
    "DifferentialD",
    "DifferentialRoot",
    "DifferentialRootReduce",
    "DifferentiatorFilter",
    "DiffusionPDETerm",
    "DiggleGatesPointProcess",
    "DiggleGrattonPointProcess",
    "DigitalSignature",
    "DigitBlock",
    "DigitBlockMinimum",
    "DigitCharacter",
    "DigitCount",
    "DigitQ",
    "DihedralAngle",
    "DihedralGroup",
    "Dilation",
    "DimensionalCombinations",
    "DimensionalMeshComponents",
    "DimensionReduce",
    "DimensionReducerFunction",
    "DimensionReduction",
    "Dimensions",
    "DiracComb",
    "DiracDelta",
    "DirectedEdge",
    "DirectedEdges",
    "DirectedGraph",
    "DirectedGraphQ",
    "DirectedInfinity",
    "Direction",
    "DirectionalLight",
    "Directive",
    "Directory",
    "DirectoryName",
    "DirectoryQ",
    "DirectoryStack",
    "DirichletBeta",
    "DirichletCharacter",
    "DirichletCondition",
    "DirichletConvolve",
    "DirichletDistribution",
    "DirichletEta",
    "DirichletL",
    "DirichletLambda",
    "DirichletTransform",
    "DirichletWindow",
    "DisableConsolePrintPacket",
    "DisableFormatting",
    "DiscreteAsymptotic",
    "DiscreteChirpZTransform",
    "DiscreteConvolve",
    "DiscreteDelta",
    "DiscreteHadamardTransform",
    "DiscreteIndicator",
    "DiscreteInputOutputModel",
    "DiscreteLimit",
    "DiscreteLQEstimatorGains",
    "DiscreteLQRegulatorGains",
    "DiscreteLyapunovSolve",
    "DiscreteMarkovProcess",
    "DiscreteMaxLimit",
    "DiscreteMinLimit",
    "DiscretePlot",
    "DiscretePlot3D",
    "DiscreteRatio",
    "DiscreteRiccatiSolve",
    "DiscreteShift",
    "DiscreteTimeModelQ",
    "DiscreteUniformDistribution",
    "DiscreteVariables",
    "DiscreteWaveletData",
    "DiscreteWaveletPacketTransform",
    "DiscreteWaveletTransform",
    "DiscretizeGraphics",
    "DiscretizeRegion",
    "Discriminant",
    "DisjointQ",
    "Disjunction",
    "Disk",
    "DiskBox",
    "DiskBoxOptions",
    "DiskMatrix",
    "DiskSegment",
    "Dispatch",
    "DispatchQ",
    "DispersionEstimatorFunction",
    "Display",
    "DisplayAllSteps",
    "DisplayEndPacket",
    "DisplayForm",
    "DisplayFunction",
    "DisplayPacket",
    "DisplayRules",
    "DisplayString",
    "DisplayTemporary",
    "DisplayWith",
    "DisplayWithRef",
    "DisplayWithVariable",
    "DistanceFunction",
    "DistanceMatrix",
    "DistanceTransform",
    "Distribute",
    "Distributed",
    "DistributedContexts",
    "DistributeDefinitions",
    "DistributionChart",
    "DistributionDomain",
    "DistributionFitTest",
    "DistributionParameterAssumptions",
    "DistributionParameterQ",
    "Dithering",
    "Div",
    "Divergence",
    "Divide",
    "DivideBy",
    "Dividers",
    "DivideSides",
    "Divisible",
    "Divisors",
    "DivisorSigma",
    "DivisorSum",
    "DMSList",
    "DMSString",
    "Do",
    "DockedCell",
    "DockedCells",
    "DocumentGenerator",
    "DocumentGeneratorInformation",
    "DocumentGeneratorInformationData",
    "DocumentGenerators",
    "DocumentNotebook",
    "DocumentWeightingRules",
    "Dodecahedron",
    "DomainRegistrationInformation",
    "DominantColors",
    "DominatorTreeGraph",
    "DominatorVertexList",
    "DOSTextFormat",
    "Dot",
    "DotDashed",
    "DotEqual",
    "DotLayer",
    "DotPlusLayer",
    "Dotted",
    "DoubleBracketingBar",
    "DoubleContourIntegral",
    "DoubleDownArrow",
    "DoubleLeftArrow",
    "DoubleLeftRightArrow",
    "DoubleLeftTee",
    "DoubleLongLeftArrow",
    "DoubleLongLeftRightArrow",
    "DoubleLongRightArrow",
    "DoubleRightArrow",
    "DoubleRightTee",
    "DoubleUpArrow",
    "DoubleUpDownArrow",
    "DoubleVerticalBar",
    "DoublyInfinite",
    "Down",
    "DownArrow",
    "DownArrowBar",
    "DownArrowUpArrow",
    "DownLeftRightVector",
    "DownLeftTeeVector",
    "DownLeftVector",
    "DownLeftVectorBar",
    "DownRightTeeVector",
    "DownRightVector",
    "DownRightVectorBar",
    "Downsample",
    "DownTee",
    "DownTeeArrow",
    "DownValues",
    "DownValuesFunction",
    "DragAndDrop",
    "DrawBackFaces",
    "DrawEdges",
    "DrawFrontFaces",
    "DrawHighlighted",
    "DrazinInverse",
    "Drop",
    "DropoutLayer",
    "DropShadowing",
    "DSolve",
    "DSolveChangeVariables",
    "DSolveValue",
    "Dt",
    "DualLinearProgramming",
    "DualPlanarGraph",
    "DualPolyhedron",
    "DualSystemsModel",
    "DumpGet",
    "DumpSave",
    "DuplicateFreeQ",
    "Duration",
    "Dynamic",
    "DynamicBox",
    "DynamicBoxOptions",
    "DynamicEvaluationTimeout",
    "DynamicGeoGraphics",
    "DynamicImage",
    "DynamicLocation",
    "DynamicModule",
    "DynamicModuleBox",
    "DynamicModuleBoxOptions",
    "DynamicModuleParent",
    "DynamicModuleValues",
    "DynamicName",
    "DynamicNamespace",
    "DynamicReference",
    "DynamicSetting",
    "DynamicUpdating",
    "DynamicWrapper",
    "DynamicWrapperBox",
    "DynamicWrapperBoxOptions",
    "E",
    "EarthImpactData",
    "EarthquakeData",
    "EccentricityCentrality",
    "Echo",
    "EchoEvaluation",
    "EchoFunction",
    "EchoLabel",
    "EchoTiming",
    "EclipseType",
    "EdgeAdd",
    "EdgeBetweennessCentrality",
    "EdgeCapacity",
    "EdgeCapForm",
    "EdgeChromaticNumber",
    "EdgeColor",
    "EdgeConnectivity",
    "EdgeContract",
    "EdgeCost",
    "EdgeCount",
    "EdgeCoverQ",
    "EdgeCycleMatrix",
    "EdgeDashing",
    "EdgeDelete",
    "EdgeDetect",
    "EdgeForm",
    "EdgeIndex",
    "EdgeJoinForm",
    "EdgeLabeling",
    "EdgeLabels",
    "EdgeLabelStyle",
    "EdgeList",
    "EdgeOpacity",
    "EdgeQ",
    "EdgeRenderingFunction",
    "EdgeRules",
    "EdgeShapeFunction",
    "EdgeStyle",
    "EdgeTaggedGraph",
    "EdgeTaggedGraphQ",
    "EdgeTags",
    "EdgeThickness",
    "EdgeTransitiveGraphQ",
    "EdgeValueRange",
    "EdgeValueSizes",
    "EdgeWeight",
    "EdgeWeightedGraphQ",
    "Editable",
    "EditButtonSettings",
    "EditCellTagsSettings",
    "EditDistance",
    "EffectiveInterest",
    "Eigensystem",
    "Eigenvalues",
    "EigenvectorCentrality",
    "Eigenvectors",
    "Element",
    "ElementData",
    "ElementwiseLayer",
    "ElidedForms",
    "Eliminate",
    "EliminationOrder",
    "Ellipsoid",
    "EllipticE",
    "EllipticExp",
    "EllipticExpPrime",
    "EllipticF",
    "EllipticFilterModel",
    "EllipticK",
    "EllipticLog",
    "EllipticNomeQ",
    "EllipticPi",
    "EllipticReducedHalfPeriods",
    "EllipticTheta",
    "EllipticThetaPrime",
    "EmbedCode",
    "EmbeddedHTML",
    "EmbeddedService",
    "EmbeddedSQLEntityClass",
    "EmbeddedSQLExpression",
    "EmbeddingLayer",
    "EmbeddingObject",
    "EmitSound",
    "EmphasizeSyntaxErrors",
    "EmpiricalDistribution",
    "Empty",
    "EmptyGraphQ",
    "EmptyRegion",
    "EmptySpaceF",
    "EnableConsolePrintPacket",
    "Enabled",
    "Enclose",
    "Encode",
    "Encrypt",
    "EncryptedObject",
    "EncryptFile",
    "End",
    "EndAdd",
    "EndDialogPacket",
    "EndOfBuffer",
    "EndOfFile",
    "EndOfLine",
    "EndOfString",
    "EndPackage",
    "EngineEnvironment",
    "EngineeringForm",
    "Enter",
    "EnterExpressionPacket",
    "EnterTextPacket",
    "Entity",
    "EntityClass",
    "EntityClassList",
    "EntityCopies",
    "EntityFunction",
    "EntityGroup",
    "EntityInstance",
    "EntityList",
    "EntityPrefetch",
    "EntityProperties",
    "EntityProperty",
    "EntityPropertyClass",
    "EntityRegister",
    "EntityStore",
    "EntityStores",
    "EntityTypeName",
    "EntityUnregister",
    "EntityValue",
    "Entropy",
    "EntropyFilter",
    "Environment",
    "Epilog",
    "EpilogFunction",
    "Equal",
    "EqualColumns",
    "EqualRows",
    "EqualTilde",
    "EqualTo",
    "EquatedTo",
    "Equilibrium",
    "EquirippleFilterKernel",
    "Equivalent",
    "Erf",
    "Erfc",
    "Erfi",
    "ErlangB",
    "ErlangC",
    "ErlangDistribution",
    "Erosion",
    "ErrorBox",
    "ErrorBoxOptions",
    "ErrorNorm",
    "ErrorPacket",
    "ErrorsDialogSettings",
    "EscapeRadius",
    "EstimatedBackground",
    "EstimatedDistribution",
    "EstimatedPointNormals",
    "EstimatedPointProcess",
    "EstimatedProcess",
    "EstimatedVariogramModel",
    "EstimatorGains",
    "EstimatorRegulator",
    "EuclideanDistance",
    "EulerAngles",
    "EulerCharacteristic",
    "EulerE",
    "EulerGamma",
    "EulerianGraphQ",
    "EulerMatrix",
    "EulerPhi",
    "Evaluatable",
    "Evaluate",
    "Evaluated",
    "EvaluatePacket",
    "EvaluateScheduledTask",
    "EvaluationBox",
    "EvaluationCell",
    "EvaluationCompletionAction",
    "EvaluationData",
    "EvaluationElements",
    "EvaluationEnvironment",
    "EvaluationMode",
    "EvaluationMonitor",
    "EvaluationNotebook",
    "EvaluationObject",
    "EvaluationOrder",
    "EvaluationPrivileges",
    "EvaluationRateLimit",
    "Evaluator",
    "EvaluatorNames",
    "EvenQ",
    "EventData",
    "EventEvaluator",
    "EventHandler",
    "EventHandlerTag",
    "EventLabels",
    "EventSeries",
    "ExactBlackmanWindow",
    "ExactNumberQ",
    "ExactRootIsolation",
    "ExampleData",
    "Except",
    "ExcludedContexts",
    "ExcludedForms",
    "ExcludedLines",
    "ExcludedPhysicalQuantities",
    "ExcludePods",
    "Exclusions",
    "ExclusionsStyle",
    "Exists",
    "Exit",
    "ExitDialog",
    "ExoplanetData",
    "Exp",
    "Expand",
    "ExpandAll",
    "ExpandDenominator",
    "ExpandFileName",
    "ExpandNumerator",
    "Expectation",
    "ExpectationE",
    "ExpectedValue",
    "ExpGammaDistribution",
    "ExpIntegralE",
    "ExpIntegralEi",
    "ExpirationDate",
    "Exponent",
    "ExponentFunction",
    "ExponentialDistribution",
    "ExponentialFamily",
    "ExponentialGeneratingFunction",
    "ExponentialMovingAverage",
    "ExponentialPowerDistribution",
    "ExponentPosition",
    "ExponentStep",
    "Export",
    "ExportAutoReplacements",
    "ExportByteArray",
    "ExportForm",
    "ExportPacket",
    "ExportString",
    "Expression",
    "ExpressionCell",
    "ExpressionGraph",
    "ExpressionPacket",
    "ExpressionTree",
    "ExpressionUUID",
    "ExpToTrig",
    "ExtendedEntityClass",
    "ExtendedGCD",
    "Extension",
    "ExtentElementFunction",
    "ExtentMarkers",
    "ExtentSize",
    "ExternalBundle",
    "ExternalCall",
    "ExternalDataCharacterEncoding",
    "ExternalEvaluate",
    "ExternalFunction",
    "ExternalFunctionName",
    "ExternalIdentifier",
    "ExternalObject",
    "ExternalOptions",
    "ExternalSessionObject",
    "ExternalSessions",
    "ExternalStorageBase",
    "ExternalStorageDownload",
    "ExternalStorageGet",
    "ExternalStorageObject",
    "ExternalStoragePut",
    "ExternalStorageUpload",
    "ExternalTypeSignature",
    "ExternalValue",
    "Extract",
    "ExtractArchive",
    "ExtractLayer",
    "ExtractPacletArchive",
    "ExtremeValueDistribution",
    "FaceAlign",
    "FaceForm",
    "FaceGrids",
    "FaceGridsStyle",
    "FaceRecognize",
    "FacialFeatures",
    "Factor",
    "FactorComplete",
    "Factorial",
    "Factorial2",
    "FactorialMoment",
    "FactorialMomentGeneratingFunction",
    "FactorialPower",
    "FactorInteger",
    "FactorList",
    "FactorSquareFree",
    "FactorSquareFreeList",
    "FactorTerms",
    "FactorTermsList",
    "Fail",
    "Failure",
    "FailureAction",
    "FailureDistribution",
    "FailureQ",
    "False",
    "FareySequence",
    "FARIMAProcess",
    "FeatureDistance",
    "FeatureExtract",
    "FeatureExtraction",
    "FeatureExtractor",
    "FeatureExtractorFunction",
    "FeatureImpactPlot",
    "FeatureNames",
    "FeatureNearest",
    "FeatureSpacePlot",
    "FeatureSpacePlot3D",
    "FeatureTypes",
    "FeatureValueDependencyPlot",
    "FeatureValueImpactPlot",
    "FEDisableConsolePrintPacket",
    "FeedbackLinearize",
    "FeedbackSector",
    "FeedbackSectorStyle",
    "FeedbackType",
    "FEEnableConsolePrintPacket",
    "FetalGrowthData",
    "Fibonacci",
    "Fibonorial",
    "FieldCompletionFunction",
    "FieldHint",
    "FieldHintStyle",
    "FieldMasked",
    "FieldSize",
    "File",
    "FileBaseName",
    "FileByteCount",
    "FileConvert",
    "FileDate",
    "FileExistsQ",
    "FileExtension",
    "FileFormat",
    "FileFormatProperties",
    "FileFormatQ",
    "FileHandler",
    "FileHash",
    "FileInformation",
    "FileName",
    "FileNameDepth",
    "FileNameDialogSettings",
    "FileNameDrop",
    "FileNameForms",
    "FileNameJoin",
    "FileNames",
    "FileNameSetter",
    "FileNameSplit",
    "FileNameTake",
    "FileNameToFormatList",
    "FilePrint",
    "FileSize",
    "FileSystemMap",
    "FileSystemScan",
    "FileSystemTree",
    "FileTemplate",
    "FileTemplateApply",
    "FileType",
    "FilledCurve",
    "FilledCurveBox",
    "FilledCurveBoxOptions",
    "FilledTorus",
    "FillForm",
    "Filling",
    "FillingStyle",
    "FillingTransform",
    "FilteredEntityClass",
    "FilterRules",
    "FinancialBond",
    "FinancialData",
    "FinancialDerivative",
    "FinancialIndicator",
    "Find",
    "FindAnomalies",
    "FindArgMax",
    "FindArgMin",
    "FindChannels",
    "FindClique",
    "FindClusters",
    "FindCookies",
    "FindCurvePath",
    "FindCycle",
    "FindDevices",
    "FindDistribution",
    "FindDistributionParameters",
    "FindDivisions",
    "FindEdgeColoring",
    "FindEdgeCover",
    "FindEdgeCut",
    "FindEdgeIndependentPaths",
    "FindEquationalProof",
    "FindEulerianCycle",
    "FindExternalEvaluators",
    "FindFaces",
    "FindFile",
    "FindFit",
    "FindFormula",
    "FindFundamentalCycles",
    "FindGeneratingFunction",
    "FindGeoLocation",
    "FindGeometricConjectures",
    "FindGeometricTransform",
    "FindGraphCommunities",
    "FindGraphIsomorphism",
    "FindGraphPartition",
    "FindHamiltonianCycle",
    "FindHamiltonianPath",
    "FindHiddenMarkovStates",
    "FindImageText",
    "FindIndependentEdgeSet",
    "FindIndependentVertexSet",
    "FindInstance",
    "FindIntegerNullVector",
    "FindIsomers",
    "FindIsomorphicSubgraph",
    "FindKClan",
    "FindKClique",
    "FindKClub",
    "FindKPlex",
    "FindLibrary",
    "FindLinearRecurrence",
    "FindList",
    "FindMatchingColor",
    "FindMaximum",
    "FindMaximumCut",
    "FindMaximumFlow",
    "FindMaxValue",
    "FindMeshDefects",
    "FindMinimum",
    "FindMinimumCostFlow",
    "FindMinimumCut",
    "FindMinValue",
    "FindMoleculeSubstructure",
    "FindPath",
    "FindPeaks",
    "FindPermutation",
    "FindPlanarColoring",
    "FindPointProcessParameters",
    "FindPostmanTour",
    "FindProcessParameters",
    "FindRegionTransform",
    "FindRepeat",
    "FindRoot",
    "FindSequenceFunction",
    "FindSettings",
    "FindShortestPath",
    "FindShortestTour",
    "FindSpanningTree",
    "FindSubgraphIsomorphism",
    "FindSystemModelEquilibrium",
    "FindTextualAnswer",
    "FindThreshold",
    "FindTransientRepeat",
    "FindVertexColoring",
    "FindVertexCover",
    "FindVertexCut",
    "FindVertexIndependentPaths",
    "Fine",
    "FinishDynamic",
    "FiniteAbelianGroupCount",
    "FiniteGroupCount",
    "FiniteGroupData",
    "First",
    "FirstCase",
    "FirstPassageTimeDistribution",
    "FirstPosition",
    "FischerGroupFi22",
    "FischerGroupFi23",
    "FischerGroupFi24Prime",
    "FisherHypergeometricDistribution",
    "FisherRatioTest",
    "FisherZDistribution",
    "Fit",
    "FitAll",
    "FitRegularization",
    "FittedModel",
    "FixedOrder",
    "FixedPoint",
    "FixedPointList",
    "FlashSelection",
    "Flat",
    "FlatShading",
    "Flatten",
    "FlattenAt",
    "FlattenLayer",
    "FlatTopWindow",
    "FlightData",
    "FlipView",
    "Floor",
    "FlowPolynomial",
    "Fold",
    "FoldList",
    "FoldPair",
    "FoldPairList",
    "FoldWhile",
    "FoldWhileList",
    "FollowRedirects",
    "Font",
    "FontColor",
    "FontFamily",
    "FontForm",
    "FontName",
    "FontOpacity",
    "FontPostScriptName",
    "FontProperties",
    "FontReencoding",
    "FontSize",
    "FontSlant",
    "FontSubstitutions",
    "FontTracking",
    "FontVariations",
    "FontWeight",
    "For",
    "ForAll",
    "ForAllType",
    "ForceVersionInstall",
    "Format",
    "FormatRules",
    "FormatType",
    "FormatTypeAutoConvert",
    "FormatValues",
    "FormBox",
    "FormBoxOptions",
    "FormControl",
    "FormFunction",
    "FormLayoutFunction",
    "FormObject",
    "FormPage",
    "FormProtectionMethod",
    "FormTheme",
    "FormulaData",
    "FormulaLookup",
    "FortranForm",
    "Forward",
    "ForwardBackward",
    "ForwardCloudCredentials",
    "Fourier",
    "FourierCoefficient",
    "FourierCosCoefficient",
    "FourierCosSeries",
    "FourierCosTransform",
    "FourierDCT",
    "FourierDCTFilter",
    "FourierDCTMatrix",
    "FourierDST",
    "FourierDSTMatrix",
    "FourierMatrix",
    "FourierParameters",
    "FourierSequenceTransform",
    "FourierSeries",
    "FourierSinCoefficient",
    "FourierSinSeries",
    "FourierSinTransform",
    "FourierTransform",
    "FourierTrigSeries",
    "FoxH",
    "FoxHReduce",
    "FractionalBrownianMotionProcess",
    "FractionalD",
    "FractionalGaussianNoiseProcess",
    "FractionalPart",
    "FractionBox",
    "FractionBoxOptions",
    "FractionLine",
    "Frame",
    "FrameBox",
    "FrameBoxOptions",
    "Framed",
    "FrameInset",
    "FrameLabel",
    "Frameless",
    "FrameListVideo",
    "FrameMargins",
    "FrameRate",
    "FrameStyle",
    "FrameTicks",
    "FrameTicksStyle",
    "FRatioDistribution",
    "FrechetDistribution",
    "FreeQ",
    "FrenetSerretSystem",
    "FrequencySamplingFilterKernel",
    "FresnelC",
    "FresnelF",
    "FresnelG",
    "FresnelS",
    "Friday",
    "FrobeniusNumber",
    "FrobeniusSolve",
    "FromAbsoluteTime",
    "FromCharacterCode",
    "FromCoefficientRules",
    "FromContinuedFraction",
    "FromDate",
    "FromDateString",
    "FromDigits",
    "FromDMS",
    "FromEntity",
    "FromJulianDate",
    "FromLetterNumber",
    "FromPolarCoordinates",
    "FromRawPointer",
    "FromRomanNumeral",
    "FromSphericalCoordinates",
    "FromUnixTime",
    "Front",
    "FrontEndDynamicExpression",
    "FrontEndEventActions",
    "FrontEndExecute",
    "FrontEndObject",
    "FrontEndResource",
    "FrontEndResourceString",
    "FrontEndStackSize",
    "FrontEndToken",
    "FrontEndTokenExecute",
    "FrontEndValueCache",
    "FrontEndVersion",
    "FrontFaceColor",
    "FrontFaceGlowColor",
    "FrontFaceOpacity",
    "FrontFaceSpecularColor",
    "FrontFaceSpecularExponent",
    "FrontFaceSurfaceAppearance",
    "FrontFaceTexture",
    "Full",
    "FullAxes",
    "FullDefinition",
    "FullForm",
    "FullGraphics",
    "FullInformationOutputRegulator",
    "FullOptions",
    "FullRegion",
    "FullSimplify",
    "Function",
    "FunctionAnalytic",
    "FunctionBijective",
    "FunctionCompile",
    "FunctionCompileExport",
    "FunctionCompileExportByteArray",
    "FunctionCompileExportLibrary",
    "FunctionCompileExportString",
    "FunctionContinuous",
    "FunctionConvexity",
    "FunctionDeclaration",
    "FunctionDiscontinuities",
    "FunctionDomain",
    "FunctionExpand",
    "FunctionInjective",
    "FunctionInterpolation",
    "FunctionLayer",
    "FunctionMeromorphic",
    "FunctionMonotonicity",
    "FunctionPeriod",
    "FunctionPoles",
    "FunctionRange",
    "FunctionSign",
    "FunctionSingularities",
    "FunctionSpace",
    "FunctionSurjective",
    "FussellVeselyImportance",
    "GaborFilter",
    "GaborMatrix",
    "GaborWavelet",
    "GainMargins",
    "GainPhaseMargins",
    "GalaxyData",
    "GalleryView",
    "Gamma",
    "GammaDistribution",
    "GammaRegularized",
    "GapPenalty",
    "GARCHProcess",
    "GatedRecurrentLayer",
    "Gather",
    "GatherBy",
    "GaugeFaceElementFunction",
    "GaugeFaceStyle",
    "GaugeFrameElementFunction",
    "GaugeFrameSize",
    "GaugeFrameStyle",
    "GaugeLabels",
    "GaugeMarkers",
    "GaugeStyle",
    "GaussianFilter",
    "GaussianIntegers",
    "GaussianMatrix",
    "GaussianOrthogonalMatrixDistribution",
    "GaussianSymplecticMatrixDistribution",
    "GaussianUnitaryMatrixDistribution",
    "GaussianWindow",
    "GCD",
    "GegenbauerC",
    "General",
    "GeneralizedLinearModelFit",
    "GenerateAsymmetricKeyPair",
    "GenerateConditions",
    "GeneratedAssetFormat",
    "GeneratedAssetLocation",
    "GeneratedCell",
    "GeneratedCellStyles",
    "GeneratedDocumentBinding",
    "GenerateDerivedKey",
    "GenerateDigitalSignature",
    "GenerateDocument",
    "GeneratedParameters",
    "GeneratedQuantityMagnitudes",
    "GenerateFileSignature",
    "GenerateHTTPResponse",
    "GenerateSecuredAuthenticationKey",
    "GenerateSymmetricKey",
    "GeneratingFunction",
    "GeneratorDescription",
    "GeneratorHistoryLength",
    "GeneratorOutputType",
    "Generic",
    "GenericCylindricalDecomposition",
    "GenomeData",
    "GenomeLookup",
    "GeoAntipode",
    "GeoArea",
    "GeoArraySize",
    "GeoBackground",
    "GeoBoundary",
    "GeoBoundingBox",
    "GeoBounds",
    "GeoBoundsRegion",
    "GeoBoundsRegionBoundary",
    "GeoBubbleChart",
    "GeoCenter",
    "GeoCircle",
    "GeoContourPlot",
    "GeoDensityPlot",
    "GeodesicClosing",
    "GeodesicDilation",
    "GeodesicErosion",
    "GeodesicOpening",
    "GeodesicPolyhedron",
    "GeoDestination",
    "GeodesyData",
    "GeoDirection",
    "GeoDisk",
    "GeoDisplacement",
    "GeoDistance",
    "GeoDistanceList",
    "GeoElevationData",
    "GeoEntities",
    "GeoGraphics",
    "GeoGraphPlot",
    "GeoGraphValuePlot",
    "GeogravityModelData",
    "GeoGridDirectionDifference",
    "GeoGridLines",
    "GeoGridLinesStyle",
    "GeoGridPosition",
    "GeoGridRange",
    "GeoGridRangePadding",
    "GeoGridUnitArea",
    "GeoGridUnitDistance",
    "GeoGridVector",
    "GeoGroup",
    "GeoHemisphere",
    "GeoHemisphereBoundary",
    "GeoHistogram",
    "GeoIdentify",
    "GeoImage",
    "GeoLabels",
    "GeoLength",
    "GeoListPlot",
    "GeoLocation",
    "GeologicalPeriodData",
    "GeomagneticModelData",
    "GeoMarker",
    "GeometricAssertion",
    "GeometricBrownianMotionProcess",
    "GeometricDistribution",
    "GeometricMean",
    "GeometricMeanFilter",
    "GeometricOptimization",
    "GeometricScene",
    "GeometricStep",
    "GeometricStylingRules",
    "GeometricTest",
    "GeometricTransformation",
    "GeometricTransformation3DBox",
    "GeometricTransformation3DBoxOptions",
    "GeometricTransformationBox",
    "GeometricTransformationBoxOptions",
    "GeoModel",
    "GeoNearest",
    "GeoOrientationData",
    "GeoPath",
    "GeoPolygon",
    "GeoPosition",
    "GeoPositionENU",
    "GeoPositionXYZ",
    "GeoProjection",
    "GeoProjectionData",
    "GeoRange",
    "GeoRangePadding",
    "GeoRegionValuePlot",
    "GeoResolution",
    "GeoScaleBar",
    "GeoServer",
    "GeoSmoothHistogram",
    "GeoStreamPlot",
    "GeoStyling",
    "GeoStylingImageFunction",
    "GeoVariant",
    "GeoVector",
    "GeoVectorENU",
    "GeoVectorPlot",
    "GeoVectorXYZ",
    "GeoVisibleRegion",
    "GeoVisibleRegionBoundary",
    "GeoWithinQ",
    "GeoZoomLevel",
    "GestureHandler",
    "GestureHandlerTag",
    "Get",
    "GetContext",
    "GetEnvironment",
    "GetFileName",
    "GetLinebreakInformationPacket",
    "GibbsPointProcess",
    "Glaisher",
    "GlobalClusteringCoefficient",
    "GlobalPreferences",
    "GlobalSession",
    "Glow",
    "GoldenAngle",
    "GoldenRatio",
    "GompertzMakehamDistribution",
    "GoochShading",
    "GoodmanKruskalGamma",
    "GoodmanKruskalGammaTest",
    "Goto",
    "GouraudShading",
    "Grad",
    "Gradient",
    "GradientFilter",
    "GradientFittedMesh",
    "GradientOrientationFilter",
    "GrammarApply",
    "GrammarRules",
    "GrammarToken",
    "Graph",
    "Graph3D",
    "GraphAssortativity",
    "GraphAutomorphismGroup",
    "GraphCenter",
    "GraphComplement",
    "GraphData",
    "GraphDensity",
    "GraphDiameter",
    "GraphDifference",
    "GraphDisjointUnion",
    "GraphDistance",
    "GraphDistanceMatrix",
    "GraphEmbedding",
    "GraphHighlight",
    "GraphHighlightStyle",
    "GraphHub",
    "Graphics",
    "Graphics3D",
    "Graphics3DBox",
    "Graphics3DBoxOptions",
    "GraphicsArray",
    "GraphicsBaseline",
    "GraphicsBox",
    "GraphicsBoxOptions",
    "GraphicsColor",
    "GraphicsColumn",
    "GraphicsComplex",
    "GraphicsComplex3DBox",
    "GraphicsComplex3DBoxOptions",
    "GraphicsComplexBox",
    "GraphicsComplexBoxOptions",
    "GraphicsContents",
    "GraphicsData",
    "GraphicsGrid",
    "GraphicsGridBox",
    "GraphicsGroup",
    "GraphicsGroup3DBox",
    "GraphicsGroup3DBoxOptions",
    "GraphicsGroupBox",
    "GraphicsGroupBoxOptions",
    "GraphicsGrouping",
    "GraphicsHighlightColor",
    "GraphicsRow",
    "GraphicsSpacing",
    "GraphicsStyle",
    "GraphIntersection",
    "GraphJoin",
    "GraphLayerLabels",
    "GraphLayers",
    "GraphLayerStyle",
    "GraphLayout",
    "GraphLinkEfficiency",
    "GraphPeriphery",
    "GraphPlot",
    "GraphPlot3D",
    "GraphPower",
    "GraphProduct",
    "GraphPropertyDistribution",
    "GraphQ",
    "GraphRadius",
    "GraphReciprocity",
    "GraphRoot",
    "GraphStyle",
    "GraphSum",
    "GraphTree",
    "GraphUnion",
    "Gray",
    "GrayLevel",
    "Greater",
    "GreaterEqual",
    "GreaterEqualLess",
    "GreaterEqualThan",
    "GreaterFullEqual",
    "GreaterGreater",
    "GreaterLess",
    "GreaterSlantEqual",
    "GreaterThan",
    "GreaterTilde",
    "GreekStyle",
    "Green",
    "GreenFunction",
    "Grid",
    "GridBaseline",
    "GridBox",
    "GridBoxAlignment",
    "GridBoxBackground",
    "GridBoxDividers",
    "GridBoxFrame",
    "GridBoxItemSize",
    "GridBoxItemStyle",
    "GridBoxOptions",
    "GridBoxSpacings",
    "GridCreationSettings",
    "GridDefaultElement",
    "GridElementStyleOptions",
    "GridFrame",
    "GridFrameMargins",
    "GridGraph",
    "GridLines",
    "GridLinesStyle",
    "GridVideo",
    "GroebnerBasis",
    "GroupActionBase",
    "GroupBy",
    "GroupCentralizer",
    "GroupElementFromWord",
    "GroupElementPosition",
    "GroupElementQ",
    "GroupElements",
    "GroupElementToWord",
    "GroupGenerators",
    "Groupings",
    "GroupMultiplicationTable",
    "GroupOpenerColor",
    "GroupOpenerInsideFrame",
    "GroupOrbits",
    "GroupOrder",
    "GroupPageBreakWithin",
    "GroupSetwiseStabilizer",
    "GroupStabilizer",
    "GroupStabilizerChain",
    "GroupTogetherGrouping",
    "GroupTogetherNestedGrouping",
    "GrowCutComponents",
    "Gudermannian",
    "GuidedFilter",
    "GumbelDistribution",
    "HaarWavelet",
    "HadamardMatrix",
    "HalfLine",
    "HalfNormalDistribution",
    "HalfPlane",
    "HalfSpace",
    "HalftoneShading",
    "HamiltonianGraphQ",
    "HammingDistance",
    "HammingWindow",
    "HandlerFunctions",
    "HandlerFunctionsKeys",
    "HankelH1",
    "HankelH2",
    "HankelMatrix",
    "HankelTransform",
    "HannPoissonWindow",
    "HannWindow",
    "HaradaNortonGroupHN",
    "HararyGraph",
    "HardcorePointProcess",
    "HarmonicMean",
    "HarmonicMeanFilter",
    "HarmonicNumber",
    "Hash",
    "HatchFilling",
    "HatchShading",
    "Haversine",
    "HazardFunction",
    "Head",
    "HeadCompose",
    "HeaderAlignment",
    "HeaderBackground",
    "HeaderDisplayFunction",
    "HeaderLines",
    "Headers",
    "HeaderSize",
    "HeaderStyle",
    "Heads",
    "HeatFluxValue",
    "HeatInsulationValue",
    "HeatOutflowValue",
    "HeatRadiationValue",
    "HeatSymmetryValue",
    "HeatTemperatureCondition",
    "HeatTransferPDEComponent",
    "HeatTransferValue",
    "HeavisideLambda",
    "HeavisidePi",
    "HeavisideTheta",
    "HeldGroupHe",
    "HeldPart",
    "HelmholtzPDEComponent",
    "HelpBrowserLookup",
    "HelpBrowserNotebook",
    "HelpBrowserSettings",
    "HelpViewerSettings",
    "Here",
    "HermiteDecomposition",
    "HermiteH",
    "Hermitian",
    "HermitianMatrixQ",
    "HessenbergDecomposition",
    "Hessian",
    "HeunB",
    "HeunBPrime",
    "HeunC",
    "HeunCPrime",
    "HeunD",
    "HeunDPrime",
    "HeunG",
    "HeunGPrime",
    "HeunT",
    "HeunTPrime",
    "HexadecimalCharacter",
    "Hexahedron",
    "HexahedronBox",
    "HexahedronBoxOptions",
    "HiddenItems",
    "HiddenMarkovProcess",
    "HiddenSurface",
    "Highlighted",
    "HighlightGraph",
    "HighlightImage",
    "HighlightMesh",
    "HighlightString",
    "HighpassFilter",
    "HigmanSimsGroupHS",
    "HilbertCurve",
    "HilbertFilter",
    "HilbertMatrix",
    "Histogram",
    "Histogram3D",
    "HistogramDistribution",
    "HistogramList",
    "HistogramPointDensity",
    "HistogramTransform",
    "HistogramTransformInterpolation",
    "HistoricalPeriodData",
    "HitMissTransform",
    "HITSCentrality",
    "HjorthDistribution",
    "HodgeDual",
    "HoeffdingD",
    "HoeffdingDTest",
    "Hold",
    "HoldAll",
    "HoldAllComplete",
    "HoldComplete",
    "HoldFirst",
    "HoldForm",
    "HoldPattern",
    "HoldRest",
    "HolidayCalendar",
    "HomeDirectory",
    "HomePage",
    "Horizontal",
    "HorizontalForm",
    "HorizontalGauge",
    "HorizontalScrollPosition",
    "HornerForm",
    "HostLookup",
    "HotellingTSquareDistribution",
    "HoytDistribution",
    "HTMLSave",
    "HTTPErrorResponse",
    "HTTPRedirect",
    "HTTPRequest",
    "HTTPRequestData",
    "HTTPResponse",
    "Hue",
    "HumanGrowthData",
    "HumpDownHump",
    "HumpEqual",
    "HurwitzLerchPhi",
    "HurwitzZeta",
    "HyperbolicDistribution",
    "HypercubeGraph",
    "HyperexponentialDistribution",
    "Hyperfactorial",
    "Hypergeometric0F1",
    "Hypergeometric0F1Regularized",
    "Hypergeometric1F1",
    "Hypergeometric1F1Regularized",
    "Hypergeometric2F1",
    "Hypergeometric2F1Regularized",
    "HypergeometricDistribution",
    "HypergeometricPFQ",
    "HypergeometricPFQRegularized",
    "HypergeometricU",
    "Hyperlink",
    "HyperlinkAction",
    "HyperlinkCreationSettings",
    "Hyperplane",
    "Hyphenation",
    "HyphenationOptions",
    "HypoexponentialDistribution",
    "HypothesisTestData",
    "I",
    "IconData",
    "Iconize",
    "IconizedObject",
    "IconRules",
    "Icosahedron",
    "Identity",
    "IdentityMatrix",
    "If",
    "IfCompiled",
    "IgnoreCase",
    "IgnoreDiacritics",
    "IgnoreIsotopes",
    "IgnorePunctuation",
    "IgnoreSpellCheck",
    "IgnoreStereochemistry",
    "IgnoringInactive",
    "Im",
    "Image",
    "Image3D",
    "Image3DProjection",
    "Image3DSlices",
    "ImageAccumulate",
    "ImageAdd",
    "ImageAdjust",
    "ImageAlign",
    "ImageApply",
    "ImageApplyIndexed",
    "ImageAspectRatio",
    "ImageAssemble",
    "ImageAugmentationLayer",
    "ImageBoundingBoxes",
    "ImageCache",
    "ImageCacheValid",
    "ImageCapture",
    "ImageCaptureFunction",
    "ImageCases",
    "ImageChannels",
    "ImageClip",
    "ImageCollage",
    "ImageColorSpace",
    "ImageCompose",
    "ImageContainsQ",
    "ImageContents",
    "ImageConvolve",
    "ImageCooccurrence",
    "ImageCorners",
    "ImageCorrelate",
    "ImageCorrespondingPoints",
    "ImageCrop",
    "ImageData",
    "ImageDeconvolve",
    "ImageDemosaic",
    "ImageDifference",
    "ImageDimensions",
    "ImageDisplacements",
    "ImageDistance",
    "ImageEditMode",
    "ImageEffect",
    "ImageExposureCombine",
    "ImageFeatureTrack",
    "ImageFileApply",
    "ImageFileFilter",
    "ImageFileScan",
    "ImageFilter",
    "ImageFocusCombine",
    "ImageForestingComponents",
    "ImageFormattingWidth",
    "ImageForwardTransformation",
    "ImageGraphics",
    "ImageHistogram",
    "ImageIdentify",
    "ImageInstanceQ",
    "ImageKeypoints",
    "ImageLabels",
    "ImageLegends",
    "ImageLevels",
    "ImageLines",
    "ImageMargins",
    "ImageMarker",
    "ImageMarkers",
    "ImageMeasurements",
    "ImageMesh",
    "ImageMultiply",
    "ImageOffset",
    "ImagePad",
    "ImagePadding",
    "ImagePartition",
    "ImagePeriodogram",
    "ImagePerspectiveTransformation",
    "ImagePosition",
    "ImagePreviewFunction",
    "ImagePyramid",
    "ImagePyramidApply",
    "ImageQ",
    "ImageRangeCache",
    "ImageRecolor",
    "ImageReflect",
    "ImageRegion",
    "ImageResize",
    "ImageResolution",
    "ImageRestyle",
    "ImageRotate",
    "ImageRotated",
    "ImageSaliencyFilter",
    "ImageScaled",
    "ImageScan",
    "ImageSize",
    "ImageSizeAction",
    "ImageSizeCache",
    "ImageSizeMultipliers",
    "ImageSizeRaw",
    "ImageStitch",
    "ImageSubtract",
    "ImageTake",
    "ImageTransformation",
    "ImageTrim",
    "ImageType",
    "ImageValue",
    "ImageValuePositions",
    "ImageVectorscopePlot",
    "ImageWaveformPlot",
    "ImagingDevice",
    "ImplicitD",
    "ImplicitRegion",
    "Implies",
    "Import",
    "ImportAutoReplacements",
    "ImportByteArray",
    "ImportedObject",
    "ImportOptions",
    "ImportString",
    "ImprovementImportance",
    "In",
    "Inactivate",
    "Inactive",
    "InactiveStyle",
    "IncidenceGraph",
    "IncidenceList",
    "IncidenceMatrix",
    "IncludeAromaticBonds",
    "IncludeConstantBasis",
    "IncludedContexts",
    "IncludeDefinitions",
    "IncludeDirectories",
    "IncludeFileExtension",
    "IncludeGeneratorTasks",
    "IncludeHydrogens",
    "IncludeInflections",
    "IncludeMetaInformation",
    "IncludePods",
    "IncludeQuantities",
    "IncludeRelatedTables",
    "IncludeSingularSolutions",
    "IncludeSingularTerm",
    "IncludeWindowTimes",
    "Increment",
    "IndefiniteMatrixQ",
    "Indent",
    "IndentingNewlineSpacings",
    "IndentMaxFraction",
    "IndependenceTest",
    "IndependentEdgeSetQ",
    "IndependentPhysicalQuantity",
    "IndependentUnit",
    "IndependentUnitDimension",
    "IndependentVertexSetQ",
    "Indeterminate",
    "IndeterminateThreshold",
    "IndexCreationOptions",
    "Indexed",
    "IndexEdgeTaggedGraph",
    "IndexGraph",
    "IndexTag",
    "Inequality",
    "InertEvaluate",
    "InertExpression",
    "InexactNumberQ",
    "InexactNumbers",
    "InfiniteFuture",
    "InfiniteLine",
    "InfiniteLineThrough",
    "InfinitePast",
    "InfinitePlane",
    "Infinity",
    "Infix",
    "InflationAdjust",
    "InflationMethod",
    "Information",
    "InformationData",
    "InformationDataGrid",
    "Inherited",
    "InheritScope",
    "InhomogeneousPoissonPointProcess",
    "InhomogeneousPoissonProcess",
    "InitialEvaluationHistory",
    "Initialization",
    "InitializationCell",
    "InitializationCellEvaluation",
    "InitializationCellWarning",
    "InitializationObject",
    "InitializationObjects",
    "InitializationValue",
    "Initialize",
    "InitialSeeding",
    "InlineCounterAssignments",
    "InlineCounterIncrements",
    "InlineRules",
    "Inner",
    "InnerPolygon",
    "InnerPolyhedron",
    "Inpaint",
    "Input",
    "InputAliases",
    "InputAssumptions",
    "InputAutoReplacements",
    "InputField",
    "InputFieldBox",
    "InputFieldBoxOptions",
    "InputForm",
    "InputGrouping",
    "InputNamePacket",
    "InputNotebook",
    "InputPacket",
    "InputPorts",
    "InputSettings",
    "InputStream",
    "InputString",
    "InputStringPacket",
    "InputToBoxFormPacket",
    "Insert",
    "InsertionFunction",
    "InsertionPointObject",
    "InsertLinebreaks",
    "InsertResults",
    "Inset",
    "Inset3DBox",
    "Inset3DBoxOptions",
    "InsetBox",
    "InsetBoxOptions",
    "Insphere",
    "Install",
    "InstallService",
    "InstanceNormalizationLayer",
    "InString",
    "Integer",
    "IntegerDigits",
    "IntegerExponent",
    "IntegerLength",
    "IntegerName",
    "IntegerPart",
    "IntegerPartitions",
    "IntegerQ",
    "IntegerReverse",
    "Integers",
    "IntegerString",
    "Integral",
    "Integrate",
    "IntegrateChangeVariables",
    "Interactive",
    "InteractiveTradingChart",
    "InterfaceSwitched",
    "Interlaced",
    "Interleaving",
    "InternallyBalancedDecomposition",
    "InterpolatingFunction",
    "InterpolatingPolynomial",
    "Interpolation",
    "InterpolationOrder",
    "InterpolationPoints",
    "InterpolationPrecision",
    "Interpretation",
    "InterpretationBox",
    "InterpretationBoxOptions",
    "InterpretationFunction",
    "Interpreter",
    "InterpretTemplate",
    "InterquartileRange",
    "Interrupt",
    "InterruptSettings",
    "IntersectedEntityClass",
    "IntersectingQ",
    "Intersection",
    "Interval",
    "IntervalIntersection",
    "IntervalMarkers",
    "IntervalMarkersStyle",
    "IntervalMemberQ",
    "IntervalSlider",
    "IntervalUnion",
    "Into",
    "Inverse",
    "InverseBetaRegularized",
    "InverseBilateralLaplaceTransform",
    "InverseBilateralZTransform",
    "InverseCDF",
    "InverseChiSquareDistribution",
    "InverseContinuousWaveletTransform",
    "InverseDistanceTransform",
    "InverseEllipticNomeQ",
    "InverseErf",
    "InverseErfc",
    "InverseFourier",
    "InverseFourierCosTransform",
    "InverseFourierSequenceTransform",
    "InverseFourierSinTransform",
    "InverseFourierTransform",
    "InverseFunction",
    "InverseFunctions",
    "InverseGammaDistribution",
    "InverseGammaRegularized",
    "InverseGaussianDistribution",
    "InverseGudermannian",
    "InverseHankelTransform",
    "InverseHaversine",
    "InverseImagePyramid",
    "InverseJacobiCD",
    "InverseJacobiCN",
    "InverseJacobiCS",
    "InverseJacobiDC",
    "InverseJacobiDN",
    "InverseJacobiDS",
    "InverseJacobiNC",
    "InverseJacobiND",
    "InverseJacobiNS",
    "InverseJacobiSC",
    "InverseJacobiSD",
    "InverseJacobiSN",
    "InverseLaplaceTransform",
    "InverseMellinTransform",
    "InversePermutation",
    "InverseRadon",
    "InverseRadonTransform",
    "InverseSeries",
    "InverseShortTimeFourier",
    "InverseSpectrogram",
    "InverseSurvivalFunction",
    "InverseTransformedRegion",
    "InverseWaveletTransform",
    "InverseWeierstrassP",
    "InverseWishartMatrixDistribution",
    "InverseZTransform",
    "Invisible",
    "InvisibleApplication",
    "InvisibleTimes",
    "IPAddress",
    "IrreduciblePolynomialQ",
    "IslandData",
    "IsolatingInterval",
    "IsomorphicGraphQ",
    "IsomorphicSubgraphQ",
    "IsotopeData",
    "Italic",
    "Item",
    "ItemAspectRatio",
    "ItemBox",
    "ItemBoxOptions",
    "ItemDisplayFunction",
    "ItemSize",
    "ItemStyle",
    "ItoProcess",
    "JaccardDissimilarity",
    "JacobiAmplitude",
    "Jacobian",
    "JacobiCD",
    "JacobiCN",
    "JacobiCS",
    "JacobiDC",
    "JacobiDN",
    "JacobiDS",
    "JacobiEpsilon",
    "JacobiNC",
    "JacobiND",
    "JacobiNS",
    "JacobiP",
    "JacobiSC",
    "JacobiSD",
    "JacobiSN",
    "JacobiSymbol",
    "JacobiZeta",
    "JacobiZN",
    "JankoGroupJ1",
    "JankoGroupJ2",
    "JankoGroupJ3",
    "JankoGroupJ4",
    "JarqueBeraALMTest",
    "JohnsonDistribution",
    "Join",
    "JoinAcross",
    "Joined",
    "JoinedCurve",
    "JoinedCurveBox",
    "JoinedCurveBoxOptions",
    "JoinForm",
    "JordanDecomposition",
    "JordanModelDecomposition",
    "JulianDate",
    "JuliaSetBoettcher",
    "JuliaSetIterationCount",
    "JuliaSetPlot",
    "JuliaSetPoints",
    "K",
    "KagiChart",
    "KaiserBesselWindow",
    "KaiserWindow",
    "KalmanEstimator",
    "KalmanFilter",
    "KarhunenLoeveDecomposition",
    "KaryTree",
    "KatzCentrality",
    "KCoreComponents",
    "KDistribution",
    "KEdgeConnectedComponents",
    "KEdgeConnectedGraphQ",
    "KeepExistingVersion",
    "KelvinBei",
    "KelvinBer",
    "KelvinKei",
    "KelvinKer",
    "KendallTau",
    "KendallTauTest",
    "KernelConfiguration",
    "KernelExecute",
    "KernelFunction",
    "KernelMixtureDistribution",
    "KernelObject",
    "Kernels",
    "Ket",
    "Key",
    "KeyCollisionFunction",
    "KeyComplement",
    "KeyDrop",
    "KeyDropFrom",
    "KeyExistsQ",
    "KeyFreeQ",
    "KeyIntersection",
    "KeyMap",
    "KeyMemberQ",
    "KeypointStrength",
    "Keys",
    "KeySelect",
    "KeySort",
    "KeySortBy",
    "KeyTake",
    "KeyUnion",
    "KeyValueMap",
    "KeyValuePattern",
    "Khinchin",
    "KillProcess",
    "KirchhoffGraph",
    "KirchhoffMatrix",
    "KleinInvariantJ",
    "KnapsackSolve",
    "KnightTourGraph",
    "KnotData",
    "KnownUnitQ",
    "KochCurve",
    "KolmogorovSmirnovTest",
    "KroneckerDelta",
    "KroneckerModelDecomposition",
    "KroneckerProduct",
    "KroneckerSymbol",
    "KuiperTest",
    "KumaraswamyDistribution",
    "Kurtosis",
    "KuwaharaFilter",
    "KVertexConnectedComponents",
    "KVertexConnectedGraphQ",
    "LABColor",
    "Label",
    "Labeled",
    "LabeledSlider",
    "LabelingFunction",
    "LabelingSize",
    "LabelStyle",
    "LabelVisibility",
    "LaguerreL",
    "LakeData",
    "LambdaComponents",
    "LambertW",
    "LameC",
    "LameCPrime",
    "LameEigenvalueA",
    "LameEigenvalueB",
    "LameS",
    "LameSPrime",
    "LaminaData",
    "LanczosWindow",
    "LandauDistribution",
    "Language",
    "LanguageCategory",
    "LanguageData",
    "LanguageIdentify",
    "LanguageOptions",
    "LaplaceDistribution",
    "LaplaceTransform",
    "Laplacian",
    "LaplacianFilter",
    "LaplacianGaussianFilter",
    "LaplacianPDETerm",
    "Large",
    "Larger",
    "Last",
    "Latitude",
    "LatitudeLongitude",
    "LatticeData",
    "LatticeReduce",
    "Launch",
    "LaunchKernels",
    "LayeredGraphPlot",
    "LayeredGraphPlot3D",
    "LayerSizeFunction",
    "LayoutInformation",
    "LCHColor",
    "LCM",
    "LeaderSize",
    "LeafCount",
    "LeapVariant",
    "LeapYearQ",
    "LearnDistribution",
    "LearnedDistribution",
    "LearningRate",
    "LearningRateMultipliers",
    "LeastSquares",
    "LeastSquaresFilterKernel",
    "Left",
    "LeftArrow",
    "LeftArrowBar",
    "LeftArrowRightArrow",
    "LeftDownTeeVector",
    "LeftDownVector",
    "LeftDownVectorBar",
    "LeftRightArrow",
    "LeftRightVector",
    "LeftTee",
    "LeftTeeArrow",
    "LeftTeeVector",
    "LeftTriangle",
    "LeftTriangleBar",
    "LeftTriangleEqual",
    "LeftUpDownVector",
    "LeftUpTeeVector",
    "LeftUpVector",
    "LeftUpVectorBar",
    "LeftVector",
    "LeftVectorBar",
    "LegendAppearance",
    "Legended",
    "LegendFunction",
    "LegendLabel",
    "LegendLayout",
    "LegendMargins",
    "LegendMarkers",
    "LegendMarkerSize",
    "LegendreP",
    "LegendreQ",
    "LegendreType",
    "Length",
    "LengthWhile",
    "LerchPhi",
    "Less",
    "LessEqual",
    "LessEqualGreater",
    "LessEqualThan",
    "LessFullEqual",
    "LessGreater",
    "LessLess",
    "LessSlantEqual",
    "LessThan",
    "LessTilde",
    "LetterCharacter",
    "LetterCounts",
    "LetterNumber",
    "LetterQ",
    "Level",
    "LeveneTest",
    "LeviCivitaTensor",
    "LevyDistribution",
    "Lexicographic",
    "LexicographicOrder",
    "LexicographicSort",
    "LibraryDataType",
    "LibraryFunction",
    "LibraryFunctionDeclaration",
    "LibraryFunctionError",
    "LibraryFunctionInformation",
    "LibraryFunctionLoad",
    "LibraryFunctionUnload",
    "LibraryLoad",
    "LibraryUnload",
    "LicenseEntitlementObject",
    "LicenseEntitlements",
    "LicenseID",
    "LicensingSettings",
    "LiftingFilterData",
    "LiftingWaveletTransform",
    "LightBlue",
    "LightBrown",
    "LightCyan",
    "Lighter",
    "LightGray",
    "LightGreen",
    "Lighting",
    "LightingAngle",
    "LightMagenta",
    "LightOrange",
    "LightPink",
    "LightPurple",
    "LightRed",
    "LightSources",
    "LightYellow",
    "Likelihood",
    "Limit",
    "LimitsPositioning",
    "LimitsPositioningTokens",
    "LindleyDistribution",
    "Line",
    "Line3DBox",
    "Line3DBoxOptions",
    "LinearFilter",
    "LinearFractionalOptimization",
    "LinearFractionalTransform",
    "LinearGradientFilling",
    "LinearGradientImage",
    "LinearizingTransformationData",
    "LinearLayer",
    "LinearModelFit",
    "LinearOffsetFunction",
    "LinearOptimization",
    "LinearProgramming",
    "LinearRecurrence",
    "LinearSolve",
    "LinearSolveFunction",
    "LineBox",
    "LineBoxOptions",
    "LineBreak",
    "LinebreakAdjustments",
    "LineBreakChart",
    "LinebreakSemicolonWeighting",
    "LineBreakWithin",
    "LineColor",
    "LineGraph",
    "LineIndent",
    "LineIndentMaxFraction",
    "LineIntegralConvolutionPlot",
    "LineIntegralConvolutionScale",
    "LineLegend",
    "LineOpacity",
    "LineSpacing",
    "LineWrapParts",
    "LinkActivate",
    "LinkClose",
    "LinkConnect",
    "LinkConnectedQ",
    "LinkCreate",
    "LinkError",
    "LinkFlush",
    "LinkFunction",
    "LinkHost",
    "LinkInterrupt",
    "LinkLaunch",
    "LinkMode",
    "LinkObject",
    "LinkOpen",
    "LinkOptions",
    "LinkPatterns",
    "LinkProtocol",
    "LinkRankCentrality",
    "LinkRead",
    "LinkReadHeld",
    "LinkReadyQ",
    "Links",
    "LinkService",
    "LinkWrite",
    "LinkWriteHeld",
    "LiouvilleLambda",
    "List",
    "Listable",
    "ListAnimate",
    "ListContourPlot",
    "ListContourPlot3D",
    "ListConvolve",
    "ListCorrelate",
    "ListCurvePathPlot",
    "ListDeconvolve",
    "ListDensityPlot",
    "ListDensityPlot3D",
    "Listen",
    "ListFormat",
    "ListFourierSequenceTransform",
    "ListInterpolation",
    "ListLineIntegralConvolutionPlot",
    "ListLinePlot",
    "ListLinePlot3D",
    "ListLogLinearPlot",
    "ListLogLogPlot",
    "ListLogPlot",
    "ListPicker",
    "ListPickerBox",
    "ListPickerBoxBackground",
    "ListPickerBoxOptions",
    "ListPlay",
    "ListPlot",
    "ListPlot3D",
    "ListPointPlot3D",
    "ListPolarPlot",
    "ListQ",
    "ListSliceContourPlot3D",
    "ListSliceDensityPlot3D",
    "ListSliceVectorPlot3D",
    "ListStepPlot",
    "ListStreamDensityPlot",
    "ListStreamPlot",
    "ListStreamPlot3D",
    "ListSurfacePlot3D",
    "ListVectorDensityPlot",
    "ListVectorDisplacementPlot",
    "ListVectorDisplacementPlot3D",
    "ListVectorPlot",
    "ListVectorPlot3D",
    "ListZTransform",
    "Literal",
    "LiteralSearch",
    "LiteralType",
    "LoadCompiledComponent",
    "LocalAdaptiveBinarize",
    "LocalCache",
    "LocalClusteringCoefficient",
    "LocalEvaluate",
    "LocalizeDefinitions",
    "LocalizeVariables",
    "LocalObject",
    "LocalObjects",
    "LocalResponseNormalizationLayer",
    "LocalSubmit",
    "LocalSymbol",
    "LocalTime",
    "LocalTimeZone",
    "LocationEquivalenceTest",
    "LocationTest",
    "Locator",
    "LocatorAutoCreate",
    "LocatorBox",
    "LocatorBoxOptions",
    "LocatorCentering",
    "LocatorPane",
    "LocatorPaneBox",
    "LocatorPaneBoxOptions",
    "LocatorRegion",
    "Locked",
    "Log",
    "Log10",
    "Log2",
    "LogBarnesG",
    "LogGamma",
    "LogGammaDistribution",
    "LogicalExpand",
    "LogIntegral",
    "LogisticDistribution",
    "LogisticSigmoid",
    "LogitModelFit",
    "LogLikelihood",
    "LogLinearPlot",
    "LogLogisticDistribution",
    "LogLogPlot",
    "LogMultinormalDistribution",
    "LogNormalDistribution",
    "LogPlot",
    "LogRankTest",
    "LogSeriesDistribution",
    "LongEqual",
    "Longest",
    "LongestCommonSequence",
    "LongestCommonSequencePositions",
    "LongestCommonSubsequence",
    "LongestCommonSubsequencePositions",
    "LongestMatch",
    "LongestOrderedSequence",
    "LongForm",
    "Longitude",
    "LongLeftArrow",
    "LongLeftRightArrow",
    "LongRightArrow",
    "LongShortTermMemoryLayer",
    "Lookup",
    "Loopback",
    "LoopFreeGraphQ",
    "Looping",
    "LossFunction",
    "LowerCaseQ",
    "LowerLeftArrow",
    "LowerRightArrow",
    "LowerTriangularize",
    "LowerTriangularMatrix",
    "LowerTriangularMatrixQ",
    "LowpassFilter",
    "LQEstimatorGains",
    "LQGRegulator",
    "LQOutputRegulatorGains",
    "LQRegulatorGains",
    "LUBackSubstitution",
    "LucasL",
    "LuccioSamiComponents",
    "LUDecomposition",
    "LunarEclipse",
    "LUVColor",
    "LyapunovSolve",
    "LyonsGroupLy",
    "MachineID",
    "MachineName",
    "MachineNumberQ",
    "MachinePrecision",
    "MacintoshSystemPageSetup",
    "Magenta",
    "Magnification",
    "Magnify",
    "MailAddressValidation",
    "MailExecute",
    "MailFolder",
    "MailItem",
    "MailReceiverFunction",
    "MailResponseFunction",
    "MailSearch",
    "MailServerConnect",
    "MailServerConnection",
    "MailSettings",
    "MainSolve",
    "MaintainDynamicCaches",
    "Majority",
    "MakeBoxes",
    "MakeExpression",
    "MakeRules",
    "ManagedLibraryExpressionID",
    "ManagedLibraryExpressionQ",
    "MandelbrotSetBoettcher",
    "MandelbrotSetDistance",
    "MandelbrotSetIterationCount",
    "MandelbrotSetMemberQ",
    "MandelbrotSetPlot",
    "MangoldtLambda",
    "ManhattanDistance",
    "Manipulate",
    "Manipulator",
    "MannedSpaceMissionData",
    "MannWhitneyTest",
    "MantissaExponent",
    "Manual",
    "Map",
    "MapAll",
    "MapApply",
    "MapAt",
    "MapIndexed",
    "MAProcess",
    "MapThread",
    "MarchenkoPasturDistribution",
    "MarcumQ",
    "MardiaCombinedTest",
    "MardiaKurtosisTest",
    "MardiaSkewnessTest",
    "MarginalDistribution",
    "MarkovProcessProperties",
    "Masking",
    "MassConcentrationCondition",
    "MassFluxValue",
    "MassImpermeableBoundaryValue",
    "MassOutflowValue",
    "MassSymmetryValue",
    "MassTransferValue",
    "MassTransportPDEComponent",
    "MatchingDissimilarity",
    "MatchLocalNameQ",
    "MatchLocalNames",
    "MatchQ",
    "Material",
    "MaterialShading",
    "MaternPointProcess",
    "MathematicalFunctionData",
    "MathematicaNotation",
    "MathieuC",
    "MathieuCharacteristicA",
    "MathieuCharacteristicB",
    "MathieuCharacteristicExponent",
    "MathieuCPrime",
    "MathieuGroupM11",
    "MathieuGroupM12",
    "MathieuGroupM22",
    "MathieuGroupM23",
    "MathieuGroupM24",
    "MathieuS",
    "MathieuSPrime",
    "MathMLForm",
    "MathMLText",
    "Matrices",
    "MatrixExp",
    "MatrixForm",
    "MatrixFunction",
    "MatrixLog",
    "MatrixNormalDistribution",
    "MatrixPlot",
    "MatrixPower",
    "MatrixPropertyDistribution",
    "MatrixQ",
    "MatrixRank",
    "MatrixTDistribution",
    "Max",
    "MaxBend",
    "MaxCellMeasure",
    "MaxColorDistance",
    "MaxDate",
    "MaxDetect",
    "MaxDisplayedChildren",
    "MaxDuration",
    "MaxExtraBandwidths",
    "MaxExtraConditions",
    "MaxFeatureDisplacement",
    "MaxFeatures",
    "MaxFilter",
    "MaximalBy",
    "Maximize",
    "MaxItems",
    "MaxIterations",
    "MaxLimit",
    "MaxMemoryUsed",
    "MaxMixtureKernels",
    "MaxOverlapFraction",
    "MaxPlotPoints",
    "MaxPoints",
    "MaxRecursion",
    "MaxStableDistribution",
    "MaxStepFraction",
    "MaxSteps",
    "MaxStepSize",
    "MaxTrainingRounds",
    "MaxValue",
    "MaxwellDistribution",
    "MaxWordGap",
    "McLaughlinGroupMcL",
    "Mean",
    "MeanAbsoluteLossLayer",
    "MeanAround",
    "MeanClusteringCoefficient",
    "MeanDegreeConnectivity",
    "MeanDeviation",
    "MeanFilter",
    "MeanGraphDistance",
    "MeanNeighborDegree",
    "MeanPointDensity",
    "MeanShift",
    "MeanShiftFilter",
    "MeanSquaredLossLayer",
    "Median",
    "MedianDeviation",
    "MedianFilter",
    "MedicalTestData",
    "Medium",
    "MeijerG",
    "MeijerGReduce",
    "MeixnerDistribution",
    "MellinConvolve",
    "MellinTransform",
    "MemberQ",
    "MemoryAvailable",
    "MemoryConstrained",
    "MemoryConstraint",
    "MemoryInUse",
    "MengerMesh",
    "Menu",
    "MenuAppearance",
    "MenuCommandKey",
    "MenuEvaluator",
    "MenuItem",
    "MenuList",
    "MenuPacket",
    "MenuSortingValue",
    "MenuStyle",
    "MenuView",
    "Merge",
    "MergeDifferences",
    "MergingFunction",
    "MersennePrimeExponent",
    "MersennePrimeExponentQ",
    "Mesh",
    "MeshCellCentroid",
    "MeshCellCount",
    "MeshCellHighlight",
    "MeshCellIndex",
    "MeshCellLabel",
    "MeshCellMarker",
    "MeshCellMeasure",
    "MeshCellQuality",
    "MeshCells",
    "MeshCellShapeFunction",
    "MeshCellStyle",
    "MeshConnectivityGraph",
    "MeshCoordinates",
    "MeshFunctions",
    "MeshPrimitives",
    "MeshQualityGoal",
    "MeshRange",
    "MeshRefinementFunction",
    "MeshRegion",
    "MeshRegionQ",
    "MeshShading",
    "MeshStyle",
    "Message",
    "MessageDialog",
    "MessageList",
    "MessageName",
    "MessageObject",
    "MessageOptions",
    "MessagePacket",
    "Messages",
    "MessagesNotebook",
    "MetaCharacters",
    "MetaInformation",
    "MeteorShowerData",
    "Method",
    "MethodOptions",
    "MexicanHatWavelet",
    "MeyerWavelet",
    "Midpoint",
    "MIMETypeToFormatList",
    "Min",
    "MinColorDistance",
    "MinDate",
    "MinDetect",
    "MineralData",
    "MinFilter",
    "MinimalBy",
    "MinimalPolynomial",
    "MinimalStateSpaceModel",
    "Minimize",
    "MinimumTimeIncrement",
    "MinIntervalSize",
    "MinkowskiQuestionMark",
    "MinLimit",
    "MinMax",
    "MinorPlanetData",
    "Minors",
    "MinPointSeparation",
    "MinRecursion",
    "MinSize",
    "MinStableDistribution",
    "Minus",
    "MinusPlus",
    "MinValue",
    "Missing",
    "MissingBehavior",
    "MissingDataMethod",
    "MissingDataRules",
    "MissingQ",
    "MissingString",
    "MissingStyle",
    "MissingValuePattern",
    "MissingValueSynthesis",
    "MittagLefflerE",
    "MixedFractionParts",
    "MixedGraphQ",
    "MixedMagnitude",
    "MixedRadix",
    "MixedRadixQuantity",
    "MixedUnit",
    "MixtureDistribution",
    "Mod",
    "Modal",
    "Mode",
    "ModelPredictiveController",
    "Modular",
    "ModularInverse",
    "ModularLambda",
    "Module",
    "Modulus",
    "MoebiusMu",
    "Molecule",
    "MoleculeAlign",
    "MoleculeContainsQ",
    "MoleculeDraw",
    "MoleculeEquivalentQ",
    "MoleculeFreeQ",
    "MoleculeGraph",
    "MoleculeMatchQ",
    "MoleculeMaximumCommonSubstructure",
    "MoleculeModify",
    "MoleculeName",
    "MoleculePattern",
    "MoleculePlot",
    "MoleculePlot3D",
    "MoleculeProperty",
    "MoleculeQ",
    "MoleculeRecognize",
    "MoleculeSubstructureCount",
    "MoleculeValue",
    "Moment",
    "MomentConvert",
    "MomentEvaluate",
    "MomentGeneratingFunction",
    "MomentOfInertia",
    "Monday",
    "Monitor",
    "MonomialList",
    "MonomialOrder",
    "MonsterGroupM",
    "MoonPhase",
    "MoonPosition",
    "MorletWavelet",
    "MorphologicalBinarize",
    "MorphologicalBranchPoints",
    "MorphologicalComponents",
    "MorphologicalEulerNumber",
    "MorphologicalGraph",
    "MorphologicalPerimeter",
    "MorphologicalTransform",
    "MortalityData",
    "Most",
    "MountainData",
    "MouseAnnotation",
    "MouseAppearance",
    "MouseAppearanceTag",
    "MouseButtons",
    "Mouseover",
    "MousePointerNote",
    "MousePosition",
    "MovieData",
    "MovingAverage",
    "MovingMap",
    "MovingMedian",
    "MoyalDistribution",
    "MultiaxisArrangement",
    "Multicolumn",
    "MultiedgeStyle",
    "MultigraphQ",
    "MultilaunchWarning",
    "MultiLetterItalics",
    "MultiLetterStyle",
    "MultilineFunction",
    "Multinomial",
    "MultinomialDistribution",
    "MultinormalDistribution",
    "MultiplicativeOrder",
    "Multiplicity",
    "MultiplySides",
    "MultiscriptBoxOptions",
    "Multiselection",
    "MultivariateHypergeometricDistribution",
    "MultivariatePoissonDistribution",
    "MultivariateTDistribution",
    "N",
    "NakagamiDistribution",
    "NameQ",
    "Names",
    "NamespaceBox",
    "NamespaceBoxOptions",
    "Nand",
    "NArgMax",
    "NArgMin",
    "NBernoulliB",
    "NBodySimulation",
    "NBodySimulationData",
    "NCache",
    "NCaputoD",
    "NDEigensystem",
    "NDEigenvalues",
    "NDSolve",
    "NDSolveValue",
    "Nearest",
    "NearestFunction",
    "NearestMeshCells",
    "NearestNeighborG",
    "NearestNeighborGraph",
    "NearestTo",
    "NebulaData",
    "NeedlemanWunschSimilarity",
    "Needs",
    "Negative",
    "NegativeBinomialDistribution",
    "NegativeDefiniteMatrixQ",
    "NegativeIntegers",
    "NegativelyOrientedPoints",
    "NegativeMultinomialDistribution",
    "NegativeRationals",
    "NegativeReals",
    "NegativeSemidefiniteMatrixQ",
    "NeighborhoodData",
    "NeighborhoodGraph",
    "Nest",
    "NestedGreaterGreater",
    "NestedLessLess",
    "NestedScriptRules",
    "NestGraph",
    "NestList",
    "NestTree",
    "NestWhile",
    "NestWhileList",
    "NetAppend",
    "NetArray",
    "NetArrayLayer",
    "NetBidirectionalOperator",
    "NetChain",
    "NetDecoder",
    "NetDelete",
    "NetDrop",
    "NetEncoder",
    "NetEvaluationMode",
    "NetExternalObject",
    "NetExtract",
    "NetFlatten",
    "NetFoldOperator",
    "NetGANOperator",
    "NetGraph",
    "NetInformation",
    "NetInitialize",
    "NetInsert",
    "NetInsertSharedArrays",
    "NetJoin",
    "NetMapOperator",
    "NetMapThreadOperator",
    "NetMeasurements",
    "NetModel",
    "NetNestOperator",
    "NetPairEmbeddingOperator",
    "NetPort",
    "NetPortGradient",
    "NetPrepend",
    "NetRename",
    "NetReplace",
    "NetReplacePart",
    "NetSharedArray",
    "NetStateObject",
    "NetTake",
    "NetTrain",
    "NetTrainResultsObject",
    "NetUnfold",
    "NetworkPacketCapture",
    "NetworkPacketRecording",
    "NetworkPacketRecordingDuring",
    "NetworkPacketTrace",
    "NeumannValue",
    "NevilleThetaC",
    "NevilleThetaD",
    "NevilleThetaN",
    "NevilleThetaS",
    "NewPrimitiveStyle",
    "NExpectation",
    "Next",
    "NextCell",
    "NextDate",
    "NextPrime",
    "NextScheduledTaskTime",
    "NeymanScottPointProcess",
    "NFractionalD",
    "NHoldAll",
    "NHoldFirst",
    "NHoldRest",
    "NicholsGridLines",
    "NicholsPlot",
    "NightHemisphere",
    "NIntegrate",
    "NMaximize",
    "NMaxValue",
    "NMinimize",
    "NMinValue",
    "NominalScale",
    "NominalVariables",
    "NonAssociative",
    "NoncentralBetaDistribution",
    "NoncentralChiSquareDistribution",
    "NoncentralFRatioDistribution",
    "NoncentralStudentTDistribution",
    "NonCommutativeMultiply",
    "NonConstants",
    "NondimensionalizationTransform",
    "None",
    "NoneTrue",
    "NonlinearModelFit",
    "NonlinearStateSpaceModel",
    "NonlocalMeansFilter",
    "NonNegative",
    "NonNegativeIntegers",
    "NonNegativeRationals",
    "NonNegativeReals",
    "NonPositive",
    "NonPositiveIntegers",
    "NonPositiveRationals",
    "NonPositiveReals",
    "Nor",
    "NorlundB",
    "Norm",
    "Normal",
    "NormalDistribution",
    "NormalGrouping",
    "NormalizationLayer",
    "Normalize",
    "Normalized",
    "NormalizedSquaredEuclideanDistance",
    "NormalMatrixQ",
    "NormalsFunction",
    "NormFunction",
    "Not",
    "NotCongruent",
    "NotCupCap",
    "NotDoubleVerticalBar",
    "Notebook",
    "NotebookApply",
    "NotebookAutoSave",
    "NotebookBrowseDirectory",
    "NotebookClose",
    "NotebookConvertSettings",
    "NotebookCreate",
    "NotebookDefault",
    "NotebookDelete",
    "NotebookDirectory",
    "NotebookDynamicExpression",
    "NotebookEvaluate",
    "NotebookEventActions",
    "NotebookFileName",
    "NotebookFind",
    "NotebookGet",
    "NotebookImport",
    "NotebookInformation",
    "NotebookInterfaceObject",
    "NotebookLocate",
    "NotebookObject",
    "NotebookOpen",
    "NotebookPath",
    "NotebookPrint",
    "NotebookPut",
    "NotebookRead",
    "Notebooks",
    "NotebookSave",
    "NotebookSelection",
    "NotebooksMenu",
    "NotebookTemplate",
    "NotebookWrite",
    "NotElement",
    "NotEqualTilde",
    "NotExists",
    "NotGreater",
    "NotGreaterEqual",
    "NotGreaterFullEqual",
    "NotGreaterGreater",
    "NotGreaterLess",
    "NotGreaterSlantEqual",
    "NotGreaterTilde",
    "Nothing",
    "NotHumpDownHump",
    "NotHumpEqual",
    "NotificationFunction",
    "NotLeftTriangle",
    "NotLeftTriangleBar",
    "NotLeftTriangleEqual",
    "NotLess",
    "NotLessEqual",
    "NotLessFullEqual",
    "NotLessGreater",
    "NotLessLess",
    "NotLessSlantEqual",
    "NotLessTilde",
    "NotNestedGreaterGreater",
    "NotNestedLessLess",
    "NotPrecedes",
    "NotPrecedesEqual",
    "NotPrecedesSlantEqual",
    "NotPrecedesTilde",
    "NotReverseElement",
    "NotRightTriangle",
    "NotRightTriangleBar",
    "NotRightTriangleEqual",
    "NotSquareSubset",
    "NotSquareSubsetEqual",
    "NotSquareSuperset",
    "NotSquareSupersetEqual",
    "NotSubset",
    "NotSubsetEqual",
    "NotSucceeds",
    "NotSucceedsEqual",
    "NotSucceedsSlantEqual",
    "NotSucceedsTilde",
    "NotSuperset",
    "NotSupersetEqual",
    "NotTilde",
    "NotTildeEqual",
    "NotTildeFullEqual",
    "NotTildeTilde",
    "NotVerticalBar",
    "Now",
    "NoWhitespace",
    "NProbability",
    "NProduct",
    "NProductFactors",
    "NRoots",
    "NSolve",
    "NSolveValues",
    "NSum",
    "NSumTerms",
    "NuclearExplosionData",
    "NuclearReactorData",
    "Null",
    "NullRecords",
    "NullSpace",
    "NullWords",
    "Number",
    "NumberCompose",
    "NumberDecompose",
    "NumberDigit",
    "NumberExpand",
    "NumberFieldClassNumber",
    "NumberFieldDiscriminant",
    "NumberFieldFundamentalUnits",
    "NumberFieldIntegralBasis",
    "NumberFieldNormRepresentatives",
    "NumberFieldRegulator",
    "NumberFieldRootsOfUnity",
    "NumberFieldSignature",
    "NumberForm",
    "NumberFormat",
    "NumberLinePlot",
    "NumberMarks",
    "NumberMultiplier",
    "NumberPadding",
    "NumberPoint",
    "NumberQ",
    "NumberSeparator",
    "NumberSigns",
    "NumberString",
    "Numerator",
    "NumeratorDenominator",
    "NumericalOrder",
    "NumericalSort",
    "NumericArray",
    "NumericArrayQ",
    "NumericArrayType",
    "NumericFunction",
    "NumericQ",
    "NuttallWindow",
    "NValues",
    "NyquistGridLines",
    "NyquistPlot",
    "O",
    "ObjectExistsQ",
    "ObservabilityGramian",
    "ObservabilityMatrix",
    "ObservableDecomposition",
    "ObservableModelQ",
    "OceanData",
    "Octahedron",
    "OddQ",
    "Off",
    "Offset",
    "OLEData",
    "On",
    "ONanGroupON",
    "Once",
    "OneIdentity",
    "Opacity",
    "OpacityFunction",
    "OpacityFunctionScaling",
    "Open",
    "OpenAppend",
    "Opener",
    "OpenerBox",
    "OpenerBoxOptions",
    "OpenerView",
    "OpenFunctionInspectorPacket",
    "Opening",
    "OpenRead",
    "OpenSpecialOptions",
    "OpenTemporary",
    "OpenWrite",
    "Operate",
    "OperatingSystem",
    "OperatorApplied",
    "OptimumFlowData",
    "Optional",
    "OptionalElement",
    "OptionInspectorSettings",
    "OptionQ",
    "Options",
    "OptionsPacket",
    "OptionsPattern",
    "OptionValue",
    "OptionValueBox",
    "OptionValueBoxOptions",
    "Or",
    "Orange",
    "Order",
    "OrderDistribution",
    "OrderedQ",
    "Ordering",
    "OrderingBy",
    "OrderingLayer",
    "Orderless",
    "OrderlessPatternSequence",
    "OrdinalScale",
    "OrnsteinUhlenbeckProcess",
    "Orthogonalize",
    "OrthogonalMatrixQ",
    "Out",
    "Outer",
    "OuterPolygon",
    "OuterPolyhedron",
    "OutputAutoOverwrite",
    "OutputControllabilityMatrix",
    "OutputControllableModelQ",
    "OutputForm",
    "OutputFormData",
    "OutputGrouping",
    "OutputMathEditExpression",
    "OutputNamePacket",
    "OutputPorts",
    "OutputResponse",
    "OutputSizeLimit",
    "OutputStream",
    "Over",
    "OverBar",
    "OverDot",
    "Overflow",
    "OverHat",
    "Overlaps",
    "Overlay",
    "OverlayBox",
    "OverlayBoxOptions",
    "OverlayVideo",
    "Overscript",
    "OverscriptBox",
    "OverscriptBoxOptions",
    "OverTilde",
    "OverVector",
    "OverwriteTarget",
    "OwenT",
    "OwnValues",
    "Package",
    "PackingMethod",
    "PackPaclet",
    "PacletDataRebuild",
    "PacletDirectoryAdd",
    "PacletDirectoryLoad",
    "PacletDirectoryRemove",
    "PacletDirectoryUnload",
    "PacletDisable",
    "PacletEnable",
    "PacletFind",
    "PacletFindRemote",
    "PacletInformation",
    "PacletInstall",
    "PacletInstallSubmit",
    "PacletNewerQ",
    "PacletObject",
    "PacletObjectQ",
    "PacletSite",
    "PacletSiteObject",
    "PacletSiteRegister",
    "PacletSites",
    "PacletSiteUnregister",
    "PacletSiteUpdate",
    "PacletSymbol",
    "PacletUninstall",
    "PacletUpdate",
    "PaddedForm",
    "Padding",
    "PaddingLayer",
    "PaddingSize",
    "PadeApproximant",
    "PadLeft",
    "PadRight",
    "PageBreakAbove",
    "PageBreakBelow",
    "PageBreakWithin",
    "PageFooterLines",
    "PageFooters",
    "PageHeaderLines",
    "PageHeaders",
    "PageHeight",
    "PageRankCentrality",
    "PageTheme",
    "PageWidth",
    "Pagination",
    "PairCorrelationG",
    "PairedBarChart",
    "PairedHistogram",
    "PairedSmoothHistogram",
    "PairedTTest",
    "PairedZTest",
    "PaletteNotebook",
    "PalettePath",
    "PalettesMenuSettings",
    "PalindromeQ",
    "Pane",
    "PaneBox",
    "PaneBoxOptions",
    "Panel",
    "PanelBox",
    "PanelBoxOptions",
    "Paneled",
    "PaneSelector",
    "PaneSelectorBox",
    "PaneSelectorBoxOptions",
    "PaperWidth",
    "ParabolicCylinderD",
    "ParagraphIndent",
    "ParagraphSpacing",
    "ParallelArray",
    "ParallelAxisPlot",
    "ParallelCombine",
    "ParallelDo",
    "Parallelepiped",
    "ParallelEvaluate",
    "Parallelization",
    "Parallelize",
    "ParallelKernels",
    "ParallelMap",
    "ParallelNeeds",
    "Parallelogram",
    "ParallelProduct",
    "ParallelSubmit",
    "ParallelSum",
    "ParallelTable",
    "ParallelTry",
    "Parameter",
    "ParameterEstimator",
    "ParameterMixtureDistribution",
    "ParameterVariables",
    "ParametricConvexOptimization",
    "ParametricFunction",
    "ParametricNDSolve",
    "ParametricNDSolveValue",
    "ParametricPlot",
    "ParametricPlot3D",
    "ParametricRampLayer",
    "ParametricRegion",
    "ParentBox",
    "ParentCell",
    "ParentConnect",
    "ParentDirectory",
    "ParentEdgeLabel",
    "ParentEdgeLabelFunction",
    "ParentEdgeLabelStyle",
    "ParentEdgeShapeFunction",
    "ParentEdgeStyle",
    "ParentEdgeStyleFunction",
    "ParentForm",
    "Parenthesize",
    "ParentList",
    "ParentNotebook",
    "ParetoDistribution",
    "ParetoPickandsDistribution",
    "ParkData",
    "Part",
    "PartBehavior",
    "PartialCorrelationFunction",
    "PartialD",
    "ParticleAcceleratorData",
    "ParticleData",
    "Partition",
    "PartitionGranularity",
    "PartitionsP",
    "PartitionsQ",
    "PartLayer",
    "PartOfSpeech",
    "PartProtection",
    "ParzenWindow",
    "PascalDistribution",
    "PassEventsDown",
    "PassEventsUp",
    "Paste",
    "PasteAutoQuoteCharacters",
    "PasteBoxFormInlineCells",
    "PasteButton",
    "Path",
    "PathGraph",
    "PathGraphQ",
    "Pattern",
    "PatternFilling",
    "PatternReaction",
    "PatternSequence",
    "PatternTest",
    "PauliMatrix",
    "PaulWavelet",
    "Pause",
    "PausedTime",
    "PDF",
    "PeakDetect",
    "PeanoCurve",
    "PearsonChiSquareTest",
    "PearsonCorrelationTest",
    "PearsonDistribution",
    "PenttinenPointProcess",
    "PercentForm",
    "PerfectNumber",
    "PerfectNumberQ",
    "PerformanceGoal",
    "Perimeter",
    "PeriodicBoundaryCondition",
    "PeriodicInterpolation",
    "Periodogram",
    "PeriodogramArray",
    "Permanent",
    "Permissions",
    "PermissionsGroup",
    "PermissionsGroupMemberQ",
    "PermissionsGroups",
    "PermissionsKey",
    "PermissionsKeys",
    "PermutationCycles",
    "PermutationCyclesQ",
    "PermutationGroup",
    "PermutationLength",
    "PermutationList",
    "PermutationListQ",
    "PermutationMatrix",
    "PermutationMax",
    "PermutationMin",
    "PermutationOrder",
    "PermutationPower",
    "PermutationProduct",
    "PermutationReplace",
    "Permutations",
    "PermutationSupport",
    "Permute",
    "PeronaMalikFilter",
    "Perpendicular",
    "PerpendicularBisector",
    "PersistenceLocation",
    "PersistenceTime",
    "PersistentObject",
    "PersistentObjects",
    "PersistentSymbol",
    "PersistentValue",
    "PersonData",
    "PERTDistribution",
    "PetersenGraph",
    "PhaseMargins",
    "PhaseRange",
    "PhongShading",
    "PhysicalSystemData",
    "Pi",
    "Pick",
    "PickedElements",
    "PickMode",
    "PIDData",
    "PIDDerivativeFilter",
    "PIDFeedforward",
    "PIDTune",
    "Piecewise",
    "PiecewiseExpand",
    "PieChart",
    "PieChart3D",
    "PillaiTrace",
    "PillaiTraceTest",
    "PingTime",
    "Pink",
    "PitchRecognize",
    "Pivoting",
    "PixelConstrained",
    "PixelValue",
    "PixelValuePositions",
    "Placed",
    "Placeholder",
    "PlaceholderLayer",
    "PlaceholderReplace",
    "Plain",
    "PlanarAngle",
    "PlanarFaceList",
    "PlanarGraph",
    "PlanarGraphQ",
    "PlanckRadiationLaw",
    "PlaneCurveData",
    "PlanetaryMoonData",
    "PlanetData",
    "PlantData",
    "Play",
    "PlaybackSettings",
    "PlayRange",
    "Plot",
    "Plot3D",
    "Plot3Matrix",
    "PlotDivision",
    "PlotJoined",
    "PlotLabel",
    "PlotLabels",
    "PlotLayout",
    "PlotLegends",
    "PlotMarkers",
    "PlotPoints",
    "PlotRange",
    "PlotRangeClipping",
    "PlotRangeClipPlanesStyle",
    "PlotRangePadding",
    "PlotRegion",
    "PlotStyle",
    "PlotTheme",
    "Pluralize",
    "Plus",
    "PlusMinus",
    "Pochhammer",
    "PodStates",
    "PodWidth",
    "Point",
    "Point3DBox",
    "Point3DBoxOptions",
    "PointBox",
    "PointBoxOptions",
    "PointCountDistribution",
    "PointDensity",
    "PointDensityFunction",
    "PointFigureChart",
    "PointLegend",
    "PointLight",
    "PointProcessEstimator",
    "PointProcessFitTest",
    "PointProcessParameterAssumptions",
    "PointProcessParameterQ",
    "PointSize",
    "PointStatisticFunction",
    "PointValuePlot",
    "PoissonConsulDistribution",
    "PoissonDistribution",
    "PoissonPDEComponent",
    "PoissonPointProcess",
    "PoissonProcess",
    "PoissonWindow",
    "PolarAxes",
    "PolarAxesOrigin",
    "PolarGridLines",
    "PolarPlot",
    "PolarTicks",
    "PoleZeroMarkers",
    "PolyaAeppliDistribution",
    "PolyGamma",
    "Polygon",
    "Polygon3DBox",
    "Polygon3DBoxOptions",
    "PolygonalNumber",
    "PolygonAngle",
    "PolygonBox",
    "PolygonBoxOptions",
    "PolygonCoordinates",
    "PolygonDecomposition",
    "PolygonHoleScale",
    "PolygonIntersections",
    "PolygonScale",
    "Polyhedron",
    "PolyhedronAngle",
    "PolyhedronBox",
    "PolyhedronBoxOptions",
    "PolyhedronCoordinates",
    "PolyhedronData",
    "PolyhedronDecomposition",
    "PolyhedronGenus",
    "PolyLog",
    "PolynomialExpressionQ",
    "PolynomialExtendedGCD",
    "PolynomialForm",
    "PolynomialGCD",
    "PolynomialLCM",
    "PolynomialMod",
    "PolynomialQ",
    "PolynomialQuotient",
    "PolynomialQuotientRemainder",
    "PolynomialReduce",
    "PolynomialRemainder",
    "Polynomials",
    "PolynomialSumOfSquaresList",
    "PoolingLayer",
    "PopupMenu",
    "PopupMenuBox",
    "PopupMenuBoxOptions",
    "PopupView",
    "PopupWindow",
    "Position",
    "PositionIndex",
    "PositionLargest",
    "PositionSmallest",
    "Positive",
    "PositiveDefiniteMatrixQ",
    "PositiveIntegers",
    "PositivelyOrientedPoints",
    "PositiveRationals",
    "PositiveReals",
    "PositiveSemidefiniteMatrixQ",
    "PossibleZeroQ",
    "Postfix",
    "PostScript",
    "Power",
    "PowerDistribution",
    "PowerExpand",
    "PowerMod",
    "PowerModList",
    "PowerRange",
    "PowerSpectralDensity",
    "PowersRepresentations",
    "PowerSymmetricPolynomial",
    "Precedence",
    "PrecedenceForm",
    "Precedes",
    "PrecedesEqual",
    "PrecedesSlantEqual",
    "PrecedesTilde",
    "Precision",
    "PrecisionGoal",
    "PreDecrement",
    "Predict",
    "PredictionRoot",
    "PredictorFunction",
    "PredictorInformation",
    "PredictorMeasurements",
    "PredictorMeasurementsObject",
    "PreemptProtect",
    "PreferencesPath",
    "PreferencesSettings",
    "Prefix",
    "PreIncrement",
    "Prepend",
    "PrependLayer",
    "PrependTo",
    "PreprocessingRules",
    "PreserveColor",
    "PreserveImageOptions",
    "Previous",
    "PreviousCell",
    "PreviousDate",
    "PriceGraphDistribution",
    "PrimaryPlaceholder",
    "Prime",
    "PrimeNu",
    "PrimeOmega",
    "PrimePi",
    "PrimePowerQ",
    "PrimeQ",
    "Primes",
    "PrimeZetaP",
    "PrimitivePolynomialQ",
    "PrimitiveRoot",
    "PrimitiveRootList",
    "PrincipalComponents",
    "PrincipalValue",
    "Print",
    "PrintableASCIIQ",
    "PrintAction",
    "PrintForm",
    "PrintingCopies",
    "PrintingOptions",
    "PrintingPageRange",
    "PrintingStartingPageNumber",
    "PrintingStyleEnvironment",
    "Printout3D",
    "Printout3DPreviewer",
    "PrintPrecision",
    "PrintTemporary",
    "Prism",
    "PrismBox",
    "PrismBoxOptions",
    "PrivateCellOptions",
    "PrivateEvaluationOptions",
    "PrivateFontOptions",
    "PrivateFrontEndOptions",
    "PrivateKey",
    "PrivateNotebookOptions",
    "PrivatePaths",
    "Probability",
    "ProbabilityDistribution",
    "ProbabilityPlot",
    "ProbabilityPr",
    "ProbabilityScalePlot",
    "ProbitModelFit",
    "ProcessConnection",
    "ProcessDirectory",
    "ProcessEnvironment",
    "Processes",
    "ProcessEstimator",
    "ProcessInformation",
    "ProcessObject",
    "ProcessParameterAssumptions",
    "ProcessParameterQ",
    "ProcessStateDomain",
    "ProcessStatus",
    "ProcessTimeDomain",
    "Product",
    "ProductDistribution",
    "ProductLog",
    "ProgressIndicator",
    "ProgressIndicatorBox",
    "ProgressIndicatorBoxOptions",
    "ProgressReporting",
    "Projection",
    "Prolog",
    "PromptForm",
    "ProofObject",
    "PropagateAborts",
    "Properties",
    "Property",
    "PropertyList",
    "PropertyValue",
    "Proportion",
    "Proportional",
    "Protect",
    "Protected",
    "ProteinData",
    "Pruning",
    "PseudoInverse",
    "PsychrometricPropertyData",
    "PublicKey",
    "PublisherID",
    "PulsarData",
    "PunctuationCharacter",
    "Purple",
    "Put",
    "PutAppend",
    "Pyramid",
    "PyramidBox",
    "PyramidBoxOptions",
    "QBinomial",
    "QFactorial",
    "QGamma",
    "QHypergeometricPFQ",
    "QnDispersion",
    "QPochhammer",
    "QPolyGamma",
    "QRDecomposition",
    "QuadraticIrrationalQ",
    "QuadraticOptimization",
    "Quantile",
    "QuantilePlot",
    "Quantity",
    "QuantityArray",
    "QuantityDistribution",
    "QuantityForm",
    "QuantityMagnitude",
    "QuantityQ",
    "QuantityUnit",
    "QuantityVariable",
    "QuantityVariableCanonicalUnit",
    "QuantityVariableDimensions",
    "QuantityVariableIdentifier",
    "QuantityVariablePhysicalQuantity",
    "Quartics",
    "QuartileDeviation",
    "Quartiles",
    "QuartileSkewness",
    "Query",
    "QuestionGenerator",
    "QuestionInterface",
    "QuestionObject",
    "QuestionSelector",
    "QueueingNetworkProcess",
    "QueueingProcess",
    "QueueProperties",
    "Quiet",
    "QuietEcho",
    "Quit",
    "Quotient",
    "QuotientRemainder",
    "RadialAxisPlot",
    "RadialGradientFilling",
    "RadialGradientImage",
    "RadialityCentrality",
    "RadicalBox",
    "RadicalBoxOptions",
    "RadioButton",
    "RadioButtonBar",
    "RadioButtonBox",
    "RadioButtonBoxOptions",
    "Radon",
    "RadonTransform",
    "RamanujanTau",
    "RamanujanTauL",
    "RamanujanTauTheta",
    "RamanujanTauZ",
    "Ramp",
    "Random",
    "RandomArrayLayer",
    "RandomChoice",
    "RandomColor",
    "RandomComplex",
    "RandomDate",
    "RandomEntity",
    "RandomFunction",
    "RandomGeneratorState",
    "RandomGeoPosition",
    "RandomGraph",
    "RandomImage",
    "RandomInstance",
    "RandomInteger",
    "RandomPermutation",
    "RandomPoint",
    "RandomPointConfiguration",
    "RandomPolygon",
    "RandomPolyhedron",
    "RandomPrime",
    "RandomReal",
    "RandomSample",
    "RandomSeed",
    "RandomSeeding",
    "RandomTime",
    "RandomTree",
    "RandomVariate",
    "RandomWalkProcess",
    "RandomWord",
    "Range",
    "RangeFilter",
    "RangeSpecification",
    "RankedMax",
    "RankedMin",
    "RarerProbability",
    "Raster",
    "Raster3D",
    "Raster3DBox",
    "Raster3DBoxOptions",
    "RasterArray",
    "RasterBox",
    "RasterBoxOptions",
    "Rasterize",
    "RasterSize",
    "Rational",
    "RationalExpressionQ",
    "RationalFunctions",
    "Rationalize",
    "Rationals",
    "Ratios",
    "RawArray",
    "RawBoxes",
    "RawData",
    "RawMedium",
    "RayleighDistribution",
    "Re",
    "ReactionBalance",
    "ReactionBalancedQ",
    "ReactionPDETerm",
    "Read",
    "ReadByteArray",
    "ReadLine",
    "ReadList",
    "ReadProtected",
    "ReadString",
    "Real",
    "RealAbs",
    "RealBlockDiagonalForm",
    "RealDigits",
    "RealExponent",
    "Reals",
    "RealSign",
    "Reap",
    "RebuildPacletData",
    "RecalibrationFunction",
    "RecognitionPrior",
    "RecognitionThreshold",
    "ReconstructionMesh",
    "Record",
    "RecordLists",
    "RecordSeparators",
    "Rectangle",
    "RectangleBox",
    "RectangleBoxOptions",
    "RectangleChart",
    "RectangleChart3D",
    "RectangularRepeatingElement",
    "RecurrenceFilter",
    "RecurrenceTable",
    "RecurringDigitsForm",
    "Red",
    "Reduce",
    "RefBox",
    "ReferenceLineStyle",
    "ReferenceMarkers",
    "ReferenceMarkerStyle",
    "Refine",
    "ReflectionMatrix",
    "ReflectionTransform",
    "Refresh",
    "RefreshRate",
    "Region",
    "RegionBinarize",
    "RegionBoundary",
    "RegionBoundaryStyle",
    "RegionBounds",
    "RegionCentroid",
    "RegionCongruent",
    "RegionConvert",
    "RegionDifference",
    "RegionDilation",
    "RegionDimension",
    "RegionDisjoint",
    "RegionDistance",
    "RegionDistanceFunction",
    "RegionEmbeddingDimension",
    "RegionEqual",
    "RegionErosion",
    "RegionFillingStyle",
    "RegionFit",
    "RegionFunction",
    "RegionImage",
    "RegionIntersection",
    "RegionMeasure",
    "RegionMember",
    "RegionMemberFunction",
    "RegionMoment",
    "RegionNearest",
    "RegionNearestFunction",
    "RegionPlot",
    "RegionPlot3D",
    "RegionProduct",
    "RegionQ",
    "RegionResize",
    "RegionSimilar",
    "RegionSize",
    "RegionSymmetricDifference",
    "RegionUnion",
    "RegionWithin",
    "RegisterExternalEvaluator",
    "RegularExpression",
    "Regularization",
    "RegularlySampledQ",
    "RegularPolygon",
    "ReIm",
    "ReImLabels",
    "ReImPlot",
    "ReImStyle",
    "Reinstall",
    "RelationalDatabase",
    "RelationGraph",
    "Release",
    "ReleaseHold",
    "ReliabilityDistribution",
    "ReliefImage",
    "ReliefPlot",
    "RemoteAuthorizationCaching",
    "RemoteBatchJobAbort",
    "RemoteBatchJobObject",
    "RemoteBatchJobs",
    "RemoteBatchMapSubmit",
    "RemoteBatchSubmissionEnvironment",
    "RemoteBatchSubmit",
    "RemoteConnect",
    "RemoteConnectionObject",
    "RemoteEvaluate",
    "RemoteFile",
    "RemoteInputFiles",
    "RemoteKernelObject",
    "RemoteProviderSettings",
    "RemoteRun",
    "RemoteRunProcess",
    "RemovalConditions",
    "Remove",
    "RemoveAlphaChannel",
    "RemoveAsynchronousTask",
    "RemoveAudioStream",
    "RemoveBackground",
    "RemoveChannelListener",
    "RemoveChannelSubscribers",
    "Removed",
    "RemoveDiacritics",
    "RemoveInputStreamMethod",
    "RemoveOutputStreamMethod",
    "RemoveProperty",
    "RemoveScheduledTask",
    "RemoveUsers",
    "RemoveVideoStream",
    "RenameDirectory",
    "RenameFile",
    "RenderAll",
    "RenderingOptions",
    "RenewalProcess",
    "RenkoChart",
    "RepairMesh",
    "Repeated",
    "RepeatedNull",
    "RepeatedString",
    "RepeatedTiming",
    "RepeatingElement",
    "Replace",
    "ReplaceAll",
    "ReplaceAt",
    "ReplaceHeldPart",
    "ReplaceImageValue",
    "ReplaceList",
    "ReplacePart",
    "ReplacePixelValue",
    "ReplaceRepeated",
    "ReplicateLayer",
    "RequiredPhysicalQuantities",
    "Resampling",
    "ResamplingAlgorithmData",
    "ResamplingMethod",
    "Rescale",
    "RescalingTransform",
    "ResetDirectory",
    "ResetScheduledTask",
    "ReshapeLayer",
    "Residue",
    "ResidueSum",
    "ResizeLayer",
    "Resolve",
    "ResolveContextAliases",
    "ResourceAcquire",
    "ResourceData",
    "ResourceFunction",
    "ResourceObject",
    "ResourceRegister",
    "ResourceRemove",
    "ResourceSearch",
    "ResourceSubmissionObject",
    "ResourceSubmit",
    "ResourceSystemBase",
    "ResourceSystemPath",
    "ResourceUpdate",
    "ResourceVersion",
    "ResponseForm",
    "Rest",
    "RestartInterval",
    "Restricted",
    "Resultant",
    "ResumePacket",
    "Return",
    "ReturnCreatesNewCell",
    "ReturnEntersInput",
    "ReturnExpressionPacket",
    "ReturnInputFormPacket",
    "ReturnPacket",
    "ReturnReceiptFunction",
    "ReturnTextPacket",
    "Reverse",
    "ReverseApplied",
    "ReverseBiorthogonalSplineWavelet",
    "ReverseElement",
    "ReverseEquilibrium",
    "ReverseGraph",
    "ReverseSort",
    "ReverseSortBy",
    "ReverseUpEquilibrium",
    "RevolutionAxis",
    "RevolutionPlot3D",
    "RGBColor",
    "RiccatiSolve",
    "RiceDistribution",
    "RidgeFilter",
    "RiemannR",
    "RiemannSiegelTheta",
    "RiemannSiegelZ",
    "RiemannXi",
    "Riffle",
    "Right",
    "RightArrow",
    "RightArrowBar",
    "RightArrowLeftArrow",
    "RightComposition",
    "RightCosetRepresentative",
    "RightDownTeeVector",
    "RightDownVector",
    "RightDownVectorBar",
    "RightTee",
    "RightTeeArrow",
    "RightTeeVector",
    "RightTriangle",
    "RightTriangleBar",
    "RightTriangleEqual",
    "RightUpDownVector",
    "RightUpTeeVector",
    "RightUpVector",
    "RightUpVectorBar",
    "RightVector",
    "RightVectorBar",
    "RipleyK",
    "RipleyRassonRegion",
    "RiskAchievementImportance",
    "RiskReductionImportance",
    "RobustConvexOptimization",
    "RogersTanimotoDissimilarity",
    "RollPitchYawAngles",
    "RollPitchYawMatrix",
    "RomanNumeral",
    "Root",
    "RootApproximant",
    "RootIntervals",
    "RootLocusPlot",
    "RootMeanSquare",
    "RootOfUnityQ",
    "RootReduce",
    "Roots",
    "RootSum",
    "RootTree",
    "Rotate",
    "RotateLabel",
    "RotateLeft",
    "RotateRight",
    "RotationAction",
    "RotationBox",
    "RotationBoxOptions",
    "RotationMatrix",
    "RotationTransform",
    "Round",
    "RoundImplies",
    "RoundingRadius",
    "Row",
    "RowAlignments",
    "RowBackgrounds",
    "RowBox",
    "RowHeights",
    "RowLines",
    "RowMinHeight",
    "RowReduce",
    "RowsEqual",
    "RowSpacings",
    "RSolve",
    "RSolveValue",
    "RudinShapiro",
    "RudvalisGroupRu",
    "Rule",
    "RuleCondition",
    "RuleDelayed",
    "RuleForm",
    "RulePlot",
    "RulerUnits",
    "RulesTree",
    "Run",
    "RunProcess",
    "RunScheduledTask",
    "RunThrough",
    "RuntimeAttributes",
    "RuntimeOptions",
    "RussellRaoDissimilarity",
    "SameAs",
    "SameQ",
    "SameTest",
    "SameTestProperties",
    "SampledEntityClass",
    "SampleDepth",
    "SampledSoundFunction",
    "SampledSoundList",
    "SampleRate",
    "SamplingPeriod",
    "SARIMAProcess",
    "SARMAProcess",
    "SASTriangle",
    "SatelliteData",
    "SatisfiabilityCount",
    "SatisfiabilityInstances",
    "SatisfiableQ",
    "Saturday",
    "Save",
    "Saveable",
    "SaveAutoDelete",
    "SaveConnection",
    "SaveDefinitions",
    "SavitzkyGolayMatrix",
    "SawtoothWave",
    "Scale",
    "Scaled",
    "ScaleDivisions",
    "ScaledMousePosition",
    "ScaleOrigin",
    "ScalePadding",
    "ScaleRanges",
    "ScaleRangeStyle",
    "ScalingFunctions",
    "ScalingMatrix",
    "ScalingTransform",
    "Scan",
    "ScheduledTask",
    "ScheduledTaskActiveQ",
    "ScheduledTaskInformation",
    "ScheduledTaskInformationData",
    "ScheduledTaskObject",
    "ScheduledTasks",
    "SchurDecomposition",
    "ScientificForm",
    "ScientificNotationThreshold",
    "ScorerGi",
    "ScorerGiPrime",
    "ScorerHi",
    "ScorerHiPrime",
    "ScreenRectangle",
    "ScreenStyleEnvironment",
    "ScriptBaselineShifts",
    "ScriptForm",
    "ScriptLevel",
    "ScriptMinSize",
    "ScriptRules",
    "ScriptSizeMultipliers",
    "Scrollbars",
    "ScrollingOptions",
    "ScrollPosition",
    "SearchAdjustment",
    "SearchIndexObject",
    "SearchIndices",
    "SearchQueryString",
    "SearchResultObject",
    "Sec",
    "Sech",
    "SechDistribution",
    "SecondOrderConeOptimization",
    "SectionGrouping",
    "SectorChart",
    "SectorChart3D",
    "SectorOrigin",
    "SectorSpacing",
    "SecuredAuthenticationKey",
    "SecuredAuthenticationKeys",
    "SecurityCertificate",
    "SeedRandom",
    "Select",
    "Selectable",
    "SelectComponents",
    "SelectedCells",
    "SelectedNotebook",
    "SelectFirst",
    "Selection",
    "SelectionAnimate",
    "SelectionCell",
    "SelectionCellCreateCell",
    "SelectionCellDefaultStyle",
    "SelectionCellParentStyle",
    "SelectionCreateCell",
    "SelectionDebuggerTag",
    "SelectionEvaluate",
    "SelectionEvaluateCreateCell",
    "SelectionMove",
    "SelectionPlaceholder",
    "SelectWithContents",
    "SelfLoops",
    "SelfLoopStyle",
    "SemanticImport",
    "SemanticImportString",
    "SemanticInterpretation",
    "SemialgebraicComponentInstances",
    "SemidefiniteOptimization",
    "SendMail",
    "SendMessage",
    "Sequence",
    "SequenceAlignment",
    "SequenceAttentionLayer",
    "SequenceCases",
    "SequenceCount",
    "SequenceFold",
    "SequenceFoldList",
    "SequenceForm",
    "SequenceHold",
    "SequenceIndicesLayer",
    "SequenceLastLayer",
    "SequenceMostLayer",
    "SequencePosition",
    "SequencePredict",
    "SequencePredictorFunction",
    "SequenceReplace",
    "SequenceRestLayer",
    "SequenceReverseLayer",
    "SequenceSplit",
    "Series",
    "SeriesCoefficient",
    "SeriesData",
    "SeriesTermGoal",
    "ServiceConnect",
    "ServiceDisconnect",
    "ServiceExecute",
    "ServiceObject",
    "ServiceRequest",
    "ServiceResponse",
    "ServiceSubmit",
    "SessionSubmit",
    "SessionTime",
    "Set",
    "SetAccuracy",
    "SetAlphaChannel",
    "SetAttributes",
    "Setbacks",
    "SetCloudDirectory",
    "SetCookies",
    "SetDelayed",
    "SetDirectory",
    "SetEnvironment",
    "SetFileDate",
    "SetFileFormatProperties",
    "SetOptions",
    "SetOptionsPacket",
    "SetPermissions",
    "SetPrecision",
    "SetProperty",
    "SetSecuredAuthenticationKey",
    "SetSelectedNotebook",
    "SetSharedFunction",
    "SetSharedVariable",
    "SetStreamPosition",
    "SetSystemModel",
    "SetSystemOptions",
    "Setter",
    "SetterBar",
    "SetterBox",
    "SetterBoxOptions",
    "Setting",
    "SetUsers",
    "Shading",
    "Shallow",
    "ShannonWavelet",
    "ShapiroWilkTest",
    "Share",
    "SharingList",
    "Sharpen",
    "ShearingMatrix",
    "ShearingTransform",
    "ShellRegion",
    "ShenCastanMatrix",
    "ShiftedGompertzDistribution",
    "ShiftRegisterSequence",
    "Short",
    "ShortDownArrow",
    "Shortest",
    "ShortestMatch",
    "ShortestPathFunction",
    "ShortLeftArrow",
    "ShortRightArrow",
    "ShortTimeFourier",
    "ShortTimeFourierData",
    "ShortUpArrow",
    "Show",
    "ShowAutoConvert",
    "ShowAutoSpellCheck",
    "ShowAutoStyles",
    "ShowCellBracket",
    "ShowCellLabel",
    "ShowCellTags",
    "ShowClosedCellArea",
    "ShowCodeAssist",
    "ShowContents",
    "ShowControls",
    "ShowCursorTracker",
    "ShowGroupOpenCloseIcon",
    "ShowGroupOpener",
    "ShowInvisibleCharacters",
    "ShowPageBreaks",
    "ShowPredictiveInterface",
    "ShowSelection",
    "ShowShortBoxForm",
    "ShowSpecialCharacters",
    "ShowStringCharacters",
    "ShowSyntaxStyles",
    "ShrinkingDelay",
    "ShrinkWrapBoundingBox",
    "SiderealTime",
    "SiegelTheta",
    "SiegelTukeyTest",
    "SierpinskiCurve",
    "SierpinskiMesh",
    "Sign",
    "Signature",
    "SignedRankTest",
    "SignedRegionDistance",
    "SignificanceLevel",
    "SignPadding",
    "SignTest",
    "SimilarityRules",
    "SimpleGraph",
    "SimpleGraphQ",
    "SimplePolygonQ",
    "SimplePolyhedronQ",
    "Simplex",
    "Simplify",
    "Sin",
    "Sinc",
    "SinghMaddalaDistribution",
    "SingleEvaluation",
    "SingleLetterItalics",
    "SingleLetterStyle",
    "SingularValueDecomposition",
    "SingularValueList",
    "SingularValuePlot",
    "SingularValues",
    "Sinh",
    "SinhIntegral",
    "SinIntegral",
    "SixJSymbol",
    "Skeleton",
    "SkeletonTransform",
    "SkellamDistribution",
    "Skewness",
    "SkewNormalDistribution",
    "SkinStyle",
    "Skip",
    "SliceContourPlot3D",
    "SliceDensityPlot3D",
    "SliceDistribution",
    "SliceVectorPlot3D",
    "Slider",
    "Slider2D",
    "Slider2DBox",
    "Slider2DBoxOptions",
    "SliderBox",
    "SliderBoxOptions",
    "SlideShowVideo",
    "SlideView",
    "Slot",
    "SlotSequence",
    "Small",
    "SmallCircle",
    "Smaller",
    "SmithDecomposition",
    "SmithDelayCompensator",
    "SmithWatermanSimilarity",
    "SmoothDensityHistogram",
    "SmoothHistogram",
    "SmoothHistogram3D",
    "SmoothKernelDistribution",
    "SmoothPointDensity",
    "SnDispersion",
    "Snippet",
    "SnippetsVideo",
    "SnubPolyhedron",
    "SocialMediaData",
    "Socket",
    "SocketConnect",
    "SocketListen",
    "SocketListener",
    "SocketObject",
    "SocketOpen",
    "SocketReadMessage",
    "SocketReadyQ",
    "Sockets",
    "SocketWaitAll",
    "SocketWaitNext",
    "SoftmaxLayer",
    "SokalSneathDissimilarity",
    "SolarEclipse",
    "SolarSystemFeatureData",
    "SolarTime",
    "SolidAngle",
    "SolidBoundaryLoadValue",
    "SolidData",
    "SolidDisplacementCondition",
    "SolidFixedCondition",
    "SolidMechanicsPDEComponent",
    "SolidMechanicsStrain",
    "SolidMechanicsStress",
    "SolidRegionQ",
    "Solve",
    "SolveAlways",
    "SolveDelayed",
    "SolveValues",
    "Sort",
    "SortBy",
    "SortedBy",
    "SortedEntityClass",
    "Sound",
    "SoundAndGraphics",
    "SoundNote",
    "SoundVolume",
    "SourceLink",
    "SourcePDETerm",
    "Sow",
    "Space",
    "SpaceCurveData",
    "SpaceForm",
    "Spacer",
    "Spacings",
    "Span",
    "SpanAdjustments",
    "SpanCharacterRounding",
    "SpanFromAbove",
    "SpanFromBoth",
    "SpanFromLeft",
    "SpanLineThickness",
    "SpanMaxSize",
    "SpanMinSize",
    "SpanningCharacters",
    "SpanSymmetric",
    "SparseArray",
    "SparseArrayQ",
    "SpatialBinnedPointData",
    "SpatialBoundaryCorrection",
    "SpatialEstimate",
    "SpatialEstimatorFunction",
    "SpatialGraphDistribution",
    "SpatialJ",
    "SpatialMedian",
    "SpatialNoiseLevel",
    "SpatialObservationRegionQ",
    "SpatialPointData",
    "SpatialPointSelect",
    "SpatialRandomnessTest",
    "SpatialTransformationLayer",
    "SpatialTrendFunction",
    "Speak",
    "SpeakerMatchQ",
    "SpearmanRankTest",
    "SpearmanRho",
    "SpeciesData",
    "SpecificityGoal",
    "SpectralLineData",
    "Spectrogram",
    "SpectrogramArray",
    "Specularity",
    "SpeechCases",
    "SpeechInterpreter",
    "SpeechRecognize",
    "SpeechSynthesize",
    "SpellingCorrection",
    "SpellingCorrectionList",
    "SpellingDictionaries",
    "SpellingDictionariesPath",
    "SpellingOptions",
    "Sphere",
    "SphereBox",
    "SphereBoxOptions",
    "SpherePoints",
    "SphericalBesselJ",
    "SphericalBesselY",
    "SphericalHankelH1",
    "SphericalHankelH2",
    "SphericalHarmonicY",
    "SphericalPlot3D",
    "SphericalRegion",
    "SphericalShell",
    "SpheroidalEigenvalue",
    "SpheroidalJoiningFactor",
    "SpheroidalPS",
    "SpheroidalPSPrime",
    "SpheroidalQS",
    "SpheroidalQSPrime",
    "SpheroidalRadialFactor",
    "SpheroidalS1",
    "SpheroidalS1Prime",
    "SpheroidalS2",
    "SpheroidalS2Prime",
    "Splice",
    "SplicedDistribution",
    "SplineClosed",
    "SplineDegree",
    "SplineKnots",
    "SplineWeights",
    "Split",
    "SplitBy",
    "SpokenString",
    "SpotLight",
    "Sqrt",
    "SqrtBox",
    "SqrtBoxOptions",
    "Square",
    "SquaredEuclideanDistance",
    "SquareFreeQ",
    "SquareIntersection",
    "SquareMatrixQ",
    "SquareRepeatingElement",
    "SquaresR",
    "SquareSubset",
    "SquareSubsetEqual",
    "SquareSuperset",
    "SquareSupersetEqual",
    "SquareUnion",
    "SquareWave",
    "SSSTriangle",
    "StabilityMargins",
    "StabilityMarginsStyle",
    "StableDistribution",
    "Stack",
    "StackBegin",
    "StackComplete",
    "StackedDateListPlot",
    "StackedListPlot",
    "StackInhibit",
    "StadiumShape",
    "StandardAtmosphereData",
    "StandardDeviation",
    "StandardDeviationFilter",
    "StandardForm",
    "Standardize",
    "Standardized",
    "StandardOceanData",
    "StandbyDistribution",
    "Star",
    "StarClusterData",
    "StarData",
    "StarGraph",
    "StartAsynchronousTask",
    "StartExternalSession",
    "StartingStepSize",
    "StartOfLine",
    "StartOfString",
    "StartProcess",
    "StartScheduledTask",
    "StartupSound",
    "StartWebSession",
    "StateDimensions",
    "StateFeedbackGains",
    "StateOutputEstimator",
    "StateResponse",
    "StateSpaceModel",
    "StateSpaceRealization",
    "StateSpaceTransform",
    "StateTransformationLinearize",
    "StationaryDistribution",
    "StationaryWaveletPacketTransform",
    "StationaryWaveletTransform",
    "StatusArea",
    "StatusCentrality",
    "StepMonitor",
    "StereochemistryElements",
    "StieltjesGamma",
    "StippleShading",
    "StirlingS1",
    "StirlingS2",
    "StopAsynchronousTask",
    "StoppingPowerData",
    "StopScheduledTask",
    "StrataVariables",
    "StratonovichProcess",
    "StraussHardcorePointProcess",
    "StraussPointProcess",
    "StreamColorFunction",
    "StreamColorFunctionScaling",
    "StreamDensityPlot",
    "StreamMarkers",
    "StreamPlot",
    "StreamPlot3D",
    "StreamPoints",
    "StreamPosition",
    "Streams",
    "StreamScale",
    "StreamStyle",
    "StrictInequalities",
    "String",
    "StringBreak",
    "StringByteCount",
    "StringCases",
    "StringContainsQ",
    "StringCount",
    "StringDelete",
    "StringDrop",
    "StringEndsQ",
    "StringExpression",
    "StringExtract",
    "StringForm",
    "StringFormat",
    "StringFormatQ",
    "StringFreeQ",
    "StringInsert",
    "StringJoin",
    "StringLength",
    "StringMatchQ",
    "StringPadLeft",
    "StringPadRight",
    "StringPart",
    "StringPartition",
    "StringPosition",
    "StringQ",
    "StringRepeat",
    "StringReplace",
    "StringReplaceList",
    "StringReplacePart",
    "StringReverse",
    "StringRiffle",
    "StringRotateLeft",
    "StringRotateRight",
    "StringSkeleton",
    "StringSplit",
    "StringStartsQ",
    "StringTake",
    "StringTakeDrop",
    "StringTemplate",
    "StringToByteArray",
    "StringToStream",
    "StringTrim",
    "StripBoxes",
    "StripOnInput",
    "StripStyleOnPaste",
    "StripWrapperBoxes",
    "StrokeForm",
    "Struckthrough",
    "StructuralImportance",
    "StructuredArray",
    "StructuredArrayHeadQ",
    "StructuredSelection",
    "StruveH",
    "StruveL",
    "Stub",
    "StudentTDistribution",
    "Style",
    "StyleBox",
    "StyleBoxAutoDelete",
    "StyleData",
    "StyleDefinitions",
    "StyleForm",
    "StyleHints",
    "StyleKeyMapping",
    "StyleMenuListing",
    "StyleNameDialogSettings",
    "StyleNames",
    "StylePrint",
    "StyleSheetPath",
    "Subdivide",
    "Subfactorial",
    "Subgraph",
    "SubMinus",
    "SubPlus",
    "SubresultantPolynomialRemainders",
    "SubresultantPolynomials",
    "Subresultants",
    "Subscript",
    "SubscriptBox",
    "SubscriptBoxOptions",
    "Subscripted",
    "Subsequences",
    "Subset",
    "SubsetCases",
    "SubsetCount",
    "SubsetEqual",
    "SubsetMap",
    "SubsetPosition",
    "SubsetQ",
    "SubsetReplace",
    "Subsets",
    "SubStar",
    "SubstitutionSystem",
    "Subsuperscript",
    "SubsuperscriptBox",
    "SubsuperscriptBoxOptions",
    "SubtitleEncoding",
    "SubtitleTrackSelection",
    "Subtract",
    "SubtractFrom",
    "SubtractSides",
    "SubValues",
    "Succeeds",
    "SucceedsEqual",
    "SucceedsSlantEqual",
    "SucceedsTilde",
    "Success",
    "SuchThat",
    "Sum",
    "SumConvergence",
    "SummationLayer",
    "Sunday",
    "SunPosition",
    "Sunrise",
    "Sunset",
    "SuperDagger",
    "SuperMinus",
    "SupernovaData",
    "SuperPlus",
    "Superscript",
    "SuperscriptBox",
    "SuperscriptBoxOptions",
    "Superset",
    "SupersetEqual",
    "SuperStar",
    "Surd",
    "SurdForm",
    "SurfaceAppearance",
    "SurfaceArea",
    "SurfaceColor",
    "SurfaceData",
    "SurfaceGraphics",
    "SurvivalDistribution",
    "SurvivalFunction",
    "SurvivalModel",
    "SurvivalModelFit",
    "SuspendPacket",
    "SuzukiDistribution",
    "SuzukiGroupSuz",
    "SwatchLegend",
    "Switch",
    "Symbol",
    "SymbolName",
    "SymletWavelet",
    "Symmetric",
    "SymmetricDifference",
    "SymmetricGroup",
    "SymmetricKey",
    "SymmetricMatrixQ",
    "SymmetricPolynomial",
    "SymmetricReduction",
    "Symmetrize",
    "SymmetrizedArray",
    "SymmetrizedArrayRules",
    "SymmetrizedDependentComponents",
    "SymmetrizedIndependentComponents",
    "SymmetrizedReplacePart",
    "SynchronousInitialization",
    "SynchronousUpdating",
    "Synonyms",
    "Syntax",
    "SyntaxForm",
    "SyntaxInformation",
    "SyntaxLength",
    "SyntaxPacket",
    "SyntaxQ",
    "SynthesizeMissingValues",
    "SystemCredential",
    "SystemCredentialData",
    "SystemCredentialKey",
    "SystemCredentialKeys",
    "SystemCredentialStoreObject",
    "SystemDialogInput",
    "SystemException",
    "SystemGet",
    "SystemHelpPath",
    "SystemInformation",
    "SystemInformationData",
    "SystemInstall",
    "SystemModel",
    "SystemModeler",
    "SystemModelExamples",
    "SystemModelLinearize",
    "SystemModelMeasurements",
    "SystemModelParametricSimulate",
    "SystemModelPlot",
    "SystemModelProgressReporting",
    "SystemModelReliability",
    "SystemModels",
    "SystemModelSimulate",
    "SystemModelSimulateSensitivity",
    "SystemModelSimulationData",
    "SystemOpen",
    "SystemOptions",
    "SystemProcessData",
    "SystemProcesses",
    "SystemsConnectionsModel",
    "SystemsModelControllerData",
    "SystemsModelDelay",
    "SystemsModelDelayApproximate",
    "SystemsModelDelete",
    "SystemsModelDimensions",
    "SystemsModelExtract",
    "SystemsModelFeedbackConnect",
    "SystemsModelLabels",
    "SystemsModelLinearity",
    "SystemsModelMerge",
    "SystemsModelOrder",
    "SystemsModelParallelConnect",
    "SystemsModelSeriesConnect",
    "SystemsModelStateFeedbackConnect",
    "SystemsModelVectorRelativeOrders",
    "SystemStub",
    "SystemTest",
    "Tab",
    "TabFilling",
    "Table",
    "TableAlignments",
    "TableDepth",
    "TableDirections",
    "TableForm",
    "TableHeadings",
    "TableSpacing",
    "TableView",
    "TableViewBox",
    "TableViewBoxAlignment",
    "TableViewBoxBackground",
    "TableViewBoxHeaders",
    "TableViewBoxItemSize",
    "TableViewBoxItemStyle",
    "TableViewBoxOptions",
    "TabSpacings",
    "TabView",
    "TabViewBox",
    "TabViewBoxOptions",
    "TagBox",
    "TagBoxNote",
    "TagBoxOptions",
    "TaggingRules",
    "TagSet",
    "TagSetDelayed",
    "TagStyle",
    "TagUnset",
    "Take",
    "TakeDrop",
    "TakeLargest",
    "TakeLargestBy",
    "TakeList",
    "TakeSmallest",
    "TakeSmallestBy",
    "TakeWhile",
    "Tally",
    "Tan",
    "Tanh",
    "TargetDevice",
    "TargetFunctions",
    "TargetSystem",
    "TargetUnits",
    "TaskAbort",
    "TaskExecute",
    "TaskObject",
    "TaskRemove",
    "TaskResume",
    "Tasks",
    "TaskSuspend",
    "TaskWait",
    "TautologyQ",
    "TelegraphProcess",
    "TemplateApply",
    "TemplateArgBox",
    "TemplateBox",
    "TemplateBoxOptions",
    "TemplateEvaluate",
    "TemplateExpression",
    "TemplateIf",
    "TemplateObject",
    "TemplateSequence",
    "TemplateSlot",
    "TemplateSlotSequence",
    "TemplateUnevaluated",
    "TemplateVerbatim",
    "TemplateWith",
    "TemporalData",
    "TemporalRegularity",
    "Temporary",
    "TemporaryVariable",
    "TensorContract",
    "TensorDimensions",
    "TensorExpand",
    "TensorProduct",
    "TensorQ",
    "TensorRank",
    "TensorReduce",
    "TensorSymmetry",
    "TensorTranspose",
    "TensorWedge",
    "TerminatedEvaluation",
    "TernaryListPlot",
    "TernaryPlotCorners",
    "TestID",
    "TestReport",
    "TestReportObject",
    "TestResultObject",
    "Tetrahedron",
    "TetrahedronBox",
    "TetrahedronBoxOptions",
    "TeXForm",
    "TeXSave",
    "Text",
    "Text3DBox",
    "Text3DBoxOptions",
    "TextAlignment",
    "TextBand",
    "TextBoundingBox",
    "TextBox",
    "TextCases",
    "TextCell",
    "TextClipboardType",
    "TextContents",
    "TextData",
    "TextElement",
    "TextForm",
    "TextGrid",
    "TextJustification",
    "TextLine",
    "TextPacket",
    "TextParagraph",
    "TextPosition",
    "TextRecognize",
    "TextSearch",
    "TextSearchReport",
    "TextSentences",
    "TextString",
    "TextStructure",
    "TextStyle",
    "TextTranslation",
    "Texture",
    "TextureCoordinateFunction",
    "TextureCoordinateScaling",
    "TextWords",
    "Therefore",
    "ThermodynamicData",
    "ThermometerGauge",
    "Thick",
    "Thickness",
    "Thin",
    "Thinning",
    "ThisLink",
    "ThomasPointProcess",
    "ThompsonGroupTh",
    "Thread",
    "Threaded",
    "ThreadingLayer",
    "ThreeJSymbol",
    "Threshold",
    "Through",
    "Throw",
    "ThueMorse",
    "Thumbnail",
    "Thursday",
    "TickDirection",
    "TickLabelOrientation",
    "TickLabelPositioning",
    "TickLabels",
    "TickLengths",
    "TickPositions",
    "Ticks",
    "TicksStyle",
    "TideData",
    "Tilde",
    "TildeEqual",
    "TildeFullEqual",
    "TildeTilde",
    "TimeConstrained",
    "TimeConstraint",
    "TimeDirection",
    "TimeFormat",
    "TimeGoal",
    "TimelinePlot",
    "TimeObject",
    "TimeObjectQ",
    "TimeRemaining",
    "Times",
    "TimesBy",
    "TimeSeries",
    "TimeSeriesAggregate",
    "TimeSeriesForecast",
    "TimeSeriesInsert",
    "TimeSeriesInvertibility",
    "TimeSeriesMap",
    "TimeSeriesMapThread",
    "TimeSeriesModel",
    "TimeSeriesModelFit",
    "TimeSeriesResample",
    "TimeSeriesRescale",
    "TimeSeriesShift",
    "TimeSeriesThread",
    "TimeSeriesWindow",
    "TimeSystem",
    "TimeSystemConvert",
    "TimeUsed",
    "TimeValue",
    "TimeWarpingCorrespondence",
    "TimeWarpingDistance",
    "TimeZone",
    "TimeZoneConvert",
    "TimeZoneOffset",
    "Timing",
    "Tiny",
    "TitleGrouping",
    "TitsGroupT",
    "ToBoxes",
    "ToCharacterCode",
    "ToColor",
    "ToContinuousTimeModel",
    "ToDate",
    "Today",
    "ToDiscreteTimeModel",
    "ToEntity",
    "ToeplitzMatrix",
    "ToExpression",
    "ToFileName",
    "Together",
    "Toggle",
    "ToggleFalse",
    "Toggler",
    "TogglerBar",
    "TogglerBox",
    "TogglerBoxOptions",
    "ToHeldExpression",
    "ToInvertibleTimeSeries",
    "TokenWords",
    "Tolerance",
    "ToLowerCase",
    "Tomorrow",
    "ToNumberField",
    "TooBig",
    "Tooltip",
    "TooltipBox",
    "TooltipBoxOptions",
    "TooltipDelay",
    "TooltipStyle",
    "ToonShading",
    "Top",
    "TopHatTransform",
    "ToPolarCoordinates",
    "TopologicalSort",
    "ToRadicals",
    "ToRawPointer",
    "ToRules",
    "Torus",
    "TorusGraph",
    "ToSphericalCoordinates",
    "ToString",
    "Total",
    "TotalHeight",
    "TotalLayer",
    "TotalVariationFilter",
    "TotalWidth",
    "TouchPosition",
    "TouchscreenAutoZoom",
    "TouchscreenControlPlacement",
    "ToUpperCase",
    "TourVideo",
    "Tr",
    "Trace",
    "TraceAbove",
    "TraceAction",
    "TraceBackward",
    "TraceDepth",
    "TraceDialog",
    "TraceForward",
    "TraceInternal",
    "TraceLevel",
    "TraceOff",
    "TraceOn",
    "TraceOriginal",
    "TracePrint",
    "TraceScan",
    "TrackCellChangeTimes",
    "TrackedSymbols",
    "TrackingFunction",
    "TracyWidomDistribution",
    "TradingChart",
    "TraditionalForm",
    "TraditionalFunctionNotation",
    "TraditionalNotation",
    "TraditionalOrder",
    "TrainImageContentDetector",
    "TrainingProgressCheckpointing",
    "TrainingProgressFunction",
    "TrainingProgressMeasurements",
    "TrainingProgressReporting",
    "TrainingStoppingCriterion",
    "TrainingUpdateSchedule",
    "TrainTextContentDetector",
    "TransferFunctionCancel",
    "TransferFunctionExpand",
    "TransferFunctionFactor",
    "TransferFunctionModel",
    "TransferFunctionPoles",
    "TransferFunctionTransform",
    "TransferFunctionZeros",
    "TransformationClass",
    "TransformationFunction",
    "TransformationFunctions",
    "TransformationMatrix",
    "TransformedDistribution",
    "TransformedField",
    "TransformedProcess",
    "TransformedRegion",
    "TransitionDirection",
    "TransitionDuration",
    "TransitionEffect",
    "TransitiveClosureGraph",
    "TransitiveReductionGraph",
    "Translate",
    "TranslationOptions",
    "TranslationTransform",
    "Transliterate",
    "Transparent",
    "TransparentColor",
    "Transpose",
    "TransposeLayer",
    "TrapEnterKey",
    "TrapSelection",
    "TravelDirections",
    "TravelDirectionsData",
    "TravelDistance",
    "TravelDistanceList",
    "TravelMethod",
    "TravelTime",
    "Tree",
    "TreeCases",
    "TreeChildren",
    "TreeCount",
    "TreeData",
    "TreeDelete",
    "TreeDepth",
    "TreeElementCoordinates",
    "TreeElementLabel",
    "TreeElementLabelFunction",
    "TreeElementLabelStyle",
    "TreeElementShape",
    "TreeElementShapeFunction",
    "TreeElementSize",
    "TreeElementSizeFunction",
    "TreeElementStyle",
    "TreeElementStyleFunction",
    "TreeExpression",
    "TreeExtract",
    "TreeFold",
    "TreeForm",
    "TreeGraph",
    "TreeGraphQ",
    "TreeInsert",
    "TreeLayout",
    "TreeLeafCount",
    "TreeLeafQ",
    "TreeLeaves",
    "TreeLevel",
    "TreeMap",
    "TreeMapAt",
    "TreeOutline",
    "TreePlot",
    "TreePosition",
    "TreeQ",
    "TreeReplacePart",
    "TreeRules",
    "TreeScan",
    "TreeSelect",
    "TreeSize",
    "TreeTraversalOrder",
    "TrendStyle",
    "Triangle",
    "TriangleCenter",
    "TriangleConstruct",
    "TriangleMeasurement",
    "TriangleWave",
    "TriangularDistribution",
    "TriangulateMesh",
    "Trig",
    "TrigExpand",
    "TrigFactor",
    "TrigFactorList",
    "Trigger",
    "TrigReduce",
    "TrigToExp",
    "TrimmedMean",
    "TrimmedVariance",
    "TropicalStormData",
    "True",
    "TrueQ",
    "TruncatedDistribution",
    "TruncatedPolyhedron",
    "TsallisQExponentialDistribution",
    "TsallisQGaussianDistribution",
    "TTest",
    "Tube",
    "TubeBezierCurveBox",
    "TubeBezierCurveBoxOptions",
    "TubeBox",
    "TubeBoxOptions",
    "TubeBSplineCurveBox",
    "TubeBSplineCurveBoxOptions",
    "Tuesday",
    "TukeyLambdaDistribution",
    "TukeyWindow",
    "TunnelData",
    "Tuples",
    "TuranGraph",
    "TuringMachine",
    "TuttePolynomial",
    "TwoWayRule",
    "Typed",
    "TypeDeclaration",
    "TypeEvaluate",
    "TypeHint",
    "TypeOf",
    "TypeSpecifier",
    "UnateQ",
    "Uncompress",
    "UnconstrainedParameters",
    "Undefined",
    "UnderBar",
    "Underflow",
    "Underlined",
    "Underoverscript",
    "UnderoverscriptBox",
    "UnderoverscriptBoxOptions",
    "Underscript",
    "UnderscriptBox",
    "UnderscriptBoxOptions",
    "UnderseaFeatureData",
    "UndirectedEdge",
    "UndirectedGraph",
    "UndirectedGraphQ",
    "UndoOptions",
    "UndoTrackedVariables",
    "Unequal",
    "UnequalTo",
    "Unevaluated",
    "UniformDistribution",
    "UniformGraphDistribution",
    "UniformPolyhedron",
    "UniformSumDistribution",
    "Uninstall",
    "Union",
    "UnionedEntityClass",
    "UnionPlus",
    "Unique",
    "UniqueElements",
    "UnitaryMatrixQ",
    "UnitBox",
    "UnitConvert",
    "UnitDimensions",
    "Unitize",
    "UnitRootTest",
    "UnitSimplify",
    "UnitStep",
    "UnitSystem",
    "UnitTriangle",
    "UnitVector",
    "UnitVectorLayer",
    "UnityDimensions",
    "UniverseModelData",
    "UniversityData",
    "UnixTime",
    "UnlabeledTree",
    "UnmanageObject",
    "Unprotect",
    "UnregisterExternalEvaluator",
    "UnsameQ",
    "UnsavedVariables",
    "Unset",
    "UnsetShared",
    "Until",
    "UntrackedVariables",
    "Up",
    "UpArrow",
    "UpArrowBar",
    "UpArrowDownArrow",
    "Update",
    "UpdateDynamicObjects",
    "UpdateDynamicObjectsSynchronous",
    "UpdateInterval",
    "UpdatePacletSites",
    "UpdateSearchIndex",
    "UpDownArrow",
    "UpEquilibrium",
    "UpperCaseQ",
    "UpperLeftArrow",
    "UpperRightArrow",
    "UpperTriangularize",
    "UpperTriangularMatrix",
    "UpperTriangularMatrixQ",
    "Upsample",
    "UpSet",
    "UpSetDelayed",
    "UpTee",
    "UpTeeArrow",
    "UpTo",
    "UpValues",
    "URL",
    "URLBuild",
    "URLDecode",
    "URLDispatcher",
    "URLDownload",
    "URLDownloadSubmit",
    "URLEncode",
    "URLExecute",
    "URLExpand",
    "URLFetch",
    "URLFetchAsynchronous",
    "URLParse",
    "URLQueryDecode",
    "URLQueryEncode",
    "URLRead",
    "URLResponseTime",
    "URLSave",
    "URLSaveAsynchronous",
    "URLShorten",
    "URLSubmit",
    "UseEmbeddedLibrary",
    "UseGraphicsRange",
    "UserDefinedWavelet",
    "Using",
    "UsingFrontEnd",
    "UtilityFunction",
    "V2Get",
    "ValenceErrorHandling",
    "ValenceFilling",
    "ValidationLength",
    "ValidationSet",
    "ValueBox",
    "ValueBoxOptions",
    "ValueDimensions",
    "ValueForm",
    "ValuePreprocessingFunction",
    "ValueQ",
    "Values",
    "ValuesData",
    "VandermondeMatrix",
    "Variables",
    "Variance",
    "VarianceEquivalenceTest",
    "VarianceEstimatorFunction",
    "VarianceGammaDistribution",
    "VarianceGammaPointProcess",
    "VarianceTest",
    "VariogramFunction",
    "VariogramModel",
    "VectorAngle",
    "VectorAround",
    "VectorAspectRatio",
    "VectorColorFunction",
    "VectorColorFunctionScaling",
    "VectorDensityPlot",
    "VectorDisplacementPlot",
    "VectorDisplacementPlot3D",
    "VectorGlyphData",
    "VectorGreater",
    "VectorGreaterEqual",
    "VectorLess",
    "VectorLessEqual",
    "VectorMarkers",
    "VectorPlot",
    "VectorPlot3D",
    "VectorPoints",
    "VectorQ",
    "VectorRange",
    "Vectors",
    "VectorScale",
    "VectorScaling",
    "VectorSizes",
    "VectorStyle",
    "Vee",
    "Verbatim",
    "Verbose",
    "VerificationTest",
    "VerifyConvergence",
    "VerifyDerivedKey",
    "VerifyDigitalSignature",
    "VerifyFileSignature",
    "VerifyInterpretation",
    "VerifySecurityCertificates",
    "VerifySolutions",
    "VerifyTestAssumptions",
    "VersionedPreferences",
    "VertexAdd",
    "VertexCapacity",
    "VertexChromaticNumber",
    "VertexColors",
    "VertexComponent",
    "VertexConnectivity",
    "VertexContract",
    "VertexCoordinateRules",
    "VertexCoordinates",
    "VertexCorrelationSimilarity",
    "VertexCosineSimilarity",
    "VertexCount",
    "VertexCoverQ",
    "VertexDataCoordinates",
    "VertexDegree",
    "VertexDelete",
    "VertexDiceSimilarity",
    "VertexEccentricity",
    "VertexInComponent",
    "VertexInComponentGraph",
    "VertexInDegree",
    "VertexIndex",
    "VertexJaccardSimilarity",
    "VertexLabeling",
    "VertexLabels",
    "VertexLabelStyle",
    "VertexList",
    "VertexNormals",
    "VertexOutComponent",
    "VertexOutComponentGraph",
    "VertexOutDegree",
    "VertexQ",
    "VertexRenderingFunction",
    "VertexReplace",
    "VertexShape",
    "VertexShapeFunction",
    "VertexSize",
    "VertexStyle",
    "VertexTextureCoordinates",
    "VertexTransitiveGraphQ",
    "VertexWeight",
    "VertexWeightedGraphQ",
    "Vertical",
    "VerticalBar",
    "VerticalForm",
    "VerticalGauge",
    "VerticalSeparator",
    "VerticalSlider",
    "VerticalTilde",
    "Video",
    "VideoCapture",
    "VideoCombine",
    "VideoDelete",
    "VideoEncoding",
    "VideoExtractFrames",
    "VideoFrameList",
    "VideoFrameMap",
    "VideoGenerator",
    "VideoInsert",
    "VideoIntervals",
    "VideoJoin",
    "VideoMap",
    "VideoMapList",
    "VideoMapTimeSeries",
    "VideoPadding",
    "VideoPause",
    "VideoPlay",
    "VideoQ",
    "VideoRecord",
    "VideoReplace",
    "VideoScreenCapture",
    "VideoSplit",
    "VideoStop",
    "VideoStream",
    "VideoStreams",
    "VideoTimeStretch",
    "VideoTrackSelection",
    "VideoTranscode",
    "VideoTransparency",
    "VideoTrim",
    "ViewAngle",
    "ViewCenter",
    "ViewMatrix",
    "ViewPoint",
    "ViewPointSelectorSettings",
    "ViewPort",
    "ViewProjection",
    "ViewRange",
    "ViewVector",
    "ViewVertical",
    "VirtualGroupData",
    "Visible",
    "VisibleCell",
    "VoiceStyleData",
    "VoigtDistribution",
    "VolcanoData",
    "Volume",
    "VonMisesDistribution",
    "VoronoiMesh",
    "WaitAll",
    "WaitAsynchronousTask",
    "WaitNext",
    "WaitUntil",
    "WakebyDistribution",
    "WalleniusHypergeometricDistribution",
    "WaringYuleDistribution",
    "WarpingCorrespondence",
    "WarpingDistance",
    "WatershedComponents",
    "WatsonUSquareTest",
    "WattsStrogatzGraphDistribution",
    "WaveletBestBasis",
    "WaveletFilterCoefficients",
    "WaveletImagePlot",
    "WaveletListPlot",
    "WaveletMapIndexed",
    "WaveletMatrixPlot",
    "WaveletPhi",
    "WaveletPsi",
    "WaveletScale",
    "WaveletScalogram",
    "WaveletThreshold",
    "WavePDEComponent",
    "WeaklyConnectedComponents",
    "WeaklyConnectedGraphComponents",
    "WeaklyConnectedGraphQ",
    "WeakStationarity",
    "WeatherData",
    "WeatherForecastData",
    "WebAudioSearch",
    "WebColumn",
    "WebElementObject",
    "WeberE",
    "WebExecute",
    "WebImage",
    "WebImageSearch",
    "WebItem",
    "WebPageMetaInformation",
    "WebRow",
    "WebSearch",
    "WebSessionObject",
    "WebSessions",
    "WebWindowObject",
    "Wedge",
    "Wednesday",
    "WeibullDistribution",
    "WeierstrassE1",
    "WeierstrassE2",
    "WeierstrassE3",
    "WeierstrassEta1",
    "WeierstrassEta2",
    "WeierstrassEta3",
    "WeierstrassHalfPeriods",
    "WeierstrassHalfPeriodW1",
    "WeierstrassHalfPeriodW2",
    "WeierstrassHalfPeriodW3",
    "WeierstrassInvariantG2",
    "WeierstrassInvariantG3",
    "WeierstrassInvariants",
    "WeierstrassP",
    "WeierstrassPPrime",
    "WeierstrassSigma",
    "WeierstrassZeta",
    "WeightedAdjacencyGraph",
    "WeightedAdjacencyMatrix",
    "WeightedData",
    "WeightedGraphQ",
    "Weights",
    "WelchWindow",
    "WheelGraph",
    "WhenEvent",
    "Which",
    "While",
    "White",
    "WhiteNoiseProcess",
    "WhitePoint",
    "Whitespace",
    "WhitespaceCharacter",
    "WhittakerM",
    "WhittakerW",
    "WholeCellGroupOpener",
    "WienerFilter",
    "WienerProcess",
    "WignerD",
    "WignerSemicircleDistribution",
    "WikidataData",
    "WikidataSearch",
    "WikipediaData",
    "WikipediaSearch",
    "WilksW",
    "WilksWTest",
    "WindDirectionData",
    "WindingCount",
    "WindingPolygon",
    "WindowClickSelect",
    "WindowElements",
    "WindowFloating",
    "WindowFrame",
    "WindowFrameElements",
    "WindowMargins",
    "WindowMovable",
    "WindowOpacity",
    "WindowPersistentStyles",
    "WindowSelected",
    "WindowSize",
    "WindowStatusArea",
    "WindowTitle",
    "WindowToolbars",
    "WindowWidth",
    "WindSpeedData",
    "WindVectorData",
    "WinsorizedMean",
    "WinsorizedVariance",
    "WishartMatrixDistribution",
    "With",
    "WithCleanup",
    "WithLock",
    "WolframAlpha",
    "WolframAlphaDate",
    "WolframAlphaQuantity",
    "WolframAlphaResult",
    "WolframCloudSettings",
    "WolframLanguageData",
    "Word",
    "WordBoundary",
    "WordCharacter",
    "WordCloud",
    "WordCount",
    "WordCounts",
    "WordData",
    "WordDefinition",
    "WordFrequency",
    "WordFrequencyData",
    "WordList",
    "WordOrientation",
    "WordSearch",
    "WordSelectionFunction",
    "WordSeparators",
    "WordSpacings",
    "WordStem",
    "WordTranslation",
    "WorkingPrecision",
    "WrapAround",
    "Write",
    "WriteLine",
    "WriteString",
    "Wronskian",
    "XMLElement",
    "XMLObject",
    "XMLTemplate",
    "Xnor",
    "Xor",
    "XYZColor",
    "Yellow",
    "Yesterday",
    "YuleDissimilarity",
    "ZernikeR",
    "ZeroSymmetric",
    "ZeroTest",
    "ZeroWidthTimes",
    "Zeta",
    "ZetaZero",
    "ZIPCodeData",
    "ZipfDistribution",
    "ZoomCenter",
    "ZoomFactor",
    "ZTest",
    "ZTransform",
    "$Aborted",
    "$ActivationGroupID",
    "$ActivationKey",
    "$ActivationUserRegistered",
    "$AddOnsDirectory",
    "$AllowDataUpdates",
    "$AllowExternalChannelFunctions",
    "$AllowInternet",
    "$AssertFunction",
    "$Assumptions",
    "$AsynchronousTask",
    "$AudioDecoders",
    "$AudioEncoders",
    "$AudioInputDevices",
    "$AudioOutputDevices",
    "$BaseDirectory",
    "$BasePacletsDirectory",
    "$BatchInput",
    "$BatchOutput",
    "$BlockchainBase",
    "$BoxForms",
    "$ByteOrdering",
    "$CacheBaseDirectory",
    "$Canceled",
    "$ChannelBase",
    "$CharacterEncoding",
    "$CharacterEncodings",
    "$CloudAccountName",
    "$CloudBase",
    "$CloudConnected",
    "$CloudConnection",
    "$CloudCreditsAvailable",
    "$CloudEvaluation",
    "$CloudExpressionBase",
    "$CloudObjectNameFormat",
    "$CloudObjectURLType",
    "$CloudRootDirectory",
    "$CloudSymbolBase",
    "$CloudUserID",
    "$CloudUserUUID",
    "$CloudVersion",
    "$CloudVersionNumber",
    "$CloudWolframEngineVersionNumber",
    "$CommandLine",
    "$CompilationTarget",
    "$CompilerEnvironment",
    "$ConditionHold",
    "$ConfiguredKernels",
    "$Context",
    "$ContextAliases",
    "$ContextPath",
    "$ControlActiveSetting",
    "$Cookies",
    "$CookieStore",
    "$CreationDate",
    "$CryptographicEllipticCurveNames",
    "$CurrentLink",
    "$CurrentTask",
    "$CurrentWebSession",
    "$DataStructures",
    "$DateStringFormat",
    "$DefaultAudioInputDevice",
    "$DefaultAudioOutputDevice",
    "$DefaultFont",
    "$DefaultFrontEnd",
    "$DefaultImagingDevice",
    "$DefaultKernels",
    "$DefaultLocalBase",
    "$DefaultLocalKernel",
    "$DefaultMailbox",
    "$DefaultNetworkInterface",
    "$DefaultPath",
    "$DefaultProxyRules",
    "$DefaultRemoteBatchSubmissionEnvironment",
    "$DefaultRemoteKernel",
    "$DefaultSystemCredentialStore",
    "$Display",
    "$DisplayFunction",
    "$DistributedContexts",
    "$DynamicEvaluation",
    "$Echo",
    "$EmbedCodeEnvironments",
    "$EmbeddableServices",
    "$EntityStores",
    "$Epilog",
    "$EvaluationCloudBase",
    "$EvaluationCloudObject",
    "$EvaluationEnvironment",
    "$ExportFormats",
    "$ExternalIdentifierTypes",
    "$ExternalStorageBase",
    "$Failed",
    "$FinancialDataSource",
    "$FontFamilies",
    "$FormatType",
    "$FrontEnd",
    "$FrontEndSession",
    "$GeneratedAssetLocation",
    "$GeoEntityTypes",
    "$GeoLocation",
    "$GeoLocationCity",
    "$GeoLocationCountry",
    "$GeoLocationPrecision",
    "$GeoLocationSource",
    "$HistoryLength",
    "$HomeDirectory",
    "$HTMLExportRules",
    "$HTTPCookies",
    "$HTTPRequest",
    "$IgnoreEOF",
    "$ImageFormattingWidth",
    "$ImageResolution",
    "$ImagingDevice",
    "$ImagingDevices",
    "$ImportFormats",
    "$IncomingMailSettings",
    "$InitialDirectory",
    "$Initialization",
    "$InitializationContexts",
    "$Input",
    "$InputFileName",
    "$InputStreamMethods",
    "$Inspector",
    "$InstallationDate",
    "$InstallationDirectory",
    "$InterfaceEnvironment",
    "$InterpreterTypes",
    "$IterationLimit",
    "$KernelCount",
    "$KernelID",
    "$Language",
    "$LaunchDirectory",
    "$LibraryPath",
    "$LicenseExpirationDate",
    "$LicenseID",
    "$LicenseProcesses",
    "$LicenseServer",
    "$LicenseSubprocesses",
    "$LicenseType",
    "$Line",
    "$Linked",
    "$LinkSupported",
    "$LoadedFiles",
    "$LocalBase",
    "$LocalSymbolBase",
    "$MachineAddresses",
    "$MachineDomain",
    "$MachineDomains",
    "$MachineEpsilon",
    "$MachineID",
    "$MachineName",
    "$MachinePrecision",
    "$MachineType",
    "$MaxDisplayedChildren",
    "$MaxExtraPrecision",
    "$MaxLicenseProcesses",
    "$MaxLicenseSubprocesses",
    "$MaxMachineNumber",
    "$MaxNumber",
    "$MaxPiecewiseCases",
    "$MaxPrecision",
    "$MaxRootDegree",
    "$MessageGroups",
    "$MessageList",
    "$MessagePrePrint",
    "$Messages",
    "$MinMachineNumber",
    "$MinNumber",
    "$MinorReleaseNumber",
    "$MinPrecision",
    "$MobilePhone",
    "$ModuleNumber",
    "$NetworkConnected",
    "$NetworkInterfaces",
    "$NetworkLicense",
    "$NewMessage",
    "$NewSymbol",
    "$NotebookInlineStorageLimit",
    "$Notebooks",
    "$NoValue",
    "$NumberMarks",
    "$Off",
    "$OperatingSystem",
    "$Output",
    "$OutputForms",
    "$OutputSizeLimit",
    "$OutputStreamMethods",
    "$Packages",
    "$ParentLink",
    "$ParentProcessID",
    "$PasswordFile",
    "$PatchLevelID",
    "$Path",
    "$PathnameSeparator",
    "$PerformanceGoal",
    "$Permissions",
    "$PermissionsGroupBase",
    "$PersistenceBase",
    "$PersistencePath",
    "$PipeSupported",
    "$PlotTheme",
    "$Post",
    "$Pre",
    "$PreferencesDirectory",
    "$PreInitialization",
    "$PrePrint",
    "$PreRead",
    "$PrintForms",
    "$PrintLiteral",
    "$Printout3DPreviewer",
    "$ProcessID",
    "$ProcessorCount",
    "$ProcessorType",
    "$ProductInformation",
    "$ProgramName",
    "$ProgressReporting",
    "$PublisherID",
    "$RandomGeneratorState",
    "$RandomState",
    "$RecursionLimit",
    "$RegisteredDeviceClasses",
    "$RegisteredUserName",
    "$ReleaseNumber",
    "$RequesterAddress",
    "$RequesterCloudUserID",
    "$RequesterCloudUserUUID",
    "$RequesterWolframID",
    "$RequesterWolframUUID",
    "$ResourceSystemBase",
    "$ResourceSystemPath",
    "$RootDirectory",
    "$ScheduledTask",
    "$ScriptCommandLine",
    "$ScriptInputString",
    "$SecuredAuthenticationKeyTokens",
    "$ServiceCreditsAvailable",
    "$Services",
    "$SessionID",
    "$SetParentLink",
    "$SharedFunctions",
    "$SharedVariables",
    "$SoundDisplay",
    "$SoundDisplayFunction",
    "$SourceLink",
    "$SSHAuthentication",
    "$SubtitleDecoders",
    "$SubtitleEncoders",
    "$SummaryBoxDataSizeLimit",
    "$SuppressInputFormHeads",
    "$SynchronousEvaluation",
    "$SyntaxHandler",
    "$System",
    "$SystemCharacterEncoding",
    "$SystemCredentialStore",
    "$SystemID",
    "$SystemMemory",
    "$SystemShell",
    "$SystemTimeZone",
    "$SystemWordLength",
    "$TargetSystems",
    "$TemplatePath",
    "$TemporaryDirectory",
    "$TemporaryPrefix",
    "$TestFileName",
    "$TextStyle",
    "$TimedOut",
    "$TimeUnit",
    "$TimeZone",
    "$TimeZoneEntity",
    "$TopDirectory",
    "$TraceOff",
    "$TraceOn",
    "$TracePattern",
    "$TracePostAction",
    "$TracePreAction",
    "$UnitSystem",
    "$Urgent",
    "$UserAddOnsDirectory",
    "$UserAgentLanguages",
    "$UserAgentMachine",
    "$UserAgentName",
    "$UserAgentOperatingSystem",
    "$UserAgentString",
    "$UserAgentVersion",
    "$UserBaseDirectory",
    "$UserBasePacletsDirectory",
    "$UserDocumentsDirectory",
    "$Username",
    "$UserName",
    "$UserURLBase",
    "$Version",
    "$VersionNumber",
    "$VideoDecoders",
    "$VideoEncoders",
    "$VoiceStyles",
    "$WolframDocumentsDirectory",
    "$WolframID",
    "$WolframUUID"
  ];
  function i(o) {
    const c = o.regex, r = /([2-9]|[1-2]\d|[3][0-5])\^\^/, e = /(\w*\.\w+|\w+\.\w*|\w+)/, g = /(\d*\.\d+|\d+\.\d*|\d+)/, h = c.either(c.concat(r, e), g), S = /``[+-]?(\d*\.\d+|\d+\.\d*|\d+)/, C = /`([+-]?(\d*\.\d+|\d+\.\d*|\d+))?/, O = c.either(S, C), N = /\*\^[+-]?\d+/, x = {
      className: "number",
      relevance: 0,
      begin: c.concat(
        h,
        c.optional(O),
        c.optional(N)
      )
    }, L = /[a-zA-Z$][a-zA-Z0-9$]*/, G = new Set(s), Y = { variants: [
      {
        className: "builtin-symbol",
        begin: L,
        // for performance out of fear of regex.either(...Mathematica.SYSTEM_SYMBOLS)
        "on:begin": (_e, se) => {
          G.has(_e[0]) || se.ignoreMatch();
        }
      },
      {
        className: "symbol",
        relevance: 0,
        begin: L
      }
    ] }, k = {
      className: "named-character",
      begin: /\\\[[$a-zA-Z][$a-zA-Z0-9]+\]/
    }, W = {
      className: "operator",
      relevance: 0,
      begin: /[+\-*/,;.:@~=><&|_`'^?!%]+/
    }, Z = {
      className: "pattern",
      relevance: 0,
      begin: /([a-zA-Z$][a-zA-Z0-9$]*)?_+([a-zA-Z$][a-zA-Z0-9$]*)?/
    }, H = {
      className: "slot",
      relevance: 0,
      begin: /#[a-zA-Z$][a-zA-Z0-9$]*|#+[0-9]?/
    }, K = {
      className: "brace",
      relevance: 0,
      begin: /[[\](){}]/
    }, Q = {
      className: "message-name",
      relevance: 0,
      begin: c.concat("::", L)
    };
    return {
      name: "Mathematica",
      aliases: [
        "mma",
        "wl"
      ],
      classNameAliases: {
        brace: "punctuation",
        pattern: "type",
        slot: "type",
        symbol: "variable",
        "named-character": "variable",
        "builtin-symbol": "built_in",
        "message-name": "string"
      },
      contains: [
        o.COMMENT(/\(\*/, /\*\)/, { contains: ["self"] }),
        Z,
        H,
        Q,
        Y,
        k,
        o.QUOTE_STRING_MODE,
        x,
        W,
        K
      ]
    };
  }
  return c_ = i, c_;
}
var d_, Fb;
function WP() {
  if (Fb)
    return d_;
  Fb = 1;
  function s(i) {
    const o = "('|\\.')+", c = {
      relevance: 0,
      contains: [{ begin: o }]
    };
    return {
      name: "Matlab",
      keywords: {
        keyword: "arguments break case catch classdef continue else elseif end enumeration events for function global if methods otherwise parfor persistent properties return spmd switch try while",
        built_in: "sin sind sinh asin asind asinh cos cosd cosh acos acosd acosh tan tand tanh atan atand atan2 atanh sec secd sech asec asecd asech csc cscd csch acsc acscd acsch cot cotd coth acot acotd acoth hypot exp expm1 log log1p log10 log2 pow2 realpow reallog realsqrt sqrt nthroot nextpow2 abs angle complex conj imag real unwrap isreal cplxpair fix floor ceil round mod rem sign airy besselj bessely besselh besseli besselk beta betainc betaln ellipj ellipke erf erfc erfcx erfinv expint gamma gammainc gammaln psi legendre cross dot factor isprime primes gcd lcm rat rats perms nchoosek factorial cart2sph cart2pol pol2cart sph2cart hsv2rgb rgb2hsv zeros ones eye repmat rand randn linspace logspace freqspace meshgrid accumarray size length ndims numel disp isempty isequal isequalwithequalnans cat reshape diag blkdiag tril triu fliplr flipud flipdim rot90 find sub2ind ind2sub bsxfun ndgrid permute ipermute shiftdim circshift squeeze isscalar isvector ans eps realmax realmin pi i|0 inf nan isnan isinf isfinite j|0 why compan gallery hadamard hankel hilb invhilb magic pascal rosser toeplitz vander wilkinson max min nanmax nanmin mean nanmean type table readtable writetable sortrows sort figure plot plot3 scatter scatter3 cellfun legend intersect ismember procrustes hold num2cell "
      },
      illegal: '(//|"|#|/\\*|\\s+/\\w+)',
      contains: [
        {
          className: "function",
          beginKeywords: "function",
          end: "$",
          contains: [
            i.UNDERSCORE_TITLE_MODE,
            {
              className: "params",
              variants: [
                {
                  begin: "\\(",
                  end: "\\)"
                },
                {
                  begin: "\\[",
                  end: "\\]"
                }
              ]
            }
          ]
        },
        {
          className: "built_in",
          begin: /true|false/,
          relevance: 0,
          starts: c
        },
        {
          begin: "[a-zA-Z][a-zA-Z_0-9]*" + o,
          relevance: 0
        },
        {
          className: "number",
          begin: i.C_NUMBER_RE,
          relevance: 0,
          starts: c
        },
        {
          className: "string",
          begin: "'",
          end: "'",
          contains: [{ begin: "''" }]
        },
        {
          begin: /\]|\}|\)/,
          relevance: 0,
          starts: c
        },
        {
          className: "string",
          begin: '"',
          end: '"',
          contains: [{ begin: '""' }],
          starts: c
        },
        i.COMMENT("^\\s*%\\{\\s*$", "^\\s*%\\}\\s*$"),
        i.COMMENT("%", "$")
      ]
    };
  }
  return d_ = s, d_;
}
var u_, Ub;
function zP() {
  if (Ub)
    return u_;
  Ub = 1;
  function s(i) {
    return {
      name: "Maxima",
      keywords: {
        $pattern: "[A-Za-z_%][0-9A-Za-z_%]*",
        keyword: "if then else elseif for thru do while unless step in and or not",
        literal: "true false unknown inf minf ind und %e %i %pi %phi %gamma",
        built_in: " abasep abs absint absolute_real_time acos acosh acot acoth acsc acsch activate addcol add_edge add_edges addmatrices addrow add_vertex add_vertices adjacency_matrix adjoin adjoint af agd airy airy_ai airy_bi airy_dai airy_dbi algsys alg_type alias allroots alphacharp alphanumericp amortization %and annuity_fv annuity_pv antid antidiff AntiDifference append appendfile apply apply1 apply2 applyb1 apropos args arit_amortization arithmetic arithsum array arrayapply arrayinfo arraymake arraysetapply ascii asec asech asin asinh askinteger asksign assoc assoc_legendre_p assoc_legendre_q assume assume_external_byte_order asympa at atan atan2 atanh atensimp atom atvalue augcoefmatrix augmented_lagrangian_method av average_degree backtrace bars barsplot barsplot_description base64 base64_decode bashindices batch batchload bc2 bdvac belln benefit_cost bern bernpoly bernstein_approx bernstein_expand bernstein_poly bessel bessel_i bessel_j bessel_k bessel_simplify bessel_y beta beta_incomplete beta_incomplete_generalized beta_incomplete_regularized bezout bfallroots bffac bf_find_root bf_fmin_cobyla bfhzeta bfloat bfloatp bfpsi bfpsi0 bfzeta biconnected_components bimetric binomial bipartition block blockmatrixp bode_gain bode_phase bothcoef box boxplot boxplot_description break bug_report build_info|10 buildq build_sample burn cabs canform canten cardinality carg cartan cartesian_product catch cauchy_matrix cbffac cdf_bernoulli cdf_beta cdf_binomial cdf_cauchy cdf_chi2 cdf_continuous_uniform cdf_discrete_uniform cdf_exp cdf_f cdf_gamma cdf_general_finite_discrete cdf_geometric cdf_gumbel cdf_hypergeometric cdf_laplace cdf_logistic cdf_lognormal cdf_negative_binomial cdf_noncentral_chi2 cdf_noncentral_student_t cdf_normal cdf_pareto cdf_poisson cdf_rank_sum cdf_rayleigh cdf_signed_rank cdf_student_t cdf_weibull cdisplay ceiling central_moment cequal cequalignore cf cfdisrep cfexpand cgeodesic cgreaterp cgreaterpignore changename changevar chaosgame charat charfun charfun2 charlist charp charpoly chdir chebyshev_t chebyshev_u checkdiv check_overlaps chinese cholesky christof chromatic_index chromatic_number cint circulant_graph clear_edge_weight clear_rules clear_vertex_label clebsch_gordan clebsch_graph clessp clesspignore close closefile cmetric coeff coefmatrix cograd col collapse collectterms columnop columnspace columnswap columnvector combination combine comp2pui compare compfile compile compile_file complement_graph complete_bipartite_graph complete_graph complex_number_p components compose_functions concan concat conjugate conmetderiv connected_components connect_vertices cons constant constantp constituent constvalue cont2part content continuous_freq contortion contour_plot contract contract_edge contragrad contrib_ode convert coord copy copy_file copy_graph copylist copymatrix cor cos cosh cot coth cov cov1 covdiff covect covers crc24sum create_graph create_list csc csch csetup cspline ctaylor ct_coordsys ctransform ctranspose cube_graph cuboctahedron_graph cunlisp cv cycle_digraph cycle_graph cylindrical days360 dblint deactivate declare declare_constvalue declare_dimensions declare_fundamental_dimensions declare_fundamental_units declare_qty declare_translated declare_unit_conversion declare_units declare_weights decsym defcon define define_alt_display define_variable defint defmatch defrule defstruct deftaylor degree_sequence del delete deleten delta demo demoivre denom depends derivdegree derivlist describe desolve determinant dfloat dgauss_a dgauss_b dgeev dgemm dgeqrf dgesv dgesvd diag diagmatrix diag_matrix diagmatrixp diameter diff digitcharp dimacs_export dimacs_import dimension dimensionless dimensions dimensions_as_list direct directory discrete_freq disjoin disjointp disolate disp dispcon dispform dispfun dispJordan display disprule dispterms distrib divide divisors divsum dkummer_m dkummer_u dlange dodecahedron_graph dotproduct dotsimp dpart draw draw2d draw3d drawdf draw_file draw_graph dscalar echelon edge_coloring edge_connectivity edges eigens_by_jacobi eigenvalues eigenvectors eighth einstein eivals eivects elapsed_real_time elapsed_run_time ele2comp ele2polynome ele2pui elem elementp elevation_grid elim elim_allbut eliminate eliminate_using ellipse elliptic_e elliptic_ec elliptic_eu elliptic_f elliptic_kc elliptic_pi ematrix empty_graph emptyp endcons entermatrix entertensor entier equal equalp equiv_classes erf erfc erf_generalized erfi errcatch error errormsg errors euler ev eval_string evenp every evolution evolution2d evundiff example exp expand expandwrt expandwrt_factored expint expintegral_chi expintegral_ci expintegral_e expintegral_e1 expintegral_ei expintegral_e_simplify expintegral_li expintegral_shi expintegral_si explicit explose exponentialize express expt exsec extdiff extract_linear_equations extremal_subset ezgcd %f f90 facsum factcomb factor factorfacsum factorial factorout factorsum facts fast_central_elements fast_linsolve fasttimes featurep fernfale fft fib fibtophi fifth filename_merge file_search file_type fillarray findde find_root find_root_abs find_root_error find_root_rel first fix flatten flength float floatnump floor flower_snark flush flush1deriv flushd flushnd flush_output fmin_cobyla forget fortran fourcos fourexpand fourier fourier_elim fourint fourintcos fourintsin foursimp foursin fourth fposition frame_bracket freeof freshline fresnel_c fresnel_s from_adjacency_matrix frucht_graph full_listify fullmap fullmapl fullratsimp fullratsubst fullsetify funcsolve fundamental_dimensions fundamental_units fundef funmake funp fv g0 g1 gamma gamma_greek gamma_incomplete gamma_incomplete_generalized gamma_incomplete_regularized gauss gauss_a gauss_b gaussprob gcd gcdex gcdivide gcfac gcfactor gd generalized_lambert_w genfact gen_laguerre genmatrix gensym geo_amortization geo_annuity_fv geo_annuity_pv geomap geometric geometric_mean geosum get getcurrentdirectory get_edge_weight getenv get_lu_factors get_output_stream_string get_pixel get_plot_option get_tex_environment get_tex_environment_default get_vertex_label gfactor gfactorsum ggf girth global_variances gn gnuplot_close gnuplot_replot gnuplot_reset gnuplot_restart gnuplot_start go Gosper GosperSum gr2d gr3d gradef gramschmidt graph6_decode graph6_encode graph6_export graph6_import graph_center graph_charpoly graph_eigenvalues graph_flow graph_order graph_periphery graph_product graph_size graph_union great_rhombicosidodecahedron_graph great_rhombicuboctahedron_graph grid_graph grind grobner_basis grotzch_graph hamilton_cycle hamilton_path hankel hankel_1 hankel_2 harmonic harmonic_mean hav heawood_graph hermite hessian hgfred hilbertmap hilbert_matrix hipow histogram histogram_description hodge horner hypergeometric i0 i1 %ibes ic1 ic2 ic_convert ichr1 ichr2 icosahedron_graph icosidodecahedron_graph icurvature ident identfor identity idiff idim idummy ieqn %if ifactors iframes ifs igcdex igeodesic_coords ilt image imagpart imetric implicit implicit_derivative implicit_plot indexed_tensor indices induced_subgraph inferencep inference_result infix info_display init_atensor init_ctensor in_neighbors innerproduct inpart inprod inrt integerp integer_partitions integrate intersect intersection intervalp intopois intosum invariant1 invariant2 inverse_fft inverse_jacobi_cd inverse_jacobi_cn inverse_jacobi_cs inverse_jacobi_dc inverse_jacobi_dn inverse_jacobi_ds inverse_jacobi_nc inverse_jacobi_nd inverse_jacobi_ns inverse_jacobi_sc inverse_jacobi_sd inverse_jacobi_sn invert invert_by_adjoint invert_by_lu inv_mod irr is is_biconnected is_bipartite is_connected is_digraph is_edge_in_graph is_graph is_graph_or_digraph ishow is_isomorphic isolate isomorphism is_planar isqrt isreal_p is_sconnected is_tree is_vertex_in_graph items_inference %j j0 j1 jacobi jacobian jacobi_cd jacobi_cn jacobi_cs jacobi_dc jacobi_dn jacobi_ds jacobi_nc jacobi_nd jacobi_ns jacobi_p jacobi_sc jacobi_sd jacobi_sn JF jn join jordan julia julia_set julia_sin %k kdels kdelta kill killcontext kostka kron_delta kronecker_product kummer_m kummer_u kurtosis kurtosis_bernoulli kurtosis_beta kurtosis_binomial kurtosis_chi2 kurtosis_continuous_uniform kurtosis_discrete_uniform kurtosis_exp kurtosis_f kurtosis_gamma kurtosis_general_finite_discrete kurtosis_geometric kurtosis_gumbel kurtosis_hypergeometric kurtosis_laplace kurtosis_logistic kurtosis_lognormal kurtosis_negative_binomial kurtosis_noncentral_chi2 kurtosis_noncentral_student_t kurtosis_normal kurtosis_pareto kurtosis_poisson kurtosis_rayleigh kurtosis_student_t kurtosis_weibull label labels lagrange laguerre lambda lambert_w laplace laplacian_matrix last lbfgs lc2kdt lcharp lc_l lcm lc_u ldefint ldisp ldisplay legendre_p legendre_q leinstein length let letrules letsimp levi_civita lfreeof lgtreillis lhs li liediff limit Lindstedt linear linearinterpol linear_program linear_regression line_graph linsolve listarray list_correlations listify list_matrix_entries list_nc_monomials listoftens listofvars listp lmax lmin load loadfile local locate_matrix_entry log logcontract log_gamma lopow lorentz_gauge lowercasep lpart lratsubst lreduce lriemann lsquares_estimates lsquares_estimates_approximate lsquares_estimates_exact lsquares_mse lsquares_residual_mse lsquares_residuals lsum ltreillis lu_backsub lucas lu_factor %m macroexpand macroexpand1 make_array makebox makefact makegamma make_graph make_level_picture makelist makeOrders make_poly_continent make_poly_country make_polygon make_random_state make_rgb_picture makeset make_string_input_stream make_string_output_stream make_transform mandelbrot mandelbrot_set map mapatom maplist matchdeclare matchfix mat_cond mat_fullunblocker mat_function mathml_display mat_norm matrix matrixmap matrixp matrix_size mattrace mat_trace mat_unblocker max max_clique max_degree max_flow maximize_lp max_independent_set max_matching maybe md5sum mean mean_bernoulli mean_beta mean_binomial mean_chi2 mean_continuous_uniform mean_deviation mean_discrete_uniform mean_exp mean_f mean_gamma mean_general_finite_discrete mean_geometric mean_gumbel mean_hypergeometric mean_laplace mean_logistic mean_lognormal mean_negative_binomial mean_noncentral_chi2 mean_noncentral_student_t mean_normal mean_pareto mean_poisson mean_rayleigh mean_student_t mean_weibull median median_deviation member mesh metricexpandall mgf1_sha1 min min_degree min_edge_cut minfactorial minimalPoly minimize_lp minimum_spanning_tree minor minpack_lsquares minpack_solve min_vertex_cover min_vertex_cut mkdir mnewton mod mode_declare mode_identity ModeMatrix moebius mon2schur mono monomial_dimensions multibernstein_poly multi_display_for_texinfo multi_elem multinomial multinomial_coeff multi_orbit multiplot_mode multi_pui multsym multthru mycielski_graph nary natural_unit nc_degree ncexpt ncharpoly negative_picture neighbors new newcontext newdet new_graph newline newton new_variable next_prime nicedummies niceindices ninth nofix nonarray noncentral_moment nonmetricity nonnegintegerp nonscalarp nonzeroandfreeof notequal nounify nptetrad npv nroots nterms ntermst nthroot nullity nullspace num numbered_boundaries numberp number_to_octets num_distinct_partitions numerval numfactor num_partitions nusum nzeta nzetai nzetar octets_to_number octets_to_oid odd_girth oddp ode2 ode_check odelin oid_to_octets op opena opena_binary openr openr_binary openw openw_binary operatorp opsubst optimize %or orbit orbits ordergreat ordergreatp orderless orderlessp orthogonal_complement orthopoly_recur orthopoly_weight outermap out_neighbors outofpois pade parabolic_cylinder_d parametric parametric_surface parg parGosper parse_string parse_timedate part part2cont partfrac partition partition_set partpol path_digraph path_graph pathname_directory pathname_name pathname_type pdf_bernoulli pdf_beta pdf_binomial pdf_cauchy pdf_chi2 pdf_continuous_uniform pdf_discrete_uniform pdf_exp pdf_f pdf_gamma pdf_general_finite_discrete pdf_geometric pdf_gumbel pdf_hypergeometric pdf_laplace pdf_logistic pdf_lognormal pdf_negative_binomial pdf_noncentral_chi2 pdf_noncentral_student_t pdf_normal pdf_pareto pdf_poisson pdf_rank_sum pdf_rayleigh pdf_signed_rank pdf_student_t pdf_weibull pearson_skewness permanent permut permutation permutations petersen_graph petrov pickapart picture_equalp picturep piechart piechart_description planar_embedding playback plog plot2d plot3d plotdf ploteq plsquares pochhammer points poisdiff poisexpt poisint poismap poisplus poissimp poissubst poistimes poistrim polar polarform polartorect polar_to_xy poly_add poly_buchberger poly_buchberger_criterion poly_colon_ideal poly_content polydecomp poly_depends_p poly_elimination_ideal poly_exact_divide poly_expand poly_expt poly_gcd polygon poly_grobner poly_grobner_equal poly_grobner_member poly_grobner_subsetp poly_ideal_intersection poly_ideal_polysaturation poly_ideal_polysaturation1 poly_ideal_saturation poly_ideal_saturation1 poly_lcm poly_minimization polymod poly_multiply polynome2ele polynomialp poly_normal_form poly_normalize poly_normalize_list poly_polysaturation_extension poly_primitive_part poly_pseudo_divide poly_reduced_grobner poly_reduction poly_saturation_extension poly_s_polynomial poly_subtract polytocompanion pop postfix potential power_mod powerseries powerset prefix prev_prime primep primes principal_components print printf printfile print_graph printpois printprops prodrac product properties propvars psi psubst ptriangularize pui pui2comp pui2ele pui2polynome pui_direct puireduc push put pv qput qrange qty quad_control quad_qag quad_qagi quad_qagp quad_qags quad_qawc quad_qawf quad_qawo quad_qaws quadrilateral quantile quantile_bernoulli quantile_beta quantile_binomial quantile_cauchy quantile_chi2 quantile_continuous_uniform quantile_discrete_uniform quantile_exp quantile_f quantile_gamma quantile_general_finite_discrete quantile_geometric quantile_gumbel quantile_hypergeometric quantile_laplace quantile_logistic quantile_lognormal quantile_negative_binomial quantile_noncentral_chi2 quantile_noncentral_student_t quantile_normal quantile_pareto quantile_poisson quantile_rayleigh quantile_student_t quantile_weibull quartile_skewness quit qunit quotient racah_v racah_w radcan radius random random_bernoulli random_beta random_binomial random_bipartite_graph random_cauchy random_chi2 random_continuous_uniform random_digraph random_discrete_uniform random_exp random_f random_gamma random_general_finite_discrete random_geometric random_graph random_graph1 random_gumbel random_hypergeometric random_laplace random_logistic random_lognormal random_negative_binomial random_network random_noncentral_chi2 random_noncentral_student_t random_normal random_pareto random_permutation random_poisson random_rayleigh random_regular_graph random_student_t random_tournament random_tree random_weibull range rank rat ratcoef ratdenom ratdiff ratdisrep ratexpand ratinterpol rational rationalize ratnumer ratnump ratp ratsimp ratsubst ratvars ratweight read read_array read_binary_array read_binary_list read_binary_matrix readbyte readchar read_hashed_array readline read_list read_matrix read_nested_list readonly read_xpm real_imagpart_to_conjugate realpart realroots rearray rectangle rectform rectform_log_if_constant recttopolar rediff reduce_consts reduce_order region region_boundaries region_boundaries_plus rem remainder remarray rembox remcomps remcon remcoord remfun remfunction remlet remove remove_constvalue remove_dimensions remove_edge remove_fundamental_dimensions remove_fundamental_units remove_plot_option remove_vertex rempart remrule remsym remvalue rename rename_file reset reset_displays residue resolvante resolvante_alternee1 resolvante_bipartite resolvante_diedrale resolvante_klein resolvante_klein3 resolvante_produit_sym resolvante_unitaire resolvante_vierer rest resultant return reveal reverse revert revert2 rgb2level rhs ricci riemann rinvariant risch rk rmdir rncombine romberg room rootscontract round row rowop rowswap rreduce run_testsuite %s save saving scalarp scaled_bessel_i scaled_bessel_i0 scaled_bessel_i1 scalefactors scanmap scatterplot scatterplot_description scene schur2comp sconcat scopy scsimp scurvature sdowncase sec sech second sequal sequalignore set_alt_display setdifference set_draw_defaults set_edge_weight setelmx setequalp setify setp set_partitions set_plot_option set_prompt set_random_state set_tex_environment set_tex_environment_default setunits setup_autoload set_up_dot_simplifications set_vertex_label seventh sexplode sf sha1sum sha256sum shortest_path shortest_weighted_path show showcomps showratvars sierpinskiale sierpinskimap sign signum similaritytransform simp_inequality simplify_sum simplode simpmetderiv simtran sin sinh sinsert sinvertcase sixth skewness skewness_bernoulli skewness_beta skewness_binomial skewness_chi2 skewness_continuous_uniform skewness_discrete_uniform skewness_exp skewness_f skewness_gamma skewness_general_finite_discrete skewness_geometric skewness_gumbel skewness_hypergeometric skewness_laplace skewness_logistic skewness_lognormal skewness_negative_binomial skewness_noncentral_chi2 skewness_noncentral_student_t skewness_normal skewness_pareto skewness_poisson skewness_rayleigh skewness_student_t skewness_weibull slength smake small_rhombicosidodecahedron_graph small_rhombicuboctahedron_graph smax smin smismatch snowmap snub_cube_graph snub_dodecahedron_graph solve solve_rec solve_rec_rat some somrac sort sparse6_decode sparse6_encode sparse6_export sparse6_import specint spherical spherical_bessel_j spherical_bessel_y spherical_hankel1 spherical_hankel2 spherical_harmonic spherical_to_xyz splice split sposition sprint sqfr sqrt sqrtdenest sremove sremovefirst sreverse ssearch ssort sstatus ssubst ssubstfirst staircase standardize standardize_inverse_trig starplot starplot_description status std std1 std_bernoulli std_beta std_binomial std_chi2 std_continuous_uniform std_discrete_uniform std_exp std_f std_gamma std_general_finite_discrete std_geometric std_gumbel std_hypergeometric std_laplace std_logistic std_lognormal std_negative_binomial std_noncentral_chi2 std_noncentral_student_t std_normal std_pareto std_poisson std_rayleigh std_student_t std_weibull stemplot stirling stirling1 stirling2 strim striml strimr string stringout stringp strong_components struve_h struve_l sublis sublist sublist_indices submatrix subsample subset subsetp subst substinpart subst_parallel substpart substring subvar subvarp sum sumcontract summand_to_rec supcase supcontext symbolp symmdifference symmetricp system take_channel take_inference tan tanh taylor taylorinfo taylorp taylor_simplifier taytorat tcl_output tcontract tellrat tellsimp tellsimpafter tentex tenth test_mean test_means_difference test_normality test_proportion test_proportions_difference test_rank_sum test_sign test_signed_rank test_variance test_variance_ratio tex tex1 tex_display texput %th third throw time timedate timer timer_info tldefint tlimit todd_coxeter toeplitz tokens to_lisp topological_sort to_poly to_poly_solve totaldisrep totalfourier totient tpartpol trace tracematrix trace_options transform_sample translate translate_file transpose treefale tree_reduce treillis treinat triangle triangularize trigexpand trigrat trigreduce trigsimp trunc truncate truncated_cube_graph truncated_dodecahedron_graph truncated_icosahedron_graph truncated_tetrahedron_graph tr_warnings_get tube tutte_graph ueivects uforget ultraspherical underlying_graph undiff union unique uniteigenvectors unitp units unit_step unitvector unorder unsum untellrat untimer untrace uppercasep uricci uriemann uvect vandermonde_matrix var var1 var_bernoulli var_beta var_binomial var_chi2 var_continuous_uniform var_discrete_uniform var_exp var_f var_gamma var_general_finite_discrete var_geometric var_gumbel var_hypergeometric var_laplace var_logistic var_lognormal var_negative_binomial var_noncentral_chi2 var_noncentral_student_t var_normal var_pareto var_poisson var_rayleigh var_student_t var_weibull vector vectorpotential vectorsimp verbify vers vertex_coloring vertex_connectivity vertex_degree vertex_distance vertex_eccentricity vertex_in_degree vertex_out_degree vertices vertices_to_cycle vertices_to_path %w weyl wheel_graph wiener_index wigner_3j wigner_6j wigner_9j with_stdout write_binary_data writebyte write_data writefile wronskian xreduce xthru %y Zeilberger zeroequiv zerofor zeromatrix zeromatrixp zeta zgeev zheev zlange zn_add_table zn_carmichael_lambda zn_characteristic_factors zn_determinant zn_factor_generators zn_invert_by_lu zn_log zn_mult_table absboxchar activecontexts adapt_depth additive adim aform algebraic algepsilon algexact aliases allbut all_dotsimp_denoms allocation allsym alphabetic animation antisymmetric arrays askexp assume_pos assume_pos_pred assumescalar asymbol atomgrad atrig1 axes axis_3d axis_bottom axis_left axis_right axis_top azimuth background background_color backsubst berlefact bernstein_explicit besselexpand beta_args_sum_to_integer beta_expand bftorat bftrunc bindtest border boundaries_array box boxchar breakup %c capping cauchysum cbrange cbtics center cflength cframe_flag cnonmet_flag color color_bar color_bar_tics colorbox columns commutative complex cone context contexts contour contour_levels cosnpiflag ctaypov ctaypt ctayswitch ctayvar ct_coords ctorsion_flag ctrgsimp cube current_let_rule_package cylinder data_file_name debugmode decreasing default_let_rule_package delay dependencies derivabbrev derivsubst detout diagmetric diff dim dimensions dispflag display2d|10 display_format_internal distribute_over doallmxops domain domxexpt domxmxops domxnctimes dontfactor doscmxops doscmxplus dot0nscsimp dot0simp dot1simp dotassoc dotconstrules dotdistrib dotexptsimp dotident dotscrules draw_graph_program draw_realpart edge_color edge_coloring edge_partition edge_type edge_width %edispflag elevation %emode endphi endtheta engineering_format_floats enhanced3d %enumer epsilon_lp erfflag erf_representation errormsg error_size error_syms error_type %e_to_numlog eval even evenfun evflag evfun ev_point expandwrt_denom expintexpand expintrep expon expop exptdispflag exptisolate exptsubst facexpand facsum_combine factlim factorflag factorial_expand factors_only fb feature features file_name file_output_append file_search_demo file_search_lisp file_search_maxima|10 file_search_tests file_search_usage file_type_lisp file_type_maxima|10 fill_color fill_density filled_func fixed_vertices flipflag float2bf font font_size fortindent fortspaces fpprec fpprintprec functions gamma_expand gammalim gdet genindex gensumnum GGFCFMAX GGFINFINITY globalsolve gnuplot_command gnuplot_curve_styles gnuplot_curve_titles gnuplot_default_term_command gnuplot_dumb_term_command gnuplot_file_args gnuplot_file_name gnuplot_out_file gnuplot_pdf_term_command gnuplot_pm3d gnuplot_png_term_command gnuplot_postamble gnuplot_preamble gnuplot_ps_term_command gnuplot_svg_term_command gnuplot_term gnuplot_view_args Gosper_in_Zeilberger gradefs grid grid2d grind halfangles head_angle head_both head_length head_type height hypergeometric_representation %iargs ibase icc1 icc2 icounter idummyx ieqnprint ifb ifc1 ifc2 ifg ifgi ifr iframe_bracket_form ifri igeowedge_flag ikt1 ikt2 imaginary inchar increasing infeval infinity inflag infolists inm inmc1 inmc2 intanalysis integer integervalued integrate_use_rootsof integration_constant integration_constant_counter interpolate_color intfaclim ip_grid ip_grid_in irrational isolate_wrt_times iterations itr julia_parameter %k1 %k2 keepfloat key key_pos kinvariant kt label label_alignment label_orientation labels lassociative lbfgs_ncorrections lbfgs_nfeval_max leftjust legend letrat let_rule_packages lfg lg lhospitallim limsubst linear linear_solver linechar linel|10 linenum line_type linewidth line_width linsolve_params linsolvewarn lispdisp listarith listconstvars listdummyvars lmxchar load_pathname loadprint logabs logarc logcb logconcoeffp logexpand lognegint logsimp logx logx_secondary logy logy_secondary logz lriem m1pbranch macroexpansion macros mainvar manual_demo maperror mapprint matrix_element_add matrix_element_mult matrix_element_transpose maxapplydepth maxapplyheight maxima_tempdir|10 maxima_userdir|10 maxnegex MAX_ORD maxposex maxpsifracdenom maxpsifracnum maxpsinegint maxpsiposint maxtayorder mesh_lines_color method mod_big_prime mode_check_errorp mode_checkp mode_check_warnp mod_test mod_threshold modular_linear_solver modulus multiplicative multiplicities myoptions nary negdistrib negsumdispflag newline newtonepsilon newtonmaxiter nextlayerfactor niceindicespref nm nmc noeval nolabels nonegative_lp noninteger nonscalar noun noundisp nouns np npi nticks ntrig numer numer_pbranch obase odd oddfun opacity opproperties opsubst optimprefix optionset orientation origin orthopoly_returns_intervals outative outchar packagefile palette partswitch pdf_file pfeformat phiresolution %piargs piece pivot_count_sx pivot_max_sx plot_format plot_options plot_realpart png_file pochhammer_max_index points pointsize point_size points_joined point_type poislim poisson poly_coefficient_ring poly_elimination_order polyfactor poly_grobner_algorithm poly_grobner_debug poly_monomial_order poly_primary_elimination_order poly_return_term_list poly_secondary_elimination_order poly_top_reduction_only posfun position powerdisp pred prederror primep_number_of_tests product_use_gamma program programmode promote_float_to_bigfloat prompt proportional_axes props psexpand ps_file radexpand radius radsubstflag rassociative ratalgdenom ratchristof ratdenomdivide rateinstein ratepsilon ratfac rational ratmx ratprint ratriemann ratsimpexpons ratvarswitch ratweights ratweyl ratwtlvl real realonly redraw refcheck resolution restart resultant ric riem rmxchar %rnum_list rombergabs rombergit rombergmin rombergtol rootsconmode rootsepsilon run_viewer same_xy same_xyz savedef savefactors scalar scalarmatrixp scale scale_lp setcheck setcheckbreak setval show_edge_color show_edges show_edge_type show_edge_width show_id show_label showtime show_vertex_color show_vertex_size show_vertex_type show_vertices show_weight simp simplified_output simplify_products simpproduct simpsum sinnpiflag solvedecomposes solveexplicit solvefactors solvenullwarn solveradcan solvetrigwarn space sparse sphere spring_embedding_depth sqrtdispflag stardisp startphi starttheta stats_numer stringdisp structures style sublis_apply_lambda subnumsimp sumexpand sumsplitfact surface surface_hide svg_file symmetric tab taylordepth taylor_logexpand taylor_order_coefficients taylor_truncate_polynomials tensorkill terminal testsuite_files thetaresolution timer_devalue title tlimswitch tr track transcompile transform transform_xy translate_fast_arrays transparent transrun tr_array_as_ref tr_bound_function_applyp tr_file_tty_messagesp tr_float_can_branch_complex tr_function_call_default trigexpandplus trigexpandtimes triginverses trigsign trivial_solutions tr_numer tr_optimize_max_loop tr_semicompile tr_state_vars tr_warn_bad_function_calls tr_warn_fexpr tr_warn_meval tr_warn_mode tr_warn_undeclared tr_warn_undefined_variable tstep ttyoff tube_extremes ufg ug %unitexpand unit_vectors uric uriem use_fast_arrays user_preamble usersetunits values vect_cross verbose vertex_color vertex_coloring vertex_partition vertex_size vertex_type view warnings weyl width windowname windowtitle wired_surface wireframe xaxis xaxis_color xaxis_secondary xaxis_type xaxis_width xlabel xlabel_secondary xlength xrange xrange_secondary xtics xtics_axis xtics_rotate xtics_rotate_secondary xtics_secondary xtics_secondary_axis xu_grid x_voxel xy_file xyplane xy_scale yaxis yaxis_color yaxis_secondary yaxis_type yaxis_width ylabel ylabel_secondary ylength yrange yrange_secondary ytics ytics_axis ytics_rotate ytics_rotate_secondary ytics_secondary ytics_secondary_axis yv_grid y_voxel yx_ratio zaxis zaxis_color zaxis_type zaxis_width zeroa zerob zerobern zeta%pi zlabel zlabel_rotate zlength zmin zn_primroot_limit zn_primroot_pretest",
        symbol: "_ __ %|0 %%|0"
      },
      contains: [
        {
          className: "comment",
          begin: "/\\*",
          end: "\\*/",
          contains: ["self"]
        },
        i.QUOTE_STRING_MODE,
        {
          className: "number",
          relevance: 0,
          variants: [
            {
              // float number w/ exponent
              // hmm, I wonder if we ought to include other exponent markers?
              begin: "\\b(\\d+|\\d+\\.|\\.\\d+|\\d+\\.\\d+)[Ee][-+]?\\d+\\b"
            },
            {
              // bigfloat number
              begin: "\\b(\\d+|\\d+\\.|\\.\\d+|\\d+\\.\\d+)[Bb][-+]?\\d+\\b",
              relevance: 10
            },
            {
              // float number w/out exponent
              // Doesn't seem to recognize floats which start with '.'
              begin: "\\b(\\.\\d+|\\d+\\.\\d+)\\b"
            },
            {
              // integer in base up to 36
              // Doesn't seem to recognize integers which end with '.'
              begin: "\\b(\\d+|0[0-9A-Za-z]+)\\.?\\b"
            }
          ]
        }
      ],
      illegal: /@/
    };
  }
  return u_ = s, u_;
}
var __, Bb;
function KP() {
  if (Bb)
    return __;
  Bb = 1;
  function s(i) {
    return {
      name: "MEL",
      keywords: "int float string vector matrix if else switch case default while do for in break continue global proc return about abs addAttr addAttributeEditorNodeHelp addDynamic addNewShelfTab addPP addPanelCategory addPrefixToName advanceToNextDrivenKey affectedNet affects aimConstraint air alias aliasAttr align alignCtx alignCurve alignSurface allViewFit ambientLight angle angleBetween animCone animCurveEditor animDisplay animView annotate appendStringArray applicationName applyAttrPreset applyTake arcLenDimContext arcLengthDimension arclen arrayMapper art3dPaintCtx artAttrCtx artAttrPaintVertexCtx artAttrSkinPaintCtx artAttrTool artBuildPaintMenu artFluidAttrCtx artPuttyCtx artSelectCtx artSetPaintCtx artUserPaintCtx assignCommand assignInputDevice assignViewportFactories attachCurve attachDeviceAttr attachSurface attrColorSliderGrp attrCompatibility attrControlGrp attrEnumOptionMenu attrEnumOptionMenuGrp attrFieldGrp attrFieldSliderGrp attrNavigationControlGrp attrPresetEditWin attributeExists attributeInfo attributeMenu attributeQuery autoKeyframe autoPlace bakeClip bakeFluidShading bakePartialHistory bakeResults bakeSimulation basename basenameEx batchRender bessel bevel bevelPlus binMembership bindSkin blend2 blendShape blendShapeEditor blendShapePanel blendTwoAttr blindDataType boneLattice boundary boxDollyCtx boxZoomCtx bufferCurve buildBookmarkMenu buildKeyframeMenu button buttonManip CBG cacheFile cacheFileCombine cacheFileMerge cacheFileTrack camera cameraView canCreateManip canvas capitalizeString catch catchQuiet ceil changeSubdivComponentDisplayLevel changeSubdivRegion channelBox character characterMap characterOutlineEditor characterize chdir checkBox checkBoxGrp checkDefaultRenderGlobals choice circle circularFillet clamp clear clearCache clip clipEditor clipEditorCurrentTimeCtx clipSchedule clipSchedulerOutliner clipTrimBefore closeCurve closeSurface cluster cmdFileOutput cmdScrollFieldExecuter cmdScrollFieldReporter cmdShell coarsenSubdivSelectionList collision color colorAtPoint colorEditor colorIndex colorIndexSliderGrp colorSliderButtonGrp colorSliderGrp columnLayout commandEcho commandLine commandPort compactHairSystem componentEditor compositingInterop computePolysetVolume condition cone confirmDialog connectAttr connectControl connectDynamic connectJoint connectionInfo constrain constrainValue constructionHistory container containsMultibyte contextInfo control convertFromOldLayers convertIffToPsd convertLightmap convertSolidTx convertTessellation convertUnit copyArray copyFlexor copyKey copySkinWeights cos cpButton cpCache cpClothSet cpCollision cpConstraint cpConvClothToMesh cpForces cpGetSolverAttr cpPanel cpProperty cpRigidCollisionFilter cpSeam cpSetEdit cpSetSolverAttr cpSolver cpSolverTypes cpTool cpUpdateClothUVs createDisplayLayer createDrawCtx createEditor createLayeredPsdFile createMotionField createNewShelf createNode createRenderLayer createSubdivRegion cross crossProduct ctxAbort ctxCompletion ctxEditMode ctxTraverse currentCtx currentTime currentTimeCtx currentUnit curve curveAddPtCtx curveCVCtx curveEPCtx curveEditorCtx curveIntersect curveMoveEPCtx curveOnSurface curveSketchCtx cutKey cycleCheck cylinder dagPose date defaultLightListCheckBox defaultNavigation defineDataServer defineVirtualDevice deformer deg_to_rad delete deleteAttr deleteShadingGroupsAndMaterials deleteShelfTab deleteUI deleteUnusedBrushes delrandstr detachCurve detachDeviceAttr detachSurface deviceEditor devicePanel dgInfo dgdirty dgeval dgtimer dimWhen directKeyCtx directionalLight dirmap dirname disable disconnectAttr disconnectJoint diskCache displacementToPoly displayAffected displayColor displayCull displayLevelOfDetail displayPref displayRGBColor displaySmoothness displayStats displayString displaySurface distanceDimContext distanceDimension doBlur dolly dollyCtx dopeSheetEditor dot dotProduct doubleProfileBirailSurface drag dragAttrContext draggerContext dropoffLocator duplicate duplicateCurve duplicateSurface dynCache dynControl dynExport dynExpression dynGlobals dynPaintEditor dynParticleCtx dynPref dynRelEdPanel dynRelEditor dynamicLoad editAttrLimits editDisplayLayerGlobals editDisplayLayerMembers editRenderLayerAdjustment editRenderLayerGlobals editRenderLayerMembers editor editorTemplate effector emit emitter enableDevice encodeString endString endsWith env equivalent equivalentTol erf error eval evalDeferred evalEcho event exactWorldBoundingBox exclusiveLightCheckBox exec executeForEachObject exists exp expression expressionEditorListen extendCurve extendSurface extrude fcheck fclose feof fflush fgetline fgetword file fileBrowserDialog fileDialog fileExtension fileInfo filetest filletCurve filter filterCurve filterExpand filterStudioImport findAllIntersections findAnimCurves findKeyframe findMenuItem findRelatedSkinCluster finder firstParentOf fitBspline flexor floatEq floatField floatFieldGrp floatScrollBar floatSlider floatSlider2 floatSliderButtonGrp floatSliderGrp floor flow fluidCacheInfo fluidEmitter fluidVoxelInfo flushUndo fmod fontDialog fopen formLayout format fprint frameLayout fread freeFormFillet frewind fromNativePath fwrite gamma gauss geometryConstraint getApplicationVersionAsFloat getAttr getClassification getDefaultBrush getFileList getFluidAttr getInputDeviceRange getMayaPanelTypes getModifiers getPanel getParticleAttr getPluginResource getenv getpid glRender glRenderEditor globalStitch gmatch goal gotoBindPose grabColor gradientControl gradientControlNoAttr graphDollyCtx graphSelectContext graphTrackCtx gravity grid gridLayout group groupObjectsByName HfAddAttractorToAS HfAssignAS HfBuildEqualMap HfBuildFurFiles HfBuildFurImages HfCancelAFR HfConnectASToHF HfCreateAttractor HfDeleteAS HfEditAS HfPerformCreateAS HfRemoveAttractorFromAS HfSelectAttached HfSelectAttractors HfUnAssignAS hardenPointCurve hardware hardwareRenderPanel headsUpDisplay headsUpMessage help helpLine hermite hide hilite hitTest hotBox hotkey hotkeyCheck hsv_to_rgb hudButton hudSlider hudSliderButton hwReflectionMap hwRender hwRenderLoad hyperGraph hyperPanel hyperShade hypot iconTextButton iconTextCheckBox iconTextRadioButton iconTextRadioCollection iconTextScrollList iconTextStaticLabel ikHandle ikHandleCtx ikHandleDisplayScale ikSolver ikSplineHandleCtx ikSystem ikSystemInfo ikfkDisplayMethod illustratorCurves image imfPlugins inheritTransform insertJoint insertJointCtx insertKeyCtx insertKnotCurve insertKnotSurface instance instanceable instancer intField intFieldGrp intScrollBar intSlider intSliderGrp interToUI internalVar intersect iprEngine isAnimCurve isConnected isDirty isParentOf isSameObject isTrue isValidObjectName isValidString isValidUiName isolateSelect itemFilter itemFilterAttr itemFilterRender itemFilterType joint jointCluster jointCtx jointDisplayScale jointLattice keyTangent keyframe keyframeOutliner keyframeRegionCurrentTimeCtx keyframeRegionDirectKeyCtx keyframeRegionDollyCtx keyframeRegionInsertKeyCtx keyframeRegionMoveKeyCtx keyframeRegionScaleKeyCtx keyframeRegionSelectKeyCtx keyframeRegionSetKeyCtx keyframeRegionTrackCtx keyframeStats lassoContext lattice latticeDeformKeyCtx launch launchImageEditor layerButton layeredShaderPort layeredTexturePort layout layoutDialog lightList lightListEditor lightListPanel lightlink lineIntersection linearPrecision linstep listAnimatable listAttr listCameras listConnections listDeviceAttachments listHistory listInputDeviceAxes listInputDeviceButtons listInputDevices listMenuAnnotation listNodeTypes listPanelCategories listRelatives listSets listTransforms listUnselected listerEditor loadFluid loadNewShelf loadPlugin loadPluginLanguageResources loadPrefObjects localizedPanelLabel lockNode loft log longNameOf lookThru ls lsThroughFilter lsType lsUI Mayatomr mag makeIdentity makeLive makePaintable makeRoll makeSingleSurface makeTubeOn makebot manipMoveContext manipMoveLimitsCtx manipOptions manipRotateContext manipRotateLimitsCtx manipScaleContext manipScaleLimitsCtx marker match max memory menu menuBarLayout menuEditor menuItem menuItemToShelf menuSet menuSetPref messageLine min minimizeApp mirrorJoint modelCurrentTimeCtx modelEditor modelPanel mouse movIn movOut move moveIKtoFK moveKeyCtx moveVertexAlongDirection multiProfileBirailSurface mute nParticle nameCommand nameField namespace namespaceInfo newPanelItems newton nodeCast nodeIconButton nodeOutliner nodePreset nodeType noise nonLinear normalConstraint normalize nurbsBoolean nurbsCopyUVSet nurbsCube nurbsEditUV nurbsPlane nurbsSelect nurbsSquare nurbsToPoly nurbsToPolygonsPref nurbsToSubdiv nurbsToSubdivPref nurbsUVSet nurbsViewDirectionVector objExists objectCenter objectLayer objectType objectTypeUI obsoleteProc oceanNurbsPreviewPlane offsetCurve offsetCurveOnSurface offsetSurface openGLExtension openMayaPref optionMenu optionMenuGrp optionVar orbit orbitCtx orientConstraint outlinerEditor outlinerPanel overrideModifier paintEffectsDisplay pairBlend palettePort paneLayout panel panelConfiguration panelHistory paramDimContext paramDimension paramLocator parent parentConstraint particle particleExists particleInstancer particleRenderInfo partition pasteKey pathAnimation pause pclose percent performanceOptions pfxstrokes pickWalk picture pixelMove planarSrf plane play playbackOptions playblast plugAttr plugNode pluginInfo pluginResourceUtil pointConstraint pointCurveConstraint pointLight pointMatrixMult pointOnCurve pointOnSurface pointPosition poleVectorConstraint polyAppend polyAppendFacetCtx polyAppendVertex polyAutoProjection polyAverageNormal polyAverageVertex polyBevel polyBlendColor polyBlindData polyBoolOp polyBridgeEdge polyCacheMonitor polyCheck polyChipOff polyClipboard polyCloseBorder polyCollapseEdge polyCollapseFacet polyColorBlindData polyColorDel polyColorPerVertex polyColorSet polyCompare polyCone polyCopyUV polyCrease polyCreaseCtx polyCreateFacet polyCreateFacetCtx polyCube polyCut polyCutCtx polyCylinder polyCylindricalProjection polyDelEdge polyDelFacet polyDelVertex polyDuplicateAndConnect polyDuplicateEdge polyEditUV polyEditUVShell polyEvaluate polyExtrudeEdge polyExtrudeFacet polyExtrudeVertex polyFlipEdge polyFlipUV polyForceUV polyGeoSampler polyHelix polyInfo polyInstallAction polyLayoutUV polyListComponentConversion polyMapCut polyMapDel polyMapSew polyMapSewMove polyMergeEdge polyMergeEdgeCtx polyMergeFacet polyMergeFacetCtx polyMergeUV polyMergeVertex polyMirrorFace polyMoveEdge polyMoveFacet polyMoveFacetUV polyMoveUV polyMoveVertex polyNormal polyNormalPerVertex polyNormalizeUV polyOptUvs polyOptions polyOutput polyPipe polyPlanarProjection polyPlane polyPlatonicSolid polyPoke polyPrimitive polyPrism polyProjection polyPyramid polyQuad polyQueryBlindData polyReduce polySelect polySelectConstraint polySelectConstraintMonitor polySelectCtx polySelectEditCtx polySeparate polySetToFaceNormal polySewEdge polyShortestPathCtx polySmooth polySoftEdge polySphere polySphericalProjection polySplit polySplitCtx polySplitEdge polySplitRing polySplitVertex polyStraightenUVBorder polySubdivideEdge polySubdivideFacet polyToSubdiv polyTorus polyTransfer polyTriangulate polyUVSet polyUnite polyWedgeFace popen popupMenu pose pow preloadRefEd print progressBar progressWindow projFileViewer projectCurve projectTangent projectionContext projectionManip promptDialog propModCtx propMove psdChannelOutliner psdEditTextureFile psdExport psdTextureFile putenv pwd python querySubdiv quit rad_to_deg radial radioButton radioButtonGrp radioCollection radioMenuItemCollection rampColorPort rand randomizeFollicles randstate rangeControl readTake rebuildCurve rebuildSurface recordAttr recordDevice redo reference referenceEdit referenceQuery refineSubdivSelectionList refresh refreshAE registerPluginResource rehash reloadImage removeJoint removeMultiInstance removePanelCategory rename renameAttr renameSelectionList renameUI render renderGlobalsNode renderInfo renderLayerButton renderLayerParent renderLayerPostProcess renderLayerUnparent renderManip renderPartition renderQualityNode renderSettings renderThumbnailUpdate renderWindowEditor renderWindowSelectContext renderer reorder reorderDeformers requires reroot resampleFluid resetAE resetPfxToPolyCamera resetTool resolutionNode retarget reverseCurve reverseSurface revolve rgb_to_hsv rigidBody rigidSolver roll rollCtx rootOf rot rotate rotationInterpolation roundConstantRadius rowColumnLayout rowLayout runTimeCommand runup sampleImage saveAllShelves saveAttrPreset saveFluid saveImage saveInitialState saveMenu savePrefObjects savePrefs saveShelf saveToolSettings scale scaleBrushBrightness scaleComponents scaleConstraint scaleKey scaleKeyCtx sceneEditor sceneUIReplacement scmh scriptCtx scriptEditorInfo scriptJob scriptNode scriptTable scriptToShelf scriptedPanel scriptedPanelType scrollField scrollLayout sculpt searchPathArray seed selLoadSettings select selectContext selectCurveCV selectKey selectKeyCtx selectKeyframeRegionCtx selectMode selectPref selectPriority selectType selectedNodes selectionConnection separator setAttr setAttrEnumResource setAttrMapping setAttrNiceNameResource setConstraintRestPosition setDefaultShadingGroup setDrivenKeyframe setDynamic setEditCtx setEditor setFluidAttr setFocus setInfinity setInputDeviceMapping setKeyCtx setKeyPath setKeyframe setKeyframeBlendshapeTargetWts setMenuMode setNodeNiceNameResource setNodeTypeFlag setParent setParticleAttr setPfxToPolyCamera setPluginResource setProject setStampDensity setStartupMessage setState setToolTo setUITemplate setXformManip sets shadingConnection shadingGeometryRelCtx shadingLightRelCtx shadingNetworkCompare shadingNode shapeCompare shelfButton shelfLayout shelfTabLayout shellField shortNameOf showHelp showHidden showManipCtx showSelectionInTitle showShadingGroupAttrEditor showWindow sign simplify sin singleProfileBirailSurface size sizeBytes skinCluster skinPercent smoothCurve smoothTangentSurface smoothstep snap2to2 snapKey snapMode snapTogetherCtx snapshot soft softMod softModCtx sort sound soundControl source spaceLocator sphere sphrand spotLight spotLightPreviewPort spreadSheetEditor spring sqrt squareSurface srtContext stackTrace startString startsWith stitchAndExplodeShell stitchSurface stitchSurfacePoints strcmp stringArrayCatenate stringArrayContains stringArrayCount stringArrayInsertAtIndex stringArrayIntersector stringArrayRemove stringArrayRemoveAtIndex stringArrayRemoveDuplicates stringArrayRemoveExact stringArrayToString stringToStringArray strip stripPrefixFromName stroke subdAutoProjection subdCleanTopology subdCollapse subdDuplicateAndConnect subdEditUV subdListComponentConversion subdMapCut subdMapSewMove subdMatchTopology subdMirror subdToBlind subdToPoly subdTransferUVsToCache subdiv subdivCrease subdivDisplaySmoothness substitute substituteAllString substituteGeometry substring surface surfaceSampler surfaceShaderList swatchDisplayPort switchTable symbolButton symbolCheckBox sysFile system tabLayout tan tangentConstraint texLatticeDeformContext texManipContext texMoveContext texMoveUVShellContext texRotateContext texScaleContext texSelectContext texSelectShortestPathCtx texSmudgeUVContext texWinToolCtx text textCurves textField textFieldButtonGrp textFieldGrp textManip textScrollList textToShelf textureDisplacePlane textureHairColor texturePlacementContext textureWindow threadCount threePointArcCtx timeControl timePort timerX toNativePath toggle toggleAxis toggleWindowVisibility tokenize tokenizeList tolerance tolower toolButton toolCollection toolDropped toolHasOptions toolPropertyWindow torus toupper trace track trackCtx transferAttributes transformCompare transformLimits translator trim trunc truncateFluidCache truncateHairCache tumble tumbleCtx turbulence twoPointArcCtx uiRes uiTemplate unassignInputDevice undo undoInfo ungroup uniform unit unloadPlugin untangleUV untitledFileName untrim upAxis updateAE userCtx uvLink uvSnapshot validateShelfName vectorize view2dToolCtx viewCamera viewClipPlane viewFit viewHeadOn viewLookAt viewManip viewPlace viewSet visor volumeAxis vortex waitCursor warning webBrowser webBrowserPrefs whatIs window windowPref wire wireContext workspace wrinkle wrinkleContext writeTake xbmLangPathList xform",
      illegal: "</",
      contains: [
        i.C_NUMBER_MODE,
        i.APOS_STRING_MODE,
        i.QUOTE_STRING_MODE,
        {
          className: "string",
          begin: "`",
          end: "`",
          contains: [i.BACKSLASH_ESCAPE]
        },
        {
          // eats variables
          begin: /[$%@](\^\w\b|#\w+|[^\s\w{]|\{\w+\}|\w+)/
        },
        i.C_LINE_COMMENT_MODE,
        i.C_BLOCK_COMMENT_MODE
      ]
    };
  }
  return __ = s, __;
}
var p_, Gb;
function QP() {
  if (Gb)
    return p_;
  Gb = 1;
  function s(i) {
    const o = {
      keyword: "module use_module import_module include_module end_module initialise mutable initialize finalize finalise interface implementation pred mode func type inst solver any_pred any_func is semidet det nondet multi erroneous failure cc_nondet cc_multi typeclass instance where pragma promise external trace atomic or_else require_complete_switch require_det require_semidet require_multi require_nondet require_cc_multi require_cc_nondet require_erroneous require_failure",
      meta: (
        // pragma
        "inline no_inline type_spec source_file fact_table obsolete memo loop_check minimal_model terminates does_not_terminate check_termination promise_equivalent_clauses foreign_proc foreign_decl foreign_code foreign_type foreign_import_module foreign_export_enum foreign_export foreign_enum may_call_mercury will_not_call_mercury thread_safe not_thread_safe maybe_thread_safe promise_pure promise_semipure tabled_for_io local untrailed trailed attach_to_io_state can_pass_as_mercury_type stable will_not_throw_exception may_modify_trail will_not_modify_trail may_duplicate may_not_duplicate affects_liveness does_not_affect_liveness doesnt_affect_liveness no_sharing unknown_sharing sharing"
      ),
      built_in: "some all not if then else true fail false try catch catch_any semidet_true semidet_false semidet_fail impure_true impure semipure"
    }, c = i.COMMENT("%", "$"), r = {
      className: "number",
      begin: "0'.\\|0[box][0-9a-fA-F]*"
    }, e = i.inherit(i.APOS_STRING_MODE, { relevance: 0 }), g = i.inherit(i.QUOTE_STRING_MODE, { relevance: 0 }), h = {
      className: "subst",
      begin: "\\\\[abfnrtv]\\|\\\\x[0-9a-fA-F]*\\\\\\|%[-+# *.0-9]*[dioxXucsfeEgGp]",
      relevance: 0
    };
    return g.contains = g.contains.slice(), g.contains.push(h), {
      name: "Mercury",
      aliases: [
        "m",
        "moo"
      ],
      keywords: o,
      contains: [
        {
          className: "built_in",
          variants: [
            { begin: "<=>" },
            {
              begin: "<=",
              relevance: 0
            },
            {
              begin: "=>",
              relevance: 0
            },
            { begin: "/\\\\" },
            { begin: "\\\\/" }
          ]
        },
        {
          className: "built_in",
          variants: [
            { begin: ":-\\|-->" },
            {
              begin: "=",
              relevance: 0
            }
          ]
        },
        c,
        i.C_BLOCK_COMMENT_MODE,
        r,
        i.NUMBER_MODE,
        e,
        g,
        {
          // relevance booster
          begin: /:-/
        },
        {
          // relevance booster
          begin: /\.$/
        }
      ]
    };
  }
  return p_ = s, p_;
}
var m_, Vb;
function XP() {
  if (Vb)
    return m_;
  Vb = 1;
  function s(i) {
    return {
      name: "MIPS Assembly",
      case_insensitive: !0,
      aliases: ["mips"],
      keywords: {
        $pattern: "\\.?" + i.IDENT_RE,
        meta: (
          // GNU preprocs
          ".2byte .4byte .align .ascii .asciz .balign .byte .code .data .else .end .endif .endm .endr .equ .err .exitm .extern .global .hword .if .ifdef .ifndef .include .irp .long .macro .rept .req .section .set .skip .space .text .word .ltorg "
        ),
        built_in: "$0 $1 $2 $3 $4 $5 $6 $7 $8 $9 $10 $11 $12 $13 $14 $15 $16 $17 $18 $19 $20 $21 $22 $23 $24 $25 $26 $27 $28 $29 $30 $31 zero at v0 v1 a0 a1 a2 a3 a4 a5 a6 a7 t0 t1 t2 t3 t4 t5 t6 t7 t8 t9 s0 s1 s2 s3 s4 s5 s6 s7 s8 k0 k1 gp sp fp ra $f0 $f1 $f2 $f2 $f4 $f5 $f6 $f7 $f8 $f9 $f10 $f11 $f12 $f13 $f14 $f15 $f16 $f17 $f18 $f19 $f20 $f21 $f22 $f23 $f24 $f25 $f26 $f27 $f28 $f29 $f30 $f31 Context Random EntryLo0 EntryLo1 Context PageMask Wired EntryHi HWREna BadVAddr Count Compare SR IntCtl SRSCtl SRSMap Cause EPC PRId EBase Config Config1 Config2 Config3 LLAddr Debug DEPC DESAVE CacheErr ECC ErrorEPC TagLo DataLo TagHi DataHi WatchLo WatchHi PerfCtl PerfCnt "
        // Coprocessor 0 registers
      },
      contains: [
        {
          className: "keyword",
          begin: "\\b(addi?u?|andi?|b(al)?|beql?|bgez(al)?l?|bgtzl?|blezl?|bltz(al)?l?|bnel?|cl[oz]|divu?|ext|ins|j(al)?|jalr(\\.hb)?|jr(\\.hb)?|lbu?|lhu?|ll|lui|lw[lr]?|maddu?|mfhi|mflo|movn|movz|move|msubu?|mthi|mtlo|mul|multu?|nop|nor|ori?|rotrv?|sb|sc|se[bh]|sh|sllv?|slti?u?|srav?|srlv?|subu?|sw[lr]?|xori?|wsbh|abs\\.[sd]|add\\.[sd]|alnv.ps|bc1[ft]l?|c\\.(s?f|un|u?eq|[ou]lt|[ou]le|ngle?|seq|l[et]|ng[et])\\.[sd]|(ceil|floor|round|trunc)\\.[lw]\\.[sd]|cfc1|cvt\\.d\\.[lsw]|cvt\\.l\\.[dsw]|cvt\\.ps\\.s|cvt\\.s\\.[dlw]|cvt\\.s\\.p[lu]|cvt\\.w\\.[dls]|div\\.[ds]|ldx?c1|luxc1|lwx?c1|madd\\.[sd]|mfc1|mov[fntz]?\\.[ds]|msub\\.[sd]|mth?c1|mul\\.[ds]|neg\\.[ds]|nmadd\\.[ds]|nmsub\\.[ds]|p[lu][lu]\\.ps|recip\\.fmt|r?sqrt\\.[ds]|sdx?c1|sub\\.[ds]|suxc1|swx?c1|break|cache|d?eret|[de]i|ehb|mfc0|mtc0|pause|prefx?|rdhwr|rdpgpr|sdbbp|ssnop|synci?|syscall|teqi?|tgei?u?|tlb(p|r|w[ir])|tlti?u?|tnei?|wait|wrpgpr)",
          end: "\\s"
        },
        // lines ending with ; or # aren't really comments, probably auto-detect fail
        i.COMMENT("[;#](?!\\s*$)", "$"),
        i.C_BLOCK_COMMENT_MODE,
        i.QUOTE_STRING_MODE,
        {
          className: "string",
          begin: "'",
          end: "[^\\\\]'",
          relevance: 0
        },
        {
          className: "title",
          begin: "\\|",
          end: "\\|",
          illegal: "\\n",
          relevance: 0
        },
        {
          className: "number",
          variants: [
            {
              // hex
              begin: "0x[0-9a-f]+"
            },
            {
              // bare number
              begin: "\\b-?\\d+"
            }
          ],
          relevance: 0
        },
        {
          className: "symbol",
          variants: [
            {
              // GNU MIPS syntax
              begin: "^\\s*[a-z_\\.\\$][a-z0-9_\\.\\$]+:"
            },
            {
              // numbered local labels
              begin: "^\\s*[0-9]+:"
            },
            {
              // number local label reference (backwards, forwards)
              begin: "[0-9]+[bf]"
            }
          ],
          relevance: 0
        }
      ],
      // forward slashes are not allowed
      illegal: /\//
    };
  }
  return m_ = s, m_;
}
var f_, Yb;
function ZP() {
  if (Yb)
    return f_;
  Yb = 1;
  function s(i) {
    return {
      name: "Mizar",
      keywords: "environ vocabularies notations constructors definitions registrations theorems schemes requirements begin end definition registration cluster existence pred func defpred deffunc theorem proof let take assume then thus hence ex for st holds consider reconsider such that and in provided of as from be being by means equals implies iff redefine define now not or attr is mode suppose per cases set thesis contradiction scheme reserve struct correctness compatibility coherence symmetry assymetry reflexivity irreflexivity connectedness uniqueness commutativity idempotence involutiveness projectivity",
      contains: [i.COMMENT("::", "$")]
    };
  }
  return f_ = s, f_;
}
var g_, Hb;
function jP() {
  if (Hb)
    return g_;
  Hb = 1;
  function s(i) {
    const o = i.regex, c = [
      "abs",
      "accept",
      "alarm",
      "and",
      "atan2",
      "bind",
      "binmode",
      "bless",
      "break",
      "caller",
      "chdir",
      "chmod",
      "chomp",
      "chop",
      "chown",
      "chr",
      "chroot",
      "close",
      "closedir",
      "connect",
      "continue",
      "cos",
      "crypt",
      "dbmclose",
      "dbmopen",
      "defined",
      "delete",
      "die",
      "do",
      "dump",
      "each",
      "else",
      "elsif",
      "endgrent",
      "endhostent",
      "endnetent",
      "endprotoent",
      "endpwent",
      "endservent",
      "eof",
      "eval",
      "exec",
      "exists",
      "exit",
      "exp",
      "fcntl",
      "fileno",
      "flock",
      "for",
      "foreach",
      "fork",
      "format",
      "formline",
      "getc",
      "getgrent",
      "getgrgid",
      "getgrnam",
      "gethostbyaddr",
      "gethostbyname",
      "gethostent",
      "getlogin",
      "getnetbyaddr",
      "getnetbyname",
      "getnetent",
      "getpeername",
      "getpgrp",
      "getpriority",
      "getprotobyname",
      "getprotobynumber",
      "getprotoent",
      "getpwent",
      "getpwnam",
      "getpwuid",
      "getservbyname",
      "getservbyport",
      "getservent",
      "getsockname",
      "getsockopt",
      "given",
      "glob",
      "gmtime",
      "goto",
      "grep",
      "gt",
      "hex",
      "if",
      "index",
      "int",
      "ioctl",
      "join",
      "keys",
      "kill",
      "last",
      "lc",
      "lcfirst",
      "length",
      "link",
      "listen",
      "local",
      "localtime",
      "log",
      "lstat",
      "lt",
      "ma",
      "map",
      "mkdir",
      "msgctl",
      "msgget",
      "msgrcv",
      "msgsnd",
      "my",
      "ne",
      "next",
      "no",
      "not",
      "oct",
      "open",
      "opendir",
      "or",
      "ord",
      "our",
      "pack",
      "package",
      "pipe",
      "pop",
      "pos",
      "print",
      "printf",
      "prototype",
      "push",
      "q|0",
      "qq",
      "quotemeta",
      "qw",
      "qx",
      "rand",
      "read",
      "readdir",
      "readline",
      "readlink",
      "readpipe",
      "recv",
      "redo",
      "ref",
      "rename",
      "require",
      "reset",
      "return",
      "reverse",
      "rewinddir",
      "rindex",
      "rmdir",
      "say",
      "scalar",
      "seek",
      "seekdir",
      "select",
      "semctl",
      "semget",
      "semop",
      "send",
      "setgrent",
      "sethostent",
      "setnetent",
      "setpgrp",
      "setpriority",
      "setprotoent",
      "setpwent",
      "setservent",
      "setsockopt",
      "shift",
      "shmctl",
      "shmget",
      "shmread",
      "shmwrite",
      "shutdown",
      "sin",
      "sleep",
      "socket",
      "socketpair",
      "sort",
      "splice",
      "split",
      "sprintf",
      "sqrt",
      "srand",
      "stat",
      "state",
      "study",
      "sub",
      "substr",
      "symlink",
      "syscall",
      "sysopen",
      "sysread",
      "sysseek",
      "system",
      "syswrite",
      "tell",
      "telldir",
      "tie",
      "tied",
      "time",
      "times",
      "tr",
      "truncate",
      "uc",
      "ucfirst",
      "umask",
      "undef",
      "unless",
      "unlink",
      "unpack",
      "unshift",
      "untie",
      "until",
      "use",
      "utime",
      "values",
      "vec",
      "wait",
      "waitpid",
      "wantarray",
      "warn",
      "when",
      "while",
      "write",
      "x|0",
      "xor",
      "y|0"
    ], r = /[dualxmsipngr]{0,12}/, e = {
      $pattern: /[\w.]+/,
      keyword: c.join(" ")
    }, g = {
      className: "subst",
      begin: "[$@]\\{",
      end: "\\}",
      keywords: e
    }, h = {
      begin: /->\{/,
      end: /\}/
      // contains defined later
    }, S = { variants: [
      { begin: /\$\d/ },
      { begin: o.concat(
        /[$%@](\^\w\b|#\w+(::\w+)*|\{\w+\}|\w+(::\w*)*)/,
        // negative look-ahead tries to avoid matching patterns that are not
        // Perl at all like $ident$, @ident@, etc.
        "(?![A-Za-z])(?![@$%])"
      ) },
      {
        begin: /[$%@][^\s\w{]/,
        relevance: 0
      }
    ] }, C = [
      i.BACKSLASH_ESCAPE,
      g,
      S
    ], O = [
      /!/,
      /\//,
      /\|/,
      /\?/,
      /'/,
      /"/,
      // valid but infrequent and weird
      /#/
      // valid but infrequent and weird
    ], N = (L, G, Y = "\\1") => {
      const k = Y === "\\1" ? Y : o.concat(Y, G);
      return o.concat(
        o.concat("(?:", L, ")"),
        G,
        /(?:\\.|[^\\\/])*?/,
        k,
        /(?:\\.|[^\\\/])*?/,
        Y,
        r
      );
    }, D = (L, G, Y) => o.concat(
      o.concat("(?:", L, ")"),
      G,
      /(?:\\.|[^\\\/])*?/,
      Y,
      r
    ), x = [
      S,
      i.HASH_COMMENT_MODE,
      i.COMMENT(
        /^=\w/,
        /=cut/,
        { endsWithParent: !0 }
      ),
      h,
      {
        className: "string",
        contains: C,
        variants: [
          {
            begin: "q[qwxr]?\\s*\\(",
            end: "\\)",
            relevance: 5
          },
          {
            begin: "q[qwxr]?\\s*\\[",
            end: "\\]",
            relevance: 5
          },
          {
            begin: "q[qwxr]?\\s*\\{",
            end: "\\}",
            relevance: 5
          },
          {
            begin: "q[qwxr]?\\s*\\|",
            end: "\\|",
            relevance: 5
          },
          {
            begin: "q[qwxr]?\\s*<",
            end: ">",
            relevance: 5
          },
          {
            begin: "qw\\s+q",
            end: "q",
            relevance: 5
          },
          {
            begin: "'",
            end: "'",
            contains: [i.BACKSLASH_ESCAPE]
          },
          {
            begin: '"',
            end: '"'
          },
          {
            begin: "`",
            end: "`",
            contains: [i.BACKSLASH_ESCAPE]
          },
          {
            begin: /\{\w+\}/,
            relevance: 0
          },
          {
            begin: "-?\\w+\\s*=>",
            relevance: 0
          }
        ]
      },
      {
        className: "number",
        begin: "(\\b0[0-7_]+)|(\\b0x[0-9a-fA-F_]+)|(\\b[1-9][0-9_]*(\\.[0-9_]+)?)|[0_]\\b",
        relevance: 0
      },
      {
        // regexp container
        begin: "(\\/\\/|" + i.RE_STARTERS_RE + "|\\b(split|return|print|reverse|grep)\\b)\\s*",
        keywords: "split return print reverse grep",
        relevance: 0,
        contains: [
          i.HASH_COMMENT_MODE,
          {
            className: "regexp",
            variants: [
              // allow matching common delimiters
              { begin: N("s|tr|y", o.either(...O, { capture: !0 })) },
              // and then paired delmis
              { begin: N("s|tr|y", "\\(", "\\)") },
              { begin: N("s|tr|y", "\\[", "\\]") },
              { begin: N("s|tr|y", "\\{", "\\}") }
            ],
            relevance: 2
          },
          {
            className: "regexp",
            variants: [
              {
                // could be a comment in many languages so do not count
                // as relevant
                begin: /(m|qr)\/\//,
                relevance: 0
              },
              // prefix is optional with /regex/
              { begin: D("(?:m|qr)?", /\//, /\//) },
              // allow matching common delimiters
              { begin: D("m|qr", o.either(...O, { capture: !0 }), /\1/) },
              // allow common paired delmins
              { begin: D("m|qr", /\(/, /\)/) },
              { begin: D("m|qr", /\[/, /\]/) },
              { begin: D("m|qr", /\{/, /\}/) }
            ]
          }
        ]
      },
      {
        className: "function",
        beginKeywords: "sub",
        end: "(\\s*\\(.*?\\))?[;{]",
        excludeEnd: !0,
        relevance: 5,
        contains: [i.TITLE_MODE]
      },
      {
        begin: "-\\w\\b",
        relevance: 0
      },
      {
        begin: "^__DATA__$",
        end: "^__END__$",
        subLanguage: "mojolicious",
        contains: [
          {
            begin: "^@@.*",
            end: "$",
            className: "comment"
          }
        ]
      }
    ];
    return g.contains = x, h.contains = x, {
      name: "Perl",
      aliases: [
        "pl",
        "pm"
      ],
      keywords: e,
      contains: x
    };
  }
  return g_ = s, g_;
}
var E_, qb;
function JP() {
  if (qb)
    return E_;
  qb = 1;
  function s(i) {
    return {
      name: "Mojolicious",
      subLanguage: "xml",
      contains: [
        {
          className: "meta",
          begin: "^__(END|DATA)__$"
        },
        // mojolicious line
        {
          begin: "^\\s*%{1,2}={0,2}",
          end: "$",
          subLanguage: "perl"
        },
        // mojolicious block
        {
          begin: "<%{1,2}={0,2}",
          end: "={0,1}%>",
          subLanguage: "perl",
          excludeBegin: !0,
          excludeEnd: !0
        }
      ]
    };
  }
  return E_ = s, E_;
}
var h_, $b;
function ek() {
  if ($b)
    return h_;
  $b = 1;
  function s(i) {
    const o = {
      className: "number",
      relevance: 0,
      variants: [
        { begin: "[$][a-fA-F0-9]+" },
        i.NUMBER_MODE
      ]
    }, c = {
      variants: [
        { match: [
          /(function|method)/,
          /\s+/,
          i.UNDERSCORE_IDENT_RE
        ] }
      ],
      scope: {
        1: "keyword",
        3: "title.function"
      }
    }, r = {
      variants: [
        { match: [
          /(class|interface|extends|implements)/,
          /\s+/,
          i.UNDERSCORE_IDENT_RE
        ] }
      ],
      scope: {
        1: "keyword",
        3: "title.class"
      }
    };
    return {
      name: "Monkey",
      case_insensitive: !0,
      keywords: {
        keyword: [
          "public",
          "private",
          "property",
          "continue",
          "exit",
          "extern",
          "new",
          "try",
          "catch",
          "eachin",
          "not",
          "abstract",
          "final",
          "select",
          "case",
          "default",
          "const",
          "local",
          "global",
          "field",
          "end",
          "if",
          "then",
          "else",
          "elseif",
          "endif",
          "while",
          "wend",
          "repeat",
          "until",
          "forever",
          "for",
          "to",
          "step",
          "next",
          "return",
          "module",
          "inline",
          "throw",
          "import",
          // not positive, but these are not literals
          "and",
          "or",
          "shl",
          "shr",
          "mod"
        ],
        built_in: [
          "DebugLog",
          "DebugStop",
          "Error",
          "Print",
          "ACos",
          "ACosr",
          "ASin",
          "ASinr",
          "ATan",
          "ATan2",
          "ATan2r",
          "ATanr",
          "Abs",
          "Abs",
          "Ceil",
          "Clamp",
          "Clamp",
          "Cos",
          "Cosr",
          "Exp",
          "Floor",
          "Log",
          "Max",
          "Max",
          "Min",
          "Min",
          "Pow",
          "Sgn",
          "Sgn",
          "Sin",
          "Sinr",
          "Sqrt",
          "Tan",
          "Tanr",
          "Seed",
          "PI",
          "HALFPI",
          "TWOPI"
        ],
        literal: [
          "true",
          "false",
          "null"
        ]
      },
      illegal: /\/\*/,
      contains: [
        i.COMMENT("#rem", "#end"),
        i.COMMENT(
          "'",
          "$",
          { relevance: 0 }
        ),
        c,
        r,
        {
          className: "variable.language",
          begin: /\b(self|super)\b/
        },
        {
          className: "meta",
          begin: /\s*#/,
          end: "$",
          keywords: { keyword: "if else elseif endif end then" }
        },
        {
          match: [
            /^\s*/,
            /strict\b/
          ],
          scope: { 2: "meta" }
        },
        {
          beginKeywords: "alias",
          end: "=",
          contains: [i.UNDERSCORE_TITLE_MODE]
        },
        i.QUOTE_STRING_MODE,
        o
      ]
    };
  }
  return h_ = s, h_;
}
var S_, Wb;
function tk() {
  if (Wb)
    return S_;
  Wb = 1;
  function s(i) {
    const o = {
      keyword: (
        // Moonscript keywords
        "if then not for in while do return else elseif break continue switch and or unless when class extends super local import export from using"
      ),
      literal: "true false nil",
      built_in: "_G _VERSION assert collectgarbage dofile error getfenv getmetatable ipairs load loadfile loadstring module next pairs pcall print rawequal rawget rawset require select setfenv setmetatable tonumber tostring type unpack xpcall coroutine debug io math os package string table"
    }, c = "[A-Za-z$_][0-9A-Za-z$_]*", r = {
      className: "subst",
      begin: /#\{/,
      end: /\}/,
      keywords: o
    }, e = [
      i.inherit(
        i.C_NUMBER_MODE,
        { starts: {
          end: "(\\s*/)?",
          relevance: 0
        } }
      ),
      // a number tries to eat the following slash to prevent treating it as a regexp
      {
        className: "string",
        variants: [
          {
            begin: /'/,
            end: /'/,
            contains: [i.BACKSLASH_ESCAPE]
          },
          {
            begin: /"/,
            end: /"/,
            contains: [
              i.BACKSLASH_ESCAPE,
              r
            ]
          }
        ]
      },
      {
        className: "built_in",
        begin: "@__" + i.IDENT_RE
      },
      {
        begin: "@" + i.IDENT_RE
        // relevance booster on par with CoffeeScript
      },
      {
        begin: i.IDENT_RE + "\\\\" + i.IDENT_RE
        // inst\method
      }
    ];
    r.contains = e;
    const g = i.inherit(i.TITLE_MODE, { begin: c }), h = "(\\(.*\\)\\s*)?\\B[-=]>", S = {
      className: "params",
      begin: "\\([^\\(]",
      returnBegin: !0,
      /* We need another contained nameless mode to not have every nested
      pair of parens to be called "params" */
      contains: [
        {
          begin: /\(/,
          end: /\)/,
          keywords: o,
          contains: ["self"].concat(e)
        }
      ]
    };
    return {
      name: "MoonScript",
      aliases: ["moon"],
      keywords: o,
      illegal: /\/\*/,
      contains: e.concat([
        i.COMMENT("--", "$"),
        {
          className: "function",
          // function: -> =>
          begin: "^\\s*" + c + "\\s*=\\s*" + h,
          end: "[-=]>",
          returnBegin: !0,
          contains: [
            g,
            S
          ]
        },
        {
          begin: /[\(,:=]\s*/,
          // anonymous function start
          relevance: 0,
          contains: [
            {
              className: "function",
              begin: h,
              end: "[-=]>",
              returnBegin: !0,
              contains: [S]
            }
          ]
        },
        {
          className: "class",
          beginKeywords: "class",
          end: "$",
          illegal: /[:="\[\]]/,
          contains: [
            {
              beginKeywords: "extends",
              endsWithParent: !0,
              illegal: /[:="\[\]]/,
              contains: [g]
            },
            g
          ]
        },
        {
          className: "name",
          // table
          begin: c + ":",
          end: ":",
          returnBegin: !0,
          returnEnd: !0,
          relevance: 0
        }
      ])
    };
  }
  return S_ = s, S_;
}
var b_, zb;
function rk() {
  if (zb)
    return b_;
  zb = 1;
  function s(i) {
    return {
      name: "N1QL",
      case_insensitive: !0,
      contains: [
        {
          beginKeywords: "build create index delete drop explain infer|10 insert merge prepare select update upsert|10",
          end: /;/,
          keywords: {
            keyword: [
              "all",
              "alter",
              "analyze",
              "and",
              "any",
              "array",
              "as",
              "asc",
              "begin",
              "between",
              "binary",
              "boolean",
              "break",
              "bucket",
              "build",
              "by",
              "call",
              "case",
              "cast",
              "cluster",
              "collate",
              "collection",
              "commit",
              "connect",
              "continue",
              "correlate",
              "cover",
              "create",
              "database",
              "dataset",
              "datastore",
              "declare",
              "decrement",
              "delete",
              "derived",
              "desc",
              "describe",
              "distinct",
              "do",
              "drop",
              "each",
              "element",
              "else",
              "end",
              "every",
              "except",
              "exclude",
              "execute",
              "exists",
              "explain",
              "fetch",
              "first",
              "flatten",
              "for",
              "force",
              "from",
              "function",
              "grant",
              "group",
              "gsi",
              "having",
              "if",
              "ignore",
              "ilike",
              "in",
              "include",
              "increment",
              "index",
              "infer",
              "inline",
              "inner",
              "insert",
              "intersect",
              "into",
              "is",
              "join",
              "key",
              "keys",
              "keyspace",
              "known",
              "last",
              "left",
              "let",
              "letting",
              "like",
              "limit",
              "lsm",
              "map",
              "mapping",
              "matched",
              "materialized",
              "merge",
              "minus",
              "namespace",
              "nest",
              "not",
              "number",
              "object",
              "offset",
              "on",
              "option",
              "or",
              "order",
              "outer",
              "over",
              "parse",
              "partition",
              "password",
              "path",
              "pool",
              "prepare",
              "primary",
              "private",
              "privilege",
              "procedure",
              "public",
              "raw",
              "realm",
              "reduce",
              "rename",
              "return",
              "returning",
              "revoke",
              "right",
              "role",
              "rollback",
              "satisfies",
              "schema",
              "select",
              "self",
              "semi",
              "set",
              "show",
              "some",
              "start",
              "statistics",
              "string",
              "system",
              "then",
              "to",
              "transaction",
              "trigger",
              "truncate",
              "under",
              "union",
              "unique",
              "unknown",
              "unnest",
              "unset",
              "update",
              "upsert",
              "use",
              "user",
              "using",
              "validate",
              "value",
              "valued",
              "values",
              "via",
              "view",
              "when",
              "where",
              "while",
              "with",
              "within",
              "work",
              "xor"
            ],
            literal: [
              "true",
              "false",
              "null",
              "missing|5"
            ],
            built_in: [
              "array_agg",
              "array_append",
              "array_concat",
              "array_contains",
              "array_count",
              "array_distinct",
              "array_ifnull",
              "array_length",
              "array_max",
              "array_min",
              "array_position",
              "array_prepend",
              "array_put",
              "array_range",
              "array_remove",
              "array_repeat",
              "array_replace",
              "array_reverse",
              "array_sort",
              "array_sum",
              "avg",
              "count",
              "max",
              "min",
              "sum",
              "greatest",
              "least",
              "ifmissing",
              "ifmissingornull",
              "ifnull",
              "missingif",
              "nullif",
              "ifinf",
              "ifnan",
              "ifnanorinf",
              "naninf",
              "neginfif",
              "posinfif",
              "clock_millis",
              "clock_str",
              "date_add_millis",
              "date_add_str",
              "date_diff_millis",
              "date_diff_str",
              "date_part_millis",
              "date_part_str",
              "date_trunc_millis",
              "date_trunc_str",
              "duration_to_str",
              "millis",
              "str_to_millis",
              "millis_to_str",
              "millis_to_utc",
              "millis_to_zone_name",
              "now_millis",
              "now_str",
              "str_to_duration",
              "str_to_utc",
              "str_to_zone_name",
              "decode_json",
              "encode_json",
              "encoded_size",
              "poly_length",
              "base64",
              "base64_encode",
              "base64_decode",
              "meta",
              "uuid",
              "abs",
              "acos",
              "asin",
              "atan",
              "atan2",
              "ceil",
              "cos",
              "degrees",
              "e",
              "exp",
              "ln",
              "log",
              "floor",
              "pi",
              "power",
              "radians",
              "random",
              "round",
              "sign",
              "sin",
              "sqrt",
              "tan",
              "trunc",
              "object_length",
              "object_names",
              "object_pairs",
              "object_inner_pairs",
              "object_values",
              "object_inner_values",
              "object_add",
              "object_put",
              "object_remove",
              "object_unwrap",
              "regexp_contains",
              "regexp_like",
              "regexp_position",
              "regexp_replace",
              "contains",
              "initcap",
              "length",
              "lower",
              "ltrim",
              "position",
              "repeat",
              "replace",
              "rtrim",
              "split",
              "substr",
              "title",
              "trim",
              "upper",
              "isarray",
              "isatom",
              "isboolean",
              "isnumber",
              "isobject",
              "isstring",
              "type",
              "toarray",
              "toatom",
              "toboolean",
              "tonumber",
              "toobject",
              "tostring"
            ]
          },
          contains: [
            {
              className: "string",
              begin: "'",
              end: "'",
              contains: [i.BACKSLASH_ESCAPE]
            },
            {
              className: "string",
              begin: '"',
              end: '"',
              contains: [i.BACKSLASH_ESCAPE]
            },
            {
              className: "symbol",
              begin: "`",
              end: "`",
              contains: [i.BACKSLASH_ESCAPE]
            },
            i.C_NUMBER_MODE,
            i.C_BLOCK_COMMENT_MODE
          ]
        },
        i.C_BLOCK_COMMENT_MODE
      ]
    };
  }
  return b_ = s, b_;
}
var T_, Kb;
function nk() {
  if (Kb)
    return T_;
  Kb = 1;
  function s(i) {
    const o = {
      match: [
        /^\s*(?=\S)/,
        // have to look forward here to avoid polynomial backtracking
        /[^:]+/,
        /:\s*/,
        /$/
      ],
      className: {
        2: "attribute",
        3: "punctuation"
      }
    }, c = {
      match: [
        /^\s*(?=\S)/,
        // have to look forward here to avoid polynomial backtracking
        /[^:]*[^: ]/,
        /[ ]*:/,
        /[ ]/,
        /.*$/
      ],
      className: {
        2: "attribute",
        3: "punctuation",
        5: "string"
      }
    }, r = {
      match: [
        /^\s*/,
        />/,
        /[ ]/,
        /.*$/
      ],
      className: {
        2: "punctuation",
        4: "string"
      }
    }, e = {
      variants: [
        { match: [
          /^\s*/,
          /-/,
          /[ ]/,
          /.*$/
        ] },
        { match: [
          /^\s*/,
          /-$/
        ] }
      ],
      className: {
        2: "bullet",
        4: "string"
      }
    };
    return {
      name: "Nested Text",
      aliases: ["nt"],
      contains: [
        i.inherit(i.HASH_COMMENT_MODE, {
          begin: /^\s*(?=#)/,
          excludeBegin: !0
        }),
        e,
        r,
        o,
        c
      ]
    };
  }
  return T_ = s, T_;
}
var v_, Qb;
function ak() {
  if (Qb)
    return v_;
  Qb = 1;
  function s(i) {
    const o = i.regex, c = {
      className: "variable",
      variants: [
        { begin: /\$\d+/ },
        { begin: /\$\{\w+\}/ },
        { begin: o.concat(/[$@]/, i.UNDERSCORE_IDENT_RE) }
      ]
    }, e = {
      endsWithParent: !0,
      keywords: {
        $pattern: /[a-z_]{2,}|\/dev\/poll/,
        literal: [
          "on",
          "off",
          "yes",
          "no",
          "true",
          "false",
          "none",
          "blocked",
          "debug",
          "info",
          "notice",
          "warn",
          "error",
          "crit",
          "select",
          "break",
          "last",
          "permanent",
          "redirect",
          "kqueue",
          "rtsig",
          "epoll",
          "poll",
          "/dev/poll"
        ]
      },
      relevance: 0,
      illegal: "=>",
      contains: [
        i.HASH_COMMENT_MODE,
        {
          className: "string",
          contains: [
            i.BACKSLASH_ESCAPE,
            c
          ],
          variants: [
            {
              begin: /"/,
              end: /"/
            },
            {
              begin: /'/,
              end: /'/
            }
          ]
        },
        // this swallows entire URLs to avoid detecting numbers within
        {
          begin: "([a-z]+):/",
          end: "\\s",
          endsWithParent: !0,
          excludeEnd: !0,
          contains: [c]
        },
        {
          className: "regexp",
          contains: [
            i.BACKSLASH_ESCAPE,
            c
          ],
          variants: [
            {
              begin: "\\s\\^",
              end: "\\s|\\{|;",
              returnEnd: !0
            },
            // regexp locations (~, ~*)
            {
              begin: "~\\*?\\s+",
              end: "\\s|\\{|;",
              returnEnd: !0
            },
            // *.example.com
            { begin: "\\*(\\.[a-z\\-]+)+" },
            // sub.example.*
            { begin: "([a-z\\-]+\\.)+\\*" }
          ]
        },
        // IP
        {
          className: "number",
          begin: "\\b\\d{1,3}\\.\\d{1,3}\\.\\d{1,3}\\.\\d{1,3}(:\\d{1,5})?\\b"
        },
        // units
        {
          className: "number",
          begin: "\\b\\d+[kKmMgGdshdwy]?\\b",
          relevance: 0
        },
        c
      ]
    };
    return {
      name: "Nginx config",
      aliases: ["nginxconf"],
      contains: [
        i.HASH_COMMENT_MODE,
        {
          beginKeywords: "upstream location",
          end: /;|\{/,
          contains: e.contains,
          keywords: { section: "upstream location" }
        },
        {
          className: "section",
          begin: o.concat(i.UNDERSCORE_IDENT_RE + o.lookahead(/\s+\{/)),
          relevance: 0
        },
        {
          begin: o.lookahead(i.UNDERSCORE_IDENT_RE + "\\s"),
          end: ";|\\{",
          contains: [
            {
              className: "attribute",
              begin: i.UNDERSCORE_IDENT_RE,
              starts: e
            }
          ],
          relevance: 0
        }
      ],
      illegal: "[^\\s\\}\\{]"
    };
  }
  return v_ = s, v_;
}
var C_, Xb;
function ik() {
  if (Xb)
    return C_;
  Xb = 1;
  function s(i) {
    return {
      name: "Nim",
      keywords: {
        keyword: [
          "addr",
          "and",
          "as",
          "asm",
          "bind",
          "block",
          "break",
          "case",
          "cast",
          "const",
          "continue",
          "converter",
          "discard",
          "distinct",
          "div",
          "do",
          "elif",
          "else",
          "end",
          "enum",
          "except",
          "export",
          "finally",
          "for",
          "from",
          "func",
          "generic",
          "guarded",
          "if",
          "import",
          "in",
          "include",
          "interface",
          "is",
          "isnot",
          "iterator",
          "let",
          "macro",
          "method",
          "mixin",
          "mod",
          "nil",
          "not",
          "notin",
          "object",
          "of",
          "or",
          "out",
          "proc",
          "ptr",
          "raise",
          "ref",
          "return",
          "shared",
          "shl",
          "shr",
          "static",
          "template",
          "try",
          "tuple",
          "type",
          "using",
          "var",
          "when",
          "while",
          "with",
          "without",
          "xor",
          "yield"
        ],
        literal: [
          "true",
          "false"
        ],
        type: [
          "int",
          "int8",
          "int16",
          "int32",
          "int64",
          "uint",
          "uint8",
          "uint16",
          "uint32",
          "uint64",
          "float",
          "float32",
          "float64",
          "bool",
          "char",
          "string",
          "cstring",
          "pointer",
          "expr",
          "stmt",
          "void",
          "auto",
          "any",
          "range",
          "array",
          "openarray",
          "varargs",
          "seq",
          "set",
          "clong",
          "culong",
          "cchar",
          "cschar",
          "cshort",
          "cint",
          "csize",
          "clonglong",
          "cfloat",
          "cdouble",
          "clongdouble",
          "cuchar",
          "cushort",
          "cuint",
          "culonglong",
          "cstringarray",
          "semistatic"
        ],
        built_in: [
          "stdin",
          "stdout",
          "stderr",
          "result"
        ]
      },
      contains: [
        {
          className: "meta",
          // Actually pragma
          begin: /\{\./,
          end: /\.\}/,
          relevance: 10
        },
        {
          className: "string",
          begin: /[a-zA-Z]\w*"/,
          end: /"/,
          contains: [{ begin: /""/ }]
        },
        {
          className: "string",
          begin: /([a-zA-Z]\w*)?"""/,
          end: /"""/
        },
        i.QUOTE_STRING_MODE,
        {
          className: "type",
          begin: /\b[A-Z]\w+\b/,
          relevance: 0
        },
        {
          className: "number",
          relevance: 0,
          variants: [
            { begin: /\b(0[xX][0-9a-fA-F][_0-9a-fA-F]*)('?[iIuU](8|16|32|64))?/ },
            { begin: /\b(0o[0-7][_0-7]*)('?[iIuUfF](8|16|32|64))?/ },
            { begin: /\b(0(b|B)[01][_01]*)('?[iIuUfF](8|16|32|64))?/ },
            { begin: /\b(\d[_\d]*)('?[iIuUfF](8|16|32|64))?/ }
          ]
        },
        i.HASH_COMMENT_MODE
      ]
    };
  }
  return C_ = s, C_;
}
var R_, Zb;
function ok() {
  if (Zb)
    return R_;
  Zb = 1;
  function s(i) {
    const o = {
      keyword: [
        "rec",
        "with",
        "let",
        "in",
        "inherit",
        "assert",
        "if",
        "else",
        "then"
      ],
      literal: [
        "true",
        "false",
        "or",
        "and",
        "null"
      ],
      built_in: [
        "import",
        "abort",
        "baseNameOf",
        "dirOf",
        "isNull",
        "builtins",
        "map",
        "removeAttrs",
        "throw",
        "toString",
        "derivation"
      ]
    }, c = {
      className: "subst",
      begin: /\$\{/,
      end: /\}/,
      keywords: o
    }, r = {
      className: "char.escape",
      begin: /''\$/
    }, e = {
      begin: /[a-zA-Z0-9-_]+(\s*=)/,
      returnBegin: !0,
      relevance: 0,
      contains: [
        {
          className: "attr",
          begin: /\S+/,
          relevance: 0.2
        }
      ]
    }, g = {
      className: "string",
      contains: [r, c],
      variants: [
        {
          begin: "''",
          end: "''"
        },
        {
          begin: '"',
          end: '"'
        }
      ]
    }, h = [
      i.NUMBER_MODE,
      i.HASH_COMMENT_MODE,
      i.C_BLOCK_COMMENT_MODE,
      g,
      e
    ];
    return c.contains = h, {
      name: "Nix",
      aliases: ["nixos"],
      keywords: o,
      contains: h
    };
  }
  return R_ = s, R_;
}
var N_, jb;
function sk() {
  if (jb)
    return N_;
  jb = 1;
  function s(i) {
    return {
      name: "Node REPL",
      contains: [
        {
          className: "meta.prompt",
          starts: {
            // a space separates the REPL prefix from the actual code
            // this is purely for cleaner HTML output
            end: / |$/,
            starts: {
              end: "$",
              subLanguage: "javascript"
            }
          },
          variants: [
            { begin: /^>(?=[ ]|$)/ },
            { begin: /^\.\.\.(?=[ ]|$)/ }
          ]
        }
      ]
    };
  }
  return N_ = s, N_;
}
var A_, Jb;
function lk() {
  if (Jb)
    return A_;
  Jb = 1;
  function s(i) {
    const o = i.regex, c = [
      "ADMINTOOLS",
      "APPDATA",
      "CDBURN_AREA",
      "CMDLINE",
      "COMMONFILES32",
      "COMMONFILES64",
      "COMMONFILES",
      "COOKIES",
      "DESKTOP",
      "DOCUMENTS",
      "EXEDIR",
      "EXEFILE",
      "EXEPATH",
      "FAVORITES",
      "FONTS",
      "HISTORY",
      "HWNDPARENT",
      "INSTDIR",
      "INTERNET_CACHE",
      "LANGUAGE",
      "LOCALAPPDATA",
      "MUSIC",
      "NETHOOD",
      "OUTDIR",
      "PICTURES",
      "PLUGINSDIR",
      "PRINTHOOD",
      "PROFILE",
      "PROGRAMFILES32",
      "PROGRAMFILES64",
      "PROGRAMFILES",
      "QUICKLAUNCH",
      "RECENT",
      "RESOURCES_LOCALIZED",
      "RESOURCES",
      "SENDTO",
      "SMPROGRAMS",
      "SMSTARTUP",
      "STARTMENU",
      "SYSDIR",
      "TEMP",
      "TEMPLATES",
      "VIDEOS",
      "WINDIR"
    ], r = [
      "ARCHIVE",
      "FILE_ATTRIBUTE_ARCHIVE",
      "FILE_ATTRIBUTE_NORMAL",
      "FILE_ATTRIBUTE_OFFLINE",
      "FILE_ATTRIBUTE_READONLY",
      "FILE_ATTRIBUTE_SYSTEM",
      "FILE_ATTRIBUTE_TEMPORARY",
      "HKCR",
      "HKCU",
      "HKDD",
      "HKEY_CLASSES_ROOT",
      "HKEY_CURRENT_CONFIG",
      "HKEY_CURRENT_USER",
      "HKEY_DYN_DATA",
      "HKEY_LOCAL_MACHINE",
      "HKEY_PERFORMANCE_DATA",
      "HKEY_USERS",
      "HKLM",
      "HKPD",
      "HKU",
      "IDABORT",
      "IDCANCEL",
      "IDIGNORE",
      "IDNO",
      "IDOK",
      "IDRETRY",
      "IDYES",
      "MB_ABORTRETRYIGNORE",
      "MB_DEFBUTTON1",
      "MB_DEFBUTTON2",
      "MB_DEFBUTTON3",
      "MB_DEFBUTTON4",
      "MB_ICONEXCLAMATION",
      "MB_ICONINFORMATION",
      "MB_ICONQUESTION",
      "MB_ICONSTOP",
      "MB_OK",
      "MB_OKCANCEL",
      "MB_RETRYCANCEL",
      "MB_RIGHT",
      "MB_RTLREADING",
      "MB_SETFOREGROUND",
      "MB_TOPMOST",
      "MB_USERICON",
      "MB_YESNO",
      "NORMAL",
      "OFFLINE",
      "READONLY",
      "SHCTX",
      "SHELL_CONTEXT",
      "SYSTEM|TEMPORARY"
    ], e = [
      "addincludedir",
      "addplugindir",
      "appendfile",
      "assert",
      "cd",
      "define",
      "delfile",
      "echo",
      "else",
      "endif",
      "error",
      "execute",
      "finalize",
      "getdllversion",
      "gettlbversion",
      "if",
      "ifdef",
      "ifmacrodef",
      "ifmacrondef",
      "ifndef",
      "include",
      "insertmacro",
      "macro",
      "macroend",
      "makensis",
      "packhdr",
      "searchparse",
      "searchreplace",
      "system",
      "tempfile",
      "undef",
      "uninstfinalize",
      "verbose",
      "warning"
    ], g = {
      className: "variable.constant",
      begin: o.concat(/\$/, o.either(...c))
    }, h = {
      // ${defines}
      className: "variable",
      begin: /\$+\{[\!\w.:-]+\}/
    }, S = {
      // $variables
      className: "variable",
      begin: /\$+\w[\w\.]*/,
      illegal: /\(\)\{\}/
    }, C = {
      // $(language_strings)
      className: "variable",
      begin: /\$+\([\w^.:!-]+\)/
    }, O = {
      // command parameters
      className: "params",
      begin: o.either(...r)
    }, N = {
      // !compiler_flags
      className: "keyword",
      begin: o.concat(
        /!/,
        o.either(...e)
      )
    }, D = {
      // $\n, $\r, $\t, $$
      className: "char.escape",
      begin: /\$(\\[nrt]|\$)/
    }, x = {
      // plug::ins
      className: "title.function",
      begin: /\w+::\w+/
    }, L = {
      className: "string",
      variants: [
        {
          begin: '"',
          end: '"'
        },
        {
          begin: "'",
          end: "'"
        },
        {
          begin: "`",
          end: "`"
        }
      ],
      illegal: /\n/,
      contains: [
        D,
        g,
        h,
        S,
        C
      ]
    }, G = [
      "Abort",
      "AddBrandingImage",
      "AddSize",
      "AllowRootDirInstall",
      "AllowSkipFiles",
      "AutoCloseWindow",
      "BGFont",
      "BGGradient",
      "BrandingText",
      "BringToFront",
      "Call",
      "CallInstDLL",
      "Caption",
      "ChangeUI",
      "CheckBitmap",
      "ClearErrors",
      "CompletedText",
      "ComponentText",
      "CopyFiles",
      "CRCCheck",
      "CreateDirectory",
      "CreateFont",
      "CreateShortCut",
      "Delete",
      "DeleteINISec",
      "DeleteINIStr",
      "DeleteRegKey",
      "DeleteRegValue",
      "DetailPrint",
      "DetailsButtonText",
      "DirText",
      "DirVar",
      "DirVerify",
      "EnableWindow",
      "EnumRegKey",
      "EnumRegValue",
      "Exch",
      "Exec",
      "ExecShell",
      "ExecShellWait",
      "ExecWait",
      "ExpandEnvStrings",
      "File",
      "FileBufSize",
      "FileClose",
      "FileErrorText",
      "FileOpen",
      "FileRead",
      "FileReadByte",
      "FileReadUTF16LE",
      "FileReadWord",
      "FileWriteUTF16LE",
      "FileSeek",
      "FileWrite",
      "FileWriteByte",
      "FileWriteWord",
      "FindClose",
      "FindFirst",
      "FindNext",
      "FindWindow",
      "FlushINI",
      "GetCurInstType",
      "GetCurrentAddress",
      "GetDlgItem",
      "GetDLLVersion",
      "GetDLLVersionLocal",
      "GetErrorLevel",
      "GetFileTime",
      "GetFileTimeLocal",
      "GetFullPathName",
      "GetFunctionAddress",
      "GetInstDirError",
      "GetKnownFolderPath",
      "GetLabelAddress",
      "GetTempFileName",
      "GetWinVer",
      "Goto",
      "HideWindow",
      "Icon",
      "IfAbort",
      "IfErrors",
      "IfFileExists",
      "IfRebootFlag",
      "IfRtlLanguage",
      "IfShellVarContextAll",
      "IfSilent",
      "InitPluginsDir",
      "InstallButtonText",
      "InstallColors",
      "InstallDir",
      "InstallDirRegKey",
      "InstProgressFlags",
      "InstType",
      "InstTypeGetText",
      "InstTypeSetText",
      "Int64Cmp",
      "Int64CmpU",
      "Int64Fmt",
      "IntCmp",
      "IntCmpU",
      "IntFmt",
      "IntOp",
      "IntPtrCmp",
      "IntPtrCmpU",
      "IntPtrOp",
      "IsWindow",
      "LangString",
      "LicenseBkColor",
      "LicenseData",
      "LicenseForceSelection",
      "LicenseLangString",
      "LicenseText",
      "LoadAndSetImage",
      "LoadLanguageFile",
      "LockWindow",
      "LogSet",
      "LogText",
      "ManifestDPIAware",
      "ManifestLongPathAware",
      "ManifestMaxVersionTested",
      "ManifestSupportedOS",
      "MessageBox",
      "MiscButtonText",
      "Name|0",
      "Nop",
      "OutFile",
      "Page",
      "PageCallbacks",
      "PEAddResource",
      "PEDllCharacteristics",
      "PERemoveResource",
      "PESubsysVer",
      "Pop",
      "Push",
      "Quit",
      "ReadEnvStr",
      "ReadINIStr",
      "ReadRegDWORD",
      "ReadRegStr",
      "Reboot",
      "RegDLL",
      "Rename",
      "RequestExecutionLevel",
      "ReserveFile",
      "Return",
      "RMDir",
      "SearchPath",
      "SectionGetFlags",
      "SectionGetInstTypes",
      "SectionGetSize",
      "SectionGetText",
      "SectionIn",
      "SectionSetFlags",
      "SectionSetInstTypes",
      "SectionSetSize",
      "SectionSetText",
      "SendMessage",
      "SetAutoClose",
      "SetBrandingImage",
      "SetCompress",
      "SetCompressor",
      "SetCompressorDictSize",
      "SetCtlColors",
      "SetCurInstType",
      "SetDatablockOptimize",
      "SetDateSave",
      "SetDetailsPrint",
      "SetDetailsView",
      "SetErrorLevel",
      "SetErrors",
      "SetFileAttributes",
      "SetFont",
      "SetOutPath",
      "SetOverwrite",
      "SetRebootFlag",
      "SetRegView",
      "SetShellVarContext",
      "SetSilent",
      "ShowInstDetails",
      "ShowUninstDetails",
      "ShowWindow",
      "SilentInstall",
      "SilentUnInstall",
      "Sleep",
      "SpaceTexts",
      "StrCmp",
      "StrCmpS",
      "StrCpy",
      "StrLen",
      "SubCaption",
      "Unicode",
      "UninstallButtonText",
      "UninstallCaption",
      "UninstallIcon",
      "UninstallSubCaption",
      "UninstallText",
      "UninstPage",
      "UnRegDLL",
      "Var",
      "VIAddVersionKey",
      "VIFileVersion",
      "VIProductVersion",
      "WindowIcon",
      "WriteINIStr",
      "WriteRegBin",
      "WriteRegDWORD",
      "WriteRegExpandStr",
      "WriteRegMultiStr",
      "WriteRegNone",
      "WriteRegStr",
      "WriteUninstaller",
      "XPStyle"
    ], Y = [
      "admin",
      "all",
      "auto",
      "both",
      "bottom",
      "bzip2",
      "colored",
      "components",
      "current",
      "custom",
      "directory",
      "false",
      "force",
      "hide",
      "highest",
      "ifdiff",
      "ifnewer",
      "instfiles",
      "lastused",
      "leave",
      "left",
      "license",
      "listonly",
      "lzma",
      "nevershow",
      "none",
      "normal",
      "notset",
      "off",
      "on",
      "open",
      "print",
      "right",
      "show",
      "silent",
      "silentlog",
      "smooth",
      "textonly",
      "top",
      "true",
      "try",
      "un.components",
      "un.custom",
      "un.directory",
      "un.instfiles",
      "un.license",
      "uninstConfirm",
      "user",
      "Win10",
      "Win7",
      "Win8",
      "WinVista",
      "zlib"
    ], k = {
      match: [
        /Function/,
        /\s+/,
        o.concat(/(\.)?/, i.IDENT_RE)
      ],
      scope: {
        1: "keyword",
        3: "title.function"
      }
    }, Z = {
      match: [
        /Var/,
        /\s+/,
        /(?:\/GLOBAL\s+)?/,
        /[A-Za-z][\w.]*/
      ],
      scope: {
        1: "keyword",
        3: "params",
        4: "variable"
      }
    };
    return {
      name: "NSIS",
      case_insensitive: !0,
      keywords: {
        keyword: G,
        literal: Y
      },
      contains: [
        i.HASH_COMMENT_MODE,
        i.C_BLOCK_COMMENT_MODE,
        i.COMMENT(
          ";",
          "$",
          { relevance: 0 }
        ),
        Z,
        k,
        { beginKeywords: "Function PageEx Section SectionGroup FunctionEnd SectionEnd" },
        L,
        N,
        h,
        S,
        C,
        O,
        x,
        i.NUMBER_MODE
      ]
    };
  }
  return A_ = s, A_;
}
var O_, eT;
function ck() {
  if (eT)
    return O_;
  eT = 1;
  function s(i) {
    const o = {
      className: "built_in",
      begin: "\\b(AV|CA|CF|CG|CI|CL|CM|CN|CT|MK|MP|MTK|MTL|NS|SCN|SK|UI|WK|XC)\\w+"
    }, c = /[a-zA-Z@][a-zA-Z0-9_]*/, S = {
      "variable.language": [
        "this",
        "super"
      ],
      $pattern: c,
      keyword: [
        "while",
        "export",
        "sizeof",
        "typedef",
        "const",
        "struct",
        "for",
        "union",
        "volatile",
        "static",
        "mutable",
        "if",
        "do",
        "return",
        "goto",
        "enum",
        "else",
        "break",
        "extern",
        "asm",
        "case",
        "default",
        "register",
        "explicit",
        "typename",
        "switch",
        "continue",
        "inline",
        "readonly",
        "assign",
        "readwrite",
        "self",
        "@synchronized",
        "id",
        "typeof",
        "nonatomic",
        "IBOutlet",
        "IBAction",
        "strong",
        "weak",
        "copy",
        "in",
        "out",
        "inout",
        "bycopy",
        "byref",
        "oneway",
        "__strong",
        "__weak",
        "__block",
        "__autoreleasing",
        "@private",
        "@protected",
        "@public",
        "@try",
        "@property",
        "@end",
        "@throw",
        "@catch",
        "@finally",
        "@autoreleasepool",
        "@synthesize",
        "@dynamic",
        "@selector",
        "@optional",
        "@required",
        "@encode",
        "@package",
        "@import",
        "@defs",
        "@compatibility_alias",
        "__bridge",
        "__bridge_transfer",
        "__bridge_retained",
        "__bridge_retain",
        "__covariant",
        "__contravariant",
        "__kindof",
        "_Nonnull",
        "_Nullable",
        "_Null_unspecified",
        "__FUNCTION__",
        "__PRETTY_FUNCTION__",
        "__attribute__",
        "getter",
        "setter",
        "retain",
        "unsafe_unretained",
        "nonnull",
        "nullable",
        "null_unspecified",
        "null_resettable",
        "class",
        "instancetype",
        "NS_DESIGNATED_INITIALIZER",
        "NS_UNAVAILABLE",
        "NS_REQUIRES_SUPER",
        "NS_RETURNS_INNER_POINTER",
        "NS_INLINE",
        "NS_AVAILABLE",
        "NS_DEPRECATED",
        "NS_ENUM",
        "NS_OPTIONS",
        "NS_SWIFT_UNAVAILABLE",
        "NS_ASSUME_NONNULL_BEGIN",
        "NS_ASSUME_NONNULL_END",
        "NS_REFINED_FOR_SWIFT",
        "NS_SWIFT_NAME",
        "NS_SWIFT_NOTHROW",
        "NS_DURING",
        "NS_HANDLER",
        "NS_ENDHANDLER",
        "NS_VALUERETURN",
        "NS_VOIDRETURN"
      ],
      literal: [
        "false",
        "true",
        "FALSE",
        "TRUE",
        "nil",
        "YES",
        "NO",
        "NULL"
      ],
      built_in: [
        "dispatch_once_t",
        "dispatch_queue_t",
        "dispatch_sync",
        "dispatch_async",
        "dispatch_once"
      ],
      type: [
        "int",
        "float",
        "char",
        "unsigned",
        "signed",
        "short",
        "long",
        "double",
        "wchar_t",
        "unichar",
        "void",
        "bool",
        "BOOL",
        "id|0",
        "_Bool"
      ]
    }, C = {
      $pattern: c,
      keyword: [
        "@interface",
        "@class",
        "@protocol",
        "@implementation"
      ]
    };
    return {
      name: "Objective-C",
      aliases: [
        "mm",
        "objc",
        "obj-c",
        "obj-c++",
        "objective-c++"
      ],
      keywords: S,
      illegal: "</",
      contains: [
        o,
        i.C_LINE_COMMENT_MODE,
        i.C_BLOCK_COMMENT_MODE,
        i.C_NUMBER_MODE,
        i.QUOTE_STRING_MODE,
        i.APOS_STRING_MODE,
        {
          className: "string",
          variants: [
            {
              begin: '@"',
              end: '"',
              illegal: "\\n",
              contains: [i.BACKSLASH_ESCAPE]
            }
          ]
        },
        {
          className: "meta",
          begin: /#\s*[a-z]+\b/,
          end: /$/,
          keywords: { keyword: "if else elif endif define undef warning error line pragma ifdef ifndef include" },
          contains: [
            {
              begin: /\\\n/,
              relevance: 0
            },
            i.inherit(i.QUOTE_STRING_MODE, { className: "string" }),
            {
              className: "string",
              begin: /<.*?>/,
              end: /$/,
              illegal: "\\n"
            },
            i.C_LINE_COMMENT_MODE,
            i.C_BLOCK_COMMENT_MODE
          ]
        },
        {
          className: "class",
          begin: "(" + C.keyword.join("|") + ")\\b",
          end: /(\{|$)/,
          excludeEnd: !0,
          keywords: C,
          contains: [i.UNDERSCORE_TITLE_MODE]
        },
        {
          begin: "\\." + i.UNDERSCORE_IDENT_RE,
          relevance: 0
        }
      ]
    };
  }
  return O_ = s, O_;
}
var y_, tT;
function dk() {
  if (tT)
    return y_;
  tT = 1;
  function s(i) {
    return {
      name: "OCaml",
      aliases: ["ml"],
      keywords: {
        $pattern: "[a-z_]\\w*!?",
        keyword: "and as assert asr begin class constraint do done downto else end exception external for fun function functor if in include inherit! inherit initializer land lazy let lor lsl lsr lxor match method!|10 method mod module mutable new object of open! open or private rec sig struct then to try type val! val virtual when while with parser value",
        built_in: (
          /* built-in types */
          "array bool bytes char exn|5 float int int32 int64 list lazy_t|5 nativeint|5 string unit in_channel out_channel ref"
        ),
        literal: "true false"
      },
      illegal: /\/\/|>>/,
      contains: [
        {
          className: "literal",
          begin: "\\[(\\|\\|)?\\]|\\(\\)",
          relevance: 0
        },
        i.COMMENT(
          "\\(\\*",
          "\\*\\)",
          { contains: ["self"] }
        ),
        {
          /* type variable */
          className: "symbol",
          begin: "'[A-Za-z_](?!')[\\w']*"
          /* the grammar is ambiguous on how 'a'b should be interpreted but not the compiler */
        },
        {
          /* polymorphic variant */
          className: "type",
          begin: "`[A-Z][\\w']*"
        },
        {
          /* module or constructor */
          className: "type",
          begin: "\\b[A-Z][\\w']*",
          relevance: 0
        },
        {
          /* don't color identifiers, but safely catch all identifiers with ' */
          begin: "[a-z_]\\w*'[\\w']*",
          relevance: 0
        },
        i.inherit(i.APOS_STRING_MODE, {
          className: "string",
          relevance: 0
        }),
        i.inherit(i.QUOTE_STRING_MODE, { illegal: null }),
        {
          className: "number",
          begin: "\\b(0[xX][a-fA-F0-9_]+[Lln]?|0[oO][0-7_]+[Lln]?|0[bB][01_]+[Lln]?|[0-9][0-9_]*([Lln]|(\\.[0-9_]*)?([eE][-+]?[0-9_]+)?)?)",
          relevance: 0
        },
        {
          begin: /->/
          // relevance booster
        }
      ]
    };
  }
  return y_ = s, y_;
}
var I_, rT;
function uk() {
  if (rT)
    return I_;
  rT = 1;
  function s(i) {
    const o = {
      className: "keyword",
      begin: "\\$(f[asn]|t|vp[rtd]|children)"
    }, c = {
      className: "literal",
      begin: "false|true|PI|undef"
    }, r = {
      className: "number",
      begin: "\\b\\d+(\\.\\d+)?(e-?\\d+)?",
      // adds 1e5, 1e-10
      relevance: 0
    }, e = i.inherit(i.QUOTE_STRING_MODE, { illegal: null }), g = {
      className: "meta",
      keywords: { keyword: "include use" },
      begin: "include|use <",
      end: ">"
    }, h = {
      className: "params",
      begin: "\\(",
      end: "\\)",
      contains: [
        "self",
        r,
        e,
        o,
        c
      ]
    }, S = {
      begin: "[*!#%]",
      relevance: 0
    }, C = {
      className: "function",
      beginKeywords: "module function",
      end: /=|\{/,
      contains: [
        h,
        i.UNDERSCORE_TITLE_MODE
      ]
    };
    return {
      name: "OpenSCAD",
      aliases: ["scad"],
      keywords: {
        keyword: "function module include use for intersection_for if else \\%",
        literal: "false true PI undef",
        built_in: "circle square polygon text sphere cube cylinder polyhedron translate rotate scale resize mirror multmatrix color offset hull minkowski union difference intersection abs sign sin cos tan acos asin atan atan2 floor round ceil ln log pow sqrt exp rands min max concat lookup str chr search version version_num norm cross parent_module echo import import_dxf dxf_linear_extrude linear_extrude rotate_extrude surface projection render children dxf_cross dxf_dim let assign"
      },
      contains: [
        i.C_LINE_COMMENT_MODE,
        i.C_BLOCK_COMMENT_MODE,
        r,
        g,
        e,
        o,
        S,
        C
      ]
    };
  }
  return I_ = s, I_;
}
var D_, nT;
function _k() {
  if (nT)
    return D_;
  nT = 1;
  function s(i) {
    const o = {
      $pattern: /\.?\w+/,
      keyword: "abstract add and array as asc aspect assembly async begin break block by case class concat const copy constructor continue create default delegate desc distinct div do downto dynamic each else empty end ensure enum equals event except exit extension external false final finalize finalizer finally flags for forward from function future global group has if implementation implements implies in index inherited inline interface into invariants is iterator join locked locking loop matching method mod module namespace nested new nil not notify nullable of old on operator or order out override parallel params partial pinned private procedure property protected public queryable raise read readonly record reintroduce remove repeat require result reverse sealed select self sequence set shl shr skip static step soft take then to true try tuple type union unit unsafe until uses using var virtual raises volatile where while with write xor yield await mapped deprecated stdcall cdecl pascal register safecall overload library platform reference packed strict published autoreleasepool selector strong weak unretained"
    }, c = i.COMMENT(
      /\{/,
      /\}/,
      { relevance: 0 }
    ), r = i.COMMENT(
      "\\(\\*",
      "\\*\\)",
      { relevance: 10 }
    ), e = {
      className: "string",
      begin: "'",
      end: "'",
      contains: [{ begin: "''" }]
    }, g = {
      className: "string",
      begin: "(#\\d+)+"
    }, h = {
      beginKeywords: "function constructor destructor procedure method",
      end: "[:;]",
      keywords: "function constructor|10 destructor|10 procedure|10 method|10",
      contains: [
        i.inherit(i.TITLE_MODE, { scope: "title.function" }),
        {
          className: "params",
          begin: "\\(",
          end: "\\)",
          keywords: o,
          contains: [
            e,
            g
          ]
        },
        c,
        r
      ]
    }, S = {
      scope: "punctuation",
      match: /;/,
      relevance: 0
    };
    return {
      name: "Oxygene",
      case_insensitive: !0,
      keywords: o,
      illegal: '("|\\$[G-Zg-z]|\\/\\*|</|=>|->)',
      contains: [
        c,
        r,
        i.C_LINE_COMMENT_MODE,
        e,
        g,
        i.NUMBER_MODE,
        h,
        S
      ]
    };
  }
  return D_ = s, D_;
}
var w_, aT;
function pk() {
  if (aT)
    return w_;
  aT = 1;
  function s(i) {
    const o = i.COMMENT(
      /\{/,
      /\}/,
      { contains: ["self"] }
    );
    return {
      name: "Parser3",
      subLanguage: "xml",
      relevance: 0,
      contains: [
        i.COMMENT("^#", "$"),
        i.COMMENT(
          /\^rem\{/,
          /\}/,
          {
            relevance: 10,
            contains: [o]
          }
        ),
        {
          className: "meta",
          begin: "^@(?:BASE|USE|CLASS|OPTIONS)$",
          relevance: 10
        },
        {
          className: "title",
          begin: "@[\\w\\-]+\\[[\\w^;\\-]*\\](?:\\[[\\w^;\\-]*\\])?(?:.*)$"
        },
        {
          className: "variable",
          begin: /\$\{?[\w\-.:]+\}?/
        },
        {
          className: "keyword",
          begin: /\^[\w\-.:]+/
        },
        {
          className: "number",
          begin: "\\^#[0-9a-fA-F]+"
        },
        i.C_NUMBER_MODE
      ]
    };
  }
  return w_ = s, w_;
}
var x_, iT;
function mk() {
  if (iT)
    return x_;
  iT = 1;
  function s(i) {
    const o = {
      className: "variable",
      begin: /\$[\w\d#@][\w\d_]*/,
      relevance: 0
    }, c = {
      className: "variable",
      begin: /<(?!\/)/,
      end: />/
    };
    return {
      name: "Packet Filter config",
      aliases: ["pf.conf"],
      keywords: {
        $pattern: /[a-z0-9_<>-]+/,
        built_in: (
          /* block match pass are "actions" in pf.conf(5), the rest are
           * lexically similar top-level commands.
           */
          "block match pass load anchor|5 antispoof|10 set table"
        ),
        keyword: "in out log quick on rdomain inet inet6 proto from port os to route allow-opts divert-packet divert-reply divert-to flags group icmp-type icmp6-type label once probability recieved-on rtable prio queue tos tag tagged user keep fragment for os drop af-to|10 binat-to|10 nat-to|10 rdr-to|10 bitmask least-stats random round-robin source-hash static-port dup-to reply-to route-to parent bandwidth default min max qlimit block-policy debug fingerprints hostid limit loginterface optimization reassemble ruleset-optimization basic none profile skip state-defaults state-policy timeout const counters persist no modulate synproxy state|5 floating if-bound no-sync pflow|10 sloppy source-track global rule max-src-nodes max-src-states max-src-conn max-src-conn-rate overload flush scrub|5 max-mss min-ttl no-df|10 random-id",
        literal: "all any no-route self urpf-failed egress|5 unknown"
      },
      contains: [
        i.HASH_COMMENT_MODE,
        i.NUMBER_MODE,
        i.QUOTE_STRING_MODE,
        o,
        c
      ]
    };
  }
  return x_ = s, x_;
}
var L_, oT;
function fk() {
  if (oT)
    return L_;
  oT = 1;
  function s(i) {
    const o = i.COMMENT("--", "$"), c = "[a-zA-Z_][a-zA-Z_0-9$]*", r = "\\$([a-zA-Z_]?|[a-zA-Z_][a-zA-Z_0-9]*)\\$", e = "<<\\s*" + c + "\\s*>>", g = (
      // https://www.postgresql.org/docs/11/static/sql-keywords-appendix.html
      // https://www.postgresql.org/docs/11/static/sql-commands.html
      // SQL commands (starting words)
      "ABORT ALTER ANALYZE BEGIN CALL CHECKPOINT|10 CLOSE CLUSTER COMMENT COMMIT COPY CREATE DEALLOCATE DECLARE DELETE DISCARD DO DROP END EXECUTE EXPLAIN FETCH GRANT IMPORT INSERT LISTEN LOAD LOCK MOVE NOTIFY PREPARE REASSIGN|10 REFRESH REINDEX RELEASE RESET REVOKE ROLLBACK SAVEPOINT SECURITY SELECT SET SHOW START TRUNCATE UNLISTEN|10 UPDATE VACUUM|10 VALUES AGGREGATE COLLATION CONVERSION|10 DATABASE DEFAULT PRIVILEGES DOMAIN TRIGGER EXTENSION FOREIGN WRAPPER|10 TABLE FUNCTION GROUP LANGUAGE LARGE OBJECT MATERIALIZED VIEW OPERATOR CLASS FAMILY POLICY PUBLICATION|10 ROLE RULE SCHEMA SEQUENCE SERVER STATISTICS SUBSCRIPTION SYSTEM TABLESPACE CONFIGURATION DICTIONARY PARSER TEMPLATE TYPE USER MAPPING PREPARED ACCESS METHOD CAST AS TRANSFORM TRANSACTION OWNED TO INTO SESSION AUTHORIZATION INDEX PROCEDURE ASSERTION ALL ANALYSE AND ANY ARRAY ASC ASYMMETRIC|10 BOTH CASE CHECK COLLATE COLUMN CONCURRENTLY|10 CONSTRAINT CROSS DEFERRABLE RANGE DESC DISTINCT ELSE EXCEPT FOR FREEZE|10 FROM FULL HAVING ILIKE IN INITIALLY INNER INTERSECT IS ISNULL JOIN LATERAL LEADING LIKE LIMIT NATURAL NOT NOTNULL NULL OFFSET ON ONLY OR ORDER OUTER OVERLAPS PLACING PRIMARY REFERENCES RETURNING SIMILAR SOME SYMMETRIC TABLESAMPLE THEN TRAILING UNION UNIQUE USING VARIADIC|10 VERBOSE WHEN WHERE WINDOW WITH BY RETURNS INOUT OUT SETOF|10 IF STRICT CURRENT CONTINUE OWNER LOCATION OVER PARTITION WITHIN BETWEEN ESCAPE EXTERNAL INVOKER DEFINER WORK RENAME VERSION CONNECTION CONNECT TABLES TEMP TEMPORARY FUNCTIONS SEQUENCES TYPES SCHEMAS OPTION CASCADE RESTRICT ADD ADMIN EXISTS VALID VALIDATE ENABLE DISABLE REPLICA|10 ALWAYS PASSING COLUMNS PATH REF VALUE OVERRIDING IMMUTABLE STABLE VOLATILE BEFORE AFTER EACH ROW PROCEDURAL ROUTINE NO HANDLER VALIDATOR OPTIONS STORAGE OIDS|10 WITHOUT INHERIT DEPENDS CALLED INPUT LEAKPROOF|10 COST ROWS NOWAIT SEARCH UNTIL ENCRYPTED|10 PASSWORD CONFLICT|10 INSTEAD INHERITS CHARACTERISTICS WRITE CURSOR ALSO STATEMENT SHARE EXCLUSIVE INLINE ISOLATION REPEATABLE READ COMMITTED SERIALIZABLE UNCOMMITTED LOCAL GLOBAL SQL PROCEDURES RECURSIVE SNAPSHOT ROLLUP CUBE TRUSTED|10 INCLUDE FOLLOWING PRECEDING UNBOUNDED RANGE GROUPS UNENCRYPTED|10 SYSID FORMAT DELIMITER HEADER QUOTE ENCODING FILTER OFF FORCE_QUOTE FORCE_NOT_NULL FORCE_NULL COSTS BUFFERS TIMING SUMMARY DISABLE_PAGE_SKIPPING RESTART CYCLE GENERATED IDENTITY DEFERRED IMMEDIATE LEVEL LOGGED UNLOGGED OF NOTHING NONE EXCLUDE ATTRIBUTE USAGE ROUTINES TRUE FALSE NAN INFINITY "
    ), h = (
      // only those not in keywrods already
      "SUPERUSER NOSUPERUSER CREATEDB NOCREATEDB CREATEROLE NOCREATEROLE INHERIT NOINHERIT LOGIN NOLOGIN REPLICATION NOREPLICATION BYPASSRLS NOBYPASSRLS "
    ), S = "ALIAS BEGIN CONSTANT DECLARE END EXCEPTION RETURN PERFORM|10 RAISE GET DIAGNOSTICS STACKED|10 FOREACH LOOP ELSIF EXIT WHILE REVERSE SLICE DEBUG LOG INFO NOTICE WARNING ASSERT OPEN ", C = (
      // https://www.postgresql.org/docs/11/static/datatype.html
      "BIGINT INT8 BIGSERIAL SERIAL8 BIT VARYING VARBIT BOOLEAN BOOL BOX BYTEA CHARACTER CHAR VARCHAR CIDR CIRCLE DATE DOUBLE PRECISION FLOAT8 FLOAT INET INTEGER INT INT4 INTERVAL JSON JSONB LINE LSEG|10 MACADDR MACADDR8 MONEY NUMERIC DEC DECIMAL PATH POINT POLYGON REAL FLOAT4 SMALLINT INT2 SMALLSERIAL|10 SERIAL2|10 SERIAL|10 SERIAL4|10 TEXT TIME ZONE TIMETZ|10 TIMESTAMP TIMESTAMPTZ|10 TSQUERY|10 TSVECTOR|10 TXID_SNAPSHOT|10 UUID XML NATIONAL NCHAR INT4RANGE|10 INT8RANGE|10 NUMRANGE|10 TSRANGE|10 TSTZRANGE|10 DATERANGE|10 ANYELEMENT ANYARRAY ANYNONARRAY ANYENUM ANYRANGE CSTRING INTERNAL RECORD PG_DDL_COMMAND VOID UNKNOWN OPAQUE REFCURSOR NAME OID REGPROC|10 REGPROCEDURE|10 REGOPER|10 REGOPERATOR|10 REGCLASS|10 REGTYPE|10 REGROLE|10 REGNAMESPACE|10 REGCONFIG|10 REGDICTIONARY|10 "
    ), O = C.trim().split(" ").map(function(Y) {
      return Y.split("|")[0];
    }).join("|"), N = "CURRENT_TIME CURRENT_TIMESTAMP CURRENT_USER CURRENT_CATALOG|10 CURRENT_DATE LOCALTIME LOCALTIMESTAMP CURRENT_ROLE|10 CURRENT_SCHEMA|10 SESSION_USER PUBLIC ", D = "FOUND NEW OLD TG_NAME|10 TG_WHEN|10 TG_LEVEL|10 TG_OP|10 TG_RELID|10 TG_RELNAME|10 TG_TABLE_NAME|10 TG_TABLE_SCHEMA|10 TG_NARGS|10 TG_ARGV|10 TG_EVENT|10 TG_TAG|10 ROW_COUNT RESULT_OID|10 PG_CONTEXT|10 RETURNED_SQLSTATE COLUMN_NAME CONSTRAINT_NAME PG_DATATYPE_NAME|10 MESSAGE_TEXT TABLE_NAME SCHEMA_NAME PG_EXCEPTION_DETAIL|10 PG_EXCEPTION_HINT|10 PG_EXCEPTION_CONTEXT|10 ", x = (
      // exceptions https://www.postgresql.org/docs/current/static/errcodes-appendix.html
      "SQLSTATE SQLERRM|10 SUCCESSFUL_COMPLETION WARNING DYNAMIC_RESULT_SETS_RETURNED IMPLICIT_ZERO_BIT_PADDING NULL_VALUE_ELIMINATED_IN_SET_FUNCTION PRIVILEGE_NOT_GRANTED PRIVILEGE_NOT_REVOKED STRING_DATA_RIGHT_TRUNCATION DEPRECATED_FEATURE NO_DATA NO_ADDITIONAL_DYNAMIC_RESULT_SETS_RETURNED SQL_STATEMENT_NOT_YET_COMPLETE CONNECTION_EXCEPTION CONNECTION_DOES_NOT_EXIST CONNECTION_FAILURE SQLCLIENT_UNABLE_TO_ESTABLISH_SQLCONNECTION SQLSERVER_REJECTED_ESTABLISHMENT_OF_SQLCONNECTION TRANSACTION_RESOLUTION_UNKNOWN PROTOCOL_VIOLATION TRIGGERED_ACTION_EXCEPTION FEATURE_NOT_SUPPORTED INVALID_TRANSACTION_INITIATION LOCATOR_EXCEPTION INVALID_LOCATOR_SPECIFICATION INVALID_GRANTOR INVALID_GRANT_OPERATION INVALID_ROLE_SPECIFICATION DIAGNOSTICS_EXCEPTION STACKED_DIAGNOSTICS_ACCESSED_WITHOUT_ACTIVE_HANDLER CASE_NOT_FOUND CARDINALITY_VIOLATION DATA_EXCEPTION ARRAY_SUBSCRIPT_ERROR CHARACTER_NOT_IN_REPERTOIRE DATETIME_FIELD_OVERFLOW DIVISION_BY_ZERO ERROR_IN_ASSIGNMENT ESCAPE_CHARACTER_CONFLICT INDICATOR_OVERFLOW INTERVAL_FIELD_OVERFLOW INVALID_ARGUMENT_FOR_LOGARITHM INVALID_ARGUMENT_FOR_NTILE_FUNCTION INVALID_ARGUMENT_FOR_NTH_VALUE_FUNCTION INVALID_ARGUMENT_FOR_POWER_FUNCTION INVALID_ARGUMENT_FOR_WIDTH_BUCKET_FUNCTION INVALID_CHARACTER_VALUE_FOR_CAST INVALID_DATETIME_FORMAT INVALID_ESCAPE_CHARACTER INVALID_ESCAPE_OCTET INVALID_ESCAPE_SEQUENCE NONSTANDARD_USE_OF_ESCAPE_CHARACTER INVALID_INDICATOR_PARAMETER_VALUE INVALID_PARAMETER_VALUE INVALID_REGULAR_EXPRESSION INVALID_ROW_COUNT_IN_LIMIT_CLAUSE INVALID_ROW_COUNT_IN_RESULT_OFFSET_CLAUSE INVALID_TABLESAMPLE_ARGUMENT INVALID_TABLESAMPLE_REPEAT INVALID_TIME_ZONE_DISPLACEMENT_VALUE INVALID_USE_OF_ESCAPE_CHARACTER MOST_SPECIFIC_TYPE_MISMATCH NULL_VALUE_NOT_ALLOWED NULL_VALUE_NO_INDICATOR_PARAMETER NUMERIC_VALUE_OUT_OF_RANGE SEQUENCE_GENERATOR_LIMIT_EXCEEDED STRING_DATA_LENGTH_MISMATCH STRING_DATA_RIGHT_TRUNCATION SUBSTRING_ERROR TRIM_ERROR UNTERMINATED_C_STRING ZERO_LENGTH_CHARACTER_STRING FLOATING_POINT_EXCEPTION INVALID_TEXT_REPRESENTATION INVALID_BINARY_REPRESENTATION BAD_COPY_FILE_FORMAT UNTRANSLATABLE_CHARACTER NOT_AN_XML_DOCUMENT INVALID_XML_DOCUMENT INVALID_XML_CONTENT INVALID_XML_COMMENT INVALID_XML_PROCESSING_INSTRUCTION INTEGRITY_CONSTRAINT_VIOLATION RESTRICT_VIOLATION NOT_NULL_VIOLATION FOREIGN_KEY_VIOLATION UNIQUE_VIOLATION CHECK_VIOLATION EXCLUSION_VIOLATION INVALID_CURSOR_STATE INVALID_TRANSACTION_STATE ACTIVE_SQL_TRANSACTION BRANCH_TRANSACTION_ALREADY_ACTIVE HELD_CURSOR_REQUIRES_SAME_ISOLATION_LEVEL INAPPROPRIATE_ACCESS_MODE_FOR_BRANCH_TRANSACTION INAPPROPRIATE_ISOLATION_LEVEL_FOR_BRANCH_TRANSACTION NO_ACTIVE_SQL_TRANSACTION_FOR_BRANCH_TRANSACTION READ_ONLY_SQL_TRANSACTION SCHEMA_AND_DATA_STATEMENT_MIXING_NOT_SUPPORTED NO_ACTIVE_SQL_TRANSACTION IN_FAILED_SQL_TRANSACTION IDLE_IN_TRANSACTION_SESSION_TIMEOUT INVALID_SQL_STATEMENT_NAME TRIGGERED_DATA_CHANGE_VIOLATION INVALID_AUTHORIZATION_SPECIFICATION INVALID_PASSWORD DEPENDENT_PRIVILEGE_DESCRIPTORS_STILL_EXIST DEPENDENT_OBJECTS_STILL_EXIST INVALID_TRANSACTION_TERMINATION SQL_ROUTINE_EXCEPTION FUNCTION_EXECUTED_NO_RETURN_STATEMENT MODIFYING_SQL_DATA_NOT_PERMITTED PROHIBITED_SQL_STATEMENT_ATTEMPTED READING_SQL_DATA_NOT_PERMITTED INVALID_CURSOR_NAME EXTERNAL_ROUTINE_EXCEPTION CONTAINING_SQL_NOT_PERMITTED MODIFYING_SQL_DATA_NOT_PERMITTED PROHIBITED_SQL_STATEMENT_ATTEMPTED READING_SQL_DATA_NOT_PERMITTED EXTERNAL_ROUTINE_INVOCATION_EXCEPTION INVALID_SQLSTATE_RETURNED NULL_VALUE_NOT_ALLOWED TRIGGER_PROTOCOL_VIOLATED SRF_PROTOCOL_VIOLATED EVENT_TRIGGER_PROTOCOL_VIOLATED SAVEPOINT_EXCEPTION INVALID_SAVEPOINT_SPECIFICATION INVALID_CATALOG_NAME INVALID_SCHEMA_NAME TRANSACTION_ROLLBACK TRANSACTION_INTEGRITY_CONSTRAINT_VIOLATION SERIALIZATION_FAILURE STATEMENT_COMPLETION_UNKNOWN DEADLOCK_DETECTED SYNTAX_ERROR_OR_ACCESS_RULE_VIOLATION SYNTAX_ERROR INSUFFICIENT_PRIVILEGE CANNOT_COERCE GROUPING_ERROR WINDOWING_ERROR INVALID_RECURSION INVALID_FOREIGN_KEY INVALID_NAME NAME_TOO_LONG RESERVED_NAME DATATYPE_MISMATCH INDETERMINATE_DATATYPE COLLATION_MISMATCH INDETERMINATE_COLLATION WRONG_OBJECT_TYPE GENERATED_ALWAYS UNDEFINED_COLUMN UNDEFINED_FUNCTION UNDEFINED_TABLE UNDEFINED_PARAMETER UNDEFINED_OBJECT DUPLICATE_COLUMN DUPLICATE_CURSOR DUPLICATE_DATABASE DUPLICATE_FUNCTION DUPLICATE_PREPARED_STATEMENT DUPLICATE_SCHEMA DUPLICATE_TABLE DUPLICATE_ALIAS DUPLICATE_OBJECT AMBIGUOUS_COLUMN AMBIGUOUS_FUNCTION AMBIGUOUS_PARAMETER AMBIGUOUS_ALIAS INVALID_COLUMN_REFERENCE INVALID_COLUMN_DEFINITION INVALID_CURSOR_DEFINITION INVALID_DATABASE_DEFINITION INVALID_FUNCTION_DEFINITION INVALID_PREPARED_STATEMENT_DEFINITION INVALID_SCHEMA_DEFINITION INVALID_TABLE_DEFINITION INVALID_OBJECT_DEFINITION WITH_CHECK_OPTION_VIOLATION INSUFFICIENT_RESOURCES DISK_FULL OUT_OF_MEMORY TOO_MANY_CONNECTIONS CONFIGURATION_LIMIT_EXCEEDED PROGRAM_LIMIT_EXCEEDED STATEMENT_TOO_COMPLEX TOO_MANY_COLUMNS TOO_MANY_ARGUMENTS OBJECT_NOT_IN_PREREQUISITE_STATE OBJECT_IN_USE CANT_CHANGE_RUNTIME_PARAM LOCK_NOT_AVAILABLE OPERATOR_INTERVENTION QUERY_CANCELED ADMIN_SHUTDOWN CRASH_SHUTDOWN CANNOT_CONNECT_NOW DATABASE_DROPPED SYSTEM_ERROR IO_ERROR UNDEFINED_FILE DUPLICATE_FILE SNAPSHOT_TOO_OLD CONFIG_FILE_ERROR LOCK_FILE_EXISTS FDW_ERROR FDW_COLUMN_NAME_NOT_FOUND FDW_DYNAMIC_PARAMETER_VALUE_NEEDED FDW_FUNCTION_SEQUENCE_ERROR FDW_INCONSISTENT_DESCRIPTOR_INFORMATION FDW_INVALID_ATTRIBUTE_VALUE FDW_INVALID_COLUMN_NAME FDW_INVALID_COLUMN_NUMBER FDW_INVALID_DATA_TYPE FDW_INVALID_DATA_TYPE_DESCRIPTORS FDW_INVALID_DESCRIPTOR_FIELD_IDENTIFIER FDW_INVALID_HANDLE FDW_INVALID_OPTION_INDEX FDW_INVALID_OPTION_NAME FDW_INVALID_STRING_LENGTH_OR_BUFFER_LENGTH FDW_INVALID_STRING_FORMAT FDW_INVALID_USE_OF_NULL_POINTER FDW_TOO_MANY_HANDLES FDW_OUT_OF_MEMORY FDW_NO_SCHEMAS FDW_OPTION_NAME_NOT_FOUND FDW_REPLY_HANDLE FDW_SCHEMA_NOT_FOUND FDW_TABLE_NOT_FOUND FDW_UNABLE_TO_CREATE_EXECUTION FDW_UNABLE_TO_CREATE_REPLY FDW_UNABLE_TO_ESTABLISH_CONNECTION PLPGSQL_ERROR RAISE_EXCEPTION NO_DATA_FOUND TOO_MANY_ROWS ASSERT_FAILURE INTERNAL_ERROR DATA_CORRUPTED INDEX_CORRUPTED "
    ), G = /* https://www.postgresql.org/docs/11/static/functions-aggregate.html */ "ARRAY_AGG AVG BIT_AND BIT_OR BOOL_AND BOOL_OR COUNT EVERY JSON_AGG JSONB_AGG JSON_OBJECT_AGG JSONB_OBJECT_AGG MAX MIN MODE STRING_AGG SUM XMLAGG CORR COVAR_POP COVAR_SAMP REGR_AVGX REGR_AVGY REGR_COUNT REGR_INTERCEPT REGR_R2 REGR_SLOPE REGR_SXX REGR_SXY REGR_SYY STDDEV STDDEV_POP STDDEV_SAMP VARIANCE VAR_POP VAR_SAMP PERCENTILE_CONT PERCENTILE_DISC ROW_NUMBER RANK DENSE_RANK PERCENT_RANK CUME_DIST NTILE LAG LEAD FIRST_VALUE LAST_VALUE NTH_VALUE NUM_NONNULLS NUM_NULLS ABS CBRT CEIL CEILING DEGREES DIV EXP FLOOR LN LOG MOD PI POWER RADIANS ROUND SCALE SIGN SQRT TRUNC WIDTH_BUCKET RANDOM SETSEED ACOS ACOSD ASIN ASIND ATAN ATAND ATAN2 ATAN2D COS COSD COT COTD SIN SIND TAN TAND BIT_LENGTH CHAR_LENGTH CHARACTER_LENGTH LOWER OCTET_LENGTH OVERLAY POSITION SUBSTRING TREAT TRIM UPPER ASCII BTRIM CHR CONCAT CONCAT_WS CONVERT CONVERT_FROM CONVERT_TO DECODE ENCODE INITCAP LEFT LENGTH LPAD LTRIM MD5 PARSE_IDENT PG_CLIENT_ENCODING QUOTE_IDENT|10 QUOTE_LITERAL|10 QUOTE_NULLABLE|10 REGEXP_MATCH REGEXP_MATCHES REGEXP_REPLACE REGEXP_SPLIT_TO_ARRAY REGEXP_SPLIT_TO_TABLE REPEAT REPLACE REVERSE RIGHT RPAD RTRIM SPLIT_PART STRPOS SUBSTR TO_ASCII TO_HEX TRANSLATE OCTET_LENGTH GET_BIT GET_BYTE SET_BIT SET_BYTE TO_CHAR TO_DATE TO_NUMBER TO_TIMESTAMP AGE CLOCK_TIMESTAMP|10 DATE_PART DATE_TRUNC ISFINITE JUSTIFY_DAYS JUSTIFY_HOURS JUSTIFY_INTERVAL MAKE_DATE MAKE_INTERVAL|10 MAKE_TIME MAKE_TIMESTAMP|10 MAKE_TIMESTAMPTZ|10 NOW STATEMENT_TIMESTAMP|10 TIMEOFDAY TRANSACTION_TIMESTAMP|10 ENUM_FIRST ENUM_LAST ENUM_RANGE AREA CENTER DIAMETER HEIGHT ISCLOSED ISOPEN NPOINTS PCLOSE POPEN RADIUS WIDTH BOX BOUND_BOX CIRCLE LINE LSEG PATH POLYGON ABBREV BROADCAST HOST HOSTMASK MASKLEN NETMASK NETWORK SET_MASKLEN TEXT INET_SAME_FAMILY INET_MERGE MACADDR8_SET7BIT ARRAY_TO_TSVECTOR GET_CURRENT_TS_CONFIG NUMNODE PLAINTO_TSQUERY PHRASETO_TSQUERY WEBSEARCH_TO_TSQUERY QUERYTREE SETWEIGHT STRIP TO_TSQUERY TO_TSVECTOR JSON_TO_TSVECTOR JSONB_TO_TSVECTOR TS_DELETE TS_FILTER TS_HEADLINE TS_RANK TS_RANK_CD TS_REWRITE TSQUERY_PHRASE TSVECTOR_TO_ARRAY TSVECTOR_UPDATE_TRIGGER TSVECTOR_UPDATE_TRIGGER_COLUMN XMLCOMMENT XMLCONCAT XMLELEMENT XMLFOREST XMLPI XMLROOT XMLEXISTS XML_IS_WELL_FORMED XML_IS_WELL_FORMED_DOCUMENT XML_IS_WELL_FORMED_CONTENT XPATH XPATH_EXISTS XMLTABLE XMLNAMESPACES TABLE_TO_XML TABLE_TO_XMLSCHEMA TABLE_TO_XML_AND_XMLSCHEMA QUERY_TO_XML QUERY_TO_XMLSCHEMA QUERY_TO_XML_AND_XMLSCHEMA CURSOR_TO_XML CURSOR_TO_XMLSCHEMA SCHEMA_TO_XML SCHEMA_TO_XMLSCHEMA SCHEMA_TO_XML_AND_XMLSCHEMA DATABASE_TO_XML DATABASE_TO_XMLSCHEMA DATABASE_TO_XML_AND_XMLSCHEMA XMLATTRIBUTES TO_JSON TO_JSONB ARRAY_TO_JSON ROW_TO_JSON JSON_BUILD_ARRAY JSONB_BUILD_ARRAY JSON_BUILD_OBJECT JSONB_BUILD_OBJECT JSON_OBJECT JSONB_OBJECT JSON_ARRAY_LENGTH JSONB_ARRAY_LENGTH JSON_EACH JSONB_EACH JSON_EACH_TEXT JSONB_EACH_TEXT JSON_EXTRACT_PATH JSONB_EXTRACT_PATH JSON_OBJECT_KEYS JSONB_OBJECT_KEYS JSON_POPULATE_RECORD JSONB_POPULATE_RECORD JSON_POPULATE_RECORDSET JSONB_POPULATE_RECORDSET JSON_ARRAY_ELEMENTS JSONB_ARRAY_ELEMENTS JSON_ARRAY_ELEMENTS_TEXT JSONB_ARRAY_ELEMENTS_TEXT JSON_TYPEOF JSONB_TYPEOF JSON_TO_RECORD JSONB_TO_RECORD JSON_TO_RECORDSET JSONB_TO_RECORDSET JSON_STRIP_NULLS JSONB_STRIP_NULLS JSONB_SET JSONB_INSERT JSONB_PRETTY CURRVAL LASTVAL NEXTVAL SETVAL COALESCE NULLIF GREATEST LEAST ARRAY_APPEND ARRAY_CAT ARRAY_NDIMS ARRAY_DIMS ARRAY_FILL ARRAY_LENGTH ARRAY_LOWER ARRAY_POSITION ARRAY_POSITIONS ARRAY_PREPEND ARRAY_REMOVE ARRAY_REPLACE ARRAY_TO_STRING ARRAY_UPPER CARDINALITY STRING_TO_ARRAY UNNEST ISEMPTY LOWER_INC UPPER_INC LOWER_INF UPPER_INF RANGE_MERGE GENERATE_SERIES GENERATE_SUBSCRIPTS CURRENT_DATABASE CURRENT_QUERY CURRENT_SCHEMA|10 CURRENT_SCHEMAS|10 INET_CLIENT_ADDR INET_CLIENT_PORT INET_SERVER_ADDR INET_SERVER_PORT ROW_SECURITY_ACTIVE FORMAT_TYPE TO_REGCLASS TO_REGPROC TO_REGPROCEDURE TO_REGOPER TO_REGOPERATOR TO_REGTYPE TO_REGNAMESPACE TO_REGROLE COL_DESCRIPTION OBJ_DESCRIPTION SHOBJ_DESCRIPTION TXID_CURRENT TXID_CURRENT_IF_ASSIGNED TXID_CURRENT_SNAPSHOT TXID_SNAPSHOT_XIP TXID_SNAPSHOT_XMAX TXID_SNAPSHOT_XMIN TXID_VISIBLE_IN_SNAPSHOT TXID_STATUS CURRENT_SETTING SET_CONFIG BRIN_SUMMARIZE_NEW_VALUES BRIN_SUMMARIZE_RANGE BRIN_DESUMMARIZE_RANGE GIN_CLEAN_PENDING_LIST SUPPRESS_REDUNDANT_UPDATES_TRIGGER LO_FROM_BYTEA LO_PUT LO_GET LO_CREAT LO_CREATE LO_UNLINK LO_IMPORT LO_EXPORT LOREAD LOWRITE GROUPING CAST ".trim().split(" ").map(function(Y) {
      return Y.split("|")[0];
    }).join("|");
    return {
      name: "PostgreSQL",
      aliases: [
        "postgres",
        "postgresql"
      ],
      supersetOf: "sql",
      case_insensitive: !0,
      keywords: {
        keyword: g + S + h,
        built_in: N + D + x
      },
      // Forbid some cunstructs from other languages to improve autodetect. In fact
      // "[a-z]:" is legal (as part of array slice), but improbabal.
      illegal: /:==|\W\s*\(\*|(^|\s)\$[a-z]|\{\{|[a-z]:\s*$|\.\.\.|TO:|DO:/,
      contains: [
        // special handling of some words, which are reserved only in some contexts
        {
          className: "keyword",
          variants: [
            { begin: /\bTEXT\s*SEARCH\b/ },
            { begin: /\b(PRIMARY|FOREIGN|FOR(\s+NO)?)\s+KEY\b/ },
            { begin: /\bPARALLEL\s+(UNSAFE|RESTRICTED|SAFE)\b/ },
            { begin: /\bSTORAGE\s+(PLAIN|EXTERNAL|EXTENDED|MAIN)\b/ },
            { begin: /\bMATCH\s+(FULL|PARTIAL|SIMPLE)\b/ },
            { begin: /\bNULLS\s+(FIRST|LAST)\b/ },
            { begin: /\bEVENT\s+TRIGGER\b/ },
            { begin: /\b(MAPPING|OR)\s+REPLACE\b/ },
            { begin: /\b(FROM|TO)\s+(PROGRAM|STDIN|STDOUT)\b/ },
            { begin: /\b(SHARE|EXCLUSIVE)\s+MODE\b/ },
            { begin: /\b(LEFT|RIGHT)\s+(OUTER\s+)?JOIN\b/ },
            { begin: /\b(FETCH|MOVE)\s+(NEXT|PRIOR|FIRST|LAST|ABSOLUTE|RELATIVE|FORWARD|BACKWARD)\b/ },
            { begin: /\bPRESERVE\s+ROWS\b/ },
            { begin: /\bDISCARD\s+PLANS\b/ },
            { begin: /\bREFERENCING\s+(OLD|NEW)\b/ },
            { begin: /\bSKIP\s+LOCKED\b/ },
            { begin: /\bGROUPING\s+SETS\b/ },
            { begin: /\b(BINARY|INSENSITIVE|SCROLL|NO\s+SCROLL)\s+(CURSOR|FOR)\b/ },
            { begin: /\b(WITH|WITHOUT)\s+HOLD\b/ },
            { begin: /\bWITH\s+(CASCADED|LOCAL)\s+CHECK\s+OPTION\b/ },
            { begin: /\bEXCLUDE\s+(TIES|NO\s+OTHERS)\b/ },
            { begin: /\bFORMAT\s+(TEXT|XML|JSON|YAML)\b/ },
            { begin: /\bSET\s+((SESSION|LOCAL)\s+)?NAMES\b/ },
            { begin: /\bIS\s+(NOT\s+)?UNKNOWN\b/ },
            { begin: /\bSECURITY\s+LABEL\b/ },
            { begin: /\bSTANDALONE\s+(YES|NO|NO\s+VALUE)\b/ },
            { begin: /\bWITH\s+(NO\s+)?DATA\b/ },
            { begin: /\b(FOREIGN|SET)\s+DATA\b/ },
            { begin: /\bSET\s+(CATALOG|CONSTRAINTS)\b/ },
            { begin: /\b(WITH|FOR)\s+ORDINALITY\b/ },
            { begin: /\bIS\s+(NOT\s+)?DOCUMENT\b/ },
            { begin: /\bXML\s+OPTION\s+(DOCUMENT|CONTENT)\b/ },
            { begin: /\b(STRIP|PRESERVE)\s+WHITESPACE\b/ },
            { begin: /\bNO\s+(ACTION|MAXVALUE|MINVALUE)\b/ },
            { begin: /\bPARTITION\s+BY\s+(RANGE|LIST|HASH)\b/ },
            { begin: /\bAT\s+TIME\s+ZONE\b/ },
            { begin: /\bGRANTED\s+BY\b/ },
            { begin: /\bRETURN\s+(QUERY|NEXT)\b/ },
            { begin: /\b(ATTACH|DETACH)\s+PARTITION\b/ },
            { begin: /\bFORCE\s+ROW\s+LEVEL\s+SECURITY\b/ },
            { begin: /\b(INCLUDING|EXCLUDING)\s+(COMMENTS|CONSTRAINTS|DEFAULTS|IDENTITY|INDEXES|STATISTICS|STORAGE|ALL)\b/ },
            { begin: /\bAS\s+(ASSIGNMENT|IMPLICIT|PERMISSIVE|RESTRICTIVE|ENUM|RANGE)\b/ }
          ]
        },
        // functions named as keywords, followed by '('
        {
          begin: /\b(FORMAT|FAMILY|VERSION)\s*\(/
          // keywords: { built_in: 'FORMAT FAMILY VERSION' }
        },
        // INCLUDE ( ... ) in index_parameters in CREATE TABLE
        {
          begin: /\bINCLUDE\s*\(/,
          keywords: "INCLUDE"
        },
        // not highlight RANGE if not in frame_clause (not 100% correct, but seems satisfactory)
        { begin: /\bRANGE(?!\s*(BETWEEN|UNBOUNDED|CURRENT|[-0-9]+))/ },
        // disable highlighting in commands CREATE AGGREGATE/COLLATION/DATABASE/OPERTOR/TEXT SEARCH .../TYPE
        // and in PL/pgSQL RAISE ... USING
        { begin: /\b(VERSION|OWNER|TEMPLATE|TABLESPACE|CONNECTION\s+LIMIT|PROCEDURE|RESTRICT|JOIN|PARSER|COPY|START|END|COLLATION|INPUT|ANALYZE|STORAGE|LIKE|DEFAULT|DELIMITER|ENCODING|COLUMN|CONSTRAINT|TABLE|SCHEMA)\s*=/ },
        // PG_smth; HAS_some_PRIVILEGE
        {
          // className: 'built_in',
          begin: /\b(PG_\w+?|HAS_[A-Z_]+_PRIVILEGE)\b/,
          relevance: 10
        },
        // extract
        {
          begin: /\bEXTRACT\s*\(/,
          end: /\bFROM\b/,
          returnEnd: !0,
          keywords: {
            // built_in: 'EXTRACT',
            type: "CENTURY DAY DECADE DOW DOY EPOCH HOUR ISODOW ISOYEAR MICROSECONDS MILLENNIUM MILLISECONDS MINUTE MONTH QUARTER SECOND TIMEZONE TIMEZONE_HOUR TIMEZONE_MINUTE WEEK YEAR"
          }
        },
        // xmlelement, xmlpi - special NAME
        {
          begin: /\b(XMLELEMENT|XMLPI)\s*\(\s*NAME/,
          keywords: {
            // built_in: 'XMLELEMENT XMLPI',
            keyword: "NAME"
          }
        },
        // xmlparse, xmlserialize
        {
          begin: /\b(XMLPARSE|XMLSERIALIZE)\s*\(\s*(DOCUMENT|CONTENT)/,
          keywords: {
            // built_in: 'XMLPARSE XMLSERIALIZE',
            keyword: "DOCUMENT CONTENT"
          }
        },
        // Sequences. We actually skip everything between CACHE|INCREMENT|MAXVALUE|MINVALUE and
        // nearest following numeric constant. Without with trick we find a lot of "keywords"
        // in 'avrasm' autodetection test...
        {
          beginKeywords: "CACHE INCREMENT MAXVALUE MINVALUE",
          end: i.C_NUMBER_RE,
          returnEnd: !0,
          keywords: "BY CACHE INCREMENT MAXVALUE MINVALUE"
        },
        // WITH|WITHOUT TIME ZONE as part of datatype
        {
          className: "type",
          begin: /\b(WITH|WITHOUT)\s+TIME\s+ZONE\b/
        },
        // INTERVAL optional fields
        {
          className: "type",
          begin: /\bINTERVAL\s+(YEAR|MONTH|DAY|HOUR|MINUTE|SECOND)(\s+TO\s+(MONTH|HOUR|MINUTE|SECOND))?\b/
        },
        // Pseudo-types which allowed only as return type
        {
          begin: /\bRETURNS\s+(LANGUAGE_HANDLER|TRIGGER|EVENT_TRIGGER|FDW_HANDLER|INDEX_AM_HANDLER|TSM_HANDLER)\b/,
          keywords: {
            keyword: "RETURNS",
            type: "LANGUAGE_HANDLER TRIGGER EVENT_TRIGGER FDW_HANDLER INDEX_AM_HANDLER TSM_HANDLER"
          }
        },
        // Known functions - only when followed by '('
        {
          begin: "\\b(" + G + ")\\s*\\("
          // keywords: { built_in: FUNCTIONS }
        },
        // Types
        {
          begin: "\\.(" + O + ")\\b"
          // prevent highlight as type, say, 'oid' in 'pgclass.oid'
        },
        {
          begin: "\\b(" + O + ")\\s+PATH\\b",
          // in XMLTABLE
          keywords: {
            keyword: "PATH",
            // hopefully no one would use PATH type in XMLTABLE...
            type: C.replace("PATH ", "")
          }
        },
        {
          className: "type",
          begin: "\\b(" + O + ")\\b"
        },
        // Strings, see https://www.postgresql.org/docs/11/static/sql-syntax-lexical.html#SQL-SYNTAX-CONSTANTS
        {
          className: "string",
          begin: "'",
          end: "'",
          contains: [{ begin: "''" }]
        },
        {
          className: "string",
          begin: "(e|E|u&|U&)'",
          end: "'",
          contains: [{ begin: "\\\\." }],
          relevance: 10
        },
        i.END_SAME_AS_BEGIN({
          begin: r,
          end: r,
          contains: [
            {
              // actually we want them all except SQL; listed are those with known implementations
              // and XML + JSON just in case
              subLanguage: [
                "pgsql",
                "perl",
                "python",
                "tcl",
                "r",
                "lua",
                "java",
                "php",
                "ruby",
                "bash",
                "scheme",
                "xml",
                "json"
              ],
              endsWithParent: !0
            }
          ]
        }),
        // identifiers in quotes
        {
          begin: '"',
          end: '"',
          contains: [{ begin: '""' }]
        },
        // numbers
        i.C_NUMBER_MODE,
        // comments
        i.C_BLOCK_COMMENT_MODE,
        o,
        // PL/pgSQL staff
        // %ROWTYPE, %TYPE, $n
        {
          className: "meta",
          variants: [
            {
              // %TYPE, %ROWTYPE
              begin: "%(ROW)?TYPE",
              relevance: 10
            },
            {
              // $n
              begin: "\\$\\d+"
            },
            {
              // #compiler option
              begin: "^#\\w",
              end: "$"
            }
          ]
        },
        // <<labeles>>
        {
          className: "symbol",
          begin: e,
          relevance: 10
        }
      ]
    };
  }
  return L_ = s, L_;
}
var M_, sT;
function gk() {
  if (sT)
    return M_;
  sT = 1;
  function s(i) {
    const o = i.regex, c = /(?![A-Za-z0-9])(?![$])/, r = o.concat(
      /[a-zA-Z_\x7f-\xff][a-zA-Z0-9_\x7f-\xff]*/,
      c
    ), e = o.concat(
      /(\\?[A-Z][a-z0-9_\x7f-\xff]+|\\?[A-Z]+(?=[A-Z][a-z0-9_\x7f-\xff])){1,}/,
      c
    ), g = {
      scope: "variable",
      match: "\\$+" + r
    }, h = {
      scope: "meta",
      variants: [
        { begin: /<\?php/, relevance: 10 },
        // boost for obvious PHP
        { begin: /<\?=/ },
        // less relevant per PSR-1 which says not to use short-tags
        { begin: /<\?/, relevance: 0.1 },
        { begin: /\?>/ }
        // end php tag
      ]
    }, S = {
      scope: "subst",
      variants: [
        { begin: /\$\w+/ },
        {
          begin: /\{\$/,
          end: /\}/
        }
      ]
    }, C = i.inherit(i.APOS_STRING_MODE, { illegal: null }), O = i.inherit(i.QUOTE_STRING_MODE, {
      illegal: null,
      contains: i.QUOTE_STRING_MODE.contains.concat(S)
    }), N = {
      begin: /<<<[ \t]*(?:(\w+)|"(\w+)")\n/,
      end: /[ \t]*(\w+)\b/,
      contains: i.QUOTE_STRING_MODE.contains.concat(S),
      "on:begin": (ge, w) => {
        w.data._beginMatch = ge[1] || ge[2];
      },
      "on:end": (ge, w) => {
        w.data._beginMatch !== ge[1] && w.ignoreMatch();
      }
    }, D = i.END_SAME_AS_BEGIN({
      begin: /<<<[ \t]*'(\w+)'\n/,
      end: /[ \t]*(\w+)\b/
    }), x = `[ 	
]`, L = {
      scope: "string",
      variants: [
        O,
        C,
        N,
        D
      ]
    }, G = {
      scope: "number",
      variants: [
        { begin: "\\b0[bB][01]+(?:_[01]+)*\\b" },
        // Binary w/ underscore support
        { begin: "\\b0[oO][0-7]+(?:_[0-7]+)*\\b" },
        // Octals w/ underscore support
        { begin: "\\b0[xX][\\da-fA-F]+(?:_[\\da-fA-F]+)*\\b" },
        // Hex w/ underscore support
        // Decimals w/ underscore support, with optional fragments and scientific exponent (e) suffix.
        { begin: "(?:\\b\\d+(?:_\\d+)*(\\.(?:\\d+(?:_\\d+)*))?|\\B\\.\\d+)(?:[eE][+-]?\\d+)?" }
      ],
      relevance: 0
    }, Y = [
      "false",
      "null",
      "true"
    ], k = [
      // Magic constants:
      // <https://www.php.net/manual/en/language.constants.predefined.php>
      "__CLASS__",
      "__DIR__",
      "__FILE__",
      "__FUNCTION__",
      "__COMPILER_HALT_OFFSET__",
      "__LINE__",
      "__METHOD__",
      "__NAMESPACE__",
      "__TRAIT__",
      // Function that look like language construct or language construct that look like function:
      // List of keywords that may not require parenthesis
      "die",
      "echo",
      "exit",
      "include",
      "include_once",
      "print",
      "require",
      "require_once",
      // These are not language construct (function) but operate on the currently-executing function and can access the current symbol table
      // 'compact extract func_get_arg func_get_args func_num_args get_called_class get_parent_class ' +
      // Other keywords:
      // <https://www.php.net/manual/en/reserved.php>
      // <https://www.php.net/manual/en/language.types.type-juggling.php>
      "array",
      "abstract",
      "and",
      "as",
      "binary",
      "bool",
      "boolean",
      "break",
      "callable",
      "case",
      "catch",
      "class",
      "clone",
      "const",
      "continue",
      "declare",
      "default",
      "do",
      "double",
      "else",
      "elseif",
      "empty",
      "enddeclare",
      "endfor",
      "endforeach",
      "endif",
      "endswitch",
      "endwhile",
      "enum",
      "eval",
      "extends",
      "final",
      "finally",
      "float",
      "for",
      "foreach",
      "from",
      "global",
      "goto",
      "if",
      "implements",
      "instanceof",
      "insteadof",
      "int",
      "integer",
      "interface",
      "isset",
      "iterable",
      "list",
      "match|0",
      "mixed",
      "new",
      "never",
      "object",
      "or",
      "private",
      "protected",
      "public",
      "readonly",
      "real",
      "return",
      "string",
      "switch",
      "throw",
      "trait",
      "try",
      "unset",
      "use",
      "var",
      "void",
      "while",
      "xor",
      "yield"
    ], W = [
      // Standard PHP library:
      // <https://www.php.net/manual/en/book.spl.php>
      "Error|0",
      "AppendIterator",
      "ArgumentCountError",
      "ArithmeticError",
      "ArrayIterator",
      "ArrayObject",
      "AssertionError",
      "BadFunctionCallException",
      "BadMethodCallException",
      "CachingIterator",
      "CallbackFilterIterator",
      "CompileError",
      "Countable",
      "DirectoryIterator",
      "DivisionByZeroError",
      "DomainException",
      "EmptyIterator",
      "ErrorException",
      "Exception",
      "FilesystemIterator",
      "FilterIterator",
      "GlobIterator",
      "InfiniteIterator",
      "InvalidArgumentException",
      "IteratorIterator",
      "LengthException",
      "LimitIterator",
      "LogicException",
      "MultipleIterator",
      "NoRewindIterator",
      "OutOfBoundsException",
      "OutOfRangeException",
      "OuterIterator",
      "OverflowException",
      "ParentIterator",
      "ParseError",
      "RangeException",
      "RecursiveArrayIterator",
      "RecursiveCachingIterator",
      "RecursiveCallbackFilterIterator",
      "RecursiveDirectoryIterator",
      "RecursiveFilterIterator",
      "RecursiveIterator",
      "RecursiveIteratorIterator",
      "RecursiveRegexIterator",
      "RecursiveTreeIterator",
      "RegexIterator",
      "RuntimeException",
      "SeekableIterator",
      "SplDoublyLinkedList",
      "SplFileInfo",
      "SplFileObject",
      "SplFixedArray",
      "SplHeap",
      "SplMaxHeap",
      "SplMinHeap",
      "SplObjectStorage",
      "SplObserver",
      "SplPriorityQueue",
      "SplQueue",
      "SplStack",
      "SplSubject",
      "SplTempFileObject",
      "TypeError",
      "UnderflowException",
      "UnexpectedValueException",
      "UnhandledMatchError",
      // Reserved interfaces:
      // <https://www.php.net/manual/en/reserved.interfaces.php>
      "ArrayAccess",
      "BackedEnum",
      "Closure",
      "Fiber",
      "Generator",
      "Iterator",
      "IteratorAggregate",
      "Serializable",
      "Stringable",
      "Throwable",
      "Traversable",
      "UnitEnum",
      "WeakReference",
      "WeakMap",
      // Reserved classes:
      // <https://www.php.net/manual/en/reserved.classes.php>
      "Directory",
      "__PHP_Incomplete_Class",
      "parent",
      "php_user_filter",
      "self",
      "static",
      "stdClass"
    ], H = {
      keyword: k,
      literal: ((ge) => {
        const w = [];
        return ge.forEach((fe) => {
          w.push(fe), fe.toLowerCase() === fe ? w.push(fe.toUpperCase()) : w.push(fe.toLowerCase());
        }), w;
      })(Y),
      built_in: W
    }, K = (ge) => ge.map((w) => w.replace(/\|\d+$/, "")), Q = { variants: [
      {
        match: [
          /new/,
          o.concat(x, "+"),
          // to prevent built ins from being confused as the class constructor call
          o.concat("(?!", K(W).join("\\b|"), "\\b)"),
          e
        ],
        scope: {
          1: "keyword",
          4: "title.class"
        }
      }
    ] }, _e = o.concat(r, "\\b(?!\\()"), se = { variants: [
      {
        match: [
          o.concat(
            /::/,
            o.lookahead(/(?!class\b)/)
          ),
          _e
        ],
        scope: { 2: "variable.constant" }
      },
      {
        match: [
          /::/,
          /class/
        ],
        scope: { 2: "variable.language" }
      },
      {
        match: [
          e,
          o.concat(
            /::/,
            o.lookahead(/(?!class\b)/)
          ),
          _e
        ],
        scope: {
          1: "title.class",
          3: "variable.constant"
        }
      },
      {
        match: [
          e,
          o.concat(
            "::",
            o.lookahead(/(?!class\b)/)
          )
        ],
        scope: { 1: "title.class" }
      },
      {
        match: [
          e,
          /::/,
          /class/
        ],
        scope: {
          1: "title.class",
          3: "variable.language"
        }
      }
    ] }, Pe = {
      scope: "attr",
      match: o.concat(r, o.lookahead(":"), o.lookahead(/(?!::)/))
    }, Ke = {
      relevance: 0,
      begin: /\(/,
      end: /\)/,
      keywords: H,
      contains: [
        Pe,
        g,
        se,
        i.C_BLOCK_COMMENT_MODE,
        L,
        G,
        Q
      ]
    }, ye = {
      relevance: 0,
      match: [
        /\b/,
        // to prevent keywords from being confused as the function title
        o.concat("(?!fn\\b|function\\b|", K(k).join("\\b|"), "|", K(W).join("\\b|"), "\\b)"),
        r,
        o.concat(x, "*"),
        o.lookahead(/(?=\()/)
      ],
      scope: { 3: "title.function.invoke" },
      contains: [Ke]
    };
    Ke.contains.push(ye);
    const Je = [
      Pe,
      se,
      i.C_BLOCK_COMMENT_MODE,
      L,
      G,
      Q
    ], mt = {
      begin: o.concat(/#\[\s*/, e),
      beginScope: "meta",
      end: /]/,
      endScope: "meta",
      keywords: {
        literal: Y,
        keyword: [
          "new",
          "array"
        ]
      },
      contains: [
        {
          begin: /\[/,
          end: /]/,
          keywords: {
            literal: Y,
            keyword: [
              "new",
              "array"
            ]
          },
          contains: [
            "self",
            ...Je
          ]
        },
        ...Je,
        {
          scope: "meta",
          match: e
        }
      ]
    };
    return {
      case_insensitive: !1,
      keywords: H,
      contains: [
        mt,
        i.HASH_COMMENT_MODE,
        i.COMMENT("//", "$"),
        i.COMMENT(
          "/\\*",
          "\\*/",
          { contains: [
            {
              scope: "doctag",
              match: "@[A-Za-z]+"
            }
          ] }
        ),
        {
          match: /__halt_compiler\(\);/,
          keywords: "__halt_compiler",
          starts: {
            scope: "comment",
            end: i.MATCH_NOTHING_RE,
            contains: [
              {
                match: /\?>/,
                scope: "meta",
                endsParent: !0
              }
            ]
          }
        },
        h,
        {
          scope: "variable.language",
          match: /\$this\b/
        },
        g,
        ye,
        se,
        {
          match: [
            /const/,
            /\s/,
            r
          ],
          scope: {
            1: "keyword",
            3: "variable.constant"
          }
        },
        Q,
        {
          scope: "function",
          relevance: 0,
          beginKeywords: "fn function",
          end: /[;{]/,
          excludeEnd: !0,
          illegal: "[$%\\[]",
          contains: [
            { beginKeywords: "use" },
            i.UNDERSCORE_TITLE_MODE,
            {
              begin: "=>",
              // No markup, just a relevance booster
              endsParent: !0
            },
            {
              scope: "params",
              begin: "\\(",
              end: "\\)",
              excludeBegin: !0,
              excludeEnd: !0,
              keywords: H,
              contains: [
                "self",
                g,
                se,
                i.C_BLOCK_COMMENT_MODE,
                L,
                G
              ]
            }
          ]
        },
        {
          scope: "class",
          variants: [
            {
              beginKeywords: "enum",
              illegal: /[($"]/
            },
            {
              beginKeywords: "class interface trait",
              illegal: /[:($"]/
            }
          ],
          relevance: 0,
          end: /\{/,
          excludeEnd: !0,
          contains: [
            { beginKeywords: "extends implements" },
            i.UNDERSCORE_TITLE_MODE
          ]
        },
        // both use and namespace still use "old style" rules (vs multi-match)
        // because the namespace name can include `\` and we still want each
        // element to be treated as its own *individual* title
        {
          beginKeywords: "namespace",
          relevance: 0,
          end: ";",
          illegal: /[.']/,
          contains: [i.inherit(i.UNDERSCORE_TITLE_MODE, { scope: "title.class" })]
        },
        {
          beginKeywords: "use",
          relevance: 0,
          end: ";",
          contains: [
            // TODO: title.function vs title.class
            {
              match: /\b(as|const|function)\b/,
              scope: "keyword"
            },
            // TODO: could be title.class or title.function
            i.UNDERSCORE_TITLE_MODE
          ]
        },
        L,
        G
      ]
    };
  }
  return M_ = s, M_;
}
var P_, lT;
function Ek() {
  if (lT)
    return P_;
  lT = 1;
  function s(i) {
    return {
      name: "PHP template",
      subLanguage: "xml",
      contains: [
        {
          begin: /<\?(php|=)?/,
          end: /\?>/,
          subLanguage: "php",
          contains: [
            // We don't want the php closing tag ?> to close the PHP block when
            // inside any of the following blocks:
            {
              begin: "/\\*",
              end: "\\*/",
              skip: !0
            },
            {
              begin: 'b"',
              end: '"',
              skip: !0
            },
            {
              begin: "b'",
              end: "'",
              skip: !0
            },
            i.inherit(i.APOS_STRING_MODE, {
              illegal: null,
              className: null,
              contains: null,
              skip: !0
            }),
            i.inherit(i.QUOTE_STRING_MODE, {
              illegal: null,
              className: null,
              contains: null,
              skip: !0
            })
          ]
        }
      ]
    };
  }
  return P_ = s, P_;
}
var k_, cT;
function hk() {
  if (cT)
    return k_;
  cT = 1;
  function s(i) {
    return {
      name: "Plain text",
      aliases: [
        "text",
        "txt"
      ],
      disableAutodetect: !0
    };
  }
  return k_ = s, k_;
}
var F_, dT;
function Sk() {
  if (dT)
    return F_;
  dT = 1;
  function s(i) {
    const o = {
      keyword: "actor addressof and as be break class compile_error compile_intrinsic consume continue delegate digestof do else elseif embed end error for fun if ifdef in interface is isnt lambda let match new not object or primitive recover repeat return struct then trait try type until use var where while with xor",
      meta: "iso val tag trn box ref",
      literal: "this false true"
    }, c = {
      className: "string",
      begin: '"""',
      end: '"""',
      relevance: 10
    }, r = {
      className: "string",
      begin: '"',
      end: '"',
      contains: [i.BACKSLASH_ESCAPE]
    }, e = {
      className: "string",
      begin: "'",
      end: "'",
      contains: [i.BACKSLASH_ESCAPE],
      relevance: 0
    }, g = {
      className: "type",
      begin: "\\b_?[A-Z][\\w]*",
      relevance: 0
    }, h = {
      begin: i.IDENT_RE + "'",
      relevance: 0
    };
    return {
      name: "Pony",
      keywords: o,
      contains: [
        g,
        c,
        r,
        e,
        h,
        {
          className: "number",
          begin: "(-?)(\\b0[xX][a-fA-F0-9]+|\\b0[bB][01]+|(\\b\\d+(_\\d+)?(\\.\\d*)?|\\.\\d+)([eE][-+]?\\d+)?)",
          relevance: 0
        },
        i.C_LINE_COMMENT_MODE,
        i.C_BLOCK_COMMENT_MODE
      ]
    };
  }
  return F_ = s, F_;
}
var U_, uT;
function bk() {
  if (uT)
    return U_;
  uT = 1;
  function s(i) {
    const o = [
      "string",
      "char",
      "byte",
      "int",
      "long",
      "bool",
      "decimal",
      "single",
      "double",
      "DateTime",
      "xml",
      "array",
      "hashtable",
      "void"
    ], c = "Add|Clear|Close|Copy|Enter|Exit|Find|Format|Get|Hide|Join|Lock|Move|New|Open|Optimize|Pop|Push|Redo|Remove|Rename|Reset|Resize|Search|Select|Set|Show|Skip|Split|Step|Switch|Undo|Unlock|Watch|Backup|Checkpoint|Compare|Compress|Convert|ConvertFrom|ConvertTo|Dismount|Edit|Expand|Export|Group|Import|Initialize|Limit|Merge|Mount|Out|Publish|Restore|Save|Sync|Unpublish|Update|Approve|Assert|Build|Complete|Confirm|Deny|Deploy|Disable|Enable|Install|Invoke|Register|Request|Restart|Resume|Start|Stop|Submit|Suspend|Uninstall|Unregister|Wait|Debug|Measure|Ping|Repair|Resolve|Test|Trace|Connect|Disconnect|Read|Receive|Send|Write|Block|Grant|Protect|Revoke|Unblock|Unprotect|Use|ForEach|Sort|Tee|Where", r = "-and|-as|-band|-bnot|-bor|-bxor|-casesensitive|-ccontains|-ceq|-cge|-cgt|-cle|-clike|-clt|-cmatch|-cne|-cnotcontains|-cnotlike|-cnotmatch|-contains|-creplace|-csplit|-eq|-exact|-f|-file|-ge|-gt|-icontains|-ieq|-ige|-igt|-ile|-ilike|-ilt|-imatch|-in|-ine|-inotcontains|-inotlike|-inotmatch|-ireplace|-is|-isnot|-isplit|-join|-le|-like|-lt|-match|-ne|-not|-notcontains|-notin|-notlike|-notmatch|-or|-regex|-replace|-shl|-shr|-split|-wildcard|-xor", e = {
      $pattern: /-?[A-z\.\-]+\b/,
      keyword: "if else foreach return do while until elseif begin for trap data dynamicparam end break throw param continue finally in switch exit filter try process catch hidden static parameter",
      // "echo" relevance has been set to 0 to avoid auto-detect conflicts with shell transcripts
      built_in: "ac asnp cat cd CFS chdir clc clear clhy cli clp cls clv cnsn compare copy cp cpi cpp curl cvpa dbp del diff dir dnsn ebp echo|0 epal epcsv epsn erase etsn exsn fc fhx fl ft fw gal gbp gc gcb gci gcm gcs gdr gerr ghy gi gin gjb gl gm gmo gp gps gpv group gsn gsnp gsv gtz gu gv gwmi h history icm iex ihy ii ipal ipcsv ipmo ipsn irm ise iwmi iwr kill lp ls man md measure mi mount move mp mv nal ndr ni nmo npssc nsn nv ogv oh popd ps pushd pwd r rbp rcjb rcsn rd rdr ren ri rjb rm rmdir rmo rni rnp rp rsn rsnp rujb rv rvpa rwmi sajb sal saps sasv sbp sc scb select set shcm si sl sleep sls sort sp spjb spps spsv start stz sujb sv swmi tee trcm type wget where wjb write"
      // TODO: 'validate[A-Z]+' can't work in keywords
    }, g = /\w[\w\d]*((-)[\w\d]+)*/, h = {
      begin: "`[\\s\\S]",
      relevance: 0
    }, S = {
      className: "variable",
      variants: [
        { begin: /\$\B/ },
        {
          className: "keyword",
          begin: /\$this/
        },
        { begin: /\$[\w\d][\w\d_:]*/ }
      ]
    }, C = {
      className: "literal",
      begin: /\$(null|true|false)\b/
    }, O = {
      className: "string",
      variants: [
        {
          begin: /"/,
          end: /"/
        },
        {
          begin: /@"/,
          end: /^"@/
        }
      ],
      contains: [
        h,
        S,
        {
          className: "variable",
          begin: /\$[A-z]/,
          end: /[^A-z]/
        }
      ]
    }, N = {
      className: "string",
      variants: [
        {
          begin: /'/,
          end: /'/
        },
        {
          begin: /@'/,
          end: /^'@/
        }
      ]
    }, D = {
      className: "doctag",
      variants: [
        /* no paramater help tags */
        { begin: /\.(synopsis|description|example|inputs|outputs|notes|link|component|role|functionality)/ },
        /* one parameter help tags */
        { begin: /\.(parameter|forwardhelptargetname|forwardhelpcategory|remotehelprunspace|externalhelp)\s+\S+/ }
      ]
    }, x = i.inherit(
      i.COMMENT(null, null),
      {
        variants: [
          /* single-line comment */
          {
            begin: /#/,
            end: /$/
          },
          /* multi-line comment */
          {
            begin: /<#/,
            end: /#>/
          }
        ],
        contains: [D]
      }
    ), L = {
      className: "built_in",
      variants: [{ begin: "(".concat(c, ")+(-)[\\w\\d]+") }]
    }, G = {
      className: "class",
      beginKeywords: "class enum",
      end: /\s*[{]/,
      excludeEnd: !0,
      relevance: 0,
      contains: [i.TITLE_MODE]
    }, Y = {
      className: "function",
      begin: /function\s+/,
      end: /\s*\{|$/,
      excludeEnd: !0,
      returnBegin: !0,
      relevance: 0,
      contains: [
        {
          begin: "function",
          relevance: 0,
          className: "keyword"
        },
        {
          className: "title",
          begin: g,
          relevance: 0
        },
        {
          begin: /\(/,
          end: /\)/,
          className: "params",
          relevance: 0,
          contains: [S]
        }
        // CMDLETS
      ]
    }, k = {
      begin: /using\s/,
      end: /$/,
      returnBegin: !0,
      contains: [
        O,
        N,
        {
          className: "keyword",
          begin: /(using|assembly|command|module|namespace|type)/
        }
      ]
    }, W = { variants: [
      // PS literals are pretty verbose so it's a good idea to accent them a bit.
      {
        className: "operator",
        begin: "(".concat(r, ")\\b")
      },
      {
        className: "literal",
        begin: /(-){1,2}[\w\d-]+/,
        relevance: 0
      }
    ] }, Z = {
      className: "selector-tag",
      begin: /@\B/,
      relevance: 0
    }, H = {
      className: "function",
      begin: /\[.*\]\s*[\w]+[ ]??\(/,
      end: /$/,
      returnBegin: !0,
      relevance: 0,
      contains: [
        {
          className: "keyword",
          begin: "(".concat(
            e.keyword.toString().replace(
              /\s/g,
              "|"
            ),
            ")\\b"
          ),
          endsParent: !0,
          relevance: 0
        },
        i.inherit(i.TITLE_MODE, { endsParent: !0 })
      ]
    }, K = [
      // STATIC_MEMBER,
      H,
      x,
      h,
      i.NUMBER_MODE,
      O,
      N,
      // PS_NEW_OBJECT_TYPE,
      L,
      S,
      C,
      Z
    ], Q = {
      begin: /\[/,
      end: /\]/,
      excludeBegin: !0,
      excludeEnd: !0,
      relevance: 0,
      contains: [].concat(
        "self",
        K,
        {
          begin: "(" + o.join("|") + ")",
          className: "built_in",
          relevance: 0
        },
        {
          className: "type",
          begin: /[\.\w\d]+/,
          relevance: 0
        }
      )
    };
    return H.contains.unshift(Q), {
      name: "PowerShell",
      aliases: [
        "pwsh",
        "ps",
        "ps1"
      ],
      case_insensitive: !0,
      keywords: e,
      contains: K.concat(
        G,
        Y,
        k,
        W,
        Q
      )
    };
  }
  return U_ = s, U_;
}
var B_, _T;
function Tk() {
  if (_T)
    return B_;
  _T = 1;
  function s(i) {
    const o = i.regex, c = [
      "displayHeight",
      "displayWidth",
      "mouseY",
      "mouseX",
      "mousePressed",
      "pmouseX",
      "pmouseY",
      "key",
      "keyCode",
      "pixels",
      "focused",
      "frameCount",
      "frameRate",
      "height",
      "width",
      "size",
      "createGraphics",
      "beginDraw",
      "createShape",
      "loadShape",
      "PShape",
      "arc",
      "ellipse",
      "line",
      "point",
      "quad",
      "rect",
      "triangle",
      "bezier",
      "bezierDetail",
      "bezierPoint",
      "bezierTangent",
      "curve",
      "curveDetail",
      "curvePoint",
      "curveTangent",
      "curveTightness",
      "shape",
      "shapeMode",
      "beginContour",
      "beginShape",
      "bezierVertex",
      "curveVertex",
      "endContour",
      "endShape",
      "quadraticVertex",
      "vertex",
      "ellipseMode",
      "noSmooth",
      "rectMode",
      "smooth",
      "strokeCap",
      "strokeJoin",
      "strokeWeight",
      "mouseClicked",
      "mouseDragged",
      "mouseMoved",
      "mousePressed",
      "mouseReleased",
      "mouseWheel",
      "keyPressed",
      "keyPressedkeyReleased",
      "keyTyped",
      "print",
      "println",
      "save",
      "saveFrame",
      "day",
      "hour",
      "millis",
      "minute",
      "month",
      "second",
      "year",
      "background",
      "clear",
      "colorMode",
      "fill",
      "noFill",
      "noStroke",
      "stroke",
      "alpha",
      "blue",
      "brightness",
      "color",
      "green",
      "hue",
      "lerpColor",
      "red",
      "saturation",
      "modelX",
      "modelY",
      "modelZ",
      "screenX",
      "screenY",
      "screenZ",
      "ambient",
      "emissive",
      "shininess",
      "specular",
      "add",
      "createImage",
      "beginCamera",
      "camera",
      "endCamera",
      "frustum",
      "ortho",
      "perspective",
      "printCamera",
      "printProjection",
      "cursor",
      "frameRate",
      "noCursor",
      "exit",
      "loop",
      "noLoop",
      "popStyle",
      "pushStyle",
      "redraw",
      "binary",
      "boolean",
      "byte",
      "char",
      "float",
      "hex",
      "int",
      "str",
      "unbinary",
      "unhex",
      "join",
      "match",
      "matchAll",
      "nf",
      "nfc",
      "nfp",
      "nfs",
      "split",
      "splitTokens",
      "trim",
      "append",
      "arrayCopy",
      "concat",
      "expand",
      "reverse",
      "shorten",
      "sort",
      "splice",
      "subset",
      "box",
      "sphere",
      "sphereDetail",
      "createInput",
      "createReader",
      "loadBytes",
      "loadJSONArray",
      "loadJSONObject",
      "loadStrings",
      "loadTable",
      "loadXML",
      "open",
      "parseXML",
      "saveTable",
      "selectFolder",
      "selectInput",
      "beginRaw",
      "beginRecord",
      "createOutput",
      "createWriter",
      "endRaw",
      "endRecord",
      "PrintWritersaveBytes",
      "saveJSONArray",
      "saveJSONObject",
      "saveStream",
      "saveStrings",
      "saveXML",
      "selectOutput",
      "popMatrix",
      "printMatrix",
      "pushMatrix",
      "resetMatrix",
      "rotate",
      "rotateX",
      "rotateY",
      "rotateZ",
      "scale",
      "shearX",
      "shearY",
      "translate",
      "ambientLight",
      "directionalLight",
      "lightFalloff",
      "lights",
      "lightSpecular",
      "noLights",
      "normal",
      "pointLight",
      "spotLight",
      "image",
      "imageMode",
      "loadImage",
      "noTint",
      "requestImage",
      "tint",
      "texture",
      "textureMode",
      "textureWrap",
      "blend",
      "copy",
      "filter",
      "get",
      "loadPixels",
      "set",
      "updatePixels",
      "blendMode",
      "loadShader",
      "PShaderresetShader",
      "shader",
      "createFont",
      "loadFont",
      "text",
      "textFont",
      "textAlign",
      "textLeading",
      "textMode",
      "textSize",
      "textWidth",
      "textAscent",
      "textDescent",
      "abs",
      "ceil",
      "constrain",
      "dist",
      "exp",
      "floor",
      "lerp",
      "log",
      "mag",
      "map",
      "max",
      "min",
      "norm",
      "pow",
      "round",
      "sq",
      "sqrt",
      "acos",
      "asin",
      "atan",
      "atan2",
      "cos",
      "degrees",
      "radians",
      "sin",
      "tan",
      "noise",
      "noiseDetail",
      "noiseSeed",
      "random",
      "randomGaussian",
      "randomSeed"
    ], r = i.IDENT_RE, e = { variants: [
      {
        match: o.concat(o.either(...c), o.lookahead(/\s*\(/)),
        className: "built_in"
      },
      {
        relevance: 0,
        match: o.concat(
          /\b(?!for|if|while)/,
          r,
          o.lookahead(/\s*\(/)
        ),
        className: "title.function"
      }
    ] }, g = {
      match: [
        /new\s+/,
        r
      ],
      className: {
        1: "keyword",
        2: "class.title"
      }
    }, h = {
      relevance: 0,
      match: [
        /\./,
        r
      ],
      className: { 2: "property" }
    }, S = {
      variants: [
        { match: [
          /class/,
          /\s+/,
          r,
          /\s+/,
          /extends/,
          /\s+/,
          r
        ] },
        { match: [
          /class/,
          /\s+/,
          r
        ] }
      ],
      className: {
        1: "keyword",
        3: "title.class",
        5: "keyword",
        7: "title.class.inherited"
      }
    }, C = [
      "boolean",
      "byte",
      "char",
      "color",
      "double",
      "float",
      "int",
      "long",
      "short"
    ], O = [
      "BufferedReader",
      "PVector",
      "PFont",
      "PImage",
      "PGraphics",
      "HashMap",
      "String",
      "Array",
      "FloatDict",
      "ArrayList",
      "FloatList",
      "IntDict",
      "IntList",
      "JSONArray",
      "JSONObject",
      "Object",
      "StringDict",
      "StringList",
      "Table",
      "TableRow",
      "XML"
    ];
    return {
      name: "Processing",
      aliases: ["pde"],
      keywords: {
        keyword: [...[
          "abstract",
          "assert",
          "break",
          "case",
          "catch",
          "const",
          "continue",
          "default",
          "else",
          "enum",
          "final",
          "finally",
          "for",
          "if",
          "import",
          "instanceof",
          "long",
          "native",
          "new",
          "package",
          "private",
          "private",
          "protected",
          "protected",
          "public",
          "public",
          "return",
          "static",
          "strictfp",
          "switch",
          "synchronized",
          "throw",
          "throws",
          "transient",
          "try",
          "void",
          "volatile",
          "while"
        ]],
        literal: "P2D P3D HALF_PI PI QUARTER_PI TAU TWO_PI null true false",
        title: "setup draw",
        variable: "super this",
        built_in: [
          ...c,
          ...O
        ],
        type: C
      },
      contains: [
        S,
        g,
        e,
        h,
        i.C_LINE_COMMENT_MODE,
        i.C_BLOCK_COMMENT_MODE,
        i.APOS_STRING_MODE,
        i.QUOTE_STRING_MODE,
        i.C_NUMBER_MODE
      ]
    };
  }
  return B_ = s, B_;
}
var G_, pT;
function vk() {
  if (pT)
    return G_;
  pT = 1;
  function s(i) {
    return {
      name: "Python profiler",
      contains: [
        i.C_NUMBER_MODE,
        {
          begin: "[a-zA-Z_][\\da-zA-Z_]+\\.[\\da-zA-Z_]{1,3}",
          end: ":",
          excludeEnd: !0
        },
        {
          begin: "(ncalls|tottime|cumtime)",
          end: "$",
          keywords: "ncalls tottime|10 cumtime|10 filename",
          relevance: 10
        },
        {
          begin: "function calls",
          end: "$",
          contains: [i.C_NUMBER_MODE],
          relevance: 10
        },
        i.APOS_STRING_MODE,
        i.QUOTE_STRING_MODE,
        {
          className: "string",
          begin: "\\(",
          end: "\\)$",
          excludeBegin: !0,
          excludeEnd: !0,
          relevance: 0
        }
      ]
    };
  }
  return G_ = s, G_;
}
var V_, mT;
function Ck() {
  if (mT)
    return V_;
  mT = 1;
  function s(i) {
    const o = {
      begin: /[a-z][A-Za-z0-9_]*/,
      relevance: 0
    }, c = {
      className: "symbol",
      variants: [
        { begin: /[A-Z][a-zA-Z0-9_]*/ },
        { begin: /_[A-Za-z0-9_]*/ }
      ],
      relevance: 0
    }, r = {
      begin: /\(/,
      end: /\)/,
      relevance: 0
    }, e = {
      begin: /\[/,
      end: /\]/
    }, g = {
      className: "comment",
      begin: /%/,
      end: /$/,
      contains: [i.PHRASAL_WORDS_MODE]
    }, h = {
      className: "string",
      begin: /`/,
      end: /`/,
      contains: [i.BACKSLASH_ESCAPE]
    }, S = {
      className: "string",
      // 0'a etc.
      begin: /0'(\\'|.)/
    }, C = {
      className: "string",
      begin: /0'\\s/
      // 0'\s
    }, N = [
      o,
      c,
      r,
      {
        // relevance booster
        begin: /:-/
      },
      e,
      g,
      i.C_BLOCK_COMMENT_MODE,
      i.QUOTE_STRING_MODE,
      i.APOS_STRING_MODE,
      h,
      S,
      C,
      i.C_NUMBER_MODE
    ];
    return r.contains = N, e.contains = N, {
      name: "Prolog",
      contains: N.concat([
        {
          // relevance booster
          begin: /\.$/
        }
      ])
    };
  }
  return V_ = s, V_;
}
var Y_, fT;
function Rk() {
  if (fT)
    return Y_;
  fT = 1;
  function s(i) {
    const o = "[ \\t\\f]*", c = "[ \\t\\f]+", r = o + "[:=]" + o, e = c, g = "(" + r + "|" + e + ")", h = "([^\\\\:= \\t\\f\\n]|\\\\.)+", S = {
      // skip DELIM
      end: g,
      relevance: 0,
      starts: {
        // value: everything until end of line (again, taking into account backslashes)
        className: "string",
        end: /$/,
        relevance: 0,
        contains: [
          { begin: "\\\\\\\\" },
          { begin: "\\\\\\n" }
        ]
      }
    };
    return {
      name: ".properties",
      disableAutodetect: !0,
      case_insensitive: !0,
      illegal: /\S/,
      contains: [
        i.COMMENT("^\\s*[!#]", "$"),
        // key: everything until whitespace or = or : (taking into account backslashes)
        // case of a key-value pair
        {
          returnBegin: !0,
          variants: [
            { begin: h + r },
            { begin: h + e }
          ],
          contains: [
            {
              className: "attr",
              begin: h,
              endsParent: !0
            }
          ],
          starts: S
        },
        // case of an empty key
        {
          className: "attr",
          begin: h + o + "$"
        }
      ]
    };
  }
  return Y_ = s, Y_;
}
var H_, gT;
function Nk() {
  if (gT)
    return H_;
  gT = 1;
  function s(i) {
    const o = [
      "package",
      "import",
      "option",
      "optional",
      "required",
      "repeated",
      "group",
      "oneof"
    ], c = [
      "double",
      "float",
      "int32",
      "int64",
      "uint32",
      "uint64",
      "sint32",
      "sint64",
      "fixed32",
      "fixed64",
      "sfixed32",
      "sfixed64",
      "bool",
      "string",
      "bytes"
    ], r = {
      match: [
        /(message|enum|service)\s+/,
        i.IDENT_RE
      ],
      scope: {
        1: "keyword",
        2: "title.class"
      }
    };
    return {
      name: "Protocol Buffers",
      aliases: ["proto"],
      keywords: {
        keyword: o,
        type: c,
        literal: [
          "true",
          "false"
        ]
      },
      contains: [
        i.QUOTE_STRING_MODE,
        i.NUMBER_MODE,
        i.C_LINE_COMMENT_MODE,
        i.C_BLOCK_COMMENT_MODE,
        r,
        {
          className: "function",
          beginKeywords: "rpc",
          end: /[{;]/,
          excludeEnd: !0,
          keywords: "rpc returns"
        },
        {
          // match enum items (relevance)
          // BLAH = ...;
          begin: /^\s*[A-Z_]+(?=\s*=[^\n]+;$)/
        }
      ]
    };
  }
  return H_ = s, H_;
}
var q_, ET;
function Ak() {
  if (ET)
    return q_;
  ET = 1;
  function s(i) {
    const o = {
      keyword: (
        /* language keywords */
        "and case default else elsif false if in import enherits node or true undef unless main settings $string "
      ),
      literal: (
        /* metaparameters */
        "alias audit before loglevel noop require subscribe tag owner ensure group mode name|0 changes context force incl lens load_path onlyif provider returns root show_diff type_check en_address ip_address realname command environment hour monute month monthday special target weekday creates cwd ogoutput refresh refreshonly tries try_sleep umask backup checksum content ctime force ignore links mtime purge recurse recurselimit replace selinux_ignore_defaults selrange selrole seltype seluser source souirce_permissions sourceselect validate_cmd validate_replacement allowdupe attribute_membership auth_membership forcelocal gid ia_load_module members system host_aliases ip allowed_trunk_vlans description device_url duplex encapsulation etherchannel native_vlan speed principals allow_root auth_class auth_type authenticate_user k_of_n mechanisms rule session_owner shared options device fstype enable hasrestart directory present absent link atboot blockdevice device dump pass remounts poller_tag use message withpath adminfile allow_virtual allowcdrom category configfiles flavor install_options instance package_settings platform responsefile status uninstall_options vendor unless_system_user unless_uid binary control flags hasstatus manifest pattern restart running start stop allowdupe auths expiry gid groups home iterations key_membership keys managehome membership password password_max_age password_min_age profile_membership profiles project purge_ssh_keys role_membership roles salt shell uid baseurl cost descr enabled enablegroups exclude failovermethod gpgcheck gpgkey http_caching include includepkgs keepalive metadata_expire metalink mirrorlist priority protect proxy proxy_password proxy_username repo_gpgcheck s3_enabled skip_if_unavailable sslcacert sslclientcert sslclientkey sslverify mounted"
      ),
      built_in: (
        /* core facts */
        "architecture augeasversion blockdevices boardmanufacturer boardproductname boardserialnumber cfkey dhcp_servers domain ec2_ ec2_userdata facterversion filesystems ldom fqdn gid hardwareisa hardwaremodel hostname id|0 interfaces ipaddress ipaddress_ ipaddress6 ipaddress6_ iphostnumber is_virtual kernel kernelmajversion kernelrelease kernelversion kernelrelease kernelversion lsbdistcodename lsbdistdescription lsbdistid lsbdistrelease lsbmajdistrelease lsbminordistrelease lsbrelease macaddress macaddress_ macosx_buildversion macosx_productname macosx_productversion macosx_productverson_major macosx_productversion_minor manufacturer memoryfree memorysize netmask metmask_ network_ operatingsystem operatingsystemmajrelease operatingsystemrelease osfamily partitions path physicalprocessorcount processor processorcount productname ps puppetversion rubysitedir rubyversion selinux selinux_config_mode selinux_config_policy selinux_current_mode selinux_current_mode selinux_enforced selinux_policyversion serialnumber sp_ sshdsakey sshecdsakey sshrsakey swapencrypted swapfree swapsize timezone type uniqueid uptime uptime_days uptime_hours uptime_seconds uuid virtual vlans xendomains zfs_version zonenae zones zpool_version"
      )
    }, c = i.COMMENT("#", "$"), r = "([A-Za-z_]|::)(\\w|::)*", e = i.inherit(i.TITLE_MODE, { begin: r }), g = {
      className: "variable",
      begin: "\\$" + r
    }, h = {
      className: "string",
      contains: [
        i.BACKSLASH_ESCAPE,
        g
      ],
      variants: [
        {
          begin: /'/,
          end: /'/
        },
        {
          begin: /"/,
          end: /"/
        }
      ]
    };
    return {
      name: "Puppet",
      aliases: ["pp"],
      contains: [
        c,
        g,
        h,
        {
          beginKeywords: "class",
          end: "\\{|;",
          illegal: /=/,
          contains: [
            e,
            c
          ]
        },
        {
          beginKeywords: "define",
          end: /\{/,
          contains: [
            {
              className: "section",
              begin: i.IDENT_RE,
              endsParent: !0
            }
          ]
        },
        {
          begin: i.IDENT_RE + "\\s+\\{",
          returnBegin: !0,
          end: /\S/,
          contains: [
            {
              className: "keyword",
              begin: i.IDENT_RE,
              relevance: 0.2
            },
            {
              begin: /\{/,
              end: /\}/,
              keywords: o,
              relevance: 0,
              contains: [
                h,
                c,
                {
                  begin: "[a-zA-Z_]+\\s*=>",
                  returnBegin: !0,
                  end: "=>",
                  contains: [
                    {
                      className: "attr",
                      begin: i.IDENT_RE
                    }
                  ]
                },
                {
                  className: "number",
                  begin: "(\\b0[0-7_]+)|(\\b0x[0-9a-fA-F_]+)|(\\b[1-9][0-9_]*(\\.[0-9_]+)?)|[0_]\\b",
                  relevance: 0
                },
                g
              ]
            }
          ],
          relevance: 0
        }
      ]
    };
  }
  return q_ = s, q_;
}
var $_, hT;
function Ok() {
  if (hT)
    return $_;
  hT = 1;
  function s(i) {
    const o = {
      // PB IDE color: #0080FF (Azure Radiance)
      className: "string",
      begin: '(~)?"',
      end: '"',
      illegal: "\\n"
    }, c = {
      // PB IDE color: #924B72 (Cannon Pink)
      //  "#" + a letter or underscore + letters, digits or underscores + (optional) "$"
      className: "symbol",
      begin: "#[a-zA-Z_]\\w*\\$?"
    };
    return {
      name: "PureBASIC",
      aliases: [
        "pb",
        "pbi"
      ],
      keywords: (
        // PB IDE color: #006666 (Blue Stone) + Bold
        // Keywords from all version of PureBASIC 5.00 upward ...
        "Align And Array As Break CallDebugger Case CompilerCase CompilerDefault CompilerElse CompilerElseIf CompilerEndIf CompilerEndSelect CompilerError CompilerIf CompilerSelect CompilerWarning Continue Data DataSection Debug DebugLevel Declare DeclareC DeclareCDLL DeclareDLL DeclareModule Default Define Dim DisableASM DisableDebugger DisableExplicit Else ElseIf EnableASM EnableDebugger EnableExplicit End EndDataSection EndDeclareModule EndEnumeration EndIf EndImport EndInterface EndMacro EndModule EndProcedure EndSelect EndStructure EndStructureUnion EndWith Enumeration EnumerationBinary Extends FakeReturn For ForEach ForEver Global Gosub Goto If Import ImportC IncludeBinary IncludeFile IncludePath Interface List Macro MacroExpandedCount Map Module NewList NewMap Next Not Or Procedure ProcedureC ProcedureCDLL ProcedureDLL ProcedureReturn Protected Prototype PrototypeC ReDim Read Repeat Restore Return Runtime Select Shared Static Step Structure StructureUnion Swap Threaded To UndefineMacro Until Until  UnuseModule UseModule Wend While With XIncludeFile XOr"
      ),
      contains: [
        // COMMENTS | PB IDE color: #00AAAA (Persian Green)
        i.COMMENT(";", "$", { relevance: 0 }),
        {
          // PROCEDURES DEFINITIONS
          className: "function",
          begin: "\\b(Procedure|Declare)(C|CDLL|DLL)?\\b",
          end: "\\(",
          excludeEnd: !0,
          returnBegin: !0,
          contains: [
            {
              // PROCEDURE KEYWORDS | PB IDE color: #006666 (Blue Stone) + Bold
              className: "keyword",
              begin: "(Procedure|Declare)(C|CDLL|DLL)?",
              excludeEnd: !0
            },
            {
              // PROCEDURE RETURN TYPE SETTING | PB IDE color: #000000 (Black)
              className: "type",
              begin: "\\.\\w*"
              // end: ' ',
            },
            i.UNDERSCORE_TITLE_MODE
            // PROCEDURE NAME | PB IDE color: #006666 (Blue Stone)
          ]
        },
        o,
        c
      ]
    };
  }
  return $_ = s, $_;
}
var W_, ST;
function yk() {
  if (ST)
    return W_;
  ST = 1;
  function s(i) {
    const o = i.regex, c = new RegExp("[\\p{XID_Start}_]\\p{XID_Continue}*", "u"), r = [
      "and",
      "as",
      "assert",
      "async",
      "await",
      "break",
      "case",
      "class",
      "continue",
      "def",
      "del",
      "elif",
      "else",
      "except",
      "finally",
      "for",
      "from",
      "global",
      "if",
      "import",
      "in",
      "is",
      "lambda",
      "match",
      "nonlocal|10",
      "not",
      "or",
      "pass",
      "raise",
      "return",
      "try",
      "while",
      "with",
      "yield"
    ], S = {
      $pattern: /[A-Za-z]\w+|__\w+__/,
      keyword: r,
      built_in: [
        "__import__",
        "abs",
        "all",
        "any",
        "ascii",
        "bin",
        "bool",
        "breakpoint",
        "bytearray",
        "bytes",
        "callable",
        "chr",
        "classmethod",
        "compile",
        "complex",
        "delattr",
        "dict",
        "dir",
        "divmod",
        "enumerate",
        "eval",
        "exec",
        "filter",
        "float",
        "format",
        "frozenset",
        "getattr",
        "globals",
        "hasattr",
        "hash",
        "help",
        "hex",
        "id",
        "input",
        "int",
        "isinstance",
        "issubclass",
        "iter",
        "len",
        "list",
        "locals",
        "map",
        "max",
        "memoryview",
        "min",
        "next",
        "object",
        "oct",
        "open",
        "ord",
        "pow",
        "print",
        "property",
        "range",
        "repr",
        "reversed",
        "round",
        "set",
        "setattr",
        "slice",
        "sorted",
        "staticmethod",
        "str",
        "sum",
        "super",
        "tuple",
        "type",
        "vars",
        "zip"
      ],
      literal: [
        "__debug__",
        "Ellipsis",
        "False",
        "None",
        "NotImplemented",
        "True"
      ],
      type: [
        "Any",
        "Callable",
        "Coroutine",
        "Dict",
        "List",
        "Literal",
        "Generic",
        "Optional",
        "Sequence",
        "Set",
        "Tuple",
        "Type",
        "Union"
      ]
    }, C = {
      className: "meta",
      begin: /^(>>>|\.\.\.) /
    }, O = {
      className: "subst",
      begin: /\{/,
      end: /\}/,
      keywords: S,
      illegal: /#/
    }, N = {
      begin: /\{\{/,
      relevance: 0
    }, D = {
      className: "string",
      contains: [i.BACKSLASH_ESCAPE],
      variants: [
        {
          begin: /([uU]|[bB]|[rR]|[bB][rR]|[rR][bB])?'''/,
          end: /'''/,
          contains: [
            i.BACKSLASH_ESCAPE,
            C
          ],
          relevance: 10
        },
        {
          begin: /([uU]|[bB]|[rR]|[bB][rR]|[rR][bB])?"""/,
          end: /"""/,
          contains: [
            i.BACKSLASH_ESCAPE,
            C
          ],
          relevance: 10
        },
        {
          begin: /([fF][rR]|[rR][fF]|[fF])'''/,
          end: /'''/,
          contains: [
            i.BACKSLASH_ESCAPE,
            C,
            N,
            O
          ]
        },
        {
          begin: /([fF][rR]|[rR][fF]|[fF])"""/,
          end: /"""/,
          contains: [
            i.BACKSLASH_ESCAPE,
            C,
            N,
            O
          ]
        },
        {
          begin: /([uU]|[rR])'/,
          end: /'/,
          relevance: 10
        },
        {
          begin: /([uU]|[rR])"/,
          end: /"/,
          relevance: 10
        },
        {
          begin: /([bB]|[bB][rR]|[rR][bB])'/,
          end: /'/
        },
        {
          begin: /([bB]|[bB][rR]|[rR][bB])"/,
          end: /"/
        },
        {
          begin: /([fF][rR]|[rR][fF]|[fF])'/,
          end: /'/,
          contains: [
            i.BACKSLASH_ESCAPE,
            N,
            O
          ]
        },
        {
          begin: /([fF][rR]|[rR][fF]|[fF])"/,
          end: /"/,
          contains: [
            i.BACKSLASH_ESCAPE,
            N,
            O
          ]
        },
        i.APOS_STRING_MODE,
        i.QUOTE_STRING_MODE
      ]
    }, x = "[0-9](_?[0-9])*", L = `(\\b(${x}))?\\.(${x})|\\b(${x})\\.`, G = `\\b|${r.join("|")}`, Y = {
      className: "number",
      relevance: 0,
      variants: [
        // exponentfloat, pointfloat
        // https://docs.python.org/3.9/reference/lexical_analysis.html#floating-point-literals
        // optionally imaginary
        // https://docs.python.org/3.9/reference/lexical_analysis.html#imaginary-literals
        // Note: no leading \b because floats can start with a decimal point
        // and we don't want to mishandle e.g. `fn(.5)`,
        // no trailing \b for pointfloat because it can end with a decimal point
        // and we don't want to mishandle e.g. `0..hex()`; this should be safe
        // because both MUST contain a decimal point and so cannot be confused with
        // the interior part of an identifier
        {
          begin: `(\\b(${x})|(${L}))[eE][+-]?(${x})[jJ]?(?=${G})`
        },
        {
          begin: `(${L})[jJ]?`
        },
        // decinteger, bininteger, octinteger, hexinteger
        // https://docs.python.org/3.9/reference/lexical_analysis.html#integer-literals
        // optionally "long" in Python 2
        // https://docs.python.org/2.7/reference/lexical_analysis.html#integer-and-long-integer-literals
        // decinteger is optionally imaginary
        // https://docs.python.org/3.9/reference/lexical_analysis.html#imaginary-literals
        {
          begin: `\\b([1-9](_?[0-9])*|0+(_?0)*)[lLjJ]?(?=${G})`
        },
        {
          begin: `\\b0[bB](_?[01])+[lL]?(?=${G})`
        },
        {
          begin: `\\b0[oO](_?[0-7])+[lL]?(?=${G})`
        },
        {
          begin: `\\b0[xX](_?[0-9a-fA-F])+[lL]?(?=${G})`
        },
        // imagnumber (digitpart-based)
        // https://docs.python.org/3.9/reference/lexical_analysis.html#imaginary-literals
        {
          begin: `\\b(${x})[jJ](?=${G})`
        }
      ]
    }, k = {
      className: "comment",
      begin: o.lookahead(/# type:/),
      end: /$/,
      keywords: S,
      contains: [
        {
          // prevent keywords from coloring `type`
          begin: /# type:/
        },
        // comment within a datatype comment includes no keywords
        {
          begin: /#/,
          end: /\b\B/,
          endsWithParent: !0
        }
      ]
    }, W = {
      className: "params",
      variants: [
        // Exclude params in functions without params
        {
          className: "",
          begin: /\(\s*\)/,
          skip: !0
        },
        {
          begin: /\(/,
          end: /\)/,
          excludeBegin: !0,
          excludeEnd: !0,
          keywords: S,
          contains: [
            "self",
            C,
            Y,
            D,
            i.HASH_COMMENT_MODE
          ]
        }
      ]
    };
    return O.contains = [
      D,
      Y,
      C
    ], {
      name: "Python",
      aliases: [
        "py",
        "gyp",
        "ipython"
      ],
      unicodeRegex: !0,
      keywords: S,
      illegal: /(<\/|\?)|=>/,
      contains: [
        C,
        Y,
        {
          // very common convention
          begin: /\bself\b/
        },
        {
          // eat "if" prior to string so that it won't accidentally be
          // labeled as an f-string
          beginKeywords: "if",
          relevance: 0
        },
        D,
        k,
        i.HASH_COMMENT_MODE,
        {
          match: [
            /\bdef/,
            /\s+/,
            c
          ],
          scope: {
            1: "keyword",
            3: "title.function"
          },
          contains: [W]
        },
        {
          variants: [
            {
              match: [
                /\bclass/,
                /\s+/,
                c,
                /\s*/,
                /\(\s*/,
                c,
                /\s*\)/
              ]
            },
            {
              match: [
                /\bclass/,
                /\s+/,
                c
              ]
            }
          ],
          scope: {
            1: "keyword",
            3: "title.class",
            6: "title.class.inherited"
          }
        },
        {
          className: "meta",
          begin: /^[\t ]*@/,
          end: /(?=#)|$/,
          contains: [
            Y,
            W,
            D
          ]
        }
      ]
    };
  }
  return W_ = s, W_;
}
var z_, bT;
function Ik() {
  if (bT)
    return z_;
  bT = 1;
  function s(i) {
    return {
      aliases: ["pycon"],
      contains: [
        {
          className: "meta.prompt",
          starts: {
            // a space separates the REPL prefix from the actual code
            // this is purely for cleaner HTML output
            end: / |$/,
            starts: {
              end: "$",
              subLanguage: "python"
            }
          },
          variants: [
            { begin: /^>>>(?=[ ]|$)/ },
            { begin: /^\.\.\.(?=[ ]|$)/ }
          ]
        }
      ]
    };
  }
  return z_ = s, z_;
}
var K_, TT;
function Dk() {
  if (TT)
    return K_;
  TT = 1;
  function s(i) {
    return {
      name: "Q",
      aliases: [
        "k",
        "kdb"
      ],
      keywords: {
        $pattern: /(`?)[A-Za-z0-9_]+\b/,
        keyword: "do while select delete by update from",
        literal: "0b 1b",
        built_in: "neg not null string reciprocal floor ceiling signum mod xbar xlog and or each scan over prior mmu lsq inv md5 ltime gtime count first var dev med cov cor all any rand sums prds mins maxs fills deltas ratios avgs differ prev next rank reverse iasc idesc asc desc msum mcount mavg mdev xrank mmin mmax xprev rotate distinct group where flip type key til get value attr cut set upsert raze union inter except cross sv vs sublist enlist read0 read1 hopen hclose hdel hsym hcount peach system ltrim rtrim trim lower upper ssr view tables views cols xcols keys xkey xcol xasc xdesc fkeys meta lj aj aj0 ij pj asof uj ww wj wj1 fby xgroup ungroup ej save load rsave rload show csv parse eval min max avg wavg wsum sin cos tan sum",
        type: "`float `double int `timestamp `timespan `datetime `time `boolean `symbol `char `byte `short `long `real `month `date `minute `second `guid"
      },
      contains: [
        i.C_LINE_COMMENT_MODE,
        i.QUOTE_STRING_MODE,
        i.C_NUMBER_MODE
      ]
    };
  }
  return K_ = s, K_;
}
var Q_, vT;
function wk() {
  if (vT)
    return Q_;
  vT = 1;
  function s(i) {
    const o = i.regex, c = {
      keyword: "in of on if for while finally var new function do return void else break catch instanceof with throw case default try this switch continue typeof delete let yield const export super debugger as async await import",
      literal: "true false null undefined NaN Infinity",
      built_in: "eval isFinite isNaN parseFloat parseInt decodeURI decodeURIComponent encodeURI encodeURIComponent escape unescape Object Function Boolean Error EvalError InternalError RangeError ReferenceError StopIteration SyntaxError TypeError URIError Number Math Date String RegExp Array Float32Array Float64Array Int16Array Int32Array Int8Array Uint16Array Uint32Array Uint8Array Uint8ClampedArray ArrayBuffer DataView JSON Intl arguments require module console window document Symbol Set Map WeakSet WeakMap Proxy Reflect Behavior bool color coordinate date double enumeration font geocircle georectangle geoshape int list matrix4x4 parent point quaternion real rect size string url variant vector2d vector3d vector4d Promise"
    }, r = "[a-zA-Z_][a-zA-Z0-9\\._]*", e = {
      className: "keyword",
      begin: "\\bproperty\\b",
      starts: {
        className: "string",
        end: "(:|=|;|,|//|/\\*|$)",
        returnEnd: !0
      }
    }, g = {
      className: "keyword",
      begin: "\\bsignal\\b",
      starts: {
        className: "string",
        end: "(\\(|:|=|;|,|//|/\\*|$)",
        returnEnd: !0
      }
    }, h = {
      className: "attribute",
      begin: "\\bid\\s*:",
      starts: {
        className: "string",
        end: r,
        returnEnd: !1
      }
    }, S = {
      begin: r + "\\s*:",
      returnBegin: !0,
      contains: [
        {
          className: "attribute",
          begin: r,
          end: "\\s*:",
          excludeEnd: !0,
          relevance: 0
        }
      ],
      relevance: 0
    }, C = {
      begin: o.concat(r, /\s*\{/),
      end: /\{/,
      returnBegin: !0,
      relevance: 0,
      contains: [i.inherit(i.TITLE_MODE, { begin: r })]
    };
    return {
      name: "QML",
      aliases: ["qt"],
      case_insensitive: !1,
      keywords: c,
      contains: [
        {
          className: "meta",
          begin: /^\s*['"]use (strict|asm)['"]/
        },
        i.APOS_STRING_MODE,
        i.QUOTE_STRING_MODE,
        {
          // template string
          className: "string",
          begin: "`",
          end: "`",
          contains: [
            i.BACKSLASH_ESCAPE,
            {
              className: "subst",
              begin: "\\$\\{",
              end: "\\}"
            }
          ]
        },
        i.C_LINE_COMMENT_MODE,
        i.C_BLOCK_COMMENT_MODE,
        {
          className: "number",
          variants: [
            { begin: "\\b(0[bB][01]+)" },
            { begin: "\\b(0[oO][0-7]+)" },
            { begin: i.C_NUMBER_RE }
          ],
          relevance: 0
        },
        {
          // "value" container
          begin: "(" + i.RE_STARTERS_RE + "|\\b(case|return|throw)\\b)\\s*",
          keywords: "return throw case",
          contains: [
            i.C_LINE_COMMENT_MODE,
            i.C_BLOCK_COMMENT_MODE,
            i.REGEXP_MODE,
            {
              // E4X / JSX
              begin: /</,
              end: />\s*[);\]]/,
              relevance: 0,
              subLanguage: "xml"
            }
          ],
          relevance: 0
        },
        g,
        e,
        {
          className: "function",
          beginKeywords: "function",
          end: /\{/,
          excludeEnd: !0,
          contains: [
            i.inherit(i.TITLE_MODE, { begin: /[A-Za-z$_][0-9A-Za-z$_]*/ }),
            {
              className: "params",
              begin: /\(/,
              end: /\)/,
              excludeBegin: !0,
              excludeEnd: !0,
              contains: [
                i.C_LINE_COMMENT_MODE,
                i.C_BLOCK_COMMENT_MODE
              ]
            }
          ],
          illegal: /\[|%/
        },
        {
          // hack: prevents detection of keywords after dots
          begin: "\\." + i.IDENT_RE,
          relevance: 0
        },
        h,
        S,
        C
      ],
      illegal: /#/
    };
  }
  return Q_ = s, Q_;
}
var X_, CT;
function xk() {
  if (CT)
    return X_;
  CT = 1;
  function s(i) {
    const o = i.regex, c = /(?:(?:[a-zA-Z]|\.[._a-zA-Z])[._a-zA-Z0-9]*)|\.(?!\d)/, r = o.either(
      // Special case: only hexadecimal binary powers can contain fractions
      /0[xX][0-9a-fA-F]+\.[0-9a-fA-F]*[pP][+-]?\d+i?/,
      // Hexadecimal numbers without fraction and optional binary power
      /0[xX][0-9a-fA-F]+(?:[pP][+-]?\d+)?[Li]?/,
      // Decimal numbers
      /(?:\d+(?:\.\d*)?|\.\d+)(?:[eE][+-]?\d+)?[Li]?/
    ), e = /[=!<>:]=|\|\||&&|:::?|<-|<<-|->>|->|\|>|[-+*\/?!$&|:<=>@^~]|\*\*/, g = o.either(
      /[()]/,
      /[{}]/,
      /\[\[/,
      /[[\]]/,
      /\\/,
      /,/
    );
    return {
      name: "R",
      keywords: {
        $pattern: c,
        keyword: "function if in break next repeat else for while",
        literal: "NULL NA TRUE FALSE Inf NaN NA_integer_|10 NA_real_|10 NA_character_|10 NA_complex_|10",
        built_in: (
          // Builtin constants
          "LETTERS letters month.abb month.name pi T F abs acos acosh all any anyNA Arg as.call as.character as.complex as.double as.environment as.integer as.logical as.null.default as.numeric as.raw asin asinh atan atanh attr attributes baseenv browser c call ceiling class Conj cos cosh cospi cummax cummin cumprod cumsum digamma dim dimnames emptyenv exp expression floor forceAndCall gamma gc.time globalenv Im interactive invisible is.array is.atomic is.call is.character is.complex is.double is.environment is.expression is.finite is.function is.infinite is.integer is.language is.list is.logical is.matrix is.na is.name is.nan is.null is.numeric is.object is.pairlist is.raw is.recursive is.single is.symbol lazyLoadDBfetch length lgamma list log max min missing Mod names nargs nzchar oldClass on.exit pos.to.env proc.time prod quote range Re rep retracemem return round seq_along seq_len seq.int sign signif sin sinh sinpi sqrt standardGeneric substitute sum switch tan tanh tanpi tracemem trigamma trunc unclass untracemem UseMethod xtfrm"
        )
      },
      contains: [
        // Roxygen comments
        i.COMMENT(
          /#'/,
          /$/,
          { contains: [
            {
              // Handle `@examples` separately to cause all subsequent code
              // until the next `@`-tag on its own line to be kept as-is,
              // preventing highlighting. This code is example R code, so nested
              // doctags shouldn’t be treated as such. See
              // `test/markup/r/roxygen.txt` for an example.
              scope: "doctag",
              match: /@examples/,
              starts: {
                end: o.lookahead(o.either(
                  // end if another doc comment
                  /\n^#'\s*(?=@[a-zA-Z]+)/,
                  // or a line with no comment
                  /\n^(?!#')/
                )),
                endsParent: !0
              }
            },
            {
              // Handle `@param` to highlight the parameter name following
              // after.
              scope: "doctag",
              begin: "@param",
              end: /$/,
              contains: [
                {
                  scope: "variable",
                  variants: [
                    { match: c },
                    { match: /`(?:\\.|[^`\\])+`/ }
                  ],
                  endsParent: !0
                }
              ]
            },
            {
              scope: "doctag",
              match: /@[a-zA-Z]+/
            },
            {
              scope: "keyword",
              match: /\\[a-zA-Z]+/
            }
          ] }
        ),
        i.HASH_COMMENT_MODE,
        {
          scope: "string",
          contains: [i.BACKSLASH_ESCAPE],
          variants: [
            i.END_SAME_AS_BEGIN({
              begin: /[rR]"(-*)\(/,
              end: /\)(-*)"/
            }),
            i.END_SAME_AS_BEGIN({
              begin: /[rR]"(-*)\{/,
              end: /\}(-*)"/
            }),
            i.END_SAME_AS_BEGIN({
              begin: /[rR]"(-*)\[/,
              end: /\](-*)"/
            }),
            i.END_SAME_AS_BEGIN({
              begin: /[rR]'(-*)\(/,
              end: /\)(-*)'/
            }),
            i.END_SAME_AS_BEGIN({
              begin: /[rR]'(-*)\{/,
              end: /\}(-*)'/
            }),
            i.END_SAME_AS_BEGIN({
              begin: /[rR]'(-*)\[/,
              end: /\](-*)'/
            }),
            {
              begin: '"',
              end: '"',
              relevance: 0
            },
            {
              begin: "'",
              end: "'",
              relevance: 0
            }
          ]
        },
        // Matching numbers immediately following punctuation and operators is
        // tricky since we need to look at the character ahead of a number to
        // ensure the number is not part of an identifier, and we cannot use
        // negative look-behind assertions. So instead we explicitly handle all
        // possible combinations of (operator|punctuation), number.
        // TODO: replace with negative look-behind when available
        // { begin: /(?<![a-zA-Z0-9._])0[xX][0-9a-fA-F]+\.[0-9a-fA-F]*[pP][+-]?\d+i?/ },
        // { begin: /(?<![a-zA-Z0-9._])0[xX][0-9a-fA-F]+([pP][+-]?\d+)?[Li]?/ },
        // { begin: /(?<![a-zA-Z0-9._])(\d+(\.\d*)?|\.\d+)([eE][+-]?\d+)?[Li]?/ }
        {
          relevance: 0,
          variants: [
            {
              scope: {
                1: "operator",
                2: "number"
              },
              match: [
                e,
                r
              ]
            },
            {
              scope: {
                1: "operator",
                2: "number"
              },
              match: [
                /%[^%]*%/,
                r
              ]
            },
            {
              scope: {
                1: "punctuation",
                2: "number"
              },
              match: [
                g,
                r
              ]
            },
            {
              scope: { 2: "number" },
              match: [
                /[^a-zA-Z0-9._]|^/,
                // not part of an identifier, or start of document
                r
              ]
            }
          ]
        },
        // Operators/punctuation when they're not directly followed by numbers
        {
          // Relevance boost for the most common assignment form.
          scope: { 3: "operator" },
          match: [
            c,
            /\s+/,
            /<-/,
            /\s+/
          ]
        },
        {
          scope: "operator",
          relevance: 0,
          variants: [
            { match: e },
            { match: /%[^%]*%/ }
          ]
        },
        {
          scope: "punctuation",
          relevance: 0,
          match: g
        },
        {
          // Escaped identifier
          begin: "`",
          end: "`",
          contains: [{ begin: /\\./ }]
        }
      ]
    };
  }
  return X_ = s, X_;
}
var Z_, RT;
function Lk() {
  if (RT)
    return Z_;
  RT = 1;
  function s(i) {
    return {
      name: "ReasonML",
      aliases: ["re"],
      keywords: {
        $pattern: /[a-z_]\w*!?/,
        keyword: [
          "and",
          "as",
          "asr",
          "assert",
          "begin",
          "class",
          "constraint",
          "do",
          "done",
          "downto",
          "else",
          "end",
          "esfun",
          "exception",
          "external",
          "for",
          "fun",
          "function",
          "functor",
          "if",
          "in",
          "include",
          "inherit",
          "initializer",
          "land",
          "lazy",
          "let",
          "lor",
          "lsl",
          "lsr",
          "lxor",
          "mod",
          "module",
          "mutable",
          "new",
          "nonrec",
          "object",
          "of",
          "open",
          "or",
          "pri",
          "pub",
          "rec",
          "sig",
          "struct",
          "switch",
          "then",
          "to",
          "try",
          "type",
          "val",
          "virtual",
          "when",
          "while",
          "with"
        ],
        built_in: [
          "array",
          "bool",
          "bytes",
          "char",
          "exn|5",
          "float",
          "int",
          "int32",
          "int64",
          "list",
          "lazy_t|5",
          "nativeint|5",
          "ref",
          "string",
          "unit"
        ],
        literal: ["true", "false"]
      },
      illegal: /(:-|:=|\$\{|\+=)/,
      contains: [
        {
          scope: "literal",
          match: /\[(\|\|)?\]|\(\)/,
          relevance: 0
        },
        i.C_LINE_COMMENT_MODE,
        i.COMMENT(/\/\*/, /\*\//, { illegal: /^(#,\/\/)/ }),
        {
          /* type variable */
          scope: "symbol",
          match: /\'[A-Za-z_](?!\')[\w\']*/
          /* the grammar is ambiguous on how 'a'b should be interpreted but not the compiler */
        },
        {
          /* polymorphic variant */
          scope: "type",
          match: /`[A-Z][\w\']*/
        },
        {
          /* module or constructor */
          scope: "type",
          match: /\b[A-Z][\w\']*/,
          relevance: 0
        },
        {
          /* don't color identifiers, but safely catch all identifiers with ' */
          match: /[a-z_]\w*\'[\w\']*/,
          relevance: 0
        },
        {
          scope: "operator",
          match: /\s+(\|\||\+[\+\.]?|\*[\*\/\.]?|\/[\.]?|\.\.\.|\|>|&&|===?)\s+/,
          relevance: 0
        },
        i.inherit(i.APOS_STRING_MODE, {
          scope: "string",
          relevance: 0
        }),
        i.inherit(i.QUOTE_STRING_MODE, { illegal: null }),
        {
          scope: "number",
          variants: [
            { match: /\b0[xX][a-fA-F0-9_]+[Lln]?/ },
            { match: /\b0[oO][0-7_]+[Lln]?/ },
            { match: /\b0[bB][01_]+[Lln]?/ },
            { match: /\b[0-9][0-9_]*([Lln]|(\.[0-9_]*)?([eE][-+]?[0-9_]+)?)/ }
          ],
          relevance: 0
        }
      ]
    };
  }
  return Z_ = s, Z_;
}
var j_, NT;
function Mk() {
  if (NT)
    return j_;
  NT = 1;
  function s(i) {
    return {
      name: "RenderMan RIB",
      keywords: "ArchiveRecord AreaLightSource Atmosphere Attribute AttributeBegin AttributeEnd Basis Begin Blobby Bound Clipping ClippingPlane Color ColorSamples ConcatTransform Cone CoordinateSystem CoordSysTransform CropWindow Curves Cylinder DepthOfField Detail DetailRange Disk Displacement Display End ErrorHandler Exposure Exterior Format FrameAspectRatio FrameBegin FrameEnd GeneralPolygon GeometricApproximation Geometry Hider Hyperboloid Identity Illuminate Imager Interior LightSource MakeCubeFaceEnvironment MakeLatLongEnvironment MakeShadow MakeTexture Matte MotionBegin MotionEnd NuPatch ObjectBegin ObjectEnd ObjectInstance Opacity Option Orientation Paraboloid Patch PatchMesh Perspective PixelFilter PixelSamples PixelVariance Points PointsGeneralPolygons PointsPolygons Polygon Procedural Projection Quantize ReadArchive RelativeDetail ReverseOrientation Rotate Scale ScreenWindow ShadingInterpolation ShadingRate Shutter Sides Skew SolidBegin SolidEnd Sphere SubdivisionMesh Surface TextureCoordinates Torus Transform TransformBegin TransformEnd TransformPoints Translate TrimCurve WorldBegin WorldEnd",
      illegal: "</",
      contains: [
        i.HASH_COMMENT_MODE,
        i.C_NUMBER_MODE,
        i.APOS_STRING_MODE,
        i.QUOTE_STRING_MODE
      ]
    };
  }
  return j_ = s, j_;
}
var J_, AT;
function Pk() {
  if (AT)
    return J_;
  AT = 1;
  function s(i) {
    const o = "[a-zA-Z-_][^\\n{]+\\{", c = {
      className: "attribute",
      begin: /[a-zA-Z-_]+/,
      end: /\s*:/,
      excludeEnd: !0,
      starts: {
        end: ";",
        relevance: 0,
        contains: [
          {
            className: "variable",
            begin: /\.[a-zA-Z-_]+/
          },
          {
            className: "keyword",
            begin: /\(optional\)/
          }
        ]
      }
    };
    return {
      name: "Roboconf",
      aliases: [
        "graph",
        "instances"
      ],
      case_insensitive: !0,
      keywords: "import",
      contains: [
        // Facet sections
        {
          begin: "^facet " + o,
          end: /\}/,
          keywords: "facet",
          contains: [
            c,
            i.HASH_COMMENT_MODE
          ]
        },
        // Instance sections
        {
          begin: "^\\s*instance of " + o,
          end: /\}/,
          keywords: "name count channels instance-data instance-state instance of",
          illegal: /\S/,
          contains: [
            "self",
            c,
            i.HASH_COMMENT_MODE
          ]
        },
        // Component sections
        {
          begin: "^" + o,
          end: /\}/,
          contains: [
            c,
            i.HASH_COMMENT_MODE
          ]
        },
        // Comments
        i.HASH_COMMENT_MODE
      ]
    };
  }
  return J_ = s, J_;
}
var ep, OT;
function kk() {
  if (OT)
    return ep;
  OT = 1;
  function s(i) {
    const o = "foreach do while for if from to step else on-error and or not in", c = "global local beep delay put len typeof pick log time set find environment terminal error execute parse resolve toarray tobool toid toip toip6 tonum tostr totime", r = "add remove enable disable set get print export edit find run debug error info warning", e = "true false yes no nothing nil null", g = "traffic-flow traffic-generator firewall scheduler aaa accounting address-list address align area bandwidth-server bfd bgp bridge client clock community config connection console customer default dhcp-client dhcp-server discovery dns e-mail ethernet filter firmware gps graphing group hardware health hotspot identity igmp-proxy incoming instance interface ip ipsec ipv6 irq l2tp-server lcd ldp logging mac-server mac-winbox mangle manual mirror mme mpls nat nd neighbor network note ntp ospf ospf-v3 ovpn-server page peer pim ping policy pool port ppp pppoe-client pptp-server prefix profile proposal proxy queue radius resource rip ripng route routing screen script security-profiles server service service-port settings shares smb sms sniffer snmp snooper socks sstp-server system tool tracking type upgrade upnp user-manager users user vlan secret vrrp watchdog web-access wireless pptp pppoe lan wan layer7-protocol lease simple raw", h = {
      className: "variable",
      variants: [
        { begin: /\$[\w\d#@][\w\d_]*/ },
        { begin: /\$\{(.*?)\}/ }
      ]
    }, S = {
      className: "string",
      begin: /"/,
      end: /"/,
      contains: [
        i.BACKSLASH_ESCAPE,
        h,
        {
          className: "variable",
          begin: /\$\(/,
          end: /\)/,
          contains: [i.BACKSLASH_ESCAPE]
        }
      ]
    }, C = {
      className: "string",
      begin: /'/,
      end: /'/
    };
    return {
      name: "MikroTik RouterOS script",
      aliases: ["mikrotik"],
      case_insensitive: !0,
      keywords: {
        $pattern: /:?[\w-]+/,
        literal: e,
        keyword: o + " :" + o.split(" ").join(" :") + " :" + c.split(" ").join(" :")
      },
      contains: [
        {
          // illegal syntax
          variants: [
            {
              // -- comment
              begin: /\/\*/,
              end: /\*\//
            },
            {
              // Stan comment
              begin: /\/\//,
              end: /$/
            },
            {
              // HTML tags
              begin: /<\//,
              end: />/
            }
          ],
          illegal: /./
        },
        i.COMMENT("^#", "$"),
        S,
        C,
        h,
        // attribute=value
        {
          // > is to avoid matches with => in other grammars
          begin: /[\w-]+=([^\s{}[\]()>]+)/,
          relevance: 0,
          returnBegin: !0,
          contains: [
            {
              className: "attribute",
              begin: /[^=]+/
            },
            {
              begin: /=/,
              endsWithParent: !0,
              relevance: 0,
              contains: [
                S,
                C,
                h,
                {
                  className: "literal",
                  begin: "\\b(" + e.split(" ").join("|") + ")\\b"
                },
                {
                  // Do not format unclassified values. Needed to exclude highlighting of values as built_in.
                  begin: /("[^"]*"|[^\s{}[\]]+)/
                }
                /*
                {
                  // IPv4 addresses and subnets
                  className: 'number',
                  variants: [
                    {begin: IPADDR_wBITMASK+'(,'+IPADDR_wBITMASK+')*'}, //192.168.0.0/24,1.2.3.0/24
                    {begin: IPADDR+'-'+IPADDR},       // 192.168.0.1-192.168.0.3
                    {begin: IPADDR+'(,'+IPADDR+')*'}, // 192.168.0.1,192.168.0.34,192.168.24.1,192.168.0.1
                  ]
                },
                {
                  // MAC addresses and DHCP Client IDs
                  className: 'number',
                  begin: /\b(1:)?([0-9A-Fa-f]{1,2}[:-]){5}([0-9A-Fa-f]){1,2}\b/,
                },
                */
              ]
            }
          ]
        },
        {
          // HEX values
          className: "number",
          begin: /\*[0-9a-fA-F]+/
        },
        {
          begin: "\\b(" + r.split(" ").join("|") + ")([\\s[(\\]|])",
          returnBegin: !0,
          contains: [
            {
              className: "built_in",
              // 'function',
              begin: /\w+/
            }
          ]
        },
        {
          className: "built_in",
          variants: [
            { begin: "(\\.\\./|/|\\s)((" + g.split(" ").join("|") + ");?\\s)+" },
            {
              begin: /\.\./,
              relevance: 0
            }
          ]
        }
      ]
    };
  }
  return ep = s, ep;
}
var tp, yT;
function Fk() {
  if (yT)
    return tp;
  yT = 1;
  function s(i) {
    const o = [
      "abs",
      "acos",
      "ambient",
      "area",
      "asin",
      "atan",
      "atmosphere",
      "attribute",
      "calculatenormal",
      "ceil",
      "cellnoise",
      "clamp",
      "comp",
      "concat",
      "cos",
      "degrees",
      "depth",
      "Deriv",
      "diffuse",
      "distance",
      "Du",
      "Dv",
      "environment",
      "exp",
      "faceforward",
      "filterstep",
      "floor",
      "format",
      "fresnel",
      "incident",
      "length",
      "lightsource",
      "log",
      "match",
      "max",
      "min",
      "mod",
      "noise",
      "normalize",
      "ntransform",
      "opposite",
      "option",
      "phong",
      "pnoise",
      "pow",
      "printf",
      "ptlined",
      "radians",
      "random",
      "reflect",
      "refract",
      "renderinfo",
      "round",
      "setcomp",
      "setxcomp",
      "setycomp",
      "setzcomp",
      "shadow",
      "sign",
      "sin",
      "smoothstep",
      "specular",
      "specularbrdf",
      "spline",
      "sqrt",
      "step",
      "tan",
      "texture",
      "textureinfo",
      "trace",
      "transform",
      "vtransform",
      "xcomp",
      "ycomp",
      "zcomp"
    ], c = [
      "matrix",
      "float",
      "color",
      "point",
      "normal",
      "vector"
    ], r = [
      "while",
      "for",
      "if",
      "do",
      "return",
      "else",
      "break",
      "extern",
      "continue"
    ], e = {
      match: [
        /(surface|displacement|light|volume|imager)/,
        /\s+/,
        i.IDENT_RE
      ],
      scope: {
        1: "keyword",
        3: "title.class"
      }
    };
    return {
      name: "RenderMan RSL",
      keywords: {
        keyword: r,
        built_in: o,
        type: c
      },
      illegal: "</",
      contains: [
        i.C_LINE_COMMENT_MODE,
        i.C_BLOCK_COMMENT_MODE,
        i.QUOTE_STRING_MODE,
        i.APOS_STRING_MODE,
        i.C_NUMBER_MODE,
        {
          className: "meta",
          begin: "#",
          end: "$"
        },
        e,
        {
          beginKeywords: "illuminate illuminance gather",
          end: "\\("
        }
      ]
    };
  }
  return tp = s, tp;
}
var rp, IT;
function Uk() {
  if (IT)
    return rp;
  IT = 1;
  function s(i) {
    return {
      name: "Oracle Rules Language",
      keywords: {
        keyword: "BILL_PERIOD BILL_START BILL_STOP RS_EFFECTIVE_START RS_EFFECTIVE_STOP RS_JURIS_CODE RS_OPCO_CODE INTDADDATTRIBUTE|5 INTDADDVMSG|5 INTDBLOCKOP|5 INTDBLOCKOPNA|5 INTDCLOSE|5 INTDCOUNT|5 INTDCOUNTSTATUSCODE|5 INTDCREATEMASK|5 INTDCREATEDAYMASK|5 INTDCREATEFACTORMASK|5 INTDCREATEHANDLE|5 INTDCREATEOVERRIDEDAYMASK|5 INTDCREATEOVERRIDEMASK|5 INTDCREATESTATUSCODEMASK|5 INTDCREATETOUPERIOD|5 INTDDELETE|5 INTDDIPTEST|5 INTDEXPORT|5 INTDGETERRORCODE|5 INTDGETERRORMESSAGE|5 INTDISEQUAL|5 INTDJOIN|5 INTDLOAD|5 INTDLOADACTUALCUT|5 INTDLOADDATES|5 INTDLOADHIST|5 INTDLOADLIST|5 INTDLOADLISTDATES|5 INTDLOADLISTENERGY|5 INTDLOADLISTHIST|5 INTDLOADRELATEDCHANNEL|5 INTDLOADSP|5 INTDLOADSTAGING|5 INTDLOADUOM|5 INTDLOADUOMDATES|5 INTDLOADUOMHIST|5 INTDLOADVERSION|5 INTDOPEN|5 INTDREADFIRST|5 INTDREADNEXT|5 INTDRECCOUNT|5 INTDRELEASE|5 INTDREPLACE|5 INTDROLLAVG|5 INTDROLLPEAK|5 INTDSCALAROP|5 INTDSCALE|5 INTDSETATTRIBUTE|5 INTDSETDSTPARTICIPANT|5 INTDSETSTRING|5 INTDSETVALUE|5 INTDSETVALUESTATUS|5 INTDSHIFTSTARTTIME|5 INTDSMOOTH|5 INTDSORT|5 INTDSPIKETEST|5 INTDSUBSET|5 INTDTOU|5 INTDTOURELEASE|5 INTDTOUVALUE|5 INTDUPDATESTATS|5 INTDVALUE|5 STDEV INTDDELETEEX|5 INTDLOADEXACTUAL|5 INTDLOADEXCUT|5 INTDLOADEXDATES|5 INTDLOADEX|5 INTDLOADEXRELATEDCHANNEL|5 INTDSAVEEX|5 MVLOAD|5 MVLOADACCT|5 MVLOADACCTDATES|5 MVLOADACCTHIST|5 MVLOADDATES|5 MVLOADHIST|5 MVLOADLIST|5 MVLOADLISTDATES|5 MVLOADLISTHIST|5 IF FOR NEXT DONE SELECT END CALL ABORT CLEAR CHANNEL FACTOR LIST NUMBER OVERRIDE SET WEEK DISTRIBUTIONNODE ELSE WHEN THEN OTHERWISE IENUM CSV INCLUDE LEAVE RIDER SAVE DELETE NOVALUE SECTION WARN SAVE_UPDATE DETERMINANT LABEL REPORT REVENUE EACH IN FROM TOTAL CHARGE BLOCK AND OR CSV_FILE RATE_CODE AUXILIARY_DEMAND UIDACCOUNT RS BILL_PERIOD_SELECT HOURS_PER_MONTH INTD_ERROR_STOP SEASON_SCHEDULE_NAME ACCOUNTFACTOR ARRAYUPPERBOUND CALLSTOREDPROC GETADOCONNECTION GETCONNECT GETDATASOURCE GETQUALIFIER GETUSERID HASVALUE LISTCOUNT LISTOP LISTUPDATE LISTVALUE PRORATEFACTOR RSPRORATE SETBINPATH SETDBMONITOR WQ_OPEN BILLINGHOURS DATE DATEFROMFLOAT DATETIMEFROMSTRING DATETIMETOSTRING DATETOFLOAT DAY DAYDIFF DAYNAME DBDATETIME HOUR MINUTE MONTH MONTHDIFF MONTHHOURS MONTHNAME ROUNDDATE SAMEWEEKDAYLASTYEAR SECOND WEEKDAY WEEKDIFF YEAR YEARDAY YEARSTR COMPSUM HISTCOUNT HISTMAX HISTMIN HISTMINNZ HISTVALUE MAXNRANGE MAXRANGE MINRANGE COMPIKVA COMPKVA COMPKVARFROMKQKW COMPLF IDATTR FLAG LF2KW LF2KWH MAXKW POWERFACTOR READING2USAGE AVGSEASON MAXSEASON MONTHLYMERGE SEASONVALUE SUMSEASON ACCTREADDATES ACCTTABLELOAD CONFIGADD CONFIGGET CREATEOBJECT CREATEREPORT EMAILCLIENT EXPBLKMDMUSAGE EXPMDMUSAGE EXPORT_USAGE FACTORINEFFECT GETUSERSPECIFIEDSTOP INEFFECT ISHOLIDAY RUNRATE SAVE_PROFILE SETREPORTTITLE USEREXIT WATFORRUNRATE TO TABLE ACOS ASIN ATAN ATAN2 BITAND CEIL COS COSECANT COSH COTANGENT DIVQUOT DIVREM EXP FABS FLOOR FMOD FREPM FREXPN LOG LOG10 MAX MAXN MIN MINNZ MODF POW ROUND ROUND2VALUE ROUNDINT SECANT SIN SINH SQROOT TAN TANH FLOAT2STRING FLOAT2STRINGNC INSTR LEFT LEN LTRIM MID RIGHT RTRIM STRING STRINGNC TOLOWER TOUPPER TRIM NUMDAYS READ_DATE STAGING",
        built_in: "IDENTIFIER OPTIONS XML_ELEMENT XML_OP XML_ELEMENT_OF DOMDOCCREATE DOMDOCLOADFILE DOMDOCLOADXML DOMDOCSAVEFILE DOMDOCGETROOT DOMDOCADDPI DOMNODEGETNAME DOMNODEGETTYPE DOMNODEGETVALUE DOMNODEGETCHILDCT DOMNODEGETFIRSTCHILD DOMNODEGETSIBLING DOMNODECREATECHILDELEMENT DOMNODESETATTRIBUTE DOMNODEGETCHILDELEMENTCT DOMNODEGETFIRSTCHILDELEMENT DOMNODEGETSIBLINGELEMENT DOMNODEGETATTRIBUTECT DOMNODEGETATTRIBUTEI DOMNODEGETATTRIBUTEBYNAME DOMNODEGETBYNAME"
      },
      contains: [
        i.C_LINE_COMMENT_MODE,
        i.C_BLOCK_COMMENT_MODE,
        i.APOS_STRING_MODE,
        i.QUOTE_STRING_MODE,
        i.C_NUMBER_MODE,
        {
          className: "literal",
          variants: [
            {
              // looks like #-comment
              begin: "#\\s+",
              relevance: 0
            },
            { begin: "#[a-zA-Z .]+" }
          ]
        }
      ]
    };
  }
  return rp = s, rp;
}
var np, DT;
function Bk() {
  if (DT)
    return np;
  DT = 1;
  function s(i) {
    const o = i.regex, c = {
      className: "title.function.invoke",
      relevance: 0,
      begin: o.concat(
        /\b/,
        /(?!let|for|while|if|else|match\b)/,
        i.IDENT_RE,
        o.lookahead(/\s*\(/)
      )
    }, r = "([ui](8|16|32|64|128|size)|f(32|64))?", e = [
      "abstract",
      "as",
      "async",
      "await",
      "become",
      "box",
      "break",
      "const",
      "continue",
      "crate",
      "do",
      "dyn",
      "else",
      "enum",
      "extern",
      "false",
      "final",
      "fn",
      "for",
      "if",
      "impl",
      "in",
      "let",
      "loop",
      "macro",
      "match",
      "mod",
      "move",
      "mut",
      "override",
      "priv",
      "pub",
      "ref",
      "return",
      "self",
      "Self",
      "static",
      "struct",
      "super",
      "trait",
      "true",
      "try",
      "type",
      "typeof",
      "unsafe",
      "unsized",
      "use",
      "virtual",
      "where",
      "while",
      "yield"
    ], g = [
      "true",
      "false",
      "Some",
      "None",
      "Ok",
      "Err"
    ], h = [
      // functions
      "drop ",
      // traits
      "Copy",
      "Send",
      "Sized",
      "Sync",
      "Drop",
      "Fn",
      "FnMut",
      "FnOnce",
      "ToOwned",
      "Clone",
      "Debug",
      "PartialEq",
      "PartialOrd",
      "Eq",
      "Ord",
      "AsRef",
      "AsMut",
      "Into",
      "From",
      "Default",
      "Iterator",
      "Extend",
      "IntoIterator",
      "DoubleEndedIterator",
      "ExactSizeIterator",
      "SliceConcatExt",
      "ToString",
      // macros
      "assert!",
      "assert_eq!",
      "bitflags!",
      "bytes!",
      "cfg!",
      "col!",
      "concat!",
      "concat_idents!",
      "debug_assert!",
      "debug_assert_eq!",
      "env!",
      "eprintln!",
      "panic!",
      "file!",
      "format!",
      "format_args!",
      "include_bytes!",
      "include_str!",
      "line!",
      "local_data_key!",
      "module_path!",
      "option_env!",
      "print!",
      "println!",
      "select!",
      "stringify!",
      "try!",
      "unimplemented!",
      "unreachable!",
      "vec!",
      "write!",
      "writeln!",
      "macro_rules!",
      "assert_ne!",
      "debug_assert_ne!"
    ], S = [
      "i8",
      "i16",
      "i32",
      "i64",
      "i128",
      "isize",
      "u8",
      "u16",
      "u32",
      "u64",
      "u128",
      "usize",
      "f32",
      "f64",
      "str",
      "char",
      "bool",
      "Box",
      "Option",
      "Result",
      "String",
      "Vec"
    ];
    return {
      name: "Rust",
      aliases: ["rs"],
      keywords: {
        $pattern: i.IDENT_RE + "!?",
        type: S,
        keyword: e,
        literal: g,
        built_in: h
      },
      illegal: "</",
      contains: [
        i.C_LINE_COMMENT_MODE,
        i.COMMENT("/\\*", "\\*/", { contains: ["self"] }),
        i.inherit(i.QUOTE_STRING_MODE, {
          begin: /b?"/,
          illegal: null
        }),
        {
          className: "string",
          variants: [
            { begin: /b?r(#*)"(.|\n)*?"\1(?!#)/ },
            { begin: /b?'\\?(x\w{2}|u\w{4}|U\w{8}|.)'/ }
          ]
        },
        {
          className: "symbol",
          begin: /'[a-zA-Z_][a-zA-Z0-9_]*/
        },
        {
          className: "number",
          variants: [
            { begin: "\\b0b([01_]+)" + r },
            { begin: "\\b0o([0-7_]+)" + r },
            { begin: "\\b0x([A-Fa-f0-9_]+)" + r },
            { begin: "\\b(\\d[\\d_]*(\\.[0-9_]+)?([eE][+-]?[0-9_]+)?)" + r }
          ],
          relevance: 0
        },
        {
          begin: [
            /fn/,
            /\s+/,
            i.UNDERSCORE_IDENT_RE
          ],
          className: {
            1: "keyword",
            3: "title.function"
          }
        },
        {
          className: "meta",
          begin: "#!?\\[",
          end: "\\]",
          contains: [
            {
              className: "string",
              begin: /"/,
              end: /"/
            }
          ]
        },
        {
          begin: [
            /let/,
            /\s+/,
            /(?:mut\s+)?/,
            i.UNDERSCORE_IDENT_RE
          ],
          className: {
            1: "keyword",
            3: "keyword",
            4: "variable"
          }
        },
        // must come before impl/for rule later
        {
          begin: [
            /for/,
            /\s+/,
            i.UNDERSCORE_IDENT_RE,
            /\s+/,
            /in/
          ],
          className: {
            1: "keyword",
            3: "variable",
            5: "keyword"
          }
        },
        {
          begin: [
            /type/,
            /\s+/,
            i.UNDERSCORE_IDENT_RE
          ],
          className: {
            1: "keyword",
            3: "title.class"
          }
        },
        {
          begin: [
            /(?:trait|enum|struct|union|impl|for)/,
            /\s+/,
            i.UNDERSCORE_IDENT_RE
          ],
          className: {
            1: "keyword",
            3: "title.class"
          }
        },
        {
          begin: i.IDENT_RE + "::",
          keywords: {
            keyword: "Self",
            built_in: h,
            type: S
          }
        },
        {
          className: "punctuation",
          begin: "->"
        },
        c
      ]
    };
  }
  return np = s, np;
}
var ap, wT;
function Gk() {
  if (wT)
    return ap;
  wT = 1;
  function s(i) {
    const o = i.regex, c = [
      "do",
      "if",
      "then",
      "else",
      "end",
      "until",
      "while",
      "abort",
      "array",
      "attrib",
      "by",
      "call",
      "cards",
      "cards4",
      "catname",
      "continue",
      "datalines",
      "datalines4",
      "delete",
      "delim",
      "delimiter",
      "display",
      "dm",
      "drop",
      "endsas",
      "error",
      "file",
      "filename",
      "footnote",
      "format",
      "goto",
      "in",
      "infile",
      "informat",
      "input",
      "keep",
      "label",
      "leave",
      "length",
      "libname",
      "link",
      "list",
      "lostcard",
      "merge",
      "missing",
      "modify",
      "options",
      "output",
      "out",
      "page",
      "put",
      "redirect",
      "remove",
      "rename",
      "replace",
      "retain",
      "return",
      "select",
      "set",
      "skip",
      "startsas",
      "stop",
      "title",
      "update",
      "waitsas",
      "where",
      "window",
      "x|0",
      "systask",
      "add",
      "and",
      "alter",
      "as",
      "cascade",
      "check",
      "create",
      "delete",
      "describe",
      "distinct",
      "drop",
      "foreign",
      "from",
      "group",
      "having",
      "index",
      "insert",
      "into",
      "in",
      "key",
      "like",
      "message",
      "modify",
      "msgtype",
      "not",
      "null",
      "on",
      "or",
      "order",
      "primary",
      "references",
      "reset",
      "restrict",
      "select",
      "set",
      "table",
      "unique",
      "update",
      "validate",
      "view",
      "where"
    ], r = [
      "abs",
      "addr",
      "airy",
      "arcos",
      "arsin",
      "atan",
      "attrc",
      "attrn",
      "band",
      "betainv",
      "blshift",
      "bnot",
      "bor",
      "brshift",
      "bxor",
      "byte",
      "cdf",
      "ceil",
      "cexist",
      "cinv",
      "close",
      "cnonct",
      "collate",
      "compbl",
      "compound",
      "compress",
      "cos",
      "cosh",
      "css",
      "curobs",
      "cv",
      "daccdb",
      "daccdbsl",
      "daccsl",
      "daccsyd",
      "dacctab",
      "dairy",
      "date",
      "datejul",
      "datepart",
      "datetime",
      "day",
      "dclose",
      "depdb",
      "depdbsl",
      "depdbsl",
      "depsl",
      "depsl",
      "depsyd",
      "depsyd",
      "deptab",
      "deptab",
      "dequote",
      "dhms",
      "dif",
      "digamma",
      "dim",
      "dinfo",
      "dnum",
      "dopen",
      "doptname",
      "doptnum",
      "dread",
      "dropnote",
      "dsname",
      "erf",
      "erfc",
      "exist",
      "exp",
      "fappend",
      "fclose",
      "fcol",
      "fdelete",
      "fetch",
      "fetchobs",
      "fexist",
      "fget",
      "fileexist",
      "filename",
      "fileref",
      "finfo",
      "finv",
      "fipname",
      "fipnamel",
      "fipstate",
      "floor",
      "fnonct",
      "fnote",
      "fopen",
      "foptname",
      "foptnum",
      "fpoint",
      "fpos",
      "fput",
      "fread",
      "frewind",
      "frlen",
      "fsep",
      "fuzz",
      "fwrite",
      "gaminv",
      "gamma",
      "getoption",
      "getvarc",
      "getvarn",
      "hbound",
      "hms",
      "hosthelp",
      "hour",
      "ibessel",
      "index",
      "indexc",
      "indexw",
      "input",
      "inputc",
      "inputn",
      "int",
      "intck",
      "intnx",
      "intrr",
      "irr",
      "jbessel",
      "juldate",
      "kurtosis",
      "lag",
      "lbound",
      "left",
      "length",
      "lgamma",
      "libname",
      "libref",
      "log",
      "log10",
      "log2",
      "logpdf",
      "logpmf",
      "logsdf",
      "lowcase",
      "max",
      "mdy",
      "mean",
      "min",
      "minute",
      "mod",
      "month",
      "mopen",
      "mort",
      "n",
      "netpv",
      "nmiss",
      "normal",
      "note",
      "npv",
      "open",
      "ordinal",
      "pathname",
      "pdf",
      "peek",
      "peekc",
      "pmf",
      "point",
      "poisson",
      "poke",
      "probbeta",
      "probbnml",
      "probchi",
      "probf",
      "probgam",
      "probhypr",
      "probit",
      "probnegb",
      "probnorm",
      "probt",
      "put",
      "putc",
      "putn",
      "qtr",
      "quote",
      "ranbin",
      "rancau",
      "ranexp",
      "rangam",
      "range",
      "rank",
      "rannor",
      "ranpoi",
      "rantbl",
      "rantri",
      "ranuni",
      "repeat",
      "resolve",
      "reverse",
      "rewind",
      "right",
      "round",
      "saving",
      "scan",
      "sdf",
      "second",
      "sign",
      "sin",
      "sinh",
      "skewness",
      "soundex",
      "spedis",
      "sqrt",
      "std",
      "stderr",
      "stfips",
      "stname",
      "stnamel",
      "substr",
      "sum",
      "symget",
      "sysget",
      "sysmsg",
      "sysprod",
      "sysrc",
      "system",
      "tan",
      "tanh",
      "time",
      "timepart",
      "tinv",
      "tnonct",
      "today",
      "translate",
      "tranwrd",
      "trigamma",
      "trim",
      "trimn",
      "trunc",
      "uniform",
      "upcase",
      "uss",
      "var",
      "varfmt",
      "varinfmt",
      "varlabel",
      "varlen",
      "varname",
      "varnum",
      "varray",
      "varrayx",
      "vartype",
      "verify",
      "vformat",
      "vformatd",
      "vformatdx",
      "vformatn",
      "vformatnx",
      "vformatw",
      "vformatwx",
      "vformatx",
      "vinarray",
      "vinarrayx",
      "vinformat",
      "vinformatd",
      "vinformatdx",
      "vinformatn",
      "vinformatnx",
      "vinformatw",
      "vinformatwx",
      "vinformatx",
      "vlabel",
      "vlabelx",
      "vlength",
      "vlengthx",
      "vname",
      "vnamex",
      "vtype",
      "vtypex",
      "weekday",
      "year",
      "yyq",
      "zipfips",
      "zipname",
      "zipnamel",
      "zipstate"
    ], e = [
      "bquote",
      "nrbquote",
      "cmpres",
      "qcmpres",
      "compstor",
      "datatyp",
      "display",
      "do",
      "else",
      "end",
      "eval",
      "global",
      "goto",
      "if",
      "index",
      "input",
      "keydef",
      "label",
      "left",
      "length",
      "let",
      "local",
      "lowcase",
      "macro",
      "mend",
      "nrbquote",
      "nrquote",
      "nrstr",
      "put",
      "qcmpres",
      "qleft",
      "qlowcase",
      "qscan",
      "qsubstr",
      "qsysfunc",
      "qtrim",
      "quote",
      "qupcase",
      "scan",
      "str",
      "substr",
      "superq",
      "syscall",
      "sysevalf",
      "sysexec",
      "sysfunc",
      "sysget",
      "syslput",
      "sysprod",
      "sysrc",
      "sysrput",
      "then",
      "to",
      "trim",
      "unquote",
      "until",
      "upcase",
      "verify",
      "while",
      "window"
    ];
    return {
      name: "SAS",
      case_insensitive: !0,
      keywords: {
        literal: [
          "null",
          "missing",
          "_all_",
          "_automatic_",
          "_character_",
          "_infile_",
          "_n_",
          "_name_",
          "_null_",
          "_numeric_",
          "_user_",
          "_webout_"
        ],
        keyword: c
      },
      contains: [
        {
          // Distinct highlight for proc <proc>, data, run, quit
          className: "keyword",
          begin: /^\s*(proc [\w\d_]+|data|run|quit)[\s;]/
        },
        {
          // Macro variables
          className: "variable",
          begin: /&[a-zA-Z_&][a-zA-Z0-9_]*\.?/
        },
        {
          begin: [
            /^\s*/,
            /datalines;|cards;/,
            /(?:.*\n)+/,
            /^\s*;\s*$/
          ],
          className: {
            2: "keyword",
            3: "string"
          }
        },
        {
          begin: [
            /%mend|%macro/,
            /\s+/,
            /[a-zA-Z_&][a-zA-Z0-9_]*/
          ],
          className: {
            1: "built_in",
            3: "title.function"
          }
        },
        {
          // Built-in macro variables
          className: "built_in",
          begin: "%" + o.either(...e)
        },
        {
          // User-defined macro functions
          className: "title.function",
          begin: /%[a-zA-Z_][a-zA-Z_0-9]*/
        },
        {
          // TODO: this is most likely an incorrect classification
          // built_in may need more nuance
          // https://github.com/highlightjs/highlight.js/issues/2521
          className: "meta",
          begin: o.either(...r) + "(?=\\()"
        },
        {
          className: "string",
          variants: [
            i.APOS_STRING_MODE,
            i.QUOTE_STRING_MODE
          ]
        },
        i.COMMENT("\\*", ";"),
        i.C_BLOCK_COMMENT_MODE
      ]
    };
  }
  return ap = s, ap;
}
var ip, xT;
function Vk() {
  if (xT)
    return ip;
  xT = 1;
  function s(i) {
    const o = i.regex, c = {
      className: "meta",
      begin: "@[A-Za-z]+"
    }, r = {
      className: "subst",
      variants: [
        { begin: "\\$[A-Za-z0-9_]+" },
        {
          begin: /\$\{/,
          end: /\}/
        }
      ]
    }, e = {
      className: "string",
      variants: [
        {
          begin: '"""',
          end: '"""'
        },
        {
          begin: '"',
          end: '"',
          illegal: "\\n",
          contains: [i.BACKSLASH_ESCAPE]
        },
        {
          begin: '[a-z]+"',
          end: '"',
          illegal: "\\n",
          contains: [
            i.BACKSLASH_ESCAPE,
            r
          ]
        },
        {
          className: "string",
          begin: '[a-z]+"""',
          end: '"""',
          contains: [r],
          relevance: 10
        }
      ]
    }, g = {
      className: "type",
      begin: "\\b[A-Z][A-Za-z0-9_]*",
      relevance: 0
    }, h = {
      className: "title",
      begin: /[^0-9\n\t "'(),.`{}\[\]:;][^\n\t "'(),.`{}\[\]:;]+|[^0-9\n\t "'(),.`{}\[\]:;=]/,
      relevance: 0
    }, S = {
      className: "class",
      beginKeywords: "class object trait type",
      end: /[:={\[\n;]/,
      excludeEnd: !0,
      contains: [
        i.C_LINE_COMMENT_MODE,
        i.C_BLOCK_COMMENT_MODE,
        {
          beginKeywords: "extends with",
          relevance: 10
        },
        {
          begin: /\[/,
          end: /\]/,
          excludeBegin: !0,
          excludeEnd: !0,
          relevance: 0,
          contains: [
            g,
            i.C_LINE_COMMENT_MODE,
            i.C_BLOCK_COMMENT_MODE
          ]
        },
        {
          className: "params",
          begin: /\(/,
          end: /\)/,
          excludeBegin: !0,
          excludeEnd: !0,
          relevance: 0,
          contains: [
            g,
            i.C_LINE_COMMENT_MODE,
            i.C_BLOCK_COMMENT_MODE
          ]
        },
        h
      ]
    }, C = {
      className: "function",
      beginKeywords: "def",
      end: o.lookahead(/[:={\[(\n;]/),
      contains: [h]
    }, O = {
      begin: [
        /^\s*/,
        // Is first token on the line
        "extension",
        /\s+(?=[[(])/
        // followed by at least one space and `[` or `(`
      ],
      beginScope: { 2: "keyword" }
    }, N = {
      begin: [
        /^\s*/,
        // Is first token on the line
        /end/,
        /\s+/,
        /(extension\b)?/
        // `extension` is the only marker that follows an `end` that cannot be captured by another rule.
      ],
      beginScope: {
        2: "keyword",
        4: "keyword"
      }
    }, D = [
      { match: /\.inline\b/ },
      {
        begin: /\binline(?=\s)/,
        keywords: "inline"
      }
    ], x = {
      begin: [
        /\(\s*/,
        // Opening `(` of a parameter or argument list
        /using/,
        /\s+(?!\))/
        // Spaces not followed by `)`
      ],
      beginScope: { 2: "keyword" }
    };
    return {
      name: "Scala",
      keywords: {
        literal: "true false null",
        keyword: "type yield lazy override def with val var sealed abstract private trait object if then forSome for while do throw finally protected extends import final return else break new catch super class case package default try this match continue throws implicit export enum given transparent"
      },
      contains: [
        {
          begin: [
            "//>",
            /\s+/,
            /using/,
            /\s+/,
            /\S+/
          ],
          beginScope: {
            1: "comment",
            3: "keyword",
            5: "type"
          },
          end: /$/,
          contains: [
            {
              className: "string",
              begin: /\S+/
            }
          ]
        },
        i.C_LINE_COMMENT_MODE,
        i.C_BLOCK_COMMENT_MODE,
        e,
        g,
        C,
        S,
        i.C_NUMBER_MODE,
        O,
        N,
        ...D,
        x,
        c
      ]
    };
  }
  return ip = s, ip;
}
var op, LT;
function Yk() {
  if (LT)
    return op;
  LT = 1;
  function s(i) {
    const o = "[^\\(\\)\\[\\]\\{\\}\",'`;#|\\\\\\s]+", c = "(-|\\+)?\\d+([./]\\d+)?", r = c + "[+\\-]" + c + "i", e = {
      $pattern: o,
      built_in: "case-lambda call/cc class define-class exit-handler field import inherit init-field interface let*-values let-values let/ec mixin opt-lambda override protect provide public rename require require-for-syntax syntax syntax-case syntax-error unit/sig unless when with-syntax and begin call-with-current-continuation call-with-input-file call-with-output-file case cond define define-syntax delay do dynamic-wind else for-each if lambda let let* let-syntax letrec letrec-syntax map or syntax-rules ' * + , ,@ - ... / ; < <= = => > >= ` abs acos angle append apply asin assoc assq assv atan boolean? caar cadr call-with-input-file call-with-output-file call-with-values car cdddar cddddr cdr ceiling char->integer char-alphabetic? char-ci<=? char-ci<? char-ci=? char-ci>=? char-ci>? char-downcase char-lower-case? char-numeric? char-ready? char-upcase char-upper-case? char-whitespace? char<=? char<? char=? char>=? char>? char? close-input-port close-output-port complex? cons cos current-input-port current-output-port denominator display eof-object? eq? equal? eqv? eval even? exact->inexact exact? exp expt floor force gcd imag-part inexact->exact inexact? input-port? integer->char integer? interaction-environment lcm length list list->string list->vector list-ref list-tail list? load log magnitude make-polar make-rectangular make-string make-vector max member memq memv min modulo negative? newline not null-environment null? number->string number? numerator odd? open-input-file open-output-file output-port? pair? peek-char port? positive? procedure? quasiquote quote quotient rational? rationalize read read-char real-part real? remainder reverse round scheme-report-environment set! set-car! set-cdr! sin sqrt string string->list string->number string->symbol string-append string-ci<=? string-ci<? string-ci=? string-ci>=? string-ci>? string-copy string-fill! string-length string-ref string-set! string<=? string<? string=? string>=? string>? string? substring symbol->string symbol? tan transcript-off transcript-on truncate values vector vector->list vector-fill! vector-length vector-ref vector-set! with-input-from-file with-output-to-file write write-char zero?"
    }, g = {
      className: "literal",
      begin: "(#t|#f|#\\\\" + o + "|#\\\\.)"
    }, h = {
      className: "number",
      variants: [
        {
          begin: c,
          relevance: 0
        },
        {
          begin: r,
          relevance: 0
        },
        { begin: "#b[0-1]+(/[0-1]+)?" },
        { begin: "#o[0-7]+(/[0-7]+)?" },
        { begin: "#x[0-9a-f]+(/[0-9a-f]+)?" }
      ]
    }, S = i.QUOTE_STRING_MODE, C = [
      i.COMMENT(
        ";",
        "$",
        { relevance: 0 }
      ),
      i.COMMENT("#\\|", "\\|#")
    ], O = {
      begin: o,
      relevance: 0
    }, N = {
      className: "symbol",
      begin: "'" + o
    }, D = {
      endsWithParent: !0,
      relevance: 0
    }, x = {
      variants: [
        { begin: /'/ },
        { begin: "`" }
      ],
      contains: [
        {
          begin: "\\(",
          end: "\\)",
          contains: [
            "self",
            g,
            S,
            h,
            O,
            N
          ]
        }
      ]
    }, L = {
      className: "name",
      relevance: 0,
      begin: o,
      keywords: e
    }, Y = {
      variants: [
        {
          begin: "\\(",
          end: "\\)"
        },
        {
          begin: "\\[",
          end: "\\]"
        }
      ],
      contains: [
        {
          begin: /lambda/,
          endsWithParent: !0,
          returnBegin: !0,
          contains: [
            L,
            {
              endsParent: !0,
              variants: [
                {
                  begin: /\(/,
                  end: /\)/
                },
                {
                  begin: /\[/,
                  end: /\]/
                }
              ],
              contains: [O]
            }
          ]
        },
        L,
        D
      ]
    };
    return D.contains = [
      g,
      h,
      S,
      O,
      N,
      x,
      Y
    ].concat(C), {
      name: "Scheme",
      aliases: ["scm"],
      illegal: /\S/,
      contains: [
        i.SHEBANG(),
        h,
        S,
        N,
        x,
        Y
      ].concat(C)
    };
  }
  return op = s, op;
}
var sp, MT;
function Hk() {
  if (MT)
    return sp;
  MT = 1;
  function s(i) {
    const o = [
      i.C_NUMBER_MODE,
      {
        className: "string",
        begin: `'|"`,
        end: `'|"`,
        contains: [
          i.BACKSLASH_ESCAPE,
          { begin: "''" }
        ]
      }
    ];
    return {
      name: "Scilab",
      aliases: ["sci"],
      keywords: {
        $pattern: /%?\w+/,
        keyword: "abort break case clear catch continue do elseif else endfunction end for function global if pause return resume select try then while",
        literal: "%f %F %t %T %pi %eps %inf %nan %e %i %z %s",
        built_in: (
          // Scilab has more than 2000 functions. Just list the most commons
          "abs and acos asin atan ceil cd chdir clearglobal cosh cos cumprod deff disp error exec execstr exists exp eye gettext floor fprintf fread fsolve imag isdef isempty isinfisnan isvector lasterror length load linspace list listfiles log10 log2 log max min msprintf mclose mopen ones or pathconvert poly printf prod pwd rand real round sinh sin size gsort sprintf sqrt strcat strcmps tring sum system tanh tan type typename warning zeros matrix"
        )
      },
      illegal: '("|#|/\\*|\\s+/\\w+)',
      contains: [
        {
          className: "function",
          beginKeywords: "function",
          end: "$",
          contains: [
            i.UNDERSCORE_TITLE_MODE,
            {
              className: "params",
              begin: "\\(",
              end: "\\)"
            }
          ]
        },
        // seems to be a guard against [ident]' or [ident].
        // perhaps to prevent attributes from flagging as keywords?
        {
          begin: "[a-zA-Z_][a-zA-Z_0-9]*[\\.']+",
          relevance: 0
        },
        {
          begin: "\\[",
          end: "\\][\\.']*",
          relevance: 0,
          contains: o
        },
        i.COMMENT("//", "$")
      ].concat(o)
    };
  }
  return sp = s, sp;
}
var lp, PT;
function qk() {
  if (PT)
    return lp;
  PT = 1;
  const s = (h) => ({
    IMPORTANT: {
      scope: "meta",
      begin: "!important"
    },
    BLOCK_COMMENT: h.C_BLOCK_COMMENT_MODE,
    HEXCOLOR: {
      scope: "number",
      begin: /#(([0-9a-fA-F]{3,4})|(([0-9a-fA-F]{2}){3,4}))\b/
    },
    FUNCTION_DISPATCH: {
      className: "built_in",
      begin: /[\w-]+(?=\()/
    },
    ATTRIBUTE_SELECTOR_MODE: {
      scope: "selector-attr",
      begin: /\[/,
      end: /\]/,
      illegal: "$",
      contains: [
        h.APOS_STRING_MODE,
        h.QUOTE_STRING_MODE
      ]
    },
    CSS_NUMBER_MODE: {
      scope: "number",
      begin: h.NUMBER_RE + "(%|em|ex|ch|rem|vw|vh|vmin|vmax|cm|mm|in|pt|pc|px|deg|grad|rad|turn|s|ms|Hz|kHz|dpi|dpcm|dppx)?",
      relevance: 0
    },
    CSS_VARIABLE: {
      className: "attr",
      begin: /--[A-Za-z_][A-Za-z0-9_-]*/
    }
  }), i = [
    "a",
    "abbr",
    "address",
    "article",
    "aside",
    "audio",
    "b",
    "blockquote",
    "body",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "dd",
    "del",
    "details",
    "dfn",
    "div",
    "dl",
    "dt",
    "em",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "header",
    "hgroup",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "label",
    "legend",
    "li",
    "main",
    "mark",
    "menu",
    "nav",
    "object",
    "ol",
    "p",
    "q",
    "quote",
    "samp",
    "section",
    "span",
    "strong",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "tr",
    "ul",
    "var",
    "video"
  ], o = [
    "any-hover",
    "any-pointer",
    "aspect-ratio",
    "color",
    "color-gamut",
    "color-index",
    "device-aspect-ratio",
    "device-height",
    "device-width",
    "display-mode",
    "forced-colors",
    "grid",
    "height",
    "hover",
    "inverted-colors",
    "monochrome",
    "orientation",
    "overflow-block",
    "overflow-inline",
    "pointer",
    "prefers-color-scheme",
    "prefers-contrast",
    "prefers-reduced-motion",
    "prefers-reduced-transparency",
    "resolution",
    "scan",
    "scripting",
    "update",
    "width",
    // TODO: find a better solution?
    "min-width",
    "max-width",
    "min-height",
    "max-height"
  ], c = [
    "active",
    "any-link",
    "blank",
    "checked",
    "current",
    "default",
    "defined",
    "dir",
    // dir()
    "disabled",
    "drop",
    "empty",
    "enabled",
    "first",
    "first-child",
    "first-of-type",
    "fullscreen",
    "future",
    "focus",
    "focus-visible",
    "focus-within",
    "has",
    // has()
    "host",
    // host or host()
    "host-context",
    // host-context()
    "hover",
    "indeterminate",
    "in-range",
    "invalid",
    "is",
    // is()
    "lang",
    // lang()
    "last-child",
    "last-of-type",
    "left",
    "link",
    "local-link",
    "not",
    // not()
    "nth-child",
    // nth-child()
    "nth-col",
    // nth-col()
    "nth-last-child",
    // nth-last-child()
    "nth-last-col",
    // nth-last-col()
    "nth-last-of-type",
    //nth-last-of-type()
    "nth-of-type",
    //nth-of-type()
    "only-child",
    "only-of-type",
    "optional",
    "out-of-range",
    "past",
    "placeholder-shown",
    "read-only",
    "read-write",
    "required",
    "right",
    "root",
    "scope",
    "target",
    "target-within",
    "user-invalid",
    "valid",
    "visited",
    "where"
    // where()
  ], r = [
    "after",
    "backdrop",
    "before",
    "cue",
    "cue-region",
    "first-letter",
    "first-line",
    "grammar-error",
    "marker",
    "part",
    "placeholder",
    "selection",
    "slotted",
    "spelling-error"
  ], e = [
    "align-content",
    "align-items",
    "align-self",
    "all",
    "animation",
    "animation-delay",
    "animation-direction",
    "animation-duration",
    "animation-fill-mode",
    "animation-iteration-count",
    "animation-name",
    "animation-play-state",
    "animation-timing-function",
    "backface-visibility",
    "background",
    "background-attachment",
    "background-blend-mode",
    "background-clip",
    "background-color",
    "background-image",
    "background-origin",
    "background-position",
    "background-repeat",
    "background-size",
    "block-size",
    "border",
    "border-block",
    "border-block-color",
    "border-block-end",
    "border-block-end-color",
    "border-block-end-style",
    "border-block-end-width",
    "border-block-start",
    "border-block-start-color",
    "border-block-start-style",
    "border-block-start-width",
    "border-block-style",
    "border-block-width",
    "border-bottom",
    "border-bottom-color",
    "border-bottom-left-radius",
    "border-bottom-right-radius",
    "border-bottom-style",
    "border-bottom-width",
    "border-collapse",
    "border-color",
    "border-image",
    "border-image-outset",
    "border-image-repeat",
    "border-image-slice",
    "border-image-source",
    "border-image-width",
    "border-inline",
    "border-inline-color",
    "border-inline-end",
    "border-inline-end-color",
    "border-inline-end-style",
    "border-inline-end-width",
    "border-inline-start",
    "border-inline-start-color",
    "border-inline-start-style",
    "border-inline-start-width",
    "border-inline-style",
    "border-inline-width",
    "border-left",
    "border-left-color",
    "border-left-style",
    "border-left-width",
    "border-radius",
    "border-right",
    "border-right-color",
    "border-right-style",
    "border-right-width",
    "border-spacing",
    "border-style",
    "border-top",
    "border-top-color",
    "border-top-left-radius",
    "border-top-right-radius",
    "border-top-style",
    "border-top-width",
    "border-width",
    "bottom",
    "box-decoration-break",
    "box-shadow",
    "box-sizing",
    "break-after",
    "break-before",
    "break-inside",
    "caption-side",
    "caret-color",
    "clear",
    "clip",
    "clip-path",
    "clip-rule",
    "color",
    "column-count",
    "column-fill",
    "column-gap",
    "column-rule",
    "column-rule-color",
    "column-rule-style",
    "column-rule-width",
    "column-span",
    "column-width",
    "columns",
    "contain",
    "content",
    "content-visibility",
    "counter-increment",
    "counter-reset",
    "cue",
    "cue-after",
    "cue-before",
    "cursor",
    "direction",
    "display",
    "empty-cells",
    "filter",
    "flex",
    "flex-basis",
    "flex-direction",
    "flex-flow",
    "flex-grow",
    "flex-shrink",
    "flex-wrap",
    "float",
    "flow",
    "font",
    "font-display",
    "font-family",
    "font-feature-settings",
    "font-kerning",
    "font-language-override",
    "font-size",
    "font-size-adjust",
    "font-smoothing",
    "font-stretch",
    "font-style",
    "font-synthesis",
    "font-variant",
    "font-variant-caps",
    "font-variant-east-asian",
    "font-variant-ligatures",
    "font-variant-numeric",
    "font-variant-position",
    "font-variation-settings",
    "font-weight",
    "gap",
    "glyph-orientation-vertical",
    "grid",
    "grid-area",
    "grid-auto-columns",
    "grid-auto-flow",
    "grid-auto-rows",
    "grid-column",
    "grid-column-end",
    "grid-column-start",
    "grid-gap",
    "grid-row",
    "grid-row-end",
    "grid-row-start",
    "grid-template",
    "grid-template-areas",
    "grid-template-columns",
    "grid-template-rows",
    "hanging-punctuation",
    "height",
    "hyphens",
    "icon",
    "image-orientation",
    "image-rendering",
    "image-resolution",
    "ime-mode",
    "inline-size",
    "isolation",
    "justify-content",
    "left",
    "letter-spacing",
    "line-break",
    "line-height",
    "list-style",
    "list-style-image",
    "list-style-position",
    "list-style-type",
    "margin",
    "margin-block",
    "margin-block-end",
    "margin-block-start",
    "margin-bottom",
    "margin-inline",
    "margin-inline-end",
    "margin-inline-start",
    "margin-left",
    "margin-right",
    "margin-top",
    "marks",
    "mask",
    "mask-border",
    "mask-border-mode",
    "mask-border-outset",
    "mask-border-repeat",
    "mask-border-slice",
    "mask-border-source",
    "mask-border-width",
    "mask-clip",
    "mask-composite",
    "mask-image",
    "mask-mode",
    "mask-origin",
    "mask-position",
    "mask-repeat",
    "mask-size",
    "mask-type",
    "max-block-size",
    "max-height",
    "max-inline-size",
    "max-width",
    "min-block-size",
    "min-height",
    "min-inline-size",
    "min-width",
    "mix-blend-mode",
    "nav-down",
    "nav-index",
    "nav-left",
    "nav-right",
    "nav-up",
    "none",
    "normal",
    "object-fit",
    "object-position",
    "opacity",
    "order",
    "orphans",
    "outline",
    "outline-color",
    "outline-offset",
    "outline-style",
    "outline-width",
    "overflow",
    "overflow-wrap",
    "overflow-x",
    "overflow-y",
    "padding",
    "padding-block",
    "padding-block-end",
    "padding-block-start",
    "padding-bottom",
    "padding-inline",
    "padding-inline-end",
    "padding-inline-start",
    "padding-left",
    "padding-right",
    "padding-top",
    "page-break-after",
    "page-break-before",
    "page-break-inside",
    "pause",
    "pause-after",
    "pause-before",
    "perspective",
    "perspective-origin",
    "pointer-events",
    "position",
    "quotes",
    "resize",
    "rest",
    "rest-after",
    "rest-before",
    "right",
    "row-gap",
    "scroll-margin",
    "scroll-margin-block",
    "scroll-margin-block-end",
    "scroll-margin-block-start",
    "scroll-margin-bottom",
    "scroll-margin-inline",
    "scroll-margin-inline-end",
    "scroll-margin-inline-start",
    "scroll-margin-left",
    "scroll-margin-right",
    "scroll-margin-top",
    "scroll-padding",
    "scroll-padding-block",
    "scroll-padding-block-end",
    "scroll-padding-block-start",
    "scroll-padding-bottom",
    "scroll-padding-inline",
    "scroll-padding-inline-end",
    "scroll-padding-inline-start",
    "scroll-padding-left",
    "scroll-padding-right",
    "scroll-padding-top",
    "scroll-snap-align",
    "scroll-snap-stop",
    "scroll-snap-type",
    "scrollbar-color",
    "scrollbar-gutter",
    "scrollbar-width",
    "shape-image-threshold",
    "shape-margin",
    "shape-outside",
    "speak",
    "speak-as",
    "src",
    // @font-face
    "tab-size",
    "table-layout",
    "text-align",
    "text-align-all",
    "text-align-last",
    "text-combine-upright",
    "text-decoration",
    "text-decoration-color",
    "text-decoration-line",
    "text-decoration-style",
    "text-emphasis",
    "text-emphasis-color",
    "text-emphasis-position",
    "text-emphasis-style",
    "text-indent",
    "text-justify",
    "text-orientation",
    "text-overflow",
    "text-rendering",
    "text-shadow",
    "text-transform",
    "text-underline-position",
    "top",
    "transform",
    "transform-box",
    "transform-origin",
    "transform-style",
    "transition",
    "transition-delay",
    "transition-duration",
    "transition-property",
    "transition-timing-function",
    "unicode-bidi",
    "vertical-align",
    "visibility",
    "voice-balance",
    "voice-duration",
    "voice-family",
    "voice-pitch",
    "voice-range",
    "voice-rate",
    "voice-stress",
    "voice-volume",
    "white-space",
    "widows",
    "width",
    "will-change",
    "word-break",
    "word-spacing",
    "word-wrap",
    "writing-mode",
    "z-index"
    // reverse makes sure longer attributes `font-weight` are matched fully
    // instead of getting false positives on say `font`
  ].reverse();
  function g(h) {
    const S = s(h), C = r, O = c, N = "@[a-z-]+", D = "and or not only", L = {
      className: "variable",
      begin: "(\\$" + "[a-zA-Z-][a-zA-Z0-9_-]*" + ")\\b",
      relevance: 0
    };
    return {
      name: "SCSS",
      case_insensitive: !0,
      illegal: "[=/|']",
      contains: [
        h.C_LINE_COMMENT_MODE,
        h.C_BLOCK_COMMENT_MODE,
        // to recognize keyframe 40% etc which are outside the scope of our
        // attribute value mode
        S.CSS_NUMBER_MODE,
        {
          className: "selector-id",
          begin: "#[A-Za-z0-9_-]+",
          relevance: 0
        },
        {
          className: "selector-class",
          begin: "\\.[A-Za-z0-9_-]+",
          relevance: 0
        },
        S.ATTRIBUTE_SELECTOR_MODE,
        {
          className: "selector-tag",
          begin: "\\b(" + i.join("|") + ")\\b",
          // was there, before, but why?
          relevance: 0
        },
        {
          className: "selector-pseudo",
          begin: ":(" + O.join("|") + ")"
        },
        {
          className: "selector-pseudo",
          begin: ":(:)?(" + C.join("|") + ")"
        },
        L,
        {
          // pseudo-selector params
          begin: /\(/,
          end: /\)/,
          contains: [S.CSS_NUMBER_MODE]
        },
        S.CSS_VARIABLE,
        {
          className: "attribute",
          begin: "\\b(" + e.join("|") + ")\\b"
        },
        { begin: "\\b(whitespace|wait|w-resize|visible|vertical-text|vertical-ideographic|uppercase|upper-roman|upper-alpha|underline|transparent|top|thin|thick|text|text-top|text-bottom|tb-rl|table-header-group|table-footer-group|sw-resize|super|strict|static|square|solid|small-caps|separate|se-resize|scroll|s-resize|rtl|row-resize|ridge|right|repeat|repeat-y|repeat-x|relative|progress|pointer|overline|outside|outset|oblique|nowrap|not-allowed|normal|none|nw-resize|no-repeat|no-drop|newspaper|ne-resize|n-resize|move|middle|medium|ltr|lr-tb|lowercase|lower-roman|lower-alpha|loose|list-item|line|line-through|line-edge|lighter|left|keep-all|justify|italic|inter-word|inter-ideograph|inside|inset|inline|inline-block|inherit|inactive|ideograph-space|ideograph-parenthesis|ideograph-numeric|ideograph-alpha|horizontal|hidden|help|hand|groove|fixed|ellipsis|e-resize|double|dotted|distribute|distribute-space|distribute-letter|distribute-all-lines|disc|disabled|default|decimal|dashed|crosshair|collapse|col-resize|circle|char|center|capitalize|break-word|break-all|bottom|both|bolder|bold|block|bidi-override|below|baseline|auto|always|all-scroll|absolute|table|table-cell)\\b" },
        {
          begin: /:/,
          end: /[;}{]/,
          relevance: 0,
          contains: [
            S.BLOCK_COMMENT,
            L,
            S.HEXCOLOR,
            S.CSS_NUMBER_MODE,
            h.QUOTE_STRING_MODE,
            h.APOS_STRING_MODE,
            S.IMPORTANT,
            S.FUNCTION_DISPATCH
          ]
        },
        // matching these here allows us to treat them more like regular CSS
        // rules so everything between the {} gets regular rule highlighting,
        // which is what we want for page and font-face
        {
          begin: "@(page|font-face)",
          keywords: {
            $pattern: N,
            keyword: "@page @font-face"
          }
        },
        {
          begin: "@",
          end: "[{;]",
          returnBegin: !0,
          keywords: {
            $pattern: /[a-z-]+/,
            keyword: D,
            attribute: o.join(" ")
          },
          contains: [
            {
              begin: N,
              className: "keyword"
            },
            {
              begin: /[a-z-]+(?=:)/,
              className: "attribute"
            },
            L,
            h.QUOTE_STRING_MODE,
            h.APOS_STRING_MODE,
            S.HEXCOLOR,
            S.CSS_NUMBER_MODE
          ]
        },
        S.FUNCTION_DISPATCH
      ]
    };
  }
  return lp = g, lp;
}
var cp, kT;
function $k() {
  if (kT)
    return cp;
  kT = 1;
  function s(i) {
    return {
      name: "Shell Session",
      aliases: [
        "console",
        "shellsession"
      ],
      contains: [
        {
          className: "meta.prompt",
          // We cannot add \s (spaces) in the regular expression otherwise it will be too broad and produce unexpected result.
          // For instance, in the following example, it would match "echo /path/to/home >" as a prompt:
          // echo /path/to/home > t.exe
          begin: /^\s{0,3}[/~\w\d[\]()@-]*[>%$#][ ]?/,
          starts: {
            end: /[^\\](?=\s*$)/,
            subLanguage: "bash"
          }
        }
      ]
    };
  }
  return cp = s, cp;
}
var dp, FT;
function Wk() {
  if (FT)
    return dp;
  FT = 1;
  function s(i) {
    const o = [
      "add",
      "and",
      "cmp",
      "cmpg",
      "cmpl",
      "const",
      "div",
      "double",
      "float",
      "goto",
      "if",
      "int",
      "long",
      "move",
      "mul",
      "neg",
      "new",
      "nop",
      "not",
      "or",
      "rem",
      "return",
      "shl",
      "shr",
      "sput",
      "sub",
      "throw",
      "ushr",
      "xor"
    ], c = [
      "aget",
      "aput",
      "array",
      "check",
      "execute",
      "fill",
      "filled",
      "goto/16",
      "goto/32",
      "iget",
      "instance",
      "invoke",
      "iput",
      "monitor",
      "packed",
      "sget",
      "sparse"
    ], r = [
      "transient",
      "constructor",
      "abstract",
      "final",
      "synthetic",
      "public",
      "private",
      "protected",
      "static",
      "bridge",
      "system"
    ];
    return {
      name: "Smali",
      contains: [
        {
          className: "string",
          begin: '"',
          end: '"',
          relevance: 0
        },
        i.COMMENT(
          "#",
          "$",
          { relevance: 0 }
        ),
        {
          className: "keyword",
          variants: [
            { begin: "\\s*\\.end\\s[a-zA-Z0-9]*" },
            {
              begin: "^[ ]*\\.[a-zA-Z]*",
              relevance: 0
            },
            {
              begin: "\\s:[a-zA-Z_0-9]*",
              relevance: 0
            },
            { begin: "\\s(" + r.join("|") + ")" }
          ]
        },
        {
          className: "built_in",
          variants: [
            { begin: "\\s(" + o.join("|") + ")\\s" },
            {
              begin: "\\s(" + o.join("|") + ")((-|/)[a-zA-Z0-9]+)+\\s",
              relevance: 10
            },
            {
              begin: "\\s(" + c.join("|") + ")((-|/)[a-zA-Z0-9]+)*\\s",
              relevance: 10
            }
          ]
        },
        {
          className: "class",
          begin: `L[^(;:
]*;`,
          relevance: 0
        },
        { begin: "[vp][0-9]+" }
      ]
    };
  }
  return dp = s, dp;
}
var up, UT;
function zk() {
  if (UT)
    return up;
  UT = 1;
  function s(i) {
    const o = "[a-z][a-zA-Z0-9_]*", c = {
      className: "string",
      begin: "\\$.{1}"
    }, r = {
      className: "symbol",
      begin: "#" + i.UNDERSCORE_IDENT_RE
    };
    return {
      name: "Smalltalk",
      aliases: ["st"],
      keywords: [
        "self",
        "super",
        "nil",
        "true",
        "false",
        "thisContext"
      ],
      contains: [
        i.COMMENT('"', '"'),
        i.APOS_STRING_MODE,
        {
          className: "type",
          begin: "\\b[A-Z][A-Za-z0-9_]*",
          relevance: 0
        },
        {
          begin: o + ":",
          relevance: 0
        },
        i.C_NUMBER_MODE,
        r,
        c,
        {
          // This looks more complicated than needed to avoid combinatorial
          // explosion under V8. It effectively means `| var1 var2 ... |` with
          // whitespace adjacent to `|` being optional.
          begin: "\\|[ ]*" + o + "([ ]+" + o + ")*[ ]*\\|",
          returnBegin: !0,
          end: /\|/,
          illegal: /\S/,
          contains: [{ begin: "(\\|[ ]*)?" + o }]
        },
        {
          begin: "#\\(",
          end: "\\)",
          contains: [
            i.APOS_STRING_MODE,
            c,
            i.C_NUMBER_MODE,
            r
          ]
        }
      ]
    };
  }
  return up = s, up;
}
var _p, BT;
function Kk() {
  if (BT)
    return _p;
  BT = 1;
  function s(i) {
    return {
      name: "SML (Standard ML)",
      aliases: ["ml"],
      keywords: {
        $pattern: "[a-z_]\\w*!?",
        keyword: (
          /* according to Definition of Standard ML 97  */
          "abstype and andalso as case datatype do else end eqtype exception fn fun functor handle if in include infix infixr let local nonfix of op open orelse raise rec sharing sig signature struct structure then type val with withtype where while"
        ),
        built_in: (
          /* built-in types according to basis library */
          "array bool char exn int list option order real ref string substring vector unit word"
        ),
        literal: "true false NONE SOME LESS EQUAL GREATER nil"
      },
      illegal: /\/\/|>>/,
      contains: [
        {
          className: "literal",
          begin: /\[(\|\|)?\]|\(\)/,
          relevance: 0
        },
        i.COMMENT(
          "\\(\\*",
          "\\*\\)",
          { contains: ["self"] }
        ),
        {
          /* type variable */
          className: "symbol",
          begin: "'[A-Za-z_](?!')[\\w']*"
          /* the grammar is ambiguous on how 'a'b should be interpreted but not the compiler */
        },
        {
          /* polymorphic variant */
          className: "type",
          begin: "`[A-Z][\\w']*"
        },
        {
          /* module or constructor */
          className: "type",
          begin: "\\b[A-Z][\\w']*",
          relevance: 0
        },
        {
          /* don't color identifiers, but safely catch all identifiers with ' */
          begin: "[a-z_]\\w*'[\\w']*"
        },
        i.inherit(i.APOS_STRING_MODE, {
          className: "string",
          relevance: 0
        }),
        i.inherit(i.QUOTE_STRING_MODE, { illegal: null }),
        {
          className: "number",
          begin: "\\b(0[xX][a-fA-F0-9_]+[Lln]?|0[oO][0-7_]+[Lln]?|0[bB][01_]+[Lln]?|[0-9][0-9_]*([Lln]|(\\.[0-9_]*)?([eE][-+]?[0-9_]+)?)?)",
          relevance: 0
        },
        {
          begin: /[-=]>/
          // relevance booster
        }
      ]
    };
  }
  return _p = s, _p;
}
var pp, GT;
function Qk() {
  if (GT)
    return pp;
  GT = 1;
  function s(i) {
    const o = {
      className: "variable",
      begin: /\b_+[a-zA-Z]\w*/
    }, c = {
      className: "title",
      begin: /[a-zA-Z][a-zA-Z_0-9]*_fnc_[a-zA-Z_0-9]+/
    }, r = {
      className: "string",
      variants: [
        {
          begin: '"',
          end: '"',
          contains: [
            {
              begin: '""',
              relevance: 0
            }
          ]
        },
        {
          begin: "'",
          end: "'",
          contains: [
            {
              begin: "''",
              relevance: 0
            }
          ]
        }
      ]
    }, e = [
      "break",
      "breakWith",
      "breakOut",
      "breakTo",
      "case",
      "catch",
      "continue",
      "continueWith",
      "default",
      "do",
      "else",
      "exit",
      "exitWith",
      "for",
      "forEach",
      "from",
      "if",
      "local",
      "private",
      "switch",
      "step",
      "then",
      "throw",
      "to",
      "try",
      "waitUntil",
      "while",
      "with"
    ], g = [
      "blufor",
      "civilian",
      "configNull",
      "controlNull",
      "displayNull",
      "diaryRecordNull",
      "east",
      "endl",
      "false",
      "grpNull",
      "independent",
      "lineBreak",
      "locationNull",
      "nil",
      "objNull",
      "opfor",
      "pi",
      "resistance",
      "scriptNull",
      "sideAmbientLife",
      "sideEmpty",
      "sideEnemy",
      "sideFriendly",
      "sideLogic",
      "sideUnknown",
      "taskNull",
      "teamMemberNull",
      "true",
      "west"
    ], h = [
      "abs",
      "accTime",
      "acos",
      "action",
      "actionIDs",
      "actionKeys",
      "actionKeysEx",
      "actionKeysImages",
      "actionKeysNames",
      "actionKeysNamesArray",
      "actionName",
      "actionParams",
      "activateAddons",
      "activatedAddons",
      "activateKey",
      "activeTitleEffectParams",
      "add3DENConnection",
      "add3DENEventHandler",
      "add3DENLayer",
      "addAction",
      "addBackpack",
      "addBackpackCargo",
      "addBackpackCargoGlobal",
      "addBackpackGlobal",
      "addBinocularItem",
      "addCamShake",
      "addCuratorAddons",
      "addCuratorCameraArea",
      "addCuratorEditableObjects",
      "addCuratorEditingArea",
      "addCuratorPoints",
      "addEditorObject",
      "addEventHandler",
      "addForce",
      "addForceGeneratorRTD",
      "addGoggles",
      "addGroupIcon",
      "addHandgunItem",
      "addHeadgear",
      "addItem",
      "addItemCargo",
      "addItemCargoGlobal",
      "addItemPool",
      "addItemToBackpack",
      "addItemToUniform",
      "addItemToVest",
      "addLiveStats",
      "addMagazine",
      "addMagazineAmmoCargo",
      "addMagazineCargo",
      "addMagazineCargoGlobal",
      "addMagazineGlobal",
      "addMagazinePool",
      "addMagazines",
      "addMagazineTurret",
      "addMenu",
      "addMenuItem",
      "addMissionEventHandler",
      "addMPEventHandler",
      "addMusicEventHandler",
      "addonFiles",
      "addOwnedMine",
      "addPlayerScores",
      "addPrimaryWeaponItem",
      "addPublicVariableEventHandler",
      "addRating",
      "addResources",
      "addScore",
      "addScoreSide",
      "addSecondaryWeaponItem",
      "addSwitchableUnit",
      "addTeamMember",
      "addToRemainsCollector",
      "addTorque",
      "addUniform",
      "addUserActionEventHandler",
      "addVehicle",
      "addVest",
      "addWaypoint",
      "addWeapon",
      "addWeaponCargo",
      "addWeaponCargoGlobal",
      "addWeaponGlobal",
      "addWeaponItem",
      "addWeaponPool",
      "addWeaponTurret",
      "addWeaponWithAttachmentsCargo",
      "addWeaponWithAttachmentsCargoGlobal",
      "admin",
      "agent",
      "agents",
      "AGLToASL",
      "aimedAtTarget",
      "aimPos",
      "airDensityCurveRTD",
      "airDensityRTD",
      "airplaneThrottle",
      "airportSide",
      "AISFinishHeal",
      "alive",
      "all3DENEntities",
      "allActiveTitleEffects",
      "allAddonsInfo",
      "allAirports",
      "allControls",
      "allCurators",
      "allCutLayers",
      "allDead",
      "allDeadMen",
      "allDiaryRecords",
      "allDiarySubjects",
      "allDisplays",
      "allEnv3DSoundSources",
      "allGroups",
      "allLODs",
      "allMapMarkers",
      "allMines",
      "allMissionObjects",
      "allObjects",
      "allow3DMode",
      "allowCrewInImmobile",
      "allowCuratorLogicIgnoreAreas",
      "allowDamage",
      "allowDammage",
      "allowedService",
      "allowFileOperations",
      "allowFleeing",
      "allowGetIn",
      "allowService",
      "allowSprint",
      "allPlayers",
      "allSimpleObjects",
      "allSites",
      "allTurrets",
      "allUnits",
      "allUnitsUAV",
      "allUsers",
      "allVariables",
      "ambientTemperature",
      "ammo",
      "ammoOnPylon",
      "and",
      "animate",
      "animateBay",
      "animateDoor",
      "animatePylon",
      "animateSource",
      "animationNames",
      "animationPhase",
      "animationSourcePhase",
      "animationState",
      "apertureParams",
      "append",
      "apply",
      "armoryPoints",
      "arrayIntersect",
      "asin",
      "ASLToAGL",
      "ASLToATL",
      "assert",
      "assignAsCargo",
      "assignAsCargoIndex",
      "assignAsCommander",
      "assignAsDriver",
      "assignAsGunner",
      "assignAsTurret",
      "assignCurator",
      "assignedCargo",
      "assignedCommander",
      "assignedDriver",
      "assignedGroup",
      "assignedGunner",
      "assignedItems",
      "assignedTarget",
      "assignedTeam",
      "assignedVehicle",
      "assignedVehicleRole",
      "assignedVehicles",
      "assignItem",
      "assignTeam",
      "assignToAirport",
      "atan",
      "atan2",
      "atg",
      "ATLToASL",
      "attachedObject",
      "attachedObjects",
      "attachedTo",
      "attachObject",
      "attachTo",
      "attackEnabled",
      "awake",
      "backpack",
      "backpackCargo",
      "backpackContainer",
      "backpackItems",
      "backpackMagazines",
      "backpackSpaceFor",
      "behaviour",
      "benchmark",
      "bezierInterpolation",
      "binocular",
      "binocularItems",
      "binocularMagazine",
      "boundingBox",
      "boundingBoxReal",
      "boundingCenter",
      "brakesDisabled",
      "briefingName",
      "buildingExit",
      "buildingPos",
      "buldozer_EnableRoadDiag",
      "buldozer_IsEnabledRoadDiag",
      "buldozer_LoadNewRoads",
      "buldozer_reloadOperMap",
      "buttonAction",
      "buttonSetAction",
      "cadetMode",
      "calculatePath",
      "calculatePlayerVisibilityByFriendly",
      "call",
      "callExtension",
      "camCommand",
      "camCommit",
      "camCommitPrepared",
      "camCommitted",
      "camConstuctionSetParams",
      "camCreate",
      "camDestroy",
      "cameraEffect",
      "cameraEffectEnableHUD",
      "cameraInterest",
      "cameraOn",
      "cameraView",
      "campaignConfigFile",
      "camPreload",
      "camPreloaded",
      "camPrepareBank",
      "camPrepareDir",
      "camPrepareDive",
      "camPrepareFocus",
      "camPrepareFov",
      "camPrepareFovRange",
      "camPreparePos",
      "camPrepareRelPos",
      "camPrepareTarget",
      "camSetBank",
      "camSetDir",
      "camSetDive",
      "camSetFocus",
      "camSetFov",
      "camSetFovRange",
      "camSetPos",
      "camSetRelPos",
      "camSetTarget",
      "camTarget",
      "camUseNVG",
      "canAdd",
      "canAddItemToBackpack",
      "canAddItemToUniform",
      "canAddItemToVest",
      "cancelSimpleTaskDestination",
      "canDeployWeapon",
      "canFire",
      "canMove",
      "canSlingLoad",
      "canStand",
      "canSuspend",
      "canTriggerDynamicSimulation",
      "canUnloadInCombat",
      "canVehicleCargo",
      "captive",
      "captiveNum",
      "cbChecked",
      "cbSetChecked",
      "ceil",
      "channelEnabled",
      "cheatsEnabled",
      "checkAIFeature",
      "checkVisibility",
      "className",
      "clear3DENAttribute",
      "clear3DENInventory",
      "clearAllItemsFromBackpack",
      "clearBackpackCargo",
      "clearBackpackCargoGlobal",
      "clearForcesRTD",
      "clearGroupIcons",
      "clearItemCargo",
      "clearItemCargoGlobal",
      "clearItemPool",
      "clearMagazineCargo",
      "clearMagazineCargoGlobal",
      "clearMagazinePool",
      "clearOverlay",
      "clearRadio",
      "clearWeaponCargo",
      "clearWeaponCargoGlobal",
      "clearWeaponPool",
      "clientOwner",
      "closeDialog",
      "closeDisplay",
      "closeOverlay",
      "collapseObjectTree",
      "collect3DENHistory",
      "collectiveRTD",
      "collisionDisabledWith",
      "combatBehaviour",
      "combatMode",
      "commandArtilleryFire",
      "commandChat",
      "commander",
      "commandFire",
      "commandFollow",
      "commandFSM",
      "commandGetOut",
      "commandingMenu",
      "commandMove",
      "commandRadio",
      "commandStop",
      "commandSuppressiveFire",
      "commandTarget",
      "commandWatch",
      "comment",
      "commitOverlay",
      "compatibleItems",
      "compatibleMagazines",
      "compile",
      "compileFinal",
      "compileScript",
      "completedFSM",
      "composeText",
      "configClasses",
      "configFile",
      "configHierarchy",
      "configName",
      "configOf",
      "configProperties",
      "configSourceAddonList",
      "configSourceMod",
      "configSourceModList",
      "confirmSensorTarget",
      "connectTerminalToUAV",
      "connectToServer",
      "controlsGroupCtrl",
      "conversationDisabled",
      "copyFromClipboard",
      "copyToClipboard",
      "copyWaypoints",
      "cos",
      "count",
      "countEnemy",
      "countFriendly",
      "countSide",
      "countType",
      "countUnknown",
      "create3DENComposition",
      "create3DENEntity",
      "createAgent",
      "createCenter",
      "createDialog",
      "createDiaryLink",
      "createDiaryRecord",
      "createDiarySubject",
      "createDisplay",
      "createGearDialog",
      "createGroup",
      "createGuardedPoint",
      "createHashMap",
      "createHashMapFromArray",
      "createLocation",
      "createMarker",
      "createMarkerLocal",
      "createMenu",
      "createMine",
      "createMissionDisplay",
      "createMPCampaignDisplay",
      "createSimpleObject",
      "createSimpleTask",
      "createSite",
      "createSoundSource",
      "createTask",
      "createTeam",
      "createTrigger",
      "createUnit",
      "createVehicle",
      "createVehicleCrew",
      "createVehicleLocal",
      "crew",
      "ctAddHeader",
      "ctAddRow",
      "ctClear",
      "ctCurSel",
      "ctData",
      "ctFindHeaderRows",
      "ctFindRowHeader",
      "ctHeaderControls",
      "ctHeaderCount",
      "ctRemoveHeaders",
      "ctRemoveRows",
      "ctrlActivate",
      "ctrlAddEventHandler",
      "ctrlAngle",
      "ctrlAnimateModel",
      "ctrlAnimationPhaseModel",
      "ctrlAt",
      "ctrlAutoScrollDelay",
      "ctrlAutoScrollRewind",
      "ctrlAutoScrollSpeed",
      "ctrlBackgroundColor",
      "ctrlChecked",
      "ctrlClassName",
      "ctrlCommit",
      "ctrlCommitted",
      "ctrlCreate",
      "ctrlDelete",
      "ctrlEnable",
      "ctrlEnabled",
      "ctrlFade",
      "ctrlFontHeight",
      "ctrlForegroundColor",
      "ctrlHTMLLoaded",
      "ctrlIDC",
      "ctrlIDD",
      "ctrlMapAnimAdd",
      "ctrlMapAnimClear",
      "ctrlMapAnimCommit",
      "ctrlMapAnimDone",
      "ctrlMapCursor",
      "ctrlMapMouseOver",
      "ctrlMapPosition",
      "ctrlMapScale",
      "ctrlMapScreenToWorld",
      "ctrlMapSetPosition",
      "ctrlMapWorldToScreen",
      "ctrlModel",
      "ctrlModelDirAndUp",
      "ctrlModelScale",
      "ctrlMousePosition",
      "ctrlParent",
      "ctrlParentControlsGroup",
      "ctrlPosition",
      "ctrlRemoveAllEventHandlers",
      "ctrlRemoveEventHandler",
      "ctrlScale",
      "ctrlScrollValues",
      "ctrlSetActiveColor",
      "ctrlSetAngle",
      "ctrlSetAutoScrollDelay",
      "ctrlSetAutoScrollRewind",
      "ctrlSetAutoScrollSpeed",
      "ctrlSetBackgroundColor",
      "ctrlSetChecked",
      "ctrlSetDisabledColor",
      "ctrlSetEventHandler",
      "ctrlSetFade",
      "ctrlSetFocus",
      "ctrlSetFont",
      "ctrlSetFontH1",
      "ctrlSetFontH1B",
      "ctrlSetFontH2",
      "ctrlSetFontH2B",
      "ctrlSetFontH3",
      "ctrlSetFontH3B",
      "ctrlSetFontH4",
      "ctrlSetFontH4B",
      "ctrlSetFontH5",
      "ctrlSetFontH5B",
      "ctrlSetFontH6",
      "ctrlSetFontH6B",
      "ctrlSetFontHeight",
      "ctrlSetFontHeightH1",
      "ctrlSetFontHeightH2",
      "ctrlSetFontHeightH3",
      "ctrlSetFontHeightH4",
      "ctrlSetFontHeightH5",
      "ctrlSetFontHeightH6",
      "ctrlSetFontHeightSecondary",
      "ctrlSetFontP",
      "ctrlSetFontPB",
      "ctrlSetFontSecondary",
      "ctrlSetForegroundColor",
      "ctrlSetModel",
      "ctrlSetModelDirAndUp",
      "ctrlSetModelScale",
      "ctrlSetMousePosition",
      "ctrlSetPixelPrecision",
      "ctrlSetPosition",
      "ctrlSetPositionH",
      "ctrlSetPositionW",
      "ctrlSetPositionX",
      "ctrlSetPositionY",
      "ctrlSetScale",
      "ctrlSetScrollValues",
      "ctrlSetShadow",
      "ctrlSetStructuredText",
      "ctrlSetText",
      "ctrlSetTextColor",
      "ctrlSetTextColorSecondary",
      "ctrlSetTextSecondary",
      "ctrlSetTextSelection",
      "ctrlSetTooltip",
      "ctrlSetTooltipColorBox",
      "ctrlSetTooltipColorShade",
      "ctrlSetTooltipColorText",
      "ctrlSetTooltipMaxWidth",
      "ctrlSetURL",
      "ctrlSetURLOverlayMode",
      "ctrlShadow",
      "ctrlShow",
      "ctrlShown",
      "ctrlStyle",
      "ctrlText",
      "ctrlTextColor",
      "ctrlTextHeight",
      "ctrlTextSecondary",
      "ctrlTextSelection",
      "ctrlTextWidth",
      "ctrlTooltip",
      "ctrlType",
      "ctrlURL",
      "ctrlURLOverlayMode",
      "ctrlVisible",
      "ctRowControls",
      "ctRowCount",
      "ctSetCurSel",
      "ctSetData",
      "ctSetHeaderTemplate",
      "ctSetRowTemplate",
      "ctSetValue",
      "ctValue",
      "curatorAddons",
      "curatorCamera",
      "curatorCameraArea",
      "curatorCameraAreaCeiling",
      "curatorCoef",
      "curatorEditableObjects",
      "curatorEditingArea",
      "curatorEditingAreaType",
      "curatorMouseOver",
      "curatorPoints",
      "curatorRegisteredObjects",
      "curatorSelected",
      "curatorWaypointCost",
      "current3DENOperation",
      "currentChannel",
      "currentCommand",
      "currentMagazine",
      "currentMagazineDetail",
      "currentMagazineDetailTurret",
      "currentMagazineTurret",
      "currentMuzzle",
      "currentNamespace",
      "currentPilot",
      "currentTask",
      "currentTasks",
      "currentThrowable",
      "currentVisionMode",
      "currentWaypoint",
      "currentWeapon",
      "currentWeaponMode",
      "currentWeaponTurret",
      "currentZeroing",
      "cursorObject",
      "cursorTarget",
      "customChat",
      "customRadio",
      "customWaypointPosition",
      "cutFadeOut",
      "cutObj",
      "cutRsc",
      "cutText",
      "damage",
      "date",
      "dateToNumber",
      "dayTime",
      "deActivateKey",
      "debriefingText",
      "debugFSM",
      "debugLog",
      "decayGraphValues",
      "deg",
      "delete3DENEntities",
      "deleteAt",
      "deleteCenter",
      "deleteCollection",
      "deleteEditorObject",
      "deleteGroup",
      "deleteGroupWhenEmpty",
      "deleteIdentity",
      "deleteLocation",
      "deleteMarker",
      "deleteMarkerLocal",
      "deleteRange",
      "deleteResources",
      "deleteSite",
      "deleteStatus",
      "deleteTeam",
      "deleteVehicle",
      "deleteVehicleCrew",
      "deleteWaypoint",
      "detach",
      "detectedMines",
      "diag_activeMissionFSMs",
      "diag_activeScripts",
      "diag_activeSQFScripts",
      "diag_activeSQSScripts",
      "diag_allMissionEventHandlers",
      "diag_captureFrame",
      "diag_captureFrameToFile",
      "diag_captureSlowFrame",
      "diag_codePerformance",
      "diag_deltaTime",
      "diag_drawmode",
      "diag_dumpCalltraceToLog",
      "diag_dumpScriptAssembly",
      "diag_dumpTerrainSynth",
      "diag_dynamicSimulationEnd",
      "diag_enable",
      "diag_enabled",
      "diag_exportConfig",
      "diag_exportTerrainSVG",
      "diag_fps",
      "diag_fpsmin",
      "diag_frameno",
      "diag_getTerrainSegmentOffset",
      "diag_lightNewLoad",
      "diag_list",
      "diag_localized",
      "diag_log",
      "diag_logSlowFrame",
      "diag_mergeConfigFile",
      "diag_recordTurretLimits",
      "diag_resetFSM",
      "diag_resetshapes",
      "diag_scope",
      "diag_setLightNew",
      "diag_stacktrace",
      "diag_tickTime",
      "diag_toggle",
      "dialog",
      "diarySubjectExists",
      "didJIP",
      "didJIPOwner",
      "difficulty",
      "difficultyEnabled",
      "difficultyEnabledRTD",
      "difficultyOption",
      "direction",
      "directionStabilizationEnabled",
      "directSay",
      "disableAI",
      "disableBrakes",
      "disableCollisionWith",
      "disableConversation",
      "disableDebriefingStats",
      "disableMapIndicators",
      "disableNVGEquipment",
      "disableRemoteSensors",
      "disableSerialization",
      "disableTIEquipment",
      "disableUAVConnectability",
      "disableUserInput",
      "displayAddEventHandler",
      "displayChild",
      "displayCtrl",
      "displayParent",
      "displayRemoveAllEventHandlers",
      "displayRemoveEventHandler",
      "displaySetEventHandler",
      "displayUniqueName",
      "displayUpdate",
      "dissolveTeam",
      "distance",
      "distance2D",
      "distanceSqr",
      "distributionRegion",
      "do3DENAction",
      "doArtilleryFire",
      "doFire",
      "doFollow",
      "doFSM",
      "doGetOut",
      "doMove",
      "doorPhase",
      "doStop",
      "doSuppressiveFire",
      "doTarget",
      "doWatch",
      "drawArrow",
      "drawEllipse",
      "drawIcon",
      "drawIcon3D",
      "drawLaser",
      "drawLine",
      "drawLine3D",
      "drawLink",
      "drawLocation",
      "drawPolygon",
      "drawRectangle",
      "drawTriangle",
      "driver",
      "drop",
      "dynamicSimulationDistance",
      "dynamicSimulationDistanceCoef",
      "dynamicSimulationEnabled",
      "dynamicSimulationSystemEnabled",
      "echo",
      "edit3DENMissionAttributes",
      "editObject",
      "editorSetEventHandler",
      "effectiveCommander",
      "elevatePeriscope",
      "emptyPositions",
      "enableAI",
      "enableAIFeature",
      "enableAimPrecision",
      "enableAttack",
      "enableAudioFeature",
      "enableAutoStartUpRTD",
      "enableAutoTrimRTD",
      "enableCamShake",
      "enableCaustics",
      "enableChannel",
      "enableCollisionWith",
      "enableCopilot",
      "enableDebriefingStats",
      "enableDiagLegend",
      "enableDirectionStabilization",
      "enableDynamicSimulation",
      "enableDynamicSimulationSystem",
      "enableEndDialog",
      "enableEngineArtillery",
      "enableEnvironment",
      "enableFatigue",
      "enableGunLights",
      "enableInfoPanelComponent",
      "enableIRLasers",
      "enableMimics",
      "enablePersonTurret",
      "enableRadio",
      "enableReload",
      "enableRopeAttach",
      "enableSatNormalOnDetail",
      "enableSaving",
      "enableSentences",
      "enableSimulation",
      "enableSimulationGlobal",
      "enableStamina",
      "enableStressDamage",
      "enableTeamSwitch",
      "enableTraffic",
      "enableUAVConnectability",
      "enableUAVWaypoints",
      "enableVehicleCargo",
      "enableVehicleSensor",
      "enableWeaponDisassembly",
      "endLoadingScreen",
      "endMission",
      "engineOn",
      "enginesIsOnRTD",
      "enginesPowerRTD",
      "enginesRpmRTD",
      "enginesTorqueRTD",
      "entities",
      "environmentEnabled",
      "environmentVolume",
      "equipmentDisabled",
      "estimatedEndServerTime",
      "estimatedTimeLeft",
      "evalObjectArgument",
      "everyBackpack",
      "everyContainer",
      "exec",
      "execEditorScript",
      "execFSM",
      "execVM",
      "exp",
      "expectedDestination",
      "exportJIPMessages",
      "eyeDirection",
      "eyePos",
      "face",
      "faction",
      "fadeEnvironment",
      "fadeMusic",
      "fadeRadio",
      "fadeSound",
      "fadeSpeech",
      "failMission",
      "fileExists",
      "fillWeaponsFromPool",
      "find",
      "findAny",
      "findCover",
      "findDisplay",
      "findEditorObject",
      "findEmptyPosition",
      "findEmptyPositionReady",
      "findIf",
      "findNearestEnemy",
      "finishMissionInit",
      "finite",
      "fire",
      "fireAtTarget",
      "firstBackpack",
      "flag",
      "flagAnimationPhase",
      "flagOwner",
      "flagSide",
      "flagTexture",
      "flatten",
      "fleeing",
      "floor",
      "flyInHeight",
      "flyInHeightASL",
      "focusedCtrl",
      "fog",
      "fogForecast",
      "fogParams",
      "forceAddUniform",
      "forceAtPositionRTD",
      "forceCadetDifficulty",
      "forcedMap",
      "forceEnd",
      "forceFlagTexture",
      "forceFollowRoad",
      "forceGeneratorRTD",
      "forceMap",
      "forceRespawn",
      "forceSpeed",
      "forceUnicode",
      "forceWalk",
      "forceWeaponFire",
      "forceWeatherChange",
      "forEachMember",
      "forEachMemberAgent",
      "forEachMemberTeam",
      "forgetTarget",
      "format",
      "formation",
      "formationDirection",
      "formationLeader",
      "formationMembers",
      "formationPosition",
      "formationTask",
      "formatText",
      "formLeader",
      "freeExtension",
      "freeLook",
      "fromEditor",
      "fuel",
      "fullCrew",
      "gearIDCAmmoCount",
      "gearSlotAmmoCount",
      "gearSlotData",
      "gestureState",
      "get",
      "get3DENActionState",
      "get3DENAttribute",
      "get3DENCamera",
      "get3DENConnections",
      "get3DENEntity",
      "get3DENEntityID",
      "get3DENGrid",
      "get3DENIconsVisible",
      "get3DENLayerEntities",
      "get3DENLinesVisible",
      "get3DENMissionAttribute",
      "get3DENMouseOver",
      "get3DENSelected",
      "getAimingCoef",
      "getAllEnv3DSoundControllers",
      "getAllEnvSoundControllers",
      "getAllHitPointsDamage",
      "getAllOwnedMines",
      "getAllPylonsInfo",
      "getAllSoundControllers",
      "getAllUnitTraits",
      "getAmmoCargo",
      "getAnimAimPrecision",
      "getAnimSpeedCoef",
      "getArray",
      "getArtilleryAmmo",
      "getArtilleryComputerSettings",
      "getArtilleryETA",
      "getAssetDLCInfo",
      "getAssignedCuratorLogic",
      "getAssignedCuratorUnit",
      "getAttackTarget",
      "getAudioOptionVolumes",
      "getBackpackCargo",
      "getBleedingRemaining",
      "getBurningValue",
      "getCalculatePlayerVisibilityByFriendly",
      "getCameraViewDirection",
      "getCargoIndex",
      "getCenterOfMass",
      "getClientState",
      "getClientStateNumber",
      "getCompatiblePylonMagazines",
      "getConnectedUAV",
      "getConnectedUAVUnit",
      "getContainerMaxLoad",
      "getCorpse",
      "getCruiseControl",
      "getCursorObjectParams",
      "getCustomAimCoef",
      "getCustomSoundController",
      "getCustomSoundControllerCount",
      "getDammage",
      "getDebriefingText",
      "getDescription",
      "getDir",
      "getDirVisual",
      "getDiverState",
      "getDLCAssetsUsage",
      "getDLCAssetsUsageByName",
      "getDLCs",
      "getDLCUsageTime",
      "getEditorCamera",
      "getEditorMode",
      "getEditorObjectScope",
      "getElevationOffset",
      "getEngineTargetRPMRTD",
      "getEnv3DSoundController",
      "getEnvSoundController",
      "getEventHandlerInfo",
      "getFatigue",
      "getFieldManualStartPage",
      "getForcedFlagTexture",
      "getForcedSpeed",
      "getFriend",
      "getFSMVariable",
      "getFuelCargo",
      "getGraphValues",
      "getGroupIcon",
      "getGroupIconParams",
      "getGroupIcons",
      "getHideFrom",
      "getHit",
      "getHitIndex",
      "getHitPointDamage",
      "getItemCargo",
      "getLighting",
      "getLightingAt",
      "getLoadedModsInfo",
      "getMagazineCargo",
      "getMarkerColor",
      "getMarkerPos",
      "getMarkerSize",
      "getMarkerType",
      "getMass",
      "getMissionConfig",
      "getMissionConfigValue",
      "getMissionDLCs",
      "getMissionLayerEntities",
      "getMissionLayers",
      "getMissionPath",
      "getModelInfo",
      "getMousePosition",
      "getMusicPlayedTime",
      "getNumber",
      "getObjectArgument",
      "getObjectChildren",
      "getObjectDLC",
      "getObjectFOV",
      "getObjectID",
      "getObjectMaterials",
      "getObjectProxy",
      "getObjectScale",
      "getObjectTextures",
      "getObjectType",
      "getObjectViewDistance",
      "getOpticsMode",
      "getOrDefault",
      "getOrDefaultCall",
      "getOxygenRemaining",
      "getPersonUsedDLCs",
      "getPilotCameraDirection",
      "getPilotCameraPosition",
      "getPilotCameraRotation",
      "getPilotCameraTarget",
      "getPiPViewDistance",
      "getPlateNumber",
      "getPlayerChannel",
      "getPlayerID",
      "getPlayerScores",
      "getPlayerUID",
      "getPlayerVoNVolume",
      "getPos",
      "getPosASL",
      "getPosASLVisual",
      "getPosASLW",
      "getPosATL",
      "getPosATLVisual",
      "getPosVisual",
      "getPosWorld",
      "getPosWorldVisual",
      "getPylonMagazines",
      "getRelDir",
      "getRelPos",
      "getRemoteSensorsDisabled",
      "getRepairCargo",
      "getResolution",
      "getRoadInfo",
      "getRotorBrakeRTD",
      "getSensorTargets",
      "getSensorThreats",
      "getShadowDistance",
      "getShotParents",
      "getSlingLoad",
      "getSoundController",
      "getSoundControllerResult",
      "getSpeed",
      "getStamina",
      "getStatValue",
      "getSteamFriendsServers",
      "getSubtitleOptions",
      "getSuppression",
      "getTerrainGrid",
      "getTerrainHeight",
      "getTerrainHeightASL",
      "getTerrainInfo",
      "getText",
      "getTextRaw",
      "getTextureInfo",
      "getTextWidth",
      "getTiParameters",
      "getTotalDLCUsageTime",
      "getTrimOffsetRTD",
      "getTurretLimits",
      "getTurretOpticsMode",
      "getUnitFreefallInfo",
      "getUnitLoadout",
      "getUnitTrait",
      "getUnloadInCombat",
      "getUserInfo",
      "getUserMFDText",
      "getUserMFDValue",
      "getVariable",
      "getVehicleCargo",
      "getVehicleTiPars",
      "getWeaponCargo",
      "getWeaponSway",
      "getWingsOrientationRTD",
      "getWingsPositionRTD",
      "getWPPos",
      "glanceAt",
      "globalChat",
      "globalRadio",
      "goggles",
      "goto",
      "group",
      "groupChat",
      "groupFromNetId",
      "groupIconSelectable",
      "groupIconsVisible",
      "groupID",
      "groupOwner",
      "groupRadio",
      "groups",
      "groupSelectedUnits",
      "groupSelectUnit",
      "gunner",
      "gusts",
      "halt",
      "handgunItems",
      "handgunMagazine",
      "handgunWeapon",
      "handsHit",
      "hashValue",
      "hasInterface",
      "hasPilotCamera",
      "hasWeapon",
      "hcAllGroups",
      "hcGroupParams",
      "hcLeader",
      "hcRemoveAllGroups",
      "hcRemoveGroup",
      "hcSelected",
      "hcSelectGroup",
      "hcSetGroup",
      "hcShowBar",
      "hcShownBar",
      "headgear",
      "hideBody",
      "hideObject",
      "hideObjectGlobal",
      "hideSelection",
      "hint",
      "hintC",
      "hintCadet",
      "hintSilent",
      "hmd",
      "hostMission",
      "htmlLoad",
      "HUDMovementLevels",
      "humidity",
      "image",
      "importAllGroups",
      "importance",
      "in",
      "inArea",
      "inAreaArray",
      "incapacitatedState",
      "inflame",
      "inflamed",
      "infoPanel",
      "infoPanelComponentEnabled",
      "infoPanelComponents",
      "infoPanels",
      "inGameUISetEventHandler",
      "inheritsFrom",
      "initAmbientLife",
      "inPolygon",
      "inputAction",
      "inputController",
      "inputMouse",
      "inRangeOfArtillery",
      "insert",
      "insertEditorObject",
      "intersect",
      "is3DEN",
      "is3DENMultiplayer",
      "is3DENPreview",
      "isAbleToBreathe",
      "isActionMenuVisible",
      "isAgent",
      "isAimPrecisionEnabled",
      "isAllowedCrewInImmobile",
      "isArray",
      "isAutoHoverOn",
      "isAutonomous",
      "isAutoStartUpEnabledRTD",
      "isAutotest",
      "isAutoTrimOnRTD",
      "isAwake",
      "isBleeding",
      "isBurning",
      "isClass",
      "isCollisionLightOn",
      "isCopilotEnabled",
      "isDamageAllowed",
      "isDedicated",
      "isDLCAvailable",
      "isEngineOn",
      "isEqualRef",
      "isEqualTo",
      "isEqualType",
      "isEqualTypeAll",
      "isEqualTypeAny",
      "isEqualTypeArray",
      "isEqualTypeParams",
      "isFilePatchingEnabled",
      "isFinal",
      "isFlashlightOn",
      "isFlatEmpty",
      "isForcedWalk",
      "isFormationLeader",
      "isGameFocused",
      "isGamePaused",
      "isGroupDeletedWhenEmpty",
      "isHidden",
      "isInRemainsCollector",
      "isInstructorFigureEnabled",
      "isIRLaserOn",
      "isKeyActive",
      "isKindOf",
      "isLaserOn",
      "isLightOn",
      "isLocalized",
      "isManualFire",
      "isMarkedForCollection",
      "isMissionProfileNamespaceLoaded",
      "isMultiplayer",
      "isMultiplayerSolo",
      "isNil",
      "isNotEqualRef",
      "isNotEqualTo",
      "isNull",
      "isNumber",
      "isObjectHidden",
      "isObjectRTD",
      "isOnRoad",
      "isPiPEnabled",
      "isPlayer",
      "isRealTime",
      "isRemoteExecuted",
      "isRemoteExecutedJIP",
      "isSaving",
      "isSensorTargetConfirmed",
      "isServer",
      "isShowing3DIcons",
      "isSimpleObject",
      "isSprintAllowed",
      "isStaminaEnabled",
      "isSteamMission",
      "isSteamOverlayEnabled",
      "isStreamFriendlyUIEnabled",
      "isStressDamageEnabled",
      "isText",
      "isTouchingGround",
      "isTurnedOut",
      "isTutHintsEnabled",
      "isUAVConnectable",
      "isUAVConnected",
      "isUIContext",
      "isUniformAllowed",
      "isVehicleCargo",
      "isVehicleRadarOn",
      "isVehicleSensorEnabled",
      "isWalking",
      "isWeaponDeployed",
      "isWeaponRested",
      "itemCargo",
      "items",
      "itemsWithMagazines",
      "join",
      "joinAs",
      "joinAsSilent",
      "joinSilent",
      "joinString",
      "kbAddDatabase",
      "kbAddDatabaseTargets",
      "kbAddTopic",
      "kbHasTopic",
      "kbReact",
      "kbRemoveTopic",
      "kbTell",
      "kbWasSaid",
      "keyImage",
      "keyName",
      "keys",
      "knowsAbout",
      "land",
      "landAt",
      "landResult",
      "language",
      "laserTarget",
      "lbAdd",
      "lbClear",
      "lbColor",
      "lbColorRight",
      "lbCurSel",
      "lbData",
      "lbDelete",
      "lbIsSelected",
      "lbPicture",
      "lbPictureRight",
      "lbSelection",
      "lbSetColor",
      "lbSetColorRight",
      "lbSetCurSel",
      "lbSetData",
      "lbSetPicture",
      "lbSetPictureColor",
      "lbSetPictureColorDisabled",
      "lbSetPictureColorSelected",
      "lbSetPictureRight",
      "lbSetPictureRightColor",
      "lbSetPictureRightColorDisabled",
      "lbSetPictureRightColorSelected",
      "lbSetSelectColor",
      "lbSetSelectColorRight",
      "lbSetSelected",
      "lbSetText",
      "lbSetTextRight",
      "lbSetTooltip",
      "lbSetValue",
      "lbSize",
      "lbSort",
      "lbSortBy",
      "lbSortByValue",
      "lbText",
      "lbTextRight",
      "lbTooltip",
      "lbValue",
      "leader",
      "leaderboardDeInit",
      "leaderboardGetRows",
      "leaderboardInit",
      "leaderboardRequestRowsFriends",
      "leaderboardRequestRowsGlobal",
      "leaderboardRequestRowsGlobalAroundUser",
      "leaderboardsRequestUploadScore",
      "leaderboardsRequestUploadScoreKeepBest",
      "leaderboardState",
      "leaveVehicle",
      "libraryCredits",
      "libraryDisclaimers",
      "lifeState",
      "lightAttachObject",
      "lightDetachObject",
      "lightIsOn",
      "lightnings",
      "limitSpeed",
      "linearConversion",
      "lineIntersects",
      "lineIntersectsObjs",
      "lineIntersectsSurfaces",
      "lineIntersectsWith",
      "linkItem",
      "list",
      "listObjects",
      "listRemoteTargets",
      "listVehicleSensors",
      "ln",
      "lnbAddArray",
      "lnbAddColumn",
      "lnbAddRow",
      "lnbClear",
      "lnbColor",
      "lnbColorRight",
      "lnbCurSelRow",
      "lnbData",
      "lnbDeleteColumn",
      "lnbDeleteRow",
      "lnbGetColumnsPosition",
      "lnbPicture",
      "lnbPictureRight",
      "lnbSetColor",
      "lnbSetColorRight",
      "lnbSetColumnsPos",
      "lnbSetCurSelRow",
      "lnbSetData",
      "lnbSetPicture",
      "lnbSetPictureColor",
      "lnbSetPictureColorRight",
      "lnbSetPictureColorSelected",
      "lnbSetPictureColorSelectedRight",
      "lnbSetPictureRight",
      "lnbSetText",
      "lnbSetTextRight",
      "lnbSetTooltip",
      "lnbSetValue",
      "lnbSize",
      "lnbSort",
      "lnbSortBy",
      "lnbSortByValue",
      "lnbText",
      "lnbTextRight",
      "lnbValue",
      "load",
      "loadAbs",
      "loadBackpack",
      "loadConfig",
      "loadFile",
      "loadGame",
      "loadIdentity",
      "loadMagazine",
      "loadOverlay",
      "loadStatus",
      "loadUniform",
      "loadVest",
      "localize",
      "localNamespace",
      "locationPosition",
      "lock",
      "lockCameraTo",
      "lockCargo",
      "lockDriver",
      "locked",
      "lockedCameraTo",
      "lockedCargo",
      "lockedDriver",
      "lockedInventory",
      "lockedTurret",
      "lockIdentity",
      "lockInventory",
      "lockTurret",
      "lockWp",
      "log",
      "logEntities",
      "logNetwork",
      "logNetworkTerminate",
      "lookAt",
      "lookAtPos",
      "magazineCargo",
      "magazines",
      "magazinesAllTurrets",
      "magazinesAmmo",
      "magazinesAmmoCargo",
      "magazinesAmmoFull",
      "magazinesDetail",
      "magazinesDetailBackpack",
      "magazinesDetailUniform",
      "magazinesDetailVest",
      "magazinesTurret",
      "magazineTurretAmmo",
      "mapAnimAdd",
      "mapAnimClear",
      "mapAnimCommit",
      "mapAnimDone",
      "mapCenterOnCamera",
      "mapGridPosition",
      "markAsFinishedOnSteam",
      "markerAlpha",
      "markerBrush",
      "markerChannel",
      "markerColor",
      "markerDir",
      "markerPolyline",
      "markerPos",
      "markerShadow",
      "markerShape",
      "markerSize",
      "markerText",
      "markerType",
      "matrixMultiply",
      "matrixTranspose",
      "max",
      "maxLoad",
      "members",
      "menuAction",
      "menuAdd",
      "menuChecked",
      "menuClear",
      "menuCollapse",
      "menuData",
      "menuDelete",
      "menuEnable",
      "menuEnabled",
      "menuExpand",
      "menuHover",
      "menuPicture",
      "menuSetAction",
      "menuSetCheck",
      "menuSetData",
      "menuSetPicture",
      "menuSetShortcut",
      "menuSetText",
      "menuSetURL",
      "menuSetValue",
      "menuShortcut",
      "menuShortcutText",
      "menuSize",
      "menuSort",
      "menuText",
      "menuURL",
      "menuValue",
      "merge",
      "min",
      "mineActive",
      "mineDetectedBy",
      "missileTarget",
      "missileTargetPos",
      "missionConfigFile",
      "missionDifficulty",
      "missionEnd",
      "missionName",
      "missionNameSource",
      "missionNamespace",
      "missionProfileNamespace",
      "missionStart",
      "missionVersion",
      "mod",
      "modelToWorld",
      "modelToWorldVisual",
      "modelToWorldVisualWorld",
      "modelToWorldWorld",
      "modParams",
      "moonIntensity",
      "moonPhase",
      "morale",
      "move",
      "move3DENCamera",
      "moveInAny",
      "moveInCargo",
      "moveInCommander",
      "moveInDriver",
      "moveInGunner",
      "moveInTurret",
      "moveObjectToEnd",
      "moveOut",
      "moveTime",
      "moveTo",
      "moveToCompleted",
      "moveToFailed",
      "musicVolume",
      "name",
      "namedProperties",
      "nameSound",
      "nearEntities",
      "nearestBuilding",
      "nearestLocation",
      "nearestLocations",
      "nearestLocationWithDubbing",
      "nearestMines",
      "nearestObject",
      "nearestObjects",
      "nearestTerrainObjects",
      "nearObjects",
      "nearObjectsReady",
      "nearRoads",
      "nearSupplies",
      "nearTargets",
      "needReload",
      "needService",
      "netId",
      "netObjNull",
      "newOverlay",
      "nextMenuItemIndex",
      "nextWeatherChange",
      "nMenuItems",
      "not",
      "numberOfEnginesRTD",
      "numberToDate",
      "objectCurators",
      "objectFromNetId",
      "objectParent",
      "objStatus",
      "onBriefingGroup",
      "onBriefingNotes",
      "onBriefingPlan",
      "onBriefingTeamSwitch",
      "onCommandModeChanged",
      "onDoubleClick",
      "onEachFrame",
      "onGroupIconClick",
      "onGroupIconOverEnter",
      "onGroupIconOverLeave",
      "onHCGroupSelectionChanged",
      "onMapSingleClick",
      "onPlayerConnected",
      "onPlayerDisconnected",
      "onPreloadFinished",
      "onPreloadStarted",
      "onShowNewObject",
      "onTeamSwitch",
      "openCuratorInterface",
      "openDLCPage",
      "openGPS",
      "openMap",
      "openSteamApp",
      "openYoutubeVideo",
      "or",
      "orderGetIn",
      "overcast",
      "overcastForecast",
      "owner",
      "param",
      "params",
      "parseNumber",
      "parseSimpleArray",
      "parseText",
      "parsingNamespace",
      "particlesQuality",
      "periscopeElevation",
      "pickWeaponPool",
      "pitch",
      "pixelGrid",
      "pixelGridBase",
      "pixelGridNoUIScale",
      "pixelH",
      "pixelW",
      "playableSlotsNumber",
      "playableUnits",
      "playAction",
      "playActionNow",
      "player",
      "playerRespawnTime",
      "playerSide",
      "playersNumber",
      "playGesture",
      "playMission",
      "playMove",
      "playMoveNow",
      "playMusic",
      "playScriptedMission",
      "playSound",
      "playSound3D",
      "playSoundUI",
      "pose",
      "position",
      "positionCameraToWorld",
      "posScreenToWorld",
      "posWorldToScreen",
      "ppEffectAdjust",
      "ppEffectCommit",
      "ppEffectCommitted",
      "ppEffectCreate",
      "ppEffectDestroy",
      "ppEffectEnable",
      "ppEffectEnabled",
      "ppEffectForceInNVG",
      "precision",
      "preloadCamera",
      "preloadObject",
      "preloadSound",
      "preloadTitleObj",
      "preloadTitleRsc",
      "preprocessFile",
      "preprocessFileLineNumbers",
      "primaryWeapon",
      "primaryWeaponItems",
      "primaryWeaponMagazine",
      "priority",
      "processDiaryLink",
      "productVersion",
      "profileName",
      "profileNamespace",
      "profileNameSteam",
      "progressLoadingScreen",
      "progressPosition",
      "progressSetPosition",
      "publicVariable",
      "publicVariableClient",
      "publicVariableServer",
      "pushBack",
      "pushBackUnique",
      "putWeaponPool",
      "queryItemsPool",
      "queryMagazinePool",
      "queryWeaponPool",
      "rad",
      "radioChannelAdd",
      "radioChannelCreate",
      "radioChannelInfo",
      "radioChannelRemove",
      "radioChannelSetCallSign",
      "radioChannelSetLabel",
      "radioEnabled",
      "radioVolume",
      "rain",
      "rainbow",
      "rainParams",
      "random",
      "rank",
      "rankId",
      "rating",
      "rectangular",
      "regexFind",
      "regexMatch",
      "regexReplace",
      "registeredTasks",
      "registerTask",
      "reload",
      "reloadEnabled",
      "remoteControl",
      "remoteExec",
      "remoteExecCall",
      "remoteExecutedOwner",
      "remove3DENConnection",
      "remove3DENEventHandler",
      "remove3DENLayer",
      "removeAction",
      "removeAll3DENEventHandlers",
      "removeAllActions",
      "removeAllAssignedItems",
      "removeAllBinocularItems",
      "removeAllContainers",
      "removeAllCuratorAddons",
      "removeAllCuratorCameraAreas",
      "removeAllCuratorEditingAreas",
      "removeAllEventHandlers",
      "removeAllHandgunItems",
      "removeAllItems",
      "removeAllItemsWithMagazines",
      "removeAllMissionEventHandlers",
      "removeAllMPEventHandlers",
      "removeAllMusicEventHandlers",
      "removeAllOwnedMines",
      "removeAllPrimaryWeaponItems",
      "removeAllSecondaryWeaponItems",
      "removeAllUserActionEventHandlers",
      "removeAllWeapons",
      "removeBackpack",
      "removeBackpackGlobal",
      "removeBinocularItem",
      "removeCuratorAddons",
      "removeCuratorCameraArea",
      "removeCuratorEditableObjects",
      "removeCuratorEditingArea",
      "removeDiaryRecord",
      "removeDiarySubject",
      "removeDrawIcon",
      "removeDrawLinks",
      "removeEventHandler",
      "removeFromRemainsCollector",
      "removeGoggles",
      "removeGroupIcon",
      "removeHandgunItem",
      "removeHeadgear",
      "removeItem",
      "removeItemFromBackpack",
      "removeItemFromUniform",
      "removeItemFromVest",
      "removeItems",
      "removeMagazine",
      "removeMagazineGlobal",
      "removeMagazines",
      "removeMagazinesTurret",
      "removeMagazineTurret",
      "removeMenuItem",
      "removeMissionEventHandler",
      "removeMPEventHandler",
      "removeMusicEventHandler",
      "removeOwnedMine",
      "removePrimaryWeaponItem",
      "removeSecondaryWeaponItem",
      "removeSimpleTask",
      "removeSwitchableUnit",
      "removeTeamMember",
      "removeUniform",
      "removeUserActionEventHandler",
      "removeVest",
      "removeWeapon",
      "removeWeaponAttachmentCargo",
      "removeWeaponCargo",
      "removeWeaponGlobal",
      "removeWeaponTurret",
      "reportRemoteTarget",
      "requiredVersion",
      "resetCamShake",
      "resetSubgroupDirection",
      "resize",
      "resources",
      "respawnVehicle",
      "restartEditorCamera",
      "reveal",
      "revealMine",
      "reverse",
      "reversedMouseY",
      "roadAt",
      "roadsConnectedTo",
      "roleDescription",
      "ropeAttachedObjects",
      "ropeAttachedTo",
      "ropeAttachEnabled",
      "ropeAttachTo",
      "ropeCreate",
      "ropeCut",
      "ropeDestroy",
      "ropeDetach",
      "ropeEndPosition",
      "ropeLength",
      "ropes",
      "ropesAttachedTo",
      "ropeSegments",
      "ropeUnwind",
      "ropeUnwound",
      "rotorsForcesRTD",
      "rotorsRpmRTD",
      "round",
      "runInitScript",
      "safeZoneH",
      "safeZoneW",
      "safeZoneWAbs",
      "safeZoneX",
      "safeZoneXAbs",
      "safeZoneY",
      "save3DENInventory",
      "saveGame",
      "saveIdentity",
      "saveJoysticks",
      "saveMissionProfileNamespace",
      "saveOverlay",
      "saveProfileNamespace",
      "saveStatus",
      "saveVar",
      "savingEnabled",
      "say",
      "say2D",
      "say3D",
      "scopeName",
      "score",
      "scoreSide",
      "screenshot",
      "screenToWorld",
      "scriptDone",
      "scriptName",
      "scudState",
      "secondaryWeapon",
      "secondaryWeaponItems",
      "secondaryWeaponMagazine",
      "select",
      "selectBestPlaces",
      "selectDiarySubject",
      "selectedEditorObjects",
      "selectEditorObject",
      "selectionNames",
      "selectionPosition",
      "selectionVectorDirAndUp",
      "selectLeader",
      "selectMax",
      "selectMin",
      "selectNoPlayer",
      "selectPlayer",
      "selectRandom",
      "selectRandomWeighted",
      "selectWeapon",
      "selectWeaponTurret",
      "sendAUMessage",
      "sendSimpleCommand",
      "sendTask",
      "sendTaskResult",
      "sendUDPMessage",
      "sentencesEnabled",
      "serverCommand",
      "serverCommandAvailable",
      "serverCommandExecutable",
      "serverName",
      "serverNamespace",
      "serverTime",
      "set",
      "set3DENAttribute",
      "set3DENAttributes",
      "set3DENGrid",
      "set3DENIconsVisible",
      "set3DENLayer",
      "set3DENLinesVisible",
      "set3DENLogicType",
      "set3DENMissionAttribute",
      "set3DENMissionAttributes",
      "set3DENModelsVisible",
      "set3DENObjectType",
      "set3DENSelected",
      "setAccTime",
      "setActualCollectiveRTD",
      "setAirplaneThrottle",
      "setAirportSide",
      "setAmmo",
      "setAmmoCargo",
      "setAmmoOnPylon",
      "setAnimSpeedCoef",
      "setAperture",
      "setApertureNew",
      "setArmoryPoints",
      "setAttributes",
      "setAutonomous",
      "setBehaviour",
      "setBehaviourStrong",
      "setBleedingRemaining",
      "setBrakesRTD",
      "setCameraInterest",
      "setCamShakeDefParams",
      "setCamShakeParams",
      "setCamUseTi",
      "setCaptive",
      "setCenterOfMass",
      "setCollisionLight",
      "setCombatBehaviour",
      "setCombatMode",
      "setCompassOscillation",
      "setConvoySeparation",
      "setCruiseControl",
      "setCuratorCameraAreaCeiling",
      "setCuratorCoef",
      "setCuratorEditingAreaType",
      "setCuratorWaypointCost",
      "setCurrentChannel",
      "setCurrentTask",
      "setCurrentWaypoint",
      "setCustomAimCoef",
      "SetCustomMissionData",
      "setCustomSoundController",
      "setCustomWeightRTD",
      "setDamage",
      "setDammage",
      "setDate",
      "setDebriefingText",
      "setDefaultCamera",
      "setDestination",
      "setDetailMapBlendPars",
      "setDiaryRecordText",
      "setDiarySubjectPicture",
      "setDir",
      "setDirection",
      "setDrawIcon",
      "setDriveOnPath",
      "setDropInterval",
      "setDynamicSimulationDistance",
      "setDynamicSimulationDistanceCoef",
      "setEditorMode",
      "setEditorObjectScope",
      "setEffectCondition",
      "setEffectiveCommander",
      "setEngineRpmRTD",
      "setFace",
      "setFaceanimation",
      "setFatigue",
      "setFeatureType",
      "setFlagAnimationPhase",
      "setFlagOwner",
      "setFlagSide",
      "setFlagTexture",
      "setFog",
      "setForceGeneratorRTD",
      "setFormation",
      "setFormationTask",
      "setFormDir",
      "setFriend",
      "setFromEditor",
      "setFSMVariable",
      "setFuel",
      "setFuelCargo",
      "setGroupIcon",
      "setGroupIconParams",
      "setGroupIconsSelectable",
      "setGroupIconsVisible",
      "setGroupid",
      "setGroupIdGlobal",
      "setGroupOwner",
      "setGusts",
      "setHideBehind",
      "setHit",
      "setHitIndex",
      "setHitPointDamage",
      "setHorizonParallaxCoef",
      "setHUDMovementLevels",
      "setHumidity",
      "setIdentity",
      "setImportance",
      "setInfoPanel",
      "setLeader",
      "setLightAmbient",
      "setLightAttenuation",
      "setLightBrightness",
      "setLightColor",
      "setLightConePars",
      "setLightDayLight",
      "setLightFlareMaxDistance",
      "setLightFlareSize",
      "setLightIntensity",
      "setLightIR",
      "setLightnings",
      "setLightUseFlare",
      "setLightVolumeShape",
      "setLocalWindParams",
      "setMagazineTurretAmmo",
      "setMarkerAlpha",
      "setMarkerAlphaLocal",
      "setMarkerBrush",
      "setMarkerBrushLocal",
      "setMarkerColor",
      "setMarkerColorLocal",
      "setMarkerDir",
      "setMarkerDirLocal",
      "setMarkerPolyline",
      "setMarkerPolylineLocal",
      "setMarkerPos",
      "setMarkerPosLocal",
      "setMarkerShadow",
      "setMarkerShadowLocal",
      "setMarkerShape",
      "setMarkerShapeLocal",
      "setMarkerSize",
      "setMarkerSizeLocal",
      "setMarkerText",
      "setMarkerTextLocal",
      "setMarkerType",
      "setMarkerTypeLocal",
      "setMass",
      "setMaxLoad",
      "setMimic",
      "setMissileTarget",
      "setMissileTargetPos",
      "setMousePosition",
      "setMusicEffect",
      "setMusicEventHandler",
      "setName",
      "setNameSound",
      "setObjectArguments",
      "setObjectMaterial",
      "setObjectMaterialGlobal",
      "setObjectProxy",
      "setObjectScale",
      "setObjectTexture",
      "setObjectTextureGlobal",
      "setObjectViewDistance",
      "setOpticsMode",
      "setOvercast",
      "setOwner",
      "setOxygenRemaining",
      "setParticleCircle",
      "setParticleClass",
      "setParticleFire",
      "setParticleParams",
      "setParticleRandom",
      "setPilotCameraDirection",
      "setPilotCameraRotation",
      "setPilotCameraTarget",
      "setPilotLight",
      "setPiPEffect",
      "setPiPViewDistance",
      "setPitch",
      "setPlateNumber",
      "setPlayable",
      "setPlayerRespawnTime",
      "setPlayerVoNVolume",
      "setPos",
      "setPosASL",
      "setPosASL2",
      "setPosASLW",
      "setPosATL",
      "setPosition",
      "setPosWorld",
      "setPylonLoadout",
      "setPylonsPriority",
      "setRadioMsg",
      "setRain",
      "setRainbow",
      "setRandomLip",
      "setRank",
      "setRectangular",
      "setRepairCargo",
      "setRotorBrakeRTD",
      "setShadowDistance",
      "setShotParents",
      "setSide",
      "setSimpleTaskAlwaysVisible",
      "setSimpleTaskCustomData",
      "setSimpleTaskDescription",
      "setSimpleTaskDestination",
      "setSimpleTaskTarget",
      "setSimpleTaskType",
      "setSimulWeatherLayers",
      "setSize",
      "setSkill",
      "setSlingLoad",
      "setSoundEffect",
      "setSpeaker",
      "setSpeech",
      "setSpeedMode",
      "setStamina",
      "setStaminaScheme",
      "setStatValue",
      "setSuppression",
      "setSystemOfUnits",
      "setTargetAge",
      "setTaskMarkerOffset",
      "setTaskResult",
      "setTaskState",
      "setTerrainGrid",
      "setTerrainHeight",
      "setText",
      "setTimeMultiplier",
      "setTiParameter",
      "setTitleEffect",
      "setTowParent",
      "setTrafficDensity",
      "setTrafficDistance",
      "setTrafficGap",
      "setTrafficSpeed",
      "setTriggerActivation",
      "setTriggerArea",
      "setTriggerInterval",
      "setTriggerStatements",
      "setTriggerText",
      "setTriggerTimeout",
      "setTriggerType",
      "setTurretLimits",
      "setTurretOpticsMode",
      "setType",
      "setUnconscious",
      "setUnitAbility",
      "setUnitCombatMode",
      "setUnitFreefallHeight",
      "setUnitLoadout",
      "setUnitPos",
      "setUnitPosWeak",
      "setUnitRank",
      "setUnitRecoilCoefficient",
      "setUnitTrait",
      "setUnloadInCombat",
      "setUserActionText",
      "setUserMFDText",
      "setUserMFDValue",
      "setVariable",
      "setVectorDir",
      "setVectorDirAndUp",
      "setVectorUp",
      "setVehicleAmmo",
      "setVehicleAmmoDef",
      "setVehicleArmor",
      "setVehicleCargo",
      "setVehicleId",
      "setVehicleLock",
      "setVehiclePosition",
      "setVehicleRadar",
      "setVehicleReceiveRemoteTargets",
      "setVehicleReportOwnPosition",
      "setVehicleReportRemoteTargets",
      "setVehicleTiPars",
      "setVehicleVarName",
      "setVelocity",
      "setVelocityModelSpace",
      "setVelocityTransformation",
      "setViewDistance",
      "setVisibleIfTreeCollapsed",
      "setWantedRPMRTD",
      "setWaves",
      "setWaypointBehaviour",
      "setWaypointCombatMode",
      "setWaypointCompletionRadius",
      "setWaypointDescription",
      "setWaypointForceBehaviour",
      "setWaypointFormation",
      "setWaypointHousePosition",
      "setWaypointLoiterAltitude",
      "setWaypointLoiterRadius",
      "setWaypointLoiterType",
      "setWaypointName",
      "setWaypointPosition",
      "setWaypointScript",
      "setWaypointSpeed",
      "setWaypointStatements",
      "setWaypointTimeout",
      "setWaypointType",
      "setWaypointVisible",
      "setWeaponReloadingTime",
      "setWeaponZeroing",
      "setWind",
      "setWindDir",
      "setWindForce",
      "setWindStr",
      "setWingForceScaleRTD",
      "setWPPos",
      "show3DIcons",
      "showChat",
      "showCinemaBorder",
      "showCommandingMenu",
      "showCompass",
      "showCuratorCompass",
      "showGps",
      "showHUD",
      "showLegend",
      "showMap",
      "shownArtilleryComputer",
      "shownChat",
      "shownCompass",
      "shownCuratorCompass",
      "showNewEditorObject",
      "shownGps",
      "shownHUD",
      "shownMap",
      "shownPad",
      "shownRadio",
      "shownScoretable",
      "shownSubtitles",
      "shownUAVFeed",
      "shownWarrant",
      "shownWatch",
      "showPad",
      "showRadio",
      "showScoretable",
      "showSubtitles",
      "showUAVFeed",
      "showWarrant",
      "showWatch",
      "showWaypoint",
      "showWaypoints",
      "side",
      "sideChat",
      "sideRadio",
      "simpleTasks",
      "simulationEnabled",
      "simulCloudDensity",
      "simulCloudOcclusion",
      "simulInClouds",
      "simulWeatherSync",
      "sin",
      "size",
      "sizeOf",
      "skill",
      "skillFinal",
      "skipTime",
      "sleep",
      "sliderPosition",
      "sliderRange",
      "sliderSetPosition",
      "sliderSetRange",
      "sliderSetSpeed",
      "sliderSpeed",
      "slingLoadAssistantShown",
      "soldierMagazines",
      "someAmmo",
      "sort",
      "soundVolume",
      "spawn",
      "speaker",
      "speechVolume",
      "speed",
      "speedMode",
      "splitString",
      "sqrt",
      "squadParams",
      "stance",
      "startLoadingScreen",
      "stop",
      "stopEngineRTD",
      "stopped",
      "str",
      "sunOrMoon",
      "supportInfo",
      "suppressFor",
      "surfaceIsWater",
      "surfaceNormal",
      "surfaceTexture",
      "surfaceType",
      "swimInDepth",
      "switchableUnits",
      "switchAction",
      "switchCamera",
      "switchGesture",
      "switchLight",
      "switchMove",
      "synchronizedObjects",
      "synchronizedTriggers",
      "synchronizedWaypoints",
      "synchronizeObjectsAdd",
      "synchronizeObjectsRemove",
      "synchronizeTrigger",
      "synchronizeWaypoint",
      "systemChat",
      "systemOfUnits",
      "systemTime",
      "systemTimeUTC",
      "tan",
      "targetKnowledge",
      "targets",
      "targetsAggregate",
      "targetsQuery",
      "taskAlwaysVisible",
      "taskChildren",
      "taskCompleted",
      "taskCustomData",
      "taskDescription",
      "taskDestination",
      "taskHint",
      "taskMarkerOffset",
      "taskName",
      "taskParent",
      "taskResult",
      "taskState",
      "taskType",
      "teamMember",
      "teamName",
      "teams",
      "teamSwitch",
      "teamSwitchEnabled",
      "teamType",
      "terminate",
      "terrainIntersect",
      "terrainIntersectASL",
      "terrainIntersectAtASL",
      "text",
      "textLog",
      "textLogFormat",
      "tg",
      "time",
      "timeMultiplier",
      "titleCut",
      "titleFadeOut",
      "titleObj",
      "titleRsc",
      "titleText",
      "toArray",
      "toFixed",
      "toLower",
      "toLowerANSI",
      "toString",
      "toUpper",
      "toUpperANSI",
      "triggerActivated",
      "triggerActivation",
      "triggerAmmo",
      "triggerArea",
      "triggerAttachedVehicle",
      "triggerAttachObject",
      "triggerAttachVehicle",
      "triggerDynamicSimulation",
      "triggerInterval",
      "triggerStatements",
      "triggerText",
      "triggerTimeout",
      "triggerTimeoutCurrent",
      "triggerType",
      "trim",
      "turretLocal",
      "turretOwner",
      "turretUnit",
      "tvAdd",
      "tvClear",
      "tvCollapse",
      "tvCollapseAll",
      "tvCount",
      "tvCurSel",
      "tvData",
      "tvDelete",
      "tvExpand",
      "tvExpandAll",
      "tvIsSelected",
      "tvPicture",
      "tvPictureRight",
      "tvSelection",
      "tvSetColor",
      "tvSetCurSel",
      "tvSetData",
      "tvSetPicture",
      "tvSetPictureColor",
      "tvSetPictureColorDisabled",
      "tvSetPictureColorSelected",
      "tvSetPictureRight",
      "tvSetPictureRightColor",
      "tvSetPictureRightColorDisabled",
      "tvSetPictureRightColorSelected",
      "tvSetSelectColor",
      "tvSetSelected",
      "tvSetText",
      "tvSetTooltip",
      "tvSetValue",
      "tvSort",
      "tvSortAll",
      "tvSortByValue",
      "tvSortByValueAll",
      "tvText",
      "tvTooltip",
      "tvValue",
      "type",
      "typeName",
      "typeOf",
      "UAVControl",
      "uiNamespace",
      "uiSleep",
      "unassignCurator",
      "unassignItem",
      "unassignTeam",
      "unassignVehicle",
      "underwater",
      "uniform",
      "uniformContainer",
      "uniformItems",
      "uniformMagazines",
      "uniqueUnitItems",
      "unitAddons",
      "unitAimPosition",
      "unitAimPositionVisual",
      "unitBackpack",
      "unitCombatMode",
      "unitIsUAV",
      "unitPos",
      "unitReady",
      "unitRecoilCoefficient",
      "units",
      "unitsBelowHeight",
      "unitTurret",
      "unlinkItem",
      "unlockAchievement",
      "unregisterTask",
      "updateDrawIcon",
      "updateMenuItem",
      "updateObjectTree",
      "useAIOperMapObstructionTest",
      "useAISteeringComponent",
      "useAudioTimeForMoves",
      "userInputDisabled",
      "values",
      "vectorAdd",
      "vectorCos",
      "vectorCrossProduct",
      "vectorDiff",
      "vectorDir",
      "vectorDirVisual",
      "vectorDistance",
      "vectorDistanceSqr",
      "vectorDotProduct",
      "vectorFromTo",
      "vectorLinearConversion",
      "vectorMagnitude",
      "vectorMagnitudeSqr",
      "vectorModelToWorld",
      "vectorModelToWorldVisual",
      "vectorMultiply",
      "vectorNormalized",
      "vectorUp",
      "vectorUpVisual",
      "vectorWorldToModel",
      "vectorWorldToModelVisual",
      "vehicle",
      "vehicleCargoEnabled",
      "vehicleChat",
      "vehicleMoveInfo",
      "vehicleRadio",
      "vehicleReceiveRemoteTargets",
      "vehicleReportOwnPosition",
      "vehicleReportRemoteTargets",
      "vehicles",
      "vehicleVarName",
      "velocity",
      "velocityModelSpace",
      "verifySignature",
      "vest",
      "vestContainer",
      "vestItems",
      "vestMagazines",
      "viewDistance",
      "visibleCompass",
      "visibleGps",
      "visibleMap",
      "visiblePosition",
      "visiblePositionASL",
      "visibleScoretable",
      "visibleWatch",
      "waves",
      "waypointAttachedObject",
      "waypointAttachedVehicle",
      "waypointAttachObject",
      "waypointAttachVehicle",
      "waypointBehaviour",
      "waypointCombatMode",
      "waypointCompletionRadius",
      "waypointDescription",
      "waypointForceBehaviour",
      "waypointFormation",
      "waypointHousePosition",
      "waypointLoiterAltitude",
      "waypointLoiterRadius",
      "waypointLoiterType",
      "waypointName",
      "waypointPosition",
      "waypoints",
      "waypointScript",
      "waypointsEnabledUAV",
      "waypointShow",
      "waypointSpeed",
      "waypointStatements",
      "waypointTimeout",
      "waypointTimeoutCurrent",
      "waypointType",
      "waypointVisible",
      "weaponAccessories",
      "weaponAccessoriesCargo",
      "weaponCargo",
      "weaponDirection",
      "weaponInertia",
      "weaponLowered",
      "weaponReloadingTime",
      "weapons",
      "weaponsInfo",
      "weaponsItems",
      "weaponsItemsCargo",
      "weaponState",
      "weaponsTurret",
      "weightRTD",
      "WFSideText",
      "wind",
      "windDir",
      "windRTD",
      "windStr",
      "wingsForcesRTD",
      "worldName",
      "worldSize",
      "worldToModel",
      "worldToModelVisual",
      "worldToScreen"
    ], S = {
      className: "meta",
      begin: /#\s*[a-z]+\b/,
      end: /$/,
      keywords: "define undef ifdef ifndef else endif include if",
      contains: [
        {
          begin: /\\\n/,
          relevance: 0
        },
        i.inherit(r, { className: "string" }),
        {
          begin: /<[^\n>]*>/,
          end: /$/,
          illegal: "\\n"
        },
        i.C_LINE_COMMENT_MODE,
        i.C_BLOCK_COMMENT_MODE
      ]
    };
    return {
      name: "SQF",
      case_insensitive: !0,
      keywords: {
        keyword: e,
        built_in: h,
        literal: g
      },
      contains: [
        i.C_LINE_COMMENT_MODE,
        i.C_BLOCK_COMMENT_MODE,
        i.NUMBER_MODE,
        o,
        c,
        r,
        S
      ],
      illegal: [
        //$ is only valid when used with Hex numbers (e.g. $FF)
        /\$[^a-fA-F0-9]/,
        /\w\$/,
        /\?/,
        //There's no ? in SQF
        /@/,
        //There's no @ in SQF
        // Brute-force-fixing the build error. See https://github.com/highlightjs/highlight.js/pull/3193#issuecomment-843088729
        / \| /,
        // . is only used in numbers
        /[a-zA-Z_]\./,
        /\:\=/,
        /\[\:/
      ]
    };
  }
  return pp = s, pp;
}
var mp, VT;
function Xk() {
  if (VT)
    return mp;
  VT = 1;
  function s(i) {
    const o = i.regex, c = i.COMMENT("--", "$"), r = {
      className: "string",
      variants: [
        {
          begin: /'/,
          end: /'/,
          contains: [{ begin: /''/ }]
        }
      ]
    }, e = {
      begin: /"/,
      end: /"/,
      contains: [{ begin: /""/ }]
    }, g = [
      "true",
      "false",
      // Not sure it's correct to call NULL literal, and clauses like IS [NOT] NULL look strange that way.
      // "null",
      "unknown"
    ], h = [
      "double precision",
      "large object",
      "with timezone",
      "without timezone"
    ], S = [
      "bigint",
      "binary",
      "blob",
      "boolean",
      "char",
      "character",
      "clob",
      "date",
      "dec",
      "decfloat",
      "decimal",
      "float",
      "int",
      "integer",
      "interval",
      "nchar",
      "nclob",
      "national",
      "numeric",
      "real",
      "row",
      "smallint",
      "time",
      "timestamp",
      "varchar",
      "varying",
      // modifier (character varying)
      "varbinary"
    ], C = [
      "add",
      "asc",
      "collation",
      "desc",
      "final",
      "first",
      "last",
      "view"
    ], O = [
      "abs",
      "acos",
      "all",
      "allocate",
      "alter",
      "and",
      "any",
      "are",
      "array",
      "array_agg",
      "array_max_cardinality",
      "as",
      "asensitive",
      "asin",
      "asymmetric",
      "at",
      "atan",
      "atomic",
      "authorization",
      "avg",
      "begin",
      "begin_frame",
      "begin_partition",
      "between",
      "bigint",
      "binary",
      "blob",
      "boolean",
      "both",
      "by",
      "call",
      "called",
      "cardinality",
      "cascaded",
      "case",
      "cast",
      "ceil",
      "ceiling",
      "char",
      "char_length",
      "character",
      "character_length",
      "check",
      "classifier",
      "clob",
      "close",
      "coalesce",
      "collate",
      "collect",
      "column",
      "commit",
      "condition",
      "connect",
      "constraint",
      "contains",
      "convert",
      "copy",
      "corr",
      "corresponding",
      "cos",
      "cosh",
      "count",
      "covar_pop",
      "covar_samp",
      "create",
      "cross",
      "cube",
      "cume_dist",
      "current",
      "current_catalog",
      "current_date",
      "current_default_transform_group",
      "current_path",
      "current_role",
      "current_row",
      "current_schema",
      "current_time",
      "current_timestamp",
      "current_path",
      "current_role",
      "current_transform_group_for_type",
      "current_user",
      "cursor",
      "cycle",
      "date",
      "day",
      "deallocate",
      "dec",
      "decimal",
      "decfloat",
      "declare",
      "default",
      "define",
      "delete",
      "dense_rank",
      "deref",
      "describe",
      "deterministic",
      "disconnect",
      "distinct",
      "double",
      "drop",
      "dynamic",
      "each",
      "element",
      "else",
      "empty",
      "end",
      "end_frame",
      "end_partition",
      "end-exec",
      "equals",
      "escape",
      "every",
      "except",
      "exec",
      "execute",
      "exists",
      "exp",
      "external",
      "extract",
      "false",
      "fetch",
      "filter",
      "first_value",
      "float",
      "floor",
      "for",
      "foreign",
      "frame_row",
      "free",
      "from",
      "full",
      "function",
      "fusion",
      "get",
      "global",
      "grant",
      "group",
      "grouping",
      "groups",
      "having",
      "hold",
      "hour",
      "identity",
      "in",
      "indicator",
      "initial",
      "inner",
      "inout",
      "insensitive",
      "insert",
      "int",
      "integer",
      "intersect",
      "intersection",
      "interval",
      "into",
      "is",
      "join",
      "json_array",
      "json_arrayagg",
      "json_exists",
      "json_object",
      "json_objectagg",
      "json_query",
      "json_table",
      "json_table_primitive",
      "json_value",
      "lag",
      "language",
      "large",
      "last_value",
      "lateral",
      "lead",
      "leading",
      "left",
      "like",
      "like_regex",
      "listagg",
      "ln",
      "local",
      "localtime",
      "localtimestamp",
      "log",
      "log10",
      "lower",
      "match",
      "match_number",
      "match_recognize",
      "matches",
      "max",
      "member",
      "merge",
      "method",
      "min",
      "minute",
      "mod",
      "modifies",
      "module",
      "month",
      "multiset",
      "national",
      "natural",
      "nchar",
      "nclob",
      "new",
      "no",
      "none",
      "normalize",
      "not",
      "nth_value",
      "ntile",
      "null",
      "nullif",
      "numeric",
      "octet_length",
      "occurrences_regex",
      "of",
      "offset",
      "old",
      "omit",
      "on",
      "one",
      "only",
      "open",
      "or",
      "order",
      "out",
      "outer",
      "over",
      "overlaps",
      "overlay",
      "parameter",
      "partition",
      "pattern",
      "per",
      "percent",
      "percent_rank",
      "percentile_cont",
      "percentile_disc",
      "period",
      "portion",
      "position",
      "position_regex",
      "power",
      "precedes",
      "precision",
      "prepare",
      "primary",
      "procedure",
      "ptf",
      "range",
      "rank",
      "reads",
      "real",
      "recursive",
      "ref",
      "references",
      "referencing",
      "regr_avgx",
      "regr_avgy",
      "regr_count",
      "regr_intercept",
      "regr_r2",
      "regr_slope",
      "regr_sxx",
      "regr_sxy",
      "regr_syy",
      "release",
      "result",
      "return",
      "returns",
      "revoke",
      "right",
      "rollback",
      "rollup",
      "row",
      "row_number",
      "rows",
      "running",
      "savepoint",
      "scope",
      "scroll",
      "search",
      "second",
      "seek",
      "select",
      "sensitive",
      "session_user",
      "set",
      "show",
      "similar",
      "sin",
      "sinh",
      "skip",
      "smallint",
      "some",
      "specific",
      "specifictype",
      "sql",
      "sqlexception",
      "sqlstate",
      "sqlwarning",
      "sqrt",
      "start",
      "static",
      "stddev_pop",
      "stddev_samp",
      "submultiset",
      "subset",
      "substring",
      "substring_regex",
      "succeeds",
      "sum",
      "symmetric",
      "system",
      "system_time",
      "system_user",
      "table",
      "tablesample",
      "tan",
      "tanh",
      "then",
      "time",
      "timestamp",
      "timezone_hour",
      "timezone_minute",
      "to",
      "trailing",
      "translate",
      "translate_regex",
      "translation",
      "treat",
      "trigger",
      "trim",
      "trim_array",
      "true",
      "truncate",
      "uescape",
      "union",
      "unique",
      "unknown",
      "unnest",
      "update",
      "upper",
      "user",
      "using",
      "value",
      "values",
      "value_of",
      "var_pop",
      "var_samp",
      "varbinary",
      "varchar",
      "varying",
      "versioning",
      "when",
      "whenever",
      "where",
      "width_bucket",
      "window",
      "with",
      "within",
      "without",
      "year"
    ], N = [
      "abs",
      "acos",
      "array_agg",
      "asin",
      "atan",
      "avg",
      "cast",
      "ceil",
      "ceiling",
      "coalesce",
      "corr",
      "cos",
      "cosh",
      "count",
      "covar_pop",
      "covar_samp",
      "cume_dist",
      "dense_rank",
      "deref",
      "element",
      "exp",
      "extract",
      "first_value",
      "floor",
      "json_array",
      "json_arrayagg",
      "json_exists",
      "json_object",
      "json_objectagg",
      "json_query",
      "json_table",
      "json_table_primitive",
      "json_value",
      "lag",
      "last_value",
      "lead",
      "listagg",
      "ln",
      "log",
      "log10",
      "lower",
      "max",
      "min",
      "mod",
      "nth_value",
      "ntile",
      "nullif",
      "percent_rank",
      "percentile_cont",
      "percentile_disc",
      "position",
      "position_regex",
      "power",
      "rank",
      "regr_avgx",
      "regr_avgy",
      "regr_count",
      "regr_intercept",
      "regr_r2",
      "regr_slope",
      "regr_sxx",
      "regr_sxy",
      "regr_syy",
      "row_number",
      "sin",
      "sinh",
      "sqrt",
      "stddev_pop",
      "stddev_samp",
      "substring",
      "substring_regex",
      "sum",
      "tan",
      "tanh",
      "translate",
      "translate_regex",
      "treat",
      "trim",
      "trim_array",
      "unnest",
      "upper",
      "value_of",
      "var_pop",
      "var_samp",
      "width_bucket"
    ], D = [
      "current_catalog",
      "current_date",
      "current_default_transform_group",
      "current_path",
      "current_role",
      "current_schema",
      "current_transform_group_for_type",
      "current_user",
      "session_user",
      "system_time",
      "system_user",
      "current_time",
      "localtime",
      "current_timestamp",
      "localtimestamp"
    ], x = [
      "create table",
      "insert into",
      "primary key",
      "foreign key",
      "not null",
      "alter table",
      "add constraint",
      "grouping sets",
      "on overflow",
      "character set",
      "respect nulls",
      "ignore nulls",
      "nulls first",
      "nulls last",
      "depth first",
      "breadth first"
    ], L = N, G = [
      ...O,
      ...C
    ].filter((H) => !N.includes(H)), Y = {
      className: "variable",
      begin: /@[a-z0-9][a-z0-9_]*/
    }, k = {
      className: "operator",
      begin: /[-+*/=%^~]|&&?|\|\|?|!=?|<(?:=>?|<|>)?|>[>=]?/,
      relevance: 0
    }, W = {
      begin: o.concat(/\b/, o.either(...L), /\s*\(/),
      relevance: 0,
      keywords: { built_in: L }
    };
    function Z(H, {
      exceptions: K,
      when: Q
    } = {}) {
      const _e = Q;
      return K = K || [], H.map((se) => se.match(/\|\d+$/) || K.includes(se) ? se : _e(se) ? `${se}|0` : se);
    }
    return {
      name: "SQL",
      case_insensitive: !0,
      // does not include {} or HTML tags `</`
      illegal: /[{}]|<\//,
      keywords: {
        $pattern: /\b[\w\.]+/,
        keyword: Z(G, { when: (H) => H.length < 3 }),
        literal: g,
        type: S,
        built_in: D
      },
      contains: [
        {
          begin: o.either(...x),
          relevance: 0,
          keywords: {
            $pattern: /[\w\.]+/,
            keyword: G.concat(x),
            literal: g,
            type: S
          }
        },
        {
          className: "type",
          begin: o.either(...h)
        },
        W,
        Y,
        r,
        e,
        i.C_NUMBER_MODE,
        i.C_BLOCK_COMMENT_MODE,
        c,
        k
      ]
    };
  }
  return mp = s, mp;
}
var fp, YT;
function Zk() {
  if (YT)
    return fp;
  YT = 1;
  function s(i) {
    const o = i.regex, c = [
      "functions",
      "model",
      "data",
      "parameters",
      "quantities",
      "transformed",
      "generated"
    ], r = [
      "for",
      "in",
      "if",
      "else",
      "while",
      "break",
      "continue",
      "return"
    ], e = [
      "array",
      "tuple",
      "complex",
      "int",
      "real",
      "vector",
      "complex_vector",
      "ordered",
      "positive_ordered",
      "simplex",
      "unit_vector",
      "row_vector",
      "complex_row_vector",
      "matrix",
      "complex_matrix",
      "cholesky_factor_corr|10",
      "cholesky_factor_cov|10",
      "corr_matrix|10",
      "cov_matrix|10",
      "void"
    ], g = [
      "abs",
      "acos",
      "acosh",
      "add_diag",
      "algebra_solver",
      "algebra_solver_newton",
      "append_array",
      "append_col",
      "append_row",
      "asin",
      "asinh",
      "atan",
      "atan2",
      "atanh",
      "bessel_first_kind",
      "bessel_second_kind",
      "binary_log_loss",
      "block",
      "cbrt",
      "ceil",
      "chol2inv",
      "cholesky_decompose",
      "choose",
      "col",
      "cols",
      "columns_dot_product",
      "columns_dot_self",
      "complex_schur_decompose",
      "complex_schur_decompose_t",
      "complex_schur_decompose_u",
      "conj",
      "cos",
      "cosh",
      "cov_exp_quad",
      "crossprod",
      "csr_extract",
      "csr_extract_u",
      "csr_extract_v",
      "csr_extract_w",
      "csr_matrix_times_vector",
      "csr_to_dense_matrix",
      "cumulative_sum",
      "dae",
      "dae_tol",
      "determinant",
      "diag_matrix",
      "diagonal",
      "diag_post_multiply",
      "diag_pre_multiply",
      "digamma",
      "dims",
      "distance",
      "dot_product",
      "dot_self",
      "eigendecompose",
      "eigendecompose_sym",
      "eigenvalues",
      "eigenvalues_sym",
      "eigenvectors",
      "eigenvectors_sym",
      "erf",
      "erfc",
      "exp",
      "exp2",
      "expm1",
      "falling_factorial",
      "fdim",
      "fft",
      "fft2",
      "floor",
      "fma",
      "fmax",
      "fmin",
      "fmod",
      "gamma_p",
      "gamma_q",
      "generalized_inverse",
      "get_imag",
      "get_real",
      "head",
      "hmm_hidden_state_prob",
      "hmm_marginal",
      "hypot",
      "identity_matrix",
      "inc_beta",
      "integrate_1d",
      "integrate_ode",
      "integrate_ode_adams",
      "integrate_ode_bdf",
      "integrate_ode_rk45",
      "int_step",
      "inv",
      "inv_cloglog",
      "inv_erfc",
      "inverse",
      "inverse_spd",
      "inv_fft",
      "inv_fft2",
      "inv_inc_beta",
      "inv_logit",
      "inv_Phi",
      "inv_sqrt",
      "inv_square",
      "is_inf",
      "is_nan",
      "lambert_w0",
      "lambert_wm1",
      "lbeta",
      "lchoose",
      "ldexp",
      "lgamma",
      "linspaced_array",
      "linspaced_int_array",
      "linspaced_row_vector",
      "linspaced_vector",
      "lmgamma",
      "lmultiply",
      "log",
      "log1m",
      "log1m_exp",
      "log1m_inv_logit",
      "log1p",
      "log1p_exp",
      "log_determinant",
      "log_diff_exp",
      "log_falling_factorial",
      "log_inv_logit",
      "log_inv_logit_diff",
      "logit",
      "log_mix",
      "log_modified_bessel_first_kind",
      "log_rising_factorial",
      "log_softmax",
      "log_sum_exp",
      "machine_precision",
      "map_rect",
      "matrix_exp",
      "matrix_exp_multiply",
      "matrix_power",
      "max",
      "mdivide_left_spd",
      "mdivide_left_tri_low",
      "mdivide_right_spd",
      "mdivide_right_tri_low",
      "mean",
      "min",
      "modified_bessel_first_kind",
      "modified_bessel_second_kind",
      "multiply_lower_tri_self_transpose",
      "negative_infinity",
      "norm",
      "norm1",
      "norm2",
      "not_a_number",
      "num_elements",
      "ode_adams",
      "ode_adams_tol",
      "ode_adjoint_tol_ctl",
      "ode_bdf",
      "ode_bdf_tol",
      "ode_ckrk",
      "ode_ckrk_tol",
      "ode_rk45",
      "ode_rk45_tol",
      "one_hot_array",
      "one_hot_int_array",
      "one_hot_row_vector",
      "one_hot_vector",
      "ones_array",
      "ones_int_array",
      "ones_row_vector",
      "ones_vector",
      "owens_t",
      "Phi",
      "Phi_approx",
      "polar",
      "positive_infinity",
      "pow",
      "print",
      "prod",
      "proj",
      "qr",
      "qr_Q",
      "qr_R",
      "qr_thin",
      "qr_thin_Q",
      "qr_thin_R",
      "quad_form",
      "quad_form_diag",
      "quad_form_sym",
      "quantile",
      "rank",
      "reduce_sum",
      "reject",
      "rep_array",
      "rep_matrix",
      "rep_row_vector",
      "rep_vector",
      "reverse",
      "rising_factorial",
      "round",
      "row",
      "rows",
      "rows_dot_product",
      "rows_dot_self",
      "scale_matrix_exp_multiply",
      "sd",
      "segment",
      "sin",
      "singular_values",
      "sinh",
      "size",
      "softmax",
      "sort_asc",
      "sort_desc",
      "sort_indices_asc",
      "sort_indices_desc",
      "sqrt",
      "square",
      "squared_distance",
      "step",
      "sub_col",
      "sub_row",
      "sum",
      "svd",
      "svd_U",
      "svd_V",
      "symmetrize_from_lower_tri",
      "tail",
      "tan",
      "tanh",
      "target",
      "tcrossprod",
      "tgamma",
      "to_array_1d",
      "to_array_2d",
      "to_complex",
      "to_int",
      "to_matrix",
      "to_row_vector",
      "to_vector",
      "trace",
      "trace_gen_quad_form",
      "trace_quad_form",
      "trigamma",
      "trunc",
      "uniform_simplex",
      "variance",
      "zeros_array",
      "zeros_int_array",
      "zeros_row_vector"
    ], h = [
      "bernoulli",
      "bernoulli_logit",
      "bernoulli_logit_glm",
      "beta",
      "beta_binomial",
      "beta_proportion",
      "binomial",
      "binomial_logit",
      "categorical",
      "categorical_logit",
      "categorical_logit_glm",
      "cauchy",
      "chi_square",
      "dirichlet",
      "discrete_range",
      "double_exponential",
      "exp_mod_normal",
      "exponential",
      "frechet",
      "gamma",
      "gaussian_dlm_obs",
      "gumbel",
      "hmm_latent",
      "hypergeometric",
      "inv_chi_square",
      "inv_gamma",
      "inv_wishart",
      "inv_wishart_cholesky",
      "lkj_corr",
      "lkj_corr_cholesky",
      "logistic",
      "loglogistic",
      "lognormal",
      "multi_gp",
      "multi_gp_cholesky",
      "multinomial",
      "multinomial_logit",
      "multi_normal",
      "multi_normal_cholesky",
      "multi_normal_prec",
      "multi_student_cholesky_t",
      "multi_student_t",
      "multi_student_t_cholesky",
      "neg_binomial",
      "neg_binomial_2",
      "neg_binomial_2_log",
      "neg_binomial_2_log_glm",
      "normal",
      "normal_id_glm",
      "ordered_logistic",
      "ordered_logistic_glm",
      "ordered_probit",
      "pareto",
      "pareto_type_2",
      "poisson",
      "poisson_log",
      "poisson_log_glm",
      "rayleigh",
      "scaled_inv_chi_square",
      "skew_double_exponential",
      "skew_normal",
      "std_normal",
      "std_normal_log",
      "student_t",
      "uniform",
      "von_mises",
      "weibull",
      "wiener",
      "wishart",
      "wishart_cholesky"
    ], S = i.COMMENT(
      /\/\*/,
      /\*\//,
      {
        relevance: 0,
        contains: [
          {
            scope: "doctag",
            match: /@(return|param)/
          }
        ]
      }
    ), C = {
      scope: "meta",
      begin: /#include\b/,
      end: /$/,
      contains: [
        {
          match: /[a-z][a-z-._]+/,
          scope: "string"
        },
        i.C_LINE_COMMENT_MODE
      ]
    }, O = [
      "lower",
      "upper",
      "offset",
      "multiplier"
    ];
    return {
      name: "Stan",
      aliases: ["stanfuncs"],
      keywords: {
        $pattern: i.IDENT_RE,
        title: c,
        type: e,
        keyword: r,
        built_in: g
      },
      contains: [
        i.C_LINE_COMMENT_MODE,
        C,
        i.HASH_COMMENT_MODE,
        S,
        {
          scope: "built_in",
          match: /\s(pi|e|sqrt2|log2|log10)(?=\()/,
          relevance: 0
        },
        {
          match: o.concat(/[<,]\s*/, o.either(...O), /\s*=/),
          keywords: O
        },
        {
          scope: "keyword",
          match: /\btarget(?=\s*\+=)/
        },
        {
          // highlights the 'T' in T[,] for only Stan language distributrions
          match: [
            /~\s*/,
            o.either(...h),
            /(?:\(\))/,
            /\s*T(?=\s*\[)/
          ],
          scope: {
            2: "built_in",
            4: "keyword"
          }
        },
        {
          // highlights distributions that end with special endings
          scope: "built_in",
          keywords: h,
          begin: o.concat(/\w*/, o.either(...h), /(_lpdf|_lupdf|_lpmf|_cdf|_lcdf|_lccdf|_qf)(?=\s*[\(.*\)])/)
        },
        {
          // highlights distributions after ~
          begin: [
            /~/,
            /\s*/,
            o.concat(o.either(...h), /(?=\s*[\(.*\)])/)
          ],
          scope: { 3: "built_in" }
        },
        {
          // highlights user defined distributions after ~
          begin: [
            /~/,
            /\s*\w+(?=\s*[\(.*\)])/,
            "(?!.*/\b(" + o.either(...h) + ")\b)"
          ],
          scope: { 2: "title.function" }
        },
        {
          // highlights user defined distributions with special endings
          scope: "title.function",
          begin: /\w*(_lpdf|_lupdf|_lpmf|_cdf|_lcdf|_lccdf|_qf)(?=\s*[\(.*\)])/
        },
        {
          scope: "number",
          match: o.concat(
            // Comes from @RunDevelopment accessed 11/29/2021 at
            // https://github.com/PrismJS/prism/blob/c53ad2e65b7193ab4f03a1797506a54bbb33d5a2/components/prism-stan.js#L56
            // start of big noncapture group which
            // 1. gets numbers that are by themselves
            // 2. numbers that are separated by _
            // 3. numbers that are separted by .
            /(?:\b\d+(?:_\d+)*(?:\.(?:\d+(?:_\d+)*)?)?|\B\.\d+(?:_\d+)*)/,
            // grabs scientific notation
            // grabs complex numbers with i
            /(?:[eE][+-]?\d+(?:_\d+)*)?i?(?!\w)/
          ),
          relevance: 0
        },
        {
          scope: "string",
          begin: /"/,
          end: /"/
        }
      ]
    };
  }
  return fp = s, fp;
}
var gp, HT;
function jk() {
  if (HT)
    return gp;
  HT = 1;
  function s(i) {
    return {
      name: "Stata",
      aliases: [
        "do",
        "ado"
      ],
      case_insensitive: !0,
      keywords: "if else in foreach for forv forva forval forvalu forvalue forvalues by bys bysort xi quietly qui capture about ac ac_7 acprplot acprplot_7 adjust ado adopath adoupdate alpha ameans an ano anov anova anova_estat anova_terms anovadef aorder ap app appe appen append arch arch_dr arch_estat arch_p archlm areg areg_p args arima arima_dr arima_estat arima_p as asmprobit asmprobit_estat asmprobit_lf asmprobit_mfx__dlg asmprobit_p ass asse asser assert avplot avplot_7 avplots avplots_7 bcskew0 bgodfrey bias binreg bip0_lf biplot bipp_lf bipr_lf bipr_p biprobit bitest bitesti bitowt blogit bmemsize boot bootsamp bootstrap bootstrap_8 boxco_l boxco_p boxcox boxcox_6 boxcox_p bprobit br break brier bro brow brows browse brr brrstat bs bs_7 bsampl_w bsample bsample_7 bsqreg bstat bstat_7 bstat_8 bstrap bstrap_7 bubble bubbleplot ca ca_estat ca_p cabiplot camat canon canon_8 canon_8_p canon_estat canon_p cap caprojection capt captu captur capture cat cc cchart cchart_7 cci cd censobs_table centile cf char chdir checkdlgfiles checkestimationsample checkhlpfiles checksum chelp ci cii cl class classutil clear cli clis clist clo clog clog_lf clog_p clogi clogi_sw clogit clogit_lf clogit_p clogitp clogl_sw cloglog clonevar clslistarray cluster cluster_measures cluster_stop cluster_tree cluster_tree_8 clustermat cmdlog cnr cnre cnreg cnreg_p cnreg_sw cnsreg codebook collaps4 collapse colormult_nb colormult_nw compare compress conf confi confir confirm conren cons const constr constra constrai constrain constraint continue contract copy copyright copysource cor corc corr corr2data corr_anti corr_kmo corr_smc corre correl correla correlat correlate corrgram cou coun count cox cox_p cox_sw coxbase coxhaz coxvar cprplot cprplot_7 crc cret cretu cretur creturn cross cs cscript cscript_log csi ct ct_is ctset ctst_5 ctst_st cttost cumsp cumsp_7 cumul cusum cusum_7 cutil d|0 datasig datasign datasigna datasignat datasignatu datasignatur datasignature datetof db dbeta de dec deco decod decode deff des desc descr descri describ describe destring dfbeta dfgls dfuller di di_g dir dirstats dis discard disp disp_res disp_s displ displa display distinct do doe doed doedi doedit dotplot dotplot_7 dprobit drawnorm drop ds ds_util dstdize duplicates durbina dwstat dydx e|0 ed edi edit egen eivreg emdef en enc enco encod encode eq erase ereg ereg_lf ereg_p ereg_sw ereghet ereghet_glf ereghet_glf_sh ereghet_gp ereghet_ilf ereghet_ilf_sh ereghet_ip eret eretu eretur ereturn err erro error esize est est_cfexist est_cfname est_clickable est_expand est_hold est_table est_unhold est_unholdok estat estat_default estat_summ estat_vce_only esti estimates etodow etof etomdy ex exi exit expand expandcl fac fact facto factor factor_estat factor_p factor_pca_rotated factor_rotate factormat fcast fcast_compute fcast_graph fdades fdadesc fdadescr fdadescri fdadescrib fdadescribe fdasav fdasave fdause fh_st file open file read file close file filefilter fillin find_hlp_file findfile findit findit_7 fit fl fli flis flist for5_0 forest forestplot form forma format fpredict frac_154 frac_adj frac_chk frac_cox frac_ddp frac_dis frac_dv frac_in frac_mun frac_pp frac_pq frac_pv frac_wgt frac_xo fracgen fracplot fracplot_7 fracpoly fracpred fron_ex fron_hn fron_p fron_tn fron_tn2 frontier ftodate ftoe ftomdy ftowdate funnel funnelplot g|0 gamhet_glf gamhet_gp gamhet_ilf gamhet_ip gamma gamma_d2 gamma_p gamma_sw gammahet gdi_hexagon gdi_spokes ge gen gene gener genera generat generate genrank genstd genvmean gettoken gl gladder gladder_7 glim_l01 glim_l02 glim_l03 glim_l04 glim_l05 glim_l06 glim_l07 glim_l08 glim_l09 glim_l10 glim_l11 glim_l12 glim_lf glim_mu glim_nw1 glim_nw2 glim_nw3 glim_p glim_v1 glim_v2 glim_v3 glim_v4 glim_v5 glim_v6 glim_v7 glm glm_6 glm_p glm_sw glmpred glo glob globa global glogit glogit_8 glogit_p gmeans gnbre_lf gnbreg gnbreg_5 gnbreg_p gomp_lf gompe_sw gomper_p gompertz gompertzhet gomphet_glf gomphet_glf_sh gomphet_gp gomphet_ilf gomphet_ilf_sh gomphet_ip gphdot gphpen gphprint gprefs gprobi_p gprobit gprobit_8 gr gr7 gr_copy gr_current gr_db gr_describe gr_dir gr_draw gr_draw_replay gr_drop gr_edit gr_editviewopts gr_example gr_example2 gr_export gr_print gr_qscheme gr_query gr_read gr_rename gr_replay gr_save gr_set gr_setscheme gr_table gr_undo gr_use graph graph7 grebar greigen greigen_7 greigen_8 grmeanby grmeanby_7 gs_fileinfo gs_filetype gs_graphinfo gs_stat gsort gwood h|0 hadimvo hareg hausman haver he heck_d2 heckma_p heckman heckp_lf heckpr_p heckprob hel help hereg hetpr_lf hetpr_p hetprob hettest hexdump hilite hist hist_7 histogram hlogit hlu hmeans hotel hotelling hprobit hreg hsearch icd9 icd9_ff icd9p iis impute imtest inbase include inf infi infil infile infix inp inpu input ins insheet insp inspe inspec inspect integ inten intreg intreg_7 intreg_p intrg2_ll intrg_ll intrg_ll2 ipolate iqreg ir irf irf_create irfm iri is_svy is_svysum isid istdize ivprob_1_lf ivprob_lf ivprobit ivprobit_p ivreg ivreg_footnote ivtob_1_lf ivtob_lf ivtobit ivtobit_p jackknife jacknife jknife jknife_6 jknife_8 jkstat joinby kalarma1 kap kap_3 kapmeier kappa kapwgt kdensity kdensity_7 keep ksm ksmirnov ktau kwallis l|0 la lab labbe labbeplot labe label labelbook ladder levels levelsof leverage lfit lfit_p li lincom line linktest lis list lloghet_glf lloghet_glf_sh lloghet_gp lloghet_ilf lloghet_ilf_sh lloghet_ip llogi_sw llogis_p llogist llogistic llogistichet lnorm_lf lnorm_sw lnorma_p lnormal lnormalhet lnormhet_glf lnormhet_glf_sh lnormhet_gp lnormhet_ilf lnormhet_ilf_sh lnormhet_ip lnskew0 loadingplot loc loca local log logi logis_lf logistic logistic_p logit logit_estat logit_p loglogs logrank loneway lookfor lookup lowess lowess_7 lpredict lrecomp lroc lroc_7 lrtest ls lsens lsens_7 lsens_x lstat ltable ltable_7 ltriang lv lvr2plot lvr2plot_7 m|0 ma mac macr macro makecns man manova manova_estat manova_p manovatest mantel mark markin markout marksample mat mat_capp mat_order mat_put_rr mat_rapp mata mata_clear mata_describe mata_drop mata_matdescribe mata_matsave mata_matuse mata_memory mata_mlib mata_mosave mata_rename mata_which matalabel matcproc matlist matname matr matri matrix matrix_input__dlg matstrik mcc mcci md0_ md1_ md1debug_ md2_ md2debug_ mds mds_estat mds_p mdsconfig mdslong mdsmat mdsshepard mdytoe mdytof me_derd mean means median memory memsize menl meqparse mer merg merge meta mfp mfx mhelp mhodds minbound mixed_ll mixed_ll_reparm mkassert mkdir mkmat mkspline ml ml_5 ml_adjs ml_bhhhs ml_c_d ml_check ml_clear ml_cnt ml_debug ml_defd ml_e0 ml_e0_bfgs ml_e0_cycle ml_e0_dfp ml_e0i ml_e1 ml_e1_bfgs ml_e1_bhhh ml_e1_cycle ml_e1_dfp ml_e2 ml_e2_cycle ml_ebfg0 ml_ebfr0 ml_ebfr1 ml_ebh0q ml_ebhh0 ml_ebhr0 ml_ebr0i ml_ecr0i ml_edfp0 ml_edfr0 ml_edfr1 ml_edr0i ml_eds ml_eer0i ml_egr0i ml_elf ml_elf_bfgs ml_elf_bhhh ml_elf_cycle ml_elf_dfp ml_elfi ml_elfs ml_enr0i ml_enrr0 ml_erdu0 ml_erdu0_bfgs ml_erdu0_bhhh ml_erdu0_bhhhq ml_erdu0_cycle ml_erdu0_dfp ml_erdu0_nrbfgs ml_exde ml_footnote ml_geqnr ml_grad0 ml_graph ml_hbhhh ml_hd0 ml_hold ml_init ml_inv ml_log ml_max ml_mlout ml_mlout_8 ml_model ml_nb0 ml_opt ml_p ml_plot ml_query ml_rdgrd ml_repor ml_s_e ml_score ml_searc ml_technique ml_unhold mleval mlf_ mlmatbysum mlmatsum mlog mlogi mlogit mlogit_footnote mlogit_p mlopts mlsum mlvecsum mnl0_ mor more mov move mprobit mprobit_lf mprobit_p mrdu0_ mrdu1_ mvdecode mvencode mvreg mvreg_estat n|0 nbreg nbreg_al nbreg_lf nbreg_p nbreg_sw nestreg net newey newey_7 newey_p news nl nl_7 nl_9 nl_9_p nl_p nl_p_7 nlcom nlcom_p nlexp2 nlexp2_7 nlexp2a nlexp2a_7 nlexp3 nlexp3_7 nlgom3 nlgom3_7 nlgom4 nlgom4_7 nlinit nllog3 nllog3_7 nllog4 nllog4_7 nlog_rd nlogit nlogit_p nlogitgen nlogittree nlpred no nobreak noi nois noisi noisil noisily note notes notes_dlg nptrend numlabel numlist odbc old_ver olo olog ologi ologi_sw ologit ologit_p ologitp on one onew onewa oneway op_colnm op_comp op_diff op_inv op_str opr opro oprob oprob_sw oprobi oprobi_p oprobit oprobitp opts_exclusive order orthog orthpoly ou out outf outfi outfil outfile outs outsh outshe outshee outsheet ovtest pac pac_7 palette parse parse_dissim pause pca pca_8 pca_display pca_estat pca_p pca_rotate pcamat pchart pchart_7 pchi pchi_7 pcorr pctile pentium pergram pergram_7 permute permute_8 personal peto_st pkcollapse pkcross pkequiv pkexamine pkexamine_7 pkshape pksumm pksumm_7 pl plo plot plugin pnorm pnorm_7 poisgof poiss_lf poiss_sw poisso_p poisson poisson_estat post postclose postfile postutil pperron pr prais prais_e prais_e2 prais_p predict predictnl preserve print pro prob probi probit probit_estat probit_p proc_time procoverlay procrustes procrustes_estat procrustes_p profiler prog progr progra program prop proportion prtest prtesti pwcorr pwd q\\s qby qbys qchi qchi_7 qladder qladder_7 qnorm qnorm_7 qqplot qqplot_7 qreg qreg_c qreg_p qreg_sw qu quadchk quantile quantile_7 que quer query range ranksum ratio rchart rchart_7 rcof recast reclink recode reg reg3 reg3_p regdw regr regre regre_p2 regres regres_p regress regress_estat regriv_p remap ren rena renam rename renpfix repeat replace report reshape restore ret retu retur return rm rmdir robvar roccomp roccomp_7 roccomp_8 rocf_lf rocfit rocfit_8 rocgold rocplot rocplot_7 roctab roctab_7 rolling rologit rologit_p rot rota rotat rotate rotatemat rreg rreg_p ru run runtest rvfplot rvfplot_7 rvpplot rvpplot_7 sa safesum sample sampsi sav save savedresults saveold sc sca scal scala scalar scatter scm_mine sco scob_lf scob_p scobi_sw scobit scor score scoreplot scoreplot_help scree screeplot screeplot_help sdtest sdtesti se search separate seperate serrbar serrbar_7 serset set set_defaults sfrancia sh she shel shell shewhart shewhart_7 signestimationsample signrank signtest simul simul_7 simulate simulate_8 sktest sleep slogit slogit_d2 slogit_p smooth snapspan so sor sort spearman spikeplot spikeplot_7 spikeplt spline_x split sqreg sqreg_p sret sretu sretur sreturn ssc st st_ct st_hc st_hcd st_hcd_sh st_is st_issys st_note st_promo st_set st_show st_smpl st_subid stack statsby statsby_8 stbase stci stci_7 stcox stcox_estat stcox_fr stcox_fr_ll stcox_p stcox_sw stcoxkm stcoxkm_7 stcstat stcurv stcurve stcurve_7 stdes stem stepwise stereg stfill stgen stir stjoin stmc stmh stphplot stphplot_7 stphtest stphtest_7 stptime strate strate_7 streg streg_sw streset sts sts_7 stset stsplit stsum sttocc sttoct stvary stweib su suest suest_8 sum summ summa summar summari summariz summarize sunflower sureg survcurv survsum svar svar_p svmat svy svy_disp svy_dreg svy_est svy_est_7 svy_estat svy_get svy_gnbreg_p svy_head svy_header svy_heckman_p svy_heckprob_p svy_intreg_p svy_ivreg_p svy_logistic_p svy_logit_p svy_mlogit_p svy_nbreg_p svy_ologit_p svy_oprobit_p svy_poisson_p svy_probit_p svy_regress_p svy_sub svy_sub_7 svy_x svy_x_7 svy_x_p svydes svydes_8 svygen svygnbreg svyheckman svyheckprob svyintreg svyintreg_7 svyintrg svyivreg svylc svylog_p svylogit svymarkout svymarkout_8 svymean svymlog svymlogit svynbreg svyolog svyologit svyoprob svyoprobit svyopts svypois svypois_7 svypoisson svyprobit svyprobt svyprop svyprop_7 svyratio svyreg svyreg_p svyregress svyset svyset_7 svyset_8 svytab svytab_7 svytest svytotal sw sw_8 swcnreg swcox swereg swilk swlogis swlogit swologit swoprbt swpois swprobit swqreg swtobit swweib symmetry symmi symplot symplot_7 syntax sysdescribe sysdir sysuse szroeter ta tab tab1 tab2 tab_or tabd tabdi tabdis tabdisp tabi table tabodds tabodds_7 tabstat tabu tabul tabula tabulat tabulate te tempfile tempname tempvar tes test testnl testparm teststd tetrachoric time_it timer tis tob tobi tobit tobit_p tobit_sw token tokeni tokeniz tokenize tostring total translate translator transmap treat_ll treatr_p treatreg trim trimfill trnb_cons trnb_mean trpoiss_d2 trunc_ll truncr_p truncreg tsappend tset tsfill tsline tsline_ex tsreport tsrevar tsrline tsset tssmooth tsunab ttest ttesti tut_chk tut_wait tutorial tw tware_st two twoway twoway__fpfit_serset twoway__function_gen twoway__histogram_gen twoway__ipoint_serset twoway__ipoints_serset twoway__kdensity_gen twoway__lfit_serset twoway__normgen_gen twoway__pci_serset twoway__qfit_serset twoway__scatteri_serset twoway__sunflower_gen twoway_ksm_serset ty typ type typeof u|0 unab unabbrev unabcmd update us use uselabel var var_mkcompanion var_p varbasic varfcast vargranger varirf varirf_add varirf_cgraph varirf_create varirf_ctable varirf_describe varirf_dir varirf_drop varirf_erase varirf_graph varirf_ograph varirf_rename varirf_set varirf_table varlist varlmar varnorm varsoc varstable varstable_w varstable_w2 varwle vce vec vec_fevd vec_mkphi vec_p vec_p_w vecirf_create veclmar veclmar_w vecnorm vecnorm_w vecrank vecstable verinst vers versi versio version view viewsource vif vwls wdatetof webdescribe webseek webuse weib1_lf weib2_lf weib_lf weib_lf0 weibhet_glf weibhet_glf_sh weibhet_glfa weibhet_glfa_sh weibhet_gp weibhet_ilf weibhet_ilf_sh weibhet_ilfa weibhet_ilfa_sh weibhet_ip weibu_sw weibul_p weibull weibull_c weibull_s weibullhet wh whelp whi which whil while wilc_st wilcoxon win wind windo window winexec wntestb wntestb_7 wntestq xchart xchart_7 xcorr xcorr_7 xi xi_6 xmlsav xmlsave xmluse xpose xsh xshe xshel xshell xt_iis xt_tis xtab_p xtabond xtbin_p xtclog xtcloglog xtcloglog_8 xtcloglog_d2 xtcloglog_pa_p xtcloglog_re_p xtcnt_p xtcorr xtdata xtdes xtfront_p xtfrontier xtgee xtgee_elink xtgee_estat xtgee_makeivar xtgee_p xtgee_plink xtgls xtgls_p xthaus xthausman xtht_p xthtaylor xtile xtint_p xtintreg xtintreg_8 xtintreg_d2 xtintreg_p xtivp_1 xtivp_2 xtivreg xtline xtline_ex xtlogit xtlogit_8 xtlogit_d2 xtlogit_fe_p xtlogit_pa_p xtlogit_re_p xtmixed xtmixed_estat xtmixed_p xtnb_fe xtnb_lf xtnbreg xtnbreg_pa_p xtnbreg_refe_p xtpcse xtpcse_p xtpois xtpoisson xtpoisson_d2 xtpoisson_pa_p xtpoisson_refe_p xtpred xtprobit xtprobit_8 xtprobit_d2 xtprobit_re_p xtps_fe xtps_lf xtps_ren xtps_ren_8 xtrar_p xtrc xtrc_p xtrchh xtrefe_p xtreg xtreg_be xtreg_fe xtreg_ml xtreg_pa_p xtreg_re xtregar xtrere_p xtset xtsf_ll xtsf_llti xtsum xttab xttest0 xttobit xttobit_8 xttobit_p xttrans yx yxview__barlike_draw yxview_area_draw yxview_bar_draw yxview_dot_draw yxview_dropline_draw yxview_function_draw yxview_iarrow_draw yxview_ilabels_draw yxview_normal_draw yxview_pcarrow_draw yxview_pcbarrow_draw yxview_pccapsym_draw yxview_pcscatter_draw yxview_pcspike_draw yxview_rarea_draw yxview_rbar_draw yxview_rbarm_draw yxview_rcap_draw yxview_rcapsym_draw yxview_rconnected_draw yxview_rline_draw yxview_rscatter_draw yxview_rspike_draw yxview_spike_draw yxview_sunflower_draw zap_s zinb zinb_llf zinb_plf zip zip_llf zip_p zip_plf zt_ct_5 zt_hc_5 zt_hcd_5 zt_is_5 zt_iss_5 zt_sho_5 zt_smp_5 ztbase_5 ztcox_5 ztdes_5 ztereg_5 ztfill_5 ztgen_5 ztir_5 ztjoin_5 ztnb ztnb_p ztp ztp_p zts_5 ztset_5 ztspli_5 ztsum_5 zttoct_5 ztvary_5 ztweib_5",
      contains: [
        {
          className: "symbol",
          begin: /`[a-zA-Z0-9_]+'/
        },
        {
          className: "variable",
          begin: /\$\{?[a-zA-Z0-9_]+\}?/,
          relevance: 0
        },
        {
          className: "string",
          variants: [
            { begin: `\`"[^\r
]*?"'` },
            { begin: `"[^\r
"]*"` }
          ]
        },
        {
          className: "built_in",
          variants: [{ begin: "\\b(abs|acos|asin|atan|atan2|atanh|ceil|cloglog|comb|cos|digamma|exp|floor|invcloglog|invlogit|ln|lnfact|lnfactorial|lngamma|log|log10|max|min|mod|reldif|round|sign|sin|sqrt|sum|tan|tanh|trigamma|trunc|betaden|Binomial|binorm|binormal|chi2|chi2tail|dgammapda|dgammapdada|dgammapdadx|dgammapdx|dgammapdxdx|F|Fden|Ftail|gammaden|gammap|ibeta|invbinomial|invchi2|invchi2tail|invF|invFtail|invgammap|invibeta|invnchi2|invnFtail|invnibeta|invnorm|invnormal|invttail|nbetaden|nchi2|nFden|nFtail|nibeta|norm|normal|normalden|normd|npnchi2|tden|ttail|uniform|abbrev|char|index|indexnot|length|lower|ltrim|match|plural|proper|real|regexm|regexr|regexs|reverse|rtrim|string|strlen|strlower|strltrim|strmatch|strofreal|strpos|strproper|strreverse|strrtrim|strtrim|strupper|subinstr|subinword|substr|trim|upper|word|wordcount|_caller|autocode|byteorder|chop|clip|cond|e|epsdouble|epsfloat|group|inlist|inrange|irecode|matrix|maxbyte|maxdouble|maxfloat|maxint|maxlong|mi|minbyte|mindouble|minfloat|minint|minlong|missing|r|recode|replay|return|s|scalar|d|date|day|dow|doy|halfyear|mdy|month|quarter|week|year|d|daily|dofd|dofh|dofm|dofq|dofw|dofy|h|halfyearly|hofd|m|mofd|monthly|q|qofd|quarterly|tin|twithin|w|weekly|wofd|y|yearly|yh|ym|yofd|yq|yw|cholesky|colnumb|colsof|corr|det|diag|diag0cnt|el|get|hadamard|I|inv|invsym|issym|issymmetric|J|matmissing|matuniform|mreldif|nullmat|rownumb|rowsof|sweep|syminv|trace|vec|vecdiag)(?=\\()" }]
        },
        i.COMMENT("^[ 	]*\\*.*$", !1),
        i.C_LINE_COMMENT_MODE,
        i.C_BLOCK_COMMENT_MODE
      ]
    };
  }
  return gp = s, gp;
}
var Ep, qT;
function Jk() {
  if (qT)
    return Ep;
  qT = 1;
  function s(i) {
    return {
      name: "STEP Part 21",
      aliases: [
        "p21",
        "step",
        "stp"
      ],
      case_insensitive: !0,
      // STEP 21 is case insensitive in theory, in practice all non-comments are capitalized.
      keywords: {
        $pattern: "[A-Z_][A-Z0-9_.]*",
        keyword: [
          "HEADER",
          "ENDSEC",
          "DATA"
        ]
      },
      contains: [
        {
          className: "meta",
          begin: "ISO-10303-21;",
          relevance: 10
        },
        {
          className: "meta",
          begin: "END-ISO-10303-21;",
          relevance: 10
        },
        i.C_LINE_COMMENT_MODE,
        i.C_BLOCK_COMMENT_MODE,
        i.COMMENT("/\\*\\*!", "\\*/"),
        i.C_NUMBER_MODE,
        i.inherit(i.APOS_STRING_MODE, { illegal: null }),
        i.inherit(i.QUOTE_STRING_MODE, { illegal: null }),
        {
          className: "string",
          begin: "'",
          end: "'"
        },
        {
          className: "symbol",
          variants: [
            {
              begin: "#",
              end: "\\d+",
              illegal: "\\W"
            }
          ]
        }
      ]
    };
  }
  return Ep = s, Ep;
}
var hp, $T;
function eF() {
  if ($T)
    return hp;
  $T = 1;
  const s = (h) => ({
    IMPORTANT: {
      scope: "meta",
      begin: "!important"
    },
    BLOCK_COMMENT: h.C_BLOCK_COMMENT_MODE,
    HEXCOLOR: {
      scope: "number",
      begin: /#(([0-9a-fA-F]{3,4})|(([0-9a-fA-F]{2}){3,4}))\b/
    },
    FUNCTION_DISPATCH: {
      className: "built_in",
      begin: /[\w-]+(?=\()/
    },
    ATTRIBUTE_SELECTOR_MODE: {
      scope: "selector-attr",
      begin: /\[/,
      end: /\]/,
      illegal: "$",
      contains: [
        h.APOS_STRING_MODE,
        h.QUOTE_STRING_MODE
      ]
    },
    CSS_NUMBER_MODE: {
      scope: "number",
      begin: h.NUMBER_RE + "(%|em|ex|ch|rem|vw|vh|vmin|vmax|cm|mm|in|pt|pc|px|deg|grad|rad|turn|s|ms|Hz|kHz|dpi|dpcm|dppx)?",
      relevance: 0
    },
    CSS_VARIABLE: {
      className: "attr",
      begin: /--[A-Za-z_][A-Za-z0-9_-]*/
    }
  }), i = [
    "a",
    "abbr",
    "address",
    "article",
    "aside",
    "audio",
    "b",
    "blockquote",
    "body",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "dd",
    "del",
    "details",
    "dfn",
    "div",
    "dl",
    "dt",
    "em",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "header",
    "hgroup",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "label",
    "legend",
    "li",
    "main",
    "mark",
    "menu",
    "nav",
    "object",
    "ol",
    "p",
    "q",
    "quote",
    "samp",
    "section",
    "span",
    "strong",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "tr",
    "ul",
    "var",
    "video"
  ], o = [
    "any-hover",
    "any-pointer",
    "aspect-ratio",
    "color",
    "color-gamut",
    "color-index",
    "device-aspect-ratio",
    "device-height",
    "device-width",
    "display-mode",
    "forced-colors",
    "grid",
    "height",
    "hover",
    "inverted-colors",
    "monochrome",
    "orientation",
    "overflow-block",
    "overflow-inline",
    "pointer",
    "prefers-color-scheme",
    "prefers-contrast",
    "prefers-reduced-motion",
    "prefers-reduced-transparency",
    "resolution",
    "scan",
    "scripting",
    "update",
    "width",
    // TODO: find a better solution?
    "min-width",
    "max-width",
    "min-height",
    "max-height"
  ], c = [
    "active",
    "any-link",
    "blank",
    "checked",
    "current",
    "default",
    "defined",
    "dir",
    // dir()
    "disabled",
    "drop",
    "empty",
    "enabled",
    "first",
    "first-child",
    "first-of-type",
    "fullscreen",
    "future",
    "focus",
    "focus-visible",
    "focus-within",
    "has",
    // has()
    "host",
    // host or host()
    "host-context",
    // host-context()
    "hover",
    "indeterminate",
    "in-range",
    "invalid",
    "is",
    // is()
    "lang",
    // lang()
    "last-child",
    "last-of-type",
    "left",
    "link",
    "local-link",
    "not",
    // not()
    "nth-child",
    // nth-child()
    "nth-col",
    // nth-col()
    "nth-last-child",
    // nth-last-child()
    "nth-last-col",
    // nth-last-col()
    "nth-last-of-type",
    //nth-last-of-type()
    "nth-of-type",
    //nth-of-type()
    "only-child",
    "only-of-type",
    "optional",
    "out-of-range",
    "past",
    "placeholder-shown",
    "read-only",
    "read-write",
    "required",
    "right",
    "root",
    "scope",
    "target",
    "target-within",
    "user-invalid",
    "valid",
    "visited",
    "where"
    // where()
  ], r = [
    "after",
    "backdrop",
    "before",
    "cue",
    "cue-region",
    "first-letter",
    "first-line",
    "grammar-error",
    "marker",
    "part",
    "placeholder",
    "selection",
    "slotted",
    "spelling-error"
  ], e = [
    "align-content",
    "align-items",
    "align-self",
    "all",
    "animation",
    "animation-delay",
    "animation-direction",
    "animation-duration",
    "animation-fill-mode",
    "animation-iteration-count",
    "animation-name",
    "animation-play-state",
    "animation-timing-function",
    "backface-visibility",
    "background",
    "background-attachment",
    "background-blend-mode",
    "background-clip",
    "background-color",
    "background-image",
    "background-origin",
    "background-position",
    "background-repeat",
    "background-size",
    "block-size",
    "border",
    "border-block",
    "border-block-color",
    "border-block-end",
    "border-block-end-color",
    "border-block-end-style",
    "border-block-end-width",
    "border-block-start",
    "border-block-start-color",
    "border-block-start-style",
    "border-block-start-width",
    "border-block-style",
    "border-block-width",
    "border-bottom",
    "border-bottom-color",
    "border-bottom-left-radius",
    "border-bottom-right-radius",
    "border-bottom-style",
    "border-bottom-width",
    "border-collapse",
    "border-color",
    "border-image",
    "border-image-outset",
    "border-image-repeat",
    "border-image-slice",
    "border-image-source",
    "border-image-width",
    "border-inline",
    "border-inline-color",
    "border-inline-end",
    "border-inline-end-color",
    "border-inline-end-style",
    "border-inline-end-width",
    "border-inline-start",
    "border-inline-start-color",
    "border-inline-start-style",
    "border-inline-start-width",
    "border-inline-style",
    "border-inline-width",
    "border-left",
    "border-left-color",
    "border-left-style",
    "border-left-width",
    "border-radius",
    "border-right",
    "border-right-color",
    "border-right-style",
    "border-right-width",
    "border-spacing",
    "border-style",
    "border-top",
    "border-top-color",
    "border-top-left-radius",
    "border-top-right-radius",
    "border-top-style",
    "border-top-width",
    "border-width",
    "bottom",
    "box-decoration-break",
    "box-shadow",
    "box-sizing",
    "break-after",
    "break-before",
    "break-inside",
    "caption-side",
    "caret-color",
    "clear",
    "clip",
    "clip-path",
    "clip-rule",
    "color",
    "column-count",
    "column-fill",
    "column-gap",
    "column-rule",
    "column-rule-color",
    "column-rule-style",
    "column-rule-width",
    "column-span",
    "column-width",
    "columns",
    "contain",
    "content",
    "content-visibility",
    "counter-increment",
    "counter-reset",
    "cue",
    "cue-after",
    "cue-before",
    "cursor",
    "direction",
    "display",
    "empty-cells",
    "filter",
    "flex",
    "flex-basis",
    "flex-direction",
    "flex-flow",
    "flex-grow",
    "flex-shrink",
    "flex-wrap",
    "float",
    "flow",
    "font",
    "font-display",
    "font-family",
    "font-feature-settings",
    "font-kerning",
    "font-language-override",
    "font-size",
    "font-size-adjust",
    "font-smoothing",
    "font-stretch",
    "font-style",
    "font-synthesis",
    "font-variant",
    "font-variant-caps",
    "font-variant-east-asian",
    "font-variant-ligatures",
    "font-variant-numeric",
    "font-variant-position",
    "font-variation-settings",
    "font-weight",
    "gap",
    "glyph-orientation-vertical",
    "grid",
    "grid-area",
    "grid-auto-columns",
    "grid-auto-flow",
    "grid-auto-rows",
    "grid-column",
    "grid-column-end",
    "grid-column-start",
    "grid-gap",
    "grid-row",
    "grid-row-end",
    "grid-row-start",
    "grid-template",
    "grid-template-areas",
    "grid-template-columns",
    "grid-template-rows",
    "hanging-punctuation",
    "height",
    "hyphens",
    "icon",
    "image-orientation",
    "image-rendering",
    "image-resolution",
    "ime-mode",
    "inline-size",
    "isolation",
    "justify-content",
    "left",
    "letter-spacing",
    "line-break",
    "line-height",
    "list-style",
    "list-style-image",
    "list-style-position",
    "list-style-type",
    "margin",
    "margin-block",
    "margin-block-end",
    "margin-block-start",
    "margin-bottom",
    "margin-inline",
    "margin-inline-end",
    "margin-inline-start",
    "margin-left",
    "margin-right",
    "margin-top",
    "marks",
    "mask",
    "mask-border",
    "mask-border-mode",
    "mask-border-outset",
    "mask-border-repeat",
    "mask-border-slice",
    "mask-border-source",
    "mask-border-width",
    "mask-clip",
    "mask-composite",
    "mask-image",
    "mask-mode",
    "mask-origin",
    "mask-position",
    "mask-repeat",
    "mask-size",
    "mask-type",
    "max-block-size",
    "max-height",
    "max-inline-size",
    "max-width",
    "min-block-size",
    "min-height",
    "min-inline-size",
    "min-width",
    "mix-blend-mode",
    "nav-down",
    "nav-index",
    "nav-left",
    "nav-right",
    "nav-up",
    "none",
    "normal",
    "object-fit",
    "object-position",
    "opacity",
    "order",
    "orphans",
    "outline",
    "outline-color",
    "outline-offset",
    "outline-style",
    "outline-width",
    "overflow",
    "overflow-wrap",
    "overflow-x",
    "overflow-y",
    "padding",
    "padding-block",
    "padding-block-end",
    "padding-block-start",
    "padding-bottom",
    "padding-inline",
    "padding-inline-end",
    "padding-inline-start",
    "padding-left",
    "padding-right",
    "padding-top",
    "page-break-after",
    "page-break-before",
    "page-break-inside",
    "pause",
    "pause-after",
    "pause-before",
    "perspective",
    "perspective-origin",
    "pointer-events",
    "position",
    "quotes",
    "resize",
    "rest",
    "rest-after",
    "rest-before",
    "right",
    "row-gap",
    "scroll-margin",
    "scroll-margin-block",
    "scroll-margin-block-end",
    "scroll-margin-block-start",
    "scroll-margin-bottom",
    "scroll-margin-inline",
    "scroll-margin-inline-end",
    "scroll-margin-inline-start",
    "scroll-margin-left",
    "scroll-margin-right",
    "scroll-margin-top",
    "scroll-padding",
    "scroll-padding-block",
    "scroll-padding-block-end",
    "scroll-padding-block-start",
    "scroll-padding-bottom",
    "scroll-padding-inline",
    "scroll-padding-inline-end",
    "scroll-padding-inline-start",
    "scroll-padding-left",
    "scroll-padding-right",
    "scroll-padding-top",
    "scroll-snap-align",
    "scroll-snap-stop",
    "scroll-snap-type",
    "scrollbar-color",
    "scrollbar-gutter",
    "scrollbar-width",
    "shape-image-threshold",
    "shape-margin",
    "shape-outside",
    "speak",
    "speak-as",
    "src",
    // @font-face
    "tab-size",
    "table-layout",
    "text-align",
    "text-align-all",
    "text-align-last",
    "text-combine-upright",
    "text-decoration",
    "text-decoration-color",
    "text-decoration-line",
    "text-decoration-style",
    "text-emphasis",
    "text-emphasis-color",
    "text-emphasis-position",
    "text-emphasis-style",
    "text-indent",
    "text-justify",
    "text-orientation",
    "text-overflow",
    "text-rendering",
    "text-shadow",
    "text-transform",
    "text-underline-position",
    "top",
    "transform",
    "transform-box",
    "transform-origin",
    "transform-style",
    "transition",
    "transition-delay",
    "transition-duration",
    "transition-property",
    "transition-timing-function",
    "unicode-bidi",
    "vertical-align",
    "visibility",
    "voice-balance",
    "voice-duration",
    "voice-family",
    "voice-pitch",
    "voice-range",
    "voice-rate",
    "voice-stress",
    "voice-volume",
    "white-space",
    "widows",
    "width",
    "will-change",
    "word-break",
    "word-spacing",
    "word-wrap",
    "writing-mode",
    "z-index"
    // reverse makes sure longer attributes `font-weight` are matched fully
    // instead of getting false positives on say `font`
  ].reverse();
  function g(h) {
    const S = s(h), C = "and or not only", O = {
      className: "variable",
      begin: "\\$" + h.IDENT_RE
    }, N = [
      "charset",
      "css",
      "debug",
      "extend",
      "font-face",
      "for",
      "import",
      "include",
      "keyframes",
      "media",
      "mixin",
      "page",
      "warn",
      "while"
    ], D = "(?=[.\\s\\n[:,(])";
    return {
      name: "Stylus",
      aliases: ["styl"],
      case_insensitive: !1,
      keywords: "if else for in",
      illegal: "(" + [
        "\\?",
        "(\\bReturn\\b)",
        // monkey
        "(\\bEnd\\b)",
        // monkey
        "(\\bend\\b)",
        // vbscript
        "(\\bdef\\b)",
        // gradle
        ";",
        // a whole lot of languages
        "#\\s",
        // markdown
        "\\*\\s",
        // markdown
        "===\\s",
        // markdown
        "\\|",
        "%"
        // prolog
      ].join("|") + ")",
      contains: [
        // strings
        h.QUOTE_STRING_MODE,
        h.APOS_STRING_MODE,
        // comments
        h.C_LINE_COMMENT_MODE,
        h.C_BLOCK_COMMENT_MODE,
        // hex colors
        S.HEXCOLOR,
        // class tag
        {
          begin: "\\.[a-zA-Z][a-zA-Z0-9_-]*" + D,
          className: "selector-class"
        },
        // id tag
        {
          begin: "#[a-zA-Z][a-zA-Z0-9_-]*" + D,
          className: "selector-id"
        },
        // tags
        {
          begin: "\\b(" + i.join("|") + ")" + D,
          className: "selector-tag"
        },
        // psuedo selectors
        {
          className: "selector-pseudo",
          begin: "&?:(" + c.join("|") + ")" + D
        },
        {
          className: "selector-pseudo",
          begin: "&?:(:)?(" + r.join("|") + ")" + D
        },
        S.ATTRIBUTE_SELECTOR_MODE,
        {
          className: "keyword",
          begin: /@media/,
          starts: {
            end: /[{;}]/,
            keywords: {
              $pattern: /[a-z-]+/,
              keyword: C,
              attribute: o.join(" ")
            },
            contains: [S.CSS_NUMBER_MODE]
          }
        },
        // @ keywords
        {
          className: "keyword",
          begin: "@((-(o|moz|ms|webkit)-)?(" + N.join("|") + "))\\b"
        },
        // variables
        O,
        // dimension
        S.CSS_NUMBER_MODE,
        // functions
        //  - only from beginning of line + whitespace
        {
          className: "function",
          begin: "^[a-zA-Z][a-zA-Z0-9_-]*\\(.*\\)",
          illegal: "[\\n]",
          returnBegin: !0,
          contains: [
            {
              className: "title",
              begin: "\\b[a-zA-Z][a-zA-Z0-9_-]*"
            },
            {
              className: "params",
              begin: /\(/,
              end: /\)/,
              contains: [
                S.HEXCOLOR,
                O,
                h.APOS_STRING_MODE,
                S.CSS_NUMBER_MODE,
                h.QUOTE_STRING_MODE
              ]
            }
          ]
        },
        // css variables
        S.CSS_VARIABLE,
        // attributes
        //  - only from beginning of line + whitespace
        //  - must have whitespace after it
        {
          className: "attribute",
          begin: "\\b(" + e.join("|") + ")\\b",
          starts: {
            // value container
            end: /;|$/,
            contains: [
              S.HEXCOLOR,
              O,
              h.APOS_STRING_MODE,
              h.QUOTE_STRING_MODE,
              S.CSS_NUMBER_MODE,
              h.C_BLOCK_COMMENT_MODE,
              S.IMPORTANT,
              S.FUNCTION_DISPATCH
            ],
            illegal: /\./,
            relevance: 0
          }
        },
        S.FUNCTION_DISPATCH
      ]
    };
  }
  return hp = g, hp;
}
var Sp, WT;
function tF() {
  if (WT)
    return Sp;
  WT = 1;
  function s(i) {
    return {
      name: "SubUnit",
      case_insensitive: !0,
      contains: [
        {
          className: "string",
          begin: `\\[
(multipart)?`,
          end: `\\]
`
        },
        {
          className: "string",
          begin: "\\d{4}-\\d{2}-\\d{2}(\\s+)\\d{2}:\\d{2}:\\d{2}.\\d+Z"
        },
        {
          className: "string",
          begin: "(\\+|-)\\d+"
        },
        {
          className: "keyword",
          relevance: 10,
          variants: [
            { begin: "^(test|testing|success|successful|failure|error|skip|xfail|uxsuccess)(:?)\\s+(test)?" },
            { begin: "^progress(:?)(\\s+)?(pop|push)?" },
            { begin: "^tags:" },
            { begin: "^time:" }
          ]
        }
      ]
    };
  }
  return Sp = s, Sp;
}
var bp, zT;
function rF() {
  if (zT)
    return bp;
  zT = 1;
  function s(se) {
    return se ? typeof se == "string" ? se : se.source : null;
  }
  function i(se) {
    return o("(?=", se, ")");
  }
  function o(...se) {
    return se.map((Ke) => s(Ke)).join("");
  }
  function c(se) {
    const Pe = se[se.length - 1];
    return typeof Pe == "object" && Pe.constructor === Object ? (se.splice(se.length - 1, 1), Pe) : {};
  }
  function r(...se) {
    return "(" + (c(se).capture ? "" : "?:") + se.map((ye) => s(ye)).join("|") + ")";
  }
  const e = (se) => o(
    /\b/,
    se,
    /\w$/.test(se) ? /\b/ : /\B/
  ), g = [
    "Protocol",
    // contextual
    "Type"
    // contextual
  ].map(e), h = [
    "init",
    "self"
  ].map(e), S = [
    "Any",
    "Self"
  ], C = [
    // strings below will be fed into the regular `keywords` engine while regex
    // will result in additional modes being created to scan for those keywords to
    // avoid conflicts with other rules
    "actor",
    "any",
    // contextual
    "associatedtype",
    "async",
    "await",
    /as\?/,
    // operator
    /as!/,
    // operator
    "as",
    // operator
    "borrowing",
    // contextual
    "break",
    "case",
    "catch",
    "class",
    "consume",
    // contextual
    "consuming",
    // contextual
    "continue",
    "convenience",
    // contextual
    "copy",
    // contextual
    "default",
    "defer",
    "deinit",
    "didSet",
    // contextual
    "distributed",
    "do",
    "dynamic",
    // contextual
    "each",
    "else",
    "enum",
    "extension",
    "fallthrough",
    /fileprivate\(set\)/,
    "fileprivate",
    "final",
    // contextual
    "for",
    "func",
    "get",
    // contextual
    "guard",
    "if",
    "import",
    "indirect",
    // contextual
    "infix",
    // contextual
    /init\?/,
    /init!/,
    "inout",
    /internal\(set\)/,
    "internal",
    "in",
    "is",
    // operator
    "isolated",
    // contextual
    "nonisolated",
    // contextual
    "lazy",
    // contextual
    "let",
    "macro",
    "mutating",
    // contextual
    "nonmutating",
    // contextual
    /open\(set\)/,
    // contextual
    "open",
    // contextual
    "operator",
    "optional",
    // contextual
    "override",
    // contextual
    "postfix",
    // contextual
    "precedencegroup",
    "prefix",
    // contextual
    /private\(set\)/,
    "private",
    "protocol",
    /public\(set\)/,
    "public",
    "repeat",
    "required",
    // contextual
    "rethrows",
    "return",
    "set",
    // contextual
    "some",
    // contextual
    "static",
    "struct",
    "subscript",
    "super",
    "switch",
    "throws",
    "throw",
    /try\?/,
    // operator
    /try!/,
    // operator
    "try",
    // operator
    "typealias",
    /unowned\(safe\)/,
    // contextual
    /unowned\(unsafe\)/,
    // contextual
    "unowned",
    // contextual
    "var",
    "weak",
    // contextual
    "where",
    "while",
    "willSet"
    // contextual
  ], O = [
    "false",
    "nil",
    "true"
  ], N = [
    "assignment",
    "associativity",
    "higherThan",
    "left",
    "lowerThan",
    "none",
    "right"
  ], D = [
    "#colorLiteral",
    "#column",
    "#dsohandle",
    "#else",
    "#elseif",
    "#endif",
    "#error",
    "#file",
    "#fileID",
    "#fileLiteral",
    "#filePath",
    "#function",
    "#if",
    "#imageLiteral",
    "#keyPath",
    "#line",
    "#selector",
    "#sourceLocation",
    "#warning"
  ], x = [
    "abs",
    "all",
    "any",
    "assert",
    "assertionFailure",
    "debugPrint",
    "dump",
    "fatalError",
    "getVaList",
    "isKnownUniquelyReferenced",
    "max",
    "min",
    "numericCast",
    "pointwiseMax",
    "pointwiseMin",
    "precondition",
    "preconditionFailure",
    "print",
    "readLine",
    "repeatElement",
    "sequence",
    "stride",
    "swap",
    "swift_unboxFromSwiftValueWithType",
    "transcode",
    "type",
    "unsafeBitCast",
    "unsafeDowncast",
    "withExtendedLifetime",
    "withUnsafeMutablePointer",
    "withUnsafePointer",
    "withVaList",
    "withoutActuallyEscaping",
    "zip"
  ], L = r(
    /[/=\-+!*%<>&|^~?]/,
    /[\u00A1-\u00A7]/,
    /[\u00A9\u00AB]/,
    /[\u00AC\u00AE]/,
    /[\u00B0\u00B1]/,
    /[\u00B6\u00BB\u00BF\u00D7\u00F7]/,
    /[\u2016-\u2017]/,
    /[\u2020-\u2027]/,
    /[\u2030-\u203E]/,
    /[\u2041-\u2053]/,
    /[\u2055-\u205E]/,
    /[\u2190-\u23FF]/,
    /[\u2500-\u2775]/,
    /[\u2794-\u2BFF]/,
    /[\u2E00-\u2E7F]/,
    /[\u3001-\u3003]/,
    /[\u3008-\u3020]/,
    /[\u3030]/
  ), G = r(
    L,
    /[\u0300-\u036F]/,
    /[\u1DC0-\u1DFF]/,
    /[\u20D0-\u20FF]/,
    /[\uFE00-\uFE0F]/,
    /[\uFE20-\uFE2F]/
    // TODO: The following characters are also allowed, but the regex isn't supported yet.
    // /[\u{E0100}-\u{E01EF}]/u
  ), Y = o(L, G, "*"), k = r(
    /[a-zA-Z_]/,
    /[\u00A8\u00AA\u00AD\u00AF\u00B2-\u00B5\u00B7-\u00BA]/,
    /[\u00BC-\u00BE\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u00FF]/,
    /[\u0100-\u02FF\u0370-\u167F\u1681-\u180D\u180F-\u1DBF]/,
    /[\u1E00-\u1FFF]/,
    /[\u200B-\u200D\u202A-\u202E\u203F-\u2040\u2054\u2060-\u206F]/,
    /[\u2070-\u20CF\u2100-\u218F\u2460-\u24FF\u2776-\u2793]/,
    /[\u2C00-\u2DFF\u2E80-\u2FFF]/,
    /[\u3004-\u3007\u3021-\u302F\u3031-\u303F\u3040-\uD7FF]/,
    /[\uF900-\uFD3D\uFD40-\uFDCF\uFDF0-\uFE1F\uFE30-\uFE44]/,
    /[\uFE47-\uFEFE\uFF00-\uFFFD]/
    // Should be /[\uFE47-\uFFFD]/, but we have to exclude FEFF.
    // The following characters are also allowed, but the regexes aren't supported yet.
    // /[\u{10000}-\u{1FFFD}\u{20000-\u{2FFFD}\u{30000}-\u{3FFFD}\u{40000}-\u{4FFFD}]/u,
    // /[\u{50000}-\u{5FFFD}\u{60000-\u{6FFFD}\u{70000}-\u{7FFFD}\u{80000}-\u{8FFFD}]/u,
    // /[\u{90000}-\u{9FFFD}\u{A0000-\u{AFFFD}\u{B0000}-\u{BFFFD}\u{C0000}-\u{CFFFD}]/u,
    // /[\u{D0000}-\u{DFFFD}\u{E0000-\u{EFFFD}]/u
  ), W = r(
    k,
    /\d/,
    /[\u0300-\u036F\u1DC0-\u1DFF\u20D0-\u20FF\uFE20-\uFE2F]/
  ), Z = o(k, W, "*"), H = o(/[A-Z]/, W, "*"), K = [
    "attached",
    "autoclosure",
    o(/convention\(/, r("swift", "block", "c"), /\)/),
    "discardableResult",
    "dynamicCallable",
    "dynamicMemberLookup",
    "escaping",
    "freestanding",
    "frozen",
    "GKInspectable",
    "IBAction",
    "IBDesignable",
    "IBInspectable",
    "IBOutlet",
    "IBSegueAction",
    "inlinable",
    "main",
    "nonobjc",
    "NSApplicationMain",
    "NSCopying",
    "NSManaged",
    o(/objc\(/, Z, /\)/),
    "objc",
    "objcMembers",
    "propertyWrapper",
    "requires_stored_property_inits",
    "resultBuilder",
    "Sendable",
    "testable",
    "UIApplicationMain",
    "unchecked",
    "unknown",
    "usableFromInline",
    "warn_unqualified_access"
  ], Q = [
    "iOS",
    "iOSApplicationExtension",
    "macOS",
    "macOSApplicationExtension",
    "macCatalyst",
    "macCatalystApplicationExtension",
    "watchOS",
    "watchOSApplicationExtension",
    "tvOS",
    "tvOSApplicationExtension",
    "swift"
  ];
  function _e(se) {
    const Pe = {
      match: /\s+/,
      relevance: 0
    }, Ke = se.COMMENT(
      "/\\*",
      "\\*/",
      { contains: ["self"] }
    ), ye = [
      se.C_LINE_COMMENT_MODE,
      Ke
    ], Je = {
      match: [
        /\./,
        r(...g, ...h)
      ],
      className: { 2: "keyword" }
    }, mt = {
      // Consume .keyword to prevent highlighting properties and methods as keywords.
      match: o(/\./, r(...C)),
      relevance: 0
    }, ge = C.filter((hr) => typeof hr == "string").concat(["_|0"]), w = C.filter((hr) => typeof hr != "string").concat(S).map(e), fe = { variants: [
      {
        className: "keyword",
        match: r(...w, ...h)
      }
    ] }, j = {
      $pattern: r(
        /\b\w+/,
        // regular keywords
        /#\w+/
        // number keywords
      ),
      keyword: ge.concat(D),
      literal: O
    }, J = [
      Je,
      mt,
      fe
    ], de = {
      // Consume .built_in to prevent highlighting properties and methods.
      match: o(/\./, r(...x)),
      relevance: 0
    }, ie = {
      className: "built_in",
      match: o(/\b/, r(...x), /(?=\()/)
    }, X = [
      de,
      ie
    ], ue = {
      // Prevent -> from being highlighting as an operator.
      match: /->/,
      relevance: 0
    }, Oe = {
      className: "operator",
      relevance: 0,
      variants: [
        { match: Y },
        {
          // dot-operator: only operators that start with a dot are allowed to use dots as
          // characters (..., ...<, .*, etc). So there rule here is: a dot followed by one or more
          // characters that may also include dots.
          match: `\\.(\\.|${G})+`
        }
      ]
    }, Re = [
      ue,
      Oe
    ], ae = "([0-9]_*)+", Ee = "([0-9a-fA-F]_*)+", ne = {
      className: "number",
      relevance: 0,
      variants: [
        // decimal floating-point-literal (subsumes decimal-literal)
        { match: `\\b(${ae})(\\.(${ae}))?([eE][+-]?(${ae}))?\\b` },
        // hexadecimal floating-point-literal (subsumes hexadecimal-literal)
        { match: `\\b0x(${Ee})(\\.(${Ee}))?([pP][+-]?(${ae}))?\\b` },
        // octal-literal
        { match: /\b0o([0-7]_*)+\b/ },
        // binary-literal
        { match: /\b0b([01]_*)+\b/ }
      ]
    }, Ge = (hr = "") => ({
      className: "subst",
      variants: [
        { match: o(/\\/, hr, /[0\\tnr"']/) },
        { match: o(/\\/, hr, /u\{[0-9a-fA-F]{1,8}\}/) }
      ]
    }), we = (hr = "") => ({
      className: "subst",
      match: o(/\\/, hr, /[\t ]*(?:[\r\n]|\r\n)/)
    }), st = (hr = "") => ({
      className: "subst",
      label: "interpol",
      begin: o(/\\/, hr, /\(/),
      end: /\)/
    }), Rt = (hr = "") => ({
      begin: o(hr, /"""/),
      end: o(/"""/, hr),
      contains: [
        Ge(hr),
        we(hr),
        st(hr)
      ]
    }), rt = (hr = "") => ({
      begin: o(hr, /"/),
      end: o(/"/, hr),
      contains: [
        Ge(hr),
        st(hr)
      ]
    }), z = {
      className: "string",
      variants: [
        Rt(),
        Rt("#"),
        Rt("##"),
        Rt("###"),
        rt(),
        rt("#"),
        rt("##"),
        rt("###")
      ]
    }, V = [
      se.BACKSLASH_ESCAPE,
      {
        begin: /\[/,
        end: /\]/,
        relevance: 0,
        contains: [se.BACKSLASH_ESCAPE]
      }
    ], Te = {
      begin: /\/[^\s](?=[^/\n]*\/)/,
      end: /\//,
      contains: V
    }, Be = (hr) => {
      const ra = o(hr, /\//), ya = o(/\//, hr);
      return {
        begin: ra,
        end: ya,
        contains: [
          ...V,
          {
            scope: "comment",
            begin: `#(?!.*${ya})`,
            end: /$/
          }
        ]
      };
    }, Le = {
      scope: "regexp",
      variants: [
        Be("###"),
        Be("##"),
        Be("#"),
        Te
      ]
    }, Yt = { match: o(/`/, Z, /`/) }, Nt = {
      className: "variable",
      match: /\$\d+/
    }, Hr = {
      className: "variable",
      match: `\\$${W}+`
    }, Er = [
      Yt,
      Nt,
      Hr
    ], tr = {
      match: /(@|#(un)?)available/,
      scope: "keyword",
      starts: { contains: [
        {
          begin: /\(/,
          end: /\)/,
          keywords: Q,
          contains: [
            ...Re,
            ne,
            z
          ]
        }
      ] }
    }, vr = {
      scope: "keyword",
      match: o(/@/, r(...K))
    }, Pr = {
      scope: "meta",
      match: o(/@/, Z)
    }, ur = [
      tr,
      vr,
      Pr
    ], Ae = {
      match: i(/\b[A-Z]/),
      relevance: 0,
      contains: [
        {
          // Common Apple frameworks, for relevance boost
          className: "type",
          match: o(/(AV|CA|CF|CG|CI|CL|CM|CN|CT|MK|MP|MTK|MTL|NS|SCN|SK|UI|WK|XC)/, W, "+")
        },
        {
          // Type identifier
          className: "type",
          match: H,
          relevance: 0
        },
        {
          // Optional type
          match: /[?!]+/,
          relevance: 0
        },
        {
          // Variadic parameter
          match: /\.\.\./,
          relevance: 0
        },
        {
          // Protocol composition
          match: o(/\s+&\s+/, i(H)),
          relevance: 0
        }
      ]
    }, pe = {
      begin: /</,
      end: />/,
      keywords: j,
      contains: [
        ...ye,
        ...J,
        ...ur,
        ue,
        Ae
      ]
    };
    Ae.contains.push(pe);
    const qe = {
      match: o(Z, /\s*:/),
      keywords: "_|0",
      relevance: 0
    }, bt = {
      begin: /\(/,
      end: /\)/,
      relevance: 0,
      keywords: j,
      contains: [
        "self",
        qe,
        ...ye,
        Le,
        ...J,
        ...X,
        ...Re,
        ne,
        z,
        ...Er,
        ...ur,
        Ae
      ]
    }, Gt = {
      begin: /</,
      end: />/,
      keywords: "repeat each",
      contains: [
        ...ye,
        Ae
      ]
    }, Ur = {
      begin: r(
        i(o(Z, /\s*:/)),
        i(o(Z, /\s+/, Z, /\s*:/))
      ),
      end: /:/,
      relevance: 0,
      contains: [
        {
          className: "keyword",
          match: /\b_\b/
        },
        {
          className: "params",
          match: Z
        }
      ]
    }, qr = {
      begin: /\(/,
      end: /\)/,
      keywords: j,
      contains: [
        Ur,
        ...ye,
        ...J,
        ...Re,
        ne,
        z,
        ...ur,
        Ae,
        bt
      ],
      endsParent: !0,
      illegal: /["']/
    }, Fn = {
      match: [
        /(func|macro)/,
        /\s+/,
        r(Yt.match, Z, Y)
      ],
      className: {
        1: "keyword",
        3: "title.function"
      },
      contains: [
        Gt,
        qr,
        Pe
      ],
      illegal: [
        /\[/,
        /%/
      ]
    }, Ga = {
      match: [
        /\b(?:subscript|init[?!]?)/,
        /\s*(?=[<(])/
      ],
      className: { 1: "keyword" },
      contains: [
        Gt,
        qr,
        Pe
      ],
      illegal: /\[|%/
    }, dn = {
      match: [
        /operator/,
        /\s+/,
        Y
      ],
      className: {
        1: "keyword",
        3: "title"
      }
    }, Qn = {
      begin: [
        /precedencegroup/,
        /\s+/,
        H
      ],
      className: {
        1: "keyword",
        3: "title"
      },
      contains: [Ae],
      keywords: [
        ...N,
        ...O
      ],
      end: /}/
    };
    for (const hr of z.variants) {
      const ra = hr.contains.find((is) => is.label === "interpol");
      ra.keywords = j;
      const ya = [
        ...J,
        ...X,
        ...Re,
        ne,
        z,
        ...Er
      ];
      ra.contains = [
        ...ya,
        {
          begin: /\(/,
          end: /\)/,
          contains: [
            "self",
            ...ya
          ]
        }
      ];
    }
    return {
      name: "Swift",
      keywords: j,
      contains: [
        ...ye,
        Fn,
        Ga,
        {
          beginKeywords: "struct protocol class extension enum actor",
          end: "\\{",
          excludeEnd: !0,
          keywords: j,
          contains: [
            se.inherit(se.TITLE_MODE, {
              className: "title.class",
              begin: /[A-Za-z$_][\u00C0-\u02B80-9A-Za-z$_]*/
            }),
            ...J
          ]
        },
        dn,
        Qn,
        {
          beginKeywords: "import",
          end: /$/,
          contains: [...ye],
          relevance: 0
        },
        Le,
        ...J,
        ...X,
        ...Re,
        ne,
        z,
        ...Er,
        ...ur,
        Ae,
        bt
      ]
    };
  }
  return bp = _e, bp;
}
var Tp, KT;
function nF() {
  if (KT)
    return Tp;
  KT = 1;
  function s(i) {
    return {
      name: "Tagger Script",
      contains: [
        {
          className: "comment",
          begin: /\$noop\(/,
          end: /\)/,
          contains: [
            { begin: /\\[()]/ },
            {
              begin: /\(/,
              end: /\)/,
              contains: [
                { begin: /\\[()]/ },
                "self"
              ]
            }
          ],
          relevance: 10
        },
        {
          className: "keyword",
          begin: /\$[_a-zA-Z0-9]+(?=\()/
        },
        {
          className: "variable",
          begin: /%[_a-zA-Z0-9:]+%/
        },
        {
          className: "symbol",
          begin: /\\[\\nt$%,()]/
        },
        {
          className: "symbol",
          begin: /\\u[a-fA-F0-9]{4}/
        }
      ]
    };
  }
  return Tp = s, Tp;
}
var vp, QT;
function aF() {
  if (QT)
    return vp;
  QT = 1;
  function s(i) {
    const o = "true false yes no null", c = "[\\w#;/?:@&=+$,.~*'()[\\]]+", r = {
      className: "attr",
      variants: [
        { begin: "\\w[\\w :\\/.-]*:(?=[ 	]|$)" },
        {
          // double quoted keys
          begin: '"\\w[\\w :\\/.-]*":(?=[ 	]|$)'
        },
        {
          // single quoted keys
          begin: "'\\w[\\w :\\/.-]*':(?=[ 	]|$)"
        }
      ]
    }, e = {
      className: "template-variable",
      variants: [
        {
          // jinja templates Ansible
          begin: /\{\{/,
          end: /\}\}/
        },
        {
          // Ruby i18n
          begin: /%\{/,
          end: /\}/
        }
      ]
    }, g = {
      className: "string",
      relevance: 0,
      variants: [
        {
          begin: /'/,
          end: /'/
        },
        {
          begin: /"/,
          end: /"/
        },
        { begin: /\S+/ }
      ],
      contains: [
        i.BACKSLASH_ESCAPE,
        e
      ]
    }, h = i.inherit(g, { variants: [
      {
        begin: /'/,
        end: /'/
      },
      {
        begin: /"/,
        end: /"/
      },
      { begin: /[^\s,{}[\]]+/ }
    ] }), D = {
      className: "number",
      begin: "\\b" + "[0-9]{4}(-[0-9][0-9]){0,2}" + "([Tt \\t][0-9][0-9]?(:[0-9][0-9]){2})?" + "(\\.[0-9]*)?" + "([ \\t])*(Z|[-+][0-9][0-9]?(:[0-9][0-9])?)?" + "\\b"
    }, x = {
      end: ",",
      endsWithParent: !0,
      excludeEnd: !0,
      keywords: o,
      relevance: 0
    }, L = {
      begin: /\{/,
      end: /\}/,
      contains: [x],
      illegal: "\\n",
      relevance: 0
    }, G = {
      begin: "\\[",
      end: "\\]",
      contains: [x],
      illegal: "\\n",
      relevance: 0
    }, Y = [
      r,
      {
        className: "meta",
        begin: "^---\\s*$",
        relevance: 10
      },
      {
        // multi line string
        // Blocks start with a | or > followed by a newline
        //
        // Indentation of subsequent lines must be the same to
        // be considered part of the block
        className: "string",
        begin: "[\\|>]([1-9]?[+-])?[ ]*\\n( +)[^ ][^\\n]*\\n(\\2[^\\n]+\\n?)*"
      },
      {
        // Ruby/Rails erb
        begin: "<%[%=-]?",
        end: "[%-]?%>",
        subLanguage: "ruby",
        excludeBegin: !0,
        excludeEnd: !0,
        relevance: 0
      },
      {
        // named tags
        className: "type",
        begin: "!\\w+!" + c
      },
      // https://yaml.org/spec/1.2/spec.html#id2784064
      {
        // verbatim tags
        className: "type",
        begin: "!<" + c + ">"
      },
      {
        // primary tags
        className: "type",
        begin: "!" + c
      },
      {
        // secondary tags
        className: "type",
        begin: "!!" + c
      },
      {
        // fragment id &ref
        className: "meta",
        begin: "&" + i.UNDERSCORE_IDENT_RE + "$"
      },
      {
        // fragment reference *ref
        className: "meta",
        begin: "\\*" + i.UNDERSCORE_IDENT_RE + "$"
      },
      {
        // array listing
        className: "bullet",
        // TODO: remove |$ hack when we have proper look-ahead support
        begin: "-(?=[ ]|$)",
        relevance: 0
      },
      i.HASH_COMMENT_MODE,
      {
        beginKeywords: o,
        keywords: { literal: o }
      },
      D,
      // numbers are any valid C-style number that
      // sit isolated from other words
      {
        className: "number",
        begin: i.C_NUMBER_RE + "\\b",
        relevance: 0
      },
      L,
      G,
      g
    ], k = [...Y];
    return k.pop(), k.push(h), x.contains = k, {
      name: "YAML",
      case_insensitive: !0,
      aliases: ["yml"],
      contains: Y
    };
  }
  return vp = s, vp;
}
var Cp, XT;
function iF() {
  if (XT)
    return Cp;
  XT = 1;
  function s(i) {
    return {
      name: "Test Anything Protocol",
      case_insensitive: !0,
      contains: [
        i.HASH_COMMENT_MODE,
        // version of format and total amount of testcases
        {
          className: "meta",
          variants: [
            { begin: "^TAP version (\\d+)$" },
            { begin: "^1\\.\\.(\\d+)$" }
          ]
        },
        // YAML block
        {
          begin: /---$/,
          end: "\\.\\.\\.$",
          subLanguage: "yaml",
          relevance: 0
        },
        // testcase number
        {
          className: "number",
          begin: " (\\d+) "
        },
        // testcase status and description
        {
          className: "symbol",
          variants: [
            { begin: "^ok" },
            { begin: "^not ok" }
          ]
        }
      ]
    };
  }
  return Cp = s, Cp;
}
var Rp, ZT;
function oF() {
  if (ZT)
    return Rp;
  ZT = 1;
  function s(i) {
    const o = i.regex, c = /[a-zA-Z_][a-zA-Z0-9_]*/, r = {
      className: "number",
      variants: [
        i.BINARY_NUMBER_MODE,
        i.C_NUMBER_MODE
      ]
    };
    return {
      name: "Tcl",
      aliases: ["tk"],
      keywords: [
        "after",
        "append",
        "apply",
        "array",
        "auto_execok",
        "auto_import",
        "auto_load",
        "auto_mkindex",
        "auto_mkindex_old",
        "auto_qualify",
        "auto_reset",
        "bgerror",
        "binary",
        "break",
        "catch",
        "cd",
        "chan",
        "clock",
        "close",
        "concat",
        "continue",
        "dde",
        "dict",
        "encoding",
        "eof",
        "error",
        "eval",
        "exec",
        "exit",
        "expr",
        "fblocked",
        "fconfigure",
        "fcopy",
        "file",
        "fileevent",
        "filename",
        "flush",
        "for",
        "foreach",
        "format",
        "gets",
        "glob",
        "global",
        "history",
        "http",
        "if",
        "incr",
        "info",
        "interp",
        "join",
        "lappend|10",
        "lassign|10",
        "lindex|10",
        "linsert|10",
        "list",
        "llength|10",
        "load",
        "lrange|10",
        "lrepeat|10",
        "lreplace|10",
        "lreverse|10",
        "lsearch|10",
        "lset|10",
        "lsort|10",
        "mathfunc",
        "mathop",
        "memory",
        "msgcat",
        "namespace",
        "open",
        "package",
        "parray",
        "pid",
        "pkg::create",
        "pkg_mkIndex",
        "platform",
        "platform::shell",
        "proc",
        "puts",
        "pwd",
        "read",
        "refchan",
        "regexp",
        "registry",
        "regsub|10",
        "rename",
        "return",
        "safe",
        "scan",
        "seek",
        "set",
        "socket",
        "source",
        "split",
        "string",
        "subst",
        "switch",
        "tcl_endOfWord",
        "tcl_findLibrary",
        "tcl_startOfNextWord",
        "tcl_startOfPreviousWord",
        "tcl_wordBreakAfter",
        "tcl_wordBreakBefore",
        "tcltest",
        "tclvars",
        "tell",
        "time",
        "tm",
        "trace",
        "unknown",
        "unload",
        "unset",
        "update",
        "uplevel",
        "upvar",
        "variable",
        "vwait",
        "while"
      ],
      contains: [
        i.COMMENT(";[ \\t]*#", "$"),
        i.COMMENT("^[ \\t]*#", "$"),
        {
          beginKeywords: "proc",
          end: "[\\{]",
          excludeEnd: !0,
          contains: [
            {
              className: "title",
              begin: "[ \\t\\n\\r]+(::)?[a-zA-Z_]((::)?[a-zA-Z0-9_])*",
              end: "[ \\t\\n\\r]",
              endsWithParent: !0,
              excludeEnd: !0
            }
          ]
        },
        {
          className: "variable",
          variants: [
            { begin: o.concat(
              /\$/,
              o.optional(/::/),
              c,
              "(::",
              c,
              ")*"
            ) },
            {
              begin: "\\$\\{(::)?[a-zA-Z_]((::)?[a-zA-Z0-9_])*",
              end: "\\}",
              contains: [r]
            }
          ]
        },
        {
          className: "string",
          contains: [i.BACKSLASH_ESCAPE],
          variants: [i.inherit(i.QUOTE_STRING_MODE, { illegal: null })]
        },
        r
      ]
    };
  }
  return Rp = s, Rp;
}
var Np, jT;
function sF() {
  if (jT)
    return Np;
  jT = 1;
  function s(i) {
    const o = [
      "bool",
      "byte",
      "i16",
      "i32",
      "i64",
      "double",
      "string",
      "binary"
    ];
    return {
      name: "Thrift",
      keywords: {
        keyword: [
          "namespace",
          "const",
          "typedef",
          "struct",
          "enum",
          "service",
          "exception",
          "void",
          "oneway",
          "set",
          "list",
          "map",
          "required",
          "optional"
        ],
        type: o,
        literal: "true false"
      },
      contains: [
        i.QUOTE_STRING_MODE,
        i.NUMBER_MODE,
        i.C_LINE_COMMENT_MODE,
        i.C_BLOCK_COMMENT_MODE,
        {
          className: "class",
          beginKeywords: "struct enum service exception",
          end: /\{/,
          illegal: /\n/,
          contains: [
            i.inherit(i.TITLE_MODE, {
              // hack: eating everything after the first title
              starts: {
                endsWithParent: !0,
                excludeEnd: !0
              }
            })
          ]
        },
        {
          begin: "\\b(set|list|map)\\s*<",
          keywords: { type: [
            ...o,
            "set",
            "list",
            "map"
          ] },
          end: ">",
          contains: ["self"]
        }
      ]
    };
  }
  return Np = s, Np;
}
var Ap, JT;
function lF() {
  if (JT)
    return Ap;
  JT = 1;
  function s(i) {
    const o = {
      className: "number",
      begin: "[1-9][0-9]*",
      /* no leading zeros */
      relevance: 0
    }, c = {
      className: "symbol",
      begin: ":[^\\]]+"
    }, r = {
      className: "built_in",
      begin: "(AR|P|PAYLOAD|PR|R|SR|RSR|LBL|VR|UALM|MESSAGE|UTOOL|UFRAME|TIMER|TIMER_OVERFLOW|JOINT_MAX_SPEED|RESUME_PROG|DIAG_REC)\\[",
      end: "\\]",
      contains: [
        "self",
        o,
        c
      ]
    }, e = {
      className: "built_in",
      begin: "(AI|AO|DI|DO|F|RI|RO|UI|UO|GI|GO|SI|SO)\\[",
      end: "\\]",
      contains: [
        "self",
        o,
        i.QUOTE_STRING_MODE,
        /* for pos section at bottom */
        c
      ]
    };
    return {
      name: "TP",
      keywords: {
        keyword: [
          "ABORT",
          "ACC",
          "ADJUST",
          "AND",
          "AP_LD",
          "BREAK",
          "CALL",
          "CNT",
          "COL",
          "CONDITION",
          "CONFIG",
          "DA",
          "DB",
          "DIV",
          "DETECT",
          "ELSE",
          "END",
          "ENDFOR",
          "ERR_NUM",
          "ERROR_PROG",
          "FINE",
          "FOR",
          "GP",
          "GUARD",
          "INC",
          "IF",
          "JMP",
          "LINEAR_MAX_SPEED",
          "LOCK",
          "MOD",
          "MONITOR",
          "OFFSET",
          "Offset",
          "OR",
          "OVERRIDE",
          "PAUSE",
          "PREG",
          "PTH",
          "RT_LD",
          "RUN",
          "SELECT",
          "SKIP",
          "Skip",
          "TA",
          "TB",
          "TO",
          "TOOL_OFFSET",
          "Tool_Offset",
          "UF",
          "UT",
          "UFRAME_NUM",
          "UTOOL_NUM",
          "UNLOCK",
          "WAIT",
          "X",
          "Y",
          "Z",
          "W",
          "P",
          "R",
          "STRLEN",
          "SUBSTR",
          "FINDSTR",
          "VOFFSET",
          "PROG",
          "ATTR",
          "MN",
          "POS"
        ],
        literal: [
          "ON",
          "OFF",
          "max_speed",
          "LPOS",
          "JPOS",
          "ENABLE",
          "DISABLE",
          "START",
          "STOP",
          "RESET"
        ]
      },
      contains: [
        r,
        e,
        {
          className: "keyword",
          begin: "/(PROG|ATTR|MN|POS|END)\\b"
        },
        {
          /* this is for cases like ,CALL */
          className: "keyword",
          begin: "(CALL|RUN|POINT_LOGIC|LBL)\\b"
        },
        {
          /* this is for cases like CNT100 where the default lexemes do not
           * separate the keyword and the number */
          className: "keyword",
          begin: "\\b(ACC|CNT|Skip|Offset|PSPD|RT_LD|AP_LD|Tool_Offset)"
        },
        {
          /* to catch numbers that do not have a word boundary on the left */
          className: "number",
          begin: "\\d+(sec|msec|mm/sec|cm/min|inch/min|deg/sec|mm|in|cm)?\\b",
          relevance: 0
        },
        i.COMMENT("//", "[;$]"),
        i.COMMENT("!", "[;$]"),
        i.COMMENT("--eg:", "$"),
        i.QUOTE_STRING_MODE,
        {
          className: "string",
          begin: "'",
          end: "'"
        },
        i.C_NUMBER_MODE,
        {
          className: "variable",
          begin: "\\$[A-Za-z0-9_]+"
        }
      ]
    };
  }
  return Ap = s, Ap;
}
var Op, e1;
function cF() {
  if (e1)
    return Op;
  e1 = 1;
  function s(i) {
    const o = i.regex, c = [
      "absolute_url",
      "asset|0",
      "asset_version",
      "attribute",
      "block",
      "constant",
      "controller|0",
      "country_timezones",
      "csrf_token",
      "cycle",
      "date",
      "dump",
      "expression",
      "form|0",
      "form_end",
      "form_errors",
      "form_help",
      "form_label",
      "form_rest",
      "form_row",
      "form_start",
      "form_widget",
      "html_classes",
      "include",
      "is_granted",
      "logout_path",
      "logout_url",
      "max",
      "min",
      "parent",
      "path|0",
      "random",
      "range",
      "relative_path",
      "render",
      "render_esi",
      "source",
      "template_from_string",
      "url|0"
    ], r = [
      "abs",
      "abbr_class",
      "abbr_method",
      "batch",
      "capitalize",
      "column",
      "convert_encoding",
      "country_name",
      "currency_name",
      "currency_symbol",
      "data_uri",
      "date",
      "date_modify",
      "default",
      "escape",
      "file_excerpt",
      "file_link",
      "file_relative",
      "filter",
      "first",
      "format",
      "format_args",
      "format_args_as_text",
      "format_currency",
      "format_date",
      "format_datetime",
      "format_file",
      "format_file_from_text",
      "format_number",
      "format_time",
      "html_to_markdown",
      "humanize",
      "inky_to_html",
      "inline_css",
      "join",
      "json_encode",
      "keys",
      "language_name",
      "last",
      "length",
      "locale_name",
      "lower",
      "map",
      "markdown",
      "markdown_to_html",
      "merge",
      "nl2br",
      "number_format",
      "raw",
      "reduce",
      "replace",
      "reverse",
      "round",
      "slice",
      "slug",
      "sort",
      "spaceless",
      "split",
      "striptags",
      "timezone_name",
      "title",
      "trans",
      "transchoice",
      "trim",
      "u|0",
      "upper",
      "url_encode",
      "yaml_dump",
      "yaml_encode"
    ];
    let e = [
      "apply",
      "autoescape",
      "block",
      "cache",
      "deprecated",
      "do",
      "embed",
      "extends",
      "filter",
      "flush",
      "for",
      "form_theme",
      "from",
      "if",
      "import",
      "include",
      "macro",
      "sandbox",
      "set",
      "stopwatch",
      "trans",
      "trans_default_domain",
      "transchoice",
      "use",
      "verbatim",
      "with"
    ];
    e = e.concat(e.map((G) => `end${G}`));
    const g = {
      scope: "string",
      variants: [
        {
          begin: /'/,
          end: /'/
        },
        {
          begin: /"/,
          end: /"/
        }
      ]
    }, h = {
      scope: "number",
      match: /\d+/
    }, S = {
      begin: /\(/,
      end: /\)/,
      excludeBegin: !0,
      excludeEnd: !0,
      contains: [
        g,
        h
      ]
    }, C = {
      beginKeywords: c.join(" "),
      keywords: { name: c },
      relevance: 0,
      contains: [S]
    }, O = {
      match: /\|(?=[A-Za-z_]+:?)/,
      beginScope: "punctuation",
      relevance: 0,
      contains: [
        {
          match: /[A-Za-z_]+:?/,
          keywords: r
        }
      ]
    }, N = (G, { relevance: Y }) => ({
      beginScope: {
        1: "template-tag",
        3: "name"
      },
      relevance: Y || 2,
      endScope: "template-tag",
      begin: [
        /\{%/,
        /\s*/,
        o.either(...G)
      ],
      end: /%\}/,
      keywords: "in",
      contains: [
        O,
        C,
        g,
        h
      ]
    }), D = /[a-z_]+/, x = N(e, { relevance: 2 }), L = N([D], { relevance: 1 });
    return {
      name: "Twig",
      aliases: ["craftcms"],
      case_insensitive: !0,
      subLanguage: "xml",
      contains: [
        i.COMMENT(/\{#/, /#\}/),
        x,
        L,
        {
          className: "template-variable",
          begin: /\{\{/,
          end: /\}\}/,
          contains: [
            "self",
            O,
            C,
            g,
            h
          ]
        }
      ]
    };
  }
  return Op = s, Op;
}
var yp, t1;
function dF() {
  if (t1)
    return yp;
  t1 = 1;
  const s = "[A-Za-z$_][0-9A-Za-z$_]*", i = [
    "as",
    // for exports
    "in",
    "of",
    "if",
    "for",
    "while",
    "finally",
    "var",
    "new",
    "function",
    "do",
    "return",
    "void",
    "else",
    "break",
    "catch",
    "instanceof",
    "with",
    "throw",
    "case",
    "default",
    "try",
    "switch",
    "continue",
    "typeof",
    "delete",
    "let",
    "yield",
    "const",
    "class",
    // JS handles these with a special rule
    // "get",
    // "set",
    "debugger",
    "async",
    "await",
    "static",
    "import",
    "from",
    "export",
    "extends"
  ], o = [
    "true",
    "false",
    "null",
    "undefined",
    "NaN",
    "Infinity"
  ], c = [
    // Fundamental objects
    "Object",
    "Function",
    "Boolean",
    "Symbol",
    // numbers and dates
    "Math",
    "Date",
    "Number",
    "BigInt",
    // text
    "String",
    "RegExp",
    // Indexed collections
    "Array",
    "Float32Array",
    "Float64Array",
    "Int8Array",
    "Uint8Array",
    "Uint8ClampedArray",
    "Int16Array",
    "Int32Array",
    "Uint16Array",
    "Uint32Array",
    "BigInt64Array",
    "BigUint64Array",
    // Keyed collections
    "Set",
    "Map",
    "WeakSet",
    "WeakMap",
    // Structured data
    "ArrayBuffer",
    "SharedArrayBuffer",
    "Atomics",
    "DataView",
    "JSON",
    // Control abstraction objects
    "Promise",
    "Generator",
    "GeneratorFunction",
    "AsyncFunction",
    // Reflection
    "Reflect",
    "Proxy",
    // Internationalization
    "Intl",
    // WebAssembly
    "WebAssembly"
  ], r = [
    "Error",
    "EvalError",
    "InternalError",
    "RangeError",
    "ReferenceError",
    "SyntaxError",
    "TypeError",
    "URIError"
  ], e = [
    "setInterval",
    "setTimeout",
    "clearInterval",
    "clearTimeout",
    "require",
    "exports",
    "eval",
    "isFinite",
    "isNaN",
    "parseFloat",
    "parseInt",
    "decodeURI",
    "decodeURIComponent",
    "encodeURI",
    "encodeURIComponent",
    "escape",
    "unescape"
  ], g = [
    "arguments",
    "this",
    "super",
    "console",
    "window",
    "document",
    "localStorage",
    "sessionStorage",
    "module",
    "global"
    // Node.js
  ], h = [].concat(
    e,
    c,
    r
  );
  function S(O) {
    const N = O.regex, D = (Ge, { after: we }) => {
      const st = "</" + Ge[0].slice(1);
      return Ge.input.indexOf(st, we) !== -1;
    }, x = s, L = {
      begin: "<>",
      end: "</>"
    }, G = /<[A-Za-z0-9\\._:-]+\s*\/>/, Y = {
      begin: /<[A-Za-z0-9\\._:-]+/,
      end: /\/[A-Za-z0-9\\._:-]+>|\/>/,
      /**
       * @param {RegExpMatchArray} match
       * @param {CallbackResponse} response
       */
      isTrulyOpeningTag: (Ge, we) => {
        const st = Ge[0].length + Ge.index, Rt = Ge.input[st];
        if (
          // HTML should not include another raw `<` inside a tag
          // nested type?
          // `<Array<Array<number>>`, etc.
          Rt === "<" || // the , gives away that this is not HTML
          // `<T, A extends keyof T, V>`
          Rt === ","
        ) {
          we.ignoreMatch();
          return;
        }
        Rt === ">" && (D(Ge, { after: st }) || we.ignoreMatch());
        let rt;
        const z = Ge.input.substring(st);
        if (rt = z.match(/^\s*=/)) {
          we.ignoreMatch();
          return;
        }
        if ((rt = z.match(/^\s+extends\s+/)) && rt.index === 0) {
          we.ignoreMatch();
          return;
        }
      }
    }, k = {
      $pattern: s,
      keyword: i,
      literal: o,
      built_in: h,
      "variable.language": g
    }, W = "[0-9](_?[0-9])*", Z = `\\.(${W})`, H = "0|[1-9](_?[0-9])*|0[0-7]*[89][0-9]*", K = {
      className: "number",
      variants: [
        // DecimalLiteral
        { begin: `(\\b(${H})((${Z})|\\.)?|(${Z}))[eE][+-]?(${W})\\b` },
        { begin: `\\b(${H})\\b((${Z})\\b|\\.)?|(${Z})\\b` },
        // DecimalBigIntegerLiteral
        { begin: "\\b(0|[1-9](_?[0-9])*)n\\b" },
        // NonDecimalIntegerLiteral
        { begin: "\\b0[xX][0-9a-fA-F](_?[0-9a-fA-F])*n?\\b" },
        { begin: "\\b0[bB][0-1](_?[0-1])*n?\\b" },
        { begin: "\\b0[oO][0-7](_?[0-7])*n?\\b" },
        // LegacyOctalIntegerLiteral (does not include underscore separators)
        // https://tc39.es/ecma262/#sec-additional-syntax-numeric-literals
        { begin: "\\b0[0-7]+n?\\b" }
      ],
      relevance: 0
    }, Q = {
      className: "subst",
      begin: "\\$\\{",
      end: "\\}",
      keywords: k,
      contains: []
      // defined later
    }, _e = {
      begin: "html`",
      end: "",
      starts: {
        end: "`",
        returnEnd: !1,
        contains: [
          O.BACKSLASH_ESCAPE,
          Q
        ],
        subLanguage: "xml"
      }
    }, se = {
      begin: "css`",
      end: "",
      starts: {
        end: "`",
        returnEnd: !1,
        contains: [
          O.BACKSLASH_ESCAPE,
          Q
        ],
        subLanguage: "css"
      }
    }, Pe = {
      begin: "gql`",
      end: "",
      starts: {
        end: "`",
        returnEnd: !1,
        contains: [
          O.BACKSLASH_ESCAPE,
          Q
        ],
        subLanguage: "graphql"
      }
    }, Ke = {
      className: "string",
      begin: "`",
      end: "`",
      contains: [
        O.BACKSLASH_ESCAPE,
        Q
      ]
    }, Je = {
      className: "comment",
      variants: [
        O.COMMENT(
          /\/\*\*(?!\/)/,
          "\\*/",
          {
            relevance: 0,
            contains: [
              {
                begin: "(?=@[A-Za-z]+)",
                relevance: 0,
                contains: [
                  {
                    className: "doctag",
                    begin: "@[A-Za-z]+"
                  },
                  {
                    className: "type",
                    begin: "\\{",
                    end: "\\}",
                    excludeEnd: !0,
                    excludeBegin: !0,
                    relevance: 0
                  },
                  {
                    className: "variable",
                    begin: x + "(?=\\s*(-)|$)",
                    endsParent: !0,
                    relevance: 0
                  },
                  // eat spaces (not newlines) so we can find
                  // types or variables
                  {
                    begin: /(?=[^\n])\s/,
                    relevance: 0
                  }
                ]
              }
            ]
          }
        ),
        O.C_BLOCK_COMMENT_MODE,
        O.C_LINE_COMMENT_MODE
      ]
    }, mt = [
      O.APOS_STRING_MODE,
      O.QUOTE_STRING_MODE,
      _e,
      se,
      Pe,
      Ke,
      // Skip numbers when they are part of a variable name
      { match: /\$\d+/ },
      K
      // This is intentional:
      // See https://github.com/highlightjs/highlight.js/issues/3288
      // hljs.REGEXP_MODE
    ];
    Q.contains = mt.concat({
      // we need to pair up {} inside our subst to prevent
      // it from ending too early by matching another }
      begin: /\{/,
      end: /\}/,
      keywords: k,
      contains: [
        "self"
      ].concat(mt)
    });
    const ge = [].concat(Je, Q.contains), w = ge.concat([
      // eat recursive parens in sub expressions
      {
        begin: /\(/,
        end: /\)/,
        keywords: k,
        contains: ["self"].concat(ge)
      }
    ]), fe = {
      className: "params",
      begin: /\(/,
      end: /\)/,
      excludeBegin: !0,
      excludeEnd: !0,
      keywords: k,
      contains: w
    }, j = {
      variants: [
        // class Car extends vehicle
        {
          match: [
            /class/,
            /\s+/,
            x,
            /\s+/,
            /extends/,
            /\s+/,
            N.concat(x, "(", N.concat(/\./, x), ")*")
          ],
          scope: {
            1: "keyword",
            3: "title.class",
            5: "keyword",
            7: "title.class.inherited"
          }
        },
        // class Car
        {
          match: [
            /class/,
            /\s+/,
            x
          ],
          scope: {
            1: "keyword",
            3: "title.class"
          }
        }
      ]
    }, J = {
      relevance: 0,
      match: N.either(
        // Hard coded exceptions
        /\bJSON/,
        // Float32Array, OutT
        /\b[A-Z][a-z]+([A-Z][a-z]*|\d)*/,
        // CSSFactory, CSSFactoryT
        /\b[A-Z]{2,}([A-Z][a-z]+|\d)+([A-Z][a-z]*)*/,
        // FPs, FPsT
        /\b[A-Z]{2,}[a-z]+([A-Z][a-z]+|\d)*([A-Z][a-z]*)*/
        // P
        // single letters are not highlighted
        // BLAH
        // this will be flagged as a UPPER_CASE_CONSTANT instead
      ),
      className: "title.class",
      keywords: {
        _: [
          // se we still get relevance credit for JS library classes
          ...c,
          ...r
        ]
      }
    }, de = {
      label: "use_strict",
      className: "meta",
      relevance: 10,
      begin: /^\s*['"]use (strict|asm)['"]/
    }, ie = {
      variants: [
        {
          match: [
            /function/,
            /\s+/,
            x,
            /(?=\s*\()/
          ]
        },
        // anonymous function
        {
          match: [
            /function/,
            /\s*(?=\()/
          ]
        }
      ],
      className: {
        1: "keyword",
        3: "title.function"
      },
      label: "func.def",
      contains: [fe],
      illegal: /%/
    }, X = {
      relevance: 0,
      match: /\b[A-Z][A-Z_0-9]+\b/,
      className: "variable.constant"
    };
    function ue(Ge) {
      return N.concat("(?!", Ge.join("|"), ")");
    }
    const Oe = {
      match: N.concat(
        /\b/,
        ue([
          ...e,
          "super",
          "import"
        ]),
        x,
        N.lookahead(/\(/)
      ),
      className: "title.function",
      relevance: 0
    }, Re = {
      begin: N.concat(/\./, N.lookahead(
        N.concat(x, /(?![0-9A-Za-z$_(])/)
      )),
      end: x,
      excludeBegin: !0,
      keywords: "prototype",
      className: "property",
      relevance: 0
    }, ae = {
      match: [
        /get|set/,
        /\s+/,
        x,
        /(?=\()/
      ],
      className: {
        1: "keyword",
        3: "title.function"
      },
      contains: [
        {
          // eat to avoid empty params
          begin: /\(\)/
        },
        fe
      ]
    }, Ee = "(\\([^()]*(\\([^()]*(\\([^()]*\\)[^()]*)*\\)[^()]*)*\\)|" + O.UNDERSCORE_IDENT_RE + ")\\s*=>", ne = {
      match: [
        /const|var|let/,
        /\s+/,
        x,
        /\s*/,
        /=\s*/,
        /(async\s*)?/,
        // async is optional
        N.lookahead(Ee)
      ],
      keywords: "async",
      className: {
        1: "keyword",
        3: "title.function"
      },
      contains: [
        fe
      ]
    };
    return {
      name: "JavaScript",
      aliases: ["js", "jsx", "mjs", "cjs"],
      keywords: k,
      // this will be extended by TypeScript
      exports: { PARAMS_CONTAINS: w, CLASS_REFERENCE: J },
      illegal: /#(?![$_A-z])/,
      contains: [
        O.SHEBANG({
          label: "shebang",
          binary: "node",
          relevance: 5
        }),
        de,
        O.APOS_STRING_MODE,
        O.QUOTE_STRING_MODE,
        _e,
        se,
        Pe,
        Ke,
        Je,
        // Skip numbers when they are part of a variable name
        { match: /\$\d+/ },
        K,
        J,
        {
          className: "attr",
          begin: x + N.lookahead(":"),
          relevance: 0
        },
        ne,
        {
          // "value" container
          begin: "(" + O.RE_STARTERS_RE + "|\\b(case|return|throw)\\b)\\s*",
          keywords: "return throw case",
          relevance: 0,
          contains: [
            Je,
            O.REGEXP_MODE,
            {
              className: "function",
              // we have to count the parens to make sure we actually have the
              // correct bounding ( ) before the =>.  There could be any number of
              // sub-expressions inside also surrounded by parens.
              begin: Ee,
              returnBegin: !0,
              end: "\\s*=>",
              contains: [
                {
                  className: "params",
                  variants: [
                    {
                      begin: O.UNDERSCORE_IDENT_RE,
                      relevance: 0
                    },
                    {
                      className: null,
                      begin: /\(\s*\)/,
                      skip: !0
                    },
                    {
                      begin: /\(/,
                      end: /\)/,
                      excludeBegin: !0,
                      excludeEnd: !0,
                      keywords: k,
                      contains: w
                    }
                  ]
                }
              ]
            },
            {
              // could be a comma delimited list of params to a function call
              begin: /,/,
              relevance: 0
            },
            {
              match: /\s+/,
              relevance: 0
            },
            {
              // JSX
              variants: [
                { begin: L.begin, end: L.end },
                { match: G },
                {
                  begin: Y.begin,
                  // we carefully check the opening tag to see if it truly
                  // is a tag and not a false positive
                  "on:begin": Y.isTrulyOpeningTag,
                  end: Y.end
                }
              ],
              subLanguage: "xml",
              contains: [
                {
                  begin: Y.begin,
                  end: Y.end,
                  skip: !0,
                  contains: ["self"]
                }
              ]
            }
          ]
        },
        ie,
        {
          // prevent this from getting swallowed up by function
          // since they appear "function like"
          beginKeywords: "while if switch catch for"
        },
        {
          // we have to count the parens to make sure we actually have the correct
          // bounding ( ).  There could be any number of sub-expressions inside
          // also surrounded by parens.
          begin: "\\b(?!function)" + O.UNDERSCORE_IDENT_RE + "\\([^()]*(\\([^()]*(\\([^()]*\\)[^()]*)*\\)[^()]*)*\\)\\s*\\{",
          // end parens
          returnBegin: !0,
          label: "func.def",
          contains: [
            fe,
            O.inherit(O.TITLE_MODE, { begin: x, className: "title.function" })
          ]
        },
        // catch ... so it won't trigger the property rule below
        {
          match: /\.\.\./,
          relevance: 0
        },
        Re,
        // hack: prevents detection of keywords in some circumstances
        // .keyword()
        // $keyword = x
        {
          match: "\\$" + x,
          relevance: 0
        },
        {
          match: [/\bconstructor(?=\s*\()/],
          className: { 1: "title.function" },
          contains: [fe]
        },
        Oe,
        X,
        j,
        ae,
        {
          match: /\$[(.]/
          // relevance booster for a pattern common to JS libs: `$(something)` and `$.something`
        }
      ]
    };
  }
  function C(O) {
    const N = S(O), D = s, x = [
      "any",
      "void",
      "number",
      "boolean",
      "string",
      "object",
      "never",
      "symbol",
      "bigint",
      "unknown"
    ], L = {
      beginKeywords: "namespace",
      end: /\{/,
      excludeEnd: !0,
      contains: [N.exports.CLASS_REFERENCE]
    }, G = {
      beginKeywords: "interface",
      end: /\{/,
      excludeEnd: !0,
      keywords: {
        keyword: "interface extends",
        built_in: x
      },
      contains: [N.exports.CLASS_REFERENCE]
    }, Y = {
      className: "meta",
      relevance: 10,
      begin: /^\s*['"]use strict['"]/
    }, k = [
      "type",
      "namespace",
      "interface",
      "public",
      "private",
      "protected",
      "implements",
      "declare",
      "abstract",
      "readonly",
      "enum",
      "override"
    ], W = {
      $pattern: s,
      keyword: i.concat(k),
      literal: o,
      built_in: h.concat(x),
      "variable.language": g
    }, Z = {
      className: "meta",
      begin: "@" + D
    }, H = (Q, _e, se) => {
      const Pe = Q.contains.findIndex((Ke) => Ke.label === _e);
      if (Pe === -1)
        throw new Error("can not find mode to replace");
      Q.contains.splice(Pe, 1, se);
    };
    Object.assign(N.keywords, W), N.exports.PARAMS_CONTAINS.push(Z), N.contains = N.contains.concat([
      Z,
      L,
      G
    ]), H(N, "shebang", O.SHEBANG()), H(N, "use_strict", Y);
    const K = N.contains.find((Q) => Q.label === "func.def");
    return K.relevance = 0, Object.assign(N, {
      name: "TypeScript",
      aliases: [
        "ts",
        "tsx",
        "mts",
        "cts"
      ]
    }), N;
  }
  return yp = C, yp;
}
var Ip, r1;
function uF() {
  if (r1)
    return Ip;
  r1 = 1;
  function s(i) {
    return {
      name: "Vala",
      keywords: {
        keyword: (
          // Value types
          "char uchar unichar int uint long ulong short ushort int8 int16 int32 int64 uint8 uint16 uint32 uint64 float double bool struct enum string void weak unowned owned async signal static abstract interface override virtual delegate if while do for foreach else switch case break default return try catch public private protected internal using new this get set const stdout stdin stderr var"
        ),
        built_in: "DBus GLib CCode Gee Object Gtk Posix",
        literal: "false true null"
      },
      contains: [
        {
          className: "class",
          beginKeywords: "class interface namespace",
          end: /\{/,
          excludeEnd: !0,
          illegal: "[^,:\\n\\s\\.]",
          contains: [i.UNDERSCORE_TITLE_MODE]
        },
        i.C_LINE_COMMENT_MODE,
        i.C_BLOCK_COMMENT_MODE,
        {
          className: "string",
          begin: '"""',
          end: '"""',
          relevance: 5
        },
        i.APOS_STRING_MODE,
        i.QUOTE_STRING_MODE,
        i.C_NUMBER_MODE,
        {
          className: "meta",
          begin: "^#",
          end: "$"
        }
      ]
    };
  }
  return Ip = s, Ip;
}
var Dp, n1;
function _F() {
  if (n1)
    return Dp;
  n1 = 1;
  function s(i) {
    const o = i.regex, c = {
      className: "string",
      begin: /"(""|[^/n])"C\b/
    }, r = {
      className: "string",
      begin: /"/,
      end: /"/,
      illegal: /\n/,
      contains: [
        {
          // double quote escape
          begin: /""/
        }
      ]
    }, e = /\d{1,2}\/\d{1,2}\/\d{4}/, g = /\d{4}-\d{1,2}-\d{1,2}/, h = /(\d|1[012])(:\d+){0,2} *(AM|PM)/, S = /\d{1,2}(:\d{1,2}){1,2}/, C = {
      className: "literal",
      variants: [
        {
          // #YYYY-MM-DD# (ISO-Date) or #M/D/YYYY# (US-Date)
          begin: o.concat(/# */, o.either(g, e), / *#/)
        },
        {
          // #H:mm[:ss]# (24h Time)
          begin: o.concat(/# */, S, / *#/)
        },
        {
          // #h[:mm[:ss]] A# (12h Time)
          begin: o.concat(/# */, h, / *#/)
        },
        {
          // date plus time
          begin: o.concat(
            /# */,
            o.either(g, e),
            / +/,
            o.either(h, S),
            / *#/
          )
        }
      ]
    }, O = {
      className: "number",
      relevance: 0,
      variants: [
        {
          // Float
          begin: /\b\d[\d_]*((\.[\d_]+(E[+-]?[\d_]+)?)|(E[+-]?[\d_]+))[RFD@!#]?/
        },
        {
          // Integer (base 10)
          begin: /\b\d[\d_]*((U?[SIL])|[%&])?/
        },
        {
          // Integer (base 16)
          begin: /&H[\dA-F_]+((U?[SIL])|[%&])?/
        },
        {
          // Integer (base 8)
          begin: /&O[0-7_]+((U?[SIL])|[%&])?/
        },
        {
          // Integer (base 2)
          begin: /&B[01_]+((U?[SIL])|[%&])?/
        }
      ]
    }, N = {
      className: "label",
      begin: /^\w+:/
    }, D = i.COMMENT(/'''/, /$/, { contains: [
      {
        className: "doctag",
        begin: /<\/?/,
        end: />/
      }
    ] }), x = i.COMMENT(null, /$/, { variants: [
      { begin: /'/ },
      {
        // TODO: Use multi-class for leading spaces
        begin: /([\t ]|^)REM(?=\s)/
      }
    ] });
    return {
      name: "Visual Basic .NET",
      aliases: ["vb"],
      case_insensitive: !0,
      classNameAliases: { label: "symbol" },
      keywords: {
        keyword: "addhandler alias aggregate ansi as async assembly auto binary by byref byval call case catch class compare const continue custom declare default delegate dim distinct do each equals else elseif end enum erase error event exit explicit finally for friend from function get global goto group handles if implements imports in inherits interface into iterator join key let lib loop me mid module mustinherit mustoverride mybase myclass namespace narrowing new next notinheritable notoverridable of off on operator option optional order overloads overridable overrides paramarray partial preserve private property protected public raiseevent readonly redim removehandler resume return select set shadows shared skip static step stop structure strict sub synclock take text then throw to try unicode until using when where while widening with withevents writeonly yield",
        built_in: (
          // Operators https://docs.microsoft.com/dotnet/visual-basic/language-reference/operators
          "addressof and andalso await directcast gettype getxmlnamespace is isfalse isnot istrue like mod nameof new not or orelse trycast typeof xor cbool cbyte cchar cdate cdbl cdec cint clng cobj csbyte cshort csng cstr cuint culng cushort"
        ),
        type: (
          // Data types https://docs.microsoft.com/dotnet/visual-basic/language-reference/data-types
          "boolean byte char date decimal double integer long object sbyte short single string uinteger ulong ushort"
        ),
        literal: "true false nothing"
      },
      illegal: "//|\\{|\\}|endif|gosub|variant|wend|^\\$ ",
      contains: [
        c,
        r,
        C,
        O,
        N,
        D,
        x,
        {
          className: "meta",
          // TODO: Use multi-class for indentation once available
          begin: /[\t ]*#(const|disable|else|elseif|enable|end|externalsource|if|region)\b/,
          end: /$/,
          keywords: { keyword: "const disable else elseif enable end externalsource if region then" },
          contains: [x]
        }
      ]
    };
  }
  return Dp = s, Dp;
}
var wp, a1;
function pF() {
  if (a1)
    return wp;
  a1 = 1;
  function s(i) {
    const o = i.regex, c = [
      "lcase",
      "month",
      "vartype",
      "instrrev",
      "ubound",
      "setlocale",
      "getobject",
      "rgb",
      "getref",
      "string",
      "weekdayname",
      "rnd",
      "dateadd",
      "monthname",
      "now",
      "day",
      "minute",
      "isarray",
      "cbool",
      "round",
      "formatcurrency",
      "conversions",
      "csng",
      "timevalue",
      "second",
      "year",
      "space",
      "abs",
      "clng",
      "timeserial",
      "fixs",
      "len",
      "asc",
      "isempty",
      "maths",
      "dateserial",
      "atn",
      "timer",
      "isobject",
      "filter",
      "weekday",
      "datevalue",
      "ccur",
      "isdate",
      "instr",
      "datediff",
      "formatdatetime",
      "replace",
      "isnull",
      "right",
      "sgn",
      "array",
      "snumeric",
      "log",
      "cdbl",
      "hex",
      "chr",
      "lbound",
      "msgbox",
      "ucase",
      "getlocale",
      "cos",
      "cdate",
      "cbyte",
      "rtrim",
      "join",
      "hour",
      "oct",
      "typename",
      "trim",
      "strcomp",
      "int",
      "createobject",
      "loadpicture",
      "tan",
      "formatnumber",
      "mid",
      "split",
      "cint",
      "sin",
      "datepart",
      "ltrim",
      "sqr",
      "time",
      "derived",
      "eval",
      "date",
      "formatpercent",
      "exp",
      "inputbox",
      "left",
      "ascw",
      "chrw",
      "regexp",
      "cstr",
      "err"
    ], r = [
      "server",
      "response",
      "request",
      // take no arguments so can be called without ()
      "scriptengine",
      "scriptenginebuildversion",
      "scriptengineminorversion",
      "scriptenginemajorversion"
    ], e = {
      begin: o.concat(o.either(...c), "\\s*\\("),
      // relevance 0 because this is acting as a beginKeywords really
      relevance: 0,
      keywords: { built_in: c }
    };
    return {
      name: "VBScript",
      aliases: ["vbs"],
      case_insensitive: !0,
      keywords: {
        keyword: [
          "call",
          "class",
          "const",
          "dim",
          "do",
          "loop",
          "erase",
          "execute",
          "executeglobal",
          "exit",
          "for",
          "each",
          "next",
          "function",
          "if",
          "then",
          "else",
          "on",
          "error",
          "option",
          "explicit",
          "new",
          "private",
          "property",
          "let",
          "get",
          "public",
          "randomize",
          "redim",
          "rem",
          "select",
          "case",
          "set",
          "stop",
          "sub",
          "while",
          "wend",
          "with",
          "end",
          "to",
          "elseif",
          "is",
          "or",
          "xor",
          "and",
          "not",
          "class_initialize",
          "class_terminate",
          "default",
          "preserve",
          "in",
          "me",
          "byval",
          "byref",
          "step",
          "resume",
          "goto"
        ],
        built_in: r,
        literal: [
          "true",
          "false",
          "null",
          "nothing",
          "empty"
        ]
      },
      illegal: "//",
      contains: [
        e,
        i.inherit(i.QUOTE_STRING_MODE, { contains: [{ begin: '""' }] }),
        i.COMMENT(
          /'/,
          /$/,
          { relevance: 0 }
        ),
        i.C_NUMBER_MODE
      ]
    };
  }
  return wp = s, wp;
}
var xp, i1;
function mF() {
  if (i1)
    return xp;
  i1 = 1;
  function s(i) {
    return {
      name: "VBScript in HTML",
      subLanguage: "xml",
      contains: [
        {
          begin: "<%",
          end: "%>",
          subLanguage: "vbscript"
        }
      ]
    };
  }
  return xp = s, xp;
}
var Lp, o1;
function fF() {
  if (o1)
    return Lp;
  o1 = 1;
  function s(i) {
    const o = i.regex, c = {
      $pattern: /\$?[\w]+(\$[\w]+)*/,
      keyword: [
        "accept_on",
        "alias",
        "always",
        "always_comb",
        "always_ff",
        "always_latch",
        "and",
        "assert",
        "assign",
        "assume",
        "automatic",
        "before",
        "begin",
        "bind",
        "bins",
        "binsof",
        "bit",
        "break",
        "buf|0",
        "bufif0",
        "bufif1",
        "byte",
        "case",
        "casex",
        "casez",
        "cell",
        "chandle",
        "checker",
        "class",
        "clocking",
        "cmos",
        "config",
        "const",
        "constraint",
        "context",
        "continue",
        "cover",
        "covergroup",
        "coverpoint",
        "cross",
        "deassign",
        "default",
        "defparam",
        "design",
        "disable",
        "dist",
        "do",
        "edge",
        "else",
        "end",
        "endcase",
        "endchecker",
        "endclass",
        "endclocking",
        "endconfig",
        "endfunction",
        "endgenerate",
        "endgroup",
        "endinterface",
        "endmodule",
        "endpackage",
        "endprimitive",
        "endprogram",
        "endproperty",
        "endspecify",
        "endsequence",
        "endtable",
        "endtask",
        "enum",
        "event",
        "eventually",
        "expect",
        "export",
        "extends",
        "extern",
        "final",
        "first_match",
        "for",
        "force",
        "foreach",
        "forever",
        "fork",
        "forkjoin",
        "function",
        "generate|5",
        "genvar",
        "global",
        "highz0",
        "highz1",
        "if",
        "iff",
        "ifnone",
        "ignore_bins",
        "illegal_bins",
        "implements",
        "implies",
        "import",
        "incdir",
        "include",
        "initial",
        "inout",
        "input",
        "inside",
        "instance",
        "int",
        "integer",
        "interconnect",
        "interface",
        "intersect",
        "join",
        "join_any",
        "join_none",
        "large",
        "let",
        "liblist",
        "library",
        "local",
        "localparam",
        "logic",
        "longint",
        "macromodule",
        "matches",
        "medium",
        "modport",
        "module",
        "nand",
        "negedge",
        "nettype",
        "new",
        "nexttime",
        "nmos",
        "nor",
        "noshowcancelled",
        "not",
        "notif0",
        "notif1",
        "or",
        "output",
        "package",
        "packed",
        "parameter",
        "pmos",
        "posedge",
        "primitive",
        "priority",
        "program",
        "property",
        "protected",
        "pull0",
        "pull1",
        "pulldown",
        "pullup",
        "pulsestyle_ondetect",
        "pulsestyle_onevent",
        "pure",
        "rand",
        "randc",
        "randcase",
        "randsequence",
        "rcmos",
        "real",
        "realtime",
        "ref",
        "reg",
        "reject_on",
        "release",
        "repeat",
        "restrict",
        "return",
        "rnmos",
        "rpmos",
        "rtran",
        "rtranif0",
        "rtranif1",
        "s_always",
        "s_eventually",
        "s_nexttime",
        "s_until",
        "s_until_with",
        "scalared",
        "sequence",
        "shortint",
        "shortreal",
        "showcancelled",
        "signed",
        "small",
        "soft",
        "solve",
        "specify",
        "specparam",
        "static",
        "string",
        "strong",
        "strong0",
        "strong1",
        "struct",
        "super",
        "supply0",
        "supply1",
        "sync_accept_on",
        "sync_reject_on",
        "table",
        "tagged",
        "task",
        "this",
        "throughout",
        "time",
        "timeprecision",
        "timeunit",
        "tran",
        "tranif0",
        "tranif1",
        "tri",
        "tri0",
        "tri1",
        "triand",
        "trior",
        "trireg",
        "type",
        "typedef",
        "union",
        "unique",
        "unique0",
        "unsigned",
        "until",
        "until_with",
        "untyped",
        "use",
        "uwire",
        "var",
        "vectored",
        "virtual",
        "void",
        "wait",
        "wait_order",
        "wand",
        "weak",
        "weak0",
        "weak1",
        "while",
        "wildcard",
        "wire",
        "with",
        "within",
        "wor",
        "xnor",
        "xor"
      ],
      literal: ["null"],
      built_in: [
        "$finish",
        "$stop",
        "$exit",
        "$fatal",
        "$error",
        "$warning",
        "$info",
        "$realtime",
        "$time",
        "$printtimescale",
        "$bitstoreal",
        "$bitstoshortreal",
        "$itor",
        "$signed",
        "$cast",
        "$bits",
        "$stime",
        "$timeformat",
        "$realtobits",
        "$shortrealtobits",
        "$rtoi",
        "$unsigned",
        "$asserton",
        "$assertkill",
        "$assertpasson",
        "$assertfailon",
        "$assertnonvacuouson",
        "$assertoff",
        "$assertcontrol",
        "$assertpassoff",
        "$assertfailoff",
        "$assertvacuousoff",
        "$isunbounded",
        "$sampled",
        "$fell",
        "$changed",
        "$past_gclk",
        "$fell_gclk",
        "$changed_gclk",
        "$rising_gclk",
        "$steady_gclk",
        "$coverage_control",
        "$coverage_get",
        "$coverage_save",
        "$set_coverage_db_name",
        "$rose",
        "$stable",
        "$past",
        "$rose_gclk",
        "$stable_gclk",
        "$future_gclk",
        "$falling_gclk",
        "$changing_gclk",
        "$display",
        "$coverage_get_max",
        "$coverage_merge",
        "$get_coverage",
        "$load_coverage_db",
        "$typename",
        "$unpacked_dimensions",
        "$left",
        "$low",
        "$increment",
        "$clog2",
        "$ln",
        "$log10",
        "$exp",
        "$sqrt",
        "$pow",
        "$floor",
        "$ceil",
        "$sin",
        "$cos",
        "$tan",
        "$countbits",
        "$onehot",
        "$isunknown",
        "$fatal",
        "$warning",
        "$dimensions",
        "$right",
        "$high",
        "$size",
        "$asin",
        "$acos",
        "$atan",
        "$atan2",
        "$hypot",
        "$sinh",
        "$cosh",
        "$tanh",
        "$asinh",
        "$acosh",
        "$atanh",
        "$countones",
        "$onehot0",
        "$error",
        "$info",
        "$random",
        "$dist_chi_square",
        "$dist_erlang",
        "$dist_exponential",
        "$dist_normal",
        "$dist_poisson",
        "$dist_t",
        "$dist_uniform",
        "$q_initialize",
        "$q_remove",
        "$q_exam",
        "$async$and$array",
        "$async$nand$array",
        "$async$or$array",
        "$async$nor$array",
        "$sync$and$array",
        "$sync$nand$array",
        "$sync$or$array",
        "$sync$nor$array",
        "$q_add",
        "$q_full",
        "$psprintf",
        "$async$and$plane",
        "$async$nand$plane",
        "$async$or$plane",
        "$async$nor$plane",
        "$sync$and$plane",
        "$sync$nand$plane",
        "$sync$or$plane",
        "$sync$nor$plane",
        "$system",
        "$display",
        "$displayb",
        "$displayh",
        "$displayo",
        "$strobe",
        "$strobeb",
        "$strobeh",
        "$strobeo",
        "$write",
        "$readmemb",
        "$readmemh",
        "$writememh",
        "$value$plusargs",
        "$dumpvars",
        "$dumpon",
        "$dumplimit",
        "$dumpports",
        "$dumpportson",
        "$dumpportslimit",
        "$writeb",
        "$writeh",
        "$writeo",
        "$monitor",
        "$monitorb",
        "$monitorh",
        "$monitoro",
        "$writememb",
        "$dumpfile",
        "$dumpoff",
        "$dumpall",
        "$dumpflush",
        "$dumpportsoff",
        "$dumpportsall",
        "$dumpportsflush",
        "$fclose",
        "$fdisplay",
        "$fdisplayb",
        "$fdisplayh",
        "$fdisplayo",
        "$fstrobe",
        "$fstrobeb",
        "$fstrobeh",
        "$fstrobeo",
        "$swrite",
        "$swriteb",
        "$swriteh",
        "$swriteo",
        "$fscanf",
        "$fread",
        "$fseek",
        "$fflush",
        "$feof",
        "$fopen",
        "$fwrite",
        "$fwriteb",
        "$fwriteh",
        "$fwriteo",
        "$fmonitor",
        "$fmonitorb",
        "$fmonitorh",
        "$fmonitoro",
        "$sformat",
        "$sformatf",
        "$fgetc",
        "$ungetc",
        "$fgets",
        "$sscanf",
        "$rewind",
        "$ftell",
        "$ferror"
      ]
    }, r = [
      "__FILE__",
      "__LINE__"
    ], e = [
      "begin_keywords",
      "celldefine",
      "default_nettype",
      "default_decay_time",
      "default_trireg_strength",
      "define",
      "delay_mode_distributed",
      "delay_mode_path",
      "delay_mode_unit",
      "delay_mode_zero",
      "else",
      "elsif",
      "end_keywords",
      "endcelldefine",
      "endif",
      "ifdef",
      "ifndef",
      "include",
      "line",
      "nounconnected_drive",
      "pragma",
      "resetall",
      "timescale",
      "unconnected_drive",
      "undef",
      "undefineall"
    ];
    return {
      name: "Verilog",
      aliases: [
        "v",
        "sv",
        "svh"
      ],
      case_insensitive: !1,
      keywords: c,
      contains: [
        i.C_BLOCK_COMMENT_MODE,
        i.C_LINE_COMMENT_MODE,
        i.QUOTE_STRING_MODE,
        {
          scope: "number",
          contains: [i.BACKSLASH_ESCAPE],
          variants: [
            { begin: /\b((\d+'([bhodBHOD]))[0-9xzXZa-fA-F_]+)/ },
            { begin: /\B(('([bhodBHOD]))[0-9xzXZa-fA-F_]+)/ },
            {
              // decimal
              begin: /\b[0-9][0-9_]*/,
              relevance: 0
            }
          ]
        },
        /* parameters to instances */
        {
          scope: "variable",
          variants: [
            { begin: "#\\((?!parameter).+\\)" },
            {
              begin: "\\.\\w+",
              relevance: 0
            }
          ]
        },
        {
          scope: "variable.constant",
          match: o.concat(/`/, o.either(...r))
        },
        {
          scope: "meta",
          begin: o.concat(/`/, o.either(...e)),
          end: /$|\/\/|\/\*/,
          returnEnd: !0,
          keywords: e
        }
      ]
    };
  }
  return Lp = s, Lp;
}
var Mp, s1;
function gF() {
  if (s1)
    return Mp;
  s1 = 1;
  function s(i) {
    const o = "\\d(_|\\d)*", c = "[eE][-+]?" + o, r = o + "(\\." + o + ")?(" + c + ")?", e = "\\w+", h = "\\b(" + (o + "#" + e + "(\\." + e + ")?#(" + c + ")?") + "|" + r + ")";
    return {
      name: "VHDL",
      case_insensitive: !0,
      keywords: {
        keyword: [
          "abs",
          "access",
          "after",
          "alias",
          "all",
          "and",
          "architecture",
          "array",
          "assert",
          "assume",
          "assume_guarantee",
          "attribute",
          "begin",
          "block",
          "body",
          "buffer",
          "bus",
          "case",
          "component",
          "configuration",
          "constant",
          "context",
          "cover",
          "disconnect",
          "downto",
          "default",
          "else",
          "elsif",
          "end",
          "entity",
          "exit",
          "fairness",
          "file",
          "for",
          "force",
          "function",
          "generate",
          "generic",
          "group",
          "guarded",
          "if",
          "impure",
          "in",
          "inertial",
          "inout",
          "is",
          "label",
          "library",
          "linkage",
          "literal",
          "loop",
          "map",
          "mod",
          "nand",
          "new",
          "next",
          "nor",
          "not",
          "null",
          "of",
          "on",
          "open",
          "or",
          "others",
          "out",
          "package",
          "parameter",
          "port",
          "postponed",
          "procedure",
          "process",
          "property",
          "protected",
          "pure",
          "range",
          "record",
          "register",
          "reject",
          "release",
          "rem",
          "report",
          "restrict",
          "restrict_guarantee",
          "return",
          "rol",
          "ror",
          "select",
          "sequence",
          "severity",
          "shared",
          "signal",
          "sla",
          "sll",
          "sra",
          "srl",
          "strong",
          "subtype",
          "then",
          "to",
          "transport",
          "type",
          "unaffected",
          "units",
          "until",
          "use",
          "variable",
          "view",
          "vmode",
          "vprop",
          "vunit",
          "wait",
          "when",
          "while",
          "with",
          "xnor",
          "xor"
        ],
        built_in: [
          "boolean",
          "bit",
          "character",
          "integer",
          "time",
          "delay_length",
          "natural",
          "positive",
          "string",
          "bit_vector",
          "file_open_kind",
          "file_open_status",
          "std_logic",
          "std_logic_vector",
          "unsigned",
          "signed",
          "boolean_vector",
          "integer_vector",
          "std_ulogic",
          "std_ulogic_vector",
          "unresolved_unsigned",
          "u_unsigned",
          "unresolved_signed",
          "u_signed",
          "real_vector",
          "time_vector"
        ],
        literal: [
          // severity_level
          "false",
          "true",
          "note",
          "warning",
          "error",
          "failure",
          // textio
          "line",
          "text",
          "side",
          "width"
        ]
      },
      illegal: /\{/,
      contains: [
        i.C_BLOCK_COMMENT_MODE,
        // VHDL-2008 block commenting.
        i.COMMENT("--", "$"),
        i.QUOTE_STRING_MODE,
        {
          className: "number",
          begin: h,
          relevance: 0
        },
        {
          className: "string",
          begin: "'(U|X|0|1|Z|W|L|H|-)'",
          contains: [i.BACKSLASH_ESCAPE]
        },
        {
          className: "symbol",
          begin: "'[A-Za-z](_?[A-Za-z0-9])*",
          contains: [i.BACKSLASH_ESCAPE]
        }
      ]
    };
  }
  return Mp = s, Mp;
}
var Pp, l1;
function EF() {
  if (l1)
    return Pp;
  l1 = 1;
  function s(i) {
    return {
      name: "Vim Script",
      keywords: {
        $pattern: /[!#@\w]+/,
        keyword: (
          // express version except: ! & * < = > !! # @ @@
          "N|0 P|0 X|0 a|0 ab abc abo al am an|0 ar arga argd arge argdo argg argl argu as au aug aun b|0 bN ba bad bd be bel bf bl bm bn bo bp br brea breaka breakd breakl bro bufdo buffers bun bw c|0 cN cNf ca cabc caddb cad caddf cal cat cb cc ccl cd ce cex cf cfir cgetb cgete cg changes chd che checkt cl cla clo cm cmapc cme cn cnew cnf cno cnorea cnoreme co col colo com comc comp con conf cope cp cpf cq cr cs cst cu cuna cunme cw delm deb debugg delc delf dif diffg diffo diffp diffpu diffs diffthis dig di dl dell dj dli do doautoa dp dr ds dsp e|0 ea ec echoe echoh echom echon el elsei em en endfo endf endt endw ene ex exe exi exu f|0 files filet fin fina fini fir fix fo foldc foldd folddoc foldo for fu go gr grepa gu gv ha helpf helpg helpt hi hid his ia iabc if ij il im imapc ime ino inorea inoreme int is isp iu iuna iunme j|0 ju k|0 keepa kee keepj lN lNf l|0 lad laddb laddf la lan lat lb lc lch lcl lcs le lefta let lex lf lfir lgetb lgete lg lgr lgrepa lh ll lla lli lmak lm lmapc lne lnew lnf ln loadk lo loc lockv lol lope lp lpf lr ls lt lu lua luad luaf lv lvimgrepa lw m|0 ma mak map mapc marks mat me menut mes mk mks mksp mkv mkvie mod mz mzf nbc nb nbs new nm nmapc nme nn nnoreme noa no noh norea noreme norm nu nun nunme ol o|0 om omapc ome on ono onoreme opt ou ounme ow p|0 profd prof pro promptr pc ped pe perld po popu pp pre prev ps pt ptN ptf ptj ptl ptn ptp ptr pts pu pw py3 python3 py3d py3f py pyd pyf quita qa rec red redi redr redraws reg res ret retu rew ri rightb rub rubyd rubyf rund ru rv sN san sa sal sav sb sbN sba sbf sbl sbm sbn sbp sbr scrip scripte scs se setf setg setl sf sfir sh sim sig sil sl sla sm smap smapc sme sn sni sno snor snoreme sor so spelld spe spelli spellr spellu spellw sp spr sre st sta startg startr star stopi stj sts sun sunm sunme sus sv sw sy synti sync tN tabN tabc tabdo tabe tabf tabfir tabl tabm tabnew tabn tabo tabp tabr tabs tab ta tags tc tcld tclf te tf th tj tl tm tn to tp tr try ts tu u|0 undoj undol una unh unl unlo unm unme uns up ve verb vert vim vimgrepa vi viu vie vm vmapc vme vne vn vnoreme vs vu vunme windo w|0 wN wa wh wi winc winp wn wp wq wqa ws wu wv x|0 xa xmapc xm xme xn xnoreme xu xunme y|0 z|0 ~ Next Print append abbreviate abclear aboveleft all amenu anoremenu args argadd argdelete argedit argglobal arglocal argument ascii autocmd augroup aunmenu buffer bNext ball badd bdelete behave belowright bfirst blast bmodified bnext botright bprevious brewind break breakadd breakdel breaklist browse bunload bwipeout change cNext cNfile cabbrev cabclear caddbuffer caddexpr caddfile call catch cbuffer cclose center cexpr cfile cfirst cgetbuffer cgetexpr cgetfile chdir checkpath checktime clist clast close cmap cmapclear cmenu cnext cnewer cnfile cnoremap cnoreabbrev cnoremenu copy colder colorscheme command comclear compiler continue confirm copen cprevious cpfile cquit crewind cscope cstag cunmap cunabbrev cunmenu cwindow delete delmarks debug debuggreedy delcommand delfunction diffupdate diffget diffoff diffpatch diffput diffsplit digraphs display deletel djump dlist doautocmd doautoall deletep drop dsearch dsplit edit earlier echo echoerr echohl echomsg else elseif emenu endif endfor endfunction endtry endwhile enew execute exit exusage file filetype find finally finish first fixdel fold foldclose folddoopen folddoclosed foldopen function global goto grep grepadd gui gvim hardcopy help helpfind helpgrep helptags highlight hide history insert iabbrev iabclear ijump ilist imap imapclear imenu inoremap inoreabbrev inoremenu intro isearch isplit iunmap iunabbrev iunmenu join jumps keepalt keepmarks keepjumps lNext lNfile list laddexpr laddbuffer laddfile last language later lbuffer lcd lchdir lclose lcscope left leftabove lexpr lfile lfirst lgetbuffer lgetexpr lgetfile lgrep lgrepadd lhelpgrep llast llist lmake lmap lmapclear lnext lnewer lnfile lnoremap loadkeymap loadview lockmarks lockvar lolder lopen lprevious lpfile lrewind ltag lunmap luado luafile lvimgrep lvimgrepadd lwindow move mark make mapclear match menu menutranslate messages mkexrc mksession mkspell mkvimrc mkview mode mzscheme mzfile nbclose nbkey nbsart next nmap nmapclear nmenu nnoremap nnoremenu noautocmd noremap nohlsearch noreabbrev noremenu normal number nunmap nunmenu oldfiles open omap omapclear omenu only onoremap onoremenu options ounmap ounmenu ownsyntax print profdel profile promptfind promptrepl pclose pedit perl perldo pop popup ppop preserve previous psearch ptag ptNext ptfirst ptjump ptlast ptnext ptprevious ptrewind ptselect put pwd py3do py3file python pydo pyfile quit quitall qall read recover redo redir redraw redrawstatus registers resize retab return rewind right rightbelow ruby rubydo rubyfile rundo runtime rviminfo substitute sNext sandbox sargument sall saveas sbuffer sbNext sball sbfirst sblast sbmodified sbnext sbprevious sbrewind scriptnames scriptencoding scscope set setfiletype setglobal setlocal sfind sfirst shell simalt sign silent sleep slast smagic smapclear smenu snext sniff snomagic snoremap snoremenu sort source spelldump spellgood spellinfo spellrepall spellundo spellwrong split sprevious srewind stop stag startgreplace startreplace startinsert stopinsert stjump stselect sunhide sunmap sunmenu suspend sview swapname syntax syntime syncbind tNext tabNext tabclose tabedit tabfind tabfirst tablast tabmove tabnext tabonly tabprevious tabrewind tag tcl tcldo tclfile tearoff tfirst throw tjump tlast tmenu tnext topleft tprevious trewind tselect tunmenu undo undojoin undolist unabbreviate unhide unlet unlockvar unmap unmenu unsilent update vglobal version verbose vertical vimgrep vimgrepadd visual viusage view vmap vmapclear vmenu vnew vnoremap vnoremenu vsplit vunmap vunmenu write wNext wall while winsize wincmd winpos wnext wprevious wqall wsverb wundo wviminfo xit xall xmapclear xmap xmenu xnoremap xnoremenu xunmap xunmenu yank"
        ),
        built_in: (
          // built in func
          "synIDtrans atan2 range matcharg did_filetype asin feedkeys xor argv complete_check add getwinposx getqflist getwinposy screencol clearmatches empty extend getcmdpos mzeval garbagecollect setreg ceil sqrt diff_hlID inputsecret get getfperm getpid filewritable shiftwidth max sinh isdirectory synID system inputrestore winline atan visualmode inputlist tabpagewinnr round getregtype mapcheck hasmapto histdel argidx findfile sha256 exists toupper getcmdline taglist string getmatches bufnr strftime winwidth bufexists strtrans tabpagebuflist setcmdpos remote_read printf setloclist getpos getline bufwinnr float2nr len getcmdtype diff_filler luaeval resolve libcallnr foldclosedend reverse filter has_key bufname str2float strlen setline getcharmod setbufvar index searchpos shellescape undofile foldclosed setqflist buflisted strchars str2nr virtcol floor remove undotree remote_expr winheight gettabwinvar reltime cursor tabpagenr finddir localtime acos getloclist search tanh matchend rename gettabvar strdisplaywidth type abs py3eval setwinvar tolower wildmenumode log10 spellsuggest bufloaded synconcealed nextnonblank server2client complete settabwinvar executable input wincol setmatches getftype hlID inputsave searchpair or screenrow line settabvar histadd deepcopy strpart remote_peek and eval getftime submatch screenchar winsaveview matchadd mkdir screenattr getfontname libcall reltimestr getfsize winnr invert pow getbufline byte2line soundfold repeat fnameescape tagfiles sin strwidth spellbadword trunc maparg log lispindent hostname setpos globpath remote_foreground getchar synIDattr fnamemodify cscope_connection stridx winbufnr indent min complete_add nr2char searchpairpos inputdialog values matchlist items hlexists strridx browsedir expand fmod pathshorten line2byte argc count getwinvar glob foldtextresult getreg foreground cosh matchdelete has char2nr simplify histget searchdecl iconv winrestcmd pumvisible writefile foldlevel haslocaldir keys cos matchstr foldtext histnr tan tempname getcwd byteidx getbufvar islocked escape eventhandler remote_send serverlist winrestview synstack pyeval prevnonblank readfile cindent filereadable changenr exp"
        )
      },
      illegal: /;/,
      contains: [
        i.NUMBER_MODE,
        {
          className: "string",
          begin: "'",
          end: "'",
          illegal: "\\n"
        },
        /*
        	      A double quote can start either a string or a line comment. Strings are
        	      ended before the end of a line by another double quote and can contain
        	      escaped double-quotes and post-escaped line breaks.
        
        	      Also, any double quote at the beginning of a line is a comment but we
        	      don't handle that properly at the moment: any double quote inside will
        	      turn them into a string. Handling it properly will require a smarter
        	      parser.
        	      */
        {
          className: "string",
          begin: /"(\\"|\n\\|[^"\n])*"/
        },
        i.COMMENT('"', "$"),
        {
          className: "variable",
          begin: /[bwtglsav]:[\w\d_]+/
        },
        {
          begin: [
            /\b(?:function|function!)/,
            /\s+/,
            i.IDENT_RE
          ],
          className: {
            1: "keyword",
            3: "title"
          },
          end: "$",
          relevance: 0,
          contains: [
            {
              className: "params",
              begin: "\\(",
              end: "\\)"
            }
          ]
        },
        {
          className: "symbol",
          begin: /<[\w-]+>/
        }
      ]
    };
  }
  return Pp = s, Pp;
}
var kp, c1;
function hF() {
  if (c1)
    return kp;
  c1 = 1;
  function s(i) {
    i.regex;
    const o = i.COMMENT(/\(;/, /;\)/);
    o.contains.push("self");
    const c = i.COMMENT(/;;/, /$/), r = [
      "anyfunc",
      "block",
      "br",
      "br_if",
      "br_table",
      "call",
      "call_indirect",
      "data",
      "drop",
      "elem",
      "else",
      "end",
      "export",
      "func",
      "global.get",
      "global.set",
      "local.get",
      "local.set",
      "local.tee",
      "get_global",
      "get_local",
      "global",
      "if",
      "import",
      "local",
      "loop",
      "memory",
      "memory.grow",
      "memory.size",
      "module",
      "mut",
      "nop",
      "offset",
      "param",
      "result",
      "return",
      "select",
      "set_global",
      "set_local",
      "start",
      "table",
      "tee_local",
      "then",
      "type",
      "unreachable"
    ], e = {
      begin: [
        /(?:func|call|call_indirect)/,
        /\s+/,
        /\$[^\s)]+/
      ],
      className: {
        1: "keyword",
        3: "title.function"
      }
    }, g = {
      className: "variable",
      begin: /\$[\w_]+/
    }, h = {
      match: /(\((?!;)|\))+/,
      className: "punctuation",
      relevance: 0
    }, S = {
      className: "number",
      relevance: 0,
      // borrowed from Prism, TODO: split out into variants
      match: /[+-]?\b(?:\d(?:_?\d)*(?:\.\d(?:_?\d)*)?(?:[eE][+-]?\d(?:_?\d)*)?|0x[\da-fA-F](?:_?[\da-fA-F])*(?:\.[\da-fA-F](?:_?[\da-fA-D])*)?(?:[pP][+-]?\d(?:_?\d)*)?)\b|\binf\b|\bnan(?::0x[\da-fA-F](?:_?[\da-fA-D])*)?\b/
    }, C = {
      // look-ahead prevents us from gobbling up opcodes
      match: /(i32|i64|f32|f64)(?!\.)/,
      className: "type"
    }, O = {
      className: "keyword",
      // borrowed from Prism, TODO: split out into variants
      match: /\b(f32|f64|i32|i64)(?:\.(?:abs|add|and|ceil|clz|const|convert_[su]\/i(?:32|64)|copysign|ctz|demote\/f64|div(?:_[su])?|eqz?|extend_[su]\/i32|floor|ge(?:_[su])?|gt(?:_[su])?|le(?:_[su])?|load(?:(?:8|16|32)_[su])?|lt(?:_[su])?|max|min|mul|nearest|neg?|or|popcnt|promote\/f32|reinterpret\/[fi](?:32|64)|rem_[su]|rot[lr]|shl|shr_[su]|store(?:8|16|32)?|sqrt|sub|trunc(?:_[su]\/f(?:32|64))?|wrap\/i64|xor))\b/
    };
    return {
      name: "WebAssembly",
      keywords: {
        $pattern: /[\w.]+/,
        keyword: r
      },
      contains: [
        c,
        o,
        {
          match: [
            /(?:offset|align)/,
            /\s*/,
            /=/
          ],
          className: {
            1: "keyword",
            3: "operator"
          }
        },
        g,
        h,
        e,
        i.QUOTE_STRING_MODE,
        C,
        O,
        S
      ]
    };
  }
  return kp = s, kp;
}
var Fp, d1;
function SF() {
  if (d1)
    return Fp;
  d1 = 1;
  function s(i) {
    const o = i.regex, c = /[a-zA-Z]\w*/, r = [
      "as",
      "break",
      "class",
      "construct",
      "continue",
      "else",
      "for",
      "foreign",
      "if",
      "import",
      "in",
      "is",
      "return",
      "static",
      "var",
      "while"
    ], e = [
      "true",
      "false",
      "null"
    ], g = [
      "this",
      "super"
    ], h = [
      "Bool",
      "Class",
      "Fiber",
      "Fn",
      "List",
      "Map",
      "Null",
      "Num",
      "Object",
      "Range",
      "Sequence",
      "String",
      "System"
    ], S = [
      "-",
      "~",
      /\*/,
      "%",
      /\.\.\./,
      /\.\./,
      /\+/,
      "<<",
      ">>",
      ">=",
      "<=",
      "<",
      ">",
      /\^/,
      /!=/,
      /!/,
      /\bis\b/,
      "==",
      "&&",
      "&",
      /\|\|/,
      /\|/,
      /\?:/,
      "="
    ], C = {
      relevance: 0,
      match: o.concat(/\b(?!(if|while|for|else|super)\b)/, c, /(?=\s*[({])/),
      className: "title.function"
    }, O = {
      match: o.concat(
        o.either(
          o.concat(/\b(?!(if|while|for|else|super)\b)/, c),
          o.either(...S)
        ),
        /(?=\s*\([^)]+\)\s*\{)/
      ),
      className: "title.function",
      starts: { contains: [
        {
          begin: /\(/,
          end: /\)/,
          contains: [
            {
              relevance: 0,
              scope: "params",
              match: c
            }
          ]
        }
      ] }
    }, N = {
      variants: [
        { match: [
          /class\s+/,
          c,
          /\s+is\s+/,
          c
        ] },
        { match: [
          /class\s+/,
          c
        ] }
      ],
      scope: {
        2: "title.class",
        4: "title.class.inherited"
      },
      keywords: r
    }, D = {
      relevance: 0,
      match: o.either(...S),
      className: "operator"
    }, x = {
      className: "string",
      begin: /"""/,
      end: /"""/
    }, L = {
      className: "property",
      begin: o.concat(/\./, o.lookahead(c)),
      end: c,
      excludeBegin: !0,
      relevance: 0
    }, G = {
      relevance: 0,
      match: o.concat(/\b_/, c),
      scope: "variable"
    }, Y = {
      relevance: 0,
      match: /\b[A-Z]+[a-z]+([A-Z]+[a-z]+)*/,
      scope: "title.class",
      keywords: { _: h }
    }, k = i.C_NUMBER_MODE, W = {
      match: [
        c,
        /\s*/,
        /=/,
        /\s*/,
        /\(/,
        c,
        /\)\s*\{/
      ],
      scope: {
        1: "title.function",
        3: "operator",
        6: "params"
      }
    }, Z = i.COMMENT(
      /\/\*\*/,
      /\*\//,
      { contains: [
        {
          match: /@[a-z]+/,
          scope: "doctag"
        },
        "self"
      ] }
    ), H = {
      scope: "subst",
      begin: /%\(/,
      end: /\)/,
      contains: [
        k,
        Y,
        C,
        G,
        D
      ]
    }, K = {
      scope: "string",
      begin: /"/,
      end: /"/,
      contains: [
        H,
        {
          scope: "char.escape",
          variants: [
            { match: /\\\\|\\["0%abefnrtv]/ },
            { match: /\\x[0-9A-F]{2}/ },
            { match: /\\u[0-9A-F]{4}/ },
            { match: /\\U[0-9A-F]{8}/ }
          ]
        }
      ]
    };
    H.contains.push(K);
    const Q = [
      ...r,
      ...g,
      ...e
    ], _e = {
      relevance: 0,
      match: o.concat(
        "\\b(?!",
        Q.join("|"),
        "\\b)",
        /[a-zA-Z_]\w*(?:[?!]|\b)/
      ),
      className: "variable"
    };
    return {
      name: "Wren",
      keywords: {
        keyword: r,
        "variable.language": g,
        literal: e
      },
      contains: [
        {
          // scope: "meta",
          scope: "comment",
          variants: [
            {
              begin: [
                /#!?/,
                /[A-Za-z_]+(?=\()/
              ],
              beginScope: {
                // 2: "attr"
              },
              keywords: { literal: e },
              contains: [
                // NUMBER,
                // VARIABLE
              ],
              end: /\)/
            },
            {
              begin: [
                /#!?/,
                /[A-Za-z_]+/
              ],
              beginScope: {
                // 2: "attr"
              },
              end: /$/
            }
          ]
        },
        k,
        K,
        x,
        Z,
        i.C_LINE_COMMENT_MODE,
        i.C_BLOCK_COMMENT_MODE,
        Y,
        N,
        W,
        O,
        C,
        D,
        G,
        L,
        _e
      ]
    };
  }
  return Fp = s, Fp;
}
var Up, u1;
function bF() {
  if (u1)
    return Up;
  u1 = 1;
  function s(i) {
    return {
      name: "Intel x86 Assembly",
      case_insensitive: !0,
      keywords: {
        $pattern: "[.%]?" + i.IDENT_RE,
        keyword: "lock rep repe repz repne repnz xaquire xrelease bnd nobnd aaa aad aam aas adc add and arpl bb0_reset bb1_reset bound bsf bsr bswap bt btc btr bts call cbw cdq cdqe clc cld cli clts cmc cmp cmpsb cmpsd cmpsq cmpsw cmpxchg cmpxchg486 cmpxchg8b cmpxchg16b cpuid cpu_read cpu_write cqo cwd cwde daa das dec div dmint emms enter equ f2xm1 fabs fadd faddp fbld fbstp fchs fclex fcmovb fcmovbe fcmove fcmovnb fcmovnbe fcmovne fcmovnu fcmovu fcom fcomi fcomip fcomp fcompp fcos fdecstp fdisi fdiv fdivp fdivr fdivrp femms feni ffree ffreep fiadd ficom ficomp fidiv fidivr fild fimul fincstp finit fist fistp fisttp fisub fisubr fld fld1 fldcw fldenv fldl2e fldl2t fldlg2 fldln2 fldpi fldz fmul fmulp fnclex fndisi fneni fninit fnop fnsave fnstcw fnstenv fnstsw fpatan fprem fprem1 fptan frndint frstor fsave fscale fsetpm fsin fsincos fsqrt fst fstcw fstenv fstp fstsw fsub fsubp fsubr fsubrp ftst fucom fucomi fucomip fucomp fucompp fxam fxch fxtract fyl2x fyl2xp1 hlt ibts icebp idiv imul in inc incbin insb insd insw int int01 int1 int03 int3 into invd invpcid invlpg invlpga iret iretd iretq iretw jcxz jecxz jrcxz jmp jmpe lahf lar lds lea leave les lfence lfs lgdt lgs lidt lldt lmsw loadall loadall286 lodsb lodsd lodsq lodsw loop loope loopne loopnz loopz lsl lss ltr mfence monitor mov movd movq movsb movsd movsq movsw movsx movsxd movzx mul mwait neg nop not or out outsb outsd outsw packssdw packsswb packuswb paddb paddd paddsb paddsiw paddsw paddusb paddusw paddw pand pandn pause paveb pavgusb pcmpeqb pcmpeqd pcmpeqw pcmpgtb pcmpgtd pcmpgtw pdistib pf2id pfacc pfadd pfcmpeq pfcmpge pfcmpgt pfmax pfmin pfmul pfrcp pfrcpit1 pfrcpit2 pfrsqit1 pfrsqrt pfsub pfsubr pi2fd pmachriw pmaddwd pmagw pmulhriw pmulhrwa pmulhrwc pmulhw pmullw pmvgezb pmvlzb pmvnzb pmvzb pop popa popad popaw popf popfd popfq popfw por prefetch prefetchw pslld psllq psllw psrad psraw psrld psrlq psrlw psubb psubd psubsb psubsiw psubsw psubusb psubusw psubw punpckhbw punpckhdq punpckhwd punpcklbw punpckldq punpcklwd push pusha pushad pushaw pushf pushfd pushfq pushfw pxor rcl rcr rdshr rdmsr rdpmc rdtsc rdtscp ret retf retn rol ror rdm rsdc rsldt rsm rsts sahf sal salc sar sbb scasb scasd scasq scasw sfence sgdt shl shld shr shrd sidt sldt skinit smi smint smintold smsw stc std sti stosb stosd stosq stosw str sub svdc svldt svts swapgs syscall sysenter sysexit sysret test ud0 ud1 ud2b ud2 ud2a umov verr verw fwait wbinvd wrshr wrmsr xadd xbts xchg xlatb xlat xor cmove cmovz cmovne cmovnz cmova cmovnbe cmovae cmovnb cmovb cmovnae cmovbe cmovna cmovg cmovnle cmovge cmovnl cmovl cmovnge cmovle cmovng cmovc cmovnc cmovo cmovno cmovs cmovns cmovp cmovpe cmovnp cmovpo je jz jne jnz ja jnbe jae jnb jb jnae jbe jna jg jnle jge jnl jl jnge jle jng jc jnc jo jno js jns jpo jnp jpe jp sete setz setne setnz seta setnbe setae setnb setnc setb setnae setcset setbe setna setg setnle setge setnl setl setnge setle setng sets setns seto setno setpe setp setpo setnp addps addss andnps andps cmpeqps cmpeqss cmpleps cmpless cmpltps cmpltss cmpneqps cmpneqss cmpnleps cmpnless cmpnltps cmpnltss cmpordps cmpordss cmpunordps cmpunordss cmpps cmpss comiss cvtpi2ps cvtps2pi cvtsi2ss cvtss2si cvttps2pi cvttss2si divps divss ldmxcsr maxps maxss minps minss movaps movhps movlhps movlps movhlps movmskps movntps movss movups mulps mulss orps rcpps rcpss rsqrtps rsqrtss shufps sqrtps sqrtss stmxcsr subps subss ucomiss unpckhps unpcklps xorps fxrstor fxrstor64 fxsave fxsave64 xgetbv xsetbv xsave xsave64 xsaveopt xsaveopt64 xrstor xrstor64 prefetchnta prefetcht0 prefetcht1 prefetcht2 maskmovq movntq pavgb pavgw pextrw pinsrw pmaxsw pmaxub pminsw pminub pmovmskb pmulhuw psadbw pshufw pf2iw pfnacc pfpnacc pi2fw pswapd maskmovdqu clflush movntdq movnti movntpd movdqa movdqu movdq2q movq2dq paddq pmuludq pshufd pshufhw pshuflw pslldq psrldq psubq punpckhqdq punpcklqdq addpd addsd andnpd andpd cmpeqpd cmpeqsd cmplepd cmplesd cmpltpd cmpltsd cmpneqpd cmpneqsd cmpnlepd cmpnlesd cmpnltpd cmpnltsd cmpordpd cmpordsd cmpunordpd cmpunordsd cmppd comisd cvtdq2pd cvtdq2ps cvtpd2dq cvtpd2pi cvtpd2ps cvtpi2pd cvtps2dq cvtps2pd cvtsd2si cvtsd2ss cvtsi2sd cvtss2sd cvttpd2pi cvttpd2dq cvttps2dq cvttsd2si divpd divsd maxpd maxsd minpd minsd movapd movhpd movlpd movmskpd movupd mulpd mulsd orpd shufpd sqrtpd sqrtsd subpd subsd ucomisd unpckhpd unpcklpd xorpd addsubpd addsubps haddpd haddps hsubpd hsubps lddqu movddup movshdup movsldup clgi stgi vmcall vmclear vmfunc vmlaunch vmload vmmcall vmptrld vmptrst vmread vmresume vmrun vmsave vmwrite vmxoff vmxon invept invvpid pabsb pabsw pabsd palignr phaddw phaddd phaddsw phsubw phsubd phsubsw pmaddubsw pmulhrsw pshufb psignb psignw psignd extrq insertq movntsd movntss lzcnt blendpd blendps blendvpd blendvps dppd dpps extractps insertps movntdqa mpsadbw packusdw pblendvb pblendw pcmpeqq pextrb pextrd pextrq phminposuw pinsrb pinsrd pinsrq pmaxsb pmaxsd pmaxud pmaxuw pminsb pminsd pminud pminuw pmovsxbw pmovsxbd pmovsxbq pmovsxwd pmovsxwq pmovsxdq pmovzxbw pmovzxbd pmovzxbq pmovzxwd pmovzxwq pmovzxdq pmuldq pmulld ptest roundpd roundps roundsd roundss crc32 pcmpestri pcmpestrm pcmpistri pcmpistrm pcmpgtq popcnt getsec pfrcpv pfrsqrtv movbe aesenc aesenclast aesdec aesdeclast aesimc aeskeygenassist vaesenc vaesenclast vaesdec vaesdeclast vaesimc vaeskeygenassist vaddpd vaddps vaddsd vaddss vaddsubpd vaddsubps vandpd vandps vandnpd vandnps vblendpd vblendps vblendvpd vblendvps vbroadcastss vbroadcastsd vbroadcastf128 vcmpeq_ospd vcmpeqpd vcmplt_ospd vcmpltpd vcmple_ospd vcmplepd vcmpunord_qpd vcmpunordpd vcmpneq_uqpd vcmpneqpd vcmpnlt_uspd vcmpnltpd vcmpnle_uspd vcmpnlepd vcmpord_qpd vcmpordpd vcmpeq_uqpd vcmpnge_uspd vcmpngepd vcmpngt_uspd vcmpngtpd vcmpfalse_oqpd vcmpfalsepd vcmpneq_oqpd vcmpge_ospd vcmpgepd vcmpgt_ospd vcmpgtpd vcmptrue_uqpd vcmptruepd vcmplt_oqpd vcmple_oqpd vcmpunord_spd vcmpneq_uspd vcmpnlt_uqpd vcmpnle_uqpd vcmpord_spd vcmpeq_uspd vcmpnge_uqpd vcmpngt_uqpd vcmpfalse_ospd vcmpneq_ospd vcmpge_oqpd vcmpgt_oqpd vcmptrue_uspd vcmppd vcmpeq_osps vcmpeqps vcmplt_osps vcmpltps vcmple_osps vcmpleps vcmpunord_qps vcmpunordps vcmpneq_uqps vcmpneqps vcmpnlt_usps vcmpnltps vcmpnle_usps vcmpnleps vcmpord_qps vcmpordps vcmpeq_uqps vcmpnge_usps vcmpngeps vcmpngt_usps vcmpngtps vcmpfalse_oqps vcmpfalseps vcmpneq_oqps vcmpge_osps vcmpgeps vcmpgt_osps vcmpgtps vcmptrue_uqps vcmptrueps vcmplt_oqps vcmple_oqps vcmpunord_sps vcmpneq_usps vcmpnlt_uqps vcmpnle_uqps vcmpord_sps vcmpeq_usps vcmpnge_uqps vcmpngt_uqps vcmpfalse_osps vcmpneq_osps vcmpge_oqps vcmpgt_oqps vcmptrue_usps vcmpps vcmpeq_ossd vcmpeqsd vcmplt_ossd vcmpltsd vcmple_ossd vcmplesd vcmpunord_qsd vcmpunordsd vcmpneq_uqsd vcmpneqsd vcmpnlt_ussd vcmpnltsd vcmpnle_ussd vcmpnlesd vcmpord_qsd vcmpordsd vcmpeq_uqsd vcmpnge_ussd vcmpngesd vcmpngt_ussd vcmpngtsd vcmpfalse_oqsd vcmpfalsesd vcmpneq_oqsd vcmpge_ossd vcmpgesd vcmpgt_ossd vcmpgtsd vcmptrue_uqsd vcmptruesd vcmplt_oqsd vcmple_oqsd vcmpunord_ssd vcmpneq_ussd vcmpnlt_uqsd vcmpnle_uqsd vcmpord_ssd vcmpeq_ussd vcmpnge_uqsd vcmpngt_uqsd vcmpfalse_ossd vcmpneq_ossd vcmpge_oqsd vcmpgt_oqsd vcmptrue_ussd vcmpsd vcmpeq_osss vcmpeqss vcmplt_osss vcmpltss vcmple_osss vcmpless vcmpunord_qss vcmpunordss vcmpneq_uqss vcmpneqss vcmpnlt_usss vcmpnltss vcmpnle_usss vcmpnless vcmpord_qss vcmpordss vcmpeq_uqss vcmpnge_usss vcmpngess vcmpngt_usss vcmpngtss vcmpfalse_oqss vcmpfalsess vcmpneq_oqss vcmpge_osss vcmpgess vcmpgt_osss vcmpgtss vcmptrue_uqss vcmptruess vcmplt_oqss vcmple_oqss vcmpunord_sss vcmpneq_usss vcmpnlt_uqss vcmpnle_uqss vcmpord_sss vcmpeq_usss vcmpnge_uqss vcmpngt_uqss vcmpfalse_osss vcmpneq_osss vcmpge_oqss vcmpgt_oqss vcmptrue_usss vcmpss vcomisd vcomiss vcvtdq2pd vcvtdq2ps vcvtpd2dq vcvtpd2ps vcvtps2dq vcvtps2pd vcvtsd2si vcvtsd2ss vcvtsi2sd vcvtsi2ss vcvtss2sd vcvtss2si vcvttpd2dq vcvttps2dq vcvttsd2si vcvttss2si vdivpd vdivps vdivsd vdivss vdppd vdpps vextractf128 vextractps vhaddpd vhaddps vhsubpd vhsubps vinsertf128 vinsertps vlddqu vldqqu vldmxcsr vmaskmovdqu vmaskmovps vmaskmovpd vmaxpd vmaxps vmaxsd vmaxss vminpd vminps vminsd vminss vmovapd vmovaps vmovd vmovq vmovddup vmovdqa vmovqqa vmovdqu vmovqqu vmovhlps vmovhpd vmovhps vmovlhps vmovlpd vmovlps vmovmskpd vmovmskps vmovntdq vmovntqq vmovntdqa vmovntpd vmovntps vmovsd vmovshdup vmovsldup vmovss vmovupd vmovups vmpsadbw vmulpd vmulps vmulsd vmulss vorpd vorps vpabsb vpabsw vpabsd vpacksswb vpackssdw vpackuswb vpackusdw vpaddb vpaddw vpaddd vpaddq vpaddsb vpaddsw vpaddusb vpaddusw vpalignr vpand vpandn vpavgb vpavgw vpblendvb vpblendw vpcmpestri vpcmpestrm vpcmpistri vpcmpistrm vpcmpeqb vpcmpeqw vpcmpeqd vpcmpeqq vpcmpgtb vpcmpgtw vpcmpgtd vpcmpgtq vpermilpd vpermilps vperm2f128 vpextrb vpextrw vpextrd vpextrq vphaddw vphaddd vphaddsw vphminposuw vphsubw vphsubd vphsubsw vpinsrb vpinsrw vpinsrd vpinsrq vpmaddwd vpmaddubsw vpmaxsb vpmaxsw vpmaxsd vpmaxub vpmaxuw vpmaxud vpminsb vpminsw vpminsd vpminub vpminuw vpminud vpmovmskb vpmovsxbw vpmovsxbd vpmovsxbq vpmovsxwd vpmovsxwq vpmovsxdq vpmovzxbw vpmovzxbd vpmovzxbq vpmovzxwd vpmovzxwq vpmovzxdq vpmulhuw vpmulhrsw vpmulhw vpmullw vpmulld vpmuludq vpmuldq vpor vpsadbw vpshufb vpshufd vpshufhw vpshuflw vpsignb vpsignw vpsignd vpslldq vpsrldq vpsllw vpslld vpsllq vpsraw vpsrad vpsrlw vpsrld vpsrlq vptest vpsubb vpsubw vpsubd vpsubq vpsubsb vpsubsw vpsubusb vpsubusw vpunpckhbw vpunpckhwd vpunpckhdq vpunpckhqdq vpunpcklbw vpunpcklwd vpunpckldq vpunpcklqdq vpxor vrcpps vrcpss vrsqrtps vrsqrtss vroundpd vroundps vroundsd vroundss vshufpd vshufps vsqrtpd vsqrtps vsqrtsd vsqrtss vstmxcsr vsubpd vsubps vsubsd vsubss vtestps vtestpd vucomisd vucomiss vunpckhpd vunpckhps vunpcklpd vunpcklps vxorpd vxorps vzeroall vzeroupper pclmullqlqdq pclmulhqlqdq pclmullqhqdq pclmulhqhqdq pclmulqdq vpclmullqlqdq vpclmulhqlqdq vpclmullqhqdq vpclmulhqhqdq vpclmulqdq vfmadd132ps vfmadd132pd vfmadd312ps vfmadd312pd vfmadd213ps vfmadd213pd vfmadd123ps vfmadd123pd vfmadd231ps vfmadd231pd vfmadd321ps vfmadd321pd vfmaddsub132ps vfmaddsub132pd vfmaddsub312ps vfmaddsub312pd vfmaddsub213ps vfmaddsub213pd vfmaddsub123ps vfmaddsub123pd vfmaddsub231ps vfmaddsub231pd vfmaddsub321ps vfmaddsub321pd vfmsub132ps vfmsub132pd vfmsub312ps vfmsub312pd vfmsub213ps vfmsub213pd vfmsub123ps vfmsub123pd vfmsub231ps vfmsub231pd vfmsub321ps vfmsub321pd vfmsubadd132ps vfmsubadd132pd vfmsubadd312ps vfmsubadd312pd vfmsubadd213ps vfmsubadd213pd vfmsubadd123ps vfmsubadd123pd vfmsubadd231ps vfmsubadd231pd vfmsubadd321ps vfmsubadd321pd vfnmadd132ps vfnmadd132pd vfnmadd312ps vfnmadd312pd vfnmadd213ps vfnmadd213pd vfnmadd123ps vfnmadd123pd vfnmadd231ps vfnmadd231pd vfnmadd321ps vfnmadd321pd vfnmsub132ps vfnmsub132pd vfnmsub312ps vfnmsub312pd vfnmsub213ps vfnmsub213pd vfnmsub123ps vfnmsub123pd vfnmsub231ps vfnmsub231pd vfnmsub321ps vfnmsub321pd vfmadd132ss vfmadd132sd vfmadd312ss vfmadd312sd vfmadd213ss vfmadd213sd vfmadd123ss vfmadd123sd vfmadd231ss vfmadd231sd vfmadd321ss vfmadd321sd vfmsub132ss vfmsub132sd vfmsub312ss vfmsub312sd vfmsub213ss vfmsub213sd vfmsub123ss vfmsub123sd vfmsub231ss vfmsub231sd vfmsub321ss vfmsub321sd vfnmadd132ss vfnmadd132sd vfnmadd312ss vfnmadd312sd vfnmadd213ss vfnmadd213sd vfnmadd123ss vfnmadd123sd vfnmadd231ss vfnmadd231sd vfnmadd321ss vfnmadd321sd vfnmsub132ss vfnmsub132sd vfnmsub312ss vfnmsub312sd vfnmsub213ss vfnmsub213sd vfnmsub123ss vfnmsub123sd vfnmsub231ss vfnmsub231sd vfnmsub321ss vfnmsub321sd rdfsbase rdgsbase rdrand wrfsbase wrgsbase vcvtph2ps vcvtps2ph adcx adox rdseed clac stac xstore xcryptecb xcryptcbc xcryptctr xcryptcfb xcryptofb montmul xsha1 xsha256 llwpcb slwpcb lwpval lwpins vfmaddpd vfmaddps vfmaddsd vfmaddss vfmaddsubpd vfmaddsubps vfmsubaddpd vfmsubaddps vfmsubpd vfmsubps vfmsubsd vfmsubss vfnmaddpd vfnmaddps vfnmaddsd vfnmaddss vfnmsubpd vfnmsubps vfnmsubsd vfnmsubss vfrczpd vfrczps vfrczsd vfrczss vpcmov vpcomb vpcomd vpcomq vpcomub vpcomud vpcomuq vpcomuw vpcomw vphaddbd vphaddbq vphaddbw vphadddq vphaddubd vphaddubq vphaddubw vphaddudq vphadduwd vphadduwq vphaddwd vphaddwq vphsubbw vphsubdq vphsubwd vpmacsdd vpmacsdqh vpmacsdql vpmacssdd vpmacssdqh vpmacssdql vpmacsswd vpmacssww vpmacswd vpmacsww vpmadcsswd vpmadcswd vpperm vprotb vprotd vprotq vprotw vpshab vpshad vpshaq vpshaw vpshlb vpshld vpshlq vpshlw vbroadcasti128 vpblendd vpbroadcastb vpbroadcastw vpbroadcastd vpbroadcastq vpermd vpermpd vpermps vpermq vperm2i128 vextracti128 vinserti128 vpmaskmovd vpmaskmovq vpsllvd vpsllvq vpsravd vpsrlvd vpsrlvq vgatherdpd vgatherqpd vgatherdps vgatherqps vpgatherdd vpgatherqd vpgatherdq vpgatherqq xabort xbegin xend xtest andn bextr blci blcic blsi blsic blcfill blsfill blcmsk blsmsk blsr blcs bzhi mulx pdep pext rorx sarx shlx shrx tzcnt tzmsk t1mskc valignd valignq vblendmpd vblendmps vbroadcastf32x4 vbroadcastf64x4 vbroadcasti32x4 vbroadcasti64x4 vcompresspd vcompressps vcvtpd2udq vcvtps2udq vcvtsd2usi vcvtss2usi vcvttpd2udq vcvttps2udq vcvttsd2usi vcvttss2usi vcvtudq2pd vcvtudq2ps vcvtusi2sd vcvtusi2ss vexpandpd vexpandps vextractf32x4 vextractf64x4 vextracti32x4 vextracti64x4 vfixupimmpd vfixupimmps vfixupimmsd vfixupimmss vgetexppd vgetexpps vgetexpsd vgetexpss vgetmantpd vgetmantps vgetmantsd vgetmantss vinsertf32x4 vinsertf64x4 vinserti32x4 vinserti64x4 vmovdqa32 vmovdqa64 vmovdqu32 vmovdqu64 vpabsq vpandd vpandnd vpandnq vpandq vpblendmd vpblendmq vpcmpltd vpcmpled vpcmpneqd vpcmpnltd vpcmpnled vpcmpd vpcmpltq vpcmpleq vpcmpneqq vpcmpnltq vpcmpnleq vpcmpq vpcmpequd vpcmpltud vpcmpleud vpcmpnequd vpcmpnltud vpcmpnleud vpcmpud vpcmpequq vpcmpltuq vpcmpleuq vpcmpnequq vpcmpnltuq vpcmpnleuq vpcmpuq vpcompressd vpcompressq vpermi2d vpermi2pd vpermi2ps vpermi2q vpermt2d vpermt2pd vpermt2ps vpermt2q vpexpandd vpexpandq vpmaxsq vpmaxuq vpminsq vpminuq vpmovdb vpmovdw vpmovqb vpmovqd vpmovqw vpmovsdb vpmovsdw vpmovsqb vpmovsqd vpmovsqw vpmovusdb vpmovusdw vpmovusqb vpmovusqd vpmovusqw vpord vporq vprold vprolq vprolvd vprolvq vprord vprorq vprorvd vprorvq vpscatterdd vpscatterdq vpscatterqd vpscatterqq vpsraq vpsravq vpternlogd vpternlogq vptestmd vptestmq vptestnmd vptestnmq vpxord vpxorq vrcp14pd vrcp14ps vrcp14sd vrcp14ss vrndscalepd vrndscaleps vrndscalesd vrndscaless vrsqrt14pd vrsqrt14ps vrsqrt14sd vrsqrt14ss vscalefpd vscalefps vscalefsd vscalefss vscatterdpd vscatterdps vscatterqpd vscatterqps vshuff32x4 vshuff64x2 vshufi32x4 vshufi64x2 kandnw kandw kmovw knotw kortestw korw kshiftlw kshiftrw kunpckbw kxnorw kxorw vpbroadcastmb2q vpbroadcastmw2d vpconflictd vpconflictq vplzcntd vplzcntq vexp2pd vexp2ps vrcp28pd vrcp28ps vrcp28sd vrcp28ss vrsqrt28pd vrsqrt28ps vrsqrt28sd vrsqrt28ss vgatherpf0dpd vgatherpf0dps vgatherpf0qpd vgatherpf0qps vgatherpf1dpd vgatherpf1dps vgatherpf1qpd vgatherpf1qps vscatterpf0dpd vscatterpf0dps vscatterpf0qpd vscatterpf0qps vscatterpf1dpd vscatterpf1dps vscatterpf1qpd vscatterpf1qps prefetchwt1 bndmk bndcl bndcu bndcn bndmov bndldx bndstx sha1rnds4 sha1nexte sha1msg1 sha1msg2 sha256rnds2 sha256msg1 sha256msg2 hint_nop0 hint_nop1 hint_nop2 hint_nop3 hint_nop4 hint_nop5 hint_nop6 hint_nop7 hint_nop8 hint_nop9 hint_nop10 hint_nop11 hint_nop12 hint_nop13 hint_nop14 hint_nop15 hint_nop16 hint_nop17 hint_nop18 hint_nop19 hint_nop20 hint_nop21 hint_nop22 hint_nop23 hint_nop24 hint_nop25 hint_nop26 hint_nop27 hint_nop28 hint_nop29 hint_nop30 hint_nop31 hint_nop32 hint_nop33 hint_nop34 hint_nop35 hint_nop36 hint_nop37 hint_nop38 hint_nop39 hint_nop40 hint_nop41 hint_nop42 hint_nop43 hint_nop44 hint_nop45 hint_nop46 hint_nop47 hint_nop48 hint_nop49 hint_nop50 hint_nop51 hint_nop52 hint_nop53 hint_nop54 hint_nop55 hint_nop56 hint_nop57 hint_nop58 hint_nop59 hint_nop60 hint_nop61 hint_nop62 hint_nop63",
        built_in: (
          // Instruction pointer
          "ip eip rip al ah bl bh cl ch dl dh sil dil bpl spl r8b r9b r10b r11b r12b r13b r14b r15b ax bx cx dx si di bp sp r8w r9w r10w r11w r12w r13w r14w r15w eax ebx ecx edx esi edi ebp esp eip r8d r9d r10d r11d r12d r13d r14d r15d rax rbx rcx rdx rsi rdi rbp rsp r8 r9 r10 r11 r12 r13 r14 r15 cs ds es fs gs ss st st0 st1 st2 st3 st4 st5 st6 st7 mm0 mm1 mm2 mm3 mm4 mm5 mm6 mm7 xmm0  xmm1  xmm2  xmm3  xmm4  xmm5  xmm6  xmm7  xmm8  xmm9 xmm10  xmm11 xmm12 xmm13 xmm14 xmm15 xmm16 xmm17 xmm18 xmm19 xmm20 xmm21 xmm22 xmm23 xmm24 xmm25 xmm26 xmm27 xmm28 xmm29 xmm30 xmm31 ymm0  ymm1  ymm2  ymm3  ymm4  ymm5  ymm6  ymm7  ymm8  ymm9 ymm10  ymm11 ymm12 ymm13 ymm14 ymm15 ymm16 ymm17 ymm18 ymm19 ymm20 ymm21 ymm22 ymm23 ymm24 ymm25 ymm26 ymm27 ymm28 ymm29 ymm30 ymm31 zmm0  zmm1  zmm2  zmm3  zmm4  zmm5  zmm6  zmm7  zmm8  zmm9 zmm10  zmm11 zmm12 zmm13 zmm14 zmm15 zmm16 zmm17 zmm18 zmm19 zmm20 zmm21 zmm22 zmm23 zmm24 zmm25 zmm26 zmm27 zmm28 zmm29 zmm30 zmm31 k0 k1 k2 k3 k4 k5 k6 k7 bnd0 bnd1 bnd2 bnd3 cr0 cr1 cr2 cr3 cr4 cr8 dr0 dr1 dr2 dr3 dr8 tr3 tr4 tr5 tr6 tr7 r0 r1 r2 r3 r4 r5 r6 r7 r0b r1b r2b r3b r4b r5b r6b r7b r0w r1w r2w r3w r4w r5w r6w r7w r0d r1d r2d r3d r4d r5d r6d r7d r0h r1h r2h r3h r0l r1l r2l r3l r4l r5l r6l r7l r8l r9l r10l r11l r12l r13l r14l r15l db dw dd dq dt ddq do dy dz resb resw resd resq rest resdq reso resy resz incbin equ times byte word dword qword nosplit rel abs seg wrt strict near far a32 ptr"
        ),
        meta: "%define %xdefine %+ %undef %defstr %deftok %assign %strcat %strlen %substr %rotate %elif %else %endif %if %ifmacro %ifctx %ifidn %ifidni %ifid %ifnum %ifstr %iftoken %ifempty %ifenv %error %warning %fatal %rep %endrep %include %push %pop %repl %pathsearch %depend %use %arg %stacksize %local %line %comment %endcomment .nolist __FILE__ __LINE__ __SECT__  __BITS__ __OUTPUT_FORMAT__ __DATE__ __TIME__ __DATE_NUM__ __TIME_NUM__ __UTC_DATE__ __UTC_TIME__ __UTC_DATE_NUM__ __UTC_TIME_NUM__  __PASS__ struc endstruc istruc at iend align alignb sectalign daz nodaz up down zero default option assume public bits use16 use32 use64 default section segment absolute extern global common cpu float __utf16__ __utf16le__ __utf16be__ __utf32__ __utf32le__ __utf32be__ __float8__ __float16__ __float32__ __float64__ __float80m__ __float80e__ __float128l__ __float128h__ __Infinity__ __QNaN__ __SNaN__ Inf NaN QNaN SNaN float8 float16 float32 float64 float80m float80e float128l float128h __FLOAT_DAZ__ __FLOAT_ROUND__ __FLOAT__"
      },
      contains: [
        i.COMMENT(
          ";",
          "$",
          { relevance: 0 }
        ),
        {
          className: "number",
          variants: [
            // Float number and x87 BCD
            {
              begin: "\\b(?:([0-9][0-9_]*)?\\.[0-9_]*(?:[eE][+-]?[0-9_]+)?|(0[Xx])?[0-9][0-9_]*(\\.[0-9_]*)?(?:[pP](?:[+-]?[0-9_]+)?)?)\\b",
              relevance: 0
            },
            // Hex number in $
            {
              begin: "\\$[0-9][0-9A-Fa-f]*",
              relevance: 0
            },
            // Number in H,D,T,Q,O,B,Y suffix
            { begin: "\\b(?:[0-9A-Fa-f][0-9A-Fa-f_]*[Hh]|[0-9][0-9_]*[DdTt]?|[0-7][0-7_]*[QqOo]|[0-1][0-1_]*[BbYy])\\b" },
            // Number in X,D,T,Q,O,B,Y prefix
            { begin: "\\b(?:0[Xx][0-9A-Fa-f_]+|0[DdTt][0-9_]+|0[QqOo][0-7_]+|0[BbYy][0-1_]+)\\b" }
          ]
        },
        // Double quote string
        i.QUOTE_STRING_MODE,
        {
          className: "string",
          variants: [
            // Single-quoted string
            {
              begin: "'",
              end: "[^\\\\]'"
            },
            // Backquoted string
            {
              begin: "`",
              end: "[^\\\\]`"
            }
          ],
          relevance: 0
        },
        {
          className: "symbol",
          variants: [
            // Global label and local label
            { begin: "^\\s*[A-Za-z._?][A-Za-z0-9_$#@~.?]*(:|\\s+label)" },
            // Macro-local label
            { begin: "^\\s*%%[A-Za-z0-9_$#@~.?]*:" }
          ],
          relevance: 0
        },
        // Macro parameter
        {
          className: "subst",
          begin: "%[0-9]+",
          relevance: 0
        },
        // Macro parameter
        {
          className: "subst",
          begin: "%!S+",
          relevance: 0
        },
        {
          className: "meta",
          begin: /^\s*\.[\w_-]+/
        }
      ]
    };
  }
  return Up = s, Up;
}
var Bp, _1;
function TF() {
  if (_1)
    return Bp;
  _1 = 1;
  function s(i) {
    const o = [
      "if",
      "then",
      "else",
      "do",
      "while",
      "until",
      "for",
      "loop",
      "import",
      "with",
      "is",
      "as",
      "where",
      "when",
      "by",
      "data",
      "constant",
      "integer",
      "real",
      "text",
      "name",
      "boolean",
      "symbol",
      "infix",
      "prefix",
      "postfix",
      "block",
      "tree"
    ], c = [
      "in",
      "mod",
      "rem",
      "and",
      "or",
      "xor",
      "not",
      "abs",
      "sign",
      "floor",
      "ceil",
      "sqrt",
      "sin",
      "cos",
      "tan",
      "asin",
      "acos",
      "atan",
      "exp",
      "expm1",
      "log",
      "log2",
      "log10",
      "log1p",
      "pi",
      "at",
      "text_length",
      "text_range",
      "text_find",
      "text_replace",
      "contains",
      "page",
      "slide",
      "basic_slide",
      "title_slide",
      "title",
      "subtitle",
      "fade_in",
      "fade_out",
      "fade_at",
      "clear_color",
      "color",
      "line_color",
      "line_width",
      "texture_wrap",
      "texture_transform",
      "texture",
      "scale_?x",
      "scale_?y",
      "scale_?z?",
      "translate_?x",
      "translate_?y",
      "translate_?z?",
      "rotate_?x",
      "rotate_?y",
      "rotate_?z?",
      "rectangle",
      "circle",
      "ellipse",
      "sphere",
      "path",
      "line_to",
      "move_to",
      "quad_to",
      "curve_to",
      "theme",
      "background",
      "contents",
      "locally",
      "time",
      "mouse_?x",
      "mouse_?y",
      "mouse_buttons"
    ], r = [
      "ObjectLoader",
      "Animate",
      "MovieCredits",
      "Slides",
      "Filters",
      "Shading",
      "Materials",
      "LensFlare",
      "Mapping",
      "VLCAudioVideo",
      "StereoDecoder",
      "PointCloud",
      "NetworkAccess",
      "RemoteControl",
      "RegExp",
      "ChromaKey",
      "Snowfall",
      "NodeJS",
      "Speech",
      "Charts"
    ], g = {
      $pattern: /[a-zA-Z][a-zA-Z0-9_?]*/,
      keyword: o,
      literal: [
        "true",
        "false",
        "nil"
      ],
      built_in: c.concat(r)
    }, h = {
      className: "string",
      begin: '"',
      end: '"',
      illegal: "\\n"
    }, S = {
      className: "string",
      begin: "'",
      end: "'",
      illegal: "\\n"
    }, C = {
      className: "string",
      begin: "<<",
      end: ">>"
    }, O = {
      className: "number",
      begin: "[0-9]+#[0-9A-Z_]+(\\.[0-9-A-Z_]+)?#?([Ee][+-]?[0-9]+)?"
    }, N = {
      beginKeywords: "import",
      end: "$",
      keywords: g,
      contains: [h]
    }, D = {
      className: "function",
      begin: /[a-z][^\n]*->/,
      returnBegin: !0,
      end: /->/,
      contains: [
        i.inherit(i.TITLE_MODE, { starts: {
          endsWithParent: !0,
          keywords: g
        } })
      ]
    };
    return {
      name: "XL",
      aliases: ["tao"],
      keywords: g,
      contains: [
        i.C_LINE_COMMENT_MODE,
        i.C_BLOCK_COMMENT_MODE,
        h,
        S,
        C,
        D,
        N,
        O,
        i.NUMBER_MODE
      ]
    };
  }
  return Bp = s, Bp;
}
var Gp, p1;
function vF() {
  if (p1)
    return Gp;
  p1 = 1;
  function s(i) {
    return {
      name: "XQuery",
      aliases: [
        "xpath",
        "xq",
        "xqm"
      ],
      case_insensitive: !1,
      illegal: /(proc)|(abstract)|(extends)|(until)|(#)/,
      keywords: {
        $pattern: /[a-zA-Z$][a-zA-Z0-9_:-]*/,
        keyword: [
          "module",
          "schema",
          "namespace",
          "boundary-space",
          "preserve",
          "no-preserve",
          "strip",
          "default",
          "collation",
          "base-uri",
          "ordering",
          "context",
          "decimal-format",
          "decimal-separator",
          "copy-namespaces",
          "empty-sequence",
          "except",
          "exponent-separator",
          "external",
          "grouping-separator",
          "inherit",
          "no-inherit",
          "lax",
          "minus-sign",
          "per-mille",
          "percent",
          "schema-attribute",
          "schema-element",
          "strict",
          "unordered",
          "zero-digit",
          "declare",
          "import",
          "option",
          "function",
          "validate",
          "variable",
          "for",
          "at",
          "in",
          "let",
          "where",
          "order",
          "group",
          "by",
          "return",
          "if",
          "then",
          "else",
          "tumbling",
          "sliding",
          "window",
          "start",
          "when",
          "only",
          "end",
          "previous",
          "next",
          "stable",
          "ascending",
          "descending",
          "allowing",
          "empty",
          "greatest",
          "least",
          "some",
          "every",
          "satisfies",
          "switch",
          "case",
          "typeswitch",
          "try",
          "catch",
          "and",
          "or",
          "to",
          "union",
          "intersect",
          "instance",
          "of",
          "treat",
          "as",
          "castable",
          "cast",
          "map",
          "array",
          "delete",
          "insert",
          "into",
          "replace",
          "value",
          "rename",
          "copy",
          "modify",
          "update"
        ],
        type: [
          "item",
          "document-node",
          "node",
          "attribute",
          "document",
          "element",
          "comment",
          "namespace",
          "namespace-node",
          "processing-instruction",
          "text",
          "construction",
          "xs:anyAtomicType",
          "xs:untypedAtomic",
          "xs:duration",
          "xs:time",
          "xs:decimal",
          "xs:float",
          "xs:double",
          "xs:gYearMonth",
          "xs:gYear",
          "xs:gMonthDay",
          "xs:gMonth",
          "xs:gDay",
          "xs:boolean",
          "xs:base64Binary",
          "xs:hexBinary",
          "xs:anyURI",
          "xs:QName",
          "xs:NOTATION",
          "xs:dateTime",
          "xs:dateTimeStamp",
          "xs:date",
          "xs:string",
          "xs:normalizedString",
          "xs:token",
          "xs:language",
          "xs:NMTOKEN",
          "xs:Name",
          "xs:NCName",
          "xs:ID",
          "xs:IDREF",
          "xs:ENTITY",
          "xs:integer",
          "xs:nonPositiveInteger",
          "xs:negativeInteger",
          "xs:long",
          "xs:int",
          "xs:short",
          "xs:byte",
          "xs:nonNegativeInteger",
          "xs:unisignedLong",
          "xs:unsignedInt",
          "xs:unsignedShort",
          "xs:unsignedByte",
          "xs:positiveInteger",
          "xs:yearMonthDuration",
          "xs:dayTimeDuration"
        ],
        literal: [
          "eq",
          "ne",
          "lt",
          "le",
          "gt",
          "ge",
          "is",
          "self::",
          "child::",
          "descendant::",
          "descendant-or-self::",
          "attribute::",
          "following::",
          "following-sibling::",
          "parent::",
          "ancestor::",
          "ancestor-or-self::",
          "preceding::",
          "preceding-sibling::",
          "NaN"
        ]
      },
      contains: [
        {
          className: "variable",
          begin: /[$][\w\-:]+/
        },
        {
          className: "built_in",
          variants: [
            {
              begin: /\barray:/,
              end: /(?:append|filter|flatten|fold-(?:left|right)|for-each(?:-pair)?|get|head|insert-before|join|put|remove|reverse|size|sort|subarray|tail)\b/
            },
            {
              begin: /\bmap:/,
              end: /(?:contains|entry|find|for-each|get|keys|merge|put|remove|size)\b/
            },
            {
              begin: /\bmath:/,
              end: /(?:a(?:cos|sin|tan[2]?)|cos|exp(?:10)?|log(?:10)?|pi|pow|sin|sqrt|tan)\b/
            },
            {
              begin: /\bop:/,
              end: /\(/,
              excludeEnd: !0
            },
            {
              begin: /\bfn:/,
              end: /\(/,
              excludeEnd: !0
            },
            // do not highlight inbuilt strings as variable or xml element names
            { begin: /[^</$:'"-]\b(?:abs|accumulator-(?:after|before)|adjust-(?:date(?:Time)?|time)-to-timezone|analyze-string|apply|available-(?:environment-variables|system-properties)|avg|base-uri|boolean|ceiling|codepoints?-(?:equal|to-string)|collation-key|collection|compare|concat|contains(?:-token)?|copy-of|count|current(?:-)?(?:date(?:Time)?|time|group(?:ing-key)?|output-uri|merge-(?:group|key))?data|dateTime|days?-from-(?:date(?:Time)?|duration)|deep-equal|default-(?:collation|language)|distinct-values|document(?:-uri)?|doc(?:-available)?|element-(?:available|with-id)|empty|encode-for-uri|ends-with|environment-variable|error|escape-html-uri|exactly-one|exists|false|filter|floor|fold-(?:left|right)|for-each(?:-pair)?|format-(?:date(?:Time)?|time|integer|number)|function-(?:arity|available|lookup|name)|generate-id|has-children|head|hours-from-(?:dateTime|duration|time)|id(?:ref)?|implicit-timezone|in-scope-prefixes|index-of|innermost|insert-before|iri-to-uri|json-(?:doc|to-xml)|key|lang|last|load-xquery-module|local-name(?:-from-QName)?|(?:lower|upper)-case|matches|max|minutes-from-(?:dateTime|duration|time)|min|months?-from-(?:date(?:Time)?|duration)|name(?:space-uri-?(?:for-prefix|from-QName)?)?|nilled|node-name|normalize-(?:space|unicode)|not|number|one-or-more|outermost|parse-(?:ietf-date|json)|path|position|(?:prefix-from-)?QName|random-number-generator|regex-group|remove|replace|resolve-(?:QName|uri)|reverse|root|round(?:-half-to-even)?|seconds-from-(?:dateTime|duration|time)|snapshot|sort|starts-with|static-base-uri|stream-available|string-?(?:join|length|to-codepoints)?|subsequence|substring-?(?:after|before)?|sum|system-property|tail|timezone-from-(?:date(?:Time)?|time)|tokenize|trace|trans(?:form|late)|true|type-available|unordered|unparsed-(?:entity|text)?-?(?:public-id|uri|available|lines)?|uri-collection|xml-to-json|years?-from-(?:date(?:Time)?|duration)|zero-or-one)\b/ },
            {
              begin: /\blocal:/,
              end: /\(/,
              excludeEnd: !0
            },
            {
              begin: /\bzip:/,
              end: /(?:zip-file|(?:xml|html|text|binary)-entry| (?:update-)?entries)\b/
            },
            {
              begin: /\b(?:util|db|functx|app|xdmp|xmldb):/,
              end: /\(/,
              excludeEnd: !0
            }
          ]
        },
        {
          className: "string",
          variants: [
            {
              begin: /"/,
              end: /"/,
              contains: [
                {
                  begin: /""/,
                  relevance: 0
                }
              ]
            },
            {
              begin: /'/,
              end: /'/,
              contains: [
                {
                  begin: /''/,
                  relevance: 0
                }
              ]
            }
          ]
        },
        {
          className: "number",
          begin: /(\b0[0-7_]+)|(\b0x[0-9a-fA-F_]+)|(\b[1-9][0-9_]*(\.[0-9_]+)?)|[0_]\b/,
          relevance: 0
        },
        {
          className: "comment",
          begin: /\(:/,
          end: /:\)/,
          relevance: 10,
          contains: [
            {
              className: "doctag",
              begin: /@\w+/
            }
          ]
        },
        {
          className: "meta",
          begin: /%[\w\-:]+/
        },
        {
          className: "title",
          begin: /\bxquery version "[13]\.[01]"\s?(?:encoding ".+")?/,
          end: /;/
        },
        {
          beginKeywords: "element attribute comment document processing-instruction",
          end: /\{/,
          excludeEnd: !0
        },
        {
          begin: /<([\w._:-]+)(\s+\S*=('|").*('|"))?>/,
          end: /(\/[\w._:-]+>)/,
          subLanguage: "xml",
          contains: [
            {
              begin: /\{/,
              end: /\}/,
              subLanguage: "xquery"
            },
            "self"
          ]
        }
      ]
    };
  }
  return Gp = s, Gp;
}
var Vp, m1;
function CF() {
  if (m1)
    return Vp;
  m1 = 1;
  function s(i) {
    const o = {
      className: "string",
      contains: [i.BACKSLASH_ESCAPE],
      variants: [
        i.inherit(i.APOS_STRING_MODE, { illegal: null }),
        i.inherit(i.QUOTE_STRING_MODE, { illegal: null })
      ]
    }, c = i.UNDERSCORE_TITLE_MODE, r = { variants: [
      i.BINARY_NUMBER_MODE,
      i.C_NUMBER_MODE
    ] }, e = (
      // classes and objects
      "namespace class interface use extends function return abstract final public protected private static deprecated throw try catch Exception echo empty isset instanceof unset let var new const self require if else elseif switch case default do while loop for continue break likely unlikely __LINE__ __FILE__ __DIR__ __FUNCTION__ __CLASS__ __TRAIT__ __METHOD__ __NAMESPACE__ array boolean float double integer object resource string char long unsigned bool int uint ulong uchar true false null undefined"
    );
    return {
      name: "Zephir",
      aliases: ["zep"],
      keywords: e,
      contains: [
        i.C_LINE_COMMENT_MODE,
        i.COMMENT(
          /\/\*/,
          /\*\//,
          { contains: [
            {
              className: "doctag",
              begin: /@[A-Za-z]+/
            }
          ] }
        ),
        {
          className: "string",
          begin: /<<<['"]?\w+['"]?$/,
          end: /^\w+;/,
          contains: [i.BACKSLASH_ESCAPE]
        },
        {
          // swallow composed identifiers to avoid parsing them as keywords
          begin: /(::|->)+[a-zA-Z_\x7f-\xff][a-zA-Z0-9_\x7f-\xff]*/
        },
        {
          className: "function",
          beginKeywords: "function fn",
          end: /[;{]/,
          excludeEnd: !0,
          illegal: /\$|\[|%/,
          contains: [
            c,
            {
              className: "params",
              begin: /\(/,
              end: /\)/,
              keywords: e,
              contains: [
                "self",
                i.C_BLOCK_COMMENT_MODE,
                o,
                r
              ]
            }
          ]
        },
        {
          className: "class",
          beginKeywords: "class interface",
          end: /\{/,
          excludeEnd: !0,
          illegal: /[:($"]/,
          contains: [
            { beginKeywords: "extends implements" },
            c
          ]
        },
        {
          beginKeywords: "namespace",
          end: /;/,
          illegal: /[.']/,
          contains: [c]
        },
        {
          beginKeywords: "use",
          end: /;/,
          contains: [c]
        },
        {
          begin: /=>/
          // No markup, just a relevance booster
        },
        o,
        r
      ]
    };
  }
  return Vp = s, Vp;
}
var ce = zL;
ce.registerLanguage("1c", KL());
ce.registerLanguage("abnf", QL());
ce.registerLanguage("accesslog", XL());
ce.registerLanguage("actionscript", ZL());
ce.registerLanguage("ada", jL());
ce.registerLanguage("angelscript", JL());
ce.registerLanguage("apache", eM());
ce.registerLanguage("applescript", tM());
ce.registerLanguage("arcade", rM());
ce.registerLanguage("arduino", nM());
ce.registerLanguage("armasm", aM());
ce.registerLanguage("xml", iM());
ce.registerLanguage("asciidoc", oM());
ce.registerLanguage("aspectj", sM());
ce.registerLanguage("autohotkey", lM());
ce.registerLanguage("autoit", cM());
ce.registerLanguage("avrasm", dM());
ce.registerLanguage("awk", uM());
ce.registerLanguage("axapta", _M());
ce.registerLanguage("bash", pM());
ce.registerLanguage("basic", mM());
ce.registerLanguage("bnf", fM());
ce.registerLanguage("brainfuck", gM());
ce.registerLanguage("c", EM());
ce.registerLanguage("cal", hM());
ce.registerLanguage("capnproto", SM());
ce.registerLanguage("ceylon", bM());
ce.registerLanguage("clean", TM());
ce.registerLanguage("clojure", vM());
ce.registerLanguage("clojure-repl", CM());
ce.registerLanguage("cmake", RM());
ce.registerLanguage("coffeescript", NM());
ce.registerLanguage("coq", AM());
ce.registerLanguage("cos", OM());
ce.registerLanguage("cpp", yM());
ce.registerLanguage("crmsh", IM());
ce.registerLanguage("crystal", DM());
ce.registerLanguage("csharp", wM());
ce.registerLanguage("csp", xM());
ce.registerLanguage("css", LM());
ce.registerLanguage("d", MM());
ce.registerLanguage("markdown", PM());
ce.registerLanguage("dart", kM());
ce.registerLanguage("delphi", FM());
ce.registerLanguage("diff", UM());
ce.registerLanguage("django", BM());
ce.registerLanguage("dns", GM());
ce.registerLanguage("dockerfile", VM());
ce.registerLanguage("dos", YM());
ce.registerLanguage("dsconfig", HM());
ce.registerLanguage("dts", qM());
ce.registerLanguage("dust", $M());
ce.registerLanguage("ebnf", WM());
ce.registerLanguage("elixir", zM());
ce.registerLanguage("elm", KM());
ce.registerLanguage("ruby", QM());
ce.registerLanguage("erb", XM());
ce.registerLanguage("erlang-repl", ZM());
ce.registerLanguage("erlang", jM());
ce.registerLanguage("excel", JM());
ce.registerLanguage("fix", eP());
ce.registerLanguage("flix", tP());
ce.registerLanguage("fortran", rP());
ce.registerLanguage("fsharp", nP());
ce.registerLanguage("gams", aP());
ce.registerLanguage("gauss", iP());
ce.registerLanguage("gcode", oP());
ce.registerLanguage("gherkin", sP());
ce.registerLanguage("glsl", lP());
ce.registerLanguage("gml", cP());
ce.registerLanguage("go", dP());
ce.registerLanguage("golo", uP());
ce.registerLanguage("gradle", _P());
ce.registerLanguage("graphql", pP());
ce.registerLanguage("groovy", mP());
ce.registerLanguage("haml", fP());
ce.registerLanguage("handlebars", gP());
ce.registerLanguage("haskell", EP());
ce.registerLanguage("haxe", hP());
ce.registerLanguage("hsp", SP());
ce.registerLanguage("http", bP());
ce.registerLanguage("hy", TP());
ce.registerLanguage("inform7", vP());
ce.registerLanguage("ini", CP());
ce.registerLanguage("irpf90", RP());
ce.registerLanguage("isbl", NP());
ce.registerLanguage("java", AP());
ce.registerLanguage("javascript", OP());
ce.registerLanguage("jboss-cli", yP());
ce.registerLanguage("json", IP());
ce.registerLanguage("julia", DP());
ce.registerLanguage("julia-repl", wP());
ce.registerLanguage("kotlin", xP());
ce.registerLanguage("lasso", LP());
ce.registerLanguage("latex", MP());
ce.registerLanguage("ldif", PP());
ce.registerLanguage("leaf", kP());
ce.registerLanguage("less", FP());
ce.registerLanguage("lisp", UP());
ce.registerLanguage("livecodeserver", BP());
ce.registerLanguage("livescript", GP());
ce.registerLanguage("llvm", VP());
ce.registerLanguage("lsl", YP());
ce.registerLanguage("lua", HP());
ce.registerLanguage("makefile", qP());
ce.registerLanguage("mathematica", $P());
ce.registerLanguage("matlab", WP());
ce.registerLanguage("maxima", zP());
ce.registerLanguage("mel", KP());
ce.registerLanguage("mercury", QP());
ce.registerLanguage("mipsasm", XP());
ce.registerLanguage("mizar", ZP());
ce.registerLanguage("perl", jP());
ce.registerLanguage("mojolicious", JP());
ce.registerLanguage("monkey", ek());
ce.registerLanguage("moonscript", tk());
ce.registerLanguage("n1ql", rk());
ce.registerLanguage("nestedtext", nk());
ce.registerLanguage("nginx", ak());
ce.registerLanguage("nim", ik());
ce.registerLanguage("nix", ok());
ce.registerLanguage("node-repl", sk());
ce.registerLanguage("nsis", lk());
ce.registerLanguage("objectivec", ck());
ce.registerLanguage("ocaml", dk());
ce.registerLanguage("openscad", uk());
ce.registerLanguage("oxygene", _k());
ce.registerLanguage("parser3", pk());
ce.registerLanguage("pf", mk());
ce.registerLanguage("pgsql", fk());
ce.registerLanguage("php", gk());
ce.registerLanguage("php-template", Ek());
ce.registerLanguage("plaintext", hk());
ce.registerLanguage("pony", Sk());
ce.registerLanguage("powershell", bk());
ce.registerLanguage("processing", Tk());
ce.registerLanguage("profile", vk());
ce.registerLanguage("prolog", Ck());
ce.registerLanguage("properties", Rk());
ce.registerLanguage("protobuf", Nk());
ce.registerLanguage("puppet", Ak());
ce.registerLanguage("purebasic", Ok());
ce.registerLanguage("python", yk());
ce.registerLanguage("python-repl", Ik());
ce.registerLanguage("q", Dk());
ce.registerLanguage("qml", wk());
ce.registerLanguage("r", xk());
ce.registerLanguage("reasonml", Lk());
ce.registerLanguage("rib", Mk());
ce.registerLanguage("roboconf", Pk());
ce.registerLanguage("routeros", kk());
ce.registerLanguage("rsl", Fk());
ce.registerLanguage("ruleslanguage", Uk());
ce.registerLanguage("rust", Bk());
ce.registerLanguage("sas", Gk());
ce.registerLanguage("scala", Vk());
ce.registerLanguage("scheme", Yk());
ce.registerLanguage("scilab", Hk());
ce.registerLanguage("scss", qk());
ce.registerLanguage("shell", $k());
ce.registerLanguage("smali", Wk());
ce.registerLanguage("smalltalk", zk());
ce.registerLanguage("sml", Kk());
ce.registerLanguage("sqf", Qk());
ce.registerLanguage("sql", Xk());
ce.registerLanguage("stan", Zk());
ce.registerLanguage("stata", jk());
ce.registerLanguage("step21", Jk());
ce.registerLanguage("stylus", eF());
ce.registerLanguage("subunit", tF());
ce.registerLanguage("swift", rF());
ce.registerLanguage("taggerscript", nF());
ce.registerLanguage("yaml", aF());
ce.registerLanguage("tap", iF());
ce.registerLanguage("tcl", oF());
ce.registerLanguage("thrift", sF());
ce.registerLanguage("tp", lF());
ce.registerLanguage("twig", cF());
ce.registerLanguage("typescript", dF());
ce.registerLanguage("vala", uF());
ce.registerLanguage("vbnet", _F());
ce.registerLanguage("vbscript", pF());
ce.registerLanguage("vbscript-html", mF());
ce.registerLanguage("verilog", fF());
ce.registerLanguage("vhdl", gF());
ce.registerLanguage("vim", EF());
ce.registerLanguage("wasm", hF());
ce.registerLanguage("wren", SF());
ce.registerLanguage("x86asm", bF());
ce.registerLanguage("xl", TF());
ce.registerLanguage("xquery", vF());
ce.registerLanguage("zephir", CF());
ce.HighlightJS = ce;
ce.default = ce;
var RF = ce;
const NF = /* @__PURE__ */ C1(RF), AF = { style: { position: "fixed", right: "300px", top: "150px" } }, OF = { style: { "margin-bottom": "10px", "font-size": "20px" } }, yF = ["href"], IF = { class: "se-wr" }, DF = {
  class: "section",
  id: "VDataTable"
}, wF = {
  class: "section",
  id: "VEditor"
}, xF = {
  class: "section",
  id: "VPaginationGroup"
}, LF = {
  class: "section",
  id: "VFormGroup"
}, MF = {
  class: "section",
  id: "TableTop"
}, PF = {
  class: "section",
  id: "VContentHeader"
}, kF = {
  class: "section",
  id: "VUploadFile"
}, FF = { style: { width: "500px" } }, UF = {
  class: "section",
  id: "VIconButton"
}, BF = {
  class: "section",
  id: "VFileButton"
}, GF = {
  class: "section",
  id: "TextButton"
}, VF = {
  class: "section",
  id: "VSortButton"
}, YF = {
  class: "section",
  id: "VCommonDropdown"
}, HF = {
  class: "section",
  id: "VModal"
}, qF = {
  class: "section",
  id: "VTextInput"
}, $F = {
  class: "section",
  id: "VIconFont"
}, WF = {
  class: "section",
  id: "VButton"
}, zF = {
  class: "section",
  id: "VCheckbox"
}, KF = {
  class: "section",
  id: "VRadiobox"
}, QF = {
  class: "section",
  id: "SearchMenu"
}, XF = { class: "search-list" }, ZF = { class: "search-list" }, jF = { class: "search-list" }, JF = { class: "search-list" }, e3 = { class: "search-list" }, t3 = {
  class: "section",
  id: "TabTitle"
}, r3 = {
  class: "section",
  id: "VDropdown"
}, n3 = {
  class: "section",
  id: "VPagination"
}, a3 = {
  class: "section",
  id: "VTable"
}, i3 = /* @__PURE__ */ Nr({
  __name: "Guide",
  setup(s) {
    async function i(ge) {
      await navigator.clipboard.writeText(ge);
    }
    const o = [
      "ic_add",
      "ic_arrow",
      "ic_calendar",
      "ic_close",
      "ic_copy",
      "ic_delete",
      "ic_double_arrow",
      "ic_download",
      "ic_dropdown",
      "ic_global",
      "ic_lock",
      "ic_navi_home",
      "ic_pencil",
      "ic_plus_w",
      "ic_reply",
      "ic_star",
      "ic_time",
      "ic_triangle",
      "ic_input_time"
    ], c = pt(1), r = pt(2), e = pt(""), g = pt([]), h = pt(), S = pt(!1), C = pt(!1), O = pt(!1), N = pt(), D = pt(), x = pt([]);
    var L = `
    // 단일 데이터
    const file1 = ref<File[]>([]);

    <VUploadFile v-model="file1" />

    // 멀티 데이터
    <VUploadFile v-model="file2" multiple />
    `;
    const G = pt([]);
    Na(() => {
      Yp(() => {
        document.querySelectorAll("code").forEach((ge) => {
          NF.highlightBlock(ge);
        });
      });
    });
    var Y = `
        <VIconButton icon="ic_global" />

        <VIconButton icon="ic_dropdown" />
    `, k = `
        <TextButton>파일 다운로드시 쓰는 텍스트버튼입니다.</TextButton>
    `, W = `
    <VContentHeader title="Title" :location="['a', 'b', 'c']" />
    `, Z = `
    <VTableTop :total-count="10" />

    <VTableTop title="테이블 타이틀">
        <template #right>버튼영역</template>
    </VTableTop>

    <VTableTop :total-count="20">
        <template #right>버튼영역</template>
    </VTableTop>
    `, H = `
    // infiniteTable 속성을 추가후 스크롤 마지막이 동작하는 end-body 이벤트를 이용하면 무한 스크롤 구현 가능

    <VTable max-height="100px" infiniteTable @end-body="console.log('스크롤 마지막')"></VTable>

    // 세로형 테이블
    <VTable type="horizon"> </VTable>
    `, K = `
    // label과 (checkbox radio)의 간격을 조절하는 역할을 한다.
    <VFormGroup>
        <label for="a">남자</label>
        <VRadiobox value="M" v-model="values" id="a" />
        <label for="b">여자</label>
        <VRadiobox value="W" v-model="values" id="b" />
    </VFormGroup>
    `, Q = `
    // total-count 데이터의 갯수, v-model:pagination : 페이지 변경시, v-model:dropdown :드롭다운 변경시
    <VPaginationGroup v-model:dropdown="pageSize" v-model:pagination="page" :total-count="10" />
    `, _e = `
        // 전역으로 등록되어있는 커스텀 alert, confirm 사용하는 방법

        import { useAlertStore } from "@/store/useAlert";
        const store = useAlertStore();

        async function 함수() {
            const res = await store.confirm("저장하시겠습니까?");
        }

    `, se = `
            const val = ref("<p>값</p>");
            <VEditor style="height: 300px" v-model="val" />
    `;
    const Pe = pt([
      { checked: !1, name: "John", age: 25, child1: "aaa", child2: "eee", year: 2020 },
      { checked: !1, name: "Jane", age: 24, child1: "bbb", child2: "ddd", year: 2022 },
      { checked: !1, name: "Doe", age: 26, child1: "ccc", child2: "fff", year: 2024 }
    ]);
    var Ke = `
    const data = ref([
        { checked: false, name: "John", age: 25, child1: 'aaa', child2: 'eee', year: 2020 },
        { checked: false, name: "Jane", age: 24, child1: 'bbb', child2: 'ddd', year: 2022 },
        { checked: false, name: "Doe", age: 26, child1: 'ccc', child2: 'fff', year: 2024 }
    ]);

    <VDataTable
        v-model="data"
        :init-width="[100, 200, 100, 400, 300]"
        :min-width="100"
        :columns="[
            {
                check: true,
                name: '',
                sort: false
            },
            {
                name: 'name',
                sort: true
            },
            {
                name: 'age',
                sort: true
            },
            {
                name: 'group',
                sort: false,
                children: [
                    {
                        name: 'child1',
                        sort: true,
                    },
                    {
                        name: 'child2',
                        sort: true,
                    }
                ]
            },
            {
                name: 'year',
                sort: true
            }
        ]"
    >
        <template #tbody>
            <tr v-for="a in data" :key="a.name">
                <td><VCheckbox v-model="a.checked" /></td>
                <td>{{ a.name }}</td>
                <td>{{ a.age }}</td>
                <td>{{ a.child1 }}</td>
                <td>{{ a.child2 }}</td>
                <td>{{ a.year }}</td>
            </tr>
        </template>
    </VDataTable>
    `;
    const ye = pt([]);
    Na(() => {
      window.addEventListener("hashchange", function() {
        var w = window.location.hash.substring(1), fe = document.getElementById(w);
        fe && fe.scrollIntoView({ behavior: "smooth" });
      }), window.addEventListener("scroll", function() {
        var w = document.querySelectorAll(".section");
        w.forEach(function(fe) {
          var j = window.scrollY, J = fe.offsetTop, de = fe.offsetHeight, ie = fe.getAttribute("id");
          let X = window;
          j >= J && j < J + de && X.history.pushState(null, null, "#" + ie);
        });
      });
      const ge = [...document.querySelectorAll(".section")];
      ye.value = ge.map((w) => w.getAttribute("id")).filter((w) => !!w);
    });
    const Je = window.location.origin + window.location.pathname + "#", mt = pt("");
    return (ge, w) => {
      const fe = pr("VCheckbox"), j = pr("VDataTable"), J = pr("VEditor"), de = pr("VTableTop"), ie = pr("VContentHeader"), X = pr("VUploadFile"), ue = pr("VIconButton"), Oe = pr("VFileButton"), Re = pr("TextButton"), ae = pr("VSortButton"), Ee = pr("VCommonDropdown"), ne = pr("VModal"), Ge = pr("VButton"), we = pr("VTextInput"), st = pr("VIconFont"), Rt = pr("VRadiobox"), rt = pr("SearchMenu"), z = pr("TabTitle"), V = pr("VDropdown"), Te = pr("VPagination"), Be = pr("VTable");
      return he(), De(nr, null, [
        U("nav", AF, [
          U("ul", null, [
            (he(!0), De(nr, null, Fr(ye.value, (Le) => (he(), De("li", OF, [
              U("a", {
                href: Je + Le
              }, wt(Le), 9, yF)
            ]))), 256))
          ])
        ]),
        U("div", IF, [
          U("div", DF, [
            w[24] || (w[24] = U("h4", null, "VDataTable", -1)),
            Ze(j, {
              modelValue: Pe.value,
              "onUpdate:modelValue": w[0] || (w[0] = (Le) => Pe.value = Le),
              "min-width": 100,
              "init-width": [100, 200, 100, 400, 300],
              columns: [
                {
                  check: !0,
                  name: "",
                  sort: !1
                },
                {
                  name: "name",
                  sort: !0
                },
                {
                  name: "age",
                  sort: !0
                },
                {
                  name: "group",
                  sort: !1,
                  children: [
                    {
                      name: "child1",
                      sort: !0
                    },
                    {
                      name: "child2",
                      sort: !0
                    }
                  ]
                },
                {
                  name: "year",
                  sort: !0
                }
              ]
            }, {
              tbody: rn(() => [
                (he(!0), De(nr, null, Fr(Pe.value, (Le) => (he(), De("tr", {
                  key: Le.name
                }, [
                  U("td", null, [
                    Ze(fe, {
                      modelValue: Le.checked,
                      "onUpdate:modelValue": (Yt) => Le.checked = Yt
                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                  ]),
                  U("td", null, wt(Le.name), 1),
                  U("td", null, wt(Le.age), 1),
                  U("td", null, wt(Le.child1), 1),
                  U("td", null, wt(Le.child2), 1),
                  U("td", null, wt(Le.year), 1)
                ]))), 128))
              ]),
              _: 1
            }, 8, ["modelValue"]),
            U("pre", null, [
              w[22] || (w[22] = Ft("                ")),
              U("code", null, `
                    ` + wt(kt(Ke)) + `
                `, 1),
              w[23] || (w[23] = Ft(`
            `))
            ]),
            w[25] || (w[25] = Yn('<table class="props-table mt-20" data-v-4371e388><thead data-v-4371e388><tr data-v-4371e388><th data-v-4371e388>Props</th><th data-v-4371e388>Type</th><th data-v-4371e388>Default</th><th data-v-4371e388>Description</th></tr></thead><tbody data-v-4371e388><tr data-v-4371e388><td data-v-4371e388>columns</td><td data-v-4371e388>{ name: string; sort: boolean }[]</td><td data-v-4371e388></td><td data-v-4371e388>{name : 칼럼명, sort : 정렬여부}</td></tr><tr data-v-4371e388><td data-v-4371e388>modelValue</td><td data-v-4371e388>{ [key: string]: any }[]</td><td data-v-4371e388></td><td data-v-4371e388>데이터들</td></tr><tr data-v-4371e388><td data-v-4371e388>initWidth</td><td data-v-4371e388>number[] | number;</td><td data-v-4371e388>100</td><td data-v-4371e388>초기넓이값 (단위px)</td></tr><tr data-v-4371e388><td data-v-4371e388>minWidth</td><td data-v-4371e388>number[] | number;</td><td data-v-4371e388>100</td><td data-v-4371e388>최소넓이값 (단위px)</td></tr></tbody></table>', 1))
          ]),
          U("div", wF, [
            w[28] || (w[28] = U("h4", null, "VEditor", -1)),
            Ze(J, {
              style: { height: "300px" },
              modelValue: mt.value,
              "onUpdate:modelValue": w[1] || (w[1] = (Le) => mt.value = Le)
            }, null, 8, ["modelValue"]),
            U("p", null, wt(mt.value), 1),
            U("pre", null, [
              w[26] || (w[26] = Ft("                ")),
              U("code", null, `
                    ` + wt(kt(se)) + `
                `, 1),
              w[27] || (w[27] = Ft(`
            `))
            ])
          ]),
          U("div", xF, [
            w[31] || (w[31] = U("h4", null, "VPaginationGroup", -1)),
            U("pre", null, [
              w[29] || (w[29] = Ft("                ")),
              U("code", null, `
                    ` + wt(kt(Q)) + `
                `, 1),
              w[30] || (w[30] = Ft(`
            `))
            ])
          ]),
          U("div", LF, [
            w[34] || (w[34] = U("h4", null, "VFormGroup", -1)),
            U("pre", null, [
              w[32] || (w[32] = Ft("                ")),
              U("code", null, `
                    ` + wt(kt(K)) + `
                `, 1),
              w[33] || (w[33] = Ft(`
            `))
            ])
          ]),
          U("div", MF, [
            w[39] || (w[39] = U("h4", null, "TableTop", -1)),
            Ze(de, { "total-count": 10 }),
            Ze(de, { title: "테이블 타이틀" }, {
              right: rn(() => w[35] || (w[35] = [
                Ft("버튼영역")
              ])),
              _: 1
            }),
            Ze(de, { "total-count": 20 }, {
              right: rn(() => w[36] || (w[36] = [
                Ft("버튼영역")
              ])),
              _: 1
            }),
            U("pre", null, [
              w[37] || (w[37] = Ft("                ")),
              U("code", null, `
                    ` + wt(kt(Z)) + `
                `, 1),
              w[38] || (w[38] = Ft(`
            `))
            ])
          ]),
          U("div", PF, [
            w[42] || (w[42] = U("h4", null, "VContentHeader", -1)),
            Ze(ie, {
              title: "제목입니다",
              location: ["a", "b", "c"]
            }),
            U("pre", null, [
              w[40] || (w[40] = Ft("                ")),
              U("code", null, `
                    ` + wt(kt(W)) + `
                `, 1),
              w[41] || (w[41] = Ft(`
            `))
            ])
          ]),
          U("div", kF, [
            w[45] || (w[45] = U("h4", null, "VUploadFile", -1)),
            w[46] || (w[46] = U("div", { class: "mt-20 mb-10" }, "단일 데이터", -1)),
            Ze(X, {
              modelValue: x.value,
              "onUpdate:modelValue": w[2] || (w[2] = (Le) => x.value = Le)
            }, null, 8, ["modelValue"]),
            w[47] || (w[47] = U("div", { class: "mt-20 mb-10" }, "멀티 데이터", -1)),
            U("div", FF, [
              Ze(X, {
                modelValue: G.value,
                "onUpdate:modelValue": w[3] || (w[3] = (Le) => G.value = Le),
                multiple: ""
              }, null, 8, ["modelValue"])
            ]),
            U("pre", null, [
              w[43] || (w[43] = Ft("                ")),
              U("code", null, `
                    ` + wt(kt(L)) + `
                `, 1),
              w[44] || (w[44] = Ft(`
            `))
            ]),
            w[48] || (w[48] = Yn('<table class="props-table mt-20" data-v-4371e388><thead data-v-4371e388><tr data-v-4371e388><th data-v-4371e388>Props</th><th data-v-4371e388>Type</th><th data-v-4371e388>Default</th><th data-v-4371e388>Description</th></tr></thead><tbody data-v-4371e388><tr data-v-4371e388><td data-v-4371e388>multiple</td><td data-v-4371e388>boolean</td><td data-v-4371e388>false</td><td data-v-4371e388>멀티 업로드 가능 여부</td></tr><tr data-v-4371e388><td data-v-4371e388>modelValue</td><td data-v-4371e388>File[ ]</td><td data-v-4371e388></td><td data-v-4371e388>v-model</td></tr><tr data-v-4371e388><td data-v-4371e388>fileFormat</td><td data-v-4371e388>string[ ]</td><td data-v-4371e388>[ ]</td><td data-v-4371e388>멀티 업로드 가능 여부</td></tr><tr data-v-4371e388><td data-v-4371e388>totalSize</td><td data-v-4371e388>number</td><td data-v-4371e388></td><td data-v-4371e388>파일 총 용량</td></tr><tr data-v-4371e388><td data-v-4371e388>maxLength</td><td data-v-4371e388>number</td><td data-v-4371e388></td><td data-v-4371e388>최대 업로드 개수</td></tr></tbody></table>', 1))
          ]),
          U("div", UF, [
            w[51] || (w[51] = U("h4", null, "VIconButton", -1)),
            Ze(ue, { icon: "ic_global" }),
            Ze(ue, { icon: "ic_dropdown" }),
            U("pre", null, [
              w[49] || (w[49] = Ft("                ")),
              U("code", null, `
                    ` + wt(kt(Y)) + `
                `, 1),
              w[50] || (w[50] = Ft(`
            `))
            ]),
            w[52] || (w[52] = Yn('<table class="props-table mt-20" data-v-4371e388><thead data-v-4371e388><tr data-v-4371e388><th data-v-4371e388>Props</th><th data-v-4371e388>Type</th><th data-v-4371e388>Default</th><th data-v-4371e388>Description</th></tr></thead><tbody data-v-4371e388><tr data-v-4371e388><td class="r" data-v-4371e388>code</td><td data-v-4371e388>string</td><td data-v-4371e388></td><td data-v-4371e388>아이콘명</td></tr></tbody></table>', 1))
          ]),
          U("div", BF, [
            w[53] || (w[53] = U("h4", null, "VFileButton", -1)),
            Ze(Oe, { id: "10" }),
            w[54] || (w[54] = Yn('<input type="file" id="10" data-v-4371e388><table class="props-table mt-20" data-v-4371e388><thead data-v-4371e388><tr data-v-4371e388><th data-v-4371e388>Props</th><th data-v-4371e388>Type</th><th data-v-4371e388>Default</th><th data-v-4371e388>Description</th></tr></thead><tbody data-v-4371e388><tr data-v-4371e388><td class="r" data-v-4371e388>id</td><td data-v-4371e388>string</td><td data-v-4371e388></td><td data-v-4371e388>ID</td></tr><tr data-v-4371e388><td data-v-4371e388>disabled</td><td data-v-4371e388>boolean</td><td data-v-4371e388>false</td><td data-v-4371e388>disabled</td></tr></tbody></table>', 2))
          ]),
          U("div", GF, [
            w[58] || (w[58] = U("h4", null, "TextButton", -1)),
            Ze(Re, null, {
              default: rn(() => w[55] || (w[55] = [
                Ft("파일 다운로드시 쓰는 텍스트버튼입니다.")
              ])),
              _: 1
            }),
            U("pre", null, [
              w[56] || (w[56] = Ft("                ")),
              U("code", null, `
                    ` + wt(kt(k)) + `
                `, 1),
              w[57] || (w[57] = Ft(`
            `))
            ])
          ]),
          U("div", VF, [
            w[59] || (w[59] = U("h4", null, "VSortButton", -1)),
            w[60] || (w[60] = U("p", null, "정렬(sorting) 버튼입니다.", -1)),
            Ze(ae),
            Ze(ae)
          ]),
          U("div", YF, [
            w[61] || (w[61] = U("h4", null, "VCommonDropdown", -1)),
            Ze(Ee, {
              code: "VI008",
              modelValue: N.value,
              "onUpdate:modelValue": w[4] || (w[4] = (Le) => N.value = Le),
              "label-property": "cdNm",
              "value-property": "commnCd"
            }, null, 8, ["modelValue"]),
            Ze(Ee, {
              code: "VI008",
              modelValue: D.value,
              "onUpdate:modelValue": w[5] || (w[5] = (Le) => D.value = Le),
              "label-property": "cdNm",
              "value-property": "commnCd",
              "all-value": ""
            }, null, 8, ["modelValue"]),
            w[62] || (w[62] = Yn('<table class="props-table mt-20" data-v-4371e388><thead data-v-4371e388><tr data-v-4371e388><th data-v-4371e388>Props</th><th data-v-4371e388>Type</th><th data-v-4371e388>Default</th><th data-v-4371e388>Description</th></tr></thead><tbody data-v-4371e388><tr data-v-4371e388><td class="r" data-v-4371e388>code</td><td data-v-4371e388>string</td><td data-v-4371e388></td><td data-v-4371e388>공통 코드 명</td></tr><tr data-v-4371e388><td data-v-4371e388>modelValue</td><td data-v-4371e388></td><td data-v-4371e388></td><td data-v-4371e388>v-model</td></tr><tr data-v-4371e388><td data-v-4371e388>method</td><td data-v-4371e388>&quot;get&quot; | &quot;post&quot;</td><td data-v-4371e388>&quot;get&quot;</td><td data-v-4371e388>메소드 명</td></tr><tr data-v-4371e388><td data-v-4371e388>allValue</td><td data-v-4371e388>boolean</td><td data-v-4371e388>false</td><td data-v-4371e388>전체라는 값을 가질지 말지</td></tr><tr data-v-4371e388><td data-v-4371e388>labelProperty</td><td data-v-4371e388>string</td><td data-v-4371e388>&quot;label&quot;</td><td data-v-4371e388>label로서의 역할을 하는 속성명 (api response값에 따라 변경해도됨)</td></tr><tr data-v-4371e388><td data-v-4371e388>valueProperty</td><td data-v-4371e388>string</td><td data-v-4371e388>&quot;value&quot;</td><td data-v-4371e388>value로서의 역할을 하는 속성명 (api response값에 따라 변경해도됨)</td></tr><tr data-v-4371e388><td data-v-4371e388>onChange</td><td data-v-4371e388></td><td data-v-4371e388></td><td data-v-4371e388>값 변경시</td></tr></tbody></table>', 1))
          ]),
          U("div", HF, [
            w[85] || (w[85] = U("h4", null, "VModal", -1)),
            C.value ? (he(), gn(ne, {
              key: 0,
              title: "모달 타이틀",
              onClose: w[6] || (w[6] = (Le) => C.value = !1),
              size: { width: "600px", height: "200px" }
            }, {
              default: rn(() => w[63] || (w[63] = [
                Ft(" 모달 내용넣는곳 @@@@@@@@@@@@@@@@@@@@@@@@ ")
              ])),
              _: 1
            })) : Ut("", !0),
            Ze(Ge, {
              onClick: w[7] || (w[7] = (Le) => C.value = !0)
            }, {
              default: rn(() => w[64] || (w[64] = [
                Ft("모달 버튼 클릭")
              ])),
              _: 1
            }),
            S.value ? (he(), gn(ne, {
              key: 1,
              onClose: w[8] || (w[8] = (Le) => S.value = !1),
              confirm: "",
              onCheck: w[9] || (w[9] = (Le) => console.log("확인 눌렀을때 이벤트"))
            }, {
              default: rn(() => w[65] || (w[65] = [
                Ft(" 작성된 항목을 삭제하시겠습니까? ")
              ])),
              _: 1
            })) : Ut("", !0),
            Ze(Ge, {
              onClick: w[10] || (w[10] = (Le) => S.value = !0)
            }, {
              default: rn(() => w[66] || (w[66] = [
                Ft("confilm 클릭")
              ])),
              _: 1
            }),
            O.value ? (he(), gn(ne, {
              key: 2,
              confirm: "",
              blurText: ""
            }, {
              blue: rn(() => w[67] || (w[67] = [
                Ft(" 123 ")
              ])),
              default: rn(() => [
                w[68] || (w[68] = Ft(" 예시텍스트 입니다. ")),
                w[69] || (w[69] = U("span", { class: "text-primary" }, "여기는 파랑색", -1)),
                w[70] || (w[70] = Ft()),
                w[71] || (w[71] = U("br", null, null, -1)),
                w[72] || (w[72] = U("br", null, null, -1)),
                w[73] || (w[73] = Ft("10asdfasdfasdf ")),
                w[74] || (w[74] = U("br", null, null, -1)),
                w[75] || (w[75] = Ft("10asdfasdfasdf ")),
                w[76] || (w[76] = U("br", null, null, -1)),
                w[77] || (w[77] = Ft("10asdfasdfasdf ")),
                w[78] || (w[78] = U("br", null, null, -1)),
                w[79] || (w[79] = Ft("10asdfasdfasdf ")),
                w[80] || (w[80] = U("br", null, null, -1)),
                w[81] || (w[81] = Ft("10asdfasdfasdf "))
              ]),
              _: 1
            })) : Ut("", !0),
            Ze(Ge, {
              onClick: w[11] || (w[11] = (Le) => O.value = !0)
            }, {
              default: rn(() => w[82] || (w[82] = [
                Ft("confilm2")
              ])),
              _: 1
            }),
            U("pre", null, [
              w[83] || (w[83] = Ft("                ")),
              U("code", null, `
                    ` + wt(kt(_e)) + `
                `, 1),
              w[84] || (w[84] = Ft(`
            `))
            ]),
            w[86] || (w[86] = Yn('<table class="props-table" data-v-4371e388><thead data-v-4371e388><tr data-v-4371e388><th data-v-4371e388>Props</th><th data-v-4371e388>Type</th><th data-v-4371e388>Default</th><th data-v-4371e388>Description</th></tr></thead><tbody data-v-4371e388><tr data-v-4371e388><td class="r" data-v-4371e388>bgNone</td><td data-v-4371e388>boolean</td><td data-v-4371e388>false</td><td data-v-4371e388>배경 dim 제거 여부</td></tr><tr data-v-4371e388><td data-v-4371e388>title</td><td data-v-4371e388>string</td><td data-v-4371e388></td><td data-v-4371e388>모달 제목</td></tr><tr data-v-4371e388><td data-v-4371e388>confirm</td><td data-v-4371e388>boolean</td><td data-v-4371e388>false</td><td data-v-4371e388>confirm창 여부</td></tr><tr data-v-4371e388><td data-v-4371e388>alert</td><td data-v-4371e388>boolean</td><td data-v-4371e388>false</td><td data-v-4371e388>alert창 여부</td></tr><tr data-v-4371e388><td data-v-4371e388>size</td><td data-v-4371e388></td><td data-v-4371e388>{width : &#39;&#39;, heigth : &#39;&#39;}</td><td data-v-4371e388>모달창의 width값과 height값을 넣는다.</td></tr></tbody></table>', 1))
          ]),
          U("div", qF, [
            w[87] || (w[87] = U("h4", null, "VTextInput", -1)),
            Ze(we, {
              name: "email",
              modelValue: e.value,
              "onUpdate:modelValue": w[12] || (w[12] = (Le) => e.value = Le)
            }, null, 8, ["modelValue"]),
            Ze(we, {
              name: "email2",
              "search-input": "",
              style: { width: "200px" }
            }),
            w[88] || (w[88] = Yn(`<table class="props-table" data-v-4371e388><thead data-v-4371e388><tr data-v-4371e388><th data-v-4371e388>Props</th><th data-v-4371e388>Type</th><th data-v-4371e388>Default</th><th data-v-4371e388>Description</th></tr></thead><tbody data-v-4371e388><tr data-v-4371e388><td class="r" data-v-4371e388>name</td><td data-v-4371e388>string</td><td data-v-4371e388></td><td data-v-4371e388>form을 위한 고유의 input의 name</td></tr><tr data-v-4371e388><td data-v-4371e388>modelValue</td><td data-v-4371e388></td><td data-v-4371e388></td><td data-v-4371e388>v-model</td></tr><tr data-v-4371e388><td data-v-4371e388>type</td><td data-v-4371e388></td><td data-v-4371e388>text</td><td data-v-4371e388>인풋의 type</td></tr><tr data-v-4371e388><td data-v-4371e388>size</td><td data-v-4371e388></td><td data-v-4371e388>&quot;xs&quot; | &quot;sm&quot; | &quot;md&quot; | &quot;lg&quot; | &quot;xl&quot; | &quot;max&quot;</td><td data-v-4371e388>{
  &quot;xs&quot;: &quot;100px&quot;,
  &quot;sm&quot;: &quot;120px&quot;,
  &quot;md&quot;: &quot;180px&quot;,
  &quot;lg&quot;: &quot;300px&quot;,
  &quot;xl&quot;: &quot;460px&quot;,
  &quot;max&quot;: &quot;100%&quot;
}</td></tr></tbody></table>`, 1))
          ]),
          w[123] || (w[123] = U("div", {
            class: "section",
            id: "Textarea"
          }, [
            U("h4", null, "Textarea")
          ], -1)),
          U("div", $F, [
            w[89] || (w[89] = U("h4", null, "아이콘", -1)),
            (he(), De(nr, null, Fr(o, (Le) => Ze(st, {
              key: Le,
              icon: Le,
              style: { "font-size": "2rem", color: "#444" },
              onClick: (Yt) => i(`<VIconFont icon="${Le}" />`)
            }, null, 8, ["icon", "onClick"])), 64)),
            w[90] || (w[90] = U("p", { class: "mt-20" }, "* 아이콘을 클릭하면 복사 됨", -1))
          ]),
          U("div", WF, [
            w[91] || (w[91] = U("h4", null, "VButton", -1)),
            Ze(Ge, {
              label: "목록",
              color: "white",
              icon: "ic_calendar"
            }),
            Ze(Ge, { label: "조회" }),
            Ze(Ge, {
              label: "조회",
              disabled: ""
            }),
            Ze(Ge, {
              label: "조회",
              color: "grey",
              mini: ""
            }),
            Ze(Ge, {
              label: "조회",
              color: "grey",
              mini: "",
              disabled: ""
            }),
            Ze(Ge, {
              label: "조회",
              color: "white",
              mini: ""
            }),
            Ze(Ge, {
              label: "조회",
              color: "white",
              mini: "",
              disabled: ""
            }),
            Ze(Ge, {
              label: "조회",
              color: "dark-grey",
              mini: ""
            }),
            Ze(Ge, {
              label: "조회",
              color: "dark",
              mini: ""
            }),
            w[92] || (w[92] = Yn('<table class="props-table" data-v-4371e388><thead data-v-4371e388><tr data-v-4371e388><th data-v-4371e388>Props</th><th data-v-4371e388>Type</th><th data-v-4371e388>Default</th><th data-v-4371e388>Description</th></tr></thead><tbody data-v-4371e388><tr data-v-4371e388><td data-v-4371e388>color</td><td data-v-4371e388>&quot;primary&quot; | &quot;grey&quot; | &quot;white&quot; | &quot;dark&quot; | &quot;dark-grey&quot;</td><td data-v-4371e388>&quot;primary&quot;</td><td data-v-4371e388>버튼 색상</td></tr><tr data-v-4371e388><td data-v-4371e388>type</td><td data-v-4371e388>&quot;submit&quot; | &quot;reset&quot; | &quot;button&quot;;</td><td data-v-4371e388>&quot;button&quot;</td><td data-v-4371e388></td></tr><tr data-v-4371e388><td data-v-4371e388>mini</td><td data-v-4371e388>&quot;boolean&quot;</td><td data-v-4371e388>&quot;false&quot;</td><td data-v-4371e388></td></tr><tr data-v-4371e388><td data-v-4371e388>label</td><td data-v-4371e388>&quot;string&quot;</td><td data-v-4371e388></td><td data-v-4371e388>국제화를 위해 label props를 사용한다.</td></tr><tr data-v-4371e388><td data-v-4371e388>icon</td><td data-v-4371e388>string</td><td data-v-4371e388></td><td data-v-4371e388>버튼에 들어가는 icon이름을 넣는다</td></tr></tbody></table>', 1))
          ]),
          U("div", zF, [
            w[93] || (w[93] = U("h4", null, "VCheckbox", -1)),
            Ze(fe, {
              modelValue: g.value,
              "onUpdate:modelValue": w[13] || (w[13] = (Le) => g.value = Le),
              value: "10"
            }, null, 8, ["modelValue"]),
            Ze(fe, {
              modelValue: g.value,
              "onUpdate:modelValue": w[14] || (w[14] = (Le) => g.value = Le),
              value: "20"
            }, null, 8, ["modelValue"]),
            Ze(fe, { "model-value": !0 }),
            Ze(fe, {
              disabled: "",
              "model-value": !0
            }),
            w[94] || (w[94] = Yn('<table class="props-table" data-v-4371e388><thead data-v-4371e388><tr data-v-4371e388><th data-v-4371e388>Props</th><th data-v-4371e388>Type</th><th data-v-4371e388>Default</th><th data-v-4371e388>Description</th></tr></thead><tbody data-v-4371e388><tr data-v-4371e388><td data-v-4371e388>value</td><td data-v-4371e388>any</td><td data-v-4371e388></td><td data-v-4371e388>체크시 얻을 값</td></tr><tr data-v-4371e388><td data-v-4371e388>modelValue</td><td data-v-4371e388></td><td data-v-4371e388></td><td data-v-4371e388>v-model</td></tr></tbody></table>', 1))
          ]),
          U("div", KF, [
            w[95] || (w[95] = U("h4", null, "VRadiobox", -1)),
            Ze(Rt),
            Ze(Rt, { checked: "" }),
            w[96] || (w[96] = Yn('<table class="props-table" data-v-4371e388><thead data-v-4371e388><tr data-v-4371e388><th data-v-4371e388>Props</th><th data-v-4371e388>Type</th><th data-v-4371e388>Default</th><th data-v-4371e388>Description</th></tr></thead><tbody data-v-4371e388><tr data-v-4371e388><td data-v-4371e388>value</td><td data-v-4371e388>any</td><td data-v-4371e388></td><td data-v-4371e388>체크시 얻을 값</td></tr><tr data-v-4371e388><td data-v-4371e388>modelValue</td><td data-v-4371e388></td><td data-v-4371e388></td><td data-v-4371e388>v-model</td></tr></tbody></table>', 1))
          ]),
          U("div", QF, [
            w[107] || (w[107] = U("h4", null, "SearchMenu", -1)),
            Ze(rt, { class: "mb-20" }, {
              default: rn(() => [
                U("div", XF, [
                  w[97] || (w[97] = U("div", { class: "search-label" }, "클럽명", -1)),
                  Ze(we, {
                    class: "mr-40",
                    name: "10",
                    modelValue: e.value,
                    "onUpdate:modelValue": w[15] || (w[15] = (Le) => e.value = Le)
                  }, null, 8, ["modelValue"]),
                  w[98] || (w[98] = U("div", { class: "search-label" }, "훈련장사용여부", -1)),
                  Ze(we, { name: "yn" })
                ]),
                U("div", ZF, [
                  w[99] || (w[99] = U("div", { class: "search-label" }, "클럽명", -1)),
                  Ze(we, {
                    class: "mr-40",
                    name: "clubName"
                  }),
                  w[100] || (w[100] = U("div", { class: "search-label" }, "훈련장사용여부", -1)),
                  Ze(we, { name: "yn" })
                ])
              ]),
              _: 1
            }),
            Ze(rt, { class: "mb-20" }, {
              default: rn(() => [
                U("div", jF, [
                  w[101] || (w[101] = U("div", { class: "search-label" }, "클럽명", -1)),
                  Ze(we, {
                    class: "mr-40",
                    name: "10",
                    modelValue: e.value,
                    "onUpdate:modelValue": w[16] || (w[16] = (Le) => e.value = Le)
                  }, null, 8, ["modelValue"]),
                  w[102] || (w[102] = U("div", { class: "search-label" }, "훈련장사용여부", -1)),
                  Ze(we, { name: "yn" })
                ]),
                U("div", JF, [
                  w[103] || (w[103] = U("div", { class: "search-label" }, "클럽명", -1)),
                  Ze(we, {
                    class: "mr-40",
                    name: "clubName"
                  }),
                  w[104] || (w[104] = U("div", { class: "search-label" }, "훈련장사용여부", -1)),
                  Ze(we, { name: "yn" })
                ]),
                U("div", e3, [
                  w[105] || (w[105] = U("div", { class: "search-label" }, "클럽명", -1)),
                  Ze(we, {
                    class: "mr-40",
                    name: "clubName"
                  }),
                  w[106] || (w[106] = U("div", { class: "search-label" }, "훈련장사용여부", -1)),
                  Ze(we, { name: "yn" })
                ])
              ]),
              _: 1
            }),
            w[108] || (w[108] = Yn('<p data-v-4371e388> SearchMenu는 슬롯을 이용하여 사용한다. 지정된 클래스명 .search-list, search-label을 사용한다. .search-list 3개 이상부터 더보기 버튼생김 </p><p data-v-4371e388>더보기 버튼을 제거하고싶을때에는 props : :is-more=false</p><table class="props-table mt-20" data-v-4371e388><thead data-v-4371e388><tr data-v-4371e388><th data-v-4371e388>Emit</th><th data-v-4371e388>Payload</th><th data-v-4371e388>Description</th></tr></thead><tbody data-v-4371e388><tr data-v-4371e388><td data-v-4371e388>search</td><td data-v-4371e388>없음</td><td data-v-4371e388>조회 눌렀을때 콜백</td></tr></tbody></table>', 3))
          ]),
          U("div", t3, [
            w[109] || (w[109] = U("h4", null, "TabTitle", -1)),
            Ze(z, {
              modelValue: c.value,
              "onUpdate:modelValue": w[17] || (w[17] = (Le) => c.value = Le),
              list: ["가", "나", "다", "라"]
            }, null, 8, ["modelValue"]),
            Ze(z, {
              modelValue: c.value,
              "onUpdate:modelValue": w[18] || (w[18] = (Le) => c.value = Le),
              list: ["가", "나", "다", "라"],
              type: "large"
            }, null, 8, ["modelValue"]),
            w[110] || (w[110] = Yn('<table class="props-table mt-20" data-v-4371e388><thead data-v-4371e388><tr data-v-4371e388><th data-v-4371e388>Props</th><th data-v-4371e388>Type</th><th data-v-4371e388>Default</th><th data-v-4371e388>Description</th></tr></thead><tbody data-v-4371e388><tr data-v-4371e388><td class="r" data-v-4371e388>list</td><td data-v-4371e388>string[ ]</td><td data-v-4371e388></td><td data-v-4371e388>탭이름 배열</td></tr><tr data-v-4371e388><td data-v-4371e388>modelValue</td><td data-v-4371e388>number</td><td data-v-4371e388></td><td data-v-4371e388>v-model</td></tr><tr data-v-4371e388><td data-v-4371e388>type</td><td data-v-4371e388>&quot;small&quot; | &quot;large&quot;</td><td data-v-4371e388>&quot;small&quot;</td><td data-v-4371e388>버튼형/스퀘어형</td></tr></tbody></table>', 1))
          ]),
          U("div", r3, [
            w[111] || (w[111] = U("h4", null, "VDropdown", -1)),
            Ze(V, {
              multiple: h.value,
              "onUpdate:multiple": w[19] || (w[19] = (Le) => h.value = Le),
              type: "multiple",
              options: [
                { id: 1, label: "eed", value: "dww" },
                { id: 2, label: "e1ed", value: "d2ww" }
              ]
            }, null, 8, ["multiple"]),
            Ze(V, {
              modelValue: h.value,
              "onUpdate:modelValue": w[20] || (w[20] = (Le) => h.value = Le),
              options: [
                { id: 1, label: "eed", value: "dww" },
                { id: 2, label: "e1ed", value: "d2ww" }
              ]
            }, null, 8, ["modelValue"]),
            Ft(" " + wt(h.value) + " ", 1),
            w[112] || (w[112] = Yn('<table class="props-table mt-20" data-v-4371e388><thead data-v-4371e388><tr data-v-4371e388><th data-v-4371e388>Props</th><th data-v-4371e388>Type</th><th data-v-4371e388>Default</th><th data-v-4371e388>Description</th></tr></thead><tbody data-v-4371e388><tr data-v-4371e388><td data-v-4371e388>options</td><td data-v-4371e388>any[ ]</td><td data-v-4371e388></td><td data-v-4371e388>단일 셀렉트 옵션</td></tr><tr data-v-4371e388><td data-v-4371e388>modelValue</td><td data-v-4371e388>any | null</td><td data-v-4371e388></td><td data-v-4371e388>v-model</td></tr><tr data-v-4371e388><td data-v-4371e388>multiple</td><td data-v-4371e388>any[ ] | null</td><td data-v-4371e388></td><td data-v-4371e388>v-model:multiple</td></tr><tr data-v-4371e388><td data-v-4371e388>placeholder</td><td data-v-4371e388>string</td><td data-v-4371e388>&quot;선택하세요.&quot;</td><td data-v-4371e388></td></tr><tr data-v-4371e388><td data-v-4371e388>labelProperty</td><td data-v-4371e388>string</td><td data-v-4371e388>&quot;label&quot;</td><td data-v-4371e388>이름으로 쓰이는 옵션의 키값 (ex : &#39;cdNm&#39;)</td></tr><tr data-v-4371e388><td data-v-4371e388>valueProperty</td><td data-v-4371e388>string</td><td data-v-4371e388>&quot;value&quot;</td><td data-v-4371e388>값로 쓰이는 옵션의 키값 (ex : &#39;cdNm&#39;)</td></tr><tr data-v-4371e388><td data-v-4371e388>disabled</td><td data-v-4371e388>boolean</td><td data-v-4371e388>false</td><td data-v-4371e388>disabled</td></tr><tr data-v-4371e388><td data-v-4371e388>type</td><td data-v-4371e388>&quot;single&quot; | &quot;multiple&quot;</td><td data-v-4371e388>&quot;single&quot;</td><td data-v-4371e388>셀렉트 타입</td></tr><tr data-v-4371e388><td data-v-4371e388>width</td><td data-v-4371e388>string</td><td data-v-4371e388>&quot;200px&quot;</td><td data-v-4371e388>width</td></tr><tr data-v-4371e388><td data-v-4371e388>scrollHeight</td><td data-v-4371e388>string</td><td data-v-4371e388>&quot;200px&quot;</td><td data-v-4371e388>드롭다운높이</td></tr><tr data-v-4371e388><td data-v-4371e388>allOption</td><td data-v-4371e388>boolean</td><td data-v-4371e388></td><td data-v-4371e388>드롭다운 전체 선택 여부</td></tr><tr data-v-4371e388><td data-v-4371e388>disabledProperty</td><td data-v-4371e388>string[]</td><td data-v-4371e388></td><td data-v-4371e388>요소만 disabled 하고싶은데 드롭다운의 value의 값을 넣는다.</td></tr></tbody></table>', 1))
          ]),
          U("div", n3, [
            w[113] || (w[113] = U("h4", null, "VPagination", -1)),
            Ze(Te, {
              totalPage: 1e3,
              modelValue: r.value,
              "onUpdate:modelValue": w[21] || (w[21] = (Le) => r.value = Le)
            }, null, 8, ["modelValue"]),
            w[114] || (w[114] = Yn('<table class="props-table mt-20" data-v-4371e388><thead data-v-4371e388><tr data-v-4371e388><th data-v-4371e388>Props</th><th data-v-4371e388>Type</th><th data-v-4371e388>Default</th><th data-v-4371e388>Description</th></tr></thead><tbody data-v-4371e388><tr data-v-4371e388><td class="r" data-v-4371e388>totalPage</td><td data-v-4371e388>number</td><td data-v-4371e388></td><td data-v-4371e388>리스트 총 길이</td></tr><tr data-v-4371e388><td class="r" data-v-4371e388>modelValue</td><td data-v-4371e388>number</td><td data-v-4371e388></td><td data-v-4371e388>v-model</td></tr><tr data-v-4371e388><td data-v-4371e388>pageLength</td><td data-v-4371e388>number</td><td data-v-4371e388>10</td><td data-v-4371e388>한번에 보여줄 페이징 개수</td></tr></tbody></table>', 1))
          ]),
          U("div", a3, [
            w[121] || (w[121] = U("h4", null, "VTable", -1)),
            Ze(Be, { "max-height": "100px" }, {
              colgroup: rn(() => w[115] || (w[115] = [
                U("col", { style: { width: "80px" } }, null, -1),
                U("col", { style: { width: "10%" } }, null, -1),
                U("col", { style: { width: "15%" } }, null, -1),
                U("col", { style: { width: "9%" } }, null, -1),
                U("col", { style: { width: "9%" } }, null, -1),
                U("col", { style: { width: "auto" } }, null, -1)
              ])),
              thead: rn(() => w[116] || (w[116] = [
                U("tr", null, [
                  U("th", null, "번호"),
                  U("th", null, "사용자구분"),
                  U("th", null, "사용자ID"),
                  U("th", null, "사용자명"),
                  U("th", null, "사용여부"),
                  U("th", { class: "th-left" }, "비밀번호변경일시")
                ], -1)
              ])),
              tbody: rn(() => w[117] || (w[117] = [
                U("tr", null, [
                  U("td", { class: "big" }, "10"),
                  U("td", null, "관리자"),
                  U("td", { class: "text-left" }, [
                    U("u", null, "admin0017")
                  ]),
                  U("td", null, "홍길동"),
                  U("td", null, "Y"),
                  U("td", { class: "td-left" }, "2023-11-11 15:10:08")
                ], -1),
                U("tr", { class: "is-active" }, [
                  U("td", { class: "big" }, "9"),
                  U("td", null, "관리자"),
                  U("td", { class: "text-left" }, [
                    U("u", null, "admin00000017")
                  ]),
                  U("td", null, "홍길동"),
                  U("td", null, "Y"),
                  U("td", { class: "td-left" }, "2023-11-11 15:10:08")
                ], -1),
                U("tr", null, [
                  U("td", { class: "big" }, "10"),
                  U("td", null, "관리자"),
                  U("td", { class: "text-left" }, [
                    U("u", null, "admin0017")
                  ]),
                  U("td", null, "홍길동"),
                  U("td", null, "Y"),
                  U("td", { class: "td-left" }, "2023-11-11 15:10:08")
                ], -1),
                U("tr", { class: "is-active" }, [
                  U("td", { class: "big" }, "9"),
                  U("td", null, "관리자"),
                  U("td", { class: "text-left" }, [
                    U("u", null, "admin00000017")
                  ]),
                  U("td", null, "홍길동"),
                  U("td", null, "Y"),
                  U("td", { class: "td-left" }, "2023-11-11 15:10:08")
                ], -1),
                U("tr", null, [
                  U("td", { class: "big" }, "10"),
                  U("td", null, "관리자"),
                  U("td", { class: "text-left" }, [
                    U("u", null, "admin0017")
                  ]),
                  U("td", null, "홍길동"),
                  U("td", null, "Y"),
                  U("td", { class: "td-left" }, "2023-11-11 15:10:08")
                ], -1),
                U("tr", { class: "is-active" }, [
                  U("td", { class: "big" }, "9"),
                  U("td", null, "관리자"),
                  U("td", { class: "text-left" }, [
                    U("u", null, "admin00000017")
                  ]),
                  U("td", null, "홍길동"),
                  U("td", null, "Y"),
                  U("td", { class: "td-left" }, "2023-11-11 15:10:08")
                ], -1)
              ])),
              _: 1
            }),
            U("pre", null, [
              w[118] || (w[118] = Ft("                ")),
              U("code", null, `
                    ` + wt(kt(H)) + `
                `, 1),
              w[119] || (w[119] = Ft(`
            `))
            ]),
            Ze(Be, { type: "horizon" }, {
              tbody: rn(() => w[120] || (w[120] = [
                U("tr", null, [
                  U("th", null, "테이블 헤더1"),
                  U("td", null, "내용1"),
                  U("th", null, "테이블 헤더2"),
                  U("td", null, "내용2")
                ], -1),
                U("tr", null, [
                  U("th", null, "테이블 헤더3"),
                  U("td", null, [
                    U("p", null, "여러줄일 때는"),
                    U("p", null, "요"),
                    U("p", null, "렇"),
                    U("p", null, "게")
                  ]),
                  U("th", null, "테이블 헤더4"),
                  U("td", { class: "align-top" }, "input 들어갈 때 align-top 추가하기")
                ], -1)
              ])),
              _: 1
            }),
            w[122] || (w[122] = Yn('<table class="props-table mt-20" data-v-4371e388><thead data-v-4371e388><tr data-v-4371e388><th data-v-4371e388>Props</th><th data-v-4371e388>Type</th><th data-v-4371e388>Default</th><th data-v-4371e388>Description</th></tr></thead><tbody data-v-4371e388><tr data-v-4371e388><td data-v-4371e388>type</td><td data-v-4371e388>&quot;common&quot; | &quot;horizon&quot;</td><td data-v-4371e388>&quot;common&quot;</td><td data-v-4371e388>테이블타입 기본/세로</td></tr><tr data-v-4371e388><td data-v-4371e388>maxHeight</td><td data-v-4371e388>string</td><td data-v-4371e388>&quot;300px&quot;</td><td data-v-4371e388>세로형 테이블 최대높이</td></tr><tr data-v-4371e388><td data-v-4371e388>scrollDependancy</td><td data-v-4371e388>MaybeRefOrGetter[]</td><td data-v-4371e388></td><td data-v-4371e388>데이터 호출시 보냄</td></tr><tr data-v-4371e388><td data-v-4371e388>loading</td><td data-v-4371e388>false</td><td data-v-4371e388></td><td data-v-4371e388>스켈레톤 여부/td&gt;</td></tr></tbody></table>', 1))
          ]),
          w[124] || (w[124] = U("div", {
            class: "section",
            id: "font"
          }, [
            U("h4", null, "숫자폰트"),
            Ft(" 숫자는 다른 폰트가 들어가야합니다. "),
            U("span", { class: "font-num" }, "1000"),
            Ft(" 50 숫자를 사용할때 .font-num 클래스를 넣으세요 ")
          ], -1))
        ])
      ], 64);
    };
  }
}), p4 = /* @__PURE__ */ wr(i3, [["__scopeId", "data-v-4371e388"]]), o3 = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC4AAAAoCAYAAACB4MgqAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAKjSURBVHgB1Zl9ctJAGMbfhKSIQEmRzjj+Y29gj2CP4An0Ct7AK3gC6wk8Qj2CB3AUxhmsJIVAIQECxPcNpS3pZvOxTTf5zSxsdhPmYfPsx7sLcIPv+wamT5h++8XjAtN7uIdyI/oUvy4wGVBsfmA6UxTFVlH0CV58g+KLJqiBv1BGQeGU+QDl4kzFj7dQPt5o+HHCu2Oz2cB84QX557UqFIRTjVc7tKdgjq5RvB9c63oF2ocNaBt1kE2kcHM4AWs03SvzvDX8uxoHedniVVah560eiL6PhW9BNkzh7tLjPrRG33urNciEKXyz9uOeS3RPnjCFNxvPuA9RJ61Wuf06d5jCK6oKR63oztcxGjZIRo2qeNlpQafd3L9ZVYJy47AufXnAfd/HR0140WqAixNQBUUf6FogPgs0J8yx0x9jY+iauM1if4GE1msHIII9cXD8nwR5Go1ev+qAKCrkzHZOuBv3HXeJrT8DUXIXTkuG8JhvBWUrECFX4eTr8bX7oJwmsP5AbGDKTThZxOQsDUQtk5twatHdqjIKEcvkIpws4syXsfeJWCaTcF4rxVkkTFbLpBZ+adnwszeAXt9i1iexSJgslkklnCaS0dgJ8tRS1nCyV5/UImGyWCaxcLLALvrZYWKw4biL23pTIMBIa5nEwnv9K6YF+ubWGlksEiaNZRIJp/gzKuKhOPTXn0Emi4RJY5lY4TNnYfPiT+Ixw7ikluEKJ9/+Ne0nX3snsQxX+CV2RhlBcRLLRAonX09nC5BFnGWYwukfx/n6KeDt30S2uK5VQDZqJTpMZIZuFOVTeLWUvOlTq+qRdSS8C4wdW9o7oVRQumSVcygfX0n4Z9i2elk4xzOgrkoHQXjxDsoh/jumj3sldIhF50F+8Y4LRz7juPA/ARaffPteysgAAAAASUVORK5CYII=", s3 = { class: "VUpload" }, l3 = {
  key: 0,
  class: "VUpload-inner"
}, c3 = { class: "d-flex" }, d3 = {
  style: { position: "relative" },
  class: "mr-10"
}, u3 = {
  key: 0,
  class: "thumbnail"
}, _3 = ["src"], p3 = { class: "thumbnail-noimg" }, m3 = ["src"], f3 = { class: "VUpload-top" }, g3 = { class: "VUpload-body" }, E3 = { class: "file-item-left" }, h3 = ["src"], S3 = ["onClick"], b3 = { class: "file-size" }, T3 = { class: "file-item-right" }, v3 = ["onClick"], C3 = ["id", "multiple"], R3 = /* @__PURE__ */ Nr({
  __name: "VUploadFile",
  props: {
    multiple: { type: Boolean, default: !1 },
    modelValue: {},
    fileFormat: { default: () => [] },
    totalSize: {},
    maxLength: {},
    thumbnail: { type: Boolean, default: !1 },
    fileUuid: {},
    fileLnkTpCd: {},
    thumbUsagYn: {},
    thumbWdthSize: {},
    thumbVelSize: {}
  },
  emits: ["update:modelValue"],
  setup(s, { emit: i }) {
    const o = s, c = i, r = pt([]), { fileUpload: e, fileSingleUpload: g, fileList: h, fileDelete: S, fileDownload: C, fileImage: O } = Rm(), N = Vt(() => {
      var K;
      return ((K = r.value[0]) == null ? void 0 : K.fileNm) ?? "";
    });
    function D(K) {
      const Q = K / 1048576;
      return Math.round(Q * 10) / 10;
    }
    const x = Vt(() => r.value.reduce((Q, _e) => Q + _e.fileSize, 0)), L = Vt(() => r.value.map((K) => K.fileNm)), G = async (K) => {
      var ye;
      if (o.maxLength && o.modelValue && o.maxLength === o.modelValue.length)
        return alert("파일 최대 업로드 개수는 " + o.maxLength + "개입니다.");
      const se = [...K.target.files], Pe = new RegExp("(" + o.fileFormat.join("|") + ")", "i"), Ke = (o.totalSize ?? 0) * 1024 * 1024;
      for (const Je of se) {
        const mt = Je.name.split(".").pop();
        if (!Pe.test(mt))
          return alert("파일 확장자를 확인해 주세요. (" + o.fileFormat.join(", ") + ")");
        if (L.value.some((ge) => ge === Je.name))
          return alert("이미 같은 파일명이 존재합니다.");
        if (Ke && x.value + Je.size > Ke)
          return alert("사이즈가 너무 큽니다.");
      }
      if (o.maxLength && se.length + (((ye = o.modelValue) == null ? void 0 : ye.length) ?? 0) > o.maxLength)
        return alert("파일 최대 업로드 개수는 " + o.maxLength + "개입니다.");
      try {
        if (o.multiple)
          if (o.modelValue)
            await e({ ...o, files: se, fileUuid: o.modelValue }), r.value = await h({ fileUuid: o.modelValue });
          else {
            let Je = await e({ ...o, files: se });
            c("update:modelValue", Je);
          }
        else {
          let Je = await g({ ...o, files: se[0], fileUuid: o.modelValue });
          r.value = await h({ fileUuid: Je }), c("update:modelValue", Je);
        }
      } catch {
        console.error("업로드 에러");
      } finally {
        K.target.value = "";
      }
    }, Y = yi();
    function k(K) {
      const Q = K.split(".").pop();
      return {
        xlsx: ov,
        ppt: sl,
        pptx: sl
      }[Q] ?? iv;
    }
    async function W(K) {
      if (window.confirm("파일을 삭제하시겠습니까? (복구 불가)") && o.modelValue)
        try {
          o.multiple ? r.value.length === 1 ? (await S({ fileUuid: o.modelValue }), r.value = [], c("update:modelValue", "")) : (await S({ fileUuid: o.modelValue, sortSeqNo: K }), r.value = await h({ fileUuid: o.modelValue })) : (await S({ fileUuid: o.modelValue }), r.value = [], c("update:modelValue", ""));
        } catch {
          console.error(o.modelValue + " ERR");
        }
    }
    async function Z() {
      if (window.confirm("파일을 모두 삭제하시겠습니까? (복구 불가)") && o.modelValue)
        try {
          await S({ fileUuid: o.modelValue }), r.value = [], c("update:modelValue", "");
        } catch {
          console.error(o.modelValue + " ERR");
        }
    }
    an(
      () => o.modelValue,
      async (K) => {
        if (K)
          try {
            const Q = await h({ fileUuid: K });
            Q.length ? r.value = Q : (console.error("파일 없음(" + K + ")"), c("update:modelValue", ""));
          } catch {
            console.error(o.modelValue + " ERR"), r.value = [], c("update:modelValue", "");
          }
        else
          r.value = [], c("update:modelValue", "");
      },
      {
        immediate: !0
      }
    );
    const H = Vt(() => o.thumbnail && o.modelValue ? O({ fileUuid: o.modelValue, sortSeqNo: 1 }) : "");
    return (K, Q) => (he(), De("div", s3, [
      K.multiple ? (he(), De(nr, { key: 1 }, [
        U("div", f3, [
          U("strong", null, "Total " + wt(r.value.length) + " / " + wt(D(x.value)) + "MB", 1),
          U("div", null, [
            Ze(Ko, {
              id: kt(Y),
              class: "mr-10"
            }, null, 8, ["id"]),
            Ze(Cm, {
              icon: "ic_delete",
              onClick: Z
            })
          ])
        ]),
        U("div", g3, [
          U("ul", null, [
            (he(!0), De(nr, null, Fr(r.value, (_e) => (he(), De("li", {
              class: "file-item",
              key: _e.fileNm
            }, [
              U("div", E3, [
                U("img", {
                  src: k(_e.fileNm),
                  alt: "",
                  class: "file"
                }, null, 8, h3),
                U("strong", {
                  class: "file-title",
                  onClick: (se) => kt(C)({ fileUuid: K.modelValue ?? "", sortSeqNo: _e.sortSeqNo })
                }, wt(_e.fileNm), 9, S3),
                U("span", b3, wt(D(_e.fileSize)) + "MB", 1)
              ]),
              U("div", T3, [
                U("button", {
                  type: "button",
                  onClick: (se) => W(_e.sortSeqNo)
                }, [
                  Ze(Ri, { icon: "ic_close" })
                ], 8, v3)
              ])
            ]))), 128))
          ])
        ])
      ], 64)) : (he(), De("div", l3, [
        U("div", c3, [
          U("div", d3, [
            Ze(_m, {
              name: kt(Y),
              disabled: "",
              "model-value": N.value,
              width: "300px"
            }, null, 8, ["name", "model-value"]),
            K.modelValue ? (he(), De("button", {
              key: 0,
              type: "button",
              onClick: Q[0] || (Q[0] = (_e) => W()),
              class: "remove-item-btn"
            }, [
              Ze(Ri, { icon: "ic_close" })
            ])) : Ut("", !0)
          ]),
          Ze(Ko, { id: kt(Y) }, null, 8, ["id"])
        ]),
        K.thumbnail ? (he(), De("div", u3, [
          fn(U("img", {
            src: H.value,
            class: "thumbnail-img",
            alt: "thumbnail"
          }, null, 8, _3), [
            [ea, !!H.value]
          ]),
          fn(U("div", p3, [
            U("img", {
              src: kt(o3),
              alt: ""
            }, null, 8, m3)
          ], 512), [
            [ea, !H.value]
          ])
        ])) : Ut("", !0)
      ])),
      fn(U("input", {
        type: "file",
        id: kt(Y),
        onChange: G,
        multiple: K.multiple
      }, null, 40, C3), [
        [ea, !1]
      ])
    ]));
  }
}), N3 = /* @__PURE__ */ wr(R3, [["__scopeId", "data-v-6047481c"]]), A3 = { class: "VTableTitle" }, O3 = { class: "VTableTitle-title-group" }, y3 = { class: "VTableTitle-title" }, I3 = {
  key: 0,
  class: "total-count"
}, D3 = { class: "font-num" }, w3 = {
  key: 1,
  class: "VTableTitle-desc"
}, x3 = { class: "VTableTitle-btn-group" }, L3 = /* @__PURE__ */ Nr({
  __name: "VTableTitle",
  props: {
    title: {},
    desc: {},
    totalCount: {}
  },
  setup(s) {
    return (i, o) => (he(), De("div", A3, [
      U("div", O3, [
        U("h4", y3, wt(i.title), 1),
        i.totalCount !== void 0 ? (he(), De("strong", I3, [
          o[0] || (o[0] = Ft("조회결과 ")),
          U("span", D3, wt(i.totalCount), 1),
          o[1] || (o[1] = Ft("건"))
        ])) : Ut("", !0),
        i.desc ? (he(), De("p", w3, wt(i.desc), 1)) : Ut("", !0)
      ]),
      U("div", x3, [
        jr(i.$slots, "default", {}, void 0, !0)
      ])
    ]));
  }
}), M3 = /* @__PURE__ */ wr(L3, [["__scopeId", "data-v-5ac5de82"]]), P3 = { class: "VTableTop" }, k3 = { class: "VTableTop-left" }, F3 = {
  key: 0,
  class: "table-title"
}, U3 = {
  key: 1,
  class: "total-count"
}, B3 = { class: "font-num" }, G3 = { class: "VTableTop-right" }, V3 = /* @__PURE__ */ Nr({
  __name: "VTableTop",
  props: {
    title: {},
    totalCount: {}
  },
  setup(s) {
    return (i, o) => (he(), De("div", P3, [
      U("div", k3, [
        i.title !== void 0 || i.totalCount !== void 0 ? (he(), De(nr, { key: 0 }, [
          i.title !== void 0 ? (he(), De("h5", F3, wt(i.title), 1)) : Ut("", !0),
          i.totalCount !== void 0 ? (he(), De("strong", U3, [
            o[0] || (o[0] = Ft("조회결과 ")),
            U("span", B3, wt(i.totalCount), 1),
            o[1] || (o[1] = Ft("건"))
          ])) : Ut("", !0)
        ], 64)) : jr(i.$slots, "left", { key: 1 }, void 0, !0)
      ]),
      U("div", G3, [
        jr(i.$slots, "right", {}, void 0, !0)
      ])
    ]));
  }
}), Y3 = /* @__PURE__ */ wr(V3, [["__scopeId", "data-v-684fd50e"]]), H3 = { class: "VPaginationGroup" }, q3 = { class: "VPaginationGroup-center" }, $3 = { class: "VPaginationGroup-right" }, W3 = /* @__PURE__ */ Nr({
  __name: "VPaginationGroup",
  props: {
    pagination: {},
    dropdown: {},
    totalCount: {}
  },
  emits: ["dropChange", "update:dropdown", "pageChange", "update:pagination"],
  setup(s, { emit: i }) {
    const o = i, c = s, r = Vt({
      get() {
        return c.pagination;
      },
      set(g) {
        o("update:pagination", g), o("pageChange", g);
      }
    }), e = Vt({
      get() {
        return c.dropdown;
      },
      set(g) {
        o("update:pagination", 1), o("update:dropdown", g), o("dropChange", g);
      }
    });
    return (g, h) => {
      var S;
      return he(), De("div", H3, [
        U("div", q3, [
          Ze(pm, {
            width: "86px",
            class: "mr-10 VPaginationGroup-dropdown",
            modelValue: e.value,
            "onUpdate:modelValue": h[0] || (h[0] = (C) => e.value = C),
            options: [
              {
                label: "10",
                value: "10"
              },
              {
                label: "30",
                value: "30"
              },
              {
                label: "50",
                value: "50"
              },
              {
                label: "100",
                value: "100"
              }
            ]
          }, null, 8, ["modelValue"]),
          Ze(A1, {
            modelValue: r.value,
            "onUpdate:modelValue": h[1] || (h[1] = (C) => r.value = C),
            "total-page": kt(N1)(((S = g.dropdown) == null ? void 0 : S.value) ?? "10", g.totalCount || 1)
          }, null, 8, ["modelValue", "total-page"])
        ]),
        U("div", $3, [
          jr(g.$slots, "right", {}, void 0, !0)
        ])
      ]);
    };
  }
}), z3 = /* @__PURE__ */ wr(W3, [["__scopeId", "data-v-a9dc2ad7"]]), K3 = { class: "sr-only" }, Q3 = ["rowspan", "colspan"], X3 = ["onClick"], Z3 = {
  key: 0,
  class: "sort-icon"
}, j3 = { key: 1 }, J3 = { key: 2 }, e4 = { key: 0 }, t4 = ["onClick"], r4 = {
  key: 0,
  class: "sort-icon"
}, n4 = { key: 1 }, a4 = { class: "sr-only" }, i4 = { key: 0 }, o4 = { key: 1 }, s4 = ["colspan"], l4 = /* @__PURE__ */ Nr({
  __name: "VDataTable",
  props: {
    columns: {},
    initWidth: { default: 100 },
    minWidth: { default: 100 },
    modelValue: {},
    maxHeight: { default: "470px" },
    loading: { type: Boolean },
    type: {},
    scrollDependancy: {}
  },
  emits: ["update:modelValue"],
  setup(s, { emit: i }) {
    const o = s, c = i, r = pt(), e = pt(), g = pt(), h = pt([]), S = pt([...o.modelValue]), C = pt([...o.modelValue]), O = pt([]), N = pt(0), D = pt(0), x = pt(0), L = pt(!1), G = pt([]), Y = pt(!1), k = pt(!1), W = pt(!1), Z = pt(null), H = (ge) => {
      N.value = "ontouchstart" in window ? ge.changedTouches[0].clientX : ge.clientX, L.value = !0;
      const w = ge.target;
      x.value = parseInt(w.dataset.idx), D.value = O.value[x.value], ge.preventDefault(), ge.stopPropagation();
    }, K = (ge) => {
      if (L.value) {
        const fe = ("ontouchstart" in window ? ge.changedTouches[0].clientX : ge.clientX) - N.value;
        let j = 0;
        typeof o.minWidth == "number" ? j = o.minWidth : j = o.minWidth[x.value];
        let J = D.value + fe;
        J < j && (J = j), O.value[x.value] = J, Ke();
      }
    }, Q = () => {
      L.value = !1;
    }, _e = Vt(() => O.value.length === 0 ? 0 : O.value.reduce((ge, w) => ge + w)), se = (ge) => {
      if (G.value[ge] === "") {
        for (let w = 0; w < G.value.length; w++)
          G.value[w] = "";
        G.value[ge] = "upper";
      } else if (G.value[ge] === "upper") {
        for (let w = 0; w < G.value.length; w++)
          G.value[w] = "";
        G.value[ge] = "lower";
      } else
        G.value[ge] = "";
      Y.value = !0, Pe(ge, G.value[ge]);
    }, Pe = (ge, w) => {
      const fe = JSON.parse(JSON.stringify(C.value));
      w === "upper" ? fe.sort((j, J) => {
        const de = Object.keys(fe[0])[ge], ie = j[de] === null ? "" : j[de], X = J[de] === null ? "" : J[de];
        return ie > X ? 1 : ie < X ? -1 : 0;
      }) : w === "lower" ? fe.sort((j, J) => {
        const de = Object.keys(fe[0])[ge], ie = j[de] === null ? "" : j[de], X = J[de] === null ? "" : J[de];
        return ie > X ? -1 : ie < X ? 1 : 0;
      }) : C.value = [...S.value], c("update:modelValue", fe);
    }, Ke = () => {
      const ge = [];
      O.value.forEach((w, fe) => {
        o.columns[fe].children ? (ge.push(w / o.columns[fe].children.length), ge.push(w / o.columns[fe].children.length)) : ge.push(w);
      }), ge.forEach(() => {
        var fe;
        const w = (fe = g.value) == null ? void 0 : fe.querySelectorAll("tr");
        w == null || w.forEach((j) => {
          j.querySelectorAll("td").forEach((J, de) => {
            J.style.width = `${ge[de]}px`;
          });
        });
      });
    }, ye = Vt(() => o.columns.find((ge) => ge.children && ge.children.length > 1)), Je = (ge, w) => {
      let fe = 0;
      for (let j = 0; j < o.columns.length; j++) {
        const J = o.columns[j].children ? o.columns[j].children.length : 0;
        if (J > 0) {
          for (let de = 0; de < J; de++)
            if (fe++, ge === j && w === de)
              return fe - 1;
        } else if (fe++, ge === j)
          return fe - 1;
      }
      return 0;
    }, mt = pt("auto");
    return an(_e, () => {
      if (r.value && _e.value < r.value.offsetWidth)
        return mt.value = "auto";
      mt.value = `${_e.value}px`;
    }), an(W, (ge) => {
      k.value || (C.value.forEach((w) => w.checked = ge), Y.value = !0, c("update:modelValue", C.value));
    }), an(
      () => o.modelValue,
      () => {
        let ge = !1;
        if (!Y.value) {
          const w = o.modelValue.filter((fe) => fe.checked);
          k.value = !0, W.value = w.length === o.modelValue.length, setTimeout(() => k.value = !1), S.value = [...o.modelValue], C.value = [...o.modelValue], G.value.forEach((fe, j) => {
            fe && (ge = !0, Y.value = !0, Pe(j, fe));
          });
        }
        ge || (Y.value = !1), setTimeout(() => Ke());
      },
      {
        deep: !0
      }
    ), Na(() => {
      let ge = 0;
      for (let fe = 0; fe < o.columns.length; fe++) {
        const j = o.columns[fe].children ? o.columns[fe].children.length : 0;
        if (typeof o.initWidth == "number" ? O.value.push(o.initWidth) : O.value.push(o.initWidth[fe]), j > 0)
          for (let J = 0; J < j; J++)
            G.value[ge] = "", ge++;
        else
          G.value[ge] = "", ge++;
      }
      Ke(), h.value.forEach((fe, j) => {
        fe.dataset.idx = `${j}`, "ontouchstart" in window ? (fe.addEventListener("touchstart", H), document.addEventListener("touchmove", K), document.addEventListener("touchend", Q)) : (fe.addEventListener("mousedown", H), document.addEventListener("mousemove", K), document.addEventListener("mouseup", Q));
      }), new ResizeObserver(function() {
        if (r.value && _e.value < r.value.offsetWidth)
          return mt.value = "auto";
        mt.value = `${_e.value}px`;
      }).observe(r.value);
    }), E1(() => {
      "ontouchstart" in window ? (h.value.forEach((ge) => ge.removeEventListener("touchstart", H)), document.removeEventListener("touchmove", K), document.removeEventListener("touchend", Q)) : (h.value.forEach((ge) => ge.removeEventListener("mousedown", H)), document.removeEventListener("mousemove", K), document.removeEventListener("mouseup", Q));
    }), (ge, w) => {
      const fe = pr("VSpinner"), j = pr("VCheckbox");
      return he(), De("div", {
        class: jt(["v-data-table", ye.value ? "tworow" : ""]),
        ref_key: "container",
        ref: r
      }, [
        ge.loading ? (he(), gn(fe, { key: 0 })) : Ut("", !0),
        U("div", {
          class: "thead-warp d-flex",
          style: nn({ width: `${_e.value}px` })
        }, [
          U("table", {
            ref_key: "table",
            ref: e,
            style: nn({ width: `${_e.value}px` })
          }, [
            fn(U("caption", K3, " 테이블 ", 512), [
              [ea, !1]
            ]),
            U("thead", null, [
              U("tr", null, [
                (he(!0), De(nr, null, Fr(o.columns, (J, de) => (he(), De("th", {
                  key: `th-${de}`,
                  class: jt({ group: J.children, star: J.star }),
                  rowspan: ye.value ? J.children ? void 0 : 2 : void 0,
                  colspan: J.children ? J.children.length : void 0,
                  style: nn({ width: `${O.value[de]}px` })
                }, [
                  J.children ? (he(), De(nr, { key: 1 }, [
                    U("span", null, wt(J.name), 1),
                    U("span", {
                      ref_for: !0,
                      ref: (ie) => h.value[de] = ie,
                      class: "resize-point"
                    }, null, 512)
                  ], 64)) : (he(), De(nr, { key: 0 }, [
                    J.sort && !J.check ? (he(), De("a", {
                      key: 0,
                      class: jt(["sort-target", G.value[Je(de, 0)]]),
                      onClick: (ie) => se(Je(de, 0))
                    }, [
                      Ft(wt(J.name) + " ", 1),
                      G.value[Je(de, 0)] ? (he(), De("i", Z3)) : Ut("", !0)
                    ], 10, X3)) : Ut("", !0),
                    !J.sort && !J.check ? (he(), De("span", j3, wt(J.name), 1)) : Ut("", !0),
                    J.check ? (he(), De("span", J3, [
                      Ze(j, {
                        modelValue: W.value,
                        "onUpdate:modelValue": w[0] || (w[0] = (ie) => W.value = ie),
                        disabled: !ge.modelValue.length || ge.loading
                      }, null, 8, ["modelValue", "disabled"])
                    ])) : Ut("", !0),
                    U("span", {
                      ref_for: !0,
                      ref: (ie) => h.value[de] = ie,
                      class: "resize-point"
                    }, null, 512)
                  ], 64))
                ], 14, Q3))), 128))
              ]),
              ye.value ? (he(), De("tr", e4, [
                (he(!0), De(nr, null, Fr(o.columns, (J, de) => (he(), De(nr, {
                  key: `th-${de}`
                }, [
                  J.children ? (he(!0), De(nr, { key: 0 }, Fr(J.children, (ie, X) => (he(), De("th", null, [
                    ie.sort ? (he(), De("a", {
                      key: 0,
                      class: jt(["sort-target", G.value[Je(de, X)]]),
                      onClick: (ue) => se(Je(de, X))
                    }, [
                      Ft(wt(ie.name) + " ", 1),
                      G.value[Je(de, X)] ? (he(), De("i", r4)) : Ut("", !0)
                    ], 10, t4)) : (he(), De("span", n4, wt(ie.name), 1))
                  ]))), 256)) : Ut("", !0)
                ], 64))), 128))
              ])) : Ut("", !0)
            ]),
            fn(U("tbody", null, null, 512), [
              [ea, !1]
            ])
          ], 4)
        ], 4),
        U("div", {
          class: "tbody-wrap",
          style: nn({ width: mt.value, maxHeight: ge.maxHeight }),
          ref_key: "tableTarget",
          ref: Z
        }, [
          U("table", {
            ref_key: "table2",
            ref: g,
            style: nn({ width: `${_e.value}px` })
          }, [
            fn(U("caption", a4, " 테이블 ", 512), [
              [ea, !1]
            ]),
            fn(U("thead", null, [
              (he(!0), De(nr, null, Fr(o.columns, (J, de) => (he(), De("tr", {
                key: `th-${de}`
              }, w[1] || (w[1] = [
                U("th", null, null, -1)
              ])))), 128))
            ], 512), [
              [ea, !1]
            ]),
            ge.modelValue.length > 0 ? (he(), De("tbody", i4, [
              jr(ge.$slots, "tbody")
            ])) : (he(), De("tbody", o4, [
              U("td", {
                colspan: o.columns.length,
                class: "no-list"
              }, "검색된 결과가 없습니다.", 8, s4)
            ]))
          ], 4)
        ], 4)
      ], 2);
    };
  }
}), c4 = /* @__PURE__ */ wr(l4, [["__scopeId", "data-v-bb947d2d"]]);
function m4(s) {
  const i = pt([]), { fileList: o, fileMultiUpload: c, fileDelete: r } = Rm(), e = async (h) => {
    let S = $o(s) || "";
    const C = h || i.value, O = C.map((D) => D.sortSeqNo), N = g(C);
    if (S) {
      const x = (await o({
        fileUuid: S
      })).filter((L) => !O.includes(Number(L.sortSeqNo)));
      if (x.length)
        for (const L of x)
          await r({
            fileUuid: S,
            sortSeqNo: L.sortSeqNo
          });
      return N.length && await c({
        files: N,
        fileUuid: S
      }), S;
    }
    if (C.length)
      return N.length ? await c({
        files: N
      }) : "";
  };
  function g(h) {
    return h.map((S) => {
      const C = {
        sortSeqNo: S.sortSeqNo,
        file: S.file || null
      };
      return S.fileLnkTpCd && (C.fileLnkTpCd = S.fileLnkTpCd), S.thumbUsagYn && (C.thumbUsagYn = S.thumbUsagYn), S.thumbWdthSize && (C.thumbWdthSize = S.thumbWdthSize), S.thumbVelSize && (C.thumbVelSize = S.thumbVelSize), C;
    });
  }
  return an(
    () => $o(s),
    async (h) => {
      if (h) {
        const S = await o({
          fileUuid: h
        });
        i.value = S.map((C) => {
          var O, N, D;
          return {
            name: C.fileNm,
            size: C.fileSize,
            sortSeqNo: Number(C.sortSeqNo),
            file: null,
            fileUuid: h ?? "",
            fileLnkTpCd: C.fileLnkTpCd,
            thumbUsagYn: ((O = C.thumbUsagYn) == null ? void 0 : O.toString()) || "",
            thumbWdthSize: ((N = C.thumbWdthSize) == null ? void 0 : N.toString()) || "",
            thumbVelSize: ((D = C.thumbVelSize) == null ? void 0 : D.toString()) || ""
          };
        });
      }
    },
    { immediate: !0 }
  ), { fileValue: i, fileSave: e };
}
function f4(s, i) {
  const o = pt([]), c = pt([]), r = Vt({
    get() {
      return o.value.length !== 0 && o.value.length === c.value.length;
    },
    set(e) {
      e ? o.value = c.value : o.value = [];
    }
  });
  return an(
    [() => $o(s), () => $o(i)],
    ([e, g]) => {
      c.value = e, o.value = g || [];
    },
    {
      immediate: !0
    }
  ), { checkedList: o, allCheck: r };
}
const g4 = {
  install(s) {
    s.component("VDatepicker", FA).component("VButton", GA).component("VCheckbox", Hp).component("VDropdown", pm).component("VIconFont", Ri).component("VModal", _O).component("VPagination", A1).component("VRadiobox", AO).component("VSwitch", IO).component("VTable", FO).component("VTextarea", VO).component("VTextInput", _m).component("VTimepicker", XO).component("TabTitle", oy).component("VCommonDropdown", CI).component("TextButton", OI).component("VSortButton", wI).component("VFileButton", Ko).component("VIconButton", Cm).component("VTableTitle", M3).component("VUploadFile", N3).component("VFormGroup", PI).component("VTableTop", Y3).component("VEditor", $D).component("SearchMenu", JO).component("VDataTable", c4).component("VSpinner", $p).component("VFileCustomUpload", m2).component("VPaginationGroup", z3), s.config.globalProperties.$dayjs = rr, s.config.globalProperties.$window = window, s.config.globalProperties.$comma = YA, s.config.globalProperties.$toPhoneFormat = HA, s.config.globalProperties.$totalPage = N1, s.config.globalProperties.$extractNumbers = qp, s.directive("focus", {
      mounted: (i) => i.focus()
    }), s.use(eL);
  }
};
export {
  p4 as Guide,
  _4 as TheSideBar,
  g4 as default,
  f4 as useCheckbox,
  m4 as useFileSave,
  Rm as useFileUpload
};
